/*!
 * @brief French Geoportal SDK based on OpenLayers (2D) and iTowns (3D) libraries
 *
 * This software is released under the licence CeCILL-B (Free BSD compatible)
 * @see http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt
 * @see http://www.cecill.info/licences/Licence_CeCILL-B_V1-fr.txt
 * @see http://www.cecill.info/
 *
 * copyright CeCILL-B
 * copyright IGN
 * @author IGN
 * @version 2.0.1
 * @date 2018-09-10
 *
 */

/*!
 * geoportal-extensions-openlayers. See https://github.com/IGNF/geoportal-extensions
 * License: https://github.com/IGNF/geoportal-extensions/blob/master/LICENCE.md
 * Version: 2.1.0
 */

/*!
 * OpenLayers. See http://openlayers.org/
 * License: https://raw.githubusercontent.com/openlayers/openlayers/master/LICENCE.md
 * Version: 4.4.2
 */

/*!
 * Sortable -- minimalist JavaScript library for reorderable drag-and-drop lists
 *
 * Released under MIT LICENSE
 *
 * Copyright 2013-2016 Lebedev Konstantin <ibnRubaXa@gmail.com>
 * http://rubaxa.github.io/Sortable/
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4
 */

/*!
 * Proj4js - Javascript reprojection library.
 *
 * Authors:
 *
 * - Mike Adair madairATdmsolutions.ca
 * - Richard Greenwood richATgreenwoodmap.com
 * - Didier Richard didier.richardATign.fr
 * - Stephen Irons stephen.ironsATclear.net.nz
 * - Olivier Terral oterralATgmail.com
 * - Calvin Metcalf cmetcalfATappgeo.com
 *
 * Copyright (c) 2014, Mike Adair, Richard Greenwood, Didier Richard, Stephen Irons, Olivier Terral and Calvin Metcalf
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a
 *  copy of this software and associated documentation files (the "Software"),
 *  to deal in the Software without restriction, including without limitation
 *  the rights to use, copy, modify, merge, publish, distribute, sublicense,
 *  and/or sell copies of the Software, and to permit persons to whom the
 *  Software is furnished to do so, subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included
 *  in all copies or substantial portions of the Software.
 *
 *  _THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 *  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 *  THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 *  FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 *  DEALINGS IN THE SOFTWARE._
 *
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("xmldom"), require("request"));
	else if(typeof define === 'function' && define.amd)
		define("Gp", ["require", "require"], factory);
	else if(typeof exports === 'object')
		exports["Gp"] = factory(require("xmldom"), require("request"));
	else
		root["Gp"] = factory(root[undefined], root[undefined]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_14__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * @brief French Geoportal Extension for OpenLayers
 *
 * This software is released under the licence CeCILL-B (Free BSD compatible)
 * @see http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt
 * @see http://www.cecill.info/licences/Licence_CeCILL-B_V1-fr.txt
 * @see http://www.cecill.info/
 *
 * copyright CeCILL-B
 * copyright IGN
 * @author IGN
 * @version 2.1.0
 * @date 2018-08-09
 *
 */

/*!
 * Sortable -- minimalist JavaScript library for reorderable drag-and-drop lists
 *
 * Released under MIT LICENSE
 *
 * Copyright 2013-2016 Lebedev Konstantin <ibnRubaXa@gmail.com>
 * http://rubaxa.github.io/Sortable/
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4
 */

/*!
 * Proj4js - Javascript reprojection library.
 *
 * Authors:
 *
 * - Mike Adair madairATdmsolutions.ca
 * - Richard Greenwood richATgreenwoodmap.com
 * - Didier Richard didier.richardATign.fr
 * - Stephen Irons stephen.ironsATclear.net.nz
 * - Olivier Terral oterralATgmail.com
 * - Calvin Metcalf cmetcalfATappgeo.com
 *
 * Copyright (c) 2014, Mike Adair, Richard Greenwood, Didier Richard, Stephen Irons, Olivier Terral and Calvin Metcalf
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a
 *  copy of this software and associated documentation files (the "Software"),
 *  to deal in the Software without restriction, including without limitation
 *  the rights to use, copy, modify, merge, publish, distribute, sublicense,
 *  and/or sell copies of the Software, and to permit persons to whom the
 *  Software is furnished to do so, subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included
 *  in all copies or substantial portions of the Software.
 *
 *  _THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 *  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 *  THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 *  FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 *  DEALINGS IN THE SOFTWARE._
 *
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(5), __webpack_require__(13), __webpack_require__(14));
	else if(typeof define === 'function' && define.amd)
		define("Gp", ["ol", "require", "require"], factory);
	else if(typeof exports === 'object')
		exports["Gp"] = factory(require("openlayers"), require("xmldom"), require("request"));
	else
		root["Gp"] = factory(root["ol"], root[undefined], root[undefined]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_25__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 24);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loglevel = __webpack_require__(26);

var Log = _interopRequireWildcard(_loglevel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LoggerByDefault = {
    /**
     *logger statique
     * @param {String} [name="default"] - the logger name
     *
     * @returns {Object} logger
     */
    getLogger: function getLogger(name) {
        // Substitute global constants configured at compile time
        // cf. webpack.config.js
         false ? Log.disableAll() : Log.enableAll();
        var logname = name || "default";
        return Log.getLogger(logname);
    }
}; /* global __PRODUCTION__ */
exports.default = LoggerByDefault;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Utils = {

    /**
     * this method is called by the constructor.
     * this information is useful to switch to touch mode.
     * Detection : test for desktop or tactile
     *
     * @returns {Boolean} isDesktop - true for desktop userAgent, false for mobile
     */
    detectSupport: function detectSupport() {
        var isDesktop = true;
        var userAgent = window.navigator.userAgent.toLowerCase();

        if (userAgent.indexOf("iphone") !== -1 || userAgent.indexOf("ipod") !== -1 || userAgent.indexOf("ipad") !== -1 || userAgent.indexOf("android") !== -1 || userAgent.indexOf("mobile") !== -1 || userAgent.indexOf("blackberry") !== -1 || userAgent.indexOf("tablet") !== -1 || userAgent.indexOf("phone") !== -1 || userAgent.indexOf("touch") !== -1) {
            isDesktop = false;
        }

        if (userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident") !== -1) {
            isDesktop = true;
        }

        return isDesktop;
    },

    /**
     *  Copies all source object members to dest
     *
     * @param {Object} dest - destination object where properties and method will be copied
     * @param {Object} source - source object from which properties and method will be copied
     * @returns {Object} dest
     */
    assign: function assign(dest, source) {
        dest = dest || {};
        for (var prop in source) {
            if (source.hasOwnProperty(prop)) {
                dest[prop] = source[prop];
            }
        }
        return dest;
    },

    /**
     * Merge two objects parameters (deeper than assign)
     *
     * @param {Object} dest   - destination object where properties and method will be merge
     * @param {Object} source - source object from which properties and method will be merge
     */
    mergeParams: function mergeParams(dest, source) {
        if (!dest || !source) {
            return;
        }
        for (var param in source) {
            if (source.hasOwnProperty(param)) {
                if (_typeof(source[param]) === "object") {
                    if (dest.hasOwnProperty(param)) {
                        this.mergeParams(dest[param], source[param]);
                    } else {
                        dest[param] = source[param];
                    }
                } else {
                    dest[param] = source[param];
                }
            }
        }
    }
};

exports.default = Utils;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * formalisme d'un tag ID :
 * -> NAME(_ORDER)-1460636385836
 *
 * Ex.
 *   GProutePoints-1460636385836
 *   GProutePoint_10-1460636385836
 */
var SelectorID = {

    /**
     * Construction d'un identifiant statique basé sur le timestamp,
     * et qui s'incremente de +1 à chaque appel
     */
    generate: function () {
        var timestamp = Math.floor(Date.now());
        return function () {
            return timestamp++;
        };
    }(),

    /**
     * nom du tag
     * @param {String} id - the id
     *
     * @returns {String} index
     */
    name: function name(id) {
        var name = null;

        var i = id.lastIndexOf("-");
        if (i === -1) {
            name = id;
        } else {
            name = id.substring(0, i);
        }

        return name;
    },

    /**
     * numero d'identifiant du tag
     * @param {String} id - the id
     *
     * @returns {String} index
     */
    index: function index(id) {
        var index = null;

        var name = this.name(id);
        // if (name !== id) {
        var i = name.lastIndexOf("_");
        if (i !== -1) {
            index = name.substring(i + 1);
        }
        // }

        return index;
    },

    /**
     * uuid du tag
     * @param {String} id - the id
     *
     * @returns {String} uuid
     */
    uuid: function uuid(id) {
        var uuid = null;

        var i = id.lastIndexOf("-");
        if (i !== -1) {
            uuid = parseInt(id.substring(i + 1), 10);
        }

        return uuid;
    }

};

exports.default = SelectorID;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * @brief Geoportal resources access library
 *
 * This software is released under the licence CeCILL-B (Free BSD compatible)
 * @see http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt
 * @see http://www.cecill.info/licences/Licence_CeCILL-B_V1-fr.txt
 * @see http://www.cecill.info/
 *
 * copyright CeCILL-B
 * copyright IGN
 * @author IGN
 * @version 2.1.0
 * @date 2018-08-01
 *
 */
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(11), __webpack_require__(25));
	else if(typeof define === 'function' && define.amd)
		define("Gp", ["require", "require"], factory);
	else if(typeof exports === 'object')
		exports["Gp"] = factory(require("xmldom"), require("request"));
	else
		root["Gp"] = factory(root[undefined], root[undefined]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_52__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 43);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loglevel__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_loglevel__);
/* global __PRODUCTION__ */


var LoggerByDefault = {
    /**
     * logger statique
     *
     * @static
     * @param {String} name - nom du logger
     * @returns {Object} retourne un logger
     */
    getLogger : function (name) {
        // Substitute global constants configured at compile time
        // cf. webpack.config.js
        ( false) ? Log.disableAll() : __WEBPACK_IMPORTED_MODULE_0_loglevel__["enableAll"]();
        var logname = name || "default";
        return __WEBPACK_IMPORTED_MODULE_0_loglevel__["getLogger"](logname);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (LoggerByDefault);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Classe de gestion des erreurs qui permer d'associer un message d'erreur à l'exception lancée.
 *
 * @example
 * MessagesResources.getMessage("ERROR_PARAM_MISSING", "x", "y", "z")));
 * // --> output : Parameter(s) 'x - y - z' missing
 *
 * @module MessagesResources
 * @alias Gp.Utils.MessagesResources
 * @private
 */
var MessagesResources = {

    // Paramètres
    PARAM_MISSING : "Parameter(s) '%var%' missing",
    PARAM_EMPTY : "Parameter(s) '%var%' empty",
    PARAM_TYPE : "Wrong type(s) for parameter(s) '%var%'",
    PARAM_FORMAT : "Parameter(s) '%var%' not correctly formatted",
    PARAM_NOT_SUPPORT : "Value(s) for parameter(s) '%var%' not supported",
    PARAM_NOT_SUPPORT_NODEJS : "Value(s) for parameter(s) '%var%' not supported to NodeJS",
    PARAM_UNKNOWN : "Value(s) for parameter(s) '%var%' unknown",

    // Services
    // Requête
    SERVICE_REQUEST_BUILD : "An error occurred during the request building of the service",
    SERVICE_REQUEST_EMPTY : "The request sent to the service is empty",

    // Réponse
    SERVICE_RESPONSE_EXCEPTION : "The service returned an exception : '%var%'",
    SERVICE_RESPONSE_EXCEPTION_2 : "The service returned an exception",
    SERVICE_RESPONSE_ANALYSE : "An error occurred while parsing the response '%var%' of the service",
    SERVICE_RESPONSE_ANALYSE_2 : "An unknown error occurred while parsing the response",
    SERVICE_RESPONSE_EMPTY : "The response of the service is empty",
    SERVICE_RESPONSE_EMPTY_2 : "The response from the service could not be analyzed or is empty",
    SERVICE_RESPONSE_FORMAT : "The format of the service response is not supported (handled format(s) : '%var%')",
    SERVICE_RESPONSE_FORMAT_2 : "The format of the service response is not supported",
    SERVICE_RESPONSE_FORMAT_3 : "No suggestion matching the search",

    // Classes
    CLASS_CONSTRUCTOR : "'%var%' constructor cannot be called as a function.",

    /**
     * Fonction qui va retourner le message d'erreur associé à la clé donnée
     *
     * @method getMessage
     * @param {String} clef - Clef de l'erreur (ex : ERROR_PARAM)
     * @param {String[]} parametres - Paramètres/variables concernés par le message d'erreur associé à la clef donnée
     * @return {String} message - String contenant le message de l'exception
     */
    getMessage : function (clef, parametres) {
        // param de la fonction uniquement pour la documentation...

        if (Object.keys(arguments).length === 0) {
            return "Message indefined !";
        }

        var params = Array.prototype.slice.call(arguments);
        var key = params.shift();
        var args = params;

        var message = this[key];

        try {
            if (Array.isArray(args) && args.length > 0) {
                message = message.replace("%var%", args.join(" - "));
            } else {
                message = message.replace("%var%", "%var% (not specified)");
            }
        } catch (e) {
            // error de string.replace()

        }

        return message;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (MessagesResources);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Errors raised by API for one among three reasons : wrong API usage, underlying service error or unknown reason.
 *
 * @property {String} message - Error message
 * @property {Number} status - Error status : when {@link Gp.Error.TYPE_SRVERR}, gives the [HTTP status of the underlying web service response]{@link https://en.wikipedia.org/wiki/List_of_HTTP_status_codes} ; -1 otherwise.
 * @property {String} type - Error type ({@link Gp.Error.TYPE_SRVERR}, {@link Gp.Error.TYPE_USEERR} or {@link Gp.Error.TYPE_UNKERR}).
 *
 * @namespace
 * @alias Gp.Error
 * @param {Object|String} error - Options for creating error object. Can be a String (message) or an Object.
 * @param {String} error.message - Error message to return to user.
 * @param {enum} [error.type=TYPE_UNKERR] - Error type
 * @param {status} [error.status=-1] - Error status : when {@link Gp.Error.TYPE_SRVERR}, gives the [HTTP status of the underlying web service response]{@link https://en.wikipedia.org/wiki/List_of_HTTP_status_codes}.
 *
 */
function ErrorService (error) {
    if (!(this instanceof ErrorService)) {
        throw new TypeError("ErrorService constructor cannot be called as a function.");
    }

    var e = error;
    if (typeof error === "string" || error instanceof String) {
        this.message = error;
        this.status = -1;
        this.type = ErrorService.TYPE_UNKERR;
    } else {
        this.message = e.message || "undefined!?";
        this.type = e.type;
        this.status = e.status || -1;
    }

    this.name = "ErrorService";
    this.stack = (new Error()).stack;
}

/**
 * Error raised when underlying geoportal service answers on error.
 *
 * @type {String}
 * @constant
 * @static
 */
ErrorService.TYPE_SRVERR = "SERVICE_ERROR";
/**
 * Error raised when funcion use is inappropriate
 *
 * @type {String}
 * @constant
 * @static
 */
ErrorService.TYPE_USEERR = "USAGE_ERROR";
/**
 * Error raised when API can't perform the job for a reason other than the two other ones.
 *
 * @type {String}
 * @constant
 * @static
 */
ErrorService.TYPE_UNKERR = "UNKNOWN_ERROR";

/**
 * @lends module:ErrorService
 */
ErrorService.prototype = Object.create(Error.prototype, {
    constructor : {
        value : ErrorService,
        writable : true,
        configurable : true
    }
});

/* harmony default export */ __webpack_exports__["a"] = (ErrorService);


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_Helper__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Protocols_Protocol__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DefaultUrlService__ = __webpack_require__(5);







/**
 * @classdesc
 * Composant Service
 *
 * @constructor
 * @alias Gp.Services.CommonService
 * @param {Object} options - options communes à tous les services
 *
 * @param {String} options.apiKey - Clef d'accès à la plateforme Géoportail,
 *      nécessaire pour franchir la couche de contrôle des accès pour avoir une réponse du service invoqué.
 *      Plusieurs clefs peuvent être passées dans le cas de l'invocation du service d'autoconfiguration.
 *      Si ce paramètre n'est pas renseigné, alors le paramètre serverUrl doit être renseigné (comprenant alors, si nécessaire la clef API).
 *
 * @param {String} options.serverUrl - URL d'accès au service.
 *      Permet de forcer l'utilisation d'un service équivalent déployé derrière une éventuelle autre URL d'accès.
 *      Si ce paramètre est renseigné alors, le paramètre apiKey est ignoré.
 *
 * @param {String} [options.protocol] - Le protocole à utiliser pour récupérer les informations du service :
 *      peut valoir 'JSONP' ou 'XHR'.
 *      Par défaut, c'est le protocole XHR qui sera utilisé.
 *      Attention, le protocole JSONP n'est pas valide dans un environnement NodeJS (Utilisation du mode XHR).
 *
 * @param {Boolean} [options.ssl] - Indique si l'on souhaite intérroger les services en https.
 *      Ce paramètre ne fonctionne que pour une utilisation hors navigateur (ex. NodeJS).
 *      Sur un navigateur, le protocole est automatiquement extrait de l'url du site...
 *      Par défaut, on utilise le protocole http (ssl=false).
 *
 * @param {String} [options.proxyURL] - Le proxy à utiliser pour pallier au problème de cross-domain dans le cas d'une requête XHR.
 *      Utile si le paramètre 'protocol' vaut 'XHR', il ne sera pas pris en compte si protocol vaut JSONP.
 *
 * @param {String} [options.callbackSuffix] - Suffixe de la fonction de callback à utiliser, dans le cas du protocole JSONP.
 *      Par défaut, la fonction de callback portera un nom du type "callback"+ID, où ID est soit un identifiant unique généré à chaque requête,
 *      soit le paramètre callbackSuffix s'il est spécifié. Par exemple, si callbackSuffix="_2", la fonction sera "callback_2 ()".
 *      Utile pour utiliser une réponse déjà encapsulée dans une fonction de callback, dont le nom est connu (ex : chargement de l'autoconfiguration en local)
 *      Utile seulement si le paramètre 'protocol' vaut 'JSONP', il ne sera pas pris en compte si protocol vaut 'XHR'.
 *
 * @param {String} [options.httpMethod] - La méthode HTTP
 *      à utiliser dans le cas d'une requête XHR : peut valoir 'GET' ou 'POST'.
 *      Non pris en compte si 'protocol' vaut JSONP qui fonctionne obligatoirement en GET.
 *      Par défaut, c'est la méthode GET qui est utilisée.
 *
 * @param {String} [options.contentType] - Content-Type de la requete
 *      à utiliser dans le cas d'une requête XHR en mode POST.
 *      Non pris en compte si 'protocol' vaut JSONP et/ou la méthode HTTP vaut GET.
 *      Par défaut, c'est la méthode GET qui est utilisée donc on n'utilise pas de Content-Type.
 *
 * @param {Number} [options.timeOut] - Délai d'attente maximal (en ms) de la réponse du service (à partir de l'envoi de la requête).
 *      Par défaut, aucun timeOut n'est pris en compte (timeoutDelay= 0).
 *
 * @param {Boolean} [options.rawResponse] - Indique si l'on souhaite que la réponse du service ne soit pas parsée par l'API avant d'être restituée.
 *      (Cf. paramètre « onSuccess » pour plus de détails).
 *
 * @param {Function} [options.onSuccess] - Fonction appelée lorsque le service répond correctement à la requête
 *      (code HTTP 200, sans message d'erreur).
 *      Cette fonction prend en paramètre la réponse du service,
 *      soit sous la forme d'un Object Javascript formaté par le parseur dédié à la syntaxe du service (comportement par défaut) ;
 *      soit brute au format String non prétraité si le paramètre « rawResponse » a été précisé avec la valeur « true ».
 *
 * @param {Function} [options.onFailure] - Fonction appelée lorsque le service ne répond pas correctement
 *      (code HTTP de retour différent de 200 ou pas de réponse).
 *
 * @param {Function} [options.onBeforeParse] - Fonction appelée avant le parsing de la réponse
 *      Permet de modifier la réponse avant parsing et la fonction doit retourner une String.
 *      Cette fonction prend en paramètre la réponse telle que renvoyée par le service
 *      (cad au format json ou xml).
 *      Pour le JSONP, si le paramètre "rawResponse" a été précisé avec la valeur "true",
 *      la fonction prend en paramètre un Object JavaScript contenant la réponse XML.
 *
 * @example
 *   var options = {
 *      apiKey : null,
 *      serverUrl : 'http://localhost/service/',
 *      protocol : 'JSONP', // JSONP|XHR
 *      ssl : false,
 *      proxyURL : null,
 *      callbackName : null,
 *      httpMethod : 'GET', // GET|POST
 *      timeOut : 10000, // ms
 *      rawResponse : false, // true|false
 *      scope : null, // this
 *      onSuccess : function (response) {},
 *      onFailure : function (error) {},
 *      onBeforeParse : function (rawResponse) {}
 *   };
 * @private
 */
function CommonService (options) {
    if (!(this instanceof CommonService)) {
        throw new TypeError(__WEBPACK_IMPORTED_MODULE_2__Utils_MessagesResources__["a" /* default */].getMessage("CLASS_CONSTRUCTOR"));
    }

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("CommonService");
    // this.// logger.trace("[Constructeur CommonService (options)]");

    // #####################
    // récupération des options par défaut pour les paramètres optionnels
    // #####################

    /**
     * Options du service
     * @type {Object}
     */
    this.options = {
        // protocol : "JSONP",
        protocol : "XHR",
        ssl : false,
        proxyURL : "",
        // callbackName : "",
        callbackSuffix : null,
        httpMethod : "GET",
        timeOut : 0,
        rawResponse : false,
        scope : this,
        /**
        * callback par defaut pour la reponse
        * @param {Object} response - response
        * @private
        */
        onSuccess : function (response) {
            // console.log("onSuccess - la reponse est la suivante : ", response);
        },
        /**
        * callback par defaut pour les erreurs
        * @param {Object} error - error
        * @private
        */
        onFailure : function (error) {
            if (error.status === 200 || !error.status) {
                // console.log("onFailure : ", error.message);
            } else {
                // console.log("onFailure - Erreur (", error.status, ") : ", error.message);
            }
        }
    };

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            this.options[opt] = options[opt];
        }
    }

    // #####################
    // analyse des options
    // #####################

    // gestion des clefs API
    if (!this.options.apiKey && !this.options.serverUrl) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_2__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "apiKey", "serverUrl"));
    }

    // modification de la fonction de callback onSuccess dans le cas où la réponse brute est demandée
    if (this.options.rawResponse && !this.options.onSuccess) {
        /**
        * callback par defaut pour la reponse
        * @param {Object} response - response
        * @private
        */
        this.options.onSuccess = function (response) {
            // console.log("onSuccess - la réponse brute du service est la suivante : ", response);
        };
    }

    // gestion du callback onSuccess
    var bOnSuccess = !!((this.options.onSuccess !== null && typeof this.options.onSuccess === "function"));
    if (!bOnSuccess) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_2__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "onSuccess()"));
    }

    // gestion de l'url du service par defaut
    if (!this.options.serverUrl) {
        // INFO
        // gestion de l'url du service par defaut pour les services qui ne possèdent qu'une seul url par defaut
        // les cas particuliers des services avec plusieurs urls (ex. Alti) devront être traité dans la classe du composant
        // donc si l'url n'est pas renseignée, il faut utiliser les urls par defaut
        __WEBPACK_IMPORTED_MODULE_5__DefaultUrlService__["a" /* default */].ssl = this.options.ssl;
        var urlByDefault = __WEBPACK_IMPORTED_MODULE_5__DefaultUrlService__["a" /* default */][this.CLASSNAME].url(this.options.apiKey);
        if (typeof urlByDefault === "string") {
            this.options.serverUrl = urlByDefault;
        } else {
            // this.// logger.trace("URL par defaut à determiner au niveau du composant...");
        }
    }

    // FIXME nettoyage des KVP dans l'url du service
    // if (this.options.serverUrl) {
    //     // INFO
    //     // si l'url est renseignée, il faut la nettoyer de tous ses KVP
    //     // ex. on ne veut pas de params. 'callback' ou 'output' car ceci declencherait
    //     // des opérations d'encapsulations des reponses légèrement farfelues ...
    //     var urlsource = this.options.serverUrl;
    //     var urlparts = urlsource.split("?");
    //     this.options.serverUrl = urlparts[0];
    // }

    // gestion de la methode HTTP
    this.options.httpMethod = (typeof options.httpMethod === "string") ? options.httpMethod.toUpperCase() : "GET";

    switch (this.options.httpMethod) {
        case "POST":
        case "GET":
            break;
        case "PUT":
        case "DELETE":
        case "HEAD":
        case "OPTIONS":
            throw new Error(__WEBPACK_IMPORTED_MODULE_2__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_NOT_SUPPORT", "httpMethod"));
        default:
            throw new Error(__WEBPACK_IMPORTED_MODULE_2__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_UNKNOWN", "httpMethod"));
    }

    // gestion du protocole
    // this.options.protocol = (typeof options.protocol === "string" ) ? options.protocol.toUpperCase() : "JSONP";
    this.options.protocol = (typeof options.protocol === "string") ? options.protocol.toUpperCase() : "XHR";

    switch (this.options.protocol) {
        case "JSONP":
        case "XHR":
            break;
        default:
            throw new Error(__WEBPACK_IMPORTED_MODULE_2__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_UNKNOWN", "protocol"));
    }

    // on determine l'environnement d'execution : browser ou non ?
    // et on lance une exception sur l'utilisation du protocole JSONP pour nodeJS...
    if (typeof window === "undefined" && this.options.protocol === "JSONP") {
        throw new Error(__WEBPACK_IMPORTED_MODULE_2__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_NOT_SUPPORT_NODEJS", "protocol=JSONP (instead use XHR)"));
    }

    // le protocole JSONP ne fonctionne qu'en GET.
    if (this.options.protocol === "JSONP") {
        this.options.httpMethod = "GET";
    }

    // gestion du cache
    this.options.nocache = options.nocache || false;

    // #####################
    // attributs d'instances
    // #####################

    /**
     * Format de réponse du service
     */
    this.options.outputFormat = null;
    /**
     * Requête envoyée au service
     */
    this.request = null;
    /**
     * Reponse du service
     */
    this.response = null;
}

/**
 * @lends module:CommonService
 */
CommonService.prototype = {

    /*
     * Constructeur (alias)
     */
    constructor : CommonService,

    /**
     * Appel du service Géoportail
     */
    call : function () {
        /* jshint validthis : true */
        // this.// logger.trace("CommonService::call ()");

        var context = this;
        /** fonction d'execution */
        function run () {
            // this.// logger.trace("CommonService::run ()");
            this.buildRequest.call(context, onError, onBuildRequest);
        }

        run.call(context);

        // callback de fin de construction de la requête
        function onBuildRequest (result) {
            // this.// logger.trace("CommonService::onBuildRequest : ", result);
            this.callService.call(context, onError, onCallService);
        }

        // callback de fin d'appel au service
        function onCallService (result) {
            // this.// logger.trace("CommonService::onCallService : ", result);
            this.analyzeResponse.call(context, onError, onAnalyzeResponse);
        }

        // callback de fin de lecture de la reponse
        function onAnalyzeResponse (result) {
            // this.// logger.trace("CommonService::onAnalyzeResponse : ", result);
            if (result) {
                this.options.onSuccess.call(this, result);
            } else {
                return onError.call(this, new __WEBPACK_IMPORTED_MODULE_4__Exceptions_ErrorService__["a" /* default */]("Analyse de la reponse en échec !?"));
            }
        }

        // callback de gestion des erreurs : renvoit un objet de type ErrorService
        function onError (error) {
            // this.// logger.trace("CommonService::onError()");
            // error : l'objet est du type ErrorService ou Error
            var e = error;
            if (!(e instanceof __WEBPACK_IMPORTED_MODULE_4__Exceptions_ErrorService__["a" /* default */])) {
                e = new __WEBPACK_IMPORTED_MODULE_4__Exceptions_ErrorService__["a" /* default */](error.message);
            }
            this.options.onFailure.call(this, e);
        }
    },

    /**
     * Création de la requête
     * @param {Function} error - callback
     * @param {Function} success - callback
     */
    buildRequest : function (error, success) {
        // INFO
        this.logger.error("overwritten method !");
        // retourne l'objet 'this.request'
        if (error) {
            error.call(this, "This method must be overwritten !");
        }
        success.call(this, "This method must be overwritten !");
    },

    /**
     * Appel du service
     * @param {Function} error - callback
     * @param {Function} success - callback
     */
    callService : function (error, success) {
        // INFO
        // retourne l'objet 'this.response'

        // NOTES
        //  Pour le mode XHR, on recupère une reponse sous forme d'un json ou xml (#document).
        //  Pour le mode JSONP, on a toujours un objet JSON mais sous 2 formes :
        //      - natif
        //      - XML encapsulé :
        //          {http : {status:200, error:null},xml :'réponse du service'}
        //          {http : {status:400, error:'reponse du service'},xml :null}
        //  En XHR, la reponse est directement sauvegardée dans 'this.response'.
        //  Par contre, en JSONP, on doit analyser la reponse (status ou non vide),
        //  et ne renvoyer que le contenu (xml ou l'objet)

        // gestion de la proxification du service
        var strUrlProxified = null;
        var strData = this.request;

        // a t on mis en place un proxy ?
        // la proxyfication est valable uniquement en mode XHR !
        var bUrlProxified = !!((this.options.proxyURL && this.options.protocol === "XHR"));

        // rajout de l'option gpbibaccess
        // INFO : acces au numero de version de package.conf aprés compilation !
        this.options.serverUrl = __WEBPACK_IMPORTED_MODULE_1__Utils_Helper__["a" /* default */].normalyzeUrl(this.options.serverUrl, {
            "gp-access-lib" : "2.1.0"
        }, false);

        // si le proxy est renseigné, on proxifie l'url du service
        if (bUrlProxified) {
            if (this.options.httpMethod === "GET") {
                strUrlProxified = this.options.proxyURL + __WEBPACK_IMPORTED_MODULE_1__Utils_Helper__["a" /* default */].normalyzeUrl(this.options.serverUrl, this.request, true);
                strData = null;
            }

            if (this.options.httpMethod === "POST") {
                strUrlProxified = this.options.proxyURL + __WEBPACK_IMPORTED_MODULE_1__Utils_Helper__["a" /* default */].normalyzeUrl(this.options.serverUrl, null, true);
                strData = this.request;
            }
        }

        // contexte du composant spécifique !
        var self = this;

        var options = {
            url : strUrlProxified || this.options.serverUrl,
            method : this.options.httpMethod,
            protocol : this.options.protocol,
            timeOut : this.options.timeOut || 0,
            format : this.options.outputFormat, // ceci declenche le parsing de la reponse du service, mais on souhaite toujours une reponse brute (string) !
            nocache : this.options.nocache || false, // ceci permet d'ajouter un timestamp dans la requête
            wrap : this.options.protocol !== "XHR", // ceci declenche l'encapsulation de la reponse XML du service dans du JSON, mais pas en mode XHR !
            callbackSuffix : this.options.callbackSuffix,
            // callbackName : this.options.callbackName || null,
            data : strData,
            headers : null, // TODO...
            content : this.options.contentType || "application/xml",
            scope : this.options.scope || this,
            // callback de reponse
            onResponse : function (response) {
                // self.// logger.trace("callService::onResponse()");

                // le contenu de la reponse à renvoyer !
                var content = null;

                // XHR : on renvoie toujours la reponse brute du service (json ou xml)
                // au parser du composant...
                if (self.options.protocol === "XHR") {
                    // self.// logger.trace("Response XHR", response);
                    content = response; // par defaut, la reponse du service  !
                }

                // JSONP : on pre-analyse la reponse brute du service (encapsuler ou pas)
                // avant de l'envoyer au parser du composant...
                if (self.options.protocol === "JSONP") {
                    // self.// logger.trace("Response JSON", response);
                    if (response) {
                        if (response.http) {
                            // reponse encapsulée :
                            // ex. reponse du service en xml
                            // > {http : {status:200, error:null},xml :'réponse du service'}
                            if (response.http.status !== 200) {
                                error.call(self, new __WEBPACK_IMPORTED_MODULE_4__Exceptions_ErrorService__["a" /* default */]({
                                    status : response.http.status,
                                    message : response.http.error,
                                    type : __WEBPACK_IMPORTED_MODULE_4__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
                                }));
                                return;
                            } else {
                                content = response.xml; // par defaut !
                                if (self.options.rawResponse) {
                                    content = response;
                                }
                            }
                        } else {
                            // reponse non encapsulée :
                            // ex. reponse du service en json ou xml
                            content = response;
                        }
                    } else {
                        error.call(self, new __WEBPACK_IMPORTED_MODULE_4__Exceptions_ErrorService__["a" /* default */]("Le contenu de la reponse est vide !?"));
                        return;
                    }
                }

                // si on souhaite parser la reponse du service
                if (typeof self.options.onBeforeParse === "function") {
                    var newResponse = self.options.onBeforeParse(content);
                    if (typeof newResponse === "string") {
                        // la reponse parsée par l'utilisateur est retournée sous
                        // forme de string !
                        content = newResponse;
                    }
                }
                // sauvegarde de la reponse dans l'objet parent (CommonService)
                self.response = content;
                // on renvoie la reponse...
                success.call(self, content);
            },
            // callback des erreurs
            onFailure : function (e) {
                // self.// logger.trace("callService::onFailure()");
                // on est forcement sur une erreur levée par un service !
                e.type = __WEBPACK_IMPORTED_MODULE_4__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR;
                error.call(self, new __WEBPACK_IMPORTED_MODULE_4__Exceptions_ErrorService__["a" /* default */](e));
            },
            // callback de timeOut
            onTimeOut : function () {
                // self.// logger.trace("callService::onTimeOut()");
                error.call(self, new __WEBPACK_IMPORTED_MODULE_4__Exceptions_ErrorService__["a" /* default */]("TimeOut!"));
            }
        };

        __WEBPACK_IMPORTED_MODULE_3__Protocols_Protocol__["a" /* default */].send(options);
    },

    /**
     * Analyse de la réponse
     * @param {Function} error - callback
     * @param {Function} success - callback
     */
    analyzeResponse : function (error, success) {
        // INFO
        this.logger.error("overwritten method !");
        // retourne l'objet spécifique au type de composant (json)
        if (error) {
            error.call(this, "This method must be overwritten !");
        }
        success.call(this, "This method must be overwritten !");
    }

};

/* harmony default export */ __webpack_exports__["a"] = (CommonService);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Classe utilitaire
 *
 * @module Helper
 * @private
 * @alias Gp.Utils.Helper
 */
var Helper = {

    /**
     * concatenation des parametres key/value dans les urls
     *
     * @method normalyzeParameters
     * @static
     * @param {Object} params - tableau de clef/valeur
     *
     * @example
     *  Gp.Utils.Helper.normalyzeParameters ({
     *         key1:value1,
     *         key2:value2,
     *         key3:value3
     *  });
     *  // out : "key1=value1&key2=value2&key3=value3"
     *
     * @returns {String} retourne les paramètres concaténés
     */
    normalyzeParameters : function (params) {
        var myParams = null;

        if (params) {
            var tabParams = [];
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var value = params[key];
                    if (!value) {
                        value = "";
                    }
                    tabParams.push(key + "=" + value);
                }
            }

            myParams = tabParams.join("&");
        }

        return myParams;
    },

    /**
     * Concaténation et encodage des urls.
     *
     * @method normalyzeUrl
     * @static
     * @param {String} url - url
     * @param {Object|String} params - tableau de clef/valeur ou string
     * @param {Boolean} encode - true|false, false par defaut
     *
     * @example
     *  Gp.Utils.Helper.normalyzeUrl (url, {
     *         key1:value1,
     *         key2=:value2,
     *         key3:value3
     *  });
     *  // out : "url?key1=value1&key2=value2&key3=value3"
     *
     * @returns {String} retourne une url normalisée
     */
    normalyzeUrl : function (url, params, encode) {
        var myUrl = url;

        if (url) {
            var k = url.indexOf("?");
            if (k === -1) { // pas de ? et KVP
                myUrl += "?";
            }

            if (k !== -1 && k !== url.length - 1) { // KVP
                myUrl += "&";
            }
        }

        if (params) {
            if (typeof params === "string") {
                myUrl += params;
            } else {
                myUrl += this.normalyzeParameters(params);
            }
        }

        if (encode) {
            // FIXME bonne idée ?
            myUrl = encodeURIComponent(myUrl);
        }

        return myUrl;
    },

    /**
     * Indentation d'une chaine
     *
     * @param {Number} n - nombre de tabulation
     * @param {String} msg - chaine
     *
     * @example
     * Gp.Utils.Helper.indent (2, "message à indenter")
     * // out
     * // ........message à indenter
     *
     * @returns {String} retourne une chaine indentée
     */
    indent : function (n, msg) {
        var num = n || 0;
        return new Array(num + 1).join("\t") + msg;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Helper);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// cette classe contient les URLs par defaut des services.
//  DefaultUrlService.Alti.url(key)[elevation-json]
//  DefaultUrlService.Alti.url(key)[elevation-xml]
//  DefaultUrlService.Alti.url(key)[profil-json]
//  DefaultUrlService.Alti.url(key)[profil-xml]
//  DefaultUrlService.Alti.url(key)[wps]
//  DefaultUrlService.ProcessIsoCurve.url(key)
//  DefaultUrlService.AutoComplete.url(key)
//  DefaultUrlService.ReverseGeocode.url(key)
//  DefaultUrlService.AutoConf.url(key)[apiKey]
//  DefaultUrlService.AutoConf.url(key)[apiKeys]
//  DefaultUrlService.AutoConf.url(key)[aggregate]
//  DefaultUrlService.Geocode.url(key)
//  DefaultUrlService.Route.url(key)

// Example :
//
// DefaultUrlService.Alti.url('efe4r54tj4uy5i78o7545eaz7e87a')[elevation-json]
//  output {String} -> http://wxs.ign.fr/efe4r54tj4uy5i78o7545eaz7e87a/alti/rest/elevation.json
//
// DefaultUrlService.Alti.url('efe4r54tj4uy5i78o7545eaz7e87a')
// output {Object|String}
// -> http://wxs.ign.fr/efe4r54tj4uy5i78o7545eaz7e87a/alti/rest/elevation.json
// -> http://wxs.ign.fr/efe4r54tj4uy5i78o7545eaz7e87a/alti/rest/elevation.xml
// -> http://wxs.ign.fr/efe4r54tj4uy5i78o7545eaz7e87a/alti/rest/elevationLine.json
// -> http://wxs.ign.fr/efe4r54tj4uy5i78o7545eaz7e87a/alti/rest/elevationLine.xml
// -> http://wxs.ign.fr/efe4r54tj4uy5i78o7545eaz7e87a/alti/wps
//
// Force ssl :
//
// DefaultUrlService.ssl = true;
// DefaultUrlService.AutoComplete.url('efe4r54tj4uy5i78o7545eaz7e87a')
// output {Object|String}
// -> https://wxs.ign.fr/efe4r54tj4uy5i78o7545eaz7e87a/ols/apis/completion

// constantes internes
var ISBROWSER = typeof window !== "undefined" ? 1 : 0;
var HOSTNAME = "wxs.ign.fr";

/**
 * Default Geoportal web services URLs access.
 *
 * @namespace
 * @alias Gp.Services.DefaultUrl
 */
var DefaultUrlService = {

    /** if set true, require the use of https protocol (except browser) */
    ssl : false,

    /**
    * base url of services (ssl protocol management)
    * @param {String} key - key
    * @param {String} path - path
    * @returns {String} url
    */
    url : function (key, path) {
        // en mode browser, c'est le protocole du navigateur,
        // sinon, il est fixé par l'option 'ssl' (par défaut à false, cad en http)
        var _protocol = (ISBROWSER) ? (location && location.protocol && location.protocol.indexOf("https:") === 0 ? "https://" : "http://") : (DefaultUrlService.ssl ? "https://" : "http://");
        return _protocol + HOSTNAME.concat("/", key, path);
    },

    /**
     * Elevation web service access
     *
     * @member {Object}
     * @property {Function} url (key) - Returns elevation service default urls with or without geoportal access key given as a parameter. The result is a javascript object with different urls given used protocols ("elevation-json", "elevation-xml", "profil-json" or "profil-xml").
     */
    Alti : {
        _key : {
            // rest
            "elevation-json" : "/alti/rest/elevation.json",
            "elevation-xml" : "/alti/rest/elevation.xml",
            "profil-json" : "/alti/rest/elevationLine.json",
            "profil-xml" : "/alti/rest/elevationLine.xml",
            // other
            wps : "/alti/wps"
        },
        /**
        * url
        * @param {String} key - key
        * @returns {String} url
        */
        url : function (key) {
            return {
                // rest
                "elevation-json" : DefaultUrlService.url(key, this._key["elevation-json"]),
                "elevation-xml" : DefaultUrlService.url(key, this._key["elevation-xml"]),
                "profil-json" : DefaultUrlService.url(key, this._key["profil-json"]),
                "profil-xml" : DefaultUrlService.url(key, this._key["profil-xml"]),
                // other
                wps : DefaultUrlService.url(key, this._key["wps"])
            };
        }
    },
    /**
     * IsoCurve web service access
     *
     * @member {Object}
     * @property {Function} url (key) - Returns isocurve service default urls with or without geoportal access key given as a parameter. The result is a javascript object with different urls given used protocols ("iso-json" or "iso-xml").
     */
    ProcessIsoCurve : {
        _key : {
            "iso-json" : "/isochrone/isochrone.json", // rest (geoconcept)
            "iso-xml" : "/isochrone/isochrone.xml" // rest (geoconcept)
        },
        /**
        * url
        * @param {String} key - key
        * @returns {String} url
        */
        url : function (key) {
            return {
                "iso-json" : DefaultUrlService.url(key, this._key["iso-json"]),
                "iso-xml" : DefaultUrlService.url(key, this._key["iso-xml"])
            };
        }
    },
    /**
     * Autocompletion web service access
     *
     * @member {Object}
     * @property {Function} url (key) - Returns autocomplete service default urls with or without geoportal access key given as a parameter. The result is a String.
     */
    AutoComplete : {
        _key : "/ols/apis/completion",
        /**
        * url
        * @param {String} key - key
        * @returns {String} url
        */
        url : function (key) {
            return DefaultUrlService.url(key, this._key);
        }
    },
    /**
     * Reverse geocoding web service access
     *
     * @member {Object}
     * @property {Function} url (key) - Returns reverse geocoding service default urls with or without geoportal access key given as a parameter. The result is a String.
     */
    ReverseGeocode : {
        _key : "/geoportail/ols",
        /**
        * url
        * @param {String} key - key
        * @returns {String} url
        */
        url : function (key) {
            return DefaultUrlService.url(key, this._key);
        }
    },
    /**
     * Autoconfiguration web service access
     *
     * @member {Object}
     * @property {Function} url ([key1,...]) - Returns autoconfiguration service default urls with geoportal access key (s) given as a String array parameter. The result is a javascript object with different urls given the access mode ("apiKey", "apiKeys" or "aggregate").
     */
    AutoConf : {
        _key : {
            apiKey : "/autoconf",
            apiKeys : "/autoconf?keys=%KEYS%",
            aggregate : "/autoconf/id/"
        },
        /**
        * url
        * @param {String} key - key
        * @returns {String} url
        */
        url : function (key) {
            var keys = "";
            if (Array.isArray(key) && key.length > 0) {
                keys = key[0];
                for (var i = 1; i < key.length; i++) {
                    keys += "," + key[i];
                }
            }
            return {
                apiKey : DefaultUrlService.url(key, this._key["apiKey"]), // une seule clé
                apiKeys : DefaultUrlService.url(key[0], this._key["apiKeys"]).replace("%KEYS%", keys), // autoconf de plusieurs clés
                aggregate : DefaultUrlService.url(key, this._key["aggregate"])
            };
        }
    },
    /**
     * Geocoding web service access
     *
     * @member {Object}
     * @property {Function} url (key) - Returns geocoding service default urls with or without geoportal access key given as a parameter. The result is a String.
     */
    Geocode : {
        _key : "/geoportail/ols",
        /**
        * url
        * @param {String} key - key
        * @returns {String} url
        */
        url : function (key) {
            return DefaultUrlService.url(key, this._key);
        }
    },
    /**
     * Routing web service access
     *
     * @member {Object}
     * @property {Function} url (key) - Returns routing service default urls with or without geoportal access key given as a parameter. The result is a javascript object with different urls given used protocols ("route-json" or "route-xml").
     */
    Route : {
        _key : {
            ols : "/itineraire/ols", // openLS
            "route-json" : "/itineraire/rest/route.json", // rest (geoconcept)
            "route-xml" : "/itineraire/rest/route.xml" // rest (geoconcept)
        },
        /**
        * url
        * @param {String} key - key
        * @returns {String} url
        */
        url : function (key) {
            return {
                ols : DefaultUrlService.url(key, this._key["ols"]),
                "route-json" : DefaultUrlService.url(key, this._key["route-json"]),
                "route-xml" : DefaultUrlService.url(key, this._key["route-xml"])
            };
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DefaultUrlService);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* global require */


// import __xmldom from "xmldom";

/**
 * @classdesc
 *
 * Classe permettant d'écrire ou de lire du XML, sous forme de document DOM,
 * éventuellement selon des clés de lecture (readers) ou d'écriture (writers) spécifiques.
 *
 * @constructor
 * @alias Gp.Formats.XML
 *
 * @param {Object} [options] - options du format XML
 *
 * @param {Object} [options.reader] - Instance d'un Reader de service (AltiResponseReader, GeocodeRequestReader, etc.)
 *      utile pour interpréter le XML lorsque sa structure est connue.
 *      Ce reader doit comporter au moins une fonction statique read (root) permettant d'initialiser la lecture.
 *
 * @param {Object} [options.writers] - writers
 *
 * @param {String} [options.xmlString] - chaîne de caractère contenant du XML à interpréter.
 *
 * @private
 */
function XML (options) {
    if (!(this instanceof XML)) {
        throw new TypeError("XML constructor cannot be called as a function.");
    }

    // FIXME : notion de singleton

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur XML ()]");

    /**
     * Chaîne de caractères contenant le texte XML
     * @type {String}
     */
    this.xmlString = null;

    /**
     * DOM Element correspondant à la structure du XML.
     * @type {DOMElement}
     */
    this.xmlDoc = null;

    /**
     * Objet contenant des fonctions de lecture des différentes balises XML.
     * @type {Object}
     */
    this.reader = null;

    // traitement des paramètres d'options s'il y en a
    if (options) {
        if (options.xmlString && typeof options.xmlString === "string") {
            this.xmlString = options.xmlString;
            // Si une chaine de caractère a été passée en entrée : on la transforme aussi en XML document
            this.xmlDoc = __getXMLDOC(options.xmlString);
        }
        if (options.reader) {
            this.setReader(options.reader);
        }
    }
}

XML.prototype = {

    /**
     * @lends module:XML
     */

    /*
     * Constructeur (alias)
     */
    constructor : XML,

    /**
     * Méthode permettant de récupérer la chaîne de caractères associée au format XML
     *
     * @returns {String} xmlString - la chaîne de caractères correspondant au format XML
     */
    getXMLString : function () {
        return this.xmlString;
    },

    /**
     * Méthode permettant d'attribuer une chaîne de caractères au format XML (attribut xmlString).
     * La méthode va aussi transformer cette chaîne de caractères en document XML,
     * afin de remplir l'attribut xmlDoc.
     *
     * @param {String} xmlString - la chaîne de caractères correspondant au format XML
     */
    setXMLString : function (xmlString) {
        if (xmlString && typeof xmlString === "string") {
            this.xmlString = xmlString;
            this.xmlDoc = __getXMLDOC(xmlString);
        }
    },

    /**
     * Méthode permettant de récupérer les readers associés au format XML, s'ils ont été définis
     *
     * @return {Object} readers - les readers associés au format XML, s'ils existent,
     *      sous forme d'une collection de fonctions
     */
    getReader : function () {
        return this.reader;
    },

    /**
     * Méthode permettant d'attribuer des readers, sous la forme d'un objet de fonctions (node, data),
     *      lorsqu'ils n'ont pas été définis lors de l'instanciation par exemple (new XML (options)).
     *
     * @param {Object} reader - Instance d'un Reader de service (AltiResponseReader, GeocodeRequestReader, etc.)
     *      utile pour interpréter le XML lorsque sa structure est connue.
     *      Ce reader doit comporter au moins une fonction statique read (root) permettant d'initialiser la lecture.
     */
    setReader : function (reader) {
        if (reader && reader.read && typeof reader.read === "function") {
            this.reader = reader;
        }
    },

    /**
     * Méthode permettant de récupérer le document XML associé au format, s'il existe.
     *
     * @return {DOMElement} xmlDoc - le document XML (DOM document node) s'il existe
     */
    getXMLDoc : function () {
        return this.xmlDoc;
    },

    /**
     * Setter
     */
    setXMLDoc : function (doc) {
        this.xmlDoc = doc;
    },
    /**
     * Méthode initialisant la lecture du XML, à partir d'un XML Document :
     *      création d'un objet JavaScript contenant les informations du XML,
     *      sauf dans le cas où il n'existe pas de XML Document à interpréter (retourne un objet vide).
     *
     * @return {Object} [parserOutput] - un objet JavaScript contenant les informations du XML :
     * - soit toutes les informations si aucun reader n'a été spécifié à la création du format
     * - soit les informations spécifiées dans le reader.
     */
    parse : function () {
        // build xml document from xmlString
        if (!this.xmlDoc && this.xmlString) {
            this.xmlDoc = __getXMLDOC(this.xmlString);
        }
        if (this.xmlDoc) {
            var root = __getRootNode(this.xmlDoc);
            if (root) {
                var parserOutput;
                // call reader if exists
                if (this.reader && this.reader.read) {
                    parserOutput = this.reader.read(root);
                } else {
                    parserOutput = {};
                    parserOutput[root.nodeName] = __readDefault(root);
                }
                return parserOutput;
            } else {
                return {};
            }
        }
    }

};

/**
 * Méthode de la classe (privée) permettant de créer un XML Document à partir d'une chaîne de caractères XML,
 *      en utilisant DOMParser () lorsque c'est possible.
 *      For more information, see: https://dvcs.w3.org/hg/innerhtml/raw-file/tip/index.html#the-domparser-interface
 *
 * @private
 * @memberof XML
 * @method __getXMLDOC
 * @param {String} xmlString - xml string to be converted into DOM element
 * @return {DOMElement} - the corresponding XML Document
 */
function __getXMLDOC (xmlString) {
    if (typeof window === "undefined") {
        // env. nodejs
        var DOMParser = __webpack_require__(20).DOMParser; // __xmldom.DOMParser;
        return new DOMParser().parseFromString(xmlString, "text/xml");
    } else {
        // env. browser

        var parser;
        var xmlDoc;
        var errorMsg = "Erreur lors du parsing de la réponse du service : XML non conforme";

        if (window.ActiveXObject) {
            // Internet Explorer < 9
            xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM");
            xmlDoc.async = false;
            xmlDoc.loadXML(xmlString);
            var parseError = xmlDoc.parseError;
            if (parseError.errorCode) {
                if (parseError.line && parseError.linepos) {
                    errorMsg += "( ligne " + parseError.line + ", colonne " + parseError.linepos;
                }
                if (parseError.reason) {
                    errorMsg += ":  " + parseError.reason + ")";
                }
                throw new Error(errorMsg);
            }
            return xmlDoc;
        } else if (window.DOMParser) {
            // les autres (Chrome, Mozilla, IE >= 9)
            parser = new window.DOMParser();
            try {
                xmlDoc = parser.parseFromString(xmlString, "text/xml");
            } catch (e) {
                // Internet Explorer browser raises exception if xmlString is not valid XML
                if (e.message === "SyntaxError") {
                    throw new Error(errorMsg);
                } else {
                    throw new Error("Erreur lors du parsing de la réponse du service : " + e.message);
                }
            }
            // look for parsing error in case no exception was raised
            if (xmlDoc.getElementsByTagName("parsererror").length > 0) {
                var parsererror = xmlDoc.getElementsByTagName("parsererror");
                for (var i = 0; i < parsererror.length; i++) {
                    var content = parsererror[i].innerHTML;
                    // except in case parsererror is just because of huge xml, but parsing is done.
                    if (content.indexOf("Huge input lookup") === -1) {
                        errorMsg += "(" + content + ")";
                        throw new Error(errorMsg);
                    }
                }
            } else if (!xmlDoc.documentElement) { // may happen in chrome browser
                throw new Error(errorMsg);
            }
            return xmlDoc;
        } else {
            // FIXME
            throw new Error("Incompatible DOM Parser pour ce navigateur !");
        }
    }
}

/**
 * Méthode de la classe (privée) permettant de récupérer le noeud racine du document,
 *      à partir d'un document node (nodeType=9), puis lecture de ce noeud (readNode)
 *
 * @private
 * @memberof XML
 * @method __getRootNode
 * @param {DOMElement} [xmlDoc] - a Document Node
 * @return {DOMElement} root - the document root node
 */
function __getRootNode (xmlDoc) {
    var root;
    if (xmlDoc.nodeType === 9) {
        // INFO : nodeType 9 represents the entire document (the root-node of the DOM tree)
        root = xmlDoc.documentElement;
    } else if (xmlDoc.nodeType === 1) {
        root = xmlDoc;
    }
    return root;
}

/**
 * Méthode de la classe (privée) permettant de lire automatiquement un noeud XML,
 *      lorsqu'aucun reader spécifique n'a été spécifié (parser brut)
 *
 * @private
 * @memberof XML
 * @method readDefault
 * @param {DOMElement} node - a DOM element node
 * @example final data object looks like :
 *          data = {
 *              attributeName: attributeValue,
 *              childName: {
 *                  attributeName: attributeValue,
 *                  attributeName: attributeValue,
 *                  childName: {
 *                      "textContent": textContent
 *                  },
 *                  childName: {
 *                      childName: {
 *                          attributeName:attributeValue
 *                      }
 *                  }
 *              }
 *          }
 */
function __readDefault (node) {
    var data = {};

    // if element node has attributes, set their values to data
    if (node.attributes.length > 0) {
        var dataAttributes = __getAttributes(node);
        data["attributes"] = dataAttributes;
    }

    // if element node has childNodes, read them and set them to data
    if (node.hasChildNodes()) {
        var childData = {};
        var child;
        var children = node.childNodes;

        for (var i = 0; i < children.length; i++) {
            child = children[i];

            if (child.nodeType === 3) { // TEXT_NODE
                data["textContent"] = child.nodeValue;
            } else if (child.nodeType === 1) {
                childData = __readDefault(child);

                if (!data[child.nodeName]) {
                    // store childData in an object
                    data[child.nodeName] = childData;
                } else {
                    // in case several childNodes has the same name : store them in an array.
                    // if data[nodeName] already exists but is not an array
                    if (!Array.isArray(data[child.nodeName])) {
                        var old = data[child.nodeName];
                        data[child.nodeName] = [];
                        data[child.nodeName].push(old);
                    }
                    data[child.nodeName].push(childData);
                }
            }
            // TODO : manage other node types (4=CDATA, etc)
        }
    }

    return data;
}

/**
 * Méthode de la classe (privée) permettant de récupérer les attributs d'un noeud élément
 *
 * @private
 * @memberof XML
 * @method __getAttributes
 * @param {DOMElement} node - noeud contenant l'attribut recherché
 * @return {Object} nodeAttributes - objet contenant les noms et valeurs des différents attributs
 */
function __getAttributes (node) {
    if (node.attributes.length > 0) {
        var nodeAttributes = {};
        var attributes = node.attributes;
        for (var i = 0; i < attributes.length; i++) {
            var attribute = attributes[i];
            nodeAttributes[attribute.nodeName] = attribute.nodeValue;
        }
        return nodeAttributes;
    }
}

/* harmony default export */ __webpack_exports__["a"] = (XML);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * @classdesc
 *
 * Liste des attributs des tables de geocodage
 * @constructor
 * @alias Gp.Services.Geocode.Request.GeocodeLocation
 * @private
 */
function GeocodeLocation () {
    if (!(this instanceof GeocodeLocation)) {
        throw new TypeError("GeocodeLocation constructor cannot be called as a function.");
    }

    /**
     * Objet qui peut prendre comme propriétés les valeurs du tableau serviceAttributes
     * @type {Object}
     */
    this.placeAttributes = {};

    /**
     * Tableau qui liste les attributs spécifiques selon le type de la GeocodeLocation.
     * Ces attributs correspondent à ceux saisis par l'utilisateur (légèrement différents de ceux du service)
     * @type {String[]}
     */
    this.attributesList = [];

    /**
     * Tableau qui liste les attributs spécifiques selon le type de la GeocodeLocation
     * Ces attributs correspondent à ceux interprétés par le service (balises Place).
     * @type {String[]}
     */
    this.serviceAttributes = [];
}

/**
 * @lends module:GeocodeLocation
 */
GeocodeLocation.prototype = {

    /**
     * Constructeur (alias)
     */
    constructor : GeocodeLocation

};

/* harmony default export */ __webpack_exports__["a"] = (GeocodeLocation);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);


/**
 * Lecture / Ecriture du format WKT
 *
 * Les besoins sont assez simples :
 * 1. lecture des types suivants :
 *  - LINESTRING
 *  - POLYGON
 *  - (TODO)
 * 2. convertir aux formats suivants :
 *  - json
 *  - (TODO)
 *
 *
 * @example
 *  var strWKT = "LINESTRING (2.416907 48.846577, 2.416916 48.846613)";
 *  WKT.toJson (strWKT,
 *      function onSuccess (json) {
 *          // {
 *          //      type : 'LINESTRING',
 *          //      coordinates : [
 *          //          [2.416907, 48.846577],
 *          //          [2.416916, 48.846613]
 *          //      ]
 *          // }
 *      },
 *      function onError (error) {
 *          // console.log(error);
 *      }
 *  );
 *
 * @module WKT
 * @alias Gp.Formats.WKT
 * @private
 */

var WKT = {

    /**
     * Parsing d'une chaine WKT
     *
     * @method toJson
     * @param {String} strWkt - chaine de type WKT
     * @param {Function} success - fonction callback
     * @param {Function} error   - fonction callback
     */
    toJson : function (strWkt, success, error) {
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();

        var json = null;

        try {
            if (!strWkt) {
                throw new Error("La chaine WKT n'est pas renseignée !");
            }

            if (!success) {
                // callback success par defaut
                success = function (json) {
                    // console.log(json);
                };
            }

            if (!error) {
                // callback error par defaut
                error = function (e) {
                    // console.log(e);
                };
            }

            var regex;
            var subst;

            // regex coordinates
            regex = /(-?\d+\.?[0-9]*)\s(-?\d+\.?[0-9]+)/g;
            subst = "[$1,$2]";
            strWkt = strWkt.replace(regex, subst);

            // regex type
            regex = /^(\w+)/;
            regex.exec(strWkt);
            if (RegExp.$1 === "POLYGON") {
                subst = "{\"type\" : \"Polygon\",";
                strWkt = strWkt.replace(RegExp.$1, subst);
                // clean
                // (( --> coordinates : [[
                regex = /(\({2}?)/;
                subst = "\"coordinates\" : [[";
                strWkt = strWkt.replace(regex, subst);
                // )) --> ]]}
                regex = /(\){2}?)/;
                subst = "]]}";
                strWkt = strWkt.replace(regex, subst);
                // all ( --> [
                regex = /(\()/g;
                subst = "[";
                strWkt = strWkt.replace(regex, subst);
                // all ) --> ]
                regex = /(\))/g;
                subst = "]";
                strWkt = strWkt.replace(regex, subst);
            } else if (RegExp.$1 === "LINESTRING") {
                subst = "{\"type\" : \"LineString\",";
                strWkt = strWkt.replace(RegExp.$1, subst);
                // clean
                regex = /(\(\(?)/;
                subst = "\"coordinates\" : [";
                strWkt = strWkt.replace(regex, subst);
                regex = /(\)\)?)/;
                subst = "]}";
                strWkt = strWkt.replace(regex, subst);
            }

            // logger.trace(strWkt);

            json = JSON.parse(strWkt);

            if (!json) {
                throw new Error("Le JSON est vide !");
            }

            if (!json.type) {
                throw new Error("Le type de geometrie n'est pas connu !");
            }

            if (!json.coordinates) {
                throw new Error("La liste des points est vide !");
            }

            success.call(this, json);
        } catch (e) {
            if (e.name === "SyntaxError") {
                error.call(this, "Erreur de parsing JSON !");
                return;
            }
            error.call(this, e);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (WKT);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Response object for {@link module:Services~getAltitude Gp.Services.getAltitude ()} invocation when successful. Received as the argument of onSuccess callback function.
 *
 * @property {Array.<Gp.Services.Alti.Elevation>} elevations - Elevations array.
 *
 * @namespace
 * @alias Gp.Services.AltiResponse
 */
function AltiResponse () {
    if (!(this instanceof AltiResponse)) {
        throw new TypeError("AltiResponse constructor cannot be called as a function.");
    }

    this.elevations = [];
}

AltiResponse.prototype = {

    constructor : AltiResponse

};

/* harmony default export */ __webpack_exports__["a"] = (AltiResponse);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Single elevation object returned by underlying web service. Contains at least, one elevation (z). May also contain point coordinates and elevation accuracy if "zonly" parameter wasn't set to true.
 *
 * @property {Float} lat - Point latitude. (only if zonly=false)
 * @property {Float} lon - Point longitude. (only if zonly=false)
 * @property {Float} z - Point elevation.
 * @property {Float} acc - Accuracy of elevation for this point. (only if zonly=false)
 *
 * @namespace
 * @alias Gp.Services.Alti.Elevation
 */
function Elevation () {
    if (!(this instanceof Elevation)) {
        throw new TypeError("Elevation constructor cannot be called as a function.");
    }

    this.z = null;
}

Elevation.prototype = {

    constructor : Elevation

};

/* harmony default export */ __webpack_exports__["a"] = (Elevation);


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__XLS_RequestHeader__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__XLS_Request__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__XLS_AbstractService__ = __webpack_require__(12);





/**
 * @classdesc
 *
 * standard OpenLS
 * standard XLS
 * (version 1.2)
 *
 * Réfs :
 *     - {@link http://schemas.opengis.net/ols/1.2/}
 *     - {@link http://www.opengeospatial.org/standards/ols}
 *     - {@link http://wxs.ign.fr/schemas/}
 *
 *
 * Création du template XLS (avec gestion des namespaces)
 * ------------------------
 * ```
 *   balise xsd : element name="XLS" attribute name="version" [(attribute ref="lang")]
 * ```
 *
 * Exemple :
 * ```
 * <XLS xmlns="http://www.opengis.net/xls" version="1.2">
 *   < (ref. OLS) />
 * </XLS>
 * ```
 * ```
 * <xls:XLS xmlns:xls="http://www.opengis.net/xls" version="1.2">
 *   <xls: (ref. OLS) />
 * </xls:XLS>
 * ```
 *
 * Création des templates OLS pour LocationUtilityService
 * ------------------------------------------------------
 *
 * Exemple :
 *
 * ```
 * <RequestHeader srsName="epsg:4326"/>
 * <Request maximumResponses="26" methodName="GeocodeRequest" requestID="uid1349081498314_388" version="1.2">
 *      <GeocodeRequest>
 *          <Address countryCode="PositionOfInterest">
 *              <freeFormAddress>saint mandé</freeFormAddress>
 *          </Address>
 *      </GeocodeRequest>
 *  </Request>
 * ```
 * ```
 * <RequestHeader sessionID="" />
 * <Request methodName="ReverseGeocodeRequest" version="1.2" requestID="" maximumResponses="10">
 *   <ReverseGeocodeRequest>
 *     <Position>
 *       <gml:Point xmlns:gml="http://www.opengis.net/gml">
 *           <gml:pos>50.347775 3.205098</gml:pos>
 *       </gml:Point>
 *     </Position>
 *     <ReverseGeocodePreference>StreetAddress</ReverseGeocodePreference>
 *  </ReverseGeocodeRequest>
 * </Request>
 * ```
 * ```
 * Geocodage direct (balise xsd) :
 *   element ref="RequestHeader" [ (attribute name="clientName" attribute name="clientPassword" attribute name="sessionID" attribute name="srsName" attribute name="MSID") ]
 *     element name="Request" attribute name="methodName" attribute name="version" attribute name="requestID" [ attribute name="maximumResponses" ]
 *       element name="GeocodeRequest" attribute name="returnFreeForm"
 *         element ref="xls:Address"
 * ```
 * ```
 * Geocodage inverse (balise xsd) :
 *   element ref="RequestHeader" [ (attribute name="clientName" attribute name="clientPassword" attribute name="sessionID" attribute name="srsName" attribute name="MSID") ]
 *     element name="Request" attribute name="methodName" attribute name="version" attribute name="requestID" [ attribute name="maximumResponses" ]
 *       element name="ReverseGeocodeRequest"
 *         element ref="xls:Position"
 *         element name="ReverseGeocodePreference" (enumeration)
 * ```
 *
 * Il existe 3 sous ensembles d'objets :
 *     - RequestHeader
 *     - Request
 *     - ReverseGeocodeRequest, GeocodeRequest
 *
 * GeocodeRequest est composé d'un objet {@link Gp.Services.Geocode.Response.GeocodeLocation}.
 * ReverseGeocodeRequest est composé d'un objet {@link Gp.Services.ReverseGeocode.Response.ReverseGeocodeLocation}.
 *
 * Les locations font appels aux objets suivants qui possèdent des attributs spécifiques
 * en fonction du type de table de geocodage interrogé :
 *     - StreetAddress
 *     - CadastralParcel
 *     - PositionOfInterest
 *     - Administratif
 *
 *
 * et des élements sous jacents tels que :
 *     - ReverseGeocodePreference -> tables de geocodages :
 *         - StreetAddress
 *         - CadastralParcel
 *         - PositionOfInterest
 *         - Administratif (une balise par table)
 *     - Position -> standard GML 3.2.1
 *     - Address  -> cf. ci-dessous
 *
 * ```
 * Position (balise xsd) :
 *   ex. <Position><gml:Point xmlns:gml="http://www.opengis.net/gml"><gml:pos>50.347775 3.205098</gml:pos></gml:Point></Position>
 *   ex. <Position><gml:CircleByCenterPoint xmlns:gml="http://www.opengis.net/gml"><gml:pos>48.85978570614691 2.2913572761128878</gml:pos><gml:radius>1000</gml:radius></gml:CircleByCenterPoint></Position>
 *   (au choix)
 *   element ref="gml:Point"
 *   element ref="gml:CircleByCenterPoint"
 *   element ref="gml:Polygon"
 *   element ref="gml:MultiPolygon"
 *   les autres elemennts ne sont pas implémentés (QoP, Speed, Direction, Time, ...)
 *
 * Address (balise xsd) :
 *   ex. <Address countryCode="StreetAddress"><freeFormAddress>1 r de paris saint denis</freeFormAddress></Address>
 *   attribute name="countryCode"
 *     element name="freeFormAddress"
 *     element ref="xls:Place"
 *     element ref="gml:Envelope"
 *  ou
 *   ex. <Address countryCode="StreetAddress"><StreetAddress><Street>1 rue Marconi</Street></StreetAddress><Place type="Municipality">Metz</Place><PostalCode>57000</PostalCode></Address>
 *   attribute name="countryCode"
 *     element ref="xls:StreetAddress"
 *     element ref="xls:PostalCode"
 *     element ref="xls:Place"
 *     element ref="gml:Envelope"
 *
 * Place  (balise xsd) :
 *  ex. <Place type="Municipality">Metz</Place>
 *  attribute name="type"
 *   enumeration value="CountrySubdivision"
 *   enumeration value="CountrySecondarySubdivision"
 *   enumeration value="Municipality"
 *   enumeration value="MunicipalitySubdivision"
 *   enumeration value="choume-banchi-go"
 *   enumeration value="Qualite"
 *   enumeration value="Departement"
 *   enumeration value="Bbox"
 *   enumeration value="Commune"
 *   enumeration value="Territoire"
 *   enumeration value="Importance"
 *   enumeration value="Nature"
 *   (la liste n'est pas exhaustives...)
 *
 * StreetAddress (balise xsd) :
 *   ex. <StreetAddress><Street>1 rue Marconi</Street></StreetAddress>
 *   attribute name="locator"
 *    element name="xls:Building"
 *    element ref="xls:Street"
 *
 * Street (balise xsd) :
 *   ex. <Street>1 rue Marconi</Street>
 *   attribute name="officialName" (...)
 *
 * Building (balise xsd) :
 *   ex. <Building number="800"/>
 *   attribute name="number" attribute name="subdivision" attribute name="buildingName"
 *
 * PostalCode (balise xsd) :
 *   ex. <PostalCode>77182</PostalCode>
 *
 * ```
 *
 * Requête
 * -------
 *
 * 2 modes de requête sur les services : GET ou POST.
 *
 * Le mode GET n'est que l'encodage du XML en param (qxml) de la requête (donc pas d'implementation particulière ?)
 *
 * Modèle de classes
 * -----------------
 *
 * ```
 *                 ________  XLS ____________
 *               /            |               \
 *   RequestHeader      AbstractService    Request
 *                            ^
 *                      ______|________________________
 *           (extends) /                               \ (extends)
 *          LocationUtilityService                    RouteService
 *                    |                                    |
 *         ___________|___________                       (...)
 *       /                        \
 * GeocodeRequest          ReverseGeocodeRequest
 *      |                          |
 *      |                     _____|______
 *      |                    /            \
 *   Address              Preference  Position
 *      |
 *    /   \
 * Place   StreetAddress
 *               |
 *             /   \
 *       Street   Building
 * ```
 *
 * @example
 * // encapsule un objet 'LocationUtilityService'
 * // dans une coquille XSL (avec/sans namespace)
 * xsl = new XSL ();
 * xsl.namespace = false;
 * xsl.srsName = "epsg:4326";
 * xsl.maximumResponses = 26;
 * //   methodName fournit par l'objet 'lus'
 * //   requestID est calculé
 * xsl.setService (lus);
 * xsl.build ();
 * // out ->
 * // <XLS xmlns="http://www.opengis.net/xls" version="1.2">
 * // <RequestHeader srsName="epsg:4326"/>
 * // <Request maximumResponses="26" methodName="GeocodeRequest" requestID="uid1349081498314_388" version="1.2">
 * //   < (ref. LocationUtilityService ou vide) />
 * //  </Request>
 * // </XLS>
 *
 *
 * @constructor
 * @alias Gp.Formats.XLS
 * @param {Object} options - options du constructeur
 * @param {Object} options.srsName - identifiant du Systeme de Coordonnees
 * @param {String}   options.maximumResponses - nombre de reponses max d'une requete
 * @param {Function} options.onsuccess - function callback success (TODO)
 * @param {Function} options.onerror   - function callback error   (TODO)
 *
 * @private
 */
function XLS (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur XLS()]");

    if (!(this instanceof XLS)) {
        throw new TypeError("XLS constructor cannot be called as a function.");
    }

    // options par defaut
    this.options = {
        srsName : "EPSG:4326",
        maximumResponses : 25
    };

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            if (options[opt]) {
                this.options[opt] = options[opt];
            }
        }
    }
}

/**
 * Version
 */
XLS.VERSION = "1.2";

XLS.prototype = {

    /**
     * @lends module:XLS#
     */

    /**
     * request (out)
     * @type {String}
     */
    requestString : null,

    /**
     * namespace
     * Surcharge les balises XLS d'un prefixe.
     * Par defaut, false
     * @type {Boolean}
     */
    namespace : false,

    /**
     * Objet Service
     * LocationUtilityService ou RouteService
     * @type {AbstractService}
     */
    oService : null,

    /**
     * Constructeur (alias)
     */
    constructor : XLS,

    /**
     * Template de la requête.
     * substitution des valeurs suivantes :
     * __VERSION__, __NAMESPACE__, __SCHEMALOCATION__
     * __REQUESTHEADER__, __REQUEST__
     */
    template : "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n" +
        "<XLS version=\"__VERSION__\"\n" +
        "__NAMESPACE__ \n" +
        "__SCHEMALOCATION__>\n" +
        "__REQUESTHEADER__\n" +
        "__REQUEST__\n" +
        "</XLS>\n",

    /**
     * Namespace par defaut.
     *
     * @returns {String} namespace
     */
    namespaceByDefault : function () {
        var ns = [
            "xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\"",
            "xmlns:xls=\"http://www.opengis.net/xls\"",
            "xmlns:gml=\"http://www.opengis.net/gml\""
        ];

        return ns.join(" ");
    },

    /**
     * Schemalocation par defaut
     *
     * @returns {String} schemaLocation
     */
    schemaLocationByDefault : function () {
        return "xsi:schemaLocation=\"http://www.opengis.net/xls http://schemas.opengis.net/ols/1.2/olsAll.xsd\"";
    },

    /**
     * Setter Service
     * Ajout d'un objet de type LocationUtilityService (LUS) ou RouteService
     *
     * @param {Object} oService - GeoceodeRequest / ReverseGeocodeRequest ou RouteRequest
     */
    setService : function (oService) {
        if (!oService) {
            // this.// logger.trace("L'objet de type Service XSL n'est pas encore defini !?");
            return;
        }

        if (oService instanceof __WEBPACK_IMPORTED_MODULE_3__XLS_AbstractService__["a" /* default */]) {
            this.oService = oService;
        } else {
            this.logger.error("L'objet n'est pas du type 'LocationUtilityService' ou 'RouteService' !?");
        }
    },

    /**
     * Getter Service
     * Retourne un objet de type LocationUtilityService (LUS) ou RouteService
     * ex. GeoceodeRequest / ReverseGeocodeRequest ou RouteRequest
     *
     * @returns {Object} service (LocationUtilityService|RouteService)
     */
    getService : function () {
        return this.oService;
    }
};

/**
 * Ajout d'un prefixe de namespace
 *
 * @todo impl. l'ajout de namespace
 * @param {Object} ns - ex. {key:xls, url:http://www.opengis.net/xls}
 * @param {String} request - requête
 * @returns {String} requête
 */
XLS.prototype.addNamespace = function (ns, request) {
    // INFO
    // on recherche la clef dans les namespaces par defaut.
    // si la clef n'existe pas dans les namespaceByDefault (), on l'ajoute.
    // on surcharge toutes les balises, ex. XLS -> xls:XLS
    // sauf celles qui sont déjà prefixées !

    var keyNS = ns.key;
    // var urlNS = ns.url; // TODO not yet implemented !

    // recherche la clef dans les namespaces par defaut
    var bFound = false;
    var allNS = this.namespaceByDefault().split(" ");
    for (var index = 0; index < allNS.length; index++) {
        var element = allNS[index];
        var map = element.split("=");
        var key = map[0];
        // var url = map[1]; // TODO not yet implemented !

        if (key === "xmlns:" + keyNS) {
            bFound = true;
            break;
        }
    }

    // TODO
    // si on a une nouvelle clef, on l'ajoute...
    if (!bFound) {
        this.logger.warn("L'ajout d'un nouvel namespace n'est pas encore implémenté !");
        return request;
    }

    // surcharge toutes les balises
    var regex;
    var subst;

    // regex balise ouvrante
    regex = /<(\w+[\s>])/g;
    subst = "<" + keyNS + ":$1";
    request = request.replace(regex, subst);

    // regex balise fermante
    regex = /<\/(\w+[\s>])/g;
    subst = "</" + keyNS + ":$1";
    request = request.replace(regex, subst);

    // this.// logger.trace("namespace", request);

    return request;
};

/**
 * Construction de la requête
 * @returns {String} requête
 */
XLS.prototype.build = function () {
    // out ->
    // <XLS xmlns="http://www.opengis.net/xls" version="1.2">
    // <RequestHeader srsName="epsg:4326"/>
    // <Request maximumResponses="26" methodName="GeocodeRequest" requestID="uid1349081498314_388" version="1.2">
    //   < (ref. LocationUtilityService ou vide) />
    //  </Request>
    // </XLS>

    // as t on un objet de type Service XLS à disposition ?
    var bService = !!this.getService();

    var template = "";
    template = this.template;
    template = template.replace(/__VERSION__/g, XLS.VERSION);
    template = template.replace(/__NAMESPACE__/g, this.namespaceByDefault);
    template = template.replace(/__SCHEMALOCATION__/g, this.schemaLocationByDefault);

    // header
    var oHeader = new __WEBPACK_IMPORTED_MODULE_1__XLS_RequestHeader__["a" /* default */]({
        srsName : this.options.srsName
    });
    template = template.replace(/__REQUESTHEADER__/g, oHeader.toString());

    // request
    var oRequest = new __WEBPACK_IMPORTED_MODULE_2__XLS_Request__["a" /* default */]({
        maximumResponses : this.options.maximumResponses,
        version : XLS.VERSION, // FIXME même version ?
        methodName : bService ? this.getService().CLASSTYPE : null
    });
    template = template.replace(/__REQUEST__/g, oRequest.toString());

    // objet lus ou route
    if (bService) { // INFO : clef __REQUESTSERVICE__ dispo dans l'objet 'Request'
        template = template.replace(/<!-- __REQUESTSERVICE__ -->/g, this.getService().toString());
    }

    if (!template) {
        this.logger.warn("traduction tmpl : empty request !?");
        return;
    }

    // ajout d'un namespace
    if (this.namespace) {
        // ajout de xls par defaut
        template = this.addNamespace({
            key : "xls",
            url : "http://www.opengis.net/xls"
        }, template);
    }

    this.requestString = template;
    // this.// logger.trace("traduction tmpl", template);

    // on retourne qqchose !
    return this.requestString;
};

/* harmony default export */ __webpack_exports__["a"] = (XLS);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);


/**
 * @classdesc
 * @private
 *
 * @constructor
 * @alias Gp.Formats.XLS.AbstractService
 *
 * @param {Object} [options] - options
 */
function AbstractService (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur AbstractService ()]");

    if (!(this instanceof AbstractService)) {
        throw new TypeError("AbstractService constructor cannot be called as a function.");
    }

    // options par defaut
    this.options = options || {};

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            this.options[opt] = options[opt];
        }
    }
}

/**
 * @lends module:AbstractService#
 */
AbstractService.prototype = {

    /**
     * request (out)
     * @type {String}
     */
    strRequest : null,

    /**
     * objet Request
     * @type {Request}
     */
    oRequest : null,

    /**
     * Filter
     * @type {FilterExtension}
     */
    oFilter : null,

    /**
     * Constructeur (alias)
     */
    constructor : AbstractService,

    /**
     * Ajout d'un objet de type Request : GeocodeRequest / ReverseGeocodeRequest / RouteRequest
     *
     * @param {Object} oRequest - GeocodeRequest / ReverseGeocodeRequest / RouteRequest
     */
    addRequest : function (oRequest) {
        this.logger.error("overwritten method !");
    },

    /**
     * Ajout d'un objet de type FilterExtension : GeocodeFilterExtension ou RouteRequestExtension
     *
     * @param {Object} oFilter - GeocodeFilterExtension ou RouteRequestExtension
     */
    addFilter : function (oFilter) {
        this.logger.error("overwritten method !");
    },

    /**
     * toString
     */
    toString : function () {
        this.logger.error("overwritten method !");
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AbstractService);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);



/**
 * @classdesc
 *
 * Ajouter des extensions de filtres spécifiques au service de geocodage de l'IGN.
 * Ceci permet de contrôler les options spécifiques de la table de geocodage intérrogées.
 *
 * @example
 * var ext =  new GeocodeFiltersExtension ();
 *     ext.add (new Administratif ());
 *     ext.add (new StreetAddress ());
 *     ext.add (new PositionOfInterest ());
 *     ext.add (new CadastralParcel ());
 *
 * ext.getNames ()
 * // --> out
 * // [Administratif, StreetAddress, PositionOfInterest, CadastralParcel]
 *
 * ext.getFilters ()
 * // --> out
 * // [Object, Object, Object, Object] = tableau d'objet GeocodeLocation
 *
 * ext.getFilter ('StreetAddress')
 * // --> out
 * // {Object} = objet GeocodeLocation
 *
 * ext.getAttributs ('StreetAddress')
 * // --> out
 * // ["bbox", "number", "ID", "IDTR", "postalCode", "quality", "street", "territoire", "commune", "department", "insee", "municipality"]
 *
 * ext.setPlaceAttributs ('StreetAddress', {number:'', territoire:'', quality:'', fake:''})
 * // --> out
 * // (fake est écarté car il n'appartient pas à la liste !)
 *
 * ext.getPlaceAttributs ('StreetAddress')
 * // --> out
 * // {number : '', territoire : '', quality : ''}
 *
 * // Comment ajouter des filtres spécifiques au service de geocodage ?
 * var req = new GeocodeRequest ({
 *      location : "saint mandé",
 *      returnFreeForm : true,
 *      filterOptions : {
 *          type : ['PositionOfInterest'], <-- ajouter une extension afin de gerer les attributs de cette table de geocodage !
 *          (...)
 *      }
 *  })
 *  req.addFilter (new PositionOfInterest ());
 * @constructor
 * @alias Gp.Formats.XLS.LocationUtilityService.GeocodeFilterExtension
 *
 * @private
 */
function GeocodeFilterExtension () {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("GeocodeFilterExtension");
    // this.// logger.trace("[Constructeur GeocodeFilterExtension ()]");

    if (!(this instanceof GeocodeFilterExtension)) {
        throw new TypeError("GeocodeFilterExtension constructor cannot be called as a function.");
    }

    /**
     * Tableau de filtres (table de geocodage)
     */
    this.filters = [];
}

/**
 * @lends module:GeocodeFilterExtension#
 */
GeocodeFilterExtension.prototype = {

    /**
     * Constructeur (alias)
     */
    constructor : GeocodeFilterExtension,

    /**
     * Ajout d'un filtre
     *
     * @param {Object} oGeocodeLocation - objet de type 'GeocodeLocation'
     */
    addFilterExtensions : function (oGeocodeLocation) {
        // FIXME test sur le type d'objet !
        if (oGeocodeLocation) {
            // FIXME ou test sur ses propriétés !
            this.filters.push(oGeocodeLocation);
        }
    },

    // getter

    /**
     * Tableau de noms (tables de geocodage)
     *
     * @returns {Array.<String>} liste des noms de filtres
     */
    getNames : function () {
        var names = [];
        for (var idx in this.filters) {
            names.push(this.filters[idx].CLASSNAME);
        }
        // this.// logger.trace(names);
        return names;
    },

    /**
     * Retourne une table de geocodage
     *
     * @param {String} name - nom de la table de geocodage
     * @returns {Object} filtre
     */
    getFilter : function (name) {
        var filter = null;
        for (var idx in this.filters) {
            if (this.filters[idx].CLASSNAME === name) {
                filter = this.filters[idx];
            }
        }
        // this.// logger.trace(filter);
        return filter;
    },

    /**
     * Tableau d'objects (tables de geocodage)
     *
     * @returns {Array.<Object>} liste des filtres
     */
    getFilters : function () {
        // this.// logger.trace(this.filters);
        return this.filters;
    },

    /**
     * Récupère la liste des attributs (filtres) sur une table de geocodage
     *
     * @param {String} name - nom de la table de geocodage
     * @returns {Array} liste des attributs d'un filtre
     */
    getAttributs : function (name) {
        var attributs = [];
        for (var idx in this.filters) {
            if (this.filters[idx].CLASSNAME === name) {
                attributs = this.filters[idx].attributesList;
            }
        }
        // this.// logger.trace(attributs);
        return attributs;
    },

    /**
     * Ajout des attributs (filtres) sur une table de geocodage
     *
     * @param {String} name - nom de la table de geocodage
     * @param {Object} options - options de la table de geocodage
     */
    setPlaceAttributs : function (name, options) {
        var filter = this.getFilter(name);
        var attributs = this.getAttributs(name);
        for (var idx in attributs) {
            var value = attributs[idx];
            if (options[value]) {
                filter.placeAttributes[value] = options[value];
            }
        }
    },

    /**
     * Retourne les attributs (filtres) sur une table de geocodage
     *
     * @param {String} name - nom de la table de geocodage
     * @returns {Array} liste des attributs d'un filtre
     */
    getPlaceAttributs : function (name) {
        var places = {};
        for (var idx in this.filters) {
            if (this.filters[idx].CLASSNAME === name) {
                places = this.filters[idx].placeAttributes;
            }
        }
        // this.// logger.trace(places);
        return places;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (GeocodeFilterExtension);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Response object for {@link module:Services~geocode Gp.Services.geocode ()} or {@link module:Services~reverseGeocode Gp.Services.reverseGeocode ()} invocation when successful. Received as the argument of onSuccess callback function.
 *
 * @property {Array.<Gp.Services.Geocode.DirectGeocodedLocation|Gp.Services.Geocode.ReverseGeocodedLocation>} locations - locations array.
 *
 * @namespace
 * @alias Gp.Services.GeocodeResponse
 */
function GeocodeResponse () {
    if (!(this instanceof GeocodeResponse)) {
        throw new TypeError("GeocodeResponse constructor cannot be called as a function.");
    }

    this.locations = [];
}

GeocodeResponse.prototype = {

    constructor : GeocodeResponse

};

/* harmony default export */ __webpack_exports__["a"] = (GeocodeResponse);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Location object holding common properties returned by the underlying geocoding and reverse geocoding web service.
 *
 * @property {Gp.Point} position - Position of the location given in the requested coordinates system.
 * @property {String} type - location type "StreetAddress" (for an address), "PositionOfInterest" (for a place name) or "CadastralParcel" (for cadastral parcel).
 * @property {String} matchType - how geocoding is performed : "street number" (exact address), "street enhanced" (street number calculated by interpolation), "street" (only the street), "city" (only the city).
 * @property {Object} placeAttributes - Associative array matching the following attributes with their values given by the underlying web service :
 *
 * *Common attributes : *
 *
 * - **freeform** - freeform complete Address.
 * - **bbox** - Bounding Box *{@link Gp.BBox}*.
 * - **municipality** - Municipality
 *
 * *if type === "StreetAddress" : *
 *
 * - **number** - Street number.
 * - **ID** - Identifier of the address in the [BD ADRESSE Database]{@link http://professionnels.ign.fr/bdadresse}.
 * - **IDTR** - Identifier of the lineString in the [BD ADRESSE Database]{@link http://professionnels.ign.fr/bdadresse}.
 * - **postalCode** - PostCode
 * - **quality** - Geocoding quality ([see]{@link http://api.ign.fr/tech-docs-js/developpeur/search.html})
 * - **street** - Street name
 * - **territory** - French Territory code
 * - **commune** - City
 * - **department** - Department
 * - **insee** - INSEE Code
 *
 *
 * *if type === "PositionOfInterest" :*
 *
 * - **importance** - Place name importance
 * - **nature** - Place name nature
 * - **postalCode** - PostCode
 * - **territory** - French Territory code
 * - **commune** - City
 * - **department** - Department
 * - **insee** - INSEE Code
 *
 *
 * *si type = "CadastralParcel" :*
 *
 * - **absorbedCity** - when a parcel comes from a city that was absorbed by another, code of that old city. "000" otherwise.
 * - **arrondissement** - arrondissement
 * - **cadastralParcel** - cadastral parcel code
 * - **district** - district
 * - **sheet** - Parcel Sheet (eg. "1").
 * - **number** - Parcel Number (eg. "0041")
 * - **section** - Parcel Section (eg. "0D").
 * - **commune** - Parcel municipality.
 * - **department** - Parcel Department.
 * - **insee** - INSEE Code.
 * - **origin** - Parcel origin (see "type" attribute in the [underlying web service response]{@link http://api.ign.fr/tech-docs-js/developpeur/search.html#Cadastral_parcels_search})
 *
 * @namespace
 * @alias Gp.Services.Geocode.GeocodedLocation
 */
function GeocodedLocation () {
    if (!(this instanceof GeocodedLocation)) {
        throw new TypeError("GeocodedLocation constructor cannot be called as a function.");
    }

    this.position = {
        x : null,
        y : null
    };

    this.matchType = null;

    this.placeAttributes = {};

    this.type = null;
}

GeocodedLocation.prototype = {

    constructor : GeocodedLocation

};

/* harmony default export */ __webpack_exports__["a"] = (GeocodedLocation);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Response object for {@link module:Services~route Gp.Services.route ()} invocation when successful. Received as the argument of onSuccess callback function.
 *
 * @property {Gp.BBox} bbox - Bounding Box of the route. Given when provideBBox parameter is used in function call.
 * @property {Object} routeGeometry - Geometry (expressed in [GeoJSON]{@link http://geojson.org/}) of the route.
 * @property {Array.<Gp.Services.Route.RouteInstruction>} routeInstructions - Instructions of the route.
 * @property {String} totalDistance - Length of the route. If distanceUnit parameter was set to "km" (default), totalDistance is a string containing the total distance expressed in kilometers, followed by " Km" (e.g. : "19.6 Km"). If distanceUnit parameter was set to "m", totalDistance is a string containing the total distance expressed in meters (e.g. : "19599.14").
 * @property {Float} totalTime - Route duration in seconds.
 *
 * @namespace
 * @alias Gp.Services.RouteResponse
 */
function RouteResponse () {
    if (!(this instanceof RouteResponse)) {
        throw new TypeError("RouteResponse constructor cannot be called as a function.");
    }

    this.totalTime = null;

    this.totalDistance = null;

    this.bbox = {
        left : null,
        right : null,
        top : null,
        bottom : null
    };

    this.routeGeometry = null; // FIXME can be null if option 'geometryInInstructions' is true !

    this.routeInstructions = [];
}

RouteResponse.prototype = {

    constructor : RouteResponse

};

/* harmony default export */ __webpack_exports__["a"] = (RouteResponse);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Single Route Instruction object.
 *
 * @property {String} code - Instruction code :
 *
 * - "F" : Straight forward
 * - "B" : U-turn
 * - "L" : turn left
 * - "R" : turn right
 * - "BL" : turn left strongly
 * - "BR" : turn right strongly
 * - "FL" : turn lightly to the left
 * - "FR" : turn lightly to the right
 * - "round_about_entry" : round about entry
 * - "round_about_exit" : round about exit
 *
 * @property {String} instruction - Instruction text : translated code + street name
 * @property {Object} geometry - Geometry (expressed in [GeoJSON]{@link http://geojson.org/}) of the street.
 * @property {Float} distance - Length of the instruction. Expressed in km or m, depending on distanceUnit parameter.
 * @property {Float} duration - Instruction duration in seconds.
 *
 * @namespace
 * @alias Gp.Services.Route.RouteInstruction
 */
function RouteInstruction () {
    if (!(this instanceof RouteInstruction)) {
        throw new TypeError("RouteInstruction constructor cannot be called as a function.");
    }

    this.duration = null;

    this.distance = null;

    this.code = null;

    this.instruction = null;

    this.geometry = null; // FIXME can be null if option 'geometryInInstructions' is false !
}

RouteInstruction.prototype = {

    constructor : RouteInstruction

};

/* harmony default export */ __webpack_exports__["a"] = (RouteInstruction);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Response object for {@link module:Services~isoCurve Gp.Services.isoCurve ()} invocation when successful. Received as the argument of onSuccess callback function.
 *
 * @property {Float} distance - distance (expressed in meters) used for the request.
 * @property {Float} time - time (expressed in seconds) used for the request.
 * @property {Object} geometry - Geometry (expressed in [GeoJSON]{@link http://geojson.org/}) of the isocurve.
 * @property {String} id - request id (used by underlying webservice).
 * @property {Gp.Point} location - Position of the start or end point used for the request (expressed in "srs" coordinates system).
 * @property {String} message - message
 * @property {String} srs - Identifier of the coordinates system used for the isocurve.
 *
 * @namespace
 * @alias Gp.Services.IsoCurveResponse
 *
 */
function ProcessIsoCurveResponse () {
    if (!(this instanceof ProcessIsoCurveResponse)) {
        throw new TypeError("ProcessIsoCurveResponse constructor cannot be called as a function.");
    }

    this.message = null;

    this.id = null;

    this.location = {};
    this.location.x = null;
    this.location.y = null;

    this.srs = null;

    this.geometry = null;

    this.time = null;

    this.distance = null;
}

ProcessIsoCurveResponse.prototype = {

    constructor : ProcessIsoCurveResponse

};

/* harmony default export */ __webpack_exports__["a"] = (ProcessIsoCurveResponse);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_Helper__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_promise__);
/* global Promise, require */




// import __request from "request";
// import __xmldom from "xmldom";

/**
 * Requêtes Ajax (utilisation des Promises)
 * cf. https://xhr.spec.whatwg.org/
 * cf. https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest
 *
 * @module XHR
 * @private
 * @alias Gp.Protocols.XHR
 * @see dependance 'promise'
 */

var XHR = {

    /**
     * Interface unique d'envoi d'une requête.
     *
     * @method call
     * @static
     * @param {Object} settings - options generales
     * @param {String} settings.url    - url du service
     * @param {String} settings.method - GET, POST, PUT, DELETE
     * @param {String} settings.format - format de la reponse du service : json, xml ou null (brute)
     * @param {String} settings.data   - content (post) ou param (get)
     * @param {String} settings.proxy  - proxy url
     * @param {Object|String} settings.headers - (post) ex. referer
     * @param {Object|String} settings.content - (post) ex. 'application/json'
     * @param {String} settings.timeOut - timeout = 0 par defaut
     * @param {String} settings.scope - this
     * @param {Function} settings.onResponse - callback
     * @param {Function} settings.onFailure  - callback
     */
    call : function (settings) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("XHR");
        // logger.trace("[XHR::call()]");

        // FIXME
        // To polyfill the global environment
        __WEBPACK_IMPORTED_MODULE_2_es6_promise___default.a.polyfill();

        // test sur les settings obligatoires
        if (!settings.url) {
            throw new Error("missing parameter : url is not defined !");
        }

        if (!settings.method) {
            throw new Error("missing parameter : method is not defined !");
        }

        if (!settings.format) {
            settings.format = "text"; // reponse brute !
        }

        var options = {};
        options.url = settings.url;
        options.data = settings.data ? settings.data : null;
        options.method = settings.method;
        options.timeOut = settings.timeOut || 0;
        options.scope = settings.scope || this;
        options.proxy = settings.proxy || null;
        options.content = settings.content || null;
        options.headers = settings.headers || {
            referer : "http://localhost"
        };

        // test sur les valeurs de 'settings.method'
        switch (settings.method) {
            case "DELETE":
            case "GET":
                break;
            case "PUT":
            case "POST":
                // on force sur ces params spécifiques au mode POST
                options.content = settings.content ? settings.content : "application/x-www-form-urlencoded"; // FIXME en attente des services : bascule en "application/xml" ou "application/json"
                options.headers = settings.headers ? settings.headers : {
                    referer : "http://localhost" // todo ...
                };
                break;
            case "HEAD":
            case "OPTIONS":
                throw new Error("HTTP method not yet supported !");
            default:
                throw new Error("HTTP method unknown !");
        }

        // test sur les valeurs de 'settings.format'
        switch (settings.format) {
            case "text":
                this.__call(options)
                    .then(function (response) {
                        // logger.trace(response);
                        settings.onResponse.call(this, response);
                    })
                    .catch(function (error) {
                        settings.onFailure.call(this, error);
                    });
                break;
            case "json":
                this.__callJSON(options)
                    .then(function (response) {
                        // logger.trace(response);
                        settings.onResponse.call(this, response);
                    })
                    .catch(function (error) {
                        settings.onFailure.call(this, error);
                    });
                break;
            case "xml":
                this.__callXML(options)
                    .then(function (response) {
                        // logger.trace(response);
                        settings.onResponse.call(this, response);
                    })
                    .catch(function (error) {
                        settings.onFailure.call(this, error);
                    });
                break;
            default:
                throw new Error("This output Format is not yet supported !");
        }
    },

    /**
     * Requete
     *
     * @method __call
     * @private
     * @param  {Object} options - options
     * @return {Object} promise
     */
    __call : function (options) {
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("XHR");
        // logger.trace("[XHR::__call()]");

        var promise = new Promise(
            function (resolve, reject) {
                // traitement du corps de la requête
                var corps = (options.method === "POST" || options.method === "PUT") ? 1 : 0;

                // seulement si options.data n'est pas vide (peut être un objet ou une chaine de caractères)
                if (options.data && ((typeof options.data === "object" && Object.keys(options.data).length) || (typeof options.data === "string" && options.data.length)) && !corps) {
                    options.url = __WEBPACK_IMPORTED_MODULE_1__Utils_Helper__["a" /* default */].normalyzeUrl(options.url, options.data);
                }

                // logger.trace("URL = ", options.url);

                var hXHR = null;

                // test on env. nodejs or browser
                if (typeof window === "undefined") {
                    // Utilisation du module :
                    // cf. http://blog.modulus.io/node.js-tutorial-how-to-use-request-module

                    var req = __webpack_require__(52);// __request

                    // mapping data avec body param. pour le mode POST ou PUT (?)
                    if (options.data && typeof options.data === "string" && corps) {
                        options.body = options.data;
                    }

                    // FIXME ERROR : self signed certificate in certificate chain
                    options.rejectUnauthorized = false;

                    req(options, function (error, response, body) {
                        if (!error && response.statusCode === 200 && body) {
                            resolve(body);
                        } else {
                            reject("Errors Occured on Http Request (nodejs) : " + error);
                        }
                    });
                } else {
                    if (window.XMLHttpRequest) {
                        // logger.trace("XMLHttpRequest");

                        hXHR = new XMLHttpRequest();
                        hXHR.open(options.method, options.url, true); // async
                        hXHR.overrideMimeType = options.content;

                        // gestion du timeout
                        var onTimeOutTrigger = null;
                        if (options.timeOut > 0) {
                            // FIXME le timeout interne ne me permet pas de declencher le bon message...
                            // hXHR.timeout = options.timeOut;
                            // logger.trace("XHR - TimeOut actif !");
                            /**
                             * Description
                             *
                             * @method onTimeOutTrigger
                             * @private
                             */
                            onTimeOutTrigger = window.setTimeout(
                                function () {
                                    var message = "TimeOut Occured on Http Request with XMLHttpRequest !";
                                    reject({
                                        message : message,
                                        status : -1
                                    });
                                }, options.timeOut);
                        }

                        if (corps) {
                            // headers, data, content of data
                            // cf. https://dvcs.w3.org/hg/xhr/raw-file/tip/Overview.html#dom-xmlhttprequest-setrequestheader
                            // logger.trace("data = ", options.data);
                            hXHR.setRequestHeader("Content-type", options.content);
                            // FIXME refused to set unsafe header content-length javascript
                            // hXHR.setRequestHeader ("Content-length", options.data.length);
                            // hXHR.setRequestHeader ("Referer", options.headers.referer);
                        }

                        /**
                         * On Error
                         * FIXME ne se declenche pas !?
                         *
                         * @param {Object} e - Event
                         * @method onerror
                         * @private
                         */
                        hXHR.onerror = function (e) {
                            // console.log(e);
                            reject(new Error("Errors Occured on Http Request with XMLHttpRequest !"));
                        };

                        /**
                         * On Timeout
                         * FIXME ne se declenche pas !?
                         *
                         * @param {Object} e - Event
                         * @method ontimeout
                         * @private
                         */
                        hXHR.ontimeout = function (e) {
                            // console.log(e);
                            reject(new Error("TimeOut Occured on Http Request with XMLHttpRequest !"));
                        };

                        /**
                         * Description
                         *
                         * @method onreadystatechange
                         * @private
                         */
                        hXHR.onreadystatechange = function (e) {
                            if (hXHR.readyState === 4) { // DONE
                                if (hXHR.status === 200) {
                                    window.clearTimeout(onTimeOutTrigger);
                                    resolve(hXHR.response);
                                } else {
                                    var message = "Errors Occured on Http Request (status : '" + e.target.statusText + "' | url : '" + e.target.responseURL + "')";
                                    var status = e.target.status;
                                    reject({
                                        message : message,
                                        status : status
                                    });
                                }
                            }
                        };

                        // gestion du content data
                        var data4xhr = (options.data && corps) ? options.data : null;

                        hXHR.send(data4xhr);
                    } else if (window.XDomainRequest) {
                        // worked in Internet Explorer 8–10 only !
                        // logger.trace("XDomainRequest");

                        hXHR = new XDomainRequest();
                        hXHR.open(options.method, options.url);

                        hXHR.overrideMimeType = options.content;

                        if (options.timeOut > 0) {
                            hXHR.timeout = options.timeout;
                            // logger.trace("XHR - TimeOut actif !");
                        }

                        if (corps) {
                            // headers, data, content of data
                            // cf. https://dvcs.w3.org/hg/xhr/raw-file/tip/Overview.html#dom-xmlhttprequest-setrequestheader
                            hXHR.setRequestHeader("Content-type", options.content);
                            // FIXME refused to set unsafe header content-length javascript
                            // hXHR.setRequestHeader ("Content-length", options.data.length);
                            // hXHR.setRequestHeader ("Referer", options.headers.referer);
                        }

                        /**
                         * Description
                         *
                         * @method onerror
                         * @private
                         */
                        hXHR.onerror = function () {
                            reject(new Error("Errors Occured on Http Request with XMLHttpRequest !"));
                        };

                        /**
                         * Description
                         *
                         * @method ontimeout
                         * @private
                         */
                        hXHR.ontimeout = function () {
                            reject(new Error("TimeOut Occured on Http Request with XMLHttpRequest !"));
                        };

                        /**
                         * On Load
                         *
                         * @method onload
                         * @private
                         */
                        hXHR.onload = function (e) {
                            if (hXHR.status === 200) {
                                resolve(hXHR.responseText);
                            } else {
                                var message = "Errors Occured on Http Request (status : '" + e.target.statusText + "' | url : '" + e.target.responseURL + "')";
                                var status = e.target.status;
                                reject({
                                    message : message,
                                    status : status
                                });
                            }
                        };

                        var data4xdr = (options.data && corps) ? options.data : null;

                        hXHR.send(data4xdr);
                    } else {
                        throw new Error("CORS not supported");
                    }
                }
            }
        );

        return promise;
    },

    /**
     * Requete avec parser JSON
     *
     * @method __callJSON
     * @private
     * @param  {Object} options - options
     * @return {Object} promise
     */
    __callJSON : function (options) {
        return this.__call(options)
            .then(JSON.parse)
            .catch(function (error) {
                // console.log("_callJSON failed on : ", options.url, error);
                // FIXME pas d'exception, laissons le fil se derouler...
                // throw error;
            });
    },

    /**
     * Requete avec parser XML
     *
     * @method __callXML
     * @private
     * @param  {Object} options - options
     * @return {Object} promise
     */
    __callXML : function (options) {
        return this.__call(options)
            .then(function (response) {
                var xmlDoc;

                // test on env. nodejs or browser
                if (typeof window === "undefined") {
                    var DOMParser = __webpack_require__(20).DOMParser; // __xmldom.DOMParser
                    xmlDoc = new DOMParser().parseFromString(response, "text/xml");
                } else {
                    if (window.DOMParser) {
                        var parser = new window.DOMParser();
                        xmlDoc = parser.parseFromString(response, "text/xml");
                    } else { // IE
                        xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM");
                        xmlDoc.async = false;
                        xmlDoc.loadXML(response);
                    }
                }

                return xmlDoc;
            })
            .catch(function (error) {
                // console.log("__callXML failed on : ", options.url, error);
                // FIXME pas d'exception, laissons le fil se derouler...
                // throw error;
            });
    }

};

/* harmony default export */ __webpack_exports__["a"] = (XHR);


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AltiRequest__ = __webpack_require__(22);




/**
 * @classdesc
 *
 * Classe de gestion des param. des requêtes de type POINT du service altimetrique.
 *
 * @constructor
 * @alias Gp.Services.Alti.Request.AltiElevationRequest
 * @param {Object} options - options
 * @param {Boolean}  options.zonly - false|true
 *
 * @private
 */
function AltiElevationRequest (options) {
    if (!(this instanceof AltiElevationRequest)) {
        throw new TypeError("AltiElevationRequest constructor cannot be called as a function.");
    }

    /**
     * Nom de la classe (heritage)
     */
    this.CLASSNAME = "AltiElevationRequest";

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_1__AltiRequest__["a" /* default */].apply(this, arguments);

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur AltiElevationRequest ()]");

    /**
     * Z uniquement.
     * true|false
     */
    this.zonly = this.options.zonly || false; // test des options héritées !
}

/**
 * @lends module:AltiElevationRequest#
 */

AltiElevationRequest.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__AltiRequest__["a" /* default */].prototype, {

    /**
     * Setter/getter pour "zonly"
     */
    zonly : {
        /** getter */
        get : function () {
            return this._zonly;
        },
        /** setter */
        set : function (z) {
            this._zonly = z;
        }
    }

});

/**
 * Constructeur (alias)
 */
AltiElevationRequest.prototype.constructor = AltiElevationRequest;

/**
 * Tableau de clefs/valeurs pour param.
 *
 * @returns {Array}
 */
AltiElevationRequest.prototype.getData = function () {
    // par glop..., appel de AltiRequest::getData () !
    var map = [];
    map.push({
        k : "lon",
        v : this.getLon()
    });
    map.push({
        k : "lat",
        v : this.getLat()
    });
    // map.push({k : "delimiter", v : this.delimiter}); // FIXME on retire le param "delimiter"
    map.push({
        k : "indent",
        v : this.indent
    });
    map.push({
        k : "crs",
        v : this.crs
    });
    map.push({
        k : "zonly",
        v : this.zonly
    });
    map.push({
        k : "format",
        v : this.format
    });

    return map;
};

/* harmony default export */ __webpack_exports__["a"] = (AltiElevationRequest);


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);



/**
 * @classdesc
 * Classe de gestion des param. des requêtes du service altimetrique.
 *
 * @constructor
 * @alias Gp.Services.Alti.Request.AltiRequest
 * @param {Object} options - options
 * @param {Object}   options.positions - tableau de coordonnées lon/lat
 * @param {String}   options.delimiter - "|"
 * @param {Boolean}  options.indent - false|true
 * @param {String}   options.crs - "CRS:84"
 * @param {String}   options.format - "JSON|XML"
 *
 * @private
 */
function AltiRequest (options) {
    if (!(this instanceof AltiRequest)) {
        throw new TypeError("AltiRequest constructor cannot be called as a function.");
    }

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur AltiRequest ()]");

    /**
     * Options en paramêtres du constructeur.
     */
    this.options = options || {};

    /**
     * Liste des coordonnées.
     * @example
     * var c = [{lon : "", lat : ""}, {lon : "", lat : ""}];
     */
    this.positions = this.options.positions || [];

    /**
     * Caractère de séparation.
     * Par defaut, "|".
     */
    this.delimiter = this.options.delimiter || "|";

    /**
     * Indentation.
     * true|false
     */
    this.indent = this.options.indent || false;

    /**
     * Projection.
     * Par defaut, CRS:84.
     */
    this.crs = this.options.crs || "CRS:84";

    /**
     * format de sortie.
     * Par defaut, "json".
     */
    this.format = this.options.format || "json";
}

/**
 * CLASSNAME
 */
AltiRequest.CLASSNAME = "AltiRequest";

AltiRequest.prototype = {

    /**
     * @lends module:AltiRequest#
     */

    /**
     * Constructeur (alias)
     */
    constructor : AltiRequest,

    /**
     * Ajout d"une liste de coordonnées.
     *
     * @param {Object[]} lstPosition - liste de positions
     * @example
     * obj.setPositions ([{lon : "0.15", lat : "0.15"}, {lon : "1.15", lat : "1.15"}]);
     */
    setPositions : function (lstPosition) {
        var positions = [];
        for (var i = 0; i < lstPosition.length; i++) {
            var o = lstPosition[i];
            if (o.lon && o.lat) {
                positions.push(o);
            }
        }

        this.positions = positions;
    },

    /**
     * Liste des coordonnées.
     *
     * @param {Int} pos - position
     * @returns {positions}
     * @example
     * obj.getPositions ();  // [{lon : "", lat : ""}, {lon : "", lat : ""}]
     * obj.getPositions (0); // [{lon : "", lat : ""}]
     */
    getPositions : function (pos) {
        // FIXME test if not a number !?
        if (!pos) {
            return this.positions;
        }

        var index = this.positions.length - 1;
        if (pos > index || pos < index) {
            this.logger.warn("index out of range !");
            return this.positions;
        }

        return this.positions[pos];
    },

    /**
     * Ajout d"une liste de coordonnées.
     *
     * @param {Object[]} lstPosition - liste de positions
     * @example
     * obj.addPositions ([{lon : "0.15", lat : "0.15"}, {lon : "1.15", lat : "1.15"}]);
     */
    addPositions : function (lstPosition) {
        for (var i = 0; i < lstPosition.length; i++) {
            var o = lstPosition[i];
            if (o.lon && o.lat) {
                this.positions.push(lstPosition[i]);
            }
        }
    },

    /**
     * Retourne la liste des longitudes avec un caractère de séparation.
     *
     * @returns {String} - une liste de longitudes
     * @example
     * // out : 0.2367|2.1570|43.789|...
     */
    getLon : function () {
        var lstLon = [];
        for (var i = 0; i < this.positions.length; i++) {
            lstLon.push(this.positions[i].lon);
        }
        // this.// logger.trace(lstLon);
        return lstLon.join(this.delimiter);
    },

    /**
     * Retourne la liste des lattitudes avec un caractère de séparation.
     *
     * @returns {String} - une liste de lattitudes
     * @example
     * // out : 0.2367|2.1570|43.789|...
     */
    getLat : function () {
        var lstLat = [];
        for (var i = 0; i < this.positions.length; i++) {
            lstLat.push(this.positions[i].lat);
        }
        // this.// logger.trace(lstLat);
        return lstLat.join(this.delimiter);
    }

};

/**
 * Tableau de clefs/valeurs pour param.
 *
 * @returns {Object[]}
 */
AltiRequest.prototype.getData = function () {
    var map = [];

    map.push({
        k : "lon",
        v : this.getLon()
    });
    map.push({
        k : "lat",
        v : this.getLat()
    });
    map.push({
        k : "delimiter",
        v : this.delimiter
    });
    map.push({
        k : "indent",
        v : this.indent
    });
    map.push({
        k : "crs",
        v : this.crs
    });
    map.push({
        k : "format",
        v : this.format
    });

    return map;
};

/* harmony default export */ __webpack_exports__["a"] = (AltiRequest);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AltiRequest__ = __webpack_require__(22);




/**
 * @classdesc
 * Classe de gestion des param. des requêtes de type PROFIL du service altimetrique.
 *
 * @constructor
 * @alias Gp.Services.Alti.Request.AltiProfilRequest
 * @param {Object}   options - options
 * @param {String}   options.sampling - 3
 *
 * @private
 */
function AltiProfilRequest (options) {
    if (!(this instanceof AltiProfilRequest)) {
        throw new TypeError("AltiProfilRequest constructor cannot be called as a function.");
    }

    /**
     * Nom de la classe (heritage)
     */
    this.CLASSNAME = "AltiProfilRequest";

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_1__AltiRequest__["a" /* default */].apply(this, arguments);

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur AltiProfilRequest ()]");

    /**
     * Sampling
     * Par defaut, 3
     */
    this.sampling = this.options.sampling || 3; // test des options héritées !
}

/**
 * @lends module:AltiProfilRequest#
 */

AltiProfilRequest.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__AltiRequest__["a" /* default */].prototype, {

    /**
     * Setter/getter pour "sampling"
     */
    sampling : {
        /** getter */
        get : function () {
            return this._sampling;
        },
        /** setter */
        set : function (value) {
            this._sampling = value;
        }
    }
});

/**
 * Constructeur (alias)
 */
AltiProfilRequest.prototype.constructor = AltiProfilRequest;

/**
 * Tableau de clefs/valeurs pour param.
 *
 * @returns {Object[]}
 */
AltiProfilRequest.prototype.getData = function () {
    // par glop..., appel de AltiRequest::getData () !
    var map = [];
    map.push({
        k : "lon",
        v : this.getLon()
    });
    map.push({
        k : "lat",
        v : this.getLat()
    });
    // map.push({k : "delimiter", v : this.delimiter}); // FIXME on retire le param "delimiter"
    map.push({
        k : "indent",
        v : this.indent
    });
    map.push({
        k : "crs",
        v : this.crs
    });
    map.push({
        k : "sampling",
        v : this.sampling
    });
    map.push({
        k : "format",
        v : this.format
    });

    return map;
};

/* harmony default export */ __webpack_exports__["a"] = (AltiProfilRequest);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Response object for {@link module:Services~getConfig Gp.Services.getConfig ()} invocation when successful. Received as the argument of onSuccess callback function.
 *
 * @property {Object} generalOptions - General properties for default map configuration resources.
 * @property {Object} generalOptions.apiKeys - Object that associates apiKey (s) with an array of resources IDs availables with that key.
 * @property {String} generalOptions.title - Underlying web service Title.
 * @property {String} generalOptions.defaultGMLGFIStyle - XSL URL used by default to translate an XML GetFeatureInfo response into an HTML array.
 * @property {String} generalOptions.theme - default theme (FIXME : for what ?)
 * @property {Array.<Float>} generalOptions.wgs84Resolutions - geographical resolutions Array for each [zoom level of the Geoportal platform]{@link http://api.ign.fr/tech-docs-js/webmaster/layers.html#Geoportal_resolutions} from 0 to 21. Expressed in degrees/pixel.
 * @property {Object} layers - Associative array mapping resources availables IDs (keys) with their properties (values given as {@link Gp.Services.Config.Layer}).
 * @property {Object} territories - Associative array mapping french territories IDs (keys) with their properties (values given as {@link Gp.Services.Config.Territory}).
 * @property {Object} tileMatrixSets - Associative Array mapping TileMatrixSets IDs (keys) availables with their properties (values given as {@link Gp.Services.Config.TileMatrixSet}).
 * @property {Object} services - Associative Array mapping Geoportal web services IDs (keys) availables with their properties (values given as {@link Gp.Services.Config.Service}).
 *
 * @namespace
 * @alias Gp.Services.GetConfigResponse
 */
function AutoConfResponse () {
    if (!(this instanceof AutoConfResponse)) {
        throw new TypeError("AutoConfResponse constructor cannot be called as a function.");
    }

    this.generalOptions = {
        apiKeys : {},
        title : null,
        defaultGMLGFIStyle : null,
        theme : null,
        wgs84Resolutions : []
    };

    this.layers = {};

    this.territories = {};

    this.tileMatrixSets = {};

    this.services = {};
}

AutoConfResponse.prototype = {

    /*
     * Constructor (alias)
     */
    constructor : AutoConfResponse,

    /**
     * Check if config is loaded for a given key
     *
     * @param {String} apiKey - Access key to Geoportal platform
     * @returns {Boolean} isConfLoaded - true if config is already loaded, false otherwise
     */
    isConfLoaded : function (apiKey) {
        if (!apiKey) {
            return;
        }
        if (this.generalOptions.apiKeys[apiKey]) {
            return true;
        }
        return false;
    },

    /**
     * Returns an array of Geoportal layers identifiers, corresponding to an API contract key.
     *
     * @param {String} apiKey - Access key to Geoportal platform
     * @returns {Array} apiKeys - Array of geoportal layers identifiers
     */
    getLayersId : function (apiKey) {
        return this.generalOptions.apiKeys[apiKey];
    },

    /**
     * Returns an associative array of Geoportal layers configurations, corresponding to an API contract key.
     * If no key is specified, all layers from configuration are returned.
     *
     * @param {String} apiKey - Access key to Geoportal platform
     * @returns {Object} layers - Object which properties are layers identifiers, and corresponding
     *      values are instances of <Gp.Services.Config.Layer>.
     */
    getLayersConf : function (apiKey) {
        var layers = {};
        var layersIdArray = this.getLayersId(apiKey);
        if (layersIdArray) {
            for (var i = 0; i < layersIdArray.length; i++) {
                var lyrId = layersIdArray[i];
                layers[lyrId] = this.layers[lyrId];
            }
        }
        return layers;
    },

    /**
     * Returns a geoportal layer configuration, given its identifier
     *
     * @param {String} layerId - Geoportal layer identifier (e.g. "GEOGRAPHICALGRIDSYSTEMS.MAPS$GEOPORTAIL:OGC:WMTS")
     * @return {Object} layer - Layer configuration : instance of {@link Gp.Services.Config.Layer}
     */
    getLayerConf : function (layerId) {
        if (!this.layers) {
            return;
        }
        return this.layers[layerId];
    },

    /**
     * Returns an associative array of Tile Matrix Sets configurations.
     *
     * @return {Object} tileMatrixSets - Object which properties are TMS identifiers,
     *      and corresponding values are instances of {@link Gp.Services.Config.TileMatrixSet}.
     */
    getTileMatrixSets : function () {
        return this.tileMatrixSets;
    },

    /**
     * Returns a Tile Matrix Sets configuration, given its identifier.
     *
     * @param {String} tmsID - Tile Matrix Set identifier (e.g. : "PM")
     * @return {Object} tileMatrixSet - Tile Matrix Set configuration, instance of {@link Gp.Services.Config.TileMatrixSet}
     */
    getTMSConf : function (tmsID) {
        if (!this.tileMatrixSets) {
            return;
        }
        return this.tileMatrixSets[tmsID];
    },

    /**
     * Returns an associative array of territories configurations.
     *
     * @return {Object} territories - Object which properties are territory identifiers,
     *      and corresponding values are instances of {@link Gp.Services.Config.Territory}.
     */
    getTerritories : function () {
        return this.territories;
    },

    /**
     * Returns a territory configuration, given its identifier.
     *
     * @param {String} territoryID - territory identifier (e.g. "FXX")
     * @return {Object} territory - Territory configuration, instance of {@link Gp.Services.Config.Territory}
     */
    getTerritoryConf : function (territoryID) {
        if (!this.territories) {
            return;
        }
        return this.territories[territoryID];
    },

    /**
     * Returns an associative array of services configurations.
     *
     * @return {Object} services - Object which properties are services identifiers,
     *      and corresponding values are instances of {@link Gp.Services.Config.Service}.
     */
    getServices : function () {
        return this.services;
    },

    /**
     * Returns a service configuration, given its identifier.
     *
     * @param {String} serviceID - service identifier (e.g. "OGC:WMTS")
     * @return {Object} service - service configuration, instance of {@link Gp.Services.Config.Service}
     */
    getServiceConf : function (serviceID) {
        if (!this.services) {
            return;
        }
        return this.services[serviceID];
    }

};

/* harmony default export */ __webpack_exports__["a"] = (AutoConfResponse);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 *
 * Object used to express a geographical (BBOX, scale) and temporal constraint.
 *
 * @property {String} crs - Coordinates System ID used to express coordinates contraints.
 * @property {Gp.BBox} bbox - Constraint Bounding Box.
 * @property {Number} minScaleDenominator - Minimum scale denominator where constraint applies.
 * @property {Number} maxScaleDenominator - Maximum scale denominator where constraint applies.
 * @property {Array.<String>} temporalExtent - Array expressing the time interval of the constraint [minT, maxT]. Dates are expressed in the [ISO-8601]{@link https://en.wikipedia.org/wiki/ISO_8601} way.
 *
 * @namespace
 * @alias Gp.Services.Config.Constraint
 */

function Constraint () {
    if (!(this instanceof Constraint)) {
        throw new TypeError("Constraint constructor cannot be called as a function.");
    }

    this.crs = null;

    this.bbox = {
        left : null,
        right : null,
        top : null,
        bottom : null
    };

    this.minScaleDenominator = null;

    this.maxScaleDenominator = null;

    this.temporalExtent = [null, null];
}

Constraint.prototype = {

    constructor : Constraint

};

/* harmony default export */ __webpack_exports__["a"] = (Constraint);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe a format to use with Geoportal resources.
 *
 * @property {Boolean} current - If true, then this format is used by default.
 * @property {String} name - Format mime-type.
 *
 * @namespace
 * @alias Gp.Services.Config.Format
 */

function Format () {
    if (!(this instanceof Format)) {
        throw new TypeError("Format constructor cannot be called as a function.");
    }

    this.current = null;

    this.name = null;
}

Format.prototype = {

    constructor : Format

};

/* harmony default export */ __webpack_exports__["a"] = (Format);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe geoportal resource (WMTS, WMS, WFS layers, geocoding resources or elevation service) parameters. Properties may be used or not depending on the resource type.
 *
 * @property {String} name - name of the resource to use with the webservice that serves it (eg : "GEOGRAPHICALGRIDSYSTEMS.MAPS").
 * @property {String} title - Human readable name for the resource.
 * @property {String} description - Resource description.
 * @property {String} layerId - Unique resource Identifier (eg : "GEOGRAPHICALGRIDSYSTEMS.MAPS$GEOPORTAIL:OGC:WMTS")
 * @property {String} quicklookUrl - Image URL for the resource.
 * @property {Object} serviceParams - Informations about the webservice that serves the resource (OpenLS, WFS, WMTS)
 * @property {String} serviceParams.id - Web Service identifier ("OGC:WMTS", "OGC:OPENLS;ReverseGeocode", etc...)
 * @property {Object} serviceParams.serverUrl - Associative array mapping geoportal access key (keys) with their properties (URLs of the web service, with the geoportal access key).
 * @property {String} serviceParams.version - webservice version.
 * @property {String} defaultProjection - coordinates system ID used by default for the resource (WMS or WFS layer) or of the TileMatrixSet used by the WMTS layer.
 * @property {Array.<String>} additionalProjections - additional coordinates systems IDs availables for the resource, others than the default one (see defaultProjection) (WMS and WFS layers only).
 * @property {Array.<Gp.Services.Config.Format>} formats - Formats availables for the resource.
 * @property {Array.<Gp.Services.Config.Legend>} legends - Informations about legends associated to the resource.
 * @property {Array.<Gp.Services.Config.Metadata>} metadata - Informations about metadata associated to the resource.
 * @property {Array.<Gp.Services.Config.Style>} styles - Informations about styles availables for the resources (WMS, WFS and WMTS only).
 * @property {Array.<Gp.Services.Config.Thematic>} thematics - Informations about thematics associated to the resource.
 * @property {Gp.Services.Config.Constraint} globalConstraint - geographical constraint for the resource.
 * @property {Array.<Gp.Services.Config.Constraint>} constraints - additionnal geographical constraints for the resource.
 * @property {Array.<Gp.Services.Config.Originator>} originators - Informations about originator of the resource.
 * @property {Object} wmtsOptions - Informations associated to WMTS resources.
 * @property {String} wmtsOptions.tileMatrixSetLink - TileMatrixSet identifier used by the resource (see {@link Gp.Services.Config.TileMatrixSet})
 * @property {Gp.Services.Config.TileMatrixLimit} wmtsOptions.tileMatrixSetLimits - limits of the resource for that TileMAtrixSet.
 * @property {Boolean} queryable - true if a getFeatureInfo request may be done for the resource (WMS or WMTS only).
 * @property {Boolean} hidden - true if the resource is not visible.
 * @property {Boolean} isAggregate - true if the resource is an aggregate of other resources (@see aggregatedLayers).
 * @property {Array.<String>} aggregatedLayers - Layers IDs composing the being described aggregated layer.
 * @property {Array.<String>} apiKeys - Array of access keys that grant access to that resource.
 * @property {Object} dimensions - Dimensions informations associated with the resource.
 * @property {String} dimensions.type
 * @property {String} dimensions.visibilityRange
 * @property {String} dimensions.visibilityMode
 * @property {String} dimensions.noDataValue
 * @property {String} dimensions.geometricType
 *
 * @namespace
 * @alias Gp.Services.Config.Layer
 */
function Layer () {
    if (!(this instanceof Layer)) {
        throw new TypeError("Layer constructor cannot be called as a function.");
    }

    // info : une instance de la classe Layer n'a aucune propriété au départ,.
    // les attributs possibles sont documentés ci-dessus,
    // et seront implémentés au fur et à mesure de la lecture de la réponse de l'autoconf, lorsque l'information est rencontrée.
}

Layer.prototype = {

    constructor : Layer,

    /**
     * Returns the layer name
     *
     * @returns {String} name - name of the resource to use with the webservice that serves it (eg : "GEOGRAPHICALGRIDSYSTEMS.MAPS").
     */
    getName : function () {
        return this.name;
    },

    /**
     * Returns the layer title
     *
     * @returns {String} title - Human readable name for the resource.
     */
    getTitle : function () {
        return this.title;
    },

    /**
     * Returns the layer description
     *
     * @returns {String} description - Resource description.
     */
    getDescription : function () {
        return this.description;
    },

    /**
     * Returns the layer identifier
     *
     * @returns {String} layerId - Unique resource Identifier (eg : "GEOGRAPHICALGRIDSYSTEMS.MAPS$GEOPORTAIL:OGC:WMTS")
     */
    getLayerId : function () {
        return this.layerId;
    },

    /**
     * Returns the layer quicklookUrl
     *
     * @returns {String} quicklookUrl - Image URL for the resource.
     */
    getQuicklookUrl : function () {
        return this.quicklookUrl;
    },

    /**
     * Returns the layer default projection
     *
     * @returns {String} defaultProjection - coordinates system ID used by default for the resource (WMS or WFS layer) or of the TileMatrixSet used by the WMTS layer.
     */
    getDefaultProjection : function () {
        return this.defaultProjection;
    },

    /**
     * Returns the layer projections
     *
     * @returns {Array.<String>} projections - coordinates systems IDs availables for the resource, including the default one.
     */
    getProjections : function () {
        var projections = [];
        projections.push(this.defaultProjection);
        var proj = projections.concat(this.additionalProjections);
        return proj;
    },

    /**
     * Returns the global BBOX
     *
     * @returns {Gp.BBox} bbox - the layer global bounding box, expressed in CRS system.
     */
    getBBOX : function () {
        if (!this.globalConstraint) {
            return;
        }
        return this.globalConstraint.bbox;
    },

    /**
     * Returns the layer minimum scale denominator
     *
     * @returns {Number} minScaleDenominator - minimum scale denominator for this layer
     */
    getMinScaleDenominator : function () {
        if (!this.globalConstraint) {
            return;
        }
        return this.globalConstraint.minScaleDenominator;
    },

    /**
     * Returns the layer maximum scale denominator
     *
     * @returns {Number} maxScaleDenominator - maximum scale denominator for this layer
     */
    getMaxScaleDenominator : function () {
        if (!this.globalConstraint) {
            return;
        }
        return this.globalConstraint.maxScaleDenominator;
    },

    /**
     * Returns layer Tile Matrix Set identifier if exists
     *
     * @returns {String} tileMatrixSetLink - Tile Matrix Set identifier (for instance : "PM")
     */
    getTMSID : function () {
        if (this.wmtsOptions) {
            return this.wmtsOptions.tileMatrixSetLink;
        }
    },

    /**
     * Returns information about the webservice that serves the resource
     *
     * @returns {Object} serviceParams - Information about the webservice that serves the resource (OpenLS, WFS, WMTS)
     */
    getServiceParams : function () {
        return this.serviceParams;
    },

    /**
     * Returns Geoportal server url for a given key
     *
     * @param {String} apiKey - Access key to Geoportal platform
     * @returns {String} serverUrl - general URL of the web service (with the geoportal access key)
     */
    getServerUrl : function (apiKey) {
        if (!apiKey || !this.serviceParams || !this.serviceParams.serverUrl) {
            return;
        }
        return this.serviceParams.serverUrl[apiKey];
    },

    /**
     * Returns information about legends associated to the resource.
     *
     * @returns {Array.<Gp.Services.Config.Legend>} legends - Informations about legends associated to the resource.
     */
    getLegends : function () {
        return this.legends;
    },

    /**
     * Returns information about metadata associated to the resource.
     *
     * @returns {Array.<Gp.Services.Config.Metadata>} metadata - Informations about metadata associated to the resource.
     */
    getMetadata : function () {
        return this.metadata;
    },

    /**
     * Returns information about styles availables for the resources (WMS, WFS and WMTS only).
     *
     * @returns {Array.<Gp.Services.Config.Style>} styles - Informations about styles availables for the resources (WMS, WFS and WMTS only).
     */
    getStyles : function () {
        return this.styles;
    },

    /**
     * Returns layer default style
     *
     * @returns {String} styleName - style identifier (eg : "normal", "bdparcellaire", ...)
     */
    getDefaultStyle : function () {
        if (!this.styles) {
            return;
        }
        var style;
        var s = this.styles;
        for (var i = 0; i < s.length; i++) {
            if (s[i].current === true) {
                style = s[i].name;
                break;
            }
        }
        return style;
    },

    /**
     * Returns information about thematics associated to the resource.
     *
     * @returns {Array.<Gp.Services.Config.Thematic>} thematics - Informations about thematics associated to the resource.
     */
    getThematics : function () {
        return this.thematics;
    },

    /**
     * Returns layer default format
     *
     * @returns {String} formatName - Format mime-type. (eg. "image/jpeg")
     */
    getDefaultFormat : function () {
        if (!this.formats) {
            return;
        }
        var format;
        var f = this.formats;
        for (var i = 0; i < f.length; i++) {
            if (f[i].current === true) {
                format = f[i].name;
                break;
            }
        }
        return format;
    },

    /**
     * Returns information about geographical or temporal constraints for the resource
     *
     * @returns {Array.<Gp.Services.Config.Constraint>} constraints - Informations about geographical or temporal constraints for the resource
     */
    getConstraints : function () {
        return this.constraints;
    },

    /**
     * Returns information about originators of this resource
     *
     * @returns {Array.<Gp.Services.Config.Originator>} originators - Informations about originators of this resource
     */
    getOriginators : function () {
        return this.originators;
    },

    /**
     * Returns information about dimensions associated with this resource
     *
     * @returns {Object} dimensions - Dimensions informations associated with the resource.
     */
    getDimensions : function () {
        return this.dimensions;
    },

    /**
     * Returns information about aggregated layers composing the being described layer, in case the resource is an aggregate of other resources.
     *
     * @returns {Object} aggregatedLayers - Layers IDs composing the being described aggregated layer.
     */
    getAggregatedLayers : function () {
        if (this.isAggregate) {
            return this.aggregatedLayers;
        } else {

        }
    }

};

/* harmony default export */ __webpack_exports__["a"] = (Layer);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe a legend file associated with a geoportal resource (WMTS, WMS, WFS layers).
 *
 * @property {String} format - mime-type of the legend file.
 * @property {String} url - legend file URL
 * @property {Number} minScaleDenominator - minimum scale denominator where this legend applies.
 *
 * @namespace
 * @alias Gp.Services.Config.Legend
 */

function Legend () {
    if (!(this instanceof Legend)) {
        throw new TypeError("Legend constructor cannot be called as a function.");
    }

    this.format = null;

    this.url = null;

    this.minScaleDenominator = null;
}

Legend.prototype = {

    constructor : Legend

};

/* harmony default export */ __webpack_exports__["a"] = (Legend);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe a metadata file associated with a geoportal resource.
 *
 * @property {String} format - mime-type of the metadata file.
 * @property {String} url - metadata file URL
 *
 * @namespace
 * @alias Gp.Services.Config.Metadata
 */

function Metadata () {
    if (!(this instanceof Metadata)) {
        throw new TypeError("Metadata constructor cannot be called as a function.");
    }

    this.format = null;

    this.url = null;
}

Metadata.prototype = {

    constructor : Metadata

};

/* harmony default export */ __webpack_exports__["a"] = (Metadata);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe an Originator of geoportal resource.
 *
 * @property {String} name - originator name
 * @property {String} attribution - originator full name
 * @property {String} logo - originator logo file URL
 * @property {String} url - originator web site URL
 * @property {Array.<Gp.Services.Config.Constraint>} constraints - where and when the originator applies for the ressource.
 *
 * @namespace
 * @alias Gp.Services.Config.Originator
 */

function Originator () {
    if (!(this instanceof Originator)) {
        throw new TypeError("Originator constructor cannot be called as a function.");
    }

    this.name = null;

    this.attribution = null;

    this.logo = null;

    this.url = null;

    this.constraints = [];
}

Originator.prototype = {

    constructor : Originator

};

/* harmony default export */ __webpack_exports__["a"] = (Originator);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe a web service of the geoportal platform.
 *
 * @property {String} title - Web service name
 * @property {Object} serverUrl - Associative array mapping geoportal access key (keys) with their properties (URLs of the web service, with the geoportal access key).
 * @property {String} version - web service version.
 *
 * @namespace
 * @alias Gp.Services.Config.Service
 */
function Service () {
    if (!(this instanceof Service)) {
        throw new TypeError("Service constructor cannot be called as a function.");
    }

    this.title = null;

    this.serverUrl = null;

    this.version = null;
}

Service.prototype = {

    constructor : Service

};

/* harmony default export */ __webpack_exports__["a"] = (Service);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe a style that may be used for a geoportal resource.
 *
 * @property {String} name - Style identifier (eg : "normal", "bdparcellaire", ...)
 * @property {String} title - human readable name of the style.
 * @property {Boolean} current - true if this is the default style.
 *
 * @namespace
 * @alias Gp.Services.Config.Style
 */

function Style () {
    if (!(this instanceof Style)) {
        throw new TypeError("Style constructor cannot be called as a function.");
    }

    this.name = null;

    this.title = null;

    this.current = null;
}

Style.prototype = {

    constructor : Style

};

/* harmony default export */ __webpack_exports__["a"] = (Style);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe properties of a french territory covered by geoportal resources.
 *
 * @property {Boolean} isDefault - if this territory is to use by default.
 * @property {String} defaultCRS - Identifier of the coordinates system to use by default for that territory.
 * @property {Array.<String>} additionalCRS - Identifiers of additional coordinates systems availables for that territory.
 * @property {Array.<String>} defaultLayers - Identifiers of layers to load by default for that territory.
 * @property {Object} defaultOptions - options to use by default for that territory.
 * @property {Number} defaultOptions.resolution - resolution to use by default for that territory (in meter per pixel).
 * @property {Number} defaultOptions.minScaleDenominator - minimum scaleDenominator accessible for that territory.
 * @property {Number} defaultOptions.maxScaleDenominator - maximum scaleDenominator accessible for that territory.
 * @property {Gp.BBox} geoBBox - Bounding Box of the territory (expressed in geographical coordinates)
 * @property {Object} geoCenter - center of the territory (expressed in geographical coordinates)
 * @property {Float} geoCenter.lon - center longitude
 * @property {Float} geoCenter.lat - center latitude
 *
 * @namespace
 * @alias Gp.Services.Config.Territory
 */
function Territory () {
    if (!(this instanceof Territory)) {
        throw new TypeError("Territory constructor cannot be called as a function.");
    }

    this.isDefault = null;

    this.defaultCRS = null;

    this.additionalCRS = [];

    this.geoBBOX = {
        left : null,
        right : null,
        top : null,
        bottom : null
    };

    this.geoCenter = {
        lon : null,
        lat : null
    };

    this.defaultOptions = {
        resolution : null,
        minScaleDenominator : null,
        maxScaleDenominator : null
    };

    this.defaultLayers = [];
}

Territory.prototype = {

    constructor : Territory

};

/* harmony default export */ __webpack_exports__["a"] = (Territory);


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe a thematic
 *
 * @property {String} name - Thematic name
 * @property {Boolean} inspire - true if the thematic name is an [INSPIRE one]{@link http://inspire.ec.europa.eu/index.cfm/pageid/2/list/7}.
 *
 * @namespace
 * @alias Gp.Services.Config.Thematic
 */

function Thematic () {
    if (!(this instanceof Thematic)) {
        throw new TypeError("Thematic constructor cannot be called as a function.");
    }

    this.inspire = null;

    this.name = null;
}

Thematic.prototype = {

    constructor : Thematic

};

/* harmony default export */ __webpack_exports__["a"] = (Thematic);


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 *
 * Object used to describe a TileMatrix set (for WMTS use).
 *
 * @property {Array.<String>} matrixIds - Array of IDs for each TileMatrix of the set.
 * @property {Array.<Gp.Services.Config.TileMatrix>} tileMatrices - Array of TileMatrix descriptions.
 * @property {Array.<Float>} nativeResolutions - Array of resolutions (in meter per pixel) applying for each TileMatrix of the set.
 * @property {String} projection - Identifier of the Cordinates System used for the tileMatrixSet.
 *
 * @namespace
 * @alias Gp.Services.Config.TileMatrixSet
 */
function TileMatrixSet () {
    if (!(this instanceof TileMatrixSet)) {
        throw new TypeError("TileMatrixSet constructor cannot be called as a function.");
    }

    this.projection = null;

    this.nativeResolutions = [];

    this.matrixIds = [];

    this.tileMatrices = {};
}

TileMatrixSet.prototype = {

    constructor : TileMatrixSet,

    /**
     * Returns Tile Matrix Set resolutions
     *
     * @returns {Array} nativeResolutions - Array of resolutions (in meter per pixel) applying for each TileMatrix of the set.
     */
    getResolutions : function () {
        return this.nativeResolutions;
    },

    /**
     * Returns Tile Matrix Set identifiers
     *
     * @returns {Array} matrixIds - Array of IDs for each TileMatrix of the set.
     */
    getMatrixIds : function () {
        return this.matrixIds;
    },

    /**
     * Returns Tile Matrix Set projection
     *
     * @returns {String} projection - Identifier of the Cordinates System used for the tileMatrixSet.
     */
    getProjection : function () {
        return this.projection;
    },

    /**
     * Returns Tile Matrices descriptions.
     *
     * @returns {Array.<Gp.Services.Config.TileMatrix>} tileMatrices - Array of TileMatrix descriptions.
     */
    getTileMatrices : function () {
        return this.tileMatrices;
    },

    /**
     * Returns top left corner point of matrices
     *
     * @returns {Gp.Point} topLeftCorner - Top Left Corner Point of TMS matrices, expressed in the tileMatrixSet coordinates system.
     */
    getTopLeftCorner : function () {
        var topLeftCorner;
        var matrices = this.getTileMatrices();
        if (matrices) {
            for (var id in matrices) {
                if (matrices.hasOwnProperty(id)) {
                    topLeftCorner = matrices[id].topLeftCorner;
                    break;
                }
            }
        }
        return topLeftCorner;
    }

};

/* harmony default export */ __webpack_exports__["a"] = (TileMatrixSet);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe a TileMatrix.
 *
 * @property {String} matrixId - matrix Identifier
 * @property {Number} matrixHeight - Number of tiles from the top to the bottom of the matrix.
 * @property {Number} matrixWidth - Number of tiles from the left to the right of the matrix.
 * @property {Number} scaleDenominator - Scale denominator associated to that matrix.
 * @property {Number} tileHeight - tile height in number of pixels
 * @property {Number} tileWidth - tile width in number of pixels
 * @property {Gp.Point} topLeftCorner - Top Left Corner Point of the matrix expressed in the tileMatrixSet coordinates system.
 *
 * @namespace
 * @alias Gp.Services.Config.TileMatrix
 */

function TileMatrix () {
    if (!(this instanceof TileMatrix)) {
        throw new TypeError("TileMatrix constructor cannot be called as a function.");
    }

    this.matrixId = null;

    this.matrixHeight = null;

    this.matrixWidth = null;

    this.scaleDenominator = null;

    this.tileHeight = null;

    this.tileWidth = null;

    this.topLeftCorner = null;
}

TileMatrix.prototype = {

    constructor : TileMatrix,

    /**
     * Returns top left corner point of the matrix
     *
     * @returns {Gp.Point} topLeftCorner - Top Left Corner Point of the matrix expressed in the tileMatrixSet coordinates system.
     */
    getTopLeftCorner : function () {
        return this.topLeftCorner;
    },

    /**
     * Returns Scale denominator associated to that matrix.
     *
     * @returns {Number} scaleDenominator - Scale denominator associated to that matrix.
     */
    getScaleDenominator : function () {
        return this.scaleDenominator;
    },

    /**
     * Returns tile height of matrix
     *
     * @returns {Number} tileHeight - tile height in number of pixels
     */
    getTileHeight : function () {
        return this.tileHeight;
    },

    /**
     * Returns tile width of matrix
     *
     * @returns {Number} tileWidth - tile width in number of pixels
     */
    getTileWidth : function () {
        return this.tileWidth;
    },

    /**
     * Returns matrix height (number of tiles)
     *
     * @returns {Number} matrixHeight - Number of tiles from the top to the bottom of the matrix.
     */
    getMatrixHeight : function () {
        return this.matrixHeight;
    },

    /**
     * Returns matrix width (number of tiles)
     *
     * @returns {Number} matrixWidth - Number of tiles from the left to the right of the matrix.
     */
    getMatrixWidth : function () {
        return this.matrixWidth;
    }

};

/* harmony default export */ __webpack_exports__["a"] = (TileMatrix);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Object used to describe a layer extent on a Tile Matrix.
 *
 * @property {Number} minTileCol - minimum column index where tile can be found on the Tile matrix.
 * @property {Number} maxTileCol - maximum column index where tile can be found on the Tile matrix.
 * @property {Number} minTileRow - minimum row index where tile can be found on the Tile matrix.
 * @property {Number} maxTileCol - maximum row index where tile can be found on the Tile matrix.
 *
 * @namespace
 * @alias Gp.Services.Config.TileMatrixLimit
 */

function TileMatrixLimit () {
    if (!(this instanceof TileMatrixLimit)) {
        throw new TypeError("TileMatrixLimit constructor cannot be called as a function.");
    }

    this.minTileRow = null;

    this.maxTileRow = null;

    this.minTileCol = null;

    this.maxTileCol = null;
}

/**
 * @lends module:Autoconf/Response/TileMatrixLimit
 */
TileMatrixLimit.prototype = {

    constructor : TileMatrixLimit
};

/* harmony default export */ __webpack_exports__["a"] = (TileMatrixLimit);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AbstractService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtilityService_GeocodeRequest__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtilityService_ReverseGeocodeRequest__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationUtilityService_GeocodeFilterExtension__ = __webpack_require__(13);






/**
 * @classdesc
 *
 * Requête de type LocationUtilityService (LUS)
 * (Factory)
 *
 * @example
 * // encapsule un objet dans une coquille XSL, Factory sur les objets Geocode/ReverseGeocode
 * lus = new LocationUtilityService ();
 * lus.addRequest (req);
 * lus.toString();
 *  ou
 * lus = new LocationUtilityService ({
 *      location : "saint mandé",
 *      returnFreeForm : true,
 *      filterOptions : {
 *          type :  ['PositionOfInterest']
 *      }
 * });
 * lus.toString();
 *
 * // out ->
 * // <GeocodeRequest>
 * //   <Address countryCode="PositionOfInterest">
 * //     <freeFormAddress>saint mandé</freeFormAddress>
 * //   </Address>
 * // </GeocodeRequest>
 *
 * // creation de l'objet Geocode
 * req = new GeocodeRequest ();
 * req.addAddress (new Address (/*todo/*));
 * req.toString();
 * // out ->
 * // <GeocodeRequest>
 * //   <Address countryCode="PositionOfInterest">
 * //     <freeFormAddress>saint mandé</freeFormAddress>
 * //   </Address>
 * // </GeocodeRequest>
 *
 * // creation de l'objet ReverseGeocode
 * req = new ReverseGeocodeRequest ();
 * req.addPosition (new Position (position:{x: , y: }));
 * req.addPreference (['StreetAddress']);
 * req.toString();
 * // out ->
 * // <ReverseGeocodeRequest>
 * //     <Position>
 * //       <gml:Point xmlns:gml="http://www.opengis.net/gml">
 * //           <gml:pos>50.347775 3.205098</gml:pos>
 * //       </gml:Point>
 * //     </Position>
 * //     <ReverseGeocodePreference>StreetAddress</ReverseGeocodePreference>
 * //  </ReverseGeocodeRequest>
 *
 * @constructor
 * @alias Gp.Formats.XLS.LocationUtilityService
 * @param {Object} options - options
 * @param {Object}   options.location - location
 * @param {String}   options.position - position : {x : "", y : ""}
 * @param {String}   options.returnFreeForm - true|false
 * @param {Object}   options.filterOptions - filtres
 * @param {Function} options.onsuccess - function callback success (TODO)
 * @param {Function} options.onerror   - function callback error   (TODO)
 *
 * @private
 */
function LocationUtilityService (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur LocationUtilityService ()]");

    if (!(this instanceof LocationUtilityService)) {
        throw new TypeError("LocationUtilityService constructor cannot be called as a function.");
    }

    /**
     * Nom de la classe
     */
    this.CLASSNAME = "LocationUtilityService";

    /**
     * Type de classe de geocodage
     * ex. GeocodeRequest ou ReverseGeocodeRequest
     */
    this.CLASSTYPE = null;

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_1__AbstractService__["a" /* default */].apply(this, arguments);

    // on determine le type de geocodage si les options sont renseignées
    if (this.options) {
        this.CLASSTYPE = (this.options.location) ? "GeocodeRequest" : (this.options.position) ? "ReverseGeocodeRequest" : null;
    }
}

/**
 * @lends module:LocationUtilityService#
 */
LocationUtilityService.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__AbstractService__["a" /* default */].prototype, {
    // todo
    // getter/setter
});

/**
 * Constructeur (alias)
 */
LocationUtilityService.prototype.constructor = LocationUtilityService;

/**
 * (overwrite) Ajout d'un objet de type LUS : GeocodeRequest ou ReverseGeocodeRequest
 *
 * @param {Object} oLUSRequest - objet de type LUS
 */
LocationUtilityService.prototype.addRequest = function (oLUSRequest) {
    // on determine le type de geocodage
    this.CLASSTYPE = oLUSRequest.CLASSNAME;

    // on controle les types acceptés
    switch (this.CLASSTYPE) {
        case "GeocodeRequest":
        case "ReverseGeocodeRequest":
            this.oRequest = oLUSRequest;
            break;
        default:
            throw new Error("Ce n'est pas un objet de type 'LUS Request' !?");
    }
};

/**
 * (overwrite) Ajout d'un objet de type GeocodeFilterExtension
 *
 * @param {Object} oFilter - objet de type Filtre
 */
LocationUtilityService.prototype.addFilter = function (oFilter) {
    // FIXME gestion des filtres à partir des tables de geocodages
    if (oFilter instanceof __WEBPACK_IMPORTED_MODULE_4__LocationUtilityService_GeocodeFilterExtension__["a" /* default */]) {
        this.oFilter = oFilter;
    }
};

/**
 * (overwrite) toString
 *
 * @returns {String} requête
 */
LocationUtilityService.prototype.toString = function () {
    // soit, on a un objet LUS Request déjà instancié
    // sinon, il faut le construire à partir des options à disposition
    if (!this.oRequest) {
        // il nous faut des options
        if (!this.options) {
            throw new Error("Les options ne sont pas renseignées, impossible de construire la requête !");
        }

        // si les options 'location' et 'position' sont renseignées,
        // on prendra par defaut le choix du geocodage direct
        if (this.CLASSTYPE === "GeocodeRequest") {
            var settingsDirect = {
                location : this.options.location,
                returnFreeForm : this.options.returnFreeForm,
                filterOptions : this.options.filterOptions || {}
            };
            this.oRequest = new __WEBPACK_IMPORTED_MODULE_2__LocationUtilityService_GeocodeRequest__["a" /* default */](settingsDirect);
            // ajout des filtres spécifiques au service du geocodage direct de l'IGN
            if (this.oFilter) {
                this.oRequest.addFilter(this.oFilter);
            }
        } else if (this.CLASSTYPE === "ReverseGeocodeRequest") {
            var settingsInv = {
                position : this.options.position,
                returnFreeForm : this.options.returnFreeForm,
                filterOptions : this.options.filterOptions || {}
            };
            this.oRequest = new __WEBPACK_IMPORTED_MODULE_3__LocationUtilityService_ReverseGeocodeRequest__["a" /* default */](settingsInv);
        } else {
            this.logger.error("impossible de determiner le type de geocodage : Direct ou Inverse !?");
        }
    }

    // objet indefini !?
    if (!this.oRequest) {
        throw new Error("Type de Geocodage indefini !");
    }

    this.strRequest = this.oRequest.toString();
    return this.strRequest;
};

/* harmony default export */ __webpack_exports__["a"] = (LocationUtilityService);


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GeocodedLocation__ = __webpack_require__(15);



/**
 * Single location object returned by the underlying geocoding web service.
 *
 * @property {Float} accuracy - Accuracy of the response towards the requested location between 0 (unaccurate) and 1 (exact match).
 *
 * @namespace
 * @extends {Gp.Services.Geocode.GeocodedLocation}
 * @alias Gp.Services.Geocode.DirectGeocodedLocation
 */
function DirectGeocodedLocation () {
    if (!(this instanceof DirectGeocodedLocation)) {
        throw new TypeError("DirectGeocodedLocation constructor cannot be called as a function.");
    }

    // INFO
    // appel du constructeur de la classe mère
    // avec passage de param.
    __WEBPACK_IMPORTED_MODULE_0__GeocodedLocation__["a" /* default */].apply(this, arguments);

    /**
     * Nom de la classe (heritage) : "DirectGeocodedLocation"
     * @type {String}
     */
    this.CLASSNAME = "DirectGeocodedLocation";

    this.accuracy = null;
}

DirectGeocodedLocation.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__GeocodedLocation__["a" /* default */].prototype);

DirectGeocodedLocation.prototype.constructor = DirectGeocodedLocation;

/* harmony default export */ __webpack_exports__["a"] = (DirectGeocodedLocation);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GeocodedLocation__ = __webpack_require__(15);



/**
 * Single location object returned by the underlying reverse geocoding web service.
 *
 * @property {Float} searchCenterDistance - Distance between the requested point and the location.
 *
 * @namespace
 * @extends {Gp.Services.Geocode.GeocodedLocation}
 * @alias Gp.Services.Geocode.ReverseGeocodedLocation
 */
function ReverseGeocodedLocation () {
    if (!(this instanceof ReverseGeocodedLocation)) {
        throw new TypeError("ReverseGeocodedLocation constructor cannot be called as a function.");
    }

    // INFO
    // appel du constructeur de la classe mère
    // avec passage de param.
    __WEBPACK_IMPORTED_MODULE_0__GeocodedLocation__["a" /* default */].apply(this, arguments);

    /**
     * Nom de la classe (heritage) : "ReverseGeocodedLocation"
     * @type {String}
     */
    this.CLASSNAME = "ReverseGeocodedLocation";

    this.searchCenterDistance = null;
}

ReverseGeocodedLocation.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__GeocodedLocation__["a" /* default */].prototype);

ReverseGeocodedLocation.prototype.constructor = ReverseGeocodedLocation;

/* harmony default export */ __webpack_exports__["a"] = (ReverseGeocodedLocation);


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Response object for {@link module:Services~autoComplete Gp.Services.autoComplete ()} invocation when successful. Received as the argument of onSuccess callback function.
 *
 * @property {Array.<Gp.Services.AutoComplete.SuggestedLocation>} suggestedLocations - SuggestedLocations array.
 *
 * @namespace
 * @alias Gp.Services.AutoCompleteResponse
 */
function AutoCompleteResponse () {
    if (!(this instanceof AutoCompleteResponse)) {
        throw new TypeError("AutoCompleteResponse constructor cannot be called as a function.");
    }

    this.suggestedLocations = [];
}

AutoCompleteResponse.prototype = {

    constructor : AutoCompleteResponse

};

/* harmony default export */ __webpack_exports__["a"] = (AutoCompleteResponse);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/**
 * Single SuggestedLocation Object returned by underlying web service.
 * Each suggested location represents a street address ("StreetAddress") or a place name ("PositionOfInterest").
 *
 * @property {String} type - Suggested location type : "StreetAddress" ou "PositionOfInterest"
 * @property {Gp.Point} position - Position of the suggested location given in requested coordinates system.
 * @property {String} commune - Suggested municipality
 * @property {String} fullText - Full text representation of the suggested location.
 * @property {String} postalCode - Suggested location postcode
 * @property {Integer} classification - Number used to classify the importance of the place where is the suggested location from 1 (most important) to 7 (less important).
 * @property {String} street - Street name of the suggested location ("StreetAddress" only).
 * @property {String} kind - Nature of the suggested location : "prefecture", "monument", "commune", ... for instance ("PositionOfInterest" only).
 *
 * @namespace
 * @alias Gp.Services.AutoComplete.SuggestedLocation
 */
function SuggestedLocation () {
    if (!(this instanceof SuggestedLocation)) {
        throw new TypeError("SuggestedLocation constructor cannot be called as a function.");
    }

    /* REPONSE :
        {
           "status" : "OK",
           "results" : [
              {
                 "country":"PositionOfInterest",
                 "x":-1.559185,
                 "y":47.952603,
                 "city":"Brie",
                 "zipcode":"35150",
                 "street":"corbe",
                 "kind":"Lieu-dit habité",
                 "fulltext":"corbe, 35150 Brie",
                 "classification":6
              },
              {
                 "country":"StreetAddress",
                 "x":1.538295,
                 "y":43.19646,
                 "city":"Brie",
                 "zipcode":"09700",
                 "street":"courreste",
                 "kind":"",
                 "fulltext":"courreste, 09700 Brie",
                 "classification":7
              }
           ]
        }
    */

    /* REPONSE EN ERREUR
        {
            status : "ERROR",
            results : [ ]
        }
    */

    /**
     * Suggested location type : "StreetAddress" ou "PositionOfInterest"
     * @type {String}
     */
    this.type = null;

    /**
     * Position of the suggested location given in requested coordinates system.
     * @type {Gp.Point}
     */
    this.position = {
        x : null,
        y : null
    };

    /**
     * Suggested municipality
     * @type {String}
     */
    this.commune = null;

    /**
     * Full text representation of the suggested location.
     * @type {String}
     */
    this.fullText = null;

    /**
     * Suggested location postcode
     * @type {Number}
     */
    this.postalCode = null;

    /**
     * Number used to classify the importance of the place where is the suggested location from 1 (most important) to 7 (less important).
     * @type {Integer}
     */
    this.classification = null;

    /**
     * Street name of the suggested location ("StreetAddress" only).
     * @type {String}
     */
    this.street = null;

    /**
     * Place name of the suggested location ("PositionOfInterest" only).
     * @type {String}
     */
    this.poi = null;

    /**
     * Nature of the suggested location : "prefecture", "monument", "commune", ... for instance ("PositionOfInterest" only).
     * @type {String}
     */
    this.kind = null;
}

SuggestedLocation.prototype = {

    constructor : SuggestedLocation
};

/* harmony default export */ __webpack_exports__["a"] = (SuggestedLocation);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(44);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Services_Services__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Services_DefaultUrlService__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Services_Alti_Response_model_AltiResponse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_Alti_Response_model_Elevation__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services_AutoComplete_Response_model_AutoCompleteResponse__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_AutoComplete_Response_model_SuggestedLocation__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Services_AutoConf_Response_model_AutoConfResponse__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Services_AutoConf_Response_model_Constraint__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Services_AutoConf_Response_model_Format__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Services_AutoConf_Response_model_Layer__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Services_AutoConf_Response_model_Legend__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Services_AutoConf_Response_model_Metadata__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Services_AutoConf_Response_model_Originator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Services_AutoConf_Response_model_Service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Services_AutoConf_Response_model_Style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Services_AutoConf_Response_model_Territory__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Services_AutoConf_Response_model_Thematic__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Services_AutoConf_Response_model_TileMatrix__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Services_AutoConf_Response_model_TileMatrixLimit__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Services_AutoConf_Response_model_TileMatrixSet__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Services_Geocode_Response_model_GeocodeResponse__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Services_Geocode_Response_model_GeocodedLocation__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Services_Geocode_Response_model_DirectGeocodedLocation__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Services_Geocode_Response_model_ReverseGeocodedLocation__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Services_ProcessIsoCurve_Response_model_ProcessIsoCurveResponse__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Services_Route_Response_model_RouteResponse__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Services_Route_Response_model_RouteInstruction__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Protocols_XHR__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Utils_Helper__ = __webpack_require__(4);
/**
* Global variable Gp.
*
* @module Gp
* @alias Gp
* @desc
*
* This is the global variable that is exposed in the browser environment.
* Content is composed of constructor, functions and properties...
*
* > Error()
*     - .TYPE_SRVERR : "SERVICE_ERROR"
*     - .TYPE_UNKERR : "UNKNOWN_ERROR"
*     - .TYPE_USEERR : "USAGE_ERROR"
*
* > Helper
*     - .indent()
*     - .normalyzeParameters()
*     - .normalyzeUrl()
*
* > Protocols
*     - .XHR.call()
*
* > Services
*     - .Alti
*         - {@link Gp.Services.Alti.Elevation .Elevation()}
*     - {@link Gp.Services.AltiResponse .AltiResponse()}
*     - .AutoComplete
*         - {@link Gp.Services.AutoComplete.SuggestedLocation .SuggestedLocation()}
*     - {@link Gp.Services.AutoCompleteResponse .AutoCompleteResponse()}
*     - {@link Gp.Services.Config .Config()}
*     - {@link Gp.Services.DefaultUrl .DefaultUrl()}
*     - .Geocode
*         - {@link Gp.Services.Geocode.GeocodedLocation .GeocodedLocation()}
*         - {@link Gp.Services.Geocode.ReverseGeocodedLocation .ReverseGeocodedLocation()}
*         - {@link Gp.Services.Geocode.DirectGeocodedLocation .DirectGeocodedLocation()}
*     - {@link Gp.Services.GeocodeResponse .GeocodeResponse()}
*     - {@link Gp.Services.GetConfigResponse .GetConfigResponse()}
*     - {@link Gp.Services.IsoCurveResponse .IsoCurveResponse()}
*     - .Route
*         - {@link Gp.Services.Route.RouteInstruction .RouteInstruction()}
*     - {@link Gp.Services.RouteResponse .RouteResponse()}
*     - {@link module:Services~autoComplete .autoComplete()}
*     - {@link module:Services~geocode .geocode()}
*     - {@link module:Services~getAltitude .getAltitude()}
*     - {@link module:Services~getConfig .getConfig()}
*     - {@link module:Services~isoCurve .isoCurve()}
*     - {@link module:Services~reverseGeocode .reverseGeocode()}
*     - {@link module:Services~route .route()}
*
* > servicesDate : "YYYY-MM-DD"
*
* > servicesVersion : "X.X.X"
*
*
*/
































var Gp = {
    servicesVersion : "2.1.0",
    servicesDate : "2018-08-01",
    /**
     * Methode pour rajouter une classe / objet au namespace global.
     *
     * @private
     * @method extend
     * @param {String} strNS - nom sous lequel on veut présenter la
     *        classe / objet (Gp."strNS").
     * @param {Object} value - la classe / objet à rajouter au NS global.
     * @returns {Object} this
     */
    extend : function (strNS, value) {
        var parts = strNS.split(".");
        var parent = this;
        var pl;

        pl = parts.length;

        for (var i = 0; i < pl; i++) {
            // create a property if it doesn't exist
            if (typeof parent[parts[i]] === "undefined") {
                parent[parts[i]] = {};
            }

            var n = pl - 1;
            if (i === n) {
                parent[parts[i]] = value;
            }

            parent = parent[parts[i]];
        }

        return this;
    }
};

// on declare les ns dans root global
Gp.extend("Protocols", {});
Gp.extend("Protocols.XHR", __WEBPACK_IMPORTED_MODULE_27__Protocols_XHR__["a" /* default */]);
Gp.extend("Services", __WEBPACK_IMPORTED_MODULE_0__Services_Services__["a" /* default */]);
// Export Alti
Gp.extend("Services.AltiResponse", __WEBPACK_IMPORTED_MODULE_2__Services_Alti_Response_model_AltiResponse__["a" /* default */]);
Gp.extend("Services.Alti.Elevation", __WEBPACK_IMPORTED_MODULE_3__Services_Alti_Response_model_Elevation__["a" /* default */]);
// Export Autocomplete
Gp.extend("Services.AutoCompleteResponse", __WEBPACK_IMPORTED_MODULE_4__Services_AutoComplete_Response_model_AutoCompleteResponse__["a" /* default */]);
Gp.extend("Services.AutoComplete.SuggestedLocation", __WEBPACK_IMPORTED_MODULE_5__Services_AutoComplete_Response_model_SuggestedLocation__["a" /* default */]);
// Export Autoconf
Gp.extend("Services.GetConfigResponse", __WEBPACK_IMPORTED_MODULE_6__Services_AutoConf_Response_model_AutoConfResponse__["a" /* default */]);
Gp.extend("Services.Config.Constraint", __WEBPACK_IMPORTED_MODULE_7__Services_AutoConf_Response_model_Constraint__["a" /* default */]);
Gp.extend("Services.Config.Format", __WEBPACK_IMPORTED_MODULE_8__Services_AutoConf_Response_model_Format__["a" /* default */]);
Gp.extend("Services.Config.Layer", __WEBPACK_IMPORTED_MODULE_9__Services_AutoConf_Response_model_Layer__["a" /* default */]);
Gp.extend("Services.Config.Legend", __WEBPACK_IMPORTED_MODULE_10__Services_AutoConf_Response_model_Legend__["a" /* default */]);
Gp.extend("Services.Config.Metadata", __WEBPACK_IMPORTED_MODULE_11__Services_AutoConf_Response_model_Metadata__["a" /* default */]);
Gp.extend("Services.Config.Originator", __WEBPACK_IMPORTED_MODULE_12__Services_AutoConf_Response_model_Originator__["a" /* default */]);
Gp.extend("Services.Config.Service", __WEBPACK_IMPORTED_MODULE_13__Services_AutoConf_Response_model_Service__["a" /* default */]);
Gp.extend("Services.Config.Style", __WEBPACK_IMPORTED_MODULE_14__Services_AutoConf_Response_model_Style__["a" /* default */]);
Gp.extend("Services.Config.Territory", __WEBPACK_IMPORTED_MODULE_15__Services_AutoConf_Response_model_Territory__["a" /* default */]);
Gp.extend("Services.Config.Thematic", __WEBPACK_IMPORTED_MODULE_16__Services_AutoConf_Response_model_Thematic__["a" /* default */]);
Gp.extend("Services.Config.TileMatrix", __WEBPACK_IMPORTED_MODULE_17__Services_AutoConf_Response_model_TileMatrix__["a" /* default */]);
Gp.extend("Services.Config.TileMatrixLimit", __WEBPACK_IMPORTED_MODULE_18__Services_AutoConf_Response_model_TileMatrixLimit__["a" /* default */]);
Gp.extend("Services.Config.TileMatrixSet", __WEBPACK_IMPORTED_MODULE_19__Services_AutoConf_Response_model_TileMatrixSet__["a" /* default */]);
// Export Geocode
Gp.extend("Services.GeocodeResponse", __WEBPACK_IMPORTED_MODULE_20__Services_Geocode_Response_model_GeocodeResponse__["a" /* default */]);
Gp.extend("Services.Geocode.GeocodedLocation", __WEBPACK_IMPORTED_MODULE_21__Services_Geocode_Response_model_GeocodedLocation__["a" /* default */]);
Gp.extend("Services.Geocode.DirectGeocodedLocation", __WEBPACK_IMPORTED_MODULE_22__Services_Geocode_Response_model_DirectGeocodedLocation__["a" /* default */]);
Gp.extend("Services.Geocode.ReverseGeocodedLocation", __WEBPACK_IMPORTED_MODULE_23__Services_Geocode_Response_model_ReverseGeocodedLocation__["a" /* default */]);
// Export IsoCurve
Gp.extend("Services.IsoCurveResponse", __WEBPACK_IMPORTED_MODULE_24__Services_ProcessIsoCurve_Response_model_ProcessIsoCurveResponse__["a" /* default */]);
// Export Route
Gp.extend("Services.RouteResponse", __WEBPACK_IMPORTED_MODULE_25__Services_Route_Response_model_RouteResponse__["a" /* default */]);
Gp.extend("Services.Route.RouteInstruction", __WEBPACK_IMPORTED_MODULE_26__Services_Route_Response_model_RouteInstruction__["a" /* default */]);
// Export Erreurs et Outils
Gp.extend("Error", __WEBPACK_IMPORTED_MODULE_28__Exceptions_ErrorService__["a" /* default */]);
Gp.extend("Helper", __WEBPACK_IMPORTED_MODULE_29__Utils_Helper__["a" /* default */]);
// Export DefaultUrls
Gp.extend("Services.DefaultUrl", __WEBPACK_IMPORTED_MODULE_1__Services_DefaultUrlService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = (Gp); // = export { Gp as default };


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Alti_Alti__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoConf_AutoConf__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Geocode_Geocode__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Geocode_ReverseGeocode__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AutoComplete_AutoComplete__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Route_Route__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProcessIsoCurve_ProcessIsoCurve__ = __webpack_require__(96);
/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "point|circle|bbox" }] */

/**
* Geoportal web services invocation namespace.
*
* @module Services
* @alias Gp.Services
*/








var Services = {
    /**
     * Access to Geoportal resources metadata availables with one ore several keys, using [Auto-configuration service]{@link https://wxs.ign.fr/APIKEY/autoconf} of the Geoportal platform.
     *
     * @method getConfig
     * @param {Object} options - Options for function call.
     * @param {String} options.apiKey - Access key to Geoportal platform, obtained [here]{@link http://professionnels.ign.fr/ign/contrats}.
     * @param {Function} options.onSuccess - Callback function for getting successful service response. Takes a {@link Gp.Services.GetConfigResponse} object as a parameter except if "rawResponse" parameter is set to true : a String will be returned.
     * @param {Function} [options.onFailure] - Callback function for handling unsuccessful service responses (timeOut, missing rights, ...). Takes a {@link Gp.Error} object as parameter.
     * @param {Number} [options.timeOut=0] - Number of milliseconds above which a timeOut response will be returned with onFailure callback (see above). Default value is 0 which means timeOut will not be handled.
     * @param {String} [options.serverUrl=http (s)://wxs.ign.fr/APIKEY/autoconf] - Web service URL. If used, options.apiKey parameter is ignored. Only use if you know what you're doing.
     * @param {String} [options.protocol=JSONP] - Protocol used to handle dialog with web service. Possible values are 'JSONP' ({@link https://en.wikipedia.org/wiki/JSONP}) and 'XHR' ({@link https://en.wikipedia.org/wiki/XMLHttpRequest}). Only XHR protocol is supported in a NodeJS environment. Only use if you know what you're doing.
     * @param {String} [options.proxyURL] - Proxy URL to use when requesting an underlying web service. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you're doing.
     * @param {String} [options.callbackSuffix] - Callback function name suffix to use in case of a JSONP protocol use (see above), to set your own suffix instead of auto-increment. Ignored when options.protocol is set to 'XHR' value. Only use if you know what you're doing.
     * @param {String} [options.httpMethod=GET] - HTTP method to use when requesting underlying web service in case of a XHR protocol use (see above). Possible values are 'GET' and 'POST'. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {String} [options.contentType="application/xml"] - Content-Type to use when requesting underlying web service in case of a XHR protocol use (see above) and if method HTTP is POST. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {Boolean} [options.rawResponse=false] - Setting this parameter to true implies you want to handle the service response by yourself : it will be returned as an unparsed String in onSuccess callback parameter. Only use if you know what you are doing.
     * @param {Function} [options.onBeforeParse] - Callback function for handling service response before parsing (as an unparsed String). Takes a String as a parameter (the raw service response). Returns a String that will be parsed as the service response. Only use if you know what you are doing.
     */
    getConfig : function (options) {
        var autoconfService = new __WEBPACK_IMPORTED_MODULE_1__AutoConf_AutoConf__["a" /* default */](options);
        autoconfService.call();
    },

    /**
     * Getting elevations in or along of one or several points on french territories using the [elevation services of the Geoportal Platform]{@link https://geoservices.ign.fr/documentation/geoservices/alti.html}.<br/>
     * Two use cases are availables :<br/>
     * 1. getting elevations of the given points : don't use the options.sampling parameter ;<br/>
     * 2. getting a regular set of elevations along the given points : use the options.sampling parameter.
     *
     * @method getAltitude
     * @param {Object} options - Options for function call.
     * @param {String} options.apiKey - Access key to Geoportal platform, obtained [here]{@link http://professionnels.ign.fr/ign/contrats}.
     * @param {Array.<Object>} options.positions - Array of positions ({lon:float, lat:float}) expressed in CRS:84 coordinates system, where to get elevations. 50 positions maximum may be given. 2 positions minimum are required if you use the options.sampling parameter.
     * @param {Number} [options.sampling] - Number of points to use (between 2 and 5000) in order to compute an elevation path. The points given with the options.positions parameter are used to fix the planimetric path along which the elevations will be computed.<br/>
     * If not used, only elevations of these positions will be returned.
     * @param {Boolean} [options.zonly=false] - Set this parameter to true if you only want to have elevations returned without corresponding coordinates.
     * @param {Function} options.onSuccess - Callback function for getting successful service response. Takes a {@link Gp.Services.AltiResponse} object as a parameter, except if "rawResponse" is set to true.
     * @param {Function} [options.onFailure] - Callback function for handling unsuccessful service responses (timeOut, missing rights, ...). Takes a {@link Gp.Error} object as parameter.
     * @param {Number} [options.timeOut=0] - Number of milliseconds above which a timeOut response will be returned with onFailure callback (see above). Default value is 0 which means timeOut will not be handled.
     * @param {String} [options.serverUrl=http (s)://wxs.ign.fr/APIKEY/alti/rest/elevation.json] - Web service URL. If used, options.apiKey parameter is ignored. Only use if you know what you're doing.
     * @param {String} [options.protocol=XHR] - Protocol used to handle dialog with web service. Possible values are 'JSONP' ({@link https://en.wikipedia.org/wiki/JSONP}) and 'XHR' ({@link https://en.wikipedia.org/wiki/XMLHttpRequest}). Only XHR protocol is supported in a NodeJS environment. Only use if you know what you're doing.
     * @param {String} [options.proxyURL] - Proxy URL to use when requesting underlying web service. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you're doing.
     * @param {String} [options.callbackSuffix] - Callback function name suffix to use in case of a JSONP protocol use (see above), to set your own suffix instead of auto-increment. Ignored when options.protocol is set to 'XHR' value. Only use if you know what you're doing.
     * @param {String} [options.httpMethod=GET] - HTTP method to use when requesting underlying web service in case of a XHR protocol use (see above). Possible values are 'GET' and 'POST'. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {String} [options.contentType="application/xml"] - Content-Type to use when requesting underlying web service in case of a XHR protocol use (see above) and if method HTTP is POST. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {Boolean} [options.rawResponse=false] - Setting this parameter to true implies you want to handle the service response by yourself : it will be returned as an unparsed String in onSuccess callback parameter. Only use if you know what you are doing.
     * @param {Function} [options.onBeforeParse] - Callback function for handling service response before parsing (as an unparsed String). Takes a String as a parameter (the raw service response). Returns a String that will be parsed as the service response. Only use if you know what you are doing.
     * @param {String} [options.api='REST'] - What API to use for interacting with underlying web service : 'REST' or 'WPS'. Only use if you know what you are doing.
     * @param {String} [options.outputFormat='xml'] - Output format for underlying web service response : 'xml' or 'json'. Only use if you know what you are doing.
     */
    getAltitude : function (options) {
        var altiService = new __WEBPACK_IMPORTED_MODULE_0__Alti_Alti__["a" /* default */](options);
        altiService.call();
    },
    /**
     * Getting positon of a geographic identifier (places names, address, cadastral parcel, other...) using the [geocoding web service of the Geoportal Platform]{@link https://geoservices.ign.fr/documentation/geoservices/geocodage.html}.
     *
     * @example
     * Gp.Services.geocode ({
     *     apiKey : "jhyvi0fgmnuxvfv0zjzorvdn",
     *     location : "73 avenue de Paris, Saint-Mandé",
     *     // traitement des resultats
     *     onSuccess  : function (result) {
     *         // console.log("found (x:"+result.position.x+", y:"+result.position.y+")") ;
     *     }
     * }) ;
     *
     *
     * @method geocode
     * @param {Object} options - Options for function call.
     * @param {String} options.apiKey - Access key to Geoportal platform, obtained [here]{@link http://professionnels.ign.fr/ign/contrats}.
     * @param {String|Object} options.location - Geographic identifier to locate. May be provided as a single String or a structured Object for an address search. In this last case, the following properties are availaibles.
     *      @param {Number} [options.location.number] - Street number.
     *      @param {String} [options.location.street] - Street name.
     *      @param {String} [options.location.city] - City name.
     *      @param {Number} [options.location.postalCode] - Postal Code
     * @param {Object} [options.filterOptions] - Additional filters to apply to search. The following properties may be given.
     *      @param {Gp.BBox} [options.filterOptions.bbox] - Bounding box where to perform the search. Properties expressed in options.srs coordinates system.
     *      @param {Array.<String>} [options.filterOptions.type] - Geographical identifier types to search. Values currently availables are : "PositionOfInterest" for place names, "StreetAddress" for address search, "CadastralParcel" for Cadastral parcels search. Default is "StreetAddress".
     *
     *      @param {String} [options.filterOptions.[prop]] - Additionnal properties to filter search. Properties depends on options.filterOptions.type, and values type should be "String".
     *      <br/><br/>
     *      Common Properties availables for all search types :<br/>
     *      "municipality", "insee", "department".
     *      <br/><br/>
     *      Properties availables for address search :<br/>
     *      "quality", "ID", "ID_TR" and "territory".
     *      <br/><br/>
     *      Properties availables for place names search :<br/>
     *      "importance", "nature" and "territory".
     *      <br/><br/>
     *      Properties availables for cadastral parcels search :<br/>
     *      "sheet", "section", and "absorbedcity".
     * @param {Number} [options.maximumResponses = 25] - Maximum number of responses. Default underlying service value applies (25) if not provided.
     * @param {Boolean} [options.returnFreeForm = false] - Set this parameter to true if you wish to have an address returned in a single String (unstructured). If unset, default underlying service value (false) applies.
     * @param {String} [options.srs = EPSG:4326] - Coordinates System used to expres coordinates for parameters and responses. Default underlying service value (EPSG:4326) applies.
     * @param {Function} options.onSuccess - Callback function for getting successful service response. Takes a {@link Gp.Services.GeocodeResponse} object as a parameter except if "rawResponse" is set to true.
     * @param {Function} [options.onFailure] - Callback function for handling unsuccessful service responses (timeOut, missing rights, ...). Takes a {@link Gp.Error} object as parameter.
     * @param {Number} [options.timeOut=0] - Number of milliseconds above which a timeOut response will be returned with onFailure callback (see above). Default value is 0 which means timeOut will not be handled.
     * @param {String} [options.serverUrl=http (s)://wxs.ign.fr/APIKEY/geoportail/ols] - Web service URL. If used, options.apiKey parameter is ignored. Only use if you know what you're doing.
     * @param {String} [options.protocol=XHR] - Protocol used to handle dialog with web service. Possible values are 'JSONP' ({@link https://en.wikipedia.org/wiki/JSONP}) and 'XHR' ({@link https://en.wikipedia.org/wiki/XMLHttpRequest}). Only XHR protocol is supported in a NodeJS environment. Only use if you know what you're doing.
     * @param {String} [options.proxyURL] - Proxy URL to use when requesting underlying web service. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you're doing.
     * @param {String} [options.callbackSuffix] - Callback function name suffix to use in case of a JSONP protocol use (see above), to set your own suffix instead of auto-increment. Ignored when options.protocol is set to 'XHR' value. Only use if you know what you're doing.
     * @param {String} [options.httpMethod=GET] - HTTP method to use when requesting underlying web service in case of a XHR protocol use (see above). Possible values are 'GET' and 'POST'. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {String} [options.contentType="application/xml"] - Content-Type to use when requesting underlying web service in case of a XHR protocol use (see above) and if method HTTP is POST. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {Boolean} [options.rawResponse=false] - Setting this parameter to true implies you want to handle the service response by yourself : it will be returned as an unparsed String in onSuccess callback parameter. Only use if you know what you are doing.
     * @param {Function} [options.onBeforeParse] - Callback function for handling service response before parsing (as an unparsed String). Takes a String as a parameter (the raw service response). Returns a String that will be parsed as the service response. Only use if you know what you are doing.
     */
    geocode : function (options) {
        var geocodeService = new __WEBPACK_IMPORTED_MODULE_2__Geocode_Geocode__["a" /* default */](options);
        geocodeService.call();
    },
    /**
     * Retrieving geographical identifiers (place names, address, cadastral parcels, ...) near a given position, using the [reverse geocoding web service of the Geoportal Platform]{@link https://geoservices.ign.fr/documentation/geoservices/geocodage-inverse.html}.
     *
     * @method reverseGeocode
     * @param {Object} options - Options for function call.
     * @param {String} options.apiKey - Access key to Geoportal platform, obtained [here]{@link http://professionnels.ign.fr/ign/contrats}.
     * @param {Gp.Point} options.position - Reference position where to search geographical identifiers. Its coordinates are expressed in the coordinates system given with options.srs parameter. (default is CRS:84, that means position.x is the longitude and position.y the latitude)
     * @param {Object} [options.filterOptions] - Additional filters to apply to search. The following properties may be given.
     *      @param {Array.<String>} [options.filterOptions.type] - Geographical identifier types to search. Values currently availables are : "PositionOfInterest" for place names, "StreetAddress" for address search, "CadastralParcel" for Cadastral parcels search. Default is "StreetAddress".
     *      @param {Gp.BBox} [options.filterOptions.bbox] - Bounding box where to perform the search. Expressed in options.srs coordinates system.
     *      @param {Gp.Circle} [options.filterOptions.circle] - Circle where to perform the search. Expressed in options.srs coordinates system.
     * @param {Array.<Gp.Point>} [options.filterOptions.polygon] - Polygon where to perform the search. Expressed in options.srs coordinates system.
     * @param {Number} [options.maximumResponses] - Maximum number of responses. Default underlying service value applies (25) if not provided.
     * @param {Boolean} [options.returnFreeForm = false] - Set this parameter to true if you wish to have an address returned in a single String (unstructured). If unset, default underlying service value (false) applies.
     * @param {String} [options.srs = CRS:84] - Coordinates System used to express coordinates for parameters and responses. Only WGS 84 geographical positioning is supported. Therefore, two values are allowed : "CRS:84" (position.x is the longitude and position.y the latitude) and "EPSG:4326" (position.x is the latitude and position.y the longitude) . Default is CRS:84.
     * @param {Function} options.onSuccess - Callback function for getting successful service response. Takes a {@link Gp.Services.GeocodeResponse} object as a parameter except if "rawResponse" is set to true.
     * @param {Function} [options.onFailure] - Callback function for handling unsuccessful service responses (timeOut, missing rights, ...). Takes a {@link Gp.Error} object as parameter.
     * @param {Number} [options.timeOut=0] - Number of milliseconds above which a timeOut response will be returned with onFailure callback (see above). Default value is 0 which means timeOut will not be handled.
     * @param {String} [options.serverUrl=http (s)://wxs.ign.fr/APIKEY/geoportail/ols] - Web service URL. If used, options.apiKey parameter is ignored. Only use if you know what you're doing.
     * @param {String} [options.protocol=XHR] - Protocol used to handle dialog with web service. Possible values are 'JSONP' ({@link https://en.wikipedia.org/wiki/JSONP}) and 'XHR' ({@link https://en.wikipedia.org/wiki/XMLHttpRequest}). Only XHR protocol is supported in a NodeJS environment. Only use if you know what you're doing.
     * @param {String} [options.proxyURL] - Proxy URL to use when requesting underlying web service. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you're doing.
     * @param {String} [options.callbackSuffix] - Callback function name suffix to use in case of a JSONP protocol use (see above), to set your own suffix instead of auto-increment. Ignored when options.protocol is set to 'XHR' value. Only use if you know what you're doing.
     * @param {String} [options.httpMethod=GET] - HTTP method to use when requesting underlying web service in case of a XHR protocol use (see above). Possible values are 'GET' and 'POST'. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {String} [options.contentType="application/xml"] - Content-Type to use when requesting underlying web service in case of a XHR protocol use (see above) and if method HTTP is POST. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {Boolean} [options.rawResponse=false] - Setting this parameter to true implies you want to handle the service response by yourself : it will be returned as an unparsed String in onSuccess callback parameter. Only use if you know what you are doing.
     * @param {Function} [options.onBeforeParse] - Callback function for handling service response before parsing (as an unparsed String). Takes a String as a parameter (the raw service response). Returns a String that will be parsed as the service response. Only use if you know what you are doing.
     */
    reverseGeocode : function (options) {
        var reverseGeocodeService = new __WEBPACK_IMPORTED_MODULE_3__Geocode_ReverseGeocode__["a" /* default */](options);
        reverseGeocodeService.call();
    },
    /**
     * Getting suggestions of probable places names or address based on uncomplete texts, using the [autocompletion service of the Geoportal Platform]{@link https://geoservices.ign.fr/documentation/geoservices/autocompletion.html}
     *
     * @method autoComplete
     * @param {Object} options - Options for function call.
     * @param {String} options.apiKey - Access key to Geoportal platform, obtained [here]{@link http://professionnels.ign.fr/ign/contrats}.
     * @param {String} options.text - Text input to complete.
     * @param {Array.<String>} [options.filterOptions.type = "StreetAddress"] - Suggestion types to provide : address ("StreetAddress") and/or place name ("PositionOfInterest").
     * @param {Array.<String>} [options.filterOptions.territory] - Places where to limit the search of suggestions : "METROPOLE" (Corsica and metropolitan France), "DOMTOM" (French overseas departments and territories), or an INSEE code of a department. No limitation by default. For instance : ['METROPOLE', '31']
     * @param {Number} [options.maximumResponses = 10] - Maximum number of responses.
     * @param {Function} options.onSuccess - Callback function for getting successful service response. Takes a {@link Gp.Services.AutoCompleteResponse} object as a parameter except if "rawResponse" is set to true.
     * @param {Function} [options.onFailure] - Callback function for handling unsuccessful service responses (timeOut, missing rights, ...). Takes a {@link Gp.Error} object as parameter.
     * @param {Number} [options.timeOut=0] - Number of milliseconds above which a timeOut response will be returned with onFailure callback (see above). Default value is 0 which means timeOut will not be handled.
     * @param {String} [options.serverUrl=http (s)://wxs.ign.fr/APIKEY/ols/apis/completion] - Web service URL. If used, options.apiKey parameter is ignored. Only use if you know what you're doing.
     * @param {String} [options.protocol=XHR] - Protocol used to handle dialog with web service. Possible values are 'JSONP' ({@link https://en.wikipedia.org/wiki/JSONP}) and 'XHR' ({@link https://en.wikipedia.org/wiki/XMLHttpRequest}). Only XHR protocol is supported in a NodeJS environment. Only use if you know what you're doing.
     * @param {String} [options.proxyURL] - Proxy URL to use when requesting underlying web service. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you're doing.
     * @param {String} [options.callbackSuffix] - Callback function name suffix to use in case of a JSONP protocol use (see above), to set your own suffix instead of auto-increment. Ignored when options.protocol is set to 'XHR' value. Only use if you know what you're doing.
     * @param {String} [options.httpMethod=GET] - HTTP method to use when requesting underlying web service in case of a XHR protocol use (see above). Possible values are 'GET' and 'POST'. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {String} [options.contentType="application/xml"] - Content-Type to use when requesting underlying web service in case of a XHR protocol use (see above) and if method HTTP is POST. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {Boolean} [options.rawResponse=false] - Setting this parameter to true implies you want to handle the service response by yourself : it will be returned as an unparsed String in onSuccess callback parameter. Only use if you know what you are doing.
     * @param {Function} [options.onBeforeParse] - Callback function for handling service response before parsing (as an unparsed String). Takes a String as a parameter (the raw service response). Returns a String that will be parsed as the service response. Only use if you know what you are doing.
     */
    autoComplete : function (options) {
        var autoCompleteService = new __WEBPACK_IMPORTED_MODULE_4__AutoComplete_AutoComplete__["a" /* default */](options);
        autoCompleteService.call();
    },
    /**
     * Getting a route from one point to another using the [route service of the Geoportal Platform]{@link https://geoservices.ign.fr/documentation/geoservices/itineraires.html}.
     *
     * @method route
     * @param {Object} options - Options for function call.
     * @param {String} options.apiKey - Access key to Geoportal platform, obtained [here]{@link http://professionnels.ign.fr/ign/contrats}.
     * @param {String} [options.routePreference = "fastest"] - Indicates the way to compute the route : "fastest" (time optimisation) or "shortest" (distance optimisation).
     * @param {Gp.Point} options.startPoint - Start point of the route. Expressed in CRS:84 coordinates system (startPoint.x corresponds to longitude, startPoint.y corresponds to latitude).
     * @param {Gp.Point} options.endPoint - End point of the route. Expressed in CRS:84 coordinates system (endPoint.x corresponds to longitude, endPoint.y corresponds to latitude).
     * @param {Array.<Gp.Point>} [options.viaPoints] - Ordered via Points of the route. Expressed in CRS:84 coordinates system (viaPoints[i].x corresponds to longitude, viaPoints[i].y corresponds to latitude).
     * @param {String} [options.graph = "Voiture"] - User profile to use to compute the route : "Voiture" (using a vehicule) or "Pieton" (pedestrian). Has an influence on the kind of roads the route may use and the average speed.
     * @param {Array.<String>} [options.exclusions] - Indicates if route has to avoid some features ("toll", "bridge" or "tunnel").
     * @param {Boolean} [options.geometryInInstructions = false] - Indicates if route geometry has to be also returned with route instructions.
     * @param {Boolean} [options.provideBoundingBox = true] - Indicates if route instructions has to be localised with a BBOX in the response.
     * @param {String} [options.distanceUnit = "km"] - The unit used to provide distances in the response ("m" or "km").
     * @param {Function} options.onSuccess - Callback function for getting successful service response. Takes a {@link Gp.Services.RouteResponse} object as a parameter except if "rawResponse" is set to true.
     * @param {Function} [options.onFailure] - Callback function for handling unsuccessful service responses (timeOut, missing rights, ...). Takes a {@link Gp.Error} object as parameter.
     * @param {Number} [options.timeOut=0] - Number of milliseconds above which a timeOut response will be returned with onFailure callback (see above). Default value is 0 which means timeOut will not be handled.
     * @param {String} [options.outputFormat='json'] - Output format ("json" or "xml") to use for underlying webService. Only use if you know what you are doing.
     * @param {String} [options.serverUrl=http (s)://wxs.ign.fr/APIKEY/itineraire/rest/route.json] - Web service URL. If used, options.apiKey parameter is ignored. Only use if you know what you're doing.
     * @param {String} [options.protocol=XHR] - Protocol used to handle dialog with web service. Possible values are 'JSONP' ({@link https://en.wikipedia.org/wiki/JSONP}) and 'XHR' ({@link https://en.wikipedia.org/wiki/XMLHttpRequest}). Only XHR protocol is supported in a NodeJS environment. Only use if you know what you're doing.
     * @param {String} [options.proxyURL] - Proxy URL to use when requesting underlying web service. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you're doing.
     * @param {String} [options.callbackSuffix] - Callback function name suffix to use in case of a JSONP protocol use (see above), to set your own suffix instead of auto-increment. Ignored when options.protocol is set to 'XHR' value. Only use if you know what you're doing.
     * @param {String} [options.httpMethod=GET] - HTTP method to use when requesting underlying web service in case of a XHR protocol use (see above). Possible values are 'GET' and 'POST'. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {String} [options.contentType="application/xml"] - Content-Type to use when requesting underlying web service in case of a XHR protocol use (see above) and if method HTTP is POST. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {Boolean} [options.rawResponse=false] - Setting this parameter to true implies you want to handle the service response by yourself : it will be returned as an unparsed String in onSuccess callback parameter. Only use if you know what you are doing.
     * @param {Function} [options.onBeforeParse] - Callback function for handling service response before parsing (as an unparsed String). Takes a String as a parameter (the raw service response). Returns a String that will be parsed as the service response. Only use if you know what you are doing.
     */
    route : function (options) {
        var routeService = new __WEBPACK_IMPORTED_MODULE_5__Route_Route__["a" /* default */](options);
        routeService.call();
    },
    /**
     * Computing a set of places (curve) reachable from a given point (or from where to start to reach a given point) within a time or distance constraint using the [isochrone service of the Geoportal Platform]{@link https://geoservices.ign.fr/documentation/geoservices/isochrones.html}.
     *
     * @method isoCurve
     * @param {Object} options - Options for function call.
     * @param {String} options.apiKey - Access key to Geoportal platform, obtained [here]{@link http://professionnels.ign.fr/ign/contrats}.
     * @param {Gp.Point} options.position - Start or Arrival (options.reverse===true) Point for the computing. Expressed in CRS:84 coordinates system (position.x corresponds to longitude, position.y corresponds to latitude).
     * @param {String} [options.graph = "Voiture"] - User profile to use to compute the isoCurve : "Voiture" (using a vehicule) or "Pieton" (pedestrian). Has an influence on the kind of roads to use and the average speed.
     * @param {Array.<String>} [options.exclusions] - Indicates if route has to avoid some features ("toll", "bridge" or "tunnel").
     * @param {String} [options.method = "time"] - Computing method to use : "time" (using a duration as a constraint) or "distance" (using a distance as a constraint).
     * @param {Float} options.time - Maximum duration (expressed in seconds) to use when options.method is set to "time".
     * @param {Float} options.distance - Maximum distance (expressed in meters) to use when options.method is set to "distance".
     * @param {Boolean} [options.reverse = false] - Set this parameter to true if you want options.position to be the destination (instead of departure) for the computing.
     * @param {Boolean} [options.smoothing = false] - Set this parameter to true if you want the resulting geometry to be smoothed.
     * @param {Boolean} [options.holes = false] - Set this parameter to true if you want the resulting geometry (polygon) to have holes if pertinent.
     * @param {Function} options.onSuccess - Callback function for getting successful service response. Takes a {@link Gp.Services.IsoCurveResponse} object as a parameter except if "rawResponse" is set to true.
     * @param {Function} [options.onFailure] - Callback function for handling unsuccessful service responses (timeOut, missing rights, ...). Takes a {@link Gp.Error} object as parameter.
     * @param {Number} [options.timeOut=0] - Number of milliseconds above which a timeOut response will be returned with onFailure callback (see above). Default value is 0 which means timeOut will not be handled.
     * @param {String} [options.outputFormat='json'] - Output format ("json" or "xml") to use for underlying webService. Only use if you know what you are doing.
     * @param {String} [options.serverUrl=http (s)://wxs.ign.fr/APIKEY/isochrone/isochrone.json] - Web service URL. If used, options.apiKey parameter is ignored. Only use if you know what you're doing.
     * @param {String} [options.protocol=XHR] - Protocol used to handle dialog with web service. Possible values are 'JSONP' ({@link https://en.wikipedia.org/wiki/JSONP}) and 'XHR' ({@link https://en.wikipedia.org/wiki/XMLHttpRequest}). Only XHR protocol is supported in a NodeJS environment. Only use if you know what you're doing.
     * @param {String} [options.proxyURL] - Proxy URL to use when requesting underlying web service. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you're doing.
     * @param {String} [options.callbackSuffix] - Callback function name suffix to use in case of a JSONP protocol use (see above), to set your own suffix instead of auto-increment. Ignored when options.protocol is set to 'XHR' value. Only use if you know what you're doing.
     * @param {String} [options.httpMethod=GET] - HTTP method to use when requesting underlying web service in case of a XHR protocol use (see above). Possible values are 'GET' and 'POST'. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {String} [options.contentType="application/xml"] - Content-Type to use when requesting underlying web service in case of a XHR protocol use (see above) and if method HTTP is POST. Ignored when options.protocol is set to 'JSONP' value. Only use if you know what you are doing.
     * @param {Boolean} [options.rawResponse=false] - Setting this parameter to true implies you want to handle the service response by yourself : it will be returned as an unparsed String in onSuccess callback parameter. Only use if you know what you are doing.
     * @param {Function} [options.onBeforeParse] - Callback function for handling service response before parsing (as an unparsed String). Takes a String as a parameter (the raw service response). Returns a String that will be parsed as the service response. Only use if you know what you are doing.
     */
    isoCurve : function (options) {
        var processIsoCurveService = new __WEBPACK_IMPORTED_MODULE_6__ProcessIsoCurve_ProcessIsoCurve__["a" /* default */](options);
        processIsoCurveService.call();
    }
};

/**
 * Point object.
 *
 * @namespace
 * @alias Gp.Point
 *
 * @property {Float} x - Point abscissa
 * @property {Float} y - Point ordinate
 */
var point = {};

/**
 * Circle object.
 *
 * @namespace
 * @alias Gp.Circle
 *
 * @property {Float} x - Circle center abscissa.
 * @property {Float} y - Circle center ordinate.
 * @property {Float} radius - Circle radius.
 */
var circle = {};

/**
 * Bounding box object, expressed with four coordinates.
 *
 * @namespace
 * @alias Gp.BBox
 *
 * @property {Float} left - minimum abscissa
 * @property {Float} right - maximum abscissa
 * @property {Float} bottom - minimum ordinate
 * @property {Float} top - maximum ordinate
 */
var bbox = {};

/* harmony default export */ __webpack_exports__["a"] = (Services);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonService__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultUrlService__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Request_AltiRequestFactory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Response_AltiResponseFactory__ = __webpack_require__(58);









/**
 * @classdesc
 *
 * Appel du service d'altimétrie du Géoportail
 *
 * @todo gestion du parma. output et callback
 * @todo outputFormat (REST) et format (WPS)
 * @todo La reponse JSON peut encapsuler un XML !
 *
 * @constructor
 * @extends {Gp.Services.CommonService}
 * @alias Gp.Services.Alti
 * @param {Object} options - options spécifiques au service (+ les options heritées)
 *
 * @param {Array.<Object>} options.positions - Tableau ({lon:float,lat:float}) contenant les coordonnées des points (CRS:84)
 *      dont on veut connaître les altitudes (ou à partir desquelles on va calculer le profil).
 *      Chaque élément du tableau est un objet JavaScript avec deux attributs : lon et lat, qui sont des flottants.
 *      Minimum 2 éléments si on souhaite calculer un profil altimétrique (ElevationLine).
 *      Maximum 50 éléments.
 *
 * @param {String} options.outputFormat - Le format de la réponse du service alti : 'xml' ou 'json'.
 *      Ce paramètre déterminera l'extension '.xml' ou '.json' du service dans le cas de l'API REST,
 *      ou la valeur du paramètre 'format' dans le cas de la norme WPS.
 *      Nécessaire si serverUrl est renseigné, et qu'on souhaite passer par l'API REST,
 *      pour connaître le format dans lequel sera fournie la réponse (pour son traitement).
 *      Non nécessaire pour la norme WPS. Par défaut, ce paramètre vaut 'json'.
 *
 * @param {Number} [options.sampling] - Nombre de points à utiliser pour déterminer le tracé d'un profil altimétrique, compris entre 2 et 5000.
 *      A spécifier lorsqu'on souhaite accéder à cette fonctionnalité.
 *      Dans ce cas, les points fournis en entrée (au minimum de deux) servent à déterminer l'axe planimétrique
 *      le long duquel le profil doit être calculé.
 *      Si le paramètre sampling n'est pas spécifié ou moins de deux points sont fournis,
 *      c'est le service Elevation qui sera interrogé (altitudes simples calculées pour les points fournis).
 *      Une valeur de sampling strictement inférieure à 2 déclenchera un échantillonnage avec la valeur par défaut du service (3 points).
 *
 * @param {String} [options.api] - Manière d'accéder au service : 'REST' (via l'API REST) ou 'WPS' (via la norme WPS).
 *      Par défaut, on utilise l'API REST.
 *
 * @param {Boolean} [options.zonly] - Permet de ne récupérer que les altitudes en sortie s'il vaut 'true'.
 *      Vaut 'false' par défaut.
 *
 * @example
 *   var options = {
 *      apiKey : null,
 *      serverUrl : 'http://localhost/service/',
 *      protocol : 'JSONP', // JSONP|XHR
 *      proxyURL : null,
 *      httpMethod : 'GET', // GET|POST
 *      timeOut : 10000, // ms
 *      rawResponse : false, // true|false
 *      scope : null, // this
 *      onSuccess : function (response) {},
 *      onFailure : function (error) {},
 *      // spécifique au service
 *      positions : [{lon:, lat:}, {lon:, lat:}],
 *      outputFormat : 'json' // json|xml
 *      sampling : 3,
 *      api : 'REST', // REST|WPS
 *      zonly : false // false|true
 *   };
 *
 * @private
 */
function Alti (options) {
    if (!(this instanceof Alti)) {
        throw new TypeError(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("CLASS_CONSTRUCTOR", "Alti"));
    }

    /**
     * Nom de la classe (heritage)
     * FIXME instance ou classe ?
     */
    this.CLASSNAME = "Alti";

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_3__CommonService__["a" /* default */].apply(this, arguments);

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("Gp.Services.Alti");
    // this.// logger.trace("[Constructeur Alti (options)]");

    // #####################
    // analyse des options
    // #####################

    if (!options.positions) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "positions"));
    }

    if (options.positions.length === 0) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_EMPTY", "positions"));
    }

    // ajout des options spécifiques au service
    this.options.positions = options.positions;

    // format de réponse du service : "json" ou "xml" (valeur par défaut), en minuscule !
    this.options.outputFormat = (typeof options.outputFormat === "string") ? options.outputFormat.toLowerCase() : "xml";

    // sampling
    this.options.sampling = options.sampling || null;

    // type d'api utilisé pour requeter le service, en majuscule !
    this.options.api = (typeof options.api === "string") ? options.api.toUpperCase() : "REST";

    // l'api ne peut être interrogée qu'en GET.
    if (this.options.api === "REST") {
        this.options.httpMethod = "GET";
    }

    // param. zonly
    this.options.zonly = options.zonly || false;

    // gestion de l'url du service par defaut
    // si l'url n'est pas renseignée, il faut utiliser les urls par defaut
    // en fonction du type d'api, REST ou WPS, du format de reponse demandé (outputFormat)
    // ainsi que sur le type de service (profil ou elevation)
    if (!this.options.serverUrl) {
        var lstUrlByDefault = __WEBPACK_IMPORTED_MODULE_4__DefaultUrlService__["a" /* default */].Alti.url(this.options.apiKey);
        var urlFound = null;
        switch (this.options.api) {
            case "WPS":
                urlFound = lstUrlByDefault.wps;
                break;
            case "REST":
                var key = (options.sampling ? "profil" : "elevation") + "-" + this.options.outputFormat;
                urlFound = lstUrlByDefault[key];
                break;
            default:
                throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_UNKNOWN", "api"));
        }

        if (!urlFound) {
            throw new Error("Url by default not found !");
        }
        this.options.serverUrl = urlFound;
        // this.// logger.trace("Server URL by default : " + this.options.serverUrl);
    }

    // gestion du type de service
    // si l'extension de l'url est .json ou .xml, on surcharge le format de sortie (outputFormat)
    var idx = this.options.serverUrl.lastIndexOf(".");
    if (idx !== -1) {
        var extension = this.options.serverUrl.substring(idx + 1);
        if (extension && extension.length < 5) { // FIXME extension de moins de 4 car. ...
            // this.// logger.trace("Server Extension URL : " + extension);
            switch (extension.toLowerCase()) {
                case "json":
                case "xml":
                    this.options.outputFormat = extension.toLowerCase();
                    break;
                default:
                    throw new Error("type of service : unknown or unsupported (json or xml) !");
            }
        }
    }
}

/**
 * @lends module:Alti#
 */
Alti.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_3__CommonService__["a" /* default */].prototype, {
    // todo
    // getter/setter
});

/**
 * Constructeur (alias)
 */
Alti.prototype.constructor = Alti;

/**
 * Création de la requête (overwrite)
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback
 */
Alti.prototype.buildRequest = function (error, success) {
    // utilisation en mode callback
    var options = {
        httpMethod : this.options.httpMethod,
        // callback
        onSuccess : function (result) {
            // sauvegarde de la requete !
            this.request = result;
            success.call(this, this.request);
        },
        onError : error,
        scope : this,
        // spécifique au service :
        positions : this.options.positions,
        outputFormat : this.options.outputFormat,
        sampling : this.options.sampling,
        api : this.options.api,
        zonly : this.options.zonly
    };

    __WEBPACK_IMPORTED_MODULE_5__Request_AltiRequestFactory__["a" /* default */].build(options);
};

/**
 * Analyse de la reponse (overwrite)
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback
 */
Alti.prototype.analyzeResponse = function (error, success) {
    // INFO
    // Factory pour masquer la complexité du retour du service qui renvoie soit
    //  - une 'string' qui contient du XML ou JSON natif en mode XHR
    //  - un objet JSON qui est natif ou encapsulé

    if (this.response) {
        var options = {
            response : this.response,
            outputFormat : this.options.outputFormat, // utile pour parser la string en mode XHR : JSON ou XML !
            rawResponse : this.options.rawResponse,
            onError : error,
            onSuccess : success,
            scope : this
        };

        __WEBPACK_IMPORTED_MODULE_6__Response_AltiResponseFactory__["a" /* default */].build(options);
    } else {
        error.call(this, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Alti);


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(this, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      var storageKey = "loglevel";
      if (name) {
        storageKey += ":" + name;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    return defaultLogger;
}));


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_Helper__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__XHR__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JSONP__ = __webpack_require__(53);
/**
 * Protocols : Interface de dialogue avec les webservices
 *
 * @module Protocols
 * @private
 * @alias Gp.Protocols.Protocols
 */




var Protocol = {

    /**
     * Interface unique d"envoi d"une requête.
     *
     * @method send
     * @static
     * @param {Object} options - options generales
     * @param {String} options.url      - url du service
     * @param {String} options.method   - GET, POST, PUT, DELETE
     * @param {String} options.protocol - XHR | JSONP
     * @param {String} options.format   - format de la reponse du service : json, xml ou null (brute)...
     * @param {String} options.wrap     - encapsuler la reponse du service dans du JSON : true|false (true par defaut sur le protocole JSONP)
     * @param {String} options.callbackSuffix - suffixe de la fonction de callback (JSONP uniquement) (ex: si callbackSuffix="", la fonction s'appellera "callback")
     * @param {String} options.timeOut  - 0 ms
     * @param {Boolean} options.nocache  - true|false
     * @param {Object|String} options.data        - content (post) ou param (get)
     * @param {Object|String} options.headers     - (post) ex. referer
     * @param {Object|String} options.content - (post) ex. "application/json"
     * @param {String} options.scope       - this (TODO)
     * @param {Function} options.onResponse - callback
     * @param {Function} options.onFailure - callback
     * @param {Function} options.onTimeOut - callback
     * @param {String} options.proxyUrl -  (TODO)
     */
    send : function (options) {
        // INFO
        // "output" - param est interne à la classe "Protocol" (parametrable via "wrap"), et à ajouter à l"url
        //      ce param est independant du service car il est géré par le filtre LUA :
        //          ex. json|xml (json par defaut).
        //          Ce param. permet d"encapsuler du XML dans du JSON :
        //              {http : {status:200, error:null},xml :"réponse du service"}
        //          Utile pour les services qui ne repondent que du XML (ex. Geocodage)
        //
        // |-------------------------------------------------|
        // |      \service |      |     |                    |
        // | output\ format| json | xml |     remarques      |
        // |--------\------|------|-----|--------------------|
        // |    json       | json | json| json/xml encapsulé |
        // |    xml        | json | xml | param inactif      |
        // |-------------------------------------------------|
        // ex. le service demande une reponse native au "format" json et avec un "output" json.
        // on a donc une reponse json encapsulé dans un json : ce qu'on ne souhaite pas !
        // dans ce cas on ne renseigne pas output=json

        // INFO
        // "wrap" - choix d"encapsuler ou non les reponses dans du JSON.
        //      Par defaut, on encapsule uniquement les reponses sur le protocole JSONP (et qui sont en xml) !

        // INFO
        // "callback" - param est interne à la classe "Protocol" (non parametrable), et à ajouter à l"url
        //      ce param est independant du service car il est géré aussi par le filtre LUA :
        //          ex. callback|null
        //          Ce param. permet de renvoyer une reponse javascript :
        //              callback ({http : {status:200, error:null},xml :"réponse du service"})
        //          Ce param. est non renseigné par defaut car pour du JSONP, on utilise le
        //          le protocol JSONP, et ce dernier implemente déjà le callback !

        // settings par defaut
        var settings = options || {
            method : "GET",
            // protocol : "JSONP",
            protocol : "XHR",
            timeOut : 0,
            format : null,
            wrap : true,
            nocache : true,
            output : "json",
            callback : null,
            callbackSuffix : null
        };

        // on determine l'environnement d'execution : browser ou non ?
        // et on stoppe pour nodeJS... sur un protocole JSONP !
        if (typeof window === "undefined" && options.protocol === "JSONP") {
            // console.log("Value (s) for parameter (s) 'protocol=JSONP (instead use XHR)' not supported to NodeJS");
            return;
        }

        if (options.protocol === "XHR" || options.format === "json") {
            settings.wrap = false;
        } else if (options.protocol === "JSONP" && options.format === "xml") {
            settings.wrap = true;
        }

        settings.callback = (options.protocol === "JSONP") ? null : null; // FIXME non géré !?
        settings.output = settings.wrap ? "json" : null;

        // on encapsule les reponses dans un objet JSON
        if (settings.wrap) {
            var params = {};
            params.output = settings.output;
            params.callback = settings.callback;
            delete params.callback; // FIXME non géré !?
            settings.url = __WEBPACK_IMPORTED_MODULE_0__Utils_Helper__["a" /* default */].normalyzeUrl(options.url, params);
        }

        // choix de l"implementation :
        // XHR ou JSONP
        switch (settings.protocol) {
            case "XHR":
                // on normalise l'url (gestion du cache)
                if (options.method === "GET" && options.nocache) {
                    settings.url = __WEBPACK_IMPORTED_MODULE_0__Utils_Helper__["a" /* default */].normalyzeUrl(settings.url, {
                        t : new Date().getTime()
                    });
                }
                // appel du service en XHR
                __WEBPACK_IMPORTED_MODULE_1__XHR__["a" /* default */].call(settings);
                break;
            case "JSONP":

                // on normalise l'url si les params. sont renseignés dans la string|object "data"
                if (settings.data) {
                    settings.url = __WEBPACK_IMPORTED_MODULE_0__Utils_Helper__["a" /* default */].normalyzeUrl(settings.url, settings.data);
                }

                // appel du service en JSONP
                __WEBPACK_IMPORTED_MODULE_2__JSONP__["a" /* default */].call(settings);
                break;
            default:
                throw new Error("protocol not supported (XHR|JSONP) !");
        }
    }

};

/* harmony default export */ __webpack_exports__["a"] = (Protocol);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4+314e4831
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var TRY_CATCH_ERROR = { error: null };

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    TRY_CATCH_ERROR.error = error;
    return TRY_CATCH_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === TRY_CATCH_ERROR) {
      reject(promise, TRY_CATCH_ERROR.error);
      TRY_CATCH_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), __webpack_require__(51)))

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 51 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_52__;

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/**
 * JSONP : Implémentation du protocole JSONP de la plateforme Géoportail (cf. {@link https://github.com/sobstel/jsonp.js}).
 *
 * @module JSONP
 * @private
 * @alias Gp.Protocols.JSONP
 */


var JSONP = {

    /**
     * Construction d'un identifiant statique basé sur le timestamp,
     * et qui s'incremente de +1 à chaque appel
     */
    uuid : (function () {
        var id = Math.floor(Date.now());
        return function () {
            return id++;
        };
    })(),

    /**
     * Cette fonction réalise l'appel du service fourni via le paramètre "options.url"
     * en mettant en œuvre le protocole JSONP.
     *
     * @method call
     * @static
     * @param {Object} options - parametres d'invocation du service en JSONP
     * @param {String} options.url - URL du service à invoquer (indépendamment du protocole JSONP).
     *  Cette URL contient déjà les paramètres du service.
     *  Si le paramètre dédié à la mise en oeuvre du protocole JSONP (callback=xxx) n'est pas présent, il est rajouté par la fonction ;
     *  sa valeur est déterminée en fonction du paramètre callbackName.
     * @param {Number} [options.timeOut = 0] - Nombre de ms au bout duquel on considère que le service n'a pas répondu.
     *  Une valeur de 0 pour ce paramètre permet de désactiver la gestion du timeOut.
     * @param {String} [options.callbackSuffix = null] - Suffixe de la fonction de callback à rajouter sur l'URL.
     *  Si aucun suffixe n'est spécifié (cas par défaut), on utilisera l'identifiant this.uuid () comme suffixe. Ex: "callback1458574396582 ()"
     * @param {String} [options.callbackName = gp.protocol.jsonp] - Valeur du paramètre callback à rajouter sur l'URL.
     *  Si l'URL fournie contient déjà le paramètre callback, le paramètre callbackName ne sera pas pris en compte.
     *  La fonction de callback est créée dynamiquement par la fonction JSONP ;
     *  elle a deux fonctions :
     *    elle annule la condition de timeOut
     *    puis appelle la fonction fournie par l'utilisateur via le paramètre onResponse.
     * @param {Function} options.onResponse - Nom de la fonction qui sera appelée lors de la réception des résultats du service.
     *  Ce paramètre sera ignoré si l'URL contient déjà le paramètre callback.
     *  La fonction de rappel appelée sera alors celle ayant pour nom la valeur de ce paramètre.
     * @param {Function} [options.onTimeOut] - Nom de la fonction qui sera appelée en cas de non réponse du service.
     *  Le temps au bout duquel on considère que le service n'a pas répondu est déterminé par le paramètre timeOut.
     *  @example
     *  var options = {
     *      url : 'http://localhost/some/test.json&callback=myResults',
     *      timeOut : 100,
     *      callbackName : 'myResults',
     *      callbackSuffix : "",
     *      onResponse : function (response) {
     *          // console.log('results : ', response);
     *      },
     *
     *   };
     *   JSONP.call(options);
     */
    call : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("JSONP");
        // logger.trace("[JSONP::call ()]");

        // analyse parametres

        if (!options) {
            logger.error("missing parameter : options !");
            throw new Error("missing parameter : options !");
        }

        if (!options.url) {
            logger.error("missing parameter : options.url !");
            throw new Error("missing parameter : options.url !");
        }

        if (!options.timeOut) {
            // logger.info("setting 'options.timeOut' default value");
            options.timeOut = 0;
        }

        // FIXME si un callback coté client a été mis en place,
        // cette condition sur cette methode n'a pas de sens !?
        if (!options.onResponse) {
            logger.error("missing parameter : options.onResponse !");
            throw new Error("missing parameter : options.onResponse !");
            // FIXME doit on definir un callback interne par defaut !?
            // options.onResponse = function (data) {
            //    // console.log("response callback (inner) : ", data);
            // };
        }

        // ID du callback à utiliser : null ou string.
        // si l'utilisateur a spécifié un suffixe pour le callback, on le récupère comme un ID (ex: options.callbackSuffix = "")
        // sinon, on utilise un timestamp : this.uuid ()
        var callbackId = (typeof options.callbackSuffix === "string") ? options.callbackSuffix : this.uuid();

        // on recherche le parametre callback et son nom de fonction dans l'url
        var urlHasCallbackKey = false;
        var urlHasCallbackName = false;

        var idx = options.url.indexOf("callback=");

        if (idx !== -1) {
            urlHasCallbackKey = true;
            // extraction callbackName de l'url : entre "callback=" et "&" ou fin de ligne
            var j = options.url.indexOf("&", idx);
            if (j === -1) {
                j = options.url.length;
            }

            // on ecrase le parametre options.callbackName s'il avait été défini
            var callbackName = options.url.substring(idx + 9, j);

            if (callbackName) {
                urlHasCallbackName = true;
                options.callbackName = callbackName;
                // logger.info("setting 'options.callbackName' value (" + options.callbackName + ") from 'options.url' parameter");
            }
        }

        // on ajoute le parametre callback dans l'URL s'il n'existe pas
        if (!urlHasCallbackKey) {
            // gestion des autres param. et "?"
            var k = options.url.indexOf("?");
            if (k === -1) {
                // aucun param., ni de '?'
                options.url = options.url + "?" + "callback=";
            } else if (k === options.url.length) {
                // uniquement le '?'
                options.url = options.url + "callback=";
            } else {
                // le '?' et les param. existent
                options.url = options.url + "&" + "callback=";
            }
            // logger.info("setting callback default key in 'options.url' : " + options.url);
        }

        // utilisation de la fonction callback coté client ?
        var HasCallbackName = options.callbackName ? true : urlHasCallbackName;

        // on ajoute le nom de la fonction callback dans l'URL si elle n'existe pas
        if (!urlHasCallbackName) {
            // fonction callback par defaut
            if (!options.callbackName) {
                // logger.info("setting 'options.callbackName' default value");
                options.callbackName = "callback"; // ou "gp.protocol.jsonp" ?
                // info : si on ne veut pas gerer d'ID dans le callback,
                // options.callbackSuffix = ""
                if (callbackId || callbackId === "") {
                    options.callbackName += callbackId;
                }
            }
            options.url = options.url.replace("callback=", "callback=" + options.callbackName);
            // logger.info("setting callback function name in 'options.url' : " + options.url);
        }

        // timeOut par defaut
        if (!options.onTimeOut) {
            // logger.info("setting 'options.onTimeOut' default value");
            /** callback timeout par defaut */
            options.onTimeOut = function (/* error */) {
                // console.log("TimeOut while invoking url : " + options.url);
            };
        }

        if (!HasCallbackName) {
            var self = this;

            // event du timeout
            var onTimeOutTrigger = null;

            // declenche le timeout si > à 0 !
            if (options.timeOut > 0) {
                onTimeOutTrigger = window.setTimeout(
                    function () {
                        /** fonction de reponse du service */
                        window[options.callbackName] = function () {};
                        options.onTimeOut();
                        self._deleteScript(callbackId);
                    }, options.timeOut);
            }

            // FIXME le nom de la fonction n'accepte pas de namespace !
            // ex. Gp.Function.callback
            /**
            * fonction de reponse du service
            * @param {Object} data - data
            * @private
            */
            window[options.callbackName] = function (data) {
                window.clearTimeout(onTimeOutTrigger);
                options.onResponse(data);
                self._deleteScript(callbackId);
            };
        }

        this._createScript(callbackId, options.url);
    },

    /**
    * create Script
    * @param {String} callbackId - callback Id
    * @param {String} url - url
    * @private
    */
    _createScript : function (callbackId, url) {
        var scriptu;
        var scripto = document.getElementById("results" + callbackId);

        scriptu = document.createElement("script");
        scriptu.setAttribute("type", "text/javascript");
        scriptu.setAttribute("src", url);
        scriptu.setAttribute("charset", "UTF-8");
        scriptu.setAttribute("id", "results" + callbackId);
        scriptu.setAttribute("async", "true"); // FIXME async ?
        // head ou body ou autres ?
        var node = document.documentElement || document.getElementsByTagName("head")[0];
        if (scripto === null) {
            node.appendChild(scriptu);
        } else {
            // s'il existe déjà, on le remplace !
            node.replaceChild(scriptu, scripto);
        }
    },

    /**
    * delete Script
    * @param {String} callbackId - callback Id
    * @private
    */
    _deleteScript : function (callbackId) {
        var script = document.getElementById("results" + callbackId);
        if (script) {
            var node = script.parentNode || document.documentElement;
            if (!node) {
                return;
            }
            node.removeChild(script);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (JSONP);


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AltiRequestREST__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AltiRequestWPS__ = __webpack_require__(56);
/**
 * Creation d'une requête en REST ou WPS
 * (Factory)
 *
 * @module AltiRequestFactory
 * @alias Gp.Services.Alti.Request.AltiRequestFactory
 * @private
 */





var AltiRequestFactory = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant Alti
     *
     * @example
     *   var options = {
     *      httpMethod : 'GET', // GET|POST
     *      onSuccess : function (response) {},
     *      onError : function (error) {},
     *      scope : this,
     *      positions : [{lon:, lat:}, {lon:, lat:}],
     *      outputFormat : 'json' // json|xml
     *      sampling : 3,
     *      api : 'REST', // REST|WPS
     *      zonly : false // false|true
     *   };
     *
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("AltiRequestFactory");
        // logger.trace(["AltiRequestFactory::build()"]);

        var request = null;

        // on factorise les options par groupe;
        // - global,
        // - param, les params pour les data inputs
        // - wps, les param du service
        // - callback

        var settings = {
            // ajout des valeurs par defaut spécifiques au service
            type : options.sampling ? "Profil" : "Elevation",
            method : options.httpMethod,
            param : {
                positions : null,
                delimiter : null, // FIXME par defaut, on ne le met pas en place car ça fait planter la requête !?
                indent : null, // par defaut
                crs : null, // par defaut
                format : null, // (only to POST)
                sampling : null, // (only use by Profil)
                zonly : null // (only use by Elevation)
            }
        };

        // surcharge des valeurs obligatoires
        settings.param.positions = options.positions;
        settings.param.format = options.outputFormat;
        settings.param.sampling = options.sampling;
        settings.param.zonly = options.zonly;

        // gestion des callback
        var bOnError = !!((options.onError !== null && typeof options.onError === "function"));
        var bOnSuccess = !!((options.onSuccess !== null && typeof options.onSuccess === "function"));

        var message = null;
        switch (options.api) {
            case "REST":
                // FIXME les exceptions ne sont pas 'catchées' sur le constructeur !
                var myReq = new __WEBPACK_IMPORTED_MODULE_2__AltiRequestREST__["a" /* default */](settings);
                if (!myReq.processRequestString()) {
                    message = "Error in process request (rest) !";
                    if (bOnError) {
                        options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */](message));
                        return;
                    }
                    throw new Error(message);
                }
                request = myReq.requestString;
                break;
            case "WPS":
                // ajout des valeurs par defaut spécifiques au service WPS
                settings.wps = {
                    service : null, // par defaut
                    version : null, // par defaut
                    identifier : null, // par defaut
                    rawdataoutput : null, // par defaut
                    request : null // par defaut
                };

                request = __WEBPACK_IMPORTED_MODULE_3__AltiRequestWPS__["a" /* default */].build(settings);
                if (!request) {
                    message = "Error in process request (wps) !";
                    if (bOnError) {
                        options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */](message));
                        return;
                    }
                    throw new Error(message);
                }
                break;
            default:
                message = "Type of API is not supported by service (REST or WPS) !";
                if (bOnError) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */](message));
                    return;
                }
                throw new Error(message);
        }

        if (bOnSuccess) {
            options.onSuccess.call(options.scope, request);
        }

        return request;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AltiRequestFactory);


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_AltiElevationRequest__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_AltiProfilRequest__ = __webpack_require__(23);
/* jshint multistr : true */






/**
 * @classdesc
 * Classe de gestion des requêtes de type REST sur le service altimetrique.
 *
 * @todo Le service Alti n'implemente pas le POST !?
 * @constructor
 * @alias Gp.Services.Alti.Request.AltiRequestREST
 * @param {Object} options - options
 * @param {Object}   options.param.positions - tableau de coordonnées lon/lat
 * @param {String}   options.param.delimiter - '|'
 * @param {Boolean}  options.param.indent - false|true
 * @param {String}   options.param.crs - 'CRS:84'
 * @param {String}   options.param.sampling - 3
 * @param {Boolean}  options.param.zonly - false|true
 * @param {String}   options.param.format - "JSON|XML"
 * @param {String}   options.type - "Profil|Elevation"
 * @param {String}   options.method - GET|POST
 *
 * @example
 *      var options = {
 *           type : 'Profil', // Elevation
 *           method : 'GET',  // par defaut
 *           param : {
 *               positions : [
 *                   {lon:'1.11', lat:'1.11'},
 *                   {lon:'1.10', lat:'1.10'},
 *                   {lon:'1.12', lat:'1.12'}
 *               ],
 *               delimiter : ";",         // par defaut
 *               indent    : true,        // par defaut
 *               crs       : 'EPSG:4326', // par defaut
 *               format    : 'json',      // par defaut (only to POST)
 *               sampling  : 3 ,          // par defaut (only use by Profil)
 *               zonly     : false        // par defaut (only use by Elevation)
 *           }
 *      };
 *
 *      var result;
 *      try {
 *          var obj = new AltiRequestREST (options);
 *          if (! obj.processRequestString ()) {
 *              throw new Error("Request empty !?")
 *          }
 *          result = obj.requestString;
 *      } catch (e) {
 *          // exceptions...
 *      }
 * @private
 */
function AltiRequestREST (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("AltiRequestREST");
    // this.// logger.trace("[Constructeur AltiRequestREST ()]");

    if (!(this instanceof AltiRequestREST)) {
        throw new TypeError("AltiRequestREST constructor cannot be called as a function.");
    }

    this.options = options || {};

    // existance des options
    if (!this.options) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_EMPTY", "options"));
    }

    // type de requete : Altitude ou Profil
    // (param. à determiner en fonction des parametres d'entrée)
    if (!this.options.type) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_EMPTY", "type (Elevation or Profil)"));
    }

    // construction du modele de requête
    // (test du type d'objet candidat)
    this.DataObject = null;
    switch (this.options.type) {
        case "Elevation":
            this.DataObject = new __WEBPACK_IMPORTED_MODULE_2__model_AltiElevationRequest__["a" /* default */](this.options.param);
            break;
        case "Profil":
            this.DataObject = new __WEBPACK_IMPORTED_MODULE_3__model_AltiProfilRequest__["a" /* default */](this.options.param);
            break;
        default:
            throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_TYPE", "type (Elevation or Profil)"));
    }

    /**
     * methode.
     * Par defaut, "GET".
     */
    this.method = this.options.method || "GET";
}

AltiRequestREST.prototype = {

    /**
     * request
     * @type {String}
     */
    requestString : null,

    /**
     * Constructeur (alias)
     */
    constructor : AltiRequestREST,

    /**
     * Template de la requête.
     */
    template : {
        get : {
            // FIXME on retire le param 'delimiter' : &delimiter='__DELIMITER__'
            value : "lon=__LON__&lat=__LAT__&indent=__INDENT__&crs='__CRS__'",
            input : {
                point : "&zonly=__ZONLY__",
                profil : "&sampling=__SAMPLING__"
            }
        },
        post : {
            // FIXME on retire le param 'delimiter' : delimiter='__DELIMITER__'\n\
            value : "lon=__LON__\n" +
                "lat=__LAT__\n" +
                "indent=__INDENT__\n" +
                "crs='__CRS__'\n",
            input : {
                point : "zonly=__ZONLY__",
                profil : "sampling=__SAMPLING__"
            }
        }
    },

    /**
     * Construction de la requête.
     *
     * @example
     * // GET  out : lon=0.2367,2.1570&lat=48.0551,46.6077&delimiter=,&indent=true&zonly=true&crs='CRS:84'
     * // POST out : Not yet supported method POST !
     * @returns {String}
     */
    processRequestString : function () {
        // this.// logger.trace("AltiRequestREST::processRequestString ()");

        var template = "";
        if (this.method === "POST") {
            template = this.template.post.value;
        } else if (this.method === "GET") {
            template = this.template.get.value;
        }

        template = template.replace(/__LON__/g, this.DataObject.getLon());
        template = template.replace(/__LAT__/g, this.DataObject.getLat());
        // FIXME on retire le param 'delimiter'
        // template = template.replace(/__DELIMITER__/g, this.DataObject.delimiter);
        template = template.replace(/__INDENT__/g, this.DataObject.indent);
        template = template.replace(/__CRS__/g, this.DataObject.crs);

        // ajout +
        template = template + this.__addDataInputs();
        // this.// logger.trace("traduction tmpl", template);

        // sauvegarde
        this.requestString = template;

        return this.requestString;
    },

    /**
     * Ajout de parametres spécifiques (ex. zonly)
     *
     * @returns {String}
     */
    __addDataInputs : function () {
        // this.// logger.trace("AltiRequestREST::addDataInput ()");

        var myTemplate;
        if (this.method === "POST") {
            myTemplate = this.template.post;
        } else if (this.method === "GET") {
            myTemplate = this.template.get;
        } else {
            throw new Error("No other HTTP method supported by the service !");
        }

        var tmpl = null;
        if (this.DataObject.CLASSNAME === "AltiElevationRequest") {
            tmpl = myTemplate.input.point;
            return tmpl.replace(/__ZONLY__/g, this.DataObject.zonly);
        } else if (this.DataObject.CLASSNAME === "AltiProfilRequest") {
            tmpl = myTemplate.input.profil;
            return tmpl.replace(/__SAMPLING__/g, this.DataObject.sampling);
        } else {
            throw new Error("No other object supported than elevation or profil !?");
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AltiRequestREST);


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Formats_WPS__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_AltiElevationRequest__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_AltiProfilRequest__ = __webpack_require__(23);
/**
 * Classe d'interface des requêtes de type WPS sur le service altimetrique.
 * (Factory)
 *
 * @module Gp.Services.Alti.Request.AltiRequestWPS
 * @alias Gp.Services.Alti.Request.AltiRequestWPS
 * @private
 */






var AltiRequestWPS = {

    /**
     * Interface unique de construction de la requête.
     *
     * @method build
     * @param {Object} options - options
     * @param {Object}   options.param.positions - tableau de coordonnées lon/lat
     * @param {String}   options.param.delimiter - '|'
     * @param {Boolean}  options.param.indent - false|true
     * @param {String}   options.param.crs - 'CRS:84'
     * @param {String}   options.param.sampling - 3
     * @param {Boolean}  options.param.zonly - false|true
     * @param {String}   options.param.format - "JSON|XML" (only to POST)
     * @param {String}   options.wps.service - "WPS"
     * @param {String}   options.wps.version - "1.0.0"
     * @param {String}   options.wps.identifier - "gs:WPSElevation|gs:WPSLineElevation"
     * @param {String}   options.wps.rawdataoutput - "result"
     * @param {String}   options.wps.request - "Execute"
     * @param {String}   options.type - "Profil|Elevation"
     * @param {String}   options.method - GET|POST
     * @example
     *      var options = {
     *           type : 'Profil', // Elevation
     *           method : 'GET',  // par defaut
     *           param : {
     *               positions : [
     *                   {lon:'1.11', lat:'1.11'},
     *                   {lon:'1.10', lat:'1.10'},
     *                   {lon:'1.12', lat:'1.12'}
     *               ],
     *               delimiter : ";",         // par defaut
     *               indent    : true,        // par defaut
     *               crs       : 'EPSG:4326', // par defaut
     *               format    : 'json',      // par defaut (only to POST)
     *               sampling  : 3 ,          // par defaut (only use by Profil)
     *               zonly     : false,       // par defaut (only use by Elevation)
     *           },
     *           wps : {
     *                 service : 'WPS',         // par defaut
     *                 version : '1.0.0',       // par defaut
     *                 identifier : 'gs:WPS',   // par defaut, Elevation = gs:WPSElevation, Profil = gs:WPSLineElevation
     *                 rawdataoutput : 'result',// par defaut
     *                 request : 'Execute'      // par defaut
     *           }
     *       };
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("AltiRequestWPS");
        // logger.trace(["AltiRequestWPS::build()"]);

        // existance des options
        if (!options) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_EMPTY", "options"));
        }

        // type de requete : Altitude ou Profil
        // (param. à determiner en fonction des parametres d'entrée)
        if (!options.type) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_EMPTY", "type (Elevation or Profil)"));
        }

        // construction du modele de requête
        // (test du type d'objet candidat)
        var DataObject = null;
        switch (options.type) {
            case "Elevation":
                // surcharge
                options.wps.identifier = "gs:WPSElevation";
                DataObject = new __WEBPACK_IMPORTED_MODULE_3__model_AltiElevationRequest__["a" /* default */](options.param);
                break;
            case "Profil":
                // surcharge
                options.wps.identifier = "gs:WPSLineElevation";
                DataObject = new __WEBPACK_IMPORTED_MODULE_4__model_AltiProfilRequest__["a" /* default */](options.param);
                break;
            default:
                throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_TYPE", "type (Elevation or Profil)"));
        }

        // construction de la requête WPS
        var settings = {
            data : DataObject,
            method : options.method,
            param : options.wps
        };

        var rqstWPS = new __WEBPACK_IMPORTED_MODULE_2__Formats_WPS__["a" /* default */](settings);

        if (!rqstWPS.processRequestString()) {
            throw new Error("Enable to process request !");
        }

        return rqstWPS.requestString;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AltiRequestWPS);


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);


/**
 * @classdesc
 * Standard WPS
 *
 * @constructor
 * @alias Gp.Formats.WPS
 * @param {Object} options - options
 * @param {Object}   options.data - objet
 * @param {String}   options.method - POST|GET
 * @param {String}   options.param.service - "WPS"
 * @param {String}   options.param.version - "1.0.0"
 * @param {String}   options.param.identifier - "gs:WPSElevation|gs:WPSLineElevation"
 * @param {String}   options.param.rawdataoutput - "result"
 * @param {String}   options.param.request - "Execute"
 * @param {Function} options.onsuccess - function callback success (TODO)
 * @param {Function} options.onerror   - function callback error   (TODO)
 * @private
 */
function WPS (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur WPS()]");

    if (!(this instanceof WPS)) {
        throw new TypeError("WPS constructor cannot be called as a function.");
    }

    this.options = options || {};

    /**
     * Objet DATA
     */
    this.DataObject = this.options.data;

    if (!this.DataObject) {
        throw new TypeError("This data object is not defined !");
    }

    /**
     * param service.
     * Par defaut, "WPS".
     */
    this.paramservice = this.options.param.service || "WPS";

    /**
     * param version.
     * Par defaut, "1.0.0".
     */
    this.paramversion = this.options.param.version || "1.0.0";

    /**
     * param identifier
     * Par defaut, "gs:WPS"
     */
    this.paramidentifier = this.options.param.identifier || "gs:WPS";

    /**
     * param rawdataoutput
     * Par defaut, "result".
     */
    this.paramrawdataoutput = this.options.param.rawdataoutput || "result";

    /**
     * param request
     * Par defaut, "Execute".
     */
    this.paramrequest = this.options.param.request || "Execute";

    /**
     * methode.
     * Par defaut, "GET".
     */
    this.method = this.options.method || "GET";
}

WPS.prototype = {

    /**
     * @lends module:WPS#
     */

    /**
     * request
     * @type {String}
     */
    requestString : null,

    /**
     * Constructeur (alias)
     */
    constructor : WPS,

    /**
     * Template de la requête.
     */
    template : {
        get : {
            value : "service=__SERVICE__" +
                "&version=__VERSION__" +
                "&rawdataoutput=__RAWDATAOUTPUT__" +
                "&identifier=__IDENTIFIER__" +
                "&request=__REQUEST__" +
                "&datainputs=<!-- __DATAINPUTS__ -->",

            input : "__KEY__=__DATA__"

        },
        post : {

            value : "<?xml version=\"1.0\" encoding=\"UTF-8\"?>" +
                "<wps:__REQUEST__ version=\"__VERSION__\" service=\"__SERVICE__\" " +
                "__NAMESPACE__ __SCHEMALOCATION__>" +
                "<ows:Identifier>__IDENTIFIER__</ows:Identifier>" +
                "<wps:DataInputs>" +
                "<!-- __DATAINPUTS__ -->" +
                "</wps:DataInputs>" +
                "<wps:ResponseForm>" +
                "<wps:RawDataOutput>" +
                "<ows:Identifier>__RAWDATAOUTPUT__</ows:Identifier>" +
                "</wps:RawDataOutput>" +
                "</wps:ResponseForm>" +
                "</wps:__REQUEST__>",

            input : "<wps:Input>" +
                "<ows:Identifier>__KEY__</ows:Identifier>" +
                "<wps:Data>" +
                "<wps:LiteralData>__DATA__</wps:LiteralData>" +
                "</wps:Data>" +
                "</wps:Input>"
        }
    },

    /**
     * Namespace par defaut de la requete POST.
     *
     * @returns {String} namespace
     */
    namespaceByDefault : function () {
        var ns = [
            "xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\"",
            "xmlns=\"http://www.opengis.net/wps/1.0.0\"",
            "xmlns:wfs=\"http://www.opengis.net/wfs\"",
            "xmlns:wps=\"http://www.opengis.net/wps/1.0.0\"",
            "xmlns:ows=\"http://www.opengis.net/ows/1.1\"",
            "xmlns:gml=\"http://www.opengis.net/gml\"",
            "xmlns:ogc=\"http://www.opengis.net/ogc\"",
            "xmlns:wcs=\"http://www.opengis.net/wcs/1.1.1\"",
            "xmlns:xlink=\"http://www.w3.org/1999/xlink\""
        ];

        return ns.join(" ");
    },

    /**
     * Schemalocation par defaut.
     *
     * @returns {String} schemaLocation
     */
    schemaLocationByDefault : function () {
        return "xsi:schemaLocation=\"http://www.opengis.net/wps/1.0.0 http://schemas.opengis.net/wps/1.0.0/wpsAll.xsd\"";
    },

    /**
     * Construction de la requête.
     *
     * @example
     * // GET  out :
     * //  service=__SERVICE__
     * //  &version=__VERSION__
     * //  &rawdataoutput=__RAWDATAOUTPUT__
     * //  &identifier=__IDENTIFIER__
     * //  &request=__REQUEST__
     * //  &datainputs="__DATAINPUTS__"
     * //  avec __DATAINPUTS__ = __KEY__=__DATA__;...
     *
     * // POST out :
     * //      <?xml version=\"1.0\" encoding=\"UTF-8\"?>
     * //      <wps:__REQUEST__ version=\"__VERSION__\" service=\"__SERVICE__\"
     * //         __NAMESPACE__ __SCHEMALOCATION__>
     * //          <ows:Identifier>__IDENTIFIER__</ows:Identifier>
     * //          <wps:DataInputs>
     * //              <!-- __DATAINPUTS__ -->
     * //          </wps:DataInputs>
     * //          <wps:ResponseForm>
     * //              <wps:RawDataOutput>
     * //              <ows:Identifier>__RAWDATAOUTPUT__</ows:Identifier>
     * //              </wps:RawDataOutput>
     * //          </wps:ResponseForm>
     * //      </wps:__REQUEST__>",
     * //      avec __DATAINPUTS__
     * //             <wps:Input>
     * //                  <ows:Identifier>__KEY__</ows:Identifier>
     * //                  <wps:Data>
     * //                    <wps:LiteralData>__DATA__</wps:LiteralData>
     * //                  </wps:Data>
     * //              </wps:Input>
     *
     * @returns {Boolean} validation de la construction de la requete
     */
    processRequestString : function () {
        // this.// logger.trace("WPS::processRequestString ()");

        var template = "";
        if (this.method === "POST") {
            template = this.template.post.value;
        } else if (this.method === "GET") {
            template = this.template.get.value;
        } else {
            this.logger.error("No other method supported by the service !");
            return false;
        }

        template = template.replace(/__SERVICE__/g, this.paramservice);
        template = template.replace(/__VERSION__/g, this.paramversion);
        template = template.replace(/__RAWDATAOUTPUT__/g, this.paramrawdataoutput);
        template = template.replace(/__IDENTIFIER__/g, this.paramidentifier);
        template = template.replace(/__REQUEST__/g, this.paramrequest);

        // ajout +
        if (this.method === "POST") {
            template = template.replace(/__NAMESPACE__/g, this.namespaceByDefault);
            template = template.replace(/__SCHEMALOCATION__/g, this.schemaLocationByDefault);
        }

        // ajout des datainputs
        template = template.replace(/<!-- __DATAINPUTS__ -->/g, this.__addDataInputs());

        if (!template) {
            this.logger.warn("traduction tmpl : empty request !?");
            return false;
        }

        this.requestString = template;
        // this.// logger.trace("traduction tmpl", template);

        return true;
    },

    /**
     * Ajout des données
     *
     * @returns {String} Données concaténées dans une chaine
     */
    __addDataInputs : function () {
        // this.// logger.trace("WPS::__addDataInputs ()");

        // c'est un peu grossier...
        var tmpl = this.method === "GET" ? this.template.get.input : this.template.post.input;
        var sep = this.method === "GET" ? ";" : "";

        var result = "";
        var that = this;
        var map = this.DataObject.getData();
        for (var i = 0; i < map.length; i++) {
            // FIXME closure ?
            (function (j) {
                if (sep) {
                    sep = (j === map.length - 1) ? "" : ";";
                }
                result = result.concat(that.__addDataInput(tmpl, map[j].k, map[j].v), sep);
            })(i);
        }

        return result;
    },

    /**
     * Ajout d'une donnée.
     *
     * @param {String} tmpl - template
     * @param {String} key - clef
     * @param {String} data - valeur
     * @returns {String} chaine avec les substitutions clef/valeur
     */
    __addDataInput : function (tmpl, key, data) {
        var tmp = tmpl;
        tmp = tmp.replace(/__KEY__/g, key);
        tmp = tmp.replace(/__DATA__/g, data);
        return tmp;
    },

    /**
     * Definir le mode de requête
     *
     * @param {String} method - GET|POST
     */
    setMethod : function (method) {
        if (method === "GET" || method === "POST") {
            this.method = method;
        } else {
            this.logger.warn("support only GET and POST method !");
        }
    },

    /**
     * Retourne le mode de requete (GET|POST).
     *
     * @returns {AltiRequest.options.mode|String} methode (GET|POST)
     */
    getMethod : function () {
        return this.method;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (WPS);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formats_XML__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Formats_AltiResponseReader__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_AltiResponse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_Elevation__ = __webpack_require__(10);
/**
 * Factory pour générer une reponse JSON à partir d'un XML ou d'un JSON
 * (Factory)
 *
 * @module AltiResponseFactory
 * @private
 * @alias Gp.Services.Alti.Response.AltiResponseFactory
 */








var AltiResponseFactory = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant Alti
     *
     * @example
     *   var options = {
     *      response :
     *      outputFormat :
     *      rawResponse :
     *      scope :
     *      onSuccess :
     *      onError :
     *   };
     *
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("AltiResponseFactory");
        // logger.trace(["AltiResponseFactory::build()"]);

        var data = null;

        if (options.response) {
            if (options.rawResponse) {
                // logger.trace("analyze response : raw");
                data = options.response;
            } else {
                switch (options.outputFormat) {
                    case "xml":
                        // logger.trace("analyze response : xml");

                        try {
                            var p = new __WEBPACK_IMPORTED_MODULE_3__Formats_XML__["a" /* default */]({
                                reader : __WEBPACK_IMPORTED_MODULE_4__Formats_AltiResponseReader__["a" /* default */]
                            });

                            if (typeof options.response === "string") {
                                p.setXMLString(options.response);
                            } else {
                                p.setXMLDoc(options.response);
                            }

                            data = p.parse();

                            if (!data) {
                                throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION_2"));
                            }
                        } catch (e) {
                            var message = e.message;
                            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                                message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", message),
                                status : 200,
                                type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
                            }));
                            return;
                        }

                        break;

                    case "json":
                        // logger.trace("analyze response : json");
                        // logger.trace("analyze response : ", typeof options.response);

                        var JSONResponse;
                        if (typeof options.response === "string") {
                            JSONResponse = JSON.parse(options.response);
                        } else {
                            JSONResponse = options.response;
                        }

                        // le service renvoie t il une erreur ?
                        if (JSONResponse.error) {
                            // ex. {"error": {"code": "BAD_PARAMETER","description": "The values () cannot be parsed as a valid longitude (double value such as -180 < lat < 180)."}}
                            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                                message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", JSONResponse.error.description),
                                status : 200,
                                type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
                            }));
                            return;
                        }

                        // analyse de la reponse
                        if (JSONResponse) {
                            var elevations = JSONResponse.elevations;
                            var altiResponse = new __WEBPACK_IMPORTED_MODULE_5__model_AltiResponse__["a" /* default */]();
                            var elevation;
                            if (Array.isArray(elevations) && elevations.length) {
                                for (var i = 0; i < elevations.length; i++) {
                                    elevation = new __WEBPACK_IMPORTED_MODULE_6__model_Elevation__["a" /* default */]();

                                    if (typeof elevations[i] === "object") {
                                        // elevations[i] est un objet elevation
                                        if (elevations[i].lon) {
                                            elevation.lon = elevations[i].lon;
                                        }
                                        if (elevations[i].lat) {
                                            elevation.lat = elevations[i].lat;
                                        }
                                        if (elevations[i].z) {
                                            elevation.z = elevations[i].z;
                                        }
                                        if (elevations[i].acc) {
                                            elevation.acc = elevations[i].acc;
                                        }
                                    } else if (typeof elevations[i] === "number") {
                                        // elevations[i] est un nombre, dans le cas de zonly=true notamment
                                        elevation.z = elevations[i];
                                    }

                                    if (Array.isArray(altiResponse.elevations)) {
                                        altiResponse.elevations.push(elevation);
                                    }
                                }
                            }
                            data = altiResponse;
                        }

                        if (!data) {
                            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                                message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_ANALYSE_2"),
                                type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_UNKERR,
                                status : -1
                            }));
                            return;
                        }
                        break;

                    default:
                        options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                            message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_FORMAT_2"),
                            type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_UNKERR,
                            status : -1
                        }));
                        return;
                }

                // Si la réponse contenait une exception renvoyée par le service
                if (data.exceptionReport) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                        message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", data.exceptionReport),
                        type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR,
                        status : 200
                    }));
                    return;
                } else if (data.error) {
                    var errorMess = data.error.description;
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                        message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", errorMess),
                        type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR,
                        status : 200
                    }));
                    return;
                }
            }
        } else {
            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
            return;
        }

        options.onSuccess.call(options.scope, data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AltiResponseFactory);


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Response_model_AltiResponse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Response_model_Elevation__ = __webpack_require__(10);

/**
 * Fonction retournant un objet contenant des clés de lecture (readers)
 *      qui permettent de parser des réponses XML du service Altimétrique du Géoportail
 *      (calcul altimétrique simple ou profil altimétrique d'une courbe),
 *      lorsque le paramètre output = xml,
 *      afin de récupérer les élévations retournées.
 *
 * @module AltiResponseReader
 * @alias Gp.Services.Alti.Formats.AltiResponseReader
 * @private
 */

// import Logger from "../../../Utils/LoggerByDefault";



/**
 *
 * Objet AltiResponseReader
 *
 * @member {Object} AltiResponseReader
 *
 * @property {Object} AltiResponseReader.READERS - Objet contenant des fonctions de lecture, appelées "readers"
 *      dont chaque clé correspond au nom d'un tag du XML que l'on souhaite lire
 *      et la valeur associée est une fonction (node, data)
 *      où node est un noeud du document DOM
 *      et data est un objet où l'on stocke les informations lues dans le XML.
 *
 * @property {Method} AltiResponseReader.READERS.elevations -  Lecture d'un noeud "elevations" de la réponse XML
 *      du service alti, correspondant logiquement à la racine du document
 *      (contient un ou plusieurs childNodes correspondant chacun à une élévation retournée)
 *
 * @property {Method} AltiResponseReader.READERS.elevation - ecture d'un noeud "elevation" de la réponse xml du service alti.
 *      (contient un ou 4 childNode (s) correspondant à l'altitude (z) et éventuellement lat, lon, et acc)
 *
 * @property {Method} AltiResponseReader.READERS.lat - Lecture d'un noeud "lat" de la réponse xml du service alti.
 *      (contient une valeur de latitude, qui est un flottant)
 *
 * @property {Method} AltiResponseReader.READERS.lon - Lecture d'un noeud "lon" de la réponse xml du service alti.
 *      (contient une valeur de longitude, qui est un flottant)
 *
 * @property {Method} AltiResponseReader.READERS.z - Lecture d'un noeud "z" de la réponse xml du service alti.
 *      (contient une valeur d'altitude, qui est un flottant)
 *
 * @property {Method} AltiResponseReader.READERS.acc - Lecture d'un noeud "acc" de la réponse xml du service alti.
 *      (contient une valeur de précision, qui est un flottant)
 *
 * @property {Method} AltiResponseReader.READERS.exceptionreport - Lecture d'un noeud "ExceptionReport" de la réponse xml du service alti.
 *
 * @property {Method} AltiResponseReader.READERS.exception - Lecture d'un noeud "Exception" de la réponse xml du service alti.
 *
 * @property {Method} AltiResponseReader.read - Méthode permettant de lancer la lecture d'une réponse XML du service altimétrique,
 *      à l'aide des readers de la classe.
 *
 */
var AltiResponseReader = {};

AltiResponseReader.READERS = {

    /**
     * Lecture d'un noeud "elevations" de la réponse XML du service alti, correspondant logiquement à la racine du document
     *      (contient un ou plusieurs childNodes correspondant chacun à une élévation retournée)
     *
     * @param {DOMElement} root - racine de la réponse XML
     * @static
     * @memberof AltiResponseReader
     * @returns {Object} Retourne un objet de type AltiResponse
     */
    elevations : function (root) {
        // INFO : on passe en paramètre l'objet en entrée elevations, vide, à remplir.
        var altiResponse = new __WEBPACK_IMPORTED_MODULE_0__Response_model_AltiResponse__["a" /* default */]();

        if (root.hasChildNodes()) {
            var children = root.childNodes;
            var child;
            var elevation;

            for (var i = 0; i < children.length; i++) {
                child = children[i];

                if (AltiResponseReader.READERS[child.nodeName]) {
                    elevation = AltiResponseReader.READERS[child.nodeName](child);
                    altiResponse.elevations.push(elevation);
                }
            }
        }

        return altiResponse;
    },

    /**
     * Lecture d'un noeud "elevation" de la réponse xml du service alti.
     *      (contient un ou 4 childNode (s) correspondant à l'altitude (z) et éventuellement lat, lon, et acc)
     *
     * @param {DOMElement} node - noeud elevation à lire pour récupérer les informations de l'élévation retournée (z [, lon, lat, acc])
     * @return {Array} elevationResponse - format de la réponse en sortie, instance de AltiResponse
     * @static
     * @memberof AltiResponseReader
     */
    elevation : function (node) {
        var elevation = new __WEBPACK_IMPORTED_MODULE_1__Response_model_Elevation__["a" /* default */]();

        if (node.hasChildNodes()) {
            var children = node.childNodes;
            var child;
            for (var i = 0; i < children.length; i++) {
                child = children[i];
                if (AltiResponseReader.READERS[child.nodeName]) {
                    // INFO : on passe en paramètre l'objet en entrée elevation, vide, à remplir.
                    AltiResponseReader.READERS[child.nodeName](child, elevation);
                }
            }
        }
        return elevation;
    },

    /**
     * Lecture d'un noeud "lat" de la réponse xml du service alti.
     *      (contient une valeur de latitude, qui est un flottant)
     *
     * @param {DOMElement} node - noeud à lire pour récupérer la latitude
     * @param {Object} elevation - objet dans lequel stocker la latitude retournée
     * @static
     * @memberof AltiResponseReader
     */
    lat : function (node, elevation) {
        var textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            elevation.lat = parseFloat(textNode.nodeValue);
        } else {
            throw new Error("Erreur dans la lecture de la réponse du service : latitude attendue mais absente");
        }
    },

    /**
     * Lecture d'un noeud "lon" de la réponse xml du service alti.
     *      (contient une valeur de longitude, qui est un flottant)
     *
     * @param {DOMElement} node - noeud à lire pour récupérer la longitude
     * @param {Object} elevation - objet dans lequel stocker la longitude retournée
     * @static
     * @memberof AltiResponseReader
     */
    lon : function (node, elevation) {
        var textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            elevation.lon = parseFloat(textNode.nodeValue);
        } else {
            throw new Error("Erreur dans la lecture de la réponse du service : longitude attendue mais absente");
        }
    },

    /**
     * Lecture d'un noeud "z" de la réponse xml du service alti.
     *      (contient une valeur d'altitude, qui est un flottant)
     *
     * @param {DOMElement} node - noeud à lire pour récupérer l'altitude
     * @param {Object} elevation - objet dans lequel stocker l'altitude retournée
     * @static
     * @memberof AltiResponseReader
     */
    z : function (node, elevation) {
        var textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            if (elevation) {
                elevation.z = parseFloat(textNode.nodeValue);
            } else {
                elevation = new __WEBPACK_IMPORTED_MODULE_1__Response_model_Elevation__["a" /* default */]();
                elevation.z = parseFloat(textNode.nodeValue);
                return elevation;
            }
        } else {
            throw new Error("Erreur dans la lecture de la réponse du service : altitude attendue mais absente");
        }
    },

    /**
     * Lecture d'un noeud "acc" de la réponse xml du service alti.
     *      (contient une valeur de précision, qui est un flottant)
     *
     * @param {DOMElement} node - noeud à lire pour récupérer la précision
     * @param {Object} elevation - objet dans lequel stocker la précision retournée
     * @static
     * @memberof AltiResponseReader
     */
    acc : function (node, elevation) {
        var textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            elevation.acc = parseFloat(textNode.nodeValue);
        } else {
            throw new Error("Erreur dans la lecture de la réponse du service : précision (acc) attendue mais absente");
        }
    },

    /**
     * Lecture d'un noeud "ExceptionReport" de la réponse xml du service alti.
     *
     * @param {DOMElement} node - noeud à lire pour récupérer l'exception
     * @return {Object} exceptionReport - objet contenant l'exception
     * @static
     * @memberof AltiResponseReader
     */
    exceptionreport : function (node) {
        var response = {};

        if (node.hasChildNodes()) {
            var children = node.childNodes;
            var child;
            for (var i = 0; i < children.length; i++) {
                child = children[i];
                if (child.nodeName === "Exception") {
                    response.exceptionReport = AltiResponseReader.READERS.exception(child);
                }
            }
        }

        return response;
    },

    /**
     * Lecture d'un noeud "Exception" de la réponse xml du service alti.
     *
     * @param {DOMElement} node - noeud à lire pour récupérer l'exception
     * @return {Object} exceptionReport - objet contenant l'exception, avec deux attributs :
     *      {String} exceptionReport.exceptionCode - qui contient l'identifiant du code de l'exception
     *      {String} exceptionReport.exception - qui contient le message de l'exception
     * @static
     * @memberof AltiResponseReader
     */
    exception : function (node) {
        var exceptionReport = {};

        // get exception code
        var exceptionCode = node.getAttribute("exceptionCode");
        if (exceptionCode) {
            exceptionReport.exceptionCode = exceptionCode;
        }

        // get exception message
        var textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            exceptionReport.exception = textNode.nodeValue;
        }

        return exceptionReport;
    },

    /**
     * Lecture d'un noeud "Error" de la réponse xml du service alti.
     *
     * @param {DOMElement} node - noeud à lire pour récupérer l'exception
     * @return {Object} error - objet contenant l'exception
     * @static
     */
    error : function (node) {
        var response = {
            error : {}
        };
        // get error code and description
        if (node.hasChildNodes()) {
            var children = node.childNodes;
            var child;
            for (var i = 0; i < children.length; i++) {
                child = children[i];
                var textNode;
                // get error code
                if (child.nodeType === 1 && child.nodeName === "code") { // 1 === node.ELEMENT_NODE
                    textNode = child.firstChild;
                    if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
                        response.error.code = textNode.nodeValue;
                    }
                }
                // get error description
                if (child.nodeType === 1 && child.nodeName === "description") { // 1 === node.ELEMENT_NODE
                    textNode = child.firstChild;
                    if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
                        response.error.description = textNode.nodeValue;
                    }
                }
            }
        }
        return response;
    }

};

/**
 * Méthode permettant de lancer la lecture d'une réponse XML du service altimétrique,
 *      à l'aide des readers de la classe.
 *
 * @method AltiResponseReader.read
 * @param {DOMElement} root - racine de la réponse XML à lire
 * @static
 * @memberof AltiResponseReader
 */
AltiResponseReader.read = function (root) {
    if (root.nodeName === "elevations") {
        var altiResponse = AltiResponseReader.READERS.elevations(root);
        return altiResponse;
    } else if (root.nodeName === "ExceptionReport") {
        var exceptionReport = AltiResponseReader.READERS.exceptionreport(root);
        return exceptionReport;
    } else if (root.nodeName === "error") {
        var error = AltiResponseReader.READERS.error(root);
        return error;
    } else {
        throw new Error("Erreur lors de la lecture de la réponse : elle n'est pas au format attendu.");
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AltiResponseReader);


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils_Helper__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultUrlService__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CommonService__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Response_AutoConfResponseFactory__ = __webpack_require__(61);









/**
 * @classdesc
 * Appel du service d'autoconfiguration du Géoportail
 *
 * @private
 * @constructor
 * @extends {Gp.Services.CommonService}
 * @alias Gp.Services.AutoConf
 *
 * @param {Object} options - options spécifiques au service (+ les options heritées)
 *
 * @param {String} [options.layerId] - Le nom de l'agrégat (couche) dont on veut connaître les informations détaillées.
 *      La présence de cette propriété implique l'utilisation de la deuxième opération du service pour accéder aux informations d'une couche aggrégée.
 *      Dans ce cas, la fonction effectuera quand même dans un premier temps la récupération des informations de l'auto-
 *      configuration complète, sauf si un premier appel à l'autoconf a déjà été fait avec cette clé (i.e. si la variable globale est définie
 *      pour la clé de contrat). Elle ira ensuite chercher les informations des couches agrégées, qui seront ajoutées à la variable globale Gp.Config.
 *
 * @example
 *   var options = {
 *      // options communes aux services
 *      apiKey : "apikey",
 *      protocol : 'JSONP', // JSONP|XHR
 *      timeOut : 10000, // ms
 *      rawResponse : false, // true|false
 *      scope : null, // this
 *      onSuccess : function (response) {},
 *      onFailure : function (error) {},
 *      layerId : "ORTHOIMAGERY.ORTHOPHOTOS.3D$GEOPORTAIL:OGC:WMTS@aggregate"
 *   };
 */
function AutoConf (options) {
    if (!(this instanceof AutoConf)) {
        throw new TypeError(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("CLASS_CONSTRUCTOR", "AutoConf"));
    }

    /**
     * Nom de la classe (heritage)
     * FIXME instance ou classe ?
     */
    this.CLASSNAME = "AutoConf";

    // Autoconf default protocol remains JSONP (#see http://ignf.github.io/geoportal-access-lib/latest/jsdoc/tutorial-optimize-getconfig.html)
    if (!options) {
        options = {};
    }
    options.protocol = options.protocol || "JSONP";

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_5__CommonService__["a" /* default */].apply(this, arguments);

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("Gp.Services.AutoConf");
    // this.// logger.trace("[Constructeur AutoConf (options)]");

    // #####################
    // analyse des options
    // #####################

    // gestion de l'url du service par defaut
    if (!this.options.serverUrl) {
        // si l'url n'est pas renseignée, il faut utiliser les urls par defaut
        // en fonction du nombre de clés en entrée et du paramètre layerId
        if (!this.options.serverUrl) {
            var lstUrlByDefault = __WEBPACK_IMPORTED_MODULE_4__DefaultUrlService__["a" /* default */].AutoConf.url(this.options.apiKey);

            if (!this.options.layerId) {
                // cas d'une autoconf simple
                if (Array.isArray(this.options.apiKey) && this.options.apiKey.length > 0) {
                    // cas d'un tableau de clés en entrée
                    this.options.serverUrl = lstUrlByDefault.apiKeys;
                } else {
                    this.options.serverUrl = lstUrlByDefault.apiKey;
                }
            } else {
                // cas d'une autoconf pour des couches aggrégées
                this.options.serverUrl = lstUrlByDefault.aggregate + this.options.layerId;
            }
        }
    }

    // INFO
    // le service ne repond pas en mode POST (405 Method Not Allowed)
    if (this.options.protocol === "XHR" && this.options.httpMethod === "POST") {
        this.logger.warn("Le service ne gére pas le mode d'interrogation en POST, on bascule sur du GET !");
        this.options.httpMethod = "GET"; // on surcharge !
    }

    // #####################
    // attributs d'instances
    // #####################

    /**
     * Format forcé de la réponse du service : "xml"
     * sauf si l'on souhaite une reponse brute (options.rawResponse)
     */
    this.options.outputFormat = (this.options.rawResponse) ? "" : "xml";
}

/**
 * @lends module:AutoConf#
 */

AutoConf.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_5__CommonService__["a" /* default */].prototype, {
    // todo
    // getter/setter
});

/*
 * Constructeur (alias)
 */
AutoConf.prototype.constructor = AutoConf;

/**
 * Création de la requête (overwrite)
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback de succès de la création de la requête
 */
AutoConf.prototype.buildRequest = function (error, success) {
    var scope = typeof window !== "undefined" ? window : {};

    if (scope.Gp && scope.Gp.Config && scope.Gp.Config.generalOptions && scope.Gp.Config.layers) {
        if (scope.Gp.Config.generalOptions.apiKeys[this.options.apiKey]) {
            if (this.options.layerId) { // cas d'une autoconf + détaillée sur une couche agrégée
                if (scope.Gp.Config.layers[this.options.layerId] && scope.Gp.Config.layers[this.options.layerId].aggregatedLayers) {
                    this.logger.warn("Gp.Config existe déjà pour cette clé et cette couche");
                    this.options.onSuccess.call(this, scope.Gp.Config);
                    return;
                }
            } else {
                this.logger.warn("Gp.Config existe déjà pour cette clé");
                this.options.onSuccess.call(this, scope.Gp.Config);
                return;
            }
        }
    }

    // requete par defaut
    this.request = "";

    // gestion de l'autoconf local
    // Le fichier en local doit respecter le format de sortie du service.
    //  - En XHR, le format est en xml
    //  - En JSONP, le format est en xml encapsulé dans un json avec une fonction de callback
    //    ex. callback ({"http":{"status":200,"error":null},"xml":"..."})
    var bLocal;
    if (this.options.serverUrl.indexOf("http://") === -1) {
        bLocal = true;
    } else {
        bLocal = false;
    }

    // FIXME param. KVP optionnel sur un service uniquement (pas sur un autoconf local !)
    if (!bLocal && this.layerId) {
        this.request = __WEBPACK_IMPORTED_MODULE_2__Utils_Helper__["a" /* default */].normalyzeParameters({
            layerId : this.layerId
        });
    }

    // normalement pas d'erreur d'autoconf...
    (this.request || this.request === "")
        ? success.call(this, this.request)
        : error.call(this, new __WEBPACK_IMPORTED_MODULE_3__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_REQUEST_BUILD")));
};

/**
 * Analyse de la reponse (overwrite)
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback de succès de l'analyse de la réponse
 */
AutoConf.prototype.analyzeResponse = function (error, success) {
    if (this.response) {
        var options = {
            layerId : this.options.layerId,
            response : this.response,
            rawResponse : this.options.rawResponse,
            onSuccess : success,
            onError : error,
            scope : this
        };

        __WEBPACK_IMPORTED_MODULE_6__Response_AutoConfResponseFactory__["a" /* default */].build(options);
    } else {
        error.call(this, new __WEBPACK_IMPORTED_MODULE_3__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AutoConf);


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formats_XML__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Formats_AutoConfResponseReader__ = __webpack_require__(62);
/**
 * Factory pour générer une reponse JSON à partir d'un XML
 *
 * @module AutoConfReponseFactory
 * @private
 * @alias Gp.Services.AutoConf.Response.AutoConfResponseFactory
 * @todo gérer le cas du JSONP qui encapsule du XML ?
 */






var AutoConfReponseFactory = {

    /**
     * interface unique
     * Fabrique d'analyse des réponses (xml) du service d'autoconfiguration.
     * Création d'un format XML, auquel on associe un reader et une chaîne XML, et qui renverra un objet JavaScript correspondant.
     * Si une erreur est levée lors de l'analyse, ou si l'objet est vide ou contient une exception : appel de la fonction de callback onError
     * Sinon, appel de la fonction de callback onSuccess (définies dans Autoconf.analyzeResponse)
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant AutoConf
     *
     * @example
     *   var options = {
     *      layerId :
     *      response :
     *      rawResponse :
     *      scope :
     *      onSuccess :
     *      onError :
     *   };
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("AutoConfResponseFactory");
        // logger.trace(["AutoConfResponseFactory::build()"]);

        // data de type AutoConfResponse
        var data = null;

        if (options.response) {
            if (options.rawResponse) {
                data = options.response;
            } else {
                try {
                    var p = new __WEBPACK_IMPORTED_MODULE_3__Formats_XML__["a" /* default */]({
                        reader : __WEBPACK_IMPORTED_MODULE_4__Formats_AutoConfResponseReader__["a" /* default */]
                    });

                    if (typeof options.response === "string") {
                        p.setXMLString(options.response);
                    } else {
                        p.setXMLDoc(options.response);
                    }

                    data = p.parse();
                } catch (e) {
                    // si une exception a été levée, on appelle le callback d'erreur avec le message renvoyé
                    var message = e.message;
                    if (typeof options.response === "string") {
                        message += "\n (raw response service'" + options.response + "')";
                    } else {
                        message += "\n (raw response service'" + options.response.documentElement.innerHTML + "')";
                    }

                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                        message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", message),
                        status : 200,
                        type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
                    }));
                    return;
                }

                // Si la réponse est vide, on appelle le callback d'erreur
                var isEmpty = true;
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        isEmpty = false;
                    }
                }
                if (isEmpty) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY_2")));
                    return;
                }

                // Si la réponse contenait une exception renvoyée par le service, on appelle le callback d'erreur
                if (data.exceptionReport) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                        message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", data.exceptionReport),
                        type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR,
                        status : 200
                    }));
                    return;
                }
            }
        } else {
            // si la réponse (xmlString) est vide, on appelle le callback d'erreur
            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
            return;
        }

        // définition de la variable globale Gp.Config à partir de la réponse
        var scope = typeof window !== "undefined" ? window : {};

        if (!scope.Gp) {
            scope.Gp = {};
        }
        if (!scope.Gp.Config) {
            scope.Gp.Config = data;
        } else {
            this.mergeConfig(scope.Gp.Config, data, options.layerId);
        }

        // si tout s'est bien passé, on appelle le callback de succès
        options.onSuccess.call(options.scope, scope.Gp.Config);
    },

    /**
     * Fonction utilisée dans le cas où l'autoconfiguration est appelée plusieurs fois
     * (par exemple pour des clés différentes ou pour des infos sur une couche agrégée)
     *
     * @method mergeConfig
     * @static
     * @param {Object} GpConfig - Variable Gp.Config préexistante
     * @param {Object} data - la nouvelle réponse de l'autoconf, à fusionner avec GpConfig
     * @param {String} [layerId] - l'identifiant d'une couche agrégée dans le cas d'une 2è opération de l'autoconf
     */
    mergeConfig : function (GpConfig, data, layerId) {
        if (data && GpConfig) {
            // on boucle sur les propriétés (generalOptions, layers, projections, services, tileMatrixSets, territories)
            for (var prop in data) {
                if (data.hasOwnProperty(prop)) {
                    // on récupère la nouvelle clé dans generalOptions
                    if (prop === "generalOptions") {
                        for (var key in data[prop].apiKeys) {
                            if (data[prop].apiKeys.hasOwnProperty(key) && !GpConfig.generalOptions.apiKeys[key]) {
                                GpConfig.generalOptions.apiKeys[key] = data[prop].apiKeys[key];
                            }
                        }
                        // on récupère les nouveaux objets (TMS, layers, projections...)
                    } else {
                        if (GpConfig[prop]) {
                            for (var obj in data[prop]) {
                                if (data[prop].hasOwnProperty(obj) && !GpConfig[prop][obj]) {
                                    GpConfig[prop][obj] = data[prop][obj];
                                }
                            }
                        }
                    }
                }
            }

            // dans le cas d'une autoconf pour une couche agrégée, on récupère l'info
            if (layerId) {
                var aggregatedLayers = [];

                for (var lyr in data.layers) {
                    if (data.layers.hasOwnProperty(lyr)) {
                        aggregatedLayers.push(lyr);
                    }
                }

                if (GpConfig.layers[layerId]) {
                    GpConfig.layers[layerId].aggregatedLayers = aggregatedLayers;
                }
            }
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AutoConfReponseFactory);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Response_model_AutoConfResponse__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Response_model_Constraint__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Response_model_Format__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Response_model_Layer__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Response_model_Legend__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Response_model_Metadata__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Response_model_Originator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Response_model_Service__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Response_model_Style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Response_model_Territory__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Response_model_Thematic__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Response_model_TileMatrixSet__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Response_model_TileMatrix__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Response_model_TileMatrixLimit__ = __webpack_require__(37);

/**
 * Fonction retournant un objet contenant des clés de lecture (readers)
 *      qui permettent de parser des réponses XML du service d'autoconfiguration du Géoportail
 *      afin de récupérer les informations retournées.
 * @module AutoConfResponseReader
 * @private
 * @alias Gp.Services.AutoConf.Formats.AutoConfResponseReader
 */

// import Logger from "../../../Utils/LoggerByDefault";















var AutoConfResponseReader = {};

/**
 * version du service d'autoconf
 */
AutoConfResponseReader.VERSION = "1.1.0";

/**
 * Objet stockant les différents namespaces et les URI associées
 */
AutoConfResponseReader.NAMESPACES = {
    xmlns : "http://www.opengis.net/context",
    gpp : "http://api.ign.fr/geoportail",
    ows : "http://www.opengis.net/ows/1.1",
    sld : "http://www.opengis.net/sld",
    wmts : "http://www.opengis.net/wmts/1.0",
    xlink : "http://www.w3.org/1999/xlink",
    xsi : "http://www.w3.org/2001/XMLSchema-instance"
};

/**
 * Localisation (URL) du schema de définition du XML (XSD)
 */
AutoConfResponseReader.SCHEMALOCATION = [
    "http://www.opengis.net/context http://gpp3-wxs.ign.fr/schemas/extContext.xsd http://api.ign.fr/geoportail http://wxs.ign.fr/schemas/autoconf/autoconf.xsd",
    "http://www.opengis.net/context http://gpp3-wxs.ign.fr/schemas/extContext.xsd http://api.ign.fr/geoportail http://gpp3-wxs.ign.fr/schemas/autoconf.xsd"
];

/**
 * Namespace par défaut du format
 */
AutoConfResponseReader.DEFAULTPREFIX = "context";

/**
 * Objet contenant des fonctions de lecture, appelées "READERS"
 *      dont chaque clé correspond au nom d'un tag du XML que l'on souhaite lire
 *      et la valeur associée est une fonction (node, data)
 *      où node est un noeud du document DOM
 *      et data est un objet où l'on stocke les informations lues dans le XML.
 */
AutoConfResponseReader.READERS = {

    context : {

        /** ViewContext */
        ViewContext : function (viewContextNode) {
            // info : balise "racine" de la réponse de l'autoconf

            // vérification de la version du service, et des namespaces de l'en-tête
            __checkServiceAttributes(viewContextNode);

            // create AutoConfResponse
            var config = new __WEBPACK_IMPORTED_MODULE_0__Response_model_AutoConfResponse__["a" /* default */]();

            __getChildNodes(viewContextNode, config);

            return config;
        },

        // info : /General/Title
        // ou : /LayerList/Layer/Title
        /** Title */
        Title : function (titleNode, data) {
            if (data && data.generalOptions) { // cas de la variable config générale
                data.generalOptions.title = __getChildValue(titleNode);
            } else if (data && data.lyr) { // cas d'une layer
                data.lyr.title = __getChildValue(titleNode);
            }
        },

        // info : /LayerList/Layer/Abstract
        /** Abstract */
        Abstract : function (node, data) {
            if (data && data.lyr) {
                data.lyr.description = __getChildValue(node);
            }
        },

        // info : /General/Extension/gpp:General/gpp:Services/Server
        // ou : /LayerList/Server
        /** Server */
        Server : function (node, data) {
            var serverId = node.getAttribute("service");
            var title = node.getAttribute("title");
            var version = node.getAttribute("version");
            if (serverId) {
                if (data && data.services && typeof data.services === "object" && !data.services[serverId]) {
                    // on est dans la balise Services
                    var s = new __WEBPACK_IMPORTED_MODULE_7__Response_model_Service__["a" /* default */]();
                    s.title = title;
                    s.version = version;
                    // récupération de l'url du service, dans une balise enfant "OnlineResource"
                    __getChildNodes(node, s);
                    // ajout du service à la variable config
                    data.services[serverId] = s;
                } else if (data && data.lyr) {
                    // on est dans la balise Layer
                    if (!data.lyr.serviceParams) {
                        // si l'objet serviceParams n'a pas encore été créé, on le crée.
                        data.lyr.serviceParams = {};
                    }
                    data.lyr.serviceParams.id = serverId;
                    data.lyr.serviceParams.version = version;
                }
            }
        },

        // info : /General/Extension/gpp:General/gpp:Services/Server/OnlineResource
        // ou : /LayerList/Layer/Server/OnlineResource
        // ou : /LayerList/Layer/Extention/gpp:Layer/gpp:QuickLook/OnlineResource
        // ou : /LayerList/Layer/Extension/gpp:Layer/gpp:Legends/gpp:Legend/gpp:LegendURL/OnlineResource
        // ou : /LayerList/Layer/Extension/gpp:Layer/gpp:MetadataURL/OnlineResource
        /** OnlineResource */
        OnlineResource : function (node, service) {
            if (service && service.hasOwnProperty("serverUrl")) {
                service.serverUrl = node.getAttribute("xlink:href");
            }
        },

        // info : /LayerList
        /** LayerList */
        LayerList : function (layerListNode, config) {
            // liste de balises "layer"
            __getChildNodes(layerListNode, config);

            if (config && config.layers && config.generalOptions && config.services) {
                // récupération des clés et des couches associées
                for (var lyr in config.layers) {
                    if (config.layers.hasOwnProperty(lyr)) {
                        var layerConfig = config.layers[lyr];

                        // récupération de la clé associée
                        var apiKeys = layerConfig.apiKeys;
                        if (apiKeys && Array.isArray(apiKeys)) {
                            for (var i = 0; i < apiKeys.length; i++) {
                                // pour chaque clé API, on ajoute la couche
                                var key = apiKeys[i];
                                if (config.generalOptions.apiKeys) {
                                    if (!config.generalOptions.apiKeys[key] || !Array.isArray(config.generalOptions.apiKeys[key])) {
                                        config.generalOptions.apiKeys[key] = [];
                                    }
                                    config.generalOptions.apiKeys[key].push(lyr);
                                }
                            }
                        }

                        // récupération du service associé
                        var serviceParams = layerConfig.serviceParams;
                        if (serviceParams && serviceParams.id) {
                            if (!config.services[serviceParams.id]) {
                                var s = new __WEBPACK_IMPORTED_MODULE_7__Response_model_Service__["a" /* default */]();
                                if (serviceParams.serverUrl) {
                                    s.serverUrl = serviceParams.serverUrl;
                                }
                                if (serviceParams.version) {
                                    s.version = serviceParams.version;
                                }
                                config.services[serviceParams.id] = s;
                            }
                        }

                        // récupération de la projection associée (dans le cas d'une couche WMTS)
                        if (layerConfig.wmtsOptions && layerConfig.wmtsOptions.tileMatrixSetLink && config.tileMatrixSets) {
                            var tmsLink = layerConfig.wmtsOptions.tileMatrixSetLink;
                            var tileMatrixSets = config.tileMatrixSets;
                            for (var tms in tileMatrixSets) {
                                if (tileMatrixSets.hasOwnProperty(tms) && tms === tmsLink) {
                                    layerConfig.defaultProjection = tileMatrixSets[tms].projection;
                                }
                            }
                        }
                    }
                }
            }
        },

        // info : /LayerList/Layer
        /** Layer */
        Layer : function (layerNode, config) {
            if (config && config.layers) {
                var lyrData = {
                    lyr : new __WEBPACK_IMPORTED_MODULE_3__Response_model_Layer__["a" /* default */](),
                    lyrId : null
                };

                var hidden = layerNode.getAttribute("hidden");
                if (hidden === "1") {
                    lyrData.lyr.hidden = true;
                } else {
                    lyrData.lyr.hidden = false;
                }

                var queryable = layerNode.getAttribute("queryable");
                if (queryable === "1") {
                    lyrData.lyr.queryable = true;
                } else {
                    lyrData.lyr.queryable = false;
                }

                // on peut avoir les balises : Server, Name, Title, Abstract, DataURL, MetadataURL,
                // sld:MinScaleDenominator, sld:MaxScaleDenominator, SRS, FormatList, StyleList
                // DimensionList, Extension
                __getChildNodes(layerNode, lyrData);

                // si on a bien récupéré l'identifiant de la couche, on s'en sert pour l'ajouter au tableau associatif des couches disponibles
                if (lyrData.lyrId) {
                    // Dans le cas des services, on modifie le contexte de l'identifiant.
                    if (lyrData.lyr.serviceParams && lyrData.lyr.serviceParams.id) {
                        var serviceid = lyrData.lyr.serviceParams.id;
                        if (serviceid.toUpperCase().indexOf("OPENLS") !== -1 || serviceid.toUpperCase().indexOf("ELEVATION") !== -1) {
                            // Il faut changer l'identifiant de la ressource.
                            var resourceId = lyrData.lyrId.split("$")[0];
                            lyrData.lyrId = resourceId + "$" + serviceid;
                        }
                    }

                    // on ajoute l'information dans les attributs de la couche
                    lyrData.lyr.layerId = lyrData.lyrId;
                    // et dans le tableau Gp.Config.layers
                    config.layers[lyrData.lyrId] = lyrData.lyr;
                }
            }
        },

        // info : /LayerList/Layer/Name
        /** TODO : jsdoc block */
        Name : function (node, lyrData) {
            if (lyrData && lyrData.lyr) {
                lyrData.lyr.name = __getChildValue(node);
            }
        },

        // info : /LayerList/Layer/SRS (dans le cas des couches WMS ou WFS)
        /** TODO : jsdoc block */
        SRS : function (node, lyrData) {
            // on récupère la projection de la couche (SRS)
            if (lyrData && lyrData.lyr) {
                lyrData.lyr.defaultProjection = __getChildValue(node);
            }
        },

        // info : /LayerList/Layer/FormatList/Format
        /** TODO : jsdoc block */
        Format : function (node, lyrData) {
            if (lyrData && lyrData.lyr) {
                var f = new __WEBPACK_IMPORTED_MODULE_2__Response_model_Format__["a" /* default */]();
                var current = node.getAttribute("current");
                if (current === "1") {
                    f.current = true;
                } else {
                    f.current = false;
                }
                f.name = __getChildValue(node);
                // si on n'a pas encore ajouté de format, on crée le tableau vide
                if (!lyrData.lyr.formats || !Array.isArray(lyrData.lyr.formats)) {
                    lyrData.lyr.formats = [];
                }
                lyrData.lyr.formats.push(f);
            }
        },

        // info : /LayerList/Layer/StyleList/Style
        /** TODO : jsdoc block */
        Style : function (node, lyrData) {
            if (lyrData && lyrData.lyr) {
                var s = new __WEBPACK_IMPORTED_MODULE_8__Response_model_Style__["a" /* default */]();
                var current = node.getAttribute("current");
                if (current === "1" || current === 1) {
                    s.current = true;
                } else {
                    s.current = false;
                }
                if (node.hasChildNodes) {
                    var children = node.childNodes;
                    var child;
                    var childName;
                    for (var i = 0; i < children.length; i++) {
                        child = children[i];
                        if (child.nodeType === 1) { // 1 === node.ELEMENT_NODE
                            childName = child.localName || child.baseName || child.nodeName;
                            if (childName === "Name") {
                                s.name = __getChildValue(child);
                            } else if (childName === "Title") {
                                s.title = __getChildValue(child);
                            }
                        }
                    }
                }
                // si on n'a pas encore ajouté de style, on crée le tableau vide
                if (!lyrData.lyr.styles || !Array.isArray(lyrData.lyr.styles)) {
                    lyrData.lyr.styles = [];
                }
                lyrData.lyr.styles.push(s);
            }
        },

        // info : /LayerList/Layer/DimensionList/Dimension
        /** TODO : jsdoc block */
        Dimension : function (node, lyrData) {
            // possède des attributs obligatoires : name, units, unitSymbol et userValue
            // et d'autres attributs facultatifs : default, multipleValues, nearestValue, current
            var name = node.getAttribute("name");
            var dim = __getChildValue(node);
            if (lyrData && lyrData.lyr) {
                // si on n'a pas encore ajouté de dimension, on crée l'objet vide
                if (!lyrData.lyr.dimensions) {
                    lyrData.lyr.dimensions = {};
                }
                if (name === "Type") {
                    lyrData.lyr.dimensions.type = dim;
                } else if (name === "VisibilityRange") {
                    lyrData.lyr.dimensions.visibilityRange = dim;
                } else if (name === "VisibilityMode ") {
                    lyrData.lyr.dimensions.visibilityMode = dim;
                } else if (name === "GeometricType") {
                    lyrData.lyr.dimensions.geometricType = dim;
                } else if (name === "NoDataValue") {
                    lyrData.lyr.dimensions.noDataValue = dim;
                }
            }
        }

    },

    gpp : {

        // info : /General/Extension/gpp:General/gpp:Theme
        /** TODO : jsdoc block */
        Theme : function (themeNode, config) {
            if (config && config.generalOptions && config.generalOptions.hasOwnProperty("theme")) {
                config.generalOptions.theme = __getChildValue(themeNode);
            }
        },

        // info : /General/Extension/gpp:General/gpp:defaultGMLGFIStyleUrl
        /** TODO : jsdoc block */
        defaultGMLGFIStyleUrl : function (node, config) {
            if (config && config.generalOptions && config.generalOptions.hasOwnProperty("defaultGMLGFIStyle")) {
                config.generalOptions.defaultGMLGFIStyle = __getChildValue(node);
            }
        },

        // info : /General/Extension/gpp:General/gpp:Territories/gpp:Territory
        /** TODO : jsdoc block */
        Territory : function (territoryNode, config) {
            // info : Information to configure the API for this territory
            var tid = territoryNode.getAttribute("id");
            if (tid) {
                // create a new Territory
                var t = new __WEBPACK_IMPORTED_MODULE_9__Response_model_Territory__["a" /* default */]();

                var isDefault = territoryNode.getAttribute("default");
                if (isDefault === "1") {
                    t.isDefault = true;
                } else {
                    t.isDefault = false;
                }
                // read territory informations
                __getChildNodes(territoryNode, t);
                // add territory to config
                if (config && config.territories && typeof config.territories === "object") {
                    config.territories[tid] = t;
                }
            }
        },

        // info : /General/Extension/gpp:General/gpp:Territories/gpp:Territory/gpp:defaultCRS
        /** TODO : jsdoc block */
        defaultCRS : function (node, territory) {
            // info : Identifier for the default Coordinate Reference System (CRS).
            if (territory && territory.hasOwnProperty("defaultCRS")) {
                territory.defaultCRS = __getChildValue(node);
            }
        },

        // info : /General/Extension/gpp:General/gpp:Territories/gpp:Territory/gpp:AdditionalCRS
        // ou : /LayerList/Extension/gpp:Layer/gpp:AdditionalCRS
        /** TODO : jsdoc block */
        AdditionalCRS : function (node, data) {
            // info : Identifier for additional Coordinate Reference System (CRS).
            // info : data peut être une instance de Territory.js, ou une instance de Layer.js
            var addCRS = __getChildValue(node);
            if (addCRS && data) {
                if (Array.isArray(data.additionalCRS)) { // cas d'un territoire
                    data.additionalCRS.push(addCRS);
                } else { // cas d'une couche
                    // si le tableau n'est pas encore créé
                    if (!data.additionalProjections || !Array.isArray(data.additionalProjections)) {
                        data.additionalProjections = [];
                    }
                    data.additionalProjections.push(addCRS);
                }
            }
        },

        // info : /General/Extension/gpp:General/gpp:Territories/gpp:Territory/gpp:DefaultLayer
        /** TODO : jsdoc block */
        DefaultLayer : function (node, territory) {
            var lyr = node.getAttribute("layerId");
            if (lyr && territory && Array.isArray(territory.defaultLayers)) {
                territory.defaultLayers.push(lyr);
            }
        },

        // info : /General/Extension/gpp:General/gpp:Territories/gpp:Territory/gpp:BoundingBox
        // ou : /LayerList/Extension/gpp:Layer/gpp:BoundingBox
        // ou : /LayerList/Layer/Extension/gpp:Layer/gpp:Constraints/gpp:Constraint/gpp:BoundingBox
        // ou : /LayerList/Extension/gpp:Layer/gpp:Originators/gpp:Originator/gpp:Constraints/gpp:Constraint/gpp:BoundingBox
        /** TODO : jsdoc block */
        BoundingBox : function (node, data) {
            if (data) {
                var values = __getChildValue(node).split(",");
                if (values.length === 4) {
                    // get bbox coordinates (wgs84)
                    var bbox = {
                        left : parseFloat(values[0]),
                        right : parseFloat(values[2]),
                        top : parseFloat(values[3]),
                        bottom : parseFloat(values[1])
                    };
                    // get temporal extent params (constraint or layer)
                    var minT = node.getAttribute("minT");
                    var maxT = node.getAttribute("maxT");

                    if (data.hasOwnProperty("geoBBOX")) { // cas d'un territoire
                        data.geoBBOX = bbox;
                    } else if (data.hasOwnProperty("bbox")) { // cas d'une constraint
                        if (data.bbox.left || data.bbox.right || data.bbox.top || data.bbox.bottom) {
                            // si on a déjà une bbox, il faut stocker d'autres contraintes
                            if (!data.multiConstraints) {
                                data.multiConstraints = [];
                            }
                            var newConstraint = new __WEBPACK_IMPORTED_MODULE_1__Response_model_Constraint__["a" /* default */]();
                            newConstraint.bbox = bbox;
                            newConstraint.temporalExtent = [minT, maxT];
                            data.multiConstraints.push(newConstraint);
                        } else {
                            // contrainte classique
                            data.bbox = bbox;
                            data.temporalExtent = [minT, maxT];
                        }
                    } else { // cas d'une layer
                        if (!data.globalConstraint) {
                            data.globalConstraint = new __WEBPACK_IMPORTED_MODULE_1__Response_model_Constraint__["a" /* default */]();
                        }
                        data.globalConstraint.bbox = bbox;
                        data.globalConstraint.temporalExtent = [minT, maxT];
                    }
                }
            }
        },

        // info : /General/Extension/gpp:General/gpp:Territories/gpp:Territory/gpp:Resolution
        /** TODO : jsdoc block */
        Resolution : function (node, territory) {
            // info : The default resolution to display on this territory, in CRS coordinate system
            var res = __getChildValue(node);
            if (res && territory && territory.defaultOptions && territory.defaultOptions.hasOwnProperty("resolution")) {
                territory.defaultOptions.resolution = parseFloat(res);
            }
        },

        // info : /General/Extension/gpp:General/gpp:Territories/gpp:Territory/gpp:Center/gpp:x
        /** TODO : jsdoc block */
        x : function (node, territory) {
            var lon = __getChildValue(node);
            if (lon && territory && territory.geoCenter && territory.geoCenter.hasOwnProperty("lon")) {
                territory.geoCenter.lon = parseFloat(lon);
            }
        },

        // info : /General/Extension/gpp:General/gpp:Territories/gpp:Territory/gpp:Center/gpp:y
        /** TODO : jsdoc block */
        y : function (node, territory) {
            var lat = __getChildValue(node);
            if (lat && territory && territory.geoCenter && territory.geoCenter.hasOwnProperty("lat")) {
                territory.geoCenter.lat = parseFloat(lat);
            }
        },

        // info : /General/Extension/gpp:General/gpp:Resolutions
        /** TODO : jsdoc block */
        Resolutions : function (resNode, config) {
            // info : List of resolutions in CRS:84 (comma separated values)
            if (config && config.generalOptions && config.generalOptions.hasOwnProperty("wgs84Resolutions")) {
                config.generalOptions.wgs84Resolutions = __getChildValue(resNode).split(",");
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer
        /** TODO : jsdoc block */
        Layer : function (node, lyrData) {
            // attributs : id, opacity, order, visibleInCatalog, aggregate, more
            if (lyrData && lyrData.hasOwnProperty("lyrId") && lyrData.lyr) {
                lyrData.lyrId = node.getAttribute("id");
                var aggregate = node.getAttribute("aggregate");
                var more = node.getAttribute("more");
                if (aggregate || more) {
                    lyrData.lyr.isAggregate = true;
                }
                __getChildNodes(node, lyrData.lyr);
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Constraints/gpp:Constraint
        // ou : /LayerList/Extension/gpp:Layer/gpp:Originators/gpp:Originator/gpp:Constraints/gpp:Constraint
        /** TODO : jsdoc block */
        Constraint : function (node, data) {
            var c = new __WEBPACK_IMPORTED_MODULE_1__Response_model_Constraint__["a" /* default */]();
            __getChildNodes(node, c);
            if (data) {
                // on peut être dans le cas d'un originator ou d'une layer, tous les deux ont l'attribut constraints
                if (!data.constraints || !Array.isArray(data.constraints)) {
                    data.constraints = [];
                }

                // cas de plusieurs contraintes (par ex différents territoires)
                if (c.multiConstraints && Array.isArray(c.multiConstraints)) {
                    // on récupère la première contrainte, stockée normalement
                    var constraint = new __WEBPACK_IMPORTED_MODULE_1__Response_model_Constraint__["a" /* default */]();
                    constraint.crs = c.crs;
                    constraint.bbox = c.bbox;
                    constraint.minScaleDenominator = c.minScaleDenominator;
                    constraint.maxScaleDenominator = c.maxScaleDenominator;
                    constraint.temporalExtent = c.temporalExtent;
                    data.constraints.push(constraint);

                    // puis on récupère les autres contraintes, à partir de multiConstraints
                    for (var i = 0; i < c.multiConstraints.length; i++) {
                        constraint = new __WEBPACK_IMPORTED_MODULE_1__Response_model_Constraint__["a" /* default */]();
                        constraint.crs = c.crs;
                        constraint.minScaleDenominator = c.minScaleDenominator;
                        constraint.maxScaleDenominator = c.maxScaleDenominator;
                        constraint.bbox = c.multiConstraints[i].bbox;
                        constraint.temporalExtent = c.multiConstraints[i].temporalExtent;
                        data.constraints.push(constraint);
                    }
                } else {
                    // cas d'une contrainte classique
                    data.constraints.push(c);
                }
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Originators/gpp:Originator/gpp:Constraints/gpp:Constraint/gpp:CRS
        // ou : /LayerList/Layer/Extension/gpp:Layer/gpp:Constraints/gpp:Constraint/gpp:CRS
        /** TODO : jsdoc block */
        CRS : function (node, data) {
            // nothing to do.
            if (data && data.hasOwnProperty("crs")) {
                data.crs = __getChildValue(node);
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Thematics/gpp:Thematic
        /** TODO : jsdoc block */
        Thematic : function (node, lyr) {
            if (lyr) {
                var t = new __WEBPACK_IMPORTED_MODULE_10__Response_model_Thematic__["a" /* default */]();
                t.inspire = false;
                t.name = __getChildValue(node);
                // si aucune thématique n'a été ajoutée, on crée le tableau vide
                if (!lyr.thematics || !Array.isArray(lyr.thematics)) {
                    lyr.thematics = [];
                }
                lyr.thematics.push(t);
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Thematics/gpp:InspireThematic
        /** TODO : jsdoc block */
        InspireThematic : function (node, lyr) {
            if (lyr) {
                var t = new __WEBPACK_IMPORTED_MODULE_10__Response_model_Thematic__["a" /* default */]();
                t.inspire = true;
                t.name = __getChildValue(node);
                // si aucune thématique n'a été ajoutée, on crée le tableau vide
                if (!lyr.thematics || !Array.isArray(lyr.thematics)) {
                    lyr.thematics = [];
                }
                lyr.thematics.push(t);
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Originators/gpp:Originator
        /** TODO : jsdoc block */
        Originator : function (node, lyr) {
            if (lyr) {
                // info : contient des balises Attribution, Logo, URL, et Constraints
                var o = new __WEBPACK_IMPORTED_MODULE_6__Response_model_Originator__["a" /* default */]();
                o.name = node.getAttribute("name");
                __getChildNodes(node, o);
                // si aucun originator n'a été ajouté, on crée le tableau vide
                if (!lyr.originators || !Array.isArray(lyr.originators)) {
                    lyr.originators = [];
                }
                lyr.originators.push(o);
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Originators/gpp:Originator/gpp:Attribution
        /** TODO : jsdoc block */
        Attribution : function (node, originator) {
            if (originator && originator.hasOwnProperty("attribution")) {
                originator.attribution = __getChildValue(node);
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Originators/gpp:Originator/gpp:Logo
        /** TODO : jsdoc block */
        Logo : function (node, originator) {
            if (originator && originator.hasOwnProperty("logo")) {
                originator.logo = __getChildValue(node);
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Originators/gpp:Originator/gpp:URL
        /** TODO : jsdoc block */
        URL : function (node, originator) {
            if (originator && originator.hasOwnProperty("url")) {
                originator.url = __getChildValue(node);
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Legends/gpp:Legend
        /** TODO : jsdoc block */
        Legend : function (node, lyr) {
            // 2 balises : sld:MinScaleDenominator et gpp:LegendURL
            var l = new __WEBPACK_IMPORTED_MODULE_4__Response_model_Legend__["a" /* default */]();
            __getChildNodes(node, l);
            if (lyr) {
                // si aucune légende n'a encore été ajoutée, on crée le tableau vide
                if (!lyr.legends || !Array.isArray(lyr.legends)) {
                    lyr.legends = [];
                }
                lyr.legends.push(l);
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Legends/gpp:Legend/gpp:LegendURL
        /** TODO : jsdoc block */
        LegendURL : function (node, legend) {
            if (legend && legend.hasOwnProperty("format")) {
                legend.format = node.getAttribute("format");
                if (node.hasChildNodes) {
                    var child = node.childNodes[0];
                    var childName = child.localName || child.baseName || child.nodeName;
                    if (childName === "OnlineResource" && legend.hasOwnProperty("url")) {
                        legend.url = child.getAttribute("xlink:href");
                    }
                }
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:QuickLook
        /** TODO : jsdoc block */
        QuickLook : function (node, lyr) {
            // info : contient une balise OnlineResource avec l'url dans l'attribut "xlink:href"
            if (node.hasChildNodes) {
                var child = node.childNodes[0];
                var childName = child.localName || child.baseName || child.nodeName;
                if (childName === "OnlineResource" && lyr) {
                    lyr.quicklookUrl = child.getAttribute("xlink:href");
                }
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:MetadataURL
        /** TODO : jsdoc block */
        MetadataURL : function (node, lyr) {
            if (lyr) {
                // info : contient une balise OnlineResource avec l'url dans l'attribut "xlink:href"
                var m = new __WEBPACK_IMPORTED_MODULE_5__Response_model_Metadata__["a" /* default */]();
                m.format = node.getAttribute("format");
                if (node.hasChildNodes) {
                    var child = node.childNodes[0];
                    var childName = child.localName || child.baseName || child.nodeName;
                    if (childName === "OnlineResource") {
                        m.url = child.getAttribute("xlink:href");
                    }
                }
                // si aucune metadata n'a été ajoutée, on crée le tableau vide
                if (!lyr.metadata && !Array.isArray(lyr.metadata)) {
                    lyr.metadata = [];
                }
                lyr.metadata.push(m);
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/gpp:Keys/gpp:Key
        /** TODO : jsdoc block */
        Key : function (node, lyr) {
            if (lyr) {
                // récupération de la clé API
                var key = node.getAttribute("id");
                // si on n'a pas encore ajouté de clé, on crée le tableau vide
                if (!lyr.apiKeys || !Array.isArray(lyr.apiKeys)) {
                    lyr.apiKeys = [];
                }
                lyr.apiKeys.push(key);

                // récupération de l'url du service avec la clé API
                var serverUrl = __getChildValue(node);
                if (!lyr.serviceParams) {
                    lyr.serviceParams = {};
                }
                if (!lyr.serviceParams.serverUrl) {
                    lyr.serviceParams.serverUrl = {};
                }
                if (!lyr.serviceParams.serverUrl[key]) {
                    lyr.serviceParams.serverUrl[key] = serverUrl;
                }
            }
        }

    },

    ows : {
        /** TODO : jsdoc block */
        Identifier : function (node, data) {
            if (data && data.hasOwnProperty("TMS")) { // dans le cas d'un TileMatrixSet
                data.identifier = __getChildValue(node);
            } else if (data && data.hasOwnProperty("matrixId")) { // dans le cas d'une TileMatrix
                data.matrixId = __getChildValue(node);
            }
        },

        /** TODO : jsdoc block */
        SupportedCRS : function (node, tmsData) {
            if (tmsData && tmsData.TMS && tmsData.TMS.hasOwnProperty("projection")) {
                tmsData.TMS.projection = __getChildValue(node);
            }
        }
    },

    sld : {
        // info : /General/Extension/gpp:General/gpp:Territories/gpp:Territory/sld:MinScaleDenominator
        // ou : /LayerList/Layer/sld:MinScaleDenominator
        // ou : /LayerList/Layer/Extension/gpp:Layer/gpp:Originators/gpp:Originator/gpp:Constraints/sld:MinScaleDenominator
        // ou : /LayerList/Layer/Extension/gpp:Layer/gpp:Legends/gpp:Legend/sld:MinScaleDenominator
        /** TODO : jsdoc block */
        MinScaleDenominator : function (node, data) {
            var minScale = __getChildValue(node);
            if (minScale && data) {
                if (data.hasOwnProperty("defaultOptions")) { // cas d'un territoire
                    data.defaultOptions.minScaleDenominator = parseFloat(minScale);
                } else if (data.lyr) { // cas d'une layer
                    if (!data.lyr.globalConstraint) {
                        data.lyr.globalConstraint = new __WEBPACK_IMPORTED_MODULE_1__Response_model_Constraint__["a" /* default */]();
                    }
                    data.lyr.globalConstraint.minScaleDenominator = parseFloat(minScale);
                } else if (data.hasOwnProperty("minScaleDenominator")) { // cas d'une contrainte ou d'une légende
                    data.minScaleDenominator = parseFloat(minScale);
                }
            }
        },

        // info : /General/Extension/gpp:General/gpp:Territories/gpp:Territory/sld:MaxScaleDenominator
        // ou : /LayerList/Layer/sld:MaxScaleDenominator
        // ou : /LayerList/Layer/Extension/gpp:Layer/gpp:Originators/gpp:Originator/gpp:Constraints/sld:MaxScaleDenominator
        /** TODO : jsdoc block */
        MaxScaleDenominator : function (node, data) {
            var maxScale = __getChildValue(node);
            if (maxScale && data) {
                if (data.hasOwnProperty("defaultOptions")) { // cas d'un territoire
                    data.defaultOptions.maxScaleDenominator = parseFloat(maxScale);
                } else if (data.lyr) { // cas d'une layer
                    if (!data.lyr.globalConstraint) {
                        data.lyr.globalConstraint = new __WEBPACK_IMPORTED_MODULE_1__Response_model_Constraint__["a" /* default */]();
                    }
                    data.lyr.globalConstraint.maxScaleDenominator = parseFloat(maxScale);
                } else if (data.hasOwnProperty("maxScaleDenominator")) { // cas d'une contrainte
                    data.maxScaleDenominator = parseFloat(maxScale);
                }
            }
        }
    },

    wmts : {

        // info : /LayerList/Layer/Extension/gpp:Layer/wmts:TileMatrixSetLink/wmts:TileMatrixSetLimits
        /** TODO : jsdoc block */
        TileMatrixSetLimits : function (node, lyr) {
            // info : contient des balises wmts:TileMatrixLimits
            if (lyr) {
                var limits = {};
                // on récupère les limites dans les balises TileMatrixLimits
                __getChildNodes(node, limits);

                if (!lyr.wmtsOptions) {
                    lyr.wmtsOptions = {};
                }
                lyr.wmtsOptions.tileMatrixSetLimits = limits;
            }
        },

        // info : /LayerList/Layer/Extension/gpp:Layer/wmts:TileMatrixSetLink/wmts:TileMatrixSetLimits/wmts:TileMatrixLimits
        /** TODO : jsdoc block */
        TileMatrixLimits : function (node, limits) {
            var limit = new __WEBPACK_IMPORTED_MODULE_13__Response_model_TileMatrixLimit__["a" /* default */]();
            var limitId;
            if (node.hasChildNodes) {
                var children = node.childNodes;
                for (var i = 0; i < children.length; i++) {
                    var child = children[i];
                    var childName = child.localName || child.baseName || child.nodeName;
                    if (childName === "TileMatrix") {
                        limitId = __getChildValue(child);
                    } else if (childName === "MinTileRow") {
                        limit.minTileRow = __getChildValue(child);
                    } else if (childName === "MaxTileRow") {
                        limit.maxTileRow = __getChildValue(child);
                    } else if (childName === "MinTileCol") {
                        limit.minTileCol = __getChildValue(child);
                    } else if (childName === "MaxTileCol") {
                        limit.maxTileCol = __getChildValue(child);
                    }
                }
                if (limitId && limits && !limits[limitId]) {
                    limits[limitId] = limit;
                }
            }
        },

        // info : /General/Extension/gpp:General/gpp:TileMatrixSets/wmts:TileMatrixSet
        // ou : // info : /LayerList/Layer/Extension/gpp:Layer/wmts:TileMatrixSetLink/wmts:TileMatrixSet
        /** TODO : jsdoc block */
        TileMatrixSet : function (node, data) {
            // info : Describes a particular set of tile matrices.

            if (data && data.tileMatrixSets) { // les tileMatrixSets de General
                // nouvel objet TileMatrixSet
                var tmsData = {};
                tmsData.TMS = new __WEBPACK_IMPORTED_MODULE_11__Response_model_TileMatrixSet__["a" /* default */]();
                tmsData.resolutions = [];

                // lecture des informations du TMS
                __getChildNodes(node, tmsData);

                // récupération des identifiants des niveaux de matrice (pour faciliter l'accès au WMTS via les API carto)
                var tileMatrices = tmsData.TMS.tileMatrices;
                for (var tm in tileMatrices) {
                    if (tileMatrices.hasOwnProperty(tm)) {
                        tmsData.TMS.matrixIds.push(tm);
                    }
                }

                if (tmsData.TMS.getProjection() === "IGNF:WGS84G" || tmsData.TMS.getProjection() === "EPSG:4326") {
                    if (data.generalOptions && Array.isArray(data.generalOptions.wgs84Resolutions)) {
                        var wgs84Resolutions = data.generalOptions.wgs84Resolutions;
                        for (var i = 0; i < wgs84Resolutions.length; i++) {
                            // info : les résolutions stockées dans wgs84Resolutions, issues de l'autoconf, sont des string
                            tmsData.resolutions[i] = parseFloat(wgs84Resolutions[i]);
                        }
                    }
                }

                // tri des résolutions (par ordre décroissant cette fois)
                if (Array.isArray(tmsData.resolutions) && tmsData.resolutions.sort !== undefined) {
                    tmsData.resolutions.sort(
                        function (x, y) {
                            return y - x;
                        }
                    );
                }
                tmsData.TMS.nativeResolutions = tmsData.resolutions;

                // ajout du TileMatrixSet à la variable config
                data.tileMatrixSets[tmsData.identifier] = tmsData.TMS;
            } else { // le TileMatrixSetLink d'une couche (layer)
                if (data && !data.wmtsOptions) {
                    data.wmtsOptions = {};
                }
                // ajout du lien vers le TMS
                data.wmtsOptions.tileMatrixSetLink = __getChildValue(node);
            }
        },

        // info : /General/Extension/gpp:General/gpp:TileMatrixSets/wmts:TileMatrixSet/wmts:TileMatrix
        /** TODO : jsdoc block */
        TileMatrix : function (node, tmsData) {
            // info : Describes a particular tile matrix.

            if (tmsData) {
                // nouveau niveau de matrice : TileMatrix
                var tileMatrix = new __WEBPACK_IMPORTED_MODULE_12__Response_model_TileMatrix__["a" /* default */]();

                // lecture des information du TileMatrix
                __getChildNodes(node, tileMatrix);

                // calcul de la résolution associée au dénominateur d'échelle du niveau de pyramide, selon la projection.
                if (tmsData.TMS && tmsData.TMS.getProjection()) {
                    var proj = tmsData.TMS.getProjection();
                    if (proj === "EPSG:3857" || proj === "EPSG:2154") {
                        // calcul de la résolution associée, en m/px
                        // en se basant sur une "taille standard de pixel" de 0.28mm*0.28mm (standard WMTS 1.0)
                        var r = tileMatrix.scaleDenominator * 0.00028;
                        if (tmsData.resolutions && Array.isArray(tmsData.resolutions)) {
                            tmsData.resolutions.push(r);
                        }
                    }
                }

                // ajout du TileMatrix au TileMatrixSet
                if (tmsData.TMS && tmsData.TMS.tileMatrices) {
                    tmsData.TMS.tileMatrices[tileMatrix.matrixId] = tileMatrix;
                }
            }
        },

        // info : /General/Extension/gpp:General/gpp:TileMatrixSets/wmts:TileMatrixSet/wmts:TileMatrix/wmts:ScaleDenominator
        /** TODO : jsdoc block */
        ScaleDenominator : function (node, tileMatrix) {
            var scale = __getChildValue(node);
            if (scale && tileMatrix && tileMatrix.hasOwnProperty("scaleDenominator")) {
                tileMatrix.scaleDenominator = parseFloat(scale);
            }
        },

        // info : /General/Extension/gpp:General/gpp:TileMatrixSets/wmts:TileMatrixSet/wmts:TileMatrix/wmts:TopLeftCorner
        /** TODO : jsdoc block */
        TopLeftCorner : function (node, tileMatrix) {
            var values = __getChildValue(node).split(" ");
            if (values && tileMatrix) {
                tileMatrix.topLeftCorner = {};
                tileMatrix.topLeftCorner.x = parseFloat(values[0]);
                tileMatrix.topLeftCorner.y = parseFloat(values[1]);
            }
        },

        // info : /General/Extension/gpp:General/gpp:TileMatrixSets/wmts:TileMatrixSet/wmts:TileMatrix/wmts:TileWidth
        /** TODO : jsdoc block */
        TileWidth : function (node, tileMatrix) {
            var value = __getChildValue(node);
            if (value && tileMatrix && tileMatrix.hasOwnProperty("tileWidth")) {
                tileMatrix.tileWidth = parseInt(value, 10);
            }
        },

        // info : /General/Extension/gpp:General/gpp:TileMatrixSets/wmts:TileMatrixSet/wmts:TileMatrix/wmts:TileHeight
        /** TODO : jsdoc block */
        TileHeight : function (node, tileMatrix) {
            var value = __getChildValue(node);
            if (value && tileMatrix && tileMatrix.hasOwnProperty("tileHeight")) {
                tileMatrix.tileHeight = parseInt(value, 10);
            }
        },

        // info : /General/Extension/gpp:General/gpp:TileMatrixSets/wmts:TileMatrixSet/wmts:TileMatrix/wmts:MatrixWidth
        /** TODO : jsdoc block */
        MatrixWidth : function (node, tileMatrix) {
            var value = __getChildValue(node);
            if (value && tileMatrix && tileMatrix.hasOwnProperty("matrixWidth")) {
                tileMatrix.matrixWidth = parseInt(value, 10);
            }
        },

        // info : /General/Extension/gpp:General/gpp:TileMatrixSets/wmts:TileMatrixSet/wmts:TileMatrix/wmts:MatrixHeight
        /** TODO : jsdoc block */
        MatrixHeight : function (node, tileMatrix) {
            var value = __getChildValue(node);
            if (value && tileMatrix && tileMatrix.hasOwnProperty("matrixHeight")) {
                tileMatrix.matrixHeight = parseInt(value, 10);
            }
        }
    },

    /** TODO : jsdoc block */
    serviceException : function (node) {
        var response = {};
        if (node.hasChildNodes()) {
            var children = node.childNodes;
            var child;
            for (var i = 0; i < children.length; i++) {
                child = children[i];
                if (child.nodeName === "exception") {
                    response.exceptionReport = AutoConfResponseReader.READERS["exception"](child);
                }
            }
        }
        return response;
    },

    /** TODO : jsdoc block */
    exception : function (node) {
        var exceptionReport = {};

        // get exception code
        var exceptionCode = node.getAttribute("code");
        if (exceptionCode) {
            exceptionReport.exceptionCode = exceptionCode;
        }

        // get exception message
        var textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            exceptionReport.exception = textNode.nodeValue;
        }

        return exceptionReport;
    }

};

/**
 * Méthode permettant de lancer la lecture d'une réponse XML du service d'autoconf,
 *      à l'aide des READERS de la classe.
 *
 * @method AutoConfResponseReader.read
 * @param {DOMElement} root - racine de la réponse XML à lire
 * @return {Object} config|exceptionReport : l'objet contenant les informations de la réponse XML,
 *      sous la forme d'un objet AutoConfResponse, ou un objet littéral exceptionReport si le service a renvoyé une exception.
 * @static
 * @memberof AutoConfResponseReader
 */
AutoConfResponseReader.read = function (root) {
    if (root.nodeName === "ViewContext") {
        var nsPrefix = root.prefix || AutoConfResponseReader.DEFAULTPREFIX;
        var config = AutoConfResponseReader.READERS[nsPrefix][root.nodeName](root);
        return config;
    } else if (root.nodeName === "serviceException") {
        var exceptionReport = AutoConfResponseReader.READERS[root.nodeName](root);
        return exceptionReport;
    } else {
        throw new Error("Erreur lors de la lecture de la réponse : elle n'est pas au format attendu.");
    }
};

/**
 * Récupération des attributs d'un noeud élément
 *
 * @private
 * @memberof AutoConfResponseReader
 * @method __getAttributes
 * @param {DOMElement} node - noeud contenant l'attribut recherché
 * @return {Object} nodeAttributes - objet contenant les noms et valeurs des différents attributs
 */
function __getAttributes (node) {
    if (node.attributes.length > 0) {
        var nodeAttributes = {};
        var attributes = node.attributes;
        for (var i = 0; i < attributes.length; i++) {
            var attribute = attributes[i];
            nodeAttributes[attribute.nodeName] = attribute.nodeValue;
        }
        return nodeAttributes;
    }
}

/**
 * Récupération des noeuds enfants (seulement de type ELEMENT), à partir d'un noeud donné, pour lecture (readNode).
 *
 * @private
 * @memberof AutoConfResponseReader
 * @method __getChildNodes
 * @param {DOMElement} node - a DOM node
 * @param {Array|Object} [data] - an object to be filled with node data
 */
function __getChildNodes (node, data) {
    if (node.hasChildNodes()) {
        var children = node.childNodes;
        var child;
        var childName;
        var childPrefix;

        for (var i = 0; i < children.length; i++) {
            child = children[i];

            if (child.nodeType === 1) { // 1 === node.ELEMENT_NODE
                childName = child.localName || child.baseName || child.nodeName;
                childPrefix = child.prefix || AutoConfResponseReader.DEFAULTPREFIX;

                if (AutoConfResponseReader.READERS[childPrefix][childName]) {
                    var reader = AutoConfResponseReader.READERS[childPrefix][childName];
                    reader(child, data);
                } else {
                    __getChildNodes(child, data);
                }
            }
        }
    }
}

/**
 * Lecture de la valeur du premier child d'un noeud, si elle existe.
 *
 * @private
 * @memberof AutoConfResponseReader
 * @method __getChildValue
 * @param {DOMElement} node - a DOM node
 * @return {String} value - valeur du firstChild du noeud en entrée, ou chaîne vide.
 */
function __getChildValue (node) {
    var textNode;
    var value = "";

    if (node.hasChildNodes()) {
        textNode = node.firstChild;
        if (textNode.nodeType === 3 || textNode.nodeType === 4) { // 3 === node.TEXT_NODE
            value = textNode.nodeValue;
        }
    }
    return value;
}

/**
 * Vérification des attributs du service, dans la balise XLS de la réponse :
 *      version, namespaces, et namespace par défaut doivent correspondre à ceux attendus.
 *
 * @private
 * @memberof AutoConfResponseReader
 * @method __checkServiceAttributes
 * @param {DOMElement} viewContextNode - a DOM node, corresponding to XLS first tag.
 */
function __checkServiceAttributes (viewContextNode) {
    if (viewContextNode.attributes.length > 0) {
        // on récupère et parcourt les attributs de la balise XLS de la réponse
        var xlsAttributes = __getAttributes(viewContextNode);
        for (var att in xlsAttributes) {
            if (xlsAttributes.hasOwnProperty(att)) {
                // vérification de la version
                if (att === "version") {
                    if (xlsAttributes["version"] !== AutoConfResponseReader.VERSION) {
                        // console.log("[AutoConfResponseReader] autoconf version is not the expected one : there may be errors in parsing");
                        return;
                    }
                }

                // on vérifie que l'uri du namespace par défaut est bien celle que l'on attend
                if (att === "xmlns") {
                    if (xlsAttributes[att] !== AutoConfResponseReader.NAMESPACES.xmlns) {
                        // console.log("[AutoConfResponseReader] autoconf response default namespace is not the expected one");
                        return;
                    }
                    continue;
                }

                var prefix = att.split(":")[0];
                var ns = att.split(":")[1];

                // si on a un autre xmlns, on vérifie aussi les URI
                if (prefix === "xmlns" && ns) {
                    // si l'attribut correspond à un namespace défini dans le reader
                    if (AutoConfResponseReader.NAMESPACES[ns]) {
                        // il faut que les URI correspondent aussi.
                        if (AutoConfResponseReader.NAMESPACES[ns] !== xlsAttributes[att]) {
                            // console.log("[AutoConfResponseReader] autoconf response " + att + " namespace is not the expected one");
                            return;
                        }
                    }
                }

                // pour finir on vérifie la localisation du schema XSD du service
                if (ns === "schemaLocation") {
                    if (xlsAttributes[att] !== AutoConfResponseReader.SCHEMALOCATION[0] && xlsAttributes[att] !== AutoConfResponseReader.SCHEMALOCATION[1]) {
                        // console.log("[AutoConfResponseReader] autoconf response schema location is not the expected one");
                        return;
                    }
                }
            }
        }
    }
}

/* harmony default export */ __webpack_exports__["a"] = (AutoConfResponseReader);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonService__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Request_DirectGeocodeRequestFactory__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Response_DirectGeocodeResponseFactory__ = __webpack_require__(76);








/**
 * @classdesc
 * Appel du service de géocodage direct du Géoportail :
 *     envoi de la requête construite selon les paramètres en options,
 *     éventuellement parsing et analyse  de la réponse,
 *     retour d'une réponse en paramètre de la fonction onSuccess.
 *
 *
 * @constructor
 * @extends {Gp.Services.CommonService}
 * @alias Gp.Services.Geocode
 *
 * @param {Object} options - options spécifiques au service (+ les options heritées)
 *
 * @param {String|Object} options.location - Nom de l'adresse, du toponyme, de l'unité administrative ou de la parcelle cadastrale recherchée.
 *      Sous forme de String, la propriété permet de faire une recherche déstructurée.
 *      Sous forme d'objet, la propriété permet de structurer la recherche.
 *      Dans ce cas, les propriétés possibles de cet objet sont décrites ci-après.
 *      @param {Number} [options.location.number] - Numéro du bâtiment de l'adresse recherchée, dans le cas d'une recherche structurée
 *      (si options.location est un objet Javascript).
 *      @param {String} [options.location.street] - Nom de la rue de l'adresse recherchée, dans le cas d'une recherche structurée
 *      (si options.location est un objet Javascript).
 *      @param {String} [options.location.city] - Nom de la ville de l'adresse recherchée, dans le cas d'une recherche structurée
 *      (si options.location est un objet Javascript).
 *      @param {Number} [options.location.postalCode] - Numéro du code postal de l'adresse recherchée, dans le cas d'une recherche structurée
 *      (si options.location est un objet Javascript).
 *
 * @param {Object} [options.filterOptions] - Les propriétés possibles de cet objet sont décrites ci-après.
 * @param {Object} [options.filterOptions.bbox] - Emprise dans laquelle on souhaite effectuer la recherche.
 *      Les propriétés possibles de cet objet sont décrites ci-après.
 *      @param {Float} options.filterOptions.bbox.left - Abscisse du côté gauche de la BBOX
 *      @param {Float} options.filterOptions.bbox.right - Abscisse du côté droit de la BBOX
 *      @param {Float} options.filterOptions.bbox.top - Ordonnée supérieure de la BBOX
 *      @param {Float} options.filterOptions.bbox.bottom - Ordonnée inférieure de la BBOX
 *
 * @param {Array.<String>} [options.filterOptions.type = "StreetAddress"] - Type de l'objet recherché.
 *      Le service de géocodage du Géoportail permet de rechercher des 'PostionOfInterest' pour des toponymes, des 'StreetAddress'
 *      pour des adresses postales, et/ou des 'CadastralParcel' pour des parcelles cadastrales.
 *      D'autres types pourront être rajoutés selon l'évolution du service.
 *      Par défaut, type = ['StreetAddress'].
 *
 * @param {String} [options.filterOptions.[proprietes du filtre]] - Critère supplémentaire pour filtrer la recherche sous la forme
 *      d'un couple clé/valeur à définir selon les possibilités du serveur ajouté à la requête.
 *      Le service de géocodage du Géoportail permet de filtrer tous les résultats avec les propriétés :
 *          "municipality", "insee", et "department".
 *      Il permet aussi de filtrer les adresses postales avec les propriétés :
 *          "quality", "ID", "ID_TR" et "territory".
 *      Il permet de filtrer les toponymes avec les propriétés :
 *          "importance", "nature" et "territory".
 *      Enfin, il permet de filtrer les parcelles cadastrales avec les propriétés :
 *          "sheet", "section", et "absorbedcity". Pas de valeur par défaut.
 *
 * @param {Number} [options.maximumResponses] - Nombre de réponses maximal que l'on souhaite recevoir.
 *      Pas de valeur par défaut.
 *      Si le serveur consulté est celui du Géoportail, la valeur par défaut sera donc celle du service : 25.
 *
 * @param {Boolean} [options.returnFreeForm] - Indique si l'on souhaite en réponse un localisant concaténée plutôt que structuré.
 *      Pas de valeur par défaut. Si le serveur consulté est celui du Géoportail, la valeur par défaut sera donc celle du service : 'false'.
 *
 * @param {String} [options.srs] - Système de coordonnées dans lequel les paramètres géographiques en entrée et la réponse du service sont exprimés.
 *      Pas de valeur par défaut. Si le serveur consulté est celui du Géoportail, la valeur par défaut sera donc celle du service : 'EPSG:4326'.
 *
 * @example
 *   var options = {
 *      apiKey : null,
 *      serverUrl : 'http://localhost/service/',
 *      protocol : 'JSONP', // JSONP|XHR
 *      proxyURL : null,
 *      httpMethod : 'GET', // GET|POST
 *      timeOut : 10000, // ms
 *      rawResponse : false, // true|false
 *      scope : null, // this
 *      onSuccess : function (response) {},
 *      onFailure : function (error) {},
 *      // spécifique au service
 *      positions : [{lon:, lat:}, {lon:, lat:}],
 *      (...)
 *   };
 * @private
 */
function Geocode (options) {
    if (!(this instanceof Geocode)) {
        throw new TypeError(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("CLASS_CONSTRUCTOR", "Geocode"));
    }

    /**
     * Nom de la classe (heritage)
     * FIXME instance ou classe ?
     */
    this.CLASSNAME = "Geocode";

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_3__CommonService__["a" /* default */].apply(this, arguments);

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("Gp.Services.Geocode");
    // this.// logger.trace("[Constructeur Geocode (options)]");

    if (!options.location) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "location"));
    }

    // FIXME ECMAScript 5 support
    if (typeof options.location === "object" && Object.keys(options.location).length === 0) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_EMPTY", "location"));
    } else if (typeof options.location === "string" && options.location.length === 0) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_EMPTY", "location"));
    }

    // ajout des options spécifiques au service
    this.options.location = options.location;

    // on definit des filtres apr defaut
    if (!options.filterOptions || typeof options.filterOptions !== "object") {
        this.options.filterOptions = options.filterOptions = {
            type : ["StreetAddress"]
        };
    }

    // FIXME ECMAScript 5 support (valable pour un objet uniquement !)
    // ceci permet de tester le cas où 'options.filterOptions' : {}
    if (Object.keys(options.filterOptions).length === 0) {
        this.options.filterOptions = {
            type : ["StreetAddress"]
        };
    }

    var filter = Object.keys(options.filterOptions);
    for (var i = 0; i < filter.length; i++) {
        var key = filter[i];
        // on transforme certains filtres qui pourraient être numériques en string
        var filtersCouldBeNumberList = ["department", "number", "postalCode", "insee", "importance", "ID", "IDTR", "absorbedCity", "sheet", "section", "inseeRegion", "inseeDepartment"];
        if (filtersCouldBeNumberList.indexOf(key) !== -1 && typeof options.filterOptions[key] !== "string") {
            options.filterOptions[key] = options.filterOptions[key].toString();
        }
        // on supprime les filtres vides
        if (!options.filterOptions[key]) {
            delete this.options.filterOptions[key];
        }
    }

    this.options.filterOptions.type = options.filterOptions.type || ["StreetAddress"];
    this.options.maximumResponses = options.maximumResponses || 25;
    this.options.returnFreeForm = options.returnFreeForm || false;
    this.options.srs = options.srs || "EPSG:4326";

    // attributs d'instances

    /**
     * Format forcé de la réponse du service : "xml"
     * sauf si l'on souhaite une reponse brute (options.rawResponse)
     */
    this.options.outputFormat = (this.options.rawResponse) ? "" : "xml";
}

/**
 * @lends module:Geocode#
 */
Geocode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_3__CommonService__["a" /* default */].prototype, {
    // todo
    // getter/setter
});

/*
 * Constructeur (alias)
 */
Geocode.prototype.constructor = Geocode;

/**
 * Création de la requête (overwrite)
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback
 */
Geocode.prototype.buildRequest = function (error, success) {
    var options = {
        httpMethod : this.options.httpMethod,
        // options specifiques du service
        location : this.options.location,
        returnFreeForm : this.options.returnFreeForm,
        filterOptions : this.options.filterOptions,
        srs : this.options.srs,
        maximumResponses : this.options.maximumResponses
    };

    this.request = __WEBPACK_IMPORTED_MODULE_4__Request_DirectGeocodeRequestFactory__["a" /* default */].build(options);

    // on teste si la requete a bien été construite !
    (!this.request)
        ? error.call(this, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_REQUEST_BUILD")))
        : success.call(this, this.request);
};

/**
 * Analyse de la reponse (overwrite)
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback
 */
Geocode.prototype.analyzeResponse = function (error, success) {
    /* INFO :
         Etape 1 : Création de la requête
            -> Appel du format OpenLS pour créer une requête à partir des paramètres (par exemple)
              (soit directement une URL si GET, soit une requête XML si POST)
            /!\ tester si apiKey && serverUrl => on ne garde que serverUrl
            -> stockage de la requête dans this.request
         Etape 2 : Envoi de la requête selon le bon protocole
            -> appel du protocol JSONP ou XHR, et envoi (par ex send ()) (this.protocol)
            -> récupération de la réponse xml dans la fonction onSuccess () (this.response)
            -> si code HTTP 200 et pas de message d'erreur : etape 3
            -> si code HTTP != 200 : lancement de la fonction de callback onFailure avec le message d'erreur
         Etape 3 : Analyse de la réponse xml et construction du JSON (si rawResponse === false )
            -> appel du parser pour récupérer le xmlDocument
            -> appel du reader OpenLS pour lire les éléments et récupérer l'objet JSON
               correspondant au type de géocodage (défini dans les specs)
         Etape 4 : Lancement de la fonction de callback onSuccess avec la réponse :
            -> xmlResponse (si rawResponse === true)
            -> ou geocodedLocations
    */

    if (this.response) {
        var options = {
            response : this.response,
            rawResponse : this.options.rawResponse,
            onError : error,
            onSuccess : success,
            scope : this
        };

        __WEBPACK_IMPORTED_MODULE_5__Response_DirectGeocodeResponseFactory__["a" /* default */].build(options);
    } else {
        error.call(this, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Geocode);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Formats_XLS__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Formats_XLS_LocationUtilityService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formats_XLS_LocationUtilityService_GeocodeFilterExtension__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Request_model_StreetAddress__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Request_model_PositionOfInterest__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Request_model_CadastralParcel__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Request_model_Administratif__ = __webpack_require__(75);
/**
 * Creation d'une requête OpenLS en mode POST ou GET
 * (Factory)
 *
 * @module DirectGeocodeRequestFactory
 * @alias Gp.Services.Geocode.Request.DirectGeocodeRequestFactory
 * @private
 */









var DirectGeocodeRequestFactory = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant Geocode
     *
     * @example
     *   var options = {
     *      httpMethod:
     *      // options specifiques du service
     *      location:
     *      returnFreeForm:
     *      filterOptions:
     *      srs:
     *      maximumResponses:
     *   };
     *   var result = DirectGeocodeRequestFactory.build(options);
     *   if (!result) {
     *       // error...
     *   }
     * @returns {String} request
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("DirectGeocodeRequestFactory");
        // logger.trace(["DirectGeocodeRequestFactory::build()"]);

        var request = null;

        // gestion des filtres (table de geocodage) !
        // par defaut, on les ajoute toute ...
        var oFilter = new __WEBPACK_IMPORTED_MODULE_3__Formats_XLS_LocationUtilityService_GeocodeFilterExtension__["a" /* default */]();
        oFilter.addFilterExtensions(new __WEBPACK_IMPORTED_MODULE_7__Request_model_Administratif__["a" /* default */]());
        oFilter.addFilterExtensions(new __WEBPACK_IMPORTED_MODULE_4__Request_model_StreetAddress__["a" /* default */]());
        oFilter.addFilterExtensions(new __WEBPACK_IMPORTED_MODULE_5__Request_model_PositionOfInterest__["a" /* default */]());
        oFilter.addFilterExtensions(new __WEBPACK_IMPORTED_MODULE_6__Request_model_CadastralParcel__["a" /* default */]());

        // objet LUS
        // on peut aussi par un objet XLS::GeocodeRequest
        var oLUS = new __WEBPACK_IMPORTED_MODULE_2__Formats_XLS_LocationUtilityService__["a" /* default */]({
            location : options.location,
            returnFreeForm : options.returnFreeForm,
            filterOptions : options.filterOptions
        });
        oLUS.addFilter(oFilter);

        // Format XLS
        var oXLS = new __WEBPACK_IMPORTED_MODULE_1__Formats_XLS__["a" /* default */]({
            srsName : options.srs,
            maximumResponses : options.maximumResponses
        });
        oXLS.namespace = true;
        oXLS.setService(oLUS);

        // request brute !
        request = oXLS.build();

        // en mode GET, la requête est encodée
        // et le param. 'qxml' est ajouté
        if (options.httpMethod === "GET") {
            var myRequest = "qxml=" +
                encodeURIComponent(request)
                    .replace(/-/g, "%2D")
                    .replace(/_/g, "%5F")
                    .replace(/\./g, "%2E")
                    .replace(/!/g, "%21")
                    .replace(/~/g, "%7E")
                    .replace(/\*/g, "%2A")
                    .replace(/'/g, "%27")
                    .replace(/\(/g, "%28")
                    .replace(/\)/g, "%29");
            request = myRequest;
        }

        // logger.trace(request);

        return request;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DirectGeocodeRequestFactory);


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);


/**
 * @classdesc
 *
 * Entête de la requête XSL
 *
 * @example
 * // header XSL
 * header = new RequestHeader ();
 * header.srsName = "epsg:4326";
 * header.toString();
 * // out ->
 * // <RequestHeader srsName="epsg:4326"/>
 *
 * @constructor
 * @alias Gp.Formats.XLS.RequestHeader
 * @param {Object} options - options
 * @param {Object}   options.srsName - projection
 * @param {Function} options.onsuccess - function callback success (TODO)
 * @param {Function} options.onerror   - function callback error   (TODO)
 *
 * @private
 */
function RequestHeader (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur RequestHeader ()]");

    if (!(this instanceof RequestHeader)) {
        throw new TypeError("RequestHeader constructor cannot be called as a function.");
    }

    // options par defaut
    this.options = options || {
        srsName : "EPSG:4326"
    };

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            this.options[opt] = options[opt];
        }
    }
}

RequestHeader.prototype = {

    /**
     * @lends module:RequestHeader#
     */

    /**
     * request (out)
     * @type {String}
     */
    requestString : null,

    /**
     * Template de la requête.
     * substitution des valeurs suivantes :
     * __SRSNAME__
     */
    template : "<RequestHeader srsName=\"__SRSNAME__\"/>",

    /**
     * Constructeur (alias)
     */
    constructor : RequestHeader,

    /**
     * toString
     * @returns {String} requête
     */
    toString : function () {
        var template = null;
        template = this.template;
        template = template.replace(/__SRSNAME__/g, this.options.srsName);
        this.requestString = template;
        return this.requestString;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (RequestHeader);


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* jshint bitwise: false */


/**
 * @classdesc
 *
 * Requête XLS
 *
 * @example
 * // request XSL
 * request = new Request ();
 * request.maximumResponses = 26;
 * request.methodName = "GeocodeRequest";
 * request.version = "1.2";
 * request.toString();
 * // out ->
 * // <Request maximumResponses="26" methodName="GeocodeRequest" requestID="uid1349081498314_388" version="1.2">
 * //   <!-- __LUS__ -->
 * //  </Request>
 *
 * @constructor
 * @alias Gp.Formats.XLS.Request
 * @param {Object} options - options
 * @param {Object}   options.maximumResponses - 25
 * @param {String}   options.methodName - nom de l'objet LUS, "GeocodeRequest" | "ReverseGeocodeRequest"
 * @param {String}   options.version - '1.2'
 * @param {Function} options.onsuccess - function callback success (TODO)
 * @param {Function} options.onerror   - function callback error   (TODO)
 *
 * @private
 */
function Request (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur Request ()]");

    if (!(this instanceof Request)) {
        throw new TypeError("Request constructor cannot be called as a function.");
    }

    // options par defaut
    this.options = options || {
        maximumResponses : 25,
        methodName : null,
        version : "1.2"
    };

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            this.options[opt] = options[opt];
        }
    }
}

Request.prototype = {

    /**
     * @lends module:Request#
     */

    /**
     * request (out)
     * @type {String}
     */
    requestString : null,

    /**
     * Template de la requête.
     * substitution des valeurs suivantes :
     * __MAXRESPONSES__, __METHODNAME__, __UUID__, __VERSION__
     * __REQUESTSERVICE__
     */
    template : "<Request maximumResponses=\"__MAXRESPONSES__\" methodName=\"__METHODNAME__\" requestID=\"__UUID__\" version=\"__VERSION__\">" +
        "<!-- __REQUESTSERVICE__ -->" +
        "</Request>",

    /**
     * Constructeur (alias)
     */
    constructor : Request,

    /**
     * an rfc4122 version 4 compliant guid
     * @returns {String} guid
     */
    guid : function () {
        // INFO
        // cf. http://byronsalau.com/blog/how-to-create-a-guid-uuid-in-javascript/
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            var v = c === "x" ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },

    /**
     * toString
     * @returns {String} requête
     */
    toString : function () {
        var template = null;
        template = this.template;
        template = template.replace(/__MAXRESPONSES__/g, this.options.maximumResponses);
        template = template.replace(/__METHODNAME__/g, this.options.methodName);
        template = template.replace(/__UUID__/g, this.guid());
        template = template.replace(/__VERSION__/g, this.options.version);

        this.requestString = template;
        return this.requestString;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Request);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Address__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GeocodeFilterExtension__ = __webpack_require__(13);




/**
 * @classdesc
 * Requête de geocodage direct
 *
 * ```
 * XSD
 * Geocodage direct (balise xsd) :
 *   element ref="RequestHeader" [ (attribute name="clientName" attribute name="clientPassword" attribute name="sessionID" attribute name="srsName" attribute name="MSID") ]
 *     element name="Request" attribute name="methodName" attribute name="version" attribute name="requestID" [ attribute name="maximumResponses" ]
 *       element name="GeocodeRequest" attribute name="returnFreeForm"
 *         element ref="xls:Address"
 * ```
 *
 * @example
 * // creation de l'objet Geocode an ajoutant un objet Address
 * req = new GeocodeRequest ();
 * req.returnFreeForm = true; // TODO !
 * req.addAddress (new Address ({
 *      location : "saint mandé",
 *      type : ['PositionOfInterest'],
 *      filter : {
 *          (...)
 *      }
 * }));
 * req.toString();
 * // out ->
 * // <GeocodeRequest>
 * //   <Address countryCode="PositionOfInterest">
 * //     <freeFormAddress>saint mandé</freeFormAddress>
 * //   </Address>
 * // </GeocodeRequest>
 *
 * // creation de l'objet Geocode avec les options uniquement
 * req = new GeocodeRequest ({
 *      location : "saint mandé",
 *      returnFreeForm : true,
 *      filterOptions : {
 *          type : ['PositionOfInterest'],
 *          (...)
 *      }
 * });
 * req.toString();
 * // out ->
 * // <GeocodeRequest>
 * //   <Address countryCode="PositionOfInterest">
 * //     <freeFormAddress>saint mandé</freeFormAddress>
 * //   </Address>
 * // </GeocodeRequest>
 * @constructor
 *
 * @alias Gp.Formats.XLS.LocationUtilityService.GeocodeRequest
 * @param {Object} options - options
 * @param {Object}   options.location - location
 * @param {String}   options.returnFreeForm - returnFreeForm
 * @param {String}   options.filterOptions - filtres
 * @param {Function} options.onsuccess - function callback success (TODO)
 * @param {Function} options.onerror   - function callback error   (TODO)
 *
 * @private
 */
function GeocodeRequest (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur GeocodeRequest ()]");

    if (!(this instanceof GeocodeRequest)) {
        throw new TypeError("GeocodeRequest constructor cannot be called as a function.");
    }

    // options par defaut
    this.options = options || {};

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            this.options[opt] = options[opt];
        }
    }

    // TODO
    // gestion de l'option 'returnFreeForm' si elle n'est pas renseignée dans les options !

    /**
     * Nom de la classe (heritage)
     */
    this.CLASSNAME = "GeocodeRequest";
}

GeocodeRequest.prototype = {

    /**
     * @lends module:GeocodeRequest#
     */

    /**
     * request (out)
     * @type {String}
     */
    strRequest : null,

    /**
     * Addresse
     * @type {Address}
     */
    oAddress : null,

    /**
     * Filter
     * @type {GeocodeFilterExtension}
     */
    oFilter : null,

    /**
     * Template de la requête.
     * substitution des valeurs suivantes :
     * __ADDRESS__, __RETURNFREEFORM__
     */
    template : "<GeocodeRequest returnFreeForm=\"__RETURNFREEFORM__\">" +
        "__ADDRESS__" +
        "</GeocodeRequest>",

    /**
     * Ajout d'un objet de type Adresse
     *
     * @param {Object} oAddress - Adresse
     */
    addAddress : function (oAddress) {
        if (oAddress instanceof __WEBPACK_IMPORTED_MODULE_1__model_Address__["a" /* default */]) {
            this.oAddress = oAddress;
        }
    },

    /**
     * Ajout d'un objet de type GeocodeFilterExtension
     *
     * @param {Object} oFilter - GeocodeFilterExtension
     */
    addFilter : function (oFilter) {
        // FIXME gestion des filtres à partir des tables de geocodages
        if (oFilter instanceof __WEBPACK_IMPORTED_MODULE_2__GeocodeFilterExtension__["a" /* default */]) {
            this.oFilter = oFilter;
        }
    },

    /**
     * Constructeur (alias)
     */
    constructor : GeocodeRequest,

    /**
     * toString
     *
     * @returns {String} requête
     */
    toString : function () {
        var template = "";
        template = this.template;

        // soit on a déjà un objet Address instancié,
        // sinon, on le fabrique via les options
        if (!this.oAddress) {
            var settings = {};
            settings.location = this.options.location;
            settings.type = this.options.filterOptions.type || ["StreetAddress"];
            settings.filter = this.options.filterOptions;
            delete settings.filter.type; // on ne met pas le 'type' dans les filtres...

            // gestion des filtres
            if (this.oFilter) {
                // on reconstruit les filtres
                settings.filter = {};

                // on determine la liste des filtres possibles
                // pour chaque table de geocodage en param
                for (var idx in settings.type) {
                    var filter = settings.type[idx];
                    var oFilter = this.oFilter.getFilter(filter);

                    if (!oFilter) {
                        this.logger.warn("Le filtre '" + filter + "' n'existe pas !?");
                        continue;
                    }

                    var mFilter = this.options.filterOptions;

                    // correspondances des attributs de filtres possibles avec ceux qui sont en options
                    var attributs = oFilter.attributesList;
                    for (var idxe = 0; idxe < attributs.length; idxe++) {
                        var key = attributs[idxe];
                        if (mFilter[key]) {
                            var matchingKey = oFilter.serviceAttributes[idxe];
                            oFilter.placeAttributes[matchingKey] = mFilter[key];
                            // this.// logger.trace("Selection du filtre '" + key + "' sur le type '" + filter + "'.");
                        }
                    }

                    // ajout des valeurs des filtres
                    var places = oFilter.placeAttributes;
                    for (var kplace in places) {
                        if (places.hasOwnProperty(kplace)) {
                            settings.filter[kplace] = places[kplace];
                        }
                    }
                }
            }

            this.oAddress = new __WEBPACK_IMPORTED_MODULE_1__model_Address__["a" /* default */](settings);
            if (!this.oAddress) {
                throw new Error("La construction de l'adresse n'est pas correctement definie !?");
            }
        }

        // FIXME gestion des filtres pour un objet Address déjà instancié ?

        template = template.replace(/__ADDRESS__/g, this.oAddress.toString());
        template = template.replace(/__RETURNFREEFORM__/g, (this.options.returnFreeForm) ? "true" : "false");

        this.strRequest = template;
        return this.strRequest;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (GeocodeRequest);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);



/**
 * @classdesc
 *
 * Location type "Address".
 *
 * Modèles de classes :
 * ------------------
 * ```
 *
 *                Address
 *            (est composé de)
 *           ______ | _________ _________________
 *          /       |          \                 \
 *      Place (StreetAddress ou FreeFormAddress) PostalCode
 *       (*)       _|_
 *                /   \
 *           Street   Building
 * ```
 * ```
 * XSD
 * Address (balise xsd) :
 *   ex. <Address countryCode="StreetAddress"><freeFormAddress>1 r de paris saint denis</freeFormAddress></Address>
 *   attribute name="countryCode"
 *     element name="freeFormAddress"
 *     element ref="xls:Place"
 *     element ref="gml:Envelope"
 *  ou
 *   ex. <Address countryCode="StreetAddress"><StreetAddress><Street>1 rue Marconi</Street></StreetAddress><Place type="Municipality">Metz</Place><PostalCode>57000</PostalCode></Address>
 *   attribute name="countryCode"
 *     element ref="xls:StreetAddress"
 *     element ref="xls:PostalCode"
 *     element ref="xls:Place"
 *     element ref="gml:Envelope"
 * ```
 *
 * @example
 * // simple
 * adr = new Address ({
 *    location : "2 av pasteur, Saint-Mandée",
 *    type : ["StreetAddress"],
 *    filter : {}
 * });
 * adr.toString();
 * // -> out
 * // <Address countryCode="StreetAddress">
 * //   <freeFormAddress>2 av pasteur, Saint-Mandée</freeFormAddress>
 * // </Address>
 *
 * // avec filtre
 * adr = new Address ({
 *    location : {
 *      number : 2,
 *      street : "av pasteur",
 *      city : "Saint-Mandée", // FIXME filter Place "commune" ou "municipality" ?
 *      postalCode : "94166"   // FIXME filter Place ou balise PostalCode ?
 *    },
 *    type : ["StreetAddress"],
 *    filter : {
 *      territory : "FR",
 *      department : "94"
 *    }
 * });
 * adr.toString();
 * // -> out
 * // <Address countryCode="StreetAddress">
 * //   <StreetAddress>
 * //   <Building number="2"/>
 * //   <Street>2 av pasteur</Street>
 * // </StreetAddress>
 * // <Place type="municipality">Saint-Mandée</Place>
 * // <Place type="departement">94</Place>
 * // <Place type="territoire">FR</Place>
 * // <PostalCode>94166</PostalCode>
 * // </Address>
 *
 * // avec bbox
 * adr = new Address ({
 *    location : "2 av pasteur, Saint-Mandée",
 *    type : ["StreetAddress"],
 *    filter : {
 *      bbox : {left:1, right:2, top:2, bottom:0}
 *    }
 * });
 * adr.toString();
 * // -> out
 * // <Address countryCode="StreetAddress">
 * //   <freeFormAddress>2 av pasteur, Saint-Mandée</freeFormAddress>
 * //   <gml:Envelope>
 * //     <gml:lowerCorner>1 0</gml:lowerCorner>
 * //     <gml:upperCorner>2 2</gml:upperCorner>
 * //   </gl:Envelope>
 * // </Address>
 *
 * @constructor
 * @alias Gp.Formats.XLS.LocationUtilityService.Address
 * @param {Object} options - options
 * @param {Object} options.location - location
 * @param {String} options.type - type
 * @param {String} options.filter - filtres
 * @param {String} options.filter.* - Filtré en fonction des tables de geocodage interrogées
 *
 * @private
 */
function Address (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("Address");
    // this.// logger.trace("[Constructeur Address ()]");

    if (!(this instanceof Address)) {
        throw new TypeError("Address constructor cannot be called as a function.");
    }

    // param par defaut
    this.options = options || {
        location : {},
        type : ["StreetAddress"],
        filter : {}
    };

    // param obligatoire
    if (!options.location) {
        throw new Error("l'option 'location' n'est pas renseignée !");
    }

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            this.options[opt] = options[opt];
        }
    }
}

/**
 * @lends module:Address#
 */
Address.prototype = {

    /**
     * Constructeur (alias)
     */
    constructor : Address,

    /**
     * request (out)
     * @type {String}
     */
    requestString : null,

    /**
     * Template de la requête.
     *
     * substitution des valeurs suivantes :
     * - address :  __COUNTRYCODE__, __LOCATION__, __PLACE__, __POSTALCODE__, __ENVELOPE__
     * - freeFormAddress : __FREEFORMADDRESSVALUE__
     * - streetAddress : __STREET__, __BUILDING__
     * - street : __STREETVALUE__
     * - building : __BUILDINGVALUE__
     * - place : __PLACEATYPE__, __PLACEVALUE__
     * - postalCode : __POSTALCODEVALUE__
     * - gml:envelope : __LEFT__ __BOTTOM__ __RIGHT__ __TOP__
     *
     * @todo gestion de l"indentation
     */
    template : {
        address : "<Address countryCode=\"__COUNTRYCODE__\">" +
            "__LOCATION__" +
            "__PLACE__" +
            "__POSTALCODE__" +
            "__ENVELOPE__" +
            "</Address>",
        location : {
            freeFormAddress : "<freeFormAddress>__FREEFORMADDRESSVALUE__</freeFormAddress>",
            streetAddress : {
                container : "<StreetAddress>" +
                    "__STREET__" +
                    "__BUILDING__" +
                    "</StreetAddress>",
                building : "<Building number=\"__BUILDINGVALUE__\"/>",
                street : "<Street>__STREETVALUE__</Street>"
            }
        },
        place : "<Place type=\"__PLACETYPE__\">__PLACEVALUE__</Place>",
        postalCode : "<PostalCode>__POSTALCODEVALUE__</PostalCode>",
        envelope : "<gml:Envelope>" +
            "<gml:lowerCorner>__LEFT__ __BOTTOM__</gml:lowerCorner>" +
            "<gml:upperCorner>__RIGHT__ __TOP__</gml:upperCorner>" +
            "</gml:Envelope>"
    }

};

/**
 * toString
 *
 * @returns {String} requête
 */
Address.prototype.toString = function () {
    var template = null;
    template = this.template.address;
    template = template.replace(/__COUNTRYCODE__/g, this.options.type);

    // on a une adresse structurée ou libre ?
    if (typeof this.options.location === "string") {
        // balise freeFormeAddress
        var tmplFreeFormAddress = this.template.location.freeFormAddress;
        tmplFreeFormAddress = tmplFreeFormAddress.replace(/__FREEFORMADDRESSVALUE__/g, this.options.location);
        template = template.replace(/__LOCATION__/g, tmplFreeFormAddress);
    } else {
        // balises Street et Building
        var tmplBuilding = "";
        var tmplStreet = "";

        if (this.options.location.number) {
            tmplBuilding = this.template.location.streetAddress.building;
            tmplBuilding = tmplBuilding.replace(/__BUILDINGVALUE__/g, this.options.location.number);
        }

        if (this.options.location.street) {
            tmplStreet = this.template.location.streetAddress.street;
            tmplStreet = tmplStreet.replace(/__STREETVALUE__/g, this.options.location.street);
        }

        // balise streetAddress
        var tmplStreetAddress = this.template.location.streetAddress.container;
        tmplStreetAddress = tmplStreetAddress.replace(/__STREET__/g, tmplStreet);
        tmplStreetAddress = tmplStreetAddress.replace(/__BUILDING__/g, tmplBuilding);
        template = template.replace(/__LOCATION__/g, tmplStreetAddress);
    }

    // a t on un filtre de type PostalCode ?
    var tmplPostalCode = "";
    if (this.options.location.postalCode) {
        tmplPostalCode = this.template.postalCode;
        tmplPostalCode = tmplPostalCode.replace(/__POSTALCODEVALUE__/g, this.options.location.postalCode);
    }

    // a t on un filtre de type GML::Envelope ?
    var tmplEnvelope = "";
    if (this.options.filter) {
        var bbox = this.options.filter.bbox;
        if (bbox) {
            tmplEnvelope = this.template.envelope;
            tmplEnvelope = tmplEnvelope.replace(/__LEFT__/g, bbox.left);
            tmplEnvelope = tmplEnvelope.replace(/__BOTTOM__/g, bbox.bottom);
            tmplEnvelope = tmplEnvelope.replace(/__RIGHT__/g, bbox.right);
            tmplEnvelope = tmplEnvelope.replace(/__TOP__/g, bbox.top);
        }
    }

    // liste des filtres Place
    var Places = [];

    // a t on des filtres de type Place ?
    var tmplPlace = "";
    if (this.options.filter) {
        var filters = this.options.filter;
        for (var filter in filters) {
            if (filter === "bbox") {
                continue;
            }
            // FIXME gestion des filtres spécifiques IGN ?
            tmplPlace = this.template.place;
            tmplPlace = tmplPlace.replace(/__PLACETYPE__/g, filter);
            tmplPlace = tmplPlace.replace(/__PLACEVALUE__/g, filters[filter]);
            Places.push(tmplPlace);
        }
    }

    // a t on un filtre de type Place dans location ?
    var tmplPlaceCity = "";
    if (this.options.location.city) {
        tmplPlaceCity = this.template.place;
        tmplPlaceCity = tmplPlaceCity.replace(/__PLACETYPE__/g, "Municipality");
        tmplPlaceCity = tmplPlaceCity.replace(/__PLACEVALUE__/g, this.options.location.city);
        Places.push(tmplPlaceCity);
    }

    template = template.replace(/__POSTALCODE__/g, tmplPostalCode);
    template = template.replace(/__PLACE__/g, Places.join("\n"));
    template = template.replace(/__ENVELOPE__/g, tmplEnvelope);

    this.requestString = template;
    return this.requestString;
};

/* harmony default export */ __webpack_exports__["a"] = (Address);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Position__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Preference__ = __webpack_require__(71);





/**
 * @classdesc
 *
 * Requête de geocodage inverse
 *
 * XSD
 * ```
 * Geocodage inverse (balise xsd) :
 *   element ref="RequestHeader" [ (attribute name="clientName" attribute name="clientPassword" attribute name="sessionID" attribute name="srsName" attribute name="MSID") ]
 *     element name="Request" attribute name="methodName" attribute name="version" attribute name="requestID" [ attribute name="maximumResponses" ]
 *       element name="ReverseGeocodeRequest"
 *         element ref="xls:Position"
 *         element name="ReverseGeocodePreference" (enumeration)
 * ```
 *
 * @example
 * // creation de l"objet ReverseGeocode
 * req = new ReverseGeocodeRequest ();
 * req.addPosition (new Position (position:{x: , y: }));
 * req.addPreference (["StreetAddress"]);
 * req.toString();
 * // out ->
 * // <ReverseGeocodeRequest>
 * //     <Position>
 * //       <gml:Point xmlns:gml="http://www.opengis.net/gml">
 * //           <gml:pos>50.347775 3.205098</gml:pos>
 * //       </gml:Point>
 * //     </Position>
 * //     <ReverseGeocodePreference>StreetAddress</ReverseGeocodePreference>
 * //  </ReverseGeocodeRequest>
 * @constructor
 * @alias Gp.Formats.XLS.ReverseGeocodeRequest
 * @param {Object} options - options
 * @param {Object}   options.position - position
 * @param {String}   options.returnFreeForm - returnFreeForm
 * @param {String}   options.filterOptions - filtres
 * @param {Function} options.onsuccess - function callback success (TODO)
 * @param {Function} options.onerror   - function callback error   (TODO)
 *
 * @private
 */
function ReverseGeocodeRequest (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur ReverseGeocodeRequest ()]");

    if (!(this instanceof ReverseGeocodeRequest)) {
        throw new TypeError("ReverseGeocodeRequest constructor cannot be called as a function.");
    }

    // options par defaut
    this.options = options || {};

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            this.options[opt] = options[opt];
        }
    }

    /**
     * Nom de la classe (heritage)
     */
    this.CLASSNAME = "ReverseGeocodeRequest";
}

ReverseGeocodeRequest.prototype = {

    /**
     * @lends module:ReverseGeocodeRequest#
     */

    /**
     * request (out)
     * @type {String}
     */
    strRequest : null,

    /**
     * Position
     * @type {Position}
     */
    oPosition : null,

    /**
     * Preference
     * @type {Preference}
     */
    oPreference : null,

    /**
     * Constructeur (alias)
     */
    constructor : ReverseGeocodeRequest,

    /**
     * Template de la requête.
     * substitution des valeurs suivantes :
     * __POSITION__, __PREFERENCE__, __RETURNFREEFORM__
     */
    template : "<ReverseGeocodeRequest returnFreeForm=\"__RETURNFREEFORM__\">" +
        "__POSITION__" +
        "__PREFERENCE__" +
        "</ReverseGeocodeRequest>",

    /**
     * Ajout d"un objet de type Position
     *
     * @param {Object} oPosition - Position
     */
    addPosition : function (oPosition) {
        if (oPosition instanceof __WEBPACK_IMPORTED_MODULE_1__model_Position__["a" /* default */]) {
            this.oPosition = oPosition;
        }
    },

    /**
     * Ajout d"une liste de table de référence LUS :
     * [StreetAddress, PointOfInterest, CadastralParcel, Administrativ]
     *
     * @param {Object} oPreference - Preference
     */
    addPreferences : function (oPreference) {
        if (oPreference instanceof __WEBPACK_IMPORTED_MODULE_2__model_Preference__["a" /* default */]) {
            this.oPreference = oPreference;
        }
    },

    /**
     * toString
     * @returns {String} requête
     */
    toString : function () {
        var template = "";
        template = this.template;

        // si on a déjà un objet Preference instancié,
        // sinon, on le fabrique via les options
        if (!this.oPreference) {
            this.oPreference = new __WEBPACK_IMPORTED_MODULE_2__model_Preference__["a" /* default */](this.options.filterOptions.type || ["StreetAddress"]);
            if (!this.oPreference) {
                throw new Error("Les preferences ne sont pas definies !?");
            }
        }
        template = template.replace(/__PREFERENCE__/g, this.oPreference.toString());

        // si on a déjà un objet Position instancié,
        // sinon, on le fabrique via les options
        if (!this.oPosition) {
            var settings = {
                position : this.options.position,
                filter : {}
            };

            // FIXME gestion des filtres ?
            if (this.options.filterOptions) {
                settings.filter = this.options.filterOptions;
                delete settings.filter.type; // pas besoin ?
            }
            this.oPosition = new __WEBPACK_IMPORTED_MODULE_1__model_Position__["a" /* default */](settings);
            if (!this.oPosition) {
                throw new Error("La position et ses filtres ne sont pas definis !?");
            }
        }
        template = template.replace(/__POSITION__/g, this.oPosition.toString());
        template = template.replace(/__RETURNFREEFORM__/g, (this.options.returnFreeForm) ? "true" : "false");

        this.strRequest = template;
        return this.strRequest;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ReverseGeocodeRequest);


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);


/**
 * @classdesc
 * Location de type Position
 *
 * ```
 * XSD
 * Position (balise xsd) :
 *   ex. <Position><gml:Point xmlns:gml="http://www.opengis.net/gml"><gml:pos>50.347775 3.205098</gml:pos></gml:Point></Position>
 *   ex. <Position><gml:CircleByCenterPoint xmlns:gml="http://www.opengis.net/gml"><gml:pos>48.85978570614691 2.2913572761128878</gml:pos><gml:radius>1000</gml:radius></gml:CircleByCenterPoint></Position>
 *   (au choix)
 *   element ref="gml:Point"
 *   element ref="gml:CircleByCenterPoint"
 *   element ref="gml:Polygon"
 *   element ref="gml:MultiPolygon"
 * ```
 *
 * FIXME les autres elements ne sont pas implémentés (QoP, Speed, Direction, Time, ...) ?
 *
 * ```
 * template : "<Position>
 *                  __GMLPOINT__
 *                  __GMLFILTER__
 *             </Position>"
 * ```
 * ```
 * GML : {
 *  pos     : "<gml:pos>__X__ __Y__</gml:pos>",
 *  point   : "<gml:Point xmlns:gml=\"http://www.opengis.net/gml\">__POS__</gml:Point>",
 *  circle  : "<gml:CircleByCenterPoint xmlns:gml=\"http://www.opengis.net/gml\">__POS__<gml:radius>__RADIUS__</gml:radius></gml:CircleByCenterPoint>",
 *  // not yet implemented !
 *  polygon      : "",
 *  multipolygon : ""
 * }
 * ```
 *
 * @constructor
 * @alias Gp.Formats.XLS.LocationUtilityService.Position
 * @param {Object} options - options données en entrée
 * @param {Object} options.position - x/y
 * @param {Object} options.filter - filtre
 * @param {Object} options.filter.circle - un cercle
 * @param {Object} options.filter.polygon - un polygone
 *
 * @private
 */
function Position (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("Position");
    // this.// logger.trace("[Constructeur Position ()]");

    if (!(this instanceof Position)) {
        throw new TypeError("Position constructor cannot be called as a function.");
    }

    // param par defaut
    this.options = options || {};

    // param obligatoire
    if (!options.position) {
        throw new Error("l'option 'position' n'est pas renseignée !");
    }

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            this.options[opt] = options[opt];
        }
    }
}

/**
 * @lends module:Position#
 */
Position.prototype = {

    /**
     * Constructeur (alias)
     */
    constructor : Position,

    /**
     * request (out)
     * @type {String}
     */
    requestString : null,

    /**
     * Template de la requête.
     *
     * substitution des valeurs suivantes :
     * __GMLPOINT__ __GMLFILTER__
     * __X__ __Y__ __RADIUS__
     * __XY__
     * @todo indentation XML
     * @todo implementation classe GML
     */
    template : {
        position : "<Position>" +
            "__GMLPOINT__" +
            "__GMLFILTER__" +
            "</Position>",
        gml : {
            point : "<gml:Point xmlns:gml=\"http://www.opengis.net/gml\"><gml:pos>__X__ __Y__</gml:pos></gml:Point>",
            pos : null,
            filter : {
                bbox : "<gml:Envelope xmlns:gml=\"http://www.opengis.net/gml\">" +
                    "<gml:lowerCorner>__LEFT__ __BOTTOM__</gml:lowerCorner>" +
                    "<gml:upperCorner>__RIGHT__ __TOP__</gml:upperCorner>" +
                    "</gml:Envelope>",
                circle : "<gml:CircleByCenterPoint xmlns:gml=\"http://www.opengis.net/gml\"><gml:pos>__X__ __Y__</gml:pos><gml:radius>__RADIUS__</gml:radius></gml:CircleByCenterPoint>",
                polygon : "<gml:Polygon xmlns:gml=\"http://www.opengis.net/gml\"><gml:exterior><gml:LinearRing><gml:posList>__XY__</gml:posList></gml:LinearRing></gml:exterior></gml:Polygon>",
                multipolygon : null
            }
        }
    }
};

/**
 * toString
 *
 * @returns {String} requête
 */
Position.prototype.toString = function () {
    var template = this.template.position;

    var tmplGmlPoint = this.template.gml.point;
    tmplGmlPoint = tmplGmlPoint.replace(/__X__/g, this.options.position.x);
    tmplGmlPoint = tmplGmlPoint.replace(/__Y__/g, this.options.position.y);

    var tmplGmlFilter = "";
    if (this.options.filter) {
        var filter = this.options.filter;

        for (var name in filter) {
            switch (name) {
                case "circle":
                    tmplGmlFilter = this.template.gml.filter[name];
                    tmplGmlFilter = tmplGmlFilter.replace(/__X__/g, filter[name].x);
                    tmplGmlFilter = tmplGmlFilter.replace(/__Y__/g, filter[name].y);
                    tmplGmlFilter = tmplGmlFilter.replace(/__RADIUS__/g, filter[name].radius);
                    break;
                case "bbox":
                    tmplGmlFilter = this.template.gml.filter[name];
                    tmplGmlFilter = tmplGmlFilter.replace(/__LEFT__/g, filter[name].left);
                    tmplGmlFilter = tmplGmlFilter.replace(/__BOTTOM__/g, filter[name].bottom);
                    tmplGmlFilter = tmplGmlFilter.replace(/__RIGHT__/g, filter[name].right);
                    tmplGmlFilter = tmplGmlFilter.replace(/__TOP__/g, filter[name].top);
                    break;
                case "polygon":
                    // FIXME implementation simple du polygone !
                    // aucun test de fermeture du polygone, ni de gestion des trous !
                    tmplGmlFilter = this.template.gml.filter[name];
                    var strPoints = "";
                    var lstPoints = filter[name];
                    for (var i = 0; i < lstPoints.length; i++) {
                        var coord = lstPoints[i];
                        if (Array.isArray(coord)) {
                            this.logger.error("Holes are not implemented !");
                            break;
                        }
                        if ((coord.x && coord.y) || (coord.x === 0 || coord.y === 0)) {
                            strPoints += coord.x + " " + coord.y;
                        }
                        if (lstPoints.length !== i + 1) {
                            strPoints += " ";
                        }
                    }
                    tmplGmlFilter = tmplGmlFilter.replace(/__XY__/g, strPoints);
                    break;
                case "multipolygon":
                    this.logger.warn("Filter '" + name + "' is not yet implemented !");
                    break;
                default:
                    this.logger.error("This filter '" + name + "' is not useful !");
            }
        }
    }

    template = template.replace(/__GMLPOINT__/g, tmplGmlPoint);
    template = template.replace(/__GMLFILTER__/g, tmplGmlFilter);

    this.requestString = template;
    return this.requestString;
};

/* harmony default export */ __webpack_exports__["a"] = (Position);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);


/**
 * @classdesc
 *
 * Preference (Reverse)
 *
 * FIXME liste des types de tables de geocodage
 *
 * ```
 * template : "<ReverseGeocodePreference>__TYPE__</ReverseGeocodePreference>"
 * ```
 *
 * @constructor
 * @alias Gp.Formats.XLS.LocationUtilityService.Preference
 * @param {String} type - type de table de geocodage
 *
 * @private
 *
 */

function Preference (type) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("Preference");
    // this.// logger.trace("[Constructeur Preference ()]");

    if (!(this instanceof Preference)) {
        throw new TypeError("Preference constructor cannot be called as a function.");
    }

    /**
     * type de table de geocodage
     * @type {Array.<String>}
     */
    this.type = type;
}

/**
 * @lends module:Preference#
 */
Preference.prototype = {

    /**
     * Constructeur (alias)
     */
    constructor : Preference,

    /**
     * request (out)
     * @type {String}
     */
    requestString : null,

    /**
     * Template de la requête.
     *
     * substitution des valeurs suivantes :
     *  __TYPE__
     *
     */
    template : "<ReverseGeocodePreference>__TYPE__</ReverseGeocodePreference>"
};

/**
 * toString
 *
 * @returns {String} requête
 */
Preference.prototype.toString = function () {
    var Preferences = [];
    var tmplPreference = "";
    for (var idx = 0; idx < this.type.length; idx++) {
        tmplPreference = this.template;
        tmplPreference = tmplPreference.replace(/__TYPE__/g, this.type[idx]);
        Preferences.push(tmplPreference);
    }

    this.strRequest = Preferences.join("\n");
    return this.strRequest;
};

/* harmony default export */ __webpack_exports__["a"] = (Preference);


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__ = __webpack_require__(7);



/**
 * @classdesc
 * Format des attributs d'un résultat de géocodage de type StreetAddress.
 *
 * @constructor
 * @alias Gp.Services.Geocode.Request.StreetAddress
 * @private
 */
function StreetAddress () {
    if (!(this instanceof StreetAddress)) {
        throw new TypeError("StreetAddress constructor cannot be called as a function.");
    }

    // INFO
    // appel du constructeur de la classe mère
    // avec passage de param.
    __WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__["a" /* default */].apply(this, arguments);

    /**
     * Nom de la classe (heritage)
     * @type {String}
     */
    this.CLASSNAME = "StreetAddress";

    /**
     * Liste des attributs possibles pour une GeocodeLocation de type StreetAddress
     * - **bbox** : Emprise de l'adresse dans le système de coordonnées demandé {left, right, top, bottom}. *{Object}*
     * - **ID** : Identifiant BD ADRESSE dans le cas où le résultat est une adresse. *{String}*
     * - **IDTR** : Identifiant "Route Adresse" de la voie portant l'adresse dans la base BD ADRESSE. *{String}*
     * - **quality** : Indicateur de qualité du géocodage (pour plus d'infos : http://api.ign.fr/tech-docs-js/fr/developpeur/search.html *{String}*
     * - **territory** : Code du territoire français où se situe l'adresse *{String}*
     * - **commune** : Ville l'adresse. *{String}*
     * - **department** : Département l'adresse. *{String}*
     * - **insee** : Code INSEE de l'adresse. *{Number}*
     * - **municipality** : Municipalité de l'adresse. *{String}*
     */

    this.attributesList = ["bbox", "ID", "IDTR", "quality", "territory", "commune", "department", "insee", "municipality"];

    this.serviceAttributes = ["bbox", "ID", "IDTR", "Qualite", "Territoire", "Commune", "Departement", "INSEE", "Municipality"];
}

/**
 * @lends module:StreetAdress#
 */
StreetAddress.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__["a" /* default */].prototype);

/**
 * Constructeur (alias)
 */
StreetAddress.prototype.constructor = StreetAddress;

/* harmony default export */ __webpack_exports__["a"] = (StreetAddress);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__ = __webpack_require__(7);



/**
 * @classdesc
 * Format des attributs d'un résultat de géocodage de type PositionOfInterest
 *
 * @constructor
 * @alias Gp.Services.Geocode.Request.PositionOfInterest
 * @private
 */
function PositionOfInterest () {
    if (!(this instanceof PositionOfInterest)) {
        throw new TypeError("PositionOfInterest constructor cannot be called as a function.");
    }

    // INFO
    // appel du constructeur de la classe mère
    // avec passage de param.
    __WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__["a" /* default */].apply(this, arguments);

    /**
     * Nom de la classe (heritage)
     * @type {String}
     */
    this.CLASSNAME = "PositionOfInterest";

    /**
     * Liste des attributs possibles pour une GeocodeLocation de type PositionOfInterest
     * - **bbox** : Emprise du toponyme dans le système de coordonnées demandé {left, right, top, bottom} *{Object}*
     * - **importance** : Importance du toponyme *{number}*
     * - **nature** : Nature du toponyme. *{String}*
     * - **territory** : Code du territoire français où se situe le toponyme *{String}*
     * - **commune** : Ville du toponyme. *{String}*
     * - **department** : Département du toponyme. *{String}*
     * - **insee** : Code INSEE de la commune où se situe le toponyme. *{Number}*
     * - **municipality** : Municipalité du toponyme. *{String}*
     */

    this.attributesList = ["bbox", "importance", "nature", "territory", "commune", "department", "insee", "municipality"];

    this.serviceAttributes = ["bbox", "Importance", "Nature", "Territoire", "Commune", "Departement", "INSEE", "Municipality"];
}

/**
 * @lends module:PositionOfInterest#
 */
PositionOfInterest.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__["a" /* default */].prototype);

/**
 * Constructeur (alias)
 */
PositionOfInterest.prototype.constructor = PositionOfInterest;

/* harmony default export */ __webpack_exports__["a"] = (PositionOfInterest);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__ = __webpack_require__(7);



/**
 * @classdesc
 * Format des attributs d'un filtre de géocodage de type CadastralParcel.
 *
 * @constructor
 * @alias Gp.Services.Geocode.Request.CadastralParcel
 * @private
 */
function CadastralParcel () {
    if (!(this instanceof CadastralParcel)) {
        throw new TypeError("CadastralParcel constructor cannot be called as a function.");
    }

    // INFO
    // appel du constructeur de la classe mère
    // avec passage de param.
    __WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__["a" /* default */].apply(this, arguments);

    /**
     * Nom de la classe (heritage)
     */
    this.CLASSNAME = "CadastralParcel";

    /**
     * Liste des attributs possibles pour une GeocodeLocation de type CadastralParcel
     * - **absorbedCity** : Code commune absorbée de la parcelle :
     *      lorsqu'une parcelle est issue p d'une ancienne commune qui a fusionné avec une autre.
     *      Sinon, le code vaut '000'. *{String}*
     * - **sheet** : Feuille de la parcelle (ex 1). *{String}*
     * - **number** : Numéro de la parcelle (ex. 0041) *{String}*
     * - **section** : Section de la parcelle (ex 0D). *{String}*
     * - **commune** : Ville du filtre. *{String}*
     * - **department** : Département du filtre. *{String}*
     * - **insee** : Code INSEE du filtre. *{Number}*
     * - **municipality** : Municipalité du filtre. *{String}*
     * - **origin** : L'origine de l'objet parcellaire renvoyé
     *      (correspond à l'attribut "type" dans la réponse XML)
     *      Pour plus d'informations : http://api.ign.fr/tech-docs-js/fr/developpeur/search.html#Recherche_par_parcelles_cadastrales *{Number}*
     *
     */

    this.attributesList = ["absorbedCity", "sheet", "number", "section", "commune", "department", "insee", "municipality", "origin"];

    this.serviceAttributes = ["CommuneAbsorbee", "Feuille", "Numero", "Section", "Commune", "Departement", "INSEE", "Municipality", "Type"];
}

/**
 * @lends module:CadastralParcel#
 */
CadastralParcel.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__["a" /* default */].prototype);

/**
 * Constructeur (alias)
 */
CadastralParcel.prototype.constructor = CadastralParcel;

/* harmony default export */ __webpack_exports__["a"] = (CadastralParcel);


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__ = __webpack_require__(7);



/**
 * @classdesc
 * Format des attributs d'un filtre de géocodage de type Administratif.
 * @constructor
 * @alias Gp.Services.Geocode.Request.Administratif
 * @private
 */
function Administratif () {
    if (!(this instanceof Administratif)) {
        throw new TypeError("Administratif constructor cannot be called as a function.");
    }

    // INFO
    // appel du constructeur de la classe mère
    // avec passage de param.
    __WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__["a" /* default */].apply(this, arguments);

    /**
     * Nom de la classe (heritage)
     * @type {String}
     */
    this.CLASSNAME = "Administratif";

    /**
     * Liste des attributs possibles pour une GeocodedLocation de type Administratif
     * - **bbox** : Emprise de l'unité administrative dans le système de coordonnées demandé *{left, right, top, bottom}*
     * - **prefecture** - Nom de la préfécture de la région ou du département *{String}*
     * - **inseeRegion** - Numéro INSEE de la région *{String}*
     * - **inseeDepartment** - Numéro INSEE du département *{String}*
     * - **municipality** - Nom de l'unité administrative *{String}*
     *
     */

    this.attributesList = ["bbox", "prefecture", "inseeRegion", "inseeDepartment", "municipality"];

    this.serviceAttributes = ["bbox", "Prefecture", "InseeRegion", "InseeDepartement", "Municipality"];
}

/**
 * @lends module:Administratif#
 */
Administratif.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__GeocodeLocation__["a" /* default */].prototype);

/**
 * Constructeur (alias)
 */
Administratif.prototype.constructor = Administratif;

/* harmony default export */ __webpack_exports__["a"] = (Administratif);


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Formats_XML__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formats_DirectGeocodeResponseReader__ = __webpack_require__(77);
/**
 * Factory pour générer une reponse JSON à partir d'un XML
 * ou d'un JSON encapsulant du XML
 * (Factory)
 *
 * @module GeocodeResponseFactory
 * @alias Gp.Services.Geocode.Response.GeocodeResponseFactory
 * @todo La reponse JSON peut encapsuler un XML !
 * @private
 */
// import Logger from "../../../Utils/LoggerByDefault";





var DirectGeocodeReponseFactory = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant Geocode
     *
     * @example
     *   var options = {
     *      response :
     *      rawResponse :
     *      scope :
     *      onSuccess :
     *      onError :
     *   };
     *
     */
    build : function (options) {
        // data de type GeocodeResponse
        var data = null;

        if (options.response) {
            if (options.rawResponse) {
                data = options.response;
            } else {
                try {
                    var p = new __WEBPACK_IMPORTED_MODULE_2__Formats_XML__["a" /* default */]({
                        reader : __WEBPACK_IMPORTED_MODULE_3__Formats_DirectGeocodeResponseReader__["a" /* default */]
                    });

                    if (typeof options.response === "string") {
                        p.setXMLString(options.response);
                    } else {
                        p.setXMLDoc(options.response);
                    }

                    data = p.parse();

                    if (!data) {
                        throw new Error("L'analyse de la réponse du service !?");
                    }
                } catch (e) {
                    var message = e.message;
                    if (typeof options.response === "string") {
                        message += "('" + options.response + "')";
                    } else {
                        message += "('" + options.response.documentElement.innerHTML + "')";
                    }
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_0__Exceptions_ErrorService__["a" /* default */]({
                        message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_ANALYSE", message),
                        type : __WEBPACK_IMPORTED_MODULE_0__Exceptions_ErrorService__["a" /* default */].TYPE_UNKERR,
                        status : -1
                    }));
                    return;
                }

                // Si la réponse contenait une exception renvoyée par le service
                if (data.exceptionReport) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_0__Exceptions_ErrorService__["a" /* default */]({
                        message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", data.exceptionReport),
                        type : __WEBPACK_IMPORTED_MODULE_0__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR,
                        status : 200 // FIXME : 200 ?
                    }));
                    return;
                }
            }
        } else {
            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_0__Exceptions_ErrorService__["a" /* default */]({
                message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY"),
                type : __WEBPACK_IMPORTED_MODULE_0__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR,
                status : -1 // FIXME : status response
            }));
            return;
        }

        options.onSuccess.call(options.scope, data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DirectGeocodeReponseFactory);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Response_model_GeocodeResponse__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Response_model_DirectGeocodedLocation__ = __webpack_require__(39);

/**
 * Fonction retournant un objet contenant des clés de lecture (readers)
 *      qui permettent de parser des réponses XML du service de géocodage direct du Géoportail
 *      afin de récupérer les résultats retournés.
 * @module DirectGeocodeResponseReader
 * @alias Gp.Services.Geocode.Formats.DirectGeocodeResponseReader
 * @private
 */

// import Logger from "../../../Utils/LoggerByDefault";





/**
 * @member DirectGeocodeResponseReader
 */
var DirectGeocodeResponseReader = {};

/**
 * @property {String} DirectGeocodeResponseReader.VERSION - version du service de géocodage
 */
DirectGeocodeResponseReader.VERSION = "1.2";

/**
 * Objet stockant les différents namespaces et les URI associées
 */
DirectGeocodeResponseReader.NAMESPACES = {
    xmlns : "http://www.opengis.net/xls",
    gml : "http://www.opengis.net/gml",
    xls : "http://www.opengis.net/xls",
    xlsext : "http://www.opengis.net/xlsext",
    xsi : "http://www.w3.org/2001/XMLSchema-instance"
};

/**
 * Localisation (URL) du schema de définition du XML (XSD)
 */
DirectGeocodeResponseReader.SCHEMALOCATION = "http://wxs.ign.fr/schemas/olsAll.xsd";

/**
 * Namespace par défaut du format
 */
DirectGeocodeResponseReader.DEFAULTPREFIX = "xls";

/**
 * Objet contenant des fonctions de lecture, appelées "READERS"
 *      dont chaque clé correspond au nom d'un tag du XML que l'on souhaite lire
 *      et la valeur associée est une fonction (node, data)
 *      où node est un noeud du document DOM
 *      et data est un objet où l'on stocke les informations lues dans le XML.
 */
DirectGeocodeResponseReader.READERS = {

    xls : {

        /** TODO : jsdoc block */
        XLS : function (root) {
            var geocodeResponse = new __WEBPACK_IMPORTED_MODULE_2__Response_model_GeocodeResponse__["a" /* default */]();

            // vérification de la version du service, et des namespaces de l'en-tête
            __checkServiceAttributes(root);

            // puis lancement de la lecture de l'ensemble des noeuds, en bouclant sur les childNodes
            __getChildNodes(root, geocodeResponse);

            return geocodeResponse;
        },

        /** TODO : jsdoc block */
        GeocodedAddress : function (node, geocodeResponse) {
            var geocodedLocation = new __WEBPACK_IMPORTED_MODULE_3__Response_model_DirectGeocodedLocation__["a" /* default */]();

            __getChildNodes(node, geocodedLocation);

            // Ajout du résultat au tableau geocodedLocations de geocodeReponse
            if (geocodeResponse && Array.isArray(geocodeResponse.locations)) {
                geocodeResponse.locations.push(geocodedLocation);
            }
        },

        /** TODO : jsdoc block */
        GeocodeMatchCode : function (node, geocodedLocation) {
            var acc = node.getAttribute("accuracy");
            if (acc && geocodedLocation) {
                geocodedLocation.accuracy = parseFloat(acc);
            }
            var matchType = node.getAttribute("matchType");
            if (matchType && geocodedLocation) {
                geocodedLocation.matchType = matchType;
            }
        },

        /** TODO : jsdoc block */
        Address : function (node, geocodedLocation) {
            var countrycode = node.getAttribute("countryCode");
            if (geocodedLocation && countrycode) {
                geocodedLocation.type = countrycode;
            }
            // on va récupérer les autres informations (StreetAddress, place, postalCode...)
            __getChildNodes(node, geocodedLocation);
        },

        /** TODO : jsdoc block */
        freeFormAddress : function (node, geocodedLocation) {
            if (geocodedLocation && geocodedLocation.hasOwnProperty("placeAttributes")) {
                geocodedLocation.placeAttributes.freeform = __getChildValue(node);
            }
        },

        /** TODO : jsdoc block */
        Building : function (node, geocodedLocation) {
            var num = node.getAttribute("number");
            if (geocodedLocation && geocodedLocation.hasOwnProperty("placeAttributes")) {
                if (num) {
                    geocodedLocation.placeAttributes.number = num;
                } else if (node.getAttribute("buildingName")) {
                    geocodedLocation.placeAttributes.number = node.getAttribute("buildingName");
                } else if (node.getAttribute("subdivision")) {
                    geocodedLocation.placeAttributes.number = node.getAttribute("subdivision");
                }
            }
        },

        /** TODO : jsdoc block */
        Street : function (node, geocodedLocation) {
            if (geocodedLocation && geocodedLocation.hasOwnProperty("placeAttributes")) {
                // in case of a streetAddress result : street represents the street name
                if (geocodedLocation.type === "StreetAddress") {
                    geocodedLocation.placeAttributes.street = __getChildValue(node);

                    // in case of a cadastral parcel result : street represents the cadastral parcel identifier
                } else if (geocodedLocation.type === "CadastralParcel") {
                    geocodedLocation.placeAttributes.cadastralParcel = __getChildValue(node);
                }
            }
        },

        /** TODO : jsdoc block */
        Place : function (node, geocodedLocation) {
            var placeType = node.getAttribute("type");
            var placeName = __getChildValue(node);

            if (geocodedLocation && geocodedLocation.hasOwnProperty("placeAttributes")) {
                if (placeType === "Municipality") {
                    geocodedLocation.placeAttributes.municipality = placeName;
                } else if (placeType === "Bbox") {
                    var values = placeName.split(";");
                    if (values.length === 4) {
                        geocodedLocation.placeAttributes.bbox = {
                            left : parseFloat(values[0]),
                            right : parseFloat(values[2]),
                            top : parseFloat(values[1]),
                            bottom : parseFloat(values[3])
                        };
                    }
                } else if (placeType === "Commune") {
                    geocodedLocation.placeAttributes.commune = placeName;
                } else if (placeType === "Departement") {
                    geocodedLocation.placeAttributes.department = placeName;
                } else if (placeType === "INSEE") {
                    geocodedLocation.placeAttributes.insee = placeName;
                } else if (placeType === "Qualite") {
                    geocodedLocation.placeAttributes.quality = placeName;
                } else if (placeType === "Territoire") {
                    geocodedLocation.placeAttributes.territory = placeName;
                } else if (placeType === "ID") {
                    geocodedLocation.placeAttributes.ID = placeName;
                } else if (placeType === "ID_TR") {
                    geocodedLocation.placeAttributes.IDTR = placeName;
                } else if (placeType === "Importance") {
                    geocodedLocation.placeAttributes.importance = parseInt(placeName, 10);
                } else if (placeType === "Nature") {
                    geocodedLocation.placeAttributes.nature = placeName;
                } else if (placeType === "Numero") {
                    geocodedLocation.placeAttributes.number = placeName;
                } else if (placeType === "Feuille") {
                    geocodedLocation.placeAttributes.sheet = placeName;
                } else if (placeType === "Section") {
                    geocodedLocation.placeAttributes.section = placeName;
                } else if (placeType === "CommuneAbsorbee") {
                    geocodedLocation.placeAttributes.absorbedCity = placeName;
                } else if (placeType === "Arrondissement") {
                    if (placeName) {
                        geocodedLocation.placeAttributes.arrondissement = placeName;
                    }
                } else if (placeType === "Type") {
                    geocodedLocation.placeAttributes.origin = placeName;
                } else if (placeType === "Prefecture") {
                    geocodedLocation.placeAttributes.prefecture = placeName;
                } else if (placeType === "InseeRegion") {
                    geocodedLocation.placeAttributes.inseeRegion = placeName;
                } else if (placeType === "InseeDepartment") {
                    geocodedLocation.placeAttributes.inseeDepartment = placeName;
                }
            }
        },

        /** TODO : jsdoc block */
        PostalCode : function (node, geocodedLocation) {
            if (geocodedLocation && geocodedLocation.hasOwnProperty("placeAttributes")) {
                geocodedLocation.placeAttributes.postalCode = __getChildValue(node);
            }
        },

        /** TODO : jsdoc block */
        Error : function (node) {
            // on imagine qu'on a une balise ainsi :
            // <Error message="Message..." errorCode="InternalServerError"/>
            var srvMess = node.getAttribute("message");
            var errorCode = node.getAttribute("errorCode");
            var message = __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION",
                "(" + errorCode + ") : " + srvMess);
            throw new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */]({
                message : message,
                type : __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
            });
        }
    },

    gml : {

        /** TODO : jsdoc block */
        pos : function (node, geocodedLocation) {
            var pos = __getChildValue(node);
            if (geocodedLocation && pos) {
                geocodedLocation.position = {
                    x : parseFloat(pos.split(" ")[0]),
                    y : parseFloat(pos.split(" ")[1])
                };
            }
        }
    },

    /** TODO : jsdoc block */
    ExceptionReport : function (node) {
        var response = {};
        if (node.hasChildNodes()) {
            var children = node.childNodes;
            var child;
            for (var i = 0; i < children.length; i++) {
                child = children[i];
                if (child.nodeName === "Exception") {
                    response.exceptionReport = DirectGeocodeResponseReader.READERS["Exception"](child);
                }
            }
        }
        return response;
    },

    /** TODO : jsdoc block */
    Exception : function (node) {
        var exceptionReport = {};

        // get exception code
        var exceptionCode = node.getAttribute("exceptionCode");
        if (exceptionCode) {
            exceptionReport.exceptionCode = exceptionCode;
        }

        // get exception message
        var textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            exceptionReport.exception = textNode.nodeValue;
        }

        return exceptionReport;
    }

};

/**
 * Méthode permettant de lancer la lecture d'une réponse XML du service de géocodage,
 *      à l'aide des READERS de la classe.
 *
 * @method DirectGeocodeResponseReader.read
 * @param {DOMElement} root - racine de la réponse XML à lire
 * @return {Object} geocodeResponse|exceptionReport : l'objet contenant les informations de la réponse XML,
 *      sous la forme d'un objet GeocodeResponse, ou un objet littéral exceptionReport si le service a renvoyé une exception.
 * @static
 * @memberof DirectGeocodeResponseReader
 */
DirectGeocodeResponseReader.read = function (root) {
    if (root.nodeName === "XLS") {
        var nsPrefix = root.prefix;
        if (!nsPrefix) {
            nsPrefix = DirectGeocodeResponseReader.DEFAULTPREFIX;
        }
        var geocodeResponse = DirectGeocodeResponseReader.READERS[nsPrefix][root.nodeName](root);
        return geocodeResponse;
    } else if (root.nodeName === "ExceptionReport") {
        var exceptionReport = DirectGeocodeResponseReader.READERS[root.nodeName](root);
        return exceptionReport;
    } else {
        var mess = __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_ANALYSE", root.nodeName);
        throw new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */]({
            message : mess,
            type : __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */].TYPE_UNKERR,
            status : 200
        });
    }
};

/**
 * Récupération des attributs d'un noeud élément
 *
 * @private
 * @memberof DirectGeocodeResponseReader
 * @method __getAttributes
 * @param {DOMElement} node - noeud contenant l'attribut recherché
 * @return {Object} nodeAttributes - objet contenant les noms et valeurs des différents attributs
 */
function __getAttributes (node) {
    if (node.attributes.length > 0) {
        var nodeAttributes = {};
        var attributes = node.attributes;
        for (var i = 0; i < attributes.length; i++) {
            var attribute = attributes[i];
            nodeAttributes[attribute.nodeName] = attribute.nodeValue;
        }
        return nodeAttributes;
    }
}

/**
 * Récupération des noeuds enfants à partir d'un noeud donné, pour lecture (readNode).
 *
 * @private
 * @memberof DirectGeocodeResponseReader
 * @method __getChildNodes
 * @param {DOMElement} node - a DOM node
 * @param {Array|Object} [data] - an object to be filled with node data
 */
function __getChildNodes (node, data) {
    if (node.hasChildNodes()) {
        var children = node.childNodes;
        var child;
        var childName;
        var childPrefix;

        for (var i = 0; i < children.length; i++) {
            child = children[i];

            if (child.nodeType === 1) { // 1 === node.ELEMENT_NODE
                childName = child.localName || child.baseName || child.nodeName;
                childPrefix = child.prefix || DirectGeocodeResponseReader.DEFAULTPREFIX;

                if (DirectGeocodeResponseReader.READERS[childPrefix][childName]) {
                    var reader = DirectGeocodeResponseReader.READERS[childPrefix][childName];
                    reader(child, data);
                } else {
                    __getChildNodes(child, data);
                }
            }
        }
    }
}

/**
 * Lecture de la valeur du premier child d'un noeud, si elle existe.
 *
 * @private
 * @memberof DirectGeocodeResponseReader
 * @method __getChildValue
 * @param {DOMElement} node - a DOM node
 * @return {String} value - valeur du firstChild du noeud en entrée, ou chaîne vide.
 */
function __getChildValue (node) {
    var textNode;
    var value = "";

    if (node.hasChildNodes()) {
        textNode = node.firstChild;
        if (textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            value = textNode.nodeValue;
        }
    }
    return value;
}

/**
 * Vérification des attributs du service, dans la balise XLS de la réponse :
 *      version, namespaces, et namespace par défaut doivent correspondre à ceux attendus.
 *
 * @private
 * @memberof DirectGeocodeResponseReader
 * @method __checkServiceAttributes
 * @param {DOMElement} XLSNode - a DOM node, corresponding to XLS first tag.
 */
function __checkServiceAttributes (XLSNode) {
    if (XLSNode.attributes.length > 0) {
        // on récupère et parcourt les attributs de la balise XLS de la réponse
        var xlsAttributes = __getAttributes(XLSNode);
        for (var att in xlsAttributes) {
            if (xlsAttributes.hasOwnProperty(att)) {
                // vérification de la version
                if (att === "version") {
                    if (xlsAttributes["version"] !== DirectGeocodeResponseReader.VERSION) {
                        // console.log("[DirectGeocodeResponseReader] geocode version is not the expected one : there may be errors in parsing");
                        return;
                    }
                }

                // on vérifie que l'uri du namespace par défaut est bien celle que l'on attend
                if (att === "xmlns") {
                    if (xlsAttributes[att] !== DirectGeocodeResponseReader.NAMESPACES[DirectGeocodeResponseReader.DEFAULTPREFIX]) {
                        // console.log("[DirectGeocodeResponseReader] geocode response default namespace is not the expected one");
                        return;
                    }
                    continue;
                }

                var prefix = att.split(":")[0];
                var ns = att.split(":")[1];

                // si on a un autre xmlns, on vérifie aussi les URI
                if (prefix === "xmlns" && ns) {
                    // si l'attribut correspond à un namespace défini dans le reader
                    if (DirectGeocodeResponseReader.NAMESPACES[ns]) {
                        // il faut que les URI correspondent aussi.
                        if (DirectGeocodeResponseReader.NAMESPACES[ns] !== xlsAttributes[att]) {
                            // console.log("[DirectGeocodeResponseReader] geocode response " + att + " namespace is not the expected one");
                            return;
                        }
                    }
                }

                // pour finir on vérifie la localisation du schema XSD du service
                if (ns === "schemaLocation") {
                    if (DirectGeocodeResponseReader.SCHEMALOCATION !== xlsAttributes[att]) {
                        // console.log("[DirectGeocodeResponseReader] geocode response schema location is not the expected one");
                        return;
                    }
                }
            }
        }
    }
}

/* harmony default export */ __webpack_exports__["a"] = (DirectGeocodeResponseReader);


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonService__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Request_ReverseGeocodeRequestFactory__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Response_ReverseGeocodeResponseFactory__ = __webpack_require__(80);








/**
 * @classdesc
 * Appel du service de géocodage inverse du Géoportail :
 *     envoi de la requête construite selon les paramètres en options,
 *     éventuellement parsing et analyse  de la réponse,
 *     retour d'une réponse en paramètre de la fonction onSuccess.
 * @constructor
 * @extends {Gp.Services.CommonService}
 * @alias Gp.Services.ReverseGeocode
 *
 * @param {Object} options - options spécifiques au service (+ les options heritées)
 *
 * @param {Object} options.position - Position du point de référence pour le calcul de proximité exprimée dans le système de référence spécifié par le srs.
 *      @param {Float} options.position.x - Abcisse du point de référence pour le calcul de proximité exprimée dans le système de référence spécifié par le srs. (= longitude si srs = "CRS:84", latitude si srs = "EPSG:4326")
 *      @param {Float} options.position.y - Ordonnée du point de référence pour le calcul de proximité exprimée dans le système de référence spécifié par le srs. (= latitude si srs = "CRS:84", longitude si srs = "EPSG:4326")
 *
 * @param {Object} [options.filterOptions] - Les propriétés possibles de cet objet sont décrites ci-après.
 * @param {Object} [options.filterOptions.bbox] - Emprise dans laquelle on souhaite effectuer la recherche.
 *      Les propriétés possibles de cet objet sont décrites ci-après.
 *      @param {Float} options.filterOptions.bbox.left   - Abscisse du côté gauche de la BBOX
 *      @param {Float} options.filterOptions.bbox.right  - Abscisse du côté droit de la BBOX
 *      @param {Float} options.filterOptions.bbox.top    - Ordonnée supérieure de la BBOX
 *      @param {Float} options.filterOptions.bbox.bottom - Ordonnée inférieure de la BBOX
 *
 * @param {Object} [options.filterOptions.circle] - Cercle dans lequel on souhaite effectuer la recherche.
 *      Les propriétés possibles de cet objet sont décrites ci-après.
 *      @param {Float} options.filterOptions.circle.x      - Abscisse du centre du cercle de recherche.
 *      @param {Float} options.filterOptions.circle.y      - Ordonnée du centre du cercle de recherche.
 *      @param {Float} options.filterOptions.circle.radius - Rayon du cercle de recherche.
 *
 * @param {Array.<Object>} [options.filterOptions.polygon] - Polygone dans lequel on souhaite effectuer la recherche.
 *      Liste des couples x et y pour chaque point constituant le polygone.
 *
 * @param {Array.<String>} [options.filterOptions.type = "StreetAddress"] - Type de l'objet recherché.
 *      Le service de géocodage du Géoportail permet de rechercher des 'PostionOfInterest' pour des toponymes, des 'StreetAddress'
 *      pour des adresses postales et/ou des 'CadastralParcel' pour des parcelles cadastrales.
 *      D'autres types pourront être rajoutés selon l'évolution du service.
 *      Par défaut, type = ['StreetAddress'].
 *
 * @param {Number} [options.maximumResponses] - Nombre de réponses maximal que l'on souhaite recevoir.
 *      Pas de valeur par défaut. Si le serveur consulté est celui du Géoportail, la valeur par défaut sera donc celle du service : 25.
 *
 * @param {String} [options.srs = CRS:84] - Système de coordonnées dans lequel les paramètres géographiques en entrée et la réponse du service sont exprimés.
 *      Pas de valeur par défaut.
 *      Si le serveur consulté est celui du Géoportail, la valeur par défaut est : "CRS:84".
 *
 * @example
 *   var options = {
 *      apiKey : null,
 *      serverUrl : 'http://localhost/service/',
 *      protocol : 'JSONP', // JSONP|XHR
 *      proxyURL : null,
 *      httpMethod : 'GET', // GET|POST
 *      timeOut : 10000, // ms
 *      rawResponse : false, // true|false
 *      scope : null, // this
 *      onSuccess : function (response) {},
 *      onFailure : function (error) {},
 *      // spécifique au service
 *      position : {x:0 , y:0},
 *      filterOptions :{
 *          bbox : {left : 0, right : 1, top : 1, bottom : 0},
 *          [circle : {
 *              x : 0,
 *              y : 0,
 *              radius : 100
 *          }]
 *          [polygon  : [{x:0,y:0}, {x:1,y:1}, {x:2,y:2}, {x:3,y:2}, {x:4,y:1}, {x:0,y:0}]]
 *          type : ['StreetAddress']
 *      },
 *      maximumResponses : 25,
 *      srs : 'EPSG:4326'
 *   };
 *
 * @private
 */
function ReverseGeocode (options) {
    if (!(this instanceof ReverseGeocode)) {
        throw new TypeError(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("CLASS_CONSTRUCTOR", "ReverseGeocode"));
    }

    /**
     * Nom de la classe (heritage)
     * FIXME instance ou classe ?
     */
    this.CLASSNAME = "ReverseGeocode";

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_3__CommonService__["a" /* default */].apply(this, arguments);

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("Gp.Services.ReverseGeocode");
    // this.// logger.trace("[Constructeur ReverseGeocode (options)]");

    if (!options.position) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "position"));
    }

    // on lance une exception afin d'eviter au service de le faire...
    if (options.position.x === null) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "position.x"));
    }

    if (options.position.y === null) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "position.y"));
    }

    // ajout des options spécifiques au service
    this.options.position = options.position;

    // on definit des filtres par defaut
    if (!options.filterOptions || typeof options.filterOptions !== "object") {
        this.options.filterOptions = options.filterOptions = {
            type : ["StreetAddress"]
        };
    }

    // FIXME ECMAScript 5 support (valable pour un objet uniquement !)
    // ceci permet de tester le cas où : object = {}
    if (Object.keys(options.filterOptions).length === 0) {
        this.options.filterOptions = {
            type : ["StreetAddress"]
        };
    }

    // on teste pour chaque filtre, les conditions suivantes : null ou vide !
    var filter = Object.keys(options.filterOptions);
    for (var i = 0; i < filter.length; i++) {
        var key = filter[i];
        if (!options.filterOptions[key] || Object.keys(options.filterOptions[key]).length === 0) {
            delete this.options.filterOptions[key];
        }
    }

    this.options.filterOptions.type = options.filterOptions.type || ["StreetAddress"];
    // on vérifie que le type est bien dans un tableau
    if (!Array.isArray(this.options.filterOptions.type)) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_TYPE", "filterOptions.type"));
    }

    this.options.maximumResponses = options.maximumResponses || 25;

    // FIXME : cet attribut (returnFreeForm) n'est pas spécifié dans la doc du constructeur ?
    // Il est inutile en effet, mais présent dans les specs...
    this.options.returnFreeForm = options.returnFreeForm || false;
    // info : en réalité le service ne reconnait que EPSG:4326. this.options.srs permet essentiellement de différencier EPSG:4326 (lat,lon) et CRS:84 (lon,lat)
    this.options.srs = options.srs || "CRS:84";

    // si on n'a pas un systeme de coordonnées EPSG géographique, il faut inverser les coordonnées
    // (car elles sont en lon, lat alors que le service attend une position en lat, lon).
    // dans le cas d'EPSG:4326 par exemple, les coordonnées sont bien en lat, lon donc on ne fait rien.
    if (ReverseGeocode.geoEPSG.indexOf(this.options.srs) === -1) {
        // pour la position
        this.options.position = {
            x : this.options.position.y,
            y : this.options.position.x
        };
        // pour les filtres spatiaux s'ils sont spécifiés
        if (this.options.filterOptions && this.options.filterOptions.circle) {
            var circle = this.options.filterOptions.circle;
            this.options.filterOptions.circle = {
                x : circle.y,
                y : circle.x,
                radius : circle.radius
            };
        }
        if (this.options.filterOptions && this.options.filterOptions.polygon) {
            var polygon = this.options.filterOptions.polygon;
            for (i = 0; i < polygon.length; i++) {
                var coords = polygon[i];
                this.options.filterOptions.polygon[i] = {
                    x : coords.y,
                    y : coords.x
                };
            }
        }
    }

    // attributs d'instances

    /**
     * Format forcé de la réponse du service : "xml"
     * sauf si l'on souhaite une reponse brute (options.rawResponse)
     */
    this.options.outputFormat = (this.options.rawResponse) ? "" : "xml";
}

/**
 * @lends module:ReverseGeocode#
 */
ReverseGeocode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_3__CommonService__["a" /* default */].prototype, {
    // todo
    // getter/setter
});

/*
 * Constructeur (alias)
 */
ReverseGeocode.prototype.constructor = ReverseGeocode;

/**
 * (overwrite)
 * Création de la requête
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback
 */
ReverseGeocode.prototype.buildRequest = function (error, success) {
    var options = {
        httpMethod : this.options.httpMethod,
        // options specifiques du service
        position : this.options.position,
        returnFreeForm : this.options.returnFreeForm,
        filterOptions : this.options.filterOptions,
        srs : "EPSG:4326", // info : en réalité le service ne reconnait que EPSG:4326. this.options.srs permet essentiellement de différencier EPSG:4326 (lat,lon) et CRS:84 (lon,lat)
        maximumResponses : this.options.maximumResponses
    };

    this.request = __WEBPACK_IMPORTED_MODULE_4__Request_ReverseGeocodeRequestFactory__["a" /* default */].build(options);

    // on teste si la requete a bien été construite !
    (!this.request)
        ? error.call(this, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_REQUEST_BUILD")))
        : success.call(this, this.request);
};

/**
 * (overwrite)
 * Analyse de la reponse
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback
 */
ReverseGeocode.prototype.analyzeResponse = function (error, success) {
    if (this.response) {
        var options = {
            response : this.response,
            rawResponse : this.options.rawResponse,
            onError : error,
            onSuccess : success,
            scope : this
        };

        __WEBPACK_IMPORTED_MODULE_5__Response_ReverseGeocodeResponseFactory__["a" /* default */].build(options);
    } else {
        error.call(this, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
    }
};

/**
 * Codes EPSG géographiques (lat/lon). Utiles car les coordonnées doivent être inversées.
 */
ReverseGeocode.geoEPSG = ["EPSG:4326"];

/* harmony default export */ __webpack_exports__["a"] = (ReverseGeocode);


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Formats_XLS__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Formats_XLS_LocationUtilityService__ = __webpack_require__(38);
/**
 * Creation d'une requête OpenLS en mode POST ou GET
 * (Factory)
 *
 * @module ReverseGeocodeRequestFactory
 * @alias Gp.Services.Geocode.Request.ReverseGeocodeRequestFactory
 * @private
 */




var ReverseGeocodeRequestFactory = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant Geocode
     *
     * @example
     *   var options = {
     *      httpMethod :
     *      // options specifiques du service
     *      position :
     *      returnFreeForm :
     *      filterOptions :
     *      srs :
     *      maximumResponses :
     *   };
     *   var result = ReverseGeocodeRequestFactory.build(options);
     *   if (!result) {
     *       // error...
     *   }
     * @returns {String} request
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("ReverseGeocodeRequestFactory");
        // logger.trace(["ReverseGeocodeRequestFactory::build()"]);

        // options non definies
        var settings = options || {};

        var request = null;

        // objet LUS
        var oLUS = new __WEBPACK_IMPORTED_MODULE_2__Formats_XLS_LocationUtilityService__["a" /* default */]({
            position : settings.position,
            returnFreeForm : settings.returnFreeForm,
            filterOptions : settings.filterOptions
        });

        // Format XLS
        var oXLS = new __WEBPACK_IMPORTED_MODULE_1__Formats_XLS__["a" /* default */]({
            srsName : settings.srs,
            maximumResponses : settings.maximumResponses
        });
        oXLS.namespace = true;
        oXLS.setService(oLUS);

        // request brute !
        request = oXLS.build();

        // en mode GET, la requête est encodée
        // et le param. 'qxml' est ajouté
        if (settings.httpMethod === "GET") {
            var myRequest = "qxml=" +
                encodeURIComponent(request)
                    .replace(/-/g, "%2D")
                    .replace(/_/g, "%5F")
                    .replace(/\./g, "%2E")
                    .replace(/!/g, "%21")
                    .replace(/~/g, "%7E")
                    .replace(/\*/g, "%2A")
                    .replace(/'/g, "%27")
                    .replace(/\(/g, "%28")
                    .replace(/\)/g, "%29");
            request = myRequest;
        }

        // logger.trace(request);

        return request;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ReverseGeocodeRequestFactory);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Formats_XML__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formats_ReverseGeocodeResponseReader__ = __webpack_require__(81);
/**
 * Factory pour générer une reponse JSON à partir d'un XML
 * ou d'un JSON encapsulant du XML
 * (Factory)
 *
 * @module ReverseGeocodeResponseFactory
 * @alias Gp.Services.ReverseGeocode.Response.ReverseGeocodeResponseFactory
 * @todo La reponse JSON peut encapsuler un XML !
 * @private
 */






var ReverseGeocodeReponseFactory = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant ReverseGeocode
     *
     * @example
     *   var options = {
     *      response :
     *      rawResponse :
     *      scope :
     *      onSuccess :
     *      onError :
     *   };
     *
     */
    build : function (options) {
        // data de type ReverseGeocodeResponse
        var data = null;

        if (options.response) {
            if (options.rawResponse) {
                data = options.response;
            } else {
                try {
                    var p = new __WEBPACK_IMPORTED_MODULE_2__Formats_XML__["a" /* default */]({
                        reader : __WEBPACK_IMPORTED_MODULE_3__Formats_ReverseGeocodeResponseReader__["a" /* default */]
                    });

                    if (typeof options.response === "string") {
                        p.setXMLString(options.response);
                    } else {
                        p.setXMLDoc(options.response);
                    }

                    data = p.parse();

                    if (!data) {
                        throw new Error("L'analyse de la réponse du service !?");
                    }
                } catch (e) {
                    // on relaye l'erreur reçue
                    e.status = 200;
                    options.onError.call(options.scope, e);
                    return;
                }

                // Si la réponse contenait une exception renvoyée par le service
                // TODO : quand cela arrive-t-il ?
                if (data.exceptionReport) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */]({
                        message : __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", data.exceptionReport),
                        type : __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR,
                        status : 200
                    }));
                    return;
                }

                // dans le cas d'un srs non EPSG géographique, il faut réinverser les coordonnées (lat,lon => lon,lat)
                if (options.scope && options.scope.options && options.scope.options.srs && options.scope.options.srs !== "EPSG:4326") {
                    var location;
                    var pos;
                    if (data || data.locations || data.locations.length) {
                        for (var i = 0; i < data.locations.length; i++) {
                            location = data.locations[i];
                            if (location) {
                                pos = location.position;
                                if (pos) {
                                    // on inverse les 2 coordonnées
                                    location.position = {
                                        x : pos.y,
                                        y : pos.x
                                    };
                                }
                            }
                        }
                    }
                }
            }
        } else {
            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */]({
                message : __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY"),
                type : __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR,
                status : -1 // FIXME : status response
            }));
            return;
        }

        options.onSuccess.call(options.scope, data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ReverseGeocodeReponseFactory);


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Response_model_GeocodeResponse__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Response_model_ReverseGeocodedLocation__ = __webpack_require__(40);

/**
 * Fonction retournant un objet contenant des clés de lecture (readers)
 *      qui permettent de parser des réponses XML du service de géocodage inverse du Géoportail
 *      afin de récupérer les résultats retournés.
 * @module ReverseGeocodeResponseReader
 * @alias Gp.Services.Geocode.Formats.ReverseGeocodeResponseReader
 * @private
 */

// import Logger from "../../../Utils/LoggerByDefault";





/**
 * Objet ReverseGeocodeResponseReader
 * @member {Object} ReverseGeocodeResponseReader
 *
 * @property {String} ReverseGeocodeResponseReader.VERSION - Version du service de géocodage
 *
 * @property {Object} ReverseGeocodeResponseReader.NAMESPACES - Objet stockant les différents namespaces et les URI associées
 *
 * @property {String} ReverseGeocodeResponseReader.SCHEMALOCATION - Localisation (URL) du schema de définition du XML (XSD)
 *
 * @property {String} ReverseGeocodeResponseReader.DEFAULTPREFIX - Namespace par défaut du format
 *
 * @property {Object} ReverseGeocodeResponseReader.READERS - Objet contenant des fonctions de lecture, appelées "READERS"
 *      dont chaque clé correspond au nom d'un tag du XML que l'on souhaite lire
 *      et la valeur associée est une fonction (node, data)
 *      où node est un noeud du document DOM
 *      et data est un objet où l'on stocke les informations lues dans le XML.
 *
 * @property {Method} ReverseGeocodeResponseReader.read - Méthode permettant de lancer la lecture d'une réponse XML du service de géocodage,
 *      à l'aide des READERS de la classe.
 *
 */

var ReverseGeocodeResponseReader = {};

/**
 * version du service de géocodage
 */
ReverseGeocodeResponseReader.VERSION = "1.2";

/**
 * Objet stockant les différents namespaces et les URI associées
 */
ReverseGeocodeResponseReader.NAMESPACES = {
    xmlns : "http://www.opengis.net/xls",
    gml : "http://www.opengis.net/gml",
    xls : "http://www.opengis.net/xls",
    xlsext : "http://www.opengis.net/xlsext",
    xsi : "http://www.w3.org/2001/XMLSchema-instance"
};

/**
 * Localisation (URL) du schema de définition du XML (XSD)
 */
ReverseGeocodeResponseReader.SCHEMALOCATION = "http://wxs.ign.fr/schemas/olsAll.xsd";

/**
 * Namespace par défaut du format
 */
ReverseGeocodeResponseReader.DEFAULTPREFIX = "xls";

/**
 * Objet contenant des fonctions de lecture, appelées "READERS"
 *      dont chaque clé correspond au nom d'un tag du XML que l'on souhaite lire
 *      et la valeur associée est une fonction (node, data)
 *      où node est un noeud du document DOM
 *      et data est un objet où l'on stocke les informations lues dans le XML.
 */
ReverseGeocodeResponseReader.READERS = {

    xls : {

        /** TODO : jsdoc block */
        XLS : function (root) {
            var reverseGeocodeResponse = new __WEBPACK_IMPORTED_MODULE_2__Response_model_GeocodeResponse__["a" /* default */]();

            // vérification de la version du service, et des namespaces de l'en-tête
            __checkServiceAttributes(root);

            // puis lancement de la lecture de l'ensemble des noeuds, en bouclant sur les childNodes
            __getChildNodes(root, reverseGeocodeResponse);

            return reverseGeocodeResponse;
        },

        /** TODO : jsdoc block */
        ReverseGeocodedLocation : function (node, reverseGeocodeResponse) {
            var reverseGeocodedLocation = new __WEBPACK_IMPORTED_MODULE_3__Response_model_ReverseGeocodedLocation__["a" /* default */]();

            __getChildNodes(node, reverseGeocodedLocation);

            // Ajout du résultat au tableau locations de reverseGeocodeResponse
            if (reverseGeocodeResponse && Array.isArray(reverseGeocodeResponse.locations)) {
                reverseGeocodeResponse.locations.push(reverseGeocodedLocation);
            }
        },

        /** TODO : jsdoc block */
        Address : function (node, reverseGeocodedLocation) {
            var countrycode = node.getAttribute("countryCode");
            if (reverseGeocodedLocation && countrycode) {
                reverseGeocodedLocation.type = countrycode;
            }
            // on va récupérer les autres informations (StreetAddress, place, postalCode...)
            __getChildNodes(node, reverseGeocodedLocation);
        },

        /** TODO : jsdoc block */
        Building : function (node, reverseGeocodedLocation) {
            var num = node.getAttribute("number");
            if (reverseGeocodedLocation && reverseGeocodedLocation.hasOwnProperty("placeAttributes")) {
                if (num) {
                    reverseGeocodedLocation.placeAttributes.number = num;
                } else if (node.getAttribute("buildingName")) {
                    reverseGeocodedLocation.placeAttributes.number = node.getAttribute("buildingName");
                } else if (node.getAttribute("subdivision")) {
                    reverseGeocodedLocation.placeAttributes.number = node.getAttribute("subdivision");
                }
            }
        },

        /** TODO : jsdoc block */
        Street : function (node, reverseGeocodedLocation) {
            // in case of a streetAddress result : street represents the street name
            if (reverseGeocodedLocation.type === "StreetAddress") {
                reverseGeocodedLocation.placeAttributes.street = __getChildValue(node);

                // in case of a cadastral parcel result : street represents the cadastral parcel identifier
            } else if (reverseGeocodedLocation.type === "CadastralParcel") {
                reverseGeocodedLocation.placeAttributes.cadastralParcel = __getChildValue(node);
            }
        },

        /** TODO : jsdoc block */
        Place : function (node, reverseGeocodedLocation) {
            var placeType = node.getAttribute("type");
            var placeName = __getChildValue(node);

            if (reverseGeocodedLocation && reverseGeocodedLocation.hasOwnProperty("placeAttributes")) {
                if (placeType === "Municipality") {
                    reverseGeocodedLocation.placeAttributes.municipality = placeName;
                } else if (placeType === "Bbox") {
                    var values = placeName.split(";");
                    if (values.length === 4) {
                        reverseGeocodedLocation.placeAttributes.bbox = {
                            left : parseFloat(values[0]),
                            right : parseFloat(values[2]),
                            top : parseFloat(values[1]),
                            bottom : parseFloat(values[3])
                        };
                    }
                } else if (placeType === "Commune") {
                    reverseGeocodedLocation.placeAttributes.commune = placeName;
                } else if (placeType === "Departement") {
                    reverseGeocodedLocation.placeAttributes.department = placeName;
                } else if (placeType === "INSEE") {
                    reverseGeocodedLocation.placeAttributes.insee = placeName;
                } else if (placeType === "Qualite") {
                    reverseGeocodedLocation.placeAttributes.quality = placeName;
                } else if (placeType === "Territoire") {
                    reverseGeocodedLocation.placeAttributes.territory = placeName;
                } else if (placeType === "ID") {
                    reverseGeocodedLocation.placeAttributes.ID = placeName;
                } else if (placeType === "ID_TR") {
                    reverseGeocodedLocation.placeAttributes.IDTR = placeName;
                } else if (placeType === "Importance") {
                    reverseGeocodedLocation.placeAttributes.importance = parseInt(placeName, 10);
                } else if (placeType === "Nature") {
                    reverseGeocodedLocation.placeAttributes.nature = placeName;
                } else if (placeType === "Numero") {
                    reverseGeocodedLocation.placeAttributes.number = placeName;
                } else if (placeType === "Feuille") {
                    reverseGeocodedLocation.placeAttributes.sheet = placeName;
                } else if (placeType === "Section") {
                    reverseGeocodedLocation.placeAttributes.section = placeName;
                } else if (placeType === "CommuneAbsorbee") {
                    reverseGeocodedLocation.placeAttributes.absorbedCity = placeName;
                } else if (placeType === "Arrondissement") {
                    if (placeName) {
                        reverseGeocodedLocation.placeAttributes.arrondissement = placeName;
                    }
                } else if (placeType === "Type") {
                    reverseGeocodedLocation.placeAttributes.origin = placeName;
                } else if (placeType === "Prefecture") {
                    reverseGeocodedLocation.placeAttributes.prefecture = placeName;
                } else if (placeType === "InseeRegion") {
                    reverseGeocodedLocation.placeAttributes.inseeRegion = placeName;
                } else if (placeType === "InseeDepartment") {
                    reverseGeocodedLocation.placeAttributes.inseeDepartment = placeName;
                }
            }
        },

        /** TODO : jsdoc block */
        PostalCode : function (node, reverseGeocodedLocation) {
            if (reverseGeocodedLocation && reverseGeocodedLocation.hasOwnProperty("placeAttributes")) {
                reverseGeocodedLocation.placeAttributes.postalCode = __getChildValue(node);
            }
        },

        /** TODO : jsdoc block */
        SearchCentreDistance : function (node, reverseGeocodedLocation) {
            if (reverseGeocodedLocation) {
                reverseGeocodedLocation.searchCenterDistance = parseFloat(node.getAttribute("value"));
            }
        },

        /** TODO : jsdoc block */
        Error : function (node) {
            // <Error message="For input string : &quot;2,45&quot;" errorCode="InternalServerError"/>
            var srvMess = node.getAttribute("message");
            var errorCode = node.getAttribute("errorCode");
            var message = __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION",
                "(" + errorCode + ") : " + srvMess);
            throw new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */]({
                message : message,
                type : __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
            });
        }
    },

    gml : {

        /** TODO : jsdoc block */
        pos : function (node, reverseGeocodedLocation) {
            var pos = __getChildValue(node);
            if (reverseGeocodedLocation && pos) {
                reverseGeocodedLocation.position = {
                    x : parseFloat(pos.split(" ")[0]),
                    y : parseFloat(pos.split(" ")[1])
                };
            }
        }
    },

    xlsext : {
        /** TODO : jsdoc block */
        ExtendedGeocodeMatchCode : function (node, reverseGeocodedLocation) {
            if (reverseGeocodedLocation) {
                reverseGeocodedLocation.matchType = __getChildValue(node);
            }
        }
    },

    /** TODO : jsdoc block */
    ExceptionReport : function (node) {
        var response = {};
        if (node.hasChildNodes()) {
            var children = node.childNodes;
            var child;
            for (var i = 0; i < children.length; i++) {
                child = children[i];
                if (child.nodeName === "Exception") {
                    response.exceptionReport = ReverseGeocodeResponseReader.READERS["Exception"](child);
                }
            }
        }
        return response;
    },

    /** TODO : jsdoc block */
    Exception : function (node) {
        var exceptionReport = {};

        // get exception code
        var exceptionCode = node.getAttribute("exceptionCode");
        if (exceptionCode) {
            exceptionReport.exceptionCode = exceptionCode;
        }

        // get exception message
        var textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            exceptionReport.exception = textNode.nodeValue;
        }

        return exceptionReport;
    }

};

/**
 * Méthode permettant de lancer la lecture d'une réponse XML du service de géocodage,
 *      à l'aide des READERS de la classe.
 *
 * @method ReverseGeocodeResponseReader.read
 * @param {DOMElement} root - racine de la réponse XML à lire
 * @return {Object} geocodeResponse|exceptionReport : l'objet contenant les informations de la réponse XML,
 *      sous la forme d'un objet GeocodeResponse, ou un objet littéral exceptionReport si le service a renvoyé une exception.
 * @static
 * @memberof ReverseGeocodeResponseReader
 */
ReverseGeocodeResponseReader.read = function (root) {
    if (root.nodeName === "XLS") {
        var nsPrefix = root.prefix;
        if (!nsPrefix) {
            nsPrefix = ReverseGeocodeResponseReader.DEFAULTPREFIX;
        }
        var geocodeResponse = ReverseGeocodeResponseReader.READERS[nsPrefix][root.nodeName](root);
        return geocodeResponse;
    } else if (root.nodeName === "ExceptionReport") {
        var exceptionReport = ReverseGeocodeResponseReader.READERS[root.nodeName](root);
        return exceptionReport;
    } else {
        throw new Error("Erreur lors de la lecture de la réponse : elle n'est pas au format attendu.");
    }
};

/**
 * Récupération des attributs d'un noeud élément
 *
 * @private
 * @memberof ReverseGeocodeResponseReader
 * @method __getAttributes
 * @param {DOMElement} node - noeud contenant l'attribut recherché
 * @return {Object} nodeAttributes - objet contenant les noms et valeurs des différents attributs
 */
function __getAttributes (node) {
    if (node.attributes.length > 0) {
        var nodeAttributes = {};
        var attributes = node.attributes;
        for (var i = 0; i < attributes.length; i++) {
            var attribute = attributes[i];
            nodeAttributes[attribute.nodeName] = attribute.nodeValue;
        }
        return nodeAttributes;
    }
}

/**
 * Récupération des noeuds enfants à partir d'un noeud donné, pour lecture (readNode).
 *
 * @private
 * @memberof ReverseGeocodeResponseReader
 * @method __getChildNodes
 * @param {DOMElement} node - a DOM node
 * @param {Array|Object} [data] - an object to be filled with node data
 */
function __getChildNodes (node, data) {
    if (node.hasChildNodes()) {
        var children = node.childNodes;
        var child;
        var childName;
        var childPrefix;

        for (var i = 0; i < children.length; i++) {
            child = children[i];

            if (child.nodeType === 1) { // 1 === node.ELEMENT_NODE
                childName = child.localName || child.baseName || child.nodeName;
                childPrefix = child.prefix || ReverseGeocodeResponseReader.DEFAULTPREFIX;

                if (ReverseGeocodeResponseReader.READERS[childPrefix][childName]) {
                    var reader = ReverseGeocodeResponseReader.READERS[childPrefix][childName];
                    reader(child, data);
                } else {
                    __getChildNodes(child, data);
                }
            }
        }
    }
}

/**
 * Lecture de la valeur du premier child d'un noeud, si elle existe.
 *
 * @private
 * @memberof ReverseGeocodeResponseReader
 * @method __getChildValue
 * @param {DOMElement} node - a DOM node
 * @return {String} value - valeur du firstChild du noeud en entrée, ou chaîne vide.
 */
function __getChildValue (node) {
    var textNode;
    var value = "";

    if (node.hasChildNodes()) {
        textNode = node.firstChild;
        if (textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            value = textNode.nodeValue;
        }
    }
    return value;
}

/**
 * Vérification des attributs du service, dans la balise XLS de la réponse :
 *      version, namespaces, et namespace par défaut doivent correspondre à ceux attendus.
 *
 * @private
 * @memberof ReverseGeocodeResponseReader
 * @method __checkServiceAttributes
 * @param {DOMElement} XLSNode - a DOM node, corresponding to XLS first tag.
 */
function __checkServiceAttributes (XLSNode) {
    if (XLSNode.attributes.length > 0) {
        // on récupère et parcourt les attributs de la balise XLS de la réponse
        var xlsAttributes = __getAttributes(XLSNode);
        for (var att in xlsAttributes) {
            if (xlsAttributes.hasOwnProperty(att)) {
                // vérification de la version
                if (att === "version") {
                    if (xlsAttributes["version"] !== ReverseGeocodeResponseReader.VERSION) {
                        // console.log("[ReverseGeocodeResponseReader] geocode version is not the expected one : there may be errors in parsing");
                        return;
                    }
                }

                // on vérifie que l'uri du namespace par défaut est bien celle que l'on attend
                if (att === "xmlns") {
                    if (xlsAttributes[att] !== ReverseGeocodeResponseReader.NAMESPACES[ReverseGeocodeResponseReader.DEFAULTPREFIX]) {
                        // console.log("[ReverseGeocodeResponseReader] geocode response default namespace is not the expected one");
                        return;
                    }
                    continue;
                }

                var prefix = att.split(":")[0];
                var ns = att.split(":")[1];

                // si on a un autre xmlns, on vérifie aussi les URI
                if (prefix === "xmlns" && ns) {
                    // si l'attribut correspond à un namespace défini dans le reader
                    if (ReverseGeocodeResponseReader.NAMESPACES[ns]) {
                        // il faut que les URI correspondent aussi.
                        if (ReverseGeocodeResponseReader.NAMESPACES[ns] !== xlsAttributes[att]) {
                            // console.log("[ReverseGeocodeResponseReader] geocode response " + att + " namespace is not the expected one");
                            return;
                        }
                    }
                }

                // pour finir on vérifie la localisation du schema XSD du service
                if (ns === "schemaLocation") {
                    if (ReverseGeocodeResponseReader.SCHEMALOCATION !== xlsAttributes[att]) {
                        // console.log("[ReverseGeocodeResponseReader] geocode response schema location is not the expected one");
                        return;
                    }
                }
            }
        }
    }
}

/* harmony default export */ __webpack_exports__["a"] = (ReverseGeocodeResponseReader);


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommonService__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Response_AutoCompleteResponseFactory__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_Helper__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Exceptions_ErrorService__ = __webpack_require__(2);







/**
 * @classdesc
 * Appel du service d'autocomplétion du Géoportail :
 * envoi de la requête construite selon les paramètres en options,
 * éventuellement parsing et analyse  de la réponse,
 * retour d'une réponse en paramètre de la fonction onSuccess.
 * @constructor
 * @extends {Gp.Services.CommonService}
 * @alias Gp.Services.AutoComplete
 *
 * @param {Object} options - options spécifiques au service (+ les options heritées)
 *
 * @param {String} options.text - La chaîne de caractère à compléter.
 *      Cette chaîne n'est pas "URL encodée".
 *      C'est l'API qui s'occupe de l'encoder pour l'inclure dans la requête.
 *
 * @param {Array.<String>} [options.filterOptions.type = "StreetAddress"] - Type de l'objet recherché.
 *      Le service d'autocomplétion du Géoportail permet de rechercher des toponymes 'PostionOfInterest' et/ou des adresses postales 'StreetAddress'.
 *      D'autres types pourront être rajoutés selon l'évolution du service.
 *      Par défaut, type = ['StreetAddress'].
 *
 * @param {Array.<String>} [options.filterOptions.territory] - Limitation de la zone de recherche de localisants.
 *      Le service d'autocomplétion du Géoportail permet de limiter la recherche à la métropole et la Corse : options.filterOptions.territory = ['METROPOLE'],
 *      DOMS TOMS : options.filterOptions.territory = ['DOMTOM'], ou à une liste de départements : options.filterOptions.territory = ['31', '34']
 *      Pas de valeur par défaut.
 *      La valeur par défaut est donc celle du service.
 *      Le service d'autocomplétion du Géoportail renvoie toutes les informations quand aucun territoire n'est spécifié.
 *
 * @param {Number} [options.maximumResponses = 10] - Nombre de réponses maximal que l'on souhaite recevoir.
 *      Pas de valeur par défaut.
 *      La valeur par défaut sera donc celle du service : 10.
 *
 * @example
 *   var options = {
 *      // options communes aux services
 *      apiKey : null,
 *      serverUrl : 'http://localhost/service/',
 *      protocol : 'JSONP', // JSONP|XHR
 *      proxyURL : null,
 *      httpMethod : 'GET', // GET|POST
 *      timeOut : 10000, // ms
 *      rawResponse : false, // true|false
 *      scope : null, // this
 *      onSuccess : function (response) {},
 *      onFailure : function (error) {},
 *      // spécifique au service
 *      text : "",
 *      filterOptions : {
 *          type : ["StreetAddress"],
 *          territory : ['METROPOLE', 'DOMTOM', '31']
 *      },
 *      maximumResponses : 10
 *   };
 * @private
 */
function AutoComplete (options) {
    if (!(this instanceof AutoComplete)) {
        throw new TypeError(__WEBPACK_IMPORTED_MODULE_3__Utils_MessagesResources__["a" /* default */].getMessage("CLASS_CONSTRUCTOR", "AutoComplete"));
    }

    /**
     * Nom de la classe (heritage)
     * FIXME instance ou classe ?
     */
    this.CLASSNAME = "AutoComplete";

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_0__CommonService__["a" /* default */].apply(this, arguments);

    this.logger = __WEBPACK_IMPORTED_MODULE_2__Utils_LoggerByDefault__["a" /* default */].getLogger("Gp.Services.AutoComplete");
    // this.// logger.trace("[Constructeur AutoComplete (options)]");

    if (!options.text) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_3__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "text"));
    }

    // ajout des options spécifiques au service
    this.options.text = options.text;

    // on definit des filtres par defaut
    if (!options.filterOptions || typeof options.filterOptions !== "object") {
        this.options.filterOptions = options.filterOptions = {
            territory : [],
            type : ["StreetAddress"]
        };
    }

    // FIXME ECMAScript 5 support (valable pour un objet uniquement !)
    // ceci permet de tester le cas où : object = {}
    if (Object.keys(options.filterOptions).length === 0) {
        this.options.filterOptions = {
            territory : [],
            type : ["StreetAddress"]
        };
    }

    this.options.filterOptions.type = options.filterOptions.type || ["StreetAddress"];
    this.options.filterOptions.territory = options.filterOptions.territory || [];
    this.options.maximumResponses = options.maximumResponses || 10;

    // INFO
    // le service ne repond pas en mode POST (405 Method Not Allowed)
    if (this.options.protocol === "XHR" && this.options.httpMethod === "POST") {
        this.logger.warn("Le service ne gére pas le mode d'interrogation en POST, on bascule sur du GET !");
        this.options.httpMethod = "GET"; // on surcharge !
    }

    // attributs d'instances

    /**
     * Format forcé de la réponse du service : "json"
     * sauf si l'on souhaite une reponse brute (options.rawResponse)
     */
    this.options.outputFormat = (this.options.rawResponse) ? "" : "json";
}

/**
 * @lends module:AutoComplete#
 */

AutoComplete.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__CommonService__["a" /* default */].prototype, {
    // todo
    // getter/setter
});

/*
 * Constructeur (alias)
 */
AutoComplete.prototype.constructor = AutoComplete;

/**
 * (overwrite)
 * Création de la requête
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback
 */
AutoComplete.prototype.buildRequest = function (error, success) {
    // ex.
    // http://wxs.ign.fr/CLEF/ols/apis/completion?
    // text=Brie-Comt&
    // type=StreetAddress,PositionOfInterest&
    // territory=METROPOLE&
    // maximumResponses=10

    // traitement des param KPV sous forme de tableau
    var territories = "";
    if (this.options.filterOptions.territory) {
        territories = this.options.filterOptions.territory.join(";");
    }

    var types = "";
    if (this.options.filterOptions.type) {
        types = this.options.filterOptions.type.join(",");
    }

    // normalisation de la requete avec param KPV
    this.request = __WEBPACK_IMPORTED_MODULE_4__Utils_Helper__["a" /* default */].normalyzeParameters({
        text : encodeURIComponent(this.options.text),
        type : types,
        terr : territories,
        maximumResponses : this.options.maximumResponses
    });

    (!this.request)
        ? error.call(this, new __WEBPACK_IMPORTED_MODULE_5__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_REQUEST_BUILD")))
        : success.call(this, this.request);
};

/**
 * (overwrite)
 * Analyse de la reponse
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback de succès de l'analyse de la réponse
 */
AutoComplete.prototype.analyzeResponse = function (error, success) {
    if (this.response) {
        var options = {
            response : this.response,
            rawResponse : this.options.rawResponse,
            onSuccess : success,
            onError : error,
            scope : this
        };

        __WEBPACK_IMPORTED_MODULE_1__Response_AutoCompleteResponseFactory__["a" /* default */].build(options);
    } else {
        error.call(this, new __WEBPACK_IMPORTED_MODULE_5__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AutoComplete);


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_AutoCompleteResponse__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_SuggestedLocation__ = __webpack_require__(42);
/**
 * Factory pour générer une reponse JSON à partir d'un XML ou d'un JSON
 * (Factory)
 *
 * @module AutoCompleteResponseFactory
 * @private
 * @alias Gp.Services.AutoComplete.Response.AutoCompleteResponseFactory
 */






var AutoCompleteResponseFactory = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant Alti
     *
     * @example
     *   var options = {
     *      response :
     *      outputFormat :
     *      rawResponse :
     *      scope :
     *      onSuccess :
     *      onError :
     *   };
     *
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("AutoCompleteResponseFactory");
        // logger.trace(["AutoCompleteResponseFactory::build()"]);

        var data = null;

        if (options.response) {
            if (options.rawResponse) {
                // logger.trace("analyze response : raw");
                data = options.response;
            } else {
                var JSONResponse;
                if (typeof options.response === "string") {
                    JSONResponse = JSON.parse(options.response);
                } else {
                    JSONResponse = options.response;
                }

                // analyse de la réponse
                if (JSONResponse) {
                    // le service renvoie t il une erreur ?
                    if (JSONResponse.error) {
                        // ex. ?
                        options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                            message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", JSONResponse.error.description),
                            status : JSONResponse.error.code,
                            type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
                        }));
                        return;
                    }

                    // création de l'objet réponse
                    data = new __WEBPACK_IMPORTED_MODULE_3__model_AutoCompleteResponse__["a" /* default */]();

                    // boucle sur les résultats de l'autocomplétion
                    if (JSONResponse.results && Array.isArray(JSONResponse.results)) {
                        var suggestedLocation;

                        for (var i = 0; i < JSONResponse.results.length; i++) {
                            var result = JSONResponse.results[i];
                            suggestedLocation = new __WEBPACK_IMPORTED_MODULE_4__model_SuggestedLocation__["a" /* default */]();

                            if (suggestedLocation) {
                                if (result && result.country === "StreetAddress") {
                                    suggestedLocation.street = result.street;
                                    suggestedLocation.type = "StreetAddress";
                                } else if (result && result.country === "PositionOfInterest") {
                                    suggestedLocation.poi = result.street;
                                    suggestedLocation.kind = result.kind;
                                    suggestedLocation.type = "PositionOfInterest";
                                }

                                if (suggestedLocation.position) {
                                    suggestedLocation.position.x = result.x;
                                    suggestedLocation.position.y = result.y;
                                }

                                suggestedLocation.commune = result.city;
                                suggestedLocation.fullText = result.fulltext;
                                suggestedLocation.postalCode = result.zipcode;
                                suggestedLocation.classification = result.classification;
                            }
                            // Ajout du résultat au tableau reverseGeocodedLocations de geocodedLocation
                            data.suggestedLocations.push(suggestedLocation);
                        }
                    } else {
                        options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_FORMAT_3")));
                        return;
                    }

                    if (!data.suggestedLocations.length) {
                        options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_FORMAT_3")));
                        return;
                    }
                }

                if (!data) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                        message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_ANALYSE_2"),
                        type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_UNKERR,
                        status : -1
                    }));
                    return;
                }

                // Si la réponse contenait une exception renvoyée par le service
                if (data.exceptionReport) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                        message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", data.exceptionReport),
                        type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR,
                        status : 200
                    }));
                    return;
                }
            }
        } else {
            // si la réponse (xmlString) est vide, on appelle le callback d'erreur
            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
            return;
        }

        // si tout s'est bien passé, on appelle le callback de succès
        options.onSuccess.call(options.scope, data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AutoCompleteResponseFactory);


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonService__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultUrlService__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Request_RouteRequestFactory__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Response_RouteResponseFactory__ = __webpack_require__(93);









/**
 * @classdesc
 * Appel du service d'itinéraire du Géoportail :
 *     envoi de la requête construite selon les paramètres en options,
 *     éventuellement parsing et analyse  de la réponse,
 *     retour d'une réponse en paramètre de la fonction onSuccess.
 *
 * @alias Gp.Services.Route
 * @constructor
 * @extends {Gp.Services.CommonService}
 * @param {Object} options - options spécifiques au service (+ les options heritées)
 *
 * @param {String} [options.api] - Manière d'accéder au service : 'REST' (via l'API REST) ou 'OLS' (via la norme XLS).
 * Par défaut, on utilise l'API REST.
 *
 * @param {String} options.outputFormat - Le format de la réponse du service itineraire : 'xml' ou 'json'.
 *      Ce paramètre déterminera l'extension '.xml' ou '.json' du service dans le cas de l'API REST.
 *      Nécessaire si serverUrl est renseigné, et qu'on souhaite passer par l'API REST,
 *      pour connaître le format dans lequel sera fournie la réponse (pour son traitement).
 *      Non nécessaire pour la norme OLS. Par défaut, ce paramètre vaut 'json'.
 *
 * @param {String} [options.routePreference = "fastest"] - Mode de calcul à utiliser :
 * - le plus rapide « fastest »
 * - le plus court « shortest »
 * Par défaut : « fastest ».
 *
 * @param {Object} options.startPoint - Point de départ du calcul. Coordonnées exprimées en longitudes, latitudes (EPSG:4326)
 * @param {Float} options.startPoint.x - Abcisse du point de départ du calcul d'itinéraire.
 * @param {Float} options.startPoint.y - Ordonnée du point de départ du calcul d'itinéraire.
 *
 * @param {Object} options.endPoint - Point d'arrivée du calcul. Coordonnées exprimées en longitudes, latitudes (EPSG:4326)
 * @param {Float} options.endPoint.x - Abcisse du point d'arrivée du calcul d'itinéraire.
 * @param {Float} options.endPoint.y - Ordonnée du point d'arrivée du calcul d'itinéraire.
 *
 * @param {Object[]} [options.viaPoints] - Liste de point ({x:Float,y:Float}) intermédaires que l'itinéraire doit emprunter dans l'ordre du tableau.
 *      Coordonnées exprimées en longitudes, latitudes (EPSG:4326) :{x:float, y:float}
 *
 * @param {String} [options.graph = "voiture"] - Type de graphe utilisé : "Voiture" ou "Pieton".
 *      Détermine le profil de vitesses utilisé pour le calcul ainsi que les tronçons autorisés ou non.
 *      Par défaut, c'est la valeur "Voiture" qui sera utilisée.
 *
 * @param {String[]} [options.exclusions] - Critères d'exclusions à appliquer pour le calcul. (correspond au paramètre "avoidFeature" d'OpenLS)
 *      On précise ici le type de tronçons que l'on ne veut pas que l'itinéraire emprunte
 *      (valeurs possibles : « toll » (éviter les péages), « bridge », « tunnel »).
 *
 * @param {Boolean} [options.geometryInInstructions = false] - Indique si la géométrie de l'itinéraire doit être reprise morceau par morceau dans les instructions.
 *      (correspond au paramètre "provideGeometry" d'OpenLS) Par défaut : false.
 *
 * @param {Boolean} [options.provideBbox = true] - Indique si les instructions doivent être localisées par une bbox dans la réponse.
 *      Par défaut : true.
 *
 * @param {String} [options.distanceUnit = "km"] - Indique si la distance doit être exprimée en km ou m dans la réponse.
 *      Par défaut : km.
 *
 * @param {String} [options.srs] - Système de coordonnées dans lequel les paramètres géographiques en entrée et la réponse du service sont exprimés.
 *      Pas de valeur par défaut. Si le serveur consulté est celui du Géoportail, la valeur par défaut sera donc celle du service : 'EPSG:4326'.
 *
 * @example
 *  var options = {
 *      // options communes aux services
 *      apiKey : null,
 *      serverUrl : 'http://localhost/service/',
 *      protocol : 'JSONP', // JSONP|XHR
 *      proxyURL : null,
 *      httpMethod : 'GET', // GET|POST
 *      timeOut : 10000, // ms
 *      rawResponse : false, // true|false
 *      scope : null, // this
 *      onSuccess : function (response) {},
 *      onFailure : function (error) {},
 *      // spécifique au service
 *      api : 'OLS',
 *      outputFormat : 'xml',
 *      startPoint : {
 *          x : 42.1121,
 *          y : 1.5557
 *      },
 *      endPoint : {
 *          x : 42.1121,
 *          y : 1.5557
 *      },
 *      provideBbox : false,
 *      exclusions : ["Bridge", "Tunnel", "Toll"],
 *      distanceUnit : "km",
 *      graph : "Voiture",
 *      geometryInInstructions : false,
 *      routePreference : "fastest"
 *  };
 *
 * @private
 */
function Route (options) {
    if (!(this instanceof Route)) {
        throw new TypeError(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("CLASS_CONSTRUCTOR", "Route"));
    }

    /**
     * Nom de la classe (heritage)
     * FIXME instance ou classe ?
     */
    this.CLASSNAME = "Route";

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_3__CommonService__["a" /* default */].apply(this, arguments);

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("Gp.Services.Route");
    // this.// logger.trace("[Constructeur Route (options)]");

    if (!options.startPoint) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "startPoint"));
    }

    // on lance une exception afin d'eviter au service de le faire...
    if (options.startPoint.x === null) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "startPoint.x"));
    }

    if (options.startPoint.y === null) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "startPoint.y"));
    }

    if (!options.endPoint) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "endPoint"));
    }

    // on lance une exception afin d'eviter au service de le faire...
    if (options.endPoint.x === null) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "endPoint.x"));
    }

    if (options.endPoint.y === null) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "endPoint.y"));
    }

    // options par defaut
    // on passe l'option api en majuscules afin d'éviter des exceptions.
    this.options.api = (typeof options.api === "string") ? options.api.toUpperCase() : "REST";

    // on passe l'option outputFormat en minuscules afin d'éviter des exceptions.
    this.options.outputFormat = (typeof options.outputFormat === "string") ? options.outputFormat.toLowerCase() : "json";

    this.options.startPoint = options.startPoint;
    this.options.endPoint = options.endPoint;
    this.options.viaPoints = options.viaPoints || null; // INFO mapping viaPoints <=> xls:viaPoint
    this.options.exclusions = options.exclusions || null; // INFO mapping exclusions <=> xls:avoidFeature
    this.options.routePreference = options.routePreference || "fastest";
    this.options.graph = options.graph || "Voiture";
    this.options.geometryInInstructions = options.geometryInInstructions || false; // INFO mapping geometryInInstructions <=> xls:provideGeometry
    this.options.provideBbox = options.provideBbox || true; // INFO mapping provideBbox <=> xls:provideBoundingBox
    this.options.distanceUnit = options.distanceUnit || "km";
    this.options.expectedStartTime = null; // FIXME not yet implemented !
    this.options.srs = options.srs || "EPSG:4326";

    // FIXME : les readers OLS ne sont pas implémentés. on utilise donc l'API REST.
    this.options.api = "REST";
    this.logger.warn("FIXME : Surcharge option 'api' : REST");
    if (this.options.protocol === "XHR") {
        this.options.httpMethod = "GET";
        // this.// logger.trace("Surcharge option 'HttpMethod' : " + this.options.httpMethod);
    }

    // gestion de l'url du service par defaut
    // si l'url n'est pas renseignée, il faut utiliser les urls par defaut
    // en fonction du type d'api, REST ou OLS
    if (!this.options.serverUrl) {
        var lstUrlByDefault = __WEBPACK_IMPORTED_MODULE_4__DefaultUrlService__["a" /* default */].Route.url(this.options.apiKey);
        var urlFound = null;
        switch (this.options.api) {
            case "OLS":
                urlFound = lstUrlByDefault.ols;
                break;
            case "REST":
                var key = "route" + "-" + this.options.outputFormat;
                urlFound = lstUrlByDefault[key];
                break;
            default:
                throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_UNKNOWN", "api"));
        }

        if (!urlFound) {
            throw new Error("Url by default not found !");
        }
        this.options.serverUrl = urlFound;
        // this.// logger.trace("Serveur URL par defaut : " + this.options.serverUrl);
    }

    // gestion du type de service
    // si l'extension de l'url est .json ou .xml, on surcharge le format de sortie (outputFormat)
    var idx = this.options.serverUrl.lastIndexOf(".");
    if (idx !== -1) {
        var extension = this.options.serverUrl.substring(idx + 1);
        if (extension && extension.length < 5) { // FIXME extension de moins de 4 car. ...
            // this.// logger.trace("Serveur Extension URL : " + extension);
            switch (extension.toLowerCase()) {
                case "json":
                case "xml":
                    this.options.outputFormat = extension.toLowerCase();
                    break;
                default:
                    throw new Error("type of service : unknown or unsupported (json or xml) !");
            }
        }
    }
}

/**
 * @lends module:Route#
 */
Route.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_3__CommonService__["a" /* default */].prototype, {
    // todo
    // getter/setter
});

/*
 * Constructeur (alias)
 */
Route.prototype.constructor = Route;

/**
 * (overwrite)
 * Création de la requête
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback
 */
Route.prototype.buildRequest = function (error, success) {
    var options = {
        // spécifique au service
        api : this.options.api,
        startPoint : this.options.startPoint,
        endPoint : this.options.endPoint,
        viaPoints : this.options.viaPoints,
        provideBbox : this.options.provideBbox,
        exclusions : this.options.exclusions,
        distanceUnit : this.options.distanceUnit,
        graph : this.options.graph,
        geometryInInstructions : this.options.geometryInInstructions,
        routePreference : this.options.routePreference,
        srs : this.options.srs
    };

    this.request = __WEBPACK_IMPORTED_MODULE_5__Request_RouteRequestFactory__["a" /* default */].build(options);

    // on teste si la requete a bien été construite !
    if (!this.request) {
        error.call(this, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_REQUEST_BUILD")));
    } else {
        success.call(this, this.request);
    }
};

/**
 * (overwrite)
 * Analyse de la reponse
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback
 */
Route.prototype.analyzeResponse = function (error, success) {
    // INFO
    // Factory pour masquer la complexité du retour du service qui renvoie soit
    //  - une 'string' qui contient du XML ou JSON natif en mode XHR
    //  - un objet JSON qui est natif ou encapsulé

    if (this.response) {
        var options = {
            distanceUnit : this.options.distanceUnit, // FIXME ce parametre nous permet de choisir le type d'unité dans la reponse !
            response : this.response,
            outputFormat : this.options.outputFormat, // utile pour parser la string en mode XHR : JSON ou XML !
            api : this.options.api, // utile de connaitre le type d'API car la reponse est differente !
            rawResponse : this.options.rawResponse,
            onError : error,
            onSuccess : success,
            scope : this
        };

        __WEBPACK_IMPORTED_MODULE_6__Response_RouteResponseFactory__["a" /* default */].build(options);
    } else {
        error.call(this, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Route);


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RouteRequestOLS__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteRequestREST__ = __webpack_require__(91);
/**
 * Creation d'une requête OpenLS ou REST en mode POST ou GET
 * (Factory)
 *
 * @module RouteRequestFactory
 * @alias Gp.Services.Route.Request.RouteRequestFactory
 * @private
 */





var RouteRequestFactory = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant Route
     *
     * @example
     *   // utilisation avec les callback
     *   var options = {
     *      (...)
     *      onSuccess : function (response) {},
     *      onError : function (error) {},
     *      // spécifique au service
     *      api : 'OLS',
     *      startPoint : {
     *          x : 42.1121,
     *          y : 1.5557
     *      },
     *      endPoint : {
     *          x : 42.1121,
     *          y : 1.5557
     *      },
     *      provideBbox : false,
     *      exclusions : ["Bridge", "Tunnel", "Toll"],
     *      distanceUnit : "km",
     *      graph : "Voiture",
     *      geometryInInstructions : false,
     *      routePreference : "fastest"
     *   };
     *   RouteRequestFactory.build(options);
     *
     *   // utilisation sans callback
     *   var options = {...};
     *   try {
     *      var result = RouteRequestFactory.build(options);
     *      if (! result) { throw new Error("..."):}
     *   } catch (e) {
     *      // todo
     *   }
     * @returns {String} request
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("RouteRequestFactory");
        // logger.trace(["RouteRequestFactory::build()"]);

        var request = null;

        var settings = options || {};

        // gestion des callback
        var bOnError = !!((options.onError !== null && typeof options.onError === "function"));

        var message = null;
        // choix entre les 2 types d'API pour consulter le service
        switch (options.api) {
            case "REST":
                // FIXME les exceptions ne sont pas 'catchées' sur le constructeur !
                var myReq = new __WEBPACK_IMPORTED_MODULE_3__RouteRequestREST__["a" /* default */](settings);
                if (!myReq.processRequestString()) {
                    message = "Error process request (rest) !";
                    if (bOnError) {
                        options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */](message));
                        return;
                    }
                    throw new Error(message);
                }
                request = myReq.requestString;
                break;
            case "OLS":
                request = __WEBPACK_IMPORTED_MODULE_2__RouteRequestOLS__["a" /* default */].build(settings);
                if (!request) {
                    message = "Error process request (ols) !";
                    if (bOnError) {
                        options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */](message));
                        return;
                    }
                    throw new Error(message);
                }
                break;
            default:
                message = "Type of API is not supported by service (REST or OLS) !";
                if (bOnError) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_1__Exceptions_ErrorService__["a" /* default */](message));
                    return;
                }
                throw new Error(message);
        }

        return request;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (RouteRequestFactory);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Formats_XLS__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Formats_XLS_RouteService__ = __webpack_require__(87);
/**
 * Creation d'une requête OpenLS en mode POST ou GET
 * (Factory)
 *
 * @module RouteRequestOLS
 * @alias Gp.Services.Route.Request.RouteRequestOLS
 * @private
 */




var RouteRequestOLS = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant Route
     *
     * @example
     *   var options = {
     *      (...)
     *   };
     *
     * @returns {String} request
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("RouteRequestOLS");
        // logger.trace(["RouteRequestOLS::build()"]);

        var request = null;

        // spécifique au service
        var settings = {
            startPoint : options.startPoint,
            endPoint : options.endPoint,
            viaPoint : options.viaPoints, // mapping OLS et options
            provideBoundingBox : options.provideBbox, // mapping OLS et options
            avoidFeature : options.exclusions, // mapping OLS et options
            expectedStartTime : options.expectedStartTime, // TODO format ?
            distanceUnit : options.distanceUnit,
            graph : options.graph,
            provideGeometry : options.geometryInInstructions, // mapping OLS et options
            routePreference : options.routePreference
        };

        // objet RouteService
        var oRS = new __WEBPACK_IMPORTED_MODULE_2__Formats_XLS_RouteService__["a" /* default */](settings);

        // Format XLS
        var oXLS = new __WEBPACK_IMPORTED_MODULE_1__Formats_XLS__["a" /* default */]({
            srsName : options.srs,
            maximumResponses : options.maximumResponses
        });
        oXLS.namespace = true;
        oXLS.setService(oRS);

        // request brute !
        request = oXLS.build();

        // en mode GET, la requête est encodée
        // et le param. 'qxml' est ajouté
        if (options.httpMethod === "GET") {
            var myRequest = "qxml=" +
                encodeURIComponent(request)
                    .replace(/-/g, "%2D")
                    .replace(/_/g, "%5F")
                    .replace(/\./g, "%2E")
                    .replace(/!/g, "%21")
                    .replace(/~/g, "%7E")
                    .replace(/\*/g, "%2A")
                    .replace(/'/g, "%27")
                    .replace(/\(/g, "%28")
                    .replace(/\)/g, "%29");
            request = myRequest;
        }

        return request;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (RouteRequestOLS);


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AbstractService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RouteService_DetermineRouteRequest__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteService_RouteRequestExtension__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteService_RouteRequestExtension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RouteService_RouteRequestExtension__);





/**
 * @classdesc
 *
 * Requête de type RouteService
 * (Factory)
 *
 * XSD :
 * ----
 * [] => non implementé !
 *
 * ```
 * element name="DetermineRouteRequest"
 *  [attribute name="provideRouteHandle" default="false"]
 *  attribute name="distanceUnit"       default="M"
 *      [element ref="xls:RouteHandle" || element ref="xls:RoutePlan"]
 *      element ref="xls:RoutePlan"
 *      element ref="xls:RouteInstructionsRequest"
 *      [element ref="xls:RouteGeometryRequest"]
 *      [element ref="xls:RouteMapRequest"]
 * ```
 * ```
 * element name="RoutePlan"
 *  [attribute name="useRealTimeTraffic" default="false"]
 *  [attribute name="expectedStartTime"  type="dateTime"]
 *  [attribute name="expectedEndTime"    type="dateTime"]
 *      element ref="xls:RoutePreference"
 *      element ref="xls:WayPointList"
 *      element ref="xls:AvoidList"
 * ```
 * ```
 * element name="RoutePreference" => value = Fastest | Shortest | Pedestrian
 * ```
 * ```
 * element name="WayPointList"
 *      element ref="xls:StartPoint"
 *      element ref="xls:ViaPoint" minOccurs="0"
 *      element ref="xls:EndPoint"
 * ```
 * ```
 * element name="StartPoint"
 *    [element name="GeocodeMatchCode"]
 *      [attribute name="accuracy"]
 *      [attribute name="matchType"] => value = City, Street, Street number, Street enhanced, ...
 *    element name="Position"
 *      element ref="gml:Point"
 * ```
 * ```
 * element name="ViaPoint"
 *    [element name="GeocodeMatchCode"]
 *      [attribute name="accuracy"]
 *      [attribute name="matchType"] => value = City, Street, Street number, Street enhanced, ...
 *    element name="Position"
 *      element ref="gml:Point"
 * ```
 * ```
 * element name="EndPoint"
 *    [element name="GeocodeMatchCode"]
 *      [attribute name="accuracy"]
 *      [attribute name="matchType"] => value = City, Street, Street number, Street enhanced, ...
 *    element name="Position"
 *      element ref="gml:Point"
 * ```
 * ```
 * element name="AvoidList"
 *      [element ref="xls:AOI"]
 *      [element ref="xls:_Location"] (cf. element name="Position")
 *      element ref="xls:AvoidFeature"
 * ```
 * ```
 * [element name="AOI"]
 *      [element ref="gml:CircleByCenterPoint" || element ref="gml:Polygon" || element ref="gml:Envelope"]
 * ```
 * ```
 * element name="AvoidFeature" => value = highway | tollway | tunnel | bridge
 * ```
 * ```
 * [element name="RouteMapRequest"]
 *      [element name="Output"]
 *          attribute name="width"
 *          attribute name="height"
 *          attribute name="format"
 *          attribute name="BGcolor"
 *          attribute name="transparent"
 *          attribute name="style" => value = Overview | Maneuver
 *          element name="BBoxContext" type="gml:EnvelopeType"
 * ```
 * ```
 * element name="RouteInstructionsRequest"
 *  [attribute name="format"]           default="text/plain"
 *  attribute name="provideGeometry"    default="false"
 *  attribute name="provideBoundingBox" default="false"
 * ```
 * ```
 * [element name="RouteGeometryRequest"]
 *  [attribute name="scale"]                  default="1"
 *  [attribute name="provideStartingPortion"] default="false"
 *  [attribute name="maxPoints"]              default="100"
 *      [element name="BoundingBox" type="gml:EnvelopeType" ]
 * ```
 *
 * --------
 * Requête :
 * --------
 * ```
 * <?xml version="1.0" encoding="UTF-8"?>
 * <XLS
 * xmlns:xls="http://www.opengis.net/xls"
 * xmlns:sch="http://www.ascc.net/xml/schematron"
 * xmlns:gml="http://www.opengis.net/gml"
 * xmlns:xlsext="http://www.opengis.net/xlsext"
 * xmlns:xlink="http://www.w3.org/1999/xlink"
 * xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
 * xsi:schemaLocation="http://www.opengis.net/xls http://schemas.opengis.net/ols/1.1.0/RouteService.xsd"
 * version="1.1" xls:lang="en">
 * <RequestHeader/>
 * <Request methodName="RouteRequest" requestID="123456789" version="1.1">
 *   <DetermineRouteRequest distanceUnit="KM">
 *     <RoutePlan>
 *       <RoutePreference>Fastest</RoutePreference>
 *       <xlsext:vehicle name="Car" />
 *       <WayPointList>
 *         <StartPoint>
 *           <Position><gml:Point srsName="EPSG:4326"><gml:pos>2.29993 48.87228</gml:pos></gml:Point></Position>
 *         </StartPoint>
 *         <EndPoint>
 *           <Position><gml:Point srsName="EPSG:4326"><gml:pos>-1.53604 47.21548</gml:pos></gml:Point></Position>
 *         </EndPoint>
 *       </WayPointList>
 *     </RoutePlan>
 *     <RouteInstructionsRequest provideGeometry="true"/>
 *     <RouteGeometryRequest/>
 *   </DetermineRouteRequest>
 * </Request>
 * </XLS
 * ```
 * -----------
 * References :
 * -----------
 * - {@link https://geoportail.forge.ign.fr/jira/browse/GPP-CI}
 * - {@link https://geoportail.forge.ign.fr/jira/browse/GPP-CI-1 Specif. ols}
 * - {@link https://geoportail.forge.ign.fr/jira/browse/GPP-CI-9 Extension}
 * - {@link https://github.com/Emergya/openlayers/blob/master/lib/OpenLayers/Format/XLS/v1_2_0.js}
 *
 * @example
 * // encapsule un objet dans une coquille XSL, Factory sur les objets ''
 * rs = new RouteService ();
 * rs.addRequest (req);
 * rs.toString();
 *  ou
 * rs = new RouteService ({
 *      ...
 * });
 * rs.toString();
 *
 * @extends {Gp.Formats.XLS}
 * @constructor
 * @alias Gp.Formats.XLS.RouteService
 * @param {Object} options - options
 * @param {Object}   options.routePreference - « fastest », « shortest » ou « pedestrian »
 * @param {String}   options.startPoint - Point de départ (coordonnées exprimées en WGS84G)
 * @param {String}   options.viaPoint - Liste de points intermédiaires
 * @param {String}   options.endPoint - Point d'arrivée (coordonnées)
 * @param {Object}   options.avoidFeature - « highway », « tollway », « tunnel » ou « bridge »
 * @param {Object}   options.graph - « car »
 * @param {Object}   options.expectedStartTime - Date et heure de départ
 * @param {Object}   options.provideGeometry - true | false
 * @param {Object}   options.provideBoundingBox - true | false
 * @param {Object}   options.distanceUnit - Unité dans lesquelles la distance est exprimée (« m » ou « km »)
 * @param {Function} options.onsuccess - function callback success (TODO)
 * @param {Function} options.onerror   - function callback error   (TODO)
 *
 * @example
 * var options = {
 *      // spécifique au service
 *      startPoint: {
 *          x: 42.1121,
 *          y: 1.5557
 *      },
 *      endPoint: {
 *          x: 42.1121,
 *          y: 1.5557
 *      },
 *      viaPoint : [
 *          {x: 42.1121,y: 1.5557},
 *          {x: 42.1121,y: 1.5557},
 *          {x: 42.1121,y: 1.5557}
 *      ],
 *      provideBoundingBox : false,
 *      avoidFeature : ["bridge", "tunnel", "tollway"],
 *      expectedStartTime : "2015-12-23", // YYYY-MM-DDThh:mm:ssZ
 *      distanceUnit : "km",
 *      vehicle: "car",
 *      provideGeometry : false,
 *      routePreference : "fastest"
 * };
 *
 * @private
 */
function RouteService (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur RouteService ()]");

    if (!(this instanceof RouteService)) {
        throw new TypeError("RouteService constructor cannot be called as a function.");
    }

    /**
     * Nom de la classe
     */
    this.CLASSNAME = "RouteService";

    /**
     * Type de classe
     * RouteRequest par defaut
     */
    this.CLASSTYPE = "RouteRequest";

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_1__AbstractService__["a" /* default */].apply(this, arguments);
}

/**
 * @lends module:RouteService#
 */
RouteService.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__AbstractService__["a" /* default */].prototype, {
    // todo
    // getter/setter
});

/**
 * Constructeur (alias)
 */
RouteService.prototype.constructor = RouteService;

/**
 * (overwrite) Ajout d'un objet de type  : RouteRequest
 *
 * @param {Object} oRequest - RouteRequest
 */
RouteService.prototype.addRequest = function (oRequest) {
    // on controle les types acceptés
    if (oRequest.CLASSNAME === "DetermineRouteRequest") {
        this.oRequest = oRequest;
    } else {
        throw new Error("Ce n'est pas un objet de type 'Route Request' !?");
    }
};

/**
 * (overwrite) Ajout d'un objet de type RouteFilterExtension
 *
 * @param {Object} oFilter - RouteFilterExtension
 */
RouteService.prototype.addFilter = function (oFilter) {
    // gestion des extensions (vehicle)
    if (oFilter instanceof __WEBPACK_IMPORTED_MODULE_3__RouteService_RouteRequestExtension___default.a) {
        this.oFilter = oFilter;
    }
};

/**
 * (overwrite) toString
 *
 * @returns {String} requête
 */
RouteService.prototype.toString = function () {
    // soit, on a un objet Request déjà instancié
    // sinon, il faut le construire à partir des options à disposition
    if (!this.oRequest) {
        // il nous faut des options
        if (!this.options) {
            throw new Error("Les options ne sont pas renseignées, impossible de construire la requête !");
        }

        if (this.CLASSTYPE === "RouteRequest") {
            var settings = {
                distanceUnit : this.options.distanceUnit || null,
                provideGeometry : this.options.provideGeometry || null,
                provideBoundingBox : this.options.provideBoundingBox || null,
                route : {
                    routePreference : this.options.routePreference || null,
                    startPoint : this.options.startPoint,
                    viaPoint : this.options.viaPoint || null,
                    endPoint : this.options.endPoint,
                    avoidFeature : this.options.avoidFeature || null,
                    graph : this.options.graph || null,
                    expectedStartTime : this.options.expectedStartTime || null
                }
            };
            this.oRequest = new __WEBPACK_IMPORTED_MODULE_2__RouteService_DetermineRouteRequest__["a" /* default */](settings);
            // ajout des filtres spécifiques au service
            if (this.oFilter) {
                this.oRequest.addFilter(this.oFilter);
            }
        }
    }

    // objet indefini !?
    if (!this.oRequest) {
        throw new Error("Type de requête indefini !");
    }

    this.strRequest = this.oRequest.toString();
    return this.strRequest;
};

/* harmony default export */ __webpack_exports__["a"] = (RouteService);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_RoutePlan__ = __webpack_require__(89);



/**
 * @classdesc
 *
 * Requête de calcul d'itinéraire
 *
 * ----
 * XSD :
 * ----
 * [] => non implementé !
 *
 * ```
 * element name="DetermineRouteRequest"
 *  [attribute name="provideRouteHandle" default="false"]
 *  attribute name="distanceUnit"       default="M"
 *      [element ref="xls:RouteHandle" || element ref="xls:RoutePlan"]
 *      element ref="xls:RoutePlan"
 *      element ref="xls:RouteInstructionsRequest"
 *      [element ref="xls:RouteGeometryRequest"]
 *      [element ref="xls:RouteMapRequest"]
 * ```
 * ```
 * element name="RouteInstructionsRequest"
 *  [attribute name="format"]           default="text/plain"
 *  attribute name="provideGeometry"    default="false"
 *  attribute name="provideBoundingBox" default="false"
 * ```
 * ```
 * element name="RouteGeometryRequest"
 *  [attribute name="scale"]                  default="1"
 *  [attribute name="provideStartingPortion"] default="false"
 *  [attribute name="maxPoints"]              default="100"
 *      [element name="BoundingBox" type="gml:EnvelopeType" ]
 * ```
 * ```
 * [element name="RouteMapRequest"]
 *      [element name="Output"]
 *          [attribute name="width"]
 *          [attribute name="height"]
 *          [attribute name="format"]
 *          [attribute name="BGcolor"]
 *          [attribute name="transparent"]
 *          [attribute name="style"] => value = Overview | Maneuver
 *          [element name="BBoxContext" type="gml:EnvelopeType"]
 * ```
 *
 * --------
 * Requête :
 * --------
 * ```
 *   <DetermineRouteRequest distanceUnit="KM">
 *     <RoutePlan>
 *              <RoutePreference>Fastest</RoutePreference>
 *              <xlsext:vehicle name="Car" />
 *              <WayPointList>
 *                  <StartPoint>
 *                      <Position><gml:Point srsName="EPSG:4326"><gml:pos>2.29993 48.87228</gml:pos></gml:Point></Position>
 *                  </StartPoint>
 *                  <EndPoint>
 *                      <Position><gml:Point srsName="EPSG:4326"><gml:pos>-1.53604 47.21548</gml:pos></gml:Point></Position>
 *                  </EndPoint>
 *              </WayPointList>
 *     </RoutePlan>
 *     <RouteInstructionsRequest provideGeometry="true"/>
 *     <RouteGeometryRequest/>
 *   </DetermineRouteRequest>
 * ```
 *
 * @constructor
 * @alias Gp.Formats.XLS.RouteService.DetermineRouteRequest
 * @param {Object} options - options
 * @param {Object}   options.route.routePreference - « fastest », « shortest » ou « pedestrian »
 * @param {String}   options.route.startPoint - Point de départ (coordonnées exprimées en WGS84G)
 * @param {String}   options.route.viaPoint - Liste de points intermédiaires
 * @param {String}   options.route.endPoint - Point d'arrivée (coordonnées)
 * @param {Object}   options.route.avoidFeature - « highway », « tollway », « tunnel » ou « bridge »
 * @param {Object}   options.route.vehicle - « car »
 * @param {Object}   options.route.expectedStartTime - Date et heure de départ
 * @param {Object}   options.provideGeometry - true | false
 * @param {Object}   options.provideBoundingBox - true | false
 * @param {Object}   options.distanceUnit - Unité dans lesquelles la distance est exprimée (« m » ou « km »)
 * @param {Function} options.onsuccess - function callback success (TODO)
 * @param {Function} options.onerror   - function callback error   (TODO)
 *
 * @private
 */
function DetermineRouteRequest (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur DetermineRouteRequest ()]");

    if (!(this instanceof DetermineRouteRequest)) {
        throw new TypeError("DetermineRouteRequest constructor cannot be called as a function.");
    }

    // options par defaut
    this.options = options || {};

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            this.options[opt] = options[opt];
        }
    }

    /**
     * Nom de la classe (heritage)
     */
    this.CLASSNAME = "DetermineRouteRequest";
}

DetermineRouteRequest.prototype = {

    /**
     * @lends module:DetermineRouteRequest#
     */

    /**
     * request (out)
     * @type {String}
     */
    strRequest : null,

    /**
     * RoutePlan
     * @type {Address}
     */
    oRoutePlan : null,

    /**
     * Template de la requête.
     * substitution des valeurs suivantes :
     * __DISTANCEUNIT__,
     * __ROUTEPLAN__, __ROUTEINSTRUCTIONREQUEST__, __ROUTEGEOMETRYREQUEST__, __ROUTEMAPREQUEST__
     * __PROVIDEGEOMETRY__, __PROVIDEBBOX__
     */
    template : {
        determineRouteRequest : "<DetermineRouteRequest distanceUnit=\"__DISTANCEUNIT__\">" +
            "__ROUTEPLAN__" +
            "__ROUTEINSTRUCTIONREQUEST__" +
            "__ROUTEGEOMETRYREQUEST__" +
            "__ROUTEMAPREQUEST__" +
            "</DetermineRouteRequest>",
        routeInstructionRequest : "<RouteInstructionsRequest " +
            "provideGeometry=\"__PROVIDEGEOMETRY__\" " +
            "provideBoundingBox=\"__PROVIDEBBOX__\" />",
        routeGeometryRequest : "<RouteGeometryRequest />",
        routeMapRequest : "" // FIXME <RouteMapRequest/> not yet implemented !
    },

    /**
     * Ajout d'un objet de type RoutePlan
     *
     * @param {Object} oRoutePlan - RoutePlan
     */
    addRoute : function (oRoutePlan) {
        if (oRoutePlan instanceof __WEBPACK_IMPORTED_MODULE_1__model_RoutePlan__["a" /* default */]) {
            this.oRoutePlan = oRoutePlan;
        }
    },

    /**
     * Constructeur (alias)
     */
    constructor : DetermineRouteRequest,

    /**
     * toString
     *
     * @returns {String} requête
     */
    toString : function () {
        var template = "";
        template = this.template.determineRouteRequest;
        template = template.replace(/__DISTANCEUNIT__/g, this.options.distanceUnit || "KM");

        // soit on a déjà un objet RoutePlan instancié,
        // sinon, on le fabrique via les options
        if (!this.oRoutePlan) {
            var settings = this.options.route;

            this.oRoutePlan = new __WEBPACK_IMPORTED_MODULE_1__model_RoutePlan__["a" /* default */](settings);
            if (!this.oRoutePlan) {
                throw new Error("La construction du calcul d'initineraire n'est pas correctement definie !?");
            }
        }

        // routeplan
        template = template.replace(/__ROUTEPLAN__/g, this.oRoutePlan.toString());

        // instruction
        var tmplInstruction = this.template.routeInstructionRequest;
        tmplInstruction = tmplInstruction.replace(/__PROVIDEGEOMETRY__/g, this.options.provideGeometry || false);
        tmplInstruction = tmplInstruction.replace(/__PROVIDEBBOX__/g, this.options.provideBoundingBox || false);
        template = template.replace(/__ROUTEINSTRUCTIONREQUEST__/g, tmplInstruction);

        // geometry
        var tmplGeometry = this.template.routeGeometryRequest;
        template = template.replace(/__ROUTEGEOMETRYREQUEST__/g, tmplGeometry);

        // map
        var tmplMap = this.template.routeMapRequest;
        template = template.replace(/__ROUTEMAPREQUEST__/g, tmplMap);

        this.strRequest = template;
        return this.strRequest;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DetermineRouteRequest);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);


/**
 * @classdesc
 *  * Élément regroupant l'ensemble des données et paramètres pour le calcul d'itinéraire : points de navigation, configuration.
 *
 * ----
 * XSD :
 * ----
 * [] => non implementé !
 *
 * ```
 * element name="RoutePlan"
 *  [attribute name="useRealTimeTraffic" default="false"]
 *  [attribute name="expectedStartTime"  type="dateTime"]
 *  [attribute name="expectedEndTime"    type="dateTime"]
 *      element ref="xls:RoutePreference"
 *      element ref="xls:WayPointList"
 *      element ref="xls:AvoidList"
 * ```
 * ```
 * element name="RoutePreference"
 *  => value = fastest | shortest | pedestrian
 * ```
 * ```
 * element name="WayPointList"
 *      element ref="xls:StartPoint"
 *      element ref="xls:ViaPoint" minOccurs="0"
 *      element ref="xls:EndPoint"
 * ```
 * ```
 * element name="StartPoint"
 *    [element name="GeocodeMatchCode"]
 *      [attribute name="accuracy"]
 *      [attribute name="matchType"] => value = City, Street, Street number, Street enhanced, ...
 *    element name="Position"
 *      element ref="gml:Point"
 * ```
 * ```
 * element name="ViaPoint"
 *    [element name="GeocodeMatchCode"]
 *      [attribute name="accuracy"]
 *      [attribute name="matchType"] => value = City, Street, Street number, Street enhanced, ...
 *    element name="Position"
 *      element ref="gml:Point"
 * ```
 * ```
 * element name="EndPoint"
 *    [element name="GeocodeMatchCode"]
 *      [attribute name="accuracy"]
 *      [attribute name="matchType"] => value = City, Street, Street number, Street enhanced, ...
 *    element name="Position"
 *      element ref="gml:Point"
 * ```
 * ```
 * element name="AvoidList"
 *      [element ref="xls:AOI"]
 *      [element ref="xls:_Location"] (cf. element name="Position")
 *      element ref="xls:AvoidFeature"
 * ```
 * ```
 * [element name="AOI"]
 *      [element ref="gml:CircleByCenterPoint" || element ref="gml:Polygon" || element ref="gml:Envelope"]
 * ```
 * ```
 * element name="AvoidFeature" => value = highway | tollway | tunnel | bridge
 * ```
 *
 * --------
 * Requête :
 * --------
 * ```
 *     <RoutePlan>
 *       <RoutePreference>Fastest</RoutePreference>
 *       <xlsext:vehicle name="Car" />
 *       <WayPointList>
 *         <StartPoint>
 *           <Position><gml:Point srsName="EPSG:4326"><gml:pos>2.29993 48.87228</gml:pos></gml:Point></Position>
 *         </StartPoint>
 *         <EndPoint>
 *           <Position><gml:Point srsName="EPSG:4326"><gml:pos>-1.53604 47.21548</gml:pos></gml:Point></Position>
 *         </EndPoint>
 *       </WayPointList>
 *       <AvoidList>
 *          <AvoidFeature>highway</AvoidFeature>
 *          <AvoidFeature>tollway</AvoidFeature>
 *          <AvoidFeature>tunnel</AvoidFeature>
 *       </AvoidList>
 *     </RoutePlan>
 * ```
 * @constructor
 * @alias Gp.Formats.XLS.RouteService.RoutePlan
 * @param {Object} options - options
 *
 * @private
 */
function RoutePlan (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("RoutePlan");
    // this.// logger.trace("[Constructeur RoutePlan ()]");

    if (!(this instanceof RoutePlan)) {
        throw new TypeError("RoutePlan constructor cannot be called as a function.");
    }

    // param par defaut
    this.options = options || {};

    // param obligatoire
    if (!options.startPoint) {
        throw new Error("l'option 'startPoint' n'est pas renseignée !");
    }

    if (!options.endPoint) {
        throw new Error("l'option 'endPoint' n'est pas renseignée !");
    }

    // et on ajoute les options en paramètre aux options par défaut
    for (var opt in options) {
        if (options.hasOwnProperty(opt)) {
            this.options[opt] = options[opt];
        }
    }
}

RoutePlan.prototype = {

    /**
     * Constructeur (alias)
     */
    constructor : RoutePlan,

    /**
     * request (out)
     * @type {String}
     */
    requestString : null,

    /**
     * Template de la requête.
     * substitution des valeurs suivantes :
     * - __ROUTEPREFERENCE__, __VALUEROUTEPREFERENCE__
     * - __GRAPH__, __VALUEGRAPH__
     * - __WAYPOINTLIST__ (lst?), __STARTPOINT__, __VIAPOINT__, __ENDPOINT__, __POINT__, __X__, __Y__
     * - __AVOIDLIST__ (lst!), __AVOIDFEATURE__, __VALUEAVOIDFEATURE__
     */
    template : {
        routePlan : "<RoutePlan>" +
            "__ROUTEPREFERENCE__" +
            "__GRAPH__" +
            "__WAYPOINTLIST__" +
            "__AVOIDLIST__" +
            "</RoutePlan>",
        routePreference : "<RoutePreference>__VALUEROUTEPREFERENCE__</RoutePreference>",
        graph : "<xlsext:graphName xmlns:xlsext=\"http://www.opengis.net/xlsext\" name=\"__VALUEGRAPH__\"/>",
        wayPointList : {
            container : "<WayPointList>" +
                "__STARTPOINT__" +
                "__VIAPOINT__" +
                "__ENDPOINT__" +
                "</WayPointList>",
            point : "<Position><gml:Point xmlns:gml=\"http://www.opengis.net/gml\"><gml:pos>__X__ __Y__</gml:pos></gml:Point></Position>",
            startPoint : "<StartPoint>" +
                "__POINT__" +
                "</StartPoint>",
            endPoint : "<EndPoint>" +
                "__POINT__" +
                "</EndPoint>",
            viaPoint : "<ViaPoint>" +
                "__POINT__" +
                "</ViaPoint>" // implémentation de plusieurs étapes...
        },
        avoidList : {
            container : "<AvoidList>" +
                "__AVOIDFEATURE__" +
                "</AvoidList>",
            avoidFeature : "<AvoidFeature>__VALUEAVOIDFEATURE__</AvoidFeature>"
        }
    },

    /**
     * toString
     *
     * @returns {String} requête
     */
    toString : function () {
        var template = "";
        template = this.template.routePlan;

        // preference
        if (this.options.routePreference) {
            var tmplPreference = this.template.routePreference;
            tmplPreference = tmplPreference.replace(/__VALUEROUTEPREFERENCE__/, this.options.routePreference);
            template = template.replace(/__ROUTEPREFERENCE__/g, tmplPreference);
        }
        // clean preference
        template = template.replace(/__ROUTEPREFERENCE__/g, "");

        // exclusions
        if (this.options.avoidFeature) {
            var tmplAvoidList = this.template.avoidList.container;
            var avoidFeatures = [];
            for (var i = 0; i < this.options.avoidFeature.length; i++) {
                var tmplAvoidFeature = this.template.avoidList.avoidFeature;
                tmplAvoidFeature = tmplAvoidFeature.replace(/__VALUEAVOIDFEATURE__/, this.options.avoidFeature[i]);
                avoidFeatures.push(tmplAvoidFeature);
            }
            tmplAvoidList = tmplAvoidList.replace(/__AVOIDFEATURE__/, avoidFeatures.join("\n"));
            template = template.replace(/__AVOIDLIST__/g, tmplAvoidList);
        }
        // clean exclusions
        template = template.replace(/__AVOIDLIST__/g, "");

        // graph
        if (this.options.graph) {
            var tmplVehicle = this.template.graph;
            tmplVehicle = tmplVehicle.replace(/__VALUEGRAPH__/, this.options.graph);
            template = template.replace(/__GRAPH__/g, tmplVehicle);
        }
        // clean vehicle
        template = template.replace(/__GRAPH__/g, "");

        // points
        var tmplWayPointList = this.template.wayPointList.container;
        var tmplPoint = "";
        // start
        tmplPoint = this.template.wayPointList.point;
        tmplPoint = tmplPoint.replace(/__X__/, this.options.startPoint.x);
        tmplPoint = tmplPoint.replace(/__Y__/, this.options.startPoint.y);
        tmplWayPointList = tmplWayPointList.replace(/__STARTPOINT__/,
            this.template.wayPointList.startPoint.replace(/__POINT__/, tmplPoint));
        // end
        tmplPoint = this.template.wayPointList.point;
        tmplPoint = tmplPoint.replace(/__X__/, this.options.endPoint.x);
        tmplPoint = tmplPoint.replace(/__Y__/, this.options.endPoint.y);
        tmplWayPointList = tmplWayPointList.replace(/__ENDPOINT__/,
            this.template.wayPointList.endPoint.replace(/__POINT__/, tmplPoint));
        // via
        if (this.options.viaPoint) {
            var points = [];
            for (var j = 0; j < this.options.viaPoint.length; j++) {
                var p = this.options.viaPoint[j];
                tmplPoint = this.template.wayPointList.point;
                tmplPoint = tmplPoint.replace(/__X__/, p.x);
                tmplPoint = tmplPoint.replace(/__Y__/, p.y);
                points.push(tmplPoint);
            }

            tmplWayPointList = tmplWayPointList.replace(/__VIAPOINT__/,
                this.template.wayPointList.viaPoint.replace(/__POINT__/, points.join("\n")));
        } else {
            // clean viaPoint
            tmplWayPointList = tmplWayPointList.replace(/__VIAPOINT__/, "");
        }

        template = template.replace(/__WAYPOINTLIST__/g, tmplWayPointList);

        this.requestString = template;
        return this.requestString;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (RoutePlan);


/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * not implemented !
 *
 * Extension de type 'graphName' de l'objet RoutePlan'
 *
 * FIXME L'extension 'graphName' est intégré comme étant du standard OLS.
 *       La balise <xlsext:GraphName> viendrait surcharger le comportement de RoutePreference...
 *
 * ex. <xlsext:graphName name="Voiture" />
 */


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_RouteParamREST__ = __webpack_require__(92);





/**
 * @classdesc
 * Classe de gestion des requêtes de type REST sur le service de calcul d'itineraire
 * (uniquement en GET)
 *
 * @constructor
 * @alias Gp.Services.Route.Request.RouteRequestREST
 * @param {Object} options - options definies dans le composant Route
 *
 * @example
 * var options = {
 *      (...)
 * };
 *
 * @private
 */
function RouteRequestREST (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("RouteRequestREST");
    // this.// logger.trace("[Constructeur RouteRequestREST ()]");

    if (!(this instanceof RouteRequestREST)) {
        throw new TypeError("RouteRequestREST constructor cannot be called as a function.");
    }

    // existance des options
    if (!options) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_EMPTY", "options"));
    }

    /** liste des options */
    this.settings = options;
}

RouteRequestREST.prototype = {

    /**
     * @lends module:RouteRequestREST#
     */

    /**
     * request
     * @type {String}
     */
    requestString : null,

    /**
     * Constructeur (alias)
     */
    constructor : RouteRequestREST,

    /**
     * Construction de la requête.
     *
     * @example
     * // GET  out : origin=2.416907353809513,48.8465772142297&destination=2.4248037771493673,48.84591353161838
     * // POST out : Not yet supported method POST !
     * @returns {String} request
     */
    processRequestString : function () {
        // INFO
        // construction simple sans template...,
        // mais en attendant que les services soient fixés, on taggue ce composant en mode PROTOTYPE !
        this.logger.warn("FIXME : PROTOTYPE !");

        // Mapping des options avec le service de l'API REST
        var oParams = new __WEBPACK_IMPORTED_MODULE_2__model_RouteParamREST__["a" /* default */](this.settings);
        var params = oParams.getParams();

        var request = "";
        for (var i = 0; i < params.length; i++) {
            var o = params[i];
            if (request) {
                request += "&";
            }
            request += o.k + "=" + o.v;
        }

        // Exemple :
        //  http://wxs.ign.fr/KEY/itineraire/rest/route.json?
        //  origin=&
        //  destination=&
        //  waypoints=&
        //  method=DISTANCE&
        //  graph=Pieton&
        //  graphName=Pieton&
        //  exclusions=&
        //  tolerance=10&
        //  srs=

        // this.// logger.trace(request);
        this.requestString = request;

        return this.requestString;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (RouteRequestREST);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);



/**
 * @classdesc
 * Classe de gestion des param. des requêtes du service de calcul d'itineraire (REST).
 *      Permet le mapping avec les options du service.
 * @constructor
 * @alias Gp.Services.Route.Request.RouteParamREST
 * @param {Object} options - options
 *
 * @private
 */
function RouteParamREST (options) {
    if (!(this instanceof RouteParamREST)) {
        throw new TypeError("RouteParamREST constructor cannot be called as a function.");
    }

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur RouteParamREST ()]");

    /**
     * Options en paramêtres du constructeur.
     */
    this.options = options || {};

    // mapping des options avec l'API REST

    /** Coordonnées du point de départ. */
    this.origin = this.options.startPoint.x + "," + this.options.startPoint.y;

    /** Coordonnées du point d’arrivée. */
    this.destination = this.options.endPoint.x + "," + this.options.endPoint.y;

    /** Coordonnées des étapes point de départ. */
    this.waypoints = this.options.viaPoints || null;

    /** Date et heure de départ */
    this.startDateTime = this.options.expectedStartTime || null; // TODO format !?

    /** Nom du graphe à utiliser */
    this.graphName = this.options.graph;

    /** projection (code EPSG comme epsg:4326 ou wgs84) */
    this.srs = this.options.srs;

    /** Liste des règles de restrictions à utiliser, séparés pas le caractère , ou ; (Exemple : Toll, Tunnel, Bridge) */
    this.exclusions = this.options.exclusions;

    /**
     * itinéraire le plus court (DISTANCE) ou le plus rapide (TIME)
     * Par defaut, DISTANCE...
     * cf. mapping ci dessous
     */
    this.method = "TIME";

    // mapping particulier sur l'option 'routePreference'
    if (this.options.routePreference) {
        var value = this.options.routePreference;
        switch (value) {
            case "fastest":
                this.method = "TIME";
                break;
            case "shortest":
                this.method = "DISTANCE";
                break;
            default:
                this.logger.warn("Par defaut, on prend l'itinéraire le plus rapide !");
                this.method = "TIME";
        }
    }

    /** Format de sortie (résumé de l’itinéraire) */
    this.format = (this.options.geometryInInstructions) ? "STANDARDEXT" : "STANDARD";

    // y'a t-il d'autres options à ajouter (par defaut) ?

    /** Distance de tolérance (en mètre) de simplification de la géométrie. */
    this.tolerance = 10;

    /** identifiant du véhicule (enregistré dans les profils de véhicule) à utiliser */
    this.profileId = null;

    /** Profil du véhicule (enregistré dans les profils de véhicule) à utiliser */
    this.profileName = null;

    // options dont le mapping n'est pas possible :
    // - distanceUnit
    // - provideBoundingBox
}

/**
 * CLASSNAME
 */
RouteParamREST.CLASSNAME = "RouteParamREST";

RouteParamREST.prototype = {

    /**
     * @lends module:RouteParamREST#
     */

    /**
     * Constructeur (alias)
     */
    constructor : RouteParamREST,

    /**
     * Retourne une liste de points
     * @returns {Array} une liste de points (sep ';')
     */
    getWaypoints : function () {
        if (!this.waypoints) {
            return;
        }
        var array = [];
        for (var i = 0; i < this.waypoints.length; i++) {
            var obj = this.waypoints[i];
            array.push(obj.x + "," + obj.y);
        }

        return array.join(";");
    },

    /**
     * Retourne la liste des exclusions
     * @returns {Array} une liste d'exclusions (sep ';')
     */
    getExclusions : function () {
        return this.exclusions.join(";");
    }
};

/**
 * Tableau de clefs/valeurs pour param.
 *
 * @returns {Array} liste de paramêtres
 */
RouteParamREST.prototype.getParams = function () {
    var map = [];

    map.push({
        k : "origin",
        v : this.origin
    });

    map.push({
        k : "destination",
        v : this.destination
    });

    map.push({
        k : "method",
        v : this.method
    });

    if (this.waypoints) {
        map.push({
            k : "waypoints",
            v : this.getWaypoints()
        });
    }

    if (this.startDateTime) {
        map.push({
            k : "startDateTime",
            v : this.startDateTime
        });
    }

    if (this.graphName) {
        map.push({
            k : "graphName",
            v : this.graphName
        });
    }

    if (this.exclusions) {
        map.push({
            k : "exclusions",
            v : this.getExclusions()
        });
    }

    if (this.srs) {
        map.push({
            k : "srs",
            v : this.srs
        });
    }

    if (this.format) {
        map.push({
            k : "format",
            v : this.format
        });
    }

    return map;
};

/* harmony default export */ __webpack_exports__["a"] = (RouteParamREST);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formats_XML__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Formats_WKT__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Formats_RouteResponseRESTReader__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Formats_RouteResponseOLSReader__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_RouteResponse__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_RouteInstruction__ = __webpack_require__(17);
/**
 * Factory pour générer une reponse JSON à partir d'un XML ou d'un JSON
 * (Factory)
 *
 * @module RouteResponseFactory
 * @alias Gp.Services.Route.Response.RouteResponseFactory
 * @private
 */










var RouteResponseFactory = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant Alti
     *
     * @example
     *   var options = {
     *      response :
     *      outputFormat :
     *      rawResponse :
     *      scope :
     *      onSuccess :
     *      onError :
     *   };
     *
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("RouteResponseFactory");
        // logger.trace("RouteResponseFactory::build()");

        var data = null;

        if (options.response) {
            if (options.rawResponse) {
                // logger.trace("analyze response : raw");
                data = options.response;
            } else {
                switch (options.outputFormat) {
                    case "xml":
                        // logger.trace("analyze response : xml");

                        // type de reader en fonction de l'API
                        var routeReader = options.api === "REST" ? __WEBPACK_IMPORTED_MODULE_5__Formats_RouteResponseRESTReader__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_6__Formats_RouteResponseOLSReader__["a" /* default */];

                        try {
                            var p = new __WEBPACK_IMPORTED_MODULE_3__Formats_XML__["a" /* default */]({
                                reader : routeReader
                            });

                            // FIXME : mode XHR ne retourne que des string ? JSONP aussi à ce niveau ?
                            if (typeof options.response === "string") {
                                p.setXMLString(options.response);
                            } else {
                                p.setXMLDoc(options.response);
                            }

                            data = p.parse();

                            if (!data) {
                                throw new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_FORMAT", "xml"));
                            }
                        } catch (e) {
                            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_ANALYSE", options.response)));
                            return;
                        }

                        break;

                    case "json":
                        // logger.trace("analyze response : json");

                        var JSONResponse;
                        if (typeof options.response === "string") {
                            JSONResponse = JSON.parse(options.response);
                        } else {
                            JSONResponse = options.response;
                        }

                        // le service renvoie t il une erreur ?
                        if (JSONResponse.message) {
                            // ex. {"message":"message not null", "status":"ERROR"}
                            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", JSONResponse.message)));
                            return;
                        }

                        // construction de l'objet réponse JSON
                        if (JSONResponse) {
                            var legs = [];
                            var legSteps = [];
                            var steps = [];

                            data = new __WEBPACK_IMPORTED_MODULE_7__model_RouteResponse__["a" /* default */]();

                            if (data.hasOwnProperty("totalTime")) {
                                // info : il y a aussi JSONResponse.duration, qui donne la durée en hh:mm:ss.
                                data.totalTime = parseFloat(JSONResponse.durationSeconds);
                            }
                            if (data.hasOwnProperty("totalDistance")) {
                                data.totalDistance = (options.distanceUnit === "m") ? JSONResponse.distanceMeters : JSONResponse.distance;
                            }

                            if (data.hasOwnProperty("bbox")) {
                                var coords = JSONResponse.bounds.split(/[,;]/);
                                data.bbox.left = parseFloat(coords[0]);
                                data.bbox.bottom = parseFloat(coords[1]);
                                data.bbox.right = parseFloat(coords[2]);
                                data.bbox.top = parseFloat(coords[3]);
                            }
                            /**
                            * callback success
                            * @param {Object} json - json
                            * @private
                            */
                            var onWKTSuccess = function (json) {
                                data.routeGeometry = json;
                            };
                            /**
                            * callback failed
                            * @param {Object} e - event
                            * @private
                            */
                            var onWKTError = function (e) {
                                // console.log(e);
                                options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_FORMAT", ["geometryWkt"])));
                            };

                            if (data.hasOwnProperty("routeGeometry")) {
                                var geometry = JSONResponse.geometryWkt || JSONResponse.simplifiedWkt;
                                if (geometry) {
                                    __WEBPACK_IMPORTED_MODULE_4__Formats_WKT__["a" /* default */].toJson(geometry, onWKTSuccess, onWKTError);
                                    if (!data.routeGeometry) {
                                        return;
                                    }
                                }
                            }

                            if (data.hasOwnProperty("routeInstructions")) {
                                var legList = JSONResponse.legs;
                                var i;
                                if (Array.isArray(legList) && legList.length) {
                                    for (i = 0; i < legList.length; i++) {
                                        legs.push(legList[i]);
                                    }
                                }
                                if (Array.isArray(legs) && legs.length) {
                                    for (i = 0; i < legs.length; i++) {
                                        legSteps.push(legs[i].steps);
                                    }
                                }
                                if (Array.isArray(legSteps) && legSteps.length) {
                                    for (i = 0; i < legSteps.length; i++) {
                                        steps = steps.concat(legSteps[i]);
                                    }
                                }

                                steps.forEach(function (step) {
                                    data.routeInstructions.push(new __WEBPACK_IMPORTED_MODULE_8__model_RouteInstruction__["a" /* default */]());
                                    data.routeInstructions[data.routeInstructions.length - 1].duration = step.durationSeconds;
                                    data.routeInstructions[data.routeInstructions.length - 1].distance = (options.distanceUnit === "m") ? step.distanceMeters : step.distance;
                                    data.routeInstructions[data.routeInstructions.length - 1].code = step.navInstruction;
                                    // geometrie en geojson
                                    var points = [];
                                    for (var i = 0; i < step.points.length; i++) {
                                        var point = step.points[i].split(",");
                                        if (point) {
                                            points.push(point);
                                        }
                                    }
                                    if (points && points.length !== 0) {
                                        data.routeInstructions[data.routeInstructions.length - 1].geometry = {
                                            coordinates : points,
                                            type : "LineString"
                                        };
                                    } else {
                                        data.routeInstructions[data.routeInstructions.length - 1].geometry = null;
                                    }

                                    /*
                                    Traduction du code en instruction
                                    * - F : tout droit
                                    * - B : demi-tour
                                    * - L : tourner à gauche
                                    * - R : tourner à droite
                                    * - BL : tourner très à gauche
                                    * - BR : tourner très à droite
                                    * - FL : tourner légèrement à gauche
                                    * - FR : tourner légèrement à droite
                                    * - round_about_entry : entrée rond-point
                                    * - round_about_exit : sortie rond-point
                                    */

                                    // on ne souhaite pas de ce type de valeur...
                                    if (step.name === "Valeur non renseignée") {
                                        step.name = "";
                                    }

                                    switch (step.navInstruction) {
                                        case "F":
                                            if (step.name) {
                                                data.routeInstructions[data.routeInstructions.length - 1].instruction = "Tout droit " + step.name;
                                            } else {
                                                data.routeInstructions[data.routeInstructions.length - 1].instruction = "Continuer tout droit ";
                                            }
                                            break;
                                        case "B":
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "Demi-tour " + step.name;
                                            break;
                                        case "L":
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "Tourner à gauche " + step.name;
                                            break;
                                        case "R":
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "Tourner à droite " + step.name;
                                            break;
                                        case "BL":
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "Tourner très à gauche " + step.name;
                                            break;
                                        case "BR":
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "Tourner très à droite " + step.name;
                                            break;
                                        case "FL":
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "Tourner légèrement à gauche " + step.name;
                                            break;
                                        case "FR":
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "Tourner légèrement à droite " + step.name;
                                            break;
                                        case "round_about_entry":
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "Entrée rond-point " + step.name;
                                            break;
                                        case "round_about_exit":
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "Sortie rond-point " + step.name;
                                            break;
                                        case null:
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "Prendre tout droit " + step.name;
                                            break;
                                        default:
                                            data.routeInstructions[data.routeInstructions.length - 1].instruction = "?" + step.navInstruction + "? " + step.name;
                                            break;
                                    }
                                });
                            }
                        }

                        if (!data) {
                            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_ANALYSE", "json")));
                            return;
                        }
                        break;

                    default:
                        options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_FORMAT", "json", "xml")));
                        return;
                }

                // Si la réponse contenait une exception renvoyée par le service
                if (data && data.exceptionReport) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION_2")));
                    return;
                }
            }
        } else {
            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
            return;
        }

        options.onSuccess.call(options.scope, data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (RouteResponseFactory);


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Formats_WKT__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Response_model_RouteResponse__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Response_model_RouteInstruction__ = __webpack_require__(17);
/**
 * Analyse de la reponse REST
 *
 * @module RouteResponseRESTReader
 * @alias Gp.Services.Route.Formats.RouteResponseRESTReader
 * @todo not yet implemented !
 * @private
 */

// import Logger from "../../../Utils/LoggerByDefault";






/**
 * Objet RouteResponseRestReader
 * @member {Object} RouteResponseRestReader
 *
 * @property {Object} RouteResponseRestReader.READERS - Objet contenant des fonctions de lecture, appelées "readers"
 *      dont chaque clé correspond au nom d'un tag du XML que l'on souhaite lire
 *      et la valeur associée est une fonction (node, data)
 *      où node est un noeud du document DOM
 *      et data est un objet où l'on stocke les informations lues dans le XML.
 *
 * @property {Method} RouteResponseRestReader.read - Méthode permettant de lancer la lecture d'une réponse XML du
 *      service de calcul d'itineraire, à l'aide des readers de la classe.
 *
 */

var RouteResponseRESTReader = {};

RouteResponseRESTReader.READERS = {

    /**
     * Route response
     * @param {Object} node - node
     * @returns {Object} response
     */
    routeResult : function (node) {
        var response = new __WEBPACK_IMPORTED_MODULE_3__Response_model_RouteResponse__["a" /* default */]();

        // on boucle sur les balises "enfant" de la réponse :
        // status, distance, duration, distanceMeters, durationSeconds, bounds, geometryWkt, simplifiedWkt, leg
        __getChildNodes(node, response);

        if (response.status === "error") {
            var message = __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION",
                response.message);
            throw new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                message : message,
                type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
            });
        }

        return response;
    },

    /**
     * Route status
     * @param {Object} node - node
     * @param {Object} response - response
     */
    status : function (node, response) {
        var status = __getChildValue(node);
        if (status === "ERROR" || status === "error") {
            if (response) {
                response.status = "error";
            }
        }
    },

    /**
     * Route message
     * @param {Object} node - node
     * @param {Object} response - response
     */
    message : function (node, response) {
        if (response) {
            response.message = __getChildValue(node);
        }
    },

    /**
     * Route distance
     * @param {Object} node - node
     * @param {Object} response - response
     */
    distance : function (node, response) {
        if (response) {
            response.totalDistance = __getChildValue(node);
        }
    },

    /**
     * Route duration
     * @param {Object} node - node
     * @param {Object} response - response
     */
    durationSeconds : function (node, response) {
        if (response) {
            response.totalTime = parseFloat(__getChildValue(node));
        }
    },

    /**
     * Route bounds
     * @param {Object} node - node
     * @param {Object} response - response
     */
    bounds : function (node, response) {
        // get value et split et parseFloat
        if (response && response.bbox) {
            var coords = __getChildValue(node).split(/[,;]/);
            response.bbox.left = parseFloat(coords[0]);
            response.bbox.bottom = parseFloat(coords[1]);
            response.bbox.right = parseFloat(coords[2]);
            response.bbox.top = parseFloat(coords[3]);
        }
    },

    /**
     * Route geometry
     * @param {Object} node - node
     * @param {Object} response - response
     */
    geometryWkt : function (node, response) {
        if (response) {
            var geomWkt = node.innerHTML;

            var onWKTSuccess = function (json) {
                response.routeGeometry = json;
            };

            var onWKTError = function () {
                var msg = __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_FORMAT", ["geometryWkt"]);
                throw new Error(msg);
            };
            // get WKT Geometry from string
            __WEBPACK_IMPORTED_MODULE_1__Formats_WKT__["a" /* default */].toJson(geomWkt, onWKTSuccess, onWKTError);
        }
    },

    /**
     * Route step
     * @param {Object} node - node
     * @param {Object} response - response
     */
    step : function (node, response) {
        // création d'une nouvelle instruction
        var routeInstruction = new __WEBPACK_IMPORTED_MODULE_4__Response_model_RouteInstruction__["a" /* default */]();
        var name;

        // lecture des informations de l'instruction (balises enfants)
        if (node.hasChildNodes) {
            var children = node.childNodes;
            var child;
            var childName;

            for (var i = 0; i < children.length; i++) {
                child = children[i];

                if (child.nodeType === 1) { // 1 === node.ELEMENT_NODE
                    childName = child.localName || child.baseName || child.nodeName;

                    if (childName === "durationSeconds") {
                        routeInstruction.duration = __getChildValue(child);
                    } else if (childName === "distance") {
                        routeInstruction.distance = __getChildValue(child);
                    } else if (childName === "navInstruction") {
                        routeInstruction.code = __getChildValue(child);
                    } else if (childName === "name") {
                        name = __getChildValue(child);
                    }
                }
            }
        }

        // on teste le code de l'instruction pour y ajouter la bonne description
        if (routeInstruction.code) {
            switch (routeInstruction.code) {
                case "F":
                    if (name !== "Valeur non renseignée") {
                        routeInstruction.instruction = "Tout droit " + name;
                    } else {
                        routeInstruction.instruction = "Continuer tout droit ";
                    }
                    break;
                case "B":
                    routeInstruction.instruction = "Demi-tour " + name;
                    break;
                case "L":
                    routeInstruction.instruction = "Tourner à gauche " + name;
                    break;
                case "R":
                    routeInstruction.instruction = "Tourner à droite " + name;
                    break;
                case "BL":
                    routeInstruction.instruction = "Tourner très à gauche " + name;
                    break;
                case "BR":
                    routeInstruction.instruction = "Tourner très à droite " + name;
                    break;
                case "FL":
                    routeInstruction.instruction = "Tourner légèrement à gauche " + name;
                    break;
                case "FR":
                    routeInstruction.instruction = "Tourner légèrement à droite " + name;
                    break;
                case "round_about_entry":
                    routeInstruction.instruction = "Entrée rond-point " + name;
                    break;
                case "round_about_exit":
                    routeInstruction.instruction = "Sortie rond-point " + name;
                    break;
                case null:
                    routeInstruction.instruction = "Prendre " + name;
                    break;
                default:
                    routeInstruction.instruction = "?" + routeInstruction.code + "? " + name;
                    break;
            }
        }

        if (Array.isArray(response.routeInstructions)) {
            response.routeInstructions.push(routeInstruction);
        }
    }

};

/**
 * Méthode permettant de lancer la lecture d'une réponse XML du service de calcul d'itineraire,
 * à l'aide des readers de la classe.
 *
 * @method RouteResponseRESTReader.read
 * @param {DOMElement} root - racine de la réponse XML à lire
 * @static
 * @memberof RouteResponseRESTReader
 * @returns {DOMElement} response
 */
RouteResponseRESTReader.read = function (root) {
    var response;

    if (root.nodeName === "routeResult") {
        response = RouteResponseRESTReader.READERS["routeResult"](root);
        return response;
    } else {
        throw new Error("Erreur lors de la lecture de la réponse : elle n'est pas au format attendu.");
    }
};

/**
 * Lecture de la valeur du premier child d'un noeud, si elle existe.
 *
 * @private
 * @memberof RouteResponseRESTReader
 * @method __getChildValue
 * @param {DOMElement} node - a DOM node
 * @return {String} value - valeur du firstChild du noeud en entrée, ou chaîne vide.
 */
function __getChildValue (node) {
    var textNode;
    var value = "";

    if (node.hasChildNodes()) {
        textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            value = textNode.nodeValue;
        }
    }
    return value;
}

/**
 * Récupération des noeuds enfants à partir d'un noeud donné, pour lecture (readNode).
 *
 * @private
 * @memberof RouteResponseRESTReader
 * @method __getChildNodes
 * @param {DOMElement} node - a DOM node
 * @param {Array|Object} [data] - an object to be filled with node data
 */
function __getChildNodes (node, data) {
    if (node.hasChildNodes()) {
        var children = node.childNodes;
        var child;
        var childName;

        for (var i = 0; i < children.length; i++) {
            child = children[i];

            if (child.nodeType === 1) { // 1 === node.ELEMENT_NODE
                childName = child.localName || child.baseName || child.nodeName;

                if (RouteResponseRESTReader.READERS[childName]) {
                    var reader = RouteResponseRESTReader.READERS[childName];
                    reader(child, data);
                } else {
                    __getChildNodes(child, data);
                }
            }
        }
    }
}

/* harmony default export */ __webpack_exports__["a"] = (RouteResponseRESTReader);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/**
 * Analyse de la reponse OLS
 *
 * @module RouteResponseOLSReader
 * @alias Gp.Services.Route.Formats.RouteResponseOLSReader
 * @todo not yet implemented !
 * @private
 */



/**
 * Objet RouteResponseOLSReader
 * @member {Object} RouteResponseOLSReader
 *
 * @property {Object} RouteResponseOLSReader.READERS - Objet contenant des fonctions de lecture, appelées "readers"
 *      dont chaque clé correspond au nom d'un tag du XML que l'on souhaite lire
 *      et la valeur associée est une fonction (node, data)
 *      où node est un noeud du document DOM
 *      et data est un objet où l'on stocke les informations lues dans le XML.
 *
 * @property {Method} RouteResponseOLSReader.read -  Méthode permettant de lancer la lecture d'une réponse
 *      XML du service de calcul d'itineraire, à l'aide des readers de la classe.
 */
var RouteResponseOLSReader = {};

/**
 * Objet contenant des fonctions de lecture, appelées "readers"
 *      dont chaque clé correspond au nom d'un tag du XML que l'on souhaite lire
 *      et la valeur associée est une fonction (node, data)
 *      où node est un noeud du document DOM
 *      et data est un objet où l'on stocke les informations lues dans le XML.
 * @static
 * @memberof RouteResponseOLSReader
 */
RouteResponseOLSReader.READERS = {
    /*
        // INFO
        // pas de reponse en JSON pour l'API OLS, uniquement du XML !

        // INFO
        // Exemple d'erreur du service
        // <?xml version= "1.0" encoding= "UTF-8" standalone= "yes" ?>
        // <XLS version="1.2" xsi : schemaLocation = "http://www.opengis.net/xls http://schemas.opengis.net/ols/1.2/olsAll.xsd" xmlns : xls = "http://www.opengis.net/xls" xmlns= "http://www.opengis.net/xls" xmlns : xlsext = "http://www.opengis.net/xlsext" xmlns : gml = "http://www.opengis.net/gml" // xmlns : xsi = "http://www.w3.org/2001/XMLSchema-instance" >
        // <ResponseHeader>
        //     <ErrorList>
        //         <Error message="Routing error : Error in smartrouting com.geoconcept.smartrouting.SmartRoutingNativeException : failed to connect waypoint { 48.846577, 2.416907, 0.000000 } failed to connect waypoint { 48.846577, 2.416907, 0.000000 } " errorCode="InternalServerError"/>
        //     </ErrorList>
        // </ResponseHeader>
        // <Response version= "1.2" requestID= "f8358c74-8aee-4203-90b9-2c70db5996a1" />
        // </XLS>

        // INFO
        // Exemple d'erreur NGinx
        // <ExceptionReport><Exception exceptionCode="MissingParameter">Resource parameter not found</Exception></ExceptionReport>
    */
};

/**
 * Méthode permettant de lancer la lecture d'une réponse XML du service de calcul d'itineraire,
 * à l'aide des readers de la classe.
 *
 * @method RouteResponseOLSReader.read
 * @param {DOMElement} root - racine de la réponse XML à lire
 * @static
 * @memberof RouteResponseOLSReader
 */
RouteResponseOLSReader.read = function (root) {
    // logger
    var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("RouteResponseOLSReader");
    logger.error("not yet implemented !");
};

/* harmony default export */ __webpack_exports__["a"] = (RouteResponseOLSReader);


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonService__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultUrlService__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Request_ProcessIsoCurveRequest__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Response_ProcessIsoCurveResponseFactory__ = __webpack_require__(99);









/**
 * @classdesc
 * Appel du service d'isochrone/distance du Géoportail :
 *     envoi de la requête construite selon les paramètres en options,
 *     éventuellement parsing et analyse  de la réponse,
 *     retour d'une réponse en paramètre de la fonction onSuccess.
 * @constructor
 * @extends {Gp.Services.CommonService}
 * @alias Gp.Services.ProcessIsoCurve
 * @param {Object} options - options spécifiques au service (+ les options heritées)
 *
 * @param {String} options.outputFormat - Le format de la réponse du service iso : 'xml' ou 'json'.
 *      Ce paramètre déterminera l'extension '.xml' ou '.json' du service.
 *      Nécessaire si serverUrl est renseigné pour connaître le format dans lequel sera fournie la réponse (pour son traitement).
 *      Par défaut, ce paramètre vaut 'json'.
 *
 * @param {Object} options.position - Point de départ du calcul.
 *      Coordonnées exprimées en longitudes, latitudes (EPSG:4326)
 *      @param {Float} options.position.x - Abcisse du point de départ du calcul d'isochrone/distance.
 *      @param {Float} options.position.y - Ordonnée du point de départ du calcul d'isochrone/distance.
 *
 * @param {String} options.srs - Projection.
 *      Système de coordonnées dans lequel les coordonnées du point « location » sont exprimées et
 *      dans lequel la géométrie de la courbe résultante sera exprimée.
 *      Par défaut, le système de coordonnées utilisé sera « EPSG:4326 ».
 *
 * @param {String} [options.graph = "voiture"] - Nom du graphe à utiliser pour le calcul (« Pieton » ou « Voiture »).
 *      La valeur par défaut est : «voiture»
 *
 * @param {Array.<String>} [options.exclusions] - Critères d'exclusions à appliquer pour le calcul.
 *      On précise ici le type de tronçons que l'on ne veut pas que l'isochrone/distance emprunte
 *      (valeurs possibles : « toll » (éviter les péages), « bridge », « tunnel »).
 *
 * @param {String} [options.method = "time"] - Méthode utilisée pour le calcul de la courbe iso.
 *      Les valeurs possible sont "time" pour un calcul d'isochrone, "distance" pour un calcul d'isodistance.
 *      Pas de valeur spécifié équivaut à un calcul d'isochrone.
 *
 * @param {Float} options.time - Durée maximum (exprimée en secondes) à utiliser pour le calcul de la courbe à partir du ou jusqu'au point « location ».
 *      Ce paramètre doit être renseigné si l'option "méthod" a la valeur "time".
 *      Si l'option method n'est pas renseignée, ce paramètre doit être renseigné.
 *
 * @param {Float} options.distance - Distance maximum (exprimée en metres) à utiliser pour le calcul de la courbe à partir du ou j'usqu'au point « location ».
 *      Ce paramètre doit être renseigné si l'option "méthod" a la valeur "DISTANCE".
 *      Si l'option "method" n'est pas renseignée, ce paramètre sera ignoré.
 *
 * @param {Boolean} [options.reverse = false] - Indique si la géométrie résultante doit être lissée (« true ») pour ne pas avoir d'effet d'escalier.
 *      Par défaut, la valeur « false » est appliquée.
 *
 * @param {Boolean} [options.smoothing = false] - Indique si la géométrie résultante doit être lissée (« true ») pour ne pas avoir d'effet d'escalier.
 *      Par défaut, la valeur « false » est appliquée.
 *
 * @param {Boolean} [options.holes = false] - Indique si la géométrie résultante (surface) doit être retournée avec des trous (« true »).
 *      Par défaut, la valeur « false » est appliquée.
 *
 * @example
 *   var options = {
 *      // options communes aux services
 *      apiKey : null,
 *      serverUrl : 'http://localhost/service/',
 *      protocol : 'JSONP', // JSONP|XHR
 *      proxyURL : null,
 *      httpMethod : 'GET', // GET|POST
 *      timeOut : 10000, // ms
 *      rawResponse : false, // true|false
 *      scope : null, // this
 *      onSuccess : function (response) {},
 *      onFailure : function (error) {},
 *      // spécifique au service
 *      position : {
 *           x : 2.3242664298058053,
 *           y : 48.86118017324745
 *      },
 *      distance : 200,
 *      [time : ]
 *      method : "distance",
 *      exclusions : ["Bridge", "Tunnel", "Toll"],
 *      graph : "voiture",
 *      reverse : false,
 *      smoothing : false,
 *      holes : false
 *  };
 * @private
 */

function ProcessIsoCurve (options) {
    if (!(this instanceof ProcessIsoCurve)) {
        throw new TypeError(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("CLASS_CONSTRUCTOR", "ProcessIsoCurve"));
    }

    /**
     * Nom de la classe (heritage)
     * FIXME instance ou classe ?
     */
    this.CLASSNAME = "ProcessIsoCurve";

    // appel du constructeur par heritage
    __WEBPACK_IMPORTED_MODULE_3__CommonService__["a" /* default */].apply(this, arguments);

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("Gp.Services.ProcessIsoCurve");
    // this.// logger.trace("[Constructeur ProcessIsoCurve (options)]");

    if (!options.position) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "position"));
    }

    // on lance une exception afin d'eviter au service de le faire...
    if (options.position.x === null) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "position.x"));
    }

    if (options.position.y === null) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_MISSING", "position.y"));
    }

    if (!options.time && !options.distance) {
        throw new Error("Parameter (s) 'distance' missing. Parameter time to calculate an isochrone, parameter distance for an isodistance");
    }

    // si on a que le paramètre "distance" en entrée, on calcule une isodistance.
    // Le paramètre "méthode" doit pour avoir une réponse du service, être passé à "distance"
    if (!options.time && options.distance) {
        this.options.method = "distance";
        // on supprime l'éventuel attribut time, résidu d'un appel antérieur
        if (this.options.time) {
            delete this.options.time;
        }
    }

    // si on a que le paramètre "time" en entrée, on calcule une isochrone.
    // Le paramètre "méthode" doit pour avoir une réponse du service, être passé à "time"
    if (options.time && !options.distance) {
        this.options.method = "time";
        // on supprime l'éventuel attribut time, résidu d'un appel antérieur
        if (this.options.distance) {
            delete this.options.distance;
        }
    }

    // au cas où on a ni l'un, ni l'autre...
    this.options.method = this.options.method || "time";

    // options par defaut du service
    this.options.exclusions = options.exclusions || null;
    this.options.graph = options.graph || "Voiture"; // TODO test de la valeur à faire !
    this.options.reverse = options.reverse || false;
    this.options.smoothing = options.smoothing || false;
    this.options.holes = options.holes || false;
    this.options.srs = options.srs || "EPSG:4326";

    // on passe l'option outputFormat en minuscules afin d'éviter des exceptions.
    this.options.outputFormat = (typeof options.outputFormat === "string") ? options.outputFormat.toLowerCase() : "json";

    // gestion de l'url du service par defaut
    // si l'url n'est pas renseignée, il faut utiliser les urls par defaut
    if (!this.options.serverUrl) {
        var lstUrlByDefault = __WEBPACK_IMPORTED_MODULE_4__DefaultUrlService__["a" /* default */].ProcessIsoCurve.url(this.options.apiKey);

        var urlFound = lstUrlByDefault["iso" + "-" + this.options.outputFormat];
        if (!urlFound) {
            throw new Error("Url by default not found !");
        }
        this.options.serverUrl = urlFound;
        // this.// logger.trace("Serveur URL par defaut : " + this.options.serverUrl);
    }

    // gestion du type de service
    // si l'extension de l'url est .json ou .xml, on surcharge le format de sortie (outputFormat)
    var idx = this.options.serverUrl.lastIndexOf(".");
    if (idx !== -1) {
        var extension = this.options.serverUrl.substring(idx + 1);
        if (extension && extension.length < 5) { // FIXME extension de moins de 4 car. ...
            // this.// logger.trace("Serveur Extension URL : " + extension);
            switch (extension.toLowerCase()) {
                case "json":
                case "xml":
                    this.options.outputFormat = extension.toLowerCase();
                    break;
                default:
                    throw new Error("type of service : unknown or unsupported (json or xml) !");
            }
        }
    }
}

/**
 * @lends module:ProcessIsoCurve#
 */
ProcessIsoCurve.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_3__CommonService__["a" /* default */].prototype, {
    // todo
    // getter/setter
});

/*
 * Constructeur (alias)
 */
ProcessIsoCurve.prototype.constructor = ProcessIsoCurve;

/**
 * Création de la requête (overwrite)
 *
 * @param {Function} error   - callback des erreurs
 * @param {Function} success - callback
 */
ProcessIsoCurve.prototype.buildRequest = function (error, success) {
    try {
        var oIsoCurve = new __WEBPACK_IMPORTED_MODULE_5__Request_ProcessIsoCurveRequest__["a" /* default */](this.options);
        if (!oIsoCurve.processRequestString()) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_REQUEST_BUILD"));
        }

        this.request = oIsoCurve.requestString;
    } catch (e) {
        error.call(this, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](e.message));
        return;
    }

    success.call(this, this.request);
};

/**
 * (overwrite)
 * Analyse de la reponse
 *
 * @param {Function} onError   - callback des erreurs
 * @param {Function} onSuccess - callback de succès de l'analyse de la réponse
 */
ProcessIsoCurve.prototype.analyzeResponse = function (onError, onSuccess) {
    if (this.response) {
        var options = {
            response : this.response,
            outputFormat : this.options.outputFormat,
            rawResponse : this.options.rawResponse,
            onSuccess : onSuccess,
            onError : onError,
            scope : this
        };

        __WEBPACK_IMPORTED_MODULE_6__Response_ProcessIsoCurveResponseFactory__["a" /* default */].build(options);
    } else {
        onError.call(this, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ProcessIsoCurve);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_ProcessIsoCurveParam__ = __webpack_require__(98);





/**
 * @classdesc
 * Classe de gestion des requêtes sur le service de calcul d'isoschrone/isodistance.
 *  Les requêtes peuvent être en mode GET ou POST,
 *  et le format de sorti est en JSON ou en XML.
 *
 * @constructor
 * @alias Gp.Services.ProcessIsoCurve.Request.ProcessIsoCurveRequest
 * @param {Object} options - options
 *
 * @example
 * var options = {
 *      httpMethod : 'GET', // GET|POST
 *      // spécifique au service
 *      exclusions : ['Bridge', 'Tunnel'],
 *      position : {
 *          x : 2.3242664298058053,
 *          y : 48.86118017324745
 *      },
 *      graph : "Voiture",
 *      method : 'time',
 *      time : 1000, //distance : 200
 *      reverse : false,
 *      smoothing : false,
 *      holes : false,
 *      srs : 'EPSG:4326'
 *  };
 *
 * try {
 *
 *      var oIsoCurve = new ProcessIsoCurveRequest (options);
 *      if (!oIsoCurve.processRequestString ()) {
 *          // error
 *      }
 *
 *      var request = oIsoCurve.requestString;
 *
 * } catch (e) {
 *      // error
 * }
 * @private
 */
function ProcessIsoCurveRequest (options) {
    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("ProcessIsoCurveRequest");
    // this.// logger.trace("[Constructeur ProcessIsoCurveRequest ()]");

    if (!(this instanceof ProcessIsoCurveRequest)) {
        throw new TypeError("ProcessIsoCurveRequest constructor cannot be called as a function.");
    }

    // existance des options
    if (!options) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_EMPTY", "options"));
    }

    /**
     * Liste des options
     */
    this.settings = options;

    /**
     * Mode HTPP.
     * Par defaut, "GET".
     * @type {String}
     */
    this.mode = this.settings.httpMethod || "GET";
}

ProcessIsoCurveRequest.prototype = {

    /**
     * @lends module:ProcessIsoCurveRequest#
     */

    /**
     * Requête
     * @type {String}
     */
    requestString : null,

    /**
     * Constructeur (alias)
     */
    constructor : ProcessIsoCurveRequest,

    /**
     * Template de la requête (POST)
     * * __X__ __Y__ __SRS__ __GRAPHNAME__ __METHOD__  (obligatoire)
     * * __REVERSE__ __SMOOTHING__ __HOLES__           (par defaut)
     * * __TIME__ __TIMEVALUE__                        (choix)
     * * __DISTANCE__ __DISTANCEVALUE__                (choix)
     * * __EXCLUSIONS__ __EXCLUSIONFEATURE__ __EXCLUSIONVALUE__ (optionnel)
     * * __PROFIL__ __PROFILID__ __PROFILNAME__                 (très optionnel)
     * * __ID__ __IDVALUE__                                     (très optionnel)
     */
    template : {
        container : "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n" +
            "<isochroneRequest>\n" +
            "__ID__" +
            "\t<location>\n" +
            "\t\t<x>__X__</x>\n" +
            "\t\t<y>__Y__</y>\n" +
            "\t</location>\n" +
            "\t<srs>__SRS__</srs>\n" +
            "\t<graphName>__GRAPHNAME__</graphName>\n" +
            "__PROFIL__" +
            "__EXCLUSIONS__" +
            "\t<method>__METHOD__</method>\n" +
            "__TIME__" +
            "__DISTANCE__" +
            "\t<reverse>__REVERSE__</reverse>\n" +
            "\t<smoothing>__SMOOTHING__</smoothing>\n" +
            "\t<holes>__HOLES__</holes>\n" +
            "</isochroneRequest>",
        id : "\t<id>__IDVALUE__</id>\n",
        profil : "\t<profileId>__PROFILID__</profileId>\n" + "\t<profileName>__PROFILNAME__</profileName>\n",
        exclusions : {
            container : "\t<exclusions>\n" +
                "__EXCLUSIONFEATURE__\n" +
                "\t</exclusions>\n",
            feature : "\t\t<exclusion>__EXCLUSIONVALUE__</exclusion>"
        },
        time : "\t<time>__TIMEVALUE__</time>\n",
        distance : "\t<distance>__DISTANCEVALUE__</distance>\n"
    },

    /**
     * Construction de la requête.
     *
     * @example
     * // GET  out :
     *   //  (http://wxs.ign.fr/KEY/isochrone/isochrone.json?)
     *   //  location=&
     *   //  time=& ou distance=&
     *   //  method="DISTANCE|TIME"&
     *   //  graph=Pieton&
     *   //  graphName=Pieton&
     *   //  exclusions=&
     *   //  reverse=10&
     *   //  smoothing=&
     *   //  holes=&
     *   //  srs=
     *
     * // POST out :
     *   // <?xml version="1.0" encoding="UTF-8"?>
     *   // <isochroneRequest>
     *   //   <id>1</id>
     *   //   <location>
     *   //     <x>-1.557189</x>
     *   //     <y>47.217122</y>
     *   //   </location>
     *   //   <srs></srs>
     *   //   <graphName></graphName>
     *   //   <profileId></profileId>
     *   //   <profileName></profileName>
     *   //   <exclusions>
     *   //     <exclusion></exclusion>
     *   //     <exclusion></exclusion>
     *   //   </exclusions>
     *   //   <method></method>
     *   //   <time>50</time>
     *   //   <distance></distance>
     *   //   <reverse></reverse>
     *   //   <smoothing></smoothing>
     *   //   <holes></holes>
     *   // </isochroneRequest>
     *
     * @returns {String} request
     */
    processRequestString : function () {
        var request = "";
        var i = 0;

        switch (this.mode) {
            case "GET":
                // this.// logger.trace("Process GET Request");

                // Mapping des options avec le service de l'API REST
                var oParams = new __WEBPACK_IMPORTED_MODULE_2__model_ProcessIsoCurveParam__["a" /* default */](this.settings);
                var params = oParams.getParams();

                for (i = 0; i < params.length; i++) {
                    var o = params[i];
                    if (request) {
                        request += "&";
                    }
                    request += o.k + "=" + o.v;
                }

                break;

            case "POST":
                // this.// logger.trace("Process POST Request");

                request = this.template.container;

                // options non prises en compte car non implémentées !
                // clean : id
                request = request.replace(/__ID__/g, "");
                // clean : profil
                request = request.replace(/__PROFIL__/g, "");

                // options obligatoires
                request = request.replace(/__X__/g, this.settings.position.x);
                request = request.replace(/__Y__/g, this.settings.position.y);
                request = request.replace(/__GRAPHNAME__/g, this.settings.graph);

                // options par defaut
                request = request.replace(/__SRS__/g, this.settings.srs);
                request = request.replace(/__SMOOTHING__/g, this.settings.smoothing);
                request = request.replace(/__HOLES__/g, this.settings.holes);
                request = request.replace(/__REVERSE__/g, this.settings.reverse);

                // options conditionnelles

                // exclusions
                if (this.settings.exclusions) {
                    var tmplExclusions = this.template.exclusions.container;
                    var exclusions = [];
                    for (i = 0; i < this.settings.exclusions.length; i++) {
                        var tmplFeature = this.template.exclusions.feature;
                        tmplFeature = tmplFeature.replace(/__EXCLUSIONVALUE__/, this.settings.exclusions[i]);
                        exclusions.push(tmplFeature);
                    }
                    tmplExclusions = tmplExclusions.replace(/__EXCLUSIONFEATURE__/, exclusions.join("\n"));
                    request = request.replace(/__EXCLUSIONS__/g, tmplExclusions);
                }
                // clean exclusions
                request = request.replace(/__EXCLUSIONS__/g, "");

                // distance
                if (this.settings.distance) {
                    var tmplDistance = this.template.distance;
                    tmplDistance = tmplDistance.replace(/__DISTANCEVALUE__/g, this.settings.distance);
                    request = request.replace(/__DISTANCE__/g, tmplDistance);
                    // method
                    request = request.replace(/__METHOD__/g, "distance");
                }
                // clean
                request = request.replace(/__DISTANCE__/g, "");

                // time
                if (this.settings.time) {
                    var tmplTime = this.template.time;
                    tmplTime = tmplTime.replace(/__TIMEVALUE__/g, this.settings.time);
                    request = request.replace(/__TIME__/g, tmplTime);
                    // method
                    request = request.replace(/__METHOD__/g, "time");
                }
                // clean
                request = request.replace(/__TIME__/g, "");
                break;

            default:
                this.logger.error("No other HTTP method supported by the service !");
        }

        // this.// logger.trace(request);
        this.requestString = request;

        return this.requestString;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ProcessIsoCurveRequest);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);



/**
 * @classdesc
 *
 * Classe de gestion des param. des requêtes du service de calcul des iso.
 * Permet le mapping avec les options du service.
 *
 * @constructor
 * @alias Gp.Services.ProcessIsoCurve.Request.ProcessIsoCurveParam
 * @param {Object} options - options
 * @private
 *
 */
function ProcessIsoCurveParam (options) {
    if (!(this instanceof ProcessIsoCurveParam)) {
        throw new TypeError("ProcessIsoCurveParam constructor cannot be called as a function.");
    }

    this.logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger();
    // this.// logger.trace("[Constructeur ProcessIsoCurveParam ()]");

    /**
     * Options en paramêtres du constructeur.
     */
    this.options = options || {};

    // mapping des options avec l'API REST

    /** Identifiant de l’isochrone */
    this.id = this.options.id;

    /** Coordonnées de départ (ou arrivée si le reverse est à true). */
    this.location = this.options.position;

    /** projection (code EPSG comme epsg:4326 ou wgs84) */
    this.srs = this.options.srs;

    /**
     * Profil de véhicule à utiliser pour le calcul.
     * Voiture ou Pieton
     */
    this.graphName = this.options.graph;

    /**
     * Identifiant et nom du véhicule
     * FIXME non utilisé
     */
    this.profileId = this.options.profileId || null; // TODO !
    this.profileName = this.options.profileName || null; // TODO !

    /** Liste des règles de restrictions à utiliser */
    this.exclusions = this.options.exclusions;

    this.reverse = this.options.reverse;
    this.smoothing = this.options.smoothing;
    this.holes = this.options.holes;

    /**
     * "time" pour isochrone ou "distance" for isodistance.
     * Par defaut, time...
     */
    var value = this.options.method;
    switch (value) {
        case "time":
            this.method = "time";
            this.time = this.options.time;
            break;
        case "distance":
            this.method = "distance";
            this.distance = this.options.distance;
            break;
        default:
            this.logger.warn("Par defaut, on calcule un isochrone !");
            this.method = "time";
    }
}

/**
 * CLASSNAME
 */
ProcessIsoCurveParam.CLASSNAME = "ProcessIsoCurveParam";

ProcessIsoCurveParam.prototype = {

    /**
     * @lends module:ProcessIsoCurveParam#
     */

    /**
     * Constructeur (alias)
     */
    constructor : ProcessIsoCurveParam,

    /**
     * Retourne la liste des exclusions
     * @returns {String} x,y
     */
    getLocation : function () {
        return this.location.x + "," + this.location.y;
    },

    /**
     * Retourne la liste des exclusions
     * @returns {String} exclusions
     */
    getExclusions : function () {
        return this.exclusions.join(";");
    }
};

/**
 * Tableau de clefs/valeurs pour param.
 *
 * @returns {Object[]} KVP
 */
ProcessIsoCurveParam.prototype.getParams = function () {
    var map = [];

    map.push({
        k : "location",
        v : this.getLocation()
    });

    map.push({
        k : "smoothing",
        v : this.smoothing
    });

    map.push({
        k : "holes",
        v : this.holes
    });

    map.push({
        k : "reverse",
        v : this.reverse
    });

    map.push({
        k : "method",
        v : this.method
    });

    if (this.time) {
        map.push({
            k : "time",
            v : this.time
        });
    }

    if (this.distance) {
        map.push({
            k : "distance",
            v : this.distance
        });
    }

    map.push({
        k : "graphName",
        v : this.graphName
    });

    if (this.exclusions) {
        map.push({
            k : "exclusions",
            v : this.getExclusions()
        });
    }

    if (this.srs) {
        map.push({
            k : "srs",
            v : this.srs
        });
    }

    return map;
};

/* harmony default export */ __webpack_exports__["a"] = (ProcessIsoCurveParam);


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Formats_XML__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Formats_WKT__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Formats_ProcessIsoCurveResponseReader__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_ProcessIsoCurveResponse__ = __webpack_require__(18);
/**
 * Factory pour générer une reponse JSON à partir d'un XML ou d'un JSON
 * (Factory)
 *
 * @module ProcessIsoCurveResponseFactory
 * @alias Gp.Services.ProcessIsoCurve.Response.ProcessIsoCurveResponseFactory
 * @private
 */








var ProcessIsoCurveResponseFactory = {

    /**
     * interface unique
     *
     * @method build
     * @static
     * @param {Object} options - options definies dans le composant ProcessIsoCurve
     *
     * @example
     *   var options = {
     *      response :
     *      outputFormat :
     *      rawResponse :
     *      scope :
     *      onSuccess :
     *      onError :
     *   };
     *
     */
    build : function (options) {
        // logger
        var logger = __WEBPACK_IMPORTED_MODULE_0__Utils_LoggerByDefault__["a" /* default */].getLogger("ProcessIsoCurveResponseFactory");
        // logger.trace(["ProcessIsoCurveResponseFactory::build()"]);

        var data = null;

        if (options.response) {
            if (options.rawResponse) {
                // logger.trace("analyze response : raw");
                data = options.response;
            } else {
                switch (options.outputFormat) {
                    case "xml":
                        // logger.trace("analyze response : xml");

                        try {
                            var p = new __WEBPACK_IMPORTED_MODULE_3__Formats_XML__["a" /* default */]({
                                reader : __WEBPACK_IMPORTED_MODULE_5__Formats_ProcessIsoCurveResponseReader__["a" /* default */]
                            });

                            // FIXME : mode XHR ne retourne que des string ? JSONP aussi à ce niveau ?
                            if (typeof options.response === "string") {
                                p.setXMLString(options.response);
                            } else {
                                p.setXMLDoc(options.response);
                            }

                            data = p.parse();

                            if (!data) {
                                throw new Error(__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION_2"));
                            }
                        } catch (e) {
                            var message = e.message;
                            message += "\n (raw response service : '" + options.response + "')";
                            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                                message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", message),
                                status : 200,
                                type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
                            }));
                            return;
                        }

                        break;

                    case "json":
                        // logger.trace("analyze response : json");

                        var JSONResponse;
                        if (typeof options.response === "string") {
                            JSONResponse = JSON.parse(options.response);
                        } else {
                            JSONResponse = options.response;
                        }

                        // analyse de la reponse
                        if (JSONResponse.status === "OK" || JSONResponse.status === "ok") {
                            // création de l'objet de réponse
                            data = new __WEBPACK_IMPORTED_MODULE_6__model_ProcessIsoCurveResponse__["a" /* default */]();

                            // remplissage de l'objet créé avec les attribtuts de la réponse du service
                            if (data) {
                                data.time = JSONResponse.time;
                                data.distance = JSONResponse.distance;
                                data.message = JSONResponse.message;
                                data.id = JSONResponse.id;
                                data.srs = JSONResponse.srs;
                                // callback de la reponse
                                var onWKTSuccess = function (json) {
                                    data.geometry = json;
                                };
                                // callback d'erreur
                                var onWKTError = function () {
                                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                                        message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_FORMAT", "wktGeometry")
                                    }));
                                };
                                if (data.hasOwnProperty("geometry")) {
                                    __WEBPACK_IMPORTED_MODULE_4__Formats_WKT__["a" /* default */].toJson(JSONResponse.wktGeometry, onWKTSuccess, onWKTError);
                                    if (!data.geometry) {
                                        return;
                                    }
                                }
                                var coords = JSONResponse.location.split(",");
                                if (data.location) {
                                    data.location.x = coords[0];
                                    data.location.y = coords[1];
                                }
                            } else {
                                options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_ANALYSE", options.response)));
                                return;
                            }
                        } else if (JSONResponse.status === "ERROR" || JSONResponse.status === "error") {
                            // JSHint bug if var message is used !?
                            var mess = JSONResponse.message;
                            mess += "\n (raw response service : '" + JSONResponse + "')";
                            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", mess)));
                            return;
                        }
                        break;

                    default:
                        options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_FORMAT", "json", "xml")));
                        return;
                }

                // info : en cas de problèmes de droits (clé invalide ou autre), la réponse est au format XML !!
                // ex. <ExceptionReport><Exception exceptionCode="MissingParameter">Key does not exist or has expired</Exception></ExceptionReport>
                // mais le statut est 403, l'erreur est donc remontée plus tôt.
                if (data && data.exceptionReport) {
                    options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                        message : __WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION", data.exceptionReport),
                        type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR,
                        status : 200
                    }));
                    return;
                }
            }
        } else {
            // si la réponse est vide, on appelle le callback d'erreur
            options.onError.call(options.scope, new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EMPTY")));
            return;
        }

        // si tout s'est bien passé, on appelle le callback de succès
        options.onSuccess.call(options.scope, data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ProcessIsoCurveResponseFactory);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Formats_WKT__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Response_model_ProcessIsoCurveResponse__ = __webpack_require__(18);
/**
 * Analyse de la reponse XML
 *
 * @module ProcessIsoCurveResponseReader
 * @alias Gp.Services.ProcessIsoCurve.Formats.ProcessIsoCurveResponseReader
 * @todo not yet implemented !
 * @private
 */






/**
 * Objet ProcessIsoCurveResponseReader
 *
 * @member {Object} ProcessIsoCurveResponseReader
 *
 * @property {Object} ProcessIsoCurveResponseReader.READERS - Objet contenant des fonctions de lecture, appelées "readers"
 *      dont chaque clé correspond au nom d'un tag du XML que l'on souhaite lire
 *      et la valeur associée est une fonction (node, data)
 *      où node est un noeud du document DOM
 *      et data est un objet où l'on stocke les informations lues dans le XML.
 *
 * @property {Method} ProcessIsoCurveResponseReader.read -  Méthode permettant de lancer la lecture d'une réponse XML
 *       du service de calcul isochrone/isodistance, à l'aide des readers de la classe.
 *
 */

var ProcessIsoCurveResponseReader = {};

/*
    // INFO
    // Exemple d'erreur du service
    // <?xml version="1.0" encoding="UTF-8" standalone="yes" ?>
    // <isochroneResult>
    //  <message>Location point must have 2 components separated with a ,</message>
    //  <status>ERROR</status>
    // </isochroneResult>

    // <?xml version="1.0" encoding="UTF-8" standalone="yes" ?>
    // <serviceResult>
    //   <message>ServiceException : Error in isochron computation Error in smartrouting null</message>
    //   <status>ERROR</status>
    // </serviceResult>

    // INFO
    // Exemple d'erreur NGinx
    // <ExceptionReport><Exception exceptionCode="MissingParameter">Resource parameter not found</Exception></ExceptionReport>
*/

/*
    // INFO
    // Exemple de réponse du service

     // <IsochroneResult>
     //    <status>OK</status>
     //    <id/>
     //    <location>-1.557189,47.217122</location>
     //    <srs/>
     //    <distance>5000</distance>
     //    <wktGeometry>POLYGON ((-1.545312 47.178178, -1.545312 47.180418, ...))</wktGeometry>
     // </IsochroneResult>

    // <isochronResult>
    //    <status>OK</status>
    //    <id>1</id>
    //    <location>-1.557189,47.217122</location>
    //    <srs/>
    //    <time>50</time>
    //    <wktGeometry>POLYGON ((-1.556864 47.216487, -1.556864 47.216948, ...))</wktGeometry>
    // </isochronResult>
*/

ProcessIsoCurveResponseReader.READERS = {

    /** TODO : jsdoc block */
    isochronResult : function (root) {
        // racine de la réponse XML : on crée l'objet de réponse
        var response = new __WEBPACK_IMPORTED_MODULE_3__Response_model_ProcessIsoCurveResponse__["a" /* default */]();

        if (root.hasChildNodes()) {
            var children = root.childNodes;
            var child;

            for (var i = 0; i < children.length; i++) {
                child = children[i];

                if (ProcessIsoCurveResponseReader.READERS[child.nodeName]) {
                    ProcessIsoCurveResponseReader.READERS[child.nodeName](child, response);
                }
            }
        }

        if (response.status === "error") {
            var message = __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION",
                response.message);
            throw new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                message : message,
                type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
            });
        }
        return response;
    },

    /** TODO : jsdoc block */
    message : function (node, response) {
        if (response) {
            response.message = __getChildValue(node);
        }
    },

    /** TODO : jsdoc block */
    status : function (node, response) {
        var status = __getChildValue(node);
        if (status === "ERROR" || status === "error") {
            if (response) {
                response.status = "error";
            }
        }
    },

    /** TODO : jsdoc block */
    id : function (node, response) {
        if (response) {
            response.id = __getChildValue(node);
        }
    },

    /** TODO : jsdoc block */
    location : function (node, response) {
        var coords = __getChildValue(node);
        if (response && response.location) {
            response.location.x = parseFloat(coords.split(",")[0]);
            response.location.y = parseFloat(coords.split(",")[1]);
        }
    },

    /** TODO : jsdoc block */
    srs : function (node, response) {
        if (response) {
            response.srs = __getChildValue(node);
        }
    },

    /** TODO : jsdoc block */
    distance : function (node, response) {
        if (response) {
            response.distance = parseFloat(__getChildValue(node));
        }
    },

    /** TODO : jsdoc block */
    time : function (node, response) {
        if (response) {
            response.time = parseFloat(__getChildValue(node));
        }
    },

    /** TODO : jsdoc block */
    wktGeometry : function (node, response) {
        if (response) {
            var wktGeometry = node.innerHTML;
            /** TODO : jsdoc block */
            var onWKTSuccess = function (json) {
                response.geometry = json;
            };
            /** TODO : jsdoc block */
            var onWKTError = function () {
                var msg = __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("PARAM_FORMAT", ["wktGeometry"]);
                throw new Error(msg);
            };
            if (response.hasOwnProperty("geometry")) {
                __WEBPACK_IMPORTED_MODULE_1__Formats_WKT__["a" /* default */].toJson(wktGeometry, onWKTSuccess, onWKTError);
            }
        }
    },

    /** TODO : jsdoc block */
    serviceResult : function (node) {
        // en cas d'exception du service
        var response = {};
        if (node.hasChildNodes()) {
            var children = node.childNodes;
            var child;
            for (var i = 0; i < children.length; i++) {
                child = children[i];
                if (ProcessIsoCurveResponseReader.READERS[child.nodeName]) {
                    ProcessIsoCurveResponseReader.READERS[child.nodeName](child, response);
                }
            }
        }
        return response;
    },

    /** TODO : jsdoc block */
    ExceptionReport : function (node) {
        var response = {};
        if (node.hasChildNodes()) {
            var children = node.childNodes;
            var child;
            for (var i = 0; i < children.length; i++) {
                child = children[i];
                if (child.nodeName === "Exception") {
                    response.exceptionReport = ProcessIsoCurveResponseReader.READERS["Exception"](child);
                }
            }
        }
        return response;
    },

    /** TODO : jsdoc block */
    Exception : function (node) {
        var exceptionReport = {};

        // get exception code
        var exceptionCode = node.getAttribute("exceptionCode");
        if (exceptionCode) {
            exceptionReport.exceptionCode = exceptionCode;
        }

        // get exception message
        var textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            exceptionReport.exception = textNode.nodeValue;
        }

        return exceptionReport;
    }
};

/** TODO : jsdoc block */
ProcessIsoCurveResponseReader.read = function (root) {
    var response;

    if (root.nodeName === "isochronResult" || root.nodeName === "isochroneResult" || root.nodeName === "IsochroneResult") {
        response = ProcessIsoCurveResponseReader.READERS["isochronResult"](root);
        return response;
    } else if (root.nodeName === "ExceptionReport") {
        response = ProcessIsoCurveResponseReader.READERS[root.nodeName](root);
        return response;
    } else if (ProcessIsoCurveResponseReader.READERS[root.nodeName]) {
        response = ProcessIsoCurveResponseReader.READERS[root.nodeName](root);
        if (response.status === "error") {
            var errMsg = __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_EXCEPTION",
                response.message);
            throw new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
                message : errMsg,
                type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_SRVERR
            });
        }
        return response;
    } else {
        throw new __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */]({
            message : __WEBPACK_IMPORTED_MODULE_0__Utils_MessagesResources__["a" /* default */].getMessage("SERVICE_RESPONSE_ANALYSE", root.nodeName),
            type : __WEBPACK_IMPORTED_MODULE_2__Exceptions_ErrorService__["a" /* default */].TYPE_UNKERR
        });
    }
};

/**
 * Lecture de la valeur du premier child d'un noeud, si elle existe.
 *
 * @private
 * @memberof ProcessIsoCurveResponseReader
 * @method __getChildValue
 * @param {DOMElement} node - a DOM node
 * @return {String} value - valeur du firstChild du noeud en entrée, ou chaîne vide.
 */
function __getChildValue (node) {
    var textNode;
    var value = "";

    if (node.hasChildNodes()) {
        textNode = node.firstChild;
        if (textNode && textNode.nodeType === 3) { // 3 === node.TEXT_NODE
            value = textNode.nodeValue;
        }
    }
    return value;
}

/* harmony default export */ __webpack_exports__["a"] = (ProcessIsoCurveResponseReader);


/***/ })
/******/ ])["default"];
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Marker = {
    lightOrange: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARDSURBVFiF3ZndaxxVGMZ/Z/YjX00Nadpo1qrFBgu56D9QbAtiLoRC7ywSNK1NURRREBKRFlSwFBW0gnSrJXY1CmISgyjFiyYSFC9ajE3MmpjdjWlMUtNos9lN9mteLzbRuCbZmTMTBB+Yi51znvd5n3nPnjnnjBIR/i/wuh4xpCpI0ojiENAA1AE1wCzwKzCE0EM5l2iShJvSyrXKnFVb8dOK4hmg3AIjifAmaU7ztMy7kYI7Zs6rQwjvka+AXcyiOMZx6XGahuE0AEHVitCFnhGAGoQugqrVaSrOKpNP4FWnSaxCGy1yWpesbyY/tLpwo7p/w0RxWHfI6Zk5q7ZSwhj6Q2sjzJLiXp1JQe+p+mllc4wA1CzHtw37lQmpCha5gbXpVxdJythh9z1kvzJJGrFixPBmOXixl+Z4mONmguZ4mIMXezG8WQsq5cs6tmDfTP7NXiSqN0vTzBD1TQfwbdmDUhX4tuyhvukATTNDlgxZ0SmUtUsgv0TZGPsv9FNSvXfNtpLqvey/0O+KTgF0zNQV7XHP4dsdtVvVKYCOmeqiPbwVOx21W9UpgI6ZWNEe2cSEo3arOgWwb0YYLp5G17Sjdqs6BdCZzYqL9B3dR2puYM221NwAfUf3uaJTAB0zaye5GmbWS6i2gdFQL5mFMCIJMgthRkO9hGobMLPFN4VWdAoptlcAQeUDRoG77YrZwDhQT4tk7JDsV6ZFMggv2+bZwyt2jYDuQnOa94GIFrc4IkzRrkPUM3NKsijatLjF0copsbJ++xec7TTPqw6EI/oB/glT+PC+13Y/aSQNv/Is+tNer09lMn7DMHwAYppp8fvTIpISkVQsFrslqww4M9OuqkgzANzl1MhCyrjZGAycm573pK1yFCyi5FoWvo/FYlPOT2fOqftRXMbB9lkEs+3zbe2f/FD5i3YMj2p3vn8/IV8DZ5yE+Gqkot+JEQCPada5dRhxEriiQ5ya90w+272916F+KpnJDLhjpkUy5HgESNqhZU2Vfr5ne+dSFtOBeso06J6cnEy6d0z0hPwEPGeH8sGVykvfjpfe1NZUci2+mHg7Go2G8z/d/goQVJ9B8S1veMYffujduo/thl+ZwUzDuBqJRGZWt7n/FcDH46lFNVLilar1uiTTxsJTnTssH/QpJVlMNQa5wbGJiWERya3Vz30zzfLb3OveY3dU5j5dp4e80Xdbd3TOu/H/yyAtpjnqgeGS8crRQRks+v5xf5gtY/KM/6NAVebhwvv90bLvHu2o/XId2pJSMmIaxo/RaHRMxN6yZtPM0K5K/7hl/FxVZgZWbs0mPDceeKcuGE95/kpSKUmaImHDNIfHrl+PiIj2zOb+MFvBY7IUOVl2ZG9g6bJH4ckJuRe/2NYZT3myKIkrGM4pNRyLjY+LW09URDb1+uaF0pfm3zJ+7zhRGdq1c9eDuwOBOzdLa/OG2X+APwE8DU64Y/5gfAAAAABJRU5ErkJggg==",
    darkOrange: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAQ+SURBVFiF3ZlLaFxlGIaf/5zJpJNpaoxpYieoCxULEYK7Lqp0IWQhFLooKNKEtNIULxWlQoJgQQWLFMEg0lQMuXgD0dRSkNJFgoy0IrYNSTpj08xMmoxNYhLUyUwyt/O5mFbjmGTOLS58d3O+y/u95/vnvx0lIvxf4HE9Y7PyU0ETwl6gAQgANcA88AswhuIsKc7TJ0k3qZVrnTmqtpGhHeFloMJERArF+3g5Qaf84UYJ7og5rPai+JhCB6xiHuEQp+Ws0zI0pwloU+0oBrAnBKAGxQBtqt1pKc46UyjgHadFrEIHXXLCbrB9MYWhNYAb3f0bBsI+u0POnpijahtpJrA/tDbCPOU8aGdSsPdWM7SzOUIAam7ntwzrnWlWfnzMYW76tYsUy9RaXYesd6aCJswI0Tw5WvuG6EyEOWUk6UyEae0bQvPkTLEUeCzBupjCyl4iqyfHydkxdh3YQ/nWnSjlp3zrTnYd2MPJ2TFTgszwFNNaDaCwRdkYLd1B/NWNa9r81Y20dAdd4SmCHTGBkh6P7bvXkd0sTxHsiKku6eH13+fIbpanCHbExEp6ZJJTjuxmeYpgXYwiVNLnysCMI7tZniLYmc1Kk/Qe3E1ycXhNW3JxmN6Du13hKYIdMWsXuRpGzsOxugYu9Q+RXgojkiS9FOZS/xDH6howcqUPhWZ4imB9B9CmyoBx4AGrZBYwCTxMl2StBFnvTJdkUbxlOc4a3rYqBOxuNHfQC0RsxZZGhAA9dgLtiTkuOYQOW7Gl0c5xMbN/+xecnTQPq89QPGM/wT9hCJ8+MvjQ81pK8yp92ZvxeMpUNuvVNK0MQAwjI15vRkTSIpKOxWK/yyoBzsS0qiq8DAP3OxWylNMWmoL1XTMresZsjIJllIzk4GosFrvl/HbmiHoCYRAHx2cBo2Pknp4v45U3befQVY/z8/sp+Q5410mKC7P+oBMhALphBNy6jHgDxU92Am+t6PFXhrcPOeRPp7LZYXfEdEkWjWeBlJWwnKEyr41s/3rFwHDAnjY0zsTj8ZR710Qfys/Aq1ZCPrlZef7iwpYF25xKRhLLyQ+i0Wi48NPtrwBt6hsofeQNJ7zhp74PfGE1/Z0ZzNC0y5FIZHa1zf2vAFmeS2vqerkuVeu5pPLa0otXa01f9CklOQw1AfnRiampkIjk1/JzX0y3/LrY7Dm0w5f/ah0Pee/GXWeiSc/G/y+NjBjGuA6h8snK8VEZLbn+uD/MbiPe7P283pd9uvh5cMH3Q8uPdd+uE7ailFw3NO1aNBqdELG2rdk0MbSqLb8p7UZVmVF/59F8Wp97Mhg4ncjqfxWplKQMkbBmGKGJ6emIiNie2TZPDHB5v+/xxrtXBnWFnhfyL1yp/ejCXMUMShIKQnmlQrFYbFJcKmJTxQBc3O9789FtmZfOzfjPvT5S068bmWvj09PTm8G16WL+S/wJLybNu1V6htkAAAAASUVORK5CYII=",
    red: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAQxSURBVFiF3ZldaBxVFMd/d2ayTRtjQpo2mlilWBEMshoj+FAERZIHIdA3iw+V1icRREFIQAKNgsUHQfBFwZI2WgWxqYUiVTDBBj9ILC5Nu2tjdjemsR+mSZNNNvsxO8eHTTRuk+zMnQmCf9iHnXvO+Z//nDvn3rmjRIT/C6zAI4ZVFRbtKDpQNCM0AvXANIo/EC4inMbmLBFZDJJaBVaZJ9Sd2HQCrwDbXHikgfewOMKPMh9ECsGIeVx1IHxEsQJeMY3iEMNy2m8aht8AtKpOhH70hADUI/TTqjr9puKvMsUE3vabxCp0MSJHdJ31xRSnVj9BVPcfOCj26U45PTHFh30c/am1EaaxuF+nKejd1WLX2gwhAPXL8T3De2XCqooKbuCu/eoiTZ6dXtch75WxaMeNENOyOXx8kHOpGMPOIudSMQ4fH8S0bBcs25Z5PMF7ZVpVL3BgQxvTsvn6+kVq6sK3jc3NRGhraKZgl9t9HGNEXvCSmvfKKJrL2nQfHVpTCEBNXZjuo0OB8JTAu5jiXmtjPL3vLl/jbnlKoNPN6spaVFbt8jXulqcEOmKSZS0yi5O+xt3ylEBHTLSsxbf913yNu+UpgU4DKE/Sc3AvczORNcfmZiL0HNwbCE8JvItxWDvJ1SjYFm0NzZzpG2RpIYbIIksLMc70Dbpsy+54SqCzzlQAY8B9Xsk8YAJ4gBHJe3HyXpkRyaN407OfN7zlVQjobjTv4BgQ1/ItjzjV9Oo46okZEBuhS8u3PDoZEDf7t9vg903zBLBfP8C/4cAnD87teclIGyFlLoVyllWh8vmQYRgVAOI4OQmFciKSFZFsMpmck1UC/Il5VNViEgHu9StkQYyb7bNNH1wrmDm3PgqWUHLBhl+SyeRV/6czLepJDAbw8fos4HTNb+/9PFv9u3YMU/X6f38/L98B7/gJ8U2uasiPEADTcRqDOozoBn7WcbzqmFOvpnYM+uTPpvP5SDBiimvP8xRPKV3DFpV7fX7HyYyD44M96xicmpqaSgd3TDQsv6J4zYvLx5nqsz/kK29qcyq5kFpafD+RSMSKf4P+CvCY+hJFRzmzmB2KPTvb+JnX8CsdzDGM8/F4/PrqseC/AggvZlGXtyipXc8kLcbCy6mdrg/6lBIbR41DYXR8cjIqIoW17IIXc17+nHnEOnS3VfhiHQt5d7HmVMK2Nn6+DHLiOGMmRLdMVI+NymjZ9Sf4abaMqZbQp01G/rnS60P5rT8duNXw1TpuGaXksmMYlxKJxLiIt23NponhKVV5a874rdZwmlYuTTvmjWdmGj9Mifl3kkpJ2hGJGY4THb9yJS4i2p0t+Gm2ggHJxMNb94eNzIAJZgEKbyxsP5kS00ZJSkG0oFQ0mZyYkKDuqIhs6u/7hyt75luM2RMPVfft3rW7bU9T0z2bxbV50+w/wF8f81R5OpwBhwAAAABJRU5ErkJggg==",
    turquoiseBlue: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASxSURBVFiF3ZhdbBRVGIafc2Z2210hbeWnpcQVUC8kwBUJXJBIgwkgBEPEC1GMxhgE4gUJJsYERMWI3orYaiqgrYSWH/mvMaQLciE1RAKUkrLbbhMobQ20/LT7N3OOF0CC0O7szGwv9L3c73u/93vnnD3zzYH/EUTBKx6sHUvQWgR6GTAdmASMA26A6AYuofUhQnYTVevuFlK6cGaObC9DGh8i9PtAKA/GEIKvSRZtZfnbA4VooTBmjlWvQFADPOmBfRN4l8Xv7ffbhvTF1lpwrHoTgga8GeE+by9NNRvR2tfDNfyQmVv5MYJP8L/CAqgidtai/sgpP0W84d7WavBV43Eo0CtYvOaAF7K3Rg7sKKU4Hcf71sqFfmz1DEvX9rslevvPFKc/YnSMAJRhyA+8EN2vzMHasQSzveR3/HrFEMV2udv3kOlaJmgtIg8jYcMcqpu1oGXJhMi0oJQVGaV6Dvd1day62DwnaWWd+GHSciGwz01rHraZXuaUETbMoe6qVR3Ly6fMD0oZAYJBKSOvVEyd3z3/jVjIDCSddYSjzqPwYEY875RRN2tBS4kZnDFcrNQMztw144UzjjKa6W4787IylU4ZSyZEpuWKv1w+dWohdB6Fl9NsnFNCUMqKnHGRO34PYnz+Ld2DFzN3nBIySvXkjGt1PQ+d23l3dB9ezPQ6JRzu6+rIFT/Q25lwVNHkfCDDwYuZFqeEVReb5wxYmQvDxfqz6QtvnW+e69yZcNR5jOKWgKbZKSVpZUOV0bpnG3vi0YxWXUAmo1XXnp54tLL5p+dSyi52FlJRt625nwCavxlDyrgKlLjm5o9byPBkFr456IbkfmWq1t1FsMM1zx1q3RoBr4OmpT4F+jxxndGHrbZ4IXozs3RtP0Ks98R1ghDrvYz/4PfD6ti39Qix0leNh6H07siaL9ZJKYuKtA6lhSgKaC0sWwYATENlLSmVECIZTKcHZ167NtAI9gO6PzO/1ZRg6XPAFF91AJnKDES21NaYN26l8uVoLWyhSZhS/345kUj4/+Q9XjMPdBR/9wl6Qn3TjyWnzyW88i3Y5e92BmDx6tPAV35KjDnXftqHEQBhKDXZvxmA4p5NCJzH+mFg3rxzvXzn0ZN+5BUoW8p4YcxUbbZQ4nXyGEIfhrDt7MS6o/tEOm07Z48ArTPCMPYnEomewpgBeGl1HMQGN5SSk381hdsSNzwqag1tRbZdHY/HL8JoXJwfr24AXnVKK7rae/mpz3fs8aCQ1FqfxzTPxuPxf7243V9oOMESa4XOvqgDZtlIKTKVHpz4w6Ej+ZbUWlgIHdNStkYikbZoNGoNl1f4lQGM3V8us0tLfhmhvh6/98Tu0hN/XslVQ2uRlahOIWWrMozLsVgs7aQ7KmYAAnVb67PjSh+bDsKtHX9Ubmv4dQRaEiE6JLQHwuG21tbWjBvNwm+z+8hmU+/Iu8l5akwo8uA34/bg3+W1B088nKdhCK2vmFJemjV7dqyxsdHzyTZqKwMQ2r55bmpK+SktRABb2ZO+2//9E+djvcAthIgZ0P5aZ+eVzaAKoTeqZgCKt238LP10xYaxZy7tq/j5+E5Ms629vb0b0KOt/Z/GP4jqqfL5oxVsAAAAAElFTkSuQmCC",
    defaultOffset: [-25.5, -38]
};

exports.default = Marker;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _LayerSwitcherDOM = __webpack_require__(31);

var _LayerSwitcherDOM2 = _interopRequireDefault(_LayerSwitcherDOM);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("layerswitcher");

/**
 * @classdesc
 * OpenLayers Control to manage map layers : their order, visibility and opacity, and display their informations (title, description, legends, metadata...)
 *
 * @constructor
 * @extends {ol.control.Control}
 * @alias ol.control.LayerSwitcher
 * @param {Object} lsOptions - control options
 * @param {Array} [lsOptions.layers] - list of layers to be configured. Each array element is an object, with following properties :
 * @param {ol.layer.Layer} [lsOptions.layers.layer] - ol.layer.Layer layer to be configured (that has been added to map)
 * @param {Object} [lsOptions.layers.config] - custom configuration object for layer information (title, description, legends, metadata, quicklook url), with following properties :
 * @param {String} [lsOptions.layers.config.title] - layer alias, to be displayed in widget layer list. E.g. : "Cartes IGN"
 * @param {String} [lsOptions.layers.config.description] - layer description, to be displayed on title hover, or in layer information panel.
 * @param {String} [lsOptions.layers.config.quicklookUrl] - link to a quick look image for this layer.
 * @param {Array} [lsOptions.layers.config.legends] - array of layer legends. Each array element is an object, with following properties :
 *      - url (String, mandatory) : link to a legend
 *      - minScaleDenominator (Number, optional) : min scale denominator for legend validity.
 * @param {Array} [lsOptions.layers.config.metadata] - array of layer metadata. Each array element is an object, with property url (String, mandatory) : link to a metadata
 * @param {Object} [lsOptions.options] - ol.control.Control options (see {@link http://openlayers.org/en/latest/apidoc/ol.control.Control.html ol.control.Control})
 * @param {Boolean} [lsOptions.options.collapsed] - Specify if widget has to be collapsed (true) or not (false) on map loading. Default is true.
 * @example
 * map.addControl(new ol.control.LayerSwitcher(
 *  [
 *      {
 *          layer : wms1,
 *          config : {
 *              title : "test layer name 1",
 *              description : "test layer desc 1",
 *          }
 *      }
 *  ],
 *  {
 *      collapsed : true
 *  }
 * ));
 */
function LayerSwitcher(lsOptions) {
    lsOptions = lsOptions || {};
    var options = lsOptions.options || {};
    var layers = lsOptions.layers || [];

    if (!(this instanceof LayerSwitcher)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    if (layers && !Array.isArray(layers)) {
        throw new Error("ERROR WRONG_TYPE : layers should be an array");
    }

    if (options && (typeof options === "undefined" ? "undefined" : _typeof(options)) !== "object") {
        throw new Error("ERROR WRONG_TYPE : options should be an object");
    }

    this._initialize(options, layers);

    var container = this._initContainer(options);

    // call ol.control.Control constructor
    _ol2.default.control.Control.call(this, {
        element: container,
        target: options.target,
        render: options.render
    });
}

// Inherits from ol.control.Control
_ol2.default.inherits(LayerSwitcher, _ol2.default.control.Control);

/*
 * @lends module:LayerSwitcher
 */
LayerSwitcher.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les méthodes de la classe commune LayerSwitcherDOM
_Utils2.default.assign(LayerSwitcher.prototype, _LayerSwitcherDOM2.default);

/**
 * Constructor (alias)
 *
 * @private
 */
LayerSwitcher.prototype.constructor = LayerSwitcher;

// ################################################################### //
// ############## public methods (getters, setters) ################## //
// ################################################################### //

/**
 * Overload setMap function, that enables to catch map events, such as movend events.
 *
 * @param {ol.Map} map - Map.
 */
LayerSwitcher.prototype.setMap = function (map) {
    // info : cette méthode est appelée (entre autres?) après un map.addControl() ou map.removeControl()

    if (map) {
        // dans le cas de l'ajout du contrôle à la map
        // on ajoute les couches
        this._addMapLayers(map);

        // At every map movement, layer switcher may be updated,
        // according to layers on map, and their range.
        this._listeners.onMoveListener = map.on("moveend", function () {
            this._onMapMoveEnd(map);
        }, this);

        // add event listeners when a new layer is added to map, to add it in LayerSwitcher control (and DOM)
        this._listeners.onAddListener = map.getLayers().on("add", function (evt) {
            var layer = evt.element;
            var id;
            // on attribue un nouvel identifiant à cette couche,
            // sauf si c'est une couche qui a déjà été ajoutée dans le LayerSwitcher au préalable (si gpLayerId existe)
            if (!layer.hasOwnProperty("gpLayerId")) {
                id = this._layerId;
                layer.gpLayerId = id;
                this._layerId++;
            } else {
                id = layer.gpLayerId;
            }
            if (!this._layers[id]) {
                this.addLayer(layer);
            }
        }, this);

        // add event listeners when a layer is removed from map, to remove it from LayerSwitcher control (and DOM)
        this._listeners.onRemoveListener = map.getLayers().on("remove", function (evt) {
            var layer = evt.element;
            var id = layer.gpLayerId;
            if (this._layers[id]) {
                this.removeLayer(layer);
            }
        }, this);
    } else {
        // we are in a setMap(null) case
        // we forget the listeners linked to the layerSwitcher
        _ol2.default.Observable.unByKey(this._listeners.onMoveListener);
        _ol2.default.Observable.unByKey(this._listeners.onAddListener);
        _ol2.default.Observable.unByKey(this._listeners.onRemoveListener);

        // we put all the layers at Zindex = 0, without changing the visual order
        // in order that the next added layers are not hidden by layers with Zindex > 0
        for (var i = this._layersOrder.length - 1; i >= 0; i--) {
            this._layersOrder[i].layer.setZIndex(0);
        }
    }

    // on appelle la méthode setMap originale d'OpenLayers
    _ol2.default.control.Control.prototype.setMap.call(this, map);
};

/**
 * Add a new layer to control (when added to map) or add new layer configuration
 *
 * @param {ol.layer.Layer} layer - layer to add to layer switcher
 * @param {Object} [config] - additional options for layer configuration
 * @param {Object} [config.title] - layer title (default is layer identifier)
 * @param {Object} [config.description] - layer description (default is null)
 * @param {Object} [config.legends] - layer legends (default is an empty array)
 * @param {Object} [config.metadata] - layer metadata (default is an empty array)
 * @param {Object} [config.quicklookUrl] - layer quicklookUrl (default is null)
 * @example
 *   layerSwitcher.addLayer(
 *       gpParcels,
 *       {
 *           title : "Parcelles cadastrales",
 *           description : "description de la couche",
 *           quicklookUrl : "http://quicklookUrl.fr"
 *       }
 *   )
 */
LayerSwitcher.prototype.addLayer = function (layer, config) {
    var map = this.getMap();
    config = config || {};

    if (!layer) {
        logger.log("[ERROR] LayerSwitcher:addLayer - missing layer parameter");
        return;
    }

    var id = layer.gpLayerId;
    if (id === "undefined") {
        logger.log("[ERROR] LayerSwitcher:addLayer - configuration cannot be set for " + layer + " layer (layer id not found)");
        return;
    }

    // make sure layer is in map layers
    var isLayerInMap = false;
    map.getLayers().forEach(function (lyr) {
        if (lyr.gpLayerId === id) {
            isLayerInMap = true;
        }
    }, this);
    if (!isLayerInMap) {
        logger.log("[ERROR] LayerSwitcher:addLayer - configuration cannot be set for ", layer, " layer (layer is not in map.getLayers() )");
        return;
    }

    // if layer is not already in layers list, add it to control (layers list and container div)
    if (!this._layers[id]) {
        // 1. add layer to layers list
        var layerInfos = this.getLayerInfo(layer) || {};
        var opacity = layer.getOpacity();
        var visibility = layer.getVisible();
        var isInRange = this.isInRange(layer, map);
        var layerOptions = {
            layer: layer,
            id: id,
            opacity: opacity != null ? opacity : 1,
            visibility: visibility != null ? visibility : true,
            inRange: isInRange != null ? isInRange : true,
            title: config.title != null ? config.title : layerInfos._title || id,
            description: config.description || layerInfos._description || null,
            legends: config.legends || layerInfos._legends || [],
            metadata: config.metadata || layerInfos._metadata || [],
            quicklookUrl: config.quicklookUrl || layerInfos._quicklookUrl || null
        };
        this._layers[id] = layerOptions;

        // 2. create layer div (to be added to control main container)
        // Création de la div correspondante à cette couche
        var layerDiv = this._createLayerDiv(layerOptions);
        // on stocke la div dans les options de la couche, pour une éventuelle réorganisation (setZIndex par ex)
        this._layers[id].div = layerDiv;

        // 3. réorganisation des couches si un zIndex est spécifié
        if (layer.getZIndex && layer.getZIndex() !== 0 || layer._forceNullzIndex) {
            // réorganisation des couches si un zIndex est spécifié
            this._updateLayersOrder(map);
        } else {
            // sinon on ajoute la couche au dessus des autres
            this._layersOrder.unshift(layerOptions);
            this._lastZIndex++;
            layer.setZIndex(this._lastZIndex);
            this._layerListContainer.insertBefore(layerDiv, this._layerListContainer.firstChild);
        }

        // 3. Add listeners for opacity and visibility changes
        layer.on("change:opacity", this._updateLayerOpacity, this);
        layer.on("change:visible", this._updateLayerVisibility, this);
        // listener for zIndex change
        var context = this;
        // fonction de callback appelée au changement de zindex d'une couche
        var updateLayersOrder = function updateLayersOrder(e) {
            context._updateLayersOrder(e);
        };
        if (this._layers[id].onZIndexChangeEvent == null) {
            this._layers[id].onZIndexChangeEvent = layer.on("change:zIndex", updateLayersOrder);
        }

        // user may also add a new configuration for an already added layer
    } else if (this._layers[id] && config) {
        // add new configuration parameters to layer informations
        for (var prop in config) {
            if (config.hasOwnProperty(prop)) {
                this._layers[id][prop] = config[prop];
            }
        }
        // set new title in layer div
        if (config.title) {
            var nameDiv = document.getElementById(this._addUID("GPname_ID_" + id));
            if (nameDiv) {
                nameDiv.innerHTML = config.title;
                nameDiv.title = config.description || config.title;
            }
        }
        // add layer info picto if necessary
        var infodiv = document.getElementById(this._addUID("GPinfo_ID_" + id));
        if (!document.getElementById(this._addUID("GPinfo_ID_" + id)) && config.description) {
            var advancedTools = document.getElementById(this._addUID("GPadvancedTools_ID_" + id));
            if (advancedTools) {
                advancedTools.appendChild(this._createAdvancedToolInformationElement({
                    id: id
                }));
            }
        }
        // close layer info element if open, to update information.
        if (infodiv && infodiv.className === "GPlayerInfoOpened") {
            document.getElementById(this._addUID("GPlayerInfoPanel")).className = "GPlayerInfoPanelClosed";
            infodiv.className = "GPlayerInfo";
        }
    }
};

/**
 * Remove a layer from control
 *
 * @param {ol.layer.Layer} layer - layer.
 * @deprecated on the future version ...
 */
LayerSwitcher.prototype.removeLayer = function (layer) {
    if (!layer) {
        return;
    }

    layer.un("change:opacity", this._updateLayerOpacity, this);
    layer.un("change:visible", this._updateLayerVisibility, this);
    // FIXME !?
    layer.un("change:zIndex", this._updateLayersOrder, this);

    // logger.trace(layer);

    var layerID = layer.gpLayerId;
    var layerList = document.getElementById(this._addUID("GPlayersList"));
    // close layer info element if open.
    var infodiv = document.getElementById(this._addUID("GPinfo_ID_" + layerID));
    if (infodiv && infodiv.className === "GPlayerInfoOpened") {
        document.getElementById(this._addUID("GPlayerInfoPanel")).className = "GPlayerInfoPanelClosed";
        infodiv.className = "GPlayerInfo";
    }
    // remove layer div
    var layerDiv = document.getElementById(this._addUID("GPlayerSwitcher_ID_" + layerID));
    if (layerDiv) {
        layerList.removeChild(layerDiv);
    }

    var layerIndex = Math.abs(layer.getZIndex() - this._lastZIndex);
    // on retire la couche de la liste ordonnée des layers
    this._layersOrder.splice(layerIndex, 1);
    this._lastZIndex--;
    // on met à jour les zindex des couches restantes
    var layerOrderTemp = this._layersOrder;
    for (var i = 0; i < layerOrderTemp.length; i++) {
        layerOrderTemp[i].layer.setZIndex(this._lastZIndex - i);
    }
    // on retire la couche de la liste des layers
    delete this._layers[layerID];
};

/**
 * Collapse or display control main container
 *
 * @param {Boolean} collapsed - True to collapse control, False to display it
 */
LayerSwitcher.prototype.setCollapsed = function (collapsed) {
    if (collapsed === undefined) {
        logger.log("[ERROR] LayerSwitcher:setCollapsed - missing collapsed parameter");
        return;
    }
    var isCollapsed = !document.getElementById(this._addUID("GPshowLayersList")).checked;
    if (collapsed && isCollapsed || !collapsed && !isCollapsed) {
        return;
    }
    // on simule l'ouverture du panneau après un click
    if (!isCollapsed) {
        var layers = document.getElementsByClassName("GPlayerInfoOpened");
        for (var i = 0; i < layers.length; i++) {
            layers[i].className = "GPlayerInfo";
        }
        document.getElementById(this._addUID("GPlayerInfoPanel")).className = "GPlayerInfoPanelClosed";
    }
    document.getElementById(this._addUID("GPshowLayersList")).checked = !collapsed;
};

/**
 * Returns true if widget is collapsed (minimize), false otherwise
 * @returns {Boolean} is collapsed
 */
LayerSwitcher.prototype.getCollapsed = function () {
    return this.collapsed;
};

/**
 * Display or hide removeLayerPicto from layerSwitcher for this layer
 *
 * @param {ol.layer.Layer} layer - ol.layer to be configured
 * @param {Boolean} removable - specify if layer can be remove from layerSwitcher (true) or not (false). Default is true
 */
LayerSwitcher.prototype.setRemovable = function (layer, removable) {
    if (!layer) {
        return;
    }
    var layerID = layer.gpLayerId;
    if (layerID == null) {
        // on teste si layerID est null ou undefined
        logger.log("[LayerSwitcher:setRemovable] layer should be added to map before calling setRemovable method");
        return;
    }
    var removalDiv = document.getElementById(this._addUID("GPremove_ID_" + layerID));
    logger.log(removalDiv.style.display);
    if (removalDiv) {
        if (removable === false) {
            removalDiv.style.display = "none";
        } else if (removable === true) {
            removalDiv.style.display = "block";
        } else {}
    }
};

// ################################################################### //
// ##################### init component ############################## //
// ################################################################### //

/**
 * Initialize LayerSwitcher control (called by constructor)
 *
 * @param {Object} options - ol.control.Control options (see {@link http://openlayers.org/en/latest/apidoc/ol.control.Control.html ol.control.Control})
 * @param {Array} layers - list of layers to be configured. Each array element is an object, with following properties :
 * @private
 */
LayerSwitcher.prototype._initialize = function (options, layers) {
    // identifiant du contrôle : utile pour suffixer les identifiants CSS (pour gérer le cas où il y en a plusieurs dans la même page)
    this._uid = _SelectorID2.default.generate();

    // {Object} control layers list. Each key is a layer id, and its value is an object of layers options (layer, id, opacity, visibility, title, description...)
    this._layers = {};
    // [Array] array of ordered control layers
    this._layersOrder = [];
    // [Object] associative array of layers ordered by zindex (keys are zindex values, and corresponding values are arrays of layers at this zindex)
    this._layersIndex = {};
    // {Number} layers max z index, to order layers using their z index
    this._lastZIndex = 0;
    // {Number} layers max id, incremented when a new layer is added
    this._layerId = 0;
    /** {Boolean} true if widget is collapsed, false otherwise */
    this.collapsed = options.collapsed !== undefined ? options.collapsed : true;
    // div qui contiendra les div des listes.
    this._layerListContainer = null;
    // [Object] listeners added to the layerSwitcher saved here in order to delete them if we remove the control from the map)
    this._listeners = {};

    // add options layers to layerlist.
    // (seulement les couches configurées dans les options du layerSwitcher par l'utilisateur),
    // les autres couches de la carte seront ajoutées dans la méthode setMap
    for (var i = 0; i < layers.length; i++) {
        // recup la layer, son id,
        var layer = layers[i].layer;
        if (layer) {
            var id;
            // si elles ont déjà un identifiant (gpLayerId), on le récupère, sinon on en crée un nouveau, en incrémentant this_layerId.
            if (!layer.hasOwnProperty("gpLayerId")) {
                id = this._layerId;
                layer.gpLayerId = id;
                this._layerId++;
            } else {
                id = layer.gpLayerId;
            }

            // et les infos de la conf si elles existent (title, description, legends, quicklook, metadata)
            var conf = layers[i].config || {};
            var opacity = layer.getOpacity();
            var visibility = layer.getVisible();
            var layerOptions = {
                layer: layer, // la couche ol.layer concernée
                id: id,
                opacity: opacity != null ? opacity : 1,
                visibility: visibility != null ? visibility : true,
                title: conf.title != null ? conf.title : id,
                description: conf.description || null,
                legends: conf.legends || [],
                metadata: conf.metadata || [],
                quicklookUrl: conf.quicklookUrl || null
            };
            this._layers[id] = layerOptions;
        }
    }
};

/**
 * Create control main container (called by constructor)
 *
 * @returns {DOMElement} container - control container
 * @private
 */
LayerSwitcher.prototype._initContainer = function () {
    // creation du container principal
    var container = this._createMainContainerElement();

    // ajout dans le container principal d'affichage des layers
    var input = this._createMainLayersShowElement();
    container.appendChild(input);

    // gestion du mode "collapsed"
    if (!this.collapsed) {
        input.checked = "checked";
        this.collapsed = false;
    } else {
        this.collapsed = true;
    }

    // on ajoute un écouteur d'évènement sur le bouton (checkbox) de dépliement/repliement des couches,
    // pour modifier la propriété this.collapsed quand on clique dessus
    var context = this;
    // event listener
    var changeCollapsed = function changeCollapsed(e) {
        this.collapsed = !e.target.checked;
        // on génère nous même l'evenement OpenLayers de changement de pté
        // (utiliser layerSwitcher.on("change:collapsed", function ) pour s'abonner à cet évènement)
        this.dispatchEvent("change:collapsed");
    };
    input.addEventListener("click", function (e) {
        changeCollapsed.call(context, e);
    });

    // ajout dans le container principal de la liste des layers
    var divL = this._layerListContainer = this._createMainLayersElement();
    container.appendChild(divL);

    // creation du mode draggable
    this._createDraggableElement(divL, this);

    // ajout dans le container principal du picto du controle
    var picto = this._createMainPictoElement();
    container.appendChild(picto);

    // ajout dans le container principal du panneau d'information
    var divI = this._createMainInfoElement();
    container.appendChild(divI);

    return container;
};

/**
 * Add all map layers to control main container
 *
 * @param {Object} map - ol.Map object, to which control is added
 * @private
 */
LayerSwitcher.prototype._addMapLayers = function (map) {
    this._layersIndex = {};
    var context = this;

    // on parcourt toutes les couches de la carte, pour les ajouter à la liste du controle si ce n'est pas déjà le cas.
    // idée : le layerSwitcher doit représenter l'ensemble des couches de la carte.
    map.getLayers().forEach(function (layer) {
        // ajout des couches de la carte à la liste
        var id;
        // si elles ont déjà un identifiant (gpLayerId), on le récupère, sinon on en crée un nouveau, en incrémentant this_layerId.
        if (!layer.hasOwnProperty("gpLayerId")) {
            id = this._layerId;
            layer.gpLayerId = id;
            this._layerId++;
        } else {
            id = layer.gpLayerId;
        }

        var layerInfos = this.getLayerInfo(layer) || {};
        if (!this._layers[id]) {
            // si la couche n'est pas encore dans la liste des layers (this._layers), on l'ajoute
            var opacity = layer.getOpacity();
            var visibility = layer.getVisible();
            var isInRange = this.isInRange(layer, map);
            var layerOptions = {
                layer: layer,
                id: id,
                opacity: opacity != null ? opacity : 1,
                visibility: visibility != null ? visibility : true,
                inRange: isInRange != null ? isInRange : true,
                title: layerInfos._title || id,
                description: layerInfos._description || null,
                legends: layerInfos._legends || [],
                metadata: layerInfos._metadata || [],
                quicklookUrl: layerInfos._quicklookUrl || null
            };
            this._layers[id] = layerOptions;
        } else {
            // si elle existe déjà, on met à jour ses informations (visibility, opacity, inRange)
            this._layers[id].opacity = layer.getOpacity();
            this._layers[id].visibility = layer.getVisible();
            this._layers[id].inRange = this.isInRange(layer, map);
        }

        // Ajout de listeners sur les changements d'opacité, visibilité
        layer.on("change:opacity", this._updateLayerOpacity, this);
        layer.on("change:visible", this._updateLayerVisibility, this);

        // récupération des zindex des couches s'ils existent, pour les ordonner.
        var layerIndex = null;
        if (layer.getZIndex !== undefined) {
            layerIndex = layer.getZIndex();
            if (!this._layersIndex[layerIndex] || !Array.isArray(this._layersIndex[layerIndex])) {
                this._layersIndex[layerIndex] = [];
            }
            this._layersIndex[layerIndex].push(this._layers[id]);
        };
    }, this);

    // on récupère l'ordre d'affichage des couches entre elles dans la carte, à partir de zindex.
    // fonction de callback appelée au changement de zindex d'une couche
    var updateLayersOrder = function updateLayersOrder(e) {
        context._updateLayersOrder(e);
    };
    for (var zindex in this._layersIndex) {
        if (this._layersIndex.hasOwnProperty(zindex)) {
            var layers = this._layersIndex[zindex];
            for (var l = 0; l < layers.length; l++) {
                // à ce stade layers[l] est une couche de this._layers.
                // on conserve l'ordre des couches : la première est celle qui se situe tout en haut, et la dernière est le "fond de carte"
                this._layersOrder.unshift(layers[l]);
                // et on réordonne les couches avec des zindex, uniques.
                this._lastZIndex++;
                layers[l].layer.setZIndex(this._lastZIndex);
                if (this._layers[layers[l].layer.gpLayerId].onZIndexChangeEvent == null) {
                    this._layers[layers[l].layer.gpLayerId].onZIndexChangeEvent = layers[l].layer.on("change:zIndex", updateLayersOrder);
                }
            }
        }
    }

    // on ajoute les div correspondantes aux différentes couches (dans l'ordre inverse d'affichage) dans le controle.
    for (var j = 0; j < this._layersOrder.length; j++) {
        var layerOptions = this._layersOrder[j];
        var layerDiv = this._createLayerDiv(layerOptions);
        this._layerListContainer.appendChild(layerDiv);
        // on stocke la div dans les options de la couche, pour une éventuelle réorganisation (setZIndex par ex)
        this._layers[layerOptions.id].div = layerDiv;
    }
};

/**
 * create layer div (to append to control DOM element).
 *
 * @param {Object} layerOptions - layer options (id, title, description, legends, metadata, quicklookUrl ...)
 *
 * @returns {DOMElement} DOM element
 *
 * @private
 */
LayerSwitcher.prototype._createLayerDiv = function (layerOptions) {
    var isLegends = layerOptions.legends && layerOptions.legends.length !== 0;
    var isMetadata = layerOptions.metadata && layerOptions.metadata.length !== 0;
    var isQuicklookUrl = layerOptions.quicklookUrl;
    // on n'affiche les informations que si elles sont renseignées (pour ne pas avoir un panneau vide)
    if (isLegends || isMetadata || isQuicklookUrl) {
        layerOptions.displayInformationElement = true;
    }

    // ajout d'une div pour cette layer dans le control
    var layerDiv = this._createContainerLayerElement(layerOptions);

    if (!layerOptions.inRange) {
        layerDiv.classList.add("outOfRange");
    }

    return layerDiv;
};

// ################################################################### //
// ######################### DOM events ############################## //
// ################################################################### //

/**
 * Change layer opacity on layer opacity picto click
 *
 * @param {Object} e - event
 * @private
 */
LayerSwitcher.prototype._onChangeLayerOpacity = function (e) {
    var divId = e.target.id; // ex GPvisibilityPicto_ID_26
    var layerID = _SelectorID2.default.index(divId); // ex. 26
    var layer = this._layers[layerID].layer;

    var opacityValue = e.target.value;
    var opacityId = document.getElementById(this._addUID("GPopacityValue_ID_" + layerID));
    opacityId.innerHTML = opacityValue + "%";

    layer.setOpacity(opacityValue / 100);
};

/**
 * Update picto opacity value on layer opacity change
 *
 * @param {Object} e - event
 * @private
 */
LayerSwitcher.prototype._updateLayerOpacity = function (e) {
    var opacity = e.target.getOpacity();
    if (opacity > 1) {
        opacity = 1;
    }
    if (opacity < 0) {
        opacity = 0;
    }
    var id = e.target.gpLayerId;

    var layerOpacityInput = document.getElementById(this._addUID("GPopacityValueDiv_ID_" + id));
    if (layerOpacityInput) {
        layerOpacityInput.value = Math.round(opacity * 100);
    }

    var layerOpacitySpan = document.getElementById(this._addUID("GPopacityValue_ID_" + id));
    if (layerOpacitySpan) {
        layerOpacitySpan.innerHTML = Math.round(opacity * 100) + "%";
    }
};

/**
 * Change layer visibility on layer visibility picto click
 *
 * @param {Object} e - event
 * @private
 */
LayerSwitcher.prototype._onVisibilityLayerClick = function (e) {
    var divId = e.target.id; // ex GPvisibilityPicto_ID_26
    var layerID = _SelectorID2.default.index(divId); // ex. 26
    var layer = this._layers[layerID].layer;

    layer.setVisible(e.target.checked);
};

/**
 * Change picto visibility on layer visibility change
 *
 * @param {Object} e - event
 * @private
 */
LayerSwitcher.prototype._updateLayerVisibility = function (e) {
    var visible = e.target.getVisible();
    var id = e.target.gpLayerId;
    var layerVisibilityInput = document.getElementById(this._addUID("GPvisibility_ID_" + id));
    if (layerVisibilityInput) {
        layerVisibilityInput.checked = visible;
    }
};

/**
 * Change layers order in layerswitcher (control container) on a layer index change (on map) or when a layer is added to a specific zindex
 *
 * @private
 */
LayerSwitcher.prototype._updateLayersOrder = function () {
    // info :
    // 1. on récupère les zindex et les couches associées dans un tableau associatif (objet)
    // 2. on réordonne les couche selon leur index : on leur attribue de nouveaux zindex uniques
    // 3. on vide le container des layers, et rajoute les div des couches dans l'ordre décroissant des zindex

    var map = this.getMap();
    if (!map) {
        return;
    }
    this._layersIndex = {};
    var layerIndex;
    var id;

    // on parcourt toutes les couches pour récupérer leur ordre :
    // on stocke les couches dans un tableau associatif ou les clés sont les zindex, et les valeurs sont des tableaux des couches à ce zindex.
    map.getLayers().forEach(function (layer) {
        id = layer.gpLayerId;

        // on commence par désactiver temporairement l'écouteur d'événements sur le changement de zindex.
        _ol2.default.Observable.unByKey(this._layers[id].onZIndexChangeEvent);
        this._layers[id].onZIndexChangeEvent = null;

        // on ajoute la couche dans le tableau (de l'objet this._layersIndex) correspondant à son zindex
        layerIndex = null;
        if (layer.getZIndex !== undefined) {
            layerIndex = layer.getZIndex();
            if (!this._layersIndex[layerIndex] || !Array.isArray(this._layersIndex[layerIndex])) {
                this._layersIndex[layerIndex] = [];
            }
            this._layersIndex[layerIndex].push(this._layers[id]);
        };
    }, this);

    // on réordonne les couches entre elles dans la carte, à partir des zindex stockés ci-dessus.
    this._lastZIndex = 0;
    var context = this;
    // fonction de callback appelée au changement de zindex d'une couche
    var updateLayersOrder = function updateLayersOrder(e) {
        context._updateLayersOrder(e);
    };
    this._layersOrder = [];
    for (var zindex in this._layersIndex) {
        if (this._layersIndex.hasOwnProperty(zindex)) {
            var layers = this._layersIndex[zindex];
            for (var l = 0; l < layers.length; l++) {
                // à ce stade layers[l] est une couche de this._layers.
                // on conserve l'ordre des couches : la première est celle qui se situe tout en haut, et la dernière est le "fond de carte"
                this._layersOrder.unshift(layers[l]);
                // et on réordonne les couches avec des zindex, uniques.
                this._lastZIndex++;
                // layers[l].layer.setZIndex(lastZIndex);
                // et on réactive l'écouteur d'événement sur les zindex
                if (this._layers[layers[l].layer.gpLayerId].onZIndexChangeEvent == null) {
                    this._layers[layers[l].layer.gpLayerId].onZIndexChangeEvent = layers[l].layer.on("change:zIndex", updateLayersOrder);
                }
            }
        }
    }

    if (this._layerListContainer) {
        // on vide le container précédent
        while (this._layerListContainer.firstChild) {
            this._layerListContainer.removeChild(this._layerListContainer.firstChild);
        }
        // et on rajoute les div correspondantes aux différentes couches, dans l'ordre décroissant des zindex
        for (var j = 0; j < this._layersOrder.length; j++) {
            var layerOptions = this._layersOrder[j];
            this._layerListContainer.appendChild(layerOptions.div);
        }
    } else {
        logger.log("[ol.control.LayerSwitcher] _updateLayersOrder : layer list container not found to update layers order ?!");
    }
};

/**
 * Open layer information panel on picto click
 *
 * @param {Event} e - MouseEvent
 * @private
 */
LayerSwitcher.prototype._onOpenLayerInfoClick = function (e) {
    var divId = e.target.id; // ex GPvisibilityPicto_ID_26
    var layerID = _SelectorID2.default.index(divId); // ex. 26
    var layerOptions = this._layers[layerID];

    var panel;
    var info;

    // Close layer info panel
    divId = document.getElementById(e.target.id);
    if (divId.className === "GPlayerInfoOpened") {
        if (divId.classList !== undefined) {
            divId.classList.remove("GPlayerInfoOpened");
            divId.classList.add("GPlayerInfo");
        }

        panel = document.getElementById(this._addUID("GPlayerInfoPanel"));
        if (panel.classList !== undefined) {
            panel.classList.remove("GPpanel");
            panel.classList.remove("GPlayerInfoPanelOpened");
            panel.classList.add("GPlayerInfoPanelClosed");
        }

        info = document.getElementById(this._addUID("GPlayerInfoContent"));
        panel.removeChild(info);
        return;
    }

    var layers = document.getElementsByClassName("GPlayerInfoOpened");
    for (var i = 0; i < layers.length; i++) {
        layers[i].className = "GPlayerInfo";
    }

    // Open layer info panel
    if (divId.classList !== undefined) {
        divId.classList.remove("GPlayerInfo");
        divId.classList.add("GPlayerInfoOpened");
    }

    panel = document.getElementById(this._addUID("GPlayerInfoPanel"));
    if (panel.classList !== undefined) {
        panel.classList.add("GPpanel");
        panel.classList.remove("GPlayerInfoPanelClosed");
        panel.classList.add("GPlayerInfoPanelOpened");
    }

    info = document.getElementById(this._addUID("GPlayerInfoContent"));
    if (info) {
        panel.removeChild(info);
    }

    // on récupère les infos associées au layer pour mettre dynamiquement le contenu du panel d'informations
    var obj = {
        title: layerOptions.title,
        description: layerOptions.description,
        quicklookUrl: layerOptions.quicklookUrl,
        metadata: layerOptions.metadata,
        legends: layerOptions.legends
    };
    // get layer max scale denominator
    var maxResolution = layerOptions.layer.getMaxResolution();
    if (maxResolution === Infinity) {
        obj._maxScaleDenominator = 560000000;
    } else {
        obj._maxScaleDenominator = Math.round(maxResolution / 0.00028);
    }
    var infoLayer = this._createContainerLayerInfoElement(obj);
    panel.appendChild(infoLayer);
};

/**
 * remove layer from layer switcher and map on picto click
 *
 * @param {Event} e - MouseEvent
 * @private
 */
LayerSwitcher.prototype._onDropLayerClick = function (e) {
    var divId = e.target.id; // ex GPvisibilityPicto_ID_26
    var layerID = _SelectorID2.default.index(divId); // ex. 26
    var layer = this._layers[layerID].layer;

    // le retrait de la couche va déclencher l'ecouteur d'évenement,
    // et appeler this.removeLayer qui va supprimer la div.
    this.getMap().getLayers().remove(layer);
};

/**
 * change layers order (on map) on drag and drop (on control container)
 *
 * @private
 */
LayerSwitcher.prototype._onDragAndDropLayerClick = function () {
    // INFO : e.oldIndex et e.newIndex marchent en mode AMD mais pas Bundle.
    var map = this.getMap();
    var context = this;
    // fonction de callback appelée au changement de zindex d'une couche
    var updateLayersOrder = function updateLayersOrder(e) {
        context._updateLayersOrder(e);
    };

    // on récupère l'ordre des div dans le contrôle pour réordonner les couches (avec zindex)
    var matchesLayers = document.querySelectorAll("div.GPlayerSwitcher_layer");
    var maxZIndex = matchesLayers.length;
    // on vide la liste ordonnée avant de la remplir avec l'ordre des couches selon les div.
    this._layersOrder = [];
    for (var i = 0; i < matchesLayers.length; i++) {
        var tag = matchesLayers[i].id;
        var id = _SelectorID2.default.index(tag);
        var layer = this._layers[id].layer;

        // on commence par désactiver temporairement l'écouteur d'événements sur le changement de zindex.
        _ol2.default.Observable.unByKey(this._layers[id].onZIndexChangeEvent);
        this._layers[id].onZIndexChangeEvent = null;

        if (layer.setZIndex) {
            // maxZIndex--;
            layer.setZIndex(maxZIndex);
            this._layersOrder.push(this._layers[id]);
            maxZIndex--;
        }

        // et on réactive l'écouteur d'événement sur les zindex
        if (this._layers[id].onZIndexChangeEvent == null) {
            this._layers[id].onZIndexChangeEvent = layer.on("change:zIndex", updateLayersOrder);
        }
    }

    // mise à jour de la visu
    map.updateSize();
};

/**
 * check layers range on map movement
 *
 * @param {ol.Map} map - ol map on which event occured
 * @private
 */
LayerSwitcher.prototype._onMapMoveEnd = function (map) {
    // pour chaque couche de la map, on vérifie qu'elle soit toujours dans la visu (inRange)
    map.getLayers().forEach(function (layer) {
        var id = layer.gpLayerId;
        if (this._layers[id]) {
            var layerOptions = this._layers[id];

            // Check if layer is out of range.
            var layerDiv;
            if (this.isInRange(layer, map) && !layerOptions.inRange) {
                layerOptions.inRange = true;
                layerDiv = document.getElementById(this._addUID("GPlayerSwitcher_ID_" + id));
                layerDiv.classList.remove("outOfRange");
            } else if (!this.isInRange(layer, map) && layerOptions.inRange) {
                layerOptions.inRange = false;
                layerDiv = document.getElementById(this._addUID("GPlayerSwitcher_ID_" + id));
                layerDiv.classList.add("outOfRange");
            }
        }
    }, this);
};

// ################################################################### //
// ############################ Utils ################################ //
// ################################################################### //

/**
 * Returns Layer Container Id associated with given olLayer
 *
 * @param {ol.layer.Layer} olLayer - ol layer object
 * @returns {String} - div container Id ; null if layer not found.
 */
LayerSwitcher.prototype.getLayerDOMId = function (olLayer) {
    var foundId = null;

    this.getMap().getLayers().forEach(function (layer) {
        if (layer == olLayer) {
            // FIXME object comparison
            foundId = layer.hasOwnProperty("gpLayerId") ? layer.gpLayerId : null;
        }
    }, this);

    // TODO : recuperer "GPlayerSwitcher_ID" depuis une constante
    return foundId !== null ? this._addUID("GPlayerSwitcher_ID_" + foundId) : null;
};

/**
 * Check if map view is out of layer range (in terms of extent and zoom)
 *
 * @method isInRange
 * @param {Object} layer - the ol.layer object
 * @param {Object} map   - the ol.Map object
 * @returns {Boolean} outOfRange - false if map view is out of layer range
 */
LayerSwitcher.prototype.isInRange = function (layer, map) {
    if (!map) {
        return;
    }
    // check if map zoom is in layer zoom range
    var mapResolution = map.getView().getResolution();
    if (mapResolution > layer.getMaxResolution() || mapResolution < layer.getMinResolution()) {
        return false;
    }

    // check if map extent intersects layer extent (if defined)
    var mapExtent = map.getView().calculateExtent(map.getSize());
    var layerExtent = layer.getExtent();
    if (layerExtent && !_ol2.default.extent.intersects(mapExtent, layerExtent)) {
        return false;
    }

    return true;
};

/**
 * Get layer informations : title, description, quicklookurl, legends, metadata
 *
 * @method getLayerInfo
 * @param {Object} layer - the ol.layer object
 * @returns {Object} layerInfo - layer informations
 */
LayerSwitcher.prototype.getLayerInfo = function (layer) {
    var layerInfo = {};
    if (layer.getSource !== undefined) {
        var src = layer.getSource();
        layerInfo._title = src._title || "";
        layerInfo._description = src._description || "";
        layerInfo._quicklookUrl = src._quicklookUrl || "";
        layerInfo._metadata = src._metadata || [];
        layerInfo._legends = src._legends || [];
    }
    return layerInfo;
};

exports.default = LayerSwitcher;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Config = __webpack_require__(8);

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    /**
     * Contrôle des droits sur les ressources.
     *
     * @param {Object} options - liste des options
     * @param {String} options.key - clef API
     * @param {Array} options.resources - liste des ressources
     * @param {Array} options.services - liste des services
     * @returns {Object} rightManagement - undefined ou {
     *       key : "",
     *       service-1 : [resource-1, resource-2],
     *       service-2 : [resource-1, resource-2]
     * }
     */
    check: function check(options) {
        // logger

        var logger = _LoggerByDefault2.default.getLogger("checkrightmanagement");

        // si aucune option n'est renseignée...
        if (!options) {
            // message orienté pour le developpeur !
            logger.error("WARNING : " + "no parameter specified !");
            return;
        }

        // les options
        var _key = options.key;
        var _resources = options.resources || [];
        var _services = options.services || [];

        // si aucune information sur les ressources,
        // il est impossible de controler quelquechose !!!
        if (!_resources || _resources.length === 0) {
            // message orienté pour le developpeur !
            logger.error("WARNING : " + "no parameter 'resources' specified !");
            return;
        }

        // si aucune information sur les services,
        // il est impossible de controler quelquechose !!!
        if (!_services || _services.length === 0) {
            // message orienté pour le developpeur !
            logger.error("WARNING : " + "no parameter 'services' specified !");
            return;
        }

        // les ressources controlées :
        // Ex.
        // {
        //   "Itineraire"     : ["Pieton", "Voiture"],
        //   "Geocode"        : ["PositionOfInterest", "StreetAddress", "CadastralParcel", "Administratif"],
        //   "AutoCompletion" : ["PositionOfInterest", "StreetAddress", "CadastralParcel", "Administratif"],
        //   "Elevation"      : ["SERVICE_CALCUL_ALTIMETRIQUE_RSC"]
        // }
        var _rightManagement = {};

        // la clef API n'est pas renseignée
        if (!_key) {
            // on verifie si l'autoconfiguration est disponible

            if (!_Config2.default.isConfigLoaded()) {
                // si l'autoconfiguration n'est pas chargée,
                // aucune vérification des droits est possible...

                logger.warn("WARNING : " + "The 'apiKey' parameter is missing, " + "and the contract key configuration has not been loaded, " + "so impossible to check yours rights !");

                return;
            } else {
                // si l'autoconfiguration est chargée,
                // on recupere la clef API, et on en profitera ensuite pour controler
                // les droits sur les ressources.

                // FIXME par defaut, on recupere toujours la première...
                _key = Object.keys(_Config2.default.configuration.generalOptions.apiKeys)[0];
                logger.log(_key);
            }
        }

        // la clef API est renseignée ou recuperée de l'autoconfiguration
        if (_key) {
            // on verifie si l'autoconfiguration est disponible

            if (!_Config2.default.isConfigLoaded()) {
                // si l'autoconfiguration n'est pas chargée,
                // il est toujours possible de requeter le service avec une clef API,
                // mais les droits sur les ressources ne sont pas garantis, on risque
                // d'obtenir des erreurs 403 forbidden...
                // la responsabilité revient à l'utilisateur (message d'information)...

                logger.warn("WARNING : " + "the contract key configuration has not been loaded, " + "so be carefull !");

                // les ressouces non controlées
                var _noRightManagement = {};

                for (var i = 0; i < _services.length; i++) {
                    var service = _services[i];
                    _noRightManagement[service] = [];

                    for (var j = 0; j < _resources.length; j++) {
                        var resource = _resources[j];
                        _noRightManagement[service].push(resource);
                    }
                }

                // on ajoute la clef
                _noRightManagement.key = _key;

                logger.log("right management not checked", _noRightManagement);

                return _noRightManagement;
            } else {
                // si l'autoconf est chargée,
                // on verifie la correspondance entre la clef et l'autoconfiguration,
                // on previent l'utilisateur (message d'information) s'il n'a
                // pas de droits sur certaines ressources ...

                // doit on ecarter les ressources sans droit ?
                // oui, si possible avec un message d'information pour l'utilisateur...

                for (var k = 0; k < _resources.length; k++) {
                    var _resource = _resources[k];

                    for (var l = 0; l < _services.length; l++) {
                        var _service = _services[l];

                        var params = _Config2.default.getServiceParams(_resource, _service, _key);
                        if (!params || Object.keys(params).length === 0) {
                            logger.warn("WARNING : " + "The contract key configuration has no rights to load this geoportal " + "resource (" + _resource + ") " + "for this service (" + _service + ") ");
                            continue;
                        }

                        if (!_rightManagement[_service]) {
                            _rightManagement[_service] = [];
                        }

                        _rightManagement[_service].push(_resource);
                    }
                }

                if (!_rightManagement || Object.keys(_rightManagement).length === 0) {
                    logger.warn("WARNING : " + "The contract key configuration has been loaded, " + "and the 'apiKey' parameter has been set, " + "but, there is a problem on the mapping between the contract and the key !");
                    return;
                }

                // on ajoute la clef
                _rightManagement.key = _key;

                logger.log("right management checked", _rightManagement);

                return _rightManagement;
            }
        }
    }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("config");

var Config = {

    /** autoconf */
    configuration: null,

    /**
     * Controle du chargement de l'autoconf
     *
     * @returns {Boolean} isConfigLoaded - True si l'autoconf a déjà été chargée, False sinon.
     */
    isConfigLoaded: function isConfigLoaded() {
        var scope = typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : {};
        if (scope.Gp && scope.Gp.Config && Object.keys(scope.Gp.Config).length !== 0) {
            this.configuration = scope.Gp.Config;
            return true;
        }
        return false;
    },

    /**
     * Recuperation de l'identifiant d'une couche donnée
     *
     * @param {String} layerName - nom de la couche (par ex. "ORTHOIMAGERY.ORTHOPHOTOS")
     * @param {String} service   - nom du service (par ex. "WMS" ou "WMTS")
     * @returns {String} layerId - identifiant de la couche (par ex. "ORTHOIMAGERY.ORTHOPHOTOS$GEOPORTAIL:OGC:WMTS")
     */
    getLayerId: function getLayerId(layerName, service) {
        var layerId = null;

        // layer
        // key : [layerName]$[contexte]:OGC:[service]
        // ex : "ORTHOIMAGERY.ORTHOPHOTOS$GEOPORTAIL:OGC:WMTS"

        // service
        // key : [layerName]$[contexte];[service]
        // ex : PositionOfInterest$OGC:OPENLS;ReverseGeocode

        if (this.configuration) {
            var layers = this.configuration["layers"];
            for (var key in layers) {
                if (layers.hasOwnProperty(key)) {
                    var parts = key.split("$");
                    if (layerName === parts[0]) {
                        if (parts[1]) {
                            var servicePartsLayer = parts[1].split(":");
                            var servicePartsService = parts[1].split(";");

                            if (servicePartsService[1] === service) {
                                layerId = key;
                                break;
                            }
                            if (servicePartsLayer[2] === service) {
                                layerId = key;
                                break;
                            }
                        }
                    }
                }
            }
        }
        if (!layerId) {
            logger.error("ERROR layer id (layer name: " + layerName + " / service: " + service + ") was not found !?");
        }

        return layerId;
    },

    /**
     * Récupération des paramètres nécessaires à l'affichage d'une couche WMS ou WMTS
     *
     * @param {String} layerName - nom de la couche (par ex. "ORTHOIMAGERY.ORTHOPHOTOS")
     * @param {String} service   - nom du service (par ex. "WMS" ou "WMTS")
     * @param {String} [apiKey]  - Clé de contrat API
     * @returns {Object} params  - paramètres du service (WMS ou WMTS) pour la couche donnée
     * @returns {String} params.url        - Url du service à requêter pour afficher la couche
     * @returns {String} params.version    - Version du service
     * @returns {String} params.styles     - Style par défaut de la couche
     * @returns {String} params.format     - Format par défaut de la couche
     * @returns {String} params.projection - Projection par défaut de la couche
     * @returns {Number} params.minScale   - Dénominateur d'échelle minimum de la couche
     * @returns {Number} params.maxScale   - Dénominateur d'échelle maximum de la couche
     * @returns {Gp.BBox} params.extent    - Etendue de la couche, dans la projection de la couche
     * @returns {Array} params.legends     - Tableau des légendes associées à la couche
     * @returns {Array} params.metadata    - Tableau des métadonnées associées à la couche
     * @returns {Array} params.originators - Tableau des originators associés à la couche
     * @returns {Array} params.title       - Nom de la resource, lisible par un humain.
     * @returns {Array} params.description - Url de l'image d'aperçu rapide de la ressource.
     * @returns {Array} params.quicklookUrl- Tableau des originators associés à la couche
     * @returns {String} params.[TMSLink]          - Identifiant de la pyramide (TMS), dans le cas d'une couche WMTS
     * @returns {Gp.Point} params.[matrixOrigin]   - Origine de la matrice (top left corner), dans le cas d'une couche WMTS
     * @returns {Array} params.[nativeResolutions] - Tableau regroupant les résolutions de chaque niveau de la matrice, dans le cas d'une couche WMTS
     * @returns {Array} params.[matrixIds]         - Tableau regroupant les identifiants de chaque niveau de la matrice, dans le cas d'une couche WMTS
     */
    getLayerParams: function getLayerParams(layerName, service, apiKey) {
        var params = {};

        if (this.configuration) {
            // récupération de l'identifiant complet de la couche.
            var layerId = this.getLayerId(layerName, service);

            if (layerId) {
                // récupération de l'objet de configuration de la couche
                var layerConf = this.configuration.layers[layerId];

                // controle de la clef
                var key = layerConf.apiKeys[0];
                if (apiKey) {
                    if (apiKey !== key) {
                        logger.error("ERROR different keys (" + apiKey + " !== " + key + ") !?");
                        return;
                    }
                }

                apiKey = apiKey || key;
                params.key = apiKey;
                // récupération des paramètres du service
                params.url = layerConf.getServerUrl(apiKey);
                params.version = layerConf.getServiceParams().version;
                params.styles = layerConf.getDefaultStyle();
                params.format = layerConf.getDefaultFormat();
                params.projection = layerConf.getDefaultProjection();

                // récupération des infos de la couche
                params.minScale = layerConf.getMinScaleDenominator();
                params.maxScale = layerConf.getMaxScaleDenominator();
                params.extent = layerConf.getBBOX();
                params.legends = layerConf.getLegends();
                params.metadata = layerConf.getMetadata();
                params.originators = layerConf.getOriginators();
                params.title = layerConf.getTitle();
                params.description = layerConf.getDescription();
                params.quicklookUrl = layerConf.getQuicklookUrl();

                // WMTS : récupération des tileMatrixSetLimits
                if (layerConf.wmtsOptions) {
                    params.tileMatrixSetLimits = layerConf.wmtsOptions.tileMatrixSetLimits;
                }

                // WMTS : récupération des paramètres de la pyramide (TMS)
                var TMSLink = layerConf.getTMSID();
                if (TMSLink) {
                    params.TMSLink = TMSLink;
                    var tmsConf = this.configuration.getTMSConf(TMSLink);
                    // Get matrix origin : Gp.Point = Object{x:Float, y:Float}
                    params.matrixOrigin = tmsConf.getTopLeftCorner();
                    params.nativeResolutions = tmsConf.nativeResolutions;
                    params.matrixIds = tmsConf.matrixIds;
                    params.tileMatrices = tmsConf.tileMatrices;
                }
            }
        }

        return params;
    },

    /**
     * Recuperation des parametres d'un service
     *
     * @param {String} [resource] - "PositionOfInterest", "StreetAddress", "Voiture", "Pieton", ...
     * @param {String} [service] - Geocode, Itineraire, ...
     * @param {String} [apiKey]  - Clé de contrat API
     * @returns {Object} params - paramètres de la ressource
     * @returns {String} params. -
     * @returns {String} params. -
     * @returns {String} params. -
     */
    getServiceParams: function getServiceParams(resource, service, apiKey) {
        var params = {};

        if (this.configuration) {
            // récupération de l'identifiant complet de la couche.
            var layerId = this.getLayerId(resource, service);

            if (layerId) {
                // récupération de l'objet de configuration de la couche
                var layerConf = this.configuration.layers[layerId];

                // controle de la clef
                var key = layerConf.apiKeys[0];
                if (apiKey) {
                    if (apiKey !== key) {
                        return;
                    }
                }

                apiKey = apiKey || key;
                params.key = apiKey;
                // récupération des paramètres du service
                params.url = layerConf.getServerUrl(apiKey);
                params.version = layerConf.getServiceParams().version;

                // récupération des infos de la couche
                params.extent = layerConf.getBBOX();
                params.title = layerConf.getTitle();
                params.description = layerConf.getDescription();
            }
        }

        return params;
    },

    /**
     * Resolution en geographique
     *
     * @returns {Array} resolutions
     */
    getResolutions: function getResolutions() {
        var resolutions = [];

        if (this.configuration) {
            resolutions = this.configuration["generalOptions"]["wgs84Resolutions"];
        }

        return resolutions;
    },

    /**
     * Recuperation des parametres TMS de la configuration
     * @param {String} tmsName - tile matrix set name
     *
     * @returns {Object} tile matrix set
     */
    getTileMatrix: function getTileMatrix(tmsName) {
        var tms = {};

        if (this.configuration) {
            if (tmsName) {
                tms = this.configuration["tileMatrixSets"][tmsName.toUpperCase()];
            }
        }

        return tms;
    },

    /**
     * Récupération des contraintes générales d'une couche donnée : extent, minScale, maxScale, projection
     *
     * @param {String} layerId - identifiant de la couche
     * @returns {Object} params - contraintes de la couche
     * @returns {String} params.projection - Projection par défaut de la couche
     * @returns {Number} params.minScale   - Dénominateur d'échelle minimum de la couche
     * @returns {Number} params.maxScale   - Dénominateur d'échelle maximum de la couche
     * @returns {Gp.BBox} params.extent    - Etendue de la couche, dans la projection de la couche
     */
    getGlobalConstraints: function getGlobalConstraints(layerId) {
        var params = {};

        if (layerId) {
            // récupération de l'objet de configuration de la couche
            var layerConf = this.configuration.layers[layerId];
            params.projection = layerConf.getDefaultProjection();
            params.minScale = layerConf.getMinScaleDenominator();
            params.maxScale = layerConf.getMaxScaleDenominator();
            params.extent = layerConf.getBBOX();
        }

        return params;
    }
};

exports.default = Config;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Interactions = __webpack_require__(15);

var _Interactions2 = _interopRequireDefault(_Interactions);

var _LayerSwitcher = __webpack_require__(6);

var _LayerSwitcher2 = _interopRequireDefault(_LayerSwitcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Derived from OpenLayers measure example
// http://openlayers.org/en/latest/examples/measure.html

var logger = _LoggerByDefault2.default.getLogger("measures");

/**
 * Measures Tools :
 * - length
 * - aera
 * - azimut
 */
var Measures = {

    // ****************************************************************** //
    // > Default Styles
    // ****************************************************************** //

    /*
     * Pointer
     */
    DEFAULT_POINTER_STYLE: new _ol2.default.style.Circle({
        radius: 5,
        stroke: new _ol2.default.style.Stroke({
            color: "#002A50",
            width: 2
        }),
        fill: new _ol2.default.style.Fill({
            color: "rgba(255, 155, 0, 0.7)"
        })
    }),

    /*
     * Measures style line
     */
    DEFAULT_DRAW_START_STYLE: new _ol2.default.style.Style({
        fill: new _ol2.default.style.Fill({
            color: "rgba(0, 183, 152, 0.2)"
        }),
        stroke: new _ol2.default.style.Stroke({
            color: "#002A50",
            lineDash: [10, 10],
            width: 2
        })
    }),

    /*
     * Measures final style line
     */
    DEFAULT_DRAW_FINISH_STYLE: new _ol2.default.style.Style({
        fill: new _ol2.default.style.Fill({
            color: "rgba(0, 183, 152, 0.3)"
        }),
        stroke: new _ol2.default.style.Stroke({
            color: "#002A50",
            width: 3
        })
    }),

    // ****************************************************************** //
    // > ToolBox : these tools work together
    // ****************************************************************** //
    // sample :
    // tools[name_control][0].(active|instance|map)
    // tools : {
    //      MeasureLength : [
    //          { active : true, instance : [Object MeasureLength], map : "map1" },
    //          { active : true, instance : [Object MeasureLength], map : "map2" }
    //      ],
    //      MeasureArea : [],
    //      MeasureAzimuth : []
    // }
    tools: {
        MeasureLength: [],
        MeasureArea: [],
        MeasureAzimuth: []
    },

    // ****************************************************************** //
    // > Variables
    // ****************************************************************** //

    /**
     * Global measure draw interaction
     * @type {ol.interaction.Draw}
     */
    measureDraw: null,

    /**
     * Global vector source for measure
     * @type {ol.source.Vector}
     */
    measureSource: null,

    /**
     * Global vector layer for measure
     * @type {ol.layer.Vector}
     */
    measureVector: null,

    /**
     * Currently drawn feature.
     * @type {ol.Feature}
     */
    sketch: null,

    /**
     * The measure tooltip element.
     * @type {Element}
     */
    measureTooltipElement: null,

    /**
     * Overlay to show the measurement.
     * @type {ol.Overlay}
     */
    measureTooltip: null,

    /**
     * TODO The help tooltip element.
     * @type {Element}
     */
    helpTooltipElement: null,

    /**
     * TODO Overlay to show the help.
     * @type {ol.Overlay}
     */
    helpTooltip: null,

    // ****************************************************************** //
    // > Methods Public
    // ****************************************************************** //

    /** Desactived Tool Measure */
    clean: function clean() {
        var _class = this.CLASSNAME;

        // logger.trace("[" + _class + "] deactived tool !");
        // sur la desactivation de l'outil de mesure
        // on fait un nettoyage des ressources
        // ainsi que le DOM
        this.clearMeasure();
        this.clearMeasureToolTip();
        this.removeMeasureEvents();
        this._showContainer.checked = false;
    },

    // ****************************************************************** //
    // > Methods Events
    // ****************************************************************** //

    /**
     * Handle pointer move.
     *
     * @param {ol.MapBrowserEvent} e - The event.
     */
    onPointerMoveHandler: function onPointerMoveHandler(e) {
        if (e.dragging) {
            return;
        }

        /** @type {ol.Coordinate|undefined} */
        var tooltipCoord = e.coordinate;

        if (this.sketch) {
            var output;
            var geom = this.sketch.getGeometry();
            output = this.format(geom);
            if (geom.getType() === "LineString") {
                tooltipCoord = geom.getLastCoordinate();
            } else if (geom.getType() === "Polygon") {
                tooltipCoord = geom.getInteriorPoint().getCoordinates();
            } else {
                return;
            }
            this.measureTooltipElement.innerHTML = output;
            this.measureTooltip.setPosition(tooltipCoord);
        }
    },

    /**
     * Main program !
     * This method is called by event 'click' on control picto
     *
     * @param {Object} e - HTMLElement
     * @param {String} type - LineString or Polygon
     * @private
     */
    onShowMeasureClick: function onShowMeasureClick(e, type) {
        var map = this.getMap();
        var currentMapId = map.getTargetElement().id;

        // desactivation des controles de mesures sur la carte courrante
        var self = this.CLASSNAME; // this.constructor.name : pas possible en mode minifié/manglifié !
        for (var className in this.tools) {
            if (this.tools.hasOwnProperty(className)) {
                var measures = this.tools[className];
                for (var i = 0; i < measures.length; i++) {
                    var o = measures[i];
                    if (o && o.active && className !== self && o.map === currentMapId) {
                        o.active = false;
                        if (o.instance !== null) {
                            // au cas où le controle a été supprimé !
                            o.instance.clean();
                        }
                    }
                }
            }
        }

        // desactivation des autres interactions parasites
        _Interactions2.default.unset(map, {
            current: "Measures"
        });

        if (!this._showContainer.checked) {
            this.addMeasureEvents();
            this.initMeasureInteraction();
            this.addMeasureInteraction(type);
            for (var j = 0; j < this.tools[self].length; j++) {
                if (this.tools[self][j].map === currentMapId) {
                    this.tools[self][j].active = true;
                }
            }
        } else {
            this.clearMeasure();
            this.clearMeasureToolTip();
            this.removeMeasureEvents();
            for (var k = 0; k < this.tools[self].length; k++) {
                if (this.tools[self][k].map === currentMapId) {
                    this.tools[self][k].active = false;
                }
            }
        }
    },

    // ****************************************************************** //
    // > Methods not Public
    // ****************************************************************** //

    /**
     * Clear all dom tooltip of length, area or azimut object.
     */
    clearMeasureToolTip: function clearMeasureToolTip() {
        var map = this.getMap();
        if (!map) {
            return;
        }

        var mapContainer = map.getTargetElement();
        // au cas où il y'aurait plusieurs container de carte !
        var overlays = mapContainer.getElementsByClassName("ol-overlaycontainer-stopevent");
        for (var k = 0; k < overlays.length; k++) {
            var nodes = overlays[k];
            var len = nodes.children.length;
            var nodesToRemove = [];
            for (var i = 0; i < len; i++) {
                var node = nodes.children[i];
                if (node.children.length !== 0) {
                    var child = node.children[0];
                    if (child.className === "GPmeasureTooltip GPmeasureTooltip-static" || child.className === "GPmeasureTooltip GPmeasureTooltip-measure") {
                        nodesToRemove.push(node);
                    }
                }
            }
            for (var j = 0; j < nodesToRemove.length; j++) {
                nodes.removeChild(nodesToRemove[j]);
            }
        }
    },

    /**
     * Clear all length, area or azimut object.
     */
    clearMeasure: function clearMeasure() {
        var map = this.getMap();

        // FIXME !?
        // if (this.measureTooltip) {
        //     map.removeOverlay(this.measureTooltip);
        //     this.measureTooltip = null;
        // }

        if (this.measureVector) {
            map.removeLayer(this.measureVector);
            this.measureVector = null;
        }

        if (this.measureDraw) {
            map.removeInteraction(this.measureDraw);
            this.measureDraw = null;
        }
    },

    /**
     * Creates a new measure tooltip
     * FIXME bug d'affichage de la tooltip de saisie en cours si on ne termine pas
     * la saisie  !?
     *
     * @param {ol.Map} map - The Map.
     */
    createMeasureTooltip: function createMeasureTooltip(map) {
        if (this.measureTooltipElement) {
            this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
        }

        this.measureTooltipElement = document.createElement("div");
        this.measureTooltipElement.className = "GPmeasureTooltip GPmeasureTooltip-measure";

        this.measureTooltip = new _ol2.default.Overlay({
            element: this.measureTooltipElement,
            offset: [0, -15],
            positioning: "bottom-center"
        });

        map.addOverlay(this.measureTooltip);
    },

    /**
     * TODO evolution
     * Creates a new help tooltip
     *
     * @param {ol.Map} map - The Map.
     */
    createHelpTooltip: function createHelpTooltip(map) {
        if (this.helpTooltipElement) {
            this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
        }

        this.helpTooltipElement = document.createElement("div");
        this.helpTooltipElement.className = "tooltip hidden";

        this.helpTooltip = new _ol2.default.Overlay({
            element: this.helpTooltipElement,
            offset: [15, 0],
            positioning: "center-left"
        });

        map.addOverlay(this.helpTooltip);
    },

    /**
     * Creates a style for drawing
     *
     * @param {Object} styles - styles.
     */
    createStylingMeasureInteraction: function createStylingMeasureInteraction(styles) {
        this.options.styles = styles || {};

        // style de depart
        // logger.trace("style start", this.options.styles.start);

        // Creation à partir des styles par défaut
        var startStyleOpts = {
            image: Measures.DEFAULT_POINTER_STYLE,
            fill: Measures.DEFAULT_DRAW_START_STYLE.getFill(),
            stroke: Measures.DEFAULT_DRAW_START_STYLE.getStroke()
        };
        // ecrasement à partir des propriétés renseignées
        if (this.options.styles.hasOwnProperty("pointer") && this.options.styles.pointer instanceof _ol2.default.style.Image) {
            startStyleOpts.image = this.options.styles.pointer;
        }
        if (this.options.styles.hasOwnProperty("start") && this.options.styles.start instanceof _ol2.default.style.Style) {
            if (this.options.styles.start.getFill() != null) {
                startStyleOpts.fill = this.options.styles.start.getFill();
            }
            if (this.options.styles.start.getStroke() != null) {
                startStyleOpts.stroke = this.options.styles.start.getStroke();
            }
        }

        this.options.styles.start = new _ol2.default.style.Style(startStyleOpts);

        // style de fin
        // logger.trace("style finish", this.options.styles.finish);

        var finishStyleOpts = {
            fill: Measures.DEFAULT_DRAW_FINISH_STYLE.getFill(),
            stroke: Measures.DEFAULT_DRAW_FINISH_STYLE.getStroke()
        };
        // ecrasement à partir des propriétés renseignées
        if (this.options.styles.hasOwnProperty("finish") && this.options.styles.finish instanceof _ol2.default.style.Style) {
            if (this.options.styles.finish.getFill() != null) {
                finishStyleOpts.fill = this.options.styles.finish.getFill();
            }
            if (this.options.styles.finish.getStroke() != null) {
                finishStyleOpts.stroke = this.options.styles.finish.getStroke();
            }
        }

        this.options.styles.finish = new _ol2.default.style.Style(finishStyleOpts);
    },

    /**
     * Add the measure interaction
     *
     * @param {String} type - LineString or Polygon.
     */
    addMeasureInteraction: function addMeasureInteraction(type) {
        var map = this.getMap();

        // Creates and adds the interaction
        var self = this;
        this.measureDraw = new _ol2.default.interaction.Draw({
            source: this.measureSource,
            // condition : permet de gerer la suppression des derniers points saisis
            condition: function condition(event) {
                if (event.originalEvent.ctrlKey) {
                    if (self.sketch) {
                        this.removeLastPoint();
                    }
                    return false;
                }
                return true;
            },
            type: type,
            style: this.options.styles.start || Measures.DEFAULT_DRAW_START_STYLE
        });
        this.measureDraw.setProperties({
            name: "Measures",
            source: this
        });
        map.addInteraction(this.measureDraw);

        // Create tooltips
        this.createMeasureTooltip(map);

        // Event start measuring
        this.measureDraw.on("drawstart", function (evt) {
            // set sketch
            self.sketch = evt.feature;
        }, this);

        // Event end measuring
        this.measureDraw.on("drawend", function () {
            // FIXME MaJ de la tooltip en mode mobile !
            if (self.sketch) {
                var output;
                var tooltipCoord;
                var geom = self.sketch.getGeometry();
                output = self.format(geom);
                if (geom.getType() === "LineString") {
                    tooltipCoord = geom.getLastCoordinate();
                } else if (geom.getType() === "Polygon") {
                    tooltipCoord = geom.getInteriorPoint().getCoordinates();
                } else {
                    return;
                }
                self.measureTooltipElement.innerHTML = output;
                self.measureTooltip.setPosition(tooltipCoord);
            }

            self.measureTooltipElement.className = "GPmeasureTooltip GPmeasureTooltip-static";
            self.measureTooltip.setOffset([0, -7]);

            // unset sketch
            self.sketch = null;
            // unset tooltip so that a new one can be created
            self.measureTooltipElement = null;
            self.createMeasureTooltip(map);
        }, this);
    },

    /**
     * Init the measure interaction
     */
    initMeasureInteraction: function initMeasureInteraction() {
        var map = this.getMap();

        this.measureSource = new _ol2.default.source.Vector();

        this.measureVector = new _ol2.default.layer.Vector({
            source: this.measureSource,
            style: this.options.styles.finish || Measures.DEFAULT_DRAW_FINISH_STYLE
        });

        // on rajoute le champ gpResultLayerId permettant d'identifier une couche crée par le composant.
        this.measureVector.gpResultLayerId = "measure";

        map.addLayer(this.measureVector);

        // Si un layer switcher est présent dans la carte, on lui affecte des informations pour cette couche
        map.getControls().forEach(function (control) {
            if (control instanceof _LayerSwitcher2.default) {
                // un layer switcher est présent dans la carte
                var layerId = this.measureVector.gpLayerId;
                // on n'ajoute des informations que s'il n'y en a pas déjà (si le titre est le numéro par défaut)
                if (control._layers[layerId].title === layerId) {
                    control.addLayer(this.measureVector, {
                        title: this.options.layerDescription.title,
                        description: this.options.layerDescription.description
                    });
                }
            }
        }, this);
    }
};

exports.default = Measures;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _MeasureToolBoxDOM = __webpack_require__(54);

var _MeasureToolBoxDOM2 = _interopRequireDefault(_MeasureToolBoxDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("toolbox");

var MeasureToolBox = {

    /**
     * liste des uid/map (pour chaque toolbox)
     * { map : uid }
     * Ex. { "map1" : 465456456486845 }
     */
    _toolbox: {},

    /**
     * Ajout d'un controle dans la ToolBox.
     * Creation de la toolbox si besoin...
     *
     * @param {ol.Map} map - map
     * @param {ol.control.Control} ctrl - objet à ajouter
     */
    add: function add(map, ctrl) {
        // logger.trace("ToolBox.add()", ctrl);

        if (!map) {
            // logger.trace("map doesn't exist !?");
            return;
        }

        var mapContainer = map.getTargetElement();
        var mapDocument = mapContainer.ownerDocument;
        var mapId = mapContainer.id;

        if (!this._toolbox || Object.keys(this._toolbox).length === 0) {
            this._toolbox[mapId] = _SelectorID2.default.generate();
        } else {
            if (!this._toolbox[mapId]) {
                this._toolbox[mapId] = _SelectorID2.default.generate();
            }
        }

        var uid = this._toolbox[mapId];
        if (!mapDocument.getElementById(this.getToolBoxID(uid))) {
            // logger.trace("create toolbox !");
            // creation et ajout de la toolbox sur la map
            var toolboxContainer = this._createToolBoxContainerElement(uid);
            var overlaysContainer = mapContainer.getElementsByClassName("ol-overlaycontainer-stopevent");
            overlaysContainer[0].appendChild(toolboxContainer);
            // mapContainer.appendChild(toolboxContainer);
        }

        // ajout du widget dans la toolbox
        var widgetContainer = mapDocument.getElementById(this.getWidgetID(uid));
        ctrl.setTarget(widgetContainer);
        // logger.trace("add control to toolbox !");
    }
};

_Utils2.default.assign(MeasureToolBox, _MeasureToolBoxDOM2.default);

exports.default = MeasureToolBox;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LayerUtils = {

    /**
     * Obtenir le ZoomLevel à partir du ScaleDenominator
     * @param {Number} scaleDenominator - the scale denominator
     * @param {String} crs - the crs
     *
     * @returns {Integer} zoom level
     */
    getZoomLevelFromScaleDenominator: function getZoomLevelFromScaleDenominator(scaleDenominator, crs) {
        // ------------------------------------------------- //
        // Code issu de l'API Geoportal/Catalogue/Config.js  //
        // ------------------------------------------------- //
        //     var configuration = Gp.Config;
        //     var general = configuration.generalOptions;
        //     var layers  = configuration.layersContext;
        //
        //     for (var tms in general.tileMatrixSets) {
        //         var tileMatrixSet = general.tileMatrixSets[tms];
        //         // IGN's WMTS bug : epsg:nnnn instead of EPSG:nnnn
        //         var crs = tileMatrixSet.supportedCRS = tileMatrixSet.supportedCRS.replace(/epsg/,"EPSG");
        //
        //         if (!Geoportal.Catalogue.CRSRESOLUTIONS.hasOwnProperty(crs)) {
        //             var p= new OpenLayers.Projection(crs);
        //             Geoportal.Catalogue.CRSRESOLUTIONS[crs]= [];
        //             var matrixIds= tileMatrixSet.matrixIds;
        //             for (var i= 0, li= matrixIds.length; i<li; ++i) {
        //                 var mid= matrixIds[i];
        //                 Geoportal.Catalogue.CRSRESOLUTIONS[crs].push(
        //                     0.00028*mid.scaleDenominator
        //                     /(OpenLayers.METERS_PER_INCH*OpenLayers.INCHES_PER_UNIT[p.getUnits()]));
        //                     mid.supportedCRS= mid.supportedCRS.replace(/epsg/,"EPSG");
        //                 }
        //                 Geoportal.Catalogue.CRSRESOLUTIONS[crs].sort(function (a,b){ return b-a; });
        //             }
        //         }
        //         var llR= Geoportal.Catalogue.CRSRESOLUTIONS['CRS:84'];
        //         if (!llR) {
        //             llR= Geoportal.Catalogue.CRSRESOLUTIONS['CRS:84']= general.resolutions.slice();
        //         }
        //         var wmR= Geoportal.Catalogue.CRSRESOLUTIONS['EPSG:3857'];
        //         if (!wmR) {//FIXME : should never happened !!
        //             // reproject resolutions from CRS84 to WebMercator (transform resolutions from degree/px to meter/px)
        //             wmR= Geoportal.Catalogue.CRSRESOLUTIONS['EPSG:3857']= new Array(llR.length);
        //             for (var i= 0, len= llR.length; i<len; i++) {
        //                 var pt= new OpenLayers.LonLat(llR[i], 0);
        //                 pt.transform(OpenLayers.Projection.CRS84, OpenLayers.Projection.WebMercator);
        //                 wmR[i]= pt.lon;
        //             }
        //         }
        //         Geoportal.Catalogue.RESOLUTIONS= wmR;
        //
        //         var getResolutionsFromCRS= function(crs) {
        //             if (OpenLayers.Projection.WebMercator.isAliasOf(crs)) {
        //                 return wmR;
        //             }
        //             if (OpenLayers.Projection.CRS84.isAliasOf(crs)) {
        //                 return llR;
        //             }
        //             return Geoportal.Catalogue.CRSRESOLUTIONS[crs]?Geoportal.Catalogue.CRSRESOLUTIONS[crs]:null ;
        //         };
        //
        //         var retrieveZoomFromResolution= function(resolutions, resolution) {
        //             for (var i= 0, li= resolutions.length; i<li; i++) {
        //                 if (resolutions[i]-resolution <= resolutions[li-1]) {
        //                     return i;
        //                 }
        //             }
        //             return -1;
        //         };
        //
        //         var getZoomLevelFromScaleDenominator= function(scaleDenominator,crs) {
        //             var resolution= scaleDenominator * 0.00028;
        //             var R= getResolutionsFromCRS(crs);
        //             if (R) {
        //                 return retrieveZoomFromResolution(R,resolution);
        //             }
        //             resolution= resolution/(OpenLayers.METERS_PER_INCH * OpenLayers.INCHES_PER_UNIT["degrees"]);
        //             return retrieveZoomFromResolution(llR,resolution);
        //         };
        //
        //         var getZoomLevelFromResolution= function(resolution,crs){
        //             var R= getResolutionsFromCRS(crs);
        //             if (R) {
        //                 return retrieveZoomFromResolution(R,resolution);
        //             }
        //             var pt0= new OpenLayers.LonLat(0, 0);
        //             var pt1= new OpenLayers.LonLat(1, 0);
        //             pt0.transform(new OpenLayers.Projection(crs),OpenLayers.Projection.CRS84);
        //             pt1.transform(new OpenLayers.Projection(crs),OpenLayers.Projection.CRS84);
        //             resolution= resolution*(Math.abs(pt1.lon-pt0.lon));
        //             return retrieveZoomFromResolution(llR,resolution);
        //         };

        // par defaut, on utilise la projection WebMercator (EPSG:3857 = PM)
        // soit la liste des resolutions natives
        var resolutionsNatives = {};
        switch (crs) {
            case "EPSG:2154":
                resolutionsNatives = {
                    0: 104579.224549894,
                    1: 52277.5323537905,
                    2: 26135.4870785954,
                    3: 13066.8913818,
                    4: 6533.2286041135,
                    5: 3266.5595244627,
                    6: 1633.2660045974,
                    7: 816.629554986,
                    8: 408.3139146768,
                    9: 204.1567415109,
                    10: 102.0783167832,
                    11: 51.0391448966,
                    12: 25.5195690743,
                    13: 12.7597836936,
                    14: 6.379891636,
                    15: 3.1899457653,
                    16: 1.5949728695,
                    17: 0.7974864315,
                    18: 0.3987432149,
                    19: 0.1993716073,
                    20: 0.0996858037,
                    21: 0.0498429018
                };
                break;
            default:
                resolutionsNatives = {
                    0: 156543.033928041,
                    1: 78271.51696402048,
                    2: 39135.758482010235,
                    3: 19567.87924100512,
                    4: 9783.93962050256,
                    5: 4891.96981025128,
                    6: 2445.98490512564,
                    7: 1222.99245256282,
                    8: 611.49622628141,
                    9: 305.7481131407048,
                    10: 152.8740565703525,
                    11: 76.43702828517624,
                    12: 38.21851414258813,
                    13: 19.10925707129406,
                    14: 9.554628535647032,
                    15: 4.777314267823516,
                    16: 2.388657133911758,
                    17: 1.194328566955879,
                    18: 0.5971642834779395,
                    19: 0.2985821417389697,
                    20: 0.1492910708694849,
                    21: 0.0746455354347424
                };
                break;
        }

        // gestion des autres SRS
        // TODO
        // if (crs) {
        // }

        var resolution = scaleDenominator * 0.00028;

        for (var index in resolutionsNatives) {
            if (resolutionsNatives.hasOwnProperty(index)) {
                if (resolutionsNatives[index] <= resolution) {
                    index = parseInt(index, 10);
                    return index;
                }
            }
        }

        return 0; // -1 ?
    },

    /**
     * Get attributions list for a layer, based on current zoom and extent
     *
     * @param {Object} params - function params
     * @param {Array.<Float>} params.extent - map current geographical extent (EPSG:4326) : [top, left, bottom, right] = [maxy, minx, miny, maxx]
     * @param {Number} params.zoom - map current zoom
     * @param {String} params.crs - map current projection code (ex "EPSG:2154")
     * @param {Boolean} params.visibility - layer visibility
     * @param {Gp.Services.Config.Originator} params.originators - resource originators (from Gp.Config.layers[].originators)
     * @returns {Object} attributions - associative array, mapping originators url (keys) with their properties : html attributions elements
     */
    getAttributions: function getAttributions(params) {
        var zoom = params.zoom;

        var attributions = [];

        if (params.originators != null && params.visibility) {
            // drawLogo = boolean, true if attribution should be displayed (zoom, extent), false otherwise
            var drawLogo;
            for (var j = 0, jl = params.originators.length; j < jl; j++) {
                drawLogo = true;
                var originator = params.originators[j];

                var constraints = params.originators[j].constraints || [];
                for (var k = 0, kl = constraints.length; k < kl; k++) {
                    var constraint = constraints[k];
                    drawLogo = true;

                    var minZoomLevel = this.getZoomLevelFromScaleDenominator(constraint.maxScaleDenominator, params.crs);
                    var maxZoomLevel = this.getZoomLevelFromScaleDenominator(constraint.minScaleDenominator, params.crs) || 21;

                    // min zoom constraints
                    if (minZoomLevel && minZoomLevel > zoom) {
                        drawLogo = false;
                    }

                    // max zoom constraints
                    if (drawLogo && maxZoomLevel !== null && maxZoomLevel < zoom) {
                        drawLogo = false;
                    }

                    // bbox constraints
                    var bbox = constraint.bbox;
                    if (drawLogo && bbox) {
                        drawLogo = false;
                        var viewExtent = params.extent;
                        if (viewExtent) {
                            var bounds = [bbox.top, bbox.left, bbox.bottom, bbox.right];
                            if (this.intersects(viewExtent, bounds)) {
                                // at least one constraint matches the map ones
                                drawLogo = true;
                                break;
                            }
                        }
                    }
                }

                if (drawLogo) {
                    // on a un originator qui correspond au zoom et à l'étendue.

                    var logo = originator.logo;
                    var url = originator.url;
                    var name = originator.name ? originator.name : "";
                    var text = originator.attribution;

                    var container = document.createElement("div");
                    container.className = "gp-control-attribution";

                    // on crée un lien dans tous les cas (même s'il ne pointe pas vers une référence), pour avoir accès à la class CSS (pour surcharge)
                    var link = null;
                    link = document.createElement("a");
                    link.className = "gp-control-attribution-link";
                    link.target = "_blank";
                    container.appendChild(link);
                    if (url) {
                        link.href = url;
                    }

                    var bImage = !!logo;
                    var image = null;
                    // si on a un logo, on l'affiche à l'interieur du lien
                    if (bImage) {
                        image = document.createElement("img");
                        if (link) {
                            image.className = "gp-control-attribution-image";
                            link.appendChild(image);
                        } else {
                            image.className = "";
                            container.appendChild(image);
                        }
                        image.src = logo; // FIXME : mixContent !
                        image.title = text || name;
                        image.style.height = "30px";
                        image.style.width = "30px";
                    } else {
                        // sinon, on affiche le nom de l'originator, ou sa description ou l'url.
                        if (name) {
                            link.textContent = name;
                        } else if (text) {
                            link.textContent = text;
                        } else if (url) {
                            link.textContent = url;
                        } else {
                            link.textContent = "";
                        }
                    }

                    attributions.push(container.innerHTML + " ");
                }
            }
        }

        return attributions;
    },

    /**
     * Determines if one extent (extent1) intersects another (extent2)
     *
     * @param {Array.<Float>} extent1 - First extent : [top, left, bottom, right] = [maxy, minx, miny, maxx]
     * @param {Array.<Float>} extent2 - Second extent : [top, left, bottom, right] = [maxy, minx, miny, maxx]
     * @return {Boolean} intersects - True if the two extents intersect, false otherwise.
     */
    intersects: function intersects(extent1, extent2) {
        var intersectsX = extent1[1] <= extent2[3] && extent2[1] <= extent1[3];
        var intersectsY = extent1[2] <= extent2[0] && extent2[2] <= extent1[0];
        return intersectsX && intersectsY;
    }
};

exports.default = LayerUtils;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProxyUtils = {
    /**
     * Ajoute un proxy aux url des couches vecteurs si besoin.
     *
     * @param {String} url - Url to proxify.
     * @param {Object} [proxyOptions] - Object defining proxy options.
     * @param {String} proxyOptions.proxyUrl - Proxy URL.
     * @param {Array.<String>} [proxyOptions.noProxyDomains] - Proxy will not be used for this list of domain names.
     *
     * @returns {String} proxy url
     */
    proxifyUrl: function proxifyUrl(url, proxyOptions) {
        // logger

        var logger = _LoggerByDefault2.default.getLogger("proxifyUrl");

        if (!proxyOptions || !proxyOptions.hasOwnProperty("proxyUrl") || proxyOptions.proxyUrl === null || proxyOptions.proxyUrl.trim().length === 0) {
            return url;
        }
        // on regarde si l'url nest pas dans les domaines sans proxy
        if (proxyOptions.noProxyDomains && Array.isArray(proxyOptions.noProxyDomains) && proxyOptions.noProxyDomains.length > 0) {
            for (var i in proxyOptions.noProxyDomains) {
                // logger.trace("[ProxyUtils] proxifyUrl : analyzing " + proxyOptions.noProxyDomains[i]);
                if (url.indexOf(proxyOptions.noProxyDomains[i]) !== -1) {
                    // logger.info("[ProxyUtils] proxifyUrl : " + url + " found in noProxyDomains list (" + proxyOptions.noProxyDomains[i] + ").");
                    return url;
                }
            }
        }
        return proxyOptions.proxyUrl + encodeURIComponent(url);
    }
};

exports.default = ProxyUtils;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import $__xmldom from "xmldom";

var logger = _LoggerByDefault2.default.getLogger("extended KML format");

/**
 * @classdesc
 *
 * Extended Styles KML format to export (internal use only !)
 *
 * INFO
 * only ol.Control is a user-extendable class.
 * Everything else requires integration with the original openlayers source and a new ol.js
 * to be built with your new classes incorporated.
 *
 * SPEC
 * cf. https://developers.google.com/kml/forum/advanced
 *
 * ISSUES
 * cf. https://github.com/openlayers/openlayers/issues/4829
 * cf. https://github.com/openlayers/openlayers/issues/4460
 * cf. https://github.com/openlayers/openlayers/pull/5590
 * cf. https://github.com/openlayers/openlayers/issues/5229
 * cf. https://github.com/openlayers/openlayers/issues/3371
 *
 * @constructor
 * @extends {ol.format.KML}
 * @param {Object} options - Options
 */
function KML(options) {
    if (!(this instanceof KML)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // call constructor
    _ol2.default.format.KML.call(this, options);

    this.options = options || {};
}

// Inherits
_ol2.default.inherits(KML, _ol2.default.format.KML);

/*
 * @lends module:KML
 */
KML.prototype = Object.create(_ol2.default.format.KML.prototype, {});

/**
 * Constructor (alias)
 *
 * En lecture, on surcharge la méthode readFeatures.
 * ✔️ In : kml string + features du format original
 * ✔️ Out : features étendus avec des styles, et des metadatas (name ou extendData)
 * > on modifie les features du format original avec les fonctionnalités non gérées.
 *
 * En écriture, on surcharge la méthode writeFearures.
 * ✔️ In : kml du format original + features étendus
 * ✔️ Out : kml étendu avec des styles, et des metadatas (name ou extendData)
 * > on modifie le kml généré par le format original avec les fonctionnalités que nous avons ajoutées aux features.
 *
 * Le principe
 * On parse le kml, et on lit (get) ou on ajoute (set) des fonctionnalités.
 *
 * Les getters vont lire le kml (ex. LabelExtendStyle), et ajouter le style ainsi que le nom du label dans le feature original.
 * getLabelIconStyle (appel des 2 fonctions suivantes)
 * getLabelExtendStyle (New)
 * getHotSpotIconStyle (Bug sur la lecture du  hotspot)
 * getExtendData (New)
 *
 * Les setters vont écrire dans le dom du kml original les fonctionnalités ajoutées dans les features.
 * setLabelExtendStyle (New)
 * setHotSpotIconStyle (Bug sur l'écriture du hotspot)
 * setNameData (Bug suppression de cette balise du format par défaut).
 *
 */
KML.prototype.constructor = KML;

/**
 * Fonction d'indentation d'une chaine de caractères KML ou XML
 * cf. https://stackoverflow.com/questions/376373/pretty-printing-xml-with-javascript/
 *
 * @param {String} xml - xml
 *
 * @returns {String} kml string
 */
function _kmlFormattedToString(xml) {
    var reg = /(>)\s*(<)(\/*)/g; // updated Mar 30, 2015
    var wsexp = / *(.*) +\n/g;
    var contexp = /(<.+>)(.+\n)/g;
    xml = xml.replace(reg, "$1\n$2$3").replace(wsexp, "$1\n").replace(contexp, "$1\n$2");
    var formatted = "";
    var lines = xml.split("\n");
    var indent = 0;
    var lastType = "other";
    // 4 types of tags - single, closing, opening, other (text, doctype, comment) - 4*4 = 16 transitions
    var transitions = {
        "single->single": 0,
        "single->closing": -1,
        "single->opening": 0,
        "single->other": 0,
        "closing->single": 0,
        "closing->closing": -1,
        "closing->opening": 0,
        "closing->other": 0,
        "opening->single": 1,
        "opening->closing": 0,
        "opening->opening": 1,
        "opening->other": 1,
        "other->single": 0,
        "other->closing": -1,
        "other->opening": 0,
        "other->other": 0
    };

    for (var i = 0; i < lines.length; i++) {
        var ln = lines[i];
        var single = Boolean(ln.match(/<.+\/>/)); // is this line a single tag? ex. <br />
        var closing = Boolean(ln.match(/<\/.+>/)); // is this a closing tag? ex. </a>
        var opening = Boolean(ln.match(/<[^!].*>/)); // is this even a tag (that's not <!something>)
        var type = single ? "single" : closing ? "closing" : opening ? "opening" : "other";
        var fromTo = lastType + "->" + type;
        lastType = type;
        var padding = "";

        indent += transitions[fromTo];
        for (var j = 0; j < indent; j++) {
            padding += "\t";
        }
        if (fromTo === "opening->closing") {
            formatted = formatted.substr(0, formatted.length - 1) + ln + "\n"; // substr removes line break (\n) from prev loop
        } else {
            formatted += padding + ln + "\n";
        }
    }

    // logger.trace(formatted);
    return formatted;
};

/**
 * Fonction de parsing d'une chaine de caractères KML
 *
 * @param {String} kmlString - kml string
 *
 * @returns {DOMElement} kml document
 */
function _kmlParse(kmlString) {
    var kmlDoc = null;
    var parser = null;
    var scope = typeof window !== "undefined" ? window : null;

    if (( false ? "undefined" : _typeof(exports)) === "object" && window === null) {
        // code for nodejs
        var DOMParser = __webpack_require__(11).DOMParser;
        parser = new DOMParser();
        kmlDoc = parser.parseFromString(kmlString, "text/xml");
    } else if (scope.DOMParser) {
        // code for modern browsers
        parser = new scope.DOMParser();
        kmlDoc = parser.parseFromString(kmlString, "text/xml");
    } else if (scope.ActiveXObject) {
        // code for old IE browsers
        kmlDoc = new scope.ActiveXObject("Microsoft.XMLDOM");
        kmlDoc.async = false;
        kmlDoc.loadXML(kmlString);
    } else {
        logger.log("Incompatible environment for DOM Parser !");
    }

    // logger.trace(kmlDoc);
    return kmlDoc;
};

/**
 * Fonction de convertion en chaine de caractères.
 *
 * @param {DOMElement} kmlDoc - kml document
 *
 * @returns {String} kml string
 */
function _kmlToString(kmlDoc) {
    var oSerializer = new XMLSerializer();
    var kmlStringExtended = oSerializer.serializeToString(kmlDoc);

    // logger.trace(kmlStringExtended);
    return kmlStringExtended;
};

/**
 * Fonction de lecture du KML avec fonction de traitement en fonction du type
 * PlaceMark (Label ou Marker).
 * Les traitements sont de 2 types :
 *  - creation de styles étendus ou correctifs sur le KML
 *  - ajout de styles étendus sur les features
 *
 * @param {DOMElement} kmlDoc - kml document
 * @param {Object[]} features - features
 * @param {Object} process - process
 *
 * @example
 * // ajoute des fonctionnalités dans le KML
 * _kmlRead(kmlDoc, {
 *   labelStyle : createStyleLabel,
 *   iconStyle  : createStyleIcon
 * });
 *
 * // lit des fonctionnalités du KML non impl. par OpenLayers
 * _kmlRead(kmlDoc, {
 *   labelStyle : getStyleToFeatureLabel,
 *   iconStyle  : getStyleToFeatureIcon,
 *   extendedData : getExtendedData
 * });
 */
function _kmlRead(kmlDoc, features, process) {
    var root = kmlDoc.documentElement;
    var firstNodeLevel = root.childNodes;

    // Si le DOM contient un seul objet, le noeud est directement un PlaceMark
    // sinon, c'est un ensemble de noeuds PlaceMark contenus dans le noeud Document.
    var nodes = firstNodeLevel;
    if (firstNodeLevel.length === 1 && firstNodeLevel[0].nodeName === "Document") {
        nodes = firstNodeLevel[0].childNodes;
    }

    // On recherche les PlaceMark de type Point ayant un Style...
    // Le style peut être placé directement dans le PlaceMark
    // ou lié avec un id (share)
    var stylesUrl = {}; // listes des styles
    var index = -1; // index du features...
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        switch (node.nodeName) {
            case "Style":
                // INFO
                // pour le traitement des balises Styles liées avec styleUrl,
                // elles doivent être toujours déclarées avant les PlaceMark !
                // On ne prend en compte que celles qui sont identifiées via un ID !
                var id = node.attributes[0];
                if (id && id.nodeName === "id") {
                    var _k = id.nodeValue;
                    var _v = node;
                    stylesUrl[_k] = _v;
                }
                break;

            case "Placemark":

                index++;
                var types = node.childNodes; // Point, LineString, Polygon, Style, ...
                var point = false;
                var styles = null; // dom
                var extend = null; // dom
                var name = node;
                for (var j = 0; j < types.length; j++) {
                    switch (types[j].nodeName) {
                        case "Point":
                            point = true;
                            break;
                        case "Style":
                            styles = types[j].childNodes; // liste de styles
                            break;
                        case "styleUrl":
                            // style avec lien vers...
                            var _idStyle = types[j].textContent.slice(1);
                            if (stylesUrl[_idStyle]) {
                                styles = stylesUrl[_idStyle].childNodes;
                            }
                            break;
                        case "ExtendedData":
                            extend = types[j].childNodes;
                            break;
                        case "name":
                            name = null;
                            break;
                        default:
                        // on ne traite pas les autres informations ...
                        // car elles seront gérées par defaut par le format standard...
                    }
                }

                // On traite les balises kml:extendedData pour tous les objets !
                if (extend) {
                    logger.log("ExtendedData :", extend);
                    var fctExtend = process.extendedData;
                    if (fctExtend && typeof fctExtend === "function") {
                        fctExtend(features[index], extend);
                    }
                }

                //  On traite la balise kml:name
                // (si elle n'existe plus lors de l'ecriture...)
                if (name) {
                    logger.log("Name :", name);
                    var fctName = process.nameData;
                    if (fctName && typeof fctName === "function") {
                        fctName(features[index], name);
                    }
                }

                // On a un Marker avec un Style.
                // Les markers sans styles seront gérées par defaut par le format standard...
                // Il peut être associé avec un Label !
                if (point && styles) {
                    // Les Styles !
                    if (styles.length) {
                        var labelStyle = null;
                        var iconStyle = null;
                        // On recherche le type de Style
                        for (var k = 0; k < styles.length; k++) {
                            switch (styles[k].nodeName) {
                                case "LabelStyle":
                                    labelStyle = styles[k];
                                    break;
                                case "IconStyle":
                                    iconStyle = styles[k];
                                    break;
                                default:
                                // on ne traite pas les autres informations ...
                            }
                        }

                        // Pour un label, il nous faut un titre !
                        var labelName = features[index].getProperties().name;
                        var labelDescription = features[index].getProperties().description;
                        var value = labelName || labelDescription;
                        // logger.trace(value);

                        // C'est uniquement un Label !
                        if (!iconStyle && labelStyle) {
                            var fctLabel = process.labelStyle;
                            if (fctLabel && typeof fctLabel === "function") {
                                fctLabel(features[index], labelStyle);
                            }
                            // C'est uniquement un marker !
                        } else if (iconStyle && !labelStyle) {
                            var fctIcon = process.iconStyle;
                            if (fctIcon && typeof fctIcon === "function") {
                                fctIcon(features[index], iconStyle);
                            }
                            // C'est un marker avec un label !
                        } else if (iconStyle && labelStyle) {
                            var fctIconLabel = process.iconLabelStyle;
                            if (fctIconLabel && typeof fctIconLabel === "function") {
                                fctIconLabel(features[index], iconStyle, labelStyle);
                            }
                        }
                    }
                }

                break;
            default:
                // logger.trace("tag is not processing !");
        }
    }
};

/**
 * Write Extend Styles for Features.
 * This function overloads ol.format.KML.writeFeatures ...
 *
 * @see ol.format.KML.prototype.writeFeatures
 * @param {Object[]} features - Features.
 * @param {Object} options - Options.
 *
 * @return {String} Result.
 */
KML.prototype.writeFeatures = function (features, options) {
    // KML.prototype._parentWriteFeatures = ol.format.KML.prototype.writeFeatures;
    logger.log("overload : ol.format.KML.writeFeatures");
    var kmlString = this._writeExtendStylesFeatures(features, options);
    return kmlString;
};

/**
 * _writeExtendStylesFeatures
 *
 * @param {Object[]} features - features
 * @param {Object} options - options
 *
 * @returns {String} kml string formatted
 *
 * @private
 */
KML.prototype._writeExtendStylesFeatures = function (features, options) {
    var kmlString = _ol2.default.format.KML.prototype.writeFeatures.call(this, features, options);

    // On met en place un Parser sur le KML
    // (Dommage que le parser XML des services ne soit pas disponible !)
    var kmlDoc = _kmlParse(kmlString);

    if (kmlDoc === null) {
        // au cas où...
        return kmlString;
    }

    /**
     * C'est un Label !
     * On va donc y ajouter qq styles sur le Label (police, halo, ...) :
     * Insertion : PlaceMark>Style>LabelStyle
     *
     * @param {Object} feature - feature
     * @param {DOMElement} style - style
     *
     * @example
     *      <LabelStyleSimpleExtensionGroup fontFamily="Arial" haloColor="16777215" haloRadius="2" haloOpacity="1"/>
     */
    var __createExtensionStyleLabel = function __createExtensionStyleLabel(feature, style) {
        // logger.trace("label with style :", style);

        if (!feature) {
            return;
        }

        var labelName = feature.getProperties().name;
        if (!labelName) {
            return;
        }

        // RGB Colors (RRGGBB) To KML Colors (AABBGGRR)
        function __convertRGBColorsToKML(data) {
            var strColor = data.toString(16);

            if (strColor.charAt(0) === "#") {
                strColor = strColor.slice(1);
            }

            var opacity = 1;
            opacity = parseInt(opacity * 255, 10);
            opacity = opacity.toString(16);
            var color = opacity;
            color = color + strColor.substr(4, 2);
            color = color + strColor.substr(2, 2);
            color = color + strColor.substr(0, 2);
            return color.toLowerCase();
        }

        // Si pas de style defini, c'est donc que l'on va utiliser celui par defaut...
        if (feature.getStyle() instanceof _ol2.default.style.Style) {
            var fTextStyle = feature.getStyle().getText().getStroke();

            if (!fTextStyle) {
                return;
            }

            var _haloColor = __convertRGBColorsToKML(fTextStyle.getColor()) || __convertRGBColorsToKML("#FFFFFF"); // KML Colors : 64FFFFFF (blanc)
            var _haloRadius = fTextStyle.getWidth() || "0";
            var _haloOpacity = "1"; // TODO
            var _font = "Sans"; // TODO

            if (style && style.getElementsByTagName("LabelStyleSimpleExtensionGroup").length === 0) {
                var labelextend = kmlDoc.createElement("LabelStyleSimpleExtensionGroup");
                labelextend.setAttribute("fontFamily", _font);
                labelextend.setAttribute("haloColor", _haloColor);
                labelextend.setAttribute("haloRadius", _haloRadius);
                labelextend.setAttribute("haloOpacity", _haloOpacity);
                style.appendChild(labelextend);
            }
        }
    };

    /**
     * C'est un marker !
     * On va donc ajouter la balise hotspot :
     *  Traiter le cas où les unités sont de type
     *   - FRACTION
     *   - PIXELS
     *  Insertion du correctif dans le noeud : <PlaceMark><Style>IconStyle
     *
     * @param {Object} feature - ol feature
     * @param {DOMElement} style - style
     *
     *  @example
     *  <Style><IconStyle>
     *      <hotSpot x="0.5"  y="1" xunits="fraction" yunits="fraction"/>
     *  </IconStyle></Style>
     */
    var __createHotSpotStyleIcon = function __createHotSpotStyleIcon(feature, style) {
        // logger.trace("marker with style (hotspot):", style);

        if (!feature) {
            return;
        }

        // Si pas de style defini, c'est donc que l'on va utiliser celui par defaut...
        if (feature.getStyle() instanceof _ol2.default.style.Style) {
            var fImageStyle = feature.getStyle().getImage();

            if (!fImageStyle) {
                return;
            }

            var x = 0;
            var y = 0;
            var xunits = "pixels";
            var yunits = "pixels";

            var size = fImageStyle.getSize();
            var anchor = fImageStyle.getAnchor(); // pixels ! but anchor_ in the current unit !

            if (anchor.length) {
                x = anchor[0];
                y = anchor[1];
                if (yunits === "fraction") {
                    y = anchor[1] === 1 ? 0 : 1 - anchor[1]; // cf. fixme contribution à faire !
                } else {
                    y = yunits === "pixels" && anchor[1] === size[1] ? 0 : size[1] - anchor[1]; // cf. fixme contribution à faire !
                }
            }

            if (style && style.getElementsByTagName("hotSpot").length === 0) {
                var hotspot = kmlDoc.createElement("hotSpot");
                hotspot.setAttribute("x", x);
                hotspot.setAttribute("y", y);
                hotspot.setAttribute("xunits", xunits);
                hotspot.setAttribute("yunits", yunits);
                style.appendChild(hotspot);
            }
        }
    };

    // TODO
    var __createStyleToFeatureIconLabel = function __createStyleToFeatureIconLabel(feature, iconStyle, labelStyle) {
        // logger.trace("write an icon with a label");
        __createHotSpotStyleIcon(feature, iconStyle);
        __createExtensionStyleLabel(feature, labelStyle);
    };

    // TODO
    var __setNameData = function __setNameData(feature, tags) {
        for (var i = 0; i < tags.length; i++) {
            var tag = tags[i];
            if (tag.nodeName === "name") {
                return;
            }
        }

        var labelName = feature.getProperties().name;
        if (labelName) {
            var name = kmlDoc.createElement("name");
            name.innerHTML = labelName;
            tags.appendChild(name);
        }
    };

    // On ajoute les styles étendus dans le DOM
    _kmlRead(kmlDoc, features, {
        labelStyle: __createExtensionStyleLabel,
        iconStyle: __createHotSpotStyleIcon,
        iconLabelStyle: __createStyleToFeatureIconLabel,
        nameData: __setNameData
    });

    // On convertit le DOM en String...
    var kmlStringExtended = _kmlToString(kmlDoc);

    // au cas où...
    if (kmlStringExtended === null) {
        kmlStringExtended = kmlString;
    }

    // On realise un formattage du KML
    var kmlStringFormatted = _kmlFormattedToString(kmlStringExtended);

    // au cas où...
    if (kmlStringFormatted === null) {
        kmlStringFormatted = kmlString;
    }

    return kmlStringFormatted;
};

/**
 * Read Extend Styles for Features.
 * This function overloads ol.format.KML.readFeatures ...
 *
 * @see ol.format.KML.prototype.readFeatures
 * @param {Document|Node|ArrayBuffer|Object|String} source - Source.
 * @param {olx.format.ReadOptions=} options - options.
 * @return {Array.<ol.Feature>} Features.
 */
KML.prototype.readFeatures = function (source, options) {
    // KML.prototype._parentReadFeatures = ol.format.KML.prototype.readFeatures;
    logger.log("overload : ol.format.KML.readFeatures");
    var features = this._readExtendStylesFeatures(source, options);
    // logger.trace("Styles étendus", features);

    // la gestion des styles est deplacée au niveau des extensions
    // qui ont besoin de lire un KML (ex. Drawing) ...
    //
    // features.forEach(function (feature) {
    //     var featureStyleFunction = feature.getStyleFunction();
    //     if (featureStyleFunction) {
    //         var styles = featureStyleFunction.call(feature, 0);
    //         if (styles && styles.length !== 0) {
    //             feature.setStyle(styles[0]);
    //         }
    //     }
    // });

    return features;
};

/**
 * _readExtendStylesFeatures
 *
 * @param {(Document|Node|ArrayBuffer|Object|String)} source - source
 * @param {olx.format.ReadOptions=} options - options
 *
 * @returns {Object[]} features
 *
 * @private
 */
KML.prototype._readExtendStylesFeatures = function (source, options) {
    var features = _ol2.default.format.KML.prototype.readFeatures.call(this, source, options);

    var kmlDoc = null;
    var kmlString = "";

    if (typeof source === "string") {
        kmlString = source;
    } else {
        kmlString = source.documentElement.outerHTML;
    }

    // On 'deformatte' le KML afin d'eviter des pb de parsing...
    kmlString = kmlString.replace(/\n/g, "");
    kmlString = kmlString.replace(/(>)\s*(<)/g, "$1$2");

    // On met en place un Parser sur le KML
    kmlDoc = _kmlParse(kmlString);

    if (kmlDoc === null) {
        // au cas où...
        return features;
    }

    /**
     * Gestion des styles étendus sur le Label
     * - ajout d'un icone par defaut (1x1p transparent) sur les labels
     * s'il n'existe pas !
     * - lecture des styles étendus des labels
     *
     * @param {Object} feature - ol feature
     * @param {DOMElement} style - style
     *
     * @example
     * <Placemark>
     *  <description>Un label</description>
     *  <name>C'est un label étendu !</name>
     *  <Style>
     *    <IconStyle>
     *      <Icon>
     *        <href>data:image/png;base64,...</href>
     *      </Icon>
     *    </IconStyle>
     *    <LabelStyle>
     *      <color>ffffffff</color>
     *      <colorMode>normal</colorMode>
     *      <scale>1.85</scale>
     *      <LabelStyleSimpleExtensionGroup haloColor="16711680" haloRadius="5" haloOpacity="1"/>
     *    </LabelStyle>
     *  </Style>
     *  <Point>
     *    <coordinates>2,48</coordinates>
     *  </Point>
     * </Placemark>
     */
    var __getExtensionStyleToFeatureLabel = function __getExtensionStyleToFeatureLabel(feature, style) {
        // logger.trace("label with style :", style);

        if (!feature) {
            return;
        }

        // KML Colors (AABBGGRR) To RGB Colors (RRGGBB)
        function __convertKMLColorsToRGB(data) {
            var color = "";
            color = color + data.substr(6, 2);
            color = color + data.substr(4, 2);
            color = color + data.substr(2, 2);
            var hex = parseInt(color, 16).toString(16);
            var comp = "";
            var len = hex.length || 0;
            for (var i = 0; i < 6 - len; i++) {
                comp += "0";
            }
            hex = "#" + comp + hex;
            return hex.toString(16);
        }

        var _text = feature.getProperties().name || "---";
        var _color = __convertKMLColorsToRGB("ff000000"); // "#000000"
        var _colorHalo = "#FFFFFF";
        var _radiusHalo = 0;
        var _font = "Sans"; // TODO
        var _fontSize = "16px"; // TODO

        // On recherche les balises du Style
        var bLabelStyleSimpleExtensionGroup = false;
        var styles = style.childNodes;
        for (var k = 0; k < styles.length; k++) {
            switch (styles[k].nodeName) {
                case "scale":
                    // TODO
                    break;
                case "colorMode":
                    // TODO
                    break;
                case "color":
                    _color = __convertKMLColorsToRGB(styles[k].textContent);
                    break;
                case "LabelStyleSimpleExtensionGroup":
                    bLabelStyleSimpleExtensionGroup = true;
                    var attributs = styles[k].attributes;
                    for (var l = 0; l < attributs.length; l++) {
                        switch (attributs[l].nodeName) {
                            case "fontFamily":
                                // TODO
                                break;
                            case "haloColor":
                                _colorHalo = __convertKMLColorsToRGB(attributs[l].nodeValue);
                                break;
                            case "haloRadius":
                                _radiusHalo = parseInt(attributs[l].nodeValue, 10);
                                break;
                            case "haloOpacity":
                                // TODO
                                break;
                            default:
                        }
                    }
                    break;
                default:
                // on ne traite pas les autres informations ...
            }
        }

        // Ce n'est pas un style étendu !
        if (!bLabelStyleSimpleExtensionGroup) {
            // logger.trace("it's not a Label Style Simple Extension Group !");
            return;
        }

        // On reconstruit le style !
        feature.setStyle(new _ol2.default.style.Style({
            image: new _ol2.default.style.Icon({
                src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGNiYAAAAAkAAxkR2eQAAAAASUVORK5CYII=",
                size: [51, 38],
                anchor: [25.5, 38],
                anchorOrigin: "top-left",
                anchorXUnits: "pixels",
                anchorYUnits: "pixels"
            }),
            text: new _ol2.default.style.Text({
                font: _fontSize + " " + _font,
                textAlign: "left",
                text: _text,
                // offsetX : 5, // FIXME valeur arbitraire MAIS esthétique !
                fill: new _ol2.default.style.Fill({
                    color: _color
                }),
                stroke: new _ol2.default.style.Stroke({
                    color: _colorHalo,
                    width: _radiusHalo
                })
            })
        }));
    };

    /**
     * Gestion de la balise kml:hostSpot sur les styles d'un Marker
     * - problème avec 'hotspot y === 0' (?)
     *
     * @param {Object} feature - ol feature
     * @param {DOMElement} style - style
     *
     * @example
     * <Placemark>
     *   <Style>
     *     <IconStyle>
     *       <Icon>
     *         <href>data:image/png;base64,...</href>
     *       </Icon>
     *       <hotSpot x="25.5" y="0" xunits="pixels" yunits="pixels"/>
     *     </IconStyle>
     *   </Style>
     *   <Point>
     *     <coordinates>2,48</coordinates>
     *   </Point>
     * </Placemark>
     */
    var __getHotSpotStyleToFeatureIcon = function __getHotSpotStyleToFeatureIcon(feature, style) {
        // logger.trace("hotspot :", style);

        var _src = null;
        var _scale = null;

        var _bSizeIcon = false;
        var _sizeW = 51;
        var _sizeH = 38;

        var _bHotSpot = false;
        var _anchorX = 25.5;
        var _anchorXUnits = "pixels";
        var _anchorY = 38;
        var _anchorYUnits = "pixels";

        var styles = style.childNodes;
        for (var k = 0; k < styles.length; k++) {
            switch (styles[k].nodeName) {
                case "Icon":
                    var nodes = styles[k].childNodes;
                    for (var i = 0; i < nodes.length; i++) {
                        switch (nodes[i].nodeName) {
                            case "href":
                                _src = nodes[i].textContent;
                                break;
                            case "gx:w":
                                _bSizeIcon = true;
                                _sizeW = parseFloat(nodes[i].textContent);
                                break;
                            case "gx:h":
                                _bSizeIcon = true;
                                _sizeH = parseFloat(nodes[i].textContent);
                                break;
                            default:
                        }
                    }
                    break;
                case "hotSpot":
                    _bHotSpot = true;
                    var attributs = styles[k].attributes;
                    for (var l = 0; l < attributs.length; l++) {
                        switch (attributs[l].nodeName) {
                            case "x":
                                _anchorX = parseFloat(attributs[l].nodeValue);
                                break;
                            case "y":
                                _anchorY = parseFloat(attributs[l].nodeValue);
                                break;
                            case "yunits":
                                _anchorXUnits = attributs[l].nodeValue;
                                break;
                            case "xunits":
                                _anchorYUnits = attributs[l].nodeValue;
                                break;
                            default:
                        }
                    }
                    break;
                case "scale":
                    _scale = parseFloat(styles[k].textContent);
                    break;
                default:
                // on ne traite pas les autres informations ...
            }
        }

        var _options = {
            src: _src,
            crossOrigin: "anonymous", // cf. https://gis.stackexchange.com/questions/121555/wms-server-with-cors-enabled/147403#147403
            scale: _scale || 1 // FIXME !?
        };

        if (_bSizeIcon) {
            _Utils2.default.mergeParams(_options, {
                size: [_sizeW, _sizeH]
            });
        }

        if (_bHotSpot) {
            _Utils2.default.mergeParams(_options, {
                anchor: [_anchorX, _anchorY],
                anchorOrigin: "bottom-left",
                anchorXUnits: _anchorXUnits || "pixels",
                anchorYUnits: _anchorYUnits || "pixels"
            });
        }

        // existe il déjà le style du label ?
        var featureStyleFunction = feature.getStyleFunction();
        if (featureStyleFunction) {
            var _styles = featureStyleFunction.call(feature, 0);
            if (_styles && _styles.length !== 0) {
                var _style = _styles.length === 1 ? _styles[0] : _styles[_styles.length - 1];
                // on écrase l'icone magic du label !
                feature.setStyle(new _ol2.default.style.Style({
                    image: new _ol2.default.style.Icon(_options),
                    text: _style.getText()
                }));
            }
        }
    };

    /**
     * Gestion de la balise kml:ExtendedData
     *
     * @param {Object} feature - ol feature
     * @param {DOMElement[]} extend - extend
     *
     * @example
     * //--> Marker (Point), LineString, Polygon
     * <ExtendedData>
     *    <Data name="attributetitle">
     *        <displayName>title</displayName>
     *        <value>Titre à concatener avec la valeur de la balise "kml:description"</value>
     *    </Data>
     * </ExtendedData>
     * //--> Label
     * <ExtendedData>
     *    <Data name="label">
     *        <value>PARIS</value> // valeur à remplacer dans "kml:name"
     *    </Data>
     *    <Data name="attributetitle">
     *        <displayName>title</displayName>
     *        <value>Titre à concatener avec la valeur de la balise "kml:description"</value>
     *    </Data>
     * </ExtendedData>
     */
    var __getExtendedData = function __getExtendedData(feature, extend) {
        // logger.trace("extendData :", extend);

        if (!feature) {
            return;
        }

        var _fname = feature.getProperties().name || "";
        var _fdescription = feature.getProperties().description || "";
        var _ftitle = null;
        for (var i = 0; i < extend.length; i++) {
            var data = extend[i];
            var name = data.attributes[0]; // 1 seul attribut !
            var nodes = data.childNodes;
            if (name.nodeName === "name") {
                switch (name.nodeValue) {
                    // compatibilité ancien geoportail !
                    case "label":
                        _fname = data.textContent;
                        break;
                    // compatibilité ancien geoportail !
                    case "title":
                    case "attributetitle":
                        for (var j = 0; j < nodes.length; j++) {
                            if (nodes[j].nodeName === "value") {
                                _ftitle = nodes[j].textContent;
                            }
                        }
                        break;
                    default:
                    // for (var k = 0; k < nodes.length; k++) {
                    //     if (nodes[k].nodeName === "value") {
                    //         _fdescription += "<br>";
                    //         _fdescription += nodes[k].textContent;
                    //
                    //     }
                    // }
                }
            }
        }

        // Modification des properties "name" et "description"
        if (_ftitle) {
            _fdescription = _fdescription ? _ftitle + " : " + _fdescription : _ftitle;
        }

        feature.setProperties({
            name: _fname,
            description: _fdescription
        });
    };

    /** TODO
    * @param {Object} feature - ol feature
    * @param {DOMElement} iconStyle - icon style
    * @param {DOMElement} labelStyle - label style
    *
    *
    */
    var __getStyleToFeatureIconLabel = function __getStyleToFeatureIconLabel(feature, iconStyle, labelStyle) {
        // logger.trace("display icon and label");
        __getExtensionStyleToFeatureLabel(feature, labelStyle);
        __getHotSpotStyleToFeatureIcon(feature, iconStyle);
    };

    // On lit les styles étendus et on les ajoute aux features
    _kmlRead(kmlDoc, features, {
        labelStyle: this.options.showPointNames ? __getExtensionStyleToFeatureLabel : null,
        iconStyle: __getHotSpotStyleToFeatureIcon,
        iconLabelStyle: this.options.showPointNames ? __getStyleToFeatureIconLabel : __getHotSpotStyleToFeatureIcon,
        extendedData: __getExtendedData
    });

    return features;
};

exports.default = KML;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("interactions");

/**
 * HOWTO
 * Pourquoi et comment l'utiliser ?
 * Cette classe permet de gérer les interactions entre chaque extension.
 * Une extension qui active une interaction avec la carte, doit desactiver
 * les autres interactions issues d'autre extensions.
 * La désactivation d'une interaction s'accompagne d'actions telles que
 * le nettoyage des dessins, l'état du composant graphique, ...
 *
 * Ex
 * // desactive toutes les interactions avec l'opération par defaut : clean
 * Interactions.unset(map);
 * // desactive les interactions sauf celles de Drawing. On execute des
 * // operations particulieres : status, collapse et message
 * Interactions.unset(map, {
 *    current : "Drawing",
 *    status : false,
 *    collapse : true,
 *    messsage : ["WARNING", "Ceci est un avertissement !"]
 * });
 *
 * Dans le code de l'extension, il faut placer des informations dans l'interaction :
 * interaction.setProperties({
 *     name : "Drawing",
 *     source : this
 * });
 */
var Interactions = {

    /**
     * Liste des extensions qui utilisent le mécanisme des interactions
     */
    _extensions: ["Measures", "ElevationPath", "Drawing"],

    /**
     * Options par defaut
     * - current : ex. "Drawing"
     *       c'est l'extension qui demande la desactivation des autres interactions.
     *       Par defaut, toutes les interactions sont desactivées.
     * - clean :
     *       c'est la suppression des interactions, des dessins de la carte,
     *       ainsi que la reinitialisation de l'état graphique.
     *       Les extensions doivent implementer la méthode 'clean()'.
     *       Par defaut, tous les dessins sont supprimés
     */
    _options: {
        current: null,
        clean: null
    },

    /**
     * Permet de desactive les interactions (Draw) de la carte pour les extensions,
     * sauf l'interaction courrante (si elle est renseignée avec l'option 'current').
     * Il est possible d'ajouter des fonctionnalités via les options.
     * Par defaut, l'option 'clean' est renseignée...
     *
     * @param {Object} map - the map
     * @param {Object} options - options
     */
    unset: function unset(map, options) {
        // logger.trace("unset()");

        var opts = {};
        _Utils2.default.mergeParams(opts, this._options);
        _Utils2.default.mergeParams(opts, options);

        var interactions = map.getInteractions().getArray();
        for (var i = 0; i < interactions.length; i++) {
            if (interactions[i].getActive() && (interactions[i] instanceof _ol2.default.interaction.Draw || interactions[i] instanceof _ol2.default.interaction.Select || interactions[i] instanceof _ol2.default.interaction.Modify)) {
                var prop = interactions[i].getProperties();
                var name = prop.name;
                if (typeof name !== "undefined" && this._extensions.indexOf(name) > -1) {
                    // doit on desactiver l'interaction courrante ?
                    if (opts.current && opts.current === name) {
                        continue;
                    }
                    interactions[i].setActive(false);
                    // instance de l'extension
                    var source = prop.source;
                    if (typeof source !== "undefined" && source instanceof _ol2.default.control.Control) {
                        // opérations sur le composant graphique
                        for (var action in opts) {
                            if (opts.hasOwnProperty(action)) {
                                if (action === "current") {
                                    continue;
                                }
                                if (typeof source[action] === "function") {
                                    var args = Array.isArray(opts[action]) ? opts[action] : [opts[action]];
                                    source[action].apply(source, args);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};

exports.default = Interactions;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _ProxyUtils = __webpack_require__(13);

var _ProxyUtils2 = _interopRequireDefault(_ProxyUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import $__xmldom from "xmldom";

var logger = _LoggerByDefault2.default.getLogger("GfiUtils");

var GfiUtils = {

    /**
     * Return layer format
     *
     * @param {ol.layer.Layer} l - layer openlayers
     *
     * @return {String} format - layer format can be wms, wmts, vector or unknown
     *
     */
    getLayerFormat: function getLayerFormat(l) {
        var source = l.getSource();
        if (source instanceof _ol2.default.source.TileWMS || source instanceof _ol2.default.source.ImageWMS) {
            return "wms";
        }
        if (source instanceof _ol2.default.source.WMTS) {
            return "wmts";
        }
        if (source instanceof _ol2.default.source.Vector || source instanceof _ol2.default.source.VectorTile) {
            return "vector";
        }
        return "unknown";
    },

    /**
     * Info Popup creation and display
     *
     * @param {ol.Map} map - map openlayers
     * @param {ol.Coordinate} coords - coordinates where to anchor popup.
     * @param {String} content - content to display
     * @param {String} [contentType='text/html'] - content mime-type
     * @param {Object} autoPanOptions - Auto-pan pop-up options
     * @param {Boolean} [autoPanOptions.autoPan] - Specifies whether the map should auto-pan if the pop-up is rendered outside of the canvas
     * @param {olx.OverlayPanOptions} [autoPanOptions.autoPanAnimation] - Used to customize the auto-pan animation. See {@link https://openlayers.org/en/latest/apidoc/olx.html#.OverlayPanOptions olx.OverlayPanOptions}.
     * @param {Number} [autoPanOptions.autoPanMargin] - Margin (in pixels) between the pop-up and the border of the map when autopanning. Default is 20.
     * @return {Boolean} displayed - indicates if something has been displayed
     */
    displayInfo: function displayInfo(map, coords, content, contentType, autoPanOptions) {
        // logger.trace("[GfiUtils] : displayInfo...");

        if (!contentType) {
            contentType = "text/html";
        }

        if (content === null) {
            return;
        }

        var _htmlDoc = null;
        var _parser = null;

        var _content = content;
        _content = _content.replace(/\n/g, "");
        _content = _content.replace(/(>)\s*(<)/g, "$1$2");

        var scope = typeof window !== "undefined" ? window : null;

        if (( false ? "undefined" : _typeof(exports)) === "object" && window === null) {
            // code for nodejs
            var DOMParser = __webpack_require__(11).DOMParser;
            _parser = new DOMParser();
            _htmlDoc = _parser.parseFromString(_content, contentType);
        } else if (scope.DOMParser) {
            // code for modern browsers
            _parser = new scope.DOMParser();
            _htmlDoc = _parser.parseFromString(_content, contentType);
        } else if (scope.ActiveXObject) {
            // code for old IE browsers
            _htmlDoc = new scope.ActiveXObject("Microsoft.XMLDOM");
            _htmlDoc.async = false;
            _htmlDoc.loadXML(_content);
        } else {
            logger.log("Incompatible environment for DOM Parser !");
            return false;
        }

        var body = _htmlDoc.getElementsByTagName("body");
        if (body && body.length === 1) {
            if (!body[0].hasChildNodes()) {
                return false;
            }
        }

        // Affichage des features.
        var element = document.createElement("div");
        element.className = "gp-feature-info-div";

        var closer = document.createElement("input");
        closer.type = "button";
        closer.className = "gp-styling-button closer";

        // fait disparaître la popup au clic sur x
        closer.onclick = function () {
            if (map.featuresOverlay) {
                map.removeOverlay(map.featuresOverlay);
                map.featuresOverlay = null;
            }
            return false;
        };

        var contentDiv = document.createElement("div");
        contentDiv.className = "gp-features-content-div";
        contentDiv.innerHTML = content;
        /*
        if (content instanceof HTMLElement) {
            // this.// logger.trace("[Openlayers] : _displayInfo : pure HTMLElement") ;
            contentDiv.appendChild(content) ;
        } else {
            var parser = new DOMParser() ;
            var doc = null ;
            try {
                doc = parser.parseFromString(content,contentType) ;
                // this.// logger.trace("[Openlayers] : _displayInfo : HTMLElement from parser") ;
                // FIXME : avec cette methode, on a une balise html + body qui s'insère...
                contentDiv.appendChild(doc.documentElement) ;
            } catch (e) {
                // console.log(e) ;
                // this.// logger.trace("[Openlayers] : _displayInfo : parsing content failed (not HTML)") ;
                // en cas d'erreur : on se contente de recopier le contenu.
                contentDiv.innerHTML = content ;
            }
        }
        */
        element.appendChild(contentDiv);
        element.appendChild(closer);

        if (map.featuresOverlay) {
            // fermeture d'une éventuelle popup déjà ouverte.
            map.removeOverlay(map.featuresOverlay);
            map.featuresOverlay = null;
        }
        map.featuresOverlay = new _ol2.default.Overlay({
            // id : id,
            element: element,
            autoPan: autoPanOptions.autoPan,
            autoPanAnimation: autoPanOptions.autoPanAnimation,
            autoPanMargin: autoPanOptions.autoPanMargin,
            positioning: "bottom-center",
            insertFirst: false, // popup appears on top of other overlays if any
            stopEvent: true
        });
        map.addOverlay(map.featuresOverlay);
        map.featuresOverlay.setPosition(coords);
        map.featuresOverlay.render();

        return true;
    },

    /**
     * Gets HTML content from features array
     *
     * @param {ol.Map} map - map openlayers
     * @param {Array.<ol.Features>} features - openlayers features Array
     * @returns {HTMLElement} HTML content.
     */
    features2html: function features2html(map, features) {
        var content = document.createElement("div");
        features.forEach(function (f) {
            var props = f.getProperties();
            if (props.hasOwnProperty("name")) {
                var nameDiv = document.createElement("div");
                nameDiv.className = "gp-att-name-div";
                // nameDiv.appendChild(document.createTextNode(props["name"])) ;
                nameDiv.insertAdjacentHTML("afterbegin", props["name"]);
                content.appendChild(nameDiv);
            }
            if (props.hasOwnProperty("description")) {
                var descDiv = document.createElement("div");
                descDiv.className = "gp-att-description-div";
                // descDiv.appendChild(document.createTextNode(props["description"])) ;
                descDiv.insertAdjacentHTML("afterbegin", props["description"]);
                content.appendChild(descDiv);
            }
            var p = null;
            var others = false;
            var oDiv = null;
            var ul = null;
            var li = null;
            for (p in props) {
                if (p === "geometry" || p === "value" || p === "name" || p === "description" || p === "styleUrl") {
                    continue;
                }
                // FIXME La lecture des extensions GPX n'est pas gérée !
                if (p === "extensionsNode_" && props[p] === undefined) {
                    continue;
                }
                if (!others) {
                    oDiv = document.createElement("div");
                    oDiv.className = "gp-att-others-div";
                    ul = document.createElement("ul");
                    others = true;
                }
                li = document.createElement("li");
                var span = document.createElement("span");
                span.className = "gp-attname-others-span";
                span.appendChild(document.createTextNode(p + " : "));
                li.appendChild(span);
                li.appendChild(document.createTextNode(props[p]));
                ul.appendChild(li);
            }
            if (ul) {
                oDiv.appendChild(ul);
                content.appendChild(oDiv);
            }
        }, map);

        // pas de contenu !
        if (!content.hasChildNodes()) {
            content = null;
        }

        return content;
    },

    /**
     * Indicates if there is a feature at the given coordinates for the given layer
     *
     * @param {ol.Map} map - map openlayers
     * @param {ol.layer.Layer} olLayer - vector layer openlayers
     * @param {ol.Coordinate} olCoordinate - coordinates pointed by user
     *
     * @return {Boolean} has feature
     *
     */
    layerGetFeatureAtCoordinates: function layerGetFeatureAtCoordinates(map, olLayer, olCoordinate) {
        var pixel = map.getPixelFromCoordinate(olCoordinate);
        return map.hasFeatureAtPixel(pixel, function (layer) {
            if (layer === olLayer) {
                return true;
            }
            return false;
        });
    },

    /**
     * Get information from all the features located at the specified coordinates
     * and belonging to the layers list argument. Those information are gathered
     * and displayed in an info popup.
     *
     * @param {ol.Map} map - map openlayers
     * @param {ol.Coordinate} olCoordinate - coordinates pointed by user
     * @param {Array.<ol.layer.Layer>} olLayers - layers requested
     * @param {Object} autoPanOptions - autopan options
     *
     * @returns {Boolean} something is displayed
     *
     */
    displayVectorFeatureInfo: function displayVectorFeatureInfo(map, olCoordinate, olLayers, autoPanOptions) {
        var pixel = map.getPixelFromCoordinate(olCoordinate);

        // couches vecteur : on remplit un tableau avec les features à proximité.
        var features = [];
        map.forEachFeatureAtPixel(pixel, function (feature, layer) {
            if (!olLayers || olLayers.indexOf(layer) > -1) {
                features.push(feature);
            }
        });
        if (features.length === 0) {
            // no features
            return false;
        }
        var content = this.features2html(map, features);
        // pas de contenu !
        if (content === null) {
            return false;
        }
        // Affichage des features.
        this.displayInfo(map, olCoordinate, content.innerHTML, "text/html", autoPanOptions);
        // this._displayInfo(evt.coordinate,content,"text/html") ;
        return true;
    },

    /**
     * Method to manage the request of information from a list of layers already added to the map.
     * Among the given list of layers only the visible ones are requested.
     * The priority is given to the upper layer having a feature at the pointed coordinates.
     * If the first (upper) feature encountered is from a vector layer the info popup will
     * display the information of the features from all visible vector layers and located at
     * the specified coordinates.
     *
     * @param {ol.Map} map - map openlayers
     * @param {ol.Coordinate} olCoordinate - coordinates pointed by user
     * @param {Array.<Object>} gfiLayers - list of layers which can be requested through the control. Each array element is an object, with following properties :
     * @param {ol.layer.Layer} gfiLayers.obj - ol.layer.Layer layer handled by the control (that has been added to map).
     * @param {String} [gfiLayers.event] - name of the mouse event triggering getFeatureInfo on this layer (that has been added to map). allowed values are : 'singleclick', 'dblclick' and 'contextmenu'
     * @param {String} [gfiLayers.infoFormat] - indicates the format mime-type of the response of GetFeatureInfo requests.
     * @param {Object} [proxyOptions] - options for poxy configuration :
     * @param {String} [proxyOptions.proxyUrl] - Proxy URL to avoid cross-domain problems, if not already set in mapOptions. Mandatory to import WMS and WMTS layer.
     * @param {Array.<String>} [proxyOptions.noProxyDomains] - Proxy will not be used for this list of domain names. Only use if you know what you're doing (if not already set in mapOptions).
     * @param {Object} [autoPanOptions] - Auto-pan pop-up options
     * @param {Boolean} [autoPanOptions.autoPan = true] - Specifies whether the map should auto-pan if the pop-up is rendered outside of the canvas. Defaults to true.
     * @param {olx.OverlayPanOptions} [autoPanOptions.autoPanAnimation] - Used to customize the auto-pan animation. See {@link https://openlayers.org/en/latest/apidoc/olx.html#.OverlayPanOptions olx.OverlayPanOptions}.
     * @param {Number} [autoPanOptions.autoPanMargin] - Margin (in pixels) between the pop-up and the border of the map when autopanning. Default is 20.
     *
     */
    displayFeatureInfo: function displayFeatureInfo(map, olCoordinate, gfiLayers, proxyOptions, autoPanOptions) {
        // Layers orders
        var layersOrdered = {};
        for (var j = 0; j < gfiLayers.length; j++) {
            var layer = gfiLayers[j];
            var position = layer.obj.getZIndex();
            if (!layersOrdered[position]) {
                layersOrdered[position] = [];
            }
            layersOrdered[position].push(layer);
        }

        // affichage de la première popup d'informations en partant du dessus...
        var requests = [];
        // inversion de l'ordre des layers
        var positions = Object.keys(layersOrdered);
        positions.sort(function (a, b) {
            return b - a;
        });

        // si la 1ere couche affichable est de type vecteur on affiche les infos de toutes
        // les couches vecteur qui suivent. Par consequent, une seule requete vecteur suffit
        // (celle correspondant au premier objet vecteur rencontre)
        var foundFeature = false;

        for (var k = 0; k < positions.length; k++) {
            var p = positions[k];
            for (var h = 0; h < layersOrdered[p].length; ++h) {
                var l = layersOrdered[p][h].obj;
                var infoFormat = layersOrdered[p][h].infoFormat || "text/html";
                var minMaxResolutionOk = true;
                if (l.minResolution && l.minResolution > map.getResolution()) {
                    minMaxResolutionOk = false;
                }
                if (minMaxResolutionOk && l.maxResolution && l.maxResolution < map.getResolution()) {
                    minMaxResolutionOk = false;
                }

                if (l.getVisible() && minMaxResolutionOk) {
                    var format = this.getLayerFormat(l);
                    if (format === "vector") {
                        if (!foundFeature && this.layerGetFeatureAtCoordinates(map, l, olCoordinate)) {
                            requests.push({
                                format: format,
                                scope: this,
                                coordinate: olCoordinate
                            });
                        }
                        continue;
                    } else if (format !== "wms" && format !== "wmts") {
                        logger.log("[ERROR] DisplayFeatureInfo - layer format '" + format + "' not allowed");
                        continue;
                    }

                    var _res = map.getView().getResolution();
                    var _url = null;
                    if (format === "wmts") {
                        _url = l.getSource().getGetFeatureInfoUrl(olCoordinate, _res, map.getView().getProjection(), {
                            INFOFORMAT: infoFormat
                        });
                    } else {
                        _url = l.getSource().getGetFeatureInfoUrl(olCoordinate, _res, map.getView().getProjection(), {
                            INFO_FORMAT: infoFormat
                        });
                    }

                    requests.push({
                        // id : _id,
                        format: infoFormat,
                        url: _ProxyUtils2.default.proxifyUrl(_url, proxyOptions),
                        scope: this,
                        coordinate: olCoordinate
                    });
                }
            }
        }

        // on recupere les couches vecteur ordonnees (a utiliser dans le cas de l'affichage de donnees vecteur)
        var vectorLayersOrdered = null;

        // call request sync
        function requestsSync(list, iterator, callback) {
            if (list.length === 0) {
                return;
            }
            var nextItemIndex = 0;
            // function report next request
            function report(displayed) {
                nextItemIndex++;
                if (displayed || nextItemIndex === list.length) {
                    callback();
                } else {
                    iterator(list[nextItemIndex], report);
                }
            }
            // instead of starting all the iterations, we only start the 1st one
            iterator(list[0], report);
        };

        var context = this;

        requestsSync(requests, function (data, report) {
            if (data.format === "vector") {
                if (!vectorLayersOrdered) {
                    vectorLayersOrdered = [];
                    for (var m = 0; m < positions.length; m++) {
                        var p = positions[m];
                        for (var n = 0; n < layersOrdered[p].length; ++n) {
                            vectorLayersOrdered.push(layersOrdered[p][n].obj);
                        }
                    }
                }
                report(data.scope.displayVectorFeatureInfo(map, data.coordinate, vectorLayersOrdered, autoPanOptions));
            } else {
                // var self = data.scope;
                _gp2.default.Protocols.XHR.call({
                    url: data.url,
                    method: "GET",
                    scope: data.scope,
                    // Handles GFI response
                    onResponse: function onResponse(resp) {
                        var exception = false;

                        // a t on une exception ?
                        if (resp.trim().length === 0 || resp.indexOf("java.lang.NullPointerException") !== -1 || resp.indexOf("not queryable") !== -1) {
                            // rien à afficher
                            exception = true;
                        }

                        // on affiche la popup GFI !
                        var displayed = !exception && context.displayInfo(map, data.coordinate, resp, "text/html", autoPanOptions);
                        // on reporte sur la prochaine requête...
                        report(displayed);
                    },
                    // Handles GFI response error
                    onFailure: function onFailure(error) {
                        logger.log(error);
                        report(false);
                    }
                });
            }
        }, function () {
            // logger.trace("Finish sync to GFI !");
        });
    },

    // Function returning the clicked position of an event
    getPosition: function getPosition(e, map) {
        if (e.coordinate) {
            return e.coordinate;
        }

        var pixel = [0, 0];

        if (e.offsetX || e.offsetY) {
            pixel[0] = e.offsetX; // + document.body.scrollLeft + document.documentElement.scrollLeft;
            pixel[1] = e.offsetY; // + document.body.scrollTop + document.documentElement.scrollTop;
        } else if (e.pointerType === "touch") {
            // a implementer !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

            // Safari iOS / iPhone en mode Touch (cf. hammer)
            var p = e.pointers[0];
            pixel[0] = p.pageX;
            pixel[1] = p.pageY;
        }

        var coordinate = map.getCoordinateFromPixel(pixel);
        return coordinate;
    },

    // onDisplayFeatureInfo
    onDisplayFeatureInfo: function onDisplayFeatureInfo(e, gfiObj) {
        if (!gfiObj.isActive()) {
            return;
        }

        // logger.trace(e);

        var map = gfiObj.getMap();

        if (e.type === "contextmenu" || e.type === "dblclick") {
            e.preventDefault();
        } else if (e.type === "singleclick") {
            var interactions = map.getInteractions().getArray();
            for (var i = 0; i < interactions.length; i++) {
                if (interactions[i].getActive() && (interactions[i] instanceof _ol2.default.interaction.Select || interactions[i] instanceof _ol2.default.interaction.Modify || interactions[i] instanceof _ol2.default.interaction.Draw)) {
                    // si on a une interaction de dessin ou de sélection en cours, on ne fait rien.
                    return;
                }
            }
        }

        var proxyOptions = {};
        if (gfiObj._proxyUrl) {
            proxyOptions.proxyUrl = gfiObj._proxyUrl;
        }
        if (gfiObj._noProxyDomains) {
            proxyOptions.noProxyDomains = gfiObj._noProxyDomains;
        }

        var autoPanOptions = {};
        if (gfiObj._autoPan) {
            autoPanOptions.autoPan = gfiObj._autoPan;
        }
        if (gfiObj._autoPanAnimation) {
            autoPanOptions.autoPanAnimation = gfiObj._autoPanAnimation;
        }
        if (gfiObj._autoPanMargin) {
            autoPanOptions.autoPanMargin = gfiObj._autoPanMargin;
        }

        var eventLayers = [];
        for (var j = 0; j < gfiObj._layers.length; ++j) {
            var event = gfiObj._layers[j].event ? gfiObj._layers[j].event : gfiObj._defaultEvent;
            if (event === e.type) {
                var ind = eventLayers.push(gfiObj._layers[j]) - 1;
                if (!eventLayers[ind].infoFormat) {
                    eventLayers[ind].infoFormat = gfiObj._defaultInfoFormat;
                }
            }
        }

        var coords = this.getPosition(e, map);

        this.displayFeatureInfo(map, coords, eventLayers, proxyOptions, autoPanOptions);
    }
};

exports.default = GfiUtils;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @classdesc
 *
 * Extended ol.source.WMTS.
 *
 * @constructor
 * @extends {ol.source.WMTS}
 * @param {Object} options - Options
 */
function WMTS(options) {
    if (!(this instanceof WMTS)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // call constructor
    _ol2.default.source.WMTS.call(this, options);
}

// Inherits
_ol2.default.inherits(WMTS, _ol2.default.source.WMTS);

/*
 * @lends module:KML
 */
WMTS.prototype = Object.create(_ol2.default.source.WMTS.prototype, {});

/**
 * Constructor (alias)
 */
WMTS.prototype.constructor = WMTS;

/**
 * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
 * projection. Return `undefined` if the GetFeatureInfo URL cannot be
 * constructed.
 * @param {ol.Coordinate} coordinate - Coordinate.
 * @param {Number} resolution - Resolution.
 * @param {ol.proj.Projection} projection - Projection.
 * @param {!Object} params - GetFeatureInfo params. `INFOFORMAT` at least should
 *     be provided.
 * @return {String|undefined} GetFeatureInfo URL.
 */
WMTS.prototype.getGetFeatureInfoUrl = function (coordinate, resolution, projection, params) {
    var pixelRatio = this.option && this.options.tilePixelRatio ? this.options.tilePixelRatio : 1;

    var tileGrid = this.tileGrid;
    var tileCoord = this.tileGrid.getTileCoordForCoordAndResolution(coordinate, resolution);

    // this code is duplicated from createFromWMTSTemplate function
    var getTransformedTileCoord = function getTransformedTileCoord(tileCoord, tileGrid, projection) {
        var tmpTileCoord = [0, 0, 0]; /* Note : [z(zoomLevel),x,y] */
        var tmpExtent = _ol2.default.extent.createEmpty();
        var x = tileCoord[1];
        var y = -tileCoord[2] - 1;
        var tileExtent = tileGrid.getTileCoordExtent(tileCoord);
        var projectionExtent = projection.getExtent();
        var extent = projectionExtent;

        if (extent != null && projection.isGlobal() && extent[0] === projectionExtent[0] && extent[2] === projectionExtent[2]) {
            var numCols = Math.ceil(_ol2.default.extent.getWidth(extent) / _ol2.default.extent.getWidth(tileExtent));
            x = x % numCols;
            tmpTileCoord[0] = tileCoord[0];
            tmpTileCoord[1] = x;
            tmpTileCoord[2] = tileCoord[2];
            tileExtent = tileGrid.getTileCoordExtent(tmpTileCoord, tmpExtent);
        }
        if (!_ol2.default.extent.intersects(tileExtent, extent) /* || ol.extent.touches(tileExtent, extent) */) {
                return null;
            }
        return [tileCoord[0], x, y];
    };

    var tileExtent = tileGrid.getTileCoordExtent(tileCoord);
    var transformedTileCoord = getTransformedTileCoord(tileCoord, tileGrid, projection);

    if (tileGrid.getResolutions().length <= tileCoord[0]) {
        return undefined;
    }

    var tileResolution = tileGrid.getResolution(tileCoord[0]);
    var tileMatrix = tileGrid.getMatrixIds()[tileCoord[0]];

    var baseParams = {
        SERVICE: "WMTS",
        VERSION: "1.0.0",
        REQUEST: "GetFeatureInfo",
        LAYER: this.getLayer(),
        TILECOL: transformedTileCoord[1],
        TILEROW: transformedTileCoord[2],
        TILEMATRIX: tileMatrix,
        TILEMATRIXSET: this.getMatrixSet(),
        FORMAT: this.getFormat() || "image/png",
        STYLE: this.getStyle() || "normal"
    };

    _Utils2.default.assign(baseParams, params);

    /* var tileSize = tileGrid.getTileSize();
    var x = Math.floor(tileSize*((coordinate[0]-tileExtent[0])/(tileExtent[2]-tileExtent[0])));
    var y = Math.floor(tileSize*((tileExtent[3]-coordinate[1])/(tileExtent[3]-tileExtent[1]))); */

    var x = Math.floor((coordinate[0] - tileExtent[0]) / (tileResolution / pixelRatio));
    var y = Math.floor((tileExtent[3] - coordinate[1]) / (tileResolution / pixelRatio));

    baseParams["I"] = x;
    baseParams["J"] = y;

    var url = this.urls[0];

    var featureInfoUrl = _gp2.default.Helper.normalyzeUrl(url, baseParams);

    return featureInfoUrl;
};

exports.default = WMTS;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _proj = __webpack_require__(19);

var _proj2 = _interopRequireDefault(_proj);

var _Register = __webpack_require__(28);

var _Register2 = _interopRequireDefault(_Register);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("CRS");

/**
 * Autoload function that loads all defs into proj4
 * and adds proj4 defs into ol.
 */
(function () {
    // load all defs into proj4
    _Register2.default.load();
    // overload proj4 into ol
    if (!_ol2.default.proj.proj4_ && _ol2.default.proj.setProj4) {
        _ol2.default.proj.setProj4(_proj2.default);
    } else {
        logger.log("WARNING : OpenLayers library should manage proj4 dependency in order to add custom projections (Lambert 93 for instance)");
    }
})();

var CRS = {

    /**
     * Overload OpenLayers ol.proj.transformExtent function,
     * to manage EPSG:2154 extent restriction
     */
    overloadTransformExtent: function overloadTransformExtent() {
        /**
         * Transforms an extent from source projection to destination projection.  This
         * returns a new extent (and does not modify the original).
         * Overload Geoportal Extension for Openlayers : to manage EPSG:2154 extent restriction.
         *
         * @param {ol.Extent} extent - The extent to transform.
         * @param {ol.proj.ProjectionLike} source - Source projection-like.
         * @param {ol.proj.ProjectionLike} destination - Destination projection-like.
         * @return {ol.Extent} extent - The transformed extent.
         */
        _ol2.default.proj.transformExtent = function (extent, source, destination) {
            if (destination === "EPSG:2154") {
                if (source === "EPSG:4326") {
                    // dans le cas d'une transfo 4326->2154,
                    // il faut restreindre l'étendue géographique à l'étendue de validité de Lambert93.
                    if (extent[0] < -9.62) {
                        extent[0] = -9.62;
                    }
                    if (extent[1] < 41.18) {
                        extent[1] = 41.18;
                    }
                    if (extent[2] > 10.3) {
                        extent[2] = 10.3;
                    }
                    if (extent[3] > 51.54) {
                        extent[3] = 51.54;
                    }
                }
            }
            var transformFn = _ol2.default.proj.getTransform(source, destination);
            var transformedExtent = _ol2.default.extent.applyTransform(extent, transformFn);
            return transformedExtent;
        };
    },

    /**
     * Load all overload function
     */
    overload: function overload() {
        // TODO ajouter les fonctions à surcharger...
        this.overloadTransformExtent();
    }
};

exports.default = CRS;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["proj4"] = __webpack_require__(27);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _WMTS = __webpack_require__(17);

var _WMTS2 = _interopRequireDefault(_WMTS);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _Config = __webpack_require__(8);

var _Config2 = _interopRequireDefault(_Config);

var _LayerUtils = __webpack_require__(12);

var _LayerUtils2 = _interopRequireDefault(_LayerUtils);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("sourcewmts");

/**
 * @classdesc
 * Geoportal WMTS source creation (inherit from ol.source.WMTS)
 *
 * @constructor
 * @alias ol.source.GeoportalWMTS
 * @extends {WMTSExtended}
 * @param {Object} options            - options for function call.
 * @param {String} options.layer      - Layer name (e.g. "ORTHOIMAGERY.ORTHOPHOTOS")
 * @param {Boolean} [options.ssl]     - if set true, enforce protocol https (only for nodejs)
 * @param {String} [options.apiKey]   - Access key to Geoportal platform
 * @param {Object} [options.olParams] - other options for ol.source.WMTS function (see {@link http://openlayers.org/en/latest/apidoc/ol.source.WMTS.html ol.source.WMTS})
 * @example
 * var sourceWMTS = new ol.source.GeoportalWMTS({
 *      layer  : "ORTHOIMAGERY.ORTHOPHOTOS"
 * });
 */
/* globals self */
function SourceWMTS(options) {
    if (!(this instanceof SourceWMTS)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // check layer params
    if (!options.layer) {
        throw new Error("ERROR PARAM_MISSING : layer");
    }
    if (typeof options.layer !== "string") {
        throw new Error("ERROR WRONG TYPE : layer");
    }

    // par defaut
    if (typeof options.ssl === "undefined") {
        options.ssl = false;
    }

    // Check if configuration is loaded
    if (!_Config2.default.isConfigLoaded()) {
        throw new Error("ERROR : contract key configuration has to be loaded to load Geoportal layers. See http://ignf.github.io/evolution-apigeoportail/ol3/ol3-autoconf.html");
    }

    var layerId = _Config2.default.getLayerId(options.layer, "WMTS");

    if (layerId && _Config2.default.configuration.getLayerConf(layerId)) {
        var wmtsParams = _Config2.default.getLayerParams(options.layer, "WMTS", options.apiKey);

        // gestion de mixContent dans l'url du service...
        var ctx = typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : null;
        var protocol = ctx ? ctx.location && ctx.location.protocol && ctx.location.protocol.indexOf("https:") === 0 ? "https://" : "http://" : options.ssl ? "https://" : "http://";

        // save originators (to be updated by Originators control)
        this._originators = wmtsParams.originators;

        // save legends and metadata (to be added to LayerSwitcher control)
        this._legends = wmtsParams.legends;
        this._metadata = wmtsParams.metadata;

        var wmtsSourceOptions = {
            // tracker extension openlayers
            // FIXME : gp-ext version en mode AMD
            url: _gp2.default.Helper.normalyzeUrl(wmtsParams.url.replace(/(http|https):\/\//, protocol), {
                "gp-ol-ext": "2.1.0"
            }, false),
            version: wmtsParams.version,
            style: wmtsParams.styles,
            format: wmtsParams.format,
            projection: wmtsParams.projection,
            maxZoom: _LayerUtils2.default.getZoomLevelFromScaleDenominator(wmtsParams.minScale),
            layer: options.layer,
            matrixSet: wmtsParams.TMSLink,
            tileGrid: new _ol2.default.tilegrid.WMTS({
                resolutions: wmtsParams.nativeResolutions,
                matrixIds: wmtsParams.matrixIds,
                origin: [wmtsParams.matrixOrigin.x, wmtsParams.matrixOrigin.y]
            })
            // ,
            // attributions : [
            //     new ol.Attribution({
            //         html : "<a class='gp-control-attribution-link' target='_blank' href='http://www.ign.fr'><img class='gp-control-attribution-image' src='http://wxs.ign.fr/static/logos/IGN/IGN.gif' title='Institut national de l\'information géographique et forestière' style='height: 30px; width: 30px;'></a>"
            //     })
            // ]
        };

        // récupération des autres paramètres passés par l'utilisateur
        _Utils2.default.mergeParams(wmtsSourceOptions, options.olParams);

        // returns a WMTS object, that inherits from WMTSExtended.
        _WMTS2.default.call(this, wmtsSourceOptions);

        // add originators to layer source (to be updated by Originators control)
        this._originators = wmtsParams.originators;

        // add legends and metadata (to be added to LayerSwitcher control)
        this._legends = wmtsParams.legends;
        this._metadata = wmtsParams.metadata;
        this._description = wmtsParams.description;
        this._title = wmtsParams.title;
        this._quicklookUrl = wmtsParams.quicklookUrl;
    } else {
        // If layer is not in Gp.Config
        logger.log("[source WMTS] ERROR : " + options.layer + " cannot be found in Geoportal Configuration. Make sure that this resource is included in your contract key.");
        return new _WMTS2.default({});
    }
}

// Inherits from ol.source.WMTS
_ol2.default.inherits(SourceWMTS, _WMTS2.default);

/*
 * @lends module:SourceWMTS
 */
SourceWMTS.prototype = Object.create(_WMTS2.default.prototype, {});

/*
 * Constructor (alias)
 */
SourceWMTS.prototype.constructor = SourceWMTS;

exports.default = SourceWMTS;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _Config = __webpack_require__(8);

var _Config2 = _interopRequireDefault(_Config);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("sourcewms");

/**
 * @classdesc
 * Geoportal tile WMS source creation (inherit from ol.source.TileWMS)
 *
 * @constructor
 * @alias ol.source.GeoportalWMS
 * @extends {ol.source.TileWMS}
 * @param {Object} options            - options for function call.
 * @param {String} options.layer      - Layer name (e.g. "ORTHOIMAGERY.ORTHOPHOTOS")
 * @param {Boolean} [options.ssl]     - if set true, enforce protocol https (only for nodejs)
 * @param {String} [options.apiKey]   - Access key to Geoportal platform
 * @param {Object} [options.olParams] - other options for ol.source.TileWMS function (see {@link http://openlayers.org/en/latest/apidoc/ol.source.TileWMS.html ol.source.TileWMS})
 * @example
 * var sourceWMS = new ol.source.GeoportalWMS({
 *      layer  : "ORTHOIMAGERY.ORTHOPHOTOS"
 * });
 */
/* globals self */
function SourceWMS(options) {
    if (!(this instanceof SourceWMS)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // check layer params
    if (!options.layer) {
        throw new Error("ERROR PARAM_MISSING : layer");
    }
    if (typeof options.layer !== "string") {
        throw new Error("ERROR WRONG TYPE : layer");
    }

    // par defaut
    if (typeof options.ssl === "undefined") {
        options.ssl = false;
    }

    // Check if configuration is loaded
    if (!_Config2.default.isConfigLoaded()) {
        throw new Error("ERROR : contract key configuration has to be loaded to load Geoportal layers. See http://ignf.github.io/evolution-apigeoportail/ol3/ol3-autoconf.html");
    }

    var layerId = _Config2.default.getLayerId(options.layer, "WMS");

    if (layerId && _Config2.default.configuration.getLayerConf(layerId)) {
        var wmsParams = _Config2.default.getLayerParams(options.layer, "WMS", options.apiKey);

        // gestion de mixContent dans l'url du service...
        var ctx = typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : null;
        var protocol = ctx ? ctx.location && ctx.location.protocol && ctx.location.protocol.indexOf("https:") === 0 ? "https://" : "http://" : options.ssl ? "https://" : "http://";

        var wmsSourceOptions = {
            // tracker extension openlayers
            // FIXME : gp-ext version en mode AMD
            url: _gp2.default.Helper.normalyzeUrl(wmsParams.url.replace(/(http|https):\/\//, protocol), {
                "gp-ol-ext": "2.1.0"
            }, false),
            params: {
                SERVICE: "WMS",
                LAYERS: options.layer,
                VERSION: wmsParams.version,
                STYLES: wmsParams.styles,
                FORMAT: wmsParams.format
                // ,
                // attributions : [
                //     new ol.Attribution({
                //         html : "<a class='gp-control-attribution-link' target='_blank' href='http://www.ign.fr'><img class='gp-control-attribution-image' src='http://wxs.ign.fr/static/logos/IGN/IGN.gif' title='Institut national de l\'information géographique et forestière' style='height: 30px; width: 30px;'></a>"
                //     })
                // ]
            } };

        // récupération des autres paramètres passés par l'utilisateur
        _Utils2.default.mergeParams(wmsSourceOptions, options.olParams);

        // returns a WMS object, that inherits from ol.source.TileWMS.
        _ol2.default.source.TileWMS.call(this, wmsSourceOptions);

        // save originators (to be updated by Originators control)
        this._originators = wmsParams.originators;

        // save legends and metadata (to be added to LayerSwitcher control)
        this._legends = wmsParams.legends;
        this._metadata = wmsParams.metadata;
        this._title = wmsParams.title;
        this._description = wmsParams.description;
        this._quicklookUrl = wmsParams.quicklookUrl;
    } else {
        // If layer is not in Gp.Config
        logger.log("[source WMS] ERROR : " + options.layer + " cannot be found in Geoportal Configuration. Make sure that this resource is included in your contract key.");
        return new _ol2.default.source.TileWMS({});
    }
}

// Inherits from ol.source.TileWMS
_ol2.default.inherits(SourceWMS, _ol2.default.source.TileWMS);

/*
 * @lends module:SourceWMS
 */
SourceWMS.prototype = Object.create(_ol2.default.source.TileWMS.prototype, {});

/*
 * Constructor (alias)
 */
SourceWMS.prototype.constructor = SourceWMS;

exports.default = SourceWMS;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _CheckRightManagement = __webpack_require__(7);

var _CheckRightManagement2 = _interopRequireDefault(_CheckRightManagement);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _LocationSelectorDOM = __webpack_require__(44);

var _LocationSelectorDOM2 = _interopRequireDefault(_LocationSelectorDOM);

var _Markers = __webpack_require__(5);

var _Markers2 = _interopRequireDefault(_Markers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("locationselector");

/**
 * @classdesc
 *
 * LocationSelector component. Enables to select a location, using autocompletion or picking location on the map
 * @param {Object} [options] - component options
 * @param {String} [options.apiKey] - API key for autocomplete service call, mandatory if autoconf service has not been charged in advance
 * @param {Boolean} [options.displayInfo = true] - whether to display info in a popup or not (not implemented yet) Default is true
 * @param {Object} [options.tag] - tag options
 * @param {Number} [options.tag.id = 1] - order id number in a locations group, in case several LocationSelector are used. For instance in route case : departure tag id should be 0, arrival tag id should be 1, and other ones : 2, 3, ...
 * @param {Number} [options.tag.groupId = null] - locationSelector global component id (in case locationSelector is called by another graphic component, e.g. route control)
 * @param {String} [options.tag.label] - text to display in component (e.g. "Departure"). Default is ">"
 * @param {Object} [options.tag.markerOpts] - options to use your own marker. Default is a lightOrange marker.
 * @param {String} [options.tag.markerOpts.url] - marker base64 encoded url (ex "data:image/png;base64,...""). Mandatory for a custom marker
 * @param {Array} [options.tag.markerOpts.offset] - Offsets in pixels used when positioning the overlay. The first element in the array is the horizontal offset. A positive value shifts the overlay right. The second element in the array is the vertical offset. A positive value shifts the overlay down. Default is [0, 0]. (see {@link http://openlayers.org/en/latest/apidoc/ol.Overlay.html ol.Overlay})
 * @param {Boolean} [options.tag.display = true] - whether to display or hide component. Default is true
 * @param {Boolean} [options.tag.addOption = false] - whether to display picto to add another LocationSelector (in case of route control)
 * @param {Boolean} [options.tag.removeOption = false] - whether to display picto to remove a LocationSelector (in case of route control)
 * @param {Object} [options.autocompleteOptions] - autocomplete service options (see {@link http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~autoComplete Gp.Services.autoComplete()} to know all autocomplete options)
 * @example
 *  var locationselector = new LocationSelector({
 *      apiKey : "",
 *      tag : {
 *         id : 1,
 *         groupId : null,
 *         label : "Départ",
 *         markerOpts : {
 *              url : "...",
 *              offset : [0,0]
 *         },
 *         display : true
 *      },
 *      autocompleteOptions : {}
 *  });
 */
function LocationSelector(options) {
    options = options || {};

    if (!(this instanceof LocationSelector)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // initialisation du composant
    this.initialize(options);

    // creation du DOM
    this._container = this._initContainer();

    // on peut éventuellement encapsuler le composant dans une div passée par l'utilisateur
    // (le composant étant positionné en relatif, il doit être positionné dans une div si utilisé seul)
    if (options.element && options.element.appendChild) {
        options.element.appendChild(this._container);
        this._container = options.element;
    }

    // call ol.control.Control constructor
    _ol2.default.control.Control.call(this, {
        element: this._container,
        target: options.target,
        render: options.render
    });
};
// Inherits from ol.control.Control
_ol2.default.inherits(LocationSelector, _ol2.default.control.Control);

/**
 * @lends module:LocationSelector
 */
LocationSelector.prototype = Object.create(_ol2.default.control.Control.prototype, {});

_Utils2.default.assign(LocationSelector.prototype, _LocationSelectorDOM2.default);

/**
 * Constructor (alias)
 */
LocationSelector.prototype.constructor = LocationSelector;

/**
 * initialize component
 *
 * @param {Object} options - options
 */
LocationSelector.prototype.initialize = function (options) {
    // set default options
    this.options = {
        tag: {
            id: 1, // numero d'ordre sur un groupe de locations
            groupId: null, // id du composant global contenant le LocationSelector
            label: ">",
            display: true,
            addOption: false,
            removeOption: false
        },
        displayInfo: true,
        autocompleteOptions: {}
    };

    // merge with user options
    _Utils2.default.mergeParams(this.options, options);

    /** uuid */
    this._uid = this.options.tag.groupId || _SelectorID2.default.generate();
    // info : si un uid (groupId) est spécifié
    // (par ex si ce composant est appélé par un autre composant graphique)
    // alors on le récupère, sinon c'est qu'il est indépendant : on génère donc un uuid

    /** container map */
    this._map = null;

    /** container principal des entrées  */
    this._inputsContainer = null;

    /** container du label du point */
    this._inputLabelContainer = null;

    /** container de la saisi de l'autocompletion */
    this._inputAutoCompleteContainer = null;

    /** container du pointer de saisi sur la carte */
    this._inputShowPointerContainer = null;

    /** label du pointer de saisi sur la carte (avec img) */
    this._inputShowPointer = null;

    /** container des coordonnées */
    this._inputCoordinateContainer = null;

    /** elements pour ajouter ou supprimer un nouveau point */
    this._addPointElement = null;
    this._removePointElement = null;

    /** coordonnées du point selectionné, en EPSG:4326 */
    this._coordinate = null;

    /** container des reponses de l'autocompletion */
    this._suggestedContainer = null;

    /** listes des reponses de l'autocompletion */
    this._suggestedLocations = [];

    /** localisant */
    this._currentLocation = null;

    /** marker */
    this._initMarker();

    /** ressources du services d'autocompletion (ayant droit!) */
    this._resources = {};

    /** a t on des droits sur les ressources du service ? */
    this._noRightManagement = false;

    // gestion des droits sur les ressources/services
    this._checkRightsManagement();
};

/**
 * initialize marker : url and offset
 *
 * @private
 */
LocationSelector.prototype._initMarker = function () {
    // init marker properties
    this._marker = null;
    this._markerUrl = "";
    this._markerOffset = [0, 0];

    if (this.options.tag.markerOpts && this.options.tag.markerOpts.url) {
        // get marker src url
        this._markerUrl = this.options.tag.markerOpts.url;

        // get marker offset
        var offset = this.options.tag.markerOpts.offset;
        if (offset) {
            if (Array.isArray(offset) && offset.length === 2) {
                this._markerOffset = offset;
            } else {
                logger.log("markerOpts.offset should be an array. e.g. : [0,0]");
            }
        }
    } else {
        // set default options for marker
        this._markerUrl = _Markers2.default["lightOrange"];
        this._markerOffset = _Markers2.default.defaultOffset;
    }
};

// ################################################################### //
// ########################## publics methods ######################## //
// ################################################################### //

/**
 * get coordinate
 *
 * @returns {Array} this._coordinate - point coordinate (EPSG:4326) : [lon, lat]
 */
LocationSelector.prototype.getCoordinate = function () {
    return this._coordinate;
};

/**
 * clean input
 */
LocationSelector.prototype.clear = function () {
    this._clearResults();
    this._inputLabelContainer.click();
};

// ################################################################### //
// ##################### init component (private) #################### //
// ################################################################### //

/**
 * check
 */
LocationSelector.prototype._checkRightsManagement = function () {
    // les ressources du service d'autocompletion
    var _opts = this.options.autocompleteOptions.filterOptions;
    var _res = _opts ? _opts.type : [];
    if (!_res || _res.length === 0) {
        _res = ["PositionOfInterest", "StreetAddress"];
    }

    var rightManagement = _CheckRightManagement2.default.check({
        key: this.options.apiKey,
        resources: _res,
        services: ["AutoCompletion"]
    });

    if (!rightManagement) {
        this._noRightManagement = true;
    }

    // on recupère les informations utiles
    // sur ce controle, on ne s'occupe pas de la ressource car elle est unique...
    // Ex. la clef API issue de l'autoconfiguration si elle n'a pas
    // été renseignée.
    if (!this.options.apiKey) {
        this.options.apiKey = rightManagement.key;
    }

    _Utils2.default.assign(this._resources, rightManagement);
};

/**
 * initialize component container
 *
 * @returns {DOMElement} DOM element
 */
LocationSelector.prototype._initContainer = function () {
    var id = this.options.tag.id;

    // create main container
    var container = this._createMainContainerElement();

    var inputs = this._inputsContainer = this._createLocationPointElement(id, this.options.tag.display);
    container.appendChild(inputs);

    var _inputLabel = this._inputLabelContainer = this._createLocationPointLabelElement(id, this.options.tag.label);
    inputs.appendChild(_inputLabel);
    var _inputAutoComplete = this._inputAutoCompleteContainer = this._createLocationAutoCompleteteInputElement(id);
    var context = this;
    if (_inputAutoComplete.addEventListener) {
        _inputAutoComplete.addEventListener("click", function () {
            context.onAutoCompleteInputClick();
        });
    } else if (_inputAutoComplete.attachEvent) {
        _inputAutoComplete.attachEvent("onclick", function () {
            context.onAutoCompleteInputClick();
        });
    }
    inputs.appendChild(_inputAutoComplete);
    var _inputCoordinate = this._inputCoordinateContainer = this._createLocationCoordinateInputElement(id);
    inputs.appendChild(_inputCoordinate);
    var _inputShowPointer = this._inputShowPointerContainer = this._createLocationPointerShowInputElement(id);
    inputs.appendChild(_inputShowPointer);
    var _inputPointer = this._inputShowPointer = this._createLocationPointerInputElement(id);
    inputs.appendChild(_inputPointer);

    if (this.options.tag.addOption) {
        var _inputAddStage = this._addPointElement = this._createLocationAddPointElement();
        inputs.appendChild(_inputAddStage);
    }

    if (this.options.tag.removeOption) {
        var _inputRemoveStage = this._removePointElement = this._createLocationRemovePointElement(id);
        inputs.appendChild(_inputRemoveStage);
    }

    var results = this._suggestedContainer = this._createLocationAutoCompleteResultElement(id);
    container.appendChild(results);

    return container;
};

// ################################################################### //
// ###################### handlers events (dom) ###################### //
// ################################################################### //

/**
 * this method is called by event 'click' on 'GPlocationOrigin' input
 *
 * @private
 */
LocationSelector.prototype.onAutoCompleteInputClick = function () {
    if (this._inputAutoCompleteContainer && this._inputAutoCompleteContainer.value.length > 2) {
        this._displaySuggestedLocation();
    }
};

/**
 * this method is called by event 'keyup' on 'GProuteOrigin' tag input
 * (cf. this._createRouteAutoCompleteteInputElement), and it gets the value of input.
 * this value is passed as a parameter for the service autocomplete (text).
 * the results of the request are displayed into a drop down menu.
 * FIXME
 *
 * @param {Object} e - HTMLElement
 * @private
 */
LocationSelector.prototype.onAutoCompleteSearchText = function (e) {
    var value = e.target.value;
    if (!value) {
        return;
    }

    // aucun droits !
    // on evite une requête...
    if (this._noRightManagement) {
        logger.log("no rights for this service !?");
        return;
    }

    // on sauvegarde le localisant
    this._currentLocation = value;

    // on limite les requêtes à partir de 3 car. saisie !
    if (value.length < 3) {
        this._clearSuggestedLocation();
        return;
    }

    // INFORMATION
    // on effectue la requête au service d'autocompletion.
    // on met en place des callbacks afin de recuperer les resultats ou
    // les messages d'erreurs du service.
    // les resultats sont affichés dans une liste deroulante.
    // les messages d'erreurs sont affichés sur la console (?)
    var context = this;
    this._requestAutoComplete({
        text: value,
        maximumResponses: 5, // FIXME je limite le nombre de reponse car le container DOM est limité dans l'affichage !!!
        // callback onSuccess
        onSuccess: function onSuccess(results) {
            if (results) {
                var locations = results.suggestedLocations;
                context._fillAutoCompletedLocationListContainer(locations);
            }
        },
        // callback onFailure
        onFailure: function onFailure(error) {
            // FIXME
            // où affiche t on les messages : ex. 'No suggestion matching the search' ?
            // doit on nettoyer la liste des suggestions dernierement enregistrée :
            context._clearSuggestedLocation();
            logger.log(error.message);
        }
    });

    var map = this.getMap();
    map.on("click", this._hideSuggestedLocation, this);
    map.on("pointerdrag", this._hideSuggestedLocation, this);
};

/**
 * this method is called by event 'click' on 'GPautoCompleteResultsList' tag div
 * (cf. this._createAutoCompleteListElement), and it selects the location.
 * this location displays a marker on the map.
 * FIXME
 *
 * @param {Object} e - HTMLElement
 * @private
 */
LocationSelector.prototype.onAutoCompletedResultsItemClick = function (e) {
    var idx = _SelectorID2.default.index(e.target.id);

    if (!idx) {
        return;
    }

    // FIXME
    // les coordonnées sont inversées entre les 2 services !?
    // AutoCompletion : lon/lat ("EPSG:4326")
    // Geocoding : lat/lon
    var position = [this._suggestedLocations[idx].position.x, this._suggestedLocations[idx].position.y];
    // on sauvegarde le point courant (en EPSG:4326, [lon, lat])
    this._coordinate = position;

    var info = {
        type: this._suggestedLocations[idx].type,
        fields: this._suggestedLocations[idx]
    };

    // on ajoute le texte de l'autocomplétion dans l'input
    var label = this._suggestedLocations[idx].fullText;
    this._setLabel(label);

    // Info : la position est en EPSG:4326, à transformer dans la projection de la carte
    var view = this.getMap().getView();
    var mapProj = view.getProjection().getCode();
    if (mapProj !== "EPSG:4326") {
        // on retransforme les coordonnées de la position dans la projection de la carte
        position = _ol2.default.proj.transform(position, "EPSG:4326", mapProj);
    }
    // on centre la vue et positionne le marker, à la position reprojetée dans la projection de la carte
    this._setPosition(position);
    this._setMarker(position, info, this.options.displayInfo);
};

/**
 * this method is called by event 'click' on 'GProuteOriginPointerImg' tag input
 * (cf. this._createRoutePointerInputElement), and it create or remove the event of click map.
 *
 * @private
 */
LocationSelector.prototype.onActivateMapPointClick = function () {
    var map = this.getMap();

    if (this._inputShowPointerContainer.checked) {
        // on efface l'ancien resultat
        this._clearResults();
        map.on("click", this.onMouseMapClick, this);
        this._setCursor("crosshair");
    } else {
        map.un("click", this.onMouseMapClick, this);
        this._setCursor();
    }
};

/**
 * this method is called by event 'click' on 'GProuteOriginLabel' tag label
 * (cf. this._createRoutePointLabelElement).
 * this point is erased.
 *
 * @private
 */
LocationSelector.prototype.onLocationClearPointClick = function () {
    this._setCursor();
    this._clearResults();
};

/**
 * this method is called by event 'click' on 'GProuteStageRemove' tag input
 * (cf. this._createRouteRemovePointElement).
 * this point is deleted
 *
 * @private
 */
LocationSelector.prototype.onLocationRemovePointClick = function () {
    this._setCursor();
    this._clearResults();
};

/**
 * TODO this method is called by event 'click' on 'GProuteStageAdd' tag input
 * (cf. this._createRouteAddPointElement).
 * this point is added as a parameter for the service route.
 *
 * @param {Object} e - HTMLElement
 */
LocationSelector.prototype.onLocationAddPointClick = function (e) {
    logger.log("onRouteAddPointClick", e);
};

// ################################################################### //
// #################### handlers events (control) #################### //
// ################################################################### //

/**
 * this method is called by event 'click' on map
 * (cf. this.onRouteMapPointClick), and it gets the coordinate of click on map.
 * this point is saved as a parameter for the service route.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
LocationSelector.prototype.onMouseMapClick = function (e) {
    var coordinate = e.coordinate;
    if (!e.map || !e.map.getView()) {
        return;
    }
    var crs = e.map.getView().getProjection();

    this._setCoordinate(coordinate, crs);

    this._setMarker([coordinate[0], coordinate[1]], null, false);

    // on desactive l'event sur la map !
    this.onActivateMapPointClick(e);
};

// ################################################################### //
// ################# pivates methods use by events ################### //
// ################################################################### //

/**
 * this sends the label to the panel.
 *
 * @param {String} label - label suggested location
 * @private
 */
LocationSelector.prototype._setLabel = function (label) {
    this._inputAutoCompleteContainer.value = label;
};

/**
 * this change the cursor of the map when entering a point.
 *
 * @param {String} cursor - cursor style
 * @private
 */
LocationSelector.prototype._setCursor = function (cursor) {
    var map = this.getMap();
    var div = map.getTargetElement();

    if (cursor) {
        div.style.cursor = cursor;
    } else {
        div.style.cursor = null;
    }
};

/**
 * this sends the coordinates to the panel.
 *
 * @method _setCoordinate
 * @param {Array} olCoordinate - ol.Coordinate object [lon, lat] ou [x, y] (proj = map proj system)
 * @param {Object} crs - coordinate CRS (ol.proj.Projection)
 * @private
 */
LocationSelector.prototype._setCoordinate = function (olCoordinate, crs) {
    // structure
    // ol.Coordinate
    //      [
    //          4   // lon ou x
    //          48  // lat ou y
    //      ]

    // on transforme olCoodinate (dont la projection est celle de la carte) en EPSG:4326
    this._coordinate = _ol2.default.proj.transform(olCoordinate, crs, "EPSG:4326");

    // INFO : si on veut des DMS
    // var coords = ol.coordinate.toStringHDMS(this._coordinate, 2).split("N ");
    // // coords est du type : "48° 00′ 00″ N 2° 00′ 00″ E". On veut récupérer les 2 coordonnées séparément.
    // var lat = coords[0] + "N";
    // var lng = coords[1];

    // Pour avoir des degrés décimaux :
    var lat = this._coordinate[0].toFixed(4);
    var lng = this._coordinate[1].toFixed(4);

    var value = lat + " / " + lng;
    this.GPdisplayCoordinate(value);
};

/**
 * this method is called by this.on*ResultsItemClick()
 * and set center at given position.
 *
 * @param {Array} position - ol.Coordinate object [lon, lat] (en lat/lon : "EPSG:4326")
 * @private
 */
LocationSelector.prototype._setPosition = function (position) {
    var view = this.getMap().getView();
    view.setCenter(position);
};

/**
 * this method is called by this.on*ResultsItemClick()
 * and displays a marker.
 * FIXME : marker IGN et informations ?
 *
 * @param {Array} position - ol.Coordinate object [lon, lat] ou [x, y]
 * @param {Object} information - suggested or geocoded information
 * @param {Boolean} display - display a popup information
 * @private
 */
LocationSelector.prototype._setMarker = function (position, information, display) {
    var map = this.getMap();
    // remove previous markers
    if (this._marker != null) {
        map.removeOverlay(this._marker);
        this._marker = null;
    }

    if (position) {
        var markerDiv = document.createElement("img");
        markerDiv.src = this._markerUrl;
        this._marker = new _ol2.default.Overlay({
            position: position,
            offset: this._markerOffset,
            element: markerDiv,
            stopEvent: false
        });
        map.addOverlay(this._marker);

        if (display) {
            logger.log("marker information : ", information);
        }
        // // FIXME
        // // doit on mettre une information
        // // - correctement construite ?
        // // - uniquement informatif ?
        // // - RIEN ?
        // if (display) {
        //     var popupContent = null;
        //
        //     var values = [];
        //
        //     values.push(information.fields.fullText || "");
        //     values.push(information.fields.street || "");
        //     values.push(information.fields.postalCode || "");
        //     values.push(information.fields.commune || "");
        //
        //     if (information.type === "PositionOfInterest") {
        //         values.push(information.fields.poi || "");
        //         values.push(information.fields.kind || "");
        //     }
        //
        //     popupContent = values.join(" | ");
        //
        //     this._marker.bindPopup(popupContent);
        // }
    }
};

/**
 * this method is called by this.()
 * and it clears all results and the marker.
 *
 * @private
 */
LocationSelector.prototype._clearResults = function () {
    var map = this.getMap();
    this._currentLocation = null;
    this._coordinate = null;
    this._hideSuggestedLocation();
    this._clearSuggestedLocation();
    this._setMarker();
    map.un("click", this.onMouseMapClick, this);
};

/**
 * this method is called by this.onAutoCompleteSearchText()
 * and it clears all suggested location.
 *
 * @private
 */
LocationSelector.prototype._clearSuggestedLocation = function () {
    // suppression du dom
    this._suggestedLocations = [];
    if (this._suggestedContainer) {
        while (this._suggestedContainer.firstChild) {
            this._suggestedContainer.removeChild(this._suggestedContainer.firstChild);
        }
    }
};

/**
 * this method is called by event 'click' on map
 * and it hide suggested locations
 *
 * @private
 */
LocationSelector.prototype._hideSuggestedLocation = function () {
    if (this._suggestedContainer) {
        this._suggestedContainer.style.display = "none";
    }
};

/**
 * this method is called by this.onAutoCompleteSearchText()
 * and it clears all suggested location.
 *
 * @private
 */
LocationSelector.prototype._displaySuggestedLocation = function () {
    if (this._suggestedContainer) {
        this._suggestedContainer.style.display = "block";
    }
};

/**
 * this method is called by this.onAutoCompleteSearch()
 * and executes a request to the service.
 *
 * @param {Object} settings - service settings
 * @param {String}   settings.text - text
 * @param {Function} settings.onSuccess - callback
 * @param {Function} settings.onFailure - callback
 * @private
 */
LocationSelector.prototype._requestAutoComplete = function (settings) {
    logger.log("_requestAutoComplete()", settings);

    // on ne fait pas de requête si on n'a pas renseigné de parametres !
    if (!settings || Object.keys(settings).length === 0) {
        return;
    }

    // on ne fait pas de requête si la parametre 'text' est vide !
    if (!settings.text) {
        return;
    }

    logger.log(settings);

    var options = {};
    // on recupere les options du service
    _Utils2.default.assign(options, this.options.autocompleteOptions);
    // ainsi que la recherche et les callbacks
    _Utils2.default.assign(options, settings);

    // les ressources
    var resources = this._resources["AutoCompletion"] || null;
    if (resources && Array.isArray(resources)) {
        if (!options.filterOptions) {
            options.filterOptions = {};
        }
        options.filterOptions.type = resources;
    }

    // cas où la clef API n'est pas renseignée dans les options du service,
    // on utilise celle de l'autoconf ou celle renseignée au niveau du controle
    options.apiKey = options.apiKey || this.options.apiKey;

    logger.log(options);

    _gp2.default.Services.autoComplete(options);
};

/**
 * this method is called by this.onAutoCompleteSearchText()
 * and fills the container of the location list.
 * it creates a HTML Element per location
 * (cf. this. ...)
 *
 * @param {Object[]} locations - locations
 *
 * @private
 */
LocationSelector.prototype._fillAutoCompletedLocationListContainer = function (locations) {
    if (!locations || locations.length === 0) {
        return;
    }

    // on vide la liste avant de la construire
    var element = this._suggestedContainer;
    if (element.childElementCount) {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    }

    for (var i = 0; i < locations.length; i++) {
        // Proposals are dynamically filled in Javascript by autocomplete service
        this._createLocationAutoCompletedLocationElement(this.options.tag.id, locations[i], i);
    }

    // sauvegarde de l'etat des locations
    this._suggestedLocations = locations;
};

exports.default = LocationSelector;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olExtended = exports.ProxyUtils = exports.LayerUtils = exports.olUtils = exports.olExtDate = exports.olExtVersion = undefined;

var _gp = __webpack_require__(4);

Object.keys(_gp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _gp[key];
    }
  });
});

var _Utils = __webpack_require__(2);

Object.defineProperty(exports, "olUtils", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Utils).default;
  }
});

var _LayerUtils = __webpack_require__(12);

Object.defineProperty(exports, "LayerUtils", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LayerUtils).default;
  }
});

var _ProxyUtils = __webpack_require__(13);

Object.defineProperty(exports, "ProxyUtils", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ProxyUtils).default;
  }
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _GfiUtils = __webpack_require__(16);

var _GfiUtils2 = _interopRequireDefault(_GfiUtils);

var _Utils2 = _interopRequireDefault(_Utils);

var _KML = __webpack_require__(14);

var _KML2 = _interopRequireDefault(_KML);

var _WMTS = __webpack_require__(17);

var _WMTS2 = _interopRequireDefault(_WMTS);

var _CRS = __webpack_require__(18);

var _CRS2 = _interopRequireDefault(_CRS);

var _SourceWMTS = __webpack_require__(21);

var _SourceWMTS2 = _interopRequireDefault(_SourceWMTS);

var _SourceWMS = __webpack_require__(22);

var _SourceWMS2 = _interopRequireDefault(_SourceWMS);

var _LayerWMTS = __webpack_require__(29);

var _LayerWMTS2 = _interopRequireDefault(_LayerWMTS);

var _LayerWMS = __webpack_require__(30);

var _LayerWMS2 = _interopRequireDefault(_LayerWMS);

var _LayerSwitcher = __webpack_require__(6);

var _LayerSwitcher2 = _interopRequireDefault(_LayerSwitcher);

var _GetFeatureInfo = __webpack_require__(33);

var _GetFeatureInfo2 = _interopRequireDefault(_GetFeatureInfo);

var _SearchEngine = __webpack_require__(35);

var _SearchEngine2 = _interopRequireDefault(_SearchEngine);

var _MousePosition = __webpack_require__(38);

var _MousePosition2 = _interopRequireDefault(_MousePosition);

var _Drawing = __webpack_require__(41);

var _Drawing2 = _interopRequireDefault(_Drawing);

var _Route = __webpack_require__(43);

var _Route2 = _interopRequireDefault(_Route);

var _Isocurve = __webpack_require__(46);

var _Isocurve2 = _interopRequireDefault(_Isocurve);

var _ReverseGeocode = __webpack_require__(48);

var _ReverseGeocode2 = _interopRequireDefault(_ReverseGeocode);

var _LayerImport = __webpack_require__(50);

var _LayerImport2 = _interopRequireDefault(_LayerImport);

var _GeoportalAttribution = __webpack_require__(52);

var _GeoportalAttribution2 = _interopRequireDefault(_GeoportalAttribution);

var _Markers = __webpack_require__(5);

var _Markers2 = _interopRequireDefault(_Markers);

var _ElevationPath = __webpack_require__(53);

var _ElevationPath2 = _interopRequireDefault(_ElevationPath);

var _MeasureLength = __webpack_require__(57);

var _MeasureLength2 = _interopRequireDefault(_MeasureLength);

var _MeasureArea = __webpack_require__(59);

var _MeasureArea2 = _interopRequireDefault(_MeasureArea);

var _MeasureAzimuth = __webpack_require__(61);

var _MeasureAzimuth2 = _interopRequireDefault(_MeasureAzimuth);

__webpack_require__(63);

__webpack_require__(96);

var _package = __webpack_require__(97);

var _package2 = _interopRequireDefault(_package);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Rajout des propriétés de l'extension dans le namespace Gp
var olExtVersion = exports.olExtVersion = _package2.default.olExtVersion;
var olExtDate = exports.olExtDate = new Date().toISOString().split("T")[0];


_ol2.default.gp = {};
_ol2.default.gp.GfiUtils = _GfiUtils2.default;

// FIXME overload or not ? name Gp.format.kml ?
_ol2.default.format.KMLExtended = _KML2.default;
_ol2.default.source.WMTSExtended = _WMTS2.default;

// Surcharge sur les functions Ol/proj4 par défaut
_CRS2.default.overload();

// Rajout des propriétés dans le namespace Ol
_ol2.default.source.GeoportalWMTS = _SourceWMTS2.default;
_ol2.default.source.GeoportalWMS = _SourceWMS2.default;
_ol2.default.layer.GeoportalWMTS = _LayerWMTS2.default;
_ol2.default.layer.GeoportalWMS = _LayerWMS2.default;
_ol2.default.control.GeoportalAttribution = _GeoportalAttribution2.default;
_ol2.default.control.LayerSwitcher = _LayerSwitcher2.default;
_ol2.default.control.GetFeatureInfo = _GetFeatureInfo2.default;
_ol2.default.control.SearchEngine = _SearchEngine2.default;
_ol2.default.control.Route = _Route2.default;
_ol2.default.control.Isocurve = _Isocurve2.default;
_ol2.default.control.GeoportalMousePosition = _MousePosition2.default;
_ol2.default.control.Drawing = _Drawing2.default;
_ol2.default.control.ReverseGeocode = _ReverseGeocode2.default;
_ol2.default.control.LayerImport = _LayerImport2.default;
_ol2.default.control.MeasureLength = _MeasureLength2.default;
_ol2.default.control.MeasureArea = _MeasureArea2.default;
_ol2.default.control.MeasureAzimuth = _MeasureAzimuth2.default;
// export default markers definitions
_ol2.default.control.DefaultMarkers = _Markers2.default;
_ol2.default.control.ElevationPath = _ElevationPath2.default;

exports.olExtended = _ol2.default;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_25__;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(this, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      var storageKey = "loglevel";
      if (name) {
        storageKey += ":" + name;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    return defaultLogger;
}));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.proj4 = factory());
}(this, (function () { 'use strict';

	var globals = function(defs) {
	  defs('EPSG:4326', "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
	  defs('EPSG:4269', "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
	  defs('EPSG:3857', "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");

	  defs.WGS84 = defs['EPSG:4326'];
	  defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
	  defs.GOOGLE = defs['EPSG:3857'];
	  defs['EPSG:900913'] = defs['EPSG:3857'];
	  defs['EPSG:102113'] = defs['EPSG:3857'];
	};

	var PJD_3PARAM = 1;
	var PJD_7PARAM = 2;
	var PJD_WGS84 = 4; // WGS84 or equivalent
	var PJD_NODATUM = 5; // WGS84 or equivalent
	var SEC_TO_RAD = 4.84813681109535993589914102357e-6;
	var HALF_PI = Math.PI/2;
	// ellipoid pj_set_ell.c
	var SIXTH = 0.1666666666666666667;
	/* 1/6 */
	var RA4 = 0.04722222222222222222;
	/* 17/360 */
	var RA6 = 0.02215608465608465608;
	var EPSLN = 1.0e-10;
	// you'd think you could use Number.EPSILON above but that makes
	// Mollweide get into an infinate loop.

	var D2R = 0.01745329251994329577;
	var R2D = 57.29577951308232088;
	var FORTPI = Math.PI/4;
	var TWO_PI = Math.PI * 2;
	// SPI is slightly greater than Math.PI, so values that exceed the -180..180
	// degree range by a tiny amount don't get wrapped. This prevents points that
	// have drifted from their original location along the 180th meridian (due to
	// floating point error) from changing their sign.
	var SPI = 3.14159265359;

	var exports$1 = {};
	exports$1.greenwich = 0.0; //"0dE",
	exports$1.lisbon = -9.131906111111; //"9d07'54.862\"W",
	exports$1.paris = 2.337229166667; //"2d20'14.025\"E",
	exports$1.bogota = -74.080916666667; //"74d04'51.3\"W",
	exports$1.madrid = -3.687938888889; //"3d41'16.58\"W",
	exports$1.rome = 12.452333333333; //"12d27'8.4\"E",
	exports$1.bern = 7.439583333333; //"7d26'22.5\"E",
	exports$1.jakarta = 106.807719444444; //"106d48'27.79\"E",
	exports$1.ferro = -17.666666666667; //"17d40'W",
	exports$1.brussels = 4.367975; //"4d22'4.71\"E",
	exports$1.stockholm = 18.058277777778; //"18d3'29.8\"E",
	exports$1.athens = 23.7163375; //"23d42'58.815\"E",
	exports$1.oslo = 10.722916666667; //"10d43'22.5\"E"

	var units = {
	  ft: {to_meter: 0.3048},
	  'us-ft': {to_meter: 1200 / 3937}
	};

	var ignoredChar = /[\s_\-\/\(\)]/g;
	function match(obj, key) {
	  if (obj[key]) {
	    return obj[key];
	  }
	  var keys = Object.keys(obj);
	  var lkey = key.toLowerCase().replace(ignoredChar, '');
	  var i = -1;
	  var testkey, processedKey;
	  while (++i < keys.length) {
	    testkey = keys[i];
	    processedKey = testkey.toLowerCase().replace(ignoredChar, '');
	    if (processedKey === lkey) {
	      return obj[testkey];
	    }
	  }
	}

	var parseProj = function(defData) {
	  var self = {};
	  var paramObj = defData.split('+').map(function(v) {
	    return v.trim();
	  }).filter(function(a) {
	    return a;
	  }).reduce(function(p, a) {
	    var split = a.split('=');
	    split.push(true);
	    p[split[0].toLowerCase()] = split[1];
	    return p;
	  }, {});
	  var paramName, paramVal, paramOutname;
	  var params = {
	    proj: 'projName',
	    datum: 'datumCode',
	    rf: function(v) {
	      self.rf = parseFloat(v);
	    },
	    lat_0: function(v) {
	      self.lat0 = v * D2R;
	    },
	    lat_1: function(v) {
	      self.lat1 = v * D2R;
	    },
	    lat_2: function(v) {
	      self.lat2 = v * D2R;
	    },
	    lat_ts: function(v) {
	      self.lat_ts = v * D2R;
	    },
	    lon_0: function(v) {
	      self.long0 = v * D2R;
	    },
	    lon_1: function(v) {
	      self.long1 = v * D2R;
	    },
	    lon_2: function(v) {
	      self.long2 = v * D2R;
	    },
	    alpha: function(v) {
	      self.alpha = parseFloat(v) * D2R;
	    },
	    lonc: function(v) {
	      self.longc = v * D2R;
	    },
	    x_0: function(v) {
	      self.x0 = parseFloat(v);
	    },
	    y_0: function(v) {
	      self.y0 = parseFloat(v);
	    },
	    k_0: function(v) {
	      self.k0 = parseFloat(v);
	    },
	    k: function(v) {
	      self.k0 = parseFloat(v);
	    },
	    a: function(v) {
	      self.a = parseFloat(v);
	    },
	    b: function(v) {
	      self.b = parseFloat(v);
	    },
	    r_a: function() {
	      self.R_A = true;
	    },
	    zone: function(v) {
	      self.zone = parseInt(v, 10);
	    },
	    south: function() {
	      self.utmSouth = true;
	    },
	    towgs84: function(v) {
	      self.datum_params = v.split(",").map(function(a) {
	        return parseFloat(a);
	      });
	    },
	    to_meter: function(v) {
	      self.to_meter = parseFloat(v);
	    },
	    units: function(v) {
	      self.units = v;
	      var unit = match(units, v);
	      if (unit) {
	        self.to_meter = unit.to_meter;
	      }
	    },
	    from_greenwich: function(v) {
	      self.from_greenwich = v * D2R;
	    },
	    pm: function(v) {
	      var pm = match(exports$1, v);
	      self.from_greenwich = (pm ? pm : parseFloat(v)) * D2R;
	    },
	    nadgrids: function(v) {
	      if (v === '@null') {
	        self.datumCode = 'none';
	      }
	      else {
	        self.nadgrids = v;
	      }
	    },
	    axis: function(v) {
	      var legalAxis = "ewnsud";
	      if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) {
	        self.axis = v;
	      }
	    }
	  };
	  for (paramName in paramObj) {
	    paramVal = paramObj[paramName];
	    if (paramName in params) {
	      paramOutname = params[paramName];
	      if (typeof paramOutname === 'function') {
	        paramOutname(paramVal);
	      }
	      else {
	        self[paramOutname] = paramVal;
	      }
	    }
	    else {
	      self[paramName] = paramVal;
	    }
	  }
	  if(typeof self.datumCode === 'string' && self.datumCode !== "WGS84"){
	    self.datumCode = self.datumCode.toLowerCase();
	  }
	  return self;
	};

	var NEUTRAL = 1;
	var KEYWORD = 2;
	var NUMBER = 3;
	var QUOTED = 4;
	var AFTERQUOTE = 5;
	var ENDED = -1;
	var whitespace = /\s/;
	var latin = /[A-Za-z]/;
	var keyword = /[A-Za-z84]/;
	var endThings = /[,\]]/;
	var digets = /[\d\.E\-\+]/;
	// const ignoredChar = /[\s_\-\/\(\)]/g;
	function Parser(text) {
	  if (typeof text !== 'string') {
	    throw new Error('not a string');
	  }
	  this.text = text.trim();
	  this.level = 0;
	  this.place = 0;
	  this.root = null;
	  this.stack = [];
	  this.currentObject = null;
	  this.state = NEUTRAL;
	}
	Parser.prototype.readCharicter = function() {
	  var char = this.text[this.place++];
	  if (this.state !== QUOTED) {
	    while (whitespace.test(char)) {
	      if (this.place >= this.text.length) {
	        return;
	      }
	      char = this.text[this.place++];
	    }
	  }
	  switch (this.state) {
	    case NEUTRAL:
	      return this.neutral(char);
	    case KEYWORD:
	      return this.keyword(char)
	    case QUOTED:
	      return this.quoted(char);
	    case AFTERQUOTE:
	      return this.afterquote(char);
	    case NUMBER:
	      return this.number(char);
	    case ENDED:
	      return;
	  }
	};
	Parser.prototype.afterquote = function(char) {
	  if (char === '"') {
	    this.word += '"';
	    this.state = QUOTED;
	    return;
	  }
	  if (endThings.test(char)) {
	    this.word = this.word.trim();
	    this.afterItem(char);
	    return;
	  }
	  throw new Error('havn\'t handled "' +char + '" in afterquote yet, index ' + this.place);
	};
	Parser.prototype.afterItem = function(char) {
	  if (char === ',') {
	    if (this.word !== null) {
	      this.currentObject.push(this.word);
	    }
	    this.word = null;
	    this.state = NEUTRAL;
	    return;
	  }
	  if (char === ']') {
	    this.level--;
	    if (this.word !== null) {
	      this.currentObject.push(this.word);
	      this.word = null;
	    }
	    this.state = NEUTRAL;
	    this.currentObject = this.stack.pop();
	    if (!this.currentObject) {
	      this.state = ENDED;
	    }

	    return;
	  }
	};
	Parser.prototype.number = function(char) {
	  if (digets.test(char)) {
	    this.word += char;
	    return;
	  }
	  if (endThings.test(char)) {
	    this.word = parseFloat(this.word);
	    this.afterItem(char);
	    return;
	  }
	  throw new Error('havn\'t handled "' +char + '" in number yet, index ' + this.place);
	};
	Parser.prototype.quoted = function(char) {
	  if (char === '"') {
	    this.state = AFTERQUOTE;
	    return;
	  }
	  this.word += char;
	  return;
	};
	Parser.prototype.keyword = function(char) {
	  if (keyword.test(char)) {
	    this.word += char;
	    return;
	  }
	  if (char === '[') {
	    var newObjects = [];
	    newObjects.push(this.word);
	    this.level++;
	    if (this.root === null) {
	      this.root = newObjects;
	    } else {
	      this.currentObject.push(newObjects);
	    }
	    this.stack.push(this.currentObject);
	    this.currentObject = newObjects;
	    this.state = NEUTRAL;
	    return;
	  }
	  if (endThings.test(char)) {
	    this.afterItem(char);
	    return;
	  }
	  throw new Error('havn\'t handled "' +char + '" in keyword yet, index ' + this.place);
	};
	Parser.prototype.neutral = function(char) {
	  if (latin.test(char)) {
	    this.word = char;
	    this.state = KEYWORD;
	    return;
	  }
	  if (char === '"') {
	    this.word = '';
	    this.state = QUOTED;
	    return;
	  }
	  if (digets.test(char)) {
	    this.word = char;
	    this.state = NUMBER;
	    return;
	  }
	  if (endThings.test(char)) {
	    this.afterItem(char);
	    return;
	  }
	  throw new Error('havn\'t handled "' +char + '" in neutral yet, index ' + this.place);
	};
	Parser.prototype.output = function() {
	  while (this.place < this.text.length) {
	    this.readCharicter();
	  }
	  if (this.state === ENDED) {
	    return this.root;
	  }
	  throw new Error('unable to parse string "' +this.text + '". State is ' + this.state);
	};

	function parseString(txt) {
	  var parser = new Parser(txt);
	  return parser.output();
	}

	function mapit(obj, key, value) {
	  if (Array.isArray(key)) {
	    value.unshift(key);
	    key = null;
	  }
	  var thing = key ? {} : obj;

	  var out = value.reduce(function(newObj, item) {
	    sExpr(item, newObj);
	    return newObj
	  }, thing);
	  if (key) {
	    obj[key] = out;
	  }
	}

	function sExpr(v, obj) {
	  if (!Array.isArray(v)) {
	    obj[v] = true;
	    return;
	  }
	  var key = v.shift();
	  if (key === 'PARAMETER') {
	    key = v.shift();
	  }
	  if (v.length === 1) {
	    if (Array.isArray(v[0])) {
	      obj[key] = {};
	      sExpr(v[0], obj[key]);
	      return;
	    }
	    obj[key] = v[0];
	    return;
	  }
	  if (!v.length) {
	    obj[key] = true;
	    return;
	  }
	  if (key === 'TOWGS84') {
	    obj[key] = v;
	    return;
	  }
	  if (!Array.isArray(key)) {
	    obj[key] = {};
	  }

	  var i;
	  switch (key) {
	    case 'UNIT':
	    case 'PRIMEM':
	    case 'VERT_DATUM':
	      obj[key] = {
	        name: v[0].toLowerCase(),
	        convert: v[1]
	      };
	      if (v.length === 3) {
	        sExpr(v[2], obj[key]);
	      }
	      return;
	    case 'SPHEROID':
	    case 'ELLIPSOID':
	      obj[key] = {
	        name: v[0],
	        a: v[1],
	        rf: v[2]
	      };
	      if (v.length === 4) {
	        sExpr(v[3], obj[key]);
	      }
	      return;
	    case 'PROJECTEDCRS':
	    case 'PROJCRS':
	    case 'GEOGCS':
	    case 'GEOCCS':
	    case 'PROJCS':
	    case 'LOCAL_CS':
	    case 'GEODCRS':
	    case 'GEODETICCRS':
	    case 'GEODETICDATUM':
	    case 'EDATUM':
	    case 'ENGINEERINGDATUM':
	    case 'VERT_CS':
	    case 'VERTCRS':
	    case 'VERTICALCRS':
	    case 'COMPD_CS':
	    case 'COMPOUNDCRS':
	    case 'ENGINEERINGCRS':
	    case 'ENGCRS':
	    case 'FITTED_CS':
	    case 'LOCAL_DATUM':
	    case 'DATUM':
	      v[0] = ['name', v[0]];
	      mapit(obj, key, v);
	      return;
	    default:
	      i = -1;
	      while (++i < v.length) {
	        if (!Array.isArray(v[i])) {
	          return sExpr(v, obj[key]);
	        }
	      }
	      return mapit(obj, key, v);
	  }
	}

	var D2R$1 = 0.01745329251994329577;
	function rename(obj, params) {
	  var outName = params[0];
	  var inName = params[1];
	  if (!(outName in obj) && (inName in obj)) {
	    obj[outName] = obj[inName];
	    if (params.length === 3) {
	      obj[outName] = params[2](obj[outName]);
	    }
	  }
	}

	function d2r(input) {
	  return input * D2R$1;
	}

	function cleanWKT(wkt) {
	  if (wkt.type === 'GEOGCS') {
	    wkt.projName = 'longlat';
	  } else if (wkt.type === 'LOCAL_CS') {
	    wkt.projName = 'identity';
	    wkt.local = true;
	  } else {
	    if (typeof wkt.PROJECTION === 'object') {
	      wkt.projName = Object.keys(wkt.PROJECTION)[0];
	    } else {
	      wkt.projName = wkt.PROJECTION;
	    }
	  }
	  if (wkt.UNIT) {
	    wkt.units = wkt.UNIT.name.toLowerCase();
	    if (wkt.units === 'metre') {
	      wkt.units = 'meter';
	    }
	    if (wkt.UNIT.convert) {
	      if (wkt.type === 'GEOGCS') {
	        if (wkt.DATUM && wkt.DATUM.SPHEROID) {
	          wkt.to_meter = wkt.UNIT.convert*wkt.DATUM.SPHEROID.a;
	        }
	      } else {
	        wkt.to_meter = wkt.UNIT.convert, 10;
	      }
	    }
	  }
	  var geogcs = wkt.GEOGCS;
	  if (wkt.type === 'GEOGCS') {
	    geogcs = wkt;
	  }
	  if (geogcs) {
	    //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
	    //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
	    //}
	    if (geogcs.DATUM) {
	      wkt.datumCode = geogcs.DATUM.name.toLowerCase();
	    } else {
	      wkt.datumCode = geogcs.name.toLowerCase();
	    }
	    if (wkt.datumCode.slice(0, 2) === 'd_') {
	      wkt.datumCode = wkt.datumCode.slice(2);
	    }
	    if (wkt.datumCode === 'new_zealand_geodetic_datum_1949' || wkt.datumCode === 'new_zealand_1949') {
	      wkt.datumCode = 'nzgd49';
	    }
	    if (wkt.datumCode === 'wgs_1984') {
	      if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') {
	        wkt.sphere = true;
	      }
	      wkt.datumCode = 'wgs84';
	    }
	    if (wkt.datumCode.slice(-6) === '_ferro') {
	      wkt.datumCode = wkt.datumCode.slice(0, - 6);
	    }
	    if (wkt.datumCode.slice(-8) === '_jakarta') {
	      wkt.datumCode = wkt.datumCode.slice(0, - 8);
	    }
	    if (~wkt.datumCode.indexOf('belge')) {
	      wkt.datumCode = 'rnb72';
	    }
	    if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
	      wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
	      if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') {
	        wkt.ellps = 'intl';
	      }

	      wkt.a = geogcs.DATUM.SPHEROID.a;
	      wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
	    }
	    if (~wkt.datumCode.indexOf('osgb_1936')) {
	      wkt.datumCode = 'osgb36';
	    }
	    if (~wkt.datumCode.indexOf('osni_1952')) {
	      wkt.datumCode = 'osni52';
	    }
	    if (~wkt.datumCode.indexOf('tm65')
	      || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) {
	      wkt.datumCode = 'ire65';
	    }
	  }
	  if (wkt.b && !isFinite(wkt.b)) {
	    wkt.b = wkt.a;
	  }

	  function toMeter(input) {
	    var ratio = wkt.to_meter || 1;
	    return input * ratio;
	  }
	  var renamer = function(a) {
	    return rename(wkt, a);
	  };
	  var list = [
	    ['standard_parallel_1', 'Standard_Parallel_1'],
	    ['standard_parallel_2', 'Standard_Parallel_2'],
	    ['false_easting', 'False_Easting'],
	    ['false_northing', 'False_Northing'],
	    ['central_meridian', 'Central_Meridian'],
	    ['latitude_of_origin', 'Latitude_Of_Origin'],
	    ['latitude_of_origin', 'Central_Parallel'],
	    ['scale_factor', 'Scale_Factor'],
	    ['k0', 'scale_factor'],
	    ['latitude_of_center', 'Latitude_of_center'],
	    ['lat0', 'latitude_of_center', d2r],
	    ['longitude_of_center', 'Longitude_Of_Center'],
	    ['longc', 'longitude_of_center', d2r],
	    ['x0', 'false_easting', toMeter],
	    ['y0', 'false_northing', toMeter],
	    ['long0', 'central_meridian', d2r],
	    ['lat0', 'latitude_of_origin', d2r],
	    ['lat0', 'standard_parallel_1', d2r],
	    ['lat1', 'standard_parallel_1', d2r],
	    ['lat2', 'standard_parallel_2', d2r],
	    ['alpha', 'azimuth', d2r],
	    ['srsCode', 'name']
	  ];
	  list.forEach(renamer);
	  if (!wkt.long0 && wkt.longc && (wkt.projName === 'Albers_Conic_Equal_Area' || wkt.projName === 'Lambert_Azimuthal_Equal_Area')) {
	    wkt.long0 = wkt.longc;
	  }
	  if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === 'Stereographic_South_Pole' || wkt.projName === 'Polar Stereographic (variant B)')) {
	    wkt.lat0 = d2r(wkt.lat1 > 0 ? 90 : -90);
	    wkt.lat_ts = wkt.lat1;
	  }
	}
	var wkt = function(wkt) {
	  var lisp = parseString(wkt);
	  var type = lisp.shift();
	  var name = lisp.shift();
	  lisp.unshift(['name', name]);
	  lisp.unshift(['type', type]);
	  var obj = {};
	  sExpr(lisp, obj);
	  cleanWKT(obj);
	  return obj;
	};

	function defs(name) {
	  /*global console*/
	  var that = this;
	  if (arguments.length === 2) {
	    var def = arguments[1];
	    if (typeof def === 'string') {
	      if (def.charAt(0) === '+') {
	        defs[name] = parseProj(arguments[1]);
	      }
	      else {
	        defs[name] = wkt(arguments[1]);
	      }
	    } else {
	      defs[name] = def;
	    }
	  }
	  else if (arguments.length === 1) {
	    if (Array.isArray(name)) {
	      return name.map(function(v) {
	        if (Array.isArray(v)) {
	          defs.apply(that, v);
	        }
	        else {
	          defs(v);
	        }
	      });
	    }
	    else if (typeof name === 'string') {
	      if (name in defs) {
	        return defs[name];
	      }
	    }
	    else if ('EPSG' in name) {
	      defs['EPSG:' + name.EPSG] = name;
	    }
	    else if ('ESRI' in name) {
	      defs['ESRI:' + name.ESRI] = name;
	    }
	    else if ('IAU2000' in name) {
	      defs['IAU2000:' + name.IAU2000] = name;
	    }
	    else {
	      // console.log(name);
	    }
	    return;
	  }


	}
	globals(defs);

	function testObj(code){
	  return typeof code === 'string';
	}
	function testDef(code){
	  return code in defs;
	}
	 var codeWords = ['PROJECTEDCRS', 'PROJCRS', 'GEOGCS','GEOCCS','PROJCS','LOCAL_CS', 'GEODCRS', 'GEODETICCRS', 'GEODETICDATUM', 'ENGCRS', 'ENGINEERINGCRS']; 
	function testWKT(code){
	  return codeWords.some(function (word) {
	    return code.indexOf(word) > -1;
	  });
	}
	function testProj(code){
	  return code[0] === '+';
	}
	function parse(code){
	  if (testObj(code)) {
	    //check to see if this is a WKT string
	    if (testDef(code)) {
	      return defs[code];
	    }
	    if (testWKT(code)) {
	      return wkt(code);
	    }
	    if (testProj(code)) {
	      return parseProj(code);
	    }
	  }else{
	    return code;
	  }
	}

	var extend = function(destination, source) {
	  destination = destination || {};
	  var value, property;
	  if (!source) {
	    return destination;
	  }
	  for (property in source) {
	    value = source[property];
	    if (value !== undefined) {
	      destination[property] = value;
	    }
	  }
	  return destination;
	};

	var msfnz = function(eccent, sinphi, cosphi) {
	  var con = eccent * sinphi;
	  return cosphi / (Math.sqrt(1 - con * con));
	};

	var sign = function(x) {
	  return x<0 ? -1 : 1;
	};

	var adjust_lon = function(x) {
	  return (Math.abs(x) <= SPI) ? x : (x - (sign(x) * TWO_PI));
	};

	var tsfnz = function(eccent, phi, sinphi) {
	  var con = eccent * sinphi;
	  var com = 0.5 * eccent;
	  con = Math.pow(((1 - con) / (1 + con)), com);
	  return (Math.tan(0.5 * (HALF_PI - phi)) / con);
	};

	var phi2z = function(eccent, ts) {
	  var eccnth = 0.5 * eccent;
	  var con, dphi;
	  var phi = HALF_PI - 2 * Math.atan(ts);
	  for (var i = 0; i <= 15; i++) {
	    con = eccent * Math.sin(phi);
	    dphi = HALF_PI - 2 * Math.atan(ts * (Math.pow(((1 - con) / (1 + con)), eccnth))) - phi;
	    phi += dphi;
	    if (Math.abs(dphi) <= 0.0000000001) {
	      return phi;
	    }
	  }
	  //// console.log("phi2z has NoConvergence");
	  return -9999;
	};

	function init() {
	  var con = this.b / this.a;
	  this.es = 1 - con * con;
	  if(!('x0' in this)){
	    this.x0 = 0;
	  }
	  if(!('y0' in this)){
	    this.y0 = 0;
	  }
	  this.e = Math.sqrt(this.es);
	  if (this.lat_ts) {
	    if (this.sphere) {
	      this.k0 = Math.cos(this.lat_ts);
	    }
	    else {
	      this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
	    }
	  }
	  else {
	    if (!this.k0) {
	      if (this.k) {
	        this.k0 = this.k;
	      }
	      else {
	        this.k0 = 1;
	      }
	    }
	  }
	}

	/* Mercator forward equations--mapping lat,long to x,y
	  --------------------------------------------------*/

	function forward(p) {
	  var lon = p.x;
	  var lat = p.y;
	  // convert to radians
	  if (lat * R2D > 90 && lat * R2D < -90 && lon * R2D > 180 && lon * R2D < -180) {
	    return null;
	  }

	  var x, y;
	  if (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
	    return null;
	  }
	  else {
	    if (this.sphere) {
	      x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
	      y = this.y0 + this.a * this.k0 * Math.log(Math.tan(FORTPI + 0.5 * lat));
	    }
	    else {
	      var sinphi = Math.sin(lat);
	      var ts = tsfnz(this.e, lat, sinphi);
	      x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
	      y = this.y0 - this.a * this.k0 * Math.log(ts);
	    }
	    p.x = x;
	    p.y = y;
	    return p;
	  }
	}

	/* Mercator inverse equations--mapping x,y to lat/long
	  --------------------------------------------------*/
	function inverse(p) {

	  var x = p.x - this.x0;
	  var y = p.y - this.y0;
	  var lon, lat;

	  if (this.sphere) {
	    lat = HALF_PI - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
	  }
	  else {
	    var ts = Math.exp(-y / (this.a * this.k0));
	    lat = phi2z(this.e, ts);
	    if (lat === -9999) {
	      return null;
	    }
	  }
	  lon = adjust_lon(this.long0 + x / (this.a * this.k0));

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$1 = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];
	var merc = {
	  init: init,
	  forward: forward,
	  inverse: inverse,
	  names: names$1
	};

	function init$1() {
	  //no-op for longlat
	}

	function identity(pt) {
	  return pt;
	}
	var names$2 = ["longlat", "identity"];
	var longlat = {
	  init: init$1,
	  forward: identity,
	  inverse: identity,
	  names: names$2
	};

	var projs = [merc, longlat];
	var names$$1 = {};
	var projStore = [];

	function add(proj, i) {
	  var len = projStore.length;
	  if (!proj.names) {
	    // console.log(i);
	    return true;
	  }
	  projStore[len] = proj;
	  proj.names.forEach(function(n) {
	    names$$1[n.toLowerCase()] = len;
	  });
	  return this;
	}

	function get(name) {
	  if (!name) {
	    return false;
	  }
	  var n = name.toLowerCase();
	  if (typeof names$$1[n] !== 'undefined' && projStore[names$$1[n]]) {
	    return projStore[names$$1[n]];
	  }
	}

	function start() {
	  projs.forEach(add);
	}
	var projections = {
	  start: start,
	  add: add,
	  get: get
	};

	var exports$2 = {};
	exports$2.MERIT = {
	  a: 6378137.0,
	  rf: 298.257,
	  ellipseName: "MERIT 1983"
	};

	exports$2.SGS85 = {
	  a: 6378136.0,
	  rf: 298.257,
	  ellipseName: "Soviet Geodetic System 85"
	};

	exports$2.GRS80 = {
	  a: 6378137.0,
	  rf: 298.257222101,
	  ellipseName: "GRS 1980(IUGG, 1980)"
	};

	exports$2.IAU76 = {
	  a: 6378140.0,
	  rf: 298.257,
	  ellipseName: "IAU 1976"
	};

	exports$2.airy = {
	  a: 6377563.396,
	  b: 6356256.910,
	  ellipseName: "Airy 1830"
	};

	exports$2.APL4 = {
	  a: 6378137,
	  rf: 298.25,
	  ellipseName: "Appl. Physics. 1965"
	};

	exports$2.NWL9D = {
	  a: 6378145.0,
	  rf: 298.25,
	  ellipseName: "Naval Weapons Lab., 1965"
	};

	exports$2.mod_airy = {
	  a: 6377340.189,
	  b: 6356034.446,
	  ellipseName: "Modified Airy"
	};

	exports$2.andrae = {
	  a: 6377104.43,
	  rf: 300.0,
	  ellipseName: "Andrae 1876 (Den., Iclnd.)"
	};

	exports$2.aust_SA = {
	  a: 6378160.0,
	  rf: 298.25,
	  ellipseName: "Australian Natl & S. Amer. 1969"
	};

	exports$2.GRS67 = {
	  a: 6378160.0,
	  rf: 298.2471674270,
	  ellipseName: "GRS 67(IUGG 1967)"
	};

	exports$2.bessel = {
	  a: 6377397.155,
	  rf: 299.1528128,
	  ellipseName: "Bessel 1841"
	};

	exports$2.bess_nam = {
	  a: 6377483.865,
	  rf: 299.1528128,
	  ellipseName: "Bessel 1841 (Namibia)"
	};

	exports$2.clrk66 = {
	  a: 6378206.4,
	  b: 6356583.8,
	  ellipseName: "Clarke 1866"
	};

	exports$2.clrk80 = {
	  a: 6378249.145,
	  rf: 293.4663,
	  ellipseName: "Clarke 1880 mod."
	};

	exports$2.clrk58 = {
	  a: 6378293.645208759,
	  rf: 294.2606763692654,
	  ellipseName: "Clarke 1858"
	};

	exports$2.CPM = {
	  a: 6375738.7,
	  rf: 334.29,
	  ellipseName: "Comm. des Poids et Mesures 1799"
	};

	exports$2.delmbr = {
	  a: 6376428.0,
	  rf: 311.5,
	  ellipseName: "Delambre 1810 (Belgium)"
	};

	exports$2.engelis = {
	  a: 6378136.05,
	  rf: 298.2566,
	  ellipseName: "Engelis 1985"
	};

	exports$2.evrst30 = {
	  a: 6377276.345,
	  rf: 300.8017,
	  ellipseName: "Everest 1830"
	};

	exports$2.evrst48 = {
	  a: 6377304.063,
	  rf: 300.8017,
	  ellipseName: "Everest 1948"
	};

	exports$2.evrst56 = {
	  a: 6377301.243,
	  rf: 300.8017,
	  ellipseName: "Everest 1956"
	};

	exports$2.evrst69 = {
	  a: 6377295.664,
	  rf: 300.8017,
	  ellipseName: "Everest 1969"
	};

	exports$2.evrstSS = {
	  a: 6377298.556,
	  rf: 300.8017,
	  ellipseName: "Everest (Sabah & Sarawak)"
	};

	exports$2.fschr60 = {
	  a: 6378166.0,
	  rf: 298.3,
	  ellipseName: "Fischer (Mercury Datum) 1960"
	};

	exports$2.fschr60m = {
	  a: 6378155.0,
	  rf: 298.3,
	  ellipseName: "Fischer 1960"
	};

	exports$2.fschr68 = {
	  a: 6378150.0,
	  rf: 298.3,
	  ellipseName: "Fischer 1968"
	};

	exports$2.helmert = {
	  a: 6378200.0,
	  rf: 298.3,
	  ellipseName: "Helmert 1906"
	};

	exports$2.hough = {
	  a: 6378270.0,
	  rf: 297.0,
	  ellipseName: "Hough"
	};

	exports$2.intl = {
	  a: 6378388.0,
	  rf: 297.0,
	  ellipseName: "International 1909 (Hayford)"
	};

	exports$2.kaula = {
	  a: 6378163.0,
	  rf: 298.24,
	  ellipseName: "Kaula 1961"
	};

	exports$2.lerch = {
	  a: 6378139.0,
	  rf: 298.257,
	  ellipseName: "Lerch 1979"
	};

	exports$2.mprts = {
	  a: 6397300.0,
	  rf: 191.0,
	  ellipseName: "Maupertius 1738"
	};

	exports$2.new_intl = {
	  a: 6378157.5,
	  b: 6356772.2,
	  ellipseName: "New International 1967"
	};

	exports$2.plessis = {
	  a: 6376523.0,
	  rf: 6355863.0,
	  ellipseName: "Plessis 1817 (France)"
	};

	exports$2.krass = {
	  a: 6378245.0,
	  rf: 298.3,
	  ellipseName: "Krassovsky, 1942"
	};

	exports$2.SEasia = {
	  a: 6378155.0,
	  b: 6356773.3205,
	  ellipseName: "Southeast Asia"
	};

	exports$2.walbeck = {
	  a: 6376896.0,
	  b: 6355834.8467,
	  ellipseName: "Walbeck"
	};

	exports$2.WGS60 = {
	  a: 6378165.0,
	  rf: 298.3,
	  ellipseName: "WGS 60"
	};

	exports$2.WGS66 = {
	  a: 6378145.0,
	  rf: 298.25,
	  ellipseName: "WGS 66"
	};

	exports$2.WGS7 = {
	  a: 6378135.0,
	  rf: 298.26,
	  ellipseName: "WGS 72"
	};

	var WGS84 = exports$2.WGS84 = {
	  a: 6378137.0,
	  rf: 298.257223563,
	  ellipseName: "WGS 84"
	};

	exports$2.sphere = {
	  a: 6370997.0,
	  b: 6370997.0,
	  ellipseName: "Normal Sphere (r=6370997)"
	};

	function eccentricity(a, b, rf, R_A) {
	  var a2 = a * a; // used in geocentric
	  var b2 = b * b; // used in geocentric
	  var es = (a2 - b2) / a2; // e ^ 2
	  var e = 0;
	  if (R_A) {
	    a *= 1 - es * (SIXTH + es * (RA4 + es * RA6));
	    a2 = a * a;
	    es = 0;
	  } else {
	    e = Math.sqrt(es); // eccentricity
	  }
	  var ep2 = (a2 - b2) / b2; // used in geocentric
	  return {
	    es: es,
	    e: e,
	    ep2: ep2
	  };
	}
	function sphere(a, b, rf, ellps, sphere) {
	  if (!a) { // do we have an ellipsoid?
	    var ellipse = match(exports$2, ellps);
	    if (!ellipse) {
	      ellipse = WGS84;
	    }
	    a = ellipse.a;
	    b = ellipse.b;
	    rf = ellipse.rf;
	  }

	  if (rf && !b) {
	    b = (1.0 - 1.0 / rf) * a;
	  }
	  if (rf === 0 || Math.abs(a - b) < EPSLN) {
	    sphere = true;
	    b = a;
	  }
	  return {
	    a: a,
	    b: b,
	    rf: rf,
	    sphere: sphere
	  };
	}

	var exports$3 = {};
	exports$3.wgs84 = {
	  towgs84: "0,0,0",
	  ellipse: "WGS84",
	  datumName: "WGS84"
	};

	exports$3.ch1903 = {
	  towgs84: "674.374,15.056,405.346",
	  ellipse: "bessel",
	  datumName: "swiss"
	};

	exports$3.ggrs87 = {
	  towgs84: "-199.87,74.79,246.62",
	  ellipse: "GRS80",
	  datumName: "Greek_Geodetic_Reference_System_1987"
	};

	exports$3.nad83 = {
	  towgs84: "0,0,0",
	  ellipse: "GRS80",
	  datumName: "North_American_Datum_1983"
	};

	exports$3.nad27 = {
	  nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
	  ellipse: "clrk66",
	  datumName: "North_American_Datum_1927"
	};

	exports$3.potsdam = {
	  towgs84: "606.0,23.0,413.0",
	  ellipse: "bessel",
	  datumName: "Potsdam Rauenberg 1950 DHDN"
	};

	exports$3.carthage = {
	  towgs84: "-263.0,6.0,431.0",
	  ellipse: "clark80",
	  datumName: "Carthage 1934 Tunisia"
	};

	exports$3.hermannskogel = {
	  towgs84: "653.0,-212.0,449.0",
	  ellipse: "bessel",
	  datumName: "Hermannskogel"
	};

	exports$3.osni52 = {
	  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
	  ellipse: "airy",
	  datumName: "Irish National"
	};

	exports$3.ire65 = {
	  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
	  ellipse: "mod_airy",
	  datumName: "Ireland 1965"
	};

	exports$3.rassadiran = {
	  towgs84: "-133.63,-157.5,-158.62",
	  ellipse: "intl",
	  datumName: "Rassadiran"
	};

	exports$3.nzgd49 = {
	  towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
	  ellipse: "intl",
	  datumName: "New Zealand Geodetic Datum 1949"
	};

	exports$3.osgb36 = {
	  towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
	  ellipse: "airy",
	  datumName: "Airy 1830"
	};

	exports$3.s_jtsk = {
	  towgs84: "589,76,480",
	  ellipse: 'bessel',
	  datumName: 'S-JTSK (Ferro)'
	};

	exports$3.beduaram = {
	  towgs84: '-106,-87,188',
	  ellipse: 'clrk80',
	  datumName: 'Beduaram'
	};

	exports$3.gunung_segara = {
	  towgs84: '-403,684,41',
	  ellipse: 'bessel',
	  datumName: 'Gunung Segara Jakarta'
	};

	exports$3.rnb72 = {
	  towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
	  ellipse: "intl",
	  datumName: "Reseau National Belge 1972"
	};

	function datum(datumCode, datum_params, a, b, es, ep2) {
	  var out = {};

	  if (datumCode === undefined || datumCode === 'none') {
	    out.datum_type = PJD_NODATUM;
	  } else {
	    out.datum_type = PJD_WGS84;
	  }

	  if (datum_params) {
	    out.datum_params = datum_params.map(parseFloat);
	    if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) {
	      out.datum_type = PJD_3PARAM;
	    }
	    if (out.datum_params.length > 3) {
	      if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
	        out.datum_type = PJD_7PARAM;
	        out.datum_params[3] *= SEC_TO_RAD;
	        out.datum_params[4] *= SEC_TO_RAD;
	        out.datum_params[5] *= SEC_TO_RAD;
	        out.datum_params[6] = (out.datum_params[6] / 1000000.0) + 1.0;
	      }
	    }
	  }

	  out.a = a; //datum object also uses these values
	  out.b = b;
	  out.es = es;
	  out.ep2 = ep2;
	  return out;
	}

	function Projection$1(srsCode,callback) {
	  if (!(this instanceof Projection$1)) {
	    return new Projection$1(srsCode);
	  }
	  callback = callback || function(error){
	    if(error){
	      throw error;
	    }
	  };
	  var json = parse(srsCode);
	  if(typeof json !== 'object'){
	    callback(srsCode);
	    return;
	  }
	  var ourProj = Projection$1.projections.get(json.projName);
	  if(!ourProj){
	    callback(srsCode);
	    return;
	  }
	  if (json.datumCode && json.datumCode !== 'none') {
	    var datumDef = match(exports$3, json.datumCode);
	    if (datumDef) {
	      json.datum_params = datumDef.towgs84 ? datumDef.towgs84.split(',') : null;
	      json.ellps = datumDef.ellipse;
	      json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
	    }
	  }
	  json.k0 = json.k0 || 1.0;
	  json.axis = json.axis || 'enu';
	  json.ellps = json.ellps || 'wgs84';
	  var sphere_ = sphere(json.a, json.b, json.rf, json.ellps, json.sphere);
	  var ecc = eccentricity(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
	  var datumObj = json.datum || datum(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2);

	  extend(this, json); // transfer everything over from the projection because we don't know what we'll need
	  extend(this, ourProj); // transfer all the methods from the projection

	  // copy the 4 things over we calulated in deriveConstants.sphere
	  this.a = sphere_.a;
	  this.b = sphere_.b;
	  this.rf = sphere_.rf;
	  this.sphere = sphere_.sphere;

	  // copy the 3 things we calculated in deriveConstants.eccentricity
	  this.es = ecc.es;
	  this.e = ecc.e;
	  this.ep2 = ecc.ep2;

	  // add in the datum object
	  this.datum = datumObj;

	  // init the projection
	  this.init();

	  // legecy callback from back in the day when it went to spatialreference.org
	  callback(null, this);

	}
	Projection$1.projections = projections;
	Projection$1.projections.start();

	function compareDatums(source, dest) {
	  if (source.datum_type !== dest.datum_type) {
	    return false; // false, datums are not equal
	  } else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) {
	    // the tolerance for es is to ensure that GRS80 and WGS84
	    // are considered identical
	    return false;
	  } else if (source.datum_type === PJD_3PARAM) {
	    return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2]);
	  } else if (source.datum_type === PJD_7PARAM) {
	    return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6]);
	  } else {
	    return true; // datums are equal
	  }
	} // cs_compare_datums()

	/*
	 * The function Convert_Geodetic_To_Geocentric converts geodetic coordinates
	 * (latitude, longitude, and height) to geocentric coordinates (X, Y, Z),
	 * according to the current ellipsoid parameters.
	 *
	 *    Latitude  : Geodetic latitude in radians                     (input)
	 *    Longitude : Geodetic longitude in radians                    (input)
	 *    Height    : Geodetic height, in meters                       (input)
	 *    X         : Calculated Geocentric X coordinate, in meters    (output)
	 *    Y         : Calculated Geocentric Y coordinate, in meters    (output)
	 *    Z         : Calculated Geocentric Z coordinate, in meters    (output)
	 *
	 */
	function geodeticToGeocentric(p, es, a) {
	  var Longitude = p.x;
	  var Latitude = p.y;
	  var Height = p.z ? p.z : 0; //Z value not always supplied

	  var Rn; /*  Earth radius at location  */
	  var Sin_Lat; /*  Math.sin(Latitude)  */
	  var Sin2_Lat; /*  Square of Math.sin(Latitude)  */
	  var Cos_Lat; /*  Math.cos(Latitude)  */

	  /*
	   ** Don't blow up if Latitude is just a little out of the value
	   ** range as it may just be a rounding issue.  Also removed longitude
	   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
	   */
	  if (Latitude < -HALF_PI && Latitude > -1.001 * HALF_PI) {
	    Latitude = -HALF_PI;
	  } else if (Latitude > HALF_PI && Latitude < 1.001 * HALF_PI) {
	    Latitude = HALF_PI;
	  } else if ((Latitude < -HALF_PI) || (Latitude > HALF_PI)) {
	    /* Latitude out of range */
	    //..reportError('geocent:lat out of range:' + Latitude);
	    return null;
	  }

	  if (Longitude > Math.PI) {
	    Longitude -= (2 * Math.PI);
	  }
	  Sin_Lat = Math.sin(Latitude);
	  Cos_Lat = Math.cos(Latitude);
	  Sin2_Lat = Sin_Lat * Sin_Lat;
	  Rn = a / (Math.sqrt(1.0e0 - es * Sin2_Lat));
	  return {
	    x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
	    y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
	    z: ((Rn * (1 - es)) + Height) * Sin_Lat
	  };
	} // cs_geodetic_to_geocentric()

	function geocentricToGeodetic(p, es, a, b) {
	  /* local defintions and variables */
	  /* end-criterium of loop, accuracy of sin(Latitude) */
	  var genau = 1e-12;
	  var genau2 = (genau * genau);
	  var maxiter = 30;

	  var P; /* distance between semi-minor axis and location */
	  var RR; /* distance between center and location */
	  var CT; /* sin of geocentric latitude */
	  var ST; /* cos of geocentric latitude */
	  var RX;
	  var RK;
	  var RN; /* Earth radius at location */
	  var CPHI0; /* cos of start or old geodetic latitude in iterations */
	  var SPHI0; /* sin of start or old geodetic latitude in iterations */
	  var CPHI; /* cos of searched geodetic latitude */
	  var SPHI; /* sin of searched geodetic latitude */
	  var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */
	  var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */

	  var X = p.x;
	  var Y = p.y;
	  var Z = p.z ? p.z : 0.0; //Z value not always supplied
	  var Longitude;
	  var Latitude;
	  var Height;

	  P = Math.sqrt(X * X + Y * Y);
	  RR = Math.sqrt(X * X + Y * Y + Z * Z);

	  /*      special cases for latitude and longitude */
	  if (P / a < genau) {

	    /*  special case, if P=0. (X=0., Y=0.) */
	    Longitude = 0.0;

	    /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
	     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */
	    if (RR / a < genau) {
	      Latitude = HALF_PI;
	      Height = -b;
	      return {
	        x: p.x,
	        y: p.y,
	        z: p.z
	      };
	    }
	  } else {
	    /*  ellipsoidal (geodetic) longitude
	     *  interval: -PI < Longitude <= +PI */
	    Longitude = Math.atan2(Y, X);
	  }

	  /* --------------------------------------------------------------
	   * Following iterative algorithm was developped by
	   * "Institut for Erdmessung", University of Hannover, July 1988.
	   * Internet: www.ife.uni-hannover.de
	   * Iterative computation of CPHI,SPHI and Height.
	   * Iteration of CPHI and SPHI to 10**-12 radian resp.
	   * 2*10**-7 arcsec.
	   * --------------------------------------------------------------
	   */
	  CT = Z / RR;
	  ST = P / RR;
	  RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
	  CPHI0 = ST * (1.0 - es) * RX;
	  SPHI0 = CT * RX;
	  iter = 0;

	  /* loop to find sin(Latitude) resp. Latitude
	   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */
	  do {
	    iter++;
	    RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);

	    /*  ellipsoidal (geodetic) height */
	    Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);

	    RK = es * RN / (RN + Height);
	    RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
	    CPHI = ST * (1.0 - RK) * RX;
	    SPHI = CT * RX;
	    SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
	    CPHI0 = CPHI;
	    SPHI0 = SPHI;
	  }
	  while (SDPHI * SDPHI > genau2 && iter < maxiter);

	  /*      ellipsoidal (geodetic) latitude */
	  Latitude = Math.atan(SPHI / Math.abs(CPHI));
	  return {
	    x: Longitude,
	    y: Latitude,
	    z: Height
	  };
	} // cs_geocentric_to_geodetic()

	/****************************************************************/
	// pj_geocentic_to_wgs84( p )
	//  p = point to transform in geocentric coordinates (x,y,z)


	/** point object, nothing fancy, just allows values to be
	    passed back and forth by reference rather than by value.
	    Other point classes may be used as long as they have
	    x and y properties, which will get modified in the transform method.
	*/
	function geocentricToWgs84(p, datum_type, datum_params) {

	  if (datum_type === PJD_3PARAM) {
	    // if( x[io] === HUGE_VAL )
	    //    continue;
	    return {
	      x: p.x + datum_params[0],
	      y: p.y + datum_params[1],
	      z: p.z + datum_params[2],
	    };
	  } else if (datum_type === PJD_7PARAM) {
	    var Dx_BF = datum_params[0];
	    var Dy_BF = datum_params[1];
	    var Dz_BF = datum_params[2];
	    var Rx_BF = datum_params[3];
	    var Ry_BF = datum_params[4];
	    var Rz_BF = datum_params[5];
	    var M_BF = datum_params[6];
	    // if( x[io] === HUGE_VAL )
	    //    continue;
	    return {
	      x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
	      y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
	      z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
	    };
	  }
	} // cs_geocentric_to_wgs84

	/****************************************************************/
	// pj_geocentic_from_wgs84()
	//  coordinate system definition,
	//  point to transform in geocentric coordinates (x,y,z)
	function geocentricFromWgs84(p, datum_type, datum_params) {

	  if (datum_type === PJD_3PARAM) {
	    //if( x[io] === HUGE_VAL )
	    //    continue;
	    return {
	      x: p.x - datum_params[0],
	      y: p.y - datum_params[1],
	      z: p.z - datum_params[2],
	    };

	  } else if (datum_type === PJD_7PARAM) {
	    var Dx_BF = datum_params[0];
	    var Dy_BF = datum_params[1];
	    var Dz_BF = datum_params[2];
	    var Rx_BF = datum_params[3];
	    var Ry_BF = datum_params[4];
	    var Rz_BF = datum_params[5];
	    var M_BF = datum_params[6];
	    var x_tmp = (p.x - Dx_BF) / M_BF;
	    var y_tmp = (p.y - Dy_BF) / M_BF;
	    var z_tmp = (p.z - Dz_BF) / M_BF;
	    //if( x[io] === HUGE_VAL )
	    //    continue;

	    return {
	      x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
	      y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
	      z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
	    };
	  } //cs_geocentric_from_wgs84()
	}

	function checkParams(type) {
	  return (type === PJD_3PARAM || type === PJD_7PARAM);
	}

	var datum_transform = function(source, dest, point) {
	  // Short cut if the datums are identical.
	  if (compareDatums(source, dest)) {
	    return point; // in this case, zero is sucess,
	    // whereas cs_compare_datums returns 1 to indicate TRUE
	    // confusing, should fix this
	  }

	  // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
	  if (source.datum_type === PJD_NODATUM || dest.datum_type === PJD_NODATUM) {
	    return point;
	  }

	  // If this datum requires grid shifts, then apply it to geodetic coordinates.

	  // Do we need to go through geocentric coordinates?
	  if (source.es === dest.es && source.a === dest.a && !checkParams(source.datum_type) &&  !checkParams(dest.datum_type)) {
	    return point;
	  }

	  // Convert to geocentric coordinates.
	  point = geodeticToGeocentric(point, source.es, source.a);
	  // Convert between datums
	  if (checkParams(source.datum_type)) {
	    point = geocentricToWgs84(point, source.datum_type, source.datum_params);
	  }
	  if (checkParams(dest.datum_type)) {
	    point = geocentricFromWgs84(point, dest.datum_type, dest.datum_params);
	  }
	  return geocentricToGeodetic(point, dest.es, dest.a, dest.b);

	};

	var adjust_axis = function(crs, denorm, point) {
	  var xin = point.x,
	    yin = point.y,
	    zin = point.z || 0.0;
	  var v, t, i;
	  var out = {};
	  for (i = 0; i < 3; i++) {
	    if (denorm && i === 2 && point.z === undefined) {
	      continue;
	    }
	    if (i === 0) {
	      v = xin;
	      t = 'x';
	    }
	    else if (i === 1) {
	      v = yin;
	      t = 'y';
	    }
	    else {
	      v = zin;
	      t = 'z';
	    }
	    switch (crs.axis[i]) {
	    case 'e':
	      out[t] = v;
	      break;
	    case 'w':
	      out[t] = -v;
	      break;
	    case 'n':
	      out[t] = v;
	      break;
	    case 's':
	      out[t] = -v;
	      break;
	    case 'u':
	      if (point[t] !== undefined) {
	        out.z = v;
	      }
	      break;
	    case 'd':
	      if (point[t] !== undefined) {
	        out.z = -v;
	      }
	      break;
	    default:
	      //// console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
	      return null;
	    }
	  }
	  return out;
	};

	var toPoint = function (array){
	  var out = {
	    x: array[0],
	    y: array[1]
	  };
	  if (array.length>2) {
	    out.z = array[2];
	  }
	  if (array.length>3) {
	    out.m = array[3];
	  }
	  return out;
	};

	var checkSanity = function (point) {
	  checkCoord(point.x);
	  checkCoord(point.y);
	};
	function checkCoord(num) {
	  if (typeof Number.isFinite === 'function') {
	    if (Number.isFinite(num)) {
	      return;
	    }
	    throw new TypeError('coordinates must be finite numbers');
	  }
	  if (typeof num !== 'number' || num !== num || !isFinite(num)) {
	    throw new TypeError('coordinates must be finite numbers');
	  }
	}

	function checkNotWGS(source, dest) {
	  return ((source.datum.datum_type === PJD_3PARAM || source.datum.datum_type === PJD_7PARAM) && dest.datumCode !== 'WGS84') || ((dest.datum.datum_type === PJD_3PARAM || dest.datum.datum_type === PJD_7PARAM) && source.datumCode !== 'WGS84');
	}

	function transform(source, dest, point) {
	  var wgs84;
	  if (Array.isArray(point)) {
	    point = toPoint(point);
	  }
	  checkSanity(point);
	  // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
	  if (source.datum && dest.datum && checkNotWGS(source, dest)) {
	    wgs84 = new Projection$1('WGS84');
	    point = transform(source, wgs84, point);
	    source = wgs84;
	  }
	  // DGR, 2010/11/12
	  if (source.axis !== 'enu') {
	    point = adjust_axis(source, false, point);
	  }
	  // Transform source points to long/lat, if they aren't already.
	  if (source.projName === 'longlat') {
	    point = {
	      x: point.x * D2R,
	      y: point.y * D2R
	    };
	  }
	  else {
	    if (source.to_meter) {
	      point = {
	        x: point.x * source.to_meter,
	        y: point.y * source.to_meter
	      };
	    }
	    point = source.inverse(point); // Convert Cartesian to longlat
	  }
	  // Adjust for the prime meridian if necessary
	  if (source.from_greenwich) {
	    point.x += source.from_greenwich;
	  }

	  // Convert datums if needed, and if possible.
	  point = datum_transform(source.datum, dest.datum, point);

	  // Adjust for the prime meridian if necessary
	  if (dest.from_greenwich) {
	    point = {
	      x: point.x - dest.from_greenwich,
	      y: point.y
	    };
	  }

	  if (dest.projName === 'longlat') {
	    // convert radians to decimal degrees
	    point = {
	      x: point.x * R2D,
	      y: point.y * R2D
	    };
	  } else { // else project
	    point = dest.forward(point);
	    if (dest.to_meter) {
	      point = {
	        x: point.x / dest.to_meter,
	        y: point.y / dest.to_meter
	      };
	    }
	  }

	  // DGR, 2010/11/12
	  if (dest.axis !== 'enu') {
	    return adjust_axis(dest, true, point);
	  }

	  return point;
	}

	var wgs84 = Projection$1('WGS84');

	function transformer(from, to, coords) {
	  var transformedArray, out, keys;
	  if (Array.isArray(coords)) {
	    transformedArray = transform(from, to, coords);
	    if (coords.length === 3) {
	      return [transformedArray.x, transformedArray.y, transformedArray.z];
	    }
	    else {
	      return [transformedArray.x, transformedArray.y];
	    }
	  }
	  else {
	    out = transform(from, to, coords);
	    keys = Object.keys(coords);
	    if (keys.length === 2) {
	      return out;
	    }
	    keys.forEach(function (key) {
	      if (key === 'x' || key === 'y') {
	        return;
	      }
	      out[key] = coords[key];
	    });
	    return out;
	  }
	}

	function checkProj(item) {
	  if (item instanceof Projection$1) {
	    return item;
	  }
	  if (item.oProj) {
	    return item.oProj;
	  }
	  return Projection$1(item);
	}
	function proj4$1(fromProj, toProj, coord) {
	  fromProj = checkProj(fromProj);
	  var single = false;
	  var obj;
	  if (typeof toProj === 'undefined') {
	    toProj = fromProj;
	    fromProj = wgs84;
	    single = true;
	  }
	  else if (typeof toProj.x !== 'undefined' || Array.isArray(toProj)) {
	    coord = toProj;
	    toProj = fromProj;
	    fromProj = wgs84;
	    single = true;
	  }
	  toProj = checkProj(toProj);
	  if (coord) {
	    return transformer(fromProj, toProj, coord);
	  }
	  else {
	    obj = {
	      forward: function(coords) {
	        return transformer(fromProj, toProj, coords);
	      },
	      inverse: function(coords) {
	        return transformer(toProj, fromProj, coords);
	      }
	    };
	    if (single) {
	      obj.oProj = toProj;
	    }
	    return obj;
	  }
	}

	/**
	 * UTM zones are grouped, and assigned to one of a group of 6
	 * sets.
	 *
	 * {int} @private
	 */
	var NUM_100K_SETS = 6;

	/**
	 * The column letters (for easting) of the lower left value, per
	 * set.
	 *
	 * {string} @private
	 */
	var SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';

	/**
	 * The row letters (for northing) of the lower left value, per
	 * set.
	 *
	 * {string} @private
	 */
	var SET_ORIGIN_ROW_LETTERS = 'AFAFAF';

	var A = 65; // A
	var I = 73; // I
	var O = 79; // O
	var V = 86; // V
	var Z = 90; // Z
	var mgrs = {
	  forward: forward$1,
	  inverse: inverse$1,
	  toPoint: toPoint$1
	};
	/**
	 * Conversion of lat/lon to MGRS.
	 *
	 * @param {object} ll Object literal with lat and lon properties on a
	 *     WGS84 ellipsoid.
	 * @param {int} accuracy Accuracy in digits (5 for 1 m, 4 for 10 m, 3 for
	 *      100 m, 2 for 1000 m or 1 for 10000 m). Optional, default is 5.
	 * @return {string} the MGRS string for the given location and accuracy.
	 */
	function forward$1(ll, accuracy) {
	  accuracy = accuracy || 5; // default accuracy 1m
	  return encode(LLtoUTM({
	    lat: ll[1],
	    lon: ll[0]
	  }), accuracy);
	}

	/**
	 * Conversion of MGRS to lat/lon.
	 *
	 * @param {string} mgrs MGRS string.
	 * @return {array} An array with left (longitude), bottom (latitude), right
	 *     (longitude) and top (latitude) values in WGS84, representing the
	 *     bounding box for the provided MGRS reference.
	 */
	function inverse$1(mgrs) {
	  var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
	  if (bbox.lat && bbox.lon) {
	    return [bbox.lon, bbox.lat, bbox.lon, bbox.lat];
	  }
	  return [bbox.left, bbox.bottom, bbox.right, bbox.top];
	}

	function toPoint$1(mgrs) {
	  var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
	  if (bbox.lat && bbox.lon) {
	    return [bbox.lon, bbox.lat];
	  }
	  return [(bbox.left + bbox.right) / 2, (bbox.top + bbox.bottom) / 2];
	}
	/**
	 * Conversion from degrees to radians.
	 *
	 * @private
	 * @param {number} deg the angle in degrees.
	 * @return {number} the angle in radians.
	 */
	function degToRad(deg) {
	  return (deg * (Math.PI / 180.0));
	}

	/**
	 * Conversion from radians to degrees.
	 *
	 * @private
	 * @param {number} rad the angle in radians.
	 * @return {number} the angle in degrees.
	 */
	function radToDeg(rad) {
	  return (180.0 * (rad / Math.PI));
	}

	/**
	 * Converts a set of Longitude and Latitude co-ordinates to UTM
	 * using the WGS84 ellipsoid.
	 *
	 * @private
	 * @param {object} ll Object literal with lat and lon properties
	 *     representing the WGS84 coordinate to be converted.
	 * @return {object} Object literal containing the UTM value with easting,
	 *     northing, zoneNumber and zoneLetter properties, and an optional
	 *     accuracy property in digits. Returns null if the conversion failed.
	 */
	function LLtoUTM(ll) {
	  var Lat = ll.lat;
	  var Long = ll.lon;
	  var a = 6378137.0; //ellip.radius;
	  var eccSquared = 0.00669438; //ellip.eccsq;
	  var k0 = 0.9996;
	  var LongOrigin;
	  var eccPrimeSquared;
	  var N, T, C, A, M;
	  var LatRad = degToRad(Lat);
	  var LongRad = degToRad(Long);
	  var LongOriginRad;
	  var ZoneNumber;
	  // (int)
	  ZoneNumber = Math.floor((Long + 180) / 6) + 1;

	  //Make sure the longitude 180.00 is in Zone 60
	  if (Long === 180) {
	    ZoneNumber = 60;
	  }

	  // Special zone for Norway
	  if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) {
	    ZoneNumber = 32;
	  }

	  // Special zones for Svalbard
	  if (Lat >= 72.0 && Lat < 84.0) {
	    if (Long >= 0.0 && Long < 9.0) {
	      ZoneNumber = 31;
	    }
	    else if (Long >= 9.0 && Long < 21.0) {
	      ZoneNumber = 33;
	    }
	    else if (Long >= 21.0 && Long < 33.0) {
	      ZoneNumber = 35;
	    }
	    else if (Long >= 33.0 && Long < 42.0) {
	      ZoneNumber = 37;
	    }
	  }

	  LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
	  // in middle of
	  // zone
	  LongOriginRad = degToRad(LongOrigin);

	  eccPrimeSquared = (eccSquared) / (1 - eccSquared);

	  N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
	  T = Math.tan(LatRad) * Math.tan(LatRad);
	  C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
	  A = Math.cos(LatRad) * (LongRad - LongOriginRad);

	  M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - (35 * eccSquared * eccSquared * eccSquared / 3072) * Math.sin(6 * LatRad));

	  var UTMEasting = (k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0);

	  var UTMNorthing = (k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0)));
	  if (Lat < 0.0) {
	    UTMNorthing += 10000000.0; //10000000 meter offset for
	    // southern hemisphere
	  }

	  return {
	    northing: Math.round(UTMNorthing),
	    easting: Math.round(UTMEasting),
	    zoneNumber: ZoneNumber,
	    zoneLetter: getLetterDesignator(Lat)
	  };
	}

	/**
	 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
	 * class where the Zone can be specified as a single string eg."60N" which
	 * is then broken down into the ZoneNumber and ZoneLetter.
	 *
	 * @private
	 * @param {object} utm An object literal with northing, easting, zoneNumber
	 *     and zoneLetter properties. If an optional accuracy property is
	 *     provided (in meters), a bounding box will be returned instead of
	 *     latitude and longitude.
	 * @return {object} An object literal containing either lat and lon values
	 *     (if no accuracy was provided), or top, right, bottom and left values
	 *     for the bounding box calculated according to the provided accuracy.
	 *     Returns null if the conversion failed.
	 */
	function UTMtoLL(utm) {

	  var UTMNorthing = utm.northing;
	  var UTMEasting = utm.easting;
	  var zoneLetter = utm.zoneLetter;
	  var zoneNumber = utm.zoneNumber;
	  // check the ZoneNummber is valid
	  if (zoneNumber < 0 || zoneNumber > 60) {
	    return null;
	  }

	  var k0 = 0.9996;
	  var a = 6378137.0; //ellip.radius;
	  var eccSquared = 0.00669438; //ellip.eccsq;
	  var eccPrimeSquared;
	  var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
	  var N1, T1, C1, R1, D, M;
	  var LongOrigin;
	  var mu, phi1Rad;

	  // remove 500,000 meter offset for longitude
	  var x = UTMEasting - 500000.0;
	  var y = UTMNorthing;

	  // We must know somehow if we are in the Northern or Southern
	  // hemisphere, this is the only time we use the letter So even
	  // if the Zone letter isn't exactly correct it should indicate
	  // the hemisphere correctly
	  if (zoneLetter < 'N') {
	    y -= 10000000.0; // remove 10,000,000 meter offset used
	    // for southern hemisphere
	  }

	  // There are 60 zones with zone 1 being at West -180 to -174
	  LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
	  // in middle of
	  // zone

	  eccPrimeSquared = (eccSquared) / (1 - eccSquared);

	  M = y / k0;
	  mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));

	  phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + (151 * e1 * e1 * e1 / 96) * Math.sin(6 * mu);
	  // double phi1 = ProjMath.radToDeg(phi1Rad);

	  N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
	  T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
	  C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
	  R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
	  D = x / (N1 * k0);

	  var lat = phi1Rad - (N1 * Math.tan(phi1Rad) / R1) * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
	  lat = radToDeg(lat);

	  var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
	  lon = LongOrigin + radToDeg(lon);

	  var result;
	  if (utm.accuracy) {
	    var topRight = UTMtoLL({
	      northing: utm.northing + utm.accuracy,
	      easting: utm.easting + utm.accuracy,
	      zoneLetter: utm.zoneLetter,
	      zoneNumber: utm.zoneNumber
	    });
	    result = {
	      top: topRight.lat,
	      right: topRight.lon,
	      bottom: lat,
	      left: lon
	    };
	  }
	  else {
	    result = {
	      lat: lat,
	      lon: lon
	    };
	  }
	  return result;
	}

	/**
	 * Calculates the MGRS letter designator for the given latitude.
	 *
	 * @private
	 * @param {number} lat The latitude in WGS84 to get the letter designator
	 *     for.
	 * @return {char} The letter designator.
	 */
	function getLetterDesignator(lat) {
	  //This is here as an error flag to show that the Latitude is
	  //outside MGRS limits
	  var LetterDesignator = 'Z';

	  if ((84 >= lat) && (lat >= 72)) {
	    LetterDesignator = 'X';
	  }
	  else if ((72 > lat) && (lat >= 64)) {
	    LetterDesignator = 'W';
	  }
	  else if ((64 > lat) && (lat >= 56)) {
	    LetterDesignator = 'V';
	  }
	  else if ((56 > lat) && (lat >= 48)) {
	    LetterDesignator = 'U';
	  }
	  else if ((48 > lat) && (lat >= 40)) {
	    LetterDesignator = 'T';
	  }
	  else if ((40 > lat) && (lat >= 32)) {
	    LetterDesignator = 'S';
	  }
	  else if ((32 > lat) && (lat >= 24)) {
	    LetterDesignator = 'R';
	  }
	  else if ((24 > lat) && (lat >= 16)) {
	    LetterDesignator = 'Q';
	  }
	  else if ((16 > lat) && (lat >= 8)) {
	    LetterDesignator = 'P';
	  }
	  else if ((8 > lat) && (lat >= 0)) {
	    LetterDesignator = 'N';
	  }
	  else if ((0 > lat) && (lat >= -8)) {
	    LetterDesignator = 'M';
	  }
	  else if ((-8 > lat) && (lat >= -16)) {
	    LetterDesignator = 'L';
	  }
	  else if ((-16 > lat) && (lat >= -24)) {
	    LetterDesignator = 'K';
	  }
	  else if ((-24 > lat) && (lat >= -32)) {
	    LetterDesignator = 'J';
	  }
	  else if ((-32 > lat) && (lat >= -40)) {
	    LetterDesignator = 'H';
	  }
	  else if ((-40 > lat) && (lat >= -48)) {
	    LetterDesignator = 'G';
	  }
	  else if ((-48 > lat) && (lat >= -56)) {
	    LetterDesignator = 'F';
	  }
	  else if ((-56 > lat) && (lat >= -64)) {
	    LetterDesignator = 'E';
	  }
	  else if ((-64 > lat) && (lat >= -72)) {
	    LetterDesignator = 'D';
	  }
	  else if ((-72 > lat) && (lat >= -80)) {
	    LetterDesignator = 'C';
	  }
	  return LetterDesignator;
	}

	/**
	 * Encodes a UTM location as MGRS string.
	 *
	 * @private
	 * @param {object} utm An object literal with easting, northing,
	 *     zoneLetter, zoneNumber
	 * @param {number} accuracy Accuracy in digits (1-5).
	 * @return {string} MGRS string for the given UTM location.
	 */
	function encode(utm, accuracy) {
	  // prepend with leading zeroes
	  var seasting = "00000" + utm.easting,
	    snorthing = "00000" + utm.northing;

	  return utm.zoneNumber + utm.zoneLetter + get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
	}

	/**
	 * Get the two letter 100k designator for a given UTM easting,
	 * northing and zone number value.
	 *
	 * @private
	 * @param {number} easting
	 * @param {number} northing
	 * @param {number} zoneNumber
	 * @return the two letter 100k designator for the given UTM location.
	 */
	function get100kID(easting, northing, zoneNumber) {
	  var setParm = get100kSetForZone(zoneNumber);
	  var setColumn = Math.floor(easting / 100000);
	  var setRow = Math.floor(northing / 100000) % 20;
	  return getLetter100kID(setColumn, setRow, setParm);
	}

	/**
	 * Given a UTM zone number, figure out the MGRS 100K set it is in.
	 *
	 * @private
	 * @param {number} i An UTM zone number.
	 * @return {number} the 100k set the UTM zone is in.
	 */
	function get100kSetForZone(i) {
	  var setParm = i % NUM_100K_SETS;
	  if (setParm === 0) {
	    setParm = NUM_100K_SETS;
	  }

	  return setParm;
	}

	/**
	 * Get the two-letter MGRS 100k designator given information
	 * translated from the UTM northing, easting and zone number.
	 *
	 * @private
	 * @param {number} column the column index as it relates to the MGRS
	 *        100k set spreadsheet, created from the UTM easting.
	 *        Values are 1-8.
	 * @param {number} row the row index as it relates to the MGRS 100k set
	 *        spreadsheet, created from the UTM northing value. Values
	 *        are from 0-19.
	 * @param {number} parm the set block, as it relates to the MGRS 100k set
	 *        spreadsheet, created from the UTM zone. Values are from
	 *        1-60.
	 * @return two letter MGRS 100k code.
	 */
	function getLetter100kID(column, row, parm) {
	  // colOrigin and rowOrigin are the letters at the origin of the set
	  var index = parm - 1;
	  var colOrigin = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
	  var rowOrigin = SET_ORIGIN_ROW_LETTERS.charCodeAt(index);

	  // colInt and rowInt are the letters to build to return
	  var colInt = colOrigin + column - 1;
	  var rowInt = rowOrigin + row;
	  var rollover = false;

	  if (colInt > Z) {
	    colInt = colInt - Z + A - 1;
	    rollover = true;
	  }

	  if (colInt === I || (colOrigin < I && colInt > I) || ((colInt > I || colOrigin < I) && rollover)) {
	    colInt++;
	  }

	  if (colInt === O || (colOrigin < O && colInt > O) || ((colInt > O || colOrigin < O) && rollover)) {
	    colInt++;

	    if (colInt === I) {
	      colInt++;
	    }
	  }

	  if (colInt > Z) {
	    colInt = colInt - Z + A - 1;
	  }

	  if (rowInt > V) {
	    rowInt = rowInt - V + A - 1;
	    rollover = true;
	  }
	  else {
	    rollover = false;
	  }

	  if (((rowInt === I) || ((rowOrigin < I) && (rowInt > I))) || (((rowInt > I) || (rowOrigin < I)) && rollover)) {
	    rowInt++;
	  }

	  if (((rowInt === O) || ((rowOrigin < O) && (rowInt > O))) || (((rowInt > O) || (rowOrigin < O)) && rollover)) {
	    rowInt++;

	    if (rowInt === I) {
	      rowInt++;
	    }
	  }

	  if (rowInt > V) {
	    rowInt = rowInt - V + A - 1;
	  }

	  var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
	  return twoLetter;
	}

	/**
	 * Decode the UTM parameters from a MGRS string.
	 *
	 * @private
	 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
	 * @return {object} An object literal with easting, northing, zoneLetter,
	 *     zoneNumber and accuracy (in meters) properties.
	 */
	function decode(mgrsString) {

	  if (mgrsString && mgrsString.length === 0) {
	    throw ("MGRSPoint coverting from nothing");
	  }

	  var length = mgrsString.length;

	  var hunK = null;
	  var sb = "";
	  var testChar;
	  var i = 0;

	  // get Zone number
	  while (!(/[A-Z]/).test(testChar = mgrsString.charAt(i))) {
	    if (i >= 2) {
	      throw ("MGRSPoint bad conversion from: " + mgrsString);
	    }
	    sb += testChar;
	    i++;
	  }

	  var zoneNumber = parseInt(sb, 10);

	  if (i === 0 || i + 3 > length) {
	    // A good MGRS string has to be 4-5 digits long,
	    // ##AAA/#AAA at least.
	    throw ("MGRSPoint bad conversion from: " + mgrsString);
	  }

	  var zoneLetter = mgrsString.charAt(i++);

	  // Should we check the zone letter here? Why not.
	  if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') {
	    throw ("MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString);
	  }

	  hunK = mgrsString.substring(i, i += 2);

	  var set = get100kSetForZone(zoneNumber);

	  var east100k = getEastingFromChar(hunK.charAt(0), set);
	  var north100k = getNorthingFromChar(hunK.charAt(1), set);

	  // We have a bug where the northing may be 2000000 too low.
	  // How
	  // do we know when to roll over?

	  while (north100k < getMinNorthing(zoneLetter)) {
	    north100k += 2000000;
	  }

	  // calculate the char index for easting/northing separator
	  var remainder = length - i;

	  if (remainder % 2 !== 0) {
	    throw ("MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString);
	  }

	  var sep = remainder / 2;

	  var sepEasting = 0.0;
	  var sepNorthing = 0.0;
	  var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
	  if (sep > 0) {
	    accuracyBonus = 100000.0 / Math.pow(10, sep);
	    sepEastingString = mgrsString.substring(i, i + sep);
	    sepEasting = parseFloat(sepEastingString) * accuracyBonus;
	    sepNorthingString = mgrsString.substring(i + sep);
	    sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
	  }

	  easting = sepEasting + east100k;
	  northing = sepNorthing + north100k;

	  return {
	    easting: easting,
	    northing: northing,
	    zoneLetter: zoneLetter,
	    zoneNumber: zoneNumber,
	    accuracy: accuracyBonus
	  };
	}

	/**
	 * Given the first letter from a two-letter MGRS 100k zone, and given the
	 * MGRS table set for the zone number, figure out the easting value that
	 * should be added to the other, secondary easting value.
	 *
	 * @private
	 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
	 * @param {number} set The MGRS table set for the zone number.
	 * @return {number} The easting value for the given letter and set.
	 */
	function getEastingFromChar(e, set) {
	  // colOrigin is the letter at the origin of the set for the
	  // column
	  var curCol = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
	  var eastingValue = 100000.0;
	  var rewindMarker = false;

	  while (curCol !== e.charCodeAt(0)) {
	    curCol++;
	    if (curCol === I) {
	      curCol++;
	    }
	    if (curCol === O) {
	      curCol++;
	    }
	    if (curCol > Z) {
	      if (rewindMarker) {
	        throw ("Bad character: " + e);
	      }
	      curCol = A;
	      rewindMarker = true;
	    }
	    eastingValue += 100000.0;
	  }

	  return eastingValue;
	}

	/**
	 * Given the second letter from a two-letter MGRS 100k zone, and given the
	 * MGRS table set for the zone number, figure out the northing value that
	 * should be added to the other, secondary northing value. You have to
	 * remember that Northings are determined from the equator, and the vertical
	 * cycle of letters mean a 2000000 additional northing meters. This happens
	 * approx. every 18 degrees of latitude. This method does *NOT* count any
	 * additional northings. You have to figure out how many 2000000 meters need
	 * to be added for the zone letter of the MGRS coordinate.
	 *
	 * @private
	 * @param {char} n Second letter of the MGRS 100k zone
	 * @param {number} set The MGRS table set number, which is dependent on the
	 *     UTM zone number.
	 * @return {number} The northing value for the given letter and set.
	 */
	function getNorthingFromChar(n, set) {

	  if (n > 'V') {
	    throw ("MGRSPoint given invalid Northing " + n);
	  }

	  // rowOrigin is the letter at the origin of the set for the
	  // column
	  var curRow = SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
	  var northingValue = 0.0;
	  var rewindMarker = false;

	  while (curRow !== n.charCodeAt(0)) {
	    curRow++;
	    if (curRow === I) {
	      curRow++;
	    }
	    if (curRow === O) {
	      curRow++;
	    }
	    // fixing a bug making whole application hang in this loop
	    // when 'n' is a wrong character
	    if (curRow > V) {
	      if (rewindMarker) { // making sure that this loop ends
	        throw ("Bad character: " + n);
	      }
	      curRow = A;
	      rewindMarker = true;
	    }
	    northingValue += 100000.0;
	  }

	  return northingValue;
	}

	/**
	 * The function getMinNorthing returns the minimum northing value of a MGRS
	 * zone.
	 *
	 * Ported from Geotrans' c Lattitude_Band_Value structure table.
	 *
	 * @private
	 * @param {char} zoneLetter The MGRS zone to get the min northing for.
	 * @return {number}
	 */
	function getMinNorthing(zoneLetter) {
	  var northing;
	  switch (zoneLetter) {
	  case 'C':
	    northing = 1100000.0;
	    break;
	  case 'D':
	    northing = 2000000.0;
	    break;
	  case 'E':
	    northing = 2800000.0;
	    break;
	  case 'F':
	    northing = 3700000.0;
	    break;
	  case 'G':
	    northing = 4600000.0;
	    break;
	  case 'H':
	    northing = 5500000.0;
	    break;
	  case 'J':
	    northing = 6400000.0;
	    break;
	  case 'K':
	    northing = 7300000.0;
	    break;
	  case 'L':
	    northing = 8200000.0;
	    break;
	  case 'M':
	    northing = 9100000.0;
	    break;
	  case 'N':
	    northing = 0.0;
	    break;
	  case 'P':
	    northing = 800000.0;
	    break;
	  case 'Q':
	    northing = 1700000.0;
	    break;
	  case 'R':
	    northing = 2600000.0;
	    break;
	  case 'S':
	    northing = 3500000.0;
	    break;
	  case 'T':
	    northing = 4400000.0;
	    break;
	  case 'U':
	    northing = 5300000.0;
	    break;
	  case 'V':
	    northing = 6200000.0;
	    break;
	  case 'W':
	    northing = 7000000.0;
	    break;
	  case 'X':
	    northing = 7900000.0;
	    break;
	  default:
	    northing = -1.0;
	  }
	  if (northing >= 0.0) {
	    return northing;
	  }
	  else {
	    throw ("Invalid zone letter: " + zoneLetter);
	  }

	}

	function Point(x, y, z) {
	  if (!(this instanceof Point)) {
	    return new Point(x, y, z);
	  }
	  if (Array.isArray(x)) {
	    this.x = x[0];
	    this.y = x[1];
	    this.z = x[2] || 0.0;
	  } else if(typeof x === 'object') {
	    this.x = x.x;
	    this.y = x.y;
	    this.z = x.z || 0.0;
	  } else if (typeof x === 'string' && typeof y === 'undefined') {
	    var coords = x.split(',');
	    this.x = parseFloat(coords[0], 10);
	    this.y = parseFloat(coords[1], 10);
	    this.z = parseFloat(coords[2], 10) || 0.0;
	  } else {
	    this.x = x;
	    this.y = y;
	    this.z = z || 0.0;
	  }
	  console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
	}

	Point.fromMGRS = function(mgrsStr) {
	  return new Point(toPoint$1(mgrsStr));
	};
	Point.prototype.toMGRS = function(accuracy) {
	  return forward$1([this.x, this.y], accuracy);
	};

	var version = "2.4.4";

	var C00 = 1;
	var C02 = 0.25;
	var C04 = 0.046875;
	var C06 = 0.01953125;
	var C08 = 0.01068115234375;
	var C22 = 0.75;
	var C44 = 0.46875;
	var C46 = 0.01302083333333333333;
	var C48 = 0.00712076822916666666;
	var C66 = 0.36458333333333333333;
	var C68 = 0.00569661458333333333;
	var C88 = 0.3076171875;

	var pj_enfn = function(es) {
	  var en = [];
	  en[0] = C00 - es * (C02 + es * (C04 + es * (C06 + es * C08)));
	  en[1] = es * (C22 - es * (C04 + es * (C06 + es * C08)));
	  var t = es * es;
	  en[2] = t * (C44 - es * (C46 + es * C48));
	  t *= es;
	  en[3] = t * (C66 - es * C68);
	  en[4] = t * es * C88;
	  return en;
	};

	var pj_mlfn = function(phi, sphi, cphi, en) {
	  cphi *= sphi;
	  sphi *= sphi;
	  return (en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4]))));
	};

	var MAX_ITER = 20;

	var pj_inv_mlfn = function(arg, es, en) {
	  var k = 1 / (1 - es);
	  var phi = arg;
	  for (var i = MAX_ITER; i; --i) { /* rarely goes over 2 iterations */
	    var s = Math.sin(phi);
	    var t = 1 - es * s * s;
	    //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
	    //phi -= t * (t * Math.sqrt(t)) * k;
	    t = (pj_mlfn(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
	    phi -= t;
	    if (Math.abs(t) < EPSLN) {
	      return phi;
	    }
	  }
	  //..reportError("cass:pj_inv_mlfn: Convergence error");
	  return phi;
	};

	// Heavily based on this tmerc projection implementation
	// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js

	function init$2() {
	  this.x0 = this.x0 !== undefined ? this.x0 : 0;
	  this.y0 = this.y0 !== undefined ? this.y0 : 0;
	  this.long0 = this.long0 !== undefined ? this.long0 : 0;
	  this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;

	  if (this.es) {
	    this.en = pj_enfn(this.es);
	    this.ml0 = pj_mlfn(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
	  }
	}

	/**
	    Transverse Mercator Forward  - long/lat to x/y
	    long/lat in radians
	  */
	function forward$2(p) {
	  var lon = p.x;
	  var lat = p.y;

	  var delta_lon = adjust_lon(lon - this.long0);
	  var con;
	  var x, y;
	  var sin_phi = Math.sin(lat);
	  var cos_phi = Math.cos(lat);

	  if (!this.es) {
	    var b = cos_phi * Math.sin(delta_lon);

	    if ((Math.abs(Math.abs(b) - 1)) < EPSLN) {
	      return (93);
	    }
	    else {
	      x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
	      y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
	      b = Math.abs(y);

	      if (b >= 1) {
	        if ((b - 1) > EPSLN) {
	          return (93);
	        }
	        else {
	          y = 0;
	        }
	      }
	      else {
	        y = Math.acos(y);
	      }

	      if (lat < 0) {
	        y = -y;
	      }

	      y = this.a * this.k0 * (y - this.lat0) + this.y0;
	    }
	  }
	  else {
	    var al = cos_phi * delta_lon;
	    var als = Math.pow(al, 2);
	    var c = this.ep2 * Math.pow(cos_phi, 2);
	    var cs = Math.pow(c, 2);
	    var tq = Math.abs(cos_phi) > EPSLN ? Math.tan(lat) : 0;
	    var t = Math.pow(tq, 2);
	    var ts = Math.pow(t, 2);
	    con = 1 - this.es * Math.pow(sin_phi, 2);
	    al = al / Math.sqrt(con);
	    var ml = pj_mlfn(lat, sin_phi, cos_phi, this.en);

	    x = this.a * (this.k0 * al * (1 +
	      als / 6 * (1 - t + c +
	      als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c +
	      als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) +
	      this.x0;

	    y = this.a * (this.k0 * (ml - this.ml0 +
	      sin_phi * delta_lon * al / 2 * (1 +
	      als / 12 * (5 - t + 9 * c + 4 * cs +
	      als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c +
	      als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) +
	      this.y0;
	  }

	  p.x = x;
	  p.y = y;

	  return p;
	}

	/**
	    Transverse Mercator Inverse  -  x/y to long/lat
	  */
	function inverse$2(p) {
	  var con, phi;
	  var lat, lon;
	  var x = (p.x - this.x0) * (1 / this.a);
	  var y = (p.y - this.y0) * (1 / this.a);

	  if (!this.es) {
	    var f = Math.exp(x / this.k0);
	    var g = 0.5 * (f - 1 / f);
	    var temp = this.lat0 + y / this.k0;
	    var h = Math.cos(temp);
	    con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
	    lat = Math.asin(con);

	    if (y < 0) {
	      lat = -lat;
	    }

	    if ((g === 0) && (h === 0)) {
	      lon = 0;
	    }
	    else {
	      lon = adjust_lon(Math.atan2(g, h) + this.long0);
	    }
	  }
	  else { // ellipsoidal form
	    con = this.ml0 + y / this.k0;
	    phi = pj_inv_mlfn(con, this.es, this.en);

	    if (Math.abs(phi) < HALF_PI) {
	      var sin_phi = Math.sin(phi);
	      var cos_phi = Math.cos(phi);
	      var tan_phi = Math.abs(cos_phi) > EPSLN ? Math.tan(phi) : 0;
	      var c = this.ep2 * Math.pow(cos_phi, 2);
	      var cs = Math.pow(c, 2);
	      var t = Math.pow(tan_phi, 2);
	      var ts = Math.pow(t, 2);
	      con = 1 - this.es * Math.pow(sin_phi, 2);
	      var d = x * Math.sqrt(con) / this.k0;
	      var ds = Math.pow(d, 2);
	      con = con * tan_phi;

	      lat = phi - (con * ds / (1 - this.es)) * 0.5 * (1 -
	        ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs -
	        ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c -
	        ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));

	      lon = adjust_lon(this.long0 + (d * (1 -
	        ds / 6 * (1 + 2 * t + c -
	        ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c -
	        ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi));
	    }
	    else {
	      lat = HALF_PI * sign(y);
	      lon = 0;
	    }
	  }

	  p.x = lon;
	  p.y = lat;

	  return p;
	}

	var names$3 = ["Transverse_Mercator", "Transverse Mercator", "tmerc"];
	var tmerc = {
	  init: init$2,
	  forward: forward$2,
	  inverse: inverse$2,
	  names: names$3
	};

	var sinh = function(x) {
	  var r = Math.exp(x);
	  r = (r - 1 / r) / 2;
	  return r;
	};

	var hypot = function(x, y) {
	  x = Math.abs(x);
	  y = Math.abs(y);
	  var a = Math.max(x, y);
	  var b = Math.min(x, y) / (a ? a : 1);

	  return a * Math.sqrt(1 + Math.pow(b, 2));
	};

	var log1py = function(x) {
	  var y = 1 + x;
	  var z = y - 1;

	  return z === 0 ? x : x * Math.log(y) / z;
	};

	var asinhy = function(x) {
	  var y = Math.abs(x);
	  y = log1py(y * (1 + y / (hypot(1, y) + 1)));

	  return x < 0 ? -y : y;
	};

	var gatg = function(pp, B) {
	  var cos_2B = 2 * Math.cos(2 * B);
	  var i = pp.length - 1;
	  var h1 = pp[i];
	  var h2 = 0;
	  var h;

	  while (--i >= 0) {
	    h = -h2 + cos_2B * h1 + pp[i];
	    h2 = h1;
	    h1 = h;
	  }

	  return (B + h * Math.sin(2 * B));
	};

	var clens = function(pp, arg_r) {
	  var r = 2 * Math.cos(arg_r);
	  var i = pp.length - 1;
	  var hr1 = pp[i];
	  var hr2 = 0;
	  var hr;

	  while (--i >= 0) {
	    hr = -hr2 + r * hr1 + pp[i];
	    hr2 = hr1;
	    hr1 = hr;
	  }

	  return Math.sin(arg_r) * hr;
	};

	var cosh = function(x) {
	  var r = Math.exp(x);
	  r = (r + 1 / r) / 2;
	  return r;
	};

	var clens_cmplx = function(pp, arg_r, arg_i) {
	  var sin_arg_r = Math.sin(arg_r);
	  var cos_arg_r = Math.cos(arg_r);
	  var sinh_arg_i = sinh(arg_i);
	  var cosh_arg_i = cosh(arg_i);
	  var r = 2 * cos_arg_r * cosh_arg_i;
	  var i = -2 * sin_arg_r * sinh_arg_i;
	  var j = pp.length - 1;
	  var hr = pp[j];
	  var hi1 = 0;
	  var hr1 = 0;
	  var hi = 0;
	  var hr2;
	  var hi2;

	  while (--j >= 0) {
	    hr2 = hr1;
	    hi2 = hi1;
	    hr1 = hr;
	    hi1 = hi;
	    hr = -hr2 + r * hr1 - i * hi1 + pp[j];
	    hi = -hi2 + i * hr1 + r * hi1;
	  }

	  r = sin_arg_r * cosh_arg_i;
	  i = cos_arg_r * sinh_arg_i;

	  return [r * hr - i * hi, r * hi + i * hr];
	};

	// Heavily based on this etmerc projection implementation
	// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js

	function init$3() {
	  if (this.es === undefined || this.es <= 0) {
	    throw new Error('incorrect elliptical usage');
	  }

	  this.x0 = this.x0 !== undefined ? this.x0 : 0;
	  this.y0 = this.y0 !== undefined ? this.y0 : 0;
	  this.long0 = this.long0 !== undefined ? this.long0 : 0;
	  this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;

	  this.cgb = [];
	  this.cbg = [];
	  this.utg = [];
	  this.gtu = [];

	  var f = this.es / (1 + Math.sqrt(1 - this.es));
	  var n = f / (2 - f);
	  var np = n;

	  this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675 ))))));
	  this.cbg[0] = n * (-2 + n * ( 2 / 3 + n * ( 4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));

	  np = np * n;
	  this.cgb[1] = np * (7 / 3 + n * (-8 / 5 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
	  this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * ( -13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));

	  np = np * n;
	  this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
	  this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (8 / 5 + n * (-12686 / 2835))));

	  np = np * n;
	  this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
	  this.cbg[3] = np * (1237 / 630 + n * (-12 / 5 + n * ( -24832 / 14175)));

	  np = np * n;
	  this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
	  this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));

	  np = np * n;
	  this.cgb[5] = np * (601676 / 22275);
	  this.cbg[5] = np * (444337 / 155925);

	  np = Math.pow(n, 2);
	  this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));

	  this.utg[0] = n * (-0.5 + n * ( 2 / 3 + n * (-37 / 96 + n * ( 1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
	  this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));

	  this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
	  this.gtu[1] = np * (13 / 48 + n * (-3 / 5 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));

	  np = np * n;
	  this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720 ))));
	  this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));

	  np = np * n;
	  this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
	  this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));

	  np = np * n;
	  this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
	  this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));

	  np = np * n;
	  this.utg[5] = np * (-20648693 / 638668800);
	  this.gtu[5] = np * (212378941 / 319334400);

	  var Z = gatg(this.cbg, this.lat0);
	  this.Zb = -this.Qn * (Z + clens(this.gtu, 2 * Z));
	}

	function forward$3(p) {
	  var Ce = adjust_lon(p.x - this.long0);
	  var Cn = p.y;

	  Cn = gatg(this.cbg, Cn);
	  var sin_Cn = Math.sin(Cn);
	  var cos_Cn = Math.cos(Cn);
	  var sin_Ce = Math.sin(Ce);
	  var cos_Ce = Math.cos(Ce);

	  Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
	  Ce = Math.atan2(sin_Ce * cos_Cn, hypot(sin_Cn, cos_Cn * cos_Ce));
	  Ce = asinhy(Math.tan(Ce));

	  var tmp = clens_cmplx(this.gtu, 2 * Cn, 2 * Ce);

	  Cn = Cn + tmp[0];
	  Ce = Ce + tmp[1];

	  var x;
	  var y;

	  if (Math.abs(Ce) <= 2.623395162778) {
	    x = this.a * (this.Qn * Ce) + this.x0;
	    y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
	  }
	  else {
	    x = Infinity;
	    y = Infinity;
	  }

	  p.x = x;
	  p.y = y;

	  return p;
	}

	function inverse$3(p) {
	  var Ce = (p.x - this.x0) * (1 / this.a);
	  var Cn = (p.y - this.y0) * (1 / this.a);

	  Cn = (Cn - this.Zb) / this.Qn;
	  Ce = Ce / this.Qn;

	  var lon;
	  var lat;

	  if (Math.abs(Ce) <= 2.623395162778) {
	    var tmp = clens_cmplx(this.utg, 2 * Cn, 2 * Ce);

	    Cn = Cn + tmp[0];
	    Ce = Ce + tmp[1];
	    Ce = Math.atan(sinh(Ce));

	    var sin_Cn = Math.sin(Cn);
	    var cos_Cn = Math.cos(Cn);
	    var sin_Ce = Math.sin(Ce);
	    var cos_Ce = Math.cos(Ce);

	    Cn = Math.atan2(sin_Cn * cos_Ce, hypot(sin_Ce, cos_Ce * cos_Cn));
	    Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);

	    lon = adjust_lon(Ce + this.long0);
	    lat = gatg(this.cgb, Cn);
	  }
	  else {
	    lon = Infinity;
	    lat = Infinity;
	  }

	  p.x = lon;
	  p.y = lat;

	  return p;
	}

	var names$4 = ["Extended_Transverse_Mercator", "Extended Transverse Mercator", "etmerc"];
	var etmerc = {
	  init: init$3,
	  forward: forward$3,
	  inverse: inverse$3,
	  names: names$4
	};

	var adjust_zone = function(zone, lon) {
	  if (zone === undefined) {
	    zone = Math.floor((adjust_lon(lon) + Math.PI) * 30 / Math.PI) + 1;

	    if (zone < 0) {
	      return 0;
	    } else if (zone > 60) {
	      return 60;
	    }
	  }
	  return zone;
	};

	var dependsOn = 'etmerc';
	function init$4() {
	  var zone = adjust_zone(this.zone, this.long0);
	  if (zone === undefined) {
	    throw new Error('unknown utm zone');
	  }
	  this.lat0 = 0;
	  this.long0 =  ((6 * Math.abs(zone)) - 183) * D2R;
	  this.x0 = 500000;
	  this.y0 = this.utmSouth ? 10000000 : 0;
	  this.k0 = 0.9996;

	  etmerc.init.apply(this);
	  this.forward = etmerc.forward;
	  this.inverse = etmerc.inverse;
	}

	var names$5 = ["Universal Transverse Mercator System", "utm"];
	var utm = {
	  init: init$4,
	  names: names$5,
	  dependsOn: dependsOn
	};

	var srat = function(esinp, exp) {
	  return (Math.pow((1 - esinp) / (1 + esinp), exp));
	};

	var MAX_ITER$1 = 20;
	function init$6() {
	  var sphi = Math.sin(this.lat0);
	  var cphi = Math.cos(this.lat0);
	  cphi *= cphi;
	  this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
	  this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
	  this.phic0 = Math.asin(sphi / this.C);
	  this.ratexp = 0.5 * this.C * this.e;
	  this.K = Math.tan(0.5 * this.phic0 + FORTPI) / (Math.pow(Math.tan(0.5 * this.lat0 + FORTPI), this.C) * srat(this.e * sphi, this.ratexp));
	}

	function forward$5(p) {
	  var lon = p.x;
	  var lat = p.y;

	  p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + FORTPI), this.C) * srat(this.e * Math.sin(lat), this.ratexp)) - HALF_PI;
	  p.x = this.C * lon;
	  return p;
	}

	function inverse$5(p) {
	  var DEL_TOL = 1e-14;
	  var lon = p.x / this.C;
	  var lat = p.y;
	  var num = Math.pow(Math.tan(0.5 * lat + FORTPI) / this.K, 1 / this.C);
	  for (var i = MAX_ITER$1; i > 0; --i) {
	    lat = 2 * Math.atan(num * srat(this.e * Math.sin(p.y), - 0.5 * this.e)) - HALF_PI;
	    if (Math.abs(lat - p.y) < DEL_TOL) {
	      break;
	    }
	    p.y = lat;
	  }
	  /* convergence failed */
	  if (!i) {
	    return null;
	  }
	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$7 = ["gauss"];
	var gauss = {
	  init: init$6,
	  forward: forward$5,
	  inverse: inverse$5,
	  names: names$7
	};

	function init$5() {
	  gauss.init.apply(this);
	  if (!this.rc) {
	    return;
	  }
	  this.sinc0 = Math.sin(this.phic0);
	  this.cosc0 = Math.cos(this.phic0);
	  this.R2 = 2 * this.rc;
	  if (!this.title) {
	    this.title = "Oblique Stereographic Alternative";
	  }
	}

	function forward$4(p) {
	  var sinc, cosc, cosl, k;
	  p.x = adjust_lon(p.x - this.long0);
	  gauss.forward.apply(this, [p]);
	  sinc = Math.sin(p.y);
	  cosc = Math.cos(p.y);
	  cosl = Math.cos(p.x);
	  k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
	  p.x = k * cosc * Math.sin(p.x);
	  p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
	  p.x = this.a * p.x + this.x0;
	  p.y = this.a * p.y + this.y0;
	  return p;
	}

	function inverse$4(p) {
	  var sinc, cosc, lon, lat, rho;
	  p.x = (p.x - this.x0) / this.a;
	  p.y = (p.y - this.y0) / this.a;

	  p.x /= this.k0;
	  p.y /= this.k0;
	  if ((rho = Math.sqrt(p.x * p.x + p.y * p.y))) {
	    var c = 2 * Math.atan2(rho, this.R2);
	    sinc = Math.sin(c);
	    cosc = Math.cos(c);
	    lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
	    lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
	  }
	  else {
	    lat = this.phic0;
	    lon = 0;
	  }

	  p.x = lon;
	  p.y = lat;
	  gauss.inverse.apply(this, [p]);
	  p.x = adjust_lon(p.x + this.long0);
	  return p;
	}

	var names$6 = ["Stereographic_North_Pole", "Oblique_Stereographic", "Polar_Stereographic", "sterea","Oblique Stereographic Alternative"];
	var sterea = {
	  init: init$5,
	  forward: forward$4,
	  inverse: inverse$4,
	  names: names$6
	};

	function ssfn_(phit, sinphi, eccen) {
	  sinphi *= eccen;
	  return (Math.tan(0.5 * (HALF_PI + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen));
	}

	function init$7() {
	  this.coslat0 = Math.cos(this.lat0);
	  this.sinlat0 = Math.sin(this.lat0);
	  if (this.sphere) {
	    if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
	      this.k0 = 0.5 * (1 + sign(this.lat0) * Math.sin(this.lat_ts));
	    }
	  }
	  else {
	    if (Math.abs(this.coslat0) <= EPSLN) {
	      if (this.lat0 > 0) {
	        //North pole
	        //trace('stere:north pole');
	        this.con = 1;
	      }
	      else {
	        //South pole
	        //trace('stere:south pole');
	        this.con = -1;
	      }
	    }
	    this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
	    if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
	      this.k0 = 0.5 * this.cons * msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / tsfnz(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
	    }
	    this.ms1 = msfnz(this.e, this.sinlat0, this.coslat0);
	    this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - HALF_PI;
	    this.cosX0 = Math.cos(this.X0);
	    this.sinX0 = Math.sin(this.X0);
	  }
	}

	// Stereographic forward equations--mapping lat,long to x,y
	function forward$6(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var sinlat = Math.sin(lat);
	  var coslat = Math.cos(lat);
	  var A, X, sinX, cosX, ts, rh;
	  var dlon = adjust_lon(lon - this.long0);

	  if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= EPSLN && Math.abs(lat + this.lat0) <= EPSLN) {
	    //case of the origine point
	    //trace('stere:this is the origin point');
	    p.x = NaN;
	    p.y = NaN;
	    return p;
	  }
	  if (this.sphere) {
	    //trace('stere:sphere case');
	    A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
	    p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
	    p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
	    return p;
	  }
	  else {
	    X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - HALF_PI;
	    cosX = Math.cos(X);
	    sinX = Math.sin(X);
	    if (Math.abs(this.coslat0) <= EPSLN) {
	      ts = tsfnz(this.e, lat * this.con, this.con * sinlat);
	      rh = 2 * this.a * this.k0 * ts / this.cons;
	      p.x = this.x0 + rh * Math.sin(lon - this.long0);
	      p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
	      //trace(p.toString());
	      return p;
	    }
	    else if (Math.abs(this.sinlat0) < EPSLN) {
	      //Eq
	      //trace('stere:equateur');
	      A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
	      p.y = A * sinX;
	    }
	    else {
	      //other case
	      //trace('stere:normal case');
	      A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
	      p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
	    }
	    p.x = A * cosX * Math.sin(dlon) + this.x0;
	  }
	  //trace(p.toString());
	  return p;
	}

	//* Stereographic inverse equations--mapping x,y to lat/long
	function inverse$6(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;
	  var lon, lat, ts, ce, Chi;
	  var rh = Math.sqrt(p.x * p.x + p.y * p.y);
	  if (this.sphere) {
	    var c = 2 * Math.atan(rh / (0.5 * this.a * this.k0));
	    lon = this.long0;
	    lat = this.lat0;
	    if (rh <= EPSLN) {
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	    lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
	    if (Math.abs(this.coslat0) < EPSLN) {
	      if (this.lat0 > 0) {
	        lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
	      }
	      else {
	        lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
	      }
	    }
	    else {
	      lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
	    }
	    p.x = lon;
	    p.y = lat;
	    return p;
	  }
	  else {
	    if (Math.abs(this.coslat0) <= EPSLN) {
	      if (rh <= EPSLN) {
	        lat = this.lat0;
	        lon = this.long0;
	        p.x = lon;
	        p.y = lat;
	        //trace(p.toString());
	        return p;
	      }
	      p.x *= this.con;
	      p.y *= this.con;
	      ts = rh * this.cons / (2 * this.a * this.k0);
	      lat = this.con * phi2z(this.e, ts);
	      lon = this.con * adjust_lon(this.con * this.long0 + Math.atan2(p.x, - 1 * p.y));
	    }
	    else {
	      ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
	      lon = this.long0;
	      if (rh <= EPSLN) {
	        Chi = this.X0;
	      }
	      else {
	        Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
	        lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
	      }
	      lat = -1 * phi2z(this.e, Math.tan(0.5 * (HALF_PI + Chi)));
	    }
	  }
	  p.x = lon;
	  p.y = lat;

	  //trace(p.toString());
	  return p;

	}

	var names$8 = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)"];
	var stere = {
	  init: init$7,
	  forward: forward$6,
	  inverse: inverse$6,
	  names: names$8,
	  ssfn_: ssfn_
	};

	/*
	  references:
	    Formules et constantes pour le Calcul pour la
	    projection cylindrique conforme à axe oblique et pour la transformation entre
	    des systèmes de référence.
	    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
	  */

	function init$8() {
	  var phy0 = this.lat0;
	  this.lambda0 = this.long0;
	  var sinPhy0 = Math.sin(phy0);
	  var semiMajorAxis = this.a;
	  var invF = this.rf;
	  var flattening = 1 / invF;
	  var e2 = 2 * flattening - Math.pow(flattening, 2);
	  var e = this.e = Math.sqrt(e2);
	  this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
	  this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
	  this.b0 = Math.asin(sinPhy0 / this.alpha);
	  var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
	  var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
	  var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
	  this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
	}

	function forward$7(p) {
	  var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
	  var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
	  var S = -this.alpha * (Sa1 + Sa2) + this.K;

	  // spheric latitude
	  var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);

	  // spheric longitude
	  var I = this.alpha * (p.x - this.lambda0);

	  // psoeudo equatorial rotation
	  var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));

	  var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));

	  p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
	  p.x = this.R * rotI + this.x0;
	  return p;
	}

	function inverse$7(p) {
	  var Y = p.x - this.x0;
	  var X = p.y - this.y0;

	  var rotI = Y / this.R;
	  var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);

	  var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
	  var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));

	  var lambda = this.lambda0 + I / this.alpha;

	  var S = 0;
	  var phy = b;
	  var prevPhy = -1000;
	  var iteration = 0;
	  while (Math.abs(phy - prevPhy) > 0.0000001) {
	    if (++iteration > 20) {
	      //...reportError("omercFwdInfinity");
	      return;
	    }
	    //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
	    S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
	    prevPhy = phy;
	    phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
	  }

	  p.x = lambda;
	  p.y = phy;
	  return p;
	}

	var names$9 = ["somerc"];
	var somerc = {
	  init: init$8,
	  forward: forward$7,
	  inverse: inverse$7,
	  names: names$9
	};

	/* Initialize the Oblique Mercator  projection
	    ------------------------------------------*/
	function init$9() {
	  this.no_off = this.no_off || false;
	  this.no_rot = this.no_rot || false;

	  if (isNaN(this.k0)) {
	    this.k0 = 1;
	  }
	  var sinlat = Math.sin(this.lat0);
	  var coslat = Math.cos(this.lat0);
	  var con = this.e * sinlat;

	  this.bl = Math.sqrt(1 + this.es / (1 - this.es) * Math.pow(coslat, 4));
	  this.al = this.a * this.bl * this.k0 * Math.sqrt(1 - this.es) / (1 - con * con);
	  var t0 = tsfnz(this.e, this.lat0, sinlat);
	  var dl = this.bl / coslat * Math.sqrt((1 - this.es) / (1 - con * con));
	  if (dl * dl < 1) {
	    dl = 1;
	  }
	  var fl;
	  var gl;
	  if (!isNaN(this.longc)) {
	    //Central point and azimuth method

	    if (this.lat0 >= 0) {
	      fl = dl + Math.sqrt(dl * dl - 1);
	    }
	    else {
	      fl = dl - Math.sqrt(dl * dl - 1);
	    }
	    this.el = fl * Math.pow(t0, this.bl);
	    gl = 0.5 * (fl - 1 / fl);
	    this.gamma0 = Math.asin(Math.sin(this.alpha) / dl);
	    this.long0 = this.longc - Math.asin(gl * Math.tan(this.gamma0)) / this.bl;

	  }
	  else {
	    //2 points method
	    var t1 = tsfnz(this.e, this.lat1, Math.sin(this.lat1));
	    var t2 = tsfnz(this.e, this.lat2, Math.sin(this.lat2));
	    if (this.lat0 >= 0) {
	      this.el = (dl + Math.sqrt(dl * dl - 1)) * Math.pow(t0, this.bl);
	    }
	    else {
	      this.el = (dl - Math.sqrt(dl * dl - 1)) * Math.pow(t0, this.bl);
	    }
	    var hl = Math.pow(t1, this.bl);
	    var ll = Math.pow(t2, this.bl);
	    fl = this.el / hl;
	    gl = 0.5 * (fl - 1 / fl);
	    var jl = (this.el * this.el - ll * hl) / (this.el * this.el + ll * hl);
	    var pl = (ll - hl) / (ll + hl);
	    var dlon12 = adjust_lon(this.long1 - this.long2);
	    this.long0 = 0.5 * (this.long1 + this.long2) - Math.atan(jl * Math.tan(0.5 * this.bl * (dlon12)) / pl) / this.bl;
	    this.long0 = adjust_lon(this.long0);
	    var dlon10 = adjust_lon(this.long1 - this.long0);
	    this.gamma0 = Math.atan(Math.sin(this.bl * (dlon10)) / gl);
	    this.alpha = Math.asin(dl * Math.sin(this.gamma0));
	  }

	  if (this.no_off) {
	    this.uc = 0;
	  }
	  else {
	    if (this.lat0 >= 0) {
	      this.uc = this.al / this.bl * Math.atan2(Math.sqrt(dl * dl - 1), Math.cos(this.alpha));
	    }
	    else {
	      this.uc = -1 * this.al / this.bl * Math.atan2(Math.sqrt(dl * dl - 1), Math.cos(this.alpha));
	    }
	  }

	}

	/* Oblique Mercator forward equations--mapping lat,long to x,y
	    ----------------------------------------------------------*/
	function forward$8(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var dlon = adjust_lon(lon - this.long0);
	  var us, vs;
	  var con;
	  if (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
	    if (lat > 0) {
	      con = -1;
	    }
	    else {
	      con = 1;
	    }
	    vs = this.al / this.bl * Math.log(Math.tan(FORTPI + con * this.gamma0 * 0.5));
	    us = -1 * con * HALF_PI * this.al / this.bl;
	  }
	  else {
	    var t = tsfnz(this.e, lat, Math.sin(lat));
	    var ql = this.el / Math.pow(t, this.bl);
	    var sl = 0.5 * (ql - 1 / ql);
	    var tl = 0.5 * (ql + 1 / ql);
	    var vl = Math.sin(this.bl * (dlon));
	    var ul = (sl * Math.sin(this.gamma0) - vl * Math.cos(this.gamma0)) / tl;
	    if (Math.abs(Math.abs(ul) - 1) <= EPSLN) {
	      vs = Number.POSITIVE_INFINITY;
	    }
	    else {
	      vs = 0.5 * this.al * Math.log((1 - ul) / (1 + ul)) / this.bl;
	    }
	    if (Math.abs(Math.cos(this.bl * (dlon))) <= EPSLN) {
	      us = this.al * this.bl * (dlon);
	    }
	    else {
	      us = this.al * Math.atan2(sl * Math.cos(this.gamma0) + vl * Math.sin(this.gamma0), Math.cos(this.bl * dlon)) / this.bl;
	    }
	  }

	  if (this.no_rot) {
	    p.x = this.x0 + us;
	    p.y = this.y0 + vs;
	  }
	  else {

	    us -= this.uc;
	    p.x = this.x0 + vs * Math.cos(this.alpha) + us * Math.sin(this.alpha);
	    p.y = this.y0 + us * Math.cos(this.alpha) - vs * Math.sin(this.alpha);
	  }
	  return p;
	}

	function inverse$8(p) {
	  var us, vs;
	  if (this.no_rot) {
	    vs = p.y - this.y0;
	    us = p.x - this.x0;
	  }
	  else {
	    vs = (p.x - this.x0) * Math.cos(this.alpha) - (p.y - this.y0) * Math.sin(this.alpha);
	    us = (p.y - this.y0) * Math.cos(this.alpha) + (p.x - this.x0) * Math.sin(this.alpha);
	    us += this.uc;
	  }
	  var qp = Math.exp(-1 * this.bl * vs / this.al);
	  var sp = 0.5 * (qp - 1 / qp);
	  var tp = 0.5 * (qp + 1 / qp);
	  var vp = Math.sin(this.bl * us / this.al);
	  var up = (vp * Math.cos(this.gamma0) + sp * Math.sin(this.gamma0)) / tp;
	  var ts = Math.pow(this.el / Math.sqrt((1 + up) / (1 - up)), 1 / this.bl);
	  if (Math.abs(up - 1) < EPSLN) {
	    p.x = this.long0;
	    p.y = HALF_PI;
	  }
	  else if (Math.abs(up + 1) < EPSLN) {
	    p.x = this.long0;
	    p.y = -1 * HALF_PI;
	  }
	  else {
	    p.y = phi2z(this.e, ts);
	    p.x = adjust_lon(this.long0 - Math.atan2(sp * Math.cos(this.gamma0) - vp * Math.sin(this.gamma0), Math.cos(this.bl * us / this.al)) / this.bl);
	  }
	  return p;
	}

	var names$10 = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "omerc"];
	var omerc = {
	  init: init$9,
	  forward: forward$8,
	  inverse: inverse$8,
	  names: names$10
	};

	function init$10() {

	  // array of:  r_maj,r_min,lat1,lat2,c_lon,c_lat,false_east,false_north
	  //double c_lat;                   /* center latitude                      */
	  //double c_lon;                   /* center longitude                     */
	  //double lat1;                    /* first standard parallel              */
	  //double lat2;                    /* second standard parallel             */
	  //double r_maj;                   /* major axis                           */
	  //double r_min;                   /* minor axis                           */
	  //double false_east;              /* x offset in meters                   */
	  //double false_north;             /* y offset in meters                   */

	  if (!this.lat2) {
	    this.lat2 = this.lat1;
	  } //if lat2 is not defined
	  if (!this.k0) {
	    this.k0 = 1;
	  }
	  this.x0 = this.x0 || 0;
	  this.y0 = this.y0 || 0;
	  // Standard Parallels cannot be equal and on opposite sides of the equator
	  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
	    return;
	  }

	  var temp = this.b / this.a;
	  this.e = Math.sqrt(1 - temp * temp);

	  var sin1 = Math.sin(this.lat1);
	  var cos1 = Math.cos(this.lat1);
	  var ms1 = msfnz(this.e, sin1, cos1);
	  var ts1 = tsfnz(this.e, this.lat1, sin1);

	  var sin2 = Math.sin(this.lat2);
	  var cos2 = Math.cos(this.lat2);
	  var ms2 = msfnz(this.e, sin2, cos2);
	  var ts2 = tsfnz(this.e, this.lat2, sin2);

	  var ts0 = tsfnz(this.e, this.lat0, Math.sin(this.lat0));

	  if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
	    this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
	  }
	  else {
	    this.ns = sin1;
	  }
	  if (isNaN(this.ns)) {
	    this.ns = sin1;
	  }
	  this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
	  this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
	  if (!this.title) {
	    this.title = "Lambert Conformal Conic";
	  }
	}

	// Lambert Conformal conic forward equations--mapping lat,long to x,y
	// -----------------------------------------------------------------
	function forward$9(p) {

	  var lon = p.x;
	  var lat = p.y;

	  // singular cases :
	  if (Math.abs(2 * Math.abs(lat) - Math.PI) <= EPSLN) {
	    lat = sign(lat) * (HALF_PI - 2 * EPSLN);
	  }

	  var con = Math.abs(Math.abs(lat) - HALF_PI);
	  var ts, rh1;
	  if (con > EPSLN) {
	    ts = tsfnz(this.e, lat, Math.sin(lat));
	    rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
	  }
	  else {
	    con = lat * this.ns;
	    if (con <= 0) {
	      return null;
	    }
	    rh1 = 0;
	  }
	  var theta = this.ns * adjust_lon(lon - this.long0);
	  p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
	  p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;

	  return p;
	}

	// Lambert Conformal Conic inverse equations--mapping x,y to lat/long
	// -----------------------------------------------------------------
	function inverse$9(p) {

	  var rh1, con, ts;
	  var lat, lon;
	  var x = (p.x - this.x0) / this.k0;
	  var y = (this.rh - (p.y - this.y0) / this.k0);
	  if (this.ns > 0) {
	    rh1 = Math.sqrt(x * x + y * y);
	    con = 1;
	  }
	  else {
	    rh1 = -Math.sqrt(x * x + y * y);
	    con = -1;
	  }
	  var theta = 0;
	  if (rh1 !== 0) {
	    theta = Math.atan2((con * x), (con * y));
	  }
	  if ((rh1 !== 0) || (this.ns > 0)) {
	    con = 1 / this.ns;
	    ts = Math.pow((rh1 / (this.a * this.f0)), con);
	    lat = phi2z(this.e, ts);
	    if (lat === -9999) {
	      return null;
	    }
	  }
	  else {
	    lat = -HALF_PI;
	  }
	  lon = adjust_lon(theta / this.ns + this.long0);

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$11 = ["Lambert Tangential Conformal Conic Projection", "Lambert_Conformal_Conic", "Lambert_Conformal_Conic_2SP", "lcc"];
	var lcc = {
	  init: init$10,
	  forward: forward$9,
	  inverse: inverse$9,
	  names: names$11
	};

	function init$11() {
	  this.a = 6377397.155;
	  this.es = 0.006674372230614;
	  this.e = Math.sqrt(this.es);
	  if (!this.lat0) {
	    this.lat0 = 0.863937979737193;
	  }
	  if (!this.long0) {
	    this.long0 = 0.7417649320975901 - 0.308341501185665;
	  }
	  /* if scale not set default to 0.9999 */
	  if (!this.k0) {
	    this.k0 = 0.9999;
	  }
	  this.s45 = 0.785398163397448; /* 45 */
	  this.s90 = 2 * this.s45;
	  this.fi0 = this.lat0;
	  this.e2 = this.es;
	  this.e = Math.sqrt(this.e2);
	  this.alfa = Math.sqrt(1 + (this.e2 * Math.pow(Math.cos(this.fi0), 4)) / (1 - this.e2));
	  this.uq = 1.04216856380474;
	  this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
	  this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
	  this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
	  this.k1 = this.k0;
	  this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
	  this.s0 = 1.37008346281555;
	  this.n = Math.sin(this.s0);
	  this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
	  this.ad = this.s90 - this.uq;
	}

	/* ellipsoid */
	/* calculate xy from lat/lon */
	/* Constants, identical to inverse transform function */
	function forward$10(p) {
	  var gfi, u, deltav, s, d, eps, ro;
	  var lon = p.x;
	  var lat = p.y;
	  var delta_lon = adjust_lon(lon - this.long0);
	  /* Transformation */
	  gfi = Math.pow(((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat))), (this.alfa * this.e / 2));
	  u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
	  deltav = -delta_lon * this.alfa;
	  s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
	  d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
	  eps = this.n * d;
	  ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
	  p.y = ro * Math.cos(eps) / 1;
	  p.x = ro * Math.sin(eps) / 1;

	  if (!this.czech) {
	    p.y *= -1;
	    p.x *= -1;
	  }
	  return (p);
	}

	/* calculate lat/lon from xy */
	function inverse$10(p) {
	  var u, deltav, s, d, eps, ro, fi1;
	  var ok;

	  /* Transformation */
	  /* revert y, x*/
	  var tmp = p.x;
	  p.x = p.y;
	  p.y = tmp;
	  if (!this.czech) {
	    p.y *= -1;
	    p.x *= -1;
	  }
	  ro = Math.sqrt(p.x * p.x + p.y * p.y);
	  eps = Math.atan2(p.y, p.x);
	  d = eps / Math.sin(this.s0);
	  s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
	  u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
	  deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
	  p.x = this.long0 - deltav / this.alfa;
	  fi1 = u;
	  ok = 0;
	  var iter = 0;
	  do {
	    p.y = 2 * (Math.atan(Math.pow(this.k, - 1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
	    if (Math.abs(fi1 - p.y) < 0.0000000001) {
	      ok = 1;
	    }
	    fi1 = p.y;
	    iter += 1;
	  } while (ok === 0 && iter < 15);
	  if (iter >= 15) {
	    return null;
	  }

	  return (p);
	}

	var names$12 = ["Krovak", "krovak"];
	var krovak = {
	  init: init$11,
	  forward: forward$10,
	  inverse: inverse$10,
	  names: names$12
	};

	var mlfn = function(e0, e1, e2, e3, phi) {
	  return (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi));
	};

	var e0fn = function(x) {
	  return (1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x)));
	};

	var e1fn = function(x) {
	  return (0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x)));
	};

	var e2fn = function(x) {
	  return (0.05859375 * x * x * (1 + 0.75 * x));
	};

	var e3fn = function(x) {
	  return (x * x * x * (35 / 3072));
	};

	var gN = function(a, e, sinphi) {
	  var temp = e * sinphi;
	  return a / Math.sqrt(1 - temp * temp);
	};

	var adjust_lat = function(x) {
	  return (Math.abs(x) < HALF_PI) ? x : (x - (sign(x) * Math.PI));
	};

	var imlfn = function(ml, e0, e1, e2, e3) {
	  var phi;
	  var dphi;

	  phi = ml / e0;
	  for (var i = 0; i < 15; i++) {
	    dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
	    phi += dphi;
	    if (Math.abs(dphi) <= 0.0000000001) {
	      return phi;
	    }
	  }

	  //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
	  return NaN;
	};

	function init$12() {
	  if (!this.sphere) {
	    this.e0 = e0fn(this.es);
	    this.e1 = e1fn(this.es);
	    this.e2 = e2fn(this.es);
	    this.e3 = e3fn(this.es);
	    this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
	  }
	}

	/* Cassini forward equations--mapping lat,long to x,y
	  -----------------------------------------------------------------------*/
	function forward$11(p) {

	  /* Forward equations
	      -----------------*/
	  var x, y;
	  var lam = p.x;
	  var phi = p.y;
	  lam = adjust_lon(lam - this.long0);

	  if (this.sphere) {
	    x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
	    y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
	  }
	  else {
	    //ellipsoid
	    var sinphi = Math.sin(phi);
	    var cosphi = Math.cos(phi);
	    var nl = gN(this.a, this.e, sinphi);
	    var tl = Math.tan(phi) * Math.tan(phi);
	    var al = lam * Math.cos(phi);
	    var asq = al * al;
	    var cl = this.es * cosphi * cosphi / (1 - this.es);
	    var ml = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);

	    x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
	    y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);


	  }

	  p.x = x + this.x0;
	  p.y = y + this.y0;
	  return p;
	}

	/* Inverse equations
	  -----------------*/
	function inverse$11(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;
	  var x = p.x / this.a;
	  var y = p.y / this.a;
	  var phi, lam;

	  if (this.sphere) {
	    var dd = y + this.lat0;
	    phi = Math.asin(Math.sin(dd) * Math.cos(x));
	    lam = Math.atan2(Math.tan(x), Math.cos(dd));
	  }
	  else {
	    /* ellipsoid */
	    var ml1 = this.ml0 / this.a + y;
	    var phi1 = imlfn(ml1, this.e0, this.e1, this.e2, this.e3);
	    if (Math.abs(Math.abs(phi1) - HALF_PI) <= EPSLN) {
	      p.x = this.long0;
	      p.y = HALF_PI;
	      if (y < 0) {
	        p.y *= -1;
	      }
	      return p;
	    }
	    var nl1 = gN(this.a, this.e, Math.sin(phi1));

	    var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
	    var tl1 = Math.pow(Math.tan(phi1), 2);
	    var dl = x * this.a / nl1;
	    var dsq = dl * dl;
	    phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
	    lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);

	  }

	  p.x = adjust_lon(lam + this.long0);
	  p.y = adjust_lat(phi);
	  return p;

	}

	var names$13 = ["Cassini", "Cassini_Soldner", "cass"];
	var cass = {
	  init: init$12,
	  forward: forward$11,
	  inverse: inverse$11,
	  names: names$13
	};

	var qsfnz = function(eccent, sinphi) {
	  var con;
	  if (eccent > 1.0e-7) {
	    con = eccent * sinphi;
	    return ((1 - eccent * eccent) * (sinphi / (1 - con * con) - (0.5 / eccent) * Math.log((1 - con) / (1 + con))));
	  }
	  else {
	    return (2 * sinphi);
	  }
	};

	/*
	  reference
	    "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
	    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
	  */

	var S_POLE = 1;

	var N_POLE = 2;
	var EQUIT = 3;
	var OBLIQ = 4;

	/* Initialize the Lambert Azimuthal Equal Area projection
	  ------------------------------------------------------*/
	function init$13() {
	  var t = Math.abs(this.lat0);
	  if (Math.abs(t - HALF_PI) < EPSLN) {
	    this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
	  }
	  else if (Math.abs(t) < EPSLN) {
	    this.mode = this.EQUIT;
	  }
	  else {
	    this.mode = this.OBLIQ;
	  }
	  if (this.es > 0) {
	    var sinphi;

	    this.qp = qsfnz(this.e, 1);
	    this.mmf = 0.5 / (1 - this.es);
	    this.apa = authset(this.es);
	    switch (this.mode) {
	    case this.N_POLE:
	      this.dd = 1;
	      break;
	    case this.S_POLE:
	      this.dd = 1;
	      break;
	    case this.EQUIT:
	      this.rq = Math.sqrt(0.5 * this.qp);
	      this.dd = 1 / this.rq;
	      this.xmf = 1;
	      this.ymf = 0.5 * this.qp;
	      break;
	    case this.OBLIQ:
	      this.rq = Math.sqrt(0.5 * this.qp);
	      sinphi = Math.sin(this.lat0);
	      this.sinb1 = qsfnz(this.e, sinphi) / this.qp;
	      this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
	      this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
	      this.ymf = (this.xmf = this.rq) / this.dd;
	      this.xmf *= this.dd;
	      break;
	    }
	  }
	  else {
	    if (this.mode === this.OBLIQ) {
	      this.sinph0 = Math.sin(this.lat0);
	      this.cosph0 = Math.cos(this.lat0);
	    }
	  }
	}

	/* Lambert Azimuthal Equal Area forward equations--mapping lat,long to x,y
	  -----------------------------------------------------------------------*/
	function forward$12(p) {

	  /* Forward equations
	      -----------------*/
	  var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
	  var lam = p.x;
	  var phi = p.y;

	  lam = adjust_lon(lam - this.long0);
	  if (this.sphere) {
	    sinphi = Math.sin(phi);
	    cosphi = Math.cos(phi);
	    coslam = Math.cos(lam);
	    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	      y = (this.mode === this.EQUIT) ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
	      if (y <= EPSLN) {
	        return null;
	      }
	      y = Math.sqrt(2 / y);
	      x = y * cosphi * Math.sin(lam);
	      y *= (this.mode === this.EQUIT) ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
	    }
	    else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
	      if (this.mode === this.N_POLE) {
	        coslam = -coslam;
	      }
	      if (Math.abs(phi + this.phi0) < EPSLN) {
	        return null;
	      }
	      y = FORTPI - phi * 0.5;
	      y = 2 * ((this.mode === this.S_POLE) ? Math.cos(y) : Math.sin(y));
	      x = y * Math.sin(lam);
	      y *= coslam;
	    }
	  }
	  else {
	    sinb = 0;
	    cosb = 0;
	    b = 0;
	    coslam = Math.cos(lam);
	    sinlam = Math.sin(lam);
	    sinphi = Math.sin(phi);
	    q = qsfnz(this.e, sinphi);
	    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	      sinb = q / this.qp;
	      cosb = Math.sqrt(1 - sinb * sinb);
	    }
	    switch (this.mode) {
	    case this.OBLIQ:
	      b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
	      break;
	    case this.EQUIT:
	      b = 1 + cosb * coslam;
	      break;
	    case this.N_POLE:
	      b = HALF_PI + phi;
	      q = this.qp - q;
	      break;
	    case this.S_POLE:
	      b = phi - HALF_PI;
	      q = this.qp + q;
	      break;
	    }
	    if (Math.abs(b) < EPSLN) {
	      return null;
	    }
	    switch (this.mode) {
	    case this.OBLIQ:
	    case this.EQUIT:
	      b = Math.sqrt(2 / b);
	      if (this.mode === this.OBLIQ) {
	        y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
	      }
	      else {
	        y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
	      }
	      x = this.xmf * b * cosb * sinlam;
	      break;
	    case this.N_POLE:
	    case this.S_POLE:
	      if (q >= 0) {
	        x = (b = Math.sqrt(q)) * sinlam;
	        y = coslam * ((this.mode === this.S_POLE) ? b : -b);
	      }
	      else {
	        x = y = 0;
	      }
	      break;
	    }
	  }

	  p.x = this.a * x + this.x0;
	  p.y = this.a * y + this.y0;
	  return p;
	}

	/* Inverse equations
	  -----------------*/
	function inverse$12(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;
	  var x = p.x / this.a;
	  var y = p.y / this.a;
	  var lam, phi, cCe, sCe, q, rho, ab;
	  if (this.sphere) {
	    var cosz = 0,
	      rh, sinz = 0;

	    rh = Math.sqrt(x * x + y * y);
	    phi = rh * 0.5;
	    if (phi > 1) {
	      return null;
	    }
	    phi = 2 * Math.asin(phi);
	    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	      sinz = Math.sin(phi);
	      cosz = Math.cos(phi);
	    }
	    switch (this.mode) {
	    case this.EQUIT:
	      phi = (Math.abs(rh) <= EPSLN) ? 0 : Math.asin(y * sinz / rh);
	      x *= sinz;
	      y = cosz * rh;
	      break;
	    case this.OBLIQ:
	      phi = (Math.abs(rh) <= EPSLN) ? this.phi0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
	      x *= sinz * this.cosph0;
	      y = (cosz - Math.sin(phi) * this.sinph0) * rh;
	      break;
	    case this.N_POLE:
	      y = -y;
	      phi = HALF_PI - phi;
	      break;
	    case this.S_POLE:
	      phi -= HALF_PI;
	      break;
	    }
	    lam = (y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ)) ? 0 : Math.atan2(x, y);
	  }
	  else {
	    ab = 0;
	    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	      x /= this.dd;
	      y *= this.dd;
	      rho = Math.sqrt(x * x + y * y);
	      if (rho < EPSLN) {
	        p.x = 0;
	        p.y = this.phi0;
	        return p;
	      }
	      sCe = 2 * Math.asin(0.5 * rho / this.rq);
	      cCe = Math.cos(sCe);
	      x *= (sCe = Math.sin(sCe));
	      if (this.mode === this.OBLIQ) {
	        ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
	        q = this.qp * ab;
	        y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
	      }
	      else {
	        ab = y * sCe / rho;
	        q = this.qp * ab;
	        y = rho * cCe;
	      }
	    }
	    else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
	      if (this.mode === this.N_POLE) {
	        y = -y;
	      }
	      q = (x * x + y * y);
	      if (!q) {
	        p.x = 0;
	        p.y = this.phi0;
	        return p;
	      }
	      ab = 1 - q / this.qp;
	      if (this.mode === this.S_POLE) {
	        ab = -ab;
	      }
	    }
	    lam = Math.atan2(x, y);
	    phi = authlat(Math.asin(ab), this.apa);
	  }

	  p.x = adjust_lon(this.long0 + lam);
	  p.y = phi;
	  return p;
	}

	/* determine latitude from authalic latitude */
	var P00 = 0.33333333333333333333;

	var P01 = 0.17222222222222222222;
	var P02 = 0.10257936507936507936;
	var P10 = 0.06388888888888888888;
	var P11 = 0.06640211640211640211;
	var P20 = 0.01641501294219154443;

	function authset(es) {
	  var t;
	  var APA = [];
	  APA[0] = es * P00;
	  t = es * es;
	  APA[0] += t * P01;
	  APA[1] = t * P10;
	  t *= es;
	  APA[0] += t * P02;
	  APA[1] += t * P11;
	  APA[2] = t * P20;
	  return APA;
	}

	function authlat(beta, APA) {
	  var t = beta + beta;
	  return (beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t));
	}

	var names$14 = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
	var laea = {
	  init: init$13,
	  forward: forward$12,
	  inverse: inverse$12,
	  names: names$14,
	  S_POLE: S_POLE,
	  N_POLE: N_POLE,
	  EQUIT: EQUIT,
	  OBLIQ: OBLIQ
	};

	var asinz = function(x) {
	  if (Math.abs(x) > 1) {
	    x = (x > 1) ? 1 : -1;
	  }
	  return Math.asin(x);
	};

	function init$14() {

	  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
	    return;
	  }
	  this.temp = this.b / this.a;
	  this.es = 1 - Math.pow(this.temp, 2);
	  this.e3 = Math.sqrt(this.es);

	  this.sin_po = Math.sin(this.lat1);
	  this.cos_po = Math.cos(this.lat1);
	  this.t1 = this.sin_po;
	  this.con = this.sin_po;
	  this.ms1 = msfnz(this.e3, this.sin_po, this.cos_po);
	  this.qs1 = qsfnz(this.e3, this.sin_po, this.cos_po);

	  this.sin_po = Math.sin(this.lat2);
	  this.cos_po = Math.cos(this.lat2);
	  this.t2 = this.sin_po;
	  this.ms2 = msfnz(this.e3, this.sin_po, this.cos_po);
	  this.qs2 = qsfnz(this.e3, this.sin_po, this.cos_po);

	  this.sin_po = Math.sin(this.lat0);
	  this.cos_po = Math.cos(this.lat0);
	  this.t3 = this.sin_po;
	  this.qs0 = qsfnz(this.e3, this.sin_po, this.cos_po);

	  if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
	    this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
	  }
	  else {
	    this.ns0 = this.con;
	  }
	  this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
	  this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
	}

	/* Albers Conical Equal Area forward equations--mapping lat,long to x,y
	  -------------------------------------------------------------------*/
	function forward$13(p) {

	  var lon = p.x;
	  var lat = p.y;

	  this.sin_phi = Math.sin(lat);
	  this.cos_phi = Math.cos(lat);

	  var qs = qsfnz(this.e3, this.sin_phi, this.cos_phi);
	  var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
	  var theta = this.ns0 * adjust_lon(lon - this.long0);
	  var x = rh1 * Math.sin(theta) + this.x0;
	  var y = this.rh - rh1 * Math.cos(theta) + this.y0;

	  p.x = x;
	  p.y = y;
	  return p;
	}

	function inverse$13(p) {
	  var rh1, qs, con, theta, lon, lat;

	  p.x -= this.x0;
	  p.y = this.rh - p.y + this.y0;
	  if (this.ns0 >= 0) {
	    rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
	    con = 1;
	  }
	  else {
	    rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
	    con = -1;
	  }
	  theta = 0;
	  if (rh1 !== 0) {
	    theta = Math.atan2(con * p.x, con * p.y);
	  }
	  con = rh1 * this.ns0 / this.a;
	  if (this.sphere) {
	    lat = Math.asin((this.c - con * con) / (2 * this.ns0));
	  }
	  else {
	    qs = (this.c - con * con) / this.ns0;
	    lat = this.phi1z(this.e3, qs);
	  }

	  lon = adjust_lon(theta / this.ns0 + this.long0);
	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	/* Function to compute phi1, the latitude for the inverse of the
	   Albers Conical Equal-Area projection.
	-------------------------------------------*/
	function phi1z(eccent, qs) {
	  var sinphi, cosphi, con, com, dphi;
	  var phi = asinz(0.5 * qs);
	  if (eccent < EPSLN) {
	    return phi;
	  }

	  var eccnts = eccent * eccent;
	  for (var i = 1; i <= 25; i++) {
	    sinphi = Math.sin(phi);
	    cosphi = Math.cos(phi);
	    con = eccent * sinphi;
	    com = 1 - con * con;
	    dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
	    phi = phi + dphi;
	    if (Math.abs(dphi) <= 1e-7) {
	      return phi;
	    }
	  }
	  return null;
	}

	var names$15 = ["Albers_Conic_Equal_Area", "Albers", "aea"];
	var aea = {
	  init: init$14,
	  forward: forward$13,
	  inverse: inverse$13,
	  names: names$15,
	  phi1z: phi1z
	};

	/*
	  reference:
	    Wolfram Mathworld "Gnomonic Projection"
	    http://mathworld.wolfram.com/GnomonicProjection.html
	    Accessed: 12th November 2009
	  */
	function init$15() {

	  /* Place parameters in static storage for common use
	      -------------------------------------------------*/
	  this.sin_p14 = Math.sin(this.lat0);
	  this.cos_p14 = Math.cos(this.lat0);
	  // Approximation for projecting points to the horizon (infinity)
	  this.infinity_dist = 1000 * this.a;
	  this.rc = 1;
	}

	/* Gnomonic forward equations--mapping lat,long to x,y
	    ---------------------------------------------------*/
	function forward$14(p) {
	  var sinphi, cosphi; /* sin and cos value        */
	  var dlon; /* delta longitude value      */
	  var coslon; /* cos of longitude        */
	  var ksp; /* scale factor          */
	  var g;
	  var x, y;
	  var lon = p.x;
	  var lat = p.y;
	  /* Forward equations
	      -----------------*/
	  dlon = adjust_lon(lon - this.long0);

	  sinphi = Math.sin(lat);
	  cosphi = Math.cos(lat);

	  coslon = Math.cos(dlon);
	  g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
	  ksp = 1;
	  if ((g > 0) || (Math.abs(g) <= EPSLN)) {
	    x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
	    y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
	  }
	  else {

	    // Point is in the opposing hemisphere and is unprojectable
	    // We still need to return a reasonable point, so we project
	    // to infinity, on a bearing
	    // equivalent to the northern hemisphere equivalent
	    // This is a reasonable approximation for short shapes and lines that
	    // straddle the horizon.

	    x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
	    y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);

	  }
	  p.x = x;
	  p.y = y;
	  return p;
	}

	function inverse$14(p) {
	  var rh; /* Rho */
	  var sinc, cosc;
	  var c;
	  var lon, lat;

	  /* Inverse equations
	      -----------------*/
	  p.x = (p.x - this.x0) / this.a;
	  p.y = (p.y - this.y0) / this.a;

	  p.x /= this.k0;
	  p.y /= this.k0;

	  if ((rh = Math.sqrt(p.x * p.x + p.y * p.y))) {
	    c = Math.atan2(rh, this.rc);
	    sinc = Math.sin(c);
	    cosc = Math.cos(c);

	    lat = asinz(cosc * this.sin_p14 + (p.y * sinc * this.cos_p14) / rh);
	    lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
	    lon = adjust_lon(this.long0 + lon);
	  }
	  else {
	    lat = this.phic0;
	    lon = 0;
	  }

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$16 = ["gnom"];
	var gnom = {
	  init: init$15,
	  forward: forward$14,
	  inverse: inverse$14,
	  names: names$16
	};

	var iqsfnz = function(eccent, q) {
	  var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
	  if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
	    if (q < 0) {
	      return (-1 * HALF_PI);
	    }
	    else {
	      return HALF_PI;
	    }
	  }
	  //var phi = 0.5* q/(1-eccent*eccent);
	  var phi = Math.asin(0.5 * q);
	  var dphi;
	  var sin_phi;
	  var cos_phi;
	  var con;
	  for (var i = 0; i < 30; i++) {
	    sin_phi = Math.sin(phi);
	    cos_phi = Math.cos(phi);
	    con = eccent * sin_phi;
	    dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
	    phi += dphi;
	    if (Math.abs(dphi) <= 0.0000000001) {
	      return phi;
	    }
	  }

	  //// console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
	  return NaN;
	};

	/*
	  reference:
	    "Cartographic Projection Procedures for the UNIX Environment-
	    A User's Manual" by Gerald I. Evenden,
	    USGS Open File Report 90-284and Release 4 Interim Reports (2003)
	*/
	function init$16() {
	  //no-op
	  if (!this.sphere) {
	    this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
	  }
	}

	/* Cylindrical Equal Area forward equations--mapping lat,long to x,y
	    ------------------------------------------------------------*/
	function forward$15(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var x, y;
	  /* Forward equations
	      -----------------*/
	  var dlon = adjust_lon(lon - this.long0);
	  if (this.sphere) {
	    x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
	    y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
	  }
	  else {
	    var qs = qsfnz(this.e, Math.sin(lat));
	    x = this.x0 + this.a * this.k0 * dlon;
	    y = this.y0 + this.a * qs * 0.5 / this.k0;
	  }

	  p.x = x;
	  p.y = y;
	  return p;
	}

	/* Cylindrical Equal Area inverse equations--mapping x,y to lat/long
	    ------------------------------------------------------------*/
	function inverse$15(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;
	  var lon, lat;

	  if (this.sphere) {
	    lon = adjust_lon(this.long0 + (p.x / this.a) / Math.cos(this.lat_ts));
	    lat = Math.asin((p.y / this.a) * Math.cos(this.lat_ts));
	  }
	  else {
	    lat = iqsfnz(this.e, 2 * p.y * this.k0 / this.a);
	    lon = adjust_lon(this.long0 + p.x / (this.a * this.k0));
	  }

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$17 = ["cea"];
	var cea = {
	  init: init$16,
	  forward: forward$15,
	  inverse: inverse$15,
	  names: names$17
	};

	function init$17() {

	  this.x0 = this.x0 || 0;
	  this.y0 = this.y0 || 0;
	  this.lat0 = this.lat0 || 0;
	  this.long0 = this.long0 || 0;
	  this.lat_ts = this.lat_ts || 0;
	  this.title = this.title || "Equidistant Cylindrical (Plate Carre)";

	  this.rc = Math.cos(this.lat_ts);
	}

	// forward equations--mapping lat,long to x,y
	// -----------------------------------------------------------------
	function forward$16(p) {

	  var lon = p.x;
	  var lat = p.y;

	  var dlon = adjust_lon(lon - this.long0);
	  var dlat = adjust_lat(lat - this.lat0);
	  p.x = this.x0 + (this.a * dlon * this.rc);
	  p.y = this.y0 + (this.a * dlat);
	  return p;
	}

	// inverse equations--mapping x,y to lat/long
	// -----------------------------------------------------------------
	function inverse$16(p) {

	  var x = p.x;
	  var y = p.y;

	  p.x = adjust_lon(this.long0 + ((x - this.x0) / (this.a * this.rc)));
	  p.y = adjust_lat(this.lat0 + ((y - this.y0) / (this.a)));
	  return p;
	}

	var names$18 = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];
	var eqc = {
	  init: init$17,
	  forward: forward$16,
	  inverse: inverse$16,
	  names: names$18
	};

	var MAX_ITER$2 = 20;

	function init$18() {
	  /* Place parameters in static storage for common use
	      -------------------------------------------------*/
	  this.temp = this.b / this.a;
	  this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
	  this.e = Math.sqrt(this.es);
	  this.e0 = e0fn(this.es);
	  this.e1 = e1fn(this.es);
	  this.e2 = e2fn(this.es);
	  this.e3 = e3fn(this.es);
	  this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
	}

	/* Polyconic forward equations--mapping lat,long to x,y
	    ---------------------------------------------------*/
	function forward$17(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var x, y, el;
	  var dlon = adjust_lon(lon - this.long0);
	  el = dlon * Math.sin(lat);
	  if (this.sphere) {
	    if (Math.abs(lat) <= EPSLN) {
	      x = this.a * dlon;
	      y = -1 * this.a * this.lat0;
	    }
	    else {
	      x = this.a * Math.sin(el) / Math.tan(lat);
	      y = this.a * (adjust_lat(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
	    }
	  }
	  else {
	    if (Math.abs(lat) <= EPSLN) {
	      x = this.a * dlon;
	      y = -1 * this.ml0;
	    }
	    else {
	      var nl = gN(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
	      x = nl * Math.sin(el);
	      y = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
	    }

	  }
	  p.x = x + this.x0;
	  p.y = y + this.y0;
	  return p;
	}

	/* Inverse equations
	  -----------------*/
	function inverse$17(p) {
	  var lon, lat, x, y, i;
	  var al, bl;
	  var phi, dphi;
	  x = p.x - this.x0;
	  y = p.y - this.y0;

	  if (this.sphere) {
	    if (Math.abs(y + this.a * this.lat0) <= EPSLN) {
	      lon = adjust_lon(x / this.a + this.long0);
	      lat = 0;
	    }
	    else {
	      al = this.lat0 + y / this.a;
	      bl = x * x / this.a / this.a + al * al;
	      phi = al;
	      var tanphi;
	      for (i = MAX_ITER$2; i; --i) {
	        tanphi = Math.tan(phi);
	        dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
	        phi += dphi;
	        if (Math.abs(dphi) <= EPSLN) {
	          lat = phi;
	          break;
	        }
	      }
	      lon = adjust_lon(this.long0 + (Math.asin(x * Math.tan(phi) / this.a)) / Math.sin(lat));
	    }
	  }
	  else {
	    if (Math.abs(y + this.ml0) <= EPSLN) {
	      lat = 0;
	      lon = adjust_lon(this.long0 + x / this.a);
	    }
	    else {

	      al = (this.ml0 + y) / this.a;
	      bl = x * x / this.a / this.a + al * al;
	      phi = al;
	      var cl, mln, mlnp, ma;
	      var con;
	      for (i = MAX_ITER$2; i; --i) {
	        con = this.e * Math.sin(phi);
	        cl = Math.sqrt(1 - con * con) * Math.tan(phi);
	        mln = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);
	        mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
	        ma = mln / this.a;
	        dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
	        phi -= dphi;
	        if (Math.abs(dphi) <= EPSLN) {
	          lat = phi;
	          break;
	        }
	      }

	      //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
	      cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
	      lon = adjust_lon(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
	    }
	  }

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$19 = ["Polyconic", "poly"];
	var poly = {
	  init: init$18,
	  forward: forward$17,
	  inverse: inverse$17,
	  names: names$19
	};

	/*
	  reference
	    Department of Land and Survey Technical Circular 1973/32
	      http://www.linz.govt.nz/docs/miscellaneous/nz-map-definition.pdf
	    OSG Technical Report 4.1
	      http://www.linz.govt.nz/docs/miscellaneous/nzmg.pdf
	  */

	/**
	 * iterations: Number of iterations to refine inverse transform.
	 *     0 -> km accuracy
	 *     1 -> m accuracy -- suitable for most mapping applications
	 *     2 -> mm accuracy
	 */


	function init$19() {
	  this.A = [];
	  this.A[1] = 0.6399175073;
	  this.A[2] = -0.1358797613;
	  this.A[3] = 0.063294409;
	  this.A[4] = -0.02526853;
	  this.A[5] = 0.0117879;
	  this.A[6] = -0.0055161;
	  this.A[7] = 0.0026906;
	  this.A[8] = -0.001333;
	  this.A[9] = 0.00067;
	  this.A[10] = -0.00034;

	  this.B_re = [];
	  this.B_im = [];
	  this.B_re[1] = 0.7557853228;
	  this.B_im[1] = 0;
	  this.B_re[2] = 0.249204646;
	  this.B_im[2] = 0.003371507;
	  this.B_re[3] = -0.001541739;
	  this.B_im[3] = 0.041058560;
	  this.B_re[4] = -0.10162907;
	  this.B_im[4] = 0.01727609;
	  this.B_re[5] = -0.26623489;
	  this.B_im[5] = -0.36249218;
	  this.B_re[6] = -0.6870983;
	  this.B_im[6] = -1.1651967;

	  this.C_re = [];
	  this.C_im = [];
	  this.C_re[1] = 1.3231270439;
	  this.C_im[1] = 0;
	  this.C_re[2] = -0.577245789;
	  this.C_im[2] = -0.007809598;
	  this.C_re[3] = 0.508307513;
	  this.C_im[3] = -0.112208952;
	  this.C_re[4] = -0.15094762;
	  this.C_im[4] = 0.18200602;
	  this.C_re[5] = 1.01418179;
	  this.C_im[5] = 1.64497696;
	  this.C_re[6] = 1.9660549;
	  this.C_im[6] = 2.5127645;

	  this.D = [];
	  this.D[1] = 1.5627014243;
	  this.D[2] = 0.5185406398;
	  this.D[3] = -0.03333098;
	  this.D[4] = -0.1052906;
	  this.D[5] = -0.0368594;
	  this.D[6] = 0.007317;
	  this.D[7] = 0.01220;
	  this.D[8] = 0.00394;
	  this.D[9] = -0.0013;
	}

	/**
	    New Zealand Map Grid Forward  - long/lat to x/y
	    long/lat in radians
	  */
	function forward$18(p) {
	  var n;
	  var lon = p.x;
	  var lat = p.y;

	  var delta_lat = lat - this.lat0;
	  var delta_lon = lon - this.long0;

	  // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
	  // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
	  var d_phi = delta_lat / SEC_TO_RAD * 1E-5;
	  var d_lambda = delta_lon;
	  var d_phi_n = 1; // d_phi^0

	  var d_psi = 0;
	  for (n = 1; n <= 10; n++) {
	    d_phi_n = d_phi_n * d_phi;
	    d_psi = d_psi + this.A[n] * d_phi_n;
	  }

	  // 2. Calculate theta
	  var th_re = d_psi;
	  var th_im = d_lambda;

	  // 3. Calculate z
	  var th_n_re = 1;
	  var th_n_im = 0; // theta^0
	  var th_n_re1;
	  var th_n_im1;

	  var z_re = 0;
	  var z_im = 0;
	  for (n = 1; n <= 6; n++) {
	    th_n_re1 = th_n_re * th_re - th_n_im * th_im;
	    th_n_im1 = th_n_im * th_re + th_n_re * th_im;
	    th_n_re = th_n_re1;
	    th_n_im = th_n_im1;
	    z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
	    z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
	  }

	  // 4. Calculate easting and northing
	  p.x = (z_im * this.a) + this.x0;
	  p.y = (z_re * this.a) + this.y0;

	  return p;
	}

	/**
	    New Zealand Map Grid Inverse  -  x/y to long/lat
	  */
	function inverse$18(p) {
	  var n;
	  var x = p.x;
	  var y = p.y;

	  var delta_x = x - this.x0;
	  var delta_y = y - this.y0;

	  // 1. Calculate z
	  var z_re = delta_y / this.a;
	  var z_im = delta_x / this.a;

	  // 2a. Calculate theta - first approximation gives km accuracy
	  var z_n_re = 1;
	  var z_n_im = 0; // z^0
	  var z_n_re1;
	  var z_n_im1;

	  var th_re = 0;
	  var th_im = 0;
	  for (n = 1; n <= 6; n++) {
	    z_n_re1 = z_n_re * z_re - z_n_im * z_im;
	    z_n_im1 = z_n_im * z_re + z_n_re * z_im;
	    z_n_re = z_n_re1;
	    z_n_im = z_n_im1;
	    th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
	    th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
	  }

	  // 2b. Iterate to refine the accuracy of the calculation
	  //        0 iterations gives km accuracy
	  //        1 iteration gives m accuracy -- good enough for most mapping applications
	  //        2 iterations bives mm accuracy
	  for (var i = 0; i < this.iterations; i++) {
	    var th_n_re = th_re;
	    var th_n_im = th_im;
	    var th_n_re1;
	    var th_n_im1;

	    var num_re = z_re;
	    var num_im = z_im;
	    for (n = 2; n <= 6; n++) {
	      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
	      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
	      th_n_re = th_n_re1;
	      th_n_im = th_n_im1;
	      num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
	      num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
	    }

	    th_n_re = 1;
	    th_n_im = 0;
	    var den_re = this.B_re[1];
	    var den_im = this.B_im[1];
	    for (n = 2; n <= 6; n++) {
	      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
	      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
	      th_n_re = th_n_re1;
	      th_n_im = th_n_im1;
	      den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
	      den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
	    }

	    // Complex division
	    var den2 = den_re * den_re + den_im * den_im;
	    th_re = (num_re * den_re + num_im * den_im) / den2;
	    th_im = (num_im * den_re - num_re * den_im) / den2;
	  }

	  // 3. Calculate d_phi              ...                                    // and d_lambda
	  var d_psi = th_re;
	  var d_lambda = th_im;
	  var d_psi_n = 1; // d_psi^0

	  var d_phi = 0;
	  for (n = 1; n <= 9; n++) {
	    d_psi_n = d_psi_n * d_psi;
	    d_phi = d_phi + this.D[n] * d_psi_n;
	  }

	  // 4. Calculate latitude and longitude
	  // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
	  var lat = this.lat0 + (d_phi * SEC_TO_RAD * 1E5);
	  var lon = this.long0 + d_lambda;

	  p.x = lon;
	  p.y = lat;

	  return p;
	}

	var names$20 = ["New_Zealand_Map_Grid", "nzmg"];
	var nzmg = {
	  init: init$19,
	  forward: forward$18,
	  inverse: inverse$18,
	  names: names$20
	};

	/*
	  reference
	    "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
	    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
	  */


	/* Initialize the Miller Cylindrical projection
	  -------------------------------------------*/
	function init$20() {
	  //no-op
	}

	/* Miller Cylindrical forward equations--mapping lat,long to x,y
	    ------------------------------------------------------------*/
	function forward$19(p) {
	  var lon = p.x;
	  var lat = p.y;
	  /* Forward equations
	      -----------------*/
	  var dlon = adjust_lon(lon - this.long0);
	  var x = this.x0 + this.a * dlon;
	  var y = this.y0 + this.a * Math.log(Math.tan((Math.PI / 4) + (lat / 2.5))) * 1.25;

	  p.x = x;
	  p.y = y;
	  return p;
	}

	/* Miller Cylindrical inverse equations--mapping x,y to lat/long
	    ------------------------------------------------------------*/
	function inverse$19(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;

	  var lon = adjust_lon(this.long0 + p.x / this.a);
	  var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$21 = ["Miller_Cylindrical", "mill"];
	var mill = {
	  init: init$20,
	  forward: forward$19,
	  inverse: inverse$19,
	  names: names$21
	};

	var MAX_ITER$3 = 20;
	function init$21() {
	  /* Place parameters in static storage for common use
	    -------------------------------------------------*/


	  if (!this.sphere) {
	    this.en = pj_enfn(this.es);
	  }
	  else {
	    this.n = 1;
	    this.m = 0;
	    this.es = 0;
	    this.C_y = Math.sqrt((this.m + 1) / this.n);
	    this.C_x = this.C_y / (this.m + 1);
	  }

	}

	/* Sinusoidal forward equations--mapping lat,long to x,y
	  -----------------------------------------------------*/
	function forward$20(p) {
	  var x, y;
	  var lon = p.x;
	  var lat = p.y;
	  /* Forward equations
	    -----------------*/
	  lon = adjust_lon(lon - this.long0);

	  if (this.sphere) {
	    if (!this.m) {
	      lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
	    }
	    else {
	      var k = this.n * Math.sin(lat);
	      for (var i = MAX_ITER$3; i; --i) {
	        var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
	        lat -= V;
	        if (Math.abs(V) < EPSLN) {
	          break;
	        }
	      }
	    }
	    x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
	    y = this.a * this.C_y * lat;

	  }
	  else {

	    var s = Math.sin(lat);
	    var c = Math.cos(lat);
	    y = this.a * pj_mlfn(lat, s, c, this.en);
	    x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
	  }

	  p.x = x;
	  p.y = y;
	  return p;
	}

	function inverse$20(p) {
	  var lat, temp, lon, s;

	  p.x -= this.x0;
	  lon = p.x / this.a;
	  p.y -= this.y0;
	  lat = p.y / this.a;

	  if (this.sphere) {
	    lat /= this.C_y;
	    lon = lon / (this.C_x * (this.m + Math.cos(lat)));
	    if (this.m) {
	      lat = asinz((this.m * lat + Math.sin(lat)) / this.n);
	    }
	    else if (this.n !== 1) {
	      lat = asinz(Math.sin(lat) / this.n);
	    }
	    lon = adjust_lon(lon + this.long0);
	    lat = adjust_lat(lat);
	  }
	  else {
	    lat = pj_inv_mlfn(p.y / this.a, this.es, this.en);
	    s = Math.abs(lat);
	    if (s < HALF_PI) {
	      s = Math.sin(lat);
	      temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
	      //temp = this.long0 + p.x / (this.a * Math.cos(lat));
	      lon = adjust_lon(temp);
	    }
	    else if ((s - EPSLN) < HALF_PI) {
	      lon = this.long0;
	    }
	  }
	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$22 = ["Sinusoidal", "sinu"];
	var sinu = {
	  init: init$21,
	  forward: forward$20,
	  inverse: inverse$20,
	  names: names$22
	};

	function init$22() {}
	/* Mollweide forward equations--mapping lat,long to x,y
	    ----------------------------------------------------*/
	function forward$21(p) {

	  /* Forward equations
	      -----------------*/
	  var lon = p.x;
	  var lat = p.y;

	  var delta_lon = adjust_lon(lon - this.long0);
	  var theta = lat;
	  var con = Math.PI * Math.sin(lat);

	  /* Iterate using the Newton-Raphson method to find theta
	      -----------------------------------------------------*/
	  while (true) {
	    var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
	    theta += delta_theta;
	    if (Math.abs(delta_theta) < EPSLN) {
	      break;
	    }
	  }
	  theta /= 2;

	  /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
	       this is done here because of precision problems with "cos(theta)"
	       --------------------------------------------------------------------------*/
	  if (Math.PI / 2 - Math.abs(lat) < EPSLN) {
	    delta_lon = 0;
	  }
	  var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
	  var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;

	  p.x = x;
	  p.y = y;
	  return p;
	}

	function inverse$21(p) {
	  var theta;
	  var arg;

	  /* Inverse equations
	      -----------------*/
	  p.x -= this.x0;
	  p.y -= this.y0;
	  arg = p.y / (1.4142135623731 * this.a);

	  /* Because of division by zero problems, 'arg' can not be 1.  Therefore
	       a number very close to one is used instead.
	       -------------------------------------------------------------------*/
	  if (Math.abs(arg) > 0.999999999999) {
	    arg = 0.999999999999;
	  }
	  theta = Math.asin(arg);
	  var lon = adjust_lon(this.long0 + (p.x / (0.900316316158 * this.a * Math.cos(theta))));
	  if (lon < (-Math.PI)) {
	    lon = -Math.PI;
	  }
	  if (lon > Math.PI) {
	    lon = Math.PI;
	  }
	  arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
	  if (Math.abs(arg) > 1) {
	    arg = 1;
	  }
	  var lat = Math.asin(arg);

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$23 = ["Mollweide", "moll"];
	var moll = {
	  init: init$22,
	  forward: forward$21,
	  inverse: inverse$21,
	  names: names$23
	};

	function init$23() {

	  /* Place parameters in static storage for common use
	      -------------------------------------------------*/
	  // Standard Parallels cannot be equal and on opposite sides of the equator
	  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
	    return;
	  }
	  this.lat2 = this.lat2 || this.lat1;
	  this.temp = this.b / this.a;
	  this.es = 1 - Math.pow(this.temp, 2);
	  this.e = Math.sqrt(this.es);
	  this.e0 = e0fn(this.es);
	  this.e1 = e1fn(this.es);
	  this.e2 = e2fn(this.es);
	  this.e3 = e3fn(this.es);

	  this.sinphi = Math.sin(this.lat1);
	  this.cosphi = Math.cos(this.lat1);

	  this.ms1 = msfnz(this.e, this.sinphi, this.cosphi);
	  this.ml1 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat1);

	  if (Math.abs(this.lat1 - this.lat2) < EPSLN) {
	    this.ns = this.sinphi;
	  }
	  else {
	    this.sinphi = Math.sin(this.lat2);
	    this.cosphi = Math.cos(this.lat2);
	    this.ms2 = msfnz(this.e, this.sinphi, this.cosphi);
	    this.ml2 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat2);
	    this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
	  }
	  this.g = this.ml1 + this.ms1 / this.ns;
	  this.ml0 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
	  this.rh = this.a * (this.g - this.ml0);
	}

	/* Equidistant Conic forward equations--mapping lat,long to x,y
	  -----------------------------------------------------------*/
	function forward$22(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var rh1;

	  /* Forward equations
	      -----------------*/
	  if (this.sphere) {
	    rh1 = this.a * (this.g - lat);
	  }
	  else {
	    var ml = mlfn(this.e0, this.e1, this.e2, this.e3, lat);
	    rh1 = this.a * (this.g - ml);
	  }
	  var theta = this.ns * adjust_lon(lon - this.long0);
	  var x = this.x0 + rh1 * Math.sin(theta);
	  var y = this.y0 + this.rh - rh1 * Math.cos(theta);
	  p.x = x;
	  p.y = y;
	  return p;
	}

	/* Inverse equations
	  -----------------*/
	function inverse$22(p) {
	  p.x -= this.x0;
	  p.y = this.rh - p.y + this.y0;
	  var con, rh1, lat, lon;
	  if (this.ns >= 0) {
	    rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
	    con = 1;
	  }
	  else {
	    rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
	    con = -1;
	  }
	  var theta = 0;
	  if (rh1 !== 0) {
	    theta = Math.atan2(con * p.x, con * p.y);
	  }

	  if (this.sphere) {
	    lon = adjust_lon(this.long0 + theta / this.ns);
	    lat = adjust_lat(this.g - rh1 / this.a);
	    p.x = lon;
	    p.y = lat;
	    return p;
	  }
	  else {
	    var ml = this.g - rh1 / this.a;
	    lat = imlfn(ml, this.e0, this.e1, this.e2, this.e3);
	    lon = adjust_lon(this.long0 + theta / this.ns);
	    p.x = lon;
	    p.y = lat;
	    return p;
	  }

	}

	var names$24 = ["Equidistant_Conic", "eqdc"];
	var eqdc = {
	  init: init$23,
	  forward: forward$22,
	  inverse: inverse$22,
	  names: names$24
	};

	/* Initialize the Van Der Grinten projection
	  ----------------------------------------*/
	function init$24() {
	  //this.R = 6370997; //Radius of earth
	  this.R = this.a;
	}

	function forward$23(p) {

	  var lon = p.x;
	  var lat = p.y;

	  /* Forward equations
	    -----------------*/
	  var dlon = adjust_lon(lon - this.long0);
	  var x, y;

	  if (Math.abs(lat) <= EPSLN) {
	    x = this.x0 + this.R * dlon;
	    y = this.y0;
	  }
	  var theta = asinz(2 * Math.abs(lat / Math.PI));
	  if ((Math.abs(dlon) <= EPSLN) || (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN)) {
	    x = this.x0;
	    if (lat >= 0) {
	      y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
	    }
	    else {
	      y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
	    }
	    //  return(OK);
	  }
	  var al = 0.5 * Math.abs((Math.PI / dlon) - (dlon / Math.PI));
	  var asq = al * al;
	  var sinth = Math.sin(theta);
	  var costh = Math.cos(theta);

	  var g = costh / (sinth + costh - 1);
	  var gsq = g * g;
	  var m = g * (2 / sinth - 1);
	  var msq = m * m;
	  var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
	  if (dlon < 0) {
	    con = -con;
	  }
	  x = this.x0 + con;
	  //con = Math.abs(con / (Math.PI * this.R));
	  var q = asq + g;
	  con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
	  if (lat >= 0) {
	    //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
	    y = this.y0 + con;
	  }
	  else {
	    //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
	    y = this.y0 - con;
	  }
	  p.x = x;
	  p.y = y;
	  return p;
	}

	/* Van Der Grinten inverse equations--mapping x,y to lat/long
	  ---------------------------------------------------------*/
	function inverse$23(p) {
	  var lon, lat;
	  var xx, yy, xys, c1, c2, c3;
	  var a1;
	  var m1;
	  var con;
	  var th1;
	  var d;

	  /* inverse equations
	    -----------------*/
	  p.x -= this.x0;
	  p.y -= this.y0;
	  con = Math.PI * this.R;
	  xx = p.x / con;
	  yy = p.y / con;
	  xys = xx * xx + yy * yy;
	  c1 = -Math.abs(yy) * (1 + xys);
	  c2 = c1 - 2 * yy * yy + xx * xx;
	  c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
	  d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
	  a1 = (c1 - c2 * c2 / 3 / c3) / c3;
	  m1 = 2 * Math.sqrt(-a1 / 3);
	  con = ((3 * d) / a1) / m1;
	  if (Math.abs(con) > 1) {
	    if (con >= 0) {
	      con = 1;
	    }
	    else {
	      con = -1;
	    }
	  }
	  th1 = Math.acos(con) / 3;
	  if (p.y >= 0) {
	    lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
	  }
	  else {
	    lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
	  }

	  if (Math.abs(xx) < EPSLN) {
	    lon = this.long0;
	  }
	  else {
	    lon = adjust_lon(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
	  }

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$25 = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];
	var vandg = {
	  init: init$24,
	  forward: forward$23,
	  inverse: inverse$23,
	  names: names$25
	};

	function init$25() {
	  this.sin_p12 = Math.sin(this.lat0);
	  this.cos_p12 = Math.cos(this.lat0);
	}

	function forward$24(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var sinphi = Math.sin(p.y);
	  var cosphi = Math.cos(p.y);
	  var dlon = adjust_lon(lon - this.long0);
	  var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
	  if (this.sphere) {
	    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
	      //North Pole case
	      p.x = this.x0 + this.a * (HALF_PI - lat) * Math.sin(dlon);
	      p.y = this.y0 - this.a * (HALF_PI - lat) * Math.cos(dlon);
	      return p;
	    }
	    else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
	      //South Pole case
	      p.x = this.x0 + this.a * (HALF_PI + lat) * Math.sin(dlon);
	      p.y = this.y0 + this.a * (HALF_PI + lat) * Math.cos(dlon);
	      return p;
	    }
	    else {
	      //default case
	      cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
	      c = Math.acos(cos_c);
	      kp = c / Math.sin(c);
	      p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
	      p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
	      return p;
	    }
	  }
	  else {
	    e0 = e0fn(this.es);
	    e1 = e1fn(this.es);
	    e2 = e2fn(this.es);
	    e3 = e3fn(this.es);
	    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
	      //North Pole case
	      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	      Ml = this.a * mlfn(e0, e1, e2, e3, lat);
	      p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
	      p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
	      return p;
	    }
	    else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
	      //South Pole case
	      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	      Ml = this.a * mlfn(e0, e1, e2, e3, lat);
	      p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
	      p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
	      return p;
	    }
	    else {
	      //Default case
	      tanphi = sinphi / cosphi;
	      Nl1 = gN(this.a, this.e, this.sin_p12);
	      Nl = gN(this.a, this.e, sinphi);
	      psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
	      Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
	      if (Az === 0) {
	        s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
	      }
	      else if (Math.abs(Math.abs(Az) - Math.PI) <= EPSLN) {
	        s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
	      }
	      else {
	        s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
	      }
	      G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
	      H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
	      GH = G * H;
	      Hs = H * H;
	      s2 = s * s;
	      s3 = s2 * s;
	      s4 = s3 * s;
	      s5 = s4 * s;
	      c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
	      p.x = this.x0 + c * Math.sin(Az);
	      p.y = this.y0 + c * Math.cos(Az);
	      return p;
	    }
	  }


	}

	function inverse$24(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;
	  var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F;
	  if (this.sphere) {
	    rh = Math.sqrt(p.x * p.x + p.y * p.y);
	    if (rh > (2 * HALF_PI * this.a)) {
	      return;
	    }
	    z = rh / this.a;

	    sinz = Math.sin(z);
	    cosz = Math.cos(z);

	    lon = this.long0;
	    if (Math.abs(rh) <= EPSLN) {
	      lat = this.lat0;
	    }
	    else {
	      lat = asinz(cosz * this.sin_p12 + (p.y * sinz * this.cos_p12) / rh);
	      con = Math.abs(this.lat0) - HALF_PI;
	      if (Math.abs(con) <= EPSLN) {
	        if (this.lat0 >= 0) {
	          lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
	        }
	        else {
	          lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
	        }
	      }
	      else {
	        /*con = cosz - this.sin_p12 * Math.sin(lat);
	        if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
	          //no-op, just keep the lon value as is
	        } else {
	          var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
	          lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
	        }*/
	        lon = adjust_lon(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
	      }
	    }

	    p.x = lon;
	    p.y = lat;
	    return p;
	  }
	  else {
	    e0 = e0fn(this.es);
	    e1 = e1fn(this.es);
	    e2 = e2fn(this.es);
	    e3 = e3fn(this.es);
	    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
	      //North pole case
	      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	      rh = Math.sqrt(p.x * p.x + p.y * p.y);
	      M = Mlp - rh;
	      lat = imlfn(M / this.a, e0, e1, e2, e3);
	      lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	    else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
	      //South pole case
	      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	      rh = Math.sqrt(p.x * p.x + p.y * p.y);
	      M = rh - Mlp;

	      lat = imlfn(M / this.a, e0, e1, e2, e3);
	      lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	    else {
	      //default case
	      rh = Math.sqrt(p.x * p.x + p.y * p.y);
	      Az = Math.atan2(p.x, p.y);
	      N1 = gN(this.a, this.e, this.sin_p12);
	      cosAz = Math.cos(Az);
	      tmp = this.e * this.cos_p12 * cosAz;
	      A = -tmp * tmp / (1 - this.es);
	      B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
	      D = rh / N1;
	      Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
	      F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
	      psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
	      lon = adjust_lon(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
	      lat = Math.atan((1 - this.es * F * this.sin_p12 / Math.sin(psi)) * Math.tan(psi) / (1 - this.es));
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	  }

	}

	var names$26 = ["Azimuthal_Equidistant", "aeqd"];
	var aeqd = {
	  init: init$25,
	  forward: forward$24,
	  inverse: inverse$24,
	  names: names$26
	};

	function init$26() {
	  //double temp;      /* temporary variable    */

	  /* Place parameters in static storage for common use
	      -------------------------------------------------*/
	  this.sin_p14 = Math.sin(this.lat0);
	  this.cos_p14 = Math.cos(this.lat0);
	}

	/* Orthographic forward equations--mapping lat,long to x,y
	    ---------------------------------------------------*/
	function forward$25(p) {
	  var sinphi, cosphi; /* sin and cos value        */
	  var dlon; /* delta longitude value      */
	  var coslon; /* cos of longitude        */
	  var ksp; /* scale factor          */
	  var g, x, y;
	  var lon = p.x;
	  var lat = p.y;
	  /* Forward equations
	      -----------------*/
	  dlon = adjust_lon(lon - this.long0);

	  sinphi = Math.sin(lat);
	  cosphi = Math.cos(lat);

	  coslon = Math.cos(dlon);
	  g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
	  ksp = 1;
	  if ((g > 0) || (Math.abs(g) <= EPSLN)) {
	    x = this.a * ksp * cosphi * Math.sin(dlon);
	    y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
	  }
	  p.x = x;
	  p.y = y;
	  return p;
	}

	function inverse$25(p) {
	  var rh; /* height above ellipsoid      */
	  var z; /* angle          */
	  var sinz, cosz; /* sin of z and cos of z      */
	  var con;
	  var lon, lat;
	  /* Inverse equations
	      -----------------*/
	  p.x -= this.x0;
	  p.y -= this.y0;
	  rh = Math.sqrt(p.x * p.x + p.y * p.y);
	  z = asinz(rh / this.a);

	  sinz = Math.sin(z);
	  cosz = Math.cos(z);

	  lon = this.long0;
	  if (Math.abs(rh) <= EPSLN) {
	    lat = this.lat0;
	    p.x = lon;
	    p.y = lat;
	    return p;
	  }
	  lat = asinz(cosz * this.sin_p14 + (p.y * sinz * this.cos_p14) / rh);
	  con = Math.abs(this.lat0) - HALF_PI;
	  if (Math.abs(con) <= EPSLN) {
	    if (this.lat0 >= 0) {
	      lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
	    }
	    else {
	      lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
	    }
	    p.x = lon;
	    p.y = lat;
	    return p;
	  }
	  lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz), rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$27 = ["ortho"];
	var ortho = {
	  init: init$26,
	  forward: forward$25,
	  inverse: inverse$25,
	  names: names$27
	};

	// QSC projection rewritten from the original PROJ4
	// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

	/* constants */
	var FACE_ENUM = {
	    FRONT: 1,
	    RIGHT: 2,
	    BACK: 3,
	    LEFT: 4,
	    TOP: 5,
	    BOTTOM: 6
	};

	var AREA_ENUM = {
	    AREA_0: 1,
	    AREA_1: 2,
	    AREA_2: 3,
	    AREA_3: 4
	};

	function init$27() {

	  this.x0 = this.x0 || 0;
	  this.y0 = this.y0 || 0;
	  this.lat0 = this.lat0 || 0;
	  this.long0 = this.long0 || 0;
	  this.lat_ts = this.lat_ts || 0;
	  this.title = this.title || "Quadrilateralized Spherical Cube";

	  /* Determine the cube face from the center of projection. */
	  if (this.lat0 >= HALF_PI - FORTPI / 2.0) {
	    this.face = FACE_ENUM.TOP;
	  } else if (this.lat0 <= -(HALF_PI - FORTPI / 2.0)) {
	    this.face = FACE_ENUM.BOTTOM;
	  } else if (Math.abs(this.long0) <= FORTPI) {
	    this.face = FACE_ENUM.FRONT;
	  } else if (Math.abs(this.long0) <= HALF_PI + FORTPI) {
	    this.face = this.long0 > 0.0 ? FACE_ENUM.RIGHT : FACE_ENUM.LEFT;
	  } else {
	    this.face = FACE_ENUM.BACK;
	  }

	  /* Fill in useful values for the ellipsoid <-> sphere shift
	   * described in [LK12]. */
	  if (this.es !== 0) {
	    this.one_minus_f = 1 - (this.a - this.b) / this.a;
	    this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
	  }
	}

	// QSC forward equations--mapping lat,long to x,y
	// -----------------------------------------------------------------
	function forward$26(p) {
	  var xy = {x: 0, y: 0};
	  var lat, lon;
	  var theta, phi;
	  var t, mu;
	  /* nu; */
	  var area = {value: 0};

	  // move lon according to projection's lon
	  p.x -= this.long0;

	  /* Convert the geodetic latitude to a geocentric latitude.
	   * This corresponds to the shift from the ellipsoid to the sphere
	   * described in [LK12]. */
	  if (this.es !== 0) {//if (P->es != 0) {
	    lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
	  } else {
	    lat = p.y;
	  }

	  /* Convert the input lat, lon into theta, phi as used by QSC.
	   * This depends on the cube face and the area on it.
	   * For the top and bottom face, we can compute theta and phi
	   * directly from phi, lam. For the other faces, we must use
	   * unit sphere cartesian coordinates as an intermediate step. */
	  lon = p.x; //lon = lp.lam;
	  if (this.face === FACE_ENUM.TOP) {
	    phi = HALF_PI - lat;
	    if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
	      area.value = AREA_ENUM.AREA_0;
	      theta = lon - HALF_PI;
	    } else if (lon > HALF_PI + FORTPI || lon <= -(HALF_PI + FORTPI)) {
	      area.value = AREA_ENUM.AREA_1;
	      theta = (lon > 0.0 ? lon - SPI : lon + SPI);
	    } else if (lon > -(HALF_PI + FORTPI) && lon <= -FORTPI) {
	      area.value = AREA_ENUM.AREA_2;
	      theta = lon + HALF_PI;
	    } else {
	      area.value = AREA_ENUM.AREA_3;
	      theta = lon;
	    }
	  } else if (this.face === FACE_ENUM.BOTTOM) {
	    phi = HALF_PI + lat;
	    if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
	      area.value = AREA_ENUM.AREA_0;
	      theta = -lon + HALF_PI;
	    } else if (lon < FORTPI && lon >= -FORTPI) {
	      area.value = AREA_ENUM.AREA_1;
	      theta = -lon;
	    } else if (lon < -FORTPI && lon >= -(HALF_PI + FORTPI)) {
	      area.value = AREA_ENUM.AREA_2;
	      theta = -lon - HALF_PI;
	    } else {
	      area.value = AREA_ENUM.AREA_3;
	      theta = (lon > 0.0 ? -lon + SPI : -lon - SPI);
	    }
	  } else {
	    var q, r, s;
	    var sinlat, coslat;
	    var sinlon, coslon;

	    if (this.face === FACE_ENUM.RIGHT) {
	      lon = qsc_shift_lon_origin(lon, +HALF_PI);
	    } else if (this.face === FACE_ENUM.BACK) {
	      lon = qsc_shift_lon_origin(lon, +SPI);
	    } else if (this.face === FACE_ENUM.LEFT) {
	      lon = qsc_shift_lon_origin(lon, -HALF_PI);
	    }
	    sinlat = Math.sin(lat);
	    coslat = Math.cos(lat);
	    sinlon = Math.sin(lon);
	    coslon = Math.cos(lon);
	    q = coslat * coslon;
	    r = coslat * sinlon;
	    s = sinlat;

	    if (this.face === FACE_ENUM.FRONT) {
	      phi = Math.acos(q);
	      theta = qsc_fwd_equat_face_theta(phi, s, r, area);
	    } else if (this.face === FACE_ENUM.RIGHT) {
	      phi = Math.acos(r);
	      theta = qsc_fwd_equat_face_theta(phi, s, -q, area);
	    } else if (this.face === FACE_ENUM.BACK) {
	      phi = Math.acos(-q);
	      theta = qsc_fwd_equat_face_theta(phi, s, -r, area);
	    } else if (this.face === FACE_ENUM.LEFT) {
	      phi = Math.acos(-r);
	      theta = qsc_fwd_equat_face_theta(phi, s, q, area);
	    } else {
	      /* Impossible */
	      phi = theta = 0;
	      area.value = AREA_ENUM.AREA_0;
	    }
	  }

	  /* Compute mu and nu for the area of definition.
	   * For mu, see Eq. (3-21) in [OL76], but note the typos:
	   * compare with Eq. (3-14). For nu, see Eq. (3-38). */
	  mu = Math.atan((12 / SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos(FORTPI)) - HALF_PI));
	  t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));

	  /* Apply the result to the real area. */
	  if (area.value === AREA_ENUM.AREA_1) {
	    mu += HALF_PI;
	  } else if (area.value === AREA_ENUM.AREA_2) {
	    mu += SPI;
	  } else if (area.value === AREA_ENUM.AREA_3) {
	    mu += 1.5 * SPI;
	  }

	  /* Now compute x, y from mu and nu */
	  xy.x = t * Math.cos(mu);
	  xy.y = t * Math.sin(mu);
	  xy.x = xy.x * this.a + this.x0;
	  xy.y = xy.y * this.a + this.y0;

	  p.x = xy.x;
	  p.y = xy.y;
	  return p;
	}

	// QSC inverse equations--mapping x,y to lat/long
	// -----------------------------------------------------------------
	function inverse$26(p) {
	  var lp = {lam: 0, phi: 0};
	  var mu, nu, cosmu, tannu;
	  var tantheta, theta, cosphi, phi;
	  var t;
	  var area = {value: 0};

	  /* de-offset */
	  p.x = (p.x - this.x0) / this.a;
	  p.y = (p.y - this.y0) / this.a;

	  /* Convert the input x, y to the mu and nu angles as used by QSC.
	   * This depends on the area of the cube face. */
	  nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
	  mu = Math.atan2(p.y, p.x);
	  if (p.x >= 0.0 && p.x >= Math.abs(p.y)) {
	    area.value = AREA_ENUM.AREA_0;
	  } else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
	    area.value = AREA_ENUM.AREA_1;
	    mu -= HALF_PI;
	  } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
	    area.value = AREA_ENUM.AREA_2;
	    mu = (mu < 0.0 ? mu + SPI : mu - SPI);
	  } else {
	    area.value = AREA_ENUM.AREA_3;
	    mu += HALF_PI;
	  }

	  /* Compute phi and theta for the area of definition.
	   * The inverse projection is not described in the original paper, but some
	   * good hints can be found here (as of 2011-12-14):
	   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
	   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */
	  t = (SPI / 12) * Math.tan(mu);
	  tantheta = Math.sin(t) / (Math.cos(t) - (1 / Math.sqrt(2)));
	  theta = Math.atan(tantheta);
	  cosmu = Math.cos(mu);
	  tannu = Math.tan(nu);
	  cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
	  if (cosphi < -1) {
	    cosphi = -1;
	  } else if (cosphi > +1) {
	    cosphi = +1;
	  }

	  /* Apply the result to the real area on the cube face.
	   * For the top and bottom face, we can compute phi and lam directly.
	   * For the other faces, we must use unit sphere cartesian coordinates
	   * as an intermediate step. */
	  if (this.face === FACE_ENUM.TOP) {
	    phi = Math.acos(cosphi);
	    lp.phi = HALF_PI - phi;
	    if (area.value === AREA_ENUM.AREA_0) {
	      lp.lam = theta + HALF_PI;
	    } else if (area.value === AREA_ENUM.AREA_1) {
	      lp.lam = (theta < 0.0 ? theta + SPI : theta - SPI);
	    } else if (area.value === AREA_ENUM.AREA_2) {
	      lp.lam = theta - HALF_PI;
	    } else /* area.value == AREA_ENUM.AREA_3 */ {
	      lp.lam = theta;
	    }
	  } else if (this.face === FACE_ENUM.BOTTOM) {
	    phi = Math.acos(cosphi);
	    lp.phi = phi - HALF_PI;
	    if (area.value === AREA_ENUM.AREA_0) {
	      lp.lam = -theta + HALF_PI;
	    } else if (area.value === AREA_ENUM.AREA_1) {
	      lp.lam = -theta;
	    } else if (area.value === AREA_ENUM.AREA_2) {
	      lp.lam = -theta - HALF_PI;
	    } else /* area.value == AREA_ENUM.AREA_3 */ {
	      lp.lam = (theta < 0.0 ? -theta - SPI : -theta + SPI);
	    }
	  } else {
	    /* Compute phi and lam via cartesian unit sphere coordinates. */
	    var q, r, s;
	    q = cosphi;
	    t = q * q;
	    if (t >= 1) {
	      s = 0;
	    } else {
	      s = Math.sqrt(1 - t) * Math.sin(theta);
	    }
	    t += s * s;
	    if (t >= 1) {
	      r = 0;
	    } else {
	      r = Math.sqrt(1 - t);
	    }
	    /* Rotate q,r,s into the correct area. */
	    if (area.value === AREA_ENUM.AREA_1) {
	      t = r;
	      r = -s;
	      s = t;
	    } else if (area.value === AREA_ENUM.AREA_2) {
	      r = -r;
	      s = -s;
	    } else if (area.value === AREA_ENUM.AREA_3) {
	      t = r;
	      r = s;
	      s = -t;
	    }
	    /* Rotate q,r,s into the correct cube face. */
	    if (this.face === FACE_ENUM.RIGHT) {
	      t = q;
	      q = -r;
	      r = t;
	    } else if (this.face === FACE_ENUM.BACK) {
	      q = -q;
	      r = -r;
	    } else if (this.face === FACE_ENUM.LEFT) {
	      t = q;
	      q = r;
	      r = -t;
	    }
	    /* Now compute phi and lam from the unit sphere coordinates. */
	    lp.phi = Math.acos(-s) - HALF_PI;
	    lp.lam = Math.atan2(r, q);
	    if (this.face === FACE_ENUM.RIGHT) {
	      lp.lam = qsc_shift_lon_origin(lp.lam, -HALF_PI);
	    } else if (this.face === FACE_ENUM.BACK) {
	      lp.lam = qsc_shift_lon_origin(lp.lam, -SPI);
	    } else if (this.face === FACE_ENUM.LEFT) {
	      lp.lam = qsc_shift_lon_origin(lp.lam, +HALF_PI);
	    }
	  }

	  /* Apply the shift from the sphere to the ellipsoid as described
	   * in [LK12]. */
	  if (this.es !== 0) {
	    var invert_sign;
	    var tanphi, xa;
	    invert_sign = (lp.phi < 0 ? 1 : 0);
	    tanphi = Math.tan(lp.phi);
	    xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
	    lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
	    if (invert_sign) {
	      lp.phi = -lp.phi;
	    }
	  }

	  lp.lam += this.long0;
	  p.x = lp.lam;
	  p.y = lp.phi;
	  return p;
	}

	/* Helper function for forward projection: compute the theta angle
	 * and determine the area number. */
	function qsc_fwd_equat_face_theta(phi, y, x, area) {
	  var theta;
	  if (phi < EPSLN) {
	    area.value = AREA_ENUM.AREA_0;
	    theta = 0.0;
	  } else {
	    theta = Math.atan2(y, x);
	    if (Math.abs(theta) <= FORTPI) {
	      area.value = AREA_ENUM.AREA_0;
	    } else if (theta > FORTPI && theta <= HALF_PI + FORTPI) {
	      area.value = AREA_ENUM.AREA_1;
	      theta -= HALF_PI;
	    } else if (theta > HALF_PI + FORTPI || theta <= -(HALF_PI + FORTPI)) {
	      area.value = AREA_ENUM.AREA_2;
	      theta = (theta >= 0.0 ? theta - SPI : theta + SPI);
	    } else {
	      area.value = AREA_ENUM.AREA_3;
	      theta += HALF_PI;
	    }
	  }
	  return theta;
	}

	/* Helper function: shift the longitude. */
	function qsc_shift_lon_origin(lon, offset) {
	  var slon = lon + offset;
	  if (slon < -SPI) {
	    slon += TWO_PI;
	  } else if (slon > +SPI) {
	    slon -= TWO_PI;
	  }
	  return slon;
	}

	var names$28 = ["Quadrilateralized Spherical Cube", "Quadrilateralized_Spherical_Cube", "qsc"];
	var qsc = {
	  init: init$27,
	  forward: forward$26,
	  inverse: inverse$26,
	  names: names$28
	};

	var includedProjections = function(proj4){
	  proj4.Proj.projections.add(tmerc);
	  proj4.Proj.projections.add(etmerc);
	  proj4.Proj.projections.add(utm);
	  proj4.Proj.projections.add(sterea);
	  proj4.Proj.projections.add(stere);
	  proj4.Proj.projections.add(somerc);
	  proj4.Proj.projections.add(omerc);
	  proj4.Proj.projections.add(lcc);
	  proj4.Proj.projections.add(krovak);
	  proj4.Proj.projections.add(cass);
	  proj4.Proj.projections.add(laea);
	  proj4.Proj.projections.add(aea);
	  proj4.Proj.projections.add(gnom);
	  proj4.Proj.projections.add(cea);
	  proj4.Proj.projections.add(eqc);
	  proj4.Proj.projections.add(poly);
	  proj4.Proj.projections.add(nzmg);
	  proj4.Proj.projections.add(mill);
	  proj4.Proj.projections.add(sinu);
	  proj4.Proj.projections.add(moll);
	  proj4.Proj.projections.add(eqdc);
	  proj4.Proj.projections.add(vandg);
	  proj4.Proj.projections.add(aeqd);
	  proj4.Proj.projections.add(ortho);
	  proj4.Proj.projections.add(qsc);
	};

	proj4$1.defaultDatum = 'WGS84'; //default datum
	proj4$1.Proj = Projection$1;
	proj4$1.WGS84 = new proj4$1.Proj('WGS84');
	proj4$1.Point = Point;
	proj4$1.toPoint = toPoint;
	proj4$1.defs = defs;
	proj4$1.transform = transform;
	proj4$1.mgrs = mgrs;
	proj4$1.version = version;
	includedProjections(proj4$1);

	return proj4$1;

})));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _proj = __webpack_require__(19);

var _proj2 = _interopRequireDefault(_proj);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Register definition for IGNF, and EPSG CRS.
 * @example
 * Gp.Register.IGNF.AMST63
 *   // return : "+title=Amsterdam 1963 +proj=geocent +towgs84=109.753,-528.133,-362.244,0,0,0,0 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs"
 * Gp.Register.get("IGNF:AMST63")
 *   // same as Gp.Register.IGNF.AMST63
 */
var Register = {

    /**
     * instance already loaded into proj4
     *
     * @private
     */
    isLoaded: false,

    /**
     * get the definition for a code
     *
     * @param {String} name - ie. EPSG:2154 (Lambert)
     * @returns {Object} definition
     */
    get: function get(name) {
        if (name === "" || name === null || typeof name === "undefined") {
            return;
        }

        var s = name.split(":");
        if (s.length !== 2) {
            return;
        }

        var register = s[0];
        var code = s[1];

        if (!this.hasOwnProperty(register)) {
            return;
        }

        if (!this[register].hasOwnProperty(code)) {
            return;
        }

        return this[register][code];
    },

    /**
     * load all defs to proj4
     */
    load: function load() {
        if (!this.isLoaded) {
            var registers = ["IGNF", "EPSG", "CRS"];
            for (var i = 0; i < registers.length; i++) {
                var register = registers[i];
                var codes = this[register];
                for (var code in codes) {
                    if (codes.hasOwnProperty(code)) {
                        var name = register + ":" + code;
                        _proj2.default.defs(name, this.get(name));
                    }
                }
            }
            this.isLoaded = true;
        }
    },

    // definitions
    EPSG: {
        4149: "+title=CH1903 +proj=longlat +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +no_defs ",
        4150: "+title=CH1903plus +proj=longlat +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +no_defs ",
        4151: "+title=CHTRF95 +proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
        4171: "+title=RGF93 +proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
        4230: "+title=ED50 +proj=longlat +ellps=intl +no_defs ",
        4235: "+title=Guyane Francaise +proj=longlat +ellps=intl +no_defs ",
        4258: "+title=ETRS89 +proj=longlat +ellps=GRS80 +no_defs ",
        4275: "+title=NTF +proj=longlat +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +no_defs ",
        4322: "+title=WGS 72 +proj=longlat +ellps=WGS72 +no_defs ",
        4326: "+title=WGS 84 +proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs ",
        4467: "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        4470: "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
        4471: "+proj=utm +zone=38 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        4474: "+proj=utm +zone=38 +south +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +units=m +no_defs ",
        4558: "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
        4559: "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        4621: "+title=Fort Marigot +proj=longlat +ellps=intl +towgs84=137,248,-430,0,0,0,0 +no_defs ",
        4622: "+title=Guadeloupe 1948 +proj=longlat +ellps=intl +no_defs ",
        4623: "+title=CSG67 +proj=longlat +ellps=intl +towgs84=-186,230,110,0,0,0,0 +no_defs ",
        4624: "+title=RGFG95 +proj=longlat +ellps=GRS80 +towgs84=2,2,-2,0,0,0,0 +no_defs ",
        4625: "+title=Martinique 1938 +proj=longlat +ellps=intl +no_defs ",
        4626: "+title=Reunion 1947 +proj=longlat +ellps=intl +no_defs ",
        4627: "+title=RGR92 +proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
        4628: "+title=Tahiti 52 +proj=longlat +ellps=intl +towgs84=162,117,154,0,0,0,0 +no_defs ",
        4629: "+title=Tahaa 54 +proj=longlat +ellps=intl +no_defs ",
        4630: "+title=IGN72 Nuku Hiva +proj=longlat +ellps=intl +no_defs ",
        4632: "+title=Combani 1950 +proj=longlat +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +no_defs ",
        4633: "+title=IGN56 Lifou +proj=longlat +ellps=intl +no_defs ",
        4634: "+title=IGN72 Grand Terre +proj=longlat +ellps=intl +no_defs ",
        4637: "+title=Perroud 1950 +proj=longlat +ellps=intl +towgs84=325,154,172,0,0,0,0 +no_defs ",
        4638: "+title=Saint Pierre et Miquelon 1950 +proj=longlat +ellps=clrk66 +towgs84=30,430,368,0,0,0,0 +no_defs ",
        4640: "+title=RRAF 1991 +proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs ",
        4641: "+title=IGN53 Mare +proj=longlat +ellps=intl +no_defs ",
        4645: "+title=RGNC 1991 +proj=longlat +ellps=intl +towgs84=0,0,0,0,0,0,0 +no_defs ",
        4687: "+proj=longlat +ellps=GRS80 +no_defs ",
        4662: "+title=IGN72 Grande Terre +proj=longlat +ellps=intl +no_defs ",
        4689: "+title=IGN63 Hiva Oa +proj=longlat +ellps=intl +no_defs ",
        4690: "+title=Tahiti 79 +proj=longlat +ellps=intl +no_defs ",
        4691: "+title=Moorea 87 +proj=longlat +ellps=intl +towgs84=215.525,149.593,176.229,-3.2624,-1.692,-1.1571,10.4773 +no_defs ",
        4692: "+title=Maupiti 83 +proj=longlat +ellps=intl +towgs84=217.037,86.959,23.956,0,0,0,0 +no_defs ",
        4698: "+title=IGN 1962 Kerguelen +proj=longlat +ellps=intl +towgs84=145,-187,103,0,0,0,0 +no_defs ",
        4749: "+title=RGNC91-93 +proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs ",
        4750: "+title=ST87 Ouvea +proj=longlat +ellps=WGS84 +towgs84=-56.263,16.136,-22.856,0,0,0,0 +no_defs ",
        4807: "+title=NTF (Paris) +proj=longlat +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +no_defs ",
        2056: "+title=CH1903+ / LV95 +proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs ",
        2154: "+title=RGF93 / Lambert-93 +proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        2213: "+title=ETRS89 / TM 30 NE +proj=tmerc +lat_0=0 +lon_0=30 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs ",
        2969: "+title=Fort Marigot / UTM zone 20N +proj=utm +zone=20 +ellps=intl +towgs84=137,248,-430,0,0,0,0 +units=m +no_defs ",
        2970: "+title=Guadeloupe 1948 / UTM zone 20N +proj=utm +zone=20 +ellps=intl +units=m +no_defs ",
        2971: "+title=CSG67 / UTM zone 22N +proj=utm +zone=22 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs ",
        2972: "+title=RGFG95 / UTM zone 22N +proj=utm +zone=22 +ellps=GRS80 +towgs84=2,2,-2,0,0,0,0 +units=m +no_defs ",
        2973: "+title=Martinique 1938 / UTM zone 20N +proj=utm +zone=20 +ellps=intl +units=m +no_defs ",
        2975: "+title=RGR92 / UTM zone 40S +proj=utm +zone=40 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        2976: "+title=Tahiti 52 / UTM zone 6S +proj=utm +zone=6 +south +ellps=intl +towgs84=162,117,154,0,0,0,0 +units=m +no_defs ",
        2977: "+title=Tahaa 54 / UTM zone 5S +proj=utm +zone=5 +south +ellps=intl +units=m +no_defs ",
        2978: "+title=IGN72 Nuku Hiva / UTM zone 7S +proj=utm +zone=7 +south +ellps=intl +units=m +no_defs ",
        2980: "+title=Combani 1950 / UTM zone 38S +proj=utm +zone=38 +south +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +units=m +no_defs ",
        2981: "+title=IGN56 Lifou / UTM zone 58S +proj=utm +zone=58 +south +ellps=intl +units=m +no_defs ",
        2982: "+title=IGN72 Grand Terre / UTM zone 58S (deprecated) +proj=utm +zone=58 +south +ellps=intl +units=m +no_defs ",
        2984: "+title=RGNC 1991 / Lambert New Caledonia (deprecated) +proj=lcc +lat_1=-20.66666666666667 +lat_2=-22.33333333333333 +lat_0=-21.5 +lon_0=166 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        2986: "+title=Terre Adelie 1950 +proj=stere +towgs84=324.9120,153.2820,172.0260 +a=6378388.0000 +rf=297.0000000000000 +lat_0=-90.000000000 +lon_0=140.000000000 +lat_ts=-67.000000000 +k=0.96027295 +x_0=300000.000 +y_0=-2299363.482 +units=m +no_defs",
        2987: "+title=Saint Pierre et Miquelon 1950 / UTM zone 21N +proj=utm +zone=21 +ellps=clrk66 +towgs84=30,430,368,0,0,0,0 +units=m +no_defs ",
        2989: "+title=RRAF 1991 / UTM zone 20N +proj=utm +zone=20 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        2990: "+title=Reunion 1947 / TM Reunion (deprecated) +proj=tmerc +lat_0=-21.11666666666667 +lon_0=55.53333333333333 +k=1 +x_0=50000 +y_0=160000 +ellps=intl +units=m +no_defs ",
        2995: "+title=IGN53 Mare / UTM zone 58S +proj=utm +zone=58 +south +ellps=intl +units=m +no_defs ",
        3038: "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3039: "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3040: "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3041: "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        // 3042 : "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        // 3043 : "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        // 3044 : "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3045: "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3046: "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3047: "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3048: "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3049: "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3050: "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3051: "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3034: "+title=ETRS89 / ETRS-LCC +proj=lcc +lat_1=35 +lat_2=65 +lat_0=52 +lon_0=10 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +units=m +no_defs ",
        3035: "+title=ETRS89 / ETRS-LAEA +proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +units=m +no_defs ",
        3042: "+title=ETRS89 / ETRS-TM30 +proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs ",
        3043: "+title=ETRS89 / ETRS-TM31 +proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs ",
        3044: "+title=ETRS89 / ETRS-TM32 +proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs ",
        25828: "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        25829: "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        // 25830 : "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        // 25831 : "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        // 25832 : "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        25833: "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        25834: "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        25835: "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        25836: "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        25837: "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        25838: "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3060: "+title=IGN72 Grande Terre / UTM zone 58S +proj=utm +zone=58 +south +ellps=intl +units=m +no_defs ",
        3163: "+title=RGNC91-93 / Lambert New Caledonia +proj=lcc +lat_1=-20.66666666666667 +lat_2=-22.33333333333333 +lat_0=-21.5 +lon_0=166 +x_0=400000 +y_0=300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3164: "+title=ST87 Ouvea / UTM zone 58S +proj=utm +zone=58 +south +ellps=WGS84 +towgs84=-56.263,16.136,-22.856,0,0,0,0 +units=m +no_defs ",
        3165: "+title=NEA74 Noumea / Noumea Lambert +proj=lcc +lat_1=-22.24469175 +lat_2=-22.29469175 +lat_0=-22.26969175 +lon_0=166.44242575 +x_0=0.66 +y_0=1.02 +ellps=intl +units=m +no_defs ",
        3166: "+title=NEA74 Noumea / Noumea Lambert 2 +proj=lcc +lat_1=-22.24472222222222 +lat_2=-22.29472222222222 +lat_0=-22.26972222222222 +lon_0=166.4425 +x_0=8.313000000000001 +y_0=-2.354 +ellps=intl +units=m +no_defs ",
        3169: "+title=RGNC91-93 / UTM zone 57S +proj=utm +zone=57 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3170: "+title=RGNC91-93 / UTM zone 58S +proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3171: "+title=RGNC91-93 / UTM zone 59S +proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ",
        3172: "+title=IGN53 Mare / UTM zone 59S +proj=utm +zone=59 +south +ellps=intl +units=m +no_defs ",
        3296: "+title=RGPF / UTM zone 5S +proj=utm +zone=5 +south +ellps=GRS80 +units=m +no_defs ",
        3297: "+title=RGPF / UTM zone 6S +proj=utm +zone=6 +south +ellps=GRS80 +units=m +no_defs ",
        3298: "+title=RGPF / UTM zone 7S +proj=utm +zone=7 +south +ellps=GRS80 +units=m +no_defs ",
        3299: "+title=RGPF / UTM zone 8S +proj=utm +zone=8 +south +ellps=GRS80 +units=m +no_defs ",
        3302: "+title=IGN63 Hiva Oa / UTM zone 7S +proj=utm +zone=7 +south +ellps=intl +units=m +no_defs ",
        3303: "+title=Fatu Iva 72 / UTM zone 7S +proj=utm +zone=7 +south +ellps=intl +towgs84=347.103,1078.12,2623.92,-33.8875,70.6773,-9.3943,186.074 +units=m +no_defs ",
        3304: "+title=Tahiti 79 / UTM zone 6S +proj=utm +zone=6 +south +ellps=intl +units=m +no_defs ",
        3305: "+title=Moorea 87 / UTM zone 6S +proj=utm +zone=6 +south +ellps=intl +towgs84=215.525,149.593,176.229,-3.2624,-1.692,-1.1571,10.4773 +units=m +no_defs ",
        3306: "+title=Maupiti 83 / UTM zone 5S +proj=utm +zone=5 +south +ellps=intl +towgs84=217.037,86.959,23.956,0,0,0,0 +units=m +no_defs ",
        3312: "+title=CSG67 / UTM zone 21N +proj=utm +zone=21 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs ",
        3313: "+title=RGFG95 / UTM zone 21N +proj=utm +zone=21 +ellps=GRS80 +towgs84=2,2,-2,0,0,0,0 +units=m +no_defs ",
        3336: "+title=IGN 1962 Kerguelen / UTM zone 42S +proj=utm +zone=42 +south +ellps=intl +towgs84=145,-187,103,0,0,0,0 +units=m +no_defs ",
        3395: "+title=WGS 84 / World Mercator +proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        3727: "+title=Reunion 1947 / TM Reunion +proj=tmerc +lat_0=-21.11666666666667 +lon_0=55.53333333333333 +k=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +no_defs ",
        21781: "+title=CH1903 / LV03 +proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs ",
        25830: "+title=ETRS89 / UTM zone 30N +proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs ",
        25831: "+title=ETRS89 / UTM zone 31N +proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs ",
        25832: "+title=ETRS89 / UTM zone 32N +proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs ",
        27561: "+title=NTF (Paris) / Lambert Nord France +proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27562: "+title=NTF (Paris) / Lambert Centre France +proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27563: "+title=NTF (Paris) / Lambert Sud France +proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.9998774990000001 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27564: "+title=NTF (Paris) / Lambert Corse +proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.9999447100000001 +x_0=234.358 +y_0=185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27571: "+title=NTF (Paris) / Lambert zone I +proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27572: "+title=NTF (Paris) / Lambert zone II +proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27573: "+title=NTF (Paris) / Lambert zone III +proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.9998774990000001 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27574: "+title=NTF (Paris) / Lambert zone IV +proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.9999447100000001 +x_0=234.358 +y_0=4185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27581: "+title=NTF (Paris) / France I (deprecated) +proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27582: "+title=NTF (Paris) / France II (deprecated) +proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27583: "+title=NTF (Paris) / France III (deprecated) +proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.9998774990000001 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27584: "+title=NTF (Paris) / France IV (deprecated) +proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.9999447100000001 +x_0=234.358 +y_0=4185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27591: "+title=NTF (Paris) / Nord France (deprecated) +proj=lcc +lat_1=49.50000000000001 +lat_0=49.50000000000001 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27592: "+title=NTF (Paris) / Centre France (deprecated) +proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27593: "+title=NTF (Paris) / Sud France (deprecated) +proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.9998774990000001 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        27594: "+title=NTF (Paris) / Corse (deprecated) +proj=lcc +lat_1=42.16500000000001 +lat_0=42.16500000000001 +lon_0=0 +k_0=0.9999447100000001 +x_0=234.358 +y_0=185861.369 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs ",
        32601: "+proj=utm +zone=1 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32602: "+proj=utm +zone=2 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32603: "+proj=utm +zone=3 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32604: "+proj=utm +zone=4 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32605: "+proj=utm +zone=5 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32606: "+proj=utm +zone=6 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32607: "+proj=utm +zone=7 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32608: "+proj=utm +zone=8 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32609: "+proj=utm +zone=9 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32610: "+proj=utm +zone=10 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32611: "+proj=utm +zone=11 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32612: "+proj=utm +zone=12 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32613: "+proj=utm +zone=13 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32614: "+proj=utm +zone=14 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32615: "+proj=utm +zone=15 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32616: "+proj=utm +zone=16 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32617: "+proj=utm +zone=17 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32618: "+proj=utm +zone=18 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32619: "+proj=utm +zone=19 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32620: "+proj=utm +zone=20 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32621: "+proj=utm +zone=21 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32622: "+proj=utm +zone=22 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32623: "+proj=utm +zone=23 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32624: "+proj=utm +zone=24 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32625: "+proj=utm +zone=25 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32626: "+proj=utm +zone=26 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32627: "+proj=utm +zone=27 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32628: "+proj=utm +zone=28 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32629: "+proj=utm +zone=29 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32630: "+proj=utm +zone=30 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32631: "+proj=utm +zone=31 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32632: "+proj=utm +zone=32 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32633: "+proj=utm +zone=33 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32634: "+proj=utm +zone=34 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32635: "+proj=utm +zone=35 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32636: "+proj=utm +zone=36 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32637: "+proj=utm +zone=37 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32638: "+proj=utm +zone=38 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32639: "+proj=utm +zone=39 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32640: "+proj=utm +zone=40 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32641: "+proj=utm +zone=41 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32642: "+proj=utm +zone=42 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32643: "+proj=utm +zone=43 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32644: "+proj=utm +zone=44 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32645: "+proj=utm +zone=45 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32646: "+proj=utm +zone=46 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32647: "+proj=utm +zone=47 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32648: "+proj=utm +zone=48 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32649: "+proj=utm +zone=49 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32650: "+proj=utm +zone=50 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32651: "+proj=utm +zone=51 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32652: "+proj=utm +zone=52 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32653: "+proj=utm +zone=53 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32654: "+proj=utm +zone=54 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32655: "+proj=utm +zone=55 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32656: "+proj=utm +zone=56 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32657: "+proj=utm +zone=57 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32658: "+proj=utm +zone=58 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32659: "+proj=utm +zone=59 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32660: "+proj=utm +zone=60 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32661: "+proj=stere +lat_0=90 +lat_ts=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32662: "+title=WGS 84 / Plate Carree +proj=eqc +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32701: "+proj=utm +zone=1 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32702: "+proj=utm +zone=2 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32703: "+proj=utm +zone=3 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32704: "+proj=utm +zone=4 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32705: "+proj=utm +zone=5 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32706: "+proj=utm +zone=6 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32707: "+proj=utm +zone=7 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32708: "+proj=utm +zone=8 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32709: "+proj=utm +zone=9 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32710: "+proj=utm +zone=10 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32711: "+proj=utm +zone=11 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32712: "+proj=utm +zone=12 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32713: "+proj=utm +zone=13 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32714: "+proj=utm +zone=14 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32715: "+proj=utm +zone=15 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32716: "+proj=utm +zone=16 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32717: "+proj=utm +zone=17 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32718: "+proj=utm +zone=18 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32719: "+proj=utm +zone=19 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32720: "+proj=utm +zone=20 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32721: "+proj=utm +zone=21 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32722: "+proj=utm +zone=22 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32723: "+proj=utm +zone=23 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32724: "+proj=utm +zone=24 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32725: "+proj=utm +zone=25 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32726: "+proj=utm +zone=26 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32727: "+proj=utm +zone=27 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32728: "+proj=utm +zone=28 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32729: "+proj=utm +zone=29 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32730: "+proj=utm +zone=30 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32731: "+proj=utm +zone=31 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32732: "+proj=utm +zone=32 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32733: "+proj=utm +zone=33 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32734: "+proj=utm +zone=34 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32735: "+proj=utm +zone=35 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32736: "+proj=utm +zone=36 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32737: "+proj=utm +zone=37 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32738: "+proj=utm +zone=38 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32739: "+proj=utm +zone=39 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32740: "+proj=utm +zone=40 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32741: "+proj=utm +zone=41 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32742: "+proj=utm +zone=42 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32743: "+proj=utm +zone=43 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32744: "+proj=utm +zone=44 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32745: "+proj=utm +zone=45 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32746: "+proj=utm +zone=46 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32747: "+proj=utm +zone=47 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32748: "+proj=utm +zone=48 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32749: "+proj=utm +zone=49 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32750: "+proj=utm +zone=50 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32751: "+proj=utm +zone=51 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32752: "+proj=utm +zone=52 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32753: "+proj=utm +zone=53 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32754: "+proj=utm +zone=54 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32755: "+proj=utm +zone=55 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32756: "+proj=utm +zone=56 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32757: "+proj=utm +zone=57 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32758: "+proj=utm +zone=58 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32759: "+proj=utm +zone=59 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32760: "+proj=utm +zone=60 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        32761: "+proj=stere +lat_0=-90 +lat_ts=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ",
        310024802: "+title=Geoportail - France metropolitaine +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=46.500000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310915814: "+title=Geoportail - Antilles francaises +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=15.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310486805: "+title=Geoportail - Guyane +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=4.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310700806: "+title=Geoportail - Reunion et dependances +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-21.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310702807: "+title=Geoportail - Mayotte +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-12.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310706808: "+title=Geoportail - Saint-Pierre et Miquelon +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=47.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310547809: "+title=Geoportail - Nouvelle-Caledonie +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-22.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310642810: "+title=Geoportail - Wallis et Futuna +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000,0.0000,0.0000,0.0000,0.000000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-14.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310032811: "+title=Geoportail - Polynesie francaise +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-15.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310642812: "+title=Geoportail - Kerguelen +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-49.500000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310642801: "+title=Geoportail - Crozet +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-46.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310642813: "+title=Geoportail - Amsterdam et Saint-Paul +proj=eqc +nadgrids=null +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-38.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        310642901: "+title=Geoportail - Monde +proj=mill +towgs84=0.0000,0.0000,0.0000,0.0000,0.0000,0.0000,0.000000 +a=6378137.0000 +rf=298.2572221010000 +lon_0=0.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        5489: "+title=RGAF09 geographiques (dms) +proj=longlat +nadgrids=@null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137 +rf=298.257222101 +units=m +no_defs",
        5490: "+title=RGAF09 UTM Nord Fuseau 20 +proj=tmerc +nadgrids=@null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137 +rf=298.257222101 +lat_0=0.000000000 +lon_0=-63.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs"
    },
    CRS: {
        84: "+title=WGS 84 longitude-latitude +proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs "
    },
    IGNF: {
        AMST63: "+title=Amsterdam 1963 +proj=geocent +towgs84=109.753,-528.133,-362.244,0,0,0,0 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        CROZ63: "+title=Crozet 1963 +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        CSG67: "+title=Guyane CSG67 +proj=geocent +towgs84=-193.0660,236.9930,105.4470,0.4814,-0.8074,0.1276,1.564900 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        ED50: "+title=ED50 +proj=geocent +towgs84=-84.0000,-97.0000,-117.0000 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        ETRS89: "+title=Systeme de reference terrestre Europeen (1989) +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        GUAD48: "+title=Guadeloupe Ste Anne +proj=geocent +towgs84=-472.2900,-5.6300,-304.1200,0.4362,-0.8374,0.2563,1.898400 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        GUADFM49: "+title=Guadeloupe Fort Marigot +proj=geocent +towgs84=136.5960,248.1480,-429.7890 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        IGN63: "+title=IGN 1963 (Hiva Oa, Tahuata, Mohotani) +proj=geocent +towgs84=410.7210,55.0490,80.7460,-2.5779,-2.3514,-0.6664,17.331100 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        IGN72: "+title=IGN 1972 Grande-Terre / Ile des Pins +proj=geocent +towgs84=-11.6400,-348.6000,291.6800 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        KERG62CAR: "+title=Kerguelen - K0 +proj=geocent +towgs84=144.8990,-186.7700,100.9230 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        MART38: "+title=Martinique Fort-Desaix +proj=geocent +towgs84=126.9260,547.9390,130.4090,-2.7867,5.1612,-0.8584,13.822650 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        MAYO50: "+title=Mayotte Combani +proj=geocent +towgs84=-599.9280,-275.5520,-195.6650,-0.0835,-0.4715,0.0602,49.281400 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        MOOREA87: "+title=Moorea 1987 +proj=geocent +towgs84=215.9820,149.5930,176.2290,3.2624,1.6920,1.1571,10.477300 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        NTF: "+title=Nouvelle Triangulation Francaise +proj=geocent +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +units=m +no_defs",
        NUKU72: "+title=IGN 1972 Nuku Hiva +proj=geocent +towgs84=165.7320,216.7200,180.5050,-0.6434,-0.4512,-0.0791,7.420400 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        REUN47: "+title=Reunion 1947 +proj=geocent +towgs84=789.5240,-626.4860,-89.9040,0.6006,76.7946,-10.5788,-32.324100 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        RGF93: "+title=Reseau geodesique francais 1993 +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGFG95: "+title=Reseau geodesique francais de Guyane 1995 +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGM04: "+title=RGM04 (Reseau Geodesique de Mayotte 2004) +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGNC: "+title=Reseau Geodesique de Nouvelle-Caledonie +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGPF: "+title=RGPF (Reseau Geodesique de Polynesie Francaise) +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGR92: "+title=Reseau geodesique Reunion 1992 +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGSPM06: "+title=Reseau Geodesique Saint-Pierre-et-Miquelon (2006) +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGTAAF07: "+title=Reseau Geodesique des TAAF (2007) +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RRAF91: "+title=RRAF 1991 (Reseau de Reference des Antilles Francaises) +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        STPL69: "+title=Saint-Paul 1969 +proj=geocent +towgs84=225.571,-346.608,-46.567,0,0,0,0 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        STPM50: "+title=St Pierre et Miquelon 1950 +proj=geocent +towgs84=-95.5930,573.7630,173.4420,-0.9602,1.2510,-1.3918,42.626500 +a=6378206.4000 +rf=294.9786982000000 +units=m +no_defs",
        TAHAA: "+title=Raiatea - Tahaa 51-54 (Tahaa, Base Terme Est) +proj=geocent +towgs84=72.4380,345.9180,79.4860,-1.6045,-0.8823,-0.5565,1.374600 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        TAHI79: "+title=IGN79 (Tahiti) Iles de la Societe +proj=geocent +towgs84=221.5250,152.9480,176.7680,2.3847,1.3896,0.8770,11.474100 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        TERA50: "+title=Pointe Geologie - Perroud 1950 +proj=geocent +towgs84=324.9120,153.2820,172.0260 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        WALL78: "+title=Wallis-Uvea 1978 (MOP78) +proj=geocent +towgs84=253.0000,-133.0000,-127.0000 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        WGS72: "+title=World Geodetic System 1972 +proj=geocent +towgs84=0.0000,12.0000,6.0000 +a=6378135.0000 +rf=298.2600000000000 +units=m +no_defs",
        WGS84: "+title=World Geodetic System 1984 +proj=geocent +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        AMST63GEO: "+title=Amsterdam 1963 +proj=longlat +towgs84=109.753,-528.133,-362.244,0,0,0,0 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        CROZ63GEO: "+title=Crozet 1963 +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        CSG67GEO: "+title=Guyane CSG67 +proj=longlat +towgs84=-193.0660,236.9930,105.4470,0.4814,-0.8074,0.1276,1.564900 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        ED50G: "+title=ED50 +proj=longlat +towgs84=-84.0000,-97.0000,-117.0000 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        GUAD48GEO: "+title=Guadeloupe Ste Anne +proj=longlat +towgs84=-472.2900,-5.6300,-304.1200,0.4362,-0.8374,0.2563,1.898400 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        GUADFM49GEO: "+title=Guadeloupe Fort Marigot +proj=longlat +towgs84=136.5960,248.1480,-429.7890 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        IGN63GEO: "+title=IGN 1963 (Hiva Oa, Tahuata, Mohotani) +proj=longlat +towgs84=410.7210,55.0490,80.7460,-2.5779,-2.3514,-0.6664,17.331100 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        IGN72GEO: "+title=IGN 1972 Grande-Terre / Ile des Pins +proj=longlat +towgs84=-11.6400,-348.6000,291.6800 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        KERG62GEO: "+title=Kerguelen - K0 +proj=longlat +towgs84=144.8990,-186.7700,100.9230 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        MART38GEO: "+title=Martinique Fort-Desaix +proj=longlat +towgs84=126.9260,547.9390,130.4090,-2.7867,5.1612,-0.8584,13.822650 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        MAYO50GEO: "+title=Mayotte Combani +proj=longlat +towgs84=-599.9280,-275.5520,-195.6650,-0.0835,-0.4715,0.0602,49.281400 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        MOOREA87GEO: "+title=Moorea 1987 +proj=longlat +towgs84=215.9820,149.5930,176.2290,3.2624,1.6920,1.1571,10.477300 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        NTFG: "+title=Nouvelle Triangulation Francaise Greenwich degres sexagesimaux +proj=longlat +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +units=m +no_defs",
        NTFP: "+title=Nouvelle Triangulation Francaise Paris grades +proj=longlat +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +pm=2.337229167 +units=m +no_defs",
        NUKU72GEO: "+title=IGN 1972 Nuku Hiva +proj=longlat +towgs84=165.7320,216.7200,180.5050,-0.6434,-0.4512,-0.0791,7.420400 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        REUN47GEO: "+title=Reunion 1947 +proj=longlat +towgs84=789.5240,-626.4860,-89.9040,0.6006,76.7946,-10.5788,-32.324100 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        RGF93G: "+title=Reseau geodesique francais 1993 +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGFG95GEO: "+title=Reseau geodesique francais de Guyane 1995 +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGM04GEO: "+title=RGM04 (Reseau Geodesique de Mayotte 2004) +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGNCGEO: "+title=Reseau Geodesique de Nouvelle-Caledonie +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGPFGEO: "+title=RGPF (Reseau Geodesique de Polynesie Francaise) +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGR92GEO: "+title=Reseau geodesique de la Reunion 1992 +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGSPM06GEO: "+title=Saint-Pierre-et-Miquelon (2006) +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        RGTAAF07G: "+title=Reseau Geodesique des TAAF (2007) (dms) +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        STPL69GEO: "+title=Saint-Paul 1969 +proj=longlat +towgs84=225.571,-346.608,-46.567,0,0,0,0 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        STPM50GEO: "+title=St Pierre et Miquelon 1950  +proj=longlat +towgs84=-95.5930,573.7630,173.4420,-0.9602,1.2510,-1.3918,42.626500 +a=6378206.4000 +rf=294.9786982000000 +units=m +no_defs",
        TAHAAGEO: "+title=Raiatea - Tahaa 51-54 (Tahaa, Base Terme Est) +proj=longlat +towgs84=72.4380,345.9180,79.4860,-1.6045,-0.8823,-0.5565,1.374600 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        TAHI79GEO: "+title=IGN79 (Tahiti) Iles de la Societe +proj=longlat +towgs84=221.5250,152.9480,176.7680,2.3847,1.3896,0.8770,11.474100 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        TERA50G: "+title=Pointe Geologie - Perroud 1950 +proj=longlat +towgs84=324.9120,153.2820,172.0260 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        WALL78GEO: "+title=Wallis - Uvea 1978 (MOP78) +proj=longlat +towgs84=253.0000,-133.0000,-127.0000 +a=6378388.0000 +rf=297.0000000000000 +units=m +no_defs",
        WGS72G: "+title=WGS72 +proj=longlat +towgs84=0.0000,12.0000,6.0000 +a=6378135.0000 +rf=298.2600000000000 +units=m +no_defs",
        WGS84G: "+title=World Geodetic System 1984 +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        WGS84RRAFGEO: "+title=Reseau de reference des Antilles francaises (1988-1991) +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        XGEO: "+title=Systeme CIO-BIH +proj=longlat +towgs84=0.0000,0.0000,0.5000,0.0000,0.0000,0.0140,-0.100000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        AMST63UTM43S: "+title=Amsterdam 1963 UTM fuseau 43 Sud +proj=tmerc +towgs84=109.753,-528.133,-362.244,0,0,0,0 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=75.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        CROZ63UTM39S: "+title=Crozet 1963 +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=51.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        CSG67UTM21: "+title=Guyane CSG67 UTM fuseau 21 +proj=tmerc +towgs84=-193.0660,236.9930,105.4470,0.4814,-0.8074,0.1276,1.564900 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-57.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        CSG67UTM22: "+title=Guyane CSG67 UTM fuseau 22 +proj=tmerc +towgs84=-193.0660,236.9930,105.4470,0.4814,-0.8074,0.1276,1.564900 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-51.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALANF: "+title=Geoportail - Antilles francaises +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=15.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALASP: "+title=Geoportail - Amsterdam et Saint-Paul +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-38.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALCRZ: "+title=Geoportail - Crozet +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-46.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALFXX: "+title=Geoportail - France metropolitaine +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=46.500000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALGUF: "+title=Geoportail - Guyane +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=4.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALKER: "+title=Geoportail - Kerguelen +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-49.500000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALMYT: "+title=Geoportail - Mayotte +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-12.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALNCL: "+title=Geoportail - Nouvelle-Caledonie +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-22.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALPYF: "+title=Geoportail - Polynesie francaise +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-15.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALREU: "+title=Geoportail - Reunion et dependances +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-21.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALSPM: "+title=Geoportail - Saint-Pierre et Miquelon +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=47.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GEOPORTALWLF: "+title=Geoportail - Wallis et Futuna +proj=eqc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=0.000000000 +lat_ts=-14.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        GUAD48UTM20: "+title=Guadeloupe Ste Anne +proj=tmerc +towgs84=-472.2900,-5.6300,-304.1200,0.4362,-0.8374,0.2563,1.898400 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-63.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        GUADFM49U20: "+title=Guadeloupe Fort Marigot  +proj=tmerc +towgs84=136.5960,248.1480,-429.7890 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-63.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        IGN63UTM7S: "+title=IGN 1963 - Hiva Oa, Tahuata, Mohotani - UTM fuseau 7 Sud +proj=tmerc +towgs84=410.7210,55.0490,80.7460,-2.5779,-2.3514,-0.6664,17.331100 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-141.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        IGN72UTM58S: "+title=IGN 1972 - UTM fuseau 58 Sud +proj=tmerc +towgs84=-11.6400,-348.6000,291.6800 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=165.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        KERG62UTM42S: "+title=Kerguelen 1962 +proj=tmerc +towgs84=144.8990,-186.7700,100.9230 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=69.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        LAMB1: "+title=Lambert I +proj=lcc +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +pm=2.337229167 +lat_0=49.500000000 +lon_0=0.000000000 +k_0=0.99987734 +lat_1=49.500000000 +x_0=600000.000 +y_0=200000.000 +units=m +no_defs",
        LAMB1C: "+title=Lambert I Carto +proj=lcc +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +pm=2.337229167 +lat_0=49.500000000 +lon_0=0.000000000 +k_0=0.99987734 +lat_1=49.500000000 +x_0=600000.000 +y_0=1200000.000 +units=m +no_defs",
        LAMB2: "+title=Lambert II +proj=lcc +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +pm=2.337229167 +lat_0=46.800000000 +lon_0=0.000000000 +k_0=0.99987742 +lat_1=46.800000000 +x_0=600000.000 +y_0=200000.000 +units=m +no_defs",
        LAMB2C: "+title=Lambert II Carto +proj=lcc +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +pm=2.337229167 +lat_0=46.800000000 +lon_0=0.000000000 +k_0=0.99987742 +lat_1=46.800000000 +x_0=600000.000 +y_0=2200000.000 +units=m +no_defs",
        LAMB3: "+title=Lambert III +proj=lcc +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +pm=2.337229167 +lat_0=44.100000000 +lon_0=0.000000000 +k_0=0.99987750 +lat_1=44.100000000 +x_0=600000.000 +y_0=200000.000 +units=m +no_defs",
        LAMB3C: "+title=Lambert III Carto +proj=lcc +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +pm=2.337229167 +lat_0=44.100000000 +lon_0=0.000000000 +k_0=0.99987750 +lat_1=44.100000000 +x_0=600000.000 +y_0=3200000.000 +units=m +no_defs",
        LAMB4: "+title=Lambert IV +proj=lcc +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +pm=2.337229167 +lat_0=42.165000000 +lon_0=0.000000000 +k_0=0.99994471 +lat_1=42.165000000 +x_0=234.358 +y_0=185861.369 +units=m +no_defs",
        LAMB4C: "+title=Lambert IV Carto +proj=lcc +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +pm=2.337229167 +lat_0=42.165000000 +lon_0=0.000000000 +k_0=0.99994471 +lat_1=42.165000000 +x_0=234.358 +y_0=4185861.369 +units=m +no_defs",
        LAMB93: "+title=Lambert 93 +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=46.500000000 +lon_0=3.000000000 +lat_1=44.000000000 +lat_2=49.000000000 +x_0=700000.000 +y_0=6600000.000 +units=m +no_defs",
        RGF93CC42: "+title=Lambert conique conforme Zone 1 +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=42.000000000 +lon_0=3.000000000 +lat_1=41.200000000 +lat_2=42.800000000 +x_0=1700000.000 +y_0=1200000.000 +units=m +no_defs",
        RGF93CC43: "+title=Lambert conique conforme Zone 2 +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=43.000000000 +lon_0=3.000000000 +lat_1=42.200000000 +lat_2=43.800000000 +x_0=1700000.000 +y_0=2200000.000 +units=m +no_defs",
        RGF93CC44: "+title=Lambert conique conforme Zone 3 +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=44.000000000 +lon_0=3.000000000 +lat_1=43.200000000 +lat_2=44.800000000 +x_0=1700000.000 +y_0=3200000.000 +units=m +no_defs",
        RGF93CC45: "+title=Lambert conique conforme Zone 4 +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=45.000000000 +lon_0=3.000000000 +lat_1=44.200000000 +lat_2=45.800000000 +x_0=1700000.000 +y_0=4200000.000 +units=m +no_defs",
        RGF93CC46: "+title=Lambert conique conforme Zone 5 +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=46.000000000 +lon_0=3.000000000 +lat_1=45.200000000 +lat_2=46.800000000 +x_0=1700000.000 +y_0=5200000.000 +units=m +no_defs",
        RGF93CC47: "+title=Lambert conique conforme Zone 6 +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=47.000000000 +lon_0=3.000000000 +lat_1=46.200000000 +lat_2=47.800000000 +x_0=1700000.000 +y_0=6200000.000 +units=m +no_defs",
        RGF93CC48: "+title=Lambert conique conforme Zone 7 +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=48.000000000 +lon_0=3.000000000 +lat_1=47.200000000 +lat_2=48.800000000 +x_0=1700000.000 +y_0=7200000.000 +units=m +no_defs",
        RGF93CC49: "+title=Lambert conique conforme Zone 8 +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=49.000000000 +lon_0=3.000000000 +lat_1=48.200000000 +lat_2=49.800000000 +x_0=1700000.000 +y_0=8200000.000 +units=m +no_defs",
        RGF93CC50: "+title=Lambert conique conforme Zone 9 +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=50.000000000 +lon_0=3.000000000 +lat_1=49.200000000 +lat_2=50.800000000 +x_0=1700000.000 +y_0=9200000.000 +units=m +no_defs",
        LAMBE: "+title=Lambert II etendu +proj=lcc +nadgrids=ntf_r93.gsb,null +wktext +towgs84=-168.0000,-60.0000,320.0000 +a=6378249.2000 +rf=293.4660210000000 +pm=2.337229167 +lat_0=46.800000000 +lon_0=0.000000000 +k_0=0.99987742 +lat_1=46.800000000 +x_0=600000.000 +y_0=2200000.000 +units=m +no_defs",
        MART38UTM20: "+title=Martinique Fort-Desaix +proj=tmerc +towgs84=126.9260,547.9390,130.4090,-2.7867,5.1612,-0.8584,13.822650 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-63.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        MAYO50UTM38S: "+title=Mayotte Combani +proj=tmerc +towgs84=-599.9280,-275.5520,-195.6650,-0.0835,-0.4715,0.0602,49.281400 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=45.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        MILLER: "+title=Geoportail - Monde +proj=mill +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lon_0=0.000000000 +x_0=0.000 +y_0=0.000 +units=m +no_defs",
        MOOREA87U6S: "+title=Moorea 1987 - UTM fuseau 6 Sud +proj=tmerc +towgs84=215.9820,149.5930,176.2290,3.2624,1.6920,1.1571,10.477300 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-147.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        NUKU72U7S: "+title=IGN 1972 Nuku Hiva - UTM fuseau 7 Sud +proj=tmerc +towgs84=165.7320,216.7200,180.5050,-0.6434,-0.4512,-0.0791,7.420400 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-141.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        REUN47GAUSSL: "+title=Reunion Gauss Laborde +proj=gstmerc +towgs84=789.5240,-626.4860,-89.9040,0.6006,76.7946,-10.5788,-32.324100 +a=6378388.0000 +rf=297.0000000000000 +lat_0=-21.116666667 +lon_0=55.533333333 +k_0=1.00000000 +x_0=160000.000 +y_0=50000.000 +units=m +no_defs",
        RGM04UTM38S: "+title=UTM fuseau 38 Sud (Reseau Geodesique de Mayotte 2004) +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=45.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        RGNCUTM57S: "+title=Reseau Geodesique de Nouvelle-Caledonie - UTM fuseau 57 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=159.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        RGNCUTM58S: "+title=Reseau Geodesique de Nouvelle-Caledonie - UTM fuseau 58 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=165.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        RGNCUTM59S: "+title=Reseau Geodesique de Nouvelle-Caledonie - UTM fuseau 59 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=171.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        RGPFUTM5S: "+title=RGPF - UTM fuseau 5 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-153.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        RGPFUTM6S: "+title=RGPF - UTM fuseau 6 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-147.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        RGPFUTM7S: "+title=RGPF - UTM fuseau 7 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-141.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        RGR92UTM40S: "+title=RGR92 UTM fuseau 40 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=57.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        RGSPM06U21: "+title=Saint-Pierre-et-Miquelon (2006) UTM Fuseau 21 Nord +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-57.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        STPL69UTM43S: "+title=Saint-Paul 1969 UTM fuseau 43 Sud +proj=tmerc +towgs84=225.571,-346.608,-46.567,0,0,0,0 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=75.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        STPM50UTM21: "+title=St Pierre et Miquelon 1950 +proj=tmerc +towgs84=-95.5930,573.7630,173.4420,-0.9602,1.2510,-1.3918,42.626500 +a=6378206.4000 +rf=294.9786982000000 +lat_0=0.000000000 +lon_0=-57.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        TAHAAUTM05S: "+title=Tahaa 1951 +proj=tmerc +towgs84=72.4380,345.9180,79.4860,-1.6045,-0.8823,-0.5565,1.374600 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-153.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        TAHI51UTM06S: "+title=Tahiti-Terme Nord UTM fuseau 6 Sud +proj=tmerc +towgs84=162.0000,117.0000,154.0000 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-147.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        TAHI79UTM6S: "+title=Tahiti 1979 +proj=tmerc +towgs84=221.5250,152.9480,176.7680,2.3847,1.3896,0.8770,11.474100 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-147.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        TERA50STEREO: "+title=Terre Adelie 1950 +proj=stere +towgs84=324.9120,153.2820,172.0260 +a=6378388.0000 +rf=297.0000000000000 +lat_0=-90.000000000 +lon_0=140.000000000 +lat_ts=-67 +k=0.96027295 +x_0=300000.000 +y_0=-2299363.482 +units=m +no_defs",
        UTM01SW84: "+title=World Geodetic System 1984 UTM fuseau 01 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-177.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        UTM20W84GUAD: "+title=World Geodetic System 1984 UTM fuseau 20 Nord-Guadeloupe +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-63.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM20W84MART: "+title=World Geodetic System 1984 UTM fuseau 20 Nord-Martinique +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-63.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM22RGFG95: "+title=RGFG95 UTM fuseau 22 Nord-Guyane +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-51.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM39SW84: "+title=World Geodetic System 1984 UTM fuseau 39 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=51.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        UTM42SW84: "+title=World Geodetic System 1984 UTM fuseau 42 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=69.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        UTM43SW84: "+title=World Geodetic System 1984 UTM fuseau 43 Sud +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=75.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        WALL78UTM1S: "+title=Wallis-Uvea 1978 (MOP78) UTM 1 SUD +proj=tmerc +towgs84=253.0000,-133.0000,-127.0000 +a=6378388.0000 +rf=297.0000000000000 +lat_0=0.000000000 +lon_0=-177.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=10000000.000 +units=m +no_defs",
        ETRS89GEO: "+title=ETRS89 geographiques (dms) +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs",
        ETRS89LAEA: "+title=ETRS89 Lambert Azimutal Equal Area +proj=laea +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=52.000000000 +lon_0=10.000000000 +x_0=4321000.000 +y_0=3210000.000 +units=m +no_defs",
        ETRS89LCC: "+title=ETRS89 Lambert Conformal Conic +proj=lcc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=52.000000000 +lon_0=9.999999995 +lat_1=35.000000000 +lat_2=65.000000000 +x_0=4000000.000 +y_0=2800000.000 +units=m +no_defs",
        UTM26ETRS89: "+title=Europe - de 30d a 24d Ouest +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-27.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM27ETRS89: "+title=Europe - de 24d a 18d Ouest +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-21.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM28ETRS89: "+title=Europe - de 18d a 12d Ouest +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-15.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM29ETRS89: "+title=Europe - de 12d a 6d Ouest +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-9.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM30ETRS89: "+title=Europe - de -6d a 0d Ouest +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=-3.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM31ETRS89: "+title=Europe - de 0d a 6d Est +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=3.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM32ETRS89: "+title=Europe - de 6d a 12d Est +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=9.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM33ETRS89: "+title=Europe - de 12d a 18d Est +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=15.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM34ETRS89: "+title=Europe - de 18d a 24d Est +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=21.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM35ETRS89: "+title=Europe - de 24d a 30d Est +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=27.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM36ETRS89: "+title=Europe - de 30d a 36d Est +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=33.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM37ETRS89: "+title=Europe - de 36d a 42d Est +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=39.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs",
        UTM38ETRS89: "+title=Europe - de 42d a 48d Est +proj=tmerc +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +lat_0=0.000000000 +lon_0=45.000000000 +k_0=0.99960000 +x_0=500000.000 +y_0=0.000 +units=m +no_defs"
    }
};

exports.default = Register;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _Config = __webpack_require__(8);

var _Config2 = _interopRequireDefault(_Config);

var _SourceWMTS = __webpack_require__(21);

var _SourceWMTS2 = _interopRequireDefault(_SourceWMTS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @classdesc
 * Geoportal LayerWMTS source creation (inherit from ol.layer.Tile)
 *
 * @constructor
 * @extends {ol.layer.Tile}
 * @alias ol.layer.GeoportalWMTS
 * @param {Object} options            - options for function call.
 * @param {String} options.layer      - Layer name (e.g. "ORTHOIMAGERY.ORTHOPHOTOS")
 * @param {Boolean} [options.ssl]     - if set true, enforce protocol https (only for nodejs)
 * @param {String} [options.apiKey]   - Access key to Geoportal platform
 * @param {Object} [options.olParams] - other options for ol.layer.Tile function (see {@link http://openlayers.org/en/latest/apidoc/ol.layer.Tile.html ol.layer.Tile})
 * @param {Object} [options.olParams.sourceParams] - other options for ol.source.WMTS function (see {@link http://openlayers.org/en/latest/apidoc/ol.source.WMTS.html ol.source.WMTS})
 * @example
 * var layerWMTS = new ol.layer.GeoportalWMTS({
 *      layer  : "ORTHOIMAGERY.ORTHOPHOTOS"
 * });
 */

function LayerWMTS(options) {
    if (!(this instanceof LayerWMTS)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    if (!options.layer) {
        throw new Error("ERROR PARAM_MISSING : layer");
    }

    if (typeof options.layer !== "string") {
        throw new Error("ERROR WRONG TYPE : layer");
    }

    // par defaut
    if (typeof options.ssl === "undefined") {
        options.ssl = false;
    }

    // Check if configuration is loaded
    if (!_Config2.default.isConfigLoaded()) {
        throw new Error("ERROR : contract key configuration has to be loaded to load Geoportal layers. See http://ignf.github.io/evolution-apigeoportail/ol3/ol3-autoconf.html");
    }

    // création de la source WMTS
    var olSourceParams;
    if (options.olParams && options.olParams.sourceParams) {
        olSourceParams = options.olParams.sourceParams;
    }
    var wmtsSource = new _SourceWMTS2.default({
        layer: options.layer,
        ssl: options.ssl,
        apiKey: options.apiKey,
        olParams: olSourceParams
    });

    var layerTileOptions = {
        source: wmtsSource
    };

    // si le param layer n'a pas été renseigné lors de la création de la source,
    // c'est que l'identifiant de la couche n'a pas été trouvé. on passe donc la recherche des paramètres.
    if (wmtsSource.getLayer() !== undefined) {
        // récupération des autres paramètres nécessaires à la création de la layer
        var layerId = _Config2.default.getLayerId(options.layer, "WMTS");
        var globalConstraints = _Config2.default.getGlobalConstraints(layerId);
        if (globalConstraints && globalConstraints.projection) {
            /* INFO : désactivation temporaire de l'étendue, car certaines étendues (trop grandes ?)
            provoquent quelques bugs d'affichage (zoom > 16 par exemple) */
            // récupération de l'étendue (en EPSG:4326), et reprojection dans la proj de la couche
            // var geobbox = [
            //     globalConstraints.extent.left,
            //     globalConstraints.extent.bottom,
            //     globalConstraints.extent.right,
            //     globalConstraints.extent.top
            // ];
            // layerTileOptions.extent = ol.proj.transformExtent(geobbox, "EPSG:4326", globalConstraints.projection);

            // récupération des résolutions min et max
            var p;
            // on récupère tout d'abord la projection
            if (typeof globalConstraints.projection === "string") {
                p = _ol2.default.proj.get(globalConstraints.projection);
            }
            // puis, selon l'unité de la projection, on calcule la résolution correspondante
            if (p && p.getUnits()) {
                if (p.getUnits() === "m") {
                    /* fixme : fix temporaire pour gérer les min/max scaledenominator qui sont arrondis dans l'autoconf !
                     * on les arrondit respectivement à l'unité inférieure et supérieure
                     * pour que les couches soient bien disponibles aux niveaux de zoom correspondants */
                    // info : 1 pixel = 0.00028 m
                    layerTileOptions.minResolution = (globalConstraints.minScale - 1) * 0.00028;
                    layerTileOptions.maxResolution = (globalConstraints.maxScale + 1) * 0.00028;
                } else if (p.getUnits() === "degrees") {
                    /* fixme : fix temporaire pour gérer les min/max scaledenominator qui sont arrondis dans l'autoconf !
                     * on les arrondit respectivement à l'unité inférieure et supérieure
                     * pour que les couches soient bien disponibles aux niveaux de zoom correspondants */
                    // info : 6378137 * 2 * pi / 360 = rayon de la terre (ellipsoide WGS84)
                    layerTileOptions.minResolution = (globalConstraints.minScale - 1) * 0.00028 * 180 / (Math.PI * 6378137);
                    layerTileOptions.maxResolution = (globalConstraints.maxScale + 1) * 0.00028 * 180 / (Math.PI * 6378137);
                }
            }
        }
    }

    // récupération des autres paramètres passés par l'utilisateur
    _Utils2.default.mergeParams(layerTileOptions, options.olParams);

    // création d'une ol.layer.Tile avec les options récupérées ci-dessus.
    _ol2.default.layer.Tile.call(this, layerTileOptions);
}

// Inherits from ol.layer.Tile
_ol2.default.inherits(LayerWMTS, _ol2.default.layer.Tile);

/*
 * @lends module:LayerWMTS
 */
LayerWMTS.prototype = Object.create(_ol2.default.layer.Tile.prototype, {});

/*
 * Constructor (alias)
 */
LayerWMTS.prototype.constructor = LayerWMTS;

exports.default = LayerWMTS;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _Config = __webpack_require__(8);

var _Config2 = _interopRequireDefault(_Config);

var _SourceWMS = __webpack_require__(22);

var _SourceWMS2 = _interopRequireDefault(_SourceWMS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @classdesc
 * Geoportal LayerWMS source creation (inherit from ol.layer.Tile)
 *
 * @constructor
 * @extends {ol.layer.Tile}
 * @alias ol.layer.GeoportalWMS
 * @param {Object} options            - options for function call.
 * @param {String} options.layer      - Layer name (e.g. "ORTHOIMAGERY.ORTHOPHOTOS")
 * @param {Boolean} [options.ssl]     - if set true, enforce protocol https (only for nodejs)
 * @param {String} [options.apiKey]   - Access key to Geoportal platform
 * @param {Object} [options.olParams] - other options for ol.layer.Tile function (see {@link http://openlayers.org/en/latest/apidoc/ol.layer.Tile.html ol.layer.Tile})
 * @param {Object} [options.olParams.sourceParams] - other options for ol.source.TileWMS function (see {@link http://openlayers.org/en/latest/apidoc/ol.source.TileWMS.html ol.source.TileWMS})
 * @example
 * var layerWMS = new ol.layer.GeoportalWMS({
 *      layer  : "ORTHOIMAGERY.ORTHOPHOTOS"
 * });
 */
function LayerWMS(options) {
    if (!(this instanceof LayerWMS)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    if (!options.layer) {
        throw new Error("ERROR PARAM_MISSING : layer");
    }

    if (typeof options.layer !== "string") {
        throw new Error("ERROR WRONG TYPE : layer");
    }

    // par defaut
    if (typeof options.ssl === "undefined") {
        options.ssl = false;
    }

    // Check if configuration is loaded
    if (!_Config2.default.isConfigLoaded()) {
        throw new Error("ERROR : contract key configuration has to be loaded to load Geoportal layers. See http://ignf.github.io/evolution-apigeoportail/ol3/ol3-autoconf.html");
    }

    // création de la source WMS
    var olSourceParams;
    if (options.olParams && options.olParams.sourceParams) {
        olSourceParams = options.olParams.sourceParams;
    }
    var wmsSource = new _SourceWMS2.default({
        layer: options.layer,
        ssl: options.ssl,
        apiKey: options.apiKey,
        olParams: olSourceParams
    });

    var layerTileOptions = {
        source: wmsSource
    };

    // si le param LAYERS n'a pas été renseigné lors de la création de la source,
    // c'est que l'identifiant de la couche n'a pas été trouvé. on passe donc la recherche des paramètres.
    if (wmsSource.getParams().LAYERS !== undefined) {
        // récupération des autres paramètres nécessaires à la création de la layer
        var layerId = _Config2.default.getLayerId(options.layer, "WMS");
        var globalConstraints = _Config2.default.getGlobalConstraints(layerId);

        /* INFO : on ne récupère l'emprise de la couche que lorsque que l'utilisateur spécifie la projection.
           Si aucune projection n'est spécifiée, il faudrait spécifier l'emprise dans la projection de la carte (car OpenLayers reprojette),
           mais on ne peut pas la récupérer à ce niveau. On ne spécifie donc aucune emprise.
           Idem pour les résolutions : il faut connaitre l'unité de la projection (metres ou degrés) pour pouvoir calculer la résolution.
        */
        if (olSourceParams && olSourceParams.projection) {
            // récupération de l'étendue (en EPSG:4326), et reprojection dans la proj spécifiée
            var geobbox = [globalConstraints.extent.left, globalConstraints.extent.bottom, globalConstraints.extent.right, globalConstraints.extent.top];
            layerTileOptions.extent = _ol2.default.proj.transformExtent(geobbox, "EPSG:4326", olSourceParams.projection);

            // récupération des résolutions min et max
            var p;
            // on récupère tout d'abord la projection
            if (typeof olSourceParams.projection === "string") {
                p = _ol2.default.proj.get(olSourceParams.projection);
            } else if (_typeof(olSourceParams.projection) === "object" && olSourceParams.projection.getCode()) {
                p = _ol2.default.proj.get(olSourceParams.projection.getCode());
            }
            // puis, selon l'unité de la projection, on calcule la résolution correspondante
            if (p && p.getUnits()) {
                if (p.getUnits() === "m") {
                    /* fixme : fix temporaire pour gérer les min/max scaledenominator qui sont arrondis dans l'autoconf !
                     * on les arrondit respectivement à l'unité inférieure et supérieure
                     * pour que les couches soient bien disponibles aux niveaux de zoom correspondants */
                    // info : 1 pixel = 0.00028 m
                    layerTileOptions.minResolution = (globalConstraints.minScale - 1) * 0.00028;
                    layerTileOptions.maxResolution = (globalConstraints.maxScale + 1) * 0.00028;
                } else if (p.getUnits() === "degrees") {
                    /* fixme : fix temporaire pour gérer les min/max scaledenominator qui sont arrondis dans l'autoconf !
                     * on les arrondit respectivement à l'unité inférieure et supérieure
                     * pour que les couches soient bien disponibles aux niveaux de zoom correspondants */
                    // info : 6378137 * 2 * pi / 360 = rayon de la terre (ellipsoide WGS84)
                    layerTileOptions.minResolution = (globalConstraints.minScale - 1) * 0.00028 * 180 / (Math.PI * 6378137);
                    layerTileOptions.maxResolution = (globalConstraints.maxScale + 1) * 0.00028 * 180 / (Math.PI * 6378137);
                }
            }
        }
    }
    // récupération des autres paramètres passés par l'utilisateur
    _Utils2.default.mergeParams(layerTileOptions, options.olParams);

    // création d'une ol.layer.Tile avec les options récupérées ci-dessus.
    _ol2.default.layer.Tile.call(this, layerTileOptions);
}

// Inherits from ol.layer.Tile
_ol2.default.inherits(LayerWMS, _ol2.default.layer.Tile);

/*
 * @lends module:LayerWMS
 */
LayerWMS.prototype = Object.create(_ol2.default.layer.Tile.prototype, {});

/*
 * Constructor (alias)
 */
LayerWMS.prototype.constructor = LayerWMS;

exports.default = LayerWMS;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sortable = __webpack_require__(32);

var _sortable2 = _interopRequireDefault(_sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayerSwitcherDOM = {

    /**
     * Creation du drag and drop
     *
     * @param {Object} elementDraggable - Element HTML (DOM) Container
     * @param {Object} context - this
     */
    _createDraggableElement: function _createDraggableElement(elementDraggable, context) {
        _sortable2.default.create(elementDraggable, {
            handle: ".GPlayerName",
            draggable: ".draggable-layer",
            ghostClass: "GPghostLayer",
            animation: 200,
            // Call event function on drag and drop
            onEnd: function onEnd(e) {
                // FIXME pas terrrible, mais il faut bien passer ce contexte...
                context._onDragAndDropLayerClick(e);
            }
        });
    },

    // ################################################################### //
    // ######################### Main container ########################## //
    // ################################################################### //

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Creation du container principal (DOM)
     *
     * @returns {DOMElement} container - layer switcher DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPlayerSwitcher");
        container.className = "GPwidget";
        return container;
    },

    /**
     * Creation du container principal d"affichage des layers (DOM)
     *
     * @returns {DOMElement} input - element for minimizing/maximizing the layer switcher
     */
    _createMainLayersShowElement: function _createMainLayersShowElement() {
        // <!-- Hidden checkbox for minimizing/maximizing -->
        var input = document.createElement("input");
        input.id = this._addUID("GPshowLayersList");
        input.type = "checkbox";
        return input;
    },

    /**
     * Creation du container principal des layers (DOM)
     *
     * @returns {DOMElement} container - layers list container
     */
    _createMainLayersElement: function _createMainLayersElement() {
        // ajout de la liste des layers dans le container principal
        // <div id="GPlayersList" class="GPpanel">
        //   (...)
        // </div>
        var div = document.createElement("div");
        div.id = this._addUID("GPlayersList");
        div.className = "GPpanel";
        return div;
    },

    /**
     * Creation du container du picto du controle (DOM)
     *
     * @returns {DOMElement} label
     */
    _createMainPictoElement: function _createMainPictoElement() {
        var self = this;

        // exemple :
        // <!-- Label for minimizing/maximizing -->
        // <label id="GPshowLayersListPicto" class="GPshowAdvancedToolPicto" for="GPshowLayersList" title="Afficher/masquer le gestionnaire de couches">
        //    <span id="GPshowLayersListOpen" class="GPshowAdvancedToolOpen"></span><span id="GPshowLayersListClose"></span>
        // </label>

        var label = document.createElement("label");
        label.id = this._addUID("GPshowLayersListPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowLayersList");
        label.title = "Afficher/masquer le gestionnaire de couches";

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowLayersListOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        spanOpen.addEventListener("click", function () {
            if (document.getElementById(self._addUID("GPshowLayersList")).checked) {
                var layers = document.getElementsByClassName("GPlayerInfoOpened");
                for (var i = 0; i < layers.length; i++) {
                    layers[i].className = "GPlayerInfo";
                }
                document.getElementById(self._addUID("GPlayerInfoPanel")).className = "GPlayerInfoPanelClosed";
            }
        });

        label.appendChild(spanOpen);

        var spanClose = document.createElement("span");
        spanClose.addEventListener("click", function () {
            if (document.getElementById(self._addUID("GPshowLayersList")).checked) {
                var layers = document.getElementsByClassName("GPlayerInfoOpened");
                for (var i = 0; i < layers.length; i++) {
                    layers[i].className = "GPlayerInfo";
                }
                document.getElementById(self._addUID("GPlayerInfoPanel")).className = "GPlayerInfoPanelClosed";
            }
        });
        spanClose.id = self._addUID("GPshowLayersListClose");

        label.appendChild(spanClose);

        return label;
    },

    /**
     * Creation du container du panneau d"information (DOM)
     *
     * @returns {DOMElement} container
     */
    _createMainInfoElement: function _createMainInfoElement() {
        // gestion du panneau d"information dans le container principal
        // <div id="GPlayerInfoPanel" class="GPlayerInfoPanelClosed">...</div>
        var div = document.createElement("div");
        div.id = this._addUID("GPlayerInfoPanel");
        div.className = "GPpanel GPlayerInfoPanelClosed";
        return div;
    },

    // ################################################################### //
    // ######################### Layer container ######################### //
    // ################################################################### //

    /**
     * Creation du container du layer (DOM)
     *
     * @param {Object} obj - options de la couche à ajouter dans le layer switcher
     * @param {Object} obj.layer - couche (ol ou leaflet)
     * @param {String} obj.id - identifiant de la couche (pour ol ou leaflet)
     * @param {String} obj.title - nom de la couche à afficher dans le controle
     * @param {String} obj.description - description de la couche à afficher
     * @param {Boolean} obj.visibility - visibilité de la couche dans la carte (true or false)
     * @param {Float} obj.opacity - opacité de la couche
     *
     * @returns {DOMElement} container
     */
    _createContainerLayerElement: function _createContainerLayerElement(obj) {
        // exemple :
        // <div id="GPlayerSwitcher_ID_Layer1" class="GPlayerSwitcher_layer outOfRange">
        //     <!-- Basic toolbar : visibility / layer name
        //     _createBasicToolElement
        //           _createBasicToolVisibilityElement
        //           _createBasicToolNameElement
        //     -->
        //     <!-- Hidden checkbox + label for showing advanced toolbar
        //     _createAdvancedToolShowElement
        //     -->
        //     <!-- Advanced toolbar : layer info / opacity slider / opacity value / removal
        //     _createAdvancedToolElement
        //           _createAdvancedToolDeleteElement
        //           _createAdvancedToolInformationElement
        //           _createAdvancedToolOpacityElement
        //     -->
        // </div>

        // <!-- Layer entry in layer list -->
        // <!-- Every item is marked with layerID, which is defined at layer import -->
        var container = document.createElement("div");
        container.id = this._addUID("GPlayerSwitcher_ID_" + obj.id);
        container.className = "GPlayerSwitcher_layer draggable-layer";

        // ajout des outils basiques (visibility / layer name)
        container.appendChild(this._createBasicToolElement(obj));

        // liste des outils avancés (layer info / opacity slider / opacity value / removal)
        var array = this._createAdvancedToolShowElement(obj);
        for (var i = 0; i < array.length; i++) {
            container.appendChild(array[i]);
        }

        // ajout des outils avancés
        container.appendChild(this._createAdvancedToolElement(obj));

        return container;
    },

    // ################################################################### //
    // ############################ Layer tool ########################### //
    // ################################################################### //

    /**
     * Creation du container des outils basiques du layer (DOM)
     *
     * @param {Object} obj - options de la couche à ajouter dans le layer switcher
     *
     * @returns {DOMElement} container
     */
    _createBasicToolElement: function _createBasicToolElement(obj) {
        // exemple :
        // <div id="GPbasicTools_ID_1" class="GPlayerBasicTools">
        //      <!-- _createBasicToolVisibilityElement -->
        //      <!-- _createBasicToolNameElement -->
        // </div>

        var div = document.createElement("div");
        div.id = this._addUID("GPbasicTools_ID_" + obj.id);
        div.className = "GPlayerBasicTools";

        div.appendChild(this._createBasicToolNameElement(obj));

        var array = this._createBasicToolVisibilityElement(obj);
        for (var i = 0; i < array.length; i++) {
            div.appendChild(array[i]);
        }

        return div;
    },

    /**
     * Creation du nom du layer (DOM)
     *
     * @param {Object} obj - options de la couche à ajouter dans le layer switcher
     *
     * @returns {DOMElement} container
     */
    _createBasicToolNameElement: function _createBasicToolNameElement(obj) {
        // exemple :
        // <span id="GPname_ID_Layer1" class="GPlayerName" title="Quartiers prioritaires de la ville">Quartiers prioritaires de la ville</span>
        var span = document.createElement("span");
        span.id = this._addUID("GPname_ID_" + obj.id);
        span.className = "GPlayerName";
        span.title = obj.description || obj.title;
        span.innerHTML = obj.title;

        return span;
    },

    /**
     * Creation de l'icone de visibilité du layer (DOM)
     *
     * @param {Object} obj - options de la couche à ajouter dans le layer switcher
      * @returns {DOMElement[]} array containing input and label elements
     */
    _createBasicToolVisibilityElement: function _createBasicToolVisibilityElement(obj) {
        // exemple :
        // <input type="checkbox" id="GPvisibility_ID_Layer1" checked="">
        // <label for="GPvisibility_ID_Layer1" id="GPvisibilityPicto_ID_Layer1" class="GPlayerVisibility" title="Afficher/masquer la couche"></label>

        var list = [];

        var checked = typeof obj.visibility !== "undefined" ? obj.visibility : true;
        var id = this._addUID("GPvisibility_ID_" + obj.id);

        var input = document.createElement("input");
        input.id = id;
        input.type = "checkbox";
        input.checked = checked;

        var label = document.createElement("label");
        label.htmlFor = id;
        label.id = this._addUID("GPvisibilityPicto_ID_" + obj.id);
        label.className = "GPlayerVisibility";
        label.title = "Afficher/masquer la couche";

        // add event for visibility change
        var context = this;
        if (input.addEventListener) {
            input.addEventListener("click", function (e) {
                context._onVisibilityLayerClick(e);
            });
        } else if (input.attachEvent) {
            // internet explorer
            input.attachEvent("onclick", function (e) {
                context._onVisibilityLayerClick(e);
            });
        }

        list.push(input);
        list.push(label);

        return list;
    },

    /**
     * Creation de l'affichage du menu des outils avancés du layer (DOM)
     *
     * @param {Object} obj - options de la couche à ajouter dans le layer switcher
     *
     * @returns {DOMElement[]} array containing input and label elements
     */
    _createAdvancedToolShowElement: function _createAdvancedToolShowElement(obj) {
        // <input type="checkbox" id="GPshowAdvancedTools_ID_Layer1">
        // <label for="GPshowAdvancedTools_ID_Layer1" id="GPshowAdvancedToolsPicto_ID_Layer1" class="GPshowMoreOptions GPshowLayerAdvancedTools" title="Plus d'outils"></label>

        var list = [];

        var label = document.createElement("label");
        label.id = this._addUID("GPshowAdvancedToolsPicto_ID_" + obj.id);
        label.htmlFor = this._addUID("GPshowAdvancedTools_ID_" + obj.id);
        label.title = "Plus d'outils";
        label.className = "GPshowMoreOptions GPshowLayerAdvancedTools";

        var input = document.createElement("input");
        input.type = "checkbox";
        input.id = this._addUID("GPshowAdvancedTools_ID_" + obj.id);

        list.push(input);
        list.push(label);

        return list;
    },

    /**
     * Creation du container des outils avancés du layer (DOM)
     *
     * @param {Object} obj - options de la couche à ajouter dans le layer switcher
     *
     * @returns {DOMElement} container
     */
    _createAdvancedToolElement: function _createAdvancedToolElement(obj) {
        // exemple :
        // <div id="GPadvancedTools_ID_Layer1" class="GPlayerAdvancedTools">
        //     <!-- _createAdvancedToolDeleteElement -->
        //     <!-- _createAdvancedToolInformationElement -->
        //     <!-- _createAdvancedToolOpacityElement -->
        // </div>

        var container = document.createElement("div");
        container.id = this._addUID("GPadvancedTools_ID_" + obj.id);
        container.className = "GPlayerAdvancedTools";

        container.appendChild(this._createAdvancedToolDeleteElement(obj));

        // si on n'a de l'informations à afficher, on met en place ce composant
        if (obj.title && obj.description) {
            container.appendChild(this._createAdvancedToolInformationElement(obj));
        }
        if (obj.type !== "feature") {
            var array = this._createAdvancedToolOpacityElement(obj);
            for (var i = 0; i < array.length; i++) {
                container.appendChild(array[i]);
            }
        }

        return container;
    },

    /**
     * Creation de l'icone de suppression du layer (DOM)
     *
     * @param {Object} obj - options de la couche à ajouter dans le layer switcher
     *
     * @returns {DOMElement} container
     */
    _createAdvancedToolDeleteElement: function _createAdvancedToolDeleteElement(obj) {
        // exemple :
        // <div id="GPremove_ID_Layer1" class="GPlayerRemove" title="Supprimer la couche" onclick="GPdropLayer(this);"></div>

        var div = document.createElement("div");
        div.id = this._addUID("GPremove_ID_" + obj.id);
        div.className = "GPlayerRemove";
        div.title = "Supprimer la couche";
        div.layerId = obj.id;

        var context = this;
        if (div.addEventListener) {
            div.addEventListener("click", function (e) {
                context._onDropLayerClick(e);
            });
        } else if (div.attachEvent) {
            // internet explorer
            div.attachEvent("onclick", function (e) {
                context._onDropLayerClick(e);
            });
        }

        return div;
    },

    /**
     * Creation de l'icone d'information du layer (DOM)
     *
     * @param {Object} obj - options de la couche à ajouter dans le layer switcher
     *
     * @returns {DOMElement} container
     */
    _createAdvancedToolInformationElement: function _createAdvancedToolInformationElement(obj) {
        // exemple :
        // <div id="GPinfo_ID_Layer1" class="GPlayerInfo" title="Informations/légende" onclick="GPopenLayerInfo(this);"></div>

        var div = document.createElement("div");
        div.id = this._addUID("GPinfo_ID_" + obj.id);
        div.className = "GPlayerInfo";
        div.title = "Informations/légende";
        div.layerId = obj.id;
        // add event on click
        var context = this;
        if (div.addEventListener) {
            div.addEventListener("click", function (e) {
                context._onOpenLayerInfoClick(e);
            });
        } else if (div.attachEvent) {
            // internet explorer
            div.attachEvent("onclick", function (e) {
                context._onOpenLayerInfoClick(e);
            });
        }

        return div;
    },

    /**
     * Creation de l'icone de gestion de l'opacité du layer (DOM)
     *
     * @param {Object} obj - options de la couche à ajouter dans le layer switcher
     *
     * @returns {DOMElement[]} array of two containers
     */
    _createAdvancedToolOpacityElement: function _createAdvancedToolOpacityElement(obj) {
        // exemple :
        // <div id="GPopacity_ID_Layer1" class="GPlayerOpacity" title="Opacité">
        //   <input id="GPopacityRange_ID_Layer1" type="range" value="100" oninput="GPchangeLayerOpacity(this);" onchange="GPchangeLayerOpacity(this);">
        // </div>
        // <div class="GPlayerOpacityValue" id="GPopacityValueDiv_ID_Layer1">
        //   <span id="GPopacityValue_ID_Layer1">100</span>
        //   %
        // </div>

        var list = [];

        // curseur pour changer l'opacité
        var divO = document.createElement("div");
        divO.id = this._addUID("GPopacity_ID_" + obj.id);
        divO.className = "GPlayerOpacity";
        divO.title = "Opacité";

        var opacity = typeof obj.opacity !== "undefined" ? obj.opacity : 1;
        opacity = Math.round(opacity * 100);

        var input = document.createElement("input");
        input.id = this._addUID("GPopacityValueDiv_ID_" + obj.id);
        input.type = "range";
        input.value = opacity;

        // add event for opacity change
        var context = this;
        if (input.addEventListener) {
            input.addEventListener("change", function (e) {
                context._onChangeLayerOpacity(e);
            });
        } else if (input.attachEvent) {
            // internet explorer
            input.attachEvent("onchange", function (e) {
                context._onChangeLayerOpacity(e);
            });
        }

        if (input.addEventListener) {
            input.addEventListener("input", function (e) {
                context._onChangeLayerOpacity(e);
            });
        } else if (input.attachEvent) {
            // internet explorer
            input.attachEvent("oninput", function (e) {
                context._onChangeLayerOpacity(e);
            });
        }

        divO.appendChild(input);

        // Valeur d'opacité
        var divC = document.createElement("div");
        divC.id = this._addUID("GPopacityValueDiv_ID_" + obj.id);
        divC.className = "GPlayerOpacityValue";

        var span = document.createElement("span");
        span.id = this._addUID("GPopacityValue_ID_" + obj.id);
        span.innerHTML = opacity + "%";

        divC.appendChild(span);

        list.push(divO);
        list.push(divC);

        return list;
    },

    // ################################################################### //
    // ############################ Layer info ########################### //
    // ################################################################### //

    /**
     * Creation du container du layer info (DOM)
     *
     * TODO GPlayerInfoPopup : ???
     * TODO GPlayerInfoLink  : mettre en forme les échelles !
     *
     * @param {Object} obj - options de la couche à ajouter dans le layer switcher
     *
     * @returns {DOMElement} container
     */
    _createContainerLayerInfoElement: function _createContainerLayerInfoElement(obj) {
        var container = document.createElement("div");
        container.id = this._addUID("GPlayerInfoContent");

        var title = document.createElement("div");
        title.id = this._addUID("GPlayerInfoTitle");
        title.innerHTML = obj.title;
        container.appendChild(title);

        if (obj.quicklookUrl) {
            var quick = document.createElement("div");
            quick.id = this._addUID("GPlayerInfoQuicklook");
            quick.title = "Afficher un aperçu de la couche";
            var refquick = document.createElement("a");
            refquick.href = obj.quicklookUrl;
            refquick.appendChild(quick);
            container.appendChild(refquick);
        }

        var close = document.createElement("div");
        close.id = this._addUID("GPlayerInfoClose");
        close.title = "Fermer la fenêtre";

        var self = this;
        /** Call event function on close click */
        var onCloseClick = function onCloseClick() {
            document.getElementById(self._addUID("GPlayerInfoPanel")).className = "GPlayerInfoPanelClosed";
            var layers = document.getElementsByClassName("GPlayerInfoOpened");
            for (var i = 0; i < layers.length; i++) {
                layers[i].className = "GPlayerInfo";
            }
        };
        if (close.addEventListener) {
            close.addEventListener("click", onCloseClick);
        } else if (close.attachEvent) {
            // internet explorer
            close.attachEvent("onclick", onCloseClick);
        }
        container.appendChild(close);

        var desc = document.createElement("div");
        desc.id = this._addUID("GPlayerInfoDescription");
        desc.innerHTML = obj.description;
        container.appendChild(desc);

        if (obj.metadata) {
            var mtd = document.createElement("div");
            mtd.id = this._addUID("GPlayerInfoMetadata");

            var mtdtitle = document.createElement("div");
            mtdtitle.className = "GPlayerInfoSubtitle";
            mtdtitle.innerHTML = "Métadonnées";
            mtd.appendChild(mtdtitle);

            for (var i = 0; i < obj.metadata.length; i++) {
                var urlmtd = obj.metadata[i].url;

                var mtdlink = document.createElement("div");
                mtdlink.className = "GPlayerInfoLink";

                var refmtd = document.createElement("a");
                refmtd.href = urlmtd;
                refmtd.innerHTML = urlmtd;
                mtdlink.appendChild(refmtd);
                mtd.appendChild(mtdlink);
            }

            if (obj.metadata.length !== 0) {
                container.appendChild(mtd);
            }
        }

        if (obj.legends) {
            var lgd = document.createElement("div");
            lgd.id = this._addUID("GPlayerInfoLegend");

            var lgdtitle = document.createElement("div");
            lgdtitle.className = "GPlayerInfoSubtitle";
            lgdtitle.innerHTML = "Légende";
            lgd.appendChild(lgdtitle);

            var legends = {};
            var maxScale = obj.maxScaleDenominator || 560000000;

            // on crée un tableau temporaire pour ordonner les légendes selon le dénominateur d'échelle
            for (var k = 0; k < obj.legends.length; k++) {
                var minScale = obj.legends[k].minScaleDenominator;
                if (minScale) {
                    var s = minScale.toString();
                    minScale = Math.round(parseInt(s.substring(0, 3), 10) / 10) * Math.pow(10, s.length - 2);
                } else {
                    minScale = 270;
                }
                legends[minScale] = obj.legends[k];
            }

            for (var scale in legends) {
                if (legends.hasOwnProperty(scale)) {
                    var urllgd = legends[scale].url;
                    // on n'affiche pas les légendes pointant vers "nolegend.jpg"
                    if (typeof urllgd === "string" && urllgd.toLowerCase().indexOf("nolegend.jpg") === -1) {
                        // TODO GPlayerInfoPopup
                        var lgdlink = document.createElement("div");
                        lgdlink.className = "GPlayerInfoLink";

                        maxScale = legends[scale].maxScaleDenominator || maxScale;

                        var reflgd = document.createElement("a");
                        reflgd.href = urllgd;
                        reflgd.innerHTML = "Du 1/" + scale + " au 1/" + maxScale;
                        lgdlink.appendChild(reflgd);
                        lgd.appendChild(lgdlink);
                    } else {
                        delete legends[scale];
                    }
                }
            }

            if (Object.keys(legends).length !== 0) {
                container.appendChild(lgd);
            }
        }

        return container;
    }
};

exports.default = LayerSwitcherDOM;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */


(function (factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	}
	else if (typeof Package !== "undefined") {
		Sortable = factory();  // export for Meteor.js
	}
	else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function () {
	"use strict";

	var dragEl,
		parentEl,
		ghostEl,
		cloneEl,
		rootEl,
		nextEl,

		scrollEl,
		scrollParentEl,

		lastEl,
		lastCSS,
		lastParentCSS,

		oldIndex,
		newIndex,

		activeGroup,
		autoScroll = {},

		tapEvt,
		touchEvt,

		moved,

		/** @const */
		RSPACE = /\s+/g,

		expando = 'Sortable' + (new Date).getTime(),

		win = window,
		document = win.document,
		parseInt = win.parseInt,

		supportDraggable = !!('draggable' in document.createElement('div')),
		supportCssPointerEvents = (function (el) {
			el = document.createElement('x');
			el.style.cssText = 'pointer-events:auto';
			return el.style.pointerEvents === 'auto';
		})(),

		_silent = false,

		abs = Math.abs,
		slice = [].slice,

		touchDragOverListeners = [],

		_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
			// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
			if (rootEl && options.scroll) {
				var el,
					rect,
					sens = options.scrollSensitivity,
					speed = options.scrollSpeed,

					x = evt.clientX,
					y = evt.clientY,

					winWidth = window.innerWidth,
					winHeight = window.innerHeight,

					vx,
					vy
				;

				// Delect scrollEl
				if (scrollParentEl !== rootEl) {
					scrollEl = options.scroll;
					scrollParentEl = rootEl;

					if (scrollEl === true) {
						scrollEl = rootEl;

						do {
							if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
								(scrollEl.offsetHeight < scrollEl.scrollHeight)
							) {
								break;
							}
							/* jshint boss:true */
						} while (scrollEl = scrollEl.parentNode);
					}
				}

				if (scrollEl) {
					el = scrollEl;
					rect = scrollEl.getBoundingClientRect();
					vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
					vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
				}


				if (!(vx || vy)) {
					vx = (winWidth - x <= sens) - (x <= sens);
					vy = (winHeight - y <= sens) - (y <= sens);

					/* jshint expr:true */
					(vx || vy) && (el = win);
				}


				if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
					autoScroll.el = el;
					autoScroll.vx = vx;
					autoScroll.vy = vy;

					clearInterval(autoScroll.pid);

					if (el) {
						autoScroll.pid = setInterval(function () {
							if (el === win) {
								win.scrollTo(win.pageXOffset + vx * speed, win.pageYOffset + vy * speed);
							} else {
								vy && (el.scrollTop += vy * speed);
								vx && (el.scrollLeft += vx * speed);
							}
						}, 24);
					}
				}
			}
		}, 30),

		_prepareGroup = function (options) {
			var group = options.group;

			if (!group || typeof group != 'object') {
				group = options.group = {name: group};
			}

			['pull', 'put'].forEach(function (key) {
				if (!(key in group)) {
					group[key] = true;
				}
			});

			options.groups = ' ' + group.name + (group.put.join ? ' ' + group.put.join(' ') : '') + ' ';
		}
	;



	/**
	 * @class  Sortable
	 * @param  {HTMLElement}  el
	 * @param  {Object}       [options]
	 */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);


		// Export instance
		el[expando] = this;


		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			ignore: 'a, img',
			filter: null,
			animation: 0,
			setData: function (dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false
		};


		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}


	Sortable.prototype = /** @lends Sortable.prototype */ {
		constructor: Sortable,

		_onTapStart: function (/** Event|TouchEvent */evt) {
			var _this = this,
				el = this.el,
				options = this.options,
				type = evt.type,
				touch = evt.touches && evt.touches[0],
				target = (touch || evt).target,
				originalTarget = target,
				filter = options.filter;


			if (type === 'mousedown' && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}

			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			// get the index of the dragged element within its parent
			oldIndex = _index(target);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, oldIndex);
					evt.preventDefault();
					return; // cancel dnd
				}
			}
			else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, oldIndex);
						return true;
					}
				});

				if (filter) {
					evt.preventDefault();
					return; // cancel dnd
				}
			}


			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}


			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target);
		},

		_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target) {
			var _this = this,
				el = _this.el,
				options = _this.options,
				ownerDocument = el.ownerDocument,
				dragStartFn;

			if (target && !dragEl && (target.parentNode === el)) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				activeGroup = options.group;

				dragStartFn = function () {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = true;

					// Chosen item
					_toggleClass(dragEl, _this.options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(touch);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}
			}
		},

		_disableDelayedDrag: function () {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
		},

		_triggerDragStart: function (/** Touch */touch) {
			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			}
			else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			}
			else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					document.selection.empty();
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {
			}
		},

		_dragStarted: function () {
			if (rootEl && dragEl) {
				// Apply effect
				_toggleClass(dragEl, this.options.ghostClass, true);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, oldIndex);
			}
		},

		_emulateDragOver: function () {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY),
					parent = target,
					groupName = ' ' + this.options.group.name + '',
					i = touchDragOverListeners.length;

				if (parent) {
					do {
						if (parent[expando] && parent[expando].options.groups.indexOf(groupName) > -1) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},


		_onTouchMove: function (/**TouchEvent*/evt) {
			if (tapEvt) {
				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				var touch = evt.touches ? evt.touches[0] : evt,
					dx = touch.clientX - tapEvt.clientX,
					dy = touch.clientY - tapEvt.clientY,
					translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function () {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
					css = _css(dragEl),
					options = this.options,
					ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
			var dataTransfer = evt.dataTransfer,
				options = this.options;

			this._offUpEvents();

			if (activeGroup.pull == 'clone') {
				cloneEl = dragEl.cloneNode(true);
				_css(cloneEl, 'display', 'none');
				rootEl.insertBefore(cloneEl, dragEl);
			}

			if (useFallback) {

				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', this._onTouchMove);
					_on(document, 'touchend', this._onDrop);
					_on(document, 'touchcancel', this._onDrop);
				} else {
					// Old brwoser
					_on(document, 'mousemove', this._onTouchMove);
					_on(document, 'mouseup', this._onDrop);
				}

				this._loopId = setInterval(this._emulateDragOver, 50);
			}
			else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(this, dataTransfer, dragEl);
				}

				_on(document, 'drop', this);
				setTimeout(this._dragStarted, 0);
			}
		},

		_onDragOver: function (/**Event*/evt) {
			var el = this.el,
				target,
				dragRect,
				revert,
				options = this.options,
				group = options.group,
				groupPut = group.put,
				isOwner = (activeGroup === group),
				canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				!options.dragoverBubble && evt.stopPropagation();
			}

			moved = true;

			if (activeGroup && !options.disabled &&
				(isOwner
					? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
					: activeGroup.pull && groupPut && (
						(activeGroup.name === group.name) || // by Name
						(groupPut.indexOf && ~groupPut.indexOf(activeGroup.name)) // by Array
					)
				) &&
				(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
				// Smart auto-scrolling
				_autoScroll(evt, options, this.el);

				if (_silent) {
					return;
				}

				target = _closest(evt.target, options.draggable, el);
				dragRect = dragEl.getBoundingClientRect();

				if (revert) {
					_cloneHide(true);

					if (cloneEl || nextEl) {
						rootEl.insertBefore(dragEl, cloneEl || nextEl);
					}
					else if (!canSort) {
						rootEl.appendChild(dragEl);
					}

					return;
				}


				if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
					(el === evt.target) && (target = _ghostIsLast(el, evt))
				) {

					if (target) {
						if (target.animated) {
							return;
						}

						targetRect = target.getBoundingClientRect();
					}

					_cloneHide(isOwner);

					if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect) !== false) {
						if (!dragEl.contains(el)) {
							el.appendChild(dragEl);
							parentEl = el; // actualization
						}

						this._animate(dragRect, dragEl);
						target && this._animate(targetRect, target);
					}
				}
				else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
					if (lastEl !== target) {
						lastEl = target;
						lastCSS = _css(target);
						lastParentCSS = _css(target.parentNode);
					}


					var targetRect = target.getBoundingClientRect(),
						width = targetRect.right - targetRect.left,
						height = targetRect.bottom - targetRect.top,
						floating = /left|right|inline/.test(lastCSS.cssFloat + lastCSS.display)
							|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
						isWide = (target.offsetWidth > dragEl.offsetWidth),
						isLong = (target.offsetHeight > dragEl.offsetHeight),
						halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						nextSibling = target.nextElementSibling,
						moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect),
						after
					;

					if (moveVector !== false) {
						_silent = true;
						setTimeout(_unsilent, 30);

						_cloneHide(isOwner);

						if (moveVector === 1 || moveVector === -1) {
							after = (moveVector === 1);
						}
						else if (floating) {
							var elTop = dragEl.offsetTop,
								tgTop = target.offsetTop;

							if (elTop === tgTop) {
								after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
							} else {
								after = tgTop > elTop;
							}
						} else {
							after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
						}

						if (!dragEl.contains(el)) {
							if (after && !nextSibling) {
								el.appendChild(dragEl);
							} else {
								target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
							}
						}

						parentEl = dragEl.parentNode; // actualization

						this._animate(dragRect, dragEl);
						this._animate(targetRect, target);
					}
				}
			}
		},

		_animate: function (prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d('
					+ (prevRect.left - currentRect.left) + 'px,'
					+ (prevRect.top - currentRect.top) + 'px,0)'
				);

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function () {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
		},

		_onDrop: function (/**Event*/evt) {
			var el = this.el,
				options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			// Unbind events
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode.removeChild(ghostEl);

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl);

						if (newIndex >= 0) {
							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);

							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, rootEl, oldIndex, newIndex);
						}
					}
					else {
						// Remove clone
						cloneEl && cloneEl.parentNode.removeChild(cloneEl);

						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						if (newIndex === null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}

				// Nulling
				rootEl =
				dragEl =
				parentEl =
				ghostEl =
				nextEl =
				cloneEl =

				scrollEl =
				scrollParentEl =

				tapEvt =
				touchEvt =

				moved =
				newIndex =

				lastEl =
				lastCSS =

				activeGroup =
				Sortable.active = null;
			}
		},


		handleEvent: function (/**Event*/evt) {
			var type = evt.type;

			if (type === 'dragover' || type === 'dragenter') {
				if (dragEl) {
					this._onDragOver(evt);
					_globalDragOver(evt);
				}
			}
			else if (type === 'drop' || type === 'dragend') {
				this._onDrop(evt);
			}
		},


		/**
		 * Serializes the item into an array of string.
		 * @returns {String[]}
		 */
		toArray: function () {
			var order = [],
				el,
				children = this.el.children,
				i = 0,
				n = children.length,
				options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},


		/**
		 * Sorts the elements according to the array.
		 * @param  {String[]}  order  order of the items
		 */
		sort: function (order) {
			var items = {}, rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},


		/**
		 * Save the current sorting
		 */
		save: function () {
			var store = this.options.store;
			store && store.set(this);
		},


		/**
		 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
		 * @param   {HTMLElement}  el
		 * @param   {String}       [selector]  default: `options.draggable`
		 * @returns {HTMLElement|null}
		 */
		closest: function (el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},


		/**
		 * Set/get option
		 * @param   {string} name
		 * @param   {*}      [value]
		 * @returns {*}
		 */
		option: function (name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},


		/**
		 * Destroy
		 */
		destroy: function () {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};


	function _cloneHide(state) {
		if (cloneEl && (cloneEl.state !== state)) {
			_css(cloneEl, 'display', state ? 'none' : '');
			!state && cloneEl.state && rootEl.insertBefore(cloneEl, dragEl);
			cloneEl.state = state;
		}
	}


	function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
				re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			do {
				if (
					(tag === '>*' && el.parentNode === ctx) || (
						(tag === '' || el.nodeName.toUpperCase() == tag) &&
						(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
					)
				) {
					return el;
				}
			}
			while (el !== ctx && (el = el.parentNode));
		}

		return null;
	}


	function _globalDragOver(/**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}


	function _on(el, event, fn) {
		el.addEventListener(event, fn, false);
	}


	function _off(el, event, fn) {
		el.removeEventListener(event, fn, false);
	}


	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			}
			else {
				var className = (' ' + el.className + ' ').replace(RSPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(RSPACE, ' ');
			}
		}
	}


	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				}
				else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			}
			else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}


	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}



	function _dispatchEvent(sortable, rootEl, name, targetEl, fromEl, startIndex, newIndex) {
		var evt = document.createEvent('Event'),
			options = (sortable || rootEl[expando]).options,
			onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}


	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect) {
		var evt,
			sortable = fromEl[expando],
			onMoveFn = sortable.options.onMove,
			retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt);
		}

		return retVal;
	}


	function _disableDraggable(el) {
		el.draggable = false;
	}


	function _unsilent() {
		_silent = false;
	}


	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
				rect = lastEl.getBoundingClientRect();

		return ((evt.clientY - (rect.top + rect.height) > 5) || (evt.clientX - (rect.right + rect.width) > 5)) && lastEl; // min delta
	}


	/**
	 * Generate id
	 * @param   {HTMLElement} el
	 * @returns {String}
	 * @private
	 */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
			i = str.length,
			sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
	 * Returns the index of an element within its parent
	 * @param  {HTMLElement} el
	 * @return {number}
	 */
	function _index(el) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if (el.nodeName.toUpperCase() !== 'TEMPLATE') {
				index++;
			}
		}

		return index;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}


	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function (el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		index: _index
	};


	/**
	 * Create sortable instance
	 * @param {HTMLElement}  el
	 * @param {Object}      [options]
	 */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};


	// Export
	Sortable.version = '1.3.0';
	return Sortable;
});


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _GfiUtils = __webpack_require__(16);

var _GfiUtils2 = _interopRequireDefault(_GfiUtils);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _GetFeatureInfoDOM = __webpack_require__(34);

var _GetFeatureInfoDOM2 = _interopRequireDefault(_GetFeatureInfoDOM);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("getfeatureinfo");

/**
 * @classdesc
 * OpenLayers Control to manage getFeatureInfo capability. All queryable layers can be requested.
 * For the vector objects the information displayed are the objects properties. For the wms and wmts layers
 * this is the response of the getFeatureInfo request which is shown to the user.
 *
 * @constructor
 * @alias ol.control.GetFeatureInfo
 * @extends {ol.control.Control}
 * @param {Object} gfiOptions - control options
 * @param {Array.<Object>} [gfiOptions.layers] - list of layers which can be requested through the control. Each array element is an object, with following properties :
 * @param {ol.layer.Layer} gfiOptions.layers.obj - {@link http://openlayers.org/en/latest/apidoc/ol.layer.Layer.html ol.layer.Layer} layer handled by the control (that has been added to map).
 * @param {String} [gfiOptions.layers.event] - name of the mouse event triggering getFeatureInfo on this layer (that has been added to map). allowed values are : 'singleclick', 'dblclick' and 'contextmenu'. If not specified the triggering event is the current default event (see gfiOptions.options.defaultEvent).
 * @param {String} [gfiOptions.layers.infoFormat] - indicates the format mime-type of the response of GetFeatureInfo requests.
 * @param {Object} [gfiOptions.options] - custom options object to configure the control, with following properties :
 * @param {Boolean} [gfiOptions.options.hidden=false] - specifies if the widget should be hidden.
 * @param {Boolean} [gfiOptions.options.auto=false] - specifies if the control run in automatic mode. In automatic mode all vector layers added on run time or added at map initialization can be requested through the control. The triggering event of those layers is the default event.
 * @param {Boolean} [gfiOptions.options.active=true] - specifies if the control is active or inactive. In inactive mode requests are not fired and no information are displayed.
 * @param {String} [gfiOptions.options.defaultEvent='singleclick'] - default triggering event chosen in the list ('singleclick', 'dblclick', 'contextmenu'). This is the triggering event of all layers added to the control without configured triggering event.
 * @param {String} [gfiOptions.options.defaultInfoFormat='text/html'] - indicates the default format mime-type of the response of GetFeatureInfo requests.
 * @param {String} [gfiOptions.options.cursorStyle='pointer'] - specifies the type of cursor to be displayed when pointing on vector feature of a layer previously added to the control. The value must be choosen in the possible values of the css cursor property.
 * @param {String} [gfiOptions.options.proxyUrl] - Proxy URL to avoid cross-domain problems.
 * @param {Array.<String>} [gfiOptions.options.noProxyDomains] - Proxy will not be used for this list of domain names. Only use if you know what you're doing.
 * @param {Boolean} [gfiOptions.options.autoPan = true] - Specifies whether the map should auto-pan if the pop-up is rendered outside of the canvas. Defaults to true.
 * @param {olx.OverlayPanOptions} [gfiOptions.options.autoPanAnimation] - Used to customize the auto-pan animation. See {@link https://openlayers.org/en/latest/apidoc/olx.html#.OverlayPanOptions olx.OverlayPanOptions}.
 * @param {Number} [gfiOptions.options.autoPanMargin] - Margin (in pixels) between the pop-up and the border of the map when autopanning. Default is 20.
 */
function GetFeatureInfo(gfiOptions) {
    gfiOptions = gfiOptions || {};
    var options = gfiOptions.options || {};
    var layers = gfiOptions.layers || [];

    if (!(this instanceof GetFeatureInfo)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    if (layers && !Array.isArray(layers)) {
        throw new Error("ERROR WRONG_TYPE : layers should be an array");
    }

    if (options && (typeof options === "undefined" ? "undefined" : _typeof(options)) !== "object") {
        throw new Error("ERROR WRONG_TYPE : options should be an object");
    }

    this._initialize(options, layers);

    // init control DOM container
    var container = this._initContainer(options);

    // call ol.control.Control constructor
    _ol2.default.control.Control.call(this, {
        element: container,
        target: options.target,
        render: options.render
    });
};

// Inherits from ol.control.Control
_ol2.default.inherits(GetFeatureInfo, _ol2.default.control.Control);

/**
 * @lends module:GetFeatureInfo
 */
GetFeatureInfo.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les méthodes de la classe commune GetFeatureInfoDOM
_Utils2.default.assign(GetFeatureInfo.prototype, _GetFeatureInfoDOM2.default);

/**
 * Constructor (alias)
 *
 * @private
 */
GetFeatureInfo.prototype.constructor = GetFeatureInfo;

// ################################################################### //
// ######################## initialize control ####################### //
// ################################################################### //

/**
 * Initializes GetFeatureInfo control (called by constructor)
 *
 * @param {Object} options - General options of the control set by user.
 * @param {Array.<Object>} layers - Array of ol layers with their configuration options (obj, event, infoFormat)
 * @private
 */
GetFeatureInfo.prototype._initialize = function (options, layers) {
    // identifiant du contrôle : utile pour suffixer les identifiants CSS (pour gérer le cas où il y en a plusieurs dans la même page)
    this._uid = _SelectorID2.default.generate();

    // List of triggering events associated to a boolean indicating if the event is listened (there must be
    // almost one layer having this triggering event configured)
    this._events = {
        dblclick: false,
        singleclick: false,
        contextmenu: false
    };

    // Object associating a event (key) to his handler (value) in order to unlisten events which have
    // no more layers related to.
    this._eventsHandler = {};

    if (typeof options.auto !== "undefined" && typeof options.auto !== "boolean") {
        logger.log("[ERROR] GetFeatureInfo:_initialize - auto parameter should be a boolean");
        return;
    }
    this._auto = options.auto || false;

    if (typeof options.active !== "undefined" && typeof options.active !== "boolean") {
        logger.log("[ERROR] GetFeatureInfo:_initialize - active parameter should be a boolean");
        return;
    }
    this._active = typeof options.active === "undefined" ? true : options.active;

    if (options.defaultEvent && typeof options.defaultEvent !== "string") {
        logger.log("[ERROR] GetFeatureInfo:_initialize - defaultEvent parameter should be a string");
        return;
    }
    this._defaultEvent = options.defaultEvent || "singleclick";
    if (!this._isValidEvent(this._defaultEvent)) {
        logger.log("[ERROR] GetFeatureInfo:_initialize - _defaultEvent '" + this._defaultEvent + "' is not a valid event");
        return;
    }

    if (options.defaultInfoFormat && typeof options.defaultInfoFormat !== "string") {
        logger.log("[ERROR] GetFeatureInfo:_initialize - defaultInfoFormat parameter should be a string");
        return;
    }
    this._defaultInfoFormat = options.defaultInfoFormat || "text/html";

    if (options.cursorStyle && typeof options.cursorStyle !== "string") {
        logger.log("[ERROR] GetFeatureInfo:_initialize - cursorStyle parameter should be a string");
        return;
    }
    this._cursorStyle = options.cursorStyle || "pointer";

    if (options.proxyUrl) {
        if (typeof options.proxyUrl !== "string") {
            logger.log("[ERROR] GetFeatureInfo:_initialize - proxyUrl parameter should be a string");
            return;
        }
        this._proxyUrl = options.proxyUrl;
    }

    if (options.noProxyDomains) {
        if (!Array.isArray(options.noProxyDomains)) {
            logger.log("[ERROR] GetFeatureInfo:_initialize - noProxyDomains parameter should be a array");
            return;
        }
        this._noProxyDomains = options.noProxyDomains;
    }

    if (typeof options.autoPan !== "undefined" && typeof options.autoPan !== "boolean") {
        logger.log("[ERROR] GetFeatureInfo:_initialize - autoPan parameter should be a boolean");
        return;
    }
    this._autoPan = typeof options.autoPan === "undefined" ? true : options.autoPan;

    if (options.autoPanAnimation) {
        if (options.autoPanAnimation.duration) {
            if (typeof options.autoPanAnimation.duration !== "number") {
                logger.log("[ERROR] GetFeatureInfo:_initialize - autoPanAnimation parameter is invalid : duration should be a number.");
                return;
            }
        }

        if (options.autoPanAnimation.easing) {
            if (typeof options.autoPanAnimation.easing !== "function") {
                logger.log("[ERROR] GetFeatureInfo:_initialize - autoPanAnimation parameter is invalid : easing should be a ol.easing function or a custom function.");
                return;
            }
        }
        this._autoPanAnimation = options.autoPanAnimation;
    }

    if (options.autoPanMargin) {
        if (typeof options.autoPanMargin !== "number") {
            logger.log("[ERROR] GetFeatureInfo:_initialize - autoPanMargin parameter should be a number");
            return;
        }
        this._autoPanMargin = options.autoPanMargin;
    }

    // {Object} control layers list.
    if (!Array.isArray(layers)) {
        logger.log("[ERROR] GetFeatureInfo:_initialize - layers parameter should be an array");
        return;
    }
    this._setLayers(layers);

    // {Object} control panel container (DOM Element)
    this._activateGetFeatureInfoContainer = null;
};

/**
 * Binds map to control.
 *
 * @param {ol.Map} map - Map.
 */
GetFeatureInfo.prototype.setMap = function (map) {
    if (map) {
        // on active les evenements (si des couches sont configurees)
        this._updateEvents(map);

        if (this._cursorStyle && this._active) {
            this._activateCursor(true, map);
        }

        map.getLayers().on("remove", function (evt) {
            for (var i = 0; i < this._layers.length; ++i) {
                if (this._layers[i].obj === evt.element) {
                    this._layers.splice(i, 1);
                    break;
                }
            }
            this._updateEvents(map);
        }, this);

        if (this._auto) {
            // ajout des couches vecteur deja dans la carte
            var updated = false;
            map.getLayers().forEach(function (olLayer) {
                var layerFormat = _GfiUtils2.default.getLayerFormat(olLayer);
                if (!this._hasLayer(olLayer) && layerFormat === "vector") {
                    this._layers.push({
                        obj: olLayer
                    });
                    updated = true;
                }
            }, this);

            if (updated) {
                this._updateEvents(map);
            }

            map.getLayers().on("add", function (evt) {
                var layerFormat = _GfiUtils2.default.getLayerFormat(evt.element);
                if (layerFormat === "vector") {
                    this._layers.push({
                        obj: evt.element
                    });
                }
                this._updateEvents(map);
            }, this);
        }
    } else {
        this._clearEvents();
        this._activateCursor(false);
    }

    // call original setMap method
    _ol2.default.control.Control.prototype.setMap.call(this, map);
};

// ################################################################### //
// #################### user interface methods ####################### //
// ################################################################### //

/**
 * Gets the list of layers already added to the map and attached to the control.
 *
 * @returns {Array.<Object>} gfiLayers List of layers.
 * @returns {ol.layer.Layer} gfiLayers.obj {@link http://openlayers.org/en/latest/apidoc/ol.layer.Layer.html ol.layer.Layer} layer handled by the control (that has been added to map).
 * @returns {String} gfiLayers.event Optional. Name of the mouse event triggering getFeatureInfo on this layer (that has been added to map). allowed values are : 'singleclick', 'dblclick' and 'contextmenu'.
 * @returns {String} gfiLayers.infoFormat Optional. Indicates the format mime-type of the response of GetFeatureInfo requests.
 */
GetFeatureInfo.prototype.getLayers = function () {
    return this._layers;
};

/**
 * Sets the default event applied to layer with no triggering event configured.
 * This can be set on run time.
 *
 * @param {String} eventName - name of the mouse event chosen in the list : 'singleclick', 'dblclick', 'contextmenu'.
 */
GetFeatureInfo.prototype.setDefaultEvent = function (eventName) {
    if (typeof eventName !== "string") {
        logger.log("[ERROR] GetFeatureInfo:setDefaultEvent - eventName parameter should be a string");
        return;
    }
    if (!eventName || !this._isValidEvent(eventName)) {
        logger.log("[ERROR] GetFeatureInfo:setDefaultEvent - event '" + eventName + "' is not allowed.");
        return;
    }

    this._defaultEvent = eventName;
    this._updateEvents();
};

/**
 * Sets the cursor style when hovering vector layers features.
 *
 * @param {String} cursorStyle - cursor style. The value must be choosen in the possible values of the css cursor property.
 */
GetFeatureInfo.prototype.setCursorStyle = function (cursorStyle) {
    if (typeof cursorStyle !== "string") {
        logger.log("[ERROR] GetFeatureInfo:setCursorStyle - cursorStyle parameter should be a string");
        return;
    }
    if (this._active) {
        if (!this._cursorStyle && cursorStyle) {
            this._activateCursor(true);
        } else if (this._cursorStyle && !cursorStyle) {
            this._activateCursor(false);
        }
    }
    this._cursorStyle = cursorStyle;
};

/**
 * Sets active control property
 *
 * @param {Boolean} active - specify the value the active property must be set to.
 */
GetFeatureInfo.prototype.setActive = function (active) {
    this._setActive(active);
    var element = document.getElementById(this._addUID("GPactivateGetFeatureInfo"));
    if (element) {
        element.checked = active;
    }
};

/**
 * Sets active control property
 *
 * @param {Boolean} active - specify the value the active property must be set to.
 *
 * @private
 */
GetFeatureInfo.prototype._setActive = function (active) {
    if (typeof active !== "boolean") {
        logger.log("[ERROR] GetFeatureInfo:_setActive - active parameter should be a boolean");
        return;
    }
    if (this._active === active) {
        return;
    }
    this._active = active;
    if (this._cursorStyle) {
        this._activateCursor(active);
    }
};

/**
 * Gets active control property
 *
 * @return {Boolean} active
 */
GetFeatureInfo.prototype.isActive = function () {
    return this._active;
};

/**
 * Hides/displays widget
 *
 * @param {Boolean} hidden - specify if the widget must be hidden
 */
GetFeatureInfo.prototype.setHidden = function (hidden) {
    this.element.style.visibility = hidden ? "hidden" : "";
};

/**
 * Indicates if the widget is hidden
 *
 * @return {Boolean} is hidden
 */
GetFeatureInfo.prototype.isHidden = function () {
    return this.element.style.visibility === "hidden";
};

/**
 * Set the layers list the control is attached to. Listened events are updated according to this list.
 *
 * @param {Array.<Object>} gfiLayers - list of layers which can be requested through the control.
 * @param {ol.layer.Layer} gfiLayers.obj - {@link http://openlayers.org/en/latest/apidoc/ol.layer.Layer.html ol.layer.Layer} layer handled by the control (that has been added to map).
 * @param {String} [gfiLayers.event] - Name of the mouse event triggering getFeatureInfo on this layer (that has been added to map). allowed values are : 'singleclick', 'dblclick' and 'contextmenu'.
 * @param {String} [gfiLayers.infoFormat] - Indicates the format mime-type of the response of GetFeatureInfo requests.
 */
GetFeatureInfo.prototype.setLayers = function (gfiLayers) {
    this._setLayers(gfiLayers);
    this._updateEvents();
};

/**
 * Indicates if an event is allowed
 *
 * @param {String} eventName - name of the mouse event chosen in the list : 'singleclick', 'dblclick', 'contextmenu'.
 *
 * @returns {Boolean} is valid event
 *
 * @private
 */
GetFeatureInfo.prototype._isValidEvent = function (eventName) {
    return Object.keys(this._events).indexOf(eventName) > -1;
};

/**
 * Adds an event listener to the specified event.
 *
 * @param {String} eventName - name of the mouse event chosen in the list : 'singleclick', 'dblclick', 'contextmenu'.
 * @param {Object} map - map on wich event are attached.
 *
 * @private
 */
GetFeatureInfo.prototype._activateEvent = function (eventName, map) {
    var gfiObj = this;

    var getFeatureInfoHandler = function getFeatureInfoHandler(e) {
        _GfiUtils2.default.onDisplayFeatureInfo(e, gfiObj);
    };

    if (eventName === "contextmenu") {
        map.getViewport().addEventListener(eventName, getFeatureInfoHandler);
    } else {
        map.on(eventName, getFeatureInfoHandler);
    }

    this._eventsHandler[eventName] = getFeatureInfoHandler;

    this._events[eventName] = true;
};

/**
 * Unlistens the specified event.
 * @param {String} eventName - name of the mouse event chosen in the list : 'singleclick', 'dblclick', 'contextmenu'.
 * @param {Object} map - map on wich event are attached.
 *
 * @private
 */
GetFeatureInfo.prototype._deactivateEvent = function (eventName, map) {
    if (eventName === "contextmenu") {
        map.getViewport().removeEventListener(eventName, this._eventsHandler[eventName]);
    } else {
        map.un(eventName, this._eventsHandler[eventName]);
    }

    delete this._eventsHandler[eventName];

    this._events[eventName] = false;
};

/**
 * Updates the listener (listen/unlisten) in accordance with the layers attached to the control and their triggering events.
 *
 * @param {Object} map - map on wich event are attached.
 *
 * @private
 */
GetFeatureInfo.prototype._updateEvents = function (map) {
    if (!map) {
        map = this.getMap();
    }
    var sEvent = [];
    for (var i = 0; i < this._layers.length; ++i) {
        var event = this._layers[i].event ? this._layers[i].event : this._defaultEvent;
        if (sEvent.indexOf(event) < 0) {
            sEvent.push(event);
        }
    }

    for (var eventName in this._events) {
        if (!this._events[eventName] && sEvent.indexOf(eventName) >= 0) {
            this._activateEvent(eventName, map);
        } else if (this._events[eventName] && sEvent.indexOf(eventName) < 0) {
            this._deactivateEvent(eventName, map);
        }
    }
};

/**
 * Clears all the listeners.
 *
 * @private
 */
GetFeatureInfo.prototype._clearEvents = function () {
    var map = this.getMap();
    for (var eventName in this._events) {
        if (this._events[eventName]) {
            this._deactivateEvent(eventName, map);
        }
    }
};

/**
 * Indicates if the control has the specified layer attached
 *
 * @param {ol.layer.Layer} olLayer - layer openlayers
 *
 * @returns {Boolean} has layer
 *
 * @private
 */
GetFeatureInfo.prototype._hasLayer = function (olLayer) {
    for (var i = 0; i < this._layers.length; ++i) {
        if (this._layers[i].obj === olLayer) {
            return true;
        }
    }
    return false;
};

/**
 * Listens/unlistens 'pointermove' event displaying specific cursor style when hovering vector features
 *
 * @param {Boolean} activate - specify if the control must be activated or deactivated
 * @param {Object} map - map on wich cursor is attached.
 *
 * @private
 */
GetFeatureInfo.prototype._activateCursor = function (activate, map) {
    if (!map) {
        map = this.getMap();
    }

    if (activate) {
        if (this._eventsHandler.hasOwnProperty("pointermove")) {
            logger.log("[ERROR] _activateCursor - inconsistent state: pointermove event handler already registered");
            return;
        }
        var gfiObj = this;

        var displayCursor = function displayCursor(evt) {
            var hit = map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
                // on ne prend en compte que les couches vecteurs connues du controle
                var gfiLayers = gfiObj.getLayers();
                for (var m = 0; m < gfiLayers.length; ++m) {
                    if (gfiLayers[m].obj === layer) {
                        return true;
                    }
                }
            });
            if (hit) {
                map.getTargetElement().style.cursor = gfiObj._cursorStyle;
            } else {
                map.getTargetElement().style.cursor = "";
            }
        };

        this._eventsHandler["pointermove"] = displayCursor;
        map.on("pointermove", displayCursor);
    } else {
        map.un("pointermove", this._eventsHandler["pointermove"]);
        delete this._eventsHandler["pointermove"];
        map.getTargetElement().style.cursor = "";
    }
};

/**
 * Sets the layers list the control is attached to.
 * @param {Array.<Object>} gfiLayers - list of layers which can be requested through the control.
 *
 * @private
 */
GetFeatureInfo.prototype._setLayers = function (gfiLayers) {
    if (!gfiLayers || !Array.isArray(gfiLayers)) {
        logger.log("[ERROR] GetFeatureInfo:setLayers - gfiLayers parameter should be a array");
        return;
    }
    this._layers = [];

    for (var i = 0; i < gfiLayers.length; ++i) {
        var ind = this._layers.push({}) - 1;

        if (gfiLayers[i].event) {
            if (!this._isValidEvent(gfiLayers[i].event)) {
                logger.log("[ERROR] GetFeatureInfo:setLayers - layer event '" + this._layers[i].event + "' is not allowed.");
            } else {
                this._layers[ind].event = gfiLayers[i].event;
            }
        }

        if (gfiLayers[i].infoFormat) {
            this._layers[ind].infoFormat = gfiLayers[i].infoFormat;
        }

        this._layers[ind].obj = gfiLayers[i].obj;
    }
};

// ################################################################### //
// ######################## methods handle dom ####################### //
// ################################################################### //

/**
 * This method is called by event 'change' on 'GPactivateGetFeatureInfo'
 * tag select (cf. this._createActivateGetFeatureInfoElement).
 *
 * @method onActivateGetFeatureInfoElementChange
 * @param {Object} e - HTMLElement
 *
 * @private
 */
GetFeatureInfo.prototype.onActivateGetFeatureInfoElementChange = function (e) {
    this._setActive(e.target.checked);
};

/**
 * Creates control main container (called by GetFeatureInfo constructor)
 * @param {Object} [options] - options object to configure the widget :
 * @param {Boolean} [options.hidden] - specifies if the widget should be hidden.
 *
 * @return {DOMElement} DOM element
 *
 * @method _initContainer
 *
 * @private
 */
GetFeatureInfo.prototype._initContainer = function (options) {
    // creation du container principal
    var container = this._createMainContainerElement();

    var inputActivate = this._activateGetFeatureInfoContainer = this._createActivateGetFeatureInfoElement(this.isActive());
    container.appendChild(inputActivate);

    // ajout dans le container principal du picto du controle
    var picto = this._createMainPictoElement();
    container.appendChild(picto);

    if (typeof options.hidden !== "undefined") {
        if (typeof options.hidden !== "boolean") {
            logger.log("[ERROR] GetFeatureInfo:_initContainer - hidden parameter should be a boolean");
            return;
        }
        if (options.hidden) {
            container.style.visibility = "hidden";
        }
    }

    return container;
};

exports.default = GetFeatureInfo;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GetFeatureInfoDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPgetFeatureInfo");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################# Methods to display Main Panel ################### //
    // ################################################################### //

    /**
     * Hidden checkbox for activating getFeatureInfo
     * @param {Boolean} activate - specify if the control is active or inactive
     *
     * @returns {DOMElement} DOM element
     */
    _createActivateGetFeatureInfoElement: function _createActivateGetFeatureInfoElement(activate) {
        // contexte d'execution
        var context = this;

        var input = document.createElement("input");
        input.id = this._addUID("GPactivateGetFeatureInfo");
        input.type = "checkbox";
        input.checked = activate;

        input.addEventListener("change", function (e) {
            context.onActivateGetFeatureInfoElementChange(e);
        });

        return input;
    },

    /**
     * Creation du container du picto du controle (DOM)
     * @returns {DOMElement} DOM element
     */
    _createMainPictoElement: function _createMainPictoElement() {
        var self = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPgetFeatureInfoPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPactivateGetFeatureInfo");
        label.title = "activer/desactiver l'interrogation des couches";

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPgetFeatureInfoActivate");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        var spanClose = document.createElement("span");
        spanClose.id = self._addUID("GPgetFeatureInfoDeactivate");
        label.appendChild(spanClose);

        return label;
    }
};

exports.default = GetFeatureInfoDOM;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _Markers = __webpack_require__(5);

var _Markers2 = _interopRequireDefault(_Markers);

var _CheckRightManagement = __webpack_require__(7);

var _CheckRightManagement2 = _interopRequireDefault(_CheckRightManagement);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _SearchEngineUtils = __webpack_require__(36);

var _SearchEngineUtils2 = _interopRequireDefault(_SearchEngineUtils);

var _SearchEngineDOM = __webpack_require__(37);

var _SearchEngineDOM2 = _interopRequireDefault(_SearchEngineDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("searchengine");

/**
 * @classdesc
 * SearchEngine control
 *
 * @constructor
 * @extends {ol.control.Control}
 * @alias ol.control.SearchEngine
 * @param {Object}  options - control options
 * @param {String}   [options.apiKey] - API key, mandatory if autoconf service has not been charged in advance
 * @param {Boolean} [options.collapsed = true] - collapse mode, true by default
 * @param {Object}   [options.resources] - resources to be used by geocode and autocompletion services :
 * @param {Array}   [options.resources.geocode] - resources geocoding, by default : ["PositionOfInterest", "StreetAddress"]
 * @param {Array}   [options.resources.autocomplete] - resources autocompletion, by default : ["PositionOfInterest", "StreetAddress"]
 * @param {Boolean}  [options.displayAdvancedSearch = true] - False to disable advanced search tools (it will not be displayed). Default is true (displayed)
 * @param {Object}  [options.advancedSearch] - advanced search options for geocoding (filters). Properties can be found among geocode options.filterOptions (see {@link http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~geocode Gp.Services.geocode})
 * @param {Object}  [options.geocodeOptions = {}] - options of geocode service (see {@link http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~geocode Gp.Services.geocode})
 * @param {Object}  [options.autocompleteOptions = {}] - options of autocomplete service (see {@link http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~autoComplete Gp.Services.autoComplete}
 * @param {Object}  [options.autocompleteOptions.serviceOptions] - options of autocomplete service
 * @param {Boolean} [options.autocompleteOptions.triggerGeocode = false] - trigger a geocoding request if the autocompletion does not return any suggestions, false by default
 * @param {Number}  [options.autocompleteOptions.triggerDelay = 1000] - waiting time before sending the geocoding request, 1000ms by default
 * @param {Sting|Numeric|Function} [options.zoomTo] - zoom to results, by default, current zoom.
 *       Value possible : auto or zoom level.
 *       Possible to overload it with a function :
 *       zoomTo : function (info) {
 *           // do some stuff...
 *           return zoom;
 *       }
 * @param {String}  [options.placeholder] - Placeholder in search bar. Default is "Rechercher un lieu, une adresse".
 * @param {Boolean}  [options.displayMarker = true] - set a marker on search result, defaults to true.
 * @param {String}  [options.markerStyle = "lightOrange"] - Marker style. Currently possible values are "lightOrange" (default value), "darkOrange", "red" and "turquoiseBlue".
 * @example
 *  var SearchEngine = ol.control.SearchEngine({
 *      apiKey : "CLEAPI",
 *      collapsed : true,
 *      resources : {
 *          geocode : ["StreetAddress", "PositionOfInterest"],
 *          autocomplete : ["StreetAddress"]
 *      },
 *      advancedSearch : {
 *          PositionOfInterest : [{name : "municipality", title : "Ville"}],
 *          StreetAddress : [{...}]
 *      },
 *      geocodeOptions : {},
 *      autocompleteOptions : {}
 *  });
 */
function SearchEngine(options) {
    options = options || {};

    if (!(this instanceof SearchEngine)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // initialisation du composant
    this.initialize(options);

    // // Widget main DOM container
    this._container = this._initContainer();
    // info: le container sera complété lors de l'ajout à la carte (setMap), car certains composants nécessitent d'être liés à la map.
    this._containerElement = null;

    // on peut éventuellement encapsuler le composant dans une div passée par l'utilisateur
    if (options.element && options.element.appendChild) {
        // dans ce cas on stocke les deux container
        options.element.appendChild(this._container);
        this._containerElement = options.element;
    }

    // call ol.control.Control constructor
    _ol2.default.control.Control.call(this, {
        element: this._containerElement || this._container,
        target: options.target,
        render: options.render
    });
};

// Inherits from ol.control.Control
_ol2.default.inherits(SearchEngine, _ol2.default.control.Control);

/*
 * @lends module:SearchEngine
 */
SearchEngine.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les méthodes de la classe commune IsoDOM
_Utils2.default.assign(SearchEngine.prototype, _SearchEngineDOM2.default);

/**
 * Constructor (alias)
 *
 * @private
 */
SearchEngine.prototype.constructor = SearchEngine;

// ################################################################### //
// ##################### public methods ############################## //
// ################################################################### //

/**
 * Overwrite OpenLayers setMap method
 *
 * @param {ol.Map} map - Map.
 */
SearchEngine.prototype.setMap = function (map) {
    if (!map) {
        this._clearResults();
    }

    // on appelle la méthode setMap originale d'OpenLayers
    _ol2.default.control.Control.prototype.setMap.call(this, map);
};

/**
 * Returns true if widget is collapsed (minimized), false otherwise
 *
 * @returns {Boolean} collapsed - true if widget is collapsed
 */
SearchEngine.prototype.getCollapsed = function () {
    return this.collapsed;
};

/**
 * Collapse or display widget main container
 *
 * @param {Boolean} collapsed - True to collapse widget, False to display it
 */
SearchEngine.prototype.setCollapsed = function (collapsed) {
    if (collapsed === undefined) {
        logger.log("[ERROR] SearchEngine:setCollapsed - missing collapsed parameter");
        return;
    }
    if (collapsed && this.collapsed || !collapsed && !this.collapsed) {
        return;
    }
    if (collapsed) {
        this._showSearchEngineInput.click();
    } else {
        this._showSearchEngineInput.click();
    }
    this.collapsed = collapsed;
};

// ################################################################### //
// ##################### init component ############################## //
// ################################################################### //

/**
 * Initialize SearchEngine control (called by SearchEngine constructor)
 *
 * @param {Object} options - constructor options
 * @private
 */
SearchEngine.prototype.initialize = function (options) {
    this._checkInputOptions(options);

    // define default options
    this.options = {
        collapsed: true,
        zoomTo: "",
        resources: {
            geocode: [],
            autocomplete: []
        },
        displayAdvancedSearch: true,
        advancedSearch: {},
        geocodeOptions: {},
        autocompleteOptions: {
            serviceOptions: {},
            triggerGeocode: false,
            triggerDelay: 1000
        },
        displayMarker: true,
        markerStyle: "lightOrange",
        placeholder: "Rechercher un lieu, une adresse"
    };

    // merge with user options
    _Utils2.default.mergeParams(this.options, options);
    if (this.options.resources.geocode.length === 0) {
        this.options.resources.geocode = ["PositionOfInterest", "StreetAddress"];
    }
    if (this.options.resources.autocomplete.length === 0) {
        this.options.resources.autocomplete = ["PositionOfInterest", "StreetAddress"];
    }

    /** {Boolean} specify if searchEngine control is collapsed (true) or not (false) */
    this.collapsed = this.options.collapsed;

    // identifiant du contrôle : utile pour suffixer les identifiants CSS (pour gérer le cas où il y en a plusieurs dans la même page)
    this._uid = _SelectorID2.default.generate();

    this._showSearchEngineInput = null;

    // container de l'input de recherche
    this._inputSearchContainer = null;

    // container des reponses de l'autocompletion
    this._autocompleteContainer = null;
    this._suggestedContainer = null;

    // listes des reponses de l'autocompletion
    this._suggestedLocations = [];

    // container des reponses du geocodage
    this._geocodedContainer = null;

    // liste des reponses du geocodage
    this._geocodedLocations = [];

    // container des filtres du geocodage
    this._filterContainer = null;

    // ressource de geocodage selectionnée pour le geocodage avancé
    this._currentGeocodingCode = null;

    // localisant */
    this._currentGeocodingLocation = null;

    // liste des filtres du geocodage pour le geocodage avancé
    this._advancedSearchFilters = {};
    this._initAdvancedSearchFilters();

    // liste des ressources du geocodage pour le geocodage avancé
    this._advancedSearchCodes = [];
    this._initAdvancedSearchCodes();

    // marker
    this._marker = null;

    // marker style
    var _markerStyle = this.options.markerStyle;
    this._markerUrl = Object.keys(_Markers2.default).indexOf(_markerStyle) === -1 ? _Markers2.default["lightOrange"] : _Markers2.default[_markerStyle];

    // marker display
    this._displayMarker = this.options.displayMarker;

    // popup
    this._popupContent = null;
    this._popupDiv = this._initPopupDiv();
    this._popupOverlay = null;

    // ressources des services d'autocompletion et de geocodage
    this._servicesRightManagement = {};

    /*
     * Droit sur les ressources sur les services.
     * Par defaut, on n'en s'occupe pas
     * sauf si l'autoconfiguration est chargée !
     */
    this._noRightManagement = false;

    // gestion des droits sur les ressources/services
    this._checkRightsManagement();

    // trigger geocode
    this._triggerHandler = null;
};

/**
 * this method is called by this.initialize()
 * and makes sure input options are correctly formated
 *
 * @param {Object} options - options
 *
 * @private
 */
SearchEngine.prototype._checkInputOptions = function (options) {
    var i;

    if (options.resources) {
        // on vérifie que resources est bien un objet
        if (_typeof(options.resources) === "object") {
            // ressources de geocodage
            var geocodeResources = options.resources.geocode;
            if (geocodeResources) {
                // on vérifie que la liste des ressources de geocodage est bien un tableau
                if (!Array.isArray(geocodeResources)) {
                    logger.log("[SearchEngine] 'options.resources.geocode' parameter should be an array");
                    geocodeResources = null;
                }
                var geocodeResourcesList = ["StreetAddress", "PositionOfInterest", "CadastralParcel", "Administratif"];
                for (i = 0; i < geocodeResources.length; i++) {
                    if (geocodeResourcesList.indexOf(geocodeResources[i]) === -1) {
                        // si la resource n'est pas référencée, on l'enlève
                        // geocodeResources.splice(i, 1);
                        logger.log("[SearchEngine] options.resources.geocode : " + geocodeResources[i] + " is not a resource for geocode");
                    }
                }
            }

            // ressources d'autocompletion
            var autocompleteResources = options.resources.autocomplete;
            if (autocompleteResources) {
                // on vérifie que la liste des ressources d'autocompletion est bien un tableau
                if (!Array.isArray(autocompleteResources)) {
                    logger.log("[SearchEngine] 'options.resources.autocomplete' parameter should be an array");
                    autocompleteResources = null;
                }
                var autocompleteResourcesList = ["StreetAddress", "PositionOfInterest"];
                for (i = 0; i < autocompleteResources.length; i++) {
                    if (autocompleteResourcesList.indexOf(autocompleteResources[i]) === -1) {
                        // si la resource n'est pas référencée, on l'enlève
                        // autocompleteResources.splice(i, 1);
                        logger.log("[SearchEngine] options.resources.autocomplete : " + autocompleteResources[i] + " is not a resource for autocomplete");
                    }
                }
            }
        } else {
            logger.log("[SearchEngine] 'resources' parameter should be an object");
            options.resources = null;
        }
    }
};

/**
 * this method is called by this.initialize()
 * and initialize the geocoding resources titles.
 *
 * @private
 */
SearchEngine.prototype._initAdvancedSearchCodes = function () {
    // INFORMATION
    // on y ajoute les filtres attributaires pour une table de ressources
    // selectionnée via un evenement (onchange) de la liste deroulante du
    // menu avancé du geocodage.
    // cf. onGeocodingAdvancedSearchCodeChange() pour la selection de la
    // ressource de geocodage à afficher

    var geocodeResources = this.options.resources.geocode;
    for (var i = 0; i < geocodeResources.length; i++) {
        switch (geocodeResources[i]) {
            case "PositionOfInterest":
                this._advancedSearchCodes.push({
                    id: "PositionOfInterest",
                    title: "Lieux/toponymes"
                });
                break;
            case "StreetAddress":
                this._advancedSearchCodes.push({
                    id: "StreetAddress",
                    title: "Adresses"
                });
                break;
            case "CadastralParcel":
                this._advancedSearchCodes.push({
                    id: "CadastralParcel",
                    title: "Parcelles cadastrales"
                });
                break;
            case "Administratif":
                this._advancedSearchCodes.push({
                    id: "Administratif",
                    title: "Administratif"
                });
                break;
            default:
                break;
        }
    }
    // par défaut, au cas où aucune ressource passée en option ne correspond à celles attendues
    if (this._advancedSearchCodes.length === 0) {
        this._advancedSearchCodes = [{
            id: "StreetAddress",
            title: "Adresses"
        }, {
            id: "PositionOfInterest",
            title: "Lieux/toponymes"
        }];
    }

    logger.log("advancedSearchCodes", this._advancedSearchCodes);
};

/**
 * this method is called by this.onAdd()
 * and initialize the advanced geocoding filters.
 *
 * @private
 */
SearchEngine.prototype._initAdvancedSearchFilters = function () {
    // liste des filtres par defauts pour toutes les ressources
    this._advancedSearchFilters = _SearchEngineUtils2.default.advancedSearchFiltersByDefault;

    // on merge les options avancées avec celles par defaut
    var advancedSearchFiltersCustom = this.options.advancedSearch;
    _Utils2.default.assign(this._advancedSearchFilters, advancedSearchFiltersCustom);

    logger.log("advancedSearchFilters", this._advancedSearchFilters);
};

/**
 * this method is called by this.initialize() and initialize popup div
 * (to display results information on marker click)
 *
 * @return {Object} element - DOM element for popup
 * @private
 */
SearchEngine.prototype._initPopupDiv = function () {
    var context = this;
    var element = document.createElement("div");
    element.className = "gp-feature-info-div";
    var closer = document.createElement("input");
    closer.type = "button";
    closer.className = "gp-styling-button closer";
    // on closer click : remove popup
    closer.onclick = function () {
        if (context._popupOverlay != null) {
            context._popupOverlay.setPosition(undefined);
        }
        return false;
    };
    this._popupContent = document.createElement("div");
    this._popupContent.className = "gp-features-content-div";
    this._popupContent.style["min-width"] = "200px";
    element.appendChild(this._popupContent);
    element.appendChild(closer);

    return element;
};

// ################################################################### //
// ######################## DOM initialize ########################### //
// ################################################################### //

/**
 * Create control main container
 *
 * @returns {DOMElement} DOM element
 *
 * @private
 */
SearchEngine.prototype._initContainer = function () {
    // create main container
    var container = this._createMainContainerElement();

    // create show search engine element
    var inputShow = this._showSearchEngineInput = this._createShowSearchEngineElement();
    container.appendChild(inputShow);

    // mode "collapsed"
    if (!this.options.collapsed) {
        inputShow.checked = true;
    }

    // create search engine picto
    var picto = this._createShowSearchEnginePictoElement();
    container.appendChild(picto);

    var search = this._inputSearchContainer = this._createSearchInputElement(this.options.placeholder);
    var context = this;
    if (search.addEventListener) {
        search.addEventListener("click", function () {
            context.onAutoCompleteInputClick();
        });
    } else if (search.attachEvent) {
        search.attachEvent("onclick", function () {
            context.onAutoCompleteInputClick();
        });
    }
    container.appendChild(search);

    if (this.options.displayAdvancedSearch) {
        var advancedShow = this._createShowAdvancedSearchElement();
        container.appendChild(advancedShow);

        // INFO je decompose les appels car j'ai besoin de recuperer le container
        // des filtres
        var advancedPanel = this._createAdvancedSearchPanelElement();
        var advancedHeader = this._createAdvancedSearchPanelHeaderElement();
        var advancedForm = this._createAdvancedSearchPanelFormElement(this._advancedSearchCodes);
        var advancedFormFilters = this._filterContainer = this._createAdvancedSearchFormFiltersElement();
        this._setFilter(this._advancedSearchCodes[0].id); // ex "PositionOfInterest"
        var advancedFormInput = this._createAdvancedSearchFormInputElement();
        advancedForm.appendChild(advancedFormFilters);
        advancedForm.appendChild(advancedFormInput);
        advancedPanel.appendChild(advancedHeader);
        advancedPanel.appendChild(advancedForm);
        container.appendChild(advancedPanel);
    }

    // INFO je decompose les appels car j'ai besoin de recuperer le container
    // des resultats de l'autocompletion
    var autocomplete = this._autocompleteContainer = this._createAutoCompleteElement();
    var autocompleteList = this._suggestedContainer = this._createAutoCompleteListElement();
    autocomplete.appendChild(autocompleteList);
    container.appendChild(autocomplete);

    // INFO je decompose les appels car j'ai besoin de recuperer le container
    // des resultats du geocodage
    var geocode = this._createGeocodeResultsElement();
    var geocodeList = this._geocodedContainer = this._createGeocodeResultsListElement();
    geocode.appendChild(geocodeList);
    container.appendChild(geocode);

    return container;
};

/**
 * this method is called by :
 * - this._initContainer() : ...
 * - this.onGeocodingAdvancedSearchCodeChoice() : ...
 * and initialize or create the filters container HTMLElement
 * to the geocoding advanced menu.
 *
 * @param {String} code - resource geocoding name
 *
 * @returns {DOMElement} DOM element
 * @private
 */
SearchEngine.prototype._setFilter = function (code) {
    // INFORMATION
    // Nous avons 2 solutions possibles pour la mise en place des filtres.
    // 1. Soit on decide de creer tous les filtres pour chaque ressource
    // de geocodage à l'initialisation du composant, et on joue sur le
    // mode 'hidden' pour n'afficher que la ressource selectionnée.
    // 2. Soit on decide de creer à chaque fois les filtres pour la
    // ressource selectionnée.
    // Chaque solution a ses inconvenients/avantages.
    // Implementation du choix 2 car elle offre plus de souplesse pour
    // recuperer les 'form-data'...

    var container = this._filterContainer;

    var codeFound = false;
    for (var i = 0; i < this._advancedSearchCodes.length; i++) {
        if (this._advancedSearchCodes[i].id === code) {
            codeFound = true;
            break;
        }
    }

    if (!codeFound) {
        // cette ressource n'est pas disponible,
        // on supprime les anciens enfants...
        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }
        return;
    }

    // on sauvegarde la ressource de geocodage sélectionnée
    this._currentGeocodingCode = code;

    // on supprime les enfants...
    while (container.firstChild) {
        container.removeChild(container.firstChild);
    }

    var lstAttributs = this._advancedSearchFilters[code];
    if (!lstAttributs || lstAttributs.length === 0) {
        // cette ressource n'est pas parametrable
        return;
    }

    var divTable = this._createAdvancedSearchFiltersTableElement(code, true);

    for (var j = 0; j < lstAttributs.length; j++) {
        var divFilter = this._createAdvancedSearchFiltersAttributElement(lstAttributs[j]);
        divTable.appendChild(divFilter);
    }

    container.appendChild(divTable);

    return container;
};

// ################################################################### //
// ##################### methods rights management ################### //
// ################################################################### //

/**
 * this method is called by constructor
 * and check the rights to resources and services
 *
 * @private
 */
SearchEngine.prototype._checkRightsManagement = function () {
    // INFORMATION
    // l'autoconfiguration n'est utile que pour récupérer la clef si elle
    // n'est pas renseignée, et pour vérifier les droits sur les ressources
    // et les services.

    // si l'autoconfiguration n'est pas chargée,
    // il est toujours possible de requeter le service avec une clef API,
    // mais les droits sur les ressources ne sont pas garantis, on risque
    // d'obtenir des erreurs 403 forbidden..., la responsabilité revient
    // à l'utilisateur (message d'information)...
    // par contre, sans clef API renseignée au niveau du controle,
    // l'utilisateur doit la renseigner au niveau des services...,
    // sinon, Exception du service

    // si l'autoconfiguration est chargée,
    // si une clef API est renseignée au niveau controle, on controle
    // le mapping entre le contrat et la clef...
    // on obtient la liste des ressources ayant droits,
    // si on ne trouve pas de ressources ou certaines ressources ne sont
    // pas disponible, on previent l'utilisateur (message d'information).

    var _resources = [];
    var _key;
    var _opts = null;

    // les ressources du service d'autocompletion
    _key = this.options.autocompleteOptions.apiKey;
    _opts = this.options.autocompleteOptions.filterOptions;
    // on récupère les éventuelles ressources passées en option, soit dans autocompleteOptions
    _resources = _opts ? _opts.type : [];
    // soit dans options.resources.autocomplete
    if (!_resources || _resources.length === 0) {
        _resources = this.options.resources.autocomplete;
    }
    // ou celles par défaut sinon.
    if (!_resources || _resources.length === 0) {
        _resources = ["StreetAddress", "PositionOfInterest"];
    }
    var rightManagementAutoComplete = _CheckRightManagement2.default.check({
        key: _key || this.options.apiKey,
        resources: _resources,
        services: ["AutoCompletion"]
    });
    logger.log("rightManagementAutoComplete", rightManagementAutoComplete);

    // les ressources du service de geocodage
    _key = this.options.geocodeOptions.apiKey;
    _opts = this.options.geocodeOptions.filterOptions;
    // on récupère les éventuelles ressources passées en option, soit dans geocodeOptions :
    _resources = _opts ? _opts.type : [];
    // soit directement dans options.resources.geocode :
    if (!_resources || _resources.length === 0) {
        _resources = this.options.resources.geocode;
    }
    // ou celles par défaut sinon.
    if (!_resources || _resources.length === 0) {
        _resources = ["StreetAddress", "PositionOfInterest"];
    }
    var rightManagementGeocode = _CheckRightManagement2.default.check({
        key: _key || this.options.apiKey,
        resources: _resources,
        services: ["Geocode"]
    });
    logger.log("rightManagementGeocode", rightManagementGeocode);

    // aucun droit !
    if (!rightManagementAutoComplete && !rightManagementGeocode) {
        this._noRightManagement = true;
        return;
    }

    // on recupère les informations utiles
    // Ex. la clef API issue de l'autoconfiguration si elle n'a pas
    // été renseignée.
    if (!this.options.apiKey) {
        if (rightManagementGeocode) {
            this.options.apiKey = rightManagementGeocode.key;
        } else {
            this.options.apiKey = rightManagementAutoComplete.key;
        }
    }

    // les ressources par services ayant droit doivent servir pour les
    // appels aux services
    if (rightManagementAutoComplete) {
        this._servicesRightManagement["AutoCompletion"] = rightManagementAutoComplete["AutoCompletion"];
    }

    if (rightManagementGeocode) {
        this._servicesRightManagement["Geocode"] = rightManagementGeocode["Geocode"];
    }
};

// ################################################################### //
// ################ methods to request and results ################### //
// ################################################################### //

/**
 * this method is called by this.onAutoCompleteSearch()
 * and executes a request to the service.
 *
 * @param {Object} settings - service settings
 * @param {String}   settings.text - text
 * @param {Function} settings.onSuccess - callback
 * @param {Function} settings.onFailure - callback
 * @private
 */
SearchEngine.prototype._requestAutoComplete = function (settings) {
    // on ne fait pas de requête si on n'a pas renseigné de parametres !
    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) === "object" && Object.keys(settings).length === 0) {
        return;
    }

    // on ne fait pas de requête si la parametre 'text' est vide !
    if (!settings.text) {
        return;
    }

    logger.log(settings);

    var options = {};
    // on recupere les options du service
    _Utils2.default.assign(options, this.options.autocompleteOptions.serviceOptions);
    // ainsi que la recherche et les callbacks
    _Utils2.default.assign(options, settings);

    // on ajoute le paramètre filterOptions.type spécifiant les ressources.
    var resources = this.options.resources.autocomplete;
    if (resources && Array.isArray(resources)) {
        if (!options.filterOptions) {
            options.filterOptions = {};
        }
        // il se peut que l'utilisateur ait surchargé ce paramètre dans geocodeOptions,
        if (!options.filterOptions.type) {
            options.filterOptions.type = resources;
        }
    }

    // cas où la clef API n'est pas renseignée dans les options du service,
    // on utilise celle de l'autoconf ou celle renseignée au niveau du controle
    options.apiKey = options.apiKey || this.options.apiKey;

    logger.log(options);

    _gp2.default.Services.autoComplete(options);
};

/**
 * this method is called by this.onAutoCompleteSearchText() (case of success)
 * and fills the container of the location list.
 * it creates a HTML Element per location
 *
 * @param {Array} locations - Array of Gp.Services.AutoComplete.SuggestedLocation corresponding to autocomplete results list
 * @private
 */
SearchEngine.prototype._fillAutoCompletedLocationListContainer = function (locations) {
    if (!locations || locations.length === 0) {
        return;
    }

    // on vide la liste avant de la construire
    var element = this._suggestedContainer;
    if (element.childElementCount) {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    }

    this._displaySuggestedLocation();
    for (var i = 0; i < locations.length; i++) {
        // Proposals are dynamically filled in Javascript by autocomplete service
        this._createAutoCompletedLocationElement(locations[i], i);
    }
};

/**
 * this method is called by this.onAutoCompleteSearch()
 * and executes a request to the service.
 *
 * @param {Object} settings - service settings
 * @param {String}   settings.location - text
 * @param {Function} settings.onSuccess - callback
 * @param {Function} settings.onFailure - callback
 * @private
 */
SearchEngine.prototype._requestGeocoding = function (settings) {
    // on ne fait pas de requête si on n'a pas renseigné de parametres !
    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) === "object" && Object.keys(settings).length === 0) {
        return;
    }

    // on ne fait pas de requête si la parametre 'text' est vide !
    if (!settings.location) {
        return;
    }

    logger.log(settings);

    var options = {};
    options.returnFreeForm = true;
    // on recupere les options du service
    _Utils2.default.assign(options, this.options.geocodeOptions);
    // ainsi que la recherche et les callbacks
    _Utils2.default.assign(options, settings);

    // on ajoute le paramètre filterOptions.type spécifiant les ressources.
    var resources = this.options.resources.geocode;
    if (resources && Array.isArray(resources)) {
        if (!options.filterOptions) {
            options.filterOptions = {};
        }
        // il se peut que l'utilisateur ait surchargé ce paramètre dans geocodeOptions,
        // ou qu'il ait déjà été rempli (cas de la recherche avancée)
        if (!options.filterOptions.type) {
            options.filterOptions.type = resources;
        }
    }

    // cas où la clef API n'est pas renseignée dans les options du service,
    // on utilise celle de l'autoconf ou celle renseignée au niveau du controle
    options.apiKey = options.apiKey || this.options.apiKey;

    logger.log(options);

    _gp2.default.Services.geocode(options);
};

/**
 * this method is called by this.onGeocodingSearch()
 * and fills the container of the location results.
 * it creates a HTML Element per location
 * (cf. this. ...)
 *
 * @param {Object[]} locations - locations
 *
 * @private
 */
SearchEngine.prototype._fillGeocodedLocationListContainer = function (locations) {
    if (!locations || locations.length === 0) {
        this._clearGeocodedLocation();
        return;
    }

    // on vide la liste avant de la construire
    var element = this._geocodedContainer;
    if (element.childElementCount) {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    }

    for (var i = 0; i < locations.length; i++) {
        logger.log(locations[i]);
        // Proposals are dynamically filled in Javascript by autocomplete service
        this._createGeocodedLocationElement(locations[i], i);
    }

    // sauvegarde de l'etat des locations
    this._geocodedLocations = locations;
};

// ################################################################### //
// ######################### other methods ########################### //
// ################################################################### //

/**
 * this sends the label to the panel.
 *
 * @param {String} label - label suggested location
 * @private
 */
SearchEngine.prototype._setLabel = function (label) {
    document.getElementById("GPsearchInputText-" + this._uid).value = label;
};

/**
 * this method is called by this.on*ResultsItemClick()
 * and move/zoom on a position.
 *
 * @param {Array} position - ol.Coordinate object [lon, lat] (en lat/lon : "EPSG:4326")
 * @param {Number} zoom - zoom level
 * @private
 */
SearchEngine.prototype._setPosition = function (position, zoom) {
    var view = this.getMap().getView();
    view.setCenter(position);
    view.setZoom(zoom);
};

/**
 * this method is called by this.on*ResultsItemClick()
 * and displays a marker.
 * FIXME
 *
 * @param {Array} position - ol.Coordinate object [lon, lat] ou [x, y]
 * @param {Object} info - location information
 * @private
 */
SearchEngine.prototype._setMarker = function (position, info) {
    var map = this.getMap();
    var context = this;

    // remove previous markers
    if (this._marker != null) {
        map.removeOverlay(this._marker);
        this._marker = null;
    }

    if (position) {
        // création de l'élément DOM
        var markerDiv = document.createElement("img");
        markerDiv.src = this._markerUrl;

        // ajout de l'évènement onclick (pour afficher une popup)
        if (markerDiv.addEventListener) {
            markerDiv.addEventListener("click", function () {
                context._onResultMarkerSelect(info);
            });
        } else if (markerDiv.attachEvent) {
            // Internet Explorer
            markerDiv.attachEvent("onclick", function () {
                context._onResultMarkerSelect(info);
            });
        }

        // création du marker (overlay)
        this._marker = new _ol2.default.Overlay({
            position: position,
            offset: [-25.5, -38],
            element: markerDiv,
            stopEvent: false
        });
        map.addOverlay(this._marker);
    }
};

/**
 * this method is called by this.on*ResultsItemClick()
 * and get zoom to results.
 *
 * @param {Object} info - info
 *
 * @returns {Integer} zoom
 * @private
 */
SearchEngine.prototype._getZoom = function (info) {
    var map = this.getMap();
    var key = this.options.zoomTo;
    var zoom = null;

    // les valeurs du zooms sont determinées
    // soit par les mots clefs suivants :  max, min ou auto
    // soit par un niveau de zoom
    // soit defini par l'utilisateur via une fonction

    if (typeof key === "function") {
        // logger.trace("zoom function");
        zoom = key.call(this, info);
    }

    if (typeof key === "number") {
        // logger.trace("zoom level");
        zoom = key;
    }

    if (typeof key === "string") {
        // if (key === "max") {
        //     zoom = map.getMaxZoom();
        // } else if (key === "min") {
        //     zoom = map.getMinZoom();
        // } else

        if (key === "auto") {
            // logger.trace("zoom auto");
            zoom = _SearchEngineUtils2.default.zoomToResultsByDefault(info);
        } else {
            // logger.trace("zoom level parsing");
            var value = parseInt(key, 10);
            if (!isNaN(value)) {
                // logger.trace("zoom parsing");
                zoom = value;
            }
        }
    }

    // polyfill IE
    Number.isInteger = Number.isInteger || function (value) {
        return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
    };

    // test de validité du zoom,
    // on prend le zoom courant par defaut ...
    if (!zoom || zoom === "" || !Number.isInteger(zoom)) {
        // logger.trace("zoom not found, current zoom...");
        zoom = map.getView().getZoom();
    }

    // FIXME test si le zoom est dans l'espace de la carte
    var min = map.minZoom; // .getMinZoom();
    var max = map.maxZoom; // .getMaxZoom();
    if (zoom < min) {
        // logger.trace("zoom level min...");
        zoom = min;
    }
    if (zoom > max) {
        // logger.trace("zoom level max...");
        zoom = max;
    }

    // logger.trace("zoom", zoom);
    return zoom;
};

/**
 * this method is called on 'click' on this._marker
 * (cf. this._setMarker() )
 * and sets a popup with marker information
 *
 * @param {Object} information - location information
 * @private
 */
SearchEngine.prototype._onResultMarkerSelect = function (information) {
    var map = this.getMap();

    var popupContent = "";
    if (information.attributes) {
        // si on a des attributes (freeform = false)
        popupContent = "<ul>";
        var attributes = information.attributes;
        for (var attr in attributes) {
            if (attributes.hasOwnProperty(attr)) {
                if (attr !== "bbox") {
                    popupContent += "<li>";
                    popupContent += "<span class=\"gp-attname-others-span\">" + attr.toUpperCase() + " : </span>";
                    popupContent += attributes[attr];
                    popupContent += " </li>";
                }
            }
        }
        popupContent += " </ul>";
    } else {
        // freeform
        popupContent = information.label;
    }

    this._popupContent.innerHTML = popupContent;
    if (!this._popupOverlay) {
        // ajout de la popup a la carte comme un overlay
        this._popupOverlay = new _ol2.default.Overlay({
            element: this._popupDiv,
            positioning: "bottom-center",
            position: this._marker.getPosition(),
            offset: [0, -42]
        });
        map.addOverlay(this._popupOverlay);
    } else {
        // si l'overlay est déjà créé, on modifie juste sa position
        this._popupOverlay.setPosition(this._marker.getPosition());
    }
};

// ################################################################### //
// ###################### other handlers events ###################### //
// ################################################################### //

/**
 * this method is called by event 'click' on 'GPshowSearchEnginePicto' tag label
 * (cf. this._createShowSearchEnginePictoElement), and it cleans the component
 * when it's closed.
 *
 * @private
 */
SearchEngine.prototype.onShowSearchEngineClick = function () {
    this.collapsed = this._showSearchEngineInput.checked;
    // on génère nous même l'evenement OpenLayers de changement de propriété
    // (utiliser ol.control.SearchEngine.on("change:collapsed", function ) pour s'abonner à cet évènement)
    this.dispatchEvent("change:collapsed");
};

/**
 * this method is called by event 'click' on 'GPsearchInputReset' tag div
 * (cf. this._createSearchInputElement), and it cleans the value of input.
 *
 * @private
 */
SearchEngine.prototype.onSearchResetClick = function () {
    this._clearResults();
};

// ################################################################### //
// ################## handlers events AutoComplete ################### //
// ################################################################### //

/**
 * this method is called by event 'click' on 'GPlocationOrigin' input
 *
 * @private
 */
SearchEngine.prototype.onAutoCompleteInputClick = function () {
    var inputSearchTextContainer = document.getElementById("GPsearchInputText-" + this._uid);
    if (inputSearchTextContainer && !inputSearchTextContainer.disabled && inputSearchTextContainer.value.length > 2) {
        this._displaySuggestedLocation();
    }
};

/**
 * this method is called by event 'keyup' on 'GPsearchInputText' tag input
 * (cf. this._createSearchInputElement), and it gets the value of input.
 * this value is passed as a parameter for the service autocomplete (text).
 * the results of the request are displayed into a drop down menu.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
SearchEngine.prototype.onAutoCompleteSearchText = function (e) {
    var value = e.target.value;
    if (!value) {
        return;
    }

    // aucun droits !
    // on evite une requête...
    if (this._noRightManagement) {
        logger.log("no rights for this service !");
        return;
    }

    // on sauvegarde le localisant
    this._currentGeocodingLocation = value;

    // on limite les requêtes à partir de 3 car. saisie !
    if (value.length < 3) {
        this._clearSuggestedLocation();
        return;
    }

    var _triggerGeocode = this.options.autocompleteOptions.triggerGeocode;
    var _triggerDelay = this.options.autocompleteOptions.triggerDelay;

    // INFORMATION
    // on effectue la requête au service d'autocompletion.
    // on met en place des callbacks afin de recuperer les resultats ou
    // les messages d'erreurs du service.
    // les resultats sont affichés dans une liste deroulante.
    var context = this;
    this._requestAutoComplete({
        text: value,
        // callback onSuccess
        onSuccess: function onSuccess(results) {
            logger.log("request from AutoComplete", results);
            if (results) {
                // on sauvegarde l'etat des résultats
                context._suggestedLocations = results.suggestedLocations;
                context._locationsToBeDisplayed = [];
                // on vérifie qu'on n'a pas récupéré des coordonnées nulles (par ex recherche par code postal)
                for (var i = 0; i < context._suggestedLocations.length; i++) {
                    var ilocation = context._suggestedLocations[i];
                    if (ilocation.position && ilocation.position.x === 0 && ilocation.position.y === 0 && ilocation.fullText) {
                        // si les coordonnées sont nulles, il faut relancer une requête de géocodage avec l'attribut "fullText" récupéré
                        context._getGeocodeCoordinatesFromFullText(ilocation, i);
                    } else {
                        // sinon on peut afficher normalement le résultat dans la liste
                        context._locationsToBeDisplayed.push(ilocation);
                    }
                };
                // on affiche les résultats qui n'ont pas des coordonnées nulles
                context._fillAutoCompletedLocationListContainer(context._locationsToBeDisplayed);
                // on annule eventuellement une requete de geocodage en cours car on obtient des
                // de nouveau des resultats d'autocompletion...
                if (context._triggerHandler) {
                    clearTimeout(context._triggerHandler);
                    context._triggerHandler = null;
                    logger.warn("Cancel a geocode request !");
                }
            }
        },
        // callback onFailure
        onFailure: function onFailure(error) {
            // FIXME
            // où affiche t on les messages : ex. 'No suggestion matching the search' ?
            context._clearSuggestedLocation();
            logger.log(error.message);
            // on envoie une requete de geocodage si aucun resultat d'autocompletion
            // n'a été trouvé ! Et on n'oublie pas d'annuler celle qui est en cours !
            if (error.message === "No suggestion matching the search" && _triggerGeocode /* && value.length === 5 */) {
                    if (context._triggerHandler) {
                        clearTimeout(context._triggerHandler);
                        logger.warn("Cancel the last geocode request !");
                    }
                    context._triggerHandler = setTimeout(function () {
                        logger.warn("Launch a geocode request (code postal) !");
                        context._requestGeocoding({
                            location: value,
                            returnFreeForm: true,
                            // callback onSuccess
                            onSuccess: function onSuccess(results) {
                                logger.log("request from Geocoding", results);
                                if (results) {
                                    context._locationsToBeDisplayed = [];
                                    // on modifie la structure des reponses pour être
                                    // compatible avec l'autocompletion !
                                    var locations = results.locations;
                                    for (var i = 0; i < locations.length; i++) {
                                        var location = locations[i];
                                        location.fullText = location.placeAttributes.freeform;
                                        location.position = {
                                            x: location.position.y,
                                            y: location.position.x
                                        };
                                        context._locationsToBeDisplayed.push(location);
                                    }
                                    context._fillAutoCompletedLocationListContainer(locations);
                                }
                            },
                            // callback onFailure
                            onFailure: function onFailure(error) {
                                logger.log(error.message);
                            }
                        });
                    }, _triggerDelay);
                }
        }
    });

    var map = this.getMap();
    map.on("click", this._hideSuggestedLocation, this);
    map.on("pointerdrag", this._hideSuggestedLocation, this);
};

/**
 * this method is called by Gp.Services.autoComplete callback in case of success
 * (cf. this.onAutoCompleteSearchText), for suggested locations with null coordinates
 * (case of postalCode research for instance).
 * Send a geocode request with suggested location 'fullText' attribute, to get its coordinates and display it in autocomplete results list container.
 *
 * @param {Gp.Services.AutoCompleteResponse.SuggestedLocation} suggestedLocation - autocompletion result (with null coordinates) to be geocoded
 * @param {Number} i - suggestedLocation position in Gp.Services.AutoCompleteResponse.suggestedLocations autocomplete results list
 * @private
 */
SearchEngine.prototype._getGeocodeCoordinatesFromFullText = function (suggestedLocation, i) {
    var context = this;
    _gp2.default.Services.geocode({
        apiKey: this.options.apiKey,
        location: suggestedLocation.fullText,
        filterOptions: {
            type: suggestedLocation.type
        },
        // callback onSuccess
        onSuccess: function onSuccess(response) {
            logger.log("request from Geocoding (coordinates null)", response);
            if (response.locations && response.locations.length !== 0 && response.locations[0].position) {
                // on modifie les coordonnées du résultat en EPSG:4326 donc lat,lon
                if (context._suggestedLocations && context._suggestedLocations[i]) {
                    context._suggestedLocations[i].position = {
                        x: response.locations[0].position.y,
                        y: response.locations[0].position.x
                    };
                    // et on l'affiche dans la liste
                    context._locationsToBeDisplayed.unshift(context._suggestedLocations[i]);
                    context._fillAutoCompletedLocationListContainer(context._locationsToBeDisplayed);
                }
            }
        },
        /** callback onFailure */
        onFailure: function onFailure() {
            // si on n'a pas réussi à récupérer les coordonnées, on affiche quand même le résultat
            if (context._suggestedLocations && context._suggestedLocations[i]) {
                context._createAutoCompletedLocationElement(context._suggestedLocations[i], i);
            }
        }
    });
};

/**
 * this method is called by event 'click' on 'GPautoCompleteResultsList' tag div
 * (cf. this._createAutoCompleteListElement), and it selects the location.
 * this location displays a marker on the map.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
SearchEngine.prototype.onAutoCompletedResultsItemClick = function (e) {
    // TODO on souhaite un comportement different pour la selection des reponses
    // de l'autocompletion :
    // - liste deroulante des reponses,
    // - puis possibilité de cliquer sur une suggestion
    // - mais aussi de la choisir avec le clavier (arrow up/down), puis valider
    // par un return
    // cette selection avec les fleches doit mettre à jour le input !
    // (comme un moteur de recherche de navigateur)

    var idx = _SelectorID2.default.index(e.target.id);
    logger.log(idx);
    logger.log(this._locationsToBeDisplayed[idx]);

    if (!idx) {
        return;
    }

    var position = [this._locationsToBeDisplayed[idx].position.x, this._locationsToBeDisplayed[idx].position.y];
    var info = {
        service: "SuggestedLocation",
        type: this._locationsToBeDisplayed[idx].type,
        fields: this._locationsToBeDisplayed[idx]
    };

    // on ajoute le texte de l'autocomplétion dans l'input
    var label = this._locationsToBeDisplayed[idx].fullText;
    this._setLabel(label);
    info.label = label;

    // Info : la position est en EPSG:4326, à transformer dans la projection de la carte
    var view = this.getMap().getView();
    var mapProj = view.getProjection().getCode();
    if (mapProj !== "EPSG:4326") {
        // on retransforme les coordonnées de la position dans la projection de la carte
        position = _ol2.default.proj.transform(position, "EPSG:4326", mapProj);
    }
    // on centre la vue et positionne le marker, à la position reprojetée dans la projection de la carte
    var zoom = this._getZoom(info);
    this._setPosition(position, zoom);
    if (this._displayMarker) {
        this._setMarker(position, info);
    }
};

// ################################################################### //
// ################### handlers events Geocode ####################### //
// ################################################################### //

/**
 * this method is called by event 'submit' on 'GPsearchInput' tag form
 * (cf. this._createSearchInputElement), and it gets the value of input.
 * this value is passed as a parameter for the service geocoding.
 * the results of the request are displayed into a window.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
SearchEngine.prototype.onGeocodingSearchSubmit = function (e) {
    var value = e.target[0].value;
    if (!value) {
        return;
    }

    // aucun droits !
    // on evite une requête...
    if (this._noRightManagement) {
        logger.log("no rights for this service !");
        return;
    }

    // on sauvegarde le localisant
    this._currentGeocodingLocation = value;

    // on met en place l'affichage des resultats dans une fenetre de recherche.
    var context = this;
    this._requestGeocoding({
        location: value,
        // callback onSuccess
        onSuccess: function onSuccess(results) {
            logger.log("request from Geocoding", results);
            if (results) {
                var locations = results.locations;
                context._fillGeocodedLocationListContainer(locations);
            }
        },
        // callback onFailure
        onFailure: function onFailure(error) {
            // FIXME cf. this.onAutoCompleteSearch()
            context._clearGeocodedLocation();
            logger.log(error.message);
        }
    });
};

/**
 * this method is called by event 'submit' on 'GPgeocodeResultsList' tag div
 * (cf. this._createGeocodeResultsListElement), and it selects the location.
 * this location displays a marker on the map.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
SearchEngine.prototype.onGeocodedResultsItemClick = function (e) {
    var idx = _SelectorID2.default.index(e.target.id);

    if (!idx) {
        return;
    }

    var position = [this._geocodedLocations[idx].position.y, this._geocodedLocations[idx].position.x];
    var attributes = this._geocodedLocations[idx].placeAttributes;
    var info = {
        service: "DirectGeocodedLocation",
        type: this._geocodedLocations[idx].type,
        fields: this._geocodedLocations[idx]
    };

    // on ajoute le texte du géocodage dans l'input
    var label;
    if (attributes.freeform) {
        // reponse en freeForm
        label = attributes.freeform;
    } else if (attributes.postalCode) {
        // cas des StreetAddress, PositionOfInterest, Administratif
        // on affiche uniquement ce qui est commun aux ressources ...
        label = attributes.postalCode + " " + attributes.commune;
        info.attributes = attributes;
    } else if (attributes.cadastralParcel) {
        // cas des CadastralParcel
        label = attributes.cadastralParcel;
        info.attributes = attributes;
    } else {
        label = "...";
    }
    this._setLabel(label);
    info.label = label;

    // Info : la position est en EPSG:4326, à transformer dans la projection de la carte
    var view = this.getMap().getView();
    var mapProj = view.getProjection().getCode();
    if (mapProj !== "EPSG:4326") {
        // on retransforme les coordonnées de la position dans la projection de la carte
        position = _ol2.default.proj.transform(position, "EPSG:4326", mapProj);
    }
    // on centre la vue et positionne le marker, à la position reprojetée dans la projection de la carte
    var zoom = this._getZoom(info);
    this._setPosition(position, zoom);
    if (this._displayMarker) {
        this._setMarker(position, info);
    }
};

// ################################################################### //
// ############## handlers events Geocode Advanced ################### //
// ################################################################### //

/**
 * this method is called by event 'change' on 'GPadvancedSearchCode' tag select
 * (cf. this._createAdvancedSearchFormCodeElement), and it gets the value of
 * option selected.
 * this value is passed as a parameter to create the attributs container.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
SearchEngine.prototype.onGeocodingAdvancedSearchCodeChange = function (e) {
    logger.log(e);
    var idx = e.target.selectedIndex;
    var value = e.target.options[idx].value;

    if (!value) {
        return;
    }

    // INFORMATION
    // le declenchement de l'evenement va creer un container de filtre à la volée...
    // l'insertion des containers d'attributs dans le DOM sont :
    // - soit GPadvancedSearchFilters > PositionOfInterest
    // - soit GPadvancedSearchFilters > StreetAddress
    // - soit GPadvancedSearchFilters > CadastralParcel
    // cf. _setFilter() pour la creation du container

    this._setFilter(value);
};

/**
 * this method is called by event 'submit' on 'GPadvancedSearchForm' tag form
 * (cf. this._createAdvancedSearchPanelFormElement), and it gets the value of all input.
 * this value is passed as a parameter for the service geocoding.
 * the results of the request are displayed into a window.
 *
 * @param {Object} e - HTMLElement
 * @param {Array} data - [{key: ..., value: ...}]
 * @private
 */
SearchEngine.prototype.onGeocodingAdvancedSearchSubmit = function (e, data) {
    logger.log(data);
    if (!data || data.length === 0) {
        return;
    }

    var _location;
    var _filterOptions = {};
    var filter;
    _filterOptions.type = [this._currentGeocodingCode];
    for (var i = 0; i < data.length; i++) {
        filter = data[i];
        _filterOptions[filter.key] = filter.value;
    }

    if (this._currentGeocodingCode === "CadastralParcel") {
        // dans ce cas, les filtres de recherche avancée ne sont pas vraiment des filtres,
        // mais simplement la décomposition des informations de la parcelle, à concaténer.
        _location = this._getCadastralParcelRequestParams(_filterOptions);

        // FIXME ne marche pas bien !
        _filterOptions = {
            type: [this._currentGeocodingCode]
        };
    } else {
        // recuperation des parametres des filtres pour les transmettre
        // à la requête, ainsi que le type de table de ressources de geocodage,
        // et le localisant (freeform)
        _location = this._currentGeocodingLocation;
    }

    // on met en place l'affichage des resultats dans une fenetre de recherche.
    var context = this;
    this._requestGeocoding({
        location: _location,
        filterOptions: _filterOptions,
        // callback onSuccess
        onSuccess: function onSuccess(results) {
            logger.log(results);
            if (results) {
                var locations = results.locations;
                context._fillGeocodedLocationListContainer(locations);
            }
        },
        // callback onFailure
        onFailure: function onFailure(error) {
            // FIXME cf. this.onAutoCompleteSearch()
            context._clearGeocodedLocation();
            logger.log(error.message);
        }
    });
};

/**
 * this method is called by 'onGeocodingAdvancedSearchSubmit' method,
 * in case geocoding type is 'CadastralParcel',
 * and gets request parameters from inputs
 *
 * @param {Object} filterOptions - object with inputs value (department, insee, ...)
 * @returns {String} location - cadastral parcel number : concatenation of inputs values (e.g. : 940670000D0041 or 94067_____0041)
 * @private
 */
SearchEngine.prototype._getCadastralParcelRequestParams = function (filterOptions) {
    /* info:
        la parcelle cadastrale se compose de 14 chiffres ou lettres, indiquant, de gauche à droite :
        - le code du département (2 caractères)
        - le code commune (3 caractères). (Remarque : code département + code commune = code INSEE)
        - OU le code INSEE de la commune (5 chiffres) (remplace les 2 précédents)
        - le code commune absorbée INSEE, ou '000' (3 caractères),
        - la section (2 caractères),
        - le numéro de parcelle (4 caractères).
        Exemple de parcelle : '940670000D0041'. Si l'identifiant est incomplet (par exemple '940670000D'), le service renverra uniquement les 25 premiers résultats pouvant correspondre.
    */

    var _location = "";

    var l;
    // code département (2 caractères)
    var dep = filterOptions.department;
    if (dep) {
        l = dep.length;
        if (l === 2) {
            _location = dep;
        } else if (l === 1) {
            // si un seul numéro a été saisi, on présume que c'est un numéro < 10
            _location = "0" + dep;
        } else {
            _location = dep.substring(0, 2);
        }
    } else {
        _location = "__";
    }

    // code commune insee (3 caractères)
    var commune = filterOptions.commune;
    if (commune) {
        l = commune.length;
        if (l === 3) {
            _location += commune;
        } else if (l === 2) {
            _location += "_" + commune;
        } else if (l === 1) {
            _location += "__" + commune;
        } else {
            // l > 3
            _location += commune.substring(0, 3);
        }
    } else {
        _location += "___";
    }

    // code insee (5 caractères) : surcharge les 2 autres si renseigné
    var insee = filterOptions.insee;
    if (insee) {
        if (insee.length === 5) {
            _location = insee;
        }
    }

    // code commune absorbee INSEE (3 caractères)
    var absorbedCity = filterOptions.absorbedCity;
    if (absorbedCity) {
        l = absorbedCity.length;
        if (l === 3) {
            _location += absorbedCity;
        } else if (l < 3) {
            if (l === 2) {
                _location += "_" + absorbedCity;
            } else if (l === 1) {
                _location += "__" + absorbedCity;
            }
        } else {
            // l > 3
            _location += absorbedCity.substring(0, 3);
        }
    } else {
        _location += "___";
    }

    // section (2 caractères)
    var section = filterOptions.section;
    if (section) {
        l = section.length;
        if (l === 2) {
            _location += section;
        } else if (l === 1) {
            _location += "_" + section;
        } else {
            _location += section.substring(0, 2);
        }
    } else {
        _location += "__";
    }

    // numéro de parcelle (4 caractères)
    var number = filterOptions.number;
    if (number) {
        l = number.length;
        if (l === 4) {
            _location += number;
        } else if (l === 3) {
            _location += "_" + number;
        } else if (l === 2) {
            _location += "__" + number;
        } else if (l === 1) {
            _location += "___" + number;
        } else {
            // l > 4
            _location += number.substring(0, 4);
        }
    } else {
        _location += "___";
    }

    logger.log("location : " + _location);

    return _location;
};

// ################################################################### //
// ############################## clean ############################## //
// ################################################################### //

/**
 * this method is called by this.onSearchReset()
 * and it clears all results and the marker.
 *
 * @private
 */
SearchEngine.prototype._clearResults = function () {
    var map = this.getMap();

    this._currentGeocodingLocation = null;

    this._clearSuggestedLocation();
    this._clearGeocodedLocation();

    this._setMarker();
    // on retire l'overlay de la popup de la carte
    if (this._popupOverlay != null) {
        map.removeOverlay(this._popupOverlay);
        this._popupOverlay = null;
    }
};

/**
 * this method is called by this.onAutoCompleteSearchText()
 * and it clears all suggested location.
 *
 * @private
 */
SearchEngine.prototype._clearSuggestedLocation = function () {
    this._suggestedLocations = [];
    if (this._suggestedContainer) {
        while (this._suggestedContainer.firstChild) {
            this._suggestedContainer.removeChild(this._suggestedContainer.firstChild);
        }
    }
};

/**
 * this method is called by event 'click' on map
 * and it hides suggested locations
 *
 * @private
 */
SearchEngine.prototype._hideSuggestedLocation = function () {
    if (this._autocompleteContainer) {
        this._autocompleteContainer.style.display = "none";
    }
};

/**
 * this method is called by event 'click' on label input
 * and it displays suggested location.
 *
 * @private
 */
SearchEngine.prototype._displaySuggestedLocation = function () {
    if (this._autocompleteContainer) {
        this._autocompleteContainer.style.display = "block";
    }
};

/**
 * this method is called by this.onGeocodingAdvancedSearchSubmit()
 * and it clears all geocoded location.
 *
 * @private
 */
SearchEngine.prototype._clearGeocodedLocation = function () {
    this._geocodedLocations = [];
    if (this._geocodedContainer) {
        while (this._geocodedContainer.firstChild) {
            this._geocodedContainer.removeChild(this._geocodedContainer.firstChild);
        }
    }
};

exports.default = SearchEngine;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SearchEngineUtils = {
    /**
     * Advanced Search Filters by default
     */
    advancedSearchFiltersByDefault: {
        PositionOfInterest: [{
            name: "importance",
            title: "Importance"
        }, {
            name: "nature",
            title: "Nature"
        }, {
            name: "territory",
            title: "Territoire"
        }, {
            name: "insee",
            title: "Code INSEE"
        }, {
            name: "municipality",
            title: "Ville"
        }, {
            name: "department",
            title: "Département"
        }],
        StreetAddress: [
        // INFO
        // ce ne sont pas des filtres mais une location dite structurée !
        // {name : "number", title : "Numéro"},
        // {name : "street", title : "Rue"},
        // {name : "postalCode", title : "Code Postal"},
        // {name : "city", title : "Commune"},
        {
            name: "territory",
            title: "Territoire"
        }, {
            name: "insee",
            title: "Code INSEE"
        }, {
            name: "municipality",
            title: "Ville"
        }, {
            name: "department",
            title: "Département"
        }],
        CadastralParcel: [{
            name: "department",
            title: "Département",
            description: "Numéro du département (ex: 01, 94)"
        }, {
            name: "commune",
            title: "Code commune (INSEE)",
            description: "Code commune (INSEE) : 3 chiffres (ex: 067)"
        },
        // {
        //     name : "insee",
        //     title : "Code INSEE"
        // },
        {
            name: "absorbedCity",
            title: "Commune absorbée",
            description: "Commune absorbée : 3 chiffres (ex: 000, 001)"
        }, {
            name: "section",
            title: "Section",
            description: "Section : 2 caractères (ex: AA, 0D)"
        }, {
            name: "number",
            title: "Numéro",
            description: "Numéro de la parcelle : 4 chiffres (ex: 0041, 0250)"
        }],
        Administratif: [{
            name: "prefecture",
            title: "Préfecture"
        }, {
            name: "inseeRegion",
            title: "Code région (INSEE)"
        }, {
            name: "inseeDepartment",
            title: "Code département (INSEE)"
        }, {
            name: "municipality",
            title: "Ville"
        }]
    },

    /**
     * Provides default zoom based on results.
     *
     * @param {Object} info - location information
     * @returns {Integer} zoom level
     */
    zoomToResultsByDefault: function zoomToResultsByDefault(info) {
        // FIXME
        // la classification du geocodage est differente de l'importance de l'autocompletion !

        var zoom = 15;

        var service = info.service;
        var fields = info.fields;
        var type = info.type;

        var importance = {
            1: 11,
            2: 12,
            3: 13,
            4: 14,
            5: 15,
            6: 16,
            7: 17,
            8: 17
        };

        // AutoCompletion POI
        if (service === "SuggestedLocation") {
            if (type === "PositionOfInterest") {
                zoom = importance[fields.classification];
            }
        }

        // Geocodage POI
        if (service === "DirectGeocodedLocation") {
            if (type === "PositionOfInterest") {
                zoom = importance[fields.importance] || 14; // au cas où la recherche est en freeform !
            }
        }

        if (type === "StreetAddress") {
            zoom = 17;
        }

        if (type === "CadastralParcel") {
            zoom = 17;
        }

        if (type === "Administratif") {
            zoom = 12;
        }

        return zoom;
    }
};

exports.default = SearchEngineUtils;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchEngineDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPsearchEngine");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################### Methods of main container ##################### //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing
     *
     * @returns {DOMElement} DOM element
     */
    _createShowSearchEngineElement: function _createShowSearchEngineElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowSearchEngine");
        input.type = "checkbox";
        return input;
    },

    /**
     * Show search engine
     *
     * @returns {DOMElement} DOM element
     */
    _createShowSearchEnginePictoElement: function _createShowSearchEnginePictoElement() {
        // contexte d'execution
        var self = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowSearchEnginePicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowSearchEngine");
        label.title = "Afficher/masquer la recherche par lieux";

        // Close all results and panels when minimizing the widget
        label.addEventListener("click", function () {
            document.getElementById(self._addUID("GPautoCompleteList")).style.display = "none";
            document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "none";
            var showAdvancedSearch = document.getElementById(self._addUID("GPshowAdvancedSearch"));
            if (showAdvancedSearch) {
                showAdvancedSearch.style.display = null;
                document.getElementById(self._addUID("GPadvancedSearchPanel")).style.display = "none";
            }
            var id = "#GPsearchInput-" + self._uid;
            document.querySelector(id + " input").disabled = false; // FIXME form[id^=GPsearchInput] = #GPsearchInput ?
            self.onShowSearchEngineClick();
        });

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowSearchEngineOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    },

    /**
     * Simple search input
     * @param {String} placeholder - placeholder
     *
     * @returns {DOMElement} DOM element
     */
    _createSearchInputElement: function _createSearchInputElement(placeholder) {
        // contexte d'execution
        var self = this;

        var form = document.createElement("form");
        form.id = this._addUID("GPsearchInput");
        // Open geocode results panel when submitting the input
        form.addEventListener("submit", function (e) {
            e.preventDefault();
            document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "block";
            document.getElementById(self._addUID("GPautoCompleteList")).style.display = "none";
            // cf. FIXME
            // document.querySelector("#GPsearchInput input").blur ();

            // gestionnaire d'evenement :
            // on récupère la valeur de saisie pour requête sur le service de geocodage
            self.onGeocodingSearchSubmit(e);
            return false;
        });

        var input = document.createElement("input");
        input.id = this._addUID("GPsearchInputText");
        input.type = "text";
        input.placeholder = placeholder;
        input.autocomplete = "off";
        // Manage autocomplete list appearance when filling the address input
        input.addEventListener("keyup", function (e) {
            var charCode = e.which || e.keyCode;
            if (charCode === 13 || charCode === 10 || charCode === 38 || charCode === 40) {
                return;
            }
            document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "none";
            if (input.value.length > 2) {
                document.getElementById(self._addUID("GPautoCompleteList")).style.display = "block";
            } else {
                document.getElementById(self._addUID("GPautoCompleteList")).style.display = "none";
            }
            // gestionnaire d'evenement :
            // on récupère la valeur de saisie pour requête sur le service d'autocompletion
            self.onAutoCompleteSearchText(e);
        });

        // FIXME ce code interfere avec le click sur la liste des suggested locations !
        // input.addEventListener("blur", function(e) {
        //     document.getElementById(self._addUID("GPautoCompleteList")).style.display = "none";
        // });

        input.addEventListener("keydown", function (e) {
            // FIXME
            // l'action clavier 'enter (13)' lance le submit de la form !
            // Ce comportement n'est pas souhaité car le submit execute un geocodage !
            // Il faut donc trouver le moyen d'eviter le submit sur un return venant
            // seulement d'une selection de suggestion...

            var charCode = e.which || e.keyCode;

            var container = document.getElementById(self._addUID("GPautocompleteResults"));

            // si aucun container !?
            if (!container) {
                return;
            }

            var curr = container.getElementsByClassName("GPautoCompleteProposal current");
            var list = container.getElementsByClassName("GPautoCompleteProposal");

            // si aucune suggestion, on ne va pas plus loin !
            var length = list.length;
            if (!length) {
                return;
            }

            var current = null;

            // si aucun item courant, on prend le 1er !
            if (!curr.length) {
                current = list[0];
                current.className = "GPautoCompleteProposal current";
                current.style.color = "#000000";
                current.style["background-color"] = "#CEDBEF";
                return;
            } else {
                current = curr[0];
            }

            var index = parseInt(_SelectorID2.default.index(current.id), 10);
            var next = index === length - 1 ? list[0] : list[index + 1];
            var prev = index === 0 ? list[length - 1] : list[index - 1];

            current.style["background-color"] = "";
            current.style.color = "";
            prev.style["background-color"] = "";
            prev.style.color = "";
            next.style["background-color"] = "";
            next.style.color = "";

            switch (charCode) {
                case 38:
                    // arrow up
                    current.className = "GPautoCompleteProposal";
                    prev.className = "GPautoCompleteProposal current";
                    prev.style.color = "#000000";
                    prev.style["background-color"] = "#CEDBEF";
                    break;
                case 40:
                    // arrow down
                    current.className = "GPautoCompleteProposal";
                    next.className = "GPautoCompleteProposal current";
                    next.style.color = "#000000";
                    next.style["background-color"] = "#CEDBEF";
                    break;
                case 13:
                    // enter
                    // cf. FIXME
                    e.preventDefault();
                    current.click(e);
                    break;
            }

            current.focus();
        });

        form.appendChild(input);

        var div = document.createElement("div");
        div.id = this._addUID("GPsearchInputReset");
        // Reset input
        div.addEventListener("click", function () {
            document.getElementById(self._addUID("GPsearchInputText")).value = "";
            document.getElementById(self._addUID("GPautoCompleteList")).style.display = "none";
            document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "none";
            self.onSearchResetClick();
        });
        form.appendChild(div);

        return form;
    },

    /**
     * Show advanced search panel
     *
     * @returns {DOMElement} DOM element
     */
    _createShowAdvancedSearchElement: function _createShowAdvancedSearchElement() {
        // contexte d'execution
        var self = this;

        var div = document.createElement("div");
        div.id = this._addUID("GPshowAdvancedSearch");
        div.className = "GPshowAdvancedToolPicto";
        div.title = "Ouvrir la recherche avancée";

        // Open advanced search
        div.addEventListener("click", function () {
            var id = "#GPsearchInput-" + self._uid;
            document.querySelector(id + " input").disabled = true;
            document.getElementById(self._addUID("GPautoCompleteList")).style.display = "none";
            document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "none";
            document.getElementById(self._addUID("GPshowAdvancedSearch")).style.display = "none";
            document.getElementById(self._addUID("GPadvancedSearchPanel")).style.display = "inline-block";
        });

        var span = document.createElement("span");
        span.id = this._addUID("GPshowAdvancedSearchOpen");
        span.className = "GPshowAdvancedToolOpen";
        div.appendChild(span);

        return div;
    },

    /**
     * Advanced search panel
     *
     * FIXME
     * don't call this._createAdvancedSearchPanelHeaderElement
     * don't call this._createAdvancedSearchPanelFormElement
     *
     * @returns {DOMElement} DOM element
     */
    _createAdvancedSearchPanelElement: function _createAdvancedSearchPanelElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPadvancedSearchPanel");
        div.className = "GPpanel";
        div.style.display = "none";

        // FIXME on decompose la fonction pour les besoins du controle,
        // on ajoutera ces childs à la main...
        // div.appendChild(this._createAdvancedSearchPanelHeaderElement ());
        // div.appendChild(this._createAdvancedSearchPanelFormElement ());

        return div;
    },

    /**
     * Geocoding results
     *
     * FIXME
     * don't call this._createGeocodeResultsListElement
     *
     * @returns {DOMElement} DOM element
     */
    _createGeocodeResultsElement: function _createGeocodeResultsElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPgeocodeResultsList");
        div.className = "GPpanel";
        div.style.display = "none";

        div.appendChild(this._createGeocodeResultsHeaderElement());

        // FIXME on decompose la fonction pour les besoins du controle,
        // on ajoutera ces childs à la main...
        // div.appendChild(this._createGeocodeResultsListElement ());

        return div;
    },

    /**
     * Autocompletion results
     *
     * FIXME
     * don't call this._createAutoCompleteListElement
     *
     * @returns {DOMElement} DOM element
     */
    _createAutoCompleteElement: function _createAutoCompleteElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPautoCompleteList");
        div.className = "GPautoCompleteList"; // GPpanel ?
        div.style.display = "none";

        // FIXME on decompose la fonction pour les besoins du controle,
        // on ajoutera ces childs à la main...
        // div.appendChild(this._createAutoCompleteListElement ());

        return div;
    },

    // ################################################################### //
    // ################### Autocompletion container ###################### //
    // ################################################################### //

    /**
     * Autocompletion results list.
     *
     * @returns {DOMElement} DOM element
     */
    _createAutoCompleteListElement: function _createAutoCompleteListElement() {
        // contexte d'execution
        var self = this;

        var container = document.createElement("div");
        container.id = this._addUID("GPautocompleteResults");

        if (container.addEventListener) {
            container.addEventListener("click", function (e) {
                self.onAutoCompletedResultsItemClick(e);
                document.getElementById(self._addUID("GPautoCompleteList")).style.display = "none";
            }, false);
        } else if (container.attachEvent) {
            container.attachEvent("onclick", function (e) {
                self.onAutoCompletedResultsItemClick(e);
                document.getElementById(self._addUID("GPautoCompleteList")).style.display = "none";
            });
        }

        // Proposals are dynamically filled in Javascript by autocomplete service
        // <div class="GPautoCompleteProposal">...</div>

        return container;
    },

    /**
     * Autocompletion result.
     * Proposals are dynamically filled in Javascript by autocomplete service
     *
     * TODO formaliser le contenu des reponse
     *
     * @param {Object} location - suggested or geocoded location results
     * @param {Number} id - ID
     */
    _createAutoCompletedLocationElement: function _createAutoCompletedLocationElement(location, id) {
        var container = document.getElementById(this._addUID("GPautocompleteResults"));

        var div = document.createElement("div");
        div.id = this._addUID("AutoCompletedLocation_" + id);
        div.className = "GPautoCompleteProposal";
        div.innerHTML = location.fullText;
        if (div.addEventListener) {
            div.addEventListener("click", function (e) {
                container.click(e);
            }, false);
        } else if (div.attachEvent) {
            div.attachEvent("onclick", function (e) {
                container.click(e);
            });
        }

        container.appendChild(div);
    },

    // ################################################################### //
    // ############### Geocoding with advanced container ################# //
    // ################################################################### //

    /**
     * @returns {DOMElement} DOM element
     */
    _createAdvancedSearchPanelHeaderElement: function _createAdvancedSearchPanelHeaderElement() {
        // contexte d'execution
        var self = this;

        var container = document.createElement("div");
        container.className = "GPpanelHeader";

        var divTitle = document.createElement("div");
        divTitle.className = "GPpanelTitle";
        divTitle.innerHTML = "Recherche avancée";
        container.appendChild(divTitle);

        var divClose = document.createElement("div");
        divClose.id = this._addUID("GPadvancedSearchClose");
        divClose.className = "GPpanelClose";
        divClose.title = "Fermer la recherche avancée";

        if (divClose.addEventListener) {
            divClose.addEventListener("click", function () {
                var id = "#GPsearchInput-" + self._uid;
                document.querySelector(id + " input").disabled = false;
                document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "none";
                document.getElementById(self._addUID("GPshowAdvancedSearch")).style.display = "inline-block";
                document.getElementById(self._addUID("GPadvancedSearchPanel")).style.display = "none";
            }, false);
        } else if (divClose.attachEvent) {
            divClose.attachEvent("onclick", function () {
                var id = "#GPsearchInput-" + self._uid;
                document.querySelector(id + " input").disabled = false;
                document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "none";
                document.getElementById(self._addUID("GPshowAdvancedSearch")).style.display = "inline-block";
                document.getElementById(self._addUID("GPadvancedSearchPanel")).style.display = "none";
            });
        }

        container.appendChild(divClose);

        return container;
    },

    /**
     * @param {Object[]} advancedSearchCodes - codes
     *
     * @returns {DOMElement} DOM element
     */
    _createAdvancedSearchPanelFormElement: function _createAdvancedSearchPanelFormElement(advancedSearchCodes) {
        // contexte d'execution
        var self = this;

        var form = document.createElement("form");
        form.id = this._addUID("GPadvancedSearchForm");
        form.addEventListener("submit", function (e) {
            e.preventDefault();
            // data
            var data = [];
            // liste des attributs de la ressource de geocodage
            var id = "#GPadvancedSearchFilters-" + self._uid;
            var matchesFilters = document.querySelectorAll(id + " > div > div > input");
            for (var i = 0; i < matchesFilters.length; i++) {
                var element = matchesFilters[i];
                data.push({
                    key: element.name,
                    value: element.value
                });
            }

            // gestionnaire d'evenement :
            // on récupère les valeurs de saisies pour requête sur le service de geocodage
            self.onGeocodingAdvancedSearchSubmit(e, data);
            document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "block";

            return false;
        });

        var div = document.createElement("div");
        div.className = "GPflexInput";

        var label = document.createElement("label");
        label.className = "GPadvancedSearchCodeLabel";
        label.innerHTML = "Recherche par";
        div.appendChild(label);

        var select = this._createAdvancedSearchFormCodeElement(advancedSearchCodes);
        div.appendChild(select);

        // FIXME on decompose la fonction pour les besoins du controle,
        // on ajoutera ces childs à la main...

        // var filters = this._createAdvancedSearchFormFiltersElement ();
        // form.appendChild(filters);

        // var input = this._createAdvancedSearchFormInputElement ();
        // form.appendChild(input);

        form.appendChild(div);

        return form;
    },

    /**
     * @param {Object[]} codes - codes
     * @returns {DOMElement} DOM element
     */
    _createAdvancedSearchFormCodeElement: function _createAdvancedSearchFormCodeElement(codes) {
        // contexte d'execution
        var self = this;

        var select = document.createElement("select");
        select.id = this._addUID("GPadvancedSearchCode");
        select.className = "GPadvancedSearchCode";
        select.addEventListener("change", function (e) {
            // var idx   = e.target.selectedIndex;
            // var value = e.target.options[idx].value;
            // gestionnaire d'evenement :
            // permet de recuperer des informations diverses...
            self.onGeocodingAdvancedSearchCodeChange(e);
        }, false);

        // liste statique au cas où des codes n'ont pas été passés en entrée
        if (!codes) {
            codes = [{
                id: "PositionOfInterest",
                title: "Lieux/toponymes"
            }, {
                id: "StreetAddress",
                title: "Adresses"
            }, {
                id: "CadastralParcel",
                title: "Parcelles cadastrales"
            }, {
                id: "Administratif",
                title: "Administratif"
            }];
        }

        for (var i = 0; i < codes.length; i++) {
            var option = document.createElement("option");
            option.value = codes[i].id;
            option.text = codes[i].title;
            select.appendChild(option);
        }

        return select;
    },

    /**
     * @returns {DOMElement} DOM element
     */
    _createAdvancedSearchFormInputElement: function _createAdvancedSearchFormInputElement() {
        var input = document.createElement("input");
        input.type = "submit";
        input.id = this._addUID("GPadvancedSearchSubmit");
        input.className = "GPinputSubmit";
        input.value = "Chercher";

        return input;
    },

    /**
     * Filters geocoding.
     *
     * @returns {DOMElement} DOM element
     */
    _createAdvancedSearchFormFiltersElement: function _createAdvancedSearchFormFiltersElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPadvancedSearchFilters");
        return container;
    },

    /**
     * Create filter container for resources :
     * "PositionOfInterest", "StreetAddress", ...
     *
     * @param {String} code - code of geocoding resource
     * @param {Boolean} display - display
     *
     * @returns {DOMElement} DOM element
     */
    _createAdvancedSearchFiltersTableElement: function _createAdvancedSearchFiltersTableElement(code, display) {
        var container = document.createElement("div");
        container.id = this._addUID(code);
        if (!display) {
            container.style.display = "none";
        }

        return container;
    },

    /**
     * Create filter attribut for a resource :
     * "PositionOfInterest", "StreetAddress", ...
     * Research filters are filled in Javascript depending on developer choice
     *
     * @param {Object} filterAttributes - filter attributes :
     * @param {String} filterAttributes.code - code of geocoding resource
     * @param {String} filterAttributes.name - ID
     * @param {String} filterAttributes.title - label
     * @param {String} filterAttributes.description - description
     * @param {String} filterAttributes.value - value
     *
     * @returns {DOMElement} DOM element
     */
    _createAdvancedSearchFiltersAttributElement: function _createAdvancedSearchFiltersAttributElement(filterAttributes) {
        // INFORMATION
        // cette methode peut être appelée si le document n'existe pas, elle
        // permet ainsi de creer une div sans insertion dans le container...

        var container = null;
        var name = filterAttributes.name;
        var title = filterAttributes.title;
        var description = filterAttributes.description;
        var code = filterAttributes.code;
        var value = filterAttributes.value;

        var div = document.createElement("div");
        div.className = "GPflexInput";

        var label = document.createElement("label");
        label.className = "GPadvancedSearchFilterLabel";
        label.htmlFor = name;
        label.title = description || title;
        label.innerHTML = title;
        div.appendChild(label);

        var input = document.createElement("input");
        input.id = name;
        input.className = "GPadvancedSearchFilterInput";
        input.type = "text";
        input.name = name;
        if (value) {
            input.value = value;
        }
        div.appendChild(input);

        container = document.getElementById(this._addUID(code));

        if (container) {
            container.appendChild(div);
        } else {
            // le container, c'est la div !
            container = div;
        }

        return container;
    },

    // ################################################################### //
    // ################## Geocoding results container #################### //
    // ################################################################### //

    /**
     * @returns {DOMElement} DOM element
     */
    _createGeocodeResultsHeaderElement: function _createGeocodeResultsHeaderElement() {
        var self = this;

        var container = document.createElement("div");
        container.className = "GPpanelHeader";

        var divTitle = document.createElement("div");
        divTitle.className = "GPpanelTitle";
        divTitle.innerHTML = "Résultats de la recherche";
        container.appendChild(divTitle);

        var divClose = document.createElement("div");
        divClose.id = this._addUID("GPgeocodeResultsClose");
        divClose.className = "GPpanelClose";
        divClose.title = "Fermer la fenêtre de résultats";

        if (divClose.addEventListener) {
            divClose.addEventListener("click", function () {
                document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "none";
            }, false);
        } else if (divClose.attachEvent) {
            divClose.attachEvent("onclick", function () {
                document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "none";
            });
        }
        container.appendChild(divClose);

        return container;
    },

    /**
     * Geocoding results list.
     *
     * @returns {DOMElement} DOM element
     */
    _createGeocodeResultsListElement: function _createGeocodeResultsListElement() {
        // contexte d'execution
        var self = this;

        var container = document.createElement("div");
        container.id = this._addUID("GPgeocodeResults");

        if (container.addEventListener) {
            container.addEventListener("click", function (e) {
                if (!e.ctrlKey) {
                    document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "none";
                }
                self.onGeocodedResultsItemClick(e);
            }, false);
        } else if (container.attachEvent) {
            container.attachEvent("onclick", function (e) {
                if (!e.ctrlKey) {
                    document.getElementById(self._addUID("GPgeocodeResultsList")).style.display = "none";
                }
                self.onGeocodedResultsItemClick(e);
            });
        }
        // Results are dynamically filled in Javascript by geocoding service
        // <div class="GPautoCompleteProposal">...</div>

        return container;
    },

    /**
     * Geocoding result.
     * Results are dynamically filled in Javascript by geocoding service
     *
     * TODO formaliser le contenu des reponses
     * FIXME formater la reponse en amont !
     *
     * @param {Object} location - suggested or geocoded location results
     * @param {Number} id - ID
     */
    _createGeocodedLocationElement: function _createGeocodedLocationElement(location, id) {
        var container = document.getElementById(this._addUID("GPgeocodeResults"));

        var div = document.createElement("div");
        div.id = this._addUID("GeocodedLocation_" + id);
        div.className = "GPautoCompleteProposal";

        if (typeof location === "string") {
            div.innerHTML = location;
        } else {
            var places = location.placeAttributes;

            if (places.freeform) {
                // reponse en freeForm
                div.innerHTML = places.freeform;
            } else if (places.postalCode) {
                // cas des StreetAddress, PositionOfInterest, Administratif
                // on affiche uniquement ce qui est commun aux ressources ...
                div.innerHTML = places.postalCode + " " + places.commune;
            } else if (places.cadastralParcel) {
                // cas des CadastralParcel
                div.innerHTML = places.cadastralParcel;
            } else {
                div.innerHTML = "...";
            }
        }

        container.appendChild(div);
    }
};

exports.default = SearchEngineDOM;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _Markers = __webpack_require__(5);

var _Markers2 = _interopRequireDefault(_Markers);

var _CheckRightManagement = __webpack_require__(7);

var _CheckRightManagement2 = _interopRequireDefault(_CheckRightManagement);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _MathUtils = __webpack_require__(39);

var _MathUtils2 = _interopRequireDefault(_MathUtils);

var _MousePositionDOM = __webpack_require__(40);

var _MousePositionDOM2 = _interopRequireDefault(_MousePositionDOM);

__webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("GeoportalMousePosition");

/**
 * @classdesc
 * MousePosition Control.
 *
 * @constructor
 * @alias ol.control.GeoportalMousePosition
 * @extends {ol.control.Control}
 * @param {Object} options - options for function call.
 * @param {Sting}   [options.apiKey] - API key, mandatory if autoconf service has not been charged in advance
 * @param {Boolean} [options.collapsed = true] - Specify if MousePosition control should be collapsed at startup. Default is true.
 * @param {Array}   [options.systems] - list of projection systems, default are Geographical ("EPSG:4326"), Web Mercator ("EPSG:3857"), Lambert 93 ("EPSG:2154") and extended Lambert 2 ("EPSG:27572").
 *      Each array element (=system) is an object with following properties :
 * @param {String}  options.systems.crs - Proj4 crs alias (from proj4 defs). e.g. : "EPSG:4326". Required
 * @param {String}  [options.systems.label] - CRS label to be displayed in control. Default is crs code (e.g. "EPSG:4326")
 * @param {String}  options.systems.type - CRS units type for coordinates conversion : "Geographical" or "Metric". Default: "Metric"
 * @param {Object}  [options.systems.geoBBox] - Aera covered by the system (WGS84 coordinates).
 * @param {Number}  options.systems.geoBBox.right - Right bound.
 * @param {Number}  options.systems.geoBBox.left - Left bound.
 * @param {Number}  options.systems.geoBBox.top - Top bound.
 * @param {Number}  options.systems.geoBBox.bottom - Bottom bound.
 * @param {Array}   [options.units] - list of coordinates units, to be displayed in control units list.
 *      Values may be "DEC" (decimal degrees), "DMS" (sexagecimal), "RAD" (radians) and "GON" (grades) for geographical coordinates,
 *      and "M" or "KM" for metric coordinates
 * @param {Array}   [options.displayAltitude = true] - activate (true) or deactivate (false) the altitude panel. True by default
 * @param {Array}   [options.displayCoordinates = true] - activate (true) or deactivate (false) the coordinates panel. True by default
 * @param {Boolean} [options.editCoordinates = false] - If true, coordinates from the MousePosition control can be edited by users to re-center the view. False by default.
 * @param {Object} [options.positionMarker] - options for position marker
 * @param {String} options.positionMarker.url - Marker url (define in src/Openlayers/Controls/Utils/Markers.js)
 * @param {Array} options.positionMarker.offset - Offsets in pixels used when positioning the marker towards targeted point.
 *      The first element in the array is the horizontal offset. A positive value shifts the marker right.
 *      The second element in the array is the vertical offset. A positive value shifts the marker down. [0,0] value positions the top-left corner of the marker image to the targeted point.
 *      Default is offset associated to default marker image.
 * @param {Boolean} options.positionMarker.hide - if true, marker is not displayed, otherwise displayed (False by default.)
 * @param {Object}  [options.altitude] - elevation configuration
 * @param {Object}  [options.altitude.serviceOptions] - options of elevation service
 * @param {Number}  [options.altitude.responseDelay] - latency for altitude request, 500 ms by default
 * @param {Number}  [options.altitude.triggerDelay] - immobilisation time of movement on the map to trigger the elevation calculation, 200 ms by default
 * @param {Number}  [options.altitude.noDataValue] - value used for altitude service no data (default is -99999). In this case, "---m" will be displayed instead of "-99999m"
 * @param {Number}  [options.altitude.noDataValueTolerance] - tolerance for no data value :
 *                  values in [noDataValue + noDataValueTolerance ; noDataValue - noDataValueTolerance] interval will not be displayed, but "---m" will be displayed instead.
 *                  Default is 90000 (no data values = [-9999 ; -189999])
 *  @example
 *  var MousePosition = new ol.control.GeoportalMousePosition({
 *      collapsed : false,
 *      displayCoordinates : true,
 *      displayAltitude : true,
 *      altitude : {
 *           triggerDelay : 100,
 *           responseDelay : 500,
 *           noDataValue : -99999,
 *           noDataValueTolerance : 99000,
 *           serviceOptions : {}
 *      },
 *      systems : [
 *       {
 *          crs : "EPSG:3857",
 *          label : "Web Mercator",
 *          type : "Metric"
 *        },
 *       {
 *          crs : "EPSG:4326",
 *          label : "Géographiques",
 *          type : "Geographical"
 *        }
 *      ],
 *      units : ["DEC", "DMS"]
 * });
 */
function MousePosition(options) {
    options = options || {};

    if (!(this instanceof MousePosition)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    this._initialize(options);

    // init control DOM container
    var container = this._initContainer(options);

    // call ol.control.Control constructor
    _ol2.default.control.Control.call(this, {
        element: container,
        target: options.target,
        render: options.render
    });
};

// Inherits from ol.control.Control
_ol2.default.inherits(MousePosition, _ol2.default.control.Control);

/**
 * @lends module:GeoportalMousePosition
 */
MousePosition.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les méthodes de la classe commune MousePositionDOM
_Utils2.default.assign(MousePosition.prototype, _MousePositionDOM2.default);

/**
 * Constructor (alias)
 *
 * @private
 */
MousePosition.prototype.constructor = MousePosition;

/**
 * Overload ol.control.Control setMap method, called when
 *
 * @param {Object} map - the map
 *
 */
MousePosition.prototype.setMap = function (map) {
    var context = this;

    if (map) {
        // dans le cas de l'ajout du contrôle à la map
        var center = this._createMapCenter();
        map.getViewport().appendChild(center);
        if (!this.collapsed && !this._isDesktop) {
            center.className = "GPmapCenterVisible";
        }

        // on met en place l'evenement sur la carte pour recuperer les coordonnées,
        // on l'active à l'ouverture du panneau uniquement !
        if (!this.collapsed) {
            // evenement valable pour le mode desktop !
            if (this._isDesktop) {
                map.on("pointermove", this.onMouseMove, this);
            } else {
                map.on("moveend", this.onMapMove, this);
            }
        }

        // add overlay only if option editCoordinates is true
        if (this.options.editCoordinates) {
            // création de l'élément DOM
            var markerDiv = document.createElement("img");
            markerDiv.id = this._addUID("GPmousePositionMarker");
            markerDiv.src = this._markerUrl;
            markerDiv.title = "Cliquer pour supprimer";
            markerDiv.addEventListener("click", function () {
                context._markerOverlay.setPosition(undefined);
            });

            this._markerOverlay = new _ol2.default.Overlay({
                offset: this._markerOffset,
                element: markerDiv,
                stopEvent: false
            });
            map.addOverlay(this._markerOverlay);
        }
    }

    // call original setMap method
    _ol2.default.control.Control.prototype.setMap.call(this, map);

    // nothing else to do if map == null
    if (map == null) {
        return;
    }

    // mode "collapsed"
    if (!this.collapsed) {
        var inputShow = document.getElementById("GPshowMousePosition-" + this._uid);
        inputShow.checked = "checked";
        this._setElevationPanel(this.options.displayAltitude);
        this._setCoordinatesPanel(this.options.displayCoordinates);
        if (!this.options.displayCoordinates) {
            this._setSettingsPanel(false);
        }
    }
};

// ################################################################### //
// #################### user interface methods ####################### //
// ################################################################### //

/**
 * Set additional projection system
 *
 * @method addSystem
 * @param {Object} system - projection system
 * @param {String} system.crs - Proj4 crs alias (from proj4 defs) e.g. "EPSG:4326"
 * @param {String} [system.label] - CRS label to be displayed in control. Default is system.crs alias
 * @param {String} [system.type] - CRS units type for coordinates conversion (one of control options.units). Default is "Metric"
 */
MousePosition.prototype.addSystem = function (system) {
    if ((typeof system === "undefined" ? "undefined" : _typeof(system)) !== "object") {
        logger.log("[ERROR] MousePosition:addSystem - system parameter should be an object");
        return;
    }
    if (!system.crs) {
        logger.error("crs not defined !");
        return;
    }
    if (!system.label) {
        logger.warn("crs label not defined, use crs code by default.");
        system.label = system.crs;
    }
    if (!system.type) {
        logger.warn("type srs not defined, use 'Metric' by default.");
        system.type = "Metric";
    }

    // 1. add system to control systems
    for (var j = 0; j < this._projectionSystems.length; j++) {
        var obj = this._projectionSystems[j];
        if (system.crs === obj.crs) {
            // warn user
            // logger.info("crs '{}' already configured", obj.crs);
        }
    }
    system.code = this._projectionSystems.length;
    this._projectionSystems.push(system);

    // 2. add system settings option to container (if it was already build)
    var selectSystem = document.getElementById("GPmousePositionProjectionSystem-" + this._uid);
    if (selectSystem) {
        var option = document.createElement("option");
        option.value = system.code;
        option.text = system.label;
        selectSystem.appendChild(option);
    }
};

/**
 * Set additional projection systems
 *
 * @param {Array} systems - Array of system object, with following properties :
 * @param {String} systems.crs - Proj4 CRS alias (from proj4 defs) e.g. "EPSG:4326"
 * @param {String} systems.label - CRS label (for coordinates conversion)
 * @param {String} systems.type - CRS units type to be displayed in control (one of control options.units). Default is "Metric"
 */
MousePosition.prototype.addSystems = function (systems) {
    if (!systems) {
        return;
    }
    if (!Array.isArray(systems)) {
        logger.log("[ERROR] MousePosition:addSystems - systems parameter should be an array");
        return;
    }
    for (var i = 0; i < systems.length; i++) {
        this.addSystem(systems[i]);
    }
};

/**
 * Remove projection system (in case there are several system with same code, only the first one will be removed)
 *
 * @param {String} systemCrs - CRS alias (from proj4 defs)
 */
MousePosition.prototype.removeSystem = function (systemCrs) {
    if (!systemCrs || typeof systemCrs !== "string") {
        logger.log("[ERROR] MousePosition:removeSystem - systemCode parameter should be a string");
        return;
    }

    var systemList = document.getElementById("GPmousePositionProjectionSystem-" + this._uid);

    var systemCode = null;
    // find system in control projection systems list
    for (var i = 0; i < this._projectionSystems.length; i++) {
        var proj = this._projectionSystems[i];
        if (systemCrs === proj.crs) {
            systemCode = proj.code;
            // remove system from control projection systems list
            this._projectionSystems.splice(i, 1);
            break;
        }
    }

    if (systemCode == null) {
        logger.log("[WARN] MousePosition:removeSystem - system not found");
        return;
    }

    /* re-initialization of codes */
    var oldNewCodeMap = [];

    for (var j = 0; j < this._projectionSystems.length; j++) {
        oldNewCodeMap[Number(this._projectionSystems[j].code)] = j;
        this._projectionSystems[j].code = j;
    }

    /* find system in control container systems list */
    var indexChildToRemove = null;

    for (var k = 0; k < systemList.childNodes.length; k++) {
        if (systemCode === systemList.childNodes[j].value) {
            indexChildToRemove = k;
            continue;
        }
        systemList.childNodes[j].value = oldNewCodeMap[Number(systemList.childNodes[j].value)];
    }
    /* remove system from control container systems list */
    if (indexChildToRemove != null) {
        systemList.removeChild(systemList.childNodes[indexChildToRemove]);
    }

    // choose arbitrarily a new current system if needed
    if (this._currentProjectionSystems.code === Number(systemCode)) {
        systemList.childNodes[0].setAttribute("selected", "selected");
        this._setCurrentSystem(systemList.childNodes[0].value);
    }
};

/**
 * Set control units (to be displayed)
 *
 * @param {Array} units - list of all coordinates units, to be displayed in control units list.
 *      Values may be "DEC" (decimal degrees), "DMS" (sexagecimal), "RAD" (radians) and "GON" (grades) for geographical coordinates,
 *      and "M" or "KM" for metric coordinates
 */
MousePosition.prototype.setUnits = function (units) {
    if (!units || !Array.isArray(units)) {
        return;
    }
    this.options.units = units;
    this._projectionUnits = [];
    this._initProjectionUnits();
    if (this._currentProjectionType) {
        this._setTypeUnitsPanel(this._currentProjectionType);
    }
};

/**
 * Set control altitude options (useless if displayAltitude == false)
 *
 * @param {Object} options - altitude options
 * @param {Object}  [options.serviceOptions] - options of elevation service
 * @param {Number}  [options.responseDelay] - latency for elevation request, 500 ms by default
 * @param {Number}  [options.triggerDelay] - immobilisation time of movement on the map to trigger the elevation calculation, 200 ms by default
 */
MousePosition.prototype.setAltitudeOptions = function (options) {
    if (!options || (typeof options === "undefined" ? "undefined" : _typeof(options)) !== "object") {
        return;
    }
    this.options.altitude.triggerDelay = options.triggerDelay;
    this.options.altitude.responseDelay = options.responseDelay;
    if (options.serviceOptions) {
        for (var opt in options.serviceOptions) {
            if (options.serviceOptions.hasOwnProperty(opt)) {
                this.options.altitude.serviceOptions[opt] = options.serviceOptions[opt];
            }
        }
    }
};

/**
 * Display or hide elevation panel
 *
 * @param {Boolean} displayAltitude - true to display elevation panel, false to hide it
 */
MousePosition.prototype.displayAltitude = function (displayAltitude) {
    if (displayAltitude === undefined) {
        return;
    }
    if (typeof this._noRightManagement === "undefined") {
        this._checkRightsManagement();
    }
    this.options.displayAltitude = displayAltitude;
    this._setElevationPanel(displayAltitude);
};

/**
 * Display or hide coordinates panel
 *
 * @param {Boolean} displayCoordinates - true to display coordinates panel, false to hide it
 */
MousePosition.prototype.displayCoordinates = function (displayCoordinates) {
    if (displayCoordinates === undefined) {
        return;
    }
    this.options.displayCoordinates = displayCoordinates;
    this._setCoordinatesPanel(displayCoordinates);
    this._setSettingsPanel(displayCoordinates);
};

/**
 * Collapse or display control main container
 *
 * @param {Boolean} collapsed - True to collapse control, False to display it
 */
MousePosition.prototype.setCollapsed = function (collapsed) {
    if (collapsed === undefined) {
        logger.log("[ERROR] MousePosition:setCollapsed - missing collapsed parameter");
        return;
    }
    if (collapsed && this.collapsed || !collapsed && !this.collapsed) {
        return;
    }
    if (!this._isDesktop) {
        document.getElementById("GPmapCenter").className = collapsed ? "" : "GPmapCenterVisible";
    }
    // on simule l'ouverture du panneau après un click
    this.onShowMousePositionClick();
    this._showMousePositionContainer.checked = !collapsed;
};

// ################################################################### //
// ######################## initialize control ####################### //
// ################################################################### //

/**
 * Initialize control (called by MousePosition constructor)
 *
 * @method _initialize
 * @param {Object} options - control options (set by user)
 * @private
 */
MousePosition.prototype._initialize = function (options) {
    // Set default options
    // {Object} control options - set by user or by default
    this.options = options || {};
    this.options.collapsed = options.collapsed !== undefined ? options.collapsed : true;
    /** {Boolean} specify if MousePosition control is collapsed (true) or not (false) */
    this.collapsed = this.options.collapsed;

    // position marker
    this._markerOverlay = null;
    this._markerUrl = null;
    this._markerOffset = [0, 0];
    this._hideMarker = false;
    this._initMarker(options.positionMarker);

    this.options.units = options.units || [];
    this.options.displayAltitude = options.displayAltitude !== undefined ? options.displayAltitude : true;
    this.options.displayCoordinates = options.displayCoordinates !== undefined ? options.displayCoordinates : true;
    if (this.options.displayCoordinates) {
        this.options.editCoordinates = options.editCoordinates !== undefined ? options.editCoordinates : false;
    } else {
        // si les coordonnées ne sont pas affichées : pas besoin de les éditer...
        this.options.editCoordinates = false;
    }
    this.editing = false;

    this.options.systems = options.systems || [];
    if (options.altitude) {
        var altitude = options.altitude;
        this.options.altitude = {
            triggerDelay: altitude.triggerDelay !== undefined ? altitude.triggerDelay : 200,
            responseDelay: altitude.responseDelay !== undefined ? altitude.responseDelay : 500,
            serviceOptions: altitude.serviceOptions || {},
            noDataValue: altitude.noDataValue !== undefined ? altitude.noDataValue : -99999,
            noDataValueTolerance: altitude.noDataValueTolerance !== undefined ? altitude.noDataValueTolerance : 90000
        };
    } else {
        this.options.altitude = {
            triggerDelay: 200,
            responseDelay: 500,
            serviceOptions: {}
        };
    }

    // identifiant du contrôle : utile pour suffixer les identifiants CSS (pour gérer le cas où il y en a plusieurs dans la même page)
    this._uid = _SelectorID2.default.generate();

    // initialisation des systemes de projections
    this._projectionSystems = [];
    this._initProjectionSystems();

    // initialisation des systemes des unités
    this._projectionUnits = {};
    this._initProjectionUnits();

    // detection du support : desktop ou tactile
    this._isDesktop = _Utils2.default.detectSupport();

    // on met en place un seuil sur le timer
    if (this.options.altitude.triggerDelay < 100) {
        this.options.altitude.triggerDelay = 100;
    }

    // {Number} timer on movestopped delay (altitude calculation)
    this._timer = this.options.altitude.triggerDelay;

    // {Object} Selected projection system
    this._currentProjectionSystems = this._projectionSystems[0];

    // {String} Selected projection units typs : Geographical or metric
    this._currentProjectionType = this._projectionSystems[0].type;

    // {String} Selected projection unit
    this._currentProjectionUnits = this._projectionUnits[this._currentProjectionType][0].code;

    // {Object} Projection units container (DOM Element)
    this._projectionUnitsContainer = null;

    // {Object} control panel container (DOM Element)
    this._showMousePositionContainer = null;

    // gestion de l'affichage du panneau de l'altitude
    if (!this.options.displayAltitude && !this.options.displayCoordinates) {
        // on reactive l'affichage des coordonnées, pour ne pas afficher un panneau vide !
        this.options.displayCoordinates = true;
    }

    // gestion des droits sur les ressources/services
    // si l'on souhaite un calcul d'altitude, on verifie les droits sur les ressources d'alti...
    if (this.options.displayAltitude) {
        this._checkRightsManagement();
    }
};

/**
 *
 * @param {Object} option - positionMarker option
 * @private
 */
MousePosition.prototype._initMarker = function (option) {
    if (!this.options.editCoordinates) {
        return;
    }

    if (!option) {
        this._markerUrl = _Markers2.default["lightOrange"];
        this._markerOffset = _Markers2.default.defaultOffset;
        return;
    }

    // hide
    this._hideMarker = option.hide !== undefined ? option.hide : false;

    // offset
    if (option.offset) {
        if (Array.isArray(option.offset) && option.offset.length === 2) {
            this._markerOffset = option.offset;
        } else {
            logger.log("positionMarker.offset should be an array. e.g. : [0,0]");
            this._markerOffset = _Markers2.default.defaultOffset;
        }
    } else {
        this._markerOffset = _Markers2.default.defaultOffset;
    }

    var url = option.url;
    if (!url) {
        this._markerUrl = _Markers2.default["lightOrange"];
    } else if (url.match(/^[a-zA-Z]+$/)) {
        // un seul mot
        this._markerUrl = _Markers2.default[url] !== undefined ? _Markers2.default[url] : _Markers2.default["lightOrange"];
    } else {
        this._markerUrl = url;
    }
};

/**
 * this method is called by the constructor and initialize the projection
 * systems.
 * getting coordinates in the requested projection :
 * see this.onMousePositionProjectionSystemChange()
 *
 * @method _initProjectionSystems
 * @private
 */
MousePosition.prototype._initProjectionSystems = function () {
    // on donne la possibilité à l'utilisateur de modifier
    // la liste des systèmes à afficher
    // Ex. this.options.systems

    // systemes de projection disponible par defaut
    var projectionSystemsByDefault = [{
        label: "G\xE9ographique",
        crs: _ol2.default.proj.get("EPSG:4326").getCode(),
        type: "Geographical"
    }, {
        label: "Web Mercator",
        crs: _ol2.default.proj.get("EPSG:3857").getCode(),
        type: "Metric"
    }, {
        label: "Lambert 93",
        crs: _ol2.default.proj.get("EPSG:2154").getCode(),
        type: "Metric",
        geoBBox: {
            left: -9.86,
            bottom: 41.15,
            right: 10.38,
            top: 51.56
        }
    }, {
        label: "Lambert II \xE9tendu",
        crs: _ol2.default.proj.get("EPSG:27572"),
        type: "Metric",
        geoBBox: {
            left: -4.87,
            bottom: 42.33,
            right: 8.23,
            top: 51.14
        }
    }];

    var systems = this.options.systems;
    for (var i = 0; i < systems.length; i++) {
        /* definition d'un systeme de reference */
        var sys = systems[i];
        this.addSystem(sys);
    }

    if (this._projectionSystems.length === 0) {
        // on ajoute les systèmes de projections par défaut
        for (var j = 0; j < projectionSystemsByDefault.length; j++) {
            this.addSystem(projectionSystemsByDefault[j]);
        }
    }
};

/**
 * this method is called by the constructor and initialize the units.
 * getting coordinates in the requested units :
 * see this.onMousePositionProjectionUnitsChange()
 *
 * @method _initProjectionUnits
 * @private
 */
MousePosition.prototype._initProjectionUnits = function () {
    // on donne la possibilité à l'utilisateur de modifier
    // la liste des unités à afficher
    // Ex.
    // this.options.units : ["DEC", "DMS"]

    // unités disponible par defaut
    var projectionUnitsByDefault = {
        Geographical: [{
            code: "DEC",
            label: "degrés décimaux",
            format: this._displayDEC
        }, {
            code: "DMS",
            label: "degrés sexagésimaux",
            format: this._displayDMS
        }, {
            code: "RAD",
            label: "radians",
            format: this._displayRAD
        }, {
            code: "GON",
            label: "grades",
            format: this._displayGON
        }],
        Metric: [{
            code: "M",
            label: "mètres",
            format: this._displayMeter
        }, {
            code: "KM",
            label: "kilomètres",
            format: this._displayKMeter
        }]
    };

    var units = this.options.units;

    for (var type in projectionUnitsByDefault) {
        if (projectionUnitsByDefault.hasOwnProperty(type)) {
            var found = false;
            for (var j = 0; j < projectionUnitsByDefault[type].length; j++) {
                var obj = projectionUnitsByDefault[type][j];
                for (var i = 0; i < units.length; i++) {
                    var unit = units[i];
                    if (obj.code === unit) {
                        found = true;
                        if (!this._projectionUnits[type]) {
                            this._projectionUnits[type] = [];
                        }
                        this._projectionUnits[type].push(obj);
                    }
                }
            }
            if (!found) {
                this._projectionUnits[type] = projectionUnitsByDefault[type];
            }
        }
    }

    // au cas où...
    if (_typeof(this._projectionUnits) === "object" && Object.keys(this._projectionUnits).length === 0) {
        this._projectionUnits = projectionUnitsByDefault;
    }
};

/**
 * this method get label from the current projection units
 *
 * @method _getCurrentProjectionInformation
 *
 * @returns {String} projection information
 *
 * @private
 */
MousePosition.prototype._getCurrentProjectionInformation = function () {
    var systemInfo = [this._currentProjectionSystems.label, "en"];

    var units = this._projectionUnits[this._currentProjectionType];
    for (var u = 0; u < units.length; ++u) {
        if (units[u].code === this._currentProjectionUnits) {
            systemInfo.push(units[u].label);
            break;
        }
    }
    return systemInfo.join(" ");
};

/**
 * this method is called by constructor
 * and check the rights to resources
 *
 * @method _checkRightsManagement
 * @private
 */
MousePosition.prototype._checkRightsManagement = function () {
    var rightManagement = _CheckRightManagement2.default.check({
        key: this.options.apiKey,
        resources: ["SERVICE_CALCUL_ALTIMETRIQUE_RSC"],
        services: ["Elevation"]
    });

    this._noRightManagement = !rightManagement;

    // on recupère les informations utiles
    // sur ce controle, on ne s'occupe pas de la ressource car elle est unique...
    // Ex. la clef API issue de l'autoconfiguration si elle n'a pas
    // été renseignée.
    if (!this.options.apiKey) {
        this.options.apiKey = rightManagement.key;
    }
};

// ################################################################### //
// ######################## methods handle dom ####################### //
// ################################################################### //

/**
 * Create control main container (called by MousePosition constructor)
 *
 * @method _initContainer
 *
 * @returns {DOMElement} DOM element
 *
 * @private
 */
MousePosition.prototype._initContainer = function () {
    // creation du container principal
    var container = this._createMainContainerElement();

    var inputShow = this._showMousePositionContainer = this._createShowMousePositionElement();
    container.appendChild(inputShow);

    var picto = this._createShowMousePositionPictoElement(this._isDesktop);
    container.appendChild(picto);

    var panel = this._createMousePositionPanelElement(this.options.displayAltitude, this.options.displayCoordinates, this.options.editCoordinates, this._currentProjectionUnits);
    var settings = this._createMousePositionSettingsElement();
    var systems = this._projectionSystemsContainer = this._createMousePositionSettingsSystemsElement(this._projectionSystems);
    var units = this._projectionUnitsContainer = this._createMousePositionSettingsUnitsElement(this._projectionUnits[this._currentProjectionType]);

    settings.appendChild(systems);
    settings.appendChild(units);
    panel.appendChild(settings);
    container.appendChild(panel);

    return container;
};

/**
 * this method is called by this.()
 * and it changes the elevation view panel into the dom.
 *
 * @method _setElevationPanel
 * @param {Boolean} active - true:active, false:disable
 * @private
 */
MousePosition.prototype._setElevationPanel = function (active) {
    var div = null;

    if (!active) {
        div = document.getElementById("GPmousePositionAltitude-" + this._uid);
        div.style.display = "none";
    } else {
        if (this._noRightManagement) {
            div = document.getElementById("GPmousePositionAlt-" + this._uid);
            div.innerHTML = "No rights!";
        } else {
            div = document.getElementById("GPmousePositionAltitude-" + this._uid);
            div.style.display = "";
        }
    }
};

/**
 * this method is called by this.()
 * and it changes the coordinate view panel into the dom.
 *
 * @method _setCoordinatesPanel
 * @param {Boolean} active - true:active, false:disable
 * @private
 */
MousePosition.prototype._setCoordinatesPanel = function (active) {
    var div = document.getElementById("GPmousePositionCoordinate-" + this._uid);
    if (!active) {
        div.style.display = "none";
    } else {
        div.style.display = "";
    }
};

/**
 * this method is called by this.()
 * and it changes the settings view panel into the dom.
 *
 * @method _setSettingsPanel
 * @param {Boolean} active - true:active, false:disable
 * @private
 */
MousePosition.prototype._setSettingsPanel = function (active) {
    var divPicto = document.getElementById("GPshowMousePositionSettingsPicto-" + this._uid);
    var divPanel = document.getElementById("GPmousePositionSettings-" + this._uid);
    if (!active) {
        divPicto.style.display = "none";
        divPanel.style.display = "none";
    } else {
        divPicto.style.display = "";
        divPanel.style.display = "";
    }
};

/**
 * this method is called by this.onMousePositionProjectionSystemChange()
 * when changes to a metric or a geographical units.
 *
 * @method _setTypeUnitsPanel
 * @param {String} type - Geographical or Metric
 * @private
 */
MousePosition.prototype._setTypeUnitsPanel = function (type) {
    var container = this._projectionUnitsContainer;

    // on supprime les enfants...
    while (container.firstChild) {
        container.removeChild(container.firstChild);
    }

    var units = this._projectionUnits[type];
    for (var j = 0; j < units.length; j++) {
        var obj = units[j];
        var option = document.createElement("option");
        option.value = obj.code ? obj.code : j;
        option.text = obj.label || j;
        // option.label = obj.label;
        container.appendChild(option);
    }

    var projectionUnits = this._projectionUnits[type][0].code;

    if (this._currentProjectionUnits === "DMS" || projectionUnits === "DMS") {
        this._resetCoordinateElements(this.options.editCoordinates, type, projectionUnits);
        this._setEditMode(this.editing);
    }

    // le nouveau type de system ...
    this._currentProjectionType = type;

    // Mise a jour des elements labels et unites
    this._resetLabelElements(type);
    this._resetUnitElements(projectionUnits);

    // et comme on a changé de type de systeme,
    // il faut changer aussi d'unité !
    this._currentProjectionUnits = projectionUnits;
};

// ################################################################### //
// ######################## method units format ###################### //
// ################################################################### //

/**
 * degreedecimal
 *
 * @method _displayDEC
 * @param {Array} olCoordinate - ol.Coordinate object [lon, lat]
 * @return {Object} coordinate - coordinate object : {lat : 48, lng : 2} par exemple
 * @private
 */
MousePosition.prototype._displayDEC = function (olCoordinate) {
    var coordinate = {};
    coordinate.lat = olCoordinate[1].toFixed(6);
    coordinate.lng = olCoordinate[0].toFixed(6);
    coordinate.unit = "°";
    return coordinate;
};

/**
 * degreedecimal2sexagecimal
 *
 * @method _displayDMS
 * @param {Array} olCoordinate - ol.Coordinate object [lon, lat]
 * @return {Object} coordinate - coordinate object : {lng : "2° 00′ 00″ E", lat : "48° 00′ 00″ N"} par exemple
 * @private
 */
MousePosition.prototype._displayDMS = function (olCoordinate) {
    return {
        lng: _MathUtils2.default.decimalToDMS(olCoordinate[0], "EO", 2),
        lat: _MathUtils2.default.decimalToDMS(olCoordinate[1], "NS", 2),
        unit: "DMS"
    };
};

/**
 * degreedecimal2radian
 *
 * @method _displayRAD
 * @param {Array} olCoordinate - ol.Coordinate object [lon, lat]
 * @return {Object} coordinate - coordinate object : {lng : "0.02837864", lat : "0.84300269"} par exemple
 * @private
 */
MousePosition.prototype._displayRAD = function (olCoordinate) {
    var coordinate = {};
    var d = 0.01745329251994329577;
    coordinate.lng = olCoordinate[0] * d;
    coordinate.lng = coordinate.lng.toFixed(8);
    coordinate.lat = olCoordinate[1] * d;
    coordinate.lat = coordinate.lat.toFixed(8);
    coordinate.unit = "rad";
    return coordinate;
};

/**
 * degreedecimal2grade
 *
 * @method _displayGON
 * @param {Array} olCoordinate - ol.Coordinate object [lon, lat]
 * @return {Object} coordinate - coordinate object : {lng : "4.09545898", lat : "53.68751528"} par exemple
 * @private
 */
MousePosition.prototype._displayGON = function (olCoordinate) {
    var coordinate = {};
    var d = 1.11111111111111111111;
    coordinate.lng = olCoordinate[0] * d;
    coordinate.lng = coordinate.lng.toFixed(8);
    coordinate.lat = olCoordinate[1] * d;
    coordinate.lat = coordinate.lat.toFixed(8);
    coordinate.unit = "gon";
    return coordinate;
};

/**
 * meter
 *
 * @method _displayMeter
 * @param {Array} olCoordinate - ol.Coordinate object [lon, lat]
 * @return {Object} coordinate - coordinate object : {x : "148593.58", y : "6176560.95"} par exemple
 * @private
 */
MousePosition.prototype._displayMeter = function (olCoordinate) {
    // on recoit toujours des coordonnées metriques
    var coordinate = {};
    coordinate.x = olCoordinate[0].toFixed(2);
    coordinate.y = olCoordinate[1].toFixed(2);
    coordinate.unit = "m";
    return coordinate;
};

/**
 * kilometer
 *
 * @method _displayKMeter
 * @param {Array} olCoordinate - ol.Coordinate object [lon, lat]
 * @return {Object} coordinate - coordinate object : {x : "214.96", y : "6250.09"} par exemple
 * @private
 */
MousePosition.prototype._displayKMeter = function (olCoordinate) {
    var coordinate = {};
    coordinate.x = (olCoordinate[0] / 1000).toFixed(2);
    coordinate.y = (olCoordinate[1] / 1000).toFixed(2);
    coordinate.unit = "km";
    return coordinate;
};

// ################################################################### //
// ##################### handlers events to control ################## //
// ################################################################### //

/**
 * this sends the coordinates to the panel.
 * (cf. this.GPdisplayCoords() into the DOM functions)
 *
 * @method _setCoordinate
 * @param {Array} olCoordinate - ol.Coordinate object [lon, lat]
 * @param {Object} crs - coordinate CRS (ol.proj.Projection)
 * @private
 */
MousePosition.prototype._setCoordinate = function (olCoordinate, crs) {
    // structure
    // ol.Coordinate
    //      [
    //          4   // lon
    //          48  // lat
    //      ]

    // structure pour les coordonnées en fonctin du type demandé :
    // {x:, y:, unit:} ou {lng:, lat:} ou {lon:, lat:} ou {e:, n:, unit:}...
    var coordinate = {};
    // on projete le point dans le systeme demandé
    var oSrs = this._currentProjectionSystems.crs;
    if (!oSrs) {
        logger.log("ERROR : system crs not found");
        return;
    }
    // on reprojette les coordonnées depuis leur CRS d'origine (CRS) vers le CRS demandé (oSrs)
    olCoordinate = _ol2.default.proj.transform(olCoordinate, crs, oSrs);

    // type de systeme : Geographical ou Metric
    var type = this._currentProjectionSystems.type;

    // on recherche la fonction de formatage dans l'unité demandée
    var format = null;
    var units = this._projectionUnits[type];
    for (var i = 0; i < units.length; i++) {
        if (units[i].code === this._currentProjectionUnits) {
            format = units[i].format;
            break;
        }
    }
    if (!format || typeof format !== "function") {
        logger.log("WARNING : coordinates format function not found");
        return;
    } else {
        coordinate = format(olCoordinate);
    }

    if (!coordinate || Object.keys(coordinate).length === 0) {
        return;
    }

    this.GPdisplayCoords(coordinate);
};

/**
 * this sends the coordinates to the panel.
 * (cf. this.GPdisplayElevation() into the DOM functions)
 *
 * @method _setElevation
 * @param {Array} olCoordinate - ol.Coordinate object [lon, lat]
 * @private
 */
MousePosition.prototype._setElevation = function (olCoordinate) {
    // gestion du timer de la requete du service d'altitude
    var delay = this.options.altitude.responseDelay;
    var noDataValue = this.options.altitude.noDataValue;
    var noDataValueTolerance = this.options.altitude.noDataValueTolerance;
    this.GPdisplayElevation(olCoordinate, delay, noDataValue, noDataValueTolerance);
};

/**
 * this method is triggered when the mouse or the map is stopped.
 * (cf. onMouseMove and onMapMove)
 *
 * @method onMoveStopped
 * @param {Array} olCoordinate - ol.Coordinate object [lon, lat]
 * @param {Object} crs - coordinate CRS (ol.proj.Projection)
 * @private
 */
MousePosition.prototype.onMoveStopped = function (olCoordinate, crs) {
    // reprojection en CRS:84 (EPSG:4326) pour le calcul alti
    var oLatLng = _ol2.default.proj.transform(olCoordinate, crs, "EPSG:4326");
    this._setElevation(oLatLng);
};

/**
 * this method is an handler event to control. The event is 'mousemove' on
 * the map. The handler sends the coordinates to the panel.
 * (cf. this.GPdisplayCoords() into the DOM functions)
 *
 * @method onMouseMove
 * @param {Object} e - HTMLElement
 * @private
 */
MousePosition.prototype.onMouseMove = function (e) {
    var self = this;

    // info: coordinate = [x, y]
    var coordinate = e.coordinate;
    if (!e.map || !e.map.getView()) {
        return;
    }
    var crs = e.map.getView().getProjection();

    this._setCoordinate(coordinate, crs);

    // calcul de l'altitude après un certain délai après l'arrêt du mouvement de la souris
    clearTimeout(this._timer);
    this._timer = setTimeout(function () {
        self.onMoveStopped(coordinate, crs);
    }, this.options.altitude.triggerDelay);
};

/**
 * this method is an handler event to control. The event is 'moveend' on
 * the map. The handler sends the coordinates to the panel.
 * (cf. this.GPdisplayCoords() into the DOM functions)
 *
 * @method onMapMove
 * @private
 */
MousePosition.prototype.onMapMove = function () {
    var self = this;

    var map = this.getMap();
    if (!map || !map.getView()) {
        return;
    }
    var view = map.getView();
    var coordinate = view.getCenter();
    var crs = view.getProjection();

    this._setCoordinate(coordinate, crs);

    // calcul de l'altitude après un certain délai après l'arrêt du mouvement de la souris
    clearTimeout(this._timer);
    this._timer = setTimeout(function () {
        self.onMoveStopped(coordinate, crs);
    }, this.options.altitude.triggerDelay);
};

// ################################################################### //
// ####################### handlers events to dom #################### //
// ################################################################### //

/**
 * this method is called by this.GPdisplayElevation() in the dom, and
 * it executes a request to the elevation service.
 *
 * @method onRequestAltitude
 * @param {Object} coordinate - {lat:..., lng:...}
 * @param {Function} callback - callback
 * @private
 */
MousePosition.prototype.onRequestAltitude = function (coordinate, callback) {
    // INFORMATION
    // on effectue la requête au service d'altitude...
    // on met en place des callbacks afin de recuperer les resultats ou
    // les messages d'erreurs du service.
    // le resultat est affiché dans une balise du dom.

    if (!coordinate || Object.keys(coordinate).length === 0) {
        return;
    }

    // si on ne veut pas de calcul d'altitude, on ne continue pas !
    if (!this.options.displayAltitude) {
        return;
    }

    // si on n'a pas les droits sur la ressource, pas la peine de
    // continuer !
    if (this._noRightManagement) {
        logger.log("[WARNING] contract key configuration has no rights to load geoportal elevation ");
        document.getElementById("GPmousePositionAlt-" + this._uid).innerHTML = "No rights!";
        return;
    }

    // on recupere les options du service
    var options = this.options.altitude.serviceOptions || {};

    // gestion du protocole et du timeout
    // le timeout est indispensable sur le protocole JSONP.
    var _protocol = options.protocol || "XHR";
    var _timeout = options.timeOut || 0;
    if (_protocol === "JSONP" && _timeout === 0) {
        _timeout = 15000;
    }

    // ainsi que les coordonnées
    var _zonly = true;
    var _positions = [{
        lon: coordinate[0],
        lat: coordinate[1]
    }];

    // et les callbacks
    var _scope = this;
    var _rawResponse = options.rawResponse || false;
    var _onSuccess = null;
    var _onFailure = null;

    if (!_rawResponse) {
        // dans le cas général
        // callback onSuccess
        _onSuccess = function _onSuccess(results) {
            if (results && Object.keys(results)) {
                callback.call(this, results.elevations[0].z);
            }
        };
    } else {
        // callback onSuccess
        _onSuccess = function _onSuccess(results) {
            logger.log("alti service raw response : ", results);
        };
    }

    // callback onFailure
    _onFailure = function _onFailure(error) {
        logger.log("[getAltitude] ERROR : " + error.message);
    };

    // cas où la clef API n'est pas renseignée dans les options du service,
    // on utilise celle de l'autoconf ou celle renseignée au niveau du controle
    var _apiKey = options.apiKey || this.options.apiKey;

    _gp2.default.Services.getAltitude({
        apiKey: _apiKey,
        protocol: _protocol,
        timeOut: _timeout,
        scope: _scope,
        rawResponse: _rawResponse,
        onSuccess: _onSuccess,
        onFailure: _onFailure,
        zonly: _zonly,
        positions: _positions
    });
};

/**
 * this method is called by event 'click' on 'GPshowMousePositionPicto' tag label
 * (cf. this._createShowMousePositionPictoElement),
 * and toggles event 'mousemove' on map.
 *
 * @method onShowMousePositionClick
 * @private
 */
MousePosition.prototype.onShowMousePositionClick = function () {
    // checked : true - panel close
    // checked : false - panel open
    var map = this.getMap();
    this.collapsed = this._showMousePositionContainer.checked;
    // on génère nous même l'evenement OpenLayers de changement de propriété
    // (utiliser mousePosition.on("change:collapsed", function(e) ) pour s'abonner à cet évènement)
    this.dispatchEvent("change:collapsed");

    // evenement declenché à l'ouverture/fermeture du panneau,
    // et en fonction du mode : desktop ou tactile !
    if (this._showMousePositionContainer.checked) {
        if (this._isDesktop) {
            map.un("pointermove", this.onMouseMove, this);
        } else {
            map.un("moveend", this.onMapMove, this);
        }
    } else if (!this.editing) {
        if (this._isDesktop) {
            map.on("pointermove", this.onMouseMove, this);
        } else {
            map.on("moveend", this.onMapMove, this);
            // on simule un deplacement en mode tactile
            this.onMapMove();
        }
    }

    // FIXME
    // on gère l'affichage des panneaux ici..., même si ce n'est pas l'endroit
    // adequate...
    this._setElevationPanel(this.options.displayAltitude);
    this._setCoordinatesPanel(this.options.displayCoordinates);
    if (!this.options.displayCoordinates) {
        this._setSettingsPanel(false);
    }
};

/**
 * this method is called by event 'click' on input coordinate
 *
 * @method onMousePositionEditModeClick
 * @param {Boolean} editing - editing mode
 */
MousePosition.prototype.onMousePositionEditModeClick = function (editing) {
    if (!this.options.editCoordinates) {
        return;
    }
    if (this.editing === editing) {
        return;
    }

    this.editing = editing;

    // Affichage des outils, input en ecriture
    this._setEditMode(this.editing);

    var map = this.getMap();
    if (this._isDesktop) {
        if (this.editing) {
            // Unlisten for 'pointermove' events
            map.un("pointermove", this.onMouseMove, this);
        } else {
            // Listen for 'pointermove' events
            map.on("pointermove", this.onMouseMove, this);
            // on simule un deplacement
            this.onMapMove();
        }
    } else {
        if (this.editing) {
            // Unlisten for 'moveend' events
            map.un("moveend", this.onMapMove, this);
        } else {
            // Listen for moveend' events
            map.on("moveend", this.onMapMove, this);
            // on simule un deplacement
            this.onMapMove();
        }
    }

    // clear _markerOverlay
    if (!this.editing && this._markerOverlay) {
        this._markerOverlay.setPosition(undefined);
    }
};

/**
 * Get coordinate from inputs and select in decimal degrees
 *
 * @method getCoordinate
 * @param {String} coordType - "Lon" or "Lat"
 * @returns {undefined}
 * @private
 */
MousePosition.prototype.getCoordinate = function (coordType) {
    var inputDegrees = document.getElementById(this._addUID("GPmousePosition" + coordType + "Degrees"));
    var degrees = inputDegrees.value;
    if (!degrees) {
        return null;
    }

    degrees = degrees.replace(",", ".");
    if (!_MathUtils2.default.isInteger(degrees)) {
        return null;
    }

    var result = _MathUtils2.default.toInteger(degrees);
    if (result < Number(inputDegrees.dataset.min) || result > Number(inputDegrees.dataset.max)) {
        return null;
    }

    var direction = document.getElementById(this._addUID("GPmousePosition" + coordType + "Direction")).value;

    var inputMinutes = document.getElementById(this._addUID("GPmousePosition" + coordType + "Minutes"));
    var minutes = inputMinutes.value;
    if (minutes) {
        minutes = minutes.replace(",", ".");
        if (_MathUtils2.default.isInteger(minutes)) {
            var mins = _MathUtils2.default.toInteger(minutes);
            if (mins >= Number(inputMinutes.dataset.min) && mins <= Number(inputMinutes.dataset.max)) {
                result += mins / 60;
            }
        }
    }

    var inputSeconds = document.getElementById(this._addUID("GPmousePosition" + coordType + "Seconds"));
    var seconds = inputSeconds.value;
    if (seconds) {
        seconds = seconds.replace(",", ".");
        var secs = _MathUtils2.default.toFloat(seconds);
        if (secs && secs >= Number(inputSeconds.dataset.min) && secs <= Number(inputSeconds.dataset.max)) {
            result += secs / 3600;
        }
    }

    if (direction === "O" || direction === "S") {
        result = -result;
    }

    return result;
};

/**
 * locate DMS coordinates on map
 *
 * @method locateDMSCoordinates
 * @private
 */
MousePosition.prototype.locateDMSCoordinates = function () {
    var lonlat = [this.getCoordinate("Lon"), this.getCoordinate("Lat")];

    if (lonlat[0] === null || lonlat[1] === null) {
        return;
    }

    var oSrs = this._currentProjectionSystems.crs;
    if (!oSrs) {
        logger.log("ERROR : system crs not found");
        return;
    }

    var view = this.getMap().getView();

    var coordinate = _ol2.default.proj.transform(lonlat, oSrs, view.getProjection());
    view.setCenter(coordinate);

    if (this._markerOverlay && !this._hideMarker) {
        this._markerOverlay.setPosition(coordinate);
    }
};

/**
 * locate coordinates on map (not DMS)
 *
 * @method locateCoordinates
 * @private
 */
MousePosition.prototype.locateCoordinates = function () {
    var lon = document.getElementById(this._addUID("GPmousePositionLon")).value;

    lon = lon.replace(",", ".");
    lon = _MathUtils2.default.toFloat(lon);
    if (lon === null) {
        return;
    }

    var lat = document.getElementById(this._addUID("GPmousePositionLat")).value;
    lat = lat.replace(",", ".");
    lat = _MathUtils2.default.toFloat(lat);
    if (lat === null) {
        return;
    }

    var oSrs = this._currentProjectionSystems.crs;
    if (!oSrs) {
        logger.log("ERROR : system crs not found");
        return;
    }

    var xy;
    if (this._currentProjectionSystems.type === "Geographical") {
        xy = [this.convert(lon), this.convert(lat)];
    } else {
        xy = [this.convert(lat), this.convert(lon)];
    }
    var xyWGS84 = _ol2.default.proj.transform(xy, this._currentProjectionSystems.crs, "EPSG:4326");

    var geoBBox = this._currentProjectionSystems.geoBBox;
    if (geoBBox) {
        // check if coordinates are in the extent
        var extent = [geoBBox.left, geoBBox.bottom, geoBBox.right, geoBBox.top];
        if (xyWGS84[0] < extent[0] || xyWGS84[0] > extent[2]) {
            return;
        }
        if (xyWGS84[1] < extent[1] || xyWGS84[1] > extent[3]) {
            return;
        }
    }

    var view = this.getMap().getView();

    var coordinate = _ol2.default.proj.transform(xy, oSrs, view.getProjection());
    view.setCenter(coordinate);

    if (this._markerOverlay && !this._hideMarker) {
        this._markerOverlay.setPosition(coordinate);
    }
};

/**
 * locate coordinates on map
 *
 * @method locate
 * @private
 */
MousePosition.prototype.onMousePositionEditModeLocateClick = function () {
    if (!this.options.editCoordinates) {
        return;
    }
    if (!this.editing) {
        this.onMousePositionEditModeClick(true);
        return;
    }

    if (this._currentProjectionUnits === "DMS") {
        this.locateDMSCoordinates();
    } else {
        this.locateCoordinates();
    }
};

/**
 * this method is called by event 'change' on 'GPmousePositionProjectionSystem'
 * tag select (cf. this._createMousePositionSettingsElement),
 * and selects the system projection.
 *
 * @method onMousePositionProjectionSystemChange
 * @param {Object} e - HTMLElement
 * @private
 */
MousePosition.prototype.onMousePositionProjectionSystemChange = function (e) {
    var idx = e.target.selectedIndex; // index
    var value = e.target.options[idx].value; // crs

    this._setCurrentSystem(value);
};

/**
 * this method selects the current system projection.
 *
 * @method _setCurrentSystem
 * @param {String} systemCode - inner code (rank in array _projectionSystems)
 * @private
 */
MousePosition.prototype._setCurrentSystem = function (systemCode) {
    // si on change de type de systeme, on doit aussi changer le type d'unités !
    var type = null;
    for (var i = 0; i < this._projectionSystems.length; ++i) {
        if (this._projectionSystems[i].code === Number(systemCode)) {
            type = this._projectionSystems[i].type;
            break;
        }
    }

    if (!type) {
        logger.log("system not found in projection systems container");
        return;
    }

    // on enregistre le systeme courant
    this._currentProjectionSystems = this._projectionSystems[Number(systemCode)];

    if (type !== this._currentProjectionType) {
        this._setTypeUnitsPanel(type);
    }

    // on simule un deplacement en mode tactile pour mettre à jour les
    // resultats
    if (!this._isDesktop) {
        this.onMapMove();
    }
};

/**
 * this method is called by event 'mouseover' on 'GPmousePositionProjectionSystem'
 * tag select (cf. this._createMousePositionSettingsElement),
 * and selects the system projection.
 *
 * @method onMousePositionProjectionSystemMouseOver
 * @param {Object} e - HTMLElement
 * @private
 */
MousePosition.prototype.onMousePositionProjectionSystemMouseOver = function (e) {
    // logger.trace(e);

    // map infos
    var map = this.getMap();
    if (!map || !map.getView()) {
        return;
    }
    var view = map.getView();
    var crs = view.getProjection();
    var mapExtent = view.calculateExtent(map.getSize());

    // get extent in WGS84 coordinates
    mapExtent = _ol2.default.proj.transformExtent(mapExtent, crs, "EPSG:4326");

    /* clear select */
    var systemList = document.getElementById(this._addUID("GPmousePositionProjectionSystem"));
    systemList.innerHTML = "";

    // add systems whose extent intersects the map extent
    for (var j = 0; j < this._projectionSystems.length; j++) {
        var proj = this._projectionSystems[j];
        var option = null;

        if (proj.geoBBox) {
            /* bboxes intersection test */
            if (mapExtent[0] > proj.geoBBox.right || mapExtent[1] > proj.geoBBox.top || mapExtent[2] < proj.geoBBox.left || mapExtent[3] < proj.geoBBox.bottom) {
                if (proj === this._currentProjectionSystems) {
                    option = document.createElement("option");
                    option.value = proj.code;
                    option.text = proj.label || j;
                    option.setAttribute("selected", "selected");
                    option.setAttribute("disabled", "disabled");

                    systemList.appendChild(option);
                }
                continue; // do not intersect
            }
        }

        var optionElement = document.createElement("option");
        optionElement.value = proj.code;
        optionElement.text = proj.label || j;

        if (proj === this._currentProjectionSystems) {
            optionElement.setAttribute("selected", "selected");
        }
        systemList.appendChild(optionElement);
    }
};

/**
 * this method is called by event 'change' on 'GPmousePositionProjectionUnits'
 * tag select (cf. this._createMousePositionSettingsElement),
 * and selects the units projection.
 *
 * @method onMousePositionProjectionUnitsChange
 * @param {Object} e - HTMLElement
 * @private
 */
MousePosition.prototype.onMousePositionProjectionUnitsChange = function (e) {
    var idx = e.target.selectedIndex;
    var value = e.target.options[idx].value;

    var oldProjectionUnits = this._currentProjectionUnits;
    this._currentProjectionUnits = value;

    // Mise a jour des elements lebels et unites
    this._resetLabelElements(this._currentProjectionType);
    this._resetUnitElements(this._currentProjectionUnits);

    // mise a jour des inputs pour les coordonnees
    if (oldProjectionUnits === "DMS" || this._currentProjectionUnits === "DMS") {
        this._resetCoordinateElements(this.options.editCoordinates, this._currentProjectionType, this._currentProjectionUnits);
        this._setEditMode(this.editing);
    }

    // on simule un deplacement en mode tactile pour mettre à jour les
    // resultats
    if (!this._isDesktop) {
        this.onMapMove();
    }
};

/**
 *
 * @param {Number} value - value to convert (km to meters, radians, grades to decimal degrees)
 * @returns {undefined}
 * @private
 */
MousePosition.prototype.convert = function (value) {
    var result;
    if (this._currentProjectionUnits === "M" || this._currentProjectionUnits === "DEC") {
        result = value;
    } else if (this._currentProjectionUnits === "KM") {
        result = value * 1000;
    } else if (this._currentProjectionUnits === "RAD") {
        var rd = (180 / Math.PI).toFixed(20);
        result = (value * rd).toFixed(20);
    } else if (this._currentProjectionUnits === "GON") {
        var d = (9 / 10).toFixed(20);
        result = (value * d).toFixed(20);
    }

    return result;
};

/**
 * @param {String} coordType - "Lon" or "Lat"
 * @param {String} value - input value
 *
 * @returns {Boolean} value is within extent
 *
 * @private
 */
MousePosition.prototype.validateExtentCoordinate = function (coordType, value) {
    if (["Lon", "Lat"].indexOf(coordType) === -1) {
        return false;
    }

    var coord = value.replace(",", ".");
    coord = _MathUtils2.default.toFloat(coord);
    if (coord === null) {
        return false;
    }

    // convert depending on _currentProjectionUnits
    coord = this.convert(coord);

    var geoBBox = this._currentProjectionSystems.geoBBox;
    if (geoBBox === undefined) {
        return true;
    }

    // convert to current projection system
    var extent = [geoBBox.left, geoBBox.bottom, geoBBox.right, geoBBox.top];
    extent = _ol2.default.proj.transformExtent(extent, "EPSG:4326", this._currentProjectionSystems.crs);

    // checking if value is in the right interval
    if (coordType === "Lat" && (coord < extent[0] || coord > extent[2])) {
        return false;
    }
    if (coordType === "Lon" && (coord < extent[1] || coord > extent[3])) {
        return false;
    }

    return true;
};

exports.default = MousePosition;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MathUtils = {
    /**
     * Reste de la division euclidienne
     * @param {Number} a - divisor
     * @param {Number} b - quotient
     * @returns {Number} Modulo
     */
    modulo: function modulo(a, b) {
        var r = a % b;
        return r * b < 0 ? r + b : r;
    },

    /**
     * Transform degrees, minutes, seconds form decimal degrees -
     * Largely inspired by the private function degreesToStringHDMS from ol/coordinate.js
     *
     * @param {Number} degrees - decimal degrees
     * @param {Array} hemispheres - "NS" ou "EO"
     * @param {Number} numDigits - number of digits for seconds
     * @returns {Object} DMS coordinate
     */
    decimalToDMS: function decimalToDMS(degrees, hemispheres, numDigits) {
        var normalizedDegrees = this.modulo(degrees + 180, 360) - 180;
        var x = Math.abs(3600 * normalizedDegrees);
        var dflPrecision = numDigits || 0;
        var precision = Math.pow(10, dflPrecision);

        var deg = Math.floor(x / 3600);
        var min = Math.floor((x - deg * 3600) / 60);
        var sec = x - deg * 3600 - min * 60;
        sec = Math.ceil(sec * precision) / precision;

        if (sec >= 60) {
            sec = 0;
            min += 1;
        }

        if (min >= 60) {
            min = 0;
            deg += 1;
        }

        var direction = hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
        return {
            d: deg,
            m: min,
            s: sec,
            direction: direction
        };
    },

    /**
     * Converts string to Integer
     *
     * @param {String} s - string number
     * @param {Numeric} base - between 2 and 36
     * @returns {null|Numeric} result
     */
    toInteger: function toInteger(s, base) {
        var _base = base || 10;
        var n = parseInt(s, _base);
        if (!isNaN(n) && isFinite(n)) {
            return n;
        }
        return null;
    },

    /**
     * check if s represents an integer
     *
     * @param {String} s - string number
     * @returns {Boolean} is integer
     */
    isInteger: function isInteger(s) {
        if (isNaN(s)) {
            return false;
        }

        var v = parseFloat(s);
        return (v | 0) === v;
    },

    /**
     * Converts s to float
     *
     * @param {String} s - string number
     * @returns {null|Numeric} result
     */
    toFloat: function toFloat(s) {
        var n = parseFloat(s);
        if (!isNaN(n) && isFinite(n)) {
            return n;
        }
        return null;
    }
};

exports.default = MathUtils;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var MousePositionDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPmousePosition");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################### Methods of main container ##################### //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing
     *
     * @returns {DOMElement} DOM element
     */
    _createShowMousePositionElement: function _createShowMousePositionElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowMousePosition");
        input.type = "checkbox";
        return input;
    },

    /**
     * Show mouse position control
     * @param {Boolean} isDesktop - specifies if the support is desktop or tactile
     *
     * @returns {DOMElement} DOM element
     */
    _createShowMousePositionPictoElement: function _createShowMousePositionPictoElement(isDesktop) {
        // contexte d'execution
        var self = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowMousePositionPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowMousePosition");
        label.title = "Afficher les coordonnées du curseur";

        // FIXME detection disponible dans le JS !
        // Detection : test for desktop or tactile
        // var isDesktop = true;
        // var userAgent = window.navigator.userAgent.toLowerCase();
        // if (userAgent.indexOf("iphone") !== -1 ||
        // userAgent.indexOf("ipod") !== -1 ||
        // userAgent.indexOf("ipad") !== -1 ||
        // userAgent.indexOf("android") !== -1 ||
        // userAgent.indexOf("mobile") !== -1 ||
        // userAgent.indexOf("blackberry") !== -1 ||
        // userAgent.indexOf("tablet") !== -1 ||
        // userAgent.indexOf("phone") !== -1 ||
        // userAgent.indexOf("touch") !== -1 ) {
        //     isDesktop = false;
        // }
        // if (userAgent.indexOf("msie") !== -1 ||
        // userAgent.indexOf("trident") !== -1) {
        //     isDesktop = true;
        // }

        // Show map center localisation if panel opened and tactile support
        label.addEventListener("click", function (e) {
            var mapCenterClass = "";
            if (!document.getElementById(self._addUID("GPshowMousePosition")).checked && !isDesktop) {
                mapCenterClass = "GPmapCenterVisible";
            }
            document.getElementById("GPmapCenter").className = mapCenterClass;
            self.onShowMousePositionClick(e);
        });

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowMousePositionOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    },

    /**
     * mouse position panel
     * @param {Boolean} [displayAltitude=true] - specifies if the altitude panel must be displayed
     * @param {Boolean} [displayCoordinates=true] - specifies if the coordinates panel must be displayed
     * @param {Boolean} [editCoordinates=false] - specifies if the coordinates edition is allowed
     * @param {Boolean} [currentProjectionUnits] - specifies if the current projection units
     *
     * FIXME
     * don't call this._createMousePositionSettingsElement
     *
     * @returns {DOMElement} DOM element
     */
    _createMousePositionPanelElement: function _createMousePositionPanelElement(displayAltitude, displayCoordinates, editCoordinates, currentProjectionUnits) {
        // default Values
        displayAltitude = typeof displayAltitude === "undefined" ? true : displayAltitude;
        displayCoordinates = typeof displayCoordinates === "undefined" ? true : displayCoordinates;
        editCoordinates = typeof editCoordinates === "undefined" ? false : editCoordinates;

        var div = document.createElement("div");
        div.id = this._addUID("GPmousePositionPanel");
        div.className = "GPpanel";

        div.appendChild(this._createMousePositionPanelHeaderElement());
        div.appendChild(this._createMousePositionPanelBasicElement(displayAltitude, displayCoordinates, editCoordinates, currentProjectionUnits));

        var arraySettings = this._createShowMousePositionSettingsElement(displayCoordinates);
        for (var j = 0; j < arraySettings.length; j++) {
            div.appendChild(arraySettings[j]);
        }

        // FIXME on decompose la fonction pour les besoins du controle,
        // on ajoutera ces childs à la main...
        // div.appendChild(this._createMousePositionSettingsElement());

        return div;
    },

    /**
     * Map center localisation (tactile use)
     *
     * @returns {DOMElement} container
     */
    _createMapCenter: function _createMapCenter() {
        var div = document.createElement("div");
        div.id = "GPmapCenter";
        div.className = "";
        return div;
    },

    // ################################################################### //
    // ####################### Panel container ########################### //
    // ################################################################### //

    /**
     * @returns {DOMElement} container
     */
    _createMousePositionPanelHeaderElement: function _createMousePositionPanelHeaderElement() {
        var container = document.createElement("div");
        container.className = "GPpanelHeader";

        var divTitle = document.createElement("div");
        divTitle.className = "GPpanelTitle";
        divTitle.innerHTML = "Coordonnées";
        container.appendChild(divTitle);

        var divClose = document.createElement("div");
        divClose.id = "GPmousePositionPanelClose";
        divClose.className = "GPpanelClose";
        divClose.title = "Fermer le panneau";

        // Link panel close / visibility checkbox
        var self = this;
        if (divClose.addEventListener) {
            divClose.addEventListener("click", function () {
                document.getElementById(self._addUID("GPshowMousePositionPicto")).click();
            }, false);
        } else if (divClose.attachEvent) {
            divClose.attachEvent("onclick", function () {
                document.getElementById(self._addUID("GPshowMousePositionPicto")).click();
            });
        }

        container.appendChild(divClose);

        return container;
    },

    /**
     * coordinate panel
     * @param {Boolean} [displayAltitude] - specifies if the altitude panel must be displayed
     * @param {Boolean} [displayCoordinates] - specifies if the coordinates panel must be displayed
     * @param {Boolean} [editCoordinates] - specifies if the coordinates edition is allowed
     * @param {Boolean} [currentProjectionUnits] - specifies if the current projection units
     *
     * FIXME
     * call this._createMousePositionPanelBasicCoordinateElement
     * call this._createMousePositionPanelBasicAltitudeElement
     *
     * @returns {DOMElement} DOM element
     */
    _createMousePositionPanelBasicElement: function _createMousePositionPanelBasicElement(displayAltitude, displayCoordinates, editCoordinates, currentProjectionUnits) {
        var container = document.createElement("div");
        container.id = this._addUID("GPmousePositionBasicPanel");

        // FIXME on devrait decomposer la fonction pour les besoins du controle,
        // on ajoutera ces childs à la main...
        container.appendChild(this._createMousePositionPanelBasicCoordinateElement(displayCoordinates, editCoordinates, currentProjectionUnits));
        container.appendChild(this._createMousePositionPanelEditToolsElement(editCoordinates));
        container.appendChild(this._createMousePositionPanelBasicAltitudeElement(displayAltitude));

        return container;
    },

    /**
     * create coordinate elements
     *
     * @param {String} coordType - ("Lon" ou "Lat")
     * @param {Boolean} [editCoordinates=false] - specifies if the coordinates edition is allowed
     *
     * @returns {Array} list of DOM elements
     */
    _createCoordinateElement: function _createCoordinateElement(coordType, editCoordinates) {
        var context = this;

        if (["Lon", "Lat"].indexOf(coordType) === -1) {
            return [];
        }

        var list = [];
        var input = document.createElement("input");
        input.id = this._addUID("GPmousePosition" + coordType);
        input.title = editCoordinates === true ? "Cliquer pour saisir des coordonnées" : "";
        input.readOnly = true;

        if (editCoordinates) {
            input.addEventListener("click", function () {
                context.onMousePositionEditModeClick(true);
            });
            input.addEventListener("change", function (e) {
                this.classList.remove("error");
                var valid = context.validateExtentCoordinate(coordType, this.value, e);
                valid ? this.classList.remove("error") : this.classList.add("error");
            });
        }
        list.push(input);

        var span = document.createElement("span");
        span.className = "GPmousePositionUnits";
        list.push(span);

        return list;
    },

    /**
     *
     * @param {String} coordType - ("Lon" ou "Lat")
     * @param {Boolean} [editCoordinates=false] - specifies if the coordinates edition is allowed
     *
     * @returns {Array} list of DOM elements
     */
    _createDMSCoordinateElement: function _createDMSCoordinateElement(coordType, editCoordinates) {
        if (["Lon", "Lat"].indexOf(coordType) === -1) {
            return [];
        }

        var context = this;

        var list = [];

        var input = document.createElement("input");
        input.id = this._addUID("GPmousePosition" + coordType + "Degrees");
        input.className = "GPSexagesimal";
        input.setAttribute("name", "degrees");
        input.title = editCoordinates === true ? "Cliquer pour saisir des coordonnées" : "";
        input.readOnly = true;
        input.dataset.min = 0;
        input.dataset.max = coordType === "Lon" ? 180 : 90;
        if (editCoordinates) {
            input.addEventListener("click", function () {
                context.onMousePositionEditModeClick(true);
            });
            input.addEventListener("change", function () {
                this.classList.remove("error");
                var valid = context._checkDMSDegrees(coordType, this);
                valid ? this.classList.remove("error") : this.classList.add("error");
            });
        }
        list.push(input);

        var span = document.createElement("span");
        span.className = "GPmousePositionSexagesimalLabel";
        span.innerHTML = "°";
        list.push(span);

        var input1 = document.createElement("input");
        input1.id = this._addUID("GPmousePosition" + coordType + "Minutes");
        input1.className = "GPSexagesimal";
        input1.setAttribute("name", "minutes");
        input1.title = editCoordinates === true ? "Cliquer pour saisir des coordonnées" : "";
        input1.readOnly = true;
        input1.dataset.min = 0;
        input1.dataset.max = 59;
        if (editCoordinates) {
            input1.addEventListener("click", function () {
                context.onMousePositionEditModeClick(true);
            });
            input1.addEventListener("change", function () {
                this.classList.remove("error");
                var valid = context._checkDMSElement(this);
                valid ? this.classList.remove("error") : this.classList.add("error");
            });
        }
        list.push(input1);

        var span1 = document.createElement("span");
        span1.className = "GPmousePositionSexagesimalLabel";
        span1.innerHTML = "'";
        list.push(span1);

        var input2 = document.createElement("input");
        input2.id = this._addUID("GPmousePosition" + coordType + "Seconds");
        input2.className = "GPSexagesimalsec";
        input2.setAttribute("name", "seconds");
        input2.title = editCoordinates === true ? "Cliquer pour saisir des coordonnées" : "";
        input2.readOnly = true;
        input2.dataset.min = 0;
        input2.dataset.max = 59;
        if (editCoordinates) {
            input2.addEventListener("click", function () {
                context.onMousePositionEditModeClick(true);
            });
            input2.addEventListener("change", function () {
                this.classList.remove("error");
                var valid = context._checkDMSElement(this, true);
                valid ? this.classList.remove("error") : this.classList.add("error");
            });
        }
        list.push(input2);

        var span2 = document.createElement("span");
        span2.className = "GPmousePositionSexagesimalLabel";
        span2.innerHTML = "''";
        list.push(span2);

        var select = document.createElement("select");
        select.id = this._addUID("GPmousePosition" + coordType + "Direction");
        select.className = "GPmousePositionDirection";
        select.setAttribute("name", "direction");
        select.disabled = true;

        var option = document.createElement("option");
        option.value = coordType === "Lon" ? "E" : "N";
        option.innerHTML = coordType === "Lon" ? "E" : "N";
        select.appendChild(option);

        var option1 = document.createElement("option");
        option1.value = coordType === "Lon" ? "O" : "S";
        option1.innerHTML = coordType === "Lon" ? "O" : "S";
        select.appendChild(option1);
        list.push(select);

        return list;
    },

    /**
     * @param {Boolean} [display=false] - specifies if the coordinates panel must be displayed
     * @param {Boolean} [editCoordinates] - specifies if the coordinates edition is allowed
     * @param {Boolean} [currentProjectionUnits] - specifies if the current projection units
     *
     * @returns {DOMElement} container
     */
    _createMousePositionPanelBasicCoordinateElement: function _createMousePositionPanelBasicCoordinateElement(display, editCoordinates, currentProjectionUnits) {
        var div = document.createElement("div");
        div.id = this._addUID("GPmousePositionCoordinate");
        div.style.display = display ? "block" : "none";

        // latitude
        var divLat = document.createElement("div");

        var spanLat = document.createElement("span");
        spanLat.className = "GPmousePositionLabel";
        spanLat.id = this._addUID("GPmousePositionLatLabel");
        spanLat.innerHTML = "Latitude : ";
        divLat.appendChild(spanLat);

        var span = document.createElement("span");
        span.id = this._addUID("GPmousePositionLatCoordinate");

        var arrayCoords;
        if (currentProjectionUnits === "DMS") {
            arrayCoords = this._createDMSCoordinateElement("Lat", editCoordinates);
        } else {
            arrayCoords = this._createCoordinateElement("Lat", editCoordinates);
        }
        for (var i = 0; i < arrayCoords.length; i++) {
            span.appendChild(arrayCoords[i]);
        }
        divLat.appendChild(span);
        div.appendChild(divLat);

        // longitude
        var divLon = document.createElement("div");

        var spanLon = document.createElement("span");
        spanLon.className = "GPmousePositionLabel";
        spanLon.id = this._addUID("GPmousePositionLonLabel");
        spanLon.innerHTML = "Longitude : ";
        divLon.appendChild(spanLon);

        var span1 = document.createElement("span");
        span1.id = this._addUID("GPmousePositionLonCoordinate");

        var arrayCoords1;
        if (currentProjectionUnits === "DMS") {
            arrayCoords1 = this._createDMSCoordinateElement("Lon", editCoordinates);
        } else {
            arrayCoords1 = this._createCoordinateElement("Lon", editCoordinates);
        }
        for (var j = 0; j < arrayCoords1.length; j++) {
            span1.appendChild(arrayCoords1[j]);
        }
        divLon.appendChild(span1);
        div.appendChild(divLon);

        return div;
    },

    /**
     * @param {Boolean} [display=false] - specifies if the altitude panel must be displayed
     *
     * @returns {DOMElement} container
     */
    _createMousePositionPanelBasicAltitudeElement: function _createMousePositionPanelBasicAltitudeElement(display) {
        var div = document.createElement("div");
        div.id = this._addUID("GPmousePositionAltitude");
        div.style.display = display ? "block" : "none";

        var spanLabel = document.createElement("span");
        spanLabel.className = "GPmousePositionLabel";
        spanLabel.innerHTML = "Altitude : ";
        div.appendChild(spanLabel);

        var spanAlt = document.createElement("span");
        spanAlt.className = "GPmousePositionCoords";
        spanAlt.id = this._addUID("GPmousePositionAlt");
        spanAlt.innerHTML = "...";
        div.appendChild(spanAlt);

        var spanUnits = document.createElement("span");
        spanUnits.className = "GPmousePositionAltitudeUnits";
        spanUnits.innerHTML = "m";
        div.appendChild(spanUnits);

        return div;
    },

    /**
     * @param {Boolean} [editCoordinates=false] - specifies if the coordinates edition is allowed
     *
     * @returns {DOMElement} container
     */
    _createMousePositionPanelEditToolsElement: function _createMousePositionPanelEditToolsElement(editCoordinates) {
        var context = this;

        var div = document.createElement("div");
        div.className = "GPmousePositionPanelEditTools";
        div.id = this._addUID("GPmousePositionPanelEditTools");
        if (!editCoordinates) {
            div.style.display = "none";
        }

        var span1 = document.createElement("span");
        span1.className = "GPmousePositionEditTool";
        span1.id = this._addUID("GPmousePositionLocate");
        span1.title = editCoordinates === true ? "Cliquer pour saisir des coordonnées" : "";
        if (editCoordinates) {
            span1.addEventListener("click", function () {
                context.onMousePositionEditModeLocateClick();
            });
        }
        div.appendChild(span1);

        var span2 = document.createElement("span");
        span2.className = "GPmousePositionEditTool";
        span2.id = this._addUID("GPmousePositionCloseEdit");
        span2.title = "Quitter la saisie des coordonnées";
        span2.style.display = "none";
        if (editCoordinates) {
            span2.addEventListener("click", function () {
                context.onMousePositionEditModeClick(false);
            });
        }
        div.appendChild(span2);

        return div;
    },

    // ################################################################### //
    // #################### Settings container ########################### //
    // ################################################################### //

    /**
     * @param {Boolean} [display=false] - specifies if the settings panel must be displayed
     *
     * @returns {DOMElement[]} array containing input and label elements
     */
    _createShowMousePositionSettingsElement: function _createShowMousePositionSettingsElement(display) {
        var list = [];

        var input = document.createElement("input");
        input.type = "checkbox";
        input.id = this._addUID("GPshowMousePositionSettings");

        var label = document.createElement("label");
        label.id = this._addUID("GPshowMousePositionSettingsPicto");
        label.htmlFor = this._addUID("GPshowMousePositionSettings");
        label.title = "Réglages";
        label.className = "GPshowMoreOptions GPshowMousePositionSettingsPicto"; // FIXME classname and id ?
        label.style.display = display ? "block" : "none";

        list.push(input);
        list.push(label);

        return list;
    },

    /**
     * settings panel
     * @param {Boolean} [display=true] - specifies if the settings panel must be displayed
     *
     * FIXME
     * don't call this._createMousePositionSettingsSystemsElement
     * don't call this._createMousePositionSettingsUnitsElement
     *
     * @returns {DOMElement} DOM element
     */
    _createMousePositionSettingsElement: function _createMousePositionSettingsElement(display) {
        var container = document.createElement("div");
        container.id = this._addUID("GPmousePositionSettings");
        container.style.display = display === undefined || display ? "block" : "none";

        var span = document.createElement("span");
        span.className = "GPmousePositionSettingsLabel";
        span.innerHTML = "Système de référence";
        container.appendChild(span);

        // FIXME on decompose la fonction pour les besoins du controle,
        // on ajoutera ces childs à la main...
        // FIXME tableau statique !
        // var systems = [
        //     {
        //         code : "GEOGRAPHIC",
        //         label : "Géographique"
        //     },
        //     {
        //         code : "MERCATOR",
        //         label : "Mercator"
        //     },
        //     {
        //         code : "LAMB93",
        //         label : "Lambert 93"
        //     },
        //     {
        //         code : "LAMB2E",
        //         label : "Lambert II étendu"
        //     }
        // ];
        //
        // var selectSystem = this._createMousePositionSettingsSystemsElement(systems);
        //
        // container.appendChild(selectSystem);

        // FIXME on decompose la fonction pour les besoins du controle,
        // on ajoutera ces childs à la main...
        // FIXME tableau statique !
        // var units = [
        //     {
        //         code : "DEC",
        //         label : "degrés décimaux",
        //     },
        //     {
        //         code : "DMS",
        //         label : "degrés sexagésimaux",
        //     },
        //     {
        //         code : "RAD",
        //         label : "radians",
        //     },
        //     {
        //         code : "GON",
        //         label : "grades"
        //     }
        // ];
        //
        // var selectUnits = this._createMousePositionSettingsUnitsElement(units);
        //
        // container.appendChild(selectUnits);

        return container;
    },

    /**
     * @param {Object[]} systems - list of systems
     *
     * @returns {DOMElement} DOM element select
     */
    _createMousePositionSettingsSystemsElement: function _createMousePositionSettingsSystemsElement(systems) {
        // contexte d'execution
        var context = this;

        var selectSystem = document.createElement("select");
        selectSystem.id = this._addUID("GPmousePositionProjectionSystem");
        selectSystem.className = "GPinputSelect GPmousePositionSettingsSelect";
        selectSystem.addEventListener("change", function (e) {
            context.onMousePositionProjectionSystemChange(e);
        });
        selectSystem.addEventListener("mouseover", function (e) {
            // FIXME mettre une condition si target === option
            if (e.target.nodeName !== "OPTION") {
                context.onMousePositionProjectionSystemMouseOver(e);
            }
        });

        for (var i = 0; i < systems.length; i++) {
            var obj = systems[i];
            var option = document.createElement("option");
            option.value = obj.code;
            option.text = obj.label || i;
            // option.label = obj.label;
            selectSystem.appendChild(option);
        }

        return selectSystem;
    },

    /**
     * @param {Object[]} units - list of units
     *
     * @returns {DOMElement} DOM element select
     */
    _createMousePositionSettingsUnitsElement: function _createMousePositionSettingsUnitsElement(units) {
        // contexte d'execution
        var context = this;

        var selectUnits = document.createElement("select");
        selectUnits.id = this._addUID("GPmousePositionProjectionUnits");
        selectUnits.className = "GPinputSelect GPmousePositionSettingsSelect";
        selectUnits.addEventListener("change", function (e) {
            context.onMousePositionProjectionUnitsChange(e);
        });

        for (var j = 0; j < units.length; j++) {
            var obj = units[j];
            var option = document.createElement("option");
            option.value = obj.code ? obj.code : j;
            option.text = obj.label || j;
            // option.label = obj.label;
            selectUnits.appendChild(option);
        }

        return selectUnits;
    },

    /**
     * @param {String} [currentProjectionType="Metric"] - "Geographical" or "Metric"
     */
    _resetLabelElements: function _resetLabelElements(currentProjectionType) {
        // Changement des labels dans le formulaire de saisie
        var spanLat = document.getElementById(this._addUID("GPmousePositionLatLabel"));
        spanLat.innerHTML = currentProjectionType === "Geographical" ? "Latitude :" : "X :";

        var spanLon = document.getElementById(this._addUID("GPmousePositionLonLabel"));
        spanLon.innerHTML = currentProjectionType === "Geographical" ? "Longitude :" : "Y :";
    },

    /**
     * @param {String} currentProjectionUnits - projection units
     */
    _resetUnitElements: function _resetUnitElements(currentProjectionUnits) {
        var value = "";
        if (currentProjectionUnits === "M" || currentProjectionUnits === "KM") {
            value = currentProjectionUnits.toLowerCase();
        }

        var elts = document.getElementsByClassName("GPmousePositionUnits");
        for (var e = 0; e < elts.length; e++) {
            elts[e].innerHTML = value;
        }
    },

    /**
     * @method _resetCoordinateElements
     * @param {Boolean} editCoordinates - edit coordinates option
     * @param {String} currentProjectionType - current projection type
     * @param {String} currentProjectionUnits - current projection unit
     */
    _resetCoordinateElements: function _resetCoordinateElements(editCoordinates, currentProjectionType, currentProjectionUnits) {
        // Suppression de tous les enfants de GPmousePositionLatCoordinate
        var latElt = document.getElementById(this._addUID("GPmousePositionLatCoordinate"));
        while (latElt.firstChild) {
            latElt.removeChild(latElt.firstChild);
        }

        var arrayCoords;
        if (currentProjectionUnits === "DMS") {
            arrayCoords = this._createDMSCoordinateElement("Lat", editCoordinates);
        } else {
            arrayCoords = this._createCoordinateElement("Lat", editCoordinates);
        }
        for (var i = 0; i < arrayCoords.length; i++) {
            latElt.appendChild(arrayCoords[i]);
        }

        // Suppression de tous les enfants de GPmousePositionLonCoordinate
        var lonElt = document.getElementById(this._addUID("GPmousePositionLonCoordinate"));
        while (lonElt.firstChild) {
            lonElt.removeChild(lonElt.firstChild);
        }

        var arrayCoords1;
        if (currentProjectionUnits === "DMS") {
            arrayCoords1 = this._createDMSCoordinateElement("Lon", editCoordinates);
        } else {
            arrayCoords1 = this._createCoordinateElement("Lon", editCoordinates);
        }
        for (var j = 0; j < arrayCoords1.length; j++) {
            lonElt.appendChild(arrayCoords1[j]);
        }

        // FIXME on simule un deplacement ?
        // this.onMapMove();
    },

    /**
     * Set/unset editing mode
     *
     * @method _setEditMode
     * @param {Boolean} editing - active edit coordinates mode
     */
    _setEditMode: function _setEditMode(editing) {
        var locateElt = document.getElementById(this._addUID("GPmousePositionLocate"));
        locateElt.title = editing ? "Aller à la position ..." : "Cliquer pour saisir des coordonnées";

        var closeEditElt = document.getElementById(this._addUID("GPmousePositionCloseEdit"));
        closeEditElt.style.display = editing ? "inline-block" : "none";

        var selector = "div[id^=" + this._addUID("GPmousePositionCoordinate") + "]";
        var inputs = document.querySelectorAll(selector + " input");
        for (var i = 0; i < inputs.length; i++) {
            inputs[i].readOnly = !editing;
            if (editing) {
                inputs[i].value = "";
                inputs[i].classList.remove("error");
            }
        }
        var selects = document.querySelectorAll(selector + " select");
        for (var j = 0; j < selects.length; j++) {
            selects[j].disabled = !editing;
        }
    },

    /**
     *
     * @param {DOMElement} input - input element
     * @param {Boolean} isFloat - check for float value
     *
     * @returns {Boolean} true if input value is within bounds
     */
    _checkDMSElement: function _checkDMSElement(input, isFloat) {
        var b = isFloat !== undefined;

        var value = input.value;
        if (b) {
            value = value.replace(",", ".");
        }
        if (isNaN(value)) {
            return false;
        }

        var v = parseFloat(value);
        if (!b && (v | 0) !== v) {
            // is it an integer
            return false;
        }

        var min = Number(input.dataset.min);
        var max = Number(input.dataset.max);
        return v >= min && v <= max;
    },

    /**
     * @param {String} coordType - "Lon" or "Lat"
     * @param {DOMElement} input - input element
     *
     * @returns {Boolean} true if input value is within bounds
     */
    _checkDMSDegrees: function _checkDMSDegrees(coordType, input) {
        if (isNaN(input.value)) {
            return false;
        }

        var v = parseFloat(input.value);
        if ((v | 0) !== v) {
            // is it an integer
            return false;
        }

        var min = Number(input.dataset.min);
        var max = Number(input.dataset.max);
        if (v < min || v > max) {
            return false;
        }

        var inputMinutes = document.getElementById(this._addUID("GPmousePosition" + coordType + "Minutes"));
        var inputSeconds = document.getElementById(this._addUID("GPmousePosition" + coordType + "Seconds"));

        if (v >= max) {
            inputMinutes.dataset.max = 0;
            inputSeconds.dataset.max = 0;
        } else {
            inputMinutes.dataset.max = 59;
            inputSeconds.dataset.max = 59.9999;
        }

        return true;
    },

    // ################################################################### //
    // ####################### handlers Event ############################ //
    // ################################################################### //

    /**
     * Function displaying coordinates from cursor position (desktop)
     * or map center (tactile)
     * @param {Object} coordinate - coordinates
     */
    GPdisplayCoords: function GPdisplayCoords(coordinate) {
        // Compute coords in case of cursor position (desktop)
        if (coordinate && coordinate != null) {
            var labelLon = document.getElementById(this._addUID("GPmousePositionLonLabel"));
            var labelLat = document.getElementById(this._addUID("GPmousePositionLatLabel"));

            if (coordinate.x || coordinate.y) {
                labelLat.innerHTML = "X : ";
                labelLon.innerHTML = "Y : ";
            } else if (coordinate.e || coordinate.n) {
                labelLat.innerHTML = "E : ";
                labelLon.innerHTML = "N : ";
            } else {
                labelLat.innerHTML = "Latitude : ";
                labelLon.innerHTML = "Longitude : ";
            }

            if (_typeof(coordinate.lat) === "object" && _typeof(coordinate.lng) === "object") {
                var parts = {
                    lng: "Lon",
                    lat: "Lat"
                };
                var units = ["Degrees", "Minutes", "Seconds"];
                for (var p in parts) {
                    for (var u = 0; u < units.length; ++u) {
                        var selector = "GPmousePosition" + parts[p] + units[u];
                        var elt = document.getElementById(this._addUID(selector));
                        var key = units[u].charAt(0).toLowerCase();
                        elt.value = coordinate[p][key];
                    }
                }
                // directions
                document.getElementById(this._addUID("GPmousePositionLonDirection")).value = coordinate.lng.direction;
                document.getElementById(this._addUID("GPmousePositionLatDirection")).value = coordinate.lat.direction;
            } else {
                var elLat = document.getElementById(this._addUID("GPmousePositionLat"));
                var elLon = document.getElementById(this._addUID("GPmousePositionLon"));

                elLat.value = coordinate.x || coordinate.lat || coordinate.e || "0";
                elLon.value = coordinate.y || coordinate.lng || coordinate.lon || coordinate.n || "0";

                // les unites
                var unit = coordinate.unit === undefined ? "" : coordinate.unit;
                var elements = document.getElementsByClassName("GPmousePositionUnits");
                for (var n = 0; n < elements.length; ++n) {
                    elements[n].innerHTML = unit;
                }
            }
        }
    },

    /**
     * Function displaying altitude from cursor position (desktop)
     * or map center (tactile)
     * @param {Object} coordinate - coordinates
     * @param {Number} altitudeTimeoutDelay - when the mouse stop moving, delay before the altitude request is launched
     * @param {Number} noDataValue - the no data value
     * @param {Number} noDataValueTolerance - the no data value tolerance
     */
    GPdisplayElevation: function GPdisplayElevation(coordinate, altitudeTimeoutDelay, noDataValue, noDataValueTolerance) {
        // contexte d'execution
        var self = this;

        // Latency for altitude request
        var altitudeTimeout;
        if (!altitudeTimeoutDelay) {
            altitudeTimeoutDelay = 500;
        }

        clearTimeout(altitudeTimeout);
        document.getElementById(this._addUID("GPmousePositionAlt")).innerHTML = "...";

        if (noDataValue == null) {
            noDataValue = -99999;
        }
        if (noDataValueTolerance == null) {
            noDataValueTolerance = 99980;
        }
        var maxThreshold = noDataValue + noDataValueTolerance;
        var minThreshold = noDataValue - noDataValueTolerance;

        // Compute coords in case of cursor position (desktop)
        if (coordinate && coordinate != null) {
            // If no altitude panel, don't call altitude request
            if (document.getElementById(this._addUID("GPmousePositionAltitude"))) {
                altitudeTimeout = setTimeout(function () {
                    self.onRequestAltitude(coordinate, function (z) {
                        if (minThreshold < z && z < maxThreshold) {
                            self.GPresetElevation();
                        } else {
                            document.getElementById(self._addUID("GPmousePositionAlt")).innerHTML = z;
                        }
                    });
                }, altitudeTimeoutDelay);
            }
        }
    },

    /**
     * Function reseting altitude value
     */
    GPresetElevation: function GPresetElevation() {
        if (document.getElementById(this._addUID("GPmousePositionAltitude"))) {
            document.getElementById(this._addUID("GPmousePositionAlt")).innerHTML = "---";
        }
    }
};

exports.default = MousePositionDOM;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _Interactions = __webpack_require__(15);

var _Interactions2 = _interopRequireDefault(_Interactions);

var _DrawingDOM = __webpack_require__(42);

var _DrawingDOM2 = _interopRequireDefault(_DrawingDOM);

var _KML = __webpack_require__(14);

var _KML2 = _interopRequireDefault(_KML);

var _LayerSwitcher = __webpack_require__(6);

var _LayerSwitcher2 = _interopRequireDefault(_LayerSwitcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("Drawing");

/**
 * @classdesc
 *
 * Drawing Control.
 *
 * @constructor
 * @alias ol.control.Drawing
 * @extends {ol.control.Control}
 * @param {Object} options - options for function call.
 * @param {Boolean} [options.collapsed = true] - Specify if Drawing control should be collapsed at startup. Default is true.
 * @param {ol.layer.Vector} [options.layer = null] - Openlayers layer that will hosts created features. If none, an empty vector layer will be created.
 * @param {Object} [options.layerDescription = {}] - Layer informations to be displayed in LayerSwitcher widget (only if a LayerSwitcher is also added to the map)
 * @param {String} [options.layerDescription.title = "Croquis"] - Layer title to be displayed in LayerSwitcher
 * @param {String} [options.layerDescription.description = "Mon croquis"] - Layer description to be displayed in LayerSwitcher
 * @param {Object} options.tools - Tools to display in the drawing toolbox. All by default.
 * @param {Boolean} [options.tools.points = true] - Display points drawing tool
 * @param {Boolean} [options.tools.lines = true] - Display lines drawing tool
 * @param {Boolean} [options.tools.polygons = true] - Display polygons drawing tool
 * @param {Boolean} [options.tools.text = true] - Display text drawing tool
 * @param {Boolean} [options.tools.remove = true] - Display feature removing tool
 * @param {Boolean} [options.tools.display = true] - Display style editing tool
 * @param {Boolean} [options.tools.tooltip = true] - Display text editing tool
 * @param {Boolean} [options.tools.edit = true] - Display editing tool
 * @param {Boolean} [options.tools.export = true] - Display exporting tool
 * @param {Boolean} [options.tools.measure = false] - Display measure drawing into popup info
 * @param {String} [options.labels] - Labels for Control
 * @param {String} [options.labels.control] - Label for Control
 * @param {String} [options.labels.points] - Label for points drawing tool
 * @param {String} [options.labels.lines] - Label for lines drawing tool
 * @param {String} [options.labels.polygons] - Label for polygons drawing tool
 * @param {String} [options.labels.text] - Label for text drawing tool
 * @param {String} [options.labels.edit] - Label for editing tool
 * @param {String} [options.labels.display] - Label for style editing tool
 * @param {String} [options.labels.tooltip] - Label for text editing tool
 * @param {String} [options.labels.remove] - Label for feature removing tool
 * @param {String} [options.labels.export] - Label for exporting tool.
 * @param {String} [options.labels.exportTitle] - Title for exporting tool.
 * @param {String} [options.labels.applyToObject] - Label for apply to object button.
 * @param {String} [options.labels.saveDescription] - Label for save description button.
 * @param {String} [options.labels.setAsDefault] - Label for set as default style button.
 * @param {String} [options.labels.strokeColor] - Label for stroke color.
 * @param {String} [options.labels.strokeWidth] - Label for stroke width.
 * @param {String} [options.labels.fillColor] - Label for fill color.
 * @param {String} [options.labels.fillOpacity] - Label for fillOpacity.
 * @param {Array.<Object>} [options.markersList = [{src : "data:image/png;base64,xxxx", anchor : [0.5,1]}]] - List of markers src to be used for points with their anchor offsets See {@link http://openlayers.org/en/latest/apidoc/ol.style.Icon.html OpenLayers params} for anchor offset options.
 * @param {Object} options.defaultStyles - Default styles applying to geometries (labels, lines and polygons).
 * @param {String} [options.defaultStyles.textFillColor = "#000000"] - Text fill color for labels (RGB hex value).
 * @param {String} [options.defaultStyles.textStrokeColor = "#FFFFFF"] - Text surrounding color for labels (RGB hex value).
 * @param {String} [options.defaultStyles.strokeColor = "#ffcc33"] - Stroke color (RGB hex value).
 * @param {Number} [options.defaultStyles.strokeWidth = 2] - Stroke width in pixels.
 * @param {String} [options.defaultStyles.polyStrokeColor = "#ffcc33"] - Stroke color (RGB hex value) for polygons.
 * @param {Number} [options.defaultStyles.polyStrokeWidth = 2] - Stroke width in pixels for polygons.
 * @param {String} [options.defaultStyles.polyFillColor = "#ffffff"] - Polygons fill color (RGB hex value).
 * @param {Number} [options.defaultStyles.polyFillOpacity = 0.2] - Polygon fill opacity (alpha value between 0:transparent and 1:opaque).
 * @param {Object} options.cursorStyle - cursor (circle) style when drawing or editing.
 * @param {String} [options.cursorStyle.fillColor = "rgba(0, 153, 255, 1)"] - Cursor fill color.
 * @param {String} [options.cursorStyle.strokeColor = "#FFF"] - Cursor stroke color.
 * @param {String} [options.cursorStyle.strokeWidth = 1] - Cursor surrounding stroke width.
 * @param {String} [options.cursorStyle.radius = 6] - Cursor radius.
 */
function Drawing(options) {
    options = options || {};

    if (!(this instanceof Drawing)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    this._initialize(options);

    // init control DOM container
    var container = this._initContainer();

    // call ol.control.Control constructor
    _ol2.default.control.Control.call(this, {
        element: container,
        target: options.target,
        render: options.render
    });
};

// Inherits from ol.control.Control
_ol2.default.inherits(Drawing, _ol2.default.control.Control);

/**
 * Default tools to display for widget
 *
 * @private
 */
Drawing.DefaultTools = {
    points: true,
    lines: true,
    polygons: true,
    text: true,
    remove: true,
    display: true,
    tooltip: true,
    edit: true,
    export: true,
    measure: false
};

/**
 * Default labels for widget
 *
 * @private
 */
Drawing.DefaultLabels = {
    control: "Annoter la carte",
    creatingTools: "Outils de création",
    points: "Placer des points",
    lines: "Dessiner des lignes",
    polygons: "Dessiner des polygones",
    text: "Ecrire sur la carte",
    editingTools: "Outils d'édition",
    edit: "Editer les tracés",
    display: "Modifier l'apparence des objets",
    tooltip: "Modifier les textes / infos-bulles",
    remove: "Supprimer des objets",
    export: "Exporter",
    exportTitle: "Exporter en KML",
    applyToObject: "Appliquer à l'objet",
    saveDescription: "Enregistrer",
    setAsDefault: "Définir par défaut",
    strokeColor: "Couleur du trait : ",
    strokeWidth: "Epaisseur du trait : ",
    fillColor: "Couleur de remplissage : ",
    fillOpacity: "Opacité du remplissage : "
};

/**
 * Default styles applyied to drawn features.
 *
 * @private
 */
Drawing.DefaultStyles = {
    textFillColor: "#000000",
    textStrokeColor: "#FFFFFF",
    // INFO : cette option n'est pas surchargeable via les options du constructeur !
    textIcon1x1: {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGNiYAAAAAkAAxkR2eQAAAAASUVORK5CYII=",
        anchor: [0, 0]
    },
    polyFillColor: "#ffffff",
    polyFillOpacity: 0.4,
    polyStrokeColor: "#ffcc33",
    polyStrokeWidth: 4,
    strokeColor: "#ffcc33",
    strokeWidth: 4
};

/**
 * Default styles when drawing
 *
 * @private
 */
Drawing.DefaultCursorStyle = {
    radius: 6,
    strokeColor: "#FFF",
    strokeWidth: 1,
    fillColor: "rgba(0, 153, 255, 1)"
};

/**
 * @lends module:Drawing
 */
Drawing.prototype = Object.create(_ol2.default.control.Control.prototype, {});

/**
 * Copies all source object members to Drawing prototype
 *
 * @param {Object} source - source object whose properties will be copied.
 * @private
 */
Drawing.prototype.assign = function (source) {
    for (var prop in source) {
        if (source.hasOwnProperty(prop)) {
            this[prop] = source[prop];
        }
    }
};

Drawing.prototype.assign(_DrawingDOM2.default);

/**
 * Constructor (alias)
 *
 * @private
 */
Drawing.prototype.constructor = Drawing;

/**
 * Overload of {@link http://openlayers.org/en/latest/apidoc/ol.control.Control.html#setMap ol.control.Control.setMap()} method, called when control is added to or removed from map.
 *
 * @param {Object} map - {@link http://openlayers.org/en/latest/apidoc/ol.Map.html ol.Map} object.
 */
Drawing.prototype.setMap = function (map) {
    // call original setMap method
    _ol2.default.control.Control.prototype.setMap.call(this, map);

    if (this.getMap() && this.eventKey) {
        _ol2.default.Observable.unByKey(this.eventKey);
    }

    // nothing else to do if map == null
    if (map == null) {
        return;
    }

    // mode "collapsed"
    if (!this.collapsed) {
        var inputShow = document.getElementById(this._addUID("GPshowDrawing"));
        inputShow.checked = "checked";
    }

    if (this.layer) {
        // ajout du layer de dessin à la carte s'il n'y est pas déjà
        this.setLayer(this.layer);
    }

    // gestion des suppressions "externes" de la couche de dessin.
    this.eventKey = this.getMap().getLayers().on("remove", function (evtRm) {
        if (evtRm.element == this.layer) {
            // FIXME object comparison
            // found layer removed.
            this.layer = null;
            // on supprime l'interaction en cours si besoin
            if (this.interactionCurrent) {
                this.getMap().removeInteraction(this.interactionCurrent);
                this.interactionCurrent = null;
            }
        }
    }, this);
};

/**
 * Export features of current drawing layer in KML.
 *
 * @returns {String} a KML representation of drawn features or null if not possible.
 */
Drawing.prototype.exportFeatures = function () {
    var result = null;
    if (_ol2.default.control.Control.prototype.getMap.call(this) == null) {
        logger.log("Impossible to export : control isn't attached to any map.");
        return result;
    }
    if (!this.layer) {
        logger.log("Impossible to export : no layer is hosting features.");
        return result;
    }
    if (!this.layer.getSource() || !this.layer.getSource().getFeatures() || !this.layer.getSource().getFeatures().length) {
        logger.log("Impossible to export : no features found.");
        return result;
    }
    var featProj = this.layer.getSource().getProjection();
    featProj = featProj || this.getMap().getView().getProjection();

    var kmlFormat = new _KML2.default({
        writeStyles: true
    });

    result = kmlFormat.writeFeatures(this.layer.getSource().getFeatures(), {
        dataProjection: "EPSG:4326",
        featureProjection: featProj
    });

    return result;
};

// ################################################################### //
// #################### user interface methods ####################### //
// ################################################################### //

/**
 * Collapse or display control main container
 *
 * @param {Boolean} collapsed - True to collapse control, False to display it
 */
Drawing.prototype.setCollapsed = function (collapsed) {
    if (collapsed === undefined) {
        logger.error("[ERROR] Drawing:setCollapsed - missing collapsed parameter");
        return;
    }
    if (collapsed && this.collapsed || !collapsed && !this.collapsed) {
        return;
    }
    // on simule l'ouverture du panneau après un click
    this.onShowDrawingClick();
    this._showDrawingContainer.checked = !collapsed;
};

/**
 * Setter for Export Name.
 *
 * @param {String} name - Export Name. By default, "Croquis".
 */
Drawing.prototype.setExportName = function (name) {
    this._exportName = name;
};

/**
 * getter for Export Name.
 *
 * @returns {String} export name
 */
Drawing.prototype.getExportName = function () {
    return this._exportName;
};

// ################################################################### //
// ######################## initialize control ####################### //
// ################################################################### //

/**
 * Gets marker options in options.markersList given its src.
 *
 * @param {String} src - marker image URI,
 * @returns {Object} markers options
 * @private
 */
Drawing.prototype._getsMarkersOptionsFromSrc = function (src) {
    var markerOptions = null;
    for (var i = 0; i < this.options.markersList.length; i++) {
        if (this.options.markersList[i].src === src) {
            markerOptions = this.options.markersList[i];
            return markerOptions;
        }
    }
    return markerOptions;
};

/**
 * Converts markerElement options into Openlayers IconStyles options.
 *
 * @param {Object} markerElement - marker element
 * @returns {Object} ol.Style.Icon constructor options.
 * @private
 */
Drawing.prototype._getIconStyleOptions = function (markerElement) {
    var iconOptions = {};
    Object.keys(markerElement).forEach(function (key) {
        switch (key) {
            case "src":
            case "size":
            case "anchor":
            case "anchorOrigin":
            case "anchorXUnits":
            case "anchorYUnits":
                iconOptions[key] = markerElement[key];
                break;
        }
    }, this);

    return iconOptions;
};

/**
 * Initialize control (called by Drawing constructor)
 *
 * @method _initialize
 * @param {Object} options - control options (set by user)
 * @private
 */
Drawing.prototype._initialize = function (options) {
    // determination d'un uid
    this._uid = _SelectorID2.default.generate();

    // export name / format / ...
    this._exportName = "Croquis";
    this._exportFormat = ".kml";

    // Set default options
    this.options = options || {};

    if (!this.options.layerDescription) {
        this.options.layerDescription = {
            title: "Croquis",
            description: "Mon croquis"
        };
    }

    // applying default tools
    if (!this.options.tools) {
        this.options.tools = {};
    }
    Object.keys(Drawing.DefaultTools).forEach(function (key) {
        if (!this.options.tools.hasOwnProperty(key)) {
            this.options.tools[key] = Drawing.DefaultTools[key];
        }
    }, this);
    // styles par defaut lors du dessin
    if (!this.options.cursorStyle) {
        this.options.cursorStyle = {};
    }
    Object.keys(Drawing.DefaultCursorStyle).forEach(function (key) {
        if (!this.options.cursorStyle.hasOwnProperty(key)) {
            this.options.cursorStyle[key] = Drawing.DefaultCursorStyle[key];
        }
    }, this);

    this.options.collapsed = options.collapsed !== undefined ? options.collapsed : true;
    /** {Boolean} specify if Drawing control is collapsed (true) or not (false) */
    this.collapsed = this.options.collapsed;
    this.options.markersList = options.markersList || [{
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARfSURBVFiF3ZhfbBRVGMV/d2Z3212tbSkCbuNaqzaRiL6QyAMPjSFoYqgx4oOiRmMFUzQG479o2lQ0QXk1EhYFgmlD2mIRkYhRwqLEaA2GiKWV7rZLQ0sLwbZId7t/Zq4PFK1125m5s/vCedz7nXO+M9/N3jsD1xFEvgXlTkrI8hBQBywFbgEqgEvAMHAayZcYHBYbuZJP77yFkdsoR+ct4GXAb4OSQPARXj4QzzGejx7yEkZuZy2CMLBAgf4nkhfEi3S67UNzQ5YSIXfQhKAdtSAACxDsk2EapXT3cF2FYQdNSN7F/YQFsJkw77gVUcL01mp3o5EDJoK1Yj37VchKjcjdlJEmhvrWmg9jGNwhGhhzSlTbZmnepjBBAMrReF2F6Hgy0+fIKPb+flWRIMtip+eQ88lcPRCtg3gCCVZ3RqhPDbJepqlPDbJ6XwSvP2nDJYCXB522prLN6iwrPIEETw33U/VoLZovBPjQfCGqHqtl3XDUZiBrn1lQCXO3ZcUDLV34Su/JueYrW0btnp8tNSRLnTamEiZoWRF6uHre9dseuT0vPrOgEqbCWtW3xNX6VSy02c+/sk4JwF+WFWZ6xGL9vA2fyzb7+QcqYUYtKwYP9s+7PrA/bsNn/geSA87DSLosa44+fT/p8VM511Jjp4g8u8KGk7XPLKhM5qhlRSbppzV4JwMdEcz0WSCNmT5LrC1CS/AujKliSw1BxGljzm8AH3MjHs4BpU65DjCBn0rxDJNOSI4nM33F2O2U58yEnU6DgOpF02AzcEGJa40LZHlfhagUZvp6vkmFawObVK7/4PLFSoZpBZ50ozEThsne6i2hjZqmFRVJ6U8JUeSVUmQNzQvg0c1MVtNMIUTSl0pNLhsaGu8A4xrfbZhS4CRQ5SoFcCWtja/5NBg+N+GZsu0vhSEkcY8mf+iNx+OuX3llmJVABNCVNUA2fl3xWdvJkriqRBb2uPugAYgNHEey1Y3Gt3/ccNxFEAChm2al6zAAjNAEWF/rc1Ev6+ffOLTwmBt7E0xD02J5CSOayQLrsHMJnYGMITJvHrr588mUMKyr54CUaaHrnfF4fCQ/kwHEBmLAa044rb+WHP4xXnxJ0VJK6CkyjO2xWOx3KMSH8zDtwONWdb2jvt41u4JtChZJKeVveDwnYrHYfw5uj4KYFRpSWbGqyCPL5ypIpMTkKwcWfWVXUEqRRcio1LTuUCjUE4lEsrnq8j4ZgKEP9bpgmfHFHPpyy3fle3f9Uto3n4aUIqNhDghN6zZ1vTcajaasfAsSBmBwq7f11tLM/24Hx2L+n+rbF38zBy2JEP0anPEGAj3d3d1pJ56F2GYAGInM82M+bWW53wxd++3ipH7x1QMLj8ysk5BAyj6Ppp2+d/nyaEdHh/I/W8EmA3Ci2b/iviVT3+tCerMmxkudiz450hcYBSYQIqrDmScGBvqawSxkH3lDV2Pxe6ltItnWcFNLTXX1qpqamkoK/BCvC/wNB+l5MdQKNHsAAAAASUVORK5CYII=",
        anchor: [0.5, 1]
        // FIXME l'impl. sur le KML connait qq souci dont la gestion de
        // la balise hotspot du format KML
        // size : [51, 38],
        // anchor : [25.5 , 38],
        // anchorOrigin : "top-left",
        // anchorXUnits : "pixels",
        // anchorYUnits : "pixels"
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAS7SURBVFiF3VhNTFxVFP7OfTNvOjMtM9AoJSSYEEVMCv6kJi5NoCa1TRqNxDTaFhcWNSmxaaxNQ0w3mqgLdGeRhKFYXVC7qDU2BhVt/YdqEQRhRgYTKD8VZqAMzM+7xwVCcIR58+6b2fRb3nO+853v3fvuu+8CtxEo1wX5pTu2IpasBfEeSFSCUAygCMAsgEkAQyD6DClXF3VMLeZSO2dmuN7vB+MYiBsAbDEn8BIIZ6BrzdQyF81FDzkxw8/594P5HQCFCvQ5QDRSYO4Tu30IO2QGiA/5XgVzAGpGsMKTZ/mw7wTbfLi2yFzvOwngpJ0aaXidAtG3VcnKZv5dWgE7Nf5fFBJCHqK2hUsqdKVG+EihDwn5K9SXViZEAHqAApGIVaLaO5Pg48iPEQDwg2WjCtHyzKx8RxJBZLP9qoJ5CdJ9t9XvkPWZiSVrkY0R3b2MxnM9aJ2Ooi3iRut0FEc/6IHuiZtyidwQ8RqrrVk3Q7zHNEd3L6N5eAYP7q2BppcB0KHpZXhoXw2aB6eyM8SPW23NuhnGvaY5L7T2w7Nt54Yxj68KDS19WSiZ66RBZQPYYZpRvfuejPH7H8scX0FJlv2sQcVMkWmGpmc2bBbPVicNKsvslmmOkZg0id/IQmkhy47WoLABYNo05/rnIxnjv1wOmtbgLHTSoDIz10xzzhypQiz624axWLQPLQ3V5kLUa7U1la35G9OcRMyFY/cV49qlLhiJMQAJGIkx9FzswsuVO5BccpnryKuWW7NK4IPFXmjLgwAKrHItYB66t5JaJmJWSJZnhjqmFiFxzirPIjqsGgFUD5qC3gRjRolrBsYMQEr/NEpmKBCJgHBKhWteHKdUjv8rVBvgw773QaizU2M9DMb58q98rwghXC5md5zI5WSmlCGcAODQZDIlhCSiJT0eX6waH490AsYq356ZZ4oK4DSuAihT4UuGYIaQILGQ4vknen2BibhYzlqfySBG2CH4ylA4HLb9y8v1BY8A9CkAzVwcZDA0BgkG0+oFBjP49Ij3o48n9b9U20gB7bZuZwCAAvM/gPndTDmSIZKS9CRDNwCHBIv1NzFdfzu/t2EEAEiTstS2GQDA2PwbAHrSh9ebSDewihtxMdn0h/dbO/ISkIYQoZyYoW6kYOD59YdQg8mRYjgleFONpKRk07D34qJBxmY5pmBOkKZdCIfDk7mZGQDUER0FUROwaoQdZpd6H07oXT/OOWYVJZmBQZdhvBcKhfqBfFyc1xcEEpKeNjMytOgYfqp32wUFiSVm7oPD0RsKhf5zsnYoFMsMyccTUtvtFHL7ZimxFC2eGPJezrYkM6VAHGQhBsrKyga7u7tTG+XlfGYAIFxXuLfEzZ288fvCb4U858+Ou0KZajBTUkCOkhADUtOGgsGg6SVIXswAQKiuqK3UbRxIH78yq//8Yr/3i01oSyD6UwDDTo9ncGBgIGFFM29mRh/FFm+J/3qBk+9aHbsZFzf39WwN3DK0tWXCQAzMIw4hfq/etSvY2dmpvLPlzQwA/PTk9od3eowvhWCnZEodHfC2fz3rnAEQBVFQA4YPjI6OnAZkPvvIGb7bX/Ta/LP+SEftne0V5eW1FRUVpcjzQ7wt8A+9at5zXMB2DQAAAABJRU5ErkJggg==",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAP0SURBVFiF3ZnLbxtVFIe/e8eOPU5DapI2whEWyiILJGDTBQuWSGTTSkVlQRGs2MGSh4RoQWLB4x/gpVIViNokJUV0U4RQXKgQr0ookCYkdjONSJtQJTGltjO2Zw6LJlEbkszLTgQ/6Ww859xzPt97556Zgf+RVKMHFGgD+oADwP3APUAHsABcBS4BXwDnFNxsdP6GSCAt8LZAWUB8WEngLYHdO137HRI4JLDgE2K9LQg8vtMMCCiBowJuSJBVcwWOSBOWfRCY1yJCrLdXdwrkUANmZL05Age3G2R3hD3iZYsC6TB16ZA8rwB3h4z1Uhp4MUxg4A23co7MA2aYhD5VBrqCnkNhZqYPPyCpVJnh4Ry2PYNIFdue4fTpHKZZ8ZEjBTwWorZgEvjEc92nUiUpFn+VjbS0NCqm6edgPbEdMD97FjI8PLIhyKoGB0d8wPy0HTBXPQux7Stbwti25QNmNmhtYW4ANtCytZNUPXxslEp4pKoq8PK5Q2FuAH97elSrcx7Xr/nIc8NnPWsKAzPv6XH27OUtr585Y/nIs/Uf0ggJHPdc76ZZlqWl0Q33y+LiqCSTFR975th2wDzjqy0xzbIMDo6IbVsiYottW3Lq1IhPEBF4ejtgdgkUm9SXrVpRoDVobYH3zEqLcTxoXEAdU1Bqco5bkluPyPNNmpV5Cdk1RwE63CSYw2FrivSYKtBPhOTr5cDJnmz2Oa11IiFi2kol4iKq7ug4QMxwa3WtXaVUpcW2Sw/MzhaHwFmNjwrTDvwC3BeJAripdXF/JvP+H7HYsu/8ohwlWDEt305YlhX5BYLAI0AOMCKMIUc6Oj4eaGuzwg5RhxNhnzTXpOAC8E6UMb5qbb0QAQRAGa7bHRlmRUeBH8IEzhnGtZc6O89HSe6C62hdaAiMgjrwFH6a0NtUU6r28p49n5WUcry9N5FIVRnGsGVZc42aGRQUgBeCxPS3tZ37LplcCJlSBMYTjvNeoVD4baWGxkpgEHjCy2+ipWVifyYzECJFRURGicUuFgqFP2+/0AyYTlupyYTIpqd4WanSwe7udy/HYr5aFhFVR0letB7LZrPjuVyuvpFfU97tzhrGgYzjfL7J+PJmOn3yo/b2qa3GEFE1jTuttB5zDWMin8/bXnmb9qJ6Jh7vv7dW+1d3cN40v3+2q+vLTcIqKHVZw2Q8lRofGxurBsnZNJhpSLZr/XvadbOrv103jOt9mcwHNwxjbZkIlBGZiml96cF9+/JDQ0Oh72xN/YRw0TQffmh5+RtDJF4H5/m9ez/8OpWaB/5CqbwBk09OT0+9Dm4z62iYfkwm37CVqgzsuuvT3p6eR3t7e7vZye8w/xX9A0ynxee2hlfFAAAAAElFTkSuQmCC",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASKSURBVFiF3ZhdbBRVHMV/9+5uPwikFExEiCtWbSKCCEsCiU1EJIEXeMIHxZgYPzBUYzB+RUPlwwTl1UhYFIiGhrQVFCMRAoQFidGaEgIuVLrbLgSkhWBb2N3uzs7M3weBILadnZndF87j3P8553/m3ty5c+Eugiq1oDy5dRw5czGKpQjTgPuAicBV4C+E02j5gSFrn4o3pkvpXbIwMmNTLaHAByjeBKqLoGRBfY4V+lSdeGmgFD2UJIzM2bwMUVFgggf634i8qo6/vttvH9oPWRAlkS1NiGrFWxCACSj1rUSiqwXx9XJ9hWH2liaQtfifYQWsIxL9yK+IJ9xYWq1+NIaBjahl6vhr33khe2pEntg+noCRxPvSGg39GNZD6tTKfrdEb8ssaHxIeYIA1FKh3/VCdD0zN74jfRS3/XpFlpx5r9vvUNC1Tc5cTDFBqoJZ1i9opyFcR0hPomD3cvR8N02H55IvOPHHUB1aBOxy05r7ZaZY6lhTFcyy74Vunp46n5AOAxWEdJhnps5n//IElaEhRw0pwucOuA8jPOpYs35BO2Mrpg87NrZiBmvn/+aooWSa29a8bACTHSsawnWjjj/1wIOOGlKEzx3wEmaiY0VIT/I1/i/uKbKfW/AS5rpjRcHudRi/VITPtSL7uQUvYfocK46e7x51PNaTKsJn9BcyDDyEkXbHkqbDc0kbp4Ydu54/xcexec42OPvcAS9b82HHmnyhmkXND3OwJ0bBPgcYFOxzHEjGWLTjEQyryrkzFXPfmkvIY1+MpSp4Aahxy3WBQQrVU9TJFzNuSK5nRsUb0yi2u+W5dNnqNgh4PWjmrXXAZU9cZ1zGMD/xQvQU5sbxfJUXbhFY5eX4Dz5/rCQSbQae96NxOyzsnXVXNjRqrSsrRarzSlWGRJRp6RBAMGAXTK1tpdRQRT6fmXHx4kAbWDf5fsPUACeAqb5SAGkxBpYMfBW9YA/mivYXZSkhFdTyc2cqlfL9yyuRaAMQAwKeNUBWZ376piV3IuVVwoSv/V1oAKpjxTGQjX40Dhh/HvMRBEAFbHuK7zAAjOttApyP9cOg17526b303iN+7G2wLa2TJQmjYmtMYDnFHEJvQwGr8H5m766M5C3n6hEgYqhAYHcqleotzcwAqmNFEuEdN5zm3PF9vxipqx4tReBMpWVtTiaTf0A5Ls4j0VbgWae6TrOvc8ngthYPFkMicpJgsCOZTP7nw+3+QsMZK/NiLqxUwdqRCrJ2PvNWes+PxQqKKBMlCdE6Hg6Hz8RiMXO4upLPDMDFWZ8tnazHfz+CvmzIHNy5Lfd712gaIqqgsXuU1nE7EOhMJBJ5J9+yhAE4P2tj8/265n+ngyNG8tdXrrfuH4E2hFLdGs6Gxow5E4/HDTee5VhmAFj92Zf7J1Q01Krq8M1nV+zMlbfTew7dXieQRaQrqPXpx+fMSbS1tXne2co2MwAds9fMm6kmHQ2gQia29ca13V8eKnT1AYMolQjA2ed6errWgF3OPkqG9pmr1+cjm4ZapjfuqK+rW1hfXz+FMr/EuwL/AGOdsbn1H7gQAAAAAElFTkSuQmCC",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAATNSURBVFiF3VhZTFxlFP7Of+8Mi12Eot2Sia36IIJCIWmT0lhSK30wfaoaNcampBhrfGhSl5hIW9HE5VFTpWilNpUI0hrTh1YwjJSkthFEcABhBoZ0YekCFGa72/FBSLAF7jY86Pc453znO9/9//nvuT/wPwIlu2DLns1Lo3J8hwDtZHA2gNUAVgC4SYRrzNxFJH6UpNjZ4iOBqWRqJ83MmVdzM7y6520CvQ4gzQIlSoxPJVX/sLi6fTwZPSTFTOMrhbuYuRJApgP6LRDv3V7ZdsptH8INmQH6aW9BOTPXwpkRAMgE0/eNZQXvssuHK7khF5VtOEhEh+F+hQlAcX/hGu1E61CzmyKOML21at3UmAMGM+96qqrttBOyo0aadufdq3mlEJxvrXlBwFhcUh58+vPOMbtcR/8ZzSu/g0UwAgAMZHgN7xtOuLZXpmXP5qUxOT4Ca8evU0RlOb7S7ntItq8S30EWjEje1GhOacWlrNyi9SR5VrGuDo92NPd3HSvfqCsJM366pqaVAKi305vtbSZAO81yJG9qdMsnZ/vvyyveSpLHB8BLkse3Mn/b1i0fnQtK3pSYuRKb6tzdm10QP2KWklNacUlOXZIzV0xOX5KbvfvwRXMdyrbbmm0zzFhjlpOVW7R+ofj9eU+ss6BkqnMnnJxmK8wSSPKschOfRpbljqbhxMykWQLr6rBJfMiCzm3LHU3DiZkRs4TRjub+BeO/+8MWdBZ8IHPBthkiXDLL6TpWvlGLTnXOFVOjk52B6oObzJXYVOdO2D8AQE1mObqSSDv/VslDI62NftbVQQAK6+rgyG8N/vNvljxsqEqqqQ4Lv93ebE8ATfseXaJpqVcALLfLtYEJI6auLTnREbFDsr0y/4wY9LVdnh0w4yu7RgCHg2ZCSrwHYNQJ1wJGFVl53wnRkZnp8Xy/E64F7Hcy/gMuP6waygpOAnjBTY3Z0Bk1ZeeuvyaESElhTksQpXiYSdOFBwBkyVA1IQwiinkTiUju1avjdYA+w3drZjkB7Qw84NIH4hqPV1wYr7wVM+JWOcykEyMsCz7fEw6HXX/yNpQVFAHww819AoNP9kS+abkcDzutoAHHXd3OAMD2o60tTPjYTY3260qLCyMAQJJhrHVtBgA8q5eWAzAf6+fAeNwYqu6c+sWNvgEYuhChpJgpPuTXBPAiLAyhs6Ez1ONdkfqEzrp59jxgVkiSToXD4eGkmAGAbUdbQ0R8wA7Hfzl+tueGctOhJDPQnaLrX4RCoT+BRbg4bywrqGXgGbO8K5NazwcXJr5zIBFj5g7IcmsoFPrXi9v2hYYZJGBfzOAnPYIy5stJaEbky86pM1ZrMpMG4iALEfD5fN1+v1+bKy/pKwMAtS/n78xIET/MU5/r/4rUNA7G+xaqwUyqgDFAQgQMSeoJBoMJM91FMQMANS/ln8xKE3dNB4Ebyq+ftU2em4cWA1G/AHo96endgUBAsaOZ9G02g7g0VhpRMovu8ZJv5rcJxbh+rHPq59l5DETB3CcL0fVYYWGwrq7O8cm2aCsDAFXPbdjkW0bNguDRDehV7ber/rihjgCYAFFQAnqfHxjoOwQYydBbVDMAcOTZxyvWLZMPXBxS6r/tjlRDlrt7e3uvAeDF1v5P42/pFun0pc2xBwAAAABJRU5ErkJggg==",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARrSURBVFiF3ZhNbFRVFMd/985H26m1VEoL0zj0Ayqi6IZElpiQ2MSgIeJCDZGFuEEXJH4bG9QN6spoImiMIaExbREEYoIxhgEb1CZNjFg6lHnTacNHW8QW7Mx0pjPvuKDVprR9X1MX/Jfvnv/5n/89N++d++AOgip2QolRQZAWhCeA9cAqYDlwHbiCcB7NcTKcVA8wUUztopmRQarI8wbwMlBmg5IGPkGzTzUwXowaimJGEmxHOADc44L+F7BLNXHEax3aC1kEJQatCB24M8I077DEeUfE2+Z6MkOCVuBdvHdYoXgPg7e9JXGJ6aPV4SXHPDARtqs1HHVDdlWIDLAMEwP3R2sxjOGnSa1mzCnR3TET3mJpjABUkedVN0THnZEYFQQYwd7r1y3STFLr9DvkvDNBWrBjRIfS1B6J0pAdolFyNGSHqD0cRZVlbKiEKOUxp6U5N3Pry26RNZRm9ZUE5ds2o4IRIIgKRih/ajOrr8RtGVI2dObKOiUA91tGrDjUjap8cH7FZRuoOfirZQ5hvdPC3JgJW0aEHm9cfP3JBsscYkNnDtyYWW4ZoYIrPa0DKKptVzQN52YUf1vGSG548YDcVRtKN+0V9B/cvABGLGPSJxKLrqeOJm0oWWzI7XBzzLotI0Z3PII5fm7eNXPsHKM7NxVFZw7cdOaUdUymjMHwGlKdUSQ3COSQ3CCp9iiD4bXIZKllDkXUaWnOJ4Be7qKUS0ClU64D3KCcOrWSlBOS485MjxhfOeU5xJdOjYDbqfnWFTkG1LjhW2AUP+v+t6l5WmiPG64N7HFjBDxerMSgDXjWS47ZKBT4unFLZLfWuqREpCyrVElAROULOgDg95lTea1NpVQmmM2mNly+PN4JhRm+VzOVwG9AvScXwERaj2/dFT5wadg/aVtfVEEJSb+Wn2LJZNLTPwDVxA1gB7N2xw1EkH37q445MQKglPjQ0pSH5+vr6+u9/dAAVBNdwIdecvzQVd7V/l1F0ksZPtOs82wGgCFaAeuxfh4MX/Ndfe2D6tNe5E0wC1obRTGjHiWPyXNgYwidhakpNfX6Ryu+SWWU+2MqklM+35FkMjlcnM4Aai0GwitOOG0nKk6e7Sm97lJSBPpKCoX9hmH8AUvx49ygA3jaKi5mBGNbXwy3u5DIiMjv+P09hmGMzl4ovpkLVGcLqr+kRKoWikmnVWrb7rrPEkN+WyOLiMqjJC5a90Yikb5oNJqfL87vtuiFoO7jz8s/653hmsK3zL9Z8vHBZcesjIioKY05oLTuNf2+WDwezwIkEgtflYremRkMdQXa7l01ddt0cLq77JcX3qz9fgFaBqUSGvoDoVBfb29vzonmkpkZOEVpZaW+UFVpRmaeXRvzXWvZGf785oTv32MikEbkol/r8w9t3Bjv7Ox0/WZbMjMAPcfLNj28bvKMzyeBfIHCS3trvvjxbGgEuIFScR/0PzMwcHEvmEtZR9HQfaz0/WxMZdo/vftQc2Pjlubm5jqWeBPvCPwD/KOH+jnO5aMAAAAASUVORK5CYII=",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASxSURBVFiF3ZhdbBRVGIafc2Z2210hbeWnpcQVUC8kwBUJXJBIgwkgBEPEC1GMxhgE4gUJJsYERMWI3orYaiqgrYSWH/mvMaQLciE1RAKUkrLbbhMobQ20/LT7N3OOF0CC0O7szGwv9L3c73u/93vnnD3zzYH/EUTBKx6sHUvQWgR6GTAdmASMA26A6AYuofUhQnYTVevuFlK6cGaObC9DGh8i9PtAKA/GEIKvSRZtZfnbA4VooTBmjlWvQFADPOmBfRN4l8Xv7ffbhvTF1lpwrHoTgga8GeE+by9NNRvR2tfDNfyQmVv5MYJP8L/CAqgidtai/sgpP0W84d7WavBV43Eo0CtYvOaAF7K3Rg7sKKU4Hcf71sqFfmz1DEvX9rslevvPFKc/YnSMAJRhyA+8EN2vzMHasQSzveR3/HrFEMV2udv3kOlaJmgtIg8jYcMcqpu1oGXJhMi0oJQVGaV6Dvd1day62DwnaWWd+GHSciGwz01rHraZXuaUETbMoe6qVR3Ly6fMD0oZAYJBKSOvVEyd3z3/jVjIDCSddYSjzqPwYEY875RRN2tBS4kZnDFcrNQMztw144UzjjKa6W4787IylU4ZSyZEpuWKv1w+dWohdB6Fl9NsnFNCUMqKnHGRO34PYnz+Ld2DFzN3nBIySvXkjGt1PQ+d23l3dB9ezPQ6JRzu6+rIFT/Q25lwVNHkfCDDwYuZFqeEVReb5wxYmQvDxfqz6QtvnW+e69yZcNR5jOKWgKbZKSVpZUOV0bpnG3vi0YxWXUAmo1XXnp54tLL5p+dSyi52FlJRt625nwCavxlDyrgKlLjm5o9byPBkFr456IbkfmWq1t1FsMM1zx1q3RoBr4OmpT4F+jxxndGHrbZ4IXozs3RtP0Ks98R1ghDrvYz/4PfD6ti39Qix0leNh6H07siaL9ZJKYuKtA6lhSgKaC0sWwYATENlLSmVECIZTKcHZ167NtAI9gO6PzO/1ZRg6XPAFF91AJnKDES21NaYN26l8uVoLWyhSZhS/345kUj4/+Q9XjMPdBR/9wl6Qn3TjyWnzyW88i3Y5e92BmDx6tPAV35KjDnXftqHEQBhKDXZvxmA4p5NCJzH+mFg3rxzvXzn0ZN+5BUoW8p4YcxUbbZQ4nXyGEIfhrDt7MS6o/tEOm07Z48ArTPCMPYnEomewpgBeGl1HMQGN5SSk381hdsSNzwqag1tRbZdHY/HL8JoXJwfr24AXnVKK7rae/mpz3fs8aCQ1FqfxzTPxuPxf7243V9oOMESa4XOvqgDZtlIKTKVHpz4w6Ej+ZbUWlgIHdNStkYikbZoNGoNl1f4lQGM3V8us0tLfhmhvh6/98Tu0hN/XslVQ2uRlahOIWWrMozLsVgs7aQ7KmYAAnVb67PjSh+bDsKtHX9Ubmv4dQRaEiE6JLQHwuG21tbWjBvNwm+z+8hmU+/Iu8l5akwo8uA34/bg3+W1B088nKdhCK2vmFJemjV7dqyxsdHzyTZqKwMQ2r55bmpK+SktRABb2ZO+2//9E+djvcAthIgZ0P5aZ+eVzaAKoTeqZgCKt238LP10xYaxZy7tq/j5+E5Ms629vb0b0KOt/Z/GP4jqqfL5oxVsAAAAAElFTkSuQmCC",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAS8SURBVFiF3VhdTBxVGD3f3Rl2oRAstZXaBGxpoxaxhSVpE0ha0ib0qU/1QX009UHjQ5Oa+BO3pdTEn0QffNDGGH+SprGUqlUTSGtcKfGHBELALYTuwGJsSyEVKLuz87Mzny80sQjMzp3lQc/j3O+c8525N3fuXOB/BCq0YNNoU5lRZBwipsMM3glgM4ANAO4AuMnM14QQl7LZbFeiNpEupHfBwtRN1q1Xc+orBHoJQHEeFB3AB45w3hrcOjhXiB4KEqZxvPEIM58BUCFB/4vBRwdqBi4G7UMEYjMoqkVjzHweckEAoIJAF6LJ6BvgYC83UJiG8YYYgDYEn2EC4VRUi74eTEQSi0vrfBCNZeAy85GB7QNfyZClGtk9sfuBkBvSIL+0VsOspVg1w9XDs36JUstMYeU1rE0QAFhflCt6WYboe2aaRpvKDNW4jfy2X1nohmE85Pc7pPh1MYqMQ2DvIBER0ds3tvc1lzRvU0mttNme6tF7xmPTsT0mm178kuJIcSuATj+9+V5mxHTYqyYiInpXddd4y7qW/SqpVQCKVFKrDqw7sL+7ujsZpnDWS4OJPX2WwncYBj/uVdO+sb2vlEqfWG6sVJTWtW1q+81Lg5h2+u1NZgN42KuguaR522rj+0r2bfXSYGZPn6WQCbPBq0AltTLIOACA8KCPngDIhCEseJXYbE+tOg77Vh5Od/PuaRH+wzBue5X06D3jq43HM/FUHk6rvpDlILPM+rwKYtOxPWk3Pbzc2IK7MHxi+sReLw0Ge/oshczW/KNXjclmcetk6/YrmStxm+1JAJbN9uTlzOV462TrDoutiGdjJOK+e/NLqE3UlkYikT8BlPvl+sC8vc7eMlQ5lPFD8j0zidpEmkCf+uX5xCd+gwCSB01TMU8BmJbh5oFpS7FOyxClwiwez4/JcPPAMZnjPxDwxyqqRc8CeCaIxn1wcG7m4MyLQohwmLnYJAqrzJRzhAoASsi1c0K4RJQtMs1M3Y0bcx2Ac48eNEw5gEEAjwQKAYB1nksfnTvjTrlG3hwmhxgpRfDV0VQqFfiXN6pFmwHEAYSkRRisv5/5wv7eSMkq5IDPg93OAOiv6e8F8E4QDbvX6g0QBAAo5LpbAocBgLI/ymIAPI/1y4Fn3FvZt9M/BfF3AdcRQitImHhLPAcXzwLeh9D7YMPW3810cpYd7+IVwGxRKHQxlUpNFSQMAPTv6NeY+bgfjvmt0ZXrt+5IWjIDI2HH+UjTtN+BNbg4j2rR8wCe8qpztdzowvPzX0pYZJl5CIrSr2nafR9u3xcansjhBXb4IIVp/UolrLuZ9On0d/lKMlMOxEkWIlFVVTUSj8dzy9UVfGYAoP6X+sNik/h6BX02PsycMy8Y11fTYCZbwJ0gIRJuKDSaTCZNL981CQMA9b31Z8Vm8a/Tgd1n/aq/utC9Ai0LonEBjKklJSOJRMLy41n4ZbaIWXv2uYr5imYqp6p7z9xZdyb7ZvqHf9YxoIP5uiLEtScbG5MdHR3SO9uazQwANFxq2EuPUQ9CUOHA0U/e/dj+2b4NYB5EyRAw9vTExPWTgFsIvzUNAwC7vtnVrjyqHLeuWJ3me5nPoCgjY2NjNwHwWnv/p/E3iQfm3w9KV7kAAAAASUVORK5CYII=",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAATaSURBVFiF3VhbbBRVGP7+M9NddtmyvcYKSbGoAYn4REJNIGmRpMREfMEH5YEYY6ptfCCBxEgEvMR4eeCBtBYa1EIIsbVAFAIIsis0og1GpJbWdrdsiUBLuXQp3e3MzpzfB23Cpe3pzGwf9Huc83/f939z5nLOAf5HoGwL7m4ryjWssdVgWkPEi5npURAKwbgJ4CoYF5n4WyBwrLZy6G42vbMWpv5MOJ9s+TYz3gIQUDtzCkw7DGgfb6gcHs5GD1kJUxcJrSWinWAUuOjgFkt+vXbl3QNe+xBeyMyg+lOhLQRqdhUEABgFRPTN59HQu8zebq7mhVxSEdoKovfgfYYJoMpzCZ91pMk87UHEHeoiobUEavai8RAYkgTWvlkxctAN3VUj2yN5eX6y464fralxG7p4vGZF8rZToqt3xs/2OzMUBADykZGb3BAdz8zutqJcI2MMYjqfX7cgTjEHHnH6H9Kd+hjW2GqAlEF0PZhataixfX5h1QJBvhLJ5kD/jaN9J7url1l2amo+U1BwugpAq5PenD9mTGtUJboeTK0v7+0rK3qhQpCvFIBPkK+0rPjFivXP/hnTtWBaaSPUPg/CzTvzlKpg1aLGdp+e+/REYz49vGTlooZfVBrMWOy0MTdh5qoK5hdWLZhqvKzo+TKVBpHa50E4D0MoVIqSr8TL+L8omnZP47pOCWCMqEokmwOK8WvT8LnjoCsA7mZmUFXSf+No31TjfTeOJKbhNOUNmQiOwxCjXVVzsrt6mWklOyYaMzLDHae63ihXaTCpfR6E4zCSKaKqsexUoOnswifiQ4eiks1+AKZksz82dDDadHbhk7ZMz1I3RlGnvTleAdRFikOEsb8AhJ1yHSA5agbnbaoaHHVCcjwz/ywx+EunPEcg7HYaBHC7OdO190G47oqrAuE6NPGhG6qrMDUrkrchaYMbrhKSNrhZ/gMeN1b10dA+ML3iReNe2JL3f/ZqQa0Qwu9nDhhE/hxmsmyRAwC6JjOWEJKI0j7DGF1y5cpwC2CP8z2F2XkiP2zr1nkAj3mLAZhpMbx3a3hnckiMTZfDTDYxErrgM92JRMLzlrcukrucgCi8nCcw+MSe2Xs6orMSbhUsoMnT6QwA1FaOtIHxqReN2G/+Ng9BAIA0Ked5DgMA12lkCwDlsn4ijNyia8d3zf7Ri78EpC1EPCthtlXC0qRYB6gXofc1YSNz/Is5rYZBtrp6EjCbpGkHEonEQFbCAED1c8k4GBudcM6fmnXscqd+06UlM9Dlt+2GeDz+BzADB+f1kTnNAL+kqhu6rHfv3Rr+2oVFmpkvQNd/jcfj9/24HR9oqKCBawyTVuk+zp+sxhyj0cMNocPT1WQmC8QxFqKztLS0KxqNWhPVZX1mAOCT1rw1uQX2oUn0+fT+4P5z3wd6p9JgpoyAvERCdEpN647FYobKd0bCAMBHzeF9ecXyodVB4kLOzwe2zzk+CS0Noj4B9OQEg12dnZ2mE8+sP2bjMEeTr6UD4eWBkCwdvzZ6Rwwd2TX7h3vrGEiBuVcX4uIzS5fGWlpaXH/ZZmxmAGBzY0H53AXWaRKcI23Y3+0INcZ/9w8CSIIopgE9L1+61LsNkNnwm9EwALB5V8EHJWWZjV0/BVpPNoW+gq539fT0XAXAM+39n8bfE7XcWzV66JYAAAAASUVORK5CYII=",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAR4SURBVFiF3ZhbbBRVGMd/58x2u7vQbmtvssSNAjaRiE8k8oAPBowkVTAGTVAJJMYXiTGYNFxisHiJ7ZMPQiIxxhRLCG1tjSBRubiAJEhiNDaFSlu6baRQELsI7e7sZY4PlKT2sjNzZvvC/3HO9//+33++M2e+GbiPIAqesYkSLNYgWAssBRYAFcBNYBjFBSTfkuR7GrhTSOnCmfmYcgTbgbeAoAPGOIJP8dPIVhKFKKEwZppYj2If8IAG+x8Eb7CNDq9lGJ7YCkGQXcBeIKSZJQi8zDNYHOMMu/XL8WYmxHvAbrx3WABPc5YsxzntJYke7m6tVk85psNCsZ4ddOqQ9Qr5hDJM+tF7RuwwimIxOxh1S5Racml2MjdGAMqBeh2i+840UYJiBGfHry7GSVHj9j3kvjMWa3BgJOQPjXe82BEz680htU2lzXpzqP2F9ljQF0w6UAlRzLNuS3PfmUa+Al7LW4k/ND68Zfhy2B9+fOpawkx0RfZEliSzSbsbsp/tbHJTms4z85hdQMtzLednMgJQVly2rLmu+RcHOkvdFqZjJmIXULe4blG+9XW16x4phM5U6JipsAvwS/+DXtYnUOm4ognomLltF5C20tds1q860PnXcUUT0DEzYhdwuPfw5XzrnZc647Yqgrw3ZCbomDlvF7DxyMYnE2aia6a10dRo1+bvNq+wVVH2OlOhY+Ynu4BkNhmM7Iksaetpi6Wt9CCQTlvpwUM9h2KRvZFHU9lUwFZFEHNbmPv3TAPzCfAXEHbNdY5bGCyknjE3JPeduTtifOma5w5fuDUCuoOm4n3guhbXHtdRfKhD1DNzdzzfqsW1x1ad8R+8flg1cgB4xVOOybA4GP0sukVKWVysVNAUorhIKZHNySIAn2FlslJaQoik3zTHll25kmiD3D26VzNh4HfgYU95AJmRiWhrZJ/vti/llKOUyAlF3CfVmZ54PO79k7eRlUAMb/8TVNWpiv3hiyVxXX4Wmr390AA4zhCrCCB4SjfF/IF5P1eeK//NQxVCWNYNvQNgKkx2AU7G+mnw3TGu1pysPOVF3gIrJ2V/Ycw0kEXyKg6G0MkQlshUn6r6WmREzj56FiiVFobREY/Hr3nfZvdwjFFWcRPB804pZV2lR8PdJXmH0jxQCnoCuVzrn4ODgzA3P85bUbxkF1b8t7/nofbIIQ2FpFLqD3y+X/v7+//34vZpJMsPgzeFKVYrQ5XPFiIzYqz6ZPURpymVElmE6lNSdkej0YuxWCw7U1zhOwMY7xprc/Nz38ySX1WeLT9Y1hXuzZdDKZGRWANCym7LMHr6+vpMO905MQNQtLPoQKY0M206CA0Fz0WO1vwwCy2JEJclXCoKhS52d3en3WgWfptNIOPPvC5TcqUVsKL3rhnjxo2aE5UnJscpGEepXp+UF55Yvryvra1N+2Sbs84ABN8JrkhVpU4roYqwyC34sfrzefHQCHALIfoMuLRhYKC3Aay5rKNgCLwd+EB8JJKlm0pbahctWl1bW7uQOb6J9wX+A8zucxGCTS9IAAAAAElFTkSuQmCC",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARZSURBVFiF3ZhbbFRVFIa/vedSZkTbClJow1irNpGIvpDIAw+NIYghqTHig6JGIoLSGEK8xEhoKpKovBoJg1aCaVNpsYhIRINh1D5oDYaIvUhn2qGhNwi2RabtXM7ZPrQk0Ns5Z5+ZF/7Hs9e//vXvtXP2OgduI4isZ1S1d0JmPVAJrACWAYuAq0A/0A7qWzBOIaquZ1M6e2bU/kLwvAu8AQRsMMZAfAK+jxCbR7JRQnbMqAMbQYSBuzXY/4J6FfFas9sypCu2UgJ1sBpEI3pGmOSJo6jwbpRytbnuzHCwGtT7uO+wAPZAeJfbJHqYPFqNrnLMhAliI2LrMR2yXiHqUAGkYugfrfkwDMb9iO3DTomaxyz1HrkxAlAI8m0dovPOTN4jQ9h7/epiDDJFTu8hjc5k1mPDSBDvWDPrIkm29Cq2ppJs6T3KukgA37gNkSD4nnBamc4xq7SuxDvWzwvdT1Na4UeGAL8fGXqG0op+NkVtGrLUmQ4dMw9ZBdTxeGs+/odnWyvAv/IwFb9by6gVTgvTMVNsFbCBUNl8609x733Z0JkOHTOLrAL8yKVu1qew2HZFU9Ax859VQApz0GJ9wIbONdsVTUHHzJBVwAl6u+dbP0ZP3IbOvBsyGzTMqFariBc589gIqfOzrQ2TPP8ykdU2hCx1pkOnM2esAsZJB4qpf6CJnkgK8yKQSmFePEIsUkzdgxMYC6xlRMRpYRoTwKcLwXsJyHfMtY9RCJQgXko4ITnvzOSIccgxz5lIrVMjoD1oGnuAy3pcS1yGzF4dop6ZyfF8pxbXGjt1xn9w+2GlwvXA865y3AzDbAiVfVglpczLUyqQFCLPp5TIGNIH4PWY6YyUphBi3J9MJlb29Y00gXGD7tZMPnAOKHWVB5DXUyOhJz8Pey+NTtiWV8IQirhXql874/G4+09eFV4DRACPfg7UPbu+/zK/4VxcN0MGDrv8oQGIbS2g9rlJsfDHf1pcGAEQHtMscW8GgMFqwMZYPxPegWsDRW+e/NmNugmmIWUsO2ZETQbYhI0h9BZa2kgveefk1yKRNKyj54BSKeHxNMfj8cEsdQYQ22LAW04o+XV/ngq2xK9qKioFHXmGcSAWi/0NOflxHm4EnrUKy2sf6ly+4YsjGgrjSqm/8HrPxmKxWy5ur0YyK2wXycxalectnCtAJpKJJTuOf2c3oVIig1BRJWVbKBTqiEQimdnist8ZwNP3caVRXPDNHPnV4r2nGwpq/+iaL4dSIi0xe4SUbabH0xmNRpNWujkxA+Dr3VefXp4/YzoIRmK/FW9u/GEO2jhCdEu44AsGO9ra2lJONHNxzABIG2OvyGH/GrMwELrxzHMlcaVox/Gfbo5TMIZSXV4p2x9ZtSra1NSk/WbLWWcAAmdrVk88uvQX5RE+Mqax7PXmz+443TUEjCJE1AMXnuvp6aoBM5d1ZA0LWnd/IJL7x+/6qqquvKxsbXl5eQk53sTbAv8DzFJ5Mvw8/r8AAAAASUVORK5CYII=",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAQLSURBVFiF3ZnPT1xVHMU/983QYcbqlNZoCmEkqCxMtJsm+gfQ2KaJqaYurDHaZeO2dmH8lZg06qZLtYY0RhqkKFrd1KYJE2VhqiQG5YftDAwEShFpARmGN8y84wIxhQLvx8xA0pPczbzv955z7u97B+4hmLLXKN0PHASeA54A9gJ7gGngBtAPfAdcwpj5svOXBVIN0odIC0jyULJIHyDt2m7pqyEdRZr2aGJtmUZ6YbstgGSQ3kFyAhpZKQ7S20jlH/Y+zLxboom15a3tMnK0DD2ythSRnt9qI7tKmCNu5RZSTRBZVkA7bwK7A+a6oQZ4I0ii/wm3vI9MAtEghB6xADzsdx8K0jMH8WAkBgudkLRhVJC3YfQrSEYh54EjBjwbQJtPSF+4jfuYlJ2Rftc6uC31Rr1trJ9vhZlf3YR0Sl3rGVnBBanLg5lftsLMDTchtjSymRlbyngwM+5XWpAFwAZ2bBoCeZcY20DEhSmPMW4xqxBkAfjHLSAPN12+T3jgmfOs6D8EMTPpFvA9DG32/RvIeODZtEHKA+mc23iPSgu3pd715sstqbdaynmYMy1+pQXpmS63gBxEa+GxDkjmYQTI52GkHZK18PgiVHvgSfoVFmQB2AmMAXHfud4xC9RhTNZPkv+eWT5inPOd5w8tfo0Ex/IVebJCp+bJoKfmUgwdq5CZY0EllXZNlc4DgcnvQrHYlmhsfN2yrEhEitrGRKokUyhaVQDhkLNUsCzHGJPbYdvZJ8fHZzqguJJeqpk48BvQUFI9gDU/P5M4dOjT8NjYond6UzQiE7b002Amkwl6OVuGMbPAK9zROoEgac/p0xf9GFmmVwhLjxbg1YaGhobSzCzX2A18VEoVOy9f7o63tWVKURFynLryPO1IYaAbeNpvanhiYuKRAwdaTDYbuHcdcBw4W3rPABhTAF7GwyF0VdrS0tJDp059XYoRpLwJhTozmczN8pgBMCYNnPSTEm9tvRTr7p4OyCjBQKRY/CSdTv8BlXk4vwC86BYW6e8frD98uD0AQ05SL+FwTzqd/uvOD5Uw86Cx7WuKRDbcxa1sNlt35MjHkVTK05FFMgWMUrKsvkQiMZBMJgvrxYWDat4QxvxtjY+/Vqyt/Zb1G0u7z5y56GZEMksWzrCxrD4nHBpMpVI2wNDQxlelij1UV42Onl+qr7/rdBBLJn+uPX78hw3SchgzZMG1qlhsoK+vL++Hs3Kv7sPD1VY8/qdTU5NY+Sk0NTWVaG4+G5qb+3+YCBaQroctq/+p/ftTHR0dgVe2iv6FEO3peWZx374fFQpVUSgU95448dl9V65MArMYkwrBtZeGh6+/B04ldZQN1Vevvm9sO/fAl+2tTY2NzU1NTXVUuBHvCfwLna16k1MlopgAAAAASUVORK5CYII=",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAATaSURBVFiF3VhdbBRVFP7Ondlddvqz/aERARtFMUos4YFIH3iAxESICfCABtqkCRiJtjGRBBODivhH1PigEovFGKhJXWktpdgQfDCugEFrCEhbitvdditSKIhtge52d3bu8YE2AWx7d2a2D/o97jnf+c43996Zsxf4H4GyXXD25ta8MSOxiiWvAWERCPeCUQzCNYAGwHyOGIf90I5erX3mZja1s2Ym8EJDYZq0V0D8IgB/BpQ4gN0ez9h7wx9tGs5GD1kxk1sdXM+EOgBFDuh/E9NzN2s3HHTbh3BHZzJqvt7BhEY4MwIARUz8jVEdfB1gVw9Xc0M2qh95gwhvwv0KExFWeh7vTJu/Nh9zXMQpcXxrNbqpMQmkBNYnPt3Y4oTsqJGCl/YVmOasKJxvrekwpEv54MieyiG7REdnxjR92zEzRgCgMC3Ey06Itldm9ubWvIQ/PojMXr9OETdYu8fud0i3qzJmJFaB1UZyvHp8b1V5++qyuQu8mpiTsuTlIx0DvVvqTy6Lm5aKbyRE+kkAzXZ6s73NWPIaVU6OV4+Hd63tXbtk/gqvJkoBeL2aKF23ZP6K8LvrIoZHSyh1AKXO3bB/ZgQ9qkrZW1XeHpjleWyyWIHhKaurKv9FqcO0yHZrdgkAz1VlrC6bu2C6+FOL5z2QgZBS527YN8MoVqV4NTHHTXwcszPuaRxOXs03VAkpS15WxC9loHM9447G4WSbDaoyjnQM9E4X//bMhZhShjDtA5kMDsxQuypjS/3JZcNxs2Oy2HA81fF8Q3u5Uoah1LkbDs4M/aBKiZuW/+FXDz3UcvpCKGXJfgCplCX7m0/1hxa+1rowkbJmZaAUstua7QmgpLoxN07WnwACdrk2MDLqN+fhw6pROyTbK3NrxKB9dnn2wF/YNQI4HDR1ab0F4IoTbga4okt+xwnRkZmRPZVDIGx1wlWCsNXJ+H+L6gI5NcEGABVuatwBtoLFbdtrhBA+H7M/SeTzMFPaEh4A0DVppoWQRJTwJpOjZRcvDjcB1gTdlZnCLY2BlMc6A+B+dy4AkU4Olxz7uE4khsYy5TCTRYyYLvj4+Vgs5vovb171V8slUQhu7hMYHOhs+dL4oz3mtEIaqHd5OwPcqK04AeADNzX8g10nXBgBANKknOfaDACMlszZAUA91k8CbWzkUuBs049u9CUgLSGiWTGDnSvTuqBKgJVD6O0gaZmB35qbyUxa6uwpwJwiTTsYi8UuZ8cMgJHdG6JMYpsdjr//5FHfXz3XHEoyA90+y/osGo12AjNwcZ5TE2wE8LQqz3v90vni458ccCCRYOaz0PVT0Wj0jg+37QsNFYTJ1axZT7DQC6fOSY7mnw62ZVqTmdIgjrAQXaWlpd2hUCg9WV7WVwYA8jbXrpH+wkNT1Of8c23BnL6feqarwUymgOwjIbqkpp2PRCJJle6MmAGA/E21DZZR+K/pwHf195+L2vd/NwUtAaJeAYQ9htHd1dWVsqOZ9W02gevsfzY3NbqcvTmlE7+J5M2rgdMHvr89j4E4mHt0Ic4tXro00tTU5PjNNmMrAwBFle+XpwLzjzEJD6RlFZ1q+Nx3pXsQwAiIIhoQ3tjX17MTkNnQm1EzAFBQsettM3DfNv/FM81FnS37oevd4XB4AADPtPZ/Gv8AkvXQkIP4nXQAAAAASUVORK5CYII=",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASpSURBVFiF3ZhbbBRlFMd/3ze7bXdp0yKlQI2NIqZlK8YHjDxgFEIikVhKAibeooH4otFIosFLgvdEn9QQHojxAkoIFChRMWBCXC5GxRgb6sJSWrrlDgXbUrrbndmZ44Mlwdru7MxsH/T/ON/5n//5z5n55swH/yOoomesb6rAMBaDNAExYAYwBbiC4hxwFORrKNlDouVaMaWLZ2bOksk44VeA5xEiBTDSiFpHqbxP267+YpRQHDONS5cjagNwkw/2n2j1DH+07gxahhGQr2hcthZhPRD1mSOC8Ag1DQ69yYNBiglmJtb8BvAWwTusgAVUN+S4nDzgN4l/M41Ll4NaTzHfO8UDVNe3c/l40h/dD+5ursKkC3/viBv6MKzbad/d55WofclZ8hoTYwRgMnb4ZT9E752pb6ogpC8WuP36RRoVnub1O+S9M4axuBAj0bLS9M6P18SzbdtPSaLVzLZtP7X9ozXxSKQkU4BKFKwHvZbmvTOx5i+BJ/JWUlaaPrf/s5OV5dE7R6/1Dw611y5YOSuTMfPfEKU2kWh9yktp3jujmO0W8tUHLx4eywhAVcWkORvfe+EXVx1HYl5L825GqHULWXL/PTPzrS9dOO82Vx3lrjMafnazKW4BJWFjepD1EVQXXNEI/JgZdAswLfuCy/r5AnSuFlzRCPyYuegW8E3815P51lv3/ZQqQCfvDRkLfswcdgt48tUP7+0fHGofa61v4Fr706+vm1cMndHwsQHID24hmYwZqV2wclbL3h/jpmX3AKZp2T1b9xyK1y5cdcfwsFnmrkPca2nevzONK8rBOoNQ6ZlbKBQDGOmbOfL9kBea9878PWJ87pnnBcKnXo2A30FTW28Dl3xx3XEJw3rXD9GfmfbdfShZ7YvrBiWr/Yz/EPTHKta8GXgsUI4bIc6WuqG257TWpaUikaxSpWERlbN1GCBkOFZOa0cplSnJZofmnD3b3wL2dXowMzNXVFJmtQG3BsoDaJz+uuHkhpBjDhfKEVG2ElIhLQeTqVQq+C9v47L5IHEkyHmCyFTrzKZK60rKb4IcbAx6OgO9yVNMbSgD7vObotweOFRtnv89QBVKOU6vvw1gNGr61wLuY/0YCIl5fpp5en8QeQccW+uu4piJx3NoHqeAIfRGKLBqzNM7lNi2e/Q4EDGVYexMpVIXgj9m13Ep2UdNwxXg4UIpVVbvd5W5y3mH0jwQgWSZbW873tPTAxNxcB5r3gascAsrdTLJW4aPb/WhkBGRI4RCv3V1df3jwx3ykSw/cvazKqQWCXryeCFa7KEaq+fbQlOKqBxKOkXrRF1d3bF4PJ4bK674nQGM+iVNthHeNU5+qTbPbqnK9Z7Il0NEWRqnW2mdcAwj2dnZmXXTnRAzAOHYQ5stSv41HURzgz/Xml17x6FlUOqkho5wNHoskUiYXjSL/5iNwEqnV+mInu+oUN31a4bkeqdlU/tuvIUCaUROhLQ+etfcuZ0tLS2+d7YJ6wxAZPaiecO6/IAIYUTsGWb3J5PsqxeBAZTqNKDj0e7uE2+CUwy9CTUDUFa/6J2sEX2pwurfMd0+8wWh0LGOjo5zgEy09n8afwEcs7T5cvn0GwAAAABJRU5ErkJggg==",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAS2SURBVFiF3VhbTBxVGP7+szPscmkq1FZqE2pvUYvYwpK0SUla0ib0iaf6oD6a+qDxoUlNvMTthZp4ifHBB22M8ZI0jVCqVk0gbeOKxAsJpAG3ENiBxdiWSypQdmd3Znbm9wGaCAKzc2b3Qb/HOf/3ff835+TMmQP8j0D5FjxwYGhdJlN0lIibmbEbwGYAGwDcBXCbmW8KIa6k0+mOWKw6mU/vvIWpqRkvV9XsK0R4CUBxDhQdwAe2Ld66cWPbbD56yEuY+vrRY8x8HkCFBP0vZhzv69tx2W8fwh+dKRzWIszcCrkgAFBBhEvhcPwNgH29XF9h6upGIwDOwP8ME0Bnw2HtdZ8iclhcWq1+NFaAw8zH+vp2fiVDlmpk796xBwIBR4P80loLM6ap7BgY2DrjlSi1zBSFX0NhggBAeVFR9mUZoueZWfiOqJPIbfuVhZ7JZB7y+h1SvLpkMkVHAXYNEgoJvaVlY09DQ8l2VaVKy+KJri59NBKZ2mcYrvyS4uJQE4B2L715XmZE3OxWEwoJvaNj62hjY+khVaUqAEWqSlWHD5ce6uzcGg8GKe2mwUyuPsvhOQwzHneraWnZ2FNWRk+sNFZWJmrOnNn0m5sGEe/22pvMBvCwW0FDQ8n2tcYPHizZ5qbBzK4+yyETZoNbgapSpZ/xBdCDube0AIkwNO9WYVk8sfY47uRgdC/nlhYhEYYn3Sq6uvTRtcaj0VQiB6M1X8hKkFlmPW4FkcjUvmTSGVhpbH7eGTh1amq/mwazu89yyGzNP7jVGAYXNzWN77x2LRW1LB4HYFoWj1+9moo2NY3vMk0OuTYmKOq5N6+E6upYWSgU+hPAeq9cD5izrNIt/f2VKS8kzzMTi1UnifCpV55HfOI1CCB50DQM5SyAKRluDpgyTeWcDFEqzOLx/IQMNweckDn+Az5/rMJh7QKAZ/xoLIV9cXr6yItCiGCQudggCqrMlLWFCgBKwLGyQjhElC4yjFTNrVuzbYB9n+03zHoANwA84isDAGZ9Njl7/LzjTGRy55BNjIQi+KehRCLh+5c3HNYaAEQBBORVmPXU+19Yme8TsgJZ4HOftzNAb++ObgDv+NGwzO5uH0EAgAKOs8V3GABYt+6PCADXY/1KYGf6Tjr59o9+/B3AsYXQ8hImGm3MAs6zAFwPoUthWXrq3XbmtO1euwqYTQoELicSiYm8hAGA3t5dGjOf9MIxMt92ZM3eu5KWzMBg0LY/0jTtd6AAF+fhsNYK4Cm3OierDc3PPf+lhEWamfuhKL2api35cHu+0HBH9gVm+whRsHy1Cnb0VDJ57rtcFZkpC+I4CxGrqqoajEaj2ZXq8j4zAFBb+0uzEJu+XkWfM6kPLxqZSyNraTCTJeCMkRAxJxAYisfjhptvQcIAQG1t9wUhNv/rdGCZPb/q8692rkJLg2hUAMNqSclgLBYzvXgWYJktYGbGeq6iYq6BaH3V/WeOMzOdTr55/Z91DOhgHlGEuPlkfX28ra1Nemcr2MwAQF3dlf1Ej3UBARWwbf3e6Y8t6+dJAHMgigeA4afHxkZOA04+/AoaBgD27PmmRVEePWka19sN/b3PoCiDw8PDtwFwob3/0/gbh/Lm30zcQi4AAAAASUVORK5CYII=",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASdSURBVFiF3ZhbbBRVHMZ/58xeSgNCqRegsamt1EhEXwjw4AMmJGpAEhNoVOItxgdFQ1C5qqQiKiVRHtQIGuKDXNItFJGSoFFYpIltExIj9EK7WxbTUi7BFqHbTndm/r60CWDp7MxsX/ge9/y/7/t/55ydOXPgDoLKtWDVQZnkDPGUgiUIs4DpQCFwBTgv0KLhpwE4UlmhrufSO2dhPtstBSrEOhRvAxOyoKSV4stIiC2rnlV9ueghJ2GqYrJUYAcw1Qf9H6V4fe0yVRu0Dx2ELCJqS0w2CsTwFwRgqgj7qqrlQxEJNLmBwmzdx0bgI4KvsBLFpqp9vB9IxC9xeGvFgmiMAkdg6foKdcAP2Vcj2w7IFDNDEv9bayz0Soay9ctVr1eir202lGED4xMEoIAQq/0QPa9M1UGZJCYXye7x6xfpQbjP63so5NVl+IXoGiQSIr14Lk1l0ynVmmmOw4WOHjrrGpln2a78/KjwJLDfS2+et5mCJW41kRDpFYvpnFnEAq0pBiJaU/xQEQveeoZEyGAgFz63wvt/RnjYrWTxXJoiYR4ZbSwaZvaiuTS6+ihmeW3NzwNghltB2XRKxxovn8EDufC5FX7CFLqKaqYFGR/G3Vl3NKLrlQBccytwHC6MOS70ZOHzb9YdDcNPmItuBR09dI413t5Nyk1DMfaEjAY/YZrcCuoamWdmODXa2OAQpw43Md9NQ5S7z63wHkZxzK3Espnw1SEebOsi7jicA4Ych3NtXcS/rmOmZZPnaiPEvbfmEZUxmZgHXcBkr1wPuGoMUrT6JdXvheR5ZSor1HWE773yPGKn1yDg86ApFpuAS364WeCSZNjsh+grzPDxfJUfbhZY5ef4DwE/rLbEZDfwQhCNG+HY9t7ta0tXaK2jUZEJplLRsIiybB0GCBlOxtLaUUoNREyzf3Z3d18N2CP8oGEmA38CJYFSABnzel/tF0/vuNbbNZgtR0TZSkiFtJxoS6VSge4A1lWoq8CL3DA7/iDScPjTg16CACglBlrKLHi5pKSkJFAYgHUVql6ErUE0Uqd/qT/TsDcVQEIZjlMUOAyAeS8bIYtj/Sjo7+vpOV797vEg/g44ttbJnISpfEJZ2mE5WRxCb2rCzmSO16zZnzH7/W9TkSFlGLWpVOpCTsIArHlOJQXe88Jp+WPXkfMd9Vd8WopAa9S2tyeTydMwHhfnMYkJLHOru9LT0nZg26JqHxYDIvIXodDJZDJ504vb84WGGwyLN00xFxrhaMHtaiyzv//onpV12WqKKAslCdG6ubi4uDUej1uj1eV8ZQA++LZ7ycQpM368jb40HNq89/SJnR1jaYiojMY5q7RudgyjLZFImG6+4xIGYMM3f+++q/D+/50Ous7EG47sfPXn29AGUKpTQ3s4P7+1ubl5yItnzrfZCCJ59muD6d7H8/ILikd+S1+7fPnYnpW/3VgnkEakI6R1y6Nz5iRqamp8P9nGbWUA3vn85Px7ih77XWkj7NiWffSHN75Ltfx6EbiKUgkD2p8/e7ajEpzx7CNnWLm16eNP9pgDr6yu3lVeWrqwvLy8iHGexDsC/wHqq7fSQTg4DwAAAABJRU5ErkJggg==",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARmSURBVFiF3ZhfbBRVFMZ/d2Z3y1aatoCAbVyxahON6AuJPPDQGIIakhojPihqJCIoxBDinxgJTUUSlVcjYTENYNo0UCiKRKrRdFUetJGEWAuE7rZLA+VPg22Fbdk/M8cHtkmtbWfmzu4L3+Pc833nfPfczD0zcAdBFVqwCSnLwdNAPfAIcA8wH7gODAJnBI5Z0LEZdbOQuQtmZjdSacIHwNtA2AVlTMHnQfh0HWqkEDUUxMweZI2CKDBPg/63wBtvotr91mH4IQui9iINCg6hZwRgnoLDUWS7IL4215eZvdAg8BH+O6yAHVHY5ldEC/mjdciPxjSwFazZgDqqQ9YqZB9SkYEE+kdrNgxb8MAm1LBXotYxy8CHFMcIQKUB7+kQPXcmf49cxd3rVxdjOVjk9R7y3Jn8hehoJFDK2Kp2YuvTDGwQMuvTDKw6TCwYZtxFmtIgPOW1Np1jVu8UEChl7OVB+pY8R50RIgKEjBCRJc9Tt3aQuEtDjnmmQsfMw04BTzbTFSrn0enWQhUsrTvA704acnsU8gQdM1VOAZHV1My2ft+z3F+IPFOhY2a+o2iIxX7W81jguqIJXa8E4IZTgJ3hisP6ZRd5/nFdUR46Zq46BQx8S99s6/1HSbrIM+uGTAfPZgS6nGI6X+GJzAjd062lh+mOvcZyF6kc80yFTmc6nQKy44Rbqniwv42YneECkLEzXEgcJNZcxUPWLeY4aSiIeS3M8wTwBTI3ABeBcq9cDxgNQ/WrqJQXkufO5EeMfV55XqCgyasR0Bw0LdgBXNPhusC1HOzUIWqZyY/nW3W4LrBVZ/wHnx9WUaQFeMmPxmTYWK2fRGo2G4ZRUiISTitVEhRROcsIAgRMO5szDFspNR5Kp1NLL10aaQNrgu/XTDlwGljiywWQMW6O7K96JjoauHjLLUdEWUpIBgz59VwymfT9yRtFVnD7NWrqq4h0zN/2VXdZa1JXIAcHfP3QANiIOimwy49G710/nPRhBECZtl3t2wzAFWgA57F+OtwwL18+seCdn/3kt8G2DCNREDONqBywFhdD6GRYKpv97u73j6RVynKOngEiGWWa7clk8kpBzABsRCWAd71wTpc1dwzMOXldM6UInC2xrD2JROIvKMKP8yhyCHjBKW4odObc/qrVBzVSjIvInwQCpxKJxH8u7oCGmBM25VR6ZUBKKmcKyKhU6puFW467FRRROZTExTB6IpHI2VgslpsuruCdAfjMvFRfYVV9PYO+dFbubP2jvKl3Ng0RlTWw+5Vh9NimeS4ej6ed8hbFDMCu4EBLefbe/00HfeHYb0cWrft+Bto4SvUZcD5YWnq2p6cn4yVnMY4ZAGNZ6/WQMbwibFdGJp6lzKGh4wu2/DQ5TmAMkd6AYZx5bNmyeFtbm/abrWidAWgMn1q++NbjvygxgzY569jCt77sLf3xKjCKUnETzr/Y39/bCHYx6ygYts/p+ni3So9vnnuwubamZmVtbW01Rd7EOwL/Ai1BeTIkgAbWAAAAAElFTkSuQmCC",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAQMSURBVFiF3ZnLT1xlGIef78zAMFgCeGscLCGoLEy0myb6B9SIMTXW1IU1Rk3cGF16SYy3xMRUN8aVWkMaY0lDUbS6qbcwKjGmSmKwXKQzMBAoINICMgxnLufnoqWhCJzLzEDSX/Ju5rzved/nu39n4BqSKfULhWqAVuAh4E7gFuAGYA44DwwAXwGnDWap1PlLIqF6oXeEloXkwdJCR4Tqdrr2qyR0SGjOI8R6mxN6ZKcZEDJCrws5AUFWzRF6Tajkw94PzBtFQqy3V3cK5FAJemS9FYQObjdIXRFzxM0uCNUHqcsKyPMKcH3AWDfVAy8GCfQ94S7vIzNANEhCj1oGdvvdh4L0TCteQKpZpos4NuOILDbjfEacKBkPOaqB+wPU5k9Cn7qO+2qlNa8/tZEuqk9RTxvrJ9sB87trIV3q3hBkVSfV7QHmt+2AOe9aiK2xLWFspTzATPqtLcgCYAOVLk5ZFx8bQ8QlVdZg3HyuUpAF4F9XjyzTLs+nPORZ9FjPFQWBmXH1+JqRLZ9/QcpDnq0bpBQSOuY63qNa1kX1bThfLqhPVcp4mDNtfmsL0jPdrh4ZosS4nU7iZBkDsmQZo4M4Me5ghSoPeeJ+CwuyAOwCJoBav7E+tAA0GEzaT5Dvnrl8xDjmN86n2vyCBJYuXZFnynRqngl6ai4G6HCZYA4Hramoa6pQOxA4+XoVKJxobmx+zrKsSESK2sZEKiSTL1gVAOGQk8tblmOMyVTadvquycn5TiisxhcLUwv8ATQVRQEsWUvzB2IPfDQRnljxnF+mYEQqbOnnoVQqFfRyBoDBLABPsKZ1gkhIR+rfPuUHBMAYhbB0Wx6ebGpqaioKBsBgeoB3i3nHd9d929NRcyJVTBkhx2koyacdoTDQA9zjN3Y6NDXVeut9bWmTDty7DjgOHC26ZwAMJg88jpdD6BrlTC738k0vfV4MCFLWhEJdqVRquiQwAAaTBF7wE9Nec/z0L1U9cwFTSjAYKRQ+TCaTZy/VUGIJnQQedfMbqhwYOhB7sCNAioykPsLh3mQy+ffaB+WAudE29nBEkU138WWTTh9sePiDkXDC05FFMnmMErKs/sbGxsF4PJ7fyC8ctOjNZDD/TFqTT8UKsS/ZuLH0ft17p9xAJJOzcEaNZfU74dBQIpGwAUZGNr8qle1D9XjFePue3J7/nQ5+jMZ/fWb3099sEpbBmBELhiuqqwf7+/uzfnKWDWaU0apaq/aveqe+cfW32dDsbGts/9HF0OKVYSJYRjoXtqyBu/ftS3R2dgZe2cr6F0JvtPfevSt7fwopVJEnX3j+5mc//qH6+xlgAWMSIRh+bHT03JvglLOOkulM1Zm3bGNnOnZ1HG9pbt7f0tLSQJkb8ZrQf5kyepAtajIBAAAAAElFTkSuQmCC",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASoSURBVFiF3VhNbFRVFP7OffMY6EjnvYGMrW2atmijRNyUBJcsTGRFQkJTKwpuXBliSDQxGolVEo0rjAuBhLCRGFuL4AoXTauWaBtNTHHoD/NHImXoOH2vY9+Uzvs5blpSoO37m7rgW777feec794zb867wGMEqnXAYrG4XQhxgIgOAtgNoBHADgAlADMAbjDzD7ZtX00mkwu1zF0zM7quq47jvAfgOIBtHiQVAF8S0Weqquq1qKEmZkql0mEiOgsgEUA+R0Rvqqp6KWwdIoyYmUnTtJNE1IdgRgAgwczfaZr2ITOH2txQZnRdP8nMvQh/wsTMH+u6/kGoIEGFy63VFybGGnCI6LCqqt8HEQcqRNM0hZkzCN5aG4YXQuxSFEXzKwzUZsz8PjbHCACojuO8G0To+2SKxeJ2SZLuwtvrNygqlmU96fd/KOI3ixDiADwYIaJKLBYbk2W5HUADgIJpmlnDMPYxs5u+TpKklwEM+KrND3m5yIMeOJV4PJ6VZXk/gBYAWwC0yLK8Px6Pp4losRZ5HkaQ38xzboRYLDZGRM+vtUZEe2Kx2KhbDGbe7bewIGaeciMst9ZG621uMYjINc/DCGJmhwdOQ8h1ANjpgfMAgpj51wOn4LJ+x0OMsgfOAwhi5q4bwTTNrMt63kMetw15BL7NMPOYG2f59Xt9Hf31SqXyolsMInLN8zB8mxFCDLlxmHnb/Pz806ZpDgO4BaAK4JZpmsPlcvkZx3G2ekg17Lc23xPA7OzsE5FI5G8Acb9aH5ivVqtNDQ0Nhh+R75NJJpMLzHzBr84PiOi8XyNAwKlZ13XVtu1JIkoG0W8EZp6VJOnZ/21qVhRFI6ITQbRuIKITQYwAIT+s5ubmLgJ4NUyM1bBt+5vOzs63hBDRKPO2JaKozEyWLWQAiEiOaQnhENHilqUlY8/t23o/YK/ow5qJA/gTQGsoFwAMw9CPdHefnZmZuedVw0w2MfIRwb9M5vP5UHcAiURiHsDrWLU7QcDM/MXp01f8GAEAIpYgeJcFHGttbW0NZQYAEonECIDPw8T4aWho5PLAQD5ECJIcp6kmlxHMHNE0bQTAPr/au4XCnVe6us4bhhH4dB3AcYBzoU8GAIjIEkIcgbch9D4syzJ7e3sHwhgBc5Uk6VI+ny/UxAwAKIqSAfCOH01/X9/V30dHSwFTMgMTUds+k8lk/gI24eJc07Q+Zu5y401PTU2+1tPzbYAUi8w8jkjkj0wmM7t6oeZmyuXyTsMwpqPRqLpuNZWKcezo0a/y2aynkYWZLBCnWYhUS0vLxPDwsLUWz/ftjBvq6+v/SaVSbzQ2Nl7G2pvF586cueJmhJlMASdHQqSciDSZTqeXACCbXf9TqeYns4Lx8fGLzc3Nj0wHv1679tvbx4//uI5sEURZAUzLdXUTqVSq6ifnppnJ5XJbmXlKUZSWlWelUqnYdejQuYWFhfttwkAFzDcjQtx4Ye/edH9/f+A3W83bbAVtbW33hoaGuuvr638WQsiWZdmfnjo1sGxkHkRpCZjuyeVufgQ4ADCVy21WObXB4ODgJ4VCYfHC+Qtfd7S3v9TR0dGETeyIxwb/Abxf6DIUZxAeAAAAAElFTkSuQmCC",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAS9SURBVFiF3VhNbFRVFP7Ond9OlBnApihJM1N0EqltQzoJLFxAQiKrruhCjXFh3GhcEGowGomiJEhYUJtUiTFCGEJsBX9CU2pQqzZB6WtLOgw0MNN5TUSggtNp6Tw6fe8dNyWp0Pa9d9/Mhm8593zfOd+9J/educAjBCq34MDAwOPBYHAHM7cQ0UYATwJYC+AOgL+J6LJpmj+EQqGz9fX1d8uZu2xmRkdHV8/Pz7/DzG8BqLJBKQLo8Hg8BzZt2jRVjhrKYmZwcHAnER0BsEaC/i8Rvd7c3HzabR3CDZmZSVGUvUTUBTkjALCGmb9RFOV9Zna1ua7MDA8P7wXwIdyfMAHYNzQ09J5bESkstFaXG40lYBLRzubm5m9lyFKFjIyMRAzDyEK+tVZC3u/3b2hsbMw7JUq1ma7r76IyRgBgdalUeluG6PhkFr4jt2Dv+pVFsaqqqsbpd8jrNEswGNwBG0aEEMVYLHYhHA7XEdE6Zr5ZKBTGc7ncZtM0rfihYrH4AoBTTmpz3GbM3GIpKkSxqalpPBKJbCWiWgB+IqqNRCJbGxoaMkIIzUqDiCzzPJTXKYGInrWKicViF4QQzy215vV6G6LR6J9WGsy80WltMhfAU1YB4XC4bqX1SCQSs9IgIss8D0LGzFobhaxzs76AJ2xXtAAZMzNWAcx802L9ho0807YrWoCMmVtWAYVCYXyl9ampKdVGnhU3ZCnImLlgFZDL5Tbrup5aak3X9ZSqqlusNIjIMs+DkLmaf7GKMU2zKpVKPZ3P5/uZeQJAiZkn8vl8fyqVesY0zaANjX6ntTmeANLp9GOapv0FIOyU6wAFn8+3vqmpadYJyfHJ1NfX32Xmr5zyHOJLp0YAyUEzEAjsAzApw7WBSb/f/7EMUcrMwni+S4ZrA7tkxn/A5R8rRVFOAHjJjcZiGIZxsrW19U0hRCDAXDVHFPAxk24IHwB4Pea8LoRJRJp/bm624fr1qW7AuM93ayYM4CKAqCsXADRNm9qze/eRycnJe3Y5zGQQQ/UK/n1MVVVXbwCJRKIA4BUs2h0ZMDMfP3bseydGAICIPRC8QQdejUajUVdmACCRSAwAOOhGQxkcHPj53DnVhQR5THO9azMAMDMzsxeA5Vi/FO7cvn2js6PjVzf5TcA0hMiWxcy2bdt0AC/DxhC6GLquz3/W2XlK0zT5NmUukcdzWlXVm2UxAwCJRCJLRG1OOD/29Z29NDp6RzIlM3AlYBifZ7PZS0AFHs4VRekC0GoVN6GqY3va2r6WSKEx8yi83qFsNvu/D7fjBw0beKNUKm33+/2rlwu4p2mz7e3tZ+wKMpMO4gwLka6trb3S39+vLxVX9pMBgN7e3pbq6urvltHn40ePnuw5c+baShrMNC9g5kiItOnxjGUymTmrvBUxAwA9PT0nampqHpoOLo6M/HFg//6+ZWgaiMYFcNUXCl1Jp9MlJzkr0WYAgFAo9Nr09PTzq1atqr3/W6FQ+OfTw4d/WhzHQBHM17xCXG5MJDLd3d3SN1vFTgYAksnklng8/psQwqfrunH40KEvFEW5BaAAoowHuPpiLnftA8CsZB1lQzKZ/Oj8+fPawU8OJuN1ddvj8fh6VHgTHwn8B/S71Ufd4vUbAAAAAElFTkSuQmCC",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAATTSURBVFiF3VhPTBRXHP7e2xmBTYwgDXVdQ6m2hxrsyaweeoCkSXtQExOZ0JLSQ9NLmx5MbGya1P49NCRoQg9UG1MTA5RZEbegsYemVE1gMU1JBRZhF9dkccHGAkUXZmfe/HooJJTCzs6b5dB+yV7m/b7v9/veezvvNw/4H4EVWjASiWzNZrOvAjhCRHsBBACUA3gE4AGAUQDfA7iuadrjQuYumJm2trYyRVE+YIy9B6AkD0qGMfaVoihfHj16dK4QNRTEjK7rxwCcBbBdgv4HY+zturq6y17r4F7IRMR0XT8FQIecEQDYTkSXOjs7PyIiT5Pr80Kurq7+GMCn8L7CjDFWG4vFrHA4fENaRJa4vLV0LxrrwAZwTNO0bhmyVCHd3d2lpmkmIL+1cmHWNM09DQ0Ns26JUv8Z0zQ/xOYYAYAyRVHelyG6XplIJLLVMIwZ5Pf6lUUGwNNuzyHFbZblA9HRiKIomVAoNBgIBHZzznfYtj2dTqcno9HoASGEE99PRK8A6HJTm8w2O+IUoChK5tChQ5PBYLCGc14JYAvnvDIYDNYcPnw47vP5FguRZy1cmyGiF5xiQqHQoKqq1euNqaq6LxQKRZ00GGN73dYmszI7nQICgcDunAI7dz5biDxrIWOm3FGU8x1expfxVN4Vrei6JQBYcAqwbXs61zgRpfPI82feFS1DxsyMU0A6nZ7MNT41NZXMI0/OCVkPMmYGnQKi0egB0zTvrDeWzWbvDA4OHnTSYIw55lkL12YYYz85xQghSnp6ep5LpVJ9tm3fB5C1bft+KpXq6+3tfV4IUeykQUR9bmtzfWgS0WUALQC25YoTQpT09/fXrHr0zPIvH8wvLS25/r5xvTKapj0mom/d8lzifGNj4xO3JKlG07KszwA8lOHmgYemaX4hQ5Qys9yeH5fh5oHjMu0/4PHDStf1NgCve9FYDSFEx8mTJ9/lnBcVEZUYjBWpRMwSXAUAxWebFuc2Y2xxi2E82Tc1NRcGxArfq5ltAIYAVHlyAcAwjLmW06fPzs7OLuXLIWKCEZIKp5tjyWTS04WGpmnzAN7AqtmRBF27ejXixggAMEY+cNpjAW9WVVVVeTIDAJqm3SKiJi8ao8PDt24PDCQ9SDCfbQc9mwGAioqKUwAc2/r1MD83lw53dv7sJb8N2ILzREHM1NbWWrZtNyCPJnQ1hBDmpXC4yzAM+W1KlGU+3+VkMjldEDMAUF9fnwBwwg0n2t9/PTEx8UgyJREQKxLi60QiMQxswsW5rus6gDqnuOl0eqzlzJlOiRSLRPQbFOWXRCLxj4PbdW/mBMuy3iGil1VVLdsoJmsYTzra23vz1SRiFhjFifORysrKWF9fn7VeXMFXBgDOnTt3pLS09MoG+nStp6fj1s2bE7k0iJjJYd9jnI/YPt9YPB43nPJuihkAaG1tbSsvL/9XdzB+9+7AhfPnf9iAtgjGJjkwrvr9sZGRkaybnAXfZisoLi5+K5PJvOT3+ytXni0sLPz+XXv7j6vjCMiAaELhfPTF/fvj4XBY+s22aSsDAM3NzQeDweANzrkqhBAdFy9+Mzo6OgNgHozFfcD4a/fuTXzy94W5Z2yqGQBoamr6fNeuXSeGfh3qutJ16QIUJTY+Pv4AAG127v80/gIGr+iWe+FGsAAAAABJRU5ErkJggg==",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAToSURBVFiF3VhdbFNlGH7ec05/F6IUE9GLIYgXXYpXJBBZE0xM9EausIl6ObzBGSHRdnEJ1p+RhnBBNF4YY/xJFigNaIwxLpFYB2WwMWCW0bG1W7eEdUBwQ0fb7fy83nQJjK3nnO90F/okvTnf+7zP+/Q75/ve7wP+R6BGJ4xGo+skSXqFmfcAaAHwFIANAO4CmCai64Zh/OT3+3+Nx+PzjdRumJmOjo71zNwB4B0APguUMjN/vri4mDh27NhcI2poiJloNLqXiL4EEBCg/8XMbx05cuS00zpkh3yKxWKHiOgLAH7BHD4iiuzatcvIZDJnnRTjyEw0Gv2QiD6C8xkmInqxtbVVy2QyvcJJRIm1V+ukkxwrwCCivYlE4gcRslAhBw4ceNzj8RQg9o2YYZaInk0kErN2iZKImtvt/gBrYwQA1gN4X4Roe2ai0eg6IroFa8uvKMo+n+9Ju/uQYleltiGaGnG73eVIJNIfDAa3yLK8Udf1mVwuN55MJneoqmrG91er1ZcBnLJVm51gAKjt7HXhdrvLnZ2d46FQaLcsy80A3LIsN4dCod2dnZ15l8tVaYTOcoh8M0GzgEgk0u/xeEIrjXm93m2RSOSiBZ0Wu4WJmHnaLCAYDG6pN97S0rK5ETrLIWJmg1mALMsbnYzX8ITlimoQMfOPWYCu6zMm4yULOn9brqgGETO3zAJyudx4vfFr164VzXIwc90/ZCWImOk3C0gmkzuq1Wp2pbFyuZxNpVI7zXIQkanOcoiY+d0sQFVVX1dX19ZsNpvWdX0SwKKu65NDQ0Ppw4cPP6dpmtcsBzOn7RZme9P0+XynK5XKZwAeqxenqqqvu7t79wOPNtV+VnDPMAzb5xvbM1NrMb6xy7OJr48ePXrfLkmo0SSijwHcFuFawG0i+lSEKGSm1p4fFOFawEGR9h9weLCKxWLdAN5wkuNBMPPxEydOvC1JksfD7Fsg8riYSdMlFwAosqFqkmQQUcW9sHB/282bcylAX+LbXgCWYT+AFwA84zAPVFWdO9PTM+WWpHcBQCeCAoCJICsMAGAQZGaAGZrLhcubNutbGUVF4rMjxWLR8ZE3Fou1AkjDwX0CM/OVwcHvJwqFomgKDfjO6e0MMpnMVDgc9gIIi+YoTU+fyw4NXXFQBpFh3BFaAJbD6/UeAmClrX8ElXK5dOnixT+c6BuAoUtSoSFm4vG4ZhjGm7DQhD5UhGGoAwMDp1RV1c2jVwHzIsny6WKxOOP4NVvC+fPnZ8Ph8F0Ar1rlFPL5X8bHxuo2pXXADIx4df3kjcnJSWANLs5jsdhJAK+Zxd2bmxv5racnKSBRYeY/oSiDhULhoY3b6dL8CDRN209EL8myvH7VGFW9f6Gv72erOZlJA3GeJWm4ubk5l06ntZXiGj4zANDe3r6nqanpx1Xyc/bq1eOjN26M1cvBTKoEY4IkadiQ5ZF8Pr9gprsmZgCgvb29u6mp6ZHuYKZUupDp7e1ZhVYB0bgEjLr8/tzw8PCiHc2Gv2ZLmJ+fb1MUpdXj8TQvPatWq3f6+/rOPBjHQBnMY4okXX9++/Z8KpUSXtnWbGYAYN++fTsDgUAvEbkMw9AvnDv3ValUugXgHojyMjD6+sTEWBwwGqG3pmYAoK2t7ZNAIPDe1OTUqSuXBr6FouRGR0enAfBaa/+n8S8PPeWMetb8+wAAAABJRU5ErkJggg==",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAATISURBVFiF3VhNbBtFGH0z3vXGbqpSikQBKSIOHKgop0quYtMadSsqVfRCoQo9IjiAuAXJ4lB+D0Q5Ig4VQvxIVZREKQhRRNoiNi2VcBECUaUNjmM7VRPHcdP81HGc/ZmPSyKVNMnuzjoHeEfPe9/73s54dnaA/xFYowsmEont0Wj0iBDiGGNsD4BHAOwCMANgEsB1IvrOcZwfDcOoNtK7YWGOHj260zTNNBG9BSDiQVID8Ilt2x8bhjHXiB4aEubQoUPHGWOnATwoIb8D4LWLFy+eDdpHKKCeHT58+BSATwFEJWtEALzc2toqCoXC5SDNBAqj6/q7AN5H8BlmjLHnYrGYnc/nL0kXkRWuLK2+IDXWgWCMHb9w4cI3MmKpRlKp1AOKooxB7j/ihllN09rOnTs361fIZdwURXkHWxMEAHaapvm2jND3zCQSie2RSKQMb9uvLGq2bT/s9z2k+HWJRqNHiMg1iKZptXQ6fTUej8dUVd1tWdZUJpPJd3V1xev1ups+qijK8wAG/PTme5kJIY65cTRNq/X29uaTyWRKVdUWAGFVVVuSyWSqp6cn19TUtOTBytVnLXyHYYw95cZJp9NXt23b9vR6Y83NzXs7OzszHqz2+O1NZgN41I0Qj8djm423t7e3NsJnLWTC7HIjqKq6O8j4Ch7y3NEKZMLcdSNYljXlMl7y4LPguaMVyIQpuxEymUx+s/ErV64UPfhs+kDWg+8wRHTVjdPV1RWvVqvX1hurVqvXuru793uwcvVZC5nd7Gc3Tr1ej3R0dDwxNDRkWJY1DsC0LGvcMAzjxIkTT5qm2eTBx/Ddm19BKpVqVhTlFoAdfrU+MM85f+z8+fOLfkS+Z2bliPGFX50fMMY+9xsEkDxoapr2AYBpGa0HTIfD4Y9khFIfZ6Ojo/VYLDYJ4EUZvQteHxwc/E1GGOjDStf1MwBeCVJjDXqy2eybnHNNI4osM6apRMx2uAoASkhYNueCMbYUXl5e3DsxMdcPOKvioGF2ENGfjLHHg2UAhBBzpVu3TlumWfeqIWIOIxQVTpdHisVi4E9eXdeTAAwEuE8gIpqpVL6uLiwUZUvYwFdBb2eQz+dvtrW1NQF4VrbGUq32y+zMzB8B2mBMiIrUbrYWlmWdAuDlWH8fbMsqzUxPDwXxF4BwOB9rSBjDMGwhxEl4OITeCyKyKpXKgOM4jjt7wyImC4XOFovFqcDLbBWFQmE2FovNAHjBq+buwsIP1fn5TQ+lm4AIGGlynL6/x8fHgS24ONd1vQ/AS248yzRHJm7e7JWwWCKiv6Aov4+Njf3rxe37QsMNtm2/wTnXOec7N+KQEIvlcvl7rzWJmA1GOeJ8uKWl5YZhGPZ6vIbPDAAcOHDgWDgc/naD+jR7+3bP/Nzc6GY1iJjFIQqM82ERCo3kcrllN98tCQMABw8ePKOq6n2ng6Va7dfy5OTgBrIlMJbnQFaNRm8MDw+bfjwbvsxWwRh71XGcZCgUaln9zXGcynSp9NO9PAJqIBpVOL/+zL59uf7+fumdbctmBgASicT+SCRyCYBKRE6lVPqsVquVAcyDsVwIyHYUCqPvAaIRflsaBgCSyeSHmqZ1Lt5dHLhze/pLKMqNbDY7CYC22vs/jX8A/Nff8x41WYEAAAAASUVORK5CYII=",
        anchor: [0.5, 1]
    }, {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAPjSURBVFiF3ZlNbxtVFIafe2cceyZxEitfqiMs1EUWSLDqggXskOiGSqCyoAj+AH8BChISAv5ABahCBaoGJziISAhWMR8LECBQUNo0cZpJpLQNVWMDTZxre+ayMIGQOp7J2DMFXuls5p57zvver7lzBv5HEBHETAMngVPAA8AxYAi4DVwHLgOfAJ8BdyLI3xVkgDeAHUAHsG3gdWDwXpBth9M0Rz6IiIN2G3gqfsp3QwBnAY9wQvbMA14immUfGC/TmYiD9mK89P/GaTqfkYPmAk/GKQKamzbsHvGzLZqHSWx4MwIR++21uISkCX78hrVtoO+oxGQIMScBy8/Jtu2dQqFQVEqta61rSqn16enpomVZ1QA5bODxENyOjPfxGVnbtrcrlcrPugXK5fK8ZVlBZvZCHGK+9yNSKBTmWgnZQz6fnwsg5rs4xFz3I6KUWmsnRinlBBCzcVRiYd64Cuhp56C1rvn4KCFE0idPDfDz+QfCHAC/+znUarWbPu03AuT5LTCjPxFGzKafw+zs7LV27TMzM06APG0HpFt4F5/1blnWTrlcnm+1X7a2tuZTqVTVLwZwPg4xzwcgoi3L2snn83NKKae555UzOTk5F1CIBp6LQ0wfUAlIKKxVgN6jEguzZ+7QXGpR4jzNK00syNA8CKKYlU1ivjUDnOkC8VZ2JiyhTj9TL3aSvAUu5XK5F6SUyaTWlhIimdBaNFyZADANr96Q0hNCVHuU2n5wY6My1fygAzoXMwD8BNzfYRyklJVcNvuWaZq7QftoLVyhcUypv1p0HKcbBYRHgCJgdBBDjwwNvTeQTjth+zfgQicE9rAOpIBHwwbo6+39ejiT+bEDDkJ43q0wR3MrnAW+DdPRNIwbY8PDX3SS3APPlXKlW2IawLMEuITuhxCiPjoy8pEQwvX3PgRa14RhFBzHudmNZbaHMs2KzRNBOwz29386kE63vZS2gdawmHLd/NW1tTWIpoKYB572c0r29Czel81+GCJ+VWs9j2n+sLKy8sv+hijEDAshlrTWh77FpRDb4+Pj55KmGejKorVoIHRJS7mQy+WuFIvFRiu/SGq7hmGccl3340Pi6+FM5tLgwMByuxhai7rEWxVSLniGsVgqlZRf3sgK1YlE4mK9Xr/rdmBb1jfZsbHPD+lWRYhrEpYStn1lYWGhdpScUVbdU1LKq57n5fYeGIZxK5fNvm0Yxl/LRMMOWi+bUl5+6MSJ0tTUVOiTLdJfCJZlPby7u/ul1joBuMdGR9/pte1N4FeEKBmw9Mzq6vIrzQL8vx+pVOpVIUS1v6//g4njxx+bmJgY5x7/h/lP4A+AJ7grnrOyCgAAAABJRU5ErkJggg==",
        anchor: [0.5, 1]
    }];

    // applying default labels
    if (!this.options.labels) {
        this.options.labels = {};
    }
    Object.keys(Drawing.DefaultLabels).forEach(function (key) {
        if (!this.options.labels.hasOwnProperty(key)) {
            this.options.labels[key] = Drawing.DefaultLabels[key];
        }
    }, this);

    // applying default styles
    if (!this.options.defaultStyles) {
        this.options.defaultStyles = {};
    }
    Object.keys(Drawing.DefaultStyles).forEach(function (key) {
        if (!options.defaultStyles.hasOwnProperty(key)) {
            this.options.defaultStyles[key] = Drawing.DefaultStyles[key];
            return;
        }
        if (key === "polyFillOpacity" && (options.defaultStyles[key] < 0 || options.defaultStyles[key] > 1)) {
            logger.log("Wrong value (" + options.defaultStyles[key] + ") for defaultStyles.polyFillOpactity. Must be between 0 and 1");
            this.options.defaultStyles[key] = Drawing.DefaultStyles[key];
            return;
        }
        if (key === "strokeWidth" || key === "polyStrokeWidth") {
            var intValue = parseInt(options.defaultStyles[key], 10);
            if (isNaN(intValue) || intValue < 0) {
                logger.log("Wrong value (" + options.defaultStyles[key] + ") for defaultStyles.strokeWidth. Must be a positive interger value.");
                this.options.defaultStyles[key] = Drawing.DefaultStyles[key];
                return;
            }
            this.options.defaultStyles[key] = intValue;
        }
    }, this);

    this.interactionCurrent = null;
    this.interactionSelectEdit = null;

    this.stylingOvl = null;

    this.layer = null;
    if (this.options.layer && this.options.layer instanceof _ol2.default.layer.Vector) {
        this.layer = this.options.layer;
    }

    // detection du support : desktop ou tactile
    // FIXME : utile ?
    this._isDesktop = this._detectSupport();
};

/**
 * Creates empty layer to host features
 *
 * @private
 */
Drawing.prototype._createEmptyLayer = function () {
    var features = new _ol2.default.Collection();
    var layer = new _ol2.default.layer.Vector({
        source: new _ol2.default.source.Vector({
            features: features
        })
    });
    // on rajoute le champ gpResultLayerId permettant d'identifier une couche crée par le composant.
    layer.gpResultLayerId = "drawing";
    // on le rajoute au controle (et à la carte)
    this.setLayer(layer);
};

/**
 * Sets vector layer to hosts feature.
 *
 * @param {ol.layer.Vector} vlayer - vector layer
 */
Drawing.prototype.setLayer = function (vlayer) {
    if (!vlayer) {
        this.layer = null;
        return;
    }

    if (!(vlayer instanceof _ol2.default.layer.Vector)) {
        logger.log("no valid layer given for hosting drawn features.");
        return;
    }

    // ajout du layer de dessin à la carte s'il n'y est pas déjà
    var layers = this.getMap().getLayers();
    if (layers) {
        var found = false;
        layers.forEach(function (mapLayer) {
            if (mapLayer == vlayer) {
                // FIXME object comparison
                // logger.trace("layer already in map. Not adding.");
                found = true;
            }
        }, this);
        // si le layer n'est pas sur la carte, on l'ajoute.
        if (!found) {
            this.getMap().addLayer(vlayer);
        }
        // TODO style par defaut du geoportail !
        // application des styles ainsi que ceux par defaut de ol sur le layer
        vlayer.getSource().getFeatures().forEach(function (feature) {
            var featureStyleFunction = feature.getStyleFunction();
            if (featureStyleFunction) {
                var styles = featureStyleFunction.call(feature, 0);
                if (styles && styles.length !== 0) {
                    feature.setStyle(styles[0]);
                }
            }
        });
        this.layer = vlayer;

        // Si un layer switcher est présent dans la carte, on lui affecte des informations pour cette couche
        this.getMap().getControls().forEach(function (control) {
            if (control instanceof _LayerSwitcher2.default) {
                // un layer switcher est présent dans la carte
                var layerId = this.layer.gpLayerId;
                // on n'ajoute des informations que s'il n'y en a pas déjà (si le titre est le numéro par défaut)
                if (control._layers[layerId].title === layerId) {
                    control.addLayer(this.layer, {
                        title: this.options.layerDescription.title,
                        description: this.options.layerDescription.description
                    });
                }
            }
        }, this);
    }
};

/**
 * this method is called by the constructor.
 * this information is useful to switch to touch mode.
 * Detection : test for desktop or tactile
 *
 * @method _detectSupport
 *
 * @returns {Boolean} is desktop
 * @private
 */
Drawing.prototype._detectSupport = function () {
    // TODO
    // Choix de gérer la détection dans le code du composant au lieu du DOM car :
    // Utilisation de l'implémentation Leaflet
    // http://leafletjs.com/reference.html#browser

    var isDesktop = true;
    var userAgent = window.navigator.userAgent.toLowerCase();

    if (userAgent.indexOf("iphone") !== -1 || userAgent.indexOf("ipod") !== -1 || userAgent.indexOf("ipad") !== -1 || userAgent.indexOf("android") !== -1 || userAgent.indexOf("mobile") !== -1 || userAgent.indexOf("blackberry") !== -1 || userAgent.indexOf("tablet") !== -1 || userAgent.indexOf("phone") !== -1 || userAgent.indexOf("touch") !== -1) {
        isDesktop = false;
    }

    if (userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident") !== -1) {
        isDesktop = true;
    }

    return isDesktop;
};

// ################################################################### //
// ######################## methods handle dom ####################### //
// ################################################################### //

/**
 * Create control main container (called by Drawing constructor)
 *
 * @method _initContainer
 *
 * @returns {DOMElement} DOM element
 * @private
 */
Drawing.prototype._initContainer = function () {
    // creation du container principal
    var container = this._createMainContainerElement();

    var inputShow = this._showDrawingContainer = this._createShowDrawingElement();
    container.appendChild(inputShow);

    var picto = this._createShowDrawingPictoElement();
    container.appendChild(picto);

    var panel = this._createDrawingPanelElement();

    container.appendChild(panel);

    return container;
};

// ################################################################### //
// ##################### handlers events to control ################## //
// ################################################################### //

/**
 * Callback de fin de dessin de geometrie
 * @param {Object} feature - ol feature
 * @param {String} geomType - geometry type
 *
 * @private
 */
Drawing.prototype._drawEndFeature = function (feature, geomType) {
    // application des styles par defaut.
    var style = null;

    switch (geomType) {
        case "Point":
            style = new _ol2.default.style.Style({
                image: new _ol2.default.style.Icon(this._getIconStyleOptions(this.options.markersList[0]))
            });
            break;
        case "LineString":
            style = new _ol2.default.style.Style({
                stroke: new _ol2.default.style.Stroke({
                    color: this.options.defaultStyles.strokeColor,
                    width: this.options.defaultStyles.strokeWidth
                })
            });
            break;
        case "Polygon":
            style = new _ol2.default.style.Style({
                fill: new _ol2.default.style.Fill({
                    color: this.hexToRgba(this.options.defaultStyles.polyFillColor, this.options.defaultStyles.polyFillOpacity)
                }),
                stroke: new _ol2.default.style.Stroke({
                    color: this.options.defaultStyles.polyStrokeColor,
                    width: this.options.defaultStyles.polyStrokeWidth
                })
            });
            break;
    }
    feature.setStyle(style);

    // gestion des mesures
    this._updateMeasure(feature, geomType);

    // creation overlay pour saisie du label
    var popupOvl = null;
    var context = this;

    /**
     * Enregistrement de la valeur saisie dans l'input.
     *
     * @param {String} value - valeur de l'attribut.
     * @param {Boolean} save - true si on garde le label.
     */
    var setAttValue = function setAttValue(value, save) {
        context.getMap().removeOverlay(popupOvl);
        if (save && value && value.trim().length > 0) {
            var formated = value.replace(/\n/g, "<br>");
            feature.setProperties({
                description: formated
            });
        }
    };
    var popup = this._createLabelDiv({
        applyFunc: setAttValue,
        inputId: this._addUID("att-input"),
        placeholder: "Saisir une description...",
        measure: this.options.tools.measure ? feature.getProperties().measure : null,
        geomType: geomType
    });
    popupOvl = new _ol2.default.Overlay({
        element: popup,
        // FIXME : autres valeurs.
        positioning: "top-center"
        // stopEvent : false
    });
    // context.getMap().addOverlay(popupOvl) ;
    this.getMap().addOverlay(popupOvl);
    var geomExtent = feature.getGeometry().getExtent();
    popupOvl.setPosition([(geomExtent[0] + geomExtent[2]) / 2, (geomExtent[1] + geomExtent[3]) / 2]);
    document.getElementById(this._addUID("att-input")).focus();
};

/**
 * Creates Interaction for features removal.
 *
 * @returns {ol.interaction.Select} created interaction.
 * @private
 */
Drawing.prototype._createRemoveInteraction = function () {
    var interaction = new _ol2.default.interaction.Select({
        // features : this.layer.getSource().getFeaturesCollection(),
        layers: [this.layer]
    });
    interaction.on("select", function (seEv) {
        if (!seEv || !seEv.selected || seEv.selected.length === 0) {
            return;
        }
        this.layer.getSource().removeFeature(seEv.selected[0]);
        // suppression puis rajout de l'interaction pour appliquer le changement tout de suite...
        this.getMap().removeInteraction(this.interactionCurrent);
        this.interactionCurrent = this._createRemoveInteraction();
        this.getMap().addInteraction(this.interactionCurrent);
    }, this);
    return interaction;
};

/**
 * Creates Interaction for features style definition.
 *
 * @returns {ol.interaction.Select} created interaction.
 * @private
 */
Drawing.prototype._createStylingInteraction = function () {
    var interaction = new _ol2.default.interaction.Select({
        layers: [this.layer]
    });
    interaction.on("select", function (seEv) {
        // suppression de toute popup existante
        if (this.stylingOvl) {
            this.getMap().removeOverlay(this.stylingOvl);
        }
        if (!seEv || !seEv.selected || seEv.selected.length === 0) {
            return;
        }

        var valuesColor = null;
        var hexColor = null;
        var popupOvl = null;
        var geomType = null;
        var initValues = {};
        if (seEv.selected[0].getGeometry() instanceof _ol2.default.geom.Point) {
            // on determine si c'est un marker ou un label.
            var _label = seEv.selected[0].getProperties().name;
            if (seEv.selected[0].getStyle().getText() && _label) {
                geomType = "Text";
                if (seEv.selected[0].getStyle().getText().getStroke() && seEv.selected[0].getStyle().getText().getStroke().getColor()) {
                    valuesColor = seEv.selected[0].getStyle().getText().getStroke().getColor();
                    if (Array.isArray(valuesColor)) {
                        valuesColor = "rgba(" + valuesColor.join() + ")";
                        hexColor = this.rgbaToHex(valuesColor);
                        initValues.strokeColor = hexColor.hex;
                        initValues.strokeOpacity = hexColor.opacity;
                    } else {
                        initValues.strokeColor = valuesColor;
                    }
                }
                if (seEv.selected[0].getStyle().getText().getFill() && seEv.selected[0].getStyle().getText().getFill().getColor()) {
                    valuesColor = seEv.selected[0].getStyle().getText().getFill().getColor();
                    if (Array.isArray(valuesColor)) {
                        valuesColor = "rgba(" + valuesColor.join() + ")";
                        hexColor = this.rgbaToHex(valuesColor);
                        initValues.fillColor = hexColor.hex;
                        initValues.fillOpacity = hexColor.opacity;
                    } else {
                        initValues.fillColor = valuesColor;
                    }
                }
                initValues.strokeColor = initValues.hasOwnProperty("strokeColor") ? initValues.strokeColor : this.options.defaultStyles.textStrokeColor;
                initValues.fillColor = initValues.hasOwnProperty("fillColor") ? initValues.fillColor : this.options.defaultStyles.textFillColor;
            } else if (seEv.selected[0].getStyle() && seEv.selected[0].getStyle().getImage()) {
                geomType = "Point";
                if (seEv.selected[0].getStyle().getImage().getSrc()) {
                    initValues.markerSrc = seEv.selected[0].getStyle().getImage().getSrc();
                } else {
                    initValues.markerSrc = this.options.markersList[0].src;
                }
            }
        } else if (seEv.selected[0].getGeometry() instanceof _ol2.default.geom.LineString) {
            geomType = "Line";
            if (seEv.selected[0].getStyle() && seEv.selected[0].getStyle().getStroke()) {
                if (seEv.selected[0].getStyle().getStroke().getWidth()) {
                    initValues.strokeWidth = seEv.selected[0].getStyle().getStroke().getWidth();
                }
                if (seEv.selected[0].getStyle().getStroke().getColor()) {
                    valuesColor = seEv.selected[0].getStyle().getStroke().getColor();
                    if (Array.isArray(valuesColor)) {
                        valuesColor = "rgba(" + valuesColor.join() + ")";
                        hexColor = this.rgbaToHex(valuesColor);
                        initValues.strokeColor = hexColor.hex;
                        initValues.fillOpacity = hexColor.opacity;
                    } else {
                        initValues.strokeColor = valuesColor;
                    }
                }
            }
            initValues.strokeWidth = initValues.hasOwnProperty("strokeWidth") ? initValues.strokeWidth : this.options.defaultStyles.strokeWidth;
            initValues.strokeColor = initValues.hasOwnProperty("strokeColor") ? initValues.strokeColor : this.options.defaultStyles.strokeColor;
        } else if (seEv.selected[0].getGeometry() instanceof _ol2.default.geom.Polygon) {
            geomType = "Polygon";
            if (seEv.selected[0].getStyle() && seEv.selected[0].getStyle().getStroke()) {
                if (seEv.selected[0].getStyle().getStroke().getWidth()) {
                    initValues.strokeWidth = seEv.selected[0].getStyle().getStroke().getWidth();
                }
                if (seEv.selected[0].getStyle().getStroke().getColor()) {
                    valuesColor = seEv.selected[0].getStyle().getStroke().getColor();
                    if (Array.isArray(valuesColor)) {
                        valuesColor = "rgba(" + valuesColor.join() + ")";
                        hexColor = this.rgbaToHex(valuesColor);
                        initValues.strokeColor = hexColor.hex;
                        initValues.strokeOpacity = hexColor.opacity;
                    } else {
                        initValues.strokeColor = valuesColor;
                    }
                }
            }
            if (seEv.selected[0].getStyle() && seEv.selected[0].getStyle().getFill()) {
                if (seEv.selected[0].getStyle().getFill().getColor()) {
                    valuesColor = seEv.selected[0].getStyle().getFill().getColor();
                    if (Array.isArray(valuesColor)) {
                        valuesColor = "rgba(" + valuesColor.join() + ")";
                    }
                    hexColor = this.rgbaToHex(valuesColor);
                    initValues.fillColor = hexColor.hex;
                    initValues.fillOpacity = hexColor.opacity;
                }
            }
            initValues.strokeWidth = initValues.hasOwnProperty("strokeWidth") ? initValues.strokeWidth : this.options.defaultStyles.polyStrokeWidth;
            initValues.strokeColor = initValues.hasOwnProperty("strokeColor") ? initValues.strokeColor : this.options.defaultStyles.polyStrokeColor;
            initValues.fillColor = initValues.hasOwnProperty("fillColor") ? initValues.fillColor : this.options.defaultStyles.polyFillColor;
            initValues.fillOpacity = initValues.hasOwnProperty("fillOpacity") ? initValues.fillOpacity : this.options.defaultStyles.polyFillOpacity;
        }
        if (!geomType) {
            logger.log("Unhandled geometry type for styling.");
            return;
        }
        var dtObj = this;
        /**
             * function called when apply button is pressed.
             *
             * @param {String} action - "apply" (to selected object), "default" (set as default), "cancel" (do nothing).
             */
        var applyStyle = function applyStyle(action) {
            if (action === "cancel") {
                dtObj.getMap().removeOverlay(popupOvl);
                return;
            }
            var setDefault = action !== "apply";

            var fillColorElem = document.getElementById(dtObj._addUID("fillColor"));
            var fillOpacityElem = document.getElementById(dtObj._addUID("fillOpacity"));
            var strokeColorElem = document.getElementById(dtObj._addUID("strokeColor"));
            var strokeWidthElem = document.getElementById(dtObj._addUID("strokeWidth"));
            switch (geomType.toLowerCase()) {
                case "text":
                    if (setDefault) {
                        dtObj.options.defaultStyles.textStrokeColor = strokeColorElem.value;
                        dtObj.options.defaultStyles.textFillColor = fillColorElem.value;
                    } else {
                        seEv.selected[0].setStyle(new _ol2.default.style.Style({
                            text: new _ol2.default.style.Text({
                                font: "16px sans",
                                textAlign: "left",
                                text: seEv.selected[0].getStyle().getText().getText(),
                                fill: new _ol2.default.style.Fill({
                                    color: fillColorElem.value
                                }),
                                stroke: new _ol2.default.style.Stroke({
                                    color: strokeColorElem.value,
                                    width: 3
                                })
                            })
                        }));
                    }
                    break;
                case "point":
                    var markerSelected = dtObj._getsMarkersOptionsFromSrc(document.querySelector("input[name='marker']:checked").value);
                    if (setDefault) {
                        if (dtObj.options.markersList.length > 1) {
                            // index du marker dans la liste des markers
                            var idxMarker = dtObj.options.markersList.findIndex(function (mrk) {
                                if (mrk == markerSelected) {
                                    // FIXME object comparison
                                    return true;
                                }
                                return false;
                            });
                            if (idxMarker > 0) {
                                // on enleve le marker de son ancienne position
                                dtObj.options.markersList.splice(idxMarker, 1);
                                // on le place en tête de liste
                                dtObj.options.markersList.splice(0, 0, markerSelected);
                            }
                        }
                    } else {
                        seEv.selected[0].setStyle(new _ol2.default.style.Style({
                            image: new _ol2.default.style.Icon(dtObj._getIconStyleOptions(markerSelected))
                        }));
                    }
                    break;
                case "line":
                    if (setDefault) {
                        dtObj.options.defaultStyles.strokeColor = strokeColorElem.value;
                        dtObj.options.defaultStyles.strokeWidth = parseInt(strokeWidthElem.value, 10);
                    } else {
                        seEv.selected[0].setStyle(new _ol2.default.style.Style({
                            stroke: new _ol2.default.style.Stroke({
                                width: parseInt(strokeWidthElem.value, 10),
                                color: strokeColorElem.value
                            })
                        }));
                    }
                    break;
                case "polygon":
                    var opacity = parseInt(fillOpacityElem.value, 10) / 10;
                    if (setDefault) {
                        dtObj.options.defaultStyles.polyStrokeColor = strokeColorElem.value;
                        dtObj.options.defaultStyles.polyFillColor = fillColorElem.value;
                        dtObj.options.defaultStyles.polyFillOpacity = opacity;
                        dtObj.options.defaultStyles.polyStrokeWidth = parseInt(strokeWidthElem.value, 10);
                    } else {
                        seEv.selected[0].setStyle(new _ol2.default.style.Style({
                            stroke: new _ol2.default.style.Stroke({
                                width: parseInt(strokeWidthElem.value, 10),
                                color: strokeColorElem.value
                            }),
                            fill: new _ol2.default.style.Fill({
                                // color : fillColorElem.value
                                color: dtObj.hexToRgba(fillColorElem.value, opacity)
                            })
                        }));
                    }
                    break;
            }
            if (!setDefault) {
                // application des styles par defaut
                // fermeture de la popup (si on applique le style à l'objet)
                dtObj.getMap().removeOverlay(popupOvl);
            }
        };

        var popupDiv = this._createStylingDiv({
            geomType: geomType,
            initValues: initValues,
            applyFunc: applyStyle
        });
        popupOvl = new _ol2.default.Overlay({
            element: popupDiv,
            // FIXME : autres valeurs.
            positioning: "top-center"
            // stopEvent : false
        });
        this.getMap().addOverlay(popupOvl);
        popupOvl.setPosition(seEv.mapBrowserEvent.coordinate);
        this.stylingOvl = popupOvl;
        // suppression puis rajout de l'interaction pour appliquer le changement tout de suite...
        this.getMap().removeInteraction(this.interactionCurrent);
        this.interactionCurrent = this._createStylingInteraction();
        this.getMap().addInteraction(this.interactionCurrent);
    }, this);
    return interaction;
};

/**
 * Creates Interaction for text definition.
 *
 * @returns {ol.interaction.Select} created interaction.
 * @private
 */
Drawing.prototype._createLabelInteraction = function () {
    var interaction = new _ol2.default.interaction.Select({
        layers: [this.layer]
    });
    interaction.on("select", function (seEv) {
        // suppression de toute popup existante
        if (this.labelOvl) {
            this.getMap().removeOverlay(this.labelOvl);
        }
        if (!seEv || !seEv.selected || seEv.selected.length === 0) {
            return;
        }
        var popupOvl = null;
        var geomType = null;
        var _textValue = null;
        var _measure = null;
        if (seEv.selected[0].getGeometry() instanceof _ol2.default.geom.Point) {
            // on determine si c'est un marker ou un label.
            var _label = seEv.selected[0].getProperties().name;
            if (seEv.selected[0].getStyle() && seEv.selected[0].getStyle().getText() && _label) {
                geomType = "Text";
            } else if (seEv.selected[0].getStyle() && seEv.selected[0].getStyle().getImage()) {
                geomType = "Point";
            }
        } else if (seEv.selected[0].getGeometry() instanceof _ol2.default.geom.LineString) {
            geomType = "Line";
        } else if (seEv.selected[0].getGeometry() instanceof _ol2.default.geom.Polygon) {
            geomType = "Polygon";
        }
        if (!geomType) {
            logger.log("Unhandled geometry type for styling.");
            return;
        }
        if (geomType === "Text") {
            // pour les labels on récupère la valeur dans le style
            _textValue = seEv.selected[0].getStyle().getText().getText();
        } else {
            // pour les autres, c'est un attribut du feature
            var featProps = seEv.selected[0].getProperties();
            if (featProps && featProps.hasOwnProperty("description")) {
                _textValue = featProps["description"];
            }
            if (featProps && featProps.hasOwnProperty("measure")) {
                _measure = featProps["measure"];
            }
        }
        var context = this;
        /**
             * Enregistrement de la valeur saisie dans l'input.
             *
             * @param {String} value - valeur de l'attribut.
             * @param {Boolean} save - true si on garde le label.
             */
        var setTextValue = function setTextValue(value, save) {
            context.getMap().removeOverlay(popupOvl);
            if (!save) {
                return;
            }
            var feature = seEv.selected[0];
            if (geomType === "Text") {
                var style = feature.getStyle();
                style.getText().setText(value);
                feature.setProperties({
                    name: value
                });
                feature.setStyle(style);
                return;
            }
            var _formated = value.replace(/\n/g, "<br>");
            feature.setProperties({
                description: _formated
            });
        };
        var popupDiv = this._createLabelDiv({
            applyFunc: setTextValue,
            inputId: this._addUID("label-input"),
            placeholder: geomType === "Text" ? "Saisir un label..." : "Saisir une description...",
            text: _textValue,
            measure: this.options.tools.measure ? _measure : null,
            geomType: geomType
        });
        popupOvl = new _ol2.default.Overlay({
            element: popupDiv,
            // FIXME : autres valeurs.
            positioning: "top-center"
            // stopEvent : false
        });
        this.getMap().addOverlay(popupOvl);
        popupOvl.setPosition(seEv.mapBrowserEvent.coordinate);
        document.getElementById(this._addUID("label-input")).focus();
        this.labelOvl = popupOvl;
        // suppression puis rajout de l'interaction pour appliquer le changement tout de suite...
        this.getMap().removeInteraction(this.interactionCurrent);
        this.interactionCurrent = this._createLabelInteraction();
        this.getMap().addInteraction(this.interactionCurrent);
    }, this);
    return interaction;
};

/**
 * Callback de fin de modification du dessin afin de mettre à jour la mesure
 * TODO
 * @param {Object} feature - ol feature
 * @param {String} geomType - geometry type
 *
 * @private
 */
Drawing.prototype._updateMeasure = function (feature, geomType) {
    logger.log(feature);

    var measure = null;

    var wgs84Sphere = new _ol2.default.Sphere(6378137);
    var projection = this.getMap().getView().getProjection();

    // arrondi
    function __roundDecimal(nombre, precision) {
        precision = precision || 2;
        var factor = Math.pow(10, precision);
        return Math.round(nombre * factor) / factor;
    }

    var type = geomType || feature.getProperties().type;
    switch (type) {
        case "Point":
            var coordinatesPoint = feature.getGeometry().getCoordinates();
            var c = _ol2.default.proj.transform(coordinatesPoint, projection, "EPSG:4326");
            measure = "lon : ";
            measure += __roundDecimal(c[0], 4) + "°";
            measure += " / ";
            measure += "lat : ";
            measure += __roundDecimal(c[1], 4) + "°";

            break;
        case "LineString":
            var measureLength = 0;
            var coordinatesLine = feature.getGeometry().getCoordinates();
            for (var i = 0, ii = coordinatesLine.length - 1; i < ii; ++i) {
                var c1 = _ol2.default.proj.transform(coordinatesLine[i], projection, "EPSG:4326");
                var c2 = _ol2.default.proj.transform(coordinatesLine[i + 1], projection, "EPSG:4326");
                measureLength += wgs84Sphere.haversineDistance(c1, c2);
            }
            measure = measureLength > 1000 ? __roundDecimal(measureLength / 1000, 3) + " km" : __roundDecimal(measureLength, 3) + " m";

            break;
        case "Polygon":
            var measureArea = 0;
            var coordinatesAera = feature.getGeometry().clone().transform(projection, "EPSG:4326").getLinearRing(0).getCoordinates();
            measureArea = Math.abs(wgs84Sphere.geodesicArea(coordinatesAera));

            measure = measureArea > 1000000 ? __roundDecimal(measureArea / 1000000, 3) + " km^2" : __roundDecimal(measureArea, 2) + " m^2";

            break;
    }

    // enregistrement de la mesure dans la feature
    feature.setProperties({
        measure: measure,
        type: type
    });
};

/**
 * Handles click on drawing tools icons
 *
 * @param {Event} clickEvent - click event
 * @param {String} toolId - selected tool Id
 * @param {Drawing} context - Drawing control.
 * @private
 */
Drawing.prototype._handleToolClick = function (clickEvent, toolId, context) {
    var map = context.getMap();
    if (!map) {
        // logger.trace("Drawing control not attached to any map.");
        return;
    }
    // on supprime  les interactions des autres extensions
    _Interactions2.default.unset(map, {
        current: "Drawing"
    });

    // on supprime l'interaction courante s'il y en a une.
    if (context.interactionCurrent) {
        map.removeInteraction(context.interactionCurrent);
        context.interactionCurrent = null;
    }

    // on supprime l'interaction de selection courante s'il y en a une.
    if (context.interactionSelectEdit) {
        map.removeInteraction(context.interactionSelectEdit);
        context.interactionSelectEdit = null;
    }

    // si aucune couche de dessin, on en crée une vide.
    if (!this.layer) {
        this._createEmptyLayer();
    }
    switch (toolId) {
        case this._addUID("drawing-tool-point"):
            if (context.dtOptions["points"].active) {
                context.interactionCurrent = new _ol2.default.interaction.Draw({
                    features: context.layer.getSource().getFeaturesCollection(),
                    style: new _ol2.default.style.Style({
                        image: new _ol2.default.style.Icon(this._getIconStyleOptions(this.options.markersList[0]))
                    }),
                    type: "Point"
                });
                context.interactionCurrent.on("drawend", function (deEv) {
                    // ajout eventuel d'un attribut description sur le feature
                    context._drawEndFeature(deEv.feature, "Point");
                }, context);
            }
            break;
        case this._addUID("drawing-tool-line"):
            if (context.dtOptions["lines"].active) {
                context.interactionCurrent = new _ol2.default.interaction.Draw({
                    features: context.layer.getSource().getFeaturesCollection(),
                    style: new _ol2.default.style.Style({
                        image: new _ol2.default.style.Circle({
                            radius: this.options.cursorStyle.radius,
                            stroke: new _ol2.default.style.Stroke({
                                color: this.options.cursorStyle.strokeColor,
                                width: this.options.cursorStyle.strokeWidth
                            }),
                            fill: new _ol2.default.style.Fill({
                                color: this.options.cursorStyle.fillColor
                            })
                        }),
                        stroke: new _ol2.default.style.Stroke({
                            color: this.options.defaultStyles.strokeColor,
                            width: this.options.defaultStyles.strokeWidth
                        })
                    }),
                    type: "LineString"
                });
                context.interactionCurrent.on("drawend", function (deEv) {
                    // ajout eventuel d'un attribut description sur le feature
                    context._drawEndFeature(deEv.feature, "LineString");
                }, context);
            }
            break;
        case this._addUID("drawing-tool-polygon"):
            if (context.dtOptions["polygons"].active) {
                context.interactionCurrent = new _ol2.default.interaction.Draw({
                    features: context.layer.getSource().getFeaturesCollection(),
                    style: new _ol2.default.style.Style({
                        image: new _ol2.default.style.Circle({
                            radius: this.options.cursorStyle.radius,
                            stroke: new _ol2.default.style.Stroke({
                                color: this.options.cursorStyle.strokeColor,
                                width: this.options.cursorStyle.strokeWidth
                            }),
                            fill: new _ol2.default.style.Fill({
                                color: this.options.cursorStyle.fillColor
                            })
                        }),
                        stroke: new _ol2.default.style.Stroke({
                            color: this.options.defaultStyles.polyStrokeColor,
                            width: this.options.defaultStyles.polyStrokeWidth
                        }),
                        fill: new _ol2.default.style.Fill({
                            color: this.hexToRgba(this.options.defaultStyles.polyFillColor, this.options.defaultStyles.polyFillOpacity)
                        })
                    }),
                    type: "Polygon"
                });
                context.interactionCurrent.on("drawend", function (deEv) {
                    // ajout eventuel d'un attribut description sur le feature
                    context._drawEndFeature(deEv.feature, "Polygon");
                }, context);
            }
            break;
        case this._addUID("drawing-tool-text"):
            // text : creation de points invisibles avec un label.
            if (context.dtOptions["text"].active) {
                context.interactionCurrent = new _ol2.default.interaction.Draw({
                    features: context.layer.getSource().getFeaturesCollection(),
                    style: new _ol2.default.style.Style({
                        image: new _ol2.default.style.Circle({
                            radius: this.options.cursorStyle.radius,
                            stroke: new _ol2.default.style.Stroke({
                                color: this.options.cursorStyle.strokeColor,
                                width: this.options.cursorStyle.strokeWidth
                            }),
                            fill: new _ol2.default.style.Fill({
                                color: this.options.cursorStyle.fillColor
                            })
                        })
                    }),
                    type: "Point"
                });
                context.interactionCurrent.on("drawend", function (deEv) {
                    // creation overlay pour saisie du label
                    var popupOvl = null;
                    /**
                         * Enregistrement de la valeur saisie dans l'input.
                         *
                         * @param {String} value - valeur du label
                         * @param {Boolean} save - true si on garde le label.
                         */
                    var setTextValue = function setTextValue( /* context,feature, */value, save) {
                        context.getMap().removeOverlay(popupOvl);
                        if (!save) {
                            // removes feature from overlay.
                            context.layer.getSource().removeFeature(deEv.feature);
                            return;
                        }

                        deEv.feature.setProperties({
                            name: value
                        });

                        deEv.feature.setStyle(new _ol2.default.style.Style({
                            image: new _ol2.default.style.Icon(context._getIconStyleOptions(context.options.defaultStyles.textIcon1x1)),
                            text: new _ol2.default.style.Text({
                                textAlign: "left",
                                font: "16px sans",
                                text: value,
                                fill: new _ol2.default.style.Fill({
                                    color: context.options.defaultStyles.textFillColor
                                }),
                                stroke: new _ol2.default.style.Stroke({
                                    color: context.options.defaultStyles.textStrokeColor,
                                    width: 3
                                })
                            })
                        }));
                    };
                    var popup = this._createLabelDiv({
                        applyFunc: setTextValue,
                        inputId: context._addUID("label-input"),
                        geomType: "Text",
                        placeholder: "Saisir un label..."
                    });
                    popupOvl = new _ol2.default.Overlay({
                        element: popup,
                        // FIXME : autres valeurs.
                        positioning: "top-center" // par defaut, top-left...
                        // stopEvent : false
                    });
                    context.getMap().addOverlay(popupOvl);
                    popupOvl.setPosition(deEv.feature.getGeometry().getCoordinates());
                    document.getElementById(this._addUID("label-input")).focus();
                }, context);
            }
            break;
        case this._addUID("drawing-tool-edit"):
            if (context.dtOptions["edit"].active) {
                context.interactionSelectEdit = new _ol2.default.interaction.Select({
                    condition: _ol2.default.events.condition.singleClick,
                    layers: [this.layer]
                });

                context.interactionSelectEdit.setProperties({
                    name: "Drawing",
                    source: context
                });
                map.addInteraction(context.interactionSelectEdit);

                context.interactionCurrent = new _ol2.default.interaction.Modify({
                    // features : context.layer.getSource().getFeaturesCollection(),
                    features: this.interactionSelectEdit.getFeatures(),
                    style: new _ol2.default.style.Style({
                        image: new _ol2.default.style.Circle({
                            radius: this.options.cursorStyle.radius,
                            stroke: new _ol2.default.style.Stroke({
                                color: this.options.cursorStyle.strokeColor,
                                width: this.options.cursorStyle.strokeWidth
                            }),
                            fill: new _ol2.default.style.Fill({
                                color: this.options.cursorStyle.fillColor
                            })
                        })
                    }),
                    // deleteCondition : aucune en mode "edition"
                    deleteCondition: function deleteCondition() /* event */{
                        return false;
                    }
                });
                context.interactionCurrent.on("modifyend", function (deEv) {
                    var feature = deEv.features.item(0);
                    context._updateMeasure(feature);
                }, context);
            }
            break;
        case this._addUID("drawing-tool-display"):
            if (context.dtOptions["display"].active) {
                context.interactionCurrent = this._createStylingInteraction();
            }
            break;
        case this._addUID("drawing-tool-tooltip"):

            if (context.dtOptions["tooltip"].active) {
                context.interactionCurrent = this._createLabelInteraction();
            }
            break;
        case this._addUID("drawing-tool-remove"):
            if (context.dtOptions["remove"].active) {
                context.interactionCurrent = context._createRemoveInteraction();
            }
            break;
        default:
            // logger.trace("unhandled tool type");
    }
    if (context.interactionCurrent) {
        context.interactionCurrent.setProperties({
            name: "Drawing",
            source: this
        });
        map.addInteraction(context.interactionCurrent);
    }
    logger.log("interactions", map.getInteractions());
};

// ################################################################### //
// ####################### handlers events to dom #################### //
// ################################################################### //

/**
 * this method is called by event 'click' on 'GPshowDrawingPicto' tag label
 * (cf. this._createShowDrawingPictoElement),
 * and toggles event 'mousemove' on map.
 *
 * @method onShowDrawingClick
 * @private
 */
Drawing.prototype.onShowDrawingClick = function () {
    var map = this.getMap();
    // on supprime toutes les interactions
    _Interactions2.default.unset(map);

    // checked : true - panel close
    // checked : false - panel open
    this.collapsed = this._showDrawingContainer.checked;
    // on génère nous même l'evenement OpenLayers de changement de propriété
    // (utiliser mousePosition.on("change:collapsed", function(e) ) pour s'abonner à cet évènement)
    this.dispatchEvent("change:collapsed");

    // on deselectionne les Tools
    for (var toolsType in this.dtOptions) {
        if (this.dtOptions.hasOwnProperty(toolsType)) {
            if (this.dtOptions[toolsType].active) {
                var toolsId = this._addUID("drawing-tool-" + this.dtOptions[toolsType].id);
                document.getElementById(toolsId).className = "drawing-tool";
                this.dtOptions[toolsType].active = false;
            }
        }
    }
};

/**
 * this method is called by event 'click' on 'drawing-export' tag button.
 *
 * @method onExportFeatureClick
 * @private
 */
Drawing.prototype.onExportFeatureClick = function () {
    // TODO
    var content = this.exportFeatures();
    if (!content) {
        return;
    }
    var link = document.createElement("a");
    // FIXME : determiner le bon charset !
    var charset = "utf-8";
    link.setAttribute("href", "data:application/vnd.google-earth.kml+xml;charset=" + charset + "," + encodeURIComponent(content));
    link.setAttribute("download", this.getExportName() + ".kml");
    if (document.createEvent) {
        var event = document.createEvent("MouseEvents");
        event.initEvent("click", true, true);
        link.dispatchEvent(event);
    } else {
        link.click();
    }
};

exports.default = Drawing;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("DrawingDOM");

var DrawingDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPdrawing");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################### Methods of main container ##################### //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing
     *
     * @returns {DOMElement} DOM element
     */
    _createShowDrawingElement: function _createShowDrawingElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowDrawing");
        input.className = "GPshowDrawing";
        input.type = "checkbox";
        return input;
    },

    /**
     * Show mouse position control
     *
     * @returns {DOMElement} DOM element
     */
    _createShowDrawingPictoElement: function _createShowDrawingPictoElement() {
        var self = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowDrawingPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowDrawing");
        label.title = this.options.labels.control;

        // gestionnaire d'evenement :
        // on ouvre le menu de saisie de saisie
        // L'ouverture/Fermeture permet de faire le menage
        // (reinitialisation)
        if (label.addEventListener) {
            label.addEventListener("click", function (e) {
                self.onShowDrawingClick(e);
            });
        } else if (label.attachEvent) {
            label.attachEvent("onclick", function (e) {
                self.onShowDrawingClick(e);
            });
        }

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowDrawingOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    },

    /**
     * Drawing panel
     *
     * @returns {DOMElement} DOM element
     */
    _createDrawingPanelElement: function _createDrawingPanelElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPdrawingPanel");
        div.className = "GPpanel";

        div.appendChild(this._createDrawingPanelHeaderElement());

        this.dtOptions = {};
        if (this.options.tools.points) {
            this.dtOptions.points = {
                label: this.options.labels.points,
                active: false,
                panel: "draw",
                id: "point"
            };
        }
        if (this.options.tools.lines) {
            this.dtOptions.lines = {
                label: this.options.labels.lines,
                active: false,
                panel: "draw",
                id: "line"
            };
        }
        if (this.options.tools.polygons) {
            this.dtOptions.polygons = {
                label: this.options.labels.polygons,
                active: false,
                panel: "draw",
                id: "polygon"
            };
        }
        if (this.options.tools.text) {
            this.dtOptions.text = {
                label: this.options.labels.text,
                active: false,
                panel: "draw",
                id: "text"
            };
        }
        if (this.options.tools.edit) {
            this.dtOptions.edit = {
                label: this.options.labels.edit,
                active: false,
                panel: "edit",
                id: "edit"
            };
        }
        if (this.options.tools.display) {
            this.dtOptions.display = {
                label: this.options.labels.display,
                active: false,
                panel: "edit",
                id: "display"
            };
        }
        if (this.options.tools.tooltip) {
            this.dtOptions.tooltip = {
                label: this.options.labels.tooltip,
                active: false,
                panel: "edit",
                id: "tooltip"
            };
        }
        if (this.options.tools.remove) {
            this.dtOptions.remove = {
                label: this.options.labels.remove,
                active: false,
                panel: "edit",
                id: "remove"
            };
        }
        // ajout drawing tools
        if (this.dtOptions.points || this.dtOptions.lines || this.dtOptions.polygons || this.dtOptions.text) {
            div.appendChild(this._createDrawingToolSection(this.options.labels.creatingTools, "draw"));
        }
        // ajout editing tools
        if (this.dtOptions.edit || this.dtOptions.display || this.dtOptions.tooltip || this.dtOptions.remove) {
            div.appendChild(this._createDrawingToolSection(this.options.labels.editingTools, "edit"));
        }
        // ajout export tools
        if (this.options.tools.export) {
            div.appendChild(this._createSavingSection(this.options.labels.export, this.options.labels.exportTitle));
        }

        return div;
    },

    // ################################################################### //
    // ####################### Panel container ########################### //
    // ################################################################### //

    /**
    * Creates drawing Panel header DOM structure
    * @returns {DOMElement} DOM element
    */
    _createDrawingPanelHeaderElement: function _createDrawingPanelHeaderElement() {
        /*
         * <div class="GPpanelHeader">
         *     <div class="GPpanelTitle">Annoter la carte</div>
         *     <div id="GPdrawingPanelClose" class="GPpanelClose" title="Fermer le panneau"></div>
         * </div>
         */

        var container = document.createElement("div");
        container.className = "GPpanelHeader";

        var divTitle = document.createElement("div");
        divTitle.className = "GPpanelTitle";
        divTitle.innerHTML = this.options.controlLabel || "Annoter la carte";
        container.appendChild(divTitle);

        var divClose = document.createElement("div");
        divClose.id = this._addUID("GPdrawingPanelClose");
        divClose.className = "GPpanelClose";
        divClose.title = "Fermer le panneau";

        // Link panel close / visibility checkbox
        var dtObj = this;
        if (divClose.addEventListener) {
            divClose.addEventListener("click", function () {
                document.getElementById(dtObj._addUID("GPshowDrawingPicto")).click();
            }, false);
        } else if (divClose.attachEvent) {
            divClose.attachEvent("onclick", function () {
                document.getElementById(dtObj._addUID("GPshowDrawingPicto")).click();
            });
        }

        container.appendChild(divClose);

        return container;
    },

    /**
     * Creates drawing tool section DOM structure.
     *
     * @param {String} sectionLabel - section title
     * @param {String} panelType - Drawing ("draw") or editing ("edit") tools panel
     * @returns {DOMElement} DOM element
     */
    _createDrawingToolSection: function _createDrawingToolSection(sectionLabel, panelType) {
        /*
         * Exemple panelType == "draw"
         *
         * <div class="drawing-tool-section">
         *     <p class="drawing-tool-section-title">Outils de création</p>
         *     <ul class="drawing-tools-flex-display">
         *         <li id="drawing-tool-point" class="drawing-tool" title="Placer des points"></li>
         *         <li id="drawing-tool-line" class="drawing-tool" title="Dessiner des lignes"></li>
         *         <li id="drawing-tool-polygon" class="drawing-tool" title="Dessiner des polygones"></li>
         *         <li id="drawing-tool-text" class="drawing-tool" title="Ecrire sur la carte"></li>
         *     </ul>
         * </div>
         */
        var container = document.createElement("div");
        container.className = "drawing-tool-section";

        var p = document.createElement("p");
        p.className = "drawing-tool-section-title";
        p.innerHTML = sectionLabel;
        container.appendChild(p);

        var ul = document.createElement("ul");
        ul.className = "drawing-tools-flex-display";
        var context = this;
        // li click handler function
        function liClickHandler(e) {
            /* jshint validthis: true */
            // this == elem clicked
            context._handleDOMToolClick(e, this.id, context);
            context._handleToolClick(e, this.id, context);
        }
        for (var type in this.dtOptions) {
            if (this.dtOptions[type].panel !== panelType) {
                continue;
            }
            var li = document.createElement("li");
            li.className = "drawing-tool";
            li.id = this._addUID("drawing-tool-" + this.dtOptions[type].id);
            li.title = this.dtOptions[type].label;
            li.addEventListener("click", liClickHandler);
            ul.appendChild(li);
        }
        container.appendChild(ul);

        return container;
    },

    /**
     * Creates drawing tool section DOM structure.
     *
     * @param {String} buttonLabel - Button label
     * @param {String} buttonTitle - Button title
     * @returns {DOMElement} DOM element
     */
    _createSavingSection: function _createSavingSection(buttonLabel, buttonTitle) {
        /*
         * <div class="drawing-tool-section drawing-tools-flex-display">
         *     <button title="Exporter en KML" class="tool-form-submit drawing-button" id="drawing-export" type="button">Exporter</button>
         * </div>
         */
        var container = document.createElement("div");
        container.className = "drawing-tool-section drawing-tools-flex-display";

        var button = document.createElement("button");
        button.title = buttonTitle;
        button.className = "tool-form-submit drawing-button";
        button.id = this._addUID("drawing-export");
        button.type = "button";
        button.textContent = buttonLabel;
        var context = this;
        /** export function */
        button.onclick = function () {
            context.onExportFeatureClick();
        };
        container.appendChild(button);

        return container;
    },

    /**
     * Converts rgba String to #RRGGBBAA
     * (Code adapted from : https://gist.github.com/mstssk/afda4ce9e5c335fd79cd)
     *
     * @param {String} rgba - A color of RGB or RGBA format.
     * @returns {Object} hex and opacity formated values
     */
    rgbaToHex: function rgbaToHex(rgba) {
        // number to hex conversion
        function hex(number) {
            if (number > 255) {
                throw new Error("'" + number + "'' is greater than 255(0xff);");
            }
            var str = Number(number).toString(16);
            return ("0" + str).slice(-2);
        }
        var regex = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(0?.?\d+)\s*)?\)/;
        var parsed = regex.exec(rgba);
        if (!parsed) {
            throw new Error("Invalid format: " + rgba);
        }
        var red = parsed[1];
        var green = parsed[2];
        var blue = parsed[3];
        var alpha = parsed[4];
        var elems = [hex(red), hex(green), hex(blue)];
        var result = {};
        result.hex = "#" + elems.join("");
        if (alpha) {
            // elems.push(hex(alpha));
            result.opacity = parseFloat(alpha);
        }
        return result;
    },

    /**
     * Converts hex color and opacity value to rgba String.
     * (Code adapted from : http://stackoverflow.com/a/5624139)
     * @param {String} hex - A color value on RGB format (hexa).
     * @param {Number} opacity - A opacity value.
     * @returns {String} A color of RGB or RGBA format
     */
    hexToRgba: function hexToRgba(hex, opacity) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        if (!hex) {
            throw new Error("Invalid format");
        }
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        rgb = rgb ? {
            r: parseInt(rgb[1], 16),
            g: parseInt(rgb[2], 16),
            b: parseInt(rgb[3], 16)
        } : null;
        var result = rgb ? "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + opacity + ")" : null;
        return result;
    },

    /**
     * Creates input for color choosing
     *
     * @param {Object} options - options
     * @param {String} options.defaultValue - defaultValue
     * @param {String} options.className - input className
     * @returns {DOMElement} - created li element
     */
    _createMarkersChooser: function _createMarkersChooser(options) {
        var li = document.createElement("li");
        li.className = options.className;
        for (var i = 0; i < this.options.markersList.length; i++) {
            // radio bouton pour la selection
            var inputElem = document.createElement("input");
            inputElem.type = "radio";
            inputElem.name = "marker";
            inputElem.id = this._addUID("marker-" + i);
            inputElem.value = this.options.markersList[i].src;
            inputElem.className = "marker-input-radio";
            if (options.defaultValue === inputElem.value) {
                inputElem.checked = true;
            }
            li.appendChild(inputElem);
            // label pour l'affichage du marker
            var labelElem = document.createElement("label");
            labelElem.className = "marker-label"; // utile ?
            labelElem.setAttribute("for", inputElem.id);
            var imgElem = document.createElement("img");
            imgElem.src = inputElem.value;
            labelElem.appendChild(imgElem);
            li.appendChild(labelElem);
        }
        return li;
    },

    /**
     * Creates input for color choosing
     *
     * @param {Object} options - options
     * @param {String} options.label - label
     * @param {String} options.type - input type for element ("color")
     * @param {String} options.defaultValue - defaultValue
     * @param {String} options.id - input id
     * @param {String} options.title - input title
     * @param {String} options.className - input className
     * @returns {DOMElement} - created li element
     */
    _createStylingElement: function _createStylingElement(options) {
        var li = document.createElement("li");
        li.className = options.className;
        var textNode = document.createTextNode(options.label);
        li.appendChild(textNode);
        var inputElem = document.createElement("input");
        try {
            inputElem.type = options.type;
        } catch (e) {
            // ie 11 input type== color ne marche pas...
            inputElem.type = "text";
        }
        inputElem.id = options.id;
        inputElem.value = options.defaultValue;
        if (options.title) {
            inputElem.title = options.title;
        }
        // si options.type == "range"
        if (options.min !== undefined) {
            inputElem.min = options.min;
        }
        if (options.max !== undefined) {
            inputElem.max = options.max;
        }
        if (options.step !== undefined) {
            inputElem.step = options.step;
        }
        li.appendChild(inputElem);
        return li;
    },

    /**
     * Creates Styling div to include in popup.
     *
     * @param {Object} options - toolId selected
     * @param {String} options.geomType - gemeotryType selected ("Point", "Line" or "Polygon")
     * @param {Object} options.initValues - values to init fields
     * @param {String} options.initValues.markerSrc - marker URL for Points
     * @param {Function} options.applyFunc - function called when apply is selected
     * @returns {DOMElement} DOM element created
     */
    _createStylingDiv: function _createStylingDiv(options) {
        var div = document.createElement("div");
        div.className = "gp-styling-div";
        var ul = document.createElement("ul");
        var li = null;
        /*
         * TODO : finir de remplir la div pour tous les styles éditables.
         */
        switch (options.geomType.toLowerCase()) {
            case "point":
                li = this._createMarkersChooser({
                    className: "gp-styling-option",
                    // defaultValue : this.options.markersList[0].src
                    defaultValue: options.initValues.markerSrc
                });
                ul.appendChild(li);
                break;
            case "text":
                li = this._createStylingElement({
                    type: "color",
                    className: "gp-styling-option",
                    label: this.options.labels.fillColor,
                    id: this._addUID("fillColor"),
                    defaultValue: options.initValues.fillColor
                });
                ul.appendChild(li);
                li = this._createStylingElement({
                    type: "color",
                    className: "gp-styling-option",
                    label: this.options.labels.strokeColor,
                    id: this._addUID("strokeColor"),
                    defaultValue: options.initValues.strokeColor
                });
                ul.appendChild(li);
                break;
            case "line":
                li = this._createStylingElement({
                    type: "color",
                    className: "gp-styling-option",
                    label: this.options.labels.strokeColor,
                    id: this._addUID("strokeColor"),
                    defaultValue: options.initValues.strokeColor
                });
                ul.appendChild(li);
                li = this._createStylingElement({
                    type: "range",
                    className: "gp-styling-option",
                    label: this.options.labels.strokeWidth,
                    title: "1 à 10 pixels",
                    id: this._addUID("strokeWidth"),
                    min: 1,
                    max: 10,
                    step: 1,
                    defaultValue: options.initValues.strokeWidth
                });
                ul.appendChild(li);
                break;
            case "polygon":
                li = this._createStylingElement({
                    type: "color",
                    className: "gp-styling-option",
                    label: this.options.labels.strokeColor,
                    id: this._addUID("strokeColor"),
                    defaultValue: options.initValues.strokeColor
                });
                ul.appendChild(li);
                li = this._createStylingElement({
                    type: "range",
                    className: "gp-styling-option",
                    label: this.options.labels.strokeWidth,
                    title: "1 à 10 pixels",
                    id: this._addUID("strokeWidth"),
                    min: 1,
                    max: 10,
                    step: 1,
                    defaultValue: options.initValues.strokeWidth
                });
                ul.appendChild(li);
                li = this._createStylingElement({
                    type: "color",
                    className: "gp-styling-option",
                    label: this.options.labels.fillColor,
                    id: this._addUID("fillColor"),
                    defaultValue: options.initValues.fillColor
                });
                ul.appendChild(li);
                li = this._createStylingElement({
                    type: "range",
                    className: "gp-styling-option",
                    label: this.options.labels.fillOpacity,
                    title: "0 (transparent) à 100% (opaque)",
                    id: this._addUID("fillOpacity"),
                    min: 0,
                    max: 10,
                    step: 1,
                    defaultValue: options.initValues.fillOpacity * 10
                });
                ul.appendChild(li);
                break;
            default:
                logger.log("Unhandled geometry type for styling.");
        }
        div.appendChild(ul);
        // apply button
        var applyButton = document.createElement("input");
        applyButton.type = "button";
        applyButton.className = "gp-styling-button";
        applyButton.value = this.options.labels.applyToObject;
        /** click sur applyButton */
        applyButton.onclick = function () {
            options.applyFunc.call(this, "apply");
        };
        div.appendChild(applyButton);
        // set default button
        var setDefaultButton = document.createElement("input");
        setDefaultButton.type = "button";
        setDefaultButton.value = this.options.labels.setAsDefault;
        setDefaultButton.className = "gp-styling-button";
        /** click sur set Default Button */
        setDefaultButton.onclick = function () {
            options.applyFunc.call(this, "default");
        };
        div.appendChild(setDefaultButton);
        // cancel Button
        var cancelButton = document.createElement("input");
        cancelButton.type = "button";
        // cancelButton.value = "X" ;
        cancelButton.className = "gp-styling-button closer";
        /** click sur cancel Button */
        cancelButton.onclick = function () {
            options.applyFunc.call(this, "cancel");
        };
        div.appendChild(cancelButton);
        return div;
    },

    /**
     * Creates Text editing div to include in popup.
     *
     * @param {Object} options - options for popup
     * @param {String} options.geomType - gemeotryType selected ("Point", "Line" or "Polygon")
     * @param {String} options.text - text to fill input.
     * @param {String} options.measure - measure to fill input.
     * @param {String} options.placeholder - placeholder for text input.
     * @param {String} options.inputId - text input id.
     * @param {Function} options.applyFunc - function called when text is to be saved.
     * @returns {DOMElement} DOM element created
     * @private
     */
    _createLabelDiv: function _createLabelDiv(options) {
        var popup = document.createElement("div");
        popup.className = "gp-label-div";
        var inputLabel = null;
        if (options.geomType === "Text") {
            inputLabel = document.createElement("input");
            inputLabel.type = "text";
            inputLabel.className = "gp-input-label-style";
        } else {
            inputLabel = document.createElement("textArea");
            inputLabel.rows = 2;
            inputLabel.cols = 40;
            inputLabel.className = "gp-textarea-att-label-style";
        }

        if (options.text) {
            inputLabel.value = options.text;
        }

        inputLabel.autocomplete = "off";
        inputLabel.placeholder = options.placeholder;
        inputLabel.id = options.inputId;
        popup.appendChild(inputLabel);
        // blur
        inputLabel.onblur = function () {
            options.applyFunc.call(this, inputLabel.value, true);
        };
        // keyup
        inputLabel.onkeyup = function (evtk) {
            if (options.geomType === "Text" && evtk.keyCode === 13) {
                options.applyFunc.call(this, inputLabel.value, true);
            }
            if (evtk.keyCode === 27) {
                options.applyFunc.call(this, inputLabel.value, false);
            }
        };

        if (options.measure && options.geomType !== "Text") {
            var inputMeasure = document.createElement("input");
            inputMeasure.type = "text";
            inputMeasure.readonly = true;
            inputMeasure.className = "gp-input-measure-style";
            inputMeasure.value = options.measure;
            popup.appendChild(inputMeasure);
        }

        if (options.geomType !== "Text") {
            // apply button
            var applyButton = document.createElement("input");
            applyButton.type = "button";
            applyButton.className = "gp-styling-button";
            applyButton.value = this.options.labels.saveDescription;
            /** click sur applyButton */
            applyButton.onclick = function () {
                options.applyFunc.call(this, inputLabel.value, true);
            };
            popup.appendChild(applyButton);
            // cancel Button
            var cancelButton = document.createElement("input");
            cancelButton.type = "button";
            cancelButton.className = "gp-styling-button closer";
            /** click sur cancel Button */
            cancelButton.onclick = function () {
                options.applyFunc.call(this, inputLabel.value, false);
            };
            popup.appendChild(cancelButton);
        }

        return popup;
    },

    /**
     * Handles drawing tool selection from a DOM point of view.
     *
     * @param {Event} e - DOM Event
     * @param {String} toolId - toolId selected
     * @param {DrawingDOM} context - Drawing control instance
     */
    _handleDOMToolClick: function _handleDOMToolClick(e, toolId, context) {
        for (var availType in context.dtOptions) {
            var availToolId = context._addUID("drawing-tool-" + context.dtOptions[availType].id);
            var li = document.getElementById(availToolId);
            // ce n'est pas l'outil selectionne : on le desactive (s'il ne l'était pas déjà).
            if (availToolId !== toolId) {
                li.className = "drawing-tool";
                context.dtOptions[availType].active = false;
                continue;
            }
            // ici, c'est le l'outil selectionne
            if (context.dtOptions[availType].active) {
                li.className = "drawing-tool";
            } else {
                li.className = "drawing-tool drawing-tool-active";
            }
            context.dtOptions[availType].active = !context.dtOptions[availType].active;
        }
    }

};

exports.default = DrawingDOM;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _CheckRightManagement = __webpack_require__(7);

var _CheckRightManagement2 = _interopRequireDefault(_CheckRightManagement);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _LocationSelector = __webpack_require__(23);

var _LocationSelector2 = _interopRequireDefault(_LocationSelector);

var _LayerSwitcher = __webpack_require__(6);

var _LayerSwitcher2 = _interopRequireDefault(_LayerSwitcher);

var _Markers = __webpack_require__(5);

var _Markers2 = _interopRequireDefault(_Markers);

var _RouteDOM = __webpack_require__(45);

var _RouteDOM2 = _interopRequireDefault(_RouteDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("route");

/**
 * @classdesc
 *
 * Route Control.
 *
 * @constructor
 * @alias ol.control.Route
 * @extends {ol.control.Control}
 * @param {Object} options - route control options
 * @param {String}   [options.apiKey] - API key for services call (route and autocomplete services), mandatory if autoconf service has not been charged in advance
 * @param {Boolean} [options.collapsed = true] - Specify if widget has to be collapsed (true) or not (false) on map loading. Default is true.
 * @param {Object}  [options.exclusions = {toll : false, tunnel : false, bridge : false}] - list of exclusions with status (true = checked). By default : no exclusions checked.
 * @param {Array}   [options.graphs = ["Voiture", "Pieton"]] - list of resources, by default : ["Voiture", "Pieton"]. The first element is selected.
 * @param {Object} [options.markersOpts] - options to use your own markers. Object properties can be "departure", "stages" or "arrival". Corresponding value is an object with following properties :
 * @param {String} [options.markersOpts[property].url] - marker base64 encoded url (ex "data:image/png;base64,...""). Mandatory for a custom marker
 * @param {Array} [options.markersOpts[property].offset] - Offsets in pixels used when positioning the overlay. The first element in the array is the horizontal offset. A positive value shifts the overlay right. The second element in the array is the vertical offset. A positive value shifts the overlay down. Default is [0, 0]. (see http://openlayers.org/en/latest/apidoc/ol.Overlay.html)
 * @param {Object} [options.routeOptions = {}] - route service options. see {@link http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~route Gp.Services.route()} to know all route options.
 * @param {Object} [options.autocompleteOptions = {}] - autocomplete service options. see {@link http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~autoComplete Gp.Services.autoComplete()} to know all autocomplete options
 * @param {Object} [options.layerDescription = {}] - Layer informations to be displayed in LayerSwitcher widget (only if a LayerSwitcher is also added to the map)
 * @param {String} [options.layerDescription.title = "Itinéraire"] - Layer title to be displayed in LayerSwitcher
 * @param {String} [options.layerDescription.description = "Itinéraire basé sur un graphe"] - Layer description to be displayed in LayerSwitcher
 * @example
 *  var route = ol.control.Route({
 *      collapsed : true
 *      exclusions : {
 *         "toll" : true,
 *         "bridge" : false,
 *         "tunnel" : true
 *      },
 *      graphs : ['Pieton', 'Voiture'],
 *      markersOpts : {
 *          departure : {
 *              url : "...",
 *              offset : [0,0]
 *          },
 *          stages : {
 *              url : "...",
 *              offset : [0,0]
 *          },
 *          arrival : {
 *              url : "...",
 *              offset : [0,0]
 *          }
 *      }
 *      autocompleteOptions : {},
 *      routeOptions : {}
 *  });
 */
function Route(options) {
    options = options || {};

    if (!(this instanceof Route)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // initialisation du composant
    this.initialize(options);

    // Widget main DOM container
    this._container = this._createMainContainerElement();
    this._containerElement = null;

    // on peut éventuellement encapsuler le composant dans une div passée par l'utilisateur
    if (options.element && options.element.appendChild) {
        // dans ce cas on stocke les deux container
        options.element.appendChild(this._container);
        this._containerElement = options.element;
    }

    // call ol.control.Control constructor
    _ol2.default.control.Control.call(this, {
        element: this._containerElement || this._container,
        target: options.target,
        render: options.render
    });
}

// Inherits from ol.control.Control
_ol2.default.inherits(Route, _ol2.default.control.Control);

/**
 * @lends module:Route
 */
Route.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les méthodes de la classe commune RouteDOM
_Utils2.default.assign(Route.prototype, _RouteDOM2.default);

/**
 * Constructor (alias)
 * @private
 */
Route.prototype.constructor = Route;

// ################################################################### //
// ##################### public methods ############################## //
// ################################################################### //

/**
 * Returns true if widget is collapsed (minimized), false otherwise
 *
 * @returns {Boolean} collapsed - true if widget is collapsed
 */
Route.prototype.getCollapsed = function () {
    return this.collapsed;
};

/**
 * Collapse or display widget main container
 *
 * @param {Boolean} collapsed - True to collapse widget, False to display it
 */
Route.prototype.setCollapsed = function (collapsed) {
    if (collapsed === undefined) {
        logger.log("[ERROR] Route:setCollapsed - missing collapsed parameter");
        return;
    }
    if (collapsed && this.collapsed || !collapsed && !this.collapsed) {
        return;
    }
    if (collapsed) {
        document.getElementById("GProutePanelClose-" + this._uid).click();
    } else {
        document.getElementById("GPshowRoute-" + this._uid).click();
    }
    this.collapsed = collapsed;
};

/**
 * Get vector layer where geoJson route is drawn
 *
 * @returns {Object} layer - ol.layer.Vector route layer
 */
Route.prototype.getLayer = function () {
    return this._geojsonSections;
};

/**
 * Overwrite OpenLayers setMap method
 *
 * @param {ol.Map} map - Map.
 */
Route.prototype.setMap = function (map) {
    if (map) {
        // enrichissement du DOM du container
        this._container = this._initContainer(map);
    }

    // on appelle la méthode setMap originale d'OpenLayers
    _ol2.default.control.Control.prototype.setMap.call(this, map);
};

// ################################################################### //
// ##################### init component ############################## //
// ################################################################### //

/**
 * Initialize route control (called by Route constructor)
 *
 * @param {Object} options - constructor options
 * @private
 */
Route.prototype.initialize = function (options) {
    this._checkInputOptions(options);

    // set default options
    this.options = {
        collapsed: true,
        graphs: ["Voiture", "Pieton"],
        exclusions: {
            toll: false,
            tunnel: false,
            bridge: false
        },
        routeOptions: {},
        autocompleteOptions: {},
        layerDescription: {
            title: "Itinéraire",
            description: "Itinéraire basé sur un graphe"
        }
    };

    // merge with user options
    _Utils2.default.assign(this.options, options);

    // cas particulier des markers par défaut
    var defaultMarkersOpts = {
        departure: {
            url: _Markers2.default["red"],
            offset: _Markers2.default.defaultOffset
        },
        stages: {
            url: _Markers2.default["lightOrange"],
            offset: _Markers2.default.defaultOffset
        },
        arrival: {
            url: _Markers2.default["darkOrange"],
            offset: _Markers2.default.defaultOffset
        }
    };
    // on récupère les options de chaque type de marker si spécifié
    this.options.markersOpts = _Utils2.default.assign(defaultMarkersOpts, options.markersOpts);

    /** {Boolean} specify if Route control is collapsed (true) or not (false) */
    this.collapsed = this.options.collapsed;

    this._uid = _SelectorID2.default.generate();

    // containers principaux
    this._waitingContainer = null;
    this._formRouteContainer = null;
    this._resultsRouteContainer = null;
    this._showRouteExclusionsElement = null;

    // liste de points selectionnée
    this._currentPoints = [];

    // Mode de transport selectionné : 'Voiture' ou 'Pieton'
    this._currentTransport = null;
    this._initTransport();

    // Mode de calcul selectionné : 'Plus rapide' ou 'plus court'
    this._currentComputation = null;
    this._initComputation();

    // Exclusions selectionnées : Tunnel, Toll et Bridge
    this._currentExclusions = [];
    this._initExclusions();

    // si un calcul est en cours ou non
    this._waiting = false;
    // timer pour cacher la patience après un certain temps
    this._timer = null;

    // la geometrie du parcours
    this._geojsonRoute = null;

    // la geometrie des troncons
    this._geojsonSections = null;

    // le container de la popup (pour les troncons selectionnés)
    this._popupContent = null;
    this._popupDiv = this._initPopupDiv();
    // l'overlay ol.Overlay correspondant à la popup (pour les troncons selectionnés)
    this._popupOverlay = null;

    // ol.interaction.Select associées à la couche des résultats (troncons)
    this._resultsSelectInteraction = null;
    this._resultsHoverInteraction = null;

    // styles pour les sélections des features
    this._defaultFeatureStyle = new _ol2.default.style.Style({
        stroke: new _ol2.default.style.Stroke({
            color: "rgba(0,183,152,0.9)",
            width: 12
        })
    });
    this._selectedFeatureStyle = new _ol2.default.style.Style({
        stroke: new _ol2.default.style.Stroke({
            color: "rgba(255,102,0,0.9)",
            width: 12
        })
    });

    // reponse du service
    // Ex. {
    //   totalTime, totalDistance, bbox, routeGeometry,
    //   routeInstructions : [{duration, distance, code, instruction, bbox, geometry}]
    // }
    this._currentRouteInformations = null;

    // liste des ressources avec droits par service
    // Ex. {
    //   "Route" : {
    //       key : "ger4g456re45er456t4er5ge5",
    //       resources : ["Pieton", "Voiture"]
    //   }
    // }
    this._resources = {};

    // gestion des droits sur les ressources
    this._noRightManagement = false;

    // gestion des droits sur les ressources/services
    this._checkRightsManagement();
};

/**
 * this method is called by this.initialize()
 *
 * @param {Object} options - options
 *
 * @private
 */
Route.prototype._checkInputOptions = function (options) {
    // vérification des options
    // mode de transport
    if (options.graphs) {
        if (Array.isArray(options.graphs)) {
            // on ne permet pas de passer un tableau vide : on spécifie au moins un graph
            if (options.graphs.length === 0) {
                options.graphs = null;
            } else {
                for (var i = 0; i < options.graphs.length; i++) {
                    if (typeof options.graphs[i] !== "string") {
                        logger.log("[ol.control.Route] ERROR : parameter 'graphs' elements should be of type 'string'");
                        options.graphs = null;
                    } else {
                        if (options.graphs[i].toLowerCase() === "pieton") {
                            options.graphs[i] = "Pieton";
                        }
                        if (options.graphs[i].toLowerCase() === "voiture") {
                            options.graphs[i] = "Voiture";
                        }
                    }
                }
            }
        } else {
            logger.warn("'graphs' parameter should be an array");
            options.graphs = null;
        }
    }

    // collapsed
    if (options.collapsed === "true") {
        options.collapsed = true;
    }
    if (options.collapsed === "false") {
        options.collapsed = false;
    }
};

/**
 * Check rights to resources (called by constructor)
 *
 * @private
 */
Route.prototype._checkRightsManagement = function () {
    var _opts = null;
    var _res = [];
    var _key = null;

    // les ressources du service du calcul d'Itineraire
    _key = this.options.routeOptions.apiKey;
    _opts = this.options.routeOptions.filterOptions;
    _res = _opts ? _opts.type : [];
    if (!_res || _res.length === 0) {
        _res = ["Voiture", "Pieton"];
    }

    var rightManagementRoute = _CheckRightManagement2.default.check({
        key: _key || this.options.apiKey,
        resources: _res,
        services: ["Itineraire"]
    });
    logger.log("rightManagementRoute", rightManagementRoute);

    // les ressources du service d'autocompletion
    _key = this.options.autocompleteOptions.apiKey;
    _opts = this.options.autocompleteOptions.filterOptions;
    _res = _opts ? _opts.type : [];
    if (!_res || _res.length === 0) {
        _res = ["PositionOfInterest", "StreetAddress"];
    }

    var rightManagementAutoComplete = _CheckRightManagement2.default.check({
        key: _key || this.options.apiKey,
        resources: _res,
        services: ["AutoCompletion"]
    });
    logger.log("rightManagementAutoComplete", rightManagementAutoComplete);

    // au cas où pas de droit !
    if (!rightManagementRoute && !rightManagementAutoComplete) {
        this._noRightManagement = true;
    }

    // FIXME je reconstruis differement la structure pour la gestion des clefs differentes
    // pour chaque service...
    if (rightManagementAutoComplete) {
        this._resources["AutoCompletion"] = {};
        this._resources["AutoCompletion"]["resources"] = rightManagementAutoComplete["AutoCompletion"];
        this._resources["AutoCompletion"]["key"] = rightManagementAutoComplete["key"];
    }

    if (rightManagementRoute) {
        this._resources["Itineraire"] = {};
        this._resources["Itineraire"]["resources"] = rightManagementRoute["Itineraire"];
        this._resources["Itineraire"]["key"] = rightManagementRoute["key"];
    }
};

/**
 * initialize component container (DOM)
 *
 * @param {Object} map - the map
 *
 * @returns {DOMElement} DOM element
 *
 * @private
 */
Route.prototype._initContainer = function (map) {
    // get main container
    var container = this._container;

    var inputShow = this._showRouteContainer = this._createShowRouteElement();
    container.appendChild(inputShow);

    // mode "collapsed"
    if (!this.collapsed) {
        inputShow.checked = true;
    }

    var picto = this._createShowRoutePictoElement();
    container.appendChild(picto);

    var routePanel = this._createRoutePanelElement();

    // header form
    var routeHeader = this._createRoutePanelHeaderElement();
    routePanel.appendChild(routeHeader);

    // form
    var routeForm = this._formRouteContainer = this._createRoutePanelFormElement();

    // form: menu des points
    var points = this._createRoutePanelFormPointsElement(map);
    for (var i = 0; i < points.length; i++) {
        routeForm.appendChild(points[i]);
    }

    // form: menu des modes
    var choice = this._createRoutePanelFormModeChoiceElement();
    choice.appendChild(this._createRoutePanelFormModeChoiceTransportElement(this.options.graphs));
    choice.appendChild(this._createRoutePanelFormModeChoiceComputeElement());
    routeForm.appendChild(choice);

    // form: menu des exclusions
    routeForm.appendChild(this._createShowRouteExclusionsElement());
    this._showRouteExclusionsElement = this._createShowRouteExclusionsPictoElement();
    routeForm.appendChild(this._showRouteExclusionsElement);
    var exclusion = this._createRoutePanelFormExclusionsElement();
    exclusion.appendChild(this._createRoutePanelFormExclusionOptionsElement(this.options.exclusions));
    routeForm.appendChild(exclusion);

    var divReset = this._createRouteFormResetElement();
    routeForm.appendChild(divReset);

    // form: bouton du calcul
    var submit = this._createRouteSubmitFormElement();
    routeForm.appendChild(submit);

    routePanel.appendChild(routeForm);

    // results
    var routeResults = this._resultsRouteContainer = this._createRoutePanelResultsElement();
    routePanel.appendChild(routeResults);

    // waiting
    var waiting = this._waitingContainer = this._createRouteWaitingElement();
    routePanel.appendChild(waiting);

    container.appendChild(routePanel);
    var context = this;
    // hide autocomplete suggested locations on container click
    if (container.addEventListener) {
        container.addEventListener("click", function (e) {
            context._hideRouteSuggestedLocations(e);
        });
    }

    return container;
};

// ################################################################### //
// ####################### init application ########################## //
// ################################################################### //

/**
 * this method is called by the constructor and initialize transport mode
 * ("Voiture" ou "Pieton")
 *
 * @private
 */
Route.prototype._initTransport = function () {
    // Mode de transport selectionné
    this._currentTransport = "Voiture"; // par defaut

    // par defaut
    var transport = this.options.graphs;
    if (!transport || transport.length === 0) {
        this.options.graphs = ["Voiture", "Pieton"];
    }

    // option
    if (Array.isArray(transport) && transport.length) {
        // FIXME pb si le 1er graphe n'est pas une ressource connue !
        if (transport[0] === "Voiture" || transport[0] === "Pieton") {
            this._currentTransport = transport[0];
        }
    }

    // TODO option sur le service
    var serviceOptions = this.options.routeOptions;
    if (serviceOptions.graph) {
        this._currentTransport = serviceOptions.graph;
    }
};

/**
 * this method is called by the constructor and initialize computation mode
 * (fastest or shortest)
 *
 * @private
 */
Route.prototype._initComputation = function () {
    // Mode de calcul selectionné
    this._currentComputation = "fastest"; // par defaut

    // TODO option sur le service
    var serviceOptions = this.options.routeOptions;
    if (serviceOptions.routePreference) {
        this._currentComputation = serviceOptions.routePreference;
    }
};

/**
 * this method is called by the constructor and initialize exclusions
 *
 * @private
 */
Route.prototype._initExclusions = function () {
    // Exclusions selectionnées : Tunnel, Toll et Bridge
    this._currentExclusions = []; // par defaut

    // par defaut
    var exclusion = this.options.exclusions;
    if (!exclusion || (typeof exclusion === "undefined" ? "undefined" : _typeof(exclusion)) === "object" && Object.keys(exclusion).length === 0) {
        this.options.exclusions = {
            toll: false,
            tunnel: false,
            bridge: false
        };
    }

    // option
    if (exclusion && (typeof exclusion === "undefined" ? "undefined" : _typeof(exclusion)) === "object" && Object.keys(exclusion).length) {
        for (var k in exclusion) {
            if (exclusion.hasOwnProperty(k)) {
                if (exclusion[k]) {
                    this._currentExclusions.push(k);
                }
            }
        }
    }

    // TODO option sur le service
    var serviceOptions = this.options.routeOptions;
    if (Array.isArray(serviceOptions.exclusions)) {
        this._currentExclusions = serviceOptions.exclusions;
    }
};

/**
 * this method is called by this.initialize() and initialize popup div
 * (to display results information on route result click)
 *
 * @return {Object} element - DOM element for popup
 * @private
 */
Route.prototype._initPopupDiv = function () {
    var context = this;
    var element = document.createElement("div");
    element.className = "gp-feature-info-div";
    var closer = document.createElement("input");
    closer.type = "button";
    closer.className = "gp-styling-button closer";
    // on closer click : remove popup
    closer.onclick = function () {
        if (context._popupOverlay != null) {
            context._popupOverlay.setPosition(undefined);
        }
        return false;
    };
    this._popupContent = document.createElement("div");
    this._popupContent.className = "gp-features-content-div";
    element.appendChild(this._popupContent);
    element.appendChild(closer);

    return element;
};

// ################################################################### //
// ############################## DOM ################################ //
// ################################################################### //

/**
 * Create List Points
 * Overwrite RouteDOM method !
 *
 * @param {Object} map - the map
 *
 * @returns {Array} List DOM element
 * @private
 */
Route.prototype._createRoutePanelFormPointsElement = function (map) {
    var points = [];
    var count = 1;

    // point de depart
    var start = new _LocationSelector2.default({
        apiKey: this.options.apiKey || null,
        tag: {
            id: count,
            groupId: this._uid,
            markerOpts: this.options.markersOpts["departure"],
            label: "Départ",
            display: true
        },
        autocompleteOptions: this.options.autocompleteOptions || null
    });
    start.setMap(map);
    // on ajoute des écouteurs d'évènements (en plus de ceux de LocationSelector),
    // pour prendre en compte les CSS spécifiques de GProuteForm
    this._addFormPointsEventListeners(start);
    points.push(start._container);
    this._currentPoints.push(start);

    // points intermediaires
    for (count = 2; count < 7; count++) {
        var step = new _LocationSelector2.default({
            apiKey: this.options.apiKey || null,
            tag: {
                id: count,
                groupId: this._uid,
                label: "Etape",
                markerOpts: this.options.markersOpts["stages"],
                display: false,
                removeOption: true
            },
            autocompleteOptions: this.options.autocompleteOptions || null
        });
        step.setMap(map);
        this._addFormPointsEventListeners(step);
        points.push(step._container);
        this._currentPoints.push(step);
    }

    // point d'arrivée
    var end = new _LocationSelector2.default({
        apiKey: this.options.apiKey || null,
        tag: {
            id: count,
            groupId: this._uid,
            markerOpts: this.options.markersOpts["arrival"],
            label: "Arrivée",
            display: true,
            addOption: true
        },
        autocompleteOptions: this.options.autocompleteOptions || null
    });
    end.setMap(map);
    this._addFormPointsEventListeners(end);
    points.push(end._container);
    this._currentPoints.push(end);

    return points;
};

/**
 * Attach events listeners to route form points (locationSelector)
 *
 * @param {Object} formPoint - route form point (locationSelector)
 * @private
 */
Route.prototype._addFormPointsEventListeners = function (formPoint) {
    if (!formPoint) {
        return;
    }
    var context = this;
    if (formPoint._inputLabelContainer.addEventListener) {
        // display form on origin label click
        formPoint._inputLabelContainer.addEventListener("click", function () {
            context.onRouteOriginLabelClick.call(this, context);
        });
        // minimize form on input show pointer, and set map event listeners (see this.onRouteOriginPointerClick)
        formPoint._inputShowPointer.addEventListener("click", function () {
            context.onRouteOriginPointerClick.call(this, context, formPoint);
        });
        if (formPoint._removePointElement) {
            formPoint._removePointElement.addEventListener("click", function () {
                // Moving up exclusions picto
                var exclusionsPictoTop = context._showRouteExclusionsElement.style.top;
                context._showRouteExclusionsElement.style.top = (parseInt(exclusionsPictoTop, 10) - 33).toString() + "px";
            });
        }
        if (formPoint._addPointElement) {
            formPoint._addPointElement.addEventListener("click", function () {
                // Moving down exclusions picto
                var exclusionsPictoTop = context._showRouteExclusionsElement.style.top;
                context._showRouteExclusionsElement.style.top = (parseInt(exclusionsPictoTop, 10) + 33).toString() + "px";
            });
        }
    } else if (formPoint._inputLabelContainer.attachEvent) {
        // attachEvent: Internet explorer event listeners management
        formPoint._inputLabelContainer.attachEvent("onclick", function () {
            context.onRouteOriginLabelClick.call(this, context);
        });
        formPoint._inputShowPointer.attachEvent("onclick", function () {
            context.onRouteOriginPointerClick.call(this, context, formPoint);
        });
        if (formPoint._removePointElement) {
            formPoint._removePointElement.attachEvent("onclick", function () {
                // Moving up exclusions picto
                var exclusionsPictoTop = context._showRouteExclusionsElement.style.top;
                context._showRouteExclusionsElement.style.top = (parseInt(exclusionsPictoTop, 10) - 33).toString() + "px";
            });
        }
        if (formPoint._addPointElement) {
            formPoint._addPointElement.attachEvent("onclick", function () {
                // Moving down exclusions picto
                var exclusionsPictoTop = context._showRouteExclusionsElement.style.top;
                context._showRouteExclusionsElement.style.top = (parseInt(exclusionsPictoTop, 10) + 33).toString() + "px";
            });
        }
    }
};

// ################################################################### //
// ####################### handlers events to dom #################### //
// ################################################################### //

/**
 * this method is called by event 'submit' on 'GProuteForm' tag form
 * (cf. this._createRoutePanelFormElement), and it displays the results.
 *
 * @param {Object} options - options
 * @private
 */
Route.prototype.onRouteComputationSubmit = function (options) {
    logger.log("onRouteComputationSubmit", options);

    // FIXME on lance une requête en EPSG:4326, les coordonnées
    // doivent donc être du type cad en lat/lon.
    // or, BUG du service du calcul d'itineraire car les
    // coordonnées envoyées doivent être en lon/lat avec une SRS en EPSG:4326 !?
    // sinon, ça plante...

    // Liste des points
    var points = this._currentPoints;

    // - point de depart (info: points[0].getCoordinate est du type [lon, lat], en EPSG:4326)
    var start;
    if (points[0] && points[0].getCoordinate) {
        var startCoordinate = points[0].getCoordinate();
        start = {
            x: startCoordinate[0],
            y: startCoordinate[1]
        };
        logger.log("start", start);
    }

    // - point d'arrivée
    var end;
    var endPoint = points[points.length - 1];
    if (endPoint && endPoint.getCoordinate) {
        var endCoordinate = endPoint.getCoordinate();
        end = {
            x: endCoordinate[0],
            y: endCoordinate[1]
        };
        logger.log("end", end);
    }

    // - les étapes
    var step = [];
    for (var i = 1; i < points.length - 1; i++) {
        if (points[i] && points[i].getCoordinate) {
            var iCoordinate = points[i].getCoordinate();
            if (iCoordinate) {
                var coordinate = {
                    x: iCoordinate[0],
                    y: iCoordinate[1]
                };
                logger.log("step", coordinate);
                step.push(coordinate);
            }
        }
    }

    // oups, aucun droits !
    // on evite donc une requête inutile ...
    if (this._noRightManagement) {
        return;
    }

    // valeurs selectionnées
    this._currentTransport = options.transport;
    this._currentComputation = options.computation;
    this._currentExclusions = options.exclusions;

    // on recupere les éventuelles options du service passées par l'utilisateur
    var routeOptions = this.options.routeOptions;

    // gestion du protocole et du timeout
    // le timeout est indispensable sur le protocole JSONP.
    var _protocol = routeOptions.protocol || "XHR";
    var _timeout = routeOptions.timeOut || 0;
    if (_protocol === "JSONP" && _timeout === 0) {
        // FIXME le timeout est obligatoire pour ce type de protocole...
        _timeout = 15000;
    }

    // on met en place l'affichage des resultats dans la fenetre de resultats.
    var context = this;
    this._requestRouting({
        startPoint: start,
        endPoint: end,
        viaPoints: step,
        graph: routeOptions.graph || this._currentTransport,
        routePreference: routeOptions.routePreference || this._currentComputation,
        exclusions: routeOptions.exclusions || this._currentExclusions,
        geometryInInstructions: true,
        distanceUnit: "m",
        timeOut: _timeout,
        protocol: _protocol,
        // callback onSuccess
        onSuccess: function onSuccess(results) {
            logger.log(results);
            if (results) {
                context._fillRouteResultsDetails(results);
            }
        },
        // callback onFailure
        onFailure: function onFailure(error) {
            context._hideWaitingContainer();
            context._clearRouteResultsDetails();
            logger.log(error.message);
        }
    });
};

/**
 * this method is called by event 'click' on 'GPlocationOriginLabel' label
 * and set 'GProuteForm' CSS class to "" (normal)
 *
 * @param {Object} routeControl - context : route Control (this)
 * @private
 */
Route.prototype.onRouteOriginLabelClick = function (routeControl) {
    var map = routeControl.getMap();
    routeControl._formRouteContainer.className = "";
    // on désactive l'écouteur d'événements sur la carte (pour ne pas placer un marker au clic)
    map.un("click", function () {
        // on ne rétablit pas le mode "normal" si on est dans le panel des résultats (où className = "GProuteComponentHidden")
        if (routeControl._formRouteContainer.className === "GProuteFormMini") {
            routeControl._formRouteContainer.className = "";
        }
    });
};

/**
 * this method is called by event 'click' on 'GPlocationOriginPointerImg' label
 * and display or minimize 'GProuteForm', using CSS class ("GProuteFormMini" or "")
 *
 * @param {Object} routeControl - context : route Control (equivalent to this)
 * @param {Object} locationSelector - context : locationSelector input (one of this._currentPoints)
 * @private
 */
Route.prototype.onRouteOriginPointerClick = function (routeControl, locationSelector) {
    var map = routeControl.getMap();
    if (locationSelector._inputShowPointerContainer.checked) {
        // au click sur l'input pour pointer sur la carte: on minimise le formulaire
        routeControl._formRouteContainer.className = "GProuteFormMini";
        // et au clic sur la carte, on réaffichera le formulaire "normal"
        map.on("click", function () {
            // on ne rétablit pas le mode "normal" si on est dans le panel des résultats (où className = "GProuteComponentHidden")
            if (routeControl._formRouteContainer.className === "GProuteFormMini") {
                routeControl._formRouteContainer.className = "";
            }
        });
    } else {
        // si on déselectionne le pointer, on rétablit le formulaire en mode normal
        routeControl._formRouteContainer.className = "";
        // et on enlève l'écouteur d'évènement sur la carte
        map.un("click", function () {
            // on ne rétablit pas le mode "normal" si on est dans le panel des résultats (où className = "GProuteComponentHidden")
            if (routeControl._formRouteContainer.className === "GProuteFormMini") {
                routeControl._formRouteContainer.className = "";
            }
        });
    }
};

/**
 * this method is called by event 'click' on 'GPshowRoutePicto'
 * tag label (cf. this._createShowRoutePictoElement),
 * and it cleans all value of input.
 *
 * @private
 */
Route.prototype.onShowRoutePanelClick = function () {
    // clean !
    if (!this._geojsonSections && !this._waiting) {
        this._clear();
    }
    this.collapsed = document.getElementById("GPshowRoute-" + this._uid).checked;
    // on génère nous même l'evenement OpenLayers de changement de pté
    // (utiliser ol.control.Route.on("change:collapsed", function ) pour s'abonner à cet évènement)
    this.dispatchEvent("change:collapsed");
};

/**
 * this method is called by event 'change' on 'GProuteComputationSelect' tag select
 * (cf. this._createRoutePanelFormModeChoiceComputeElement).
 * this value is saved as a parameter for the service route.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Route.prototype.onRouteModeComputationChange = function (e) {
    var idx = e.target.selectedIndex;
    var value = e.target.options[idx].value;

    if (!value) {
        return;
    }

    logger.log(value);
    this._currentComputation = value;
};

/**
 * this method is called by event 'change' on 'GProuteResultsComputationSelect' tag select
 * (cf. this._createRouteResultsElement).
 * this value is saved as a parameter for the service route,
 * and this launches the route request !
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Route.prototype.onRouteModeComputationChangeAndRun = function (e) {
    // event choice computation
    this.onRouteModeComputationChange(e);

    // clean avant un nouveau calcul !
    this._clearRouteResultsDetails();
    this._clearRouteResultsGeometry();
    this._clearRouteResultsFeatureGeometry();

    // submit request
    this.onRouteComputationSubmit({
        computation: this._currentComputation,
        transport: this._currentTransport,
        exclusions: this._currentExclusions
    });
};

/**
 * this method is called by event 'change' on 'GProuteTransportCar' or 'GProuteTransportPedestrian' tag input
 * (cf. this._createRoutePanelFormModeChoiceTransportElement).
 * this value is saved as a parameter for the service route.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Route.prototype.onRouteModeTransportChange = function (e) {
    var value = e.target.value;
    if (!value) {
        return;
    }
    this._currentTransport = value;
};

/**
 * TODO this method is called by event 'click' on 'GPshowRouteExclusionsPicto' tag input
 * (cf. this._createShowRouteExclusionsPictoElement), and it displays the panel options of exclusions.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Route.prototype.onShowRouteExclusionsClick = function (e) {
    logger.log("onShowRouteExclusionsClick", e);
    // FIXME not use ?!
};

/**
 * this method is called by event 'change' on 'GProuteExclusionsToll'
 * or 'GProuteExclusionsTunnel' or 'GProuteExclusionsBridge' tag input
 * (cf. this._createRoutePanelFormExclusionOptionsElement).
 * this value is saved as a parameter for the service route.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Route.prototype.onRouteExclusionsChange = function (e) {
    var value = e.target.value;
    var checked = e.target.checked;

    if (!value || typeof value !== "string") {
        return;
    }
    value = value.toLowerCase();

    var bFound = false;
    var iFound = null;
    for (var i = 0; i < this._currentExclusions.length; i++) {
        if (this._currentExclusions[i] === value) {
            iFound = i;
            bFound = true;
        }
    }
    // on l'ajoute si la valeur n'existe pas et est déselectionnée
    // info : checked = passage autorisé (ce n'est pas une exclusion)
    if (!bFound && !checked) {
        this._currentExclusions.push(value);
    }
    // on la retire si la valeur existe et est selectionnée
    if (bFound && checked) {
        this._currentExclusions.splice(iFound, 1);
    }
};

/**
 * this method is called by event 'click' on 'GProuteReset'
 * tag label (cf. this._createRouteFormResetElement),
 * and it cleans all route input options and results.
 *
 * @private
 */
Route.prototype.onRouteResetClick = function () {
    // clear points
    var currentPoints = this._currentPoints;
    for (var i = 0; i < currentPoints.length; i++) {
        currentPoints[i].clear();
    }

    // clear results
    this._clear();

    this._clearRouteInputOptions();
};

/**
 * this method is called by event 'click' on 'GProuteSubmit'
 * tag label (cf. this._createRouteSubmitFormElement),
 * and it cleans the route geometry.
 *
 * @private
 */
Route.prototype.onShowRouteResultsNewClick = function () {
    // clean avant un nouveau calcul !
    this._clearRouteResultsDetails();
    this._clearRouteResultsGeometry();
    this._clearRouteResultsFeatureGeometry();
};

/**
 * this method is called by event 'mouseover' on 'GProuteResultsDetailsInstruction_'
 * tag label (cf. this._addRouteResultsDetailsElement),
 * and it makes a style on feature route.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Route.prototype.onRouteResultsDetailsMouseOver = function (e) {
    // récupération de l'id de l'instruction survolée
    var tagid = e.target.id; // ex GProuteResultsDetailsInstruction_125
    var idx = tagid.substring(tagid.indexOf("_") + 1); // ex. 125

    // on passe le texte en gras
    if (e.target.classList) {
        e.target.classList.add("GProuteResultsDetailsInstructionHighlight");
    }

    if (!this._geojsonSections) {
        return;
    }

    // on récupère l'entité correspondante à l'instruction survolée
    var f = this._geojsonSections.getSource().getFeatureById(parseInt(idx, 10));
    // et on lui affecte un nouveau style
    f.setStyle(this._selectedFeatureStyle);
};

/**
 * this method is called by event 'mouseout' on 'GProuteResultsDetailsInstruction_'
 * tag label (cf. this._addRouteResultsDetailsElement),
 * and it deletes a style on feature route.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Route.prototype.onRouteResultsDetailsMouseOut = function (e) {
    // récupération de l'id de l'instruction survolée
    var tagid = e.target.id; // ex GProuteResultsDetailsInstruction_125
    var idx = tagid.substring(tagid.indexOf("_") + 1); // ex. 125

    // on repasse le texte en style normal
    if (e.target.classList) {
        e.target.classList.remove("GProuteResultsDetailsInstructionHighlight");
    }

    if (!this._geojsonSections) {
        return;
    }
    // on récupère l'entité correspondante à l'instruction qui était survolée
    var f = this._geojsonSections.getSource().getFeatureById(parseInt(idx, 10));
    // et on lui réaffecte un style normal
    f.setStyle(null);
};

// ################################################################### //
// ########################### Routing ############################### //
// ############## (methods to request and results) ################### //

/**
 * this method is called by this.onRouteComputationSubmit()
 * and executes a request to the service.
 *
 * @param {Object} options - route service request options
 * @param {Function} options.onSuccess - callback
 * @param {Function} options.onFailure - callback
 * @private
 */
Route.prototype._requestRouting = function (options) {
    // on ne fait pas de requête si on n'a pas renseigné de parametres !
    if (!options || (typeof options === "undefined" ? "undefined" : _typeof(options)) === "object" && Object.keys(options).length === 0) {
        return;
    }

    // on ne fait pas de requête si
    // - la parametre 'startPoint' est vide !
    if (!options.startPoint) {
        return;
    }
    // - la parametre 'endPoint' est vide !
    if (!options.endPoint) {
        return;
    }

    // on ne fait pas de requête si aucun droit !
    if (this._noRightManagement || !this._resources["Itineraire"]) {
        return;
    }

    // gestion des droits !
    var resources = this._resources["Itineraire"].resources;
    if (!resources || (typeof resources === "undefined" ? "undefined" : _typeof(resources)) === "object" && Object.keys(resources).length === 0) {
        return;
    }

    // gestion de la clef !
    var key = this._resources["Itineraire"]["key"];

    // la ressource donne elle des droits ?
    var bFound = false;
    for (var i = 0; i < resources.length; i++) {
        if (resources[i] === options.graph) {
            bFound = true;
        }
    }

    // on fait quoi ?
    if (!bFound) {
        logger.log("no rights for this service !?");
        return;
    }

    // cas où la clef API n'est pas renseignée dans les options du service,
    // on utilise celle de l'autoconf ou celle renseignée au niveau du controle
    options.apiKey = this.options.routeOptions.apiKey || this.options.apiKey || key;

    logger.log(options);

    // mise en place de la patience
    this._displayWaitingContainer();

    // appel du service de calcul d'itinéraires
    _gp2.default.Services.route(options);
};

/**
 * this method is called by this.onRouteComputationSubmit() (in case of route computation success)
 * and fills the container of the route instructions list, distance and time
 * information, also, constructs the geometry route.
 *
 * @param {Object} results - results of the route calculation
 *
 * @private
 */
Route.prototype._fillRouteResultsDetails = function (results) {
    // 1. Affichage des distances et durées
    var distance = results.totalDistance;
    var duration = results.totalTime;
    // Détails avec simplifications des troncons
    var instructions = this._simplifiedInstructions(results.routeInstructions);
    // var instructions = results.routeInstructions;

    if (instructions) {
        this._fillRouteResultsDetailsContainer(distance, duration, instructions);
    }

    // 2. Affichage des géométries
    // Geometrie simplifiée (si renseignée)
    var geometry = results.routeGeometry;
    if (geometry) {
        this._fillRouteResultsDetailsGeometry(geometry, this._defaultFeatureStyle);
    }

    // Geometries des tronçon (si renseignée)
    if (instructions && instructions[0].geometry) {
        this._fillRouteResultsDetailsFeatureGeometry(instructions, this._defaultFeatureStyle);
    }

    // 3. Zoom sur l'emprise de l'itinéraire (si spécifiée)
    var bbox = results.bbox;
    if (bbox) {
        var map = this.getMap();
        var bounds = [bbox.left, bbox.bottom, bbox.right, bbox.top];
        // reprojection dans la projection de la carte (bbox initialement en EPSG:4326)
        var mapProj = map.getView().getProjection().getCode();
        if (mapProj !== "EPSG:4326") {
            bounds = _ol2.default.proj.transformExtent(bounds, "EPSG:4326", mapProj);
        }
        map.getView().fit(bounds, map.getSize());
    }

    // sauvegarde de l'etat des resultats
    this._currentRouteInformations = results;

    // mise à jour du controle !
    this._formRouteContainer.className = "GProuteComponentHidden";
    this._hideWaitingContainer();
    this._resultsRouteContainer.className = "";
};

/**
 * this method is called by this._fillRouteResultsDetails()
 * and fills the container of the route instructions list, distance and time
 * information.
 *
 * @param {Number} distance - distance
 * @param {Number} duration - duration
 * @param {Object[]} instructions - list of instructions
 *
 * @private
 */
Route.prototype._fillRouteResultsDetailsContainer = function (distance, duration, instructions) {
    // Distance et Durée
    this._resultsRouteValuesContainer = this._addRouteResultsValuesElement(distance, duration, this._convertSecondsToTime);

    // Détails
    this._resultsRouteDetailsContainer = this._addRouteResultsDetailsElement(instructions, this._convertSecondsToTime);
};

/**
 * this method is called by this._fillRouteResultsDetails()
 * and constructs the geometry route.
 *
 * @param {Object} geometry - geoJSON object for route geometry
 * @param {Object} style - route ol.style.Style object
 * @private
 */
Route.prototype._fillRouteResultsDetailsGeometry = function (geometry, style) {
    this._clearRouteResultsGeometry();

    var map = this.getMap();

    if (!geometry) {
        return;
    }

    // création de l'objet geoJSON
    var geojsonObject = {
        type: "Feature",
        crs: {
            type: "name",
            properties: {
                name: "EPSG:4326"
            }
        },
        geometry: geometry
    };
    var geojsonformat = new _ol2.default.format.GeoJSON({
        defaultDataProjection: "EPSG:4326"
    });
    var features = geojsonformat.readFeatures(geojsonObject, {
        dataProjection: "EPSG:4326",
        featureProjection: "EPSG:3857"
    });

    // ajout de la géométrie comme nouvelle couche vecteur à la carte
    this._geojsonRoute = new _ol2.default.layer.Vector({
        source: new _ol2.default.source.Vector({
            features: features
        }),
        style: style
    });
    map.addLayer(this._geojsonRoute);
};

/**
 * this method is called by this._fillRouteResultsDetails()
 * and constructs the geometries street with informations.
 *
 * @param {Array} instructions - route instructions list (containing geoJSON geometry)
 * @param {Object} style - route ol.style.Style object
 * @private
 */
Route.prototype._fillRouteResultsDetailsFeatureGeometry = function (instructions, style) {
    this._clearRouteResultsFeatureGeometry();

    var map = this.getMap();

    // 1. création de l'objet geoJSON
    var geojsonObject = {
        type: "FeatureCollection",
        crs: {
            type: "name",
            properties: {
                name: "EPSG:4326"
            }
        },
        features: []
    };

    // 2. Remplissage de l'objet geoJSON : ajout des géométries de chaque instruction
    for (var i = 0; i < instructions.length; i++) {
        var o = instructions[i];
        var id = i + 1;

        var coords = o.geometry.coordinates;
        for (var j = 0; j < coords.length; j++) {
            // remarque : les coordonnées sont au format string, à convertir en nombres
            if (typeof coords[j][0] === "string") {
                coords[j][0] = parseFloat(coords[j][0]);
                coords[j][1] = parseFloat(coords[j][1]);
            }
        }

        geojsonObject.features.push({
            type: "Feature",
            geometry: o.geometry,
            properties: {
                popupContent: "(" + id + ") distance : " + this._convertDistance(o.distance) + " / temps : " + this._convertSecondsToTime(o.duration)
            },
            id: id
        });
    }

    logger.log(geojsonObject);

    // Création du format GeoJSON, avec reprojection des géométries
    var geojsonformat = new _ol2.default.format.GeoJSON({
        defaultDataProjection: "EPSG:4326"
    });
    var mapProj = this.getMap().getView().getProjection().getCode();
    var features = geojsonformat.readFeatures(geojsonObject, {
        dataProjection: "EPSG:4326",
        featureProjection: mapProj
    });

    // 3. Ajout du tracé de l'itinéraire (geoJSON) comme nouvelle couche vecteur à la carte
    this._geojsonSections = new _ol2.default.layer.Vector({
        source: new _ol2.default.source.Vector({
            features: features
        }),
        style: style,
        opacity: 0.9
    });

    var graph;
    if (this._currentTransport === "Pieton") {
        graph = "piéton";
        this._geojsonSections.gpResultLayerId = "Pieton$OGC:OPENLS;Itineraire";
    } else {
        graph = "voiture";
        this._geojsonSections.gpResultLayerId = "Voiture$OGC:OPENLS;Itineraire";
    }
    // ajout à la carte
    map.addLayer(this._geojsonSections);

    // 4. Si un layer switcher est présent dans la carte, on lui affecte des informations pour cette couche
    map.getControls().forEach(function (control) {
        if (control instanceof _LayerSwitcher2.default) {
            // un layer switcher est présent dans la carte
            var layerId = this._geojsonSections.gpLayerId;
            // on n'ajoute des informations que s'il n'y en a pas déjà (si le titre est le numéro par défaut)
            if (control._layers[layerId].title === layerId) {
                control.addLayer(this._geojsonSections, {
                    title: this.options.layerDescription.title + " (" + graph + ")",
                    description: this.options.layerDescription.description
                });
            }
        }
    }, this);

    // 5. Ajout de popups aux troncons
    // Création de l'interaction : survol des features (=troncons de l'itinéraire)
    this._resultsHoverInteraction = new _ol2.default.interaction.Select({
        condition: _ol2.default.events.condition.pointerMove,
        layers: [this._geojsonSections],
        style: this._selectedFeatureStyle
    });
    this._resultsHoverInteraction.on("select", this._onResultsFeatureMouseOver, this);
    map.addInteraction(this._resultsHoverInteraction);

    // Création de l'interaction : selection des features (=troncons de l'itinéraire)
    this._resultsSelectInteraction = new _ol2.default.interaction.Select({
        layers: [this._geojsonSections],
        style: this._selectedFeatureStyle
    });
    this._resultsSelectInteraction.on("select", this._onResultsFeatureSelect, this);
    map.addInteraction(this._resultsSelectInteraction);
};

/**
 * this method is called on route features hover
 * and highlight instruction label
 *
 * @param {Object} e - event
 *
 * @private
 */
Route.prototype._onResultsFeatureMouseOver = function (e) {
    if (e.selected.length !== 0) {
        // si on a bien survolé un tronçon, on surligne l'instruction correspondante
        var f = e.selected[0];
        var selectedInstruction = document.getElementById("GProuteResultsDetailsInstruction_" + f.getId() + "-" + this._uid);
        if (selectedInstruction && selectedInstruction.classList) {
            selectedInstruction.classList.add("GProuteResultsDetailsInstructionHighlight");
        }
    }

    // si on déselectionne un tronçon (mouseout), on rétablit un style normal pour l'instruction
    if (e.deselected.length !== 0) {
        var deselectedFeature = e.deselected[0];
        // on repasse l'instruction correspondante en normal
        var deSelectedInstruction = document.getElementById("GProuteResultsDetailsInstruction_" + deselectedFeature.getId() + "-" + this._uid);
        if (deSelectedInstruction && deSelectedInstruction.classList) {
            deSelectedInstruction.classList.remove("GProuteResultsDetailsInstructionHighlight");
        }
    }
};

/**
 * this method is called on route features select
 * and set a popup with feature information
 *
 * @param {Object} e - on select event
 * @private
 */
Route.prototype._onResultsFeatureSelect = function (e) {
    var map = this.getMap();
    if (e.selected.length !== 0) {
        // si on a sélectionné un troncon, on lui ajoute une popup
        var f = e.selected[0];
        this._popupContent.innerHTML = f.getProperties().popupContent;

        if (!this._popupOverlay) {
            // ajout de la popup a la carte comme un overlay
            this._popupOverlay = new _ol2.default.Overlay({
                element: this._popupDiv,
                positioning: "bottom-center",
                position: e.mapBrowserEvent.coordinate
            });
            map.addOverlay(this._popupOverlay);
        } else {
            // si l'overlay est déjà créé, on modifie juste sa position
            this._popupOverlay.setPosition(e.mapBrowserEvent.coordinate);
        }
    } else {
        // si aucun troncon n'est sélectionné (click à côté du tracé),
        // on fait disparaitre la popup si elle existe
        if (this._popupOverlay != null) {
            this._popupOverlay.setPosition(undefined);
        }
    }
};

// ################################################################### //
// ############################# Clean ############################### //
// ################################################################### //

/**
 * this method is called by this.onShowRoutePanelClick()
 * and it clears all elements (reinit).
 *
 * @private
 */
Route.prototype._clear = function () {
    this._currentTransport = null;
    this._currentExclusions = [];
    this._currentComputation = null;

    // les resultats
    this._clearRouteResultsDetails();
    // la geometrie
    this._clearRouteResultsGeometry();
    this._clearRouteResultsFeatureGeometry();
    // les points
    for (var i = 0; i < this._currentPoints.length; i++) {
        this._currentPoints[i].clear();
    }
    // suppression des points intermédiaires
    this._removeRouteStepLocations();
};

/**
 * this method is called by this.onRouteResetClick()
 * and it clears all options inputs (reinit).
 *
 * @private
 */
Route.prototype._clearRouteInputOptions = function () {
    // reinit options to default
    this._initTransport();
    this._initComputation();
    this._initExclusions();

    // set transport mode to default
    var transportdiv;
    if (this._currentTransport === "Pieton") {
        transportdiv = document.getElementById("GProuteTransportPedestrian-" + this._uid);
        if (transportdiv) {
            transportdiv.checked = "true";
        }
    } else {
        transportdiv = document.getElementById("GProuteTransportCar-" + this._uid);
        if (transportdiv) {
            transportdiv.checked = "true";
        }
    }

    // set computation mode to default
    var computationdiv = document.getElementById("GProuteComputationSelect-" + this._uid);
    if (computationdiv) {
        computationdiv.value = this._currentComputation;
    }

    // set exclusions to default
    var tollInput = document.getElementById("GProuteExclusionsToll-" + this._uid);
    if (tollInput) {
        if (this._currentExclusions.indexOf("toll") !== -1) {
            tollInput.checked = false;
        } else {
            tollInput.checked = true;
        }
    }

    var tunnelInput = document.getElementById("GProuteExclusionsTunnel-" + this._uid);
    if (tunnelInput) {
        if (this._currentExclusions.indexOf("tunnel") !== -1) {
            tunnelInput.checked = false;
        } else {
            tunnelInput.checked = true;
        }
    }

    var bridgeInput = document.getElementById("GProuteExclusionsBridge-" + this._uid);
    if (bridgeInput) {
        if (this._currentExclusions.indexOf("bridge") !== -1 && bridgeInput) {
            bridgeInput.checked = false;
        } else {
            bridgeInput.checked = true;
        }
    }
};

/**
 * this method is called by this._clear()
 * and it removes step location inputs (excepted departure and arrival)
 *
 * @private
 */
Route.prototype._removeRouteStepLocations = function () {
    var points = document.querySelectorAll("div[id^=\"GPlocationPoint\"]");
    if (points.length !== 0) {
        // on boucle sur les points intermédiaires
        for (var i = 1; i < points.length - 1; i++) {
            // on va regarder les classes associées
            var classList = points[i].classList;
            if (classList.length !== 0) {
                for (var j = 0; j < classList.length; j++) {
                    if (classList[j] === "GPlocationStageFlexInput") {
                        // si l'élément est visible, on le supprime en simulant un clic sur la croix (x)
                        document.getElementById(this._addUID("GPlocationStageRemove_" + (i + 1))).click();
                    }
                }
            }
        }
    }
};

/**
 * this method is called by this.onRouteComputationSubmit() (in case of failure)
 * and it clears all route instructions.
 *
 * @private
 */
Route.prototype._clearRouteResultsDetails = function () {
    this._currentRouteInformations = null;

    // doit on nettoyer le container "GProuteResultsDetails" ?
    // il sera de toute façon écrasé par la prochaine requête...
    if (this._resultsRouteDetailsContainer) {
        var detailsDiv = this._resultsRouteDetailsContainer;
        if (detailsDiv.childElementCount) {
            while (detailsDiv.firstChild) {
                detailsDiv.removeChild(detailsDiv.firstChild);
            }
        }
    }

    if (this._resultsRouteValuesContainer) {
        var valuesDiv = this._resultsRouteValuesContainer;
        if (valuesDiv.childElementCount) {
            while (valuesDiv.firstChild) {
                valuesDiv.removeChild(valuesDiv.firstChild);
            }
        }
    }
};

/**
 * this method is called by this.onRouteComputationSubmit()
 * and it clears all route geometries.
 *
 * @private
 */
Route.prototype._clearRouteResultsGeometry = function () {
    var map = this.getMap();

    if (this._geojsonRoute != null) {
        map.removeLayer(this._geojsonRoute);
        this._geojsonRoute = null;
    }
};

/**
 * this method is called by this.onRouteComputationSubmit()
 * and it clears all route geometries.
 *
 * @private
 */
Route.prototype._clearRouteResultsFeatureGeometry = function () {
    var map = this.getMap();

    // on retire la couche itinéraire de la carte
    if (this._geojsonSections != null) {
        map.removeLayer(this._geojsonSections);
        this._geojsonSections = null;
    }
    // on retire l'overlay de la popup de la carte
    if (this._popupOverlay != null) {
        map.removeOverlay(this._popupOverlay);
        this._popupOverlay = null;
    }
    // et les interactions liées à cette couche
    if (this._resultsSelectInteraction != null) {
        map.removeInteraction(this._resultsSelectInteraction);
        this._resultsSelectInteraction = null;
    }
    if (this._resultsHoverInteraction != null) {
        map.removeInteraction(this._resultsHoverInteraction);
        this._resultsHoverInteraction = null;
    }
};

/**
 * this method is called by event 'click' on control main container
 * and hide suggested Locations (unless target is an autocomplete input)
 *
 * @param {Object} e - event
 *
 * @private
 */
Route.prototype._hideRouteSuggestedLocations = function (e) {
    // si on clique sur un input de saisie de locationSelector
    if (e.target && e.target.id && e.target.id.indexOf("GPlocationOrigin_") !== -1) {
        // on récupère le numéro du point
        var pointId = parseInt(e.target.id.split("_")[1][0], 10) - 1;
        // et on cache les autres résultats d'autocomplétion (sauf celui sur lequel on clique)
        for (var j = 0; j < this._currentPoints.length; j++) {
            if (j !== parseInt(pointId, 10)) {
                this._currentPoints[j]._hideSuggestedLocation();
            }
        }
    } else {
        // si on clique ailleurs dans le DOM du control, on cache tous les résultats d'autocomplétion
        for (var i = 0; i < this._currentPoints.length; i++) {
            this._currentPoints[i]._hideSuggestedLocation();
        }
    }
};

/**
 * this method displays waiting container and sets a timeout
 *
 * @private
 */
Route.prototype._displayWaitingContainer = function () {
    this._waitingContainer.className = "GProuteCalcWaitingContainerVisible";
    this._waiting = true;

    // mise en place d'un timeout pour réinitialiser le panel (cacher la patience)
    // si on est toujours en attente (si la requête est bloquée par exemple)
    // ceci est vrai, uniquement sur le protocole JSONP !
    var opts = this.options.routeOptions;
    if (opts && opts.timeOut) {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
        var context = this;
        this._timer = setTimeout(function () {
            if (context._waiting === true) {
                context._hideWaitingContainer();
            } else {
                if (context._timer) {
                    clearTimeout(context._timer);
                }
            }
        }, 16000);
    }
};

/**
 * this method hides waiting container and clears timeout
 *
 * @private
 */
Route.prototype._hideWaitingContainer = function () {
    if (this._waiting) {
        this._waitingContainer.className = "GProuteCalcWaitingContainerHidden";
        this._waiting = false;
        var opts = this.options.routeOptions;
        if (opts && opts.timeOut) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    }
};

// ################################################################### //
// ########################## Geometry ############################### //
// ################################################################### //

/**
 * simplified instructions
 *
 * @param {Object[]} instructions - list of instructions
 *
 * @returns {Object[]} simplified instructions
 *
 * @private
 */
Route.prototype._simplifiedInstructions = function (instructions) {
    var newInstructions = [];

    // cas où...
    var current = instructions[0];
    if (instructions.length === 1) {
        newInstructions.push(current);
    }

    for (var i = 1; i < instructions.length; i++) {
        var o = instructions[i];
        if (o.instruction === current.instruction) {
            current.distance = (parseFloat(o.distance) + parseFloat(current.distance)).toString();
            current.duration = (parseFloat(o.duration) + parseFloat(current.duration)).toString();
            for (var j = 1; j < o.geometry.coordinates.length; j++) {
                current.geometry.coordinates.push(o.geometry.coordinates[j]);
            }
        } else {
            newInstructions.push(current);
            current = o;
            // last
            if (i === instructions.length - 1) {
                newInstructions.push(o);
                current = null;
            }
        }
    }
    logger.log(newInstructions);
    return newInstructions;
};

// ################################################################### //
// ################# Utils for Distance/Duration ##################### //
// ################################################################### //

/**
 * convert seconds to time : HH:MM:SS
 *
 * @param {Number} duration - duration in seconds
 *
 * @returns {String} time in hours/minutes/seconds
 *
 * @private
 */
Route.prototype._convertSecondsToTime = function (duration) {
    var time = "";

    duration = Math.round(duration);
    var hours = Math.floor(duration / (60 * 60));

    var divisor4minutes = duration % (60 * 60);
    var minutes = Math.floor(divisor4minutes / 60);
    // if (!minutes) {
    //     minutes = "00";
    // }

    // var divisor4seconds = divisor4minutes % 60;
    // var seconds = Math.ceil(divisor4seconds);
    // if (!seconds) {
    //     seconds = "00";
    // }

    if (hours) {
        time = hours + "h ";
    }
    time += minutes + " min";
    return time;
};

/**
 * convert distance in meters or kilometers
 *
 * @param {Number} distance - distance in meters
 *
 * @returns {String} distance in km
 *
 * @private
 */
Route.prototype._convertDistance = function (distance) {
    var d = "";

    var distanceKm = parseInt(distance / 1000, 10);
    if (!distanceKm) {
        d = parseInt(distance, 10) + " m"; // arrondi !
    } else {
        d = distanceKm + " km";
    }

    return d;
};

exports.default = Route;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("LocationSelectorDOM");

var LocationSelectorDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.className = this._addUID("GPlocationPoint"); // ceci permet de gerer les groupes de points !
        container.className += " GPwidget";
        return container;
    },

    /**
     * Create Container Point
     * see event !
     *
     * @param {Number} id - tag ID
     * @param {Number} display  - display
     * @returns {DOMElement} DOM element
     */
    _createLocationPointElement: function _createLocationPointElement(id, display) {
        var div = document.createElement("div");
        div.id = this._addUID("GPlocationPoint_" + id);
        div.className = display ? "GPflexInput GPlocationStageFlexInput" : "GPflexInput GPlocationStageFlexInputHidden";
        div.style.cssText = "";

        return div;
    },

    /**
     * Create Container Point
     * see event !
     *
     * @param {Number} id - tag ID
     * @param {String} text - label
     * @returns {DOMElement} DOM element
     */
    _createLocationPointLabelElement: function _createLocationPointLabelElement(id, text) {
        // contexte d'execution
        var self = this;

        var labelOrigin = document.createElement("label");
        labelOrigin.id = this._addUID("GPlocationOriginLabel_" + id);
        labelOrigin.htmlFor = "GPlocationOrigin_" + id;
        labelOrigin.innerHTML = text;
        labelOrigin.addEventListener("click", function (e) {
            var i = _SelectorID2.default.index(this.id);
            var points = document.getElementsByClassName(self._addUID("GPlocationPoint"));
            for (var j = 0; j < points.length; j++) {
                var tag = points[j].childNodes[0].id;
                var id = _SelectorID2.default.index(tag);
                document.getElementById(self._addUID("GPlocationPoint_" + id)).style.cssText = "";
            }
            document.getElementById(self._addUID("GPlocationOriginCoords_" + i)).value = "";
            document.getElementById(self._addUID("GPlocationOrigin_" + i)).value = "";
            document.getElementById(self._addUID("GPlocationPoint_" + i)).style.cssText = "";
            document.getElementById(self._addUID("GPlocationOriginPointer_" + i)).checked = false;
            document.getElementById(self._addUID("GPlocationOrigin_" + i)).className = "GPlocationOriginVisible";
            document.getElementById(self._addUID("GPlocationOriginCoords_" + i)).className = "GPlocationOriginHidden";
            if (document.getElementById(self._addUID("GPlocationStageRemove_" + i))) {
                document.getElementById(self._addUID("GPlocationStageRemove_" + i)).className = "GPlocationStageRemove";
            }
            if (document.getElementById(self._addUID("GPlocationStageAdd"))) {
                document.getElementById(self._addUID("GPlocationStageAdd")).className = "";
            }
            // document.getElementById(self._addUID("GPlocationOriginCoords_" + i)).disabled = true;
            self.onLocationClearPointClick(e);
        });

        return labelOrigin;
    },

    /**
     * Create Input AutoComplete Point tag
     *
     * @param {Number} id - tag ID
     * @returns {DOMElement} DOM element
     */
    _createLocationAutoCompleteteInputElement: function _createLocationAutoCompleteteInputElement(id) {
        // contexte d'execution
        var self = this;

        var inputOrigin = document.createElement("input");
        inputOrigin.id = this._addUID("GPlocationOrigin_" + id);
        inputOrigin.className = "GPlocationOriginVisible";
        inputOrigin.type = "text";
        inputOrigin.placeholder = "Saisir une adresse";
        inputOrigin.autocomplete = "off";
        inputOrigin.addEventListener("keyup", function (e) {
            var charCode = e.which || e.keyCode;
            if (charCode === 13 || charCode === 10 || charCode === 38 || charCode === 40) {
                return;
            }

            var i = _SelectorID2.default.index(this.id);
            if (document.getElementById(self._addUID("GPlocationOrigin_" + i)).value.length > 2) {
                document.getElementById(self._addUID("GPlocationAutoCompleteList_" + i)).style.display = "block";
            } else {
                document.getElementById(self._addUID("GPlocationAutoCompleteList_" + i)).style.display = "none";
            }
            // gestionnaire d'evenement :
            // on récupère la valeur de saisie pour une requête sur le service d'autocompletion.
            // le resultat de la requête nous permet de recuperer les coordonnées du point...
            self.onAutoCompleteSearchText(e);
        });

        inputOrigin.addEventListener("keydown", function (e) {
            var charCode = e.which || e.keyCode;

            var container = document.getElementById(self._addUID("GPlocationAutoCompleteList_" + id));

            // si aucun container !?
            if (!container) {
                return;
            }

            var curr = container.getElementsByClassName("GPautoCompleteProposal current");
            var list = container.getElementsByClassName("GPautoCompleteProposal");

            // si aucune suggestion, on ne va pas plus loin !
            var length = list.length;
            if (!length) {
                return;
            }

            var current = null;

            // si aucun item courant, on prend le 1er !
            if (!curr.length) {
                current = list[0];
                current.className = "GPautoCompleteProposal current";
                current.style.color = "#000000";
                current.style["background-color"] = "#CEDBEF";
                return;
            } else {
                current = curr[0];
            }

            var index = parseInt(_SelectorID2.default.index(current.id), 10);
            var next = index === length - 1 ? list[0] : list[index + 1];
            var prev = index === 0 ? list[length - 1] : list[index - 1];

            current.style["background-color"] = "";
            current.style.color = "";
            prev.style["background-color"] = "";
            prev.style.color = "";
            next.style["background-color"] = "";
            next.style.color = "";

            switch (charCode) {
                case 38:
                    // arrow up
                    logger.log("arrow up");
                    current.className = "GPautoCompleteProposal";
                    prev.className = "GPautoCompleteProposal current";
                    prev.style.color = "#000000";
                    prev.style["background-color"] = "#CEDBEF";
                    break;
                case 40:
                    // arrow down
                    logger.log("arrow down");
                    current.className = "GPautoCompleteProposal";
                    next.className = "GPautoCompleteProposal current";
                    next.style.color = "#000000";
                    next.style["background-color"] = "#CEDBEF";
                    break;
                case 13:
                    // enter
                    logger.log("enter");
                    current.click(e);
                    break;
            }

            current.focus();
        });

        return inputOrigin;
    },

    /**
     * Create Input Coordinate Point tag
     *
     * @param {Number} id - tag ID
     * @returns {DOMElement} DOM element
     */
    _createLocationCoordinateInputElement: function _createLocationCoordinateInputElement(id) {
        // contexte d'execution
        var self = this;

        var inputOriginCoord = document.createElement("input");
        inputOriginCoord.id = this._addUID("GPlocationOriginCoords_" + id);
        inputOriginCoord.className = "GPlocationOriginHidden";
        inputOriginCoord.type = "text";
        inputOriginCoord.disabled = false;
        inputOriginCoord.addEventListener("click", function () {
            var i = _SelectorID2.default.index(this.id);
            document.getElementById(self._addUID("GPlocationOriginLabel_" + i)).click();
        });
        return inputOriginCoord;
    },

    /**
     * Create Show Pointer tag
     *
     * @param {Number} id - tag ID
     * @returns {DOMElement} DOM element
     */
    _createLocationPointerShowInputElement: function _createLocationPointerShowInputElement(id) {
        var inputOriginPointer = document.createElement("input");
        inputOriginPointer.id = this._addUID("GPlocationOriginPointer_" + id);
        inputOriginPointer.type = "checkbox";
        return inputOriginPointer;
    },

    /**
     * Create Input Pointer tag
     *
     * @param {Number} id - tag ID
     * @returns {DOMElement} DOM element
     */
    _createLocationPointerInputElement: function _createLocationPointerInputElement(id) {
        // contexte d'execution
        var self = this;

        var labelOriginPointer = document.createElement("label");
        labelOriginPointer.id = this._addUID("GPlocationOriginPointerImg_" + id);
        labelOriginPointer.htmlFor = "GPlocationOriginPointer_" + id;
        labelOriginPointer.className = "GPlocationOriginPointerImg";
        labelOriginPointer.title = "Pointer un lieu sur la carte";
        labelOriginPointer.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var i = _SelectorID2.default.index(this.id);
            var points = document.getElementsByClassName(self._addUID("GPlocationPoint"));
            var j;
            var tag;
            var id;
            for (j = 0; j < points.length; j++) {
                tag = points[j].childNodes[0].id;
                id = _SelectorID2.default.index(tag);
                if (i !== id) {
                    document.getElementById(self._addUID("GPlocationOriginPointer_" + id)).checked = false;
                    if (document.getElementById(self._addUID("GPlocationOriginCoords_" + id)).value === "Pointer un lieu sur la carte") {
                        document.getElementById(self._addUID("GPlocationOriginCoords_" + id)).value = "";
                        document.getElementById(self._addUID("GPlocationOrigin_" + id)).className = "GPlocationOriginVisible";
                        document.getElementById(self._addUID("GPlocationOriginCoords_" + id)).className = "GPlocationOriginHidden";
                    }
                }
            }
            if (document.getElementById(self._addUID("GPlocationOriginPointer_" + i)).checked) {
                document.getElementById(self._addUID("GPlocationOriginCoords_" + i)).value = "";
                for (j = 0; j < points.length; j++) {
                    tag = points[j].childNodes[0].id;
                    id = _SelectorID2.default.index(tag);
                    document.getElementById(self._addUID("GPlocationPoint_" + id)).style.cssText = "";
                }
                if (document.getElementById(self._addUID("GPlocationStageRemove_" + i))) {
                    document.getElementById(self._addUID("GPlocationStageRemove_" + i)).className = "GPlocationStageRemove";
                }
                if (document.getElementById(self._addUID("GPlocationStageAdd"))) {
                    document.getElementById(self._addUID("GPlocationStageAdd")).className = "";
                }
                document.getElementById(self._addUID("GPlocationOriginPointer_" + i)).checked = false;
                document.getElementById(self._addUID("GPlocationOrigin_" + i)).className = "GPlocationOriginVisible";
                document.getElementById(self._addUID("GPlocationOriginCoords_" + i)).className = "GPlocationOriginHidden";
            } else {
                document.getElementById(self._addUID("GPlocationOriginCoords_" + i)).value = "Pointer un lieu sur la carte";
                for (j = 0; j < points.length; j++) {
                    tag = points[j].childNodes[0].id;
                    id = _SelectorID2.default.index(tag);
                    if (i === id) {
                        document.getElementById(self._addUID("GPlocationPoint_" + id)).style.cssText = "";
                    } else {
                        document.getElementById(self._addUID("GPlocationPoint_" + id)).style.display = "none";
                    }
                }
                if (document.getElementById(self._addUID("GPlocationStageRemove_" + i))) {
                    document.getElementById(self._addUID("GPlocationStageRemove_" + i)).className = "GPlocationOriginHidden";
                }
                if (document.getElementById(self._addUID("GPlocationStageAdd"))) {
                    document.getElementById(self._addUID("GPlocationStageAdd")).className = "GPlocationOriginHidden";
                }
                document.getElementById(self._addUID("GPlocationOriginPointer_" + i)).checked = true;
                document.getElementById(self._addUID("GPlocationOrigin_" + i)).className = "GPlocationOriginHidden";
                document.getElementById(self._addUID("GPlocationOriginCoords_" + i)).className = "GPlocationOriginVisible";
                document.getElementById(self._addUID("GPlocationOriginCoords_" + i)).disabled = true;
            }
            // gestionnaire d'evenement :
            // on stocke la valeur du point, utilisée pour la requête sur le service de calcul d'itiniraire
            self.onActivateMapPointClick(e);
        });

        return labelOriginPointer;
    },

    /**
     * Create Remove Point tag
     * see event !
     *
     * @param {Number} id - tag ID
     * @returns {DOMElement} DOM element
     */
    _createLocationRemovePointElement: function _createLocationRemovePointElement(id) {
        // contexte d'execution
        var self = this;

        var divRm = document.createElement("div");
        divRm.id = this._addUID("GPlocationStageRemove_" + id);
        divRm.className = "GPlocationStageRemove";
        divRm.title = "Supprimer l'étape";
        divRm.addEventListener("click", function (e) {
            var points = document.getElementsByClassName(self._addUID("GPlocationPoint"));
            var last = points.length - 1;
            var start = points[0].childNodes[0].id;
            var end = points[last].childNodes[0].id;

            var startID = _SelectorID2.default.index(start);
            var endID = _SelectorID2.default.index(end);

            if (id !== startID && id !== endID) {
                var i = _SelectorID2.default.index(this.id);
                document.getElementById(self._addUID("GPlocationPoint_" + i)).className = "GPflexInput GPlocationStageFlexInputHidden";
                document.getElementById(self._addUID("GPlocationOrigin_" + i)).value = "";
                document.getElementById(self._addUID("GPlocationOrigin_" + i)).className = "GPlocationOriginVisible";
                document.getElementById(self._addUID("GPlocationOriginCoords_" + i)).value = "";
                document.getElementById(self._addUID("GPlocationOriginCoords_" + i)).className = "GPlocationOriginHidden";
                document.getElementById(self._addUID("GPlocationStageAdd")).style.display = "";
                // Moving up exclusions picto
                // var exclusionsPictoTop = document.getElementById(self._addUID("GPshowLocationExclusionsPicto")).style.top;
                // document.getElementById(self._addUID("GPshowLocationExclusionsPicto")).style.top = (parseInt(exclusionsPictoTop) - 33).toString() + "px";

                // gestionnaire d'evenement :
                // on supprime le point, utilisé pour la requête sur le service d'itiniraire
                self.onLocationRemovePointClick(e);
            }
        });

        return divRm;
    },

    /**
     * Create Add Point tag
     * see event !
     *
     * @returns {DOMElement} DOM element
     */
    _createLocationAddPointElement: function _createLocationAddPointElement() {
        // contexte d'execution
        var self = this;

        var divAdd = document.createElement("div");
        divAdd.id = this._addUID("GPlocationStageAdd");
        divAdd.title = "Ajouter une étape";
        divAdd.addEventListener("click", function (e) {
            var lastStage = 1;
            var nbStages = 0;
            var points = document.getElementsByClassName(self._addUID("GPlocationPoint"));
            for (var i = 1; i < points.length - 1; i++) {
                var tag = points[i].childNodes[0].id;
                var id = _SelectorID2.default.index(tag);
                if (document.getElementById(self._addUID("GPlocationPoint_" + id))) {
                    if (document.getElementById(self._addUID("GPlocationPoint_" + id)).className === "GPflexInput GPlocationStageFlexInputHidden") {
                        if (lastStage === 1) {
                            lastStage = id;
                        }
                    } else {
                        nbStages++;
                    }
                }
            }
            // FIXME algo à revoir : lastStage = id hors si id = 300 sur 3 points !?
            if (lastStage < points.length) {
                document.getElementById(self._addUID("GPlocationPoint_" + lastStage)).className = "GPflexInput GPlocationStageFlexInput";
                // Moving down exclusions picto
                // var exclusionsPictoTop = document.getElementById(self._addUID("GPshowLocationExclusionsPicto")).style.top;
                // document.getElementById(self._addUID("GPshowLocationExclusionsPicto")).style.top = (parseInt(exclusionsPictoTop) + 33).toString() + "px";
            }
            if (nbStages === 4) {
                document.getElementById(self._addUID("GPlocationStageAdd")).style.display = "none";
            }
            // gestionnaire d'evenement :
            // on ajoute le point, utilisé pour la requête sur le service d'itiniraire
            self.onLocationAddPointClick(e);
        });

        return divAdd;
    },

    /**
     * Create Results autocompletion to the point
     * see event!
     *
     * @param {Number} id - tag ID
     * @returns {DOMElement} DOM element
     */
    _createLocationAutoCompleteResultElement: function _createLocationAutoCompleteResultElement(id) {
        // contexte d'execution
        var self = this;

        var div = document.createElement("div");
        div.id = this._addUID("GPlocationAutoCompleteList_" + id);
        div.className = "GPadvancedAutoCompleteList";

        if (div.addEventListener) {
            div.addEventListener("click", function (e) {
                self.onAutoCompletedResultsItemClick(e);
                document.getElementById(self._addUID("GPlocationAutoCompleteList_" + id)).style.display = "none";
            }, false);
        } else if (div.attachEvent) {
            div.attachEvent("onclick", function (e) {
                self.onAutoCompletedResultsItemClick(e);
                document.getElementById(self._addUID("GPlocationAutoCompleteList_" + id)).style.display = "none";
            });
        }

        return div;
    },

    /**
     * Autocompletion result to a point.
     * Proposals are dynamically filled in Javascript by autocomplete service
     *
     * TODO formaliser le contenu des reponse
     *
     * @param {Number} id - tag ID
     * @param {Object} location - suggested location result
     * @param {Number} n  - number of the point
     */
    _createLocationAutoCompletedLocationElement: function _createLocationAutoCompletedLocationElement(id, location, n) {
        var container = document.getElementById(this._addUID("GPlocationAutoCompleteList_" + id));

        var div = document.createElement("div");
        div.id = this._addUID("AutoCompletedLocation_" + n);
        div.className = "GPautoCompleteProposal";
        div.innerHTML = location.fullText;

        container.appendChild(div);
    },

    /**
    * Display Coordinate
    * @param {String} value - a Coordinate
    */
    GPdisplayCoordinate: function GPdisplayCoordinate(value) {
        var points = document.getElementsByClassName(this._addUID("GPlocationPoint"));
        for (var i = 0; i < points.length; i++) {
            var tag = points[i].childNodes[0].id;
            var id1 = _SelectorID2.default.index(tag);
            if (document.getElementById(this._addUID("GPlocationOriginPointer_" + id1)).checked) {
                document.getElementById(this._addUID("GPlocationOriginCoords_" + id1)).value = value;
                document.getElementById(this._addUID("GPlocationOriginCoords_" + id1)).disabled = false;
                for (var j = 0; j < points.length; j++) {
                    tag = points[j].childNodes[0].id;
                    var id2 = _SelectorID2.default.index(tag);
                    document.getElementById(this._addUID("GPlocationPoint_" + id2)).style.cssText = "";
                    if (document.getElementById(this._addUID("GPlocationStageRemove_" + id2))) {
                        document.getElementById(this._addUID("GPlocationStageRemove_" + id2)).className = "GPlocationStageRemove";
                    }
                }
                document.getElementById(this._addUID("GPlocationOriginPointer_" + id1)).checked = false;
                if (document.getElementById(this._addUID("GPlocationStageAdd"))) {
                    document.getElementById(this._addUID("GPlocationStageAdd")).className = "";
                }
                return;
            }
        }
    }
};

exports.default = LocationSelectorDOM;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("RouteDOM");

var RouteDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GProute");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################# Methods to display Main Panel ################### //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing panel
     *
     * @returns {DOMElement} DOM element
     */
    _createShowRouteElement: function _createShowRouteElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowRoute");
        input.type = "checkbox";
        return input;
    },

    /**
     * Show route control
     * see event !
     *
     * @returns {DOMElement} DOM element
     */
    _createShowRoutePictoElement: function _createShowRoutePictoElement() {
        // contexte d'execution
        var context = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowRoutePicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowRoute");
        label.title = "Ouvrir le calcul d'itinéraire";

        // gestionnaire d'evenement :
        // on ouvre le menu de saisie du calcul d'itiniraire
        // L'ouverture/Fermeture permet de faire le menage
        // (reinitialisation)
        if (label.addEventListener) {
            label.addEventListener("click", function (e) {
                context.onShowRoutePanelClick(e);
            });
        } else if (label.attachEvent) {
            label.attachEvent("onclick", function (e) {
                context.onShowRoutePanelClick(e);
            });
        }

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowRouteOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    },

    // ################################################################### //
    // ################## Methods to display Inputs Panel ################ //
    // ################################################################### //

    /**
     * Create Container Panel
     *
     * FIXME
     * don't call this._createRoutePanelHeaderElement
     * don't call this._createRoutePanelFormElement
     * don't call this._createRoutePanelResultsElement
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelElement: function _createRoutePanelElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GProutePanel");
        div.className = "GPpanel";

        // div.appendChild(this._createRoutePanelHeaderElement());
        // div.appendChild(this._createRoutePanelFormElement());
        // div.appendChild(this._createRoutePanelResultsElement());

        return div;
    },

    /**
     * Create Header Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelHeaderElement: function _createRoutePanelHeaderElement() {
        // contexte d'execution
        var self = this;

        var container = document.createElement("div");
        container.className = "GPpanelHeader";

        var div = document.createElement("div");
        div.className = "GPpanelTitle";
        div.innerHTML = "Calcul d'itinéraire";
        container.appendChild(div);

        var divClose = document.createElement("div");
        divClose.id = this._addUID("GProutePanelClose");
        divClose.className = "GPpanelClose";
        divClose.title = "Masquer le panneau";

        // Link panel close / visibility checkbox
        if (divClose.addEventListener) {
            divClose.addEventListener("click", function () {
                document.getElementById(self._addUID("GPshowRoutePicto")).click();
            }, false);
        } else if (divClose.attachEvent) {
            divClose.attachEvent("onclick", function () {
                document.getElementById(self._addUID("GPshowRoutePicto")).click();
            });
        }
        container.appendChild(divClose);

        return container;
    },

    /**
     * Create Form
     * see evenement !
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelFormElement: function _createRoutePanelFormElement() {
        // contexte d'execution
        var self = this;

        var form = document.createElement("form");
        form.id = this._addUID("GProuteForm");
        form.setAttribute("onkeypress", "return event.keyCode != 13;"); // FIXME hack pour desactiver l'execution via 'enter' au clavier !

        form.addEventListener("submit", function (e) {
            logger.log(e);
            e.preventDefault();

            // points
            var points = document.getElementsByClassName(self._addUID("GPlocationPoint"));

            // Must have at least two origin points
            var start = points[0].childNodes[0].id;
            var end = points[points.length - 1].childNodes[0].id;
            var startID = _SelectorID2.default.index(start);
            var endID = _SelectorID2.default.index(end);

            if (document.getElementById(self._addUID("GPlocationOrigin_" + startID)).value === "" && document.getElementById(self._addUID("GPlocationOriginCoords_" + startID)).value === "" || document.getElementById(self._addUID("GPlocationOrigin_" + endID)).value === "" && document.getElementById(self._addUID("GPlocationOriginCoords_" + endID)).value === "") {
                return false;
            }

            // Send stages to results panel
            var id;
            document.getElementById(self._addUID("GProuteResultsStages")).innerHTML = "";
            for (var i = 0; i < points.length; i++) {
                var tag = points[i].childNodes[0].id;
                id = _SelectorID2.default.index(tag);
                if (document.getElementById(self._addUID("GPlocationPoint_" + id)).className === "GPflexInput GPlocationStageFlexInput") {
                    var resultStage = document.createElement("div");
                    resultStage.className = "GProuteResultsStages";
                    var resultStageLabel = document.createElement("div");
                    resultStageLabel.className = "GProuteResultStageLabel";
                    resultStageLabel.innerHTML = document.getElementById(self._addUID("GPlocationOriginLabel_" + id)).innerHTML + " :";
                    resultStage.appendChild(resultStageLabel);
                    var resultStageValue = document.createElement("div");
                    resultStageValue.className = "GProuteResultStageValue";
                    var elementCoords = document.getElementById(self._addUID("GPlocationOriginCoords_" + id));
                    var stageCoords = elementCoords.value;
                    var visible = elementCoords.className === "GPlocationOriginVisible";
                    if (stageCoords !== null && stageCoords !== "" && visible) {
                        resultStageValue.innerHTML = stageCoords;
                    } else {
                        resultStageValue.innerHTML = document.getElementById(self._addUID("GPlocationOrigin_" + id)).value;
                    }
                    resultStage.appendChild(resultStageValue);
                    if (resultStageValue.innerHTML !== "") {
                        document.getElementById(self._addUID("GProuteResultsStages")).appendChild(resultStage);
                    }
                }
            }

            // on peut récuperer les valeurs utiles pour les transmettre au service d'iti...
            // - le mode de calcul
            // - le mode de transport
            // - les exclusions
            // Les points sont déjà stockés dans l'application.

            // computation mode params
            var modeComputation = null;
            if (document.getElementById(self._addUID("GProuteComputationSelect"))) {
                var select = document.getElementById(self._addUID("GProuteResultsComputationSelect"));
                select.selectedIndex = document.getElementById(self._addUID("GProuteComputationSelect")).selectedIndex;
                modeComputation = select.options[select.selectedIndex].value;
            }

            // transport mode params
            var modeTransport = null;
            // voiture ?
            if (document.getElementById(self._addUID("GProuteTransportCar"))) {
                if (document.getElementById(self._addUID("GProuteTransportCar")).checked) {
                    modeTransport = document.getElementById(self._addUID("GProuteTransportCar")).value;
                }
            }
            // pieton ?
            if (document.getElementById(self._addUID("GProuteTransportPedestrian"))) {
                if (document.getElementById(self._addUID("GProuteTransportPedestrian")).checked) {
                    modeTransport = document.getElementById(self._addUID("GProuteTransportPedestrian")).value;
                }
            }

            // exclusions params
            var exclusions = [];
            var exclusionsElement = document.getElementsByClassName("GProuteExclusionsOption");
            for (var j = 0; j < exclusionsElement.length; j++) {
                id = exclusionsElement[j].htmlFor;
                var el = document.getElementById(id);
                if (!el.checked) {
                    exclusions.push(el.value);
                }
            }

            self.onRouteComputationSubmit({
                computation: modeComputation,
                transport: modeTransport,
                exclusions: exclusions
            });

            // FIXME mise à jour du controle dans le composant JS !
            // document.getElementById(self._addUID("GProuteForm")).className = "GProuteComponentHidden";
            // document.getElementById(self._addUID("GProuteResultsPanel")).className = "";

            return false;
        });

        return form;
    },

    /**
     * Create Results Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelResultsElement: function _createRoutePanelResultsElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GProuteResultsPanel");
        container.className = "GProuteComponentHidden";

        container.appendChild(this._createRouteResultsStagesElement());
        container.appendChild(this._createRouteResultsElement());

        var divBorderUp = document.createElement("div");
        divBorderUp.className = "GPfakeBorder GPfakeBorderLeft";
        container.appendChild(divBorderUp);

        container.appendChild(this._createRouteShowResultsDetailsElement());

        var labelShow = document.createElement("label");
        labelShow.htmlFor = this._addUID("GProuteResultsShowDetails");
        labelShow.innerHTML = "Afficher le détail";
        container.appendChild(labelShow);

        var labelHide = document.createElement("label");
        labelHide.htmlFor = this._addUID("GProuteResultsShowDetails");
        labelHide.innerHTML = "Masquer le détail";
        container.appendChild(labelHide);

        var divBorderDown = document.createElement("div");
        divBorderDown.className = "GPfakeBorder";
        container.appendChild(divBorderDown);

        container.appendChild(this._createRouteResultsDetailsElement());

        return container;
    },

    /**
     * Create Waiting Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createRouteWaitingElement: function _createRouteWaitingElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GProuteCalcWaitingContainer");
        div.className = "GProuteCalcWaitingContainerHidden";

        var p = document.createElement("p");
        p.className = "GProuteCalcWaiting";
        p.innerHTML = "Calcul en cours...";

        div.appendChild(p);

        return div;
    },
    // ################################################################### //
    // ############### Methods to the window results ##################### //
    // ################################################################### //

    /**
     * Create Results Stages
     * (results dynamically generate !)
     *
     * @returns {DOMElement} DOM element
     */
    _createRouteResultsStagesElement: function _createRouteResultsStagesElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GProuteResultsStages");
        return div;
    },

    /**
     * Create Show Results
     * see event!
     *
     * @returns {DOMElement} DOM element
     */
    _createRouteResultsElement: function _createRouteResultsElement() {
        // contexte
        var self = this;

        var container = document.createElement("div");
        container.id = this._addUID("GProuteResults");

        // FIXME Route results are dynamically filled in Javascript by route service
        var divValue = document.createElement("div");
        divValue.id = this._addUID("GProuteResultsValues");
        container.appendChild(divValue);

        var divMode = document.createElement("div");
        divMode.id = this._addUID("GProuteResultsMode");

        var select = document.createElement("select");
        select.id = this._addUID("GProuteResultsComputationSelect");
        select.className = "GPinputSelect";
        // gestionnaire d'evenement :
        // on stocke la valeur du mode de calcul, et on relance le calcul d'itiniraire
        select.addEventListener("change", function (e) {
            self.onRouteModeComputationChangeAndRun(e);
        });

        var computes = [{
            code: "fastest",
            label: "Plus rapide"
        }, {
            code: "shortest",
            label: "Plus court"
        }];

        for (var i = 0; i < computes.length; i++) {
            var option = document.createElement("option");
            option.value = computes[i].code;
            option.text = computes[i].label;
            select.appendChild(option);
        }
        divMode.appendChild(select);
        container.appendChild(divMode);

        var divNew = document.createElement("div");
        divNew.id = this._addUID("GProuteResultsNew");
        divNew.title = "Modifier le calcul";
        divNew.addEventListener("click", function (e) {
            document.getElementById(self._addUID("GProuteResultsPanel")).className = "GProuteComponentHidden";
            document.getElementById(self._addUID("GProuteForm")).className = "";
            self.onShowRouteResultsNewClick(e);
        });
        container.appendChild(divNew);

        return container;
    },

    /**
     * Add Results Duration and Distance
     * (results dynamically generate !)
     * see event!
     * @param {Number} distance - distance
     * @param {Number} duration - duration
     * @param {Function} fconvert - fconvert
     *
     * @returns {DOMElement} DOM element
     */
    _addRouteResultsValuesElement: function _addRouteResultsValuesElement(distance, duration, fconvert) {
        var div = document.getElementById(this._addUID("GProuteResultsValues"));

        // clean !
        if (div.childElementCount) {
            while (div.firstChild) {
                div.removeChild(div.firstChild);
            }
        }

        var containerDistance = document.createElement("div");
        containerDistance.className = "GProuteResultsValue";

        var labelDistance = document.createElement("label");
        labelDistance.className = "GProuteResultsValueLabel";
        labelDistance.innerHTML = "Distance :";
        containerDistance.appendChild(labelDistance);

        var distanceLabel = 0;
        var isKm = parseInt(distance / 1000, 10);

        if (!isKm) {
            distanceLabel = Math.round(distance) + " m";
        } else {
            var distanceArrondi = Math.round(distance);
            distanceArrondi = distanceArrondi / 1000;
            distanceLabel = distanceArrondi + " km";
        }

        var divDistance = document.createElement("div");
        divDistance.id = this._addUID("GProuteResultsValueDist");
        divDistance.innerHTML = distanceLabel;
        containerDistance.appendChild(divDistance);

        div.appendChild(containerDistance);

        var containerDuration = document.createElement("div");
        containerDuration.className = "GProuteResultsValue";

        var labelDuration = document.createElement("label");
        labelDuration.className = "GProuteResultsValueLabel";
        labelDuration.innerHTML = "Durée :";
        containerDuration.appendChild(labelDuration);

        var divDuration = document.createElement("div");
        divDuration.id = this._addUID("GProuteResultsValueDist");
        divDuration.innerHTML = fconvert(duration);
        containerDuration.appendChild(divDuration);

        div.appendChild(containerDuration);

        return div;
    },

    /**
     * Create Show Results Details
     *
     * @returns {DOMElement} DOM element
     */
    _createRouteShowResultsDetailsElement: function _createRouteShowResultsDetailsElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GProuteResultsShowDetails");
        input.type = "checkbox";
        return input;
    },

    /**
     *  Create Results Details
     *
     * @returns {DOMElement} DOM element
     */
    _createRouteResultsDetailsElement: function _createRouteResultsDetailsElement() {
        // <!-- Route results details are dynamically filled in Javascript by route service -->
        var div = document.createElement("div");
        div.id = this._addUID("GProuteResultsDetails");
        return div;
    },

    /**
     *  Add Results Details
     * (results dynamically generate !)
     * @param {Object[]} instructions - instructions
     * @param {Function} fconvert - fconvert
     *
     * @returns {DOMElement} DOM element
     */
    _addRouteResultsDetailsElement: function _addRouteResultsDetailsElement(instructions, fconvert) {
        // contexte
        var context = this;

        var div = document.getElementById(this._addUID("GProuteResultsDetails"));

        // clean !
        if (div.childElementCount) {
            while (div.firstChild) {
                div.removeChild(div.firstChild);
            }
        }

        // calcul des valeurs cumulé !
        var distanceCumul = 0;
        var durationCumul = 0;

        /* jshint -W083 */
        for (var i = 0; i < instructions.length; i++) {
            var id = i + 1;

            var o = instructions[i];

            var divNum = document.createElement("div");
            divNum.className = "GProuteResultsDetailsNumber";
            divNum.innerHTML = id + ".";
            div.appendChild(divNum);

            durationCumul += parseFloat(o.duration);
            distanceCumul += parseFloat(o.distance);

            var distance = 0;
            var isCumulKm = parseInt(distanceCumul / 1000, 10);
            if (!isCumulKm) {
                distance = Math.round(distanceCumul) + " m";
            } else {
                var distanceArrondi = Math.round(distanceCumul);
                distanceArrondi = distanceArrondi / 1000;
                distance = distanceArrondi + " km";
            }

            var divIns = document.createElement("div");
            divIns.className = "GProuteResultsDetailsInstruction";
            divIns.id = this._addUID("GProuteResultsDetailsInstruction_" + id);
            divIns.title = "distance : " + distance + " / " + "temps : " + fconvert(durationCumul);
            divIns.innerHTML = o.instruction;

            divIns.addEventListener("mouseover", function (e) {
                context.onRouteResultsDetailsMouseOver(e);
            });
            divIns.addEventListener("mouseout", function (e) {
                context.onRouteResultsDetailsMouseOut(e);
            });
            divIns.addEventListener("click", function (e) {
                // mode mobile !
                if (typeof context.onRouteResultsDetailsClick === "function") {
                    context.onRouteResultsDetailsClick(e);
                }
            });
            div.appendChild(divIns);
        }

        return div;
    },

    // ################################################################### //
    // ################### Methods to the form points #################### //
    // ################# OVERWRITTEN BY LOCATIONSELECTOR ! ################# //

    /**
     * Create Point
     * see event !
     * OVERWRITTEN BY LOCATIONSELECTOR !
     * (version initial without LOCATIONSELECTOR PLUGIN)
     * @param {Integer} n - n
     * @param {String} text - text
     * @param {Boolean} visibility - visibility
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelFormPointElement: function _createRoutePanelFormPointElement(n, text, visibility) {
        // contexte d'execution
        var context = this;

        var div = document.createElement("div");
        div.id = "GProutePoint" + n;
        div.className = visibility ? "GPflexInput GProuteStageFlexInput" : "GPflexInput GProuteStageFlexInputHidden";

        var labelOrigin = document.createElement("label");
        labelOrigin.id = "GProuteOriginLabel" + n;
        labelOrigin.htmlFor = "GProuteOrigin" + n;
        labelOrigin.innerHTML = text;
        labelOrigin.addEventListener("click", function () {
            var i = this.id.charAt(this.id.length - 1);
            document.getElementById("GProuteOriginCoords" + i).value = "";
            for (var j = 1; j < 8; j++) {
                document.getElementById("GProutePoint" + j).style.display = "flex";
            }
            document.getElementById("GProuteForm").className = "";
            document.getElementById("GProuteOriginPointer" + i).checked = false;
            document.getElementById("GProuteOrigin" + i).className = "GProuteOriginVisible";
            document.getElementById("GProuteOriginCoords" + i).className = "GProuteOriginHidden";
        });
        div.appendChild(labelOrigin);

        var inputOrigin = document.createElement("input");
        inputOrigin.id = "GProuteOrigin" + n;
        inputOrigin.className = "GProuteOriginVisible";
        inputOrigin.type = "text";
        inputOrigin.placeholder = "Saisir une adresse";
        inputOrigin.addEventListener("keyup", function (e) {
            var charCode = e.which || e.keyCode;
            if (charCode === 13 || charCode === 10) {
                return;
            }
            var i = this.id.charAt(this.id.length - 1);
            if (document.getElementById("GProuteOrigin" + i).value.length > 2) {
                document.getElementById("GProuteAutoCompleteList" + i).style.display = "block";
            } else {
                document.getElementById("GProuteAutoCompleteList" + i).style.display = "none";
            }
            // gestionnaire d'evenement :
            // on récupère la valeur de saisie pour une requête sur le service d'autocompletion.
            // le resultat de la requête nous permet de recuperer les coordonnées du point...
            context.onAutoCompleteSearchText(e);
        });
        inputOrigin.addEventListener("blur", function () {
            var i = this.id.charAt(this.id.length - 1);
            document.getElementById("GProuteAutoCompleteList" + i).style.display = "none";
        });
        div.appendChild(inputOrigin);

        var inputOriginCoord = document.createElement("input");
        inputOriginCoord.id = "GProuteOriginCoords" + n;
        inputOriginCoord.className = "GProuteOriginHidden";
        inputOriginCoord.type = "text";
        inputOriginCoord.disabled = true;
        div.appendChild(inputOriginCoord);

        var inputOriginPointer = document.createElement("input");
        inputOriginPointer.id = "GProuteOriginPointer" + n;
        inputOriginPointer.type = "checkbox";
        div.appendChild(inputOriginPointer);

        var labelOriginPointer = document.createElement("label");
        labelOriginPointer.id = "GProuteOriginPointerImg" + n;
        labelOriginPointer.htmlFor = "GProuteOriginPointer" + n;
        labelOriginPointer.className = "GProuteOriginPointerImg";
        labelOriginPointer.title = "Pointer un lieu sur la carte";
        labelOriginPointer.addEventListener("click", function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            var i = this.id.charAt(this.id.length - 1);
            var j;
            for (j = 1; j < 8; j++) {
                if (i !== j) {
                    document.getElementById("GProuteOriginPointer" + j).checked = false;
                    if (document.getElementById("GProuteOriginCoords" + j).value === "Pointer un lieu sur la carte") {
                        document.getElementById("GProuteOriginCoords" + j).value = "";
                        document.getElementById("GProuteOrigin" + j).className = "GProuteOriginVisible";
                        document.getElementById("GProuteOriginCoords" + j).className = "GProuteOriginHidden";
                    }
                }
            }
            if (document.getElementById("GProuteOriginPointer" + i).checked) {
                document.getElementById("GProuteOriginCoords" + i).value = "";
                for (j = 1; j < 8; j++) {
                    document.getElementById("GProutePoint" + j).style.display = "flex";
                }
                document.getElementById("GProuteForm").className = "";
                document.getElementById("GProuteOriginPointer" + i).checked = false;
                document.getElementById("GProuteOrigin" + i).className = "GProuteOriginVisible";
                document.getElementById("GProuteOriginCoords" + i).className = "GProuteOriginHidden";
            } else {
                document.getElementById("GProuteOriginCoords" + i).value = "Pointer un lieu sur la carte";
                for (j = 1; j < 8; j++) {
                    if (i === j) {
                        document.getElementById("GProutePoint" + j).style.display = "flex";
                    } else {
                        document.getElementById("GProutePoint" + j).style.display = "none";
                    }
                }
                document.getElementById("GProuteForm").className = "GProuteFormMini";
                document.getElementById("GProuteOriginPointer" + i).checked = true;
                document.getElementById("GProuteOrigin" + i).className = "GProuteOriginHidden";
                document.getElementById("GProuteOriginCoords" + i).className = "GProuteOriginVisible";
            }
            // gestionnaire d'evenement :
            // on stocke la valeur du point, utilisée pour la requête sur le service de calcul d'itiniraire
            context.onRouteMapPointClick(evt);
        });
        div.appendChild(labelOriginPointer);

        return div;
    },

    /**
     * Create Remove Point tag
     * see event !
     * OVERWRITTEN BY LOCATIONSELECTOR !
     * (version initial without LOCATIONSELECTOR PLUGIN)
     * @param {Integer} n - n
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelFormRemoveStageElement: function _createRoutePanelFormRemoveStageElement(n) {
        // contexte d'execution
        var context = this;

        var divRm = document.createElement("div");
        divRm.id = "GProuteStageRemove" + n;
        divRm.className = "GProuteStageRemove";
        divRm.title = "Supprimer l'étape";
        if (n !== 1 && n !== 7) {
            divRm.addEventListener("click", function (e) {
                var i = this.id.charAt(this.id.length - 1);
                document.getElementById("GProutePoint" + i).className = "GPflexInput GProuteStageFlexInputHidden";
                document.getElementById("GProuteOrigin" + i).value = "";
                document.getElementById("GProuteOrigin" + i).className = "GProuteOriginVisible";
                document.getElementById("GProuteOriginCoords" + i).value = "";
                document.getElementById("GProuteOriginCoords" + i).className = "GProuteOriginHidden";
                document.getElementById("GProuteStageAdd").style.display = "";
                // Moving up exclusions picto
                var exclusionsPictoTop = document.getElementById("GPshowRouteExclusionsPicto").style.top;
                document.getElementById("GPshowRouteExclusionsPicto").style.top = (parseInt(exclusionsPictoTop, 10) - 33).toString() + "px";
                // gestionnaire d'evenement :
                // on supprime le point, utilisé pour la requête sur le service d'itiniraire
                context.onRouteRemovePointClick(e);
            });
        }
        return divRm;
    },

    /**
     * Create Add Point tag
     * see event !
     * OVERWRITTEN BY LOCATIONSELECTOR !
     * (version initial without LOCATIONSELECTOR PLUGIN)
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelFormAddStageElement: function _createRoutePanelFormAddStageElement() {
        // contexte d'execution
        var context = this;

        var divAdd = document.createElement("div");
        divAdd.id = "GProuteStageAdd";
        divAdd.title = "Ajouter une étape";
        divAdd.addEventListener("click", function (e) {
            var lastStage = 1;
            var nbStages = 0;
            for (var i = 2; i < 7; i++) {
                if (document.getElementById("GProutePoint" + i).className === "GPflexInput GProuteStageFlexInputHidden") {
                    if (lastStage === 1) {
                        lastStage = i;
                    }
                } else {
                    nbStages++;
                }
            }
            if (lastStage < 7) {
                document.getElementById("GProutePoint" + lastStage).className = "GPflexInput GProuteStageFlexInput";
                // Moving down exclusions picto
                var exclusionsPictoTop = document.getElementById("GPshowRouteExclusionsPicto").style.top;
                document.getElementById("GPshowRouteExclusionsPicto").style.top = (parseInt(exclusionsPictoTop, 10) + 33).toString() + "px";
            }
            if (nbStages === 4) {
                document.getElementById("GProuteStageAdd").style.display = "none";
            }
            // gestionnaire d'evenement :
            // on ajoute le point, utilisé pour la requête sur le service d'itiniraire
            context.onRouteAddPointClick(e);
        });

        return divAdd;
    },

    /**
     * Create Results autocompletion to the point
     * see event!
     * OVERWRITTEN BY LOCATIONSELECTOR !
     * (version initial without LOCATIONSELECTOR PLUGIN)
     * @param {Integer} n - n
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelFormAutoCompleteListElement: function _createRoutePanelFormAutoCompleteListElement(n) {
        // contexte d'execution
        var context = this;

        var div = document.createElement("div");
        div.id = "GProuteAutoCompleteList" + n;
        div.className = "GPadvancedAutoCompleteList";

        if (div.addEventListener) {
            div.addEventListener("click", function (e) {
                context.onAutoCompletedResultsItemClick(e);
                document.getElementById("GProuteAutoCompleteList" + n).style.display = "none";
            }, false);
        } else if (div.attachEvent) {
            div.attachEvent("onclick", function (e) {
                context.onAutoCompletedResultsItemClick(e);
                document.getElementById("GProuteAutoCompleteList" + n).style.display = "none";
            });
        }

        // Proposals are dynamically filled in Javascript by autocomplete service
        // <div class="GPautoCompleteProposal">...</div>

        return div;
    },

    /**
     * Autocompletion result to a point.
     * Proposals are dynamically filled in Javascript by autocomplete service
     * OVERWRITTEN BY LOCATIONSELECTOR !
     * (version initial without LOCATIONSELECTOR PLUGIN)
     *
     *
     * @param {Object} location - suggested location results
     * @param {Number} n  - number of the point
     * @param {Number} id - ID
     */
    _createRouteAutoCompletedLocationElement: function _createRouteAutoCompletedLocationElement(location, n, id) {
        var container = document.getElementById("GProuteAutoCompleteList" + n);

        var div = document.createElement("div");
        div.id = "AutoCompletedLocation" + id;
        div.className = "GPautoCompleteProposal";
        div.innerHTML = location.fullText;

        container.appendChild(div);
    },

    // ################################################################### //
    // ############## Methods to the choice mode into form ############### //
    // ################################################################### //

    /**
     * Create Container to Mode choice transport
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelFormModeChoiceElement: function _createRoutePanelFormModeChoiceElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GProuteModeChoice");

        // div.appendChild(this._createRoutePanelFormModeChoiceTransportElement());
        // div.appendChild(this._createRoutePanelFormModeChoiceComputeElement());

        return div;
    },

    /**
     * Create Mode choice transport
     * see event !
     * FIXME event not useful
     * @param {String[]} transports - transports
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelFormModeChoiceTransportElement: function _createRoutePanelFormModeChoiceTransportElement(transports) {
        // contexte d'execution
        var context = this;

        var div = document.createElement("div");
        div.id = this._addUID("GProuteTransportChoice");

        var span = document.createElement("span");
        span.className = "GProuteModeLabel";
        span.innerHTML = "Mode de transport";
        div.appendChild(span);

        /* jshint -W083 */
        for (var i = 0; i < transports.length; i++) {
            var transport = transports[i];

            if (transport === "Voiture") {
                var inputCar = document.createElement("input");
                inputCar.id = this._addUID("GProuteTransportCar");
                inputCar.type = "radio";
                inputCar.name = "GProuteTransport";
                inputCar.value = "Voiture";
                if (i === 0) {
                    inputCar.checked = true;
                }
                // gestionnaire d'evenement :
                // on stocke le mode de transport,
                // utilisation pour la requête sur le service de calcul d'itiniraire
                if (inputCar.addEventListener) {
                    inputCar.addEventListener("change", function (e) {
                        context.onRouteModeTransportChange(e);
                    });
                } else if (inputCar.attachEvent) {
                    inputCar.attachEvent("onchange", function (e) {
                        context.onRouteModeTransportChange(e);
                    });
                }
                div.appendChild(inputCar);

                var labelCar = document.createElement("label");
                labelCar.className = "GProuteTransportImg";
                labelCar.htmlFor = this._addUID("GProuteTransportCar");
                labelCar.title = "Voiture";
                div.appendChild(labelCar);
            }

            if (transport === "Pieton") {
                var inputPedestrian = document.createElement("input");
                inputPedestrian.id = this._addUID("GProuteTransportPedestrian");
                inputPedestrian.type = "radio";
                inputPedestrian.name = "GProuteTransport";
                inputPedestrian.value = "Pieton";
                if (i === 0) {
                    inputPedestrian.checked = true;
                }
                // gestionnaire d'evenement :
                // on stocke le mode de transport,
                // utilisation pour la requête sur le service de calcul d'itiniraire
                if (inputPedestrian.addEventListener) {
                    inputPedestrian.addEventListener("change", function (e) {
                        context.onRouteModeTransportChange(e);
                    });
                } else if (inputPedestrian.attachEvent) {
                    inputPedestrian.attachEvent("onchange", function (e) {
                        context.onRouteModeTransportChange(e);
                    });
                }
                div.appendChild(inputPedestrian);

                var labelPedestrian = document.createElement("label");
                labelPedestrian.className = "GProuteTransportImg";
                labelPedestrian.htmlFor = this._addUID("GProuteTransportPedestrian");
                labelPedestrian.title = "Piéton";
                div.appendChild(labelPedestrian);
            }
        }

        return div;
    },

    /**
     * Create Mode choice computation
     * see event!
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelFormModeChoiceComputeElement: function _createRoutePanelFormModeChoiceComputeElement() {
        // contexte d'execution
        var context = this;

        var div = document.createElement("div");
        div.id = this._addUID("GProuteComputationChoice");

        var span = document.createElement("span");
        span.className = "GProuteModeLabel";
        span.innerHTML = "Mode de calcul";
        div.appendChild(span);

        var select = document.createElement("select");
        select.id = this._addUID("GProuteComputationSelect");
        select.className = "GPinputSelect";
        // gestionnaire d'evenement :
        // on stocke la valeur du mode de calcul,
        // utilisation pour la requête sur le service de calcul d'itiniraire
        select.addEventListener("change", function (e) {
            context.onRouteModeComputationChange(e);
        });

        var computes = [{
            code: "fastest",
            label: "Plus rapide"
        }, {
            code: "shortest",
            label: "Plus court"
        }];

        for (var i = 0; i < computes.length; i++) {
            var option = document.createElement("option");
            option.value = computes[i].code;
            option.text = computes[i].label;
            select.appendChild(option);
        }
        div.appendChild(select);

        return div;
    },

    // ################################################################### //
    // ################# Methods to the choice exclusions ################ //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing Exclusions Options
     *
     * @returns {DOMElement} DOM element
     */
    _createShowRouteExclusionsElement: function _createShowRouteExclusionsElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowRouteExclusions");
        input.type = "checkbox";
        return input;
    },

    /**
     * Label to Exclusions Options
     * see event !
     * FIXME event not useful
     *
     * @returns {DOMElement} DOM element
     */
    _createShowRouteExclusionsPictoElement: function _createShowRouteExclusionsPictoElement() {
        // contexte d'execution
        var context = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowRouteExclusionsPicto");
        label.className = "GPshowMoreOptions GPshowRouteExclusionsPicto";
        label.htmlFor = this._addUID("GPshowRouteExclusions");
        label.title = "Exclusions";
        label.style.top = "185px";

        // gestionnaire d'evenement :
        // on ouvre le menu des options des exclusions
        if (label.addEventListener) {
            label.addEventListener("click", function (e) {
                context.onShowRouteExclusionsClick(e);
            });
        } else if (label.attachEvent) {
            label.attachEvent("onclick", function (e) {
                context.onShowRouteExclusionsClick(e);
            });
        }

        return label;
    },

    /**
     * Create Container to Exclusions
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelFormExclusionsElement: function _createRoutePanelFormExclusionsElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GProuteExclusions");

        var span = document.createElement("span");
        span.className = "GProuteExclusionsLabel";
        span.innerHTML = "Passages autorisés";
        div.appendChild(span);

        // div.appendChild(this._createRoutePanelFormExclusionOptionsElement());

        return div;
    },

    /**
     * Create Exclusions Options
     * see event !
     * FIXME event not useful
     * @param {Object[]} exclusions - exclusions
     *
     * @returns {DOMElement} DOM element
     */
    _createRoutePanelFormExclusionOptionsElement: function _createRoutePanelFormExclusionOptionsElement(exclusions) {
        // contexte d'execution
        var context = this;

        var div = document.createElement("div");
        div.className = "GProuteExclusionsOptions";

        /* jshint -W083 */
        for (var value in exclusions) {
            if (exclusions.hasOwnProperty(value)) {
                var status = exclusions[value];
                switch (value) {
                    case "toll":
                        var inputToll = document.createElement("input");
                        inputToll.id = this._addUID("GProuteExclusionsToll");
                        inputToll.type = "checkbox";
                        inputToll.value = "Toll";
                        inputToll.checked = !status;
                        // gestionnaire d'evenement :
                        // on stocke l'exclusion,
                        // utilisation pour la requête sur le service de calcul d'itiniraire
                        if (inputToll.addEventListener) {
                            inputToll.addEventListener("change", function (e) {
                                context.onRouteExclusionsChange(e);
                            });
                        } else if (inputToll.attachEvent) {
                            inputToll.attachEvent("onchange", function (e) {
                                context.onRouteExclusionsChange(e);
                            });
                        }
                        div.appendChild(inputToll);

                        var labelToll = document.createElement("label");
                        labelToll.className = "GProuteExclusionsOption";
                        labelToll.htmlFor = this._addUID("GProuteExclusionsToll");
                        labelToll.innerHTML = "Péages";
                        div.appendChild(labelToll);
                        break;

                    case "tunnel":
                        var inputTunnel = document.createElement("input");
                        inputTunnel.id = this._addUID("GProuteExclusionsTunnel");
                        inputTunnel.type = "checkbox";
                        inputTunnel.value = "Tunnel";
                        inputTunnel.checked = !status;
                        // gestionnaire d'evenement :
                        // on stocke l'exclusion,
                        // utilisation pour la requête sur le service de calcul d'itiniraire
                        if (inputTunnel.addEventListener) {
                            inputTunnel.addEventListener("change", function (e) {
                                context.onRouteExclusionsChange(e);
                            });
                        } else if (inputTunnel.attachEvent) {
                            inputTunnel.attachEvent("onchange", function (e) {
                                context.onRouteExclusionsChange(e);
                            });
                        }
                        div.appendChild(inputTunnel);

                        var labelTunnel = document.createElement("label");
                        labelTunnel.className = "GProuteExclusionsOption";
                        labelTunnel.htmlFor = this._addUID("GProuteExclusionsTunnel");
                        labelTunnel.innerHTML = "Tunnels";
                        div.appendChild(labelTunnel);
                        break;

                    case "bridge":
                        var inputBridge = document.createElement("input");
                        inputBridge.id = this._addUID("GProuteExclusionsBridge");
                        inputBridge.type = "checkbox";
                        inputBridge.value = "Bridge";
                        inputBridge.checked = !status;
                        // gestionnaire d'evenement :
                        // on stocke l'exclusion,
                        // utilisation pour la requête sur le service de calcul d'itiniraire
                        if (inputBridge.addEventListener) {
                            inputBridge.addEventListener("change", function (e) {
                                context.onRouteExclusionsChange(e);
                            });
                        } else if (inputBridge.attachEvent) {
                            inputBridge.attachEvent("onchange", function (e) {
                                context.onRouteExclusionsChange(e);
                            });
                        }
                        div.appendChild(inputBridge);

                        var labelBridge = document.createElement("label");
                        labelBridge.className = "GProuteExclusionsOption";
                        labelBridge.htmlFor = this._addUID("GProuteExclusionsBridge");
                        labelBridge.innerHTML = "Ponts";
                        div.appendChild(labelBridge);
                        break;
                }
            }
        }

        return div;
    },

    // ################################################################### //
    // ############################### Submit Form ####################### //
    // ################################################################### //

    /**
     * Create Submit Form Element
     *
     * @returns {DOMElement} DOM element
     */
    _createRouteSubmitFormElement: function _createRouteSubmitFormElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GProuteSubmit");
        input.className = "GPinputSubmit";
        input.type = "submit";
        input.value = "Calculer";

        return input;
    },

    // ################################################################### //
    // ############################### Reset picto ####################### //
    // ################################################################### //

    /**
     * Create Reset Picto Element
     *
     * @returns {DOMElement} DOM element
     */
    _createRouteFormResetElement: function _createRouteFormResetElement() {
        var self = this;

        var divReset = document.createElement("div");
        divReset.id = this._addUID("GProuteReset");
        divReset.title = "Réinitialiser les paramètres";
        divReset.addEventListener("click", function (e) {
            self.onRouteResetClick(e);
        });

        return divReset;
    }
};

exports.default = RouteDOM;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _CheckRightManagement = __webpack_require__(7);

var _CheckRightManagement2 = _interopRequireDefault(_CheckRightManagement);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _LocationSelector = __webpack_require__(23);

var _LocationSelector2 = _interopRequireDefault(_LocationSelector);

var _LayerSwitcher = __webpack_require__(6);

var _LayerSwitcher2 = _interopRequireDefault(_LayerSwitcher);

var _Markers = __webpack_require__(5);

var _Markers2 = _interopRequireDefault(_Markers);

var _IsoDOM = __webpack_require__(47);

var _IsoDOM2 = _interopRequireDefault(_IsoDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("isocurve");

/**
 * @classdesc
 *
 * Isocurve Control.
 *
 * @constructor
 * @alias ol.control.Isocurve
 * @extends {ol.control.Control}
 * @param {Object} options - Isocurve control options
 * @param {String}   [options.apiKey] - API key for services call (isocurve and autocomplete services), mandatory if autoconf service has not been charged in advance
 * @param {Boolean} [options.collapsed = true] - Specify if widget has to be collapsed (true) or not (false) on map loading. Default is true.
 * @param {Object}  [options.exclusions = {toll : false, tunnel : false, bridge : false}] - list of exclusions with status (true = checked). By default : no exclusions checked.
 * @param {Array}   [options.graphs = ["Voiture", "Pieton"]] - list of graph resources to be used for isocurve calculation, by default : ["Voiture", "Pieton"]. Possible values are "Voiture" and "Pieton". The first element is selected.
 * @param {Array}   [options.methods = ["time", "distance"]] - list of methods, by default : ["time", "distance"]. Possible values are "time" and "distance". The first element is selected by default.
 * @param {Array}   [options.directions = ["departure", "arrival"]] - list of directions to be displayed, by default : ["departure", "arrival"]. The first element is selected by default. Possible values are "departure" and "arrival".
 *      Directions enable to specify if input location point will be used as a departure point ("departure") or as an arrival point ("arrival")
 * @param {Object} [options.markerOpts] - options to use your own marker. Default is a lightOrange marker.
 * @param {String} [options.markerOpts.url] - marker base64 encoded url (ex "data:image/png;base64,...""). Mandatory for a custom marker
 * @param {Array} [options.markerOpts.offset] - Offsets in pixels used when positioning the overlay. The first element in the array is the horizontal offset. A positive value shifts the overlay right. The second element in the array is the vertical offset. A positive value shifts the overlay down. Default is [0, 0]. (see http://openlayers.org/en/latest/apidoc/ol.Overlay.html)
 * @param {Object} [options.isocurveOptions = {}] - isocurve service options. see {@link http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~isoCurve Gp.Services.isoCurve()} to know all isocurve options.
 * @param {Object} [options.autocompleteOptions = {}] - autocomplete service options. see {@link http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~autoComplete Gp.Services.autoComplete()} to know all autocomplete options
 * @param {Object} [options.layerDescription = {}] - Layer informations to be displayed in LayerSwitcher widget (only if a LayerSwitcher is also added to the map)
 * @param {String} [options.layerDescription.title = "Isochrone/Isodistance"] - Layer title to be displayed in LayerSwitcher
 * @param {String} [options.layerDescription.description = "isochrones/isodistance basé sur un graphe"] - Layer description to be displayed in LayerSwitcher
 * @example
 *  var iso = ol.control.Isocurve({
 *      collapsed : false
 *      methods : ["time", "distance"],
 *      exclusions : {
 *         toll : true,
 *         bridge : false,
 *         tunnel : true
 *      },
 *      graphs : ["Pieton", "Voiture"],
 *      markerOpts : {
 *          url : "...",
 *          offset : [0,0]
 *      }
 *      isocurveOptions : {},
 *      autocompleteOptions : {}
 *  });
 */
function Isocurve(options) {
    options = options || {};

    if (!(this instanceof Isocurve)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // initialisation du composant
    this.initialize(options);

    // // Widget main DOM container
    this._container = this._createMainContainerElement();
    // info: le container sera complété lors de l'ajout à la carte (setMap), car certains composants nécessitent d'être liés à la map.
    this._containerElement = null;

    // on peut éventuellement encapsuler le composant dans une div passée par l'utilisateur
    if (options.element && options.element.appendChild) {
        // dans ce cas on stocke les deux container
        options.element.appendChild(this._container);
        this._containerElement = options.element;
    }

    // call ol.control.Control constructor
    _ol2.default.control.Control.call(this, {
        element: this._containerElement || this._container,
        target: options.target,
        render: options.render
    });
};

// Inherits from ol.control.Control
_ol2.default.inherits(Isocurve, _ol2.default.control.Control);

/**
 * @lends module:Isocurve
 */
Isocurve.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les méthodes de la classe commune IsoDOM
_Utils2.default.assign(Isocurve.prototype, _IsoDOM2.default);

/**
 * Constructor (alias)
 *
 * @private
 */
Isocurve.prototype.constructor = Isocurve;

// ################################################################### //
// ##################### public methods ############################## //
// ################################################################### //

/**
 * Returns true if widget is collapsed (minimized), false otherwise
 *
 * @returns {Boolean} collapsed - true if widget is collapsed
 */
Isocurve.prototype.getCollapsed = function () {
    return this.collapsed;
};

/**
 * Collapse or display widget main container
 *
 * @param {Boolean} collapsed - True to collapse widget, False to display it
 */
Isocurve.prototype.setCollapsed = function (collapsed) {
    if (collapsed === undefined) {
        logger.log("[ERROR] Isocurve:setCollapsed - missing collapsed parameter");
        return;
    }
    if (collapsed && this.collapsed || !collapsed && !this.collapsed) {
        return;
    }
    if (collapsed) {
        document.getElementById("GPisochronPanelClose-" + this._uid).click();
    } else {
        document.getElementById("GPshowIsochronPicto-" + this._uid).click();
    }
    this.collapsed = collapsed;
};

/**
 * Get vector layer where Isocurve geometry is drawn
 *
 * @returns {Object} layer - ol.layer.Vector isocurve layer
 */
Isocurve.prototype.getLayer = function () {
    return this._geojsonLayer;
};

/**
 * Overwrite OpenLayers setMap method
 *
 * @param {ol.Map} map - Map.
 */
Isocurve.prototype.setMap = function (map) {
    if (map) {
        // enrichissement du DOM du container lors de l'ajout à la carte
        this._container = this._initContainer(map);
    }

    // on appelle la méthode setMap originale d'OpenLayers
    _ol2.default.control.Control.prototype.setMap.call(this, map);
};

// ################################################################### //
// ##################### init component ############################## //
// ################################################################### //

/**
 * Initialize Isocurve control (called by Isocurve constructor)
 *
 * @param {Object} options - constructor options
 * @private
 */
Isocurve.prototype.initialize = function (options) {
    this._checkInputOptions(options);

    // set default options
    this.options = {
        collapsed: true,
        methods: ["time", "distance"],
        graphs: ["Voiture", "Pieton"],
        exclusions: {
            toll: false,
            tunnel: false,
            bridge: false
        },
        directions: ["departure", "arrival"],
        markerOpts: {
            url: _Markers2.default["lightOrange"],
            offset: _Markers2.default.defaultOffset
        },
        isocurveOptions: {},
        autocompleteOptions: {},
        layerDescription: {
            title: "Isochrone/Isodistance",
            description: "isochrones/isodistance basé sur un graphe"
        }
    };

    // merge with user options
    _Utils2.default.assign(this.options, options);

    /** {Boolean} specify if isocurve control is collapsed (true) or not (false) */
    this.collapsed = this.options.collapsed;

    // identifiant du contrôle : utile pour suffixer les identifiants CSS (pour gérer le cas où il y en a plusieurs dans la même page)
    this._uid = _SelectorID2.default.generate();

    // Options du service paramétrables via l'interface (graph, method, exclusions)
    // Mode de transport selectionné : 'Voiture' ou 'Pieton'
    this._currentTransport = null;
    this._initTransport();
    // Mode de calcul selectionné : 'time' (isochron) ou 'distance' (isodistance)
    this._currentComputation = null;
    this._initComputation();
    // Exclusions selectionnées : Tunnel, Toll et Bridge
    this._currentExclusions = [];
    this._initExclusions();
    // sens de parcours : "departure" ou "arrival"
    this._currentDirection = null;
    this._initDirection();

    // point de saisie
    this._originPoint = null;

    // // containers principaux
    this._showIsoContainer = null;
    this._waitingContainer = null;
    this._formContainer = null;

    // les résultats du calcul
    this._currentIsoResults = null;

    // la géométrie
    this._geojsonLayer = null;

    // si un calcul est en cours ou non
    this._waiting = false;
    // timer pour cacher la patience après un certain temps
    this._timer = null;

    // styles pour les sélections des features
    this._defaultFeatureStyle = new _ol2.default.style.Style({
        fill: new _ol2.default.style.Fill({
            color: "rgba(0, 183, 152, 0.7)"
        })
    });

    // liste des ressources avec droits par service
    // Ex. {
    //   "Isocurve" : {
    //       key : "ger4g456re45er456t4er5ge5",
    //       resources : ["Pieton", "Voiture"]
    //   }
    // }
    this._resources = {};

    // gestion des droits sur les ressources
    this._noRightManagement = false;

    // gestion des droits sur les ressources/services
    this._checkRightsManagement();
};

/**
 * this method is called by this.initialize()
 *
 * @param {Object} options - options
 *
 * @private
 */
Isocurve.prototype._checkInputOptions = function (options) {
    // vérification des options
    // on ne permet pas de n'afficher aucun mode de calcul ou aucun mode de transport ?
    var i;

    // modes de calcul
    if (options.methods) {
        if (Array.isArray(options.methods)) {
            // on ne permet pas de passer un tableau vide : on spécifie au moins une méthode
            if (options.methods.length === 0) {
                options.methods = null;
            } else {
                for (i = 0; i < options.methods.length; i++) {
                    if (typeof options.methods[i] !== "string") {
                        logger.log("[ol.control.Isocurve] ERROR : parameter 'methods' elements should be of type 'string'");
                    }
                }
            }
        } else {
            logger.warn("'methods' parameter should be an array");
            options.methods = null;
        }
    }

    // mode de transport
    if (options.graphs) {
        if (Array.isArray(options.graphs)) {
            // on ne permet pas de passer un tableau vide : on spécifie au moins un graph
            if (options.graphs.length === 0) {
                options.graphs = null;
            } else {
                for (i = 0; i < options.graphs.length; i++) {
                    if (typeof options.graphs[i] !== "string") {
                        logger.log("[ol.control.Isocurve] ERROR : parameter 'graphs' elements should be of type 'string'");
                    } else {
                        if (options.graphs[i].toLowerCase() === "pieton") {
                            options.graphs[i] = "Pieton";
                        }
                        if (options.graphs[i].toLowerCase() === "voiture") {
                            options.graphs[i] = "Voiture";
                        }
                    }
                }
            }
        } else {
            logger.warn("'graphs' parameter should be an array");
            options.graphs = null;
        }
    }

    // sens du parcours
    if (options.directions) {
        if (Array.isArray(options.directions)) {
            // on ne permet pas de passer un tableau vide : on spécifie au moins une direction
            if (options.directions.length === 0) {
                options.directions = null;
            } else {
                for (i = 0; i < options.directions.length; i++) {
                    if (typeof options.directions[i] !== "string") {
                        logger.log("[ol.control.Isocurve] ERROR : parameter 'directions' elements should be of type 'string'");
                    }
                }
            }
        } else {
            logger.warn("'directions' parameter should be an array");
            options.directions = null;
        }
    }

    // collapsed
    if (options.collapsed === "true") {
        options.collapsed = true;
    }
    if (options.collapsed === "false") {
        options.collapsed = false;
    }
};

/**
 * this method is called by this.initialize() and initialize transport mode
 * ("Voiture" ou "Pieton")
 *
 * @private
 */
Isocurve.prototype._initTransport = function () {
    // Mode de transport selectionné
    this._currentTransport = "Voiture"; // par defaut

    // par defaut
    var transports = this.options.graphs;
    if (!transports || transports.length === 0) {
        this.options.graphs = ["Voiture", "Pieton"];
    }

    // option
    if (Array.isArray(transports) && transports.length) {
        // FIXME pb si le 1er graphe n'est pas une ressource connue !
        if (transports[0] === "Voiture" || transports[0] === "Pieton") {
            this._currentTransport = transports[0];
        }
    }

    // si l'utilisateur a spécifié un graph dans le service, on surcharge les options du widget
    var serviceOptions = this.options.isocurveOptions;
    if (serviceOptions.graph) {
        this._currentTransport = serviceOptions.graph;
    }
};

/**
 * this method is called by this.initialize() and initialize computation mode
 * (time or distance)
 *
 * @private
 */
Isocurve.prototype._initComputation = function () {
    // Mode de calcul selectionné
    this._currentComputation = "time"; // par defaut

    // par defaut
    var methods = this.options.methods;
    if (!methods || methods.length === 0) {
        this.options.methods = ["time", "distance"];
    }

    // option
    if (Array.isArray(methods) && methods.length) {
        // FIXME pb si le 1er graphe n'est pas une ressource connue !
        if (methods[0] === "time" || methods[0] === "distance") {
            this._currentComputation = methods[0];
        }
    }

    // si l'utilisateur a spécifié une méthode dans le service, on surcharge les options du widget
    var serviceOptions = this.options.isocurveOptions;
    if (serviceOptions.method) {
        this._currentComputation = serviceOptions.method;
    }
    if (serviceOptions.time) {
        this._currentComputation = "time";
    }
    if (serviceOptions.distance) {
        this._currentComputation = "distance";
    }
};

/**
 * this method is called by this.initialize() and initialize direction mode
 * (departure or arrival)
 *
 * @private
 */
Isocurve.prototype._initDirection = function () {
    // Mode de calcul selectionné
    this._currentDirection = "departure"; // par defaut

    // par defaut
    var directions = this.options.directions;
    if (!directions || directions.length === 0) {
        this.options.directions = ["departure", "arrival"];
    }

    // option
    if (Array.isArray(directions) && directions.length) {
        // FIXME pb si le 1er graphe n'est pas une ressource connue !
        if (directions[0] === "departure" || directions[0] === "arrival") {
            this._currentDirection = directions[0];
        }
    }

    // si l'utilisateur a spécifié une méthode dans le service, on surcharge les options du widget
    var serviceOptions = this.options.isocurveOptions;
    if (!serviceOptions.reverse) {
        this._currentDirection = "departure";
    }
    if (serviceOptions.reverse === true) {
        this._currentDirection = "arrival";
        this.options.directions = ["arrival", "departure"];
    }
};

/**
 * this method is called by this.initialize() and initialize exclusions
 *
 * @private
 */
Isocurve.prototype._initExclusions = function () {
    // Exclusions selectionnées : Tunnel, Toll et Bridge
    this._currentExclusions = []; // par defaut

    // par defaut
    var exclusion = this.options.exclusions;
    if (!exclusion || (typeof exclusion === "undefined" ? "undefined" : _typeof(exclusion)) === "object" && Object.keys(exclusion).length === 0) {
        this.options.exclusions = {
            toll: false,
            tunnel: false,
            bridge: false
        };
    }

    // option
    if (exclusion && (typeof exclusion === "undefined" ? "undefined" : _typeof(exclusion)) === "object" && Object.keys(exclusion).length) {
        for (var k in exclusion) {
            if (exclusion.hasOwnProperty(k)) {
                if (exclusion.k) {
                    this._currentExclusions.push(k);
                }
            }
        }
    }

    // si l'utilisateur a spécifié des exclusions dans le service, on surcharge les options du widget
    var serviceOptions = this.options.isocurveOptions;
    if (Array.isArray(serviceOptions.exclusions)) {
        this._currentExclusions = serviceOptions.exclusions;
    }
};

/**
 * Check rights to resources (called by this.initialize())
 *
 * @private
 */
Isocurve.prototype._checkRightsManagement = function () {
    var _opts = null;
    var _res = [];
    var _key = null;

    // les ressources du service du calcul d'isocurve
    _key = this.options.isocurveOptions.apiKey;
    _opts = this.options.isocurveOptions.filterOptions;
    _res = _opts ? _opts.type : [];
    if (!_res || _res.length === 0) {
        _res = ["Voiture", "Pieton"];
    }

    var rightManagementIsocurve = _CheckRightManagement2.default.check({
        key: _key || this.options.apiKey,
        resources: _res,
        services: ["Isochrone"]
    });
    logger.log("rightManagementIsocurve", rightManagementIsocurve);

    // les ressources du service d'autocompletion
    _key = this.options.autocompleteOptions.apiKey;
    _opts = this.options.autocompleteOptions.filterOptions;
    _res = _opts ? _opts.type : [];
    if (!_res || _res.length === 0) {
        _res = ["PositionOfInterest", "StreetAddress"];
    }

    var rightManagementAutoComplete = _CheckRightManagement2.default.check({
        key: _key || this.options.apiKey,
        resources: _res,
        services: ["AutoCompletion"]
    });
    logger.log("rightManagementAutoComplete", rightManagementAutoComplete);

    // au cas où pas de droit !
    if (!rightManagementIsocurve && !rightManagementAutoComplete) {
        this._noRightManagement = true;
    }

    // FIXME je reconstruis differement la structure pour la gestion des clefs differentes
    // pour chaque service...
    if (rightManagementAutoComplete) {
        this._resources["AutoCompletion"] = {};
        this._resources["AutoCompletion"]["resources"] = rightManagementAutoComplete["AutoCompletion"];
        this._resources["AutoCompletion"]["key"] = rightManagementAutoComplete["key"];
    }

    if (rightManagementIsocurve) {
        this._resources["Isocurve"] = {};
        this._resources["Isocurve"]["resources"] = rightManagementIsocurve["Isochrone"];
        this._resources["Isocurve"]["key"] = rightManagementIsocurve["key"];
    }
};

// ################################################################### //
// ######################## DOM initialize ########################### //
// ################################################################### //

/**
 * initialize component container (DOM)
 *
 * @param {Object} map - the map
 *
 * @returns {DOMElement} DOM element
 *
 * @private
 */
Isocurve.prototype._initContainer = function (map) {
    // get main container
    var container = this._container;

    var inputShow = this._showIsoContainer = this._createShowIsoElement();
    container.appendChild(inputShow);

    // mode "collapsed"
    if (!this.collapsed) {
        inputShow.checked = true;
    }

    var picto = this._createShowIsoPictoElement();
    container.appendChild(picto);

    // panneau
    var panel = this._createIsoPanelElement();

    // header
    var header = this._createIsoPanelHeaderElement();
    panel.appendChild(header);

    // form
    var form = this._formContainer = this._createIsoPanelFormElement();

    // form: input de saisie de la localisation (fonction de Isocurve, voir ci-dessous)
    var point = this._createIsoPanelFormPointElement(map);
    form.appendChild(point);

    var isoChronChecked = false;
    var isoDistChecked = false;
    var typeChoice = this._createIsoPanelFormTypeChoiceElement();
    for (var i = 0; i < this.options.methods.length; i++) {
        if (this.options.methods[i] === "time") {
            isoChronChecked = i === 0;
            typeChoice.appendChild(this._createIsoPanelFormTypeChoiceChronElement(isoChronChecked));
        }
        if (this.options.methods[i] === "distance") {
            isoDistChecked = i === 0;
            typeChoice.appendChild(this._createIsoPanelFormTypeChoiceDistElement(isoDistChecked));
        }
    }
    form.appendChild(typeChoice);

    // form: menu du choix des valeurs
    form.appendChild(this._createIsoPanelFormValueIsochronElement(isoChronChecked));
    form.appendChild(this._createIsoPanelFormValueIsodistanceElement(isoDistChecked));

    // form: menu du choix du transport et du sens du parcours
    var modeChoice = this._createIsoPanelFormModeChoiceElement();
    modeChoice.appendChild(this._createIsoPanelFormModeChoiceTransportElement(this.options.graphs));
    // FIXME : doit on passer le paramètre defaultDirection ?
    modeChoice.appendChild(this._createIsoPanelFormModeChoiceDirectionElement(this.options.directions));
    form.appendChild(modeChoice);

    // form: menu des exclusions
    if (this.options.exclusions && _typeof(this.options.exclusions) === "object" && Object.keys(this.options.exclusions).length !== 0) {
        form.appendChild(this._createShowIsoExclusionsElement());
        form.appendChild(this._createShowIsoExclusionsPictoElement());
        var exclusion = this._createIsoPanelFormExclusionsElement();
        exclusion.appendChild(this._createIsoPanelFormExclusionOptionsElement(this.options.exclusions));
        form.appendChild(exclusion);
    }

    var divReset = this._createIsoFormResetElement();
    form.appendChild(divReset);

    // form: bouton du calcul
    var submit = this._submitContainer = this._createIsoSubmitFormElement();
    form.appendChild(submit);

    panel.appendChild(form);

    // waiting
    var waiting = this._waitingContainer = this._createIsoWaitingElement();
    panel.appendChild(waiting);

    container.appendChild(panel);
    var context = this;
    // hide autocomplete suggested locations on container click
    if (container.addEventListener) {
        container.addEventListener("click", function (e) {
            context._hideIsoSuggestedLocations(e);
        });
    }

    return container;
};

/**
 * Create start point
 *
 * @param {Object} map - the map
 *
 * @returns {Object} DOM element
 * @private
 */
Isocurve.prototype._createIsoPanelFormPointElement = function (map) {
    this._originPoint = new _LocationSelector2.default({
        apiKey: this.options.apiKey || null,
        tag: {
            id: 1,
            groupId: this._uid,
            markerOpts: this.options.markerOpts,
            label: "Départ",
            display: true
        },
        autocompleteOptions: this.options.autocompleteOptions || null
    });
    this._originPoint.setMap(map);
    // a la sélection d'un nouveau point, on réinitialise aussi le tracé
    var self = this;
    /** click sur le pointer */
    document.getElementById("GPlocationOriginPointerImg_1-" + this._uid).onclick = function () {
        self._clearGeojsonLayer();
        var map = self.getMap();
        if (self._originPoint._inputShowPointerContainer.checked) {
            // au click sur l'input pour pointer sur la carte: on minimise le formulaire
            self._formContainer.className = "GPisochronFormMini";
            // et au clic sur la carte, on réaffichera le formulaire "normal"
            map.on("click", function () {
                self._formContainer.className = "";
            });
        } else {
            // si on déselectionne le pointer, on rétablit le formulaire en mode normal
            self._formContainer.className = "";
            // et on enlève l'écouteur d'évènement sur la carte
            map.un("click", function () {
                self._formContainer.className = "";
            });
        }
    };
    /** click sur le label */
    document.getElementById("GPlocationOriginLabel_1-" + this._uid).onclick = function () {
        self._clearGeojsonLayer();
        self._formContainer.className = "";
        // on désactive l'écouteur d'événements sur la carte (pour ne pas placer un marker au clic)
        map.un("click", function () {
            self._formContainer.className = "";
        });
    };
    /** click sur la zone de saisie */
    document.getElementById("GPlocationOrigin_1-" + this._uid).onclick = function () {
        self._clearGeojsonLayer();
    };
    return this._originPoint._container;
};

// ################################################################### //
// ####################### handlers events to dom #################### //
// ################################################################### //

/**
 * this method is called by event 'submit' on 'GPisochronForm' tag form
 * (cf. this._createIsoPanelFormElement),
 * and call isocurve service to display results
 *
 * @private
 */
Isocurve.prototype.onIsoComputationSubmit = function () {
    // si on n'a pas de valeur récupérée pour notre point origine, on ne fait rien
    if (!this._originPoint || !this._originPoint.getCoordinate || !this._originPoint.getCoordinate()) {
        logger.log("[Isocurve] Missing position parameter to submit isocurve request");
        return;
    }

    // récupération de l'origine
    var positionCoordinates = this._originPoint.getCoordinate();
    var position = {
        x: positionCoordinates[0],
        y: positionCoordinates[1]
    };
    logger.log("origin : ", position);

    // récupération du temps ou de la distance
    var time;
    var distance;
    if (this._currentComputation.toLowerCase() === "time") {
        var timeHourInput = document.getElementById("GPisochronValueChronInput1-" + this._uid);
        var hours = parseInt(timeHourInput.value, 10);
        if (isNaN && isNaN(hours)) {
            hours = 0;
        }
        var timeMinutesInput = document.getElementById("GPisochronValueChronInput2-" + this._uid);
        var minutes = parseInt(timeMinutesInput.value, 10);
        if (isNaN && isNaN(minutes)) {
            minutes = 0;
        }
        // durée exprimée en secondes
        time = hours * 3600 + minutes * 60;
        logger.log("time : " + time);
    }
    if (this._currentComputation.toLowerCase() === "distance") {
        var distInput = document.getElementById("GPisochronValueDistInput-" + this._uid);
        // distance exprimée en mètres
        distance = parseFloat(distInput.value) * 1000;
        logger.log("distance : " + distance);
    }

    // si on n'a pas de valeur de calcul renseignée, on ne lance pas la requête.
    if (!time && !distance) {
        logger.log("[Isocurve] Missing time or distance parameter to submit isocurve request");
        return;
    }

    // oups, aucun droits !
    // on evite donc une requête inutile ...
    if (this._noRightManagement) {
        logger.log("[Isocurve] no rights for this service");
        return;
    }

    // on recupere les éventuelles options du service passées par l'utilisateur
    var options = this.options.isocurveOptions || {};

    // gestion du protocole et du timeout
    // le timeout est indispensable sur le protocole JSONP.
    var _protocol = options.protocol || "XHR";
    var _timeout = options.timeOut || 0;
    if (_protocol === "JSONP" && _timeout === 0) {
        // FIXME le timeout est obligatoire pour ce type de protocole...
        _timeout = 15000;
    }

    // on met en place l'affichage des resultats dans la fenetre de resultats.
    var context = this;
    var isoRequestOptions = {
        position: position,
        graph: options.graph || this._currentTransport,
        exclusions: options.exclusions || this._currentExclusions,
        method: options.method || this._currentComputation,
        smoothing: options.smoothing || true,
        timeOut: _timeout,
        protocol: _protocol,
        // callback onSuccess
        onSuccess: function onSuccess(results) {
            logger.log(results);
            if (results) {
                context._drawIsoResults(results);
            }
        },
        // callback onFailure
        onFailure: function onFailure(error) {
            // FIXME mise à jour du controle mais le service ne repond pas en 200 !?
            context._hideWaitingContainer();
            logger.log(error.message);
        }
    };
    if (this._currentDirection.toLowerCase() === "arrival" || options.reverse) {
        isoRequestOptions.reverse = true;
    }
    if (time) {
        isoRequestOptions.time = time;
    }
    if (distance) {
        isoRequestOptions.distance = distance;
    }

    this._requestIsoCurve(isoRequestOptions);
};

/**
 * this method is called by event 'click' on 'GPshowIsochronPicto' picto
 * (cf. this._createShowIsoPictoElement),
 * and clear inputs and previous isocurve drawings
 *
 * @private
 */
Isocurve.prototype.onShowIsoPanelClick = function () {
    this.collapsed = this._showIsoContainer.checked;
    // on génère nous même l'evenement OpenLayers de changement de propriété
    // (utiliser ol.control.Isocurve.on("change:collapsed", function ) pour s'abonner à cet évènement)
    this.dispatchEvent("change:collapsed");
};

/**
 * this method is called by event 'change' on 'GPisochronChoiceAltDist' or 'GPisochronChoiceAltChron'
 * input (cf. this._createIsoPanelFormTypeChoiceElement),
 * and updates current computation mode
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Isocurve.prototype.onIsoTypeChoiceChange = function (e) {
    var value = e.target.value;
    if (!value) {
        return;
    }
    if (value === "isodistance") {
        this._currentComputation = "distance";
    }
    if (value === "isochron") {
        this._currentComputation = "time";
    }
};

/**
 * this method is called by event 'click' on 'GPisochronTransportPedestrian' or 'GPisochronTransportCar'
 * input (cf. this._createIsoPanelFormModeChoiceTransportElement),
 * and updates current transport mode
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Isocurve.prototype.onIsoModeTransportChange = function (e) {
    var value = e.target.value;
    if (!value) {
        return;
    }
    this._currentTransport = value;
};

/**
 * this method is called by event 'change' on 'GPisochronDirectionSelect' select
 * (cf. this._createIsoPanelFormModeChoiceDirectionElement),
 * and updates current direction mode
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Isocurve.prototype.onIsoModeDirectionChange = function (e) {
    var value = e.target.value;
    if (!value) {
        return;
    }
    if (value.toLowerCase() === "arrival") {
        this._originPoint._inputLabelContainer.innerHTML = "Arrivée";
    } else {
        this._originPoint._inputLabelContainer.innerHTML = "Départ";
    }
    this._currentDirection = value;
};

/**
 * this method is called by event 'change' on 'GPIsoExclusionsToll'
 * or 'GPIsoeExclusionsTunnel' or 'GPIsoExclusionsBridge' tag input
 * (cf. this._createIsoPanelFormExclusionOptionsElement).
 * this value is saved as a parameter for the service isocurve.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
Isocurve.prototype.onIsoExclusionsChange = function (e) {
    var value = e.target.value;
    var checked = e.target.checked;

    if (!value) {
        return;
    }

    var bFound = false;
    var iFound = null;
    for (var i = 0; i < this._currentExclusions.length; i++) {
        if (this._currentExclusions[i] === value) {
            iFound = i;
            bFound = true;
        }
    }
    // on l'ajoute si la valeur n'existe pas et est selectionnée
    if (!bFound && !checked) {
        this._currentExclusions.push(value);
    }
    // on la retire si la valeur existe et est deselectionnée
    if (bFound && checked) {
        this._currentExclusions[iFound] = null;
    }
};

/**
 * this method is called by event 'click' on 'GPisoReset'
 * tag label (cf. this._createIsoFormResetElement),
 * and it cleans all isochron input options and results.
 *
 * @private
 */
Isocurve.prototype.onIsoResetClick = function () {
    // clear
    this._clear();
};

// ################################################################### //
// ######################## isocurve calculation ##################### //
// ################################################################### //

/**
 * this method is called by this.onIsoComputationSubmit
 * and executes a request to the service.
 *
 * @param {Object} options - isocurve service request options
 * @private
 */
Isocurve.prototype._requestIsoCurve = function (options) {
    // on ne fait pas de requête si on n'a pas renseigné de parametres !
    if (!options || (typeof options === "undefined" ? "undefined" : _typeof(options)) === "object" && Object.keys(options).length === 0) {
        return;
    }
    // on ne fait pas de requête si on n'a pas de point d'origine
    if (!options.position) {
        return;
    }
    // ni si on n'a aucun droit
    if (this._noRightManagement || !this._resources["Isocurve"]) {
        logger.log("no rights for this service");
        return;
    }

    // gestion des droits !
    var resources = this._resources["Isocurve"].resources;
    if (!resources || (typeof resources === "undefined" ? "undefined" : _typeof(resources)) === "object" && Object.keys(resources).length === 0) {
        logger.log("no rights for this service");
        return;
    }

    // la ressource donne elle des droits ?
    var bFound = false;
    for (var i = 0; i < resources.length; i++) {
        if (resources[i] === options.graph) {
            bFound = true;
        }
    }
    // on fait quoi ?
    if (!bFound) {
        logger.log("no rights for this service !?");
        return;
    }

    // cas où la clef API n'est pas renseignée dans les options du service,
    // on utilise celle de l'autoconf ou celle renseignée au niveau du controle
    var key = this._resources["Isocurve"]["key"];
    options.apiKey = this.options.isocurveOptions.apiKey || this.options.apiKey || key;

    logger.log(options);

    // on efface une éventuelle précédente couche
    this._clearGeojsonLayer();

    // mise en place de la patience
    this._displayWaitingContainer();

    // appel du service de calcul d'isochrones
    _gp2.default.Services.isoCurve(options);
};

/**
 * this method is called by this.onIsoComputationSubmit (in case of success)
 * and draw isocurve results geometry on map
 *
 * @param {Object} results - isocurve response results
 * @private
 */
Isocurve.prototype._drawIsoResults = function (results) {
    // sauvegarde de l'etat des resultats
    this._currentIsoResults = results;
    // cache la patience
    this._hideWaitingContainer();

    if (!results.geometry) {
        return;
    }

    var map = this.getMap();

    // 1. création de l'objet geoJSON
    var geojsonObject = {
        type: "Feature",
        crs: {
            type: "name",
            properties: {
                name: "EPSG:4326"
            }
        },
        geometry: results.geometry
    };
    var geojsonformat = new _ol2.default.format.GeoJSON({
        defaultDataProjection: "EPSG:4326"
    });
    var mapProj = map.getView().getProjection().getCode();
    var features = geojsonformat.readFeatures(geojsonObject, {
        dataProjection: "EPSG:4326",
        featureProjection: mapProj
    });

    // 2. ajout de la géométrie comme nouvelle couche vecteur à la carte
    this._geojsonLayer = new _ol2.default.layer.Vector({
        source: new _ol2.default.source.Vector({
            features: features
        }),
        style: this._defaultFeatureStyle,
        opacity: 0.9
    });
    // ajout d'un identifiant à la couche
    var graph;
    if (this._currentTransport === "Pieton") {
        graph = "piéton";
        this._geojsonLayer.gpResultLayerId = "Pieton$GEOPORTAIL:GPP:Isocurve";
    } else {
        graph = "voiture";
        this._geojsonLayer.gpResultLayerId = "Voiture$GEOPORTAIL:GPP:Isocurve";
    }
    // ajout à la carte
    map.addLayer(this._geojsonLayer);

    // 3. Zoom sur l'emprise de la geometry
    if (features[0] && features[0].getGeometry() && features[0].getGeometry().getExtent()) {
        var extent = features[0].getGeometry().getExtent();
        map.getView().fit(extent, map.getSize());
    }

    // 5. Si un layer switcher est présent dans la carte, on lui affecte des informations pour cette couche
    var method = this._currentComputation === "time" ? "Isochrone" : "Isodistance";
    map.getControls().forEach(function (control) {
        if (control instanceof _LayerSwitcher2.default) {
            // un layer switcher est présent dans la carte
            var layerId = this._geojsonLayer.gpLayerId;
            // on n'ajoute des informations que s'il n'y en a pas déjà (si le titre est le numéro par défaut)
            if (control._layers[layerId].title === layerId) {
                control.addLayer(this._geojsonLayer, {
                    title: this.options.layerDescription.title + " (" + method + "/" + graph + ")",
                    description: this.options.layerDescription.description
                });
            }
        }
    }, this);
};

// ################################################################### //
// ############################# Clean ############################### //
// ################################################################### //

/**
 * this method is called by this.onShowIsoPanelClick()
 * and it clears all elements (reinit).
 *
 * @private
 */
Isocurve.prototype._clear = function () {
    // clear inputs
    this._clearIsoInputs();

    // clear origin point (and marker)
    this._originPoint.clear();

    // remove geometry layer
    this._clearGeojsonLayer();

    // clear results
    this._currentIsoResults = null;
};

/**
 * this method is called by this._clear()
 * and it clears all input elements (dist and time)
 *
 * @private
 */
Isocurve.prototype._clearIsoInputs = function () {
    // 1. clear inputs
    // clear time inputs (if exists) :
    // hours
    var timeHourInput = document.getElementById("GPisochronValueChronInput1-" + this._uid);
    if (timeHourInput) {
        timeHourInput.value = "0";
    }
    // minutes
    var timeMinutesInput = document.getElementById("GPisochronValueChronInput2-" + this._uid);
    if (timeMinutesInput) {
        timeMinutesInput.value = "0";
    }
    // clear distance input (if exists)
    var distInput = document.getElementById("GPisochronValueDistInput-" + this._uid);
    if (distInput) {
        distInput.value = "0";
    }

    // 2. reinit options to default
    this._initTransport();
    this._initComputation();
    this._initDirection();
    this._initExclusions();

    // 3. set transport mode to default
    var transportdiv;
    if (this._currentTransport === "Pieton") {
        transportdiv = document.getElementById("GPisochronTransportPedestrian-" + this._uid);
        if (transportdiv) {
            transportdiv.checked = "true";
        }
    } else {
        transportdiv = document.getElementById("GPisochronTransportCar-" + this._uid);
        if (transportdiv) {
            transportdiv.checked = "true";
        }
    }

    // 4. set computation mode to default (distance or time)
    var computationdiv;
    if (this._currentComputation.toLowerCase() === "distance") {
        computationdiv = document.getElementById("GPisochronChoiceAltDist-" + this._uid);
        if (computationdiv) {
            computationdiv.checked = "true";
        }
        if (document.getElementById("GPisochronValueDist-" + this._uid)) {
            document.getElementById("GPisochronValueDist-" + this._uid).className = "GPflexInput";
        }
        if (document.getElementById("GPisochronValueChron-" + this._uid)) {
            document.getElementById("GPisochronValueChron-" + this._uid).className = "GPisochronValueHidden";
        }
    } else {
        computationdiv = document.getElementById("GPisochronChoiceAltChron-" + this._uid);
        if (computationdiv) {
            computationdiv.checked = "true";
        }
        if (document.getElementById("GPisochronValueChron-" + this._uid)) {
            document.getElementById("GPisochronValueChron-" + this._uid).className = "GPflexInput";
        }
        if (document.getElementById("GPisochronValueDist-" + this._uid)) {
            document.getElementById("GPisochronValueDist-" + this._uid).className = "GPisochronValueHidden";
        }
    }

    // 5. set direction mode to default (arrival or departure)
    var directionSelect = document.getElementById("GPisochronDirectionSelect-" + this._uid);
    if (directionSelect) {
        directionSelect.value = this._currentDirection;
    }
    if (this._currentDirection === "arrival") {
        this._originPoint._inputLabelContainer.innerHTML = "Arrivée";
    } else {
        this._originPoint._inputLabelContainer.innerHTML = "Départ";
    }

    // 6. set exclusions to default
    var tollInput = document.getElementById("GPisoExclusionsToll-" + this._uid);
    if (tollInput) {
        if (this._currentExclusions.indexOf("toll") !== -1) {
            tollInput.checked = false;
        } else {
            tollInput.checked = true;
        }
    }
    var tunnelInput = document.getElementById("GPisoExclusionsTunnel-" + this._uid);
    if (tunnelInput) {
        if (this._currentExclusions.indexOf("tunnel") !== -1) {
            tunnelInput.checked = false;
        } else {
            tunnelInput.checked = true;
        }
    }
    var bridgeInput = document.getElementById("GPisoExclusionsBridge-" + this._uid);
    if (bridgeInput) {
        if (this._currentExclusions.indexOf("bridge") !== -1 && bridgeInput) {
            bridgeInput.checked = false;
        } else {
            bridgeInput.checked = true;
        }
    }
};

/**
 * this method is called by this.onIsoComputationSubmit (in case of failure)
 * and it clears all geometries
 *
 * @private
 */
Isocurve.prototype._clearGeojsonLayer = function () {
    var map = this.getMap();
    // remove layer
    if (this._geojsonLayer) {
        map.removeLayer(this._geojsonLayer);
        this._geojsonLayer = null;
    }
};

/**
 * this method is called by event 'click' on control main container
 * and hide suggested Locations (unless target is an autocomplete input)
 *
 * @param {Object} e - event
 *
 * @private
 */
Isocurve.prototype._hideIsoSuggestedLocations = function (e) {
    // si on clique sur l'input de saisie du point d'origine
    if (e.target && e.target.id && e.target.id.indexOf("GPlocationOrigin_") !== -1) {} else {
        // si on clique ailleurs dans le DOM du control, on cache tous les résultats d'autocomplétion
        this._originPoint._hideSuggestedLocation();
    }
};

/**
 * this method displays waiting container and sets a timeout
 *
 * @private
 */
Isocurve.prototype._displayWaitingContainer = function () {
    this._waitingContainer.className = "GPisochronCalcWaitingContainerVisible";
    this._waiting = true;

    // mise en place d'un timeout pour réinitialiser le panel (cacher la patience)
    // si on est toujours en attente (si la requête est bloquée par exemple)
    var opts = this.options.isocurveOptions;
    if (opts && opts.timeOut) {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
        var context = this;
        this._timer = setTimeout(function () {
            if (context._waiting === true) {
                context._hideWaitingContainer();
            } else {
                if (context._timer) {
                    clearTimeout(context._timer);
                }
            }
        }, 16000);
    }
};

/**
 * this method hides waiting container and clears timeout
 *
 * @private
 */
Isocurve.prototype._hideWaitingContainer = function () {
    if (this._waiting) {
        this._waitingContainer.className = "GPisochronCalcWaitingContainerHidden";
        this._waiting = false;
        var opts = this.options.isocurveOptions;
        if (opts && opts.timeOut) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    }
};

exports.default = Isocurve;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var IsoDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPisochron");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################# Methods to display Main Panel ################### //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing panel
     *
     * @returns {DOMElement} DOM element
     */
    _createShowIsoElement: function _createShowIsoElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowIsochron");
        input.type = "checkbox";
        return input;
    },

    /**
     * Show iso control
     * see event !
     *
     * @returns {DOMElement} DOM element
     */
    _createShowIsoPictoElement: function _createShowIsoPictoElement() {
        // contexte d'execution
        var context = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowIsochronPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowIsochron");
        label.title = "Calculer une isochrone";

        // gestionnaire d'evenement :
        // on ouvre le menu de saisie du calcul d'isochrone
        // L'ouverture/Fermeture permet de faire le menage
        // (reinitialisation)
        if (label.addEventListener) {
            label.addEventListener("click", function (e) {
                context.onShowIsoPanelClick(e);
            });
        } else if (label.attachEvent) {
            label.attachEvent("onclick", function (e) {
                context.onShowIsoPanelClick(e);
            });
        }

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowIsochronOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    },

    // ################################################################### //
    // ################## Methods to display Inputs Panel ################ //
    // ################################################################### //

    /**
     * Create Container Panel
     *
     * FIXME
     * don't call this._createIsoPanelHeaderElement
     * don't call this._createIsoPanelFormElement
     *
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelElement: function _createIsoPanelElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPisochronPanel");
        div.className = "GPpanel";

        // div.appendChild(this._createIsoPanelHeaderElement());
        // div.appendChild(this._createIsoPanelFormElement());

        return div;
    },

    /**
     * Create Header Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelHeaderElement: function _createIsoPanelHeaderElement() {
        var self = this;

        var container = document.createElement("div");
        container.className = "GPpanelHeader";

        var div = document.createElement("div");
        div.className = "GPpanelTitle";
        div.innerHTML = "Calcul d'isochrone";
        container.appendChild(div);

        // on desactive l'impl. reduction de la fenetre
        // var divReduce  = document.createElement("div");
        // divReduce.id = this._addUID("GPisochronPanelReduce");
        // divReduce.className = "GPpanelReduce";
        // divReduce.title = "Masquer le panneau";
        //
        // if (divReduce.addEventListener) {
        //     divReduce.addEventListener("click", function () {
        //         if ( typeof self.onReduceIsoPanelClick === "function") {
        //             document.getElementById(self._addUID("GPshowIsochron")).checked = false;
        //             self.onReduceIsoPanelClick();
        //         }
        //     }, false);
        // } else if (divReduce.attachEvent) {
        //     divReduce.attachEvent("onclick", function () {
        //         if ( typeof self.onReduceIsoPanelClick === "function") {
        //             document.getElementById(self._addUID("GPshowIsochron")).checked = false;
        //             self.onReduceIsoPanelClick();
        //         }
        //     });
        // }
        // container.appendChild(divReduce);

        var divClose = document.createElement("div");
        divClose.id = this._addUID("GPisochronPanelClose");
        divClose.className = "GPpanelClose";
        divClose.title = "Fermer le panneau";

        // Link panel close / visibility checkbox
        if (divClose.addEventListener) {
            divClose.addEventListener("click", function () {
                document.getElementById(self._addUID("GPshowIsochronPicto")).click();
            }, false);
        } else if (divClose.attachEvent) {
            divClose.attachEvent("onclick", function () {
                document.getElementById(self._addUID("GPshowIsochronPicto")).click();
            });
        }
        container.appendChild(divClose);

        return container;
    },

    /**
     * Create Form
     * see evenement !
     *
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormElement: function _createIsoPanelFormElement() {
        // contexte d'execution
        var self = this;

        var form = document.createElement("form");
        form.id = this._addUID("GPisochronForm");

        form.addEventListener("submit", function (e) {
            e.preventDefault();
            self.onIsoComputationSubmit(e);
            return false;
        });

        return form;
    },

    /**
     * Create Waiting Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createIsoWaitingElement: function _createIsoWaitingElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPisochronCalcWaitingContainer");
        div.className = "GPisochronCalcWaitingContainerHidden";

        var p = document.createElement("p");
        p.className = "GPisochronCalcWaiting";
        p.innerHTML = "Calcul en cours...";

        div.appendChild(p);

        return div;
    },

    // ################################################################### //
    // ############# Methods to the type choice into form ################ //
    // ################################################################### //

    /**
     * Create Container to type choice
     *
     * FIXME
     * don't call this._createIsoPanelFormTypeChoiceChronElement
     * don't call this._createIsoPanelFormTypeChoiceDistElement
     *
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormTypeChoiceElement: function _createIsoPanelFormTypeChoiceElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPisochronChoice");

        // div.appendChild(this._createIsoPanelFormTypeChoiceChronElement());
        // div.appendChild(this._createIsoPanelFormTypeChoiceDistElement());

        return div;
    },

    /**
     * Create Type choice Chron
     * see event !
     * FIXME event not useful
     * @param {Boolean} checked - checked
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormTypeChoiceChronElement: function _createIsoPanelFormTypeChoiceChronElement(checked) {
        var self = this;

        var div = document.createElement("div");
        div.className = "GPisochronChoiceAlt";

        var input = document.createElement("input");
        input.id = this._addUID("GPisochronChoiceAltChron");
        input.name = "GPisochronChoiceMode";
        input.type = "radio";
        input.checked = !!checked;
        if (input.addEventListener) {
            input.addEventListener("change", function (e) {
                document.getElementById(self._addUID("GPisochronValueChron")).className = "GPflexInput";
                document.getElementById(self._addUID("GPisochronValueDist")).className = "GPisochronValueHidden";
                self.onIsoTypeChoiceChange(e);
            }, false);
        } else if (input.attachEvent) {
            input.attachEvent("onchange", function () {
                document.getElementById(self._addUID("GPisochronValueChron")).className = "GPflexInput";
                document.getElementById(self._addUID("GPisochronValueDist")).className = "GPisochronValueHidden";
                self.onIsoTypeChoiceChange();
            });
        }
        // info: Internet explorer support
        input.value = "isochron";
        div.appendChild(input);

        var label = document.createElement("label");
        label.className = "GPisochronChoiceAltImg";
        label.htmlFor = this._addUID("GPisochronChoiceAltChron");
        div.appendChild(label);

        var span = document.createElement("span");
        span.id = this._addUID("GPisochronChoiceAltChronTxt");
        span.innerHTML = "isochrone";
        if (span.addEventListener) {
            span.addEventListener("click", function () {
                document.getElementById(self._addUID("GPisochronChoiceAltChron")).click();
            }, false);
        } else if (span.attachEvent) {
            span.attachEvent("onclick", function () {
                document.getElementById(self._addUID("GPisochronChoiceAltChron")).click();
            });
        }
        div.appendChild(span);

        return div;
    },

    /**
     * Create Type choice Dist
     * see event !
     * FIXME event not useful
     * @param {Boolean} checked - checked
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormTypeChoiceDistElement: function _createIsoPanelFormTypeChoiceDistElement(checked) {
        var self = this;

        var div = document.createElement("div");
        div.className = "GPisochronChoiceAlt";

        var input = document.createElement("input");
        input.id = this._addUID("GPisochronChoiceAltDist");
        input.name = "GPisochronChoiceMode";
        input.type = "radio";
        input.checked = !!checked;
        if (input.addEventListener) {
            input.addEventListener("change", function (e) {
                document.getElementById(self._addUID("GPisochronValueDist")).className = "GPflexInput";
                document.getElementById(self._addUID("GPisochronValueChron")).className = "GPisochronValueHidden";
                self.onIsoTypeChoiceChange(e);
            }, false);
        } else if (input.attachEvent) {
            input.attachEvent("onchange", function () {
                document.getElementById(self._addUID("GPisochronValueDist")).className = "GPflexInput";
                document.getElementById(self._addUID("GPisochronValueChron")).className = "GPisochronValueHidden";
                self.onIsoTypeChoiceChange();
            });
        }
        // info: Internet explorer support
        input.value = "isodistance";
        div.appendChild(input);

        var label = document.createElement("label");
        label.className = "GPisochronChoiceAltImg";
        label.htmlFor = this._addUID("GPisochronChoiceAltDist");
        div.appendChild(label);

        var span = document.createElement("span");
        span.id = this._addUID("GPisochronChoiceAltDistTxt");
        span.innerHTML = "isodistance";
        if (span.addEventListener) {
            span.addEventListener("click", function () {
                document.getElementById(self._addUID("GPisochronChoiceAltDist")).click();
            }, false);
        } else if (span.attachEvent) {
            span.attachEvent("onclick", function () {
                document.getElementById(self._addUID("GPisochronChoiceAltDist")).click();
            });
        }
        div.appendChild(span);

        return div;
    },

    // ################################################################### //
    // ############### Methods to the value iso into form ################ //
    // ################################################################### //

    /**
     * Create isochron inputs values
     * see event !
     * @param {Boolean} checked - checked
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormValueIsochronElement: function _createIsoPanelFormValueIsochronElement(checked) {
        // contexte
        var context = this;

        var div = document.createElement("div");
        div.id = this._addUID("GPisochronValueChron");
        div.className = checked ? "GPflexInput" : "GPisochronValueHidden";

        var label = document.createElement("label");
        label.id = this._addUID("GPisochronValueChronLabel");
        label.htmlFor = this._addUID("GPisochronValueChronInput");
        label.innerHTML = "Temps";
        div.appendChild(label);

        var input1 = document.createElement("input");
        input1.id = this._addUID("GPisochronValueChronInput1");
        input1.min = "0";
        input1.step = "1";
        input1.value = "0";
        input1.type = "number";
        if (input1.addEventListener) {
            input1.addEventListener("change", function (e) {
                if (typeof context.onIsoValueChronTimeMinuteChange === "function") {
                    context.onIsoValueChronTimeHourChange(e);
                }
            });
        } else if (input1.attachEvent) {
            input1.attachEvent("onchange", function (e) {
                if (typeof context.onIsoValueChronTimeMinuteChange === "function") {
                    context.onIsoValueChronTimeHourChange(e);
                }
            });
        }
        div.appendChild(input1);

        var label1 = document.createElement("label");
        label1.innerHTML = "h";
        div.appendChild(label1);

        var input2 = document.createElement("input");
        input2.id = this._addUID("GPisochronValueChronInput2");
        input2.min = "0";
        input2.max = "59";
        input2.step = "1";
        input2.value = "0";
        input2.type = "number";
        if (input2.addEventListener) {
            input2.addEventListener("change", function (e) {
                if (typeof context.onIsoValueChronTimeMinuteChange === "function") {
                    context.onIsoValueChronTimeMinuteChange(e);
                }
            });
        } else if (input2.attachEvent) {
            input2.attachEvent("onchange", function (e) {
                if (typeof context.onIsoValueChronTimeMinuteChange === "function") {
                    context.onIsoValueChronTimeMinuteChange(e);
                }
            });
        }
        div.appendChild(input2);

        var label2 = document.createElement("label");
        label2.innerHTML = "min";
        div.appendChild(label2);

        return div;
    },

    /**
     * Create isodistance inputs values
     * see event !
     * @param {Boolean} checked - checked
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormValueIsodistanceElement: function _createIsoPanelFormValueIsodistanceElement(checked) {
        // contexte
        var context = this;

        var div = document.createElement("div");
        div.id = this._addUID("GPisochronValueDist");
        div.className = checked ? "GPflexInput" : "GPisochronValueHidden";

        var label = document.createElement("label");
        label.id = this._addUID("GPisochronValueDistLabel");
        label.htmlFor = this._addUID("GPisochronValueDistInput");
        label.innerHTML = "Distance";
        div.appendChild(label);

        var input1 = document.createElement("input");
        input1.id = this._addUID("GPisochronValueDistInput");
        input1.min = "0";
        input1.step = "any";
        input1.value = "0";
        input1.type = "number";
        if (input1.addEventListener) {
            input1.addEventListener("change", function (e) {
                if (typeof context.onIsoValueDistChange === "function") {
                    context.onIsoValueDistChange(e);
                }
            });
        } else if (input1.attachEvent) {
            input1.attachEvent("onchange", function (e) {
                if (typeof context.onIsoValueDistChange === "function") {
                    context.onIsoValueDistChange(e);
                }
            });
        }
        div.appendChild(input1);

        var label1 = document.createElement("label");
        label1.innerHTML = "km";
        div.appendChild(label1);

        return div;
    },

    // ################################################################### //
    // ############ Methods to the mode choice into form ################# //
    // ################################################################### //

    /**
     * Create Container to Mode choice
     *
     * FIXME
     * don't call this._createIsoPanelFormModeChoiceTransportElement
     * don't call this._createIsoPanelFormModeChoiceDirectionElement
     *
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormModeChoiceElement: function _createIsoPanelFormModeChoiceElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPisochronModeChoice");

        // div.appendChild(this._createIsoPanelFormModeChoiceTransportElement());
        // div.appendChild(this._createIsoPanelFormModeChoiceDirectionElement());

        return div;
    },

    /**
     * Create Mode choice transport
     * see event !
     * FIXME event not useful
     * @param {Array} transports - transports in a list
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormModeChoiceTransportElement: function _createIsoPanelFormModeChoiceTransportElement(transports) {
        // contexte d'execution
        var context = this;

        var div = document.createElement("div");
        div.id = this._addUID("GPisochronTransportChoice");

        var span = document.createElement("span");
        span.className = "GPisochronModeLabel";
        span.innerHTML = "Mode de transport";
        div.appendChild(span);

        /* jshint -W083 */
        for (var i = 0; i < transports.length; i++) {
            var transport = transports[i];

            if (transport === "Voiture") {
                var inputCar = document.createElement("input");
                inputCar.id = this._addUID("GPisochronTransportCar");
                inputCar.type = "radio";
                inputCar.name = "GPisochronTransport";
                if (i === 0) {
                    inputCar.checked = true;
                }
                // gestionnaire d'evenement :
                // on stocke le mode de transport,
                // utilisation pour la requête sur le service de calcul d'itiniraire
                if (inputCar.addEventListener) {
                    inputCar.addEventListener("change", function (e) {
                        context.onIsoModeTransportChange(e);
                    });
                } else if (inputCar.attachEvent) {
                    inputCar.attachEvent("onchange", function (e) {
                        context.onIsoModeTransportChange(e);
                    });
                }
                // info : internet explorer support
                inputCar.value = "Voiture";
                div.appendChild(inputCar);

                var labelCar = document.createElement("label");
                labelCar.className = "GPisochronTransportImg";
                labelCar.htmlFor = this._addUID("GPisochronTransportCar");
                labelCar.title = "Voiture";
                div.appendChild(labelCar);
            }

            if (transport === "Pieton") {
                var inputPedestrian = document.createElement("input");
                inputPedestrian.id = this._addUID("GPisochronTransportPedestrian");
                inputPedestrian.type = "radio";
                inputPedestrian.name = "GPisochronTransport";
                if (i === 0) {
                    inputPedestrian.checked = true;
                }
                // gestionnaire d'evenement :
                // on stocke le mode de transport,
                // utilisation pour la requête sur le service de calcul d'itiniraire
                if (inputPedestrian.addEventListener) {
                    inputPedestrian.addEventListener("change", function (e) {
                        context.onIsoModeTransportChange(e);
                    });
                } else if (inputPedestrian.attachEvent) {
                    inputPedestrian.attachEvent("onchange", function (e) {
                        context.onIsoModeTransportChange(e);
                    });
                }
                // info : internet explorer support
                inputPedestrian.value = "Pieton";
                div.appendChild(inputPedestrian);

                var labelPedestrian = document.createElement("label");
                labelPedestrian.className = "GPisochronTransportImg";
                labelPedestrian.htmlFor = this._addUID("GPisochronTransportPedestrian");
                labelPedestrian.title = "Piéton";
                div.appendChild(labelPedestrian);
            }
        }

        return div;
    },

    /**
     * Create Mode choice direction
     * see event!
     *
     * @param {Array} directions - directions to display in list ("Departure", "Arrival"). First element will be selected by default
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormModeChoiceDirectionElement: function _createIsoPanelFormModeChoiceDirectionElement(directions) {
        // contexte d'execution
        var self = this;

        var div = document.createElement("div");
        div.id = this._addUID("GPisochronDirectionChoice");

        var span = document.createElement("span");
        span.className = "GPisochronModeLabel";
        span.innerHTML = "Sens de parcours";
        div.appendChild(span);

        var select = document.createElement("select");
        select.id = this._addUID("GPisochronDirectionSelect");
        select.className = "GPinputSelect";
        // gestionnaire d'evenement :
        // on stocke la valeur du mode de calcul,
        // utilisation pour la requête sur le service de calcul d'iso
        select.addEventListener("change", function (e) {
            self.onIsoModeDirectionChange(e);
        });

        for (var i = 0; i < directions.length; i++) {
            var direction = directions[i];
            if (direction.toLowerCase() === "departure") {
                var departureOption = document.createElement("option");
                if (i === 0) {
                    departureOption.selected = "selected";
                }
                departureOption.value = "departure";
                departureOption.text = "Départ";
                select.appendChild(departureOption);
            }
            if (direction.toLowerCase() === "arrival") {
                var arrivalOption = document.createElement("option");
                if (i === 0) {
                    arrivalOption.selected = "selected";
                }
                arrivalOption.value = "arrival";
                arrivalOption.text = "Arrivée";
                select.appendChild(arrivalOption);
            }
        }
        div.appendChild(select);

        return div;
    },

    // ################################################################### //
    // ################# Methods to the choice exclusions ################ //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing Exclusions Options
     *
     * @returns {DOMElement} DOM element
     */
    _createShowIsoExclusionsElement: function _createShowIsoExclusionsElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowIsoExclusions");
        input.type = "checkbox";
        return input;
    },

    /**
     * Label to Exclusions Options
     *
     * @returns {DOMElement} DOM element
     */
    _createShowIsoExclusionsPictoElement: function _createShowIsoExclusionsPictoElement() {
        var label = document.createElement("label");
        label.id = this._addUID("GPshowIsoExclusionsPicto");
        label.className = "GPshowMoreOptions GPshowIsoExclusionsPicto";
        label.htmlFor = this._addUID("GPshowIsoExclusions");
        label.title = "Exclusions";
        label.style.top = "240px";

        return label;
    },

    /**
     * Create Container to Exclusions
     *
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormExclusionsElement: function _createIsoPanelFormExclusionsElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPisoExclusions");

        var span = document.createElement("span");
        span.className = "GPisoExclusionsLabel";
        span.innerHTML = "Passages autorisés";
        div.appendChild(span);

        // div.appendChild(this._createIsoPanelFormExclusionOptionsElement());

        return div;
    },

    /**
     * Create Exclusions Options
     * see event !
     * FIXME event not useful
     * @param {Array} exclusions - exclusions to display in list
     * @returns {DOMElement} DOM element
     */
    _createIsoPanelFormExclusionOptionsElement: function _createIsoPanelFormExclusionOptionsElement(exclusions) {
        // contexte d'execution
        var context = this;

        var div = document.createElement("div");
        div.className = "GPisoExclusionsOptions";

        /* jshint -W083 */
        for (var value in exclusions) {
            if (exclusions.hasOwnProperty(value)) {
                var status = exclusions[value];
                switch (value) {
                    case "toll":
                        var inputToll = document.createElement("input");
                        inputToll.id = this._addUID("GPisoExclusionsToll");
                        inputToll.type = "checkbox";
                        inputToll.checked = !status;
                        // gestionnaire d'evenement :
                        // on stocke l'exclusion,
                        // utilisation pour la requête sur le service de calcul d'itiniraire
                        if (inputToll.addEventListener) {
                            inputToll.addEventListener("change", function (e) {
                                context.onIsoExclusionsChange(e);
                            });
                        } else if (inputToll.attachEvent) {
                            inputToll.attachEvent("onchange", function (e) {
                                context.onIsoExclusionsChange(e);
                            });
                        }
                        // info : internet explorer support
                        inputToll.value = "Toll";
                        div.appendChild(inputToll);

                        var labelToll = document.createElement("label");
                        labelToll.className = "GPisoExclusionsOption";
                        labelToll.htmlFor = this._addUID("GPisoExclusionsToll");
                        labelToll.innerHTML = "Péages";
                        div.appendChild(labelToll);
                        break;

                    case "tunnel":
                        var inputTunnel = document.createElement("input");
                        inputTunnel.id = this._addUID("GPisoExclusionsTunnel");
                        inputTunnel.type = "checkbox";
                        inputTunnel.checked = !status;
                        // gestionnaire d'evenement :
                        // on stocke l'exclusion,
                        // utilisation pour la requête sur le service de calcul d'itiniraire
                        if (inputTunnel.addEventListener) {
                            inputTunnel.addEventListener("change", function (e) {
                                context.onIsoExclusionsChange(e);
                            });
                        } else if (inputTunnel.attachEvent) {
                            inputTunnel.attachEvent("onchange", function (e) {
                                context.onIsoExclusionsChange(e);
                            });
                        }
                        // info : internet explorer support
                        inputTunnel.value = "Tunnel";
                        div.appendChild(inputTunnel);

                        var labelTunnel = document.createElement("label");
                        labelTunnel.className = "GPisoExclusionsOption";
                        labelTunnel.htmlFor = this._addUID("GPisoExclusionsTunnel");
                        labelTunnel.innerHTML = "Tunnels";
                        div.appendChild(labelTunnel);
                        break;

                    case "bridge":
                        var inputBridge = document.createElement("input");
                        inputBridge.id = this._addUID("GPisoExclusionsBridge");
                        inputBridge.type = "checkbox";
                        inputBridge.checked = !status;
                        // gestionnaire d'evenement :
                        // on stocke l'exclusion,
                        // utilisation pour la requête sur le service de calcul d'itiniraire
                        if (inputBridge.addEventListener) {
                            inputBridge.addEventListener("change", function (e) {
                                context.onIsoExclusionsChange(e);
                            });
                        } else if (inputBridge.attachEvent) {
                            inputBridge.attachEvent("onchange", function (e) {
                                context.onIsoExclusionsChange(e);
                            });
                        }
                        // info : internet explorer support
                        inputBridge.value = "Bridge";
                        div.appendChild(inputBridge);

                        var labelBridge = document.createElement("label");
                        labelBridge.className = "GPisoExclusionsOption";
                        labelBridge.htmlFor = this._addUID("GPisoExclusionsBridge");
                        labelBridge.innerHTML = "Ponts";
                        div.appendChild(labelBridge);
                        break;
                }
            }
        }

        return div;
    },

    // ################################################################### //
    // ############################### Submit Form ####################### //
    // ################################################################### //

    /**
     * Create Submit Form Element
     *
     * @returns {DOMElement} DOM element
     */
    _createIsoSubmitFormElement: function _createIsoSubmitFormElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPisochronSubmit");
        input.className = "GPinputSubmit";
        input.type = "submit";
        input.value = "Calculer";

        return input;
    },

    // ################################################################### //
    // ############################### Reset picto ####################### //
    // ################################################################### //

    /**
     * Create Reset Picto Element
     *
     * @returns {DOMElement} DOM element
     */
    _createIsoFormResetElement: function _createIsoFormResetElement() {
        var self = this;

        var divReset = document.createElement("div");
        divReset.id = this._addUID("GPisochronReset");
        divReset.title = "Réinitialiser les paramètres";
        divReset.addEventListener("click", function (e) {
            self.onIsoResetClick(e);
        });

        return divReset;
    }
};

exports.default = IsoDOM;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _Markers = __webpack_require__(5);

var _Markers2 = _interopRequireDefault(_Markers);

var _LayerSwitcher = __webpack_require__(6);

var _LayerSwitcher2 = _interopRequireDefault(_LayerSwitcher);

var _CheckRightManagement = __webpack_require__(7);

var _CheckRightManagement2 = _interopRequireDefault(_CheckRightManagement);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _ReverseGeocodingDOM = __webpack_require__(49);

var _ReverseGeocodingDOM2 = _interopRequireDefault(_ReverseGeocodingDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("reversegeocoding");

/**
 * @classdesc
 *
 * ReverseGeocode Control.
 *
 * @constructor
 * @alias ol.control.ReverseGeocode
 * @extends {ol.control.Control}
 * @param {Object} options - ReverseGeocode control options
 * @param {String}   [options.apiKey] - API key for services call (reverse geocode service), mandatory if autoconf service has not been charged in advance
 * @param {Boolean} [options.collapsed = true] - Specify if widget has to be collapsed (true) or not (false) on map loading. Default is true.
 * @param {Object}   [options.resources =  ["StreetAddress", "PositionOfInterest", "CadastralParcel"]] - resources for geocoding, by default : ["StreetAddress", "PositionOfInterest", "CadastralParcel"]. Possible values are : "StreetAddress", "PositionOfInterest", "CadastralParcel", "Administratif". Resources will be displayed in the same order in widget list.
 * @param {Object}   [options.delimitations = ["Point", "Circle", "Extent"]] - delimitations for reverse geocoding, by default : ["Point", "Circle", "Extent"]. Possible values are : "Point", "Circle", "Extent". Delimitations will be displayed in the same order in widget list.
 * @param {Object}  [options.reverseGeocodeOptions = {}] - reverse geocode service options. see {@link http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~reverseGeocode Gp.Services.reverseGeocode()} to know all reverse geocode options.
 * @param {Object} [options.layerDescription = {}] - Layer informations to be displayed in LayerSwitcher widget (only if a LayerSwitcher is also added to the map)
 * @param {String} [options.layerDescription.title = "Saisie (recherche inverse)"] - Layer title to be displayed in LayerSwitcher
 * @param {String} [options.layerDescription.description = "Couche de saisie d'une zone de recherche pour la recherche inverse"] - Layer description to be displayed in LayerSwitcher
 * @example
 *  var iso = ol.control.ReverseGeocode({
 *      collapsed : false,
 *      resources : ["StreetAddress", "PositionOfInterest"],
 *      delimitations : ["Point", "Circle"],
 *      reverseGeocodeOptions : {}
 *  });
 */
function ReverseGeocode(options) {
    options = options || {};

    if (!(this instanceof ReverseGeocode)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // initialisation du composant
    this.initialize(options);

    // Widget main DOM container
    this._container = this._initContainer();
    this._containerElement = null;

    // on peut éventuellement encapsuler le composant dans une div passée par l'utilisateur
    if (options.element && options.element.appendChild) {
        // dans ce cas on stocke les deux container
        options.element.appendChild(this._container);
        this._containerElement = options.element;
    }

    // call ol.control.Control constructor
    _ol2.default.control.Control.call(this, {
        element: this._containerElement || this._container,
        target: options.target,
        render: options.render
    });
};

// Inherits from ol.control.Control
_ol2.default.inherits(ReverseGeocode, _ol2.default.control.Control);

/**
 * @lends module:ReverseGeocode
 */
ReverseGeocode.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les méthodes de la classe commune ReverseGeocodingDOM
_Utils2.default.assign(ReverseGeocode.prototype, _ReverseGeocodingDOM2.default);

/**
 * Constructor (alias)
 *
 * @private
 */
ReverseGeocode.prototype.constructor = ReverseGeocode;

// ################################################################### //
// ############## public methods (getters, setters) ################## //
// ################################################################### //

/**
 * Returns true if widget is collapsed (minimized), false otherwise
 *
 * @returns {Boolean} collapsed - true if widget is collapsed
 */
ReverseGeocode.prototype.getCollapsed = function () {
    return this.collapsed;
};

/**
 * Collapse or display widget main container
 *
 * @param {Boolean} collapsed - True to collapse widget, False to display it
 */
ReverseGeocode.prototype.setCollapsed = function (collapsed) {
    if (collapsed === undefined) {
        logger.log("[ERROR] ReverseGeocode:setCollapsed - missing collapsed parameter");
        return;
    }
    if (collapsed && this.collapsed || !collapsed && !this.collapsed) {
        return;
    }
    if (collapsed) {
        document.getElementById("GPreverseGeocodingPanelClose-" + this._uid).click();
    } else {
        document.getElementById("GPshowReverseGeocoding-" + this._uid).click();
    }
    this.collapsed = collapsed;
};

/**
 * Overwrite OpenLayers setMap method
 *
 * @param {ol.Map} map - Map.
 */
ReverseGeocode.prototype.setMap = function (map) {
    if (map) {
        // lors de l'ajout à la map, on active la saisie du point ou de la zone de recherche sur la carte,
        // mais seulement si le widget est ouvert
        this._activateMapInteraction(map);
    } else {
        var _map = this.getMap();
        // on remet à zéro = on efface les géométries + interactions + valeurs stockées
        // suppression des résultats précédents
        this._clearResults();
        // on efface les points qui ont pu être saisis précédemment
        this._clearInputFeatures();
        // on supprime l'éventuelle précédente interaction
        this._removeMapInteraction(_map);
        // on retire aussi la couche de saisie de la zone de recherche à la fermeture du widget
        if (this._inputFeaturesLayer != null) {
            _map.removeLayer(this._inputFeaturesLayer);
            this._inputFeaturesLayer = null;
            this._inputFeaturesSources = null;
            this._inputFeatures = null;
        }
    }

    // on appelle la méthode setMap originale d'OpenLayers
    _ol2.default.control.Control.prototype.setMap.call(this, map);
};

// ################################################################### //
// ##################### init component ############################## //
// ################################################################### //

/**
 * Initialize ReverseGeocode control (called by ReverseGeocode constructor)
 *
 * @param {Object} options - constructor options
 * @private
 */
ReverseGeocode.prototype.initialize = function (options) {
    // ############################################################ //
    // ################### Options du composant ################### //

    // check input options format (resources and delimitations arrays)
    this._checkInputOptions(options);

    // set default options
    this.options = {
        collapsed: true,
        resources: ["StreetAddress", "PositionOfInterest", "CadastralParcel"],
        delimitations: ["Point", "Circle", "Extent"],
        reverseGeocodeOptions: {},
        layerDescription: {
            title: "Saisie (recherche inverse)",
            description: "Couche de saisie d'une zone de recherche pour la recherche inverse"
        }
    };

    // merge with user options
    _Utils2.default.assign(this.options, options);

    /** {Boolean} specify if reverseGeocoding control is collapsed (true) or not (false) */
    this.collapsed = this.options.collapsed;

    // identifiant du contrôle : utile pour suffixer les identifiants CSS (pour gérer le cas où il y en a plusieurs dans la même page)
    this._uid = _SelectorID2.default.generate();

    // #################################################################### //
    // ################### informations sur les droits #################### //

    // ressources des services d'autocompletion et de geocodage
    this._servicesRightManagement = {};

    // gestion des droits sur les ressources
    this._noRightManagement = false;

    // gestion des droits sur les ressources/services
    this._checkRightsManagement();

    // #################################################################### //
    // ################### informations sur les droits #################### //

    // Type de géocodage sélectionné (StreetAddress, PositionOfInterest, ...)
    this._currentGeocodingType = null;
    this._initGeocodingType();

    // Type de délimitation à utiliser pour la requête + pour sélection sur la containerDistance
    this._currentGeocodingDelimitation = null;
    this._initGeocodingDelimitation();

    // ################################################################## //
    // ################### Elements principaux du DOM ################### //

    // containers principaux
    this._showReverseGeocodingInput = null;
    // header panel
    this._panelHeaderContainer = null;
    this._panelTitleContainer = null;
    this._returnPictoContainer = null;
    // form
    this._formContainer = null;
    // results
    this._resultsContainer = null;
    this._resultsListContainer = null;
    // waiting
    this._waitingContainer = null;

    // ###################################################################### //
    // ################### informations des points saisis ################### //

    // collection des points saisis sur la carte
    this._inputFeatures = null;
    // source contenant les features ci-dessus
    this._inputFeaturesSource = null;
    // couche vectorielle dans laquelle seront saisis les points (features ci-dessus)
    this._inputFeaturesLayer = null;
    // interaction avec la carte (de type "Point", "Circle" ou "Polygon")
    this._mapInteraction = null;

    // #################################################################### //
    // ################### informations pour la requête ################### //

    // options pour la requête de géocodage inverse
    this._requestOptions = null;
    // position du géocodage inverse qui sera envoyée dans la requête
    this._requestPosition = null;
    // eventuels filtres géométriques saisis par l'utilisateur : cercle ou bbox
    this._requestCircleFilter = null;
    this._requestBboxFilter = null;
    // pour savoir si un calcul est en cours ou non
    this._waiting = false;
    // timer pour cacher la patience après un certain temps
    this._timer = null;

    // #################################################################### //
    // #################### informations des résultats #################### //

    this._reverseGeocodingLocations = [];
    this._reverseGeocodingLocationsMarkers = [];
    this._resultsDefaultStyle = new _ol2.default.style.Style({
        image: new _ol2.default.style.Icon({
            src: _Markers2.default["lightOrange"],
            anchor: [0.5, 1]
        })
    });
    this._resultsSelectedStyle = new _ol2.default.style.Style({
        image: new _ol2.default.style.Icon({
            src: _Markers2.default["red"],
            anchor: [0.5, 1]
        })
    });
    this._resultsHoverInteraction = null;
    this._resultsSelectInteraction = null;
    // container de la popup (affichage des infos au clic sur les markers)
    this._popupContent = null;
    this._popupDiv = this._initPopupDiv();
    this._popupOverlay = null;
};

/**
 * this method is called by this.initialize()
 * and makes sure input options are correctly formated
 *
 * @param {Object} options - options
 *
 * @private
 */
ReverseGeocode.prototype._checkInputOptions = function (options) {
    var i;
    var j;

    // on vérifie le tableau des resources
    if (options.resources) {
        var resources = options.resources;
        // on vérifie que la liste des ressources de geocodage est bien un tableau
        if (!Array.isArray(resources)) {
            logger.log("[ReverseGeocode] 'options.resources' parameter should be an array");
            resources = null;
        }
        var resourcesList = ["StreetAddress", "PositionOfInterest", "CadastralParcel", "Administratif"];
        var wrongResourcesIndexes = [];
        for (i = 0; i < resources.length; i++) {
            if (resourcesList.indexOf(resources[i]) === -1) {
                // si la resource n'est pas référencée, on stocke son index pour la retirer du tableau (après avoir terminé de parcourir le tableau)
                wrongResourcesIndexes.push(i);
                logger.log("[ReverseGeocode] options.resources : " + resources[i] + " is not a resource for reverse geocode");
            }
        }
        // on retire les ressoures non référencées qu'on a pu rencontrer
        if (wrongResourcesIndexes.length !== 0) {
            for (j = 0; j < wrongResourcesIndexes.length; j++) {
                resources.splice(wrongResourcesIndexes[j], 1);
            }
        }
    }

    // et le tableau des délimitations
    if (options.delimitations) {
        var delimitations = options.delimitations;
        // on vérifie que la liste des delimitations est bien un tableau
        if (!Array.isArray(delimitations)) {
            logger.log("[ReverseGeocode] 'options.delimitations' parameter should be an array");
            delimitations = null;
        }
        var delimitationsList = ["Circle", "Point", "Extent"];
        var wrongDelimitationsIndexes = [];
        for (i = 0; i < delimitations.length; i++) {
            if (delimitationsList.indexOf(delimitations[i]) === -1) {
                // si la delimitations n'est pas référencée, on stocke son index pour la retirer du tableau (après avoir terminé de parcourir le tableau)
                wrongDelimitationsIndexes.push(i);
                logger.log("[ReverseGeocode] options.delimitations : " + delimitations[i] + " is not a delimitation for reverse geocode");
            }
        }
        // on retire les ressoures non référencées qu'on a pu rencontrer
        if (wrongDelimitationsIndexes.length !== 0) {
            for (j = 0; j < wrongDelimitationsIndexes.length; j++) {
                delimitations.splice(wrongDelimitationsIndexes[j], 1);
            }
        }
    }
};

/**
 * this method is called by this.initialize() and initialize geocoding type (=resource)
 * ("StreetAddress", "PositionOfInterest", "CadastralParcel", "Administratif")
 *
 * @private
 */
ReverseGeocode.prototype._initGeocodingType = function () {
    // Type de géocodage selectionné
    this._currentGeocodingType = "StreetAddress"; // par defaut

    // par defaut
    var resources = this.options.resources;
    if (!resources || resources.length === 0) {
        this.options.resources = ["StreetAddress", "PositionOfInterest", "CadastralParcel"];
    }

    // options utilisateur
    if (Array.isArray(resources) && resources.length) {
        // vérification des droits
        var noRightsIndexes = [];
        for (var i = 0; i < resources.length; i++) {
            if (this._servicesRightManagement["Geocode"].indexOf(resources[i]) < 0) {
                // si on n'a pas les droits sur la ressource, on va la supprimer : on stocke son index
                noRightsIndexes.push(i);
                logger.log("[ReverseGeocode] no rights for options.resources : " + resources[i]);
            }
        }
        // on retire les ressoures non autorisées qu'on a pu rencontrer
        if (noRightsIndexes.length !== 0) {
            for (var j = 0; j < noRightsIndexes.length; j++) {
                resources.splice(noRightsIndexes[j], 1);
            }
        }

        // récupération du type par défaut
        if (resources[0] === "StreetAddress" || resources[0] === "PositionOfInterest" || resources[0] === "CadastralParcel" || resources[0] === "Administratif") {
            this._currentGeocodingType = resources[0];
        }
    }

    // si l'utilisateur a spécifié au moins une ressource dans le service, on surcharge les options du widget
    var serviceOptions = this.options.reverseGeocodeOptions;
    if (serviceOptions.filterOptions && Array.isArray(serviceOptions.filterOptions.type) && serviceOptions.filterOptions.type.length !== 0) {
        this._currentGeocodingType = serviceOptions.filterOptions.type[0];
    }
};

/**
 * this method is called by this.initialize() and initialize geocoding delimitation
 * ("Point", "Circle", "Extent")
 *
 * @private
 */
ReverseGeocode.prototype._initGeocodingDelimitation = function () {
    // Type de délimitation selectionné
    this._currentGeocodingDelimitation = "Point"; // par defaut

    // par defaut
    var delimitations = this.options.delimitations;
    if (!delimitations || delimitations.length === 0) {
        this.options.delimitations = ["Point", "Circle", "Extent"];
    }

    // options utilisateur
    if (Array.isArray(delimitations) && delimitations.length) {
        var d = delimitations[0].toLowerCase();
        if (d === "point" || d === "circle" || d === "extent") {
            this._currentGeocodingDelimitation = delimitations[0];
        }
    }
};

/**
 * this method is called by this.initialize() and initialize popup div
 * (to display results information on marker click)
 *
 * @return {Object} element - DOM element for popup
 * @private
 */
ReverseGeocode.prototype._initPopupDiv = function () {
    var context = this;
    var element = document.createElement("div");
    element.className = "gp-feature-info-div";
    var closer = document.createElement("input");
    closer.type = "button";
    closer.className = "gp-styling-button closer";
    // on closer click : remove popup
    closer.onclick = function () {
        if (context._popupOverlay != null) {
            context._popupOverlay.setPosition(undefined);
        }
        return false;
    };
    this._popupContent = document.createElement("div");
    this._popupContent.className = "gp-features-content-div";
    element.appendChild(this._popupContent);
    element.appendChild(closer);

    return element;
};

/**
 * Check rights to resources (called by this.initialize())
 *
 * @private
 */
ReverseGeocode.prototype._checkRightsManagement = function () {
    var _resources = [];
    var _key;
    var _opts = null;

    // les ressources du service de geocodage
    _key = this.options.reverseGeocodeOptions.apiKey;
    _opts = this.options.reverseGeocodeOptions.filterOptions;
    // on récupère les éventuelles ressources passées en option, soit dans reverseGeocodeOptions :
    _resources = _opts ? _opts.type : [];
    // soit directement dans options.resources.geocode :
    if (!_resources || _resources.length === 0) {
        _resources = this.options.resources;
    }
    // ou celles par défaut sinon.
    if (!_resources || _resources.length === 0) {
        _resources = ["StreetAddress", "PositionOfInterest"];
    }
    var rightManagementGeocode = _CheckRightManagement2.default.check({
        key: _key || this.options.apiKey,
        resources: _resources,
        services: ["Geocode"]
    });
    logger.log("rightManagementGeocode", rightManagementGeocode);

    // aucun droit !
    if (!rightManagementGeocode) {
        this._noRightManagement = true;
        return;
    }

    // on recupère les informations utiles
    // Ex. la clef API issue de l'autoconfiguration si elle n'a pas
    // été renseignée.
    if (!this.options.apiKey) {
        this.options.apiKey = rightManagementGeocode.key;
    }

    if (rightManagementGeocode) {
        this._servicesRightManagement["Geocode"] = rightManagementGeocode["Geocode"];
    }
};

/**
 * Create control main container (DOM initialize)
 *
 * @returns {DOMElement} DOM element
 *
 * @private
 */
ReverseGeocode.prototype._initContainer = function () {
    // create main container
    var container = this._createMainContainerElement();

    // create show ReverseGeocode element
    var inputShow = this._showReverseGeocodingInput = this._createShowReverseGeocodingElement();
    container.appendChild(inputShow);

    // mode "collapsed"
    if (!this.collapsed) {
        inputShow.checked = true;
    }

    // create ReverseGeocode picto
    var picto = this._createShowReverseGeocodingPictoElement();
    container.appendChild(picto);

    // panel
    var reverseGeocodingPanel = this._createReverseGeocodingPanelElement();

    // header
    var panelHeader = this._panelHeaderContainer = this._createReverseGeocodingPanelHeaderElement();
    // return picto (hidden at start)
    var returnPicto = this._returnPictoContainer = this._createReverseGeocodingPanelReturnPictoElement();
    panelHeader.appendChild(returnPicto);
    // pane title
    var panelTitle = this._panelTitleContainer = this._createReverseGeocodingPanelTitleElement();
    panelHeader.appendChild(panelTitle);
    // close picto
    var closeDiv = this._createReverseGeocodingPanelCloseElement();
    panelHeader.appendChild(closeDiv);
    reverseGeocodingPanel.appendChild(panelHeader);

    // form
    var reverseGeocodingForm = this._formContainer = this._createReverseGeocodingPanelFormElement();
    // choices element
    reverseGeocodingForm.appendChild(this._createReverseGeocodingFormModeChoiceGeocodingTypeElement(this.options.resources));
    reverseGeocodingForm.appendChild(this._createReverseGeocodingFormModeChoiceGeocodingDelimitationElement(this.options.delimitations));

    // submit (bouton "Chercher")
    var submit = this._createReverseGeocodingSubmitFormElement();
    reverseGeocodingForm.appendChild(submit);

    reverseGeocodingPanel.appendChild(reverseGeocodingForm);

    // waiting
    var waiting = this._waitingContainer = this._createReverseGeocodingWaitingElement();
    reverseGeocodingPanel.appendChild(waiting);

    // results (dans le panel)
    var resultsPanel = this._resultsContainer = this._createReverseGeocodingResultsPanelElement();
    var reverseGeocodingResultsList = this._resultsListContainer = this._createReverseGeocodingResultsListElement();
    resultsPanel.appendChild(reverseGeocodingResultsList);
    reverseGeocodingPanel.appendChild(resultsPanel);

    container.appendChild(reverseGeocodingPanel);

    logger.log(container);

    return container;
};

// ################################################################### //
// ################### Map interactions management ################### //
// ################################################################### //

/**
 * this method is called by this.setMap,
 * or by this.onShowReverseGeocodingClick,
 * and calls method corresponding to current delimitation, if widget is not collapsed.
 *
 * @param {ol.Map} map - control map.
 * @private
 */
ReverseGeocode.prototype._activateMapInteraction = function (map) {
    if (!this.collapsed) {
        // 1. Creation de la couche vectorielle sur laquelle on va dessiner
        if (this._inputFeaturesLayer == null) {
            // on crée une collection, qui accueillera les points saisis sur la carte par les interactions,
            // sous formes de features (dans une couche vectorielle).
            // on les stocke de sorte à pouvoir les supprimer facilement
            this._inputFeatures = new _ol2.default.Collection();

            // on crée la couche qui va accueillir les features
            this._inputFeaturesSource = new _ol2.default.source.Vector({
                features: this._inputFeatures
            });
            this._inputFeaturesLayer = new _ol2.default.layer.Vector({
                source: this._inputFeaturesSource,
                style: new _ol2.default.style.Style({
                    fill: new _ol2.default.style.Fill({
                        color: "rgba(0, 183, 152, 0.3)"
                    }),
                    stroke: new _ol2.default.style.Stroke({
                        color: "rgba(0, 183, 152, 0.8)",
                        width: 3
                    }),
                    image: new _ol2.default.style.Icon({
                        src: _Markers2.default["turquoiseBlue"],
                        anchor: [0.5, 1]
                    })
                })
            });
            // on rajoute le champ gpResultLayerId permettant d'identifier une couche crée par le composant. (pour layerSwitcher par ex)
            this._inputFeaturesLayer.gpResultLayerId = "reverseGeocoding";
            // on ajoute la couche à la carte
            map.addLayer(this._inputFeaturesLayer);
        }

        // 2. Création de l'interaction de dessin, selon le type de délimitation sélectionné
        var delimitation = this._currentGeocodingDelimitation.toLowerCase();
        switch (delimitation) {
            case "point":
                this._activatePointInteraction(map);
                break;
            case "circle":
                this._activateCircleInteraction(map);
                break;
            case "extent":
                this._activateBoxInteraction(map);
                break;
            default:
                break;
        }

        // 3. Si un layer switcher est présent dans la carte, on lui affecte des informations pour cette couche
        map.getControls().forEach(function (control) {
            if (control instanceof _LayerSwitcher2.default) {
                // un layer switcher est présent dans la carte
                var layerId = this._inputFeaturesLayer.gpLayerId;
                // on n'ajoute des informations que s'il n'y en a pas déjà (si le titre est le numéro par défaut)
                if (control._layers[layerId].title === layerId) {
                    control.addLayer(this._inputFeaturesLayer, {
                        title: this.options.layerDescription.title,
                        description: this.options.layerDescription.description
                    });
                    control.setRemovable(this._inputFeaturesLayer, false);
                }
            }
        }, this);
    }
};

/**
 * this method is called by this._activateMapInteraction,
 * and creates map point drawing interaction.
 *
 * @param {ol.Map} map - control map.
 * @private
 */
ReverseGeocode.prototype._activatePointInteraction = function (map) {
    // interaction permettant de dessiner un point
    this._mapInteraction = new _ol2.default.interaction.Draw({
        style: new _ol2.default.style.Style({
            image: new _ol2.default.style.Circle({
                radius: 0,
                fill: new _ol2.default.style.Fill({
                    color: "rgba(0, 183, 152, 0.8)"
                })
            })
        }),
        type: "Point",
        source: this._inputFeaturesSource
    });

    this._mapInteraction.on("drawstart", function (e) {
        logger.log("on drawstart ", e);

        // on efface les points qui ont pu être saisis précédemment (on vide la collection des features de la couche)
        this._inputFeatures.clear();

        // on récupère les coordonnées du point qui vient d'être saisi
        this._onDrawStart(e, "point");
    }, this);

    map.addInteraction(this._mapInteraction);
    this._setCursor("crosshair", map);
};

/**
 * this method is called by this._activateMapInteraction,
 * and creates map circle drawing interaction.
 *
 * @param {ol.Map} map - control map.
 * @private
 */
ReverseGeocode.prototype._activateCircleInteraction = function (map) {
    // interaction permettant de dessiner un cercle
    this._mapInteraction = new _ol2.default.interaction.Draw({
        style: new _ol2.default.style.Style({
            fill: new _ol2.default.style.Fill({
                color: "rgba(0, 183, 152, 0.3)"
            }),
            stroke: new _ol2.default.style.Stroke({
                color: "rgba(0, 183, 152, 0.8)",
                width: 3
            }),
            image: new _ol2.default.style.Circle({
                radius: 4,
                fill: new _ol2.default.style.Fill({
                    color: "rgba(0, 183, 152, 0.8)"
                })
            })
        }),
        type: "Circle",
        source: this._inputFeaturesSource
    });

    this._mapInteraction.on("drawstart", function (e) {
        logger.log("on drawstart ", e);
        // on efface les points qui ont pu être saisis précédemment (on vide la collection des features de la couche)
        this._inputFeatures.clear();
        // on récupère les coordonnées du centre du cercle = premier point du tracé
        this._onDrawStart(e, "circle");
    }, this);

    this._mapInteraction.on("drawend", function (e) {
        logger.log("on drawend", e);

        // on récupère le rayon du cercle qui vient d'être tracé
        if (e.feature && e.feature.getGeometry) {
            var radius = e.feature.getGeometry().getRadius();
            // et on le stocke comme filtre pour la requête
            this._requestCircleFilter = {};
            this._requestCircleFilter.radius = radius;
            if (this._requestPosition) {
                this._requestCircleFilter.x = this._requestPosition.x;
                this._requestCircleFilter.y = this._requestPosition.y;
            }
            logger.log("circle radius : ", radius);
        }
    }, this);

    map.addInteraction(this._mapInteraction);
};

/**
 * this method is called by this._activateMapInteraction,
 * and creates map box drawing interaction.
 *
 * @param {ol.Map} map - control map.
 * @private
 */
ReverseGeocode.prototype._activateBoxInteraction = function (map) {
    // info : il n'y a pas de geometry de type rectangle, donc on va créer un objet de type "LineString",
    // avec seulement 2 points qui formeront les extrémités du rectangle.
    // on aura donc une géométrie LineString avec 5 coordonnées : start, point2, end, point4, start,
    // où les coordonnées de point2 et point4 sont calculées à partir de start et end, et start est répété à la fin pour fermer la géométrie.

    // function to draw rectangle with only 2 points
    var geometryFunction = function geometryFunction(coordinates, geometry) {
        if (!geometry) {
            geometry = new _ol2.default.geom.Polygon(null);
        }
        var start = coordinates[0];
        var end = coordinates[1];
        // on crée les 5 coordonnées de la ligne à partir des 2 points saisis.
        geometry.setCoordinates([[start, [start[0], end[1]], end, [end[0], start[1]], start]]);
        return geometry;
    };

    // interaction permettant de dessiner un rectangle (= LineString de 5 points, à partir de 2 points saisis)
    this._mapInteraction = new _ol2.default.interaction.Draw({
        style: new _ol2.default.style.Style({
            fill: new _ol2.default.style.Fill({
                color: "rgba(0, 183, 152, 0.3)"
            }),
            stroke: new _ol2.default.style.Stroke({
                color: "rgba(0, 183, 152, 0.8)",
                width: 3
            }),
            image: new _ol2.default.style.Circle({
                radius: 4,
                fill: new _ol2.default.style.Fill({
                    color: "rgba(0, 183, 152, 0.8)"
                })
            })
        }),
        type: "LineString",
        source: this._inputFeaturesSource,
        maxPoints: 2,
        geometryFunction: geometryFunction
    });

    this._mapInteraction.on("drawstart", function (e) {
        logger.log("on drawstart", e);
        // on efface les points qui ont pu être saisis précédemment (on vide la collection des features de la couche)
        this._inputFeatures.clear();
    }, this);

    this._mapInteraction.on("drawend", function (e) {
        logger.log("on drawend", e);
        // on va récupérer les coordonnées du rectangle qui vient d'être tracé
        this._onBoxDrawEnd(e);
    }, this);

    map.addInteraction(this._mapInteraction);
};

/**
 * remove draw interaction from map (if exists)
 *
 * @param {ol.Map} map - control map.
 * @private
 */
ReverseGeocode.prototype._removeMapInteraction = function (map) {
    if (this._mapInteraction != null) {
        map.removeInteraction(this._mapInteraction);
        this._mapInteraction = null;
    }
    this._setCursor();
};

/**
 * this method is called by event 'drawstart' on map point or circle drawing interaction
 * (cf. this._activatePointInteraction), and it gets map click coordinates.
 * this point is saved as a parameter for reverse Geocode service.
 *
 * @param {Object} e - HTMLElement
 * @param {String} type - geometry type : "point" or "circle"
 * @private
 */
ReverseGeocode.prototype._onDrawStart = function (e, type) {
    var coordinate;
    if (e.feature && e.feature.getGeometry) {
        var geometry = e.feature.getGeometry();
        if (type === "point") {
            coordinate = geometry.getCoordinates();
        }
        if (type === "circle") {
            coordinate = geometry.getCenter();
        }
    }
    if (!coordinate) {
        return;
    }

    var crs;
    if (this.options.reverseGeocodeOptions && this.options.reverseGeocodeOptions.srs) {
        crs = this.options.reverseGeocodeOptions.srs;
    } else {
        var map = this.getMap();
        if (!map || !map.getView()) {
            return;
        }
        crs = map.getView().getProjection();
    }

    var geoCoordinate = _ol2.default.proj.transform(coordinate, crs, "EPSG:4326");
    this._requestPosition = {
        x: geoCoordinate[0],
        y: geoCoordinate[1]
    };
    logger.log("position coordinates : ", this._requestPosition);
};

/**
 * this method is called by event 'drawend' on map box drawing interaction
 * (cf. this._activateBoxInteraction), and it gets geometry coordinates,
 * to be saved as a filter parameter for reverse Geocode service.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
ReverseGeocode.prototype._onBoxDrawEnd = function (e) {
    // on va récupérer les coordonnées du rectangle qui vient d'être tracé
    if (e.feature && e.feature.getGeometry) {
        // info: coordinates est un tableau [start, point2, end, point4, start]
        // car c'est une linestring donc on a 5 coordonnées pour boucler
        var coordinates = e.feature.getGeometry().getCoordinates()[0];
        var start = coordinates[0];
        var end = coordinates[2];

        var crs;
        if (this.options.reverseGeocodeOptions && this.options.reverseGeocodeOptions.srs) {
            crs = this.options.reverseGeocodeOptions.srs;
        } else {
            var map = this.getMap();
            if (!map || !map.getView()) {
                return;
            }
            crs = map.getView().getProjection();
        }

        // on reprojette les coordonnées des deux extrémités du rectangle (start et end)
        var startGeoCoordinate = _ol2.default.proj.transform(start, crs, "EPSG:4326");
        var endGeoCoordinate = _ol2.default.proj.transform(end, crs, "EPSG:4326");

        this._requestPosition = {};
        this._requestBboxFilter = {};
        // on récupère les valeurs left, right, top et bottom, pour le filtre bbox du service reverseGeocode
        if (startGeoCoordinate[0] < endGeoCoordinate[0]) {
            this._requestBboxFilter.left = startGeoCoordinate[0];
            this._requestBboxFilter.right = endGeoCoordinate[0];
        } else {
            this._requestBboxFilter.left = endGeoCoordinate[0];
            this._requestBboxFilter.right = startGeoCoordinate[0];
        }
        if (startGeoCoordinate[1] < endGeoCoordinate[1]) {
            this._requestBboxFilter.bottom = startGeoCoordinate[1];
            this._requestBboxFilter.top = endGeoCoordinate[1];
        } else {
            this._requestBboxFilter.bottom = endGeoCoordinate[1];
            this._requestBboxFilter.top = startGeoCoordinate[1];
        }

        // ainsi que le centre du rectangle pour le paramètre "position" du service reverseGeocode
        this._requestPosition.x = (startGeoCoordinate[0] + endGeoCoordinate[0]) / 2;
        this._requestPosition.y = (startGeoCoordinate[1] + endGeoCoordinate[1]) / 2;
        logger.log("bbox filter : ", this._requestBboxFilter);

        logger.log("center coordinates : ", this._requestPosition);
    }
};

/**
 * this change the cursor of the map when entering a point.
 *
 * @param {String} cursor - cursor style
 * @param {ol.Map} map - control map (optional)
 * @private
 */
ReverseGeocode.prototype._setCursor = function (cursor, map) {
    map = map || this.getMap();
    if (!map) {
        return;
    }
    var div = map.getTargetElement();

    if (cursor) {
        div.style.cursor = cursor;
    } else {
        div.style.cursor = null;
    }
};

// ################################################################### //
// ##################### Reverse Geocoding request ################### //
// ################################################################### //

/**
 * this methode is called by this.onReverseGeocodingSubmit method,
 * it generates and sends reverse geocode request, then displays results
 *
 * @private
 */
ReverseGeocode.prototype._reverseGeocodingRequest = function () {
    var map = this.getMap();

    // on construit les options pour la requête
    this._requestOptions = this._getReverseGeocodingRequestOptions();

    // retrait de l'interaction sur la map pendant l'attente (et l'affichage des résultats)
    this._removeMapInteraction(map);
    // affichage d'une patience pendant l'attente
    this._displayWaitingContainer();

    // envoi de la requête
    _gp2.default.Services.reverseGeocode(this._requestOptions);
};

/**
 * this methode is called by this._reverseGeocodingRequest method,
 * and returns options object for Gp.Services.reverseGeocode request
 *
 * @returns {Object} requestOptions - reverse geocode options
 * @private
 */
ReverseGeocode.prototype._getReverseGeocodingRequestOptions = function () {
    var map = this.getMap();

    // on recupere les éventuelles options du service passées par l'utilisateur
    var reverseGeocodeOptions = this.options.reverseGeocodeOptions;

    // on crée les options pour le service reverseGeocode
    var context = this;
    var requestOptions = {
        apiKey: reverseGeocodeOptions.apiKey || this.options.apiKey,
        position: this._requestPosition,
        filterOptions: {
            type: [this._currentGeocodingType]
        },
        srs: "CRS:84",
        returnFreeForm: false,
        maximumResponses: reverseGeocodeOptions.maximumResponses || 25,
        timeOut: reverseGeocodeOptions.timeOut || 30000,
        protocol: reverseGeocodeOptions.protocol || "XHR",
        // callback onSuccess
        onSuccess: function onSuccess(response) {
            if (response.locations) {
                logger.log("reverseGeocode results : ", response.locations);
                context._displayGeocodedLocations(response.locations);
            }
        },
        // callback onFailure
        onFailure: function onFailure(error) {
            // FIXME mise à jour du controle mais le service ne repond pas en 200 !?

            // on cache la patience
            context._hideWaitingContainer();

            // suppression d'éventuels résultats précédents
            context._clearResults();
            // on efface les points qui ont été saisis précédemment
            context._clearInputFeatures();

            // et on réactive l'interaction sur la map
            context._activateMapInteraction(map);
            logger.log(error.message);
        }
    };

    // on récupère d'éventuels filtres
    if (this._currentGeocodingDelimitation.toLowerCase() === "circle" && this._requestCircleFilter) {
        // FIXME : a confirmer !
        if (this._requestCircleFilter.radius > 1000) {
            logger.log("INFO : initial circle radius (" + this._requestCircleFilter.radius + ") limited to 1000m.");
            this._requestCircleFilter.radius = 1000;
        }
        requestOptions.filterOptions.circle = this._requestCircleFilter;
    }
    if (this._currentGeocodingDelimitation.toLowerCase() === "extent" && this._requestBboxFilter) {
        requestOptions.filterOptions.bbox = this._requestBboxFilter;
    }
    logger.log("reverseGeocode request options : ", requestOptions);

    return requestOptions;
};

/**
 * this method is called by this._reverseGeocodingRequest() (in case of reverse geocode success)
 * and display results : in both container list and map
 *
 * @param {Array} locations - array of geocoded locations (reverse geocode results)
 * @private
 */
ReverseGeocode.prototype._displayGeocodedLocations = function (locations) {
    // 1. on vide les résultats précédents
    this._clearResults();
    this._reverseGeocodingLocations = locations;

    // 2. cache de la patience et du formulaire
    this._formContainer.className = "GPreverseGeocodingComponentHidden";
    this._hideWaitingContainer();
    // affichage de la div des résultats (et changement du titre)
    this._panelTitleContainer.innerHTML = "Résultats de la recherche";
    this._returnPictoContainer.className = "";
    this._resultsContainer.className = "GPpanel";

    // 3. ajout de la liste des résultats dans le container des resultats
    this._fillGeocodedLocationListContainer(locations);

    // 4. affichage des résultats sur la carte (+ zoom ?)
    this._displayGeocodedLocationsOnMap(locations);
};

// ################################################################### //
// ############################# results list ######################## //
// ################################################################### //

/**
 * this method is called by this._displayGeocodedLocations()
 * and fills the container with results list
 *
 * @param {Array} locations - array of geocoded locations (reverse geocode results)
 * @private
 */
ReverseGeocode.prototype._fillGeocodedLocationListContainer = function (locations) {
    //  ajout de la liste des résultats dans le container des resultats
    for (var i = 0; i < locations.length; i++) {
        var location = locations[i];
        logger.log(location);
        // on récupère la description à afficher dans la liste
        var locationDescription = this._fillGeocodedLocationDescription(location);
        // on ajoute chaque résutat à la liste
        if (locationDescription.length !== 0) {
            this._createReverseGeocodingResultElement(locationDescription, i);
        }
    }
};

/**
 * this method is called by this._fillGeocodedLocationListContainer()
 * and fills location description (String), depending on matchType
 *
 * @param {Object} location - geocoded location (from reverse geocode results)
 * @returns {String} locationDescription - geocoded location description to be displayed
 * @private
 */
ReverseGeocode.prototype._fillGeocodedLocationDescription = function (location) {
    if (!location || !location.placeAttributes) {
        return;
    }
    var attr = location.placeAttributes;

    var locationDescription = "";
    // on sélectionne les infos à afficher selon le type
    switch (location.type) {
        case "StreetAddress":
            if (attr.street) {
                locationDescription += attr.number ? attr.number + " " : "";
                locationDescription += attr.street + ", ";
            }
            locationDescription += attr.postalCode + " " + attr.commune;
            break;

        case "PositionOfInterest":
            if (location.matchType === "City" && attr.commune) {
                locationDescription += attr.commune;
                locationDescription += attr.postalCode ? ", " + attr.postalCode : "";
            } else if (location.matchType === "Département" && attr.municipality) {
                locationDescription += attr.municipality;
                locationDescription += attr.postalCode ? ", " + attr.postalCode : "";
            } else if (location.matchType === "Toponym" && attr.municipality) {
                locationDescription += attr.municipality;
                locationDescription += attr.postalCode ? ", " + attr.postalCode : "";
                locationDescription += attr.commune ? " " + attr.commune : "";
            } else {
                locationDescription += attr.municipality ? attr.municipality : "";
            }
            locationDescription += attr.nature ? " (" + attr.nature + ") " : "";
            break;

        case "CadastralParcel":
            locationDescription += attr.cadastralParcel ? attr.cadastralParcel : "";
            locationDescription += attr.municipality ? " (" + attr.municipality + ")" : "";
            break;

        case "Administratif":
            locationDescription += attr.municipality ? attr.municipality : "";
            if (attr.inseeDepartment) {
                locationDescription += "(Département)";
            } else if (attr.inseeRegion) {
                locationDescription += "(Région)";
            }
            break;

        default:
            locationDescription += attr.municipality ? attr.municipality : "";
            break;
    };

    return locationDescription;
};

// ################################################################### //
// ######################## map results (markers) #################### //
// ################################################################### //

/**
 * this method is called by this._displayGeocodedLocations()
 * and display locations in map (markers)
 *
 * @param {Object} locations - geocoded locations (reverse geocode result)
 * @private
 */
ReverseGeocode.prototype._displayGeocodedLocationsOnMap = function (locations) {
    if (this._reverseGeocodingLocations.length !== 0) {
        var map = this.getMap();

        // 1. création de la couche où seront ajoutés les résultats
        this._createResultsLayer();
        // ajout de chaque résultat à la couche (marker)
        for (var i = 0; i < locations.length; i++) {
            this._addResultFeature(locations[i], i);
        }

        // 2. Zoom sur l'étendue des résultats (features)
        if (this._resultsFeatures.getLength() > 1) {
            if (this._resultsFeaturesSource && this._resultsFeaturesSource.getExtent) {
                var extent = this._resultsFeaturesSource.getExtent();
                map.getView().fit(extent, map.getSize());
            }
        } else {
            // dans le cas où on n'a qu'un seul résultat, l'étendue n'est pas définie, on zoome donc sur le résulat
            var feature = this._resultsFeatures.item(0);
            var coords = feature.getGeometry().getCoordinates();
            map.getView().setCenter(coords);
            map.getView().setZoom(17);
        }

        // 3. ajout des interactions (survol, click)
        // au survol : modification des styles (marker et list)
        this._resultsHoverInteraction = new _ol2.default.interaction.Select({
            condition: _ol2.default.events.condition.pointerMove,
            layers: [this._resultsFeaturesLayer]
        });
        this._resultsHoverInteraction.on("select", this._onResultsFeatureMouseOver, this);
        map.addInteraction(this._resultsHoverInteraction);

        // au click : affichage popup
        this._resultsSelectInteraction = new _ol2.default.interaction.Select({
            layers: [this._resultsFeaturesLayer]
        });
        this._resultsSelectInteraction.on("select", this._onResultsFeatureSelect, this);
        map.addInteraction(this._resultsSelectInteraction);

        // 4. Si un layer switcher est présent dans la carte, on lui affecte des informations pour cette couche
        var geocodeType = "";
        switch (this._currentGeocodingType) {
            case "StreetAddress":
                geocodeType = "adresses";
                break;
            case "PositionOfInterest":
                geocodeType = "toponymes";
                break;
            case "CadastralParcel":
                geocodeType = "parcelles cadastrales";
                break;
            case "Administratif":
                geocodeType = "unités administratives";
                break;
            default:
                break;
        }
        map.getControls().forEach(function (control) {
            if (control instanceof _LayerSwitcher2.default) {
                // un layer switcher est présent dans la carte
                var layerId = this._resultsFeaturesLayer.gpLayerId;
                // on n'ajoute des informations que s'il n'y en a pas déjà (si le titre est le numéro par défaut)
                if (control._layers[layerId].title === layerId) {
                    control.addLayer(this._resultsFeaturesLayer, {
                        title: "Résultats de la recherche inverse",
                        description: "Résultats de la recherche inverse sur les " + geocodeType
                    });
                    control.setRemovable(this._resultsFeaturesLayer, false);
                }
            }
        }, this);
    }
};

/**
 * this method is called by this._displayGeocodedLocations()
 * and creates result layer (where geocoded locations will be displayed)
 *
 * @private
 */
ReverseGeocode.prototype._createResultsLayer = function () {
    var map = this.getMap();

    this._resultsFeatures = new _ol2.default.Collection();

    // on crée la couche qui va accueillir les features
    this._resultsFeaturesSource = new _ol2.default.source.Vector({
        features: this._resultsFeatures
    });
    this._resultsFeaturesLayer = new _ol2.default.layer.Vector({
        source: this._resultsFeaturesSource
    });
    // on rajoute le champ gpResultLayerId permettant d'identifier une couche crée par le composant. (pour layerSwitcher par ex)
    this._resultsFeaturesLayer.gpResultLayerId = "reverseGeocodingResults";
    // on ajoute la couche à la carte
    map.addLayer(this._resultsFeaturesLayer);
};

/**
 * this method is called by this._displayGeocodedLocations()
 * and displays locations in map (markers) : add new feature to results layer
 *
 * @param {Object} location - geocoded location (reverse geocode result)
 * @param {Number} i - geocoded location index in response list
 * @private
 */
ReverseGeocode.prototype._addResultFeature = function (location, i) {
    var map = this.getMap();

    // récupération de la position
    var position = [location.position.x, location.position.y];
    if (!position) {
        return;
    }
    var view = map.getView();
    var mapProj = view.getProjection().getCode();
    if (mapProj !== "EPSG:4326") {
        // on retransforme les coordonnées de la position dans la projection de la carte
        position = _ol2.default.proj.transform(position, "EPSG:4326", mapProj);
    }

    // on ajoute le résultat à la collection de points existantes (composant la couche vectorielle this._inputFeaturesLayer)
    var feature = new _ol2.default.Feature({
        geometry: new _ol2.default.geom.Point(position)
    });
    feature.setStyle(this._resultsDefaultStyle);
    feature.setId(i);
    feature.setProperties({
        popupContent: this._fillPopupContent(location)
    });
    this._resultsFeatures.push(feature);
};

/**
 * this method is called by this._addResultFeature()
 * and fills popup content (to be displayed on marker click) for a given geocoded location
 *
 * @param {Object} location - geocoded location (reverse geocode result)
 * @returns {String} popupContent - text to be displayed in popup
 * @private
 */
ReverseGeocode.prototype._fillPopupContent = function (location) {
    var popupContent = "<ul>";

    var attributes = location.placeAttributes;
    for (var attr in attributes) {
        if (attributes.hasOwnProperty(attr)) {
            if (attr !== "bbox") {
                popupContent += "<li>";
                popupContent += "<span class=\"gp-attname-others-span\">" + attr.toUpperCase() + " : </span>";
                popupContent += attributes[attr];
                popupContent += " </li>";
            }
        }
    }
    popupContent += " </ul>";

    return popupContent;
};

/**
 * this method is called on 'pointerMove' on this._resultsFeaturesLayer (ol.interaction.Select)
 * (cf. this._displayGeocodedLocationsOnMap() )
 * and highlights result in list container
 *
 * @param {Object} e - on select event
 * @private
 */
ReverseGeocode.prototype._onResultsFeatureMouseOver = function (e) {
    var f;

    // si on survole un résultat, on change son style (marker)
    if (e.selected.length !== 0) {
        // on change le style du marker (red)
        f = e.selected[0];
        f.setStyle(this._resultsSelectedStyle);

        // on surligne le résultat correspondant dans la liste des résultats
        if (f.getId() != null) {
            var selectedResultDiv = document.getElementById("ReverseGeocodedLocation_" + f.getId() + "-" + this._uid);
            if (selectedResultDiv && selectedResultDiv.classList) {
                selectedResultDiv.classList.add("GPreverseGeocodedLocationHighlight");
            }
        }
        document.getElementById("ReverseGeocodedLocation_" + f.getId() + "-" + this._uid);
    }

    // si on déselectionne un résultat (mouseout), on rétablit un style normal pour le marker
    if (e.deselected.length !== 0) {
        // on change le style du marker (lightOrange)
        f = e.deselected[0];
        f.setStyle(this._resultsDefaultStyle);

        // on rétablit un style normal pour le résultat correspondant dans la liste des résultats
        var deSelectedResultDiv = document.getElementById("ReverseGeocodedLocation_" + f.getId() + "-" + this._uid);
        if (deSelectedResultDiv && deSelectedResultDiv.classList) {
            deSelectedResultDiv.classList.remove("GPreverseGeocodedLocationHighlight");
        }
    }
};

/**
 * this method is called on 'click' on this._resultsFeaturesLayer (ol.interaction.Select)
 * (cf. this._displayGeocodedLocationsOnMap() )
 * and sets a popup with feature information
 *
 * @param {Object} e - on select event
 * @private
 */
ReverseGeocode.prototype._onResultsFeatureSelect = function (e) {
    var map = this.getMap();
    if (e.selected.length !== 0) {
        // si on a sélectionné un marker, on lui ajoute une popup
        var f = e.selected[0];
        this._popupContent.innerHTML = f.getProperties().popupContent;

        if (!this._popupOverlay) {
            // ajout de la popup a la carte comme un overlay
            this._popupOverlay = new _ol2.default.Overlay({
                element: this._popupDiv,
                positioning: "bottom-center",
                position: e.mapBrowserEvent.coordinate
            });
            map.addOverlay(this._popupOverlay);
        } else {
            // si l'overlay est déjà créé, on modifie juste sa position
            this._popupOverlay.setPosition(e.mapBrowserEvent.coordinate);
        }
    } else {
        // si aucun troncon n'est sélectionné (click à côté du tracé),
        // on fait disparaitre la popup si elle existe
        if (this._popupOverlay != null) {
            this._popupOverlay.setPosition(undefined);
        }
    }
};

// ################################################################### //
// ####################### handlers events to dom #################### //
// ################################################################### //

/**
 * this method is called by event 'click' on 'GPshowReverseGeocodingPicto' tag label
 * (cf. ReverseGeocodingDOM._createShowReverseGeocodingPictoElement), and it cleans the component
 * when it's closed.
 *
 * @private
 */
ReverseGeocode.prototype.onShowReverseGeocodingClick = function () {
    this.collapsed = this._showReverseGeocodingInput.checked;
    // info : on génère nous même l'evenement OpenLayers de changement de propriété
    // (utiliser ol.control.ReverseGeocode.on("change:collapsed", function ) pour s'abonner à cet évènement)
    this.dispatchEvent("change:collapsed");
    var map = this.getMap();

    if (!this._waiting && !this._reverseGeocodingLocations.length) {
        // Cas 1 : input panel (ni en attente, ni sur le panel des résultats)
        if (this.collapsed) {
            // on remet à zéro = on efface les géométries + interactions + valeurs stockées
            // suppression des résultats précédents
            this._clearResults();
            // on efface les points qui ont pu être saisis précédemment
            this._clearInputFeatures();
            // on supprime l'éventuelle précédente interaction
            this._removeMapInteraction(map);
            // on retire aussi la couche de saisie de la zone de recherche à la fermeture du widget
            if (this._inputFeaturesLayer != null) {
                map.removeLayer(this._inputFeaturesLayer);
                this._inputFeaturesLayer = null;
                this._inputFeaturesSources = null;
                this._inputFeatures = null;
            }
        } else {
            // on réactive l'interaction
            this._activateMapInteraction(map);
        }
    }
    // info : si on est en attente ou sur le panel des résultats : on ne fait rien.
};

/**
 * this method is called by event 'change' on 'GPreverseGeocodingCode' tag select
 * (cf. ReverseGeocodingDOM._createReverseGeocodingFormModeChoiceGeocodingTypeElement).
 * this value is saved as a parameter for reverseGeocode service.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
ReverseGeocode.prototype.onReverseGeocodingTypeChange = function (e) {
    var idx = e.target.selectedIndex;
    var value = e.target.options[idx].value;

    if (!value) {
        return;
    }
    logger.log(value);
    this._currentGeocodingType = value;
};

/**
 * this method is called by event 'change' on 'GPreverseGeocodingCode' tag select
 * (cf. ReverseGeocodingDOM._createReverseGeocodingFormModeChoiceGeocodingDelimitationElement).
 * this value is saved as a parameter for reverseGeocode service.
 *
 * @param {Object} e - HTMLElement
 * @private
 */
ReverseGeocode.prototype.onReverseGeocodingDelimitationChange = function (e) {
    var idx = e.target.selectedIndex;
    var value = e.target.options[idx].value;

    if (!value) {
        return;
    }

    logger.log(value);
    this._currentGeocodingDelimitation = value;

    // on met à jour l'interaction de la map en fonction de la nouvelle délimitation
    var map = this.getMap();
    // on supprime l'interaction précédente, ainsi que les géométries et valeurs stockées (filtres, position)
    this._clearInputFeatures();
    // on supprime l'éventuelle précédente interaction
    this._removeMapInteraction(map);
    // on crée une nouvelle interaction
    this._activateMapInteraction(map);
};

/**
 * this method is called by event 'click' on 'GPreverseGeocodingReturnPicto' div
 * (cf. ReverseGeocodingDOM._createReverseGeocodingPanelReturnPictoElement),
 * and clear geocoded location (from both list container and map)
 *
 * @private
 */
ReverseGeocode.prototype.onGPreverseGeocodingReturnPictoClick = function () {
    // suppression des résultats précédents
    this._clearResults();
    // on efface les points qui ont pu être saisis précédemment
    this._clearInputFeatures();
    // et on réactive l'interaction sur la map
    this._activateMapInteraction(this.getMap());
};

/**
 * this methode is called by event 'submit' on reverseGeocoding form ('GPreverseGeocodingForm')
 * (cf. ReverseGeocodingDOM._createReverseGeocodingPanelFormElement),
 * it checks reverse geocode mandatory parameters,
 * then call this._reverseGeocodingRequest() to generate and send request
 *
 * @private
 */
ReverseGeocode.prototype.onReverseGeocodingSubmit = function () {
    // le paramètre position est obligatoire
    if (!this._requestPosition) {
        logger.log("missing position");
        return;
    }

    // si on n'a trouvé aucun droit, on evite une requête inutile ...
    if (this._noRightManagement) {
        return;
    }

    this._reverseGeocodingRequest();
};

/**
 * this method is called by event 'click' on 'ReverseGeocodedLocation_' div
 * (cf. ReverseGeocodingDOM._createReverseGeocodingResultElement),
 * and zoom to location ?
 * TODO
 *
 * @param {Object} e - HTMLElement
 * @private
 */
ReverseGeocode.prototype.onReverseGeocodingResultClick = function (e) {
    logger.log("onReverseGeocodingResultClick", e);
};

/**
 * this method is called by event 'mouseover' on 'ReverseGeocodedLocation_' div
 * (cf. ReverseGeocodingDOM._createReverseGeocodingResultElement),
 * and changes style of matching marker on map (selected)
 *
 * @param {Object} e - HTMLElement
 * @private
 */
ReverseGeocode.prototype.onReverseGeocodingResultMouseOver = function (e) {
    // récupération de l'id du résultat survolé
    var tagid = e.target.id; // ex ReverseGeocodedLocation_21
    var idx = tagid.substring(tagid.indexOf("_") + 1); // ex. 21

    // on passe le texte en gras
    if (e.target.classList) {
        e.target.classList.add("GPreverseGeocodedLocationHighlight");
    }

    if (!this._resultsFeaturesSource) {
        return;
    }

    // on récupère l'entité correspondante au résultat survolé
    var f = this._resultsFeaturesSource.getFeatureById(parseInt(idx, 10));
    // et on lui affecte un nouveau style
    f.setStyle(this._resultsSelectedStyle);
};

/**
 * this method is called by event 'mouseout' on 'ReverseGeocodedLocation_' div
 * (cf. ReverseGeocodingDOM._createReverseGeocodingResultElement),
 * and changes style of matching marker on map (default)
 *
 * @param {Object} e - HTMLElement
 * @private
 */
ReverseGeocode.prototype.onReverseGeocodingResultMouseOut = function (e) {
    // récupération de l'id du résultat survolé
    var tagid = e.target.id; // ex GProuteResultsDetailsInstruction_125
    var idx = tagid.substring(tagid.indexOf("_") + 1); // ex. 125

    // on repasse le texte en style normal
    if (e.target.classList) {
        e.target.classList.remove("GPreverseGeocodedLocationHighlight");
    }

    if (!this._resultsFeaturesSource) {
        return;
    }
    // on récupère l'entité correspondante au résultat qui était survolé
    var f = this._resultsFeaturesSource.getFeatureById(parseInt(idx, 10));
    // et on lui réaffecte un style normal
    f.setStyle(this._resultsDefaultStyle);
};

// ################################################################### //
// ################################ clean ############################ //
// ################################################################### //

/**
 * this method clears previous location results
 *
 * @private
 */
ReverseGeocode.prototype._clearResults = function () {
    var map = this.getMap();

    this._reverseGeocodingLocations = [];
    // on vide le container avec la liste des résultats
    if (this._resultsListContainer) {
        while (this._resultsListContainer.firstChild) {
            this._resultsListContainer.removeChild(this._resultsListContainer.firstChild);
        }
    }
    // on retire la couche des résultats
    if (this._resultsFeaturesLayer) {
        map.removeLayer(this._resultsFeaturesLayer);
        this._resultsFeaturesLayer = null;
    }
    // on retire l'overlay de la popup de la carte
    if (this._popupOverlay != null) {
        map.removeOverlay(this._popupOverlay);
        this._popupOverlay = null;
    }
    // on retire les interactions sur les markers (select et mouseover)
    if (this._resultsSelectInteraction != null) {
        map.removeInteraction(this._resultsSelectInteraction);
        this._resultsSelectInteraction = null;
    }
    if (this._resultsHoverInteraction != null) {
        map.removeInteraction(this._resultsHoverInteraction);
        this._resultsHoverInteraction = null;
    }
};

/**
 * this method clears previous input features (features, layer, position and filters)
 *
 * @private
 */
ReverseGeocode.prototype._clearInputFeatures = function () {
    // on efface les points qui ont pu être saisis précédemment (on vide la collection des features de la couche)
    if (this._inputFeatures) {
        this._inputFeatures.clear();
    }

    // on supprime les valeurs stockées (filtres, position)
    this._requestPosition = null;
    this._requestCircleFilter = null;
    this._requestBboxFilter = null;
};

/**
 * this method displays waiting container and sets a timeout
 *
 * @private
 */
ReverseGeocode.prototype._displayWaitingContainer = function () {
    this._waitingContainer.className = "GProuteCalcWaitingContainerVisible";
    this._waiting = true;

    // mise en place d'un timeout pour réinitialiser le panel (cacher la patience)
    // si on est toujours en attente (si la requête est bloquée par exemple)
    if (this._timer) {
        clearTimeout(this._timer);
        this._timer = null;
    }
    var context = this;
    this._timer = setTimeout(function () {
        if (context._waiting === true) {
            context._hideWaitingContainer();
        } else {
            if (context._timer) {
                clearTimeout(context._timer);
            }
        }
    }, 16000);
};

/**
 * this method hides waiting container and clears timeout
 *
 * @private
 */
ReverseGeocode.prototype._hideWaitingContainer = function () {
    if (this._waiting) {
        this._waitingContainer.className = "GProuteCalcWaitingContainerHidden";
        this._waiting = false;
        clearTimeout(this._timer);
        this._timer = null;
    }
};

exports.default = ReverseGeocode;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ReverseGeocodingDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPreverseGeocoding");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################### Methods of main container ##################### //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing
     *
     * @returns {DOMElement} DOM element
     */
    _createShowReverseGeocodingElement: function _createShowReverseGeocodingElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowReverseGeocoding");
        input.type = "checkbox";
        return input;
    },

    /**
     * Show ReverseGeocoding
     *
     * @returns {DOMElement} DOM element
     */
    _createShowReverseGeocodingPictoElement: function _createShowReverseGeocodingPictoElement() {
        // contexte d'execution
        var self = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowReverseGeocodingPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowReverseGeocoding");
        label.title = "Ouvrir la recherche inverse";

        // Close all results and panels when minimizing the widget
        if (label.addEventListener) {
            label.addEventListener("click", function () {
                self.onShowReverseGeocodingClick();
            });
        } else if (label.attachEvent) {
            label.attachEvent("onclick", function () {
                self.onShowReverseGeocodingClick();
            });
        }

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowReverseGeocodingOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    },

    /**
     * Create Waiting Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingWaitingElement: function _createReverseGeocodingWaitingElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPreverseGeocodingCalcWaitingContainer");
        div.className = "GPreverseGeocodingCalcWaitingContainerHidden";

        var p = document.createElement("p");
        p.className = "GPreverseGeocodingCalcWaiting";
        p.innerHTML = "Recherche en cours...";

        div.appendChild(p);

        return div;
    },

    /**
     * Reverse geocoding results panel element.
     *
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingResultsPanelElement: function _createReverseGeocodingResultsPanelElement() {
        var resultsPanelDiv = document.createElement("div");
        resultsPanelDiv.id = this._addUID("GPreverseGeocodingResultsPanel");
        resultsPanelDiv.className = "GPpanel GPreverseGeocodingComponentHidden";
        return resultsPanelDiv;
    },

    /**
     * Reverse geocoding results list.
     *
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingResultsListElement: function _createReverseGeocodingResultsListElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPreverseGeocodingResultsList");
        // Results are dynamically filled in Javascript by reverse geocoding service
        return container;
    },

    /**
     *  Add Result
     * (results dynamically generate !)
     *
     * @param {String} locationDescription - reverse geocoded location results
     * @param {Number} id - ID
     */
    _createReverseGeocodingResultElement: function _createReverseGeocodingResultElement(locationDescription, id) {
        // contexte
        var context = this;

        var container = document.getElementById(this._addUID("GPreverseGeocodingResultsList"));

        var div = document.createElement("div");
        div.id = this._addUID("ReverseGeocodedLocation_" + id);
        div.className = "GPautoCompleteProposal";
        div.innerHTML = locationDescription;
        div.title = locationDescription;

        if (div.addEventListener) {
            div.addEventListener("mouseover", function (e) {
                context.onReverseGeocodingResultMouseOver(e);
            });
            div.addEventListener("mouseout", function (e) {
                context.onReverseGeocodingResultMouseOut(e);
            });
            div.addEventListener("click", function (e) {
                if (typeof context.onReverseGeocodingResultClick === "function") {
                    context.onReverseGeocodingResultClick(e);
                }
            });
        } else if (div.attachEvent) {
            div.attachEvent("onmouseover", function (e) {
                context.onReverseGeocodingResultMouseOver(e);
            });
            div.attachEvent("onmouseout", function (e) {
                context.onReverseGeocodingResultMouseOut(e);
            });
            div.attachEvent("onclick", function (e) {
                if (typeof context.onReverseGeocodingResultClick === "function") {
                    context.onReverseGeocodingResultClick(e);
                }
            });
        }

        container.appendChild(div);
    },

    // ################################################################### //
    // ######################### Inputs panel ############################ //
    // ################################################################### //

    /**
     * Create Container Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingPanelElement: function _createReverseGeocodingPanelElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPreverseGeocodingPanel");
        div.className = "GPpanel";

        return div;
    },

    /**
     * Create Header Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingPanelHeaderElement: function _createReverseGeocodingPanelHeaderElement() {
        var container = document.createElement("div");
        container.className = "GPpanelHeader";
        // info: on sépare les appels pour la création du picto de retour,
        // du titre et de la croix de fermeture pour les récupérer dans le composant
        return container;
    },

    /**
     * Create return picto in panel header
     *
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingPanelReturnPictoElement: function _createReverseGeocodingPanelReturnPictoElement() {
        // contexte
        var self = this;

        var divNew = document.createElement("div");
        divNew.id = this._addUID("GPreverseGeocodingReturnPicto");
        divNew.title = "Nouvelle recherche";
        divNew.className = "GPreverseGeocodingReturnPictoHidden";
        if (divNew.addEventListener) {
            divNew.addEventListener("click", function (e) {
                document.getElementById(self._addUID("GPreverseGeocodingResultsPanel")).className = "GProuteComponentHidden";
                document.getElementById(self._addUID("GPreverseGeocodingForm")).className = "";
                document.getElementById(self._addUID("GPreverseGeocodingHeaderTitle")).innerHTML = "Recherche inverse";
                document.getElementById(self._addUID("GPreverseGeocodingReturnPicto")).className = "GPreverseGeocodingReturnPictoHidden";
                self.onGPreverseGeocodingReturnPictoClick(e);
            });
        } else if (divNew.attachEvent) {
            divNew.attachEvent("onclick", function (e) {
                document.getElementById(self._addUID("GPreverseGeocodingResultsPanel")).className = "GProuteComponentHidden";
                document.getElementById(self._addUID("GPreverseGeocodingForm")).className = "";
                document.getElementById(self._addUID("GPreverseGeocodingHeaderTitle")).innerHTML = "Recherche inverse";
                document.getElementById(self._addUID("GPreverseGeocodingReturnPicto")).className = "GPreverseGeocodingReturnPictoHidden";
                self.onGPreverseGeocodingReturnPictoClick(e);
            });
        }
        return divNew;
    },

    /**
     * Create Header Title Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingPanelTitleElement: function _createReverseGeocodingPanelTitleElement() {
        var div = document.createElement("div");
        div.className = "GPpanelTitle";
        div.id = this._addUID("GPreverseGeocodingHeaderTitle");
        div.innerHTML = "Recherche inverse";
        return div;
    },

    /**
     * Create Header close div
     *
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingPanelCloseElement: function _createReverseGeocodingPanelCloseElement() {
        // contexte
        var self = this;

        var divClose = document.createElement("div");
        divClose.id = this._addUID("GPreverseGeocodingPanelClose");
        divClose.className = "GPpanelClose";
        divClose.title = "Fermer le panneau";

        // Link panel close / visibility checkbox
        if (divClose.addEventListener) {
            divClose.addEventListener("click", function () {
                document.getElementById(self._addUID("GPshowReverseGeocodingPicto")).click();
            }, false);
        } else if (divClose.attachEvent) {
            divClose.attachEvent("onclick", function () {
                document.getElementById(self._addUID("GPshowReverseGeocodingPicto")).click();
            });
        }

        return divClose;
    },

    /**
     * Create Form
     * see event !
     *
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingPanelFormElement: function _createReverseGeocodingPanelFormElement() {
        // contexte d'execution
        var self = this;

        var form = document.createElement("form");
        form.id = this._addUID("GPreverseGeocodingForm");

        if (form.addEventListener) {
            form.addEventListener("submit", function (e) {
                e.preventDefault();
                self.onReverseGeocodingSubmit();
            });
        } else if (form.attachEvent) {
            form.attachEvent("onsubmit", function (e) {
                e.preventDefault();
                self.onReverseGeocodingSubmit();
            });
        }

        return form;
    },

    // ################################################################### //
    // ####################### Choice mode into form ##################### //
    // ################################################################### //

    /**
     * Create Container to Mode choice geocoding type
     *
     * @param {Array} resources - geocoding resources to be displayed (and used)
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingFormModeChoiceGeocodingTypeElement: function _createReverseGeocodingFormModeChoiceGeocodingTypeElement(resources) {
        // contexte d'execution
        var context = this;

        var div = document.createElement("div");
        div.className = "GPflexInput";

        var label = document.createElement("label");
        label.className = "GPreverseGeocodingCodeLabel";
        label.innerHTML = "Recherche par";
        label.title = "Recherche par";
        div.appendChild(label);

        var select = document.createElement("select");
        select.className = "GPreverseGeocodingCode";
        // gestionnaire d'evenement : on stocke la valeur du type de geocodage,
        // utilisé dans la requête de géocodage inverse
        if (select.addEventListener) {
            select.addEventListener("change", function (e) {
                context.onReverseGeocodingTypeChange(e);
            });
        } else if (select.attachEvent) {
            select.attachEvent("onchange", function (e) {
                context.onReverseGeocodingTypeChange(e);
            });
        }

        // on prend soit les valeurs passées par l'utilisateur, soit des valeurs par défaut
        if (!resources || !Array.isArray(resources)) {
            resources = ["StreetAddress", "PositionOfInterest", "CadastralParcel"];
        }
        for (var i = 0; i < resources.length; i++) {
            switch (resources[i]) {
                case "PositionOfInterest":
                    var POIOption = document.createElement("option");
                    POIOption.value = "PositionOfInterest";
                    POIOption.text = "Lieux/toponymes";
                    select.appendChild(POIOption);
                    break;
                case "StreetAddress":
                    var SAOption = document.createElement("option");
                    SAOption.value = "StreetAddress";
                    SAOption.text = "Adresses";
                    select.appendChild(SAOption);
                    break;
                case "CadastralParcel":
                    var CPOption = document.createElement("option");
                    CPOption.value = "CadastralParcel";
                    CPOption.text = "Parcelles cadastrales";
                    select.appendChild(CPOption);
                    break;
                case "Administratif":
                    var adminOption = document.createElement("option");
                    adminOption.value = "Administratif";
                    adminOption.text = "Unités administratives";
                    select.appendChild(adminOption);
                    break;
                default:
                    break;
            }
        }

        div.appendChild(select);

        return div;
    },

    /**
     * Create Container to Mode choice geocoding delimitation
     *
     * @param {Array} delimitations - geocoding delimitations to be displayed (and used)
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingFormModeChoiceGeocodingDelimitationElement: function _createReverseGeocodingFormModeChoiceGeocodingDelimitationElement(delimitations) {
        // contexte d'execution
        var context = this;

        var div = document.createElement("div");
        div.className = "GPflexInput";

        var label = document.createElement("label");
        label.className = "GPreverseGeocodingCodeLabel";
        label.innerHTML = "Délimitation";
        label.title = "Délimitation";
        div.appendChild(label);

        var select = document.createElement("select");
        select.className = "GPreverseGeocodingCode";
        // gestionnaire d'evenement : on stocke la valeur du type de délimitation,
        // et on modifie l'événement de pointage sur la carte en fonction
        if (select.addEventListener) {
            select.addEventListener("change", function (e) {
                context.onReverseGeocodingDelimitationChange(e);
            });
        } else if (select.attachEvent) {
            select.attachEvent("onchange", function (e) {
                context.onReverseGeocodingDelimitationChange(e);
            });
        }

        // on prend soit les valeurs passées par l'utilisateur, soit des valeurs par défaut
        if (!delimitations || !Array.isArray(delimitations)) {
            delimitations = ["Point", "Circle", "Extent"];
        }
        for (var i = 0; i < delimitations.length; i++) {
            switch (delimitations[i].toLowerCase()) {
                case "point":
                    var pointOption = document.createElement("option");
                    pointOption.value = "point";
                    pointOption.text = "Pointer un lieu";
                    select.appendChild(pointOption);
                    break;
                case "circle":
                    var circleOption = document.createElement("option");
                    circleOption.value = "circle";
                    circleOption.text = "Dessiner un cercle";
                    select.appendChild(circleOption);
                    break;
                case "extent":
                    var extentOption = document.createElement("option");
                    extentOption.value = "extent";
                    extentOption.text = "Dessiner une emprise";
                    select.appendChild(extentOption);
                    break;
                default:
                    break;
            }
        }

        div.appendChild(select);

        return div;
    },

    // ################################################################### //
    // ########################### Submit Form ########################### //
    // ################################################################### //

    /**
     * Create Submit Form Element
     *
     * @returns {DOMElement} DOM element
     */
    _createReverseGeocodingSubmitFormElement: function _createReverseGeocodingSubmitFormElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPreverseGeocodingSubmit");
        input.className = "GPinputSubmit";
        input.type = "submit";
        input.value = "Rechercher";

        return input;
    }

};

exports.default = ReverseGeocodingDOM;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _Markers = __webpack_require__(5);

var _Markers2 = _interopRequireDefault(_Markers);

var _LayerImportDOM = __webpack_require__(51);

var _LayerImportDOM2 = _interopRequireDefault(_LayerImportDOM);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

var _ProxyUtils = __webpack_require__(13);

var _ProxyUtils2 = _interopRequireDefault(_ProxyUtils);

var _KML = __webpack_require__(14);

var _KML2 = _interopRequireDefault(_KML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("layerimport");

/**
 * @classdesc
 *
 * LayerImport Control. Allows users to add geographical data in standards formats from their own sources to the map.
 *
 * @constructor
 * @alias ol.control.LayerImport
 * @extends {ol.control.Control}
 * @param {Object} options - options for function call.
 * @param {Boolean} [options.collapsed = false] - Specify if LayerImport control should be collapsed at startup. Default is true.
 * @param {Array} [options.layerTypes = ["KML", "GPX", "GeoJSON", "WMS", "WMTS"]] - data types that could be imported : "KML", "GPX", "GeoJSON", "WMS" and "WMTS". Values will be displayed in the same order in widget list.
 * @param {Object} [options.webServicesOptions = {}] - Options to import WMS or WMTS layers
 * @param {String} [options.webServicesOptions.proxyUrl] - Proxy URL to avoid cross-domain problems. Mandatory to import WMS and WMTS layer.
 * @param {Array.<String>} [options.webServicesOptions.noProxyDomains] - Proxy will not be used for this list of domain names. Only use if you know what you're doing.
 * @param {Object} [options.vectorStyleOptions] - Options for imported vector layer styling (KML, GPX, GeoJSON)
 * @param {Object} [options.vectorStyleOptions.KML] - Options for KML layer styling
 * @param {Boolean} [options.vectorStyleOptions.KML.extractStyles = true] - Extract styles from the KML. Default is true.
 * @param {Boolean} [options.vectorStyleOptions.KML.showPointNames = true] - Show names as labels for KML placemarks which contain points. Default is true.
 * @param {Object} [options.vectorStyleOptions.KML.defaultStyle] - default style to be applied to KML imports in case no style is defined. defaultStyle is an {@link http://openlayers.org/en/latest/apidoc/ol.style.Style.html ol.style.Style} object.
 * @param {Object} [options.vectorStyleOptions.GPX] - Options for GPX layer styling
 * @param {Object} [options.vectorStyleOptions.GPX.defaultStyle] - default style to be applied to GPX imports in case no style is defined. defaultStyle is an {@link http://openlayers.org/en/latest/apidoc/ol.style.Style.html ol.style.Style} object.
 * @param {Object} [options.vectorStyleOptions.GeoJSON] - Options for GeoJSON layer styling
 * @param {Object} [options.vectorStyleOptions.GeoJSON.defaultStyle] - default style to be applied to GeoJSON imports in case no style is defined. defaultStyle is an {@link http://openlayers.org/en/latest/apidoc/ol.style.Style.html ol.style.Style} object.
 * @example
 *  var LayerImport = new ol.control.LayerImport({
 *      collapsed : false,
 *      layerTypes : ["KML", "GPX"],
 *      webServicesOptions : {
 *          proxyUrl : "http://localhost/proxy/php/proxy.php?url=",
 *          noProxyDomains : []
 *      },
 *      vectorStyleOptions : {
 *          KML : {
 *              extractStyles : true,
 *              defaultStyle : new ol.style.Style({
 *                  image : new ol.style.Icon({
 *                       src : "data:image/png;base64....",
 *                       size : [51, 38],
 *                  }),
 *                  stroke : new ol.style.Stroke({
 *                       color : "#ffffff",
 *                       width : 7
 *                  }),
 *                  fill : new ol.style.Fill({
 *                       color : "rgba(255, 183, 152, 0.2)"
 *                  }),
 *                  text : new ol.style.Text({
 *                      font : "16px Sans",
 *                      textAlign : "left",
 *                      fill : new ol.style.Fill({
 *                          color : "rgba(255, 255, 255, 1)"
 *                      }),
 *                      stroke : new ol.style.Stroke({
 *                          color : "rgba(0, 0, 0, 1)",
 *                          width : 2
 *                      })
 *                  })
 *              })
 *          },
 *          GPX : {
 *              defaultStyle : new ol.style.Style({
 *                  image : new ol.style.Icon({
 *                       src : "path/to/my/icon.png",
 *                       size : [51, 38],
 *                  }),
 *                  stroke : new ol.style.Stroke({
 *                       color : "#ffffff",
 *                       width : 7
 *                  })
 *              })
 *          }
 *      }
 *  });
 */
function LayerImport(options) {
    options = options || {};

    if (!(this instanceof LayerImport)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    this._initialize(options);

    // init control DOM container
    var container = this._initContainer(options);

    // call ol.control.Control constructor
    _ol2.default.control.Control.call(this, {
        element: container,
        target: options.target,
        render: options.render
    });
};

// Inherits from ol.control.Control
_ol2.default.inherits(LayerImport, _ol2.default.control.Control);

/**
 * Default styles applyied to KML, GPX and GeoJSON features.
 *
 * @private
 */
LayerImport.DefaultStyles = {
    image: new _ol2.default.style.Icon({
        src: _Markers2.default["lightOrange"],
        anchor: [25.5, 38],
        anchorOrigin: "top-left",
        anchorXUnits: "pixels",
        anchorYUnits: "pixels"
    }),
    stroke: new _ol2.default.style.Stroke({
        color: "rgba(0,42,80,0.8)",
        width: 4
    }),
    fill: new _ol2.default.style.Fill({
        color: "rgba(0, 183, 152, 0.5)"
    }),
    text: new _ol2.default.style.Text({
        font: "16px Sans",
        textAlign: "left",
        fill: new _ol2.default.style.Fill({
            color: "rgba(255, 255, 255, 1)"
        }),
        stroke: new _ol2.default.style.Stroke({
            color: "rgba(0, 0, 0, 1)",
            width: 2
        })
    })
};

/**
 * @lends module:LayerImport
 */
LayerImport.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les méthodes de la classe commune LayerImportDOM
_Utils2.default.assign(LayerImport.prototype, _LayerImportDOM2.default);

/**
 * Constructor (alias)
 *
 * @private
 */
LayerImport.prototype.constructor = LayerImport;

// ################################################################### //
// ############## public methods (getters, setters) ################## //
// ################################################################### //

/**
 * Returns true if widget is collapsed (minimized), false otherwise
 *
 * @returns {Boolean} collapsed - true if widget is collapsed
 */
LayerImport.prototype.getCollapsed = function () {
    return this.collapsed;
};

/**
 * Collapse or display widget main container
 *
 * @param {Boolean} collapsed - True to collapse widget, False to display it
 */
LayerImport.prototype.setCollapsed = function (collapsed) {
    if (collapsed === undefined) {
        logger.error("[ERROR] LayerImport:setCollapsed - missing collapsed parameter");
        return;
    }
    if (collapsed && this.collapsed || !collapsed && !this.collapsed) {
        return;
    }
    if (collapsed) {
        document.getElementById("GPimportPanelClose-" + this._uid).click();
    } else {
        document.getElementById("GPshowImport-" + this._uid).click();
    }
    this.collapsed = collapsed;
};

/**
 * Returns content of a static import (KML, GPX or GeoJSON)
 *
 * @returns {String} contentStatic  - content static
 */
LayerImport.prototype.getStaticImportContent = function () {
    return this.contentStatic;
};

/**
 * Returns content of a service import (GetCapabilities)
 *
 * @returns {String} contentService  - content service
 */
LayerImport.prototype.getServiceImportContent = function () {
    return this.contentService;
};

// ################################################################### //
// ##################### init component ############################## //
// ################################################################### //

/**
 * Initialize LayerImport control (called by LayerImport constructor)
 *
 * @param {Object} options - constructor options
 * @private
 */
LayerImport.prototype._initialize = function (options) {
    // ############################################################ //
    // ################### Options du composant ################### //

    // check input options format
    this._checkInputOptions(options);

    // set default options
    this.options = {
        collapsed: true,
        layerTypes: ["KML", "GPX", "GeoJSON", "WMS", "WMTS"],
        webServicesOptions: {},
        vectorStyleOptions: {
            KML: {
                extractStyles: true,
                showPointNames: true,
                defaultStyle: {}
            },
            GPX: {
                defaultStyle: {}
            },
            GeoJSON: {
                defaultStyle: {}
            }
        }
    };

    // set extractStyles parameter
    if (options.vectorStyleOptions && options.vectorStyleOptions.KML && options.vectorStyleOptions.KML.extractStyles) {
        this.options.vectorStyleOptions.KML.extractStyles = options.vectorStyleOptions.KML.extractStyles;
    }
    // set showPointNames parameter
    if (options.vectorStyleOptions && options.vectorStyleOptions.KML && options.vectorStyleOptions.KML.showPointNames) {
        this.options.vectorStyleOptions.KML.showPointNames = options.vectorStyleOptions.KML.showPointNames;
    }

    // set vector layers default styles (KML, GPX, GeoJSON)
    if (options.vectorStyleOptions && options.vectorStyleOptions.KML && options.vectorStyleOptions.KML.defaultStyle) {
        // get from options if specified
        this.options.vectorStyleOptions.KML.defaultStyle = options.vectorStyleOptions.KML.defaultStyle;
    } else {
        // get from control default options otherwise
        this.options.vectorStyleOptions.KML.defaultStyle = new _ol2.default.style.Style({
            image: LayerImport.DefaultStyles.image,
            stroke: LayerImport.DefaultStyles.stroke,
            fill: LayerImport.DefaultStyles.fill,
            text: LayerImport.DefaultStyles.text
        });
    }
    if (options.vectorStyleOptions && options.vectorStyleOptions.GPX && options.vectorStyleOptions.GPX.defaultStyle) {
        // get from options if specified
        this.options.vectorStyleOptions.GPX.defaultStyle = options.vectorStyleOptions.GPX.defaultStyle;
    } else {
        // get from control default options otherwise
        this.options.vectorStyleOptions.GPX.defaultStyle = new _ol2.default.style.Style({
            image: LayerImport.DefaultStyles.image,
            stroke: LayerImport.DefaultStyles.stroke,
            fill: LayerImport.DefaultStyles.fill
        });
    }
    if (options.vectorStyleOptions && options.vectorStyleOptions.GeoJSON && options.vectorStyleOptions.GeoJSON.defaultStyle) {
        // get from options if specified
        this.options.vectorStyleOptions.GeoJSON.defaultStyle = options.vectorStyleOptions.GeoJSON.defaultStyle;
    } else {
        // get from control default options otherwise
        this.options.vectorStyleOptions.GeoJSON.defaultStyle = new _ol2.default.style.Style({
            image: LayerImport.DefaultStyles.image,
            stroke: LayerImport.DefaultStyles.stroke,
            fill: LayerImport.DefaultStyles.fill
        });
    }

    // merge layer types
    if (Array.isArray(options.layerTypes)) {
        var layerTypes = [];
        for (var i = 0; i < options.layerTypes.length; i++) {
            layerTypes.push(options.layerTypes[i]);
        }
        this.options.layerTypes = layerTypes;
    }

    // merge with user options
    _Utils2.default.mergeParams(this.options, options);

    /** {Boolean} specify if reverseGeocoding control is collapsed (true) or not (false) */
    this.collapsed = this.options.collapsed;

    // identifiant du contrôle : utile pour suffixer les identifiants CSS (pour gérer le cas où il y en a plusieurs dans la même page)
    this._uid = _SelectorID2.default.generate();

    // si une requête est en cours ou non
    this._waiting = false;
    // timer pour cacher la patience après un certain temps
    this._timer = null;

    // initialisation des types d'import
    this._initImportTypes();
    // initialisation des styles par défaut
    this._initDefaultStyles();

    // ################################################################## //
    // ################### Elements principaux du DOM ################### //

    // containers principaux (FIXME : tous utiles ?)
    this._showImportInput = null;
    this._importPanel = null;
    this._formContainer = null;
    this._staticLocalImportInput = null;
    this._staticUrlImportInput = null;
    this._serviceUrlImportInput = null;
    this._getCapPanel = null;
    this._getCapResultsListContainer = null;
    this._waitingContainer = null;

    // ################################################################## //
    // ################ Interrogation du GetCapabilities ################ //

    this._getCapRequestUrl = null;
    this._getCapResponseWMS = null;
    this._getCapResponseWMSLayers = [];
    this._getCapResponseWMTS = null;
    this._getCapResponseWMTSLayers = [];
};

/**
 * this method is called by this.initialize()
 * and makes sure input options are correctly formated
 *
 * @param {Object} options - control input options
 * @private
 */
LayerImport.prototype._checkInputOptions = function (options) {
    // on vérifie le tableau des types
    if (options.layerTypes) {
        var layerTypes = options.layerTypes;
        // on vérifie que la liste des types est bien un tableau
        if (!Array.isArray(layerTypes)) {
            logger.warn("[ol.control.LayerImport] 'options.layerTypes' parameter should be an array. Set default values [\"KML\", \"GPX\", \"GeoJSON\", \"WMS\", \"WMTS\"]");
            options.layerTypes = ["KML", "GPX", "GeoJSON", "WMS", "WMTS"];
        } else {
            var typesList = ["KML", "GPX", "GEOJSON", "WMS", "WMTS", "WFS"];
            var wrongTypesIndexes = [];
            for (var i = 0; i < layerTypes.length; i++) {
                if (typeof layerTypes[i] !== "string") {
                    // si l'élément du tableau n'est pas une chaine de caractères, on stocke l'index pour le retirer du tableau
                    wrongTypesIndexes.push(i);
                    logger.warn("[ol.control.LayerImport] 'options.layerTypes' elements should be of type string (" + layerTypes[i] + ")");
                } else {
                    // on passe en majuscules pour comparer
                    layerTypes[i] = layerTypes[i].toUpperCase();
                    if (typesList.indexOf(layerTypes[i]) === -1) {
                        // si le type n'est pas référencé, on stocke son index pour le retirer du tableau (après avoir terminé de parcourir le tableau)
                        wrongTypesIndexes.push(i);
                        logger.log("[ol.control.LayerImport] options.layerTypes : " + layerTypes[i] + " is not a supported type");
                    }
                    // cas spécial du GeoJSON qu'on ne laisse pas en majuscules
                    if (layerTypes[i] === "GEOJSON") {
                        layerTypes[i] = "GeoJSON";
                    }
                }
            }
            // on retire les types non référencés qu'on a pu rencontrer
            if (wrongTypesIndexes.length !== 0) {
                for (var j = wrongTypesIndexes.length - 1; j >= 0; j--) {
                    layerTypes.splice(wrongTypesIndexes[j], 1);
                }
            }
        }
    }
};

/**
 * this method is called by this.initialize()
 * and initializes default styles for vector layers (KML/GPX/GeoJSON)
 *
 * @private
 */
LayerImport.prototype._initDefaultStyles = function () {
    var kmlDefaultStyles = this.options.vectorStyleOptions.KML.defaultStyle;
    this._defaultKMLStyle = new _ol2.default.style.Style({
        image: kmlDefaultStyles.image,
        stroke: kmlDefaultStyles.stroke,
        fill: kmlDefaultStyles.fill,
        text: kmlDefaultStyles.text
    });
    var gpxDefaultStyles = this.options.vectorStyleOptions.GPX.defaultStyle;
    this._defaultGPXStyle = new _ol2.default.style.Style({
        image: gpxDefaultStyles.image,
        stroke: gpxDefaultStyles.stroke,
        fill: gpxDefaultStyles.fill
    });
    var geoJSONDefaultStyles = this.options.vectorStyleOptions.GeoJSON.defaultStyle;
    this._defaultGeoJSONStyle = new _ol2.default.style.Style({
        image: geoJSONDefaultStyles.image,
        stroke: geoJSONDefaultStyles.stroke,
        fill: geoJSONDefaultStyles.fill
    });
};

/**
 * this method is called by this.initialize()
 * and initializes import types parameter
 *
 * @private
 */
LayerImport.prototype._initImportTypes = function () {
    this._currentImportType = this.options.layerTypes[0] || "KML";
    if (this._currentImportType === "KML" || this._currentImportType === "GPX" || this._currentImportType === "GeoJSON") {
        this._isCurrentImportTypeStatic = true;
    } else if (this._currentImportType === "WMS" || this._currentImportType === "WMTS" || this._currentImportType === "WFS") {
        this._isCurrentImportTypeStatic = false;
    }
    this._currentStaticImportType = "local";
};

/**
 * Create control main container (DOM initialize)
 *
 * @private
 * @returns {DOMElement} container - control main container
 */
LayerImport.prototype._initContainer = function () {
    // create main container
    var container = this._createMainContainerElement();

    // create show Import element
    var inputShow = this._showImportInput = this._createShowImportElement();
    container.appendChild(inputShow);

    // mode "collapsed"
    if (!this.collapsed) {
        inputShow.checked = true;
    }

    // create Import picto
    var picto = this._createShowImportPictoElement();
    container.appendChild(picto);

    // panel
    var importPanel = this._importPanel = this._createImportPanelElement();

    // header
    var panelHeader = this._createImportPanelHeaderElement();
    importPanel.appendChild(panelHeader);

    // form : initialisation du formulaire d'import des couches (types d'import et saisie de l'url / du fichier)
    var importForm = this._formContainer = this._initInputFormElement();
    importPanel.appendChild(importForm);

    container.appendChild(importPanel);

    // results (dans le panel)
    var getCapPanel = this._getCapPanel = this._createImportGetCapPanelElement();
    getCapPanel.appendChild(this._createImportGetCapPanelHeaderElement());
    var importGetCapResultsList = this._getCapResultsListContainer = this._createImportGetCapResultsContainer();
    getCapPanel.appendChild(importGetCapResultsList);

    container.appendChild(getCapPanel);

    // waiting
    var waiting = this._waitingContainer = this._createImportWaitingElement();
    container.appendChild(waiting);

    return container;
};

/**
 * Create control main container (DOM initialize)
 *
 * @private
 * @returns {DOMElement} importForm - form main container
 */
LayerImport.prototype._initInputFormElement = function () {
    // form main container
    var importForm = this._createImportPanelFormElement();

    // Format choice
    var importTypeChoiceDiv = this._createImportTypeLineElement(this.options.layerTypes);
    importForm.appendChild(importTypeChoiceDiv);

    // params for KML/GPX/GeoJSON

    var importStaticParamsContainer = this._createImportStaticParamsContainer(this.options.layerTypes[0]);
    // static file name
    var staticNameLabel = this._createStaticNameLabel();
    importStaticParamsContainer.appendChild(staticNameLabel);
    // static import choice (local / url)
    var staticImportChoice = this._createStaticModeChoiceDiv();
    // TODO : passer un paramètre "checked" ??
    var staticLocalImportChoice = this._createStaticLocalChoiceDiv();
    staticImportChoice.appendChild(staticLocalImportChoice);
    var staticUrlImportChoice = this._createStaticUrlChoiceDiv();
    staticImportChoice.appendChild(staticUrlImportChoice);
    importStaticParamsContainer.appendChild(staticImportChoice);

    // div for local file import
    var staticLocalInputDiv = this._createStaticLocalInputDiv();
    // label
    staticLocalInputDiv.appendChild(this._createStaticLocalInputLabel());
    // file input
    this._staticLocalImportInput = this._createStaticLocalInput();
    staticLocalInputDiv.appendChild(this._staticLocalImportInput);
    // append div to params container
    importStaticParamsContainer.appendChild(staticLocalInputDiv);

    // div for url input (info: séparation pour récupérer l'élément input)
    var staticUrlInputDiv = this._createStaticUrlInputDiv();
    // label
    staticUrlInputDiv.appendChild(this._createStaticUrlInputLabel());
    // url input
    this._staticUrlImportInput = this._createStaticUrlInput();
    staticUrlInputDiv.appendChild(this._staticUrlImportInput);
    // append div to params container
    importStaticParamsContainer.appendChild(staticUrlInputDiv);

    // append static params container to form container
    importForm.appendChild(importStaticParamsContainer);

    // params for WMS/WMTS/WFS

    var importServiceParamsContainer = this._createServiceParamsContainer(this.options.layerTypes[0]);
    // div for service url
    var importServiceUrlDiv = this._createServiceUrlDiv();
    // label
    importServiceUrlDiv.appendChild(this._createServiceUrlInputLabel());
    // input
    this._serviceUrlImportInput = this._createServiceUrlInput();
    importServiceUrlDiv.appendChild(this._serviceUrlImportInput);
    // append div to params container
    importServiceParamsContainer.appendChild(importServiceUrlDiv);
    // append service params container to form container
    importForm.appendChild(importServiceParamsContainer);

    // submit (bouton "Importer")
    var submit = this._createImportSubmitFormElement();
    importForm.appendChild(submit);

    return importForm;
};

// ################################################################### //
// ######################### DOM events ############################## //
// ################################################################### //

/**
 * this method is called by event 'click' on 'GPshowImportPicto' picto
 * (cf. LayerImportDOM._createShowImportPictoElement),
 * and dispatch event change:collapsed (for tools listening this property)
 *
 * @private
 */
LayerImport.prototype._onShowImportClick = function () {
    this.collapsed = this._showImportInput.checked;
    // info : on génère nous même l'evenement OpenLayers de changement de propriété
    // (utiliser ol.control.LayerImport.on("change:collapsed", function ) pour s'abonner à cet évènement)
    this.dispatchEvent("change:collapsed");
};

/**
 * this method is called by event 'change' on 'GPimportType' tag form
 * (cf. LayerImportDOM._createImportTypeLineElement),
 * and change current import type
 *
 * @param {Object} e - HTMLElement
 * @private
 */
LayerImport.prototype._onImportTypeChange = function (e) {
    this._currentImportType = e.target.value;
    if (this._currentImportType === "KML" || this._currentImportType === "GPX" || this._currentImportType === "GeoJSON") {
        this._isCurrentImportTypeStatic = true;
    } else if (this._currentImportType === "WMS" || this._currentImportType === "WMTS" || this._currentImportType === "WFS") {
        this._isCurrentImportTypeStatic = false;
    }
};

/**
 * this method is called by event 'change' on 'GPimportType' tag form
 * (cf. LayerImportDOM._createImportTypeLineElement),
 * and change current import type
 *
 * @param {Object} e - HTMLElement
 * @private
 */
LayerImport.prototype._onStaticImportTypeChange = function (e) {
    this._currentStaticImportType = e.target.value;
};

/**
 * this method is called by event 'click' on 'GPimportGetCapPanelClose' tag form
 * (cf. LayerImportDOM._createImportGetCapPanelHeaderElement),
 * and reset getCapabilities information
 *
 * @private
 */
LayerImport.prototype._onGetCapPanelClose = function () {
    this._clearGetCapParams();
    this._emptyGetCapResultsList();
};

// ################################################################### //
// ######################## Submit form ############################## //
// ################################################################### //

/**
 * this method is called by event 'submit' on 'GPimportForm' tag form
 * (cf. LayerImportDOM._createImportPanelFormElement),
 * and import static layer or call getCap service (according to import type)
 *
 * @private
 */
LayerImport.prototype._onImportSubmit = function () {
    logger.log("import d'une couche de type : " + this._currentImportType);

    // reinitialisation du contenu d'un import de type
    // - static (KML ou GPX ou GeoJSON)
    this.contentStatic = null;
    // - service (WMS, ...)
    this.contentService = null;

    if (this._isCurrentImportTypeStatic) {
        this._importStaticLayer();
    } else {
        this._importServiceLayers();
    }
};

// ################################################################### //
// ################## Import KML/GPX/GeoJSON layers ################## //
// ################################################################### //

/**
 * this method is called by this_onImportSubmit method
 * and import static layer (KML/GPX/GeoJSON) from url or file
 *
 * @private
 */
LayerImport.prototype._importStaticLayer = function () {
    var layerName;
    var staticImportNameInput = document.getElementById(this._addUID("GPimportName"));
    if (staticImportNameInput) {
        layerName = staticImportNameInput.value;
        logger.log("import layer name : " + layerName);
    }

    if (this._currentStaticImportType === "local") {
        logger.log("import static layer from local file");
        this._importStaticLayerFromLocalFile(layerName);
    } else if (this._currentStaticImportType === "url") {
        logger.log("import static layer from url");
        this._importStaticLayerFromUrl(layerName);
    }
};

/**
 * this method is called by _importStaticLayer method
 * and import static layer (KML/GPX/GeoJSON) from url
 *
 * @param {String} layerName - imported layer name
 * @private
 */
LayerImport.prototype._importStaticLayerFromUrl = function (layerName) {
    layerName = layerName || "";

    // 1. Récupération de l'url
    var url = this._staticUrlImportInput.value;
    logger.log("url : ", url);
    if (url.length === 0) {
        logger.error("[ol.control.LayerImport] url parameter is mandatory");
        return;
    }
    // on supprime les éventuels espaces avant ou après
    if (url.trim) {
        url = url.trim();
    }

    // 2. récupération proxy
    if (!this.options.webServicesOptions || !this.options.webServicesOptions.proxyUrl && !this.options.webServicesOptions.noProxyDomains) {
        logger.error("[ol.control.LayerImport] options.webServicesOptions.proxyUrl parameter is mandatory to request resources on another domain (cross-domain)");
        return;
    };
    url = _ProxyUtils2.default.proxifyUrl(url, this.options.webServicesOptions);

    // FIXME pb de surcharge en mode UMD !? ça ne marche pas...
    // this._hideWaitingContainer();
    // this._addFeaturesFromImportStaticLayerUrl(url, layerName);

    var context = this;
    _gp2.default.Protocols.XHR.call({
        url: url,
        method: "GET",
        timeOut: 15000,
        // on success callback : display results in container
        onResponse: function onResponse(response) {
            context._hideWaitingContainer();
            context._addFeaturesFromImportStaticLayer(response, layerName);
        },
        // on error callback : log error
        onFailure: function onFailure(error) {
            // en cas d'erreur, on revient au panel initial et on cache la patience
            context._hideWaitingContainer();
            logger.error("[ol.control.LayerImport] KML/GPX/GeoJSON request failed : ", error);
        }
    });
};

/**
 * this method is called by _importStaticLayer method
 * and import static layer (KML/GPX/GeoJSON) from local file
 *
 * @param {String} layerName - imported layer name
 * @private
 */
LayerImport.prototype._importStaticLayerFromLocalFile = function (layerName) {
    var file = this._staticLocalImportInput.files[0];
    if (!file) {
        logger.warn("[ol.control.LayerImport] missing file");
        return;
    }

    // Création d'un objet FileReader qui permet de lire le contenu du fichier chargé
    var fReader = new FileReader();

    // Définition des fonctions de callbacks associées au reader,
    // notamment la fonction onload qui affichera les entités chargées à la carte
    var context = this;
    // on readAsText error
    fReader.onerror = function (e) {
        // en cas d'erreur, on revient au panel initial et on cache la patience
        context._hideWaitingContainer();
        logger.error("error fileReader : ", e);
    };
    /** on readAsText progress */
    fReader.onprogress = function () {
        logger.log("onprogress");
    };
    /** on load start */
    fReader.onloadstart = function () {
        // affichage d'une patience le temps du chargement
        context._displayWaitingContainer();
        logger.log("onloadstart");
    };
    /** on readAsText abort */
    fReader.onabort = function () {
        // en cas d'erreur, on revient au panel initial et on cache la patience
        context._hideWaitingContainer();
        logger.log("onabort");
    };
    // on readAsText loadend
    fReader.onloadend = function (e) {
        // fReader = null ?
        // en cas d'erreur, on revient au panel initial et on cache la patience
        // context._hideWaitingContainer();
        // TODO : replier le formulaire ?
        logger.log("onloadend : ", e);
    };
    // on readAsText load
    fReader.onload = function (e) {
        logger.log("fileReader onload - file content : ", e.target.result);

        // on cache la patience
        context._hideWaitingContainer();
        context._addFeaturesFromImportStaticLayer(e.target.result, layerName);
    };

    // Lecture du fichier chargé à l'aide de fileReader
    fReader.readAsText(file);
};

/**
 * this method is called by _importStaticLayerFom* method
 * and add features to the map
 *
 * @param {String} fileContent - content file
 * @param {String} layerName - imported layer name
 * @private
 */
LayerImport.prototype._addFeaturesFromImportStaticLayer = function (fileContent, layerName) {
    // récupération du contenu du fichier
    var map = this.getMap();
    if (!map || !fileContent) {
        return;
    }

    // sauvegarde du content KML/GPX/GeoJSON
    this.contentStatic = fileContent;

    var format;
    var vectorStyle;
    if (this._currentImportType === "KML") {
        // lecture du fichier KML : création d'un format ol.format.KML, qui possède une méthode readFeatures (et readProjection)
        format = new _KML2.default({
            showPointNames: this.options.vectorStyleOptions.KML.showPointNames,
            extractStyles: this.options.vectorStyleOptions.KML.extractStyles,
            defaultStyle: [this.options.vectorStyleOptions.KML.defaultStyle]
        });
        vectorStyle = this.options.vectorStyleOptions.KML.defaultStyle;
    } else if (this._currentImportType === "GPX") {
        // lecture du fichier GPX : création d'un format ol.format.GPX, qui possède une méthode readFeatures (et readProjection)
        format = new _ol2.default.format.GPX();
        vectorStyle = this.options.vectorStyleOptions.GPX.defaultStyle;
    } else if (this._currentImportType === "GeoJSON") {
        // lecture du fichier GeoJSON : création d'un format ol.format.GeoJSON, qui possède une méthode readFeatures (et readProjection)
        format = new _ol2.default.format.GeoJSON();
        vectorStyle = this.options.vectorStyleOptions.GeoJSON.defaultStyle;
    }

    // lecture de la géométrie des entités à partir du fichier, pour éventuelle reprojection.
    var fileProj = format.readProjection(fileContent);
    // récupération de la projection de la carte pour reprojection des géométries
    var mapProj = this._getMapProjectionCode();

    // récupération des entités avec reprojection éventuelle des géométries
    var features = null;
    features = format.readFeatures(fileContent, {
        dataProjection: fileProj,
        featureProjection: mapProj
    });

    logger.log("loaded features : ", features);

    // création d'une couche vectorielle à partir de ces features
    var vectorSource = new _ol2.default.source.Vector({
        features: new _ol2.default.Collection()
    });
    vectorSource.addFeatures(features);

    // logger.trace(vectorSource);

    // ajout des informations pour le layerSwitcher (titre, description)
    if (layerName) {
        vectorSource._title = vectorSource._description = layerName;
    } else {
        if (format.readName && format.readName(fileContent)) {
            vectorSource._title = vectorSource._description = format.readName(fileContent);
        } else {
            vectorSource._title = vectorSource._description = "Import " + this._currentImportType;
            logger.log("[ol.control.LayerImport] set default name \"Import " + this._currentImportType + "\"");
        }
    }

    var vectorLayer = new _ol2.default.layer.Vector({
        source: vectorSource,
        style: vectorStyle
    });

    // on rajoute le champ gpResultLayerId permettant d'identifier une couche crée par le composant. (pour layerSwitcher par ex)
    vectorLayer.gpResultLayerId = "layerimport:" + this._currentImportType;
    map.addLayer(vectorLayer);

    // TODO : appeler fonction commune
    // zoom sur l'étendue des entités récupérées (si possible)
    if (map.getView() && map.getSize() && vectorSource.getExtent) {
        var sourceExtent = vectorSource.getExtent();
        if (sourceExtent && sourceExtent[0] !== Infinity) {
            map.getView().fit(vectorSource.getExtent(), map.getSize());
        }
    }
};

/**
 * NOT USE : this method is called by _importStaticLayerFom* method
 * and add features to the map
 *
 * @param {String} url - url
 * @param {String} layerName - imported layer name
 * @private
 */
LayerImport.prototype._addFeaturesFromImportStaticLayerUrl = function (url, layerName) {
    // récupération du contenu du fichier
    var map = this.getMap();
    if (!map || !url) {
        return;
    }

    var format;
    if (this._currentImportType === "KML") {
        // lecture du fichier KML : création d'un format ol.format.KML, qui possède une méthode readFeatures (et readProjection)
        format = new _KML2.default({
            showPointNames: true, // FIXME option !
            extractStyles: this.options.vectorStyleOptions.KML.extractStyles,
            defaultStyle: [this.options.vectorStyleOptions.KML.defaultStyle]
        });
    } else if (this._currentImportType === "GPX") {
        // lecture du fichier GPX : création d'un format ol.format.GPX, qui possède une méthode readFeatures (et readProjection)
        format = new _ol2.default.format.GPX();
    } else if (this._currentImportType === "GeoJSON") {
        // lecture du fichier GeoJSON : création d'un format ol.format.GeoJSON, qui possède une méthode readFeatures (et readProjection)
        format = new _ol2.default.format.GeoJSON();
    }

    // création d'une couche vectorielle à partir de ces features
    var vectorSource = new _ol2.default.source.Vector({
        url: url,
        format: format
    });

    if (this._currentImportType === "GPX") {
        vectorSource.forEachFeature(function (feature) {
            // si aucun style n'est associé au feature
            if (feature.getStyle() == null) {
                logger.log("[ol.control.LayerImport] set default style for GPX feature");
                feature.setStyle(this.options.vectorStyleOptions.GPX.defaultStyle);
            }
        });
    }
    if (this._currentImportType === "GeoJSON") {
        vectorSource.forEachFeature(function (feature) {
            // si aucun style n'est associé au feature
            if (feature.getStyle() == null) {
                logger.log("[ol.control.LayerImport] set default style for GeoJSON feature");
                feature.setStyle(this.options.vectorStyleOptions.GeoJSON.defaultStyle);
            }
        });
    }

    // ajout des informations pour le layerSwitcher (titre, description)
    if (layerName) {
        vectorSource._title = vectorSource._description = layerName;
    } else {
        vectorSource._title = vectorSource._description = "Import " + this._currentImportType;
    }

    var vectorLayer = new _ol2.default.layer.Vector({
        source: vectorSource
    });

    // on rajoute le champ gpResultLayerId permettant d'identifier une couche crée par le composant. (pour layerSwitcher par ex)
    vectorLayer.gpResultLayerId = "layerimport:" + this._currentImportType;
    map.addLayer(vectorLayer);

    // TODO : appeler fonction commune
    // zoom sur l'étendue des entités récupérées (si possible)
    if (map.getView() && map.getSize() && vectorSource.getExtent) {
        var sourceExtent = vectorSource.getExtent();
        if (sourceExtent && sourceExtent[0] !== Infinity) {
            map.getView().fit(vectorSource.getExtent(), map.getSize());
        }
    }
};

// ################################################################### //
// #################### Import WMS/WMTS layers ####################### //
// ################################################################### //

/**
 * this method is called by this_onImportSubmit method
 * and call getCap service from specified url, then display layers list in new panel
 *
 * @private
 */
LayerImport.prototype._importServiceLayers = function () {
    if (this._currentImportType === "WFS") {
        logger.warn("[ol.control.LayerImport] WFS layer import is not implemented yet");
        return;
    }

    // 0. on vide d'éventuels résultats précédents dans le panel GetCapResults
    this._emptyGetCapResultsList();

    // 1. récupération de l'url renseignée
    var url = this._getCapRequestUrl = this._serviceUrlImportInput.value;
    if (!url) {
        logger.error("[ol.control.LayerImport] url parameter is mandatory");
        return;
    }
    logger.log("url : ", url);

    // on supprime les éventuels espaces avant ou après
    if (url.trim) {
        url = url.trim();
    }
    // Info : on ajoute des paramètres uniquement si l'utilisateur n'en a pas déjà saisi (on vérifie la position du caractère "?")
    var questionMarkIndex = url.indexOf("?");
    if (questionMarkIndex < 0) {
        // dans le cas d'une url du type http://wxs.ign.fr/geoportail/wmts
        url += "?SERVICE=" + this._currentImportType + "&REQUEST=GetCapabilities";
    } else if (questionMarkIndex === url.length - 1) {
        // dans le cas où l'url se termine par "?"
        url += "SERVICE=" + this._currentImportType + "&REQUEST=GetCapabilities";
    }
    // si on n'est pas dans ces deux cas : l'utilisateur a déjà saisit des paramètres après "?" => on ne fait rien.

    // 2. récupération proxy
    if (!this.options.webServicesOptions || !this.options.webServicesOptions.proxyUrl && !this.options.webServicesOptions.noProxyDomains) {
        logger.error("[ol.control.LayerImport] options.webServicesOptions.proxyUrl parameter is mandatory to request web service layers (getcapabilities request)");
        return;
    };
    var proxyUrl = this.options.webServicesOptions.proxyUrl;
    var noProxyDomains = this.options.webServicesOptions.noProxyDomains;
    // on regarde si l'url nest pas dans les domaines sans proxy
    var bfound = false;
    if (noProxyDomains && Array.isArray(noProxyDomains) && noProxyDomains.length > 0) {
        for (var i in noProxyDomains) {
            logger.log("analyzing " + noProxyDomains[i]);
            if (url.indexOf(noProxyDomains[i]) !== -1) {
                logger.log(url + " found in noProxyDomains list (" + noProxyDomains[i] + ").");
                bfound = true;
            }
        }
    }
    // si on n'est pas dans un domaine sans proxy, on ajoute le proxy (+ encodage)
    if (bfound === false) {
        url = proxyUrl + encodeURIComponent(url);
    }

    // 3. affichage d'une patience le temps de la requête
    this._displayWaitingContainer();

    // 4. send getcapabilities request (XHR protocol => proxy Url is needed)
    var context = this;
    _gp2.default.Protocols.XHR.call({
        url: url,
        method: "GET",
        timeOut: 15000,
        // on success callback : display results in container
        onResponse: function onResponse(response) {
            context._hideWaitingContainer();
            context._displayGetCapResponseLayers(response);
        },
        // on error callback : log error
        onFailure: function onFailure(error) {
            // en cas d'erreur, on revient au panel initial et on cache la patience
            context._hideWaitingContainer();
            logger.error("[ol.control.LayerImport] getCapabilities request failed : ", error);
        }
    });
};

/**
 * this method is called by this._importServiceLayers method
 * and display layers list from getcapabilities response
 *
 * @param {Object} xmlResponse - getCapabilities response (xml format)
 * @private
 */
LayerImport.prototype._displayGetCapResponseLayers = function (xmlResponse) {
    var parser;
    var layers;
    var layerDescription = {
        content: null,
        title: null
    };
    var projection;
    this._getCapResponseWMSLayers = [];

    // sauvegarde du content d'un GetCapabilities
    this.contentService = xmlResponse;

    // Affichage du panel des couches accessibles
    this._importPanel.style.display = "none";
    this._getCapPanel.style.display = "block";

    // Parse GetCapabilities Response
    if (this._currentImportType === "WMS") {
        parser = new _ol2.default.format.WMSCapabilities();
        if (!parser) {
            return;
        }
        var getCapResponseWMS = this._getCapResponseWMS = parser.read(xmlResponse);
        logger.log("getCapabilities response : ", getCapResponseWMS);

        if (getCapResponseWMS && getCapResponseWMS.Capability && getCapResponseWMS.Capability.Layer) {
            // info: le parser Openlayers récupère la première layer de <Capability> comme un unique objet (il écrase les précédents s'il y a pls <Layer> à la racine de <Capability>)
            // /!\ être vigilant si le parser est modifié (notamment pour récupérer les différentes layers à la racine. ex  http://geoservices.brgm.fr/geologie?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities)

            var getCapLayer = getCapResponseWMS.Capability.Layer;
            // on va lire le contenu de la (ou les) <Layer> pour l'afficher ou en afficher les couches disponibles
            if (Array.isArray(getCapLayer)) {
                // cas où on a plusieurs <Layer> à la racine, mais non géré encore par ol.format.WMSCapabilities jusqu'à la v3.18.2.
                for (var i = 0; i < getCapLayer.length; i++) {
                    this._displayGetCapResponseWMSLayer(getCapLayer[i]);
                }
            } else {
                // cas du parser ol.format.WMSCapabilities jusqu'à la v3.18.2.
                this._displayGetCapResponseWMSLayer(getCapLayer);
            }
        }
    } else if (this._currentImportType === "WMTS") {
        parser = new _ol2.default.format.WMTSCapabilities();
        if (!parser) {
            return;
        }
        var getCapResponseWMTS = this._getCapResponseWMTS = parser.read(xmlResponse);
        logger.log("getCapabilities response : ", getCapResponseWMTS);

        if (getCapResponseWMTS && getCapResponseWMTS.Contents && getCapResponseWMTS.Contents.Layer) {
            layers = getCapResponseWMTS.Contents.Layer;

            if (Array.isArray(layers)) {
                // on stocke la liste des couches pour faire le lien avec le DOM
                this._getCapResponseWMTSLayers = layers;

                for (var j = 0; j < layers.length; j++) {
                    // on vérifie que la projection de la couche WMTS est compatible avec celle de la carte
                    // (ie elle doit être connue par ol.proj)
                    projection = this._getWMTSLayerProjection(layers[j], getCapResponseWMTS);
                    if (projection && typeof projection === "string") {
                        if (_ol2.default.proj.get(projection) || _ol2.default.proj.get(projection.toUpperCase())) {
                            // si la projection de la couche est connue par ol.proj,
                            // on ajoute chaque couche de la réponse dans la liste des couches accessibles
                            layerDescription = {
                                content: layers[j].Title,
                                title: layers[j].Abstract || layers[j].Title
                            };
                            if (this._getCapResultsListContainer) {
                                this._addImportGetCapResultLayer(layerDescription, j, this._getCapResultsListContainer);
                            }
                        } else {
                            // si la projection de la couche n'est pas connue par ol.proj,
                            // on n'affiche pas la couche dans le panel des résultats
                            logger.warn("[ol.control.LayerImport] wmts layer cannot be added to map : unknown projection", layers[j]);
                            continue;
                        }
                    }
                }
            }
        }
    }
};

/**
 * this method is called by this._displayGetCapResponseLayers method
 * and display WMS layer in list from getcapabilities response
 *
 * @param {Object} layerObj - object corresponding to <Layer> content in WMS GetCapabilities response
 * @param {Object} [parentLayersInfos] - object corresponding to parents <Layer> content in WMS GetCapabilities response (without children <Layer> infos)
 * @private
 */
LayerImport.prototype._displayGetCapResponseWMSLayer = function (layerObj, parentLayersInfos) {
    if (!layerObj) {
        logger.warn("[ol.control.LayerImport] _displayGetCapResponseWMSLayer : getCapabilities layer object not found");
    } else {
        logger.log("[ol.control.LayerImport] _displayGetCapResponseWMSLayer - layerObj : ", layerObj);
    }

    // récupération de la projection de la map (pour vérifier que l'on peut reprojeter les couches disponibles)
    var mapProjCode = this._getMapProjectionCode();
    var projection;
    var layerDescription = {
        content: null,
        title: null
    };

    // 1. héritage éventuels des informations de la couche parent
    if (parentLayersInfos) {
        var key;
        var i;

        // propriétés héritées à ajouter aux propriétés parent
        var addKeys = ["CRS", "Style"
        // "AuthorityURL" // TODO
        ];
        for (i = 0; i < addKeys.length; i++) {
            key = addKeys[i];
            if (Array.isArray(parentLayersInfos[key]) && parentLayersInfos[key].length !== 0) {
                if (Array.isArray(layerObj[key]) && layerObj[key].length !== 0) {
                    // on ajoute celles de la couche parent
                    for (var n = 0; n < parentLayersInfos[key]; n++) {
                        if (layerObj[key].indexOf(parentLayersInfos[key][n]) === -1) {
                            // si le CRS/Style parent n'est pas dans les CRS/Style de la couche, on l'ajoute
                            layerObj[key].push(parentLayersInfos[key][n]);
                        }
                    }
                } else {
                    // si la couche n'a pas de CRS ou Style, on récupère ceux de la couche parent
                    layerObj[key] = parentLayersInfos[key];
                }
            }
        }

        // propriétés qui remplacent les valeurs des propriétés héritées,
        // càd on récupère la propriété parent seulement si elle n'est pas définie pour l'élément enfant
        var replaceKeys = ["BoundingBox", "EX_GeographicBoundingBox", "MaxScaleDenominator", "MinScaleDenominator", "Attribution", "Dimension", "queryable", "cascaded", "opaque", "noSubsets", "fixedWidth", "fixedHeight"];
        for (i = 0; i < replaceKeys.length; i++) {
            key = replaceKeys[i];
            if (parentLayersInfos[key] && !layerObj[key]) {
                layerObj[key] = parentLayersInfos[key];
            }
        }
    } else {
        // si on n'a pas d'infos de couche parent, on est à la racine du Capability, on le note
        layerObj._isRootLayer = true;
        layerObj._container = this._getCapResultsListContainer;
        if (!layerObj.Title) {
            layerObj.Title = "Liste des couches";
        }
    }

    // 2. si on a d'autres couches <Layer> imbriquées, on descend d'un niveau, sinon on affiche la couche dans la liste des résultats
    if (layerObj.Layer) {
        if (Array.isArray(layerObj.Layer)) {
            var _container = layerObj ? layerObj._container : parentLayersInfos._container;
            var _title = layerObj ? layerObj.Title : parentLayersInfos.Title;
            layerObj._container = this._addImportGetCapResultListRubrique(_title, _container).lastChild;
            for (var j = 0; j < layerObj.Layer.length; j++) {
                // on recommence pour chaque sous couche, avec les infos éventuellement héritées
                var bRubriqueExist = false;
                var lstRubrique = layerObj._container.getElementsByClassName("GPimportGetCapRubriqueTitle");
                for (var ii = 0; ii < lstRubrique.length; ii++) {
                    if (lstRubrique[ii].title === layerObj.Title) {
                        bRubriqueExist = true;
                        layerObj.Layer[j]._container = lstRubrique[ii].parentElement;
                    }
                }
                if (!bRubriqueExist) {
                    layerObj.Layer[j]._container = this._addImportGetCapResultRubrique(layerObj.Title, layerObj._container).lastChild;
                }
                this._displayGetCapResponseWMSLayer(layerObj.Layer[j], layerObj);
            }
        }
    } else {
        // on récupère la longueur de la liste des couches déjà récupérées, pour avoir ce qui sera l'index de la couche à ajouter.
        var lastIndex = this._getCapResponseWMSLayers.length;

        // on vérifie que la couche ait une projection compatible avec celle de la carte
        // ou soit connue par proj4js, et on stocke cette projection dans les infos de la couche.
        projection = this._getWMSLayerProjection(layerObj, mapProjCode);

        if (!projection) {
            // si aucune projection n'est compatible avec celle de la carte ou connue par ol.proj,
            // on n'affiche pas la couche dans le panel des résultats
            logger.warn("[ol.control.LayerImport] wms layer cannot be added to map : unknown projection", layerObj);
        } else {
            // si on a une projection compatible : on la stocke et la couche sera éventuellement reprojetée à l'ajout
            layerObj._projection = projection;
            // on ajoute chaque couche de la réponse dans la liste des couches accessibles
            layerDescription = {
                content: layerObj.Title,
                title: layerObj.Abstract || layerObj.Title
            };
            // FIXME beurk !?
            var _isGoodContainer = layerObj._container;
            if (_isGoodContainer.localName === "ul") {
                _isGoodContainer = _isGoodContainer.lastChild;
            }
            this._addImportGetCapResultLayer(layerDescription, lastIndex, _isGoodContainer);

            // puis on stoke la couche dans la liste pour faire le lien avec le DOM
            this._getCapResponseWMSLayers[lastIndex] = layerObj;
        }
    }
};

/**
 * this method is called on 'GPimportGetCapProposal' div click
 * and add corresponding layer to map
 *
 * @param {Object} e - HTMLElement
 * @private
 */
LayerImport.prototype._onGetCapResponseLayerClick = function (e) {
    if (e.target && e.target.id) {
        var proposalId = parseInt(e.target.id.substr(23), 10);

        if (proposalId == null) {
            return;
        }

        var layerInfo;

        if (this._currentImportType === "WMS") {
            // récupération des informations liées à la couche
            layerInfo = this._getCapResponseWMSLayers[proposalId];
            // ajout de la couche à la carte
            this._addGetCapWMSLayer(layerInfo);
        } else if (this._currentImportType === "WMTS") {
            // récupération des informations liées à la couche
            layerInfo = this._getCapResponseWMTSLayers[proposalId];
            // ajout de la couche à la carte
            this._addGetCapWMTSLayer(layerInfo);
        }
    }
};

// ################################################################### //
// ######### create WMS layer from getCapabilities response ######### //
// ################################################################### //

/**
 * this method is called by this._onGetCapResponseLayerClick
 * and add WMS layer to map using parameters from getCapabilities response
 *
 * @param {Object} layerInfo - layer information from getCapabilities response
 * @private
 */
LayerImport.prototype._addGetCapWMSLayer = function (layerInfo) {
    var map = this.getMap();
    if (!map) {
        logger.warn("[ol.control.LayerImport] _addGetCapWMSLayer error : map is not defined");
        return;
    }
    if (!layerInfo) {
        logger.warn("[ol.control.LayerImport] _addGetCapWMSLayer error : layerInfo is not defined");
        return;
    }

    // récupération de la projection de la carte
    var mapProjCode = this._getMapProjectionCode();

    var wmsSourceOptions = {};

    // Récupération de l'url
    var getMapUrl = this._getWMSLayerGetMapUrl();
    // on essaie de récupérer l'url du service dans le getCapbilities
    if (getMapUrl) {
        wmsSourceOptions.url = getMapUrl;
    } else {
        // sinon, on récupère l'url du getCapabilities, à laquelle on enlève éventuellement les paramètres
        var questionMarkIndex = this._getCapRequestUrl.indexOf("?");
        if (questionMarkIndex !== -1) {
            wmsSourceOptions.url = this._getCapRequestUrl.substring(0, questionMarkIndex);
        } else {
            wmsSourceOptions.url = this._getCapRequestUrl;
        }
    }

    wmsSourceOptions.params = {};
    if (layerInfo.Name) {
        wmsSourceOptions.params["LAYERS"] = layerInfo.Name;
    } else {
        logger.warn("[ol.control.LayerImport] unable to add wms layer : mandatory layer 'name' parameter cannot be found", layerInfo);
        return;
    }
    wmsSourceOptions.params["SERVICE"] = "WMS";
    if (this._getCapResponseWMS.version) {
        wmsSourceOptions.params["VERSION"] = this._getCapResponseWMS.version;
    }

    // on a déjà vérifié que la couche peut être reprojetée,
    // on vérifie que la couche ait une projection compatible avec celle de la carte
    // ou soit connue par proj4js
    var projection = layerInfo._projection;
    if (!projection) {
        logger.warn("[ol.control.LayerImport] wms layer cannot be added to map : unknown projection");
        return;
    } else if (projection !== mapProjCode) {
        // si la projection de la carte n'est pas disponible pour cette couche,
        // on spécifie une projection (qui doit avoir été définie dans proj4js) pour reprojection par Openlayers
        wmsSourceOptions.projection = projection;
    }

    // récupération du premier style disponible (pas d'info default?)
    var legend;
    if (layerInfo.Style && Array.isArray(layerInfo.Style)) {
        var style = layerInfo.Style[0];
        wmsSourceOptions.params["STYLES"] = style.Name;
        if (style.LegendURL && Array.isArray(style.LegendURL) && style.LegendURL.length !== 0) {
            legend = style.LegendURL[0].OnlineResource;
        }
    }

    // Création de la source (tester un try catch ?)
    var wmsSource = new _ol2.default.source.TileWMS(wmsSourceOptions);
    // ajout des informations pour le layerSwitcher (titre, description, legendes, metadata) ou originators
    this._getWMSLayerInfoForLayerSwitcher(layerInfo, legend, wmsSource);

    var layerTileOptions = {};
    layerTileOptions["source"] = wmsSource;
    // récupération des résolutions min et max de la layer à partir des dénominateurs d'échelle
    this._getWMSLayerMinMaxResolution(layerInfo, mapProjCode, layerTileOptions);
    // récupération de l'étendue (bbox)
    this._getWMSLayerExtent(layerInfo, mapProjCode, layerTileOptions);

    // création de la couche à partir de la source
    var wmsLayer = new _ol2.default.layer.Tile(layerTileOptions);
    // on rajoute le champ gpResultLayerId permettant d'identifier une couche crée par le composant. (pour layerSwitcher par ex)
    wmsLayer.gpResultLayerId = "layerimport:WMS";
    // on rajoute le champ gpGFIparams permettant d'identifier si la couche est queryable, et de transmettre les formats reconnus par GetFeatureInfo
    if (layerInfo.queryable) {
        wmsLayer.gpGFIparams = {
            queryable: true
        };
        // récupération des différents formats reconnus par le GetFeatureInfo
        if (this._getCapResponseWMS && this._getCapResponseWMS.Capability && this._getCapResponseWMS.Capability.Request && this._getCapResponseWMS.Capability.Request.GetFeatureInfo && this._getCapResponseWMS.Capability.Request.GetFeatureInfo.Format && Array.isArray(this._getCapResponseWMS.Capability.Request.GetFeatureInfo.Format)) {
            wmsLayer.gpGFIparams.formats = this._getCapResponseWMS.Capability.Request.GetFeatureInfo.Format;
        }
    }

    map.addLayer(wmsLayer);
};

/**
 * this method is called by this._addGetCapWMSLayer
 * and gets service getMap request url
 *
 * @return {String} getmapurl - service getMap request url
 * @private
 */
LayerImport.prototype._getWMSLayerGetMapUrl = function () {
    var getmapurl;
    if (this._getCapResponseWMS && this._getCapResponseWMS.Capability && this._getCapResponseWMS.Capability.Request && this._getCapResponseWMS.Capability.Request.GetMap) {
        var getmap = this._getCapResponseWMS.Capability.Request.GetMap;
        if (getmap.DCPType && Array.isArray(getmap.DCPType) && getmap.DCPType.length !== 0) {
            var url = getmap.DCPType[0];
            if (url && url.HTTP && url.HTTP.Get) {
                getmapurl = url.HTTP.Get.OnlineResource;
            }
        }
    }
    return getmapurl;
};

/**
 * this method is called by this._addGetCapWMSLayer
 * and gets a projection both available for a given layer and already defined in proj4js (ol.proj)
 * (openlayers raster reprojection will be then able to reproject layer in map projection)
 *
 * @param {Object} layerInfo - layer information from getCapabilities response
 * @param {String} mapProjCode - map projection code (e.g. "EPSG:4326")
 * @return {String} projection - ol.proj projection alias (e.g. "EPSG:4326")
 * @private
 */
LayerImport.prototype._getWMSLayerProjection = function (layerInfo, mapProjCode) {
    var projection;

    if (!layerInfo || (typeof layerInfo === "undefined" ? "undefined" : _typeof(layerInfo)) !== "object") {
        logger.warn("missing layer information (from getCapabilities)");
        return;
    }

    // on va parcourir la liste des CRS disponibles pour la couche
    // si on trouve la projection de la carte : c'est parfait
    // si on trouve une projection qui est connue par ol.proj : Openlayers gère la reprojection
    var CRSList = layerInfo.CRS;
    if (Array.isArray(CRSList)) {
        for (var i = 0; i < CRSList.length; i++) {
            var layerCRS = CRSList[i];
            if (layerCRS === mapProjCode) {
                projection = layerCRS;
                break;
            } else {
                if (layerCRS && typeof layerCRS === "string") {
                    if (_ol2.default.proj.get(layerCRS) || _ol2.default.proj.get(layerCRS.toUpperCase())) {
                        projection = layerCRS;
                        break;
                    }
                }
            }
        }
    }
    return projection;
};

/**
 * this method is called by this._addGetCapWMSLayer
 * and sets minResolution and maxResolution parameters for WMS layer (if available in getCapabilities response)
 *
 * @param {Object} layerInfo - layer information from getCapabilities response
 * @param {String} mapProjCode - map projection code (e.g. "EPSG:4326")
 * @param {Object} layerTileOptions - options for ol.layer.Tile (to be filled)
 * @private
 */
LayerImport.prototype._getWMSLayerMinMaxResolution = function (layerInfo, mapProjCode, layerTileOptions) {
    // récupération des résolutions min et max à partir des dénominateurs d'échelle
    var mapUnits = _ol2.default.proj.get(mapProjCode).getUnits();
    if (mapUnits === "m") {
        // info : 1 pixel = 0.00028 m
        if (layerInfo.MinScaleDenominator) {
            layerTileOptions.minResolution = layerInfo.MinScaleDenominator * 0.00028;
        }
        if (layerInfo.MaxScaleDenominator) {
            layerTileOptions.maxResolution = layerInfo.MaxScaleDenominator * 0.00028;
        }
    } else if (mapUnits === "degrees") {
        // info : 6378137 * 2 * pi / 360 = rayon de la terre (ellipsoide WGS84)
        var cste = 0.00028 * 180 / (Math.PI * 6378137);
        if (layerInfo.MinScaleDenominator) {
            layerTileOptions.minResolution = layerInfo.MinScaleDenominator * cste;
        }
        if (layerInfo.MaxScaleDenominator) {
            layerTileOptions.maxResolution = layerInfo.MaxScaleDenominator * cste;
        }
    }
};

/**
 * this method is called by this._addGetCapWMSLayer
 * and sets extent for WMS layer in map projection (if available in getCapabilities response)
 *
 * @param {Object} layerInfo - layer information from getCapabilities response
 * @param {String} mapProjCode - map projection code (e.g. "EPSG:4326")
 * @param {Object} layerTileOptions - options for ol.layer.Tile (to be filled)
 * @private
 */
LayerImport.prototype._getWMSLayerExtent = function (layerInfo, mapProjCode, layerTileOptions) {
    if (!layerInfo) {
        logger.warn("[ol.control.LayerImport] _getWMSLayerExtent error : layerInfo is not defined");
        return;
    }

    // récupération des 2 propriétés qui peuvent spécifier l'étendue (bbox) selon les specs OGC WMS 1.3.0 :
    // 1. layerInfo.EX_GeographicBoundingBox est un tableau de type [westBoundLongitude, southBoundLatitude, eastBoundLongitude, northBoundLatitude] en WGS84
    var exGeographicBoundingBox = layerInfo["EX_GeographicBoundingBox"];
    // 2. layerInfo.BoundingBox est un tableau dont chaque élément est un objet (balise bbox) avec les propriétés suivantes :
    // crs (String) et extent (tableau de type [minx, miny, maxx, maxy])
    var boundingBox = layerInfo.BoundingBox;

    if (exGeographicBoundingBox && Array.isArray(exGeographicBoundingBox)) {
        if (mapProjCode === "EPSG:4326") {
            // si la projection de la carte est la même que celle de l'extent (EPSG:4326), on la passe telle quelle
            layerTileOptions.extent = exGeographicBoundingBox;
        } else {
            layerTileOptions.extent = _ol2.default.proj.transformExtent(exGeographicBoundingBox, "EPSG:4326", mapProjCode);
        }

        // si jamais EX_GeographicBoundingBox n'est pas ou est mal renseigné, on essaie de récupérer via le paramètre BoundingBox
    } else if (boundingBox && Array.isArray(boundingBox)) {
        var crs;
        var extent;
        for (var i = 0; i < boundingBox.length; i++) {
            // on peut avoir plusieurs BoundingBox
            crs = boundingBox[i].crs;
            extent = boundingBox[i].extent;
            if (crs) {
                if (crs === mapProjCode) {
                    // si la bbox est dans la projection de la carte, on la passe telle quelle
                    layerTileOptions.extent = extent;
                    break;
                } else {
                    if (crs && typeof crs === "string") {
                        var olProj = _ol2.default.proj.get(crs) ? _ol2.default.proj.get(crs) : _ol2.default.proj.get(crs.toUpperCase());
                        // if ( ol.proj.get(crs) || ol.proj.get(crs.toUpperCase()) ) {
                        if (olProj) {
                            // si la bbox est dans une projection connue, on va la reprojeter
                            // tout d'abord, on gère le cas des systèmes EPSG géographiques : inversion des axes x et y
                            if (olProj.getUnits() === "degrees" && crs.toUpperCase().indexOf("EPSG") === 0) {
                                // le tableau extent est inversé, on a besoin de : [miny, minx, maxx, maxy]
                                var reversedExtent = [extent[1], extent[0], extent[3], extent[2]];
                                layerTileOptions.extent = _ol2.default.proj.transformExtent(reversedExtent, olProj, mapProjCode);
                            } else {
                                // reprojection dans la projection de la carte
                                layerTileOptions.extent = _ol2.default.proj.transformExtent(extent, olProj, mapProjCode);
                            }
                            break;
                        }
                    }
                }
            }
        }
    }
};

/**
 * this method is called by this._addGetCapWMSLayer
 * and sets more information about layer (legends, title, description, metadata, originators) for layerSwitcher or attributions controls
 *
 * @param {Object} layerInfo - layer information from getCapabilities response
 * @param {String} legend - legend url
 * @param {Object} wmsSource - options for ol.source.TileWMS (to be filled)
 * @private
 */
LayerImport.prototype._getWMSLayerInfoForLayerSwitcher = function (layerInfo, legend, wmsSource) {
    // ajout des informations pour le layerSwitcher (titre, description)
    if (layerInfo.Title) {
        wmsSource._title = layerInfo.Title;
        wmsSource._description = layerInfo.Abstract ? layerInfo.Abstract : layerInfo.Title;
    } else {
        wmsSource._title = layerInfo.Name;
        wmsSource._description = layerInfo.Abstract ? layerInfo.Abstract : layerInfo.Name;
    }
    // ajout de légende si on en a trouvé
    if (legend) {
        wmsSource._legends = [{
            url: legend
        }];
    }
    // ajout d'éventuelles métadonnées
    if (layerInfo.MetadataURL && Array.isArray(layerInfo.MetadataURL)) {
        wmsSource._metadata = [];
        for (var i = 0; i < layerInfo.MetadataURL.length; i++) {
            var metadata = layerInfo.MetadataURL[i].OnlineResource;
            if (metadata) {
                wmsSource._metadata.push({
                    url: metadata
                });
            }
        }
    }
    // ajout d'éventuelles attributions / originators
    if (layerInfo.Attribution) {
        var attribution = layerInfo.Attribution;
        wmsSource._originators = {};
        if (attribution.OnlineResource) {
            wmsSource._originators.url = attribution.OnlineResource;
        }
        if (attribution.Title) {
            wmsSource._originators.name = wmsSource._originators.attribution = attribution.Title;
        }
        if (attribution.LogoURL && attribution.LogoURL.OnlineResource) {
            wmsSource._originators.logo = attribution.LogoURL.OnlineResource;
        }
    }
};

// ################################################################### //
// ######### create WMTS layer from getCapabilities response ######### //
// ################################################################### //

/**
 * this method is called by this._onGetCapResponseLayerClick
 * and add WMTS layer to map using parameters from getCapabilities response
 *
 * @param {Object} layerInfo - layer information from getCapabilities response
 * @private
 */
LayerImport.prototype._addGetCapWMTSLayer = function (layerInfo) {
    if (!layerInfo || !layerInfo.Identifier) {
        logger.warn("[ol.control.LayerImport] layer information not found in getCapabilities response for layer ");
        return;
    }

    var map = this.getMap();
    if (!map) {
        return;
    }

    var wmtsSourceOptions = {};
    wmtsSourceOptions.layer = layerInfo.Identifier;
    // service version
    if (this._getCapResponseWMTS.version) {
        wmtsSourceOptions.version = this._getCapResponseWMTS.version;
    }
    // Récupération de l'url
    var getMapUrl = this._getWMTSLayerGetTileUrl();
    // on essaie de récupérer l'url du service dans le getCapbilities
    if (getMapUrl) {
        wmtsSourceOptions.url = getMapUrl;
    } else {
        // sinon, on récupère l'url du getCapabilities, à laquelle on enlève éventuellement les paramètres
        var questionMarkIndex = this._getCapRequestUrl.indexOf("?");
        if (questionMarkIndex !== -1) {
            wmtsSourceOptions.url = this._getCapRequestUrl.substring(0, questionMarkIndex);
        } else {
            wmtsSourceOptions.url = this._getCapRequestUrl;
        }
    }

    // Récupération des informations de la pyramide (tileGrid information) : matrixIds, resolutions, origin et projection
    var tmsOptions = this._getTMSParams(layerInfo);
    wmtsSourceOptions.matrixSet = tmsOptions.tms;
    wmtsSourceOptions.projection = tmsOptions.projCode;
    wmtsSourceOptions.tileGrid = new _ol2.default.tilegrid.WMTS({
        resolutions: tmsOptions.resolutions,
        matrixIds: tmsOptions.matrixIds,
        origin: tmsOptions.origin
    });

    // Récupération du style par défaut
    var defaultStyle;
    var legend;
    if (layerInfo.Style && Array.isArray(layerInfo.Style)) {
        var style;
        for (var s = 0; s < layerInfo.Style.length; s++) {
            style = layerInfo.Style[s];
            // on récupère le style
            defaultStyle = style.Identifier;
            if (style.isDefault) {
                // si c'est celui par défaut, on le garde (on ne boucle plus sur les autres styles)
                break;
            }
            // et une éventuelle légende
            if (style.LegendURL && Array.isArray(style.LegendURL) && style.LegendURL.length !== 0) {
                legend = style.LegendURL[0].href;
            }
        }
    }
    if (defaultStyle == null) {
        logger.warn("[ol.control.LayerImport] style information not found in getCapabilities response for layer " + layerInfo.Identifier);
    }
    wmtsSourceOptions.style = defaultStyle;

    // Récupération du format (le premier trouvé)
    var format;
    if (layerInfo.Format && Array.isArray(layerInfo.Format)) {
        format = layerInfo.Format[0];
    }
    if (format == null) {
        logger.warn("[ol.control.LayerImport] format information not found in getCapabilities response for layer " + layerInfo.Identifier);
    }
    wmtsSourceOptions.format = format;

    // Création de la source (tester un try catch ?)
    var wmtsSource = new _ol2.default.source.WMTS(wmtsSourceOptions);

    // ajout des informations pour le layerSwitcher (titre, description)
    if (layerInfo.Title) {
        wmtsSource._title = layerInfo.Title;
        wmtsSource._description = layerInfo.Abstract ? layerInfo.Abstract : layerInfo.Title;
    } else {
        wmtsSource._title = layerInfo.Identifier;
        wmtsSource._description = layerInfo.Abstract ? layerInfo.Abstract : layerInfo.Identifier;
    }
    // ajout d'une éventuelle légende
    if (legend) {
        wmtsSource._legends = [{
            url: legend
        }];
    }

    var layerTileOptions = {};
    layerTileOptions.source = wmtsSource;
    // récupération de l'étendue (bbox)
    layerTileOptions.extent = this._getWMTSLayerExtent(layerInfo);
    var wmtsLayer;
    try {
        wmtsLayer = new _ol2.default.layer.Tile(layerTileOptions);
    } catch (e) {
        logger.warn("[ol.control.LayerImport] an error occured while trying to create ol.layer.Tile from getCapabilities information. error : ", e);
        return;
    }
    // on rajoute le champ gpResultLayerId permettant d'identifier une couche crée par le composant. (pour layerSwitcher par ex)
    wmtsLayer.gpResultLayerId = "layerimport:WMTS";

    map.addLayer(wmtsLayer);
};

/**
 * this method is called by this._addGetCapWMTSLayer
 * and gets service getTile request url
 *
 * @return {String} gettileurl - service getTile request url
 * @private
 */
LayerImport.prototype._getWMTSLayerGetTileUrl = function () {
    var gettileurl;
    if (this._getCapResponseWMTS && this._getCapResponseWMTS.OperationsMetadata && this._getCapResponseWMTS.OperationsMetadata.GetTile) {
        var gettile = this._getCapResponseWMTS.OperationsMetadata.GetTile;
        if (gettile.DCP && gettile.DCP.HTTP && gettile.DCP.HTTP.Get && Array.isArray(gettile.DCP.HTTP.Get) && gettile.DCP.HTTP.Get.length !== 0) {
            gettileurl = gettile.DCP.HTTP.Get[0].href;
        }
    }
    return gettileurl;
};

/**
 * this method is called by this._displayGetCapResponseLayers
 * and gets layer TileMatrixSet projection if defined in proj4js
 *
 * @param {Object} layerInfo - layer information from getCapabilities response
 * @param {Object} getCapResponseWMTS - whole getCapabilities response
 * @return {String} projection - ol.proj projection alias (e.g. "EPSG:4326")
 * @private
 */
LayerImport.prototype._getWMTSLayerProjection = function (layerInfo, getCapResponseWMTS) {
    var projection;

    if (!layerInfo || (typeof layerInfo === "undefined" ? "undefined" : _typeof(layerInfo)) !== "object") {
        logger.warn("missing layer information (from getCapabilities)");
        return;
    }

    if (!getCapResponseWMTS || (typeof getCapResponseWMTS === "undefined" ? "undefined" : _typeof(getCapResponseWMTS)) !== "object") {
        logger.warn("missing getCapabilities response");
        return;
    }

    if (layerInfo.TileMatrixSetLink && Array.isArray(layerInfo.TileMatrixSetLink)) {
        var tms = layerInfo.TileMatrixSetLink[0].TileMatrixSet;
        var crs;
        if (getCapResponseWMTS.Contents && Array.isArray(getCapResponseWMTS.Contents.TileMatrixSet)) {
            var tileMatrixSets = getCapResponseWMTS.Contents.TileMatrixSet;
            for (var i = 0; i < tileMatrixSets.length; i++) {
                if (tileMatrixSets[i].Identifier === tms && tileMatrixSets[i].TileMatrix) {
                    // on a trouvé le TMS correspondant
                    var tileMatrixSet = tileMatrixSets[i];
                    crs = tileMatrixSet.SupportedCRS;
                    if (crs && typeof crs === "string") {
                        if (_ol2.default.proj.get(crs) || _ol2.default.proj.get(crs.toUpperCase())) {
                            projection = crs;
                        }
                    }
                    break;
                }
            }
        }
    };

    return projection;
};

/**
 * this method is called by this._addGetCapWMTSLayer
 * and get ol.tileGrid.WMTS parameters using getCapabilities response
 *
 * @param {Object} layerInfo - layer information from getCapabilities response
 * @return {Object} tmsOptions - ol.tileGrid.WMTS options
 * @private
 */
LayerImport.prototype._getTMSParams = function (layerInfo) {
    var tmsOptions = {};

    var matrixIds = [];
    var resolutions = [];
    var origin = [];
    var tms;
    var projCode;
    var projection;

    // TODO : recup TOUS les autres params d'un tileGrid ! (tileSize, width...)

    var map = this.getMap();
    if (!map) {
        return;
    }

    // Récupération des informations de la pyramide (tileGrid information) : matrixIds, resolutions, origin
    if (layerInfo.TileMatrixSetLink && Array.isArray(layerInfo.TileMatrixSetLink)) {
        tms = layerInfo.TileMatrixSetLink[0].TileMatrixSet;

        if (this._getCapResponseWMTS.Contents && Array.isArray(this._getCapResponseWMTS.Contents.TileMatrixSet)) {
            var tileMatrixSets = this._getCapResponseWMTS.Contents.TileMatrixSet;
            for (var i = 0; i < tileMatrixSets.length; i++) {
                if (tileMatrixSets[i].Identifier === tms && tileMatrixSets[i].TileMatrix) {
                    // on a trouvé le TMS correspondant
                    var tileMatrixSet = tileMatrixSets[i];

                    var tilematrix;
                    var id;
                    var scaledenominator;
                    var resolution;
                    var units;

                    if (tileMatrixSet.SupportedCRS) {
                        projCode = tileMatrixSet.SupportedCRS;
                        projection = _ol2.default.proj.get(projCode);
                    }
                    if (projection && projection.getUnits) {
                        units = projection.getUnits();
                    }

                    if (Array.isArray(tileMatrixSet.TileMatrix)) {
                        for (var j = 0; j < tileMatrixSet.TileMatrix.length; j++) {
                            // construction du tableau des matrixIds
                            tilematrix = tileMatrixSet.TileMatrix[j];
                            if (tilematrix.Identifier != null) {
                                id = parseInt(tilematrix.Identifier, 10);
                                matrixIds.push(id);
                            }

                            // construction du tableau des résolutions, calculées à partir des dénominateurs d'échelle (scaledenominator)
                            scaledenominator = tilematrix.ScaleDenominator;
                            // calcul des résolutions selon la projection du TMS : selon si on a des coordonnées planes ou géographiques
                            if (units === "degrees") {
                                // info : 6378137 * 2 * pi / 360 = rayon de la terre (ellipsoide WGS84)
                                resolution = scaledenominator * 0.00028 * 180 / (Math.PI * 6378137);
                            } else {
                                // info : 1 pixel = 0.00028 m
                                resolution = scaledenominator * 0.00028;
                            }
                            resolutions.push(resolution);

                            origin = tilematrix.TopLeftCorner;
                        }
                    }

                    // tri des résolutions par ordre décroissant
                    if (Array.isArray(resolutions) && resolutions.sort !== undefined) {
                        resolutions.sort(function (x, y) {
                            return y - x;
                        });
                    }
                    // tri des identifiants des niveaux de pyramide (matrixIds) par ordre croissant
                    if (Array.isArray(matrixIds) && matrixIds.sort !== undefined) {
                        matrixIds.sort(function (x, y) {
                            return x - y;
                        });
                    }
                }
            }
        } else {
            logger.warn("[ol.control.LayerImport] TileMatrixSet data not found in getCapabilities response for layer " + layerInfo.Identifier);
        }
    } else {
        return;
    }

    tmsOptions.tms = tms;
    tmsOptions.projCode = projCode;
    tmsOptions.matrixIds = matrixIds;
    tmsOptions.resolutions = resolutions;
    tmsOptions.origin = origin;

    return tmsOptions;
};

/**
 * this method is called by this._addGetCapWMTSLayer
 * and sets extent for WMTS layer in map projection (if available in getCapabilities response)
 *
 * @param {Object} layerInfo - layer information from getCapabilities response
 * @return {Array} extent - layer extent
 * @private
 */
LayerImport.prototype._getWMTSLayerExtent = function (layerInfo) {
    var extent;
    var mapProjCode = this._getMapProjectionCode();

    // récupération de l'étendue (bbox)
    if (layerInfo.WGS84BoundingBox && Array.isArray(layerInfo.WGS84BoundingBox)) {
        extent = _ol2.default.proj.transformExtent(layerInfo.WGS84BoundingBox, "EPSG:4326", mapProjCode);
    }

    return extent;
};

// ################################################################### //
// ################################ utils ############################ //
// ################################################################### //

/**
 * gets control map projection code
 *
 * @return {String} mapProjCode - control map projection code (e.g. "EPSG:3857")
 * @private
 */
LayerImport.prototype._getMapProjectionCode = function () {
    var map = this.getMap();
    if (!map || !map.getView || !map.getView().getProjection) {
        logger.warn("unable to get layerimport's map");
        return;
    }
    var mapProjCode = map.getView().getProjection().getCode();
    return mapProjCode;
};

// ################################################################### //
// ################################ clean ############################ //
// ################################################################### //

/**
 * this method displays waiting container and sets a timeout
 *
 * @private
 */
LayerImport.prototype._displayWaitingContainer = function () {
    this._waitingContainer.className = "GPimportWaitingContainerVisible";
    this._waiting = true;

    // mise en place d'un timeout pour réinitialiser le panel (cacher la patience)
    // si on est toujours en attente (si la requête est bloquée par exemple)
    if (this._timer) {
        clearTimeout(this._timer);
        this._timer = null;
    }
    var context = this;
    this._timer = setTimeout(function () {
        if (context._waiting === true) {
            context._hideWaitingContainer();
        } else {
            if (context._timer) {
                clearTimeout(context._timer);
            }
        }
    }, 16000);
};

/**
 * this method hides waiting container and clears timeout
 *
 * @private
 */
LayerImport.prototype._hideWaitingContainer = function () {
    if (this._waiting) {
        this._waitingContainer.className = "GPimportWaitingContainerHidden";
        this._waiting = false;
        clearTimeout(this._timer);
        this._timer = null;
    }
};

/**
 * this method clears previous getCap request url or response information
 *
 * @private
 */
LayerImport.prototype._clearGetCapParams = function () {
    this._getCapRequestUrl = null;
    this._getCapResponseWMS = null;
    this._getCapResponseWMTS = null;
    this._getCapResponseWMSLayers = null;
    this._getCapResponseWMTSLayers = null;
};

/**
 * this method empties getCap results list (DOM element)
 *
 * @private
 */
LayerImport.prototype._emptyGetCapResultsList = function () {
    if (this._getCapResultsListContainer) {
        while (this._getCapResultsListContainer.firstChild) {
            this._getCapResultsListContainer.removeChild(this._getCapResultsListContainer.firstChild);
        }
    }
};

exports.default = LayerImport;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayerImportDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPimport");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ######################### show widget ############################# //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing
     *
     * @returns {DOMElement} DOM element
     */
    _createShowImportElement: function _createShowImportElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowImport");
        input.type = "checkbox";
        return input;
    },

    /**
     * Show Import
     *
     * @returns {DOMElement} DOM element
     */
    _createShowImportPictoElement: function _createShowImportPictoElement() {
        // contexte d'execution
        var self = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowImportPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowImport");
        label.title = "Ouvrir l'import de couches";

        // Close all results and panels when minimizing the widget
        if (label.addEventListener) {
            label.addEventListener("click", function () {
                self._onShowImportClick();
            });
        } else if (label.attachEvent) {
            label.attachEvent("onclick", function () {
                self._onShowImportClick();
            });
        }

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowImportOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    },

    // ################################################################### //
    // ######################### Header panel ############################ //
    // ################################################################### //

    /**
     * Create Container Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createImportPanelElement: function _createImportPanelElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPimportPanel");
        div.className = "GPpanel";

        return div;
    },

    /**
     * Create Header Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createImportPanelHeaderElement: function _createImportPanelHeaderElement() {
        var container = document.createElement("div");
        container.className = "GPpanelHeader";

        // panel title
        var panelTitle = this._createImportPanelTitleElement();
        container.appendChild(panelTitle);
        // close picto
        var closeDiv = this._createImportPanelCloseElement();
        container.appendChild(closeDiv);

        return container;
    },

    /**
     * Create Header Title Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createImportPanelTitleElement: function _createImportPanelTitleElement() {
        var div = document.createElement("div");
        div.className = "GPpanelTitle";
        div.innerHTML = "Import de données";
        return div;
    },

    /**
     * Create Header close div
     *
     * @returns {DOMElement} DOM element
     */
    _createImportPanelCloseElement: function _createImportPanelCloseElement() {
        // contexte
        var self = this;

        var divClose = document.createElement("div");
        divClose.id = this._addUID("GPimportPanelClose");
        divClose.className = "GPpanelClose";
        divClose.title = "Fermer le panneau";

        // Link panel close / visibility checkbox
        if (divClose.addEventListener) {
            divClose.addEventListener("click", function () {
                document.getElementById(self._addUID("GPshowImportPicto")).click();
            }, false);
        } else if (divClose.attachEvent) {
            divClose.attachEvent("onclick", function () {
                document.getElementById(self._addUID("GPshowImportPicto")).click();
            });
        }

        return divClose;
    },

    // ################################################################### //
    // ########################### Form panel ############################ //
    // ################################################################### //

    /**
     * Create Form
     * see event !
     *
     * @returns {DOMElement} DOM element
     */
    _createImportPanelFormElement: function _createImportPanelFormElement() {
        // contexte d'execution
        var self = this;

        var form = document.createElement("form");
        form.id = this._addUID("GPimportForm");
        form.className = "map-tool-box";

        // TODO ?
        if (form.addEventListener) {
            form.addEventListener("submit", function (e) {
                e.preventDefault();
                self._onImportSubmit();
            });
        } else if (form.attachEvent) {
            form.attachEvent("onsubmit", function (e) {
                e.preventDefault();
                self._onImportSubmit();
            });
        }

        return form;
    },

    /**
     * Create Container for import type choice
     *
     * @param {Array} importTypes - import types to be displayed (and used)
     * @returns {DOMElement} DOM element
     */
    _createImportTypeLineElement: function _createImportTypeLineElement(importTypes) {
        // contexte d'execution
        var context = this;

        var div = document.createElement("div");
        div.id = this._addUID("GPimportTypeLine");
        div.className = "GPimportInputLine";

        var label = document.createElement("label");
        label.htmlFor = this._addUID("GPimportType");
        label.className = "GPimportLabel";
        label.innerHTML = "Type de donnée";
        label.title = "Type de donnée";
        div.appendChild(label);

        var select = document.createElement("select");
        select.className = "GPimportSelect";
        // gestionnaire d'evenement : on stocke la valeur du type d'import
        if (select.addEventListener) {
            select.addEventListener("change", function (e) {
                if (this.value === "KML" || this.value === "GPX" || this.value === "GeoJSON") {
                    // static import
                    document.getElementById(context._addUID("GPimportStaticParams")).className = "GPimportVisibleParams";
                    document.getElementById(context._addUID("GPimportServiceParams")).className = "GPimportHiddenParams";
                } else if (this.value === "WMS" || this.value === "WMTS" || this.value === "WFS") {
                    // service import
                    document.getElementById(context._addUID("GPimportServiceParams")).className = "GPimportVisibleParams";
                    document.getElementById(context._addUID("GPimportStaticParams")).className = "GPimportHiddenParams";
                }
                context._onImportTypeChange(e);
            });
        } else if (select.attachEvent) {
            select.attachEvent("onchange", function () {
                if (this.value === "KML" || this.value === "GPX" || this.value === "GeoJSON") {
                    // static import
                    document.getElementById(context._addUID("GPimportStaticParams")).className = "GPimportVisibleParams";
                    document.getElementById(context._addUID("GPimportServiceParams")).className = "GPimportHiddenParams";
                } else if (this.value === "WMS" || this.value === "WMTS" || this.value === "WFS") {
                    // service import
                    document.getElementById(context._addUID("GPimportServiceParams")).className = "GPimportVisibleParams";
                    document.getElementById(context._addUID("GPimportStaticParams")).className = "GPimportHiddenParams";
                }
                context._onImportTypeChange();
            });
        }
        select.id = this._addUID("GPimportType");

        // on prend soit les valeurs passées par l'utilisateur, soit des valeurs par défaut
        if (!importTypes || !Array.isArray(importTypes)) {
            importTypes = ["KML", "GPX", "GeoJSON", "WMS", "WMTS", "WFS"];
        }
        var option;
        for (var i = 0; i < importTypes.length; i++) {
            option = document.createElement("option");
            option.value = importTypes[i];
            option.text = importTypes[i];
            select.appendChild(option);
        }

        div.appendChild(select);

        return div;
    },

    /**
     * Create Waiting Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createImportWaitingElement: function _createImportWaitingElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPimportWaitingContainer");
        div.className = "GPimportWaitingContainerHidden";

        var p = document.createElement("p");
        p.className = "GPimportWaiting";
        p.innerHTML = "Recherche en cours...";

        div.appendChild(p);

        return div;
    },

    // ################################################################### //
    // ############### Params for static import (KML / GPX / GeoJSON) ############## //
    // ################################################################### //

    /**
     * Create container for KML/GPX/GeoJSON parameters
     * @param {String} currentType - GeoJSON, GPX or KML value
     * @returns {DOMElement} DOM element
     */
    _createImportStaticParamsContainer: function _createImportStaticParamsContainer(currentType) {
        var div = document.createElement("div");
        div.id = this._addUID("GPimportStaticParams");
        if (currentType === "KML" || currentType === "GPX" || currentType === "GeoJSON") {
            div.className = "GPimportVisibleParams";
        } else {
            div.className = "GPimportHiddenParams";
        }

        return div;
    },

    /**
     * Create name label for KML/GPX/GeoJSON parameters
     *
     * @returns {DOMElement} DOM element
     */
    _createStaticNameLabel: function _createStaticNameLabel() {
        var div = document.createElement("div");
        div.className = "GPimportInputLine";

        var label = document.createElement("label");
        label.className = "GPimportLabel";
        label.htmlFor = this._addUID("GPimportName");
        label.innerHTML = "Nom";
        label.title = "Nom";
        div.appendChild(label);

        var input = document.createElement("input");
        input.type = "text";
        input.id = this._addUID("GPimportName");
        input.className = "GPimportInput";
        div.appendChild(input);

        return div;
    },

    /**
     * Create import choice for KML/GPX/GeoJSON parameters (local or url)
     *
     * @returns {DOMElement} DOM element
     */
    _createStaticModeChoiceDiv: function _createStaticModeChoiceDiv() {
        var div = document.createElement("div");
        div.id = this._addUID("GPimportChoice");
        return div;
    },

    /**
     * Create local import choice for KML/GPX/GeoJSON parameters
     *
     * @returns {DOMElement} DOM element
     */
    _createStaticLocalChoiceDiv: function _createStaticLocalChoiceDiv() {
        var context = this;

        var div = document.createElement("div");
        div.className = "GPimportChoiceAlt";

        var input = document.createElement("input");
        input.type = "radio";
        if (input.addEventListener) {
            input.addEventListener("change", function (e) {
                document.getElementById(context._addUID("GPimportValueLocal")).className = "GPimportInputLine";
                document.getElementById(context._addUID("GPimportValueUrl")).className = "GPimportValueHidden";
                context._onStaticImportTypeChange(e);
            });
        } else if (input.appendChild) {
            input.appendChild("onchange", function () {
                document.getElementById(context._addUID("GPimportValueLocal")).className = "GPimportInputLine";
                document.getElementById(context._addUID("GPimportValueUrl")).className = "GPimportValueHidden";
                context._onStaticImportTypeChange();
            });
        }
        input.name = "GPimportChoiceMode";
        input.value = "local";
        input.checked = true;
        input.id = this._addUID("GPimportChoiceAltLocal");
        div.appendChild(input);

        var label = document.createElement("label");
        label.className = "GPimportChoiceAltTxt";
        label.htmlFor = this._addUID("GPimportChoiceAltLocal");
        label.innerHTML = "par fichier local";
        label.title = "par fichier local";
        div.appendChild(label);

        return div;
    },

    /**
     * Create url import choice for KML/GPX/GeoJSON parameters
     *
     * @returns {DOMElement} DOM element
     */
    _createStaticUrlChoiceDiv: function _createStaticUrlChoiceDiv() {
        var context = this;

        var div = document.createElement("div");
        div.className = "GPimportChoiceAlt";

        var input = document.createElement("input");
        input.type = "radio";
        if (input.addEventListener) {
            input.addEventListener("change", function (e) {
                document.getElementById(context._addUID("GPimportValueUrl")).className = "GPimportInputLine";
                document.getElementById(context._addUID("GPimportValueLocal")).className = "GPimportValueHidden";
                context._onStaticImportTypeChange(e);
            });
        } else if (input.appendChild) {
            input.appendChild("onchange", function () {
                document.getElementById(context._addUID("GPimportValueUrl")).className = "GPimportInputLine";
                document.getElementById(context._addUID("GPimportValueLocal")).className = "GPimportValueHidden";
                context._onStaticImportTypeChange();
            });
        }
        input.id = this._addUID("GPimportChoiceAltUrl");
        input.name = "GPimportChoiceMode";
        input.value = "url";
        input.checked = false;
        div.appendChild(input);

        var label = document.createElement("label");
        label.className = "GPimportChoiceAltTxt";
        label.htmlFor = this._addUID("GPimportChoiceAltUrl");
        label.innerHTML = "par URL";
        label.title = "par URL";
        div.appendChild(label);

        return div;
    },

    /**
     * Create input div for KML/GPX/GeoJSON parameters local import
     *
     * @returns {DOMElement} DOM element
     */
    _createStaticLocalInputDiv: function _createStaticLocalInputDiv() {
        var div = document.createElement("div");
        div.id = this._addUID("GPimportValueLocal");
        div.className = "GPimportInputLine";
        return div;
    },

    /**
     * Create input label for KML/GPX/GeoJSON parameters local import
     *
     * @returns {DOMElement} DOM element
     */
    _createStaticLocalInputLabel: function _createStaticLocalInputLabel() {
        var label = document.createElement("label");
        label.className = "GPimportLabel";
        label.htmlFor = this._addUID("GPimportFile");
        label.innerHTML = "Fichier local";
        label.title = "Fichier local";
        return label;
    },

    /**
     * Create file input for KML/GPX/GeoJSON parameters local import
     *
     * @returns {DOMElement} DOM element
     */
    _createStaticLocalInput: function _createStaticLocalInput() {
        var input = document.createElement("input");
        input.type = "file";
        input.id = this._addUID("GPimportFile");
        input.className = "GPimportInputFile";
        return input;
    },

    /**
     * Create input div for KML/GPX/GeoJSON parameters url import
     *
     * @returns {DOMElement} DOM element
     */
    _createStaticUrlInputDiv: function _createStaticUrlInputDiv() {
        var div = document.createElement("div");
        div.id = this._addUID("GPimportValueUrl");
        div.className = "GPimportValueHidden";
        return div;
    },

    /**
     * Create input label for KML/GPX/GeoJSON parameters url import
     *
     * @returns {DOMElement} DOM element
     */
    _createStaticUrlInputLabel: function _createStaticUrlInputLabel() {
        var label = document.createElement("label");
        label.className = "GPimportLabel";
        label.htmlFor = this._addUID("GPimportUrl");
        label.innerHTML = "URL";
        label.title = "URL";
        return label;
    },

    /**
     * Create url input for KML/GPX/GeoJSON parameters url import
     *
     * @returns {DOMElement} DOM element
     */
    _createStaticUrlInput: function _createStaticUrlInput() {
        var input = document.createElement("input");
        input.type = "text";
        input.id = this._addUID("GPimportUrl");
        input.className = "GPimportInput";
        return input;
    },

    // ################################################################### //
    // ######## Params for service params import (WMS//WMTS/WFS) ######### //
    // ################################################################### //

    /**
     * Create container for WMS/WMTS/WFS parameters
     * @param {String} currentType - WMS, WMTS or WFS value
     * @returns {DOMElement} DOM element
     */
    _createServiceParamsContainer: function _createServiceParamsContainer(currentType) {
        var div = document.createElement("div");
        div.id = this._addUID("GPimportServiceParams");
        if (currentType === "WMS" || currentType === "WMTS" || currentType === "WFS") {
            div.className = "GPimportVisibleParams";
        } else {
            div.className = "GPimportHiddenParams";
        }

        return div;
    },

    /**
     * Create div for WMS/WMTS/WFS url
     *
     * @returns {DOMElement} DOM element
     */
    _createServiceUrlDiv: function _createServiceUrlDiv() {
        var div = document.createElement("div");
        div.className = "GPimportInputLine";
        return div;
    },

    /**
     * Create input label for WMS/WMTS/WFS url
     *
     * @returns {DOMElement} DOM element
     */
    _createServiceUrlInputLabel: function _createServiceUrlInputLabel() {
        var label = document.createElement("label");
        label.className = "GPimportLabel";
        label.htmlFor = this._addUID("GPimportServiceUrl");
        label.innerHTML = "URL du service";
        label.title = "URL du service";
        return label;
    },

    /**
     * Create input for WMS/WMTS/WFS parameters url
     *
     * @returns {DOMElement} DOM element
     */
    _createServiceUrlInput: function _createServiceUrlInput() {
        var input = document.createElement("input");
        input.type = "text";
        input.id = this._addUID("GPimportServiceUrl");
        input.className = "GPimportInput";
        return input;
    },

    // ################################################################### //
    // ########################### Submit Form ########################### //
    // ################################################################### //

    /**
     * Create Submit Form Element
     *
     * @returns {DOMElement} DOM element
     */
    _createImportSubmitFormElement: function _createImportSubmitFormElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPimportSubmit");
        input.className = "GPinputSubmit tool-form-submit";
        input.type = "submit";
        input.value = "Importer";

        return input;
    },

    // ################################################################### //
    // ########################### GetCap Panel ########################## //
    // ################################################################### //

    /**
     * Create GetCap Panel Element
     *
     * @returns {DOMElement} DOM element
     */
    _createImportGetCapPanelElement: function _createImportGetCapPanelElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPimportGetCapPanel");
        div.className = "GPpanel";
        return div;
    },

    /**
     * Create GetCap Panel Header Element
     *
     * @returns {DOMElement} DOM element
     */
    _createImportGetCapPanelHeaderElement: function _createImportGetCapPanelHeaderElement() {
        // contexte
        var context = this;

        var container = document.createElement("div");
        container.className = "GPpanelHeader";

        // panel title
        var panelTitle = document.createElement("div");
        panelTitle.className = "GPpanelTitle";
        panelTitle.innerHTML = "Couches accessibles";
        panelTitle.title = "Couches accessibles";
        container.appendChild(panelTitle);

        // close picto
        var closeDiv = document.createElement("div");
        if (closeDiv.addEventListener) {
            closeDiv.addEventListener("click", function () {
                document.getElementById(context._addUID("GPimportGetCapPanel")).style.display = "none";
                document.getElementById(context._addUID("GPimportPanel")).style.display = "";
                context._onGetCapPanelClose();
            });
        } else if (closeDiv.attachEvent) {
            closeDiv.attachEvent("click", function () {
                document.getElementById(context._addUID("GPimportGetCapPanel")).style.display = "none";
                document.getElementById(context._addUID("GPimportPanel")).style.display = "";
                context._onGetCapPanelClose();
            });
        }
        closeDiv.className = "GPpanelClose";
        closeDiv.title = "Fermer le panneau";
        closeDiv.id = this._addUID("GPimportGetCapPanelClose");
        container.appendChild(closeDiv);

        return container;
    },

    /**
     * Create GetCap Results List Element
     *
     * @returns {DOMElement} DOM element
     */
    _createImportGetCapResultsContainer: function _createImportGetCapResultsContainer() {
        var container = document.createElement("div");
        container.className = "GPimportGetCapRoot";
        container.id = this._addUID("GPimportGetCapResults");

        return container;
    },

    _addImportGetCapResultListRubrique: function _addImportGetCapResultListRubrique(title, container) {
        var ul = document.createElement("ul");
        ul.className = "GPimportGetCapListRubrique";
        ul.title = title;

        container.appendChild(ul);
        return container;
    },

    _addImportGetCapResultRubrique: function _addImportGetCapResultRubrique(title, container) {
        var li = document.createElement("li");
        li.className = "GPimportGetCapRubrique";

        // input
        var input = document.createElement("input");
        input.id = "GPimportGetCapRubrique-" + _SelectorID2.default.generate();
        input.className = "GPimportGetCapRubrique";
        input.type = "checkbox";
        li.appendChild(input);

        // label for
        var label = document.createElement("label");
        label.className = "GPimportGetCapRubriqueTitle";
        label.htmlFor = input.id;
        label.innerHTML = title;
        label.title = title;
        li.appendChild(label);

        container.appendChild(li);
        return container;
    },

    _addImportGetCapResultListLayer: function _addImportGetCapResultListLayer(container) {
        var ul = document.createElement("ul");
        ul.className = "GPimportGetCapListLayer";

        container.appendChild(ul);
        return container;
    },

    _addImportGetCapResultLayer: function _addImportGetCapResultLayer(description, id, container) {
        var li = document.createElement("li");
        li.className = "GPimportGetCapProposal";
        li.innerHTML = description.content;
        li.title = description.title;
        li.id = "GPimportGetCapProposal_" + id;

        var context = this;
        if (li.addEventListener) {
            li.addEventListener("click", function (e) {
                context._onGetCapResponseLayerClick(e);
            });
        } else if (li.attachEvent) {
            li.attachEvent("onclick", function () {
                context._onGetCapResponseLayerClick();
            });
        }

        container.appendChild(li);
        return container;
    }

};

exports.default = LayerImportDOM;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _LayerUtils = __webpack_require__(12);

var _LayerUtils2 = _interopRequireDefault(_LayerUtils);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("geoportalattribution");

/**
 * @classdesc
 * OpenLayers Control to manage Originators for layer resources
 *
 * @constructor
 * @extends {ol.control.Attribution}
 * @alias ol.control.GeoportalAttribution
 * @param {Object} options - ol.control.Attribution options (see {@link http://openlayers.org/en/latest/apidoc/ol.control.Attribution.html ol.Control.Attribution})
 * @example
 * map.addControl(
 *      new ol.control.GeoportalAttribution({
 *          collapsed : false
 * );
 */
function GeoportalAttribution(options) {
    if (!(this instanceof GeoportalAttribution)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // call ol.control.Attribution constructor
    _ol2.default.control.Attribution.call(this, options);
}

// Inherits from ol.control.Attribution
_ol2.default.inherits(GeoportalAttribution, _ol2.default.control.Attribution);

/*
 * @lends module:GeoportalAttribution
 */
GeoportalAttribution.prototype = Object.create(_ol2.default.control.Attribution.prototype, {});

/**
 * Constructor (alias)
 */
GeoportalAttribution.prototype.constructor = GeoportalAttribution;

/**
 * Overload setMap function, that enables to catch map events, such as movend events.
 *
 * @param {ol.Map} map - Map.
 */
GeoportalAttribution.prototype.setMap = function (map) {
    if (map != null) {
        // Remove default ol.control.Attribution
        var ctrls = map.getControls();
        ctrls.forEach(function (element) {
            if (element instanceof _ol2.default.control.Attribution && !(element instanceof GeoportalAttribution)) {
                this.remove(element);
            }
        }, ctrls);

        // on récupère les attributions des couches déjà ajoutées à la carte.
        this._updateAttributions(map);

        // At every map movement, layers attributions have to be updated,
        // according to map and originators zoom and extent.
        var context = this;
        map.on("moveend", function () {
            context._updateAttributions(map);
        }, this);
        map.getLayers().on("add", function () {
            context._updateAttributions(map);
        }, this);
        map.getLayers().on("remove", function () {
            context._updateAttributions(map);
        }, this);
    }

    _ol2.default.control.Attribution.prototype.setMap.call(this, map);
};

/**
 * Update map layers attributions
 *
 * @param {ol.Map} map - Map.
 * @private
 */
GeoportalAttribution.prototype._updateAttributions = function (map) {
    // get map parameters
    var mapAttributions = {};

    var view = map.getView();
    // extent, then convert to geographical coordinates
    var extent = view.calculateExtent(map.getSize());
    var mapProjection = view.getProjection().getCode();
    var geoExtent = _ol2.default.proj.transformExtent(extent, mapProjection, "EPSG:4326");
    // transform extent from [minx, miny, maxx, maxy] to [maxy, minx, miny, maxx]
    var standardExtent = [geoExtent[3], geoExtent[0], geoExtent[1], geoExtent[2]];
    // zoom
    var zoom = view.getZoom();
    // layers
    var layers = map.getLayers().getArray();

    // info : This option suppresses warnings about functions inside of loops.
    /* jshint loopfunc: true */

    // loop on layers to get their originators, if there is at least one originator, and if layer is visible.
    for (var i = 0; i < layers.length; i++) {
        // distinguish case of ol.layer.Group (which is made up of layers with their own source)
        // and other ol.layer (with their own source)
        if (layers[i].getSource) {
            // single ol.layer
            this._updateLayerAttributions(layers[i], mapAttributions, standardExtent, mapProjection, zoom);
        } else if (layers[i].getLayers) {
            // ol.layer.Group
            var lyrs = layers[i].getLayers();
            var context = this;
            lyrs.forEach(function (lyr) {
                if (lyr.getSource) {
                    context._updateLayerAttributions(lyr, mapAttributions, standardExtent, mapProjection, zoom);
                } else {
                    logger.log("cannot find layer source in layergroup ", layers[i]);
                }
            });
        }
    }
};

/**
 * Update a layer attributions
 *
 * @param {ol.layer} layer - layer
 * @param {Object} mapAttributions - object recensing attributions already added, to prevent displaying twice the same producer
 * @param {Array} mapExtent - map current extent
 * @param {String} mapCrs - map current crs
 * @param {Number} mapZoom - map current zoom
 * @private
 */
GeoportalAttribution.prototype._updateLayerAttributions = function (layer, mapAttributions, mapExtent, mapCrs, mapZoom) {
    var src = layer.getSource();

    var attributions = [];

    var visibility = layer.getVisible();
    var originators = src._originators;

    // info : clean previous attributions ONLY for Geoportal Layers (when src._originators is defined)
    if (typeof originators !== "undefined") {
        src.setAttributions(); // clean
    }

    if (originators && visibility) {
        // get layer's attributions array
        var layerAttributions = _LayerUtils2.default.getAttributions({
            extent: mapExtent,
            crs: mapCrs,
            zoom: mapZoom,
            visibility: visibility,
            originators: originators
        });

        for (var j = 0; j < layerAttributions.length; j++) {
            var attributionj = layerAttributions[j];
            // check that this attribution hasn't been added yet for another layer
            if (!mapAttributions || !mapAttributions[attributionj]) {
                // add attribution html
                attributions.push(new _ol2.default.Attribution({
                    html: attributionj
                }));

                // add attribution to mapAttributions, to manage all layers attributions
                mapAttributions[attributionj] = true;
            }
        };

        // update source attribution
        if (attributions.length !== 0) {
            src.setAttributions(attributions);
        }
    }
};

exports.default = GeoportalAttribution;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* globals AmCharts, d3 */


var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _CheckRightManagement = __webpack_require__(7);

var _CheckRightManagement2 = _interopRequireDefault(_CheckRightManagement);

var _Measures = __webpack_require__(9);

var _Measures2 = _interopRequireDefault(_Measures);

var _MeasureToolBox = __webpack_require__(10);

var _MeasureToolBox2 = _interopRequireDefault(_MeasureToolBox);

var _LayerSwitcher = __webpack_require__(6);

var _LayerSwitcher2 = _interopRequireDefault(_LayerSwitcher);

var _Interactions = __webpack_require__(15);

var _Interactions2 = _interopRequireDefault(_Interactions);

var _ElevationPathDOM = __webpack_require__(55);

var _ElevationPathDOM2 = _interopRequireDefault(_ElevationPathDOM);

var _ProfileElevationPathDOM = __webpack_require__(56);

var _ProfileElevationPathDOM2 = _interopRequireDefault(_ProfileElevationPathDOM);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _LoggerByDefault2.default.getLogger("elevationpath");

/**
 * @classdesc
 *
 * Elevation Path Control. Allows users to draw a path on a Openlayers map see the elevation profile computed with geoportal elevation path web service along that path.
 *
 * @constructor
 * @alias ol.control.ElevationPath
 * @extends ol.control.Control
 * @param {Object} options - options for function call.
 * @param {Boolean} [options.active = false] - specify if control should be actived at startup. Default is false.
 * @param {Object} [options.layerDescription = {}] - Layer informations to be displayed in LayerSwitcher widget (only if a LayerSwitcher is also added to the map)
 * @param {String} [options.layerDescription.title = "Profil altimétrique"] - Layer title to be displayed in LayerSwitcher
 * @param {String} [options.layerDescription.description = "Mon profil altimétrique"] - Layer description to be displayed in LayerSwitcher
 * @param {Object} [options.stylesOptions = DEFAULT_STYLES] - styles management
 * @param {Object} [options.stylesOptions.marker = {}] - styles management of marker displayed on map when the user follows the elevation path. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Image.html ol.style.Image} subclass object
 * @param {Object} [options.stylesOptions.draw = {}] - styles used when drawing. Specified with following properties.
 * @param {Object} [options.stylesOptions.draw.pointer = {}] - Style for mouse pointer when drawing the line. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Image.html ol.style.Image} subclass object.
 * @param {Object} [options.stylesOptions.draw.start = {}] - Line Style when drawing. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Stroke.html ol.style.Stroke} object.
 * @param {Object} [options.stylesOptions.draw.finish = {}] - Line Style when finished drawing. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Stroke.html ol.style.Stroke} object.
 * @param {Object} [options.elevationPathOptions = {}] - elevation path service options. See {@link http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~getAltitude Gp.Services.getAltitude()} for available options
 * @param {Object} [options.displayProfileOptions = {}] - profile options.
 * @param {Boolean} [options.displayProfileOptions.greaterSlope = true] - display the greater slope into the graph
 * @param {Boolean} [options.displayProfileOptions.meanSlope = true] -  display the mean slope into the graph
 * @param {Boolean} [options.displayProfileOptions.ascendingElevation = true] -  display the ascending elevation into the graph
 * @param {Boolean} [options.displayProfileOptions.descendingElevation = true] -  display the descending elevation into the graph
 * @param {Boolean} [options.displayProfileOptions.currentSlope = true] -  display current slope value on profile mouseover
 * @param {Function} [options.displayProfileOptions.apply] - function to display profile if you want to cutomise it. By default, ([DISPLAY_PROFILE_BY_DEFAULT()](./ol.control.ElevationPath.html#.DISPLAY_PROFILE_BY_DEFAULT)) is used. Helper functions to use with D3 ([DISPLAY_PROFILE_LIB_D3()](./ol.control.ElevationPath.html#.DISPLAY_PROFILE_LIB_D3)) or AmCharts ([DISPLAY_PROFILE_LIB_AMCHARTS()](./ol.control.ElevationPath.html#.DISPLAY_PROFILE_LIB_AMCHARTS)) frameworks are also provided. You may also provide your own function.
 * @param {Object} [options.displayProfileOptions.target] - DOM container to use to display the profile.
 * @example
 *
 * var measure = new ol.control.ElevationPath({
 *    stylesOptions : {
 *     draw : {
 *       finish : new ol.style.Stroke({
 *            color : "rgba(0, 0, 0, 0.5)",
 *            width : 2
 *       })
 *     },
 *    }
 *    displayProfileOptions : {
 *       apply : ol.control.ElevationPath.DISPLAY_PROFILE_RAW,
 *    }
 * });
 *
 * Exemples :
 * - displayProfileOptions.apply : null
 * - displayProfileOptions.apply : function (elevations, container, context) {  // do some stuff... }
 * - displayProfileOptions.apply : ol.control.ElevationPath.DISPLAY_PROFILE_{LIB_AMCHARTS | LIB_D3 | RAW}
 *
 */
function ElevationPath(options) {
    // logger.trace("ElevationPath()");

    /**
     * options
     * @private
     */
    options = options || {};

    if (!(this instanceof ElevationPath)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    /**
     * Nom de la classe (heritage)
     * @private
     */
    this.CLASSNAME = "ElevationPath";

    // uuid
    this._uid = _SelectorID2.default.generate();

    // container : HTMLElement
    this._showContainer = null;
    this._pictoContainer = null;
    this._panelContainer = null;
    this._profileContainer = null;
    this._waitingContainer = null;
    this._infoContainer = null;

    // timer sur la fenetre d'informations des données
    this._timerHdlr = null;

    // objet de type "ol.style"
    this._drawStyleStart = null;
    this._drawStyleFinish = null;
    this._markerStyle = null;

    // graph
    this._profile = null;

    // data elevations
    this._data = {};

    /* objet de type
        "ol.source.Vector",
        "ol.layer.Vector",
        "ol.interaction.Draw"
    */
    this._measureSource = null;
    this._measureVector = null;
    this._measureDraw = null;

    // objet de type ol.feature, saisie en cours
    this._lastSketch = null;
    this._currentSketch = null;

    // objet de type ol.feature, marker
    this._marker = null;

    // gestion des droits sur le service
    this._noRightManagement = false;

    // initialisation du composant
    this._initialize(options);

    // gestion des droits
    this._checkRightsManagement();

    // creation du DOM container
    var container = options.element ? options.element : this._initializeContainer();

    // heritage
    _ol2.default.control.Control.call(this, {
        element: container,
        target: options.target,
        render: options.render
    });
}

// heritage avec ol.control.Control
_ol2.default.inherits(ElevationPath, _ol2.default.control.Control);

/**
 * @lends module:ElevationPath
 */
ElevationPath.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les mixins de la classe "ElevationPathDOM"
_Utils2.default.assign(ElevationPath.prototype, _ElevationPathDOM2.default);

/**
 * suppression du marker
 *
 * @param {Object} context - context
 *
 * @private
 */
ElevationPath.__removeProfileMarker = function (context) {
    var self = context;
    // suppression de l'ancien marker
    if (self._marker) {
        self._measureSource.removeFeature(self._marker);
        self._marker = null;
    }
};

/**
 * suppression du marker
 *
 * @param {Object} context - context
 * @param {Object} d - d
 *
 * @private
 */
ElevationPath.__createProfileMarker = function (context, d) {
    var self = context;
    var map = self.getMap();
    var proj = map.getView().getProjection();

    var _coordinate = _ol2.default.proj.transform([d.lon, d.lat], "EPSG:4326", proj);
    var _coordinateProj = self._measureSource.getFeatures()[0].getGeometry().getClosestPoint(_coordinate);

    var _geometry = new _ol2.default.geom.Point(_coordinateProj);

    self._marker = new _ol2.default.Feature({
        geometry: _geometry
    });
    // logger.trace(_geometry);

    // style
    self._marker.setStyle(self._markerStyle);

    // ajout du marker sur la map
    self._measureSource.addFeature(self._marker);
};

/**
 * mise à jour du marker
 *
 * @param {Object} context - context
 * @param {Object} d - data
 *
 * @private
 */
ElevationPath.__updateProfileMarker = function (context, d) {
    var self = context;
    ElevationPath.__removeProfileMarker(self);
    ElevationPath.__createProfileMarker(self, d);
};

/**
 * TODO : customisation possible d'une opération sur le profil
 *
 * @param {Object} context - context
 * @param {Object} d - data
 *
 * @private
 */
ElevationPath.__customRawProfileOperation = function (context, d) {
    logger.log("__customRawProfileOperation");

    var self = context;

    var _pts = d.points;
    var _proj = self.getMap().getView().getProjection();
    for (var i = 0; i < _pts.length; i++) {
        var obj = _pts[i];
        var _coordinate = _ol2.default.proj.transform([obj.lon, obj.lat], "EPSG:4326", _proj);
        var _geometry = new _ol2.default.geom.Point(_coordinate);

        self._marker = new _ol2.default.Feature({
            geometry: _geometry
        });
        // logger.trace(_geometry);

        // TODO style en options ?
        var styles = ElevationPath.DEFAULT_STYLES.RESULTS;
        var _image = new _ol2.default.style.Circle({
            radius: styles.imageRadius,
            stroke: new _ol2.default.style.Stroke({
                color: styles.imageStrokeColor,
                width: styles.imageStrokeWidth
            }),
            fill: new _ol2.default.style.Fill({
                color: styles.imageFillColor
            })
        });
        self._marker.setStyle(new _ol2.default.style.Style({
            image: _image
        }));

        // ajout du marker sur la map
        self._measureSource.addFeature(self._marker);
    }
};

/**
 * TODO : customisation possible d'une opération sur le profil
 * Ex. Methode appélée dans le DOM : ProfileElevationPathDOM
 *
 * @param {Object} context - context
 * @param {Object} e - event
 * @private
 */
ElevationPath.__customRawProfileMouseOverEvent = function (context, e) {
    logger.log("__customRawProfileMouseOverEvent", context, e);
};

/**
 * display Profile using Amcharts framework. This method needs AmCharts libraries to be loaded.
 *
 * @param {Object} data - collection elevations
 * @param {HTMLElement} container - container
 * @param {Object} context - this control object
 */
ElevationPath.DISPLAY_PROFILE_LIB_AMCHARTS = function (data, container, context) {
    // logger.trace("ElevationPath.DISPLAY_PROFILE_LIB_AMCHARTS");

    // Calcul du profile
    if (typeof AmCharts === "undefined") {
        logger.log("Lib. AmCharts is not loaded !");
        return;
    }

    var profile = _ProfileElevationPathDOM2.default.displayProfileLibAmCharts(data, container, context, ElevationPath);
    // on sauvegarde le profil du container dans l'objet
    if (profile) {
        this._profile = profile;
    }
};

/**
 * display Profile using D3 javascript framework. This method needs D3 libraries to be loaded.
 *
 * @param {Object} data - elevations values for profile
 * @param {HTMLElement} container - html container where to display profile
 * @param {Object} context - this control object
 */
ElevationPath.DISPLAY_PROFILE_LIB_D3 = function (data, container, context) {
    // logger.trace("ElevationPath.DISPLAY_PROFILE_LIB_D3");

    // Calcul du profile
    if (typeof d3 === "undefined") {
        logger.log("Lib. D3 is not loaded !");
        return;
    }

    var profile = _ProfileElevationPathDOM2.default.displayProfileLibD3(data, container, context, ElevationPath);
    // on sauvegarde le profil du container dans l'objet
    if (profile) {
        this._profile = profile;
    }
};

/**
 * display Profile without graphical rendering (raw service response)
 *
 * @param {Object} data - elevations values for profile
 * @param {HTMLElement} container - html container where to display profile
 * @param {Object} context - this control object
 */
ElevationPath.DISPLAY_PROFILE_RAW = function (data, container, context) {
    // logger.trace("ElevationPath.DISPLAY_PROFILE_RAW");

    var profile = _ProfileElevationPathDOM2.default.displayProfileRaw(data, container, context, ElevationPath);
    // on sauvegarde le profil du container dans l'objet
    if (profile) {
        this._profile = profile;
    }
};

/**
 * Display Profile function used by default : no additonal framework needed.
 *
 * @param {Object} data - elevations values for profile
 * @param {HTMLElement} container - html container where to display profile
 * @param {Object} context - this control object
 */
ElevationPath.DISPLAY_PROFILE_BY_DEFAULT = function (data, container, context) {
    // logger.trace("ElevationPath.DISPLAY_PROFILE_BY_DEFAULT");

    var profile = _ProfileElevationPathDOM2.default.displayProfileByDefault(data, container, context, ElevationPath);
    // on sauvegarde le profil du container dans l'objet
    if (profile) {
        this._profile = profile;
    }
};

/**
 * Styles applied by default if stylesOptions property is not set.
 */
ElevationPath.DEFAULT_STYLES = {
    // styling drawing by default
    // see => Measures.DEFAULTS_STYLES
    // stying marker to the profile by default
    MARKER: new _ol2.default.style.Icon({
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAsCAYAAAAATWqyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABTtJREFUeNq8WGtsFUUU/rb3gtdCAykFG9AUDTQUKimhxUewEusrJYoBo4FfEgoqotHERH6oP9TGmJhIrIlWAf9hjAaEiME2pgFfVVpFii8sWqIQLLSx3EJLW7p+Z2Z2b2l7d/b23vZLTmZ2duacb2fmnDk7DlKA67rXs1hJKacsohRQppjXFygnKT9TDlH2O47zFzIFGnco91EOuqnjoBnr2Ow4FhIlLN6m3DykFTh3BGj/Doj/CfSe082xPCDnBmDWTUBeyXDVjZTHOUNHUiZCEs+weI0ySTV0/w0c2wa07gIungn+vOx8YN46oPhpYOp1Xms/5TmSeSMUERKImFnYqBoGuPRNL5LEW8BgX2rrmjWZZLYApS8BUW8r4T0zO5eTEjFr+S6lSjV0HgPqVwNdf6S30abNB+7aDeQWey3bKZtIxvU5DxvyrE/izJfAvuXpkxCIDtElOjWqjK2RM8LZWMbiG0oEnUc5kB7a14WMYvI04H56du5ieZKluZWz8r0/IyQh5TuKRH8cqFuTeRIC0Sm6xYbYok1j21+ahyhLVO3wC8D5VowbRLfY0FhibOulIavDLEoRZyD8sJDeMWBXKG5ZsIobsdDsg+OMq3u1m1u9KQo8zP45EqjRxOUpk6i50IRl4FuGjpZtwUoiMYa314GFj/EzIsN8n8v+C1e4kfvwcm+wnhsZY27xQ8oiWZpKrWRQB6tAElfxpKnjsCdGklDzG9HvpI/0DYLYEpsalVnmAAM6fgR62oMHl70C5N9mn3rpI32DILbEpkZ5ljlFgbPNFtebzij5VPhNKX1lTBASNtXSzPZ3cxCuvVOH7FTCu4yxeZDGbCES0z5+PniQ3uGpwTYmYTOWCPGTpgYP6u9OnYhtzBCbQkSH0NiM4EEdP6VOxDYmYbNLiJxQ1elFwYPaG3XQCn3QHddjgpCweUKI6K2bvzw4YROf//rJob6fZl/H2FRoFiINfqo3qyzYwD8MVIeYLw32J+8j76SP9A2C2BKbGg1CZL+EF/W4YKP9a3/fCeyhkrY9DOOXEu1SlzZ5J31sSNjqURm/OfQkY9qgvkYOvXhbuH0g505Oga7HT9rPF9+t5+pDL0ulwzt46FV5ROax+JUSRRtP0LoHMK64+xNg7iqVEVOKSKRVxRGpsKhRnaRD4SPjR0J0axKCGmP7ilQxm4X8d8xXmfvHJZlPkCR3WfODl9FLMlxCIhevSJ5Nwzo1XdKxYpe3hpmB6BKdmoS43VqPxIgsni+aWOg8biZ3f+nLmSMiuvKWek/P01az7QdLyNVT7lC/l59WAKcb0iMxhzpW1nvmvpDtSiKD1l9OkpnDgv8UyMWFU9wvTP8vdY6NhJwnD1JVtso2OiiLSeL0iJUbNfg6zikVVwRTyOn2HWOfjfLtHgnBhtFIJCViyNDZUatdmnGlaFPqJIoe1WM1aqlz71ivJbLNobgAA9zgu7nZ/vstHAk5WVdzaPRqmGC5lER6kjpV4OWJdq+1kkshSk4VH9izcy/bV66qSPQZV+0J9G7rTY6+XNmqHmYwyJVV24kse1X31dhKHdasygkzy+a64oC4nWr47F4e858nSbLv4V/KAe9JKpVDrx/SImLIXMOiRUKdujESl+49O8xVZxpXzVc/C/I/RxL/hgq8YYkYhev9q6kVO4d9B+sr3vdICNaHJTHWW8Ya/87wqy2uWwstUk/gTYw3aCRGOarMDfS67kfFWqSuIe9imAjQEC272nJHixYNaSvGRIIGN49ywbsZEw1zI11N6TZSHeaGORn+F2AAJtRIMx4t+hUAAAAASUVORK5CYII=",
        anchor: [0.5, 1],
        snapToPixel: true
    }),
    // styling service results points by default
    RESULTS: {
        // INFO orienté maintenance !
        imageRadius: 5,
        imageFillColor: "rgba(128, 128, 128, 0.2)",
        imageStrokeColor: "rgba(0, 0, 0, 0.7)",
        imageStrokeWidth: 2
        // FIXME ???
        // PROFILE : {
        //     type : "serial",
        //     pathToImages : "http://cdn.amcharts.com/lib/3/images/",
        //     categoryField : "dist",
        //     autoMarginOffset : 0,
        //     marginRight : 10,
        //     marginTop : 10,
        //     startDuration : 0,
        //     color : "#5E5E5E",
        //     fontSize : 10,
        //     theme : "light",
        //     thousandsSeparator : "",
        //     categoryAxis : {
        //         color : "#5E5E5E",
        //         gridPosition : "start",
        //         minHorizontalGap : 40,
        //         tickPosition : "start",
        //         title : "Distance (km)",
        //         titleColor : "#5E5E5E",
        //         startOnAxis : true
        //     },
        //     chartCursor : {
        //         animationDuration : 0,
        //         bulletsEnabled : true,
        //         bulletSize : 10,
        //         categoryBalloonEnabled : false,
        //         cursorColor : "#F90",
        //         graphBulletAlpha : 1,
        //         graphBulletSize : 1,
        //         zoomable : false
        //     },
        //     trendLines : [],
        //     graphs : [
        //         {
        //             balloonColor : "#CCCCCC",
        //             balloonText : "<span class='altiPathValue'>[[title]] : [[value]]m</span><br/><span class='altiPathCoords'>(lat: [[lat]] / lon:[[lon]])</span>",
        //             bullet : "round",
        //             bulletAlpha : 0,
        //             bulletBorderColor : "#FFF",
        //             bulletBorderThickness : 2,currentSlope
        //             bulletColor : "#F90",
        //             bulletSize : 6,
        //             hidden : false,
        //             id : "AmGraph-1",
        //             fillAlphas : 0.4,
        //             fillColors : "#C77A04",
        //             lineAlpha : 1,
        //             lineColor : "#C77A04",
        //             lineThickness : 1,
        //             title : "Altitude",
        //             valueField : "z"
        //         }
        //     ],
        //     guides : [],
        //     valueAxes : [
        //         {
        //             id : "ValueAxis-1",
        //             minVerticalGap : 20,
        //             title : "Altitude (m)"
        //         }
        //     ],
        //     allLabels : [],
        //     balloon : {
        //         borderColor : "#CCCCCC",
        //         borderThickness : 1,
        //         fillColor : "#FFFFFF",
        //         showBullet : true
        //     },
        //     titles : []
        // }
    } };

/**
 * Constructor (alias)
 * @private
 */
ElevationPath.prototype.constructor = ElevationPath;

// ################################################################### //
// ##################### public methods ############################## //
// ################################################################### //

/**
 * Attach control to map. Overloaded ol.control.Control.setMap() method.
 *
 * @param {ol.Map} map - Map.
 */
ElevationPath.prototype.setMap = function (map) {
    // logger.trace("ElevationPath::setMap");

    if (map) {
        // activation des interactions de dessin selon la valeur de
        // l'option active
        if (this.options.active) {
            // on n'affiche pas la fenetre de profile s'il n'existe pas...
            if (this._profile === null) {
                this._panelContainer.style.display = "none";
                // this._panelContainer.style.visibility = "hidden";
            }
            this._initMeasureInteraction(map);
            this._addMeasureInteraction(map);
        }

        // ajout du composant dans une toolbox
        if (!this.options.target) {
            _MeasureToolBox2.default.add(map, this);
        }
    }

    // on appelle la méthode setMap originale d'OpenLayers
    _ol2.default.control.Control.prototype.setMap.call(this, map);
};

/**
 * Returns true if widget is actived (drawing),
 * false otherwise
 *
 * @returns {Boolean} active - true or false
 */
ElevationPath.prototype.getActive = function () {
    // logger.trace("ElevationPath::getActive");
    return this.options.active;
};

/**
 * Actived widget drawing or not
 *
 * @param {Boolean} active - true / false
 */
ElevationPath.prototype.setActive = function (active) {
    // logger.trace("ElevationPath::setActive");
    this.options.active = active;
};

/**
 * clean
 */
ElevationPath.prototype.clean = function () {
    // logger.trace("ElevationPath::clean");

    var map = this.getMap();

    // fenetre du profil
    this._panelContainer.style.display = "none";
    // this._panelContainer.style.visibility = "hidden";

    // picto
    this._showContainer.checked = false;

    this._removeProfile();
    this._removeMeasure();
    this._removeMeasureInteraction(map);
};

/**
 * Remove measure
 * @private
 */
ElevationPath.prototype._removeMeasure = function () {
    // sketch
    this._lastSketch = null;
    this._currentSketch = null;

    if (this._measureSource) {
        // marker
        if (this._marker) {
            this._measureSource.removeFeature(this._marker);
            this._marker = null;
        }

        // all other features
        var _features = this._measureSource.getFeatures();
        for (var i = 0; i < _features.length; i++) {
            this._measureSource.removeFeature(_features[i]);
        }
    }
};

/**
 * Remove profile
 * @private
 */
ElevationPath.prototype._removeProfile = function () {
    // graph
    this._profile = null;

    // on vide le container
    if (this._profileContainer) {
        while (this._profileContainer.firstChild) {
            this._profileContainer.removeChild(this._profileContainer.firstChild);
        }
    }
};

// ################################################################### //
// ##################### init component ############################## //
// ################################################################### //

/**
 * Initialize control (called by constructor)
 *
 * @param {Object} options - options
 *
 * @private
 */
ElevationPath.prototype._initialize = function (options) {
    // logger.trace("ElevationPath::_initialize : ", options);

    // liste des options
    this.options = {
        target: null,
        render: null,
        active: false,
        apiKey: null,
        elevationOptions: {},
        layerDescription: {
            title: "Profil altimétrique",
            description: "Mon profil altimétrique"
        },
        displayProfileOptions: {
            greaterSlope: true,
            meanSlope: true,
            ascendingElevation: true,
            descendingElevation: true,
            currentSlope: true,
            apply: null,
            target: null
        },
        stylesOptions: {
            profile: null,
            draw: null,
            marker: null
        }
    };

    // merge with user options
    _Utils2.default.mergeParams(this.options, options);

    // cle API sur le service
    this.options.apiKey = options.apiKey;

    // gestion de l'affichage du profil
    var _profile = options.displayProfileOptions || {};

    // gestion de la fonction du profil
    var displayFunction = _profile.apply;
    this.options.displayProfileOptions.apply = typeof displayFunction === "function" ? displayFunction : ElevationPath.DISPLAY_PROFILE_BY_DEFAULT;

    // gestion du container du profil
    var displayContainer = _profile.target;
    this.options.displayProfileOptions.target = typeof displayContainer !== "undefined" ? displayContainer : null;

    // gestion des styles
    var _styles = options.stylesOptions || {};

    // FIXME ???
    // gestion du style du profil
    // var profileStyle = _styles.profile;
    // this.options.stylesOptions.profile = ( typeof profileStyle === "undefined" || Object.keys(profileStyle).length === 0 ) ?
    //     ElevationPath.DEFAULT_STYLES.PROFILE : profileStyle;
    // this._createStylingProfile();

    // gestion des styles du tracé
    this.options.stylesOptions.draw = _styles.draw || {};
    this._createStylingDraw();

    // gestion des styles du marker
    this.options.stylesOptions.marker = _styles.marker || {};
    this._createStylingMarker();
};

/**
 * initialize component container (DOM)
 *
 * @returns {DOMElement} DOM element
 *
 * @private
 */
ElevationPath.prototype._initializeContainer = function () {
    // logger.trace("ElevationPath::_initializeContainer : ", this._uid);

    // create main container
    var container = this._createMainContainerElement();

    var inputShow = this._showContainer = this._createShowElevationPathElement();
    container.appendChild(inputShow);

    var picto = this._pictoContainer = this._createShowElevationPathPictoElement();
    container.appendChild(picto);

    // mode "active"
    if (this.options.active) {
        this._showContainer.checked = true;
    }

    // panneau
    var panel = this._panelContainer = this._createElevationPathPanelElement();

    // header
    var header = this._createElevationPathPanelHeaderElement();
    panel.appendChild(header);

    // profile
    var profile = this._profileContainer = this._createElevationPathPanelProfilElement();
    panel.appendChild(profile);

    // waiting
    var waiting = this._waitingContainer = this._createElevationPathWaitingElement();
    panel.appendChild(waiting);

    // info
    var info = this._infoContainer = this._createElevationPathInformationsElement();
    panel.appendChild(info);

    if (this.options.displayProfileOptions.target === null) {
        container.appendChild(panel);
    }

    return container;
};

/**
 * this method is called by constructor (into method _initialize())
 * and check the rights to resources
 *
 * @private
 */
ElevationPath.prototype._checkRightsManagement = function () {
    // logger.trace("ElevationPath::_checkRightsManagement");

    var rightManagement = _CheckRightManagement2.default.check({
        key: this.options.apiKey,
        resources: ["SERVICE_CALCUL_ALTIMETRIQUE_RSC"],
        services: ["Elevation"]
    });

    if (!rightManagement) {
        this._noRightManagement = true;
    }

    // on recupère les informations utiles
    // sur ce controle, on ne s'occupe pas de la ressource car elle est unique...
    // Ex. la clef API issue de l'autoconfiguration si elle n'a pas
    // été renseignée.
    if (!this.options.apiKey) {
        this.options.apiKey = rightManagement.key;
    }
};

// ################################################################### //
// ###################### init styles ################################ //
// ################################################################### //

/**
 * create style marker object : "ol.style"
 *
 * @private
 */
ElevationPath.prototype._createStylingMarker = function () {
    // logger.trace("ElevationPath::_createStylingMarker ");

    var marker = ElevationPath.DEFAULT_STYLES.MARKER;
    // logger.trace("style marker", marker);

    // si marker n'est pas un objet ol.style.Image, on applique le
    // style par défaut.
    if (this.options.stylesOptions.marker instanceof _ol2.default.style.Image) {
        marker = this.options.stylesOptions.marker;
    }

    this._markerStyle = new _ol2.default.style.Style({
        image: marker
    });
};

/**
 * create style draw object : "ol.style"
 *
 * @private
 */
ElevationPath.prototype._createStylingDraw = function () {
    // logger.trace("ElevationPath::_createStylingDraw");

    // on interprete les params pour y creer un objet ol.Style
    var styles = this.options.stylesOptions.draw;

    // style de depart
    // logger.trace("style start", styles.start);

    // Creation à partir des styles par défaut
    var startStyleOpts = {
        image: _Measures2.default.DEFAULT_POINTER_STYLE,
        stroke: _Measures2.default.DEFAULT_DRAW_START_STYLE.getStroke()
    };
    // ecrasement à partir des propriétés renseignées
    if (styles.hasOwnProperty("pointer") && styles.pointer instanceof _ol2.default.style.Image) {
        startStyleOpts.image = styles.pointer;
    }
    if (styles.hasOwnProperty("start") && styles.start instanceof _ol2.default.style.Stroke) {
        startStyleOpts.stroke = styles.start;
    }

    this._drawStyleStart = new _ol2.default.style.Style(startStyleOpts);

    // style de fin
    // logger.trace("style finish", styles.finish);

    var finishStyleOpts = {
        stroke: _Measures2.default.DEFAULT_DRAW_FINISH_STYLE.getStroke()
    };
    // ecrasement à partir des propriétés renseignées
    if (styles.hasOwnProperty("finish") && styles.finish instanceof _ol2.default.style.Stroke) {
        finishStyleOpts.stroke = styles.finish;
    }

    this._drawStyleFinish = new _ol2.default.style.Style(finishStyleOpts);
};

/**
 * create style graph
 * FIXME : à revoir car ne sert que pour AmCharts !?
 *
 * @private
 */
ElevationPath.prototype._createStylingProfile = function () {
    // logger.trace("ElevationPath::_createStylingProfile");

    var userStyles = this.options.stylesOptions.profile;

    // logger.trace("style profile", userStyles);

    var defaultStyle = ElevationPath.DEFAULT_STYLES.PROFILE;
    Object.keys(defaultStyle).forEach(function (key) {
        if (!userStyles.hasOwnProperty(key)) {
            // si le style user n'existe pas, on ajoute celui par defaut
            userStyles[key] = defaultStyle[key];
        } else {
            var _defaultStyle = defaultStyle[key];
            if ((typeof _defaultStyle === "undefined" ? "undefined" : _typeof(_defaultStyle)) === "object") {
                // on merge avec un objet,
                // les styles user ecrasent ceux par defaut...
                _Utils2.default.mergeParams(_defaultStyle, userStyles[key]);
                userStyles[key] = _defaultStyle;
            }
        }
    }, this);
};

// ################################################################### //
// ################### Map interactions management ################### //
// ################################################################### //

/**
 * this method is called by this.onShowElevationPathClick,
 * and initialize a vector layer, if widget is active.
 *
 * @param {ol.Map} map - Map
 * @private
 */
ElevationPath.prototype._initMeasureInteraction = function (map) {
    // logger.trace("ElevationPath::_initMeasureInteraction()");

    // var map = this.getMap();
    if (!map) {
        return;
    }

    this._measureSource = new _ol2.default.source.Vector();

    this._measureVector = new _ol2.default.layer.Vector({
        source: this._measureSource,
        style: this._drawStyleFinish
    });

    // on rajoute le champ gpResultLayerId permettant d'identifier une couche crée par le composant.
    this._measureVector.gpResultLayerId = "measure";

    map.addLayer(this._measureVector);

    // Si un layer switcher est présent dans la carte, on lui affecte des informations pour cette couche
    map.getControls().forEach(function (control) {
        if (control instanceof _LayerSwitcher2.default) {
            // un layer switcher est présent dans la carte
            var layerId = this._measureVector.gpLayerId;
            // on n'ajoute des informations que s'il n'y en a pas déjà (si le titre est le numéro par défaut)
            if (control._layers[layerId].title === layerId) {
                control.addLayer(this._measureVector, {
                    title: this.options.layerDescription.title,
                    description: this.options.layerDescription.description
                });
            }
        }
    }, this);
};

/**
 * this method is called by this.onShowElevationPathClick,
 * and add draw interaction to map, if widget is not active.
 *
 * @param {ol.Map} map - Map
 * @private
 */
ElevationPath.prototype._addMeasureInteraction = function (map) {
    // logger.trace("ElevationPath::_addMeasureInteraction()");

    // var map = this.getMap();
    if (!map) {
        return;
    }

    // Creates and adds the interaction
    this._measureDraw = new _ol2.default.interaction.Draw({
        source: this._measureSource,
        type: "LineString",
        style: this._drawStyleStart
    });

    this._measureDraw.setProperties({
        name: "ElevationPath",
        source: this
    });

    map.addInteraction(this._measureDraw);

    // Event start
    var self = this;
    this._measureDraw.on("drawstart", function (evt) {
        // logger.trace("drawstart", evt);

        // delete marker current
        if (self._marker !== null) {
            self._measureSource.removeFeature(self._marker);
            self._marker = null;
        }

        // set new feature and remove last feature
        if (self._lastSketch !== null) {
            self._measureSource.removeFeature(self._lastSketch);
            self._lastSketch = null;
        }
        self._currentSketch = evt.feature;

        // and, all features
        var _features = self._measureSource.getFeatures();
        for (var i = 0; i < _features.length; i++) {
            self._measureSource.removeFeature(_features[i]);
        }
    }, this);

    // Event end
    this._measureDraw.on("drawend", function (evt) {
        // logger.trace("drawend", evt);

        // set feature
        self._lastSketch = self._currentSketch;

        // set an alti request and display results

        // FIXME à revoir...
        // Si il n'y a pas de surcharge utilisateur de la fonction de recuperation des
        // resultats, on realise l'affichage du panneau
        if (typeof self.options.elevationOptions.onSuccess === "undefined" && self.options.displayProfileOptions.target === null) {
            self._panelContainer.style.display = "block";
            // self._panelContainer.style.visibility = "visible";
        }
        self._requestService();
    }, this);
};

/**
 * this method is called by this.onShowElevationPathClick,
 * and removes draw interaction from map (if exists)
 * And removes layer too...
 *
 * @param {ol.Map} map - Map
 * @private
 */
ElevationPath.prototype._removeMeasureInteraction = function (map) {
    // logger.trace("ElevationPath::_removeMeasureInteraction()");

    // var map = this.getMap();
    if (!map) {
        return;
    }

    if (this._measureVector) {
        map.removeLayer(this._measureVector);
        this._measureVector = null;
    }

    if (this._measureDraw) {
        map.removeInteraction(this._measureDraw);
        this._measureDraw = null;
    }
};

// ################################################################### //
// ############################ Alti request ######################### //
// ################################################################### //

/**
 * transforme geometry feature to position coordinate (service)
 *
 * @returns {Object[]} geometry
 *
 * @private
 */
ElevationPath.prototype._getGeometry = function () {
    // INFO
    // on transmet toujours des coordonnées au service en EPSG:4326

    if (this._currentSketch === null) {
        logger.warn("Current Feature undefined !?");
        return;
    }

    var geometry = [];

    var map = this.getMap();
    var projSrc = map.getView().getProjection();
    var projDest = "EPSG:4326";
    var coordinates = this._currentSketch.getGeometry().getCoordinates();
    for (var i = 0; i < coordinates.length; i++) {
        var xy = coordinates[i];
        var ll = xy;
        // on transmet au service des coordonnées en EPSG:4326
        if (projSrc !== projDest) {
            ll = _ol2.default.proj.transform(xy, projSrc, projDest);
        }
        geometry.push({
            lon: ll[0],
            lat: ll[1]
        });
    }

    return geometry;
};

/**
 * get geometry feature length
 *
 * @returns {Integer} length
 *
 * @private
 */
ElevationPath.prototype._getLength = function () {
    if (this._currentSketch === null) {
        logger.warn("Current Feature undefined !?");
        return;
    }

    var length = 0;

    var wgs84Sphere = new _ol2.default.Sphere(6378137);

    var map = this.getMap();
    var projSrc = map.getView().getProjection();
    var projDest = "EPSG:4326";

    var coordinates = this._currentSketch.getGeometry().getCoordinates();
    for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
        var c1 = _ol2.default.proj.transform(coordinates[i], projSrc, projDest);
        var c2 = _ol2.default.proj.transform(coordinates[i + 1], projSrc, projDest);
        length += wgs84Sphere.haversineDistance(c1, c2);
    }

    return length;
};

/**
 * this method is called at the end of the path,
 * it generates and sends alti request, then displays results
 *
 * @private
 */
ElevationPath.prototype._requestService = function () {
    // logger.trace("ElevationPath::_requestService");

    // les coordonnées sont obligatoires
    var geometry = this._getGeometry();
    // logger.trace("geometry", geometry);
    if (!geometry) {
        logger.warn("missing geometry !?");
        return;
    }

    // oups, aucun droits !
    if (this._noRightManagement) {
        logger.warn("no rights to this service !");
        return;
    }

    // on construit les options pour la requête
    var options = {};

    // on surcharge avec les options de l'utilisateur
    _Utils2.default.mergeParams(options, this.options.elevationOptions);

    // au cas où ...
    _Utils2.default.mergeParams(options, {
        apiKey: this.options.apiKey
    });

    // les callbacks
    var self = this;

    // callback _requestServiceOnSuccess
    var _requestServiceOnSuccess = function _requestServiceOnSuccess(result) {
        // logger.trace(result);
        if (result) {
            self._panelContainer.style.display = "block";
            // self._panelContainer.style.visibility = "visible";
            self._displayProfile(result.elevations);
            self._waitingContainer.className = "GPelevationPathCalcWaitingContainerHidden";
            self._waiting = false;
        }
    };

    // callback _requestServiceOnFailure
    var _requestServiceOnFailure = function _requestServiceOnFailure(error) {
        // on ferme le panneau en cas d'erreur !
        self._panelContainer.style.display = "none";
        // self._panelContainer.style.visibility = "hidden";
        logger.error(error.message);
        self._waitingContainer.className = "GPelevationPathCalcWaitingContainerHidden";
        self._waiting = false;
    };

    _Utils2.default.mergeParams(options, {
        onSuccess: this.options.elevationOptions.onSuccess || _requestServiceOnSuccess,
        onFailure: this.options.elevationOptions.onFailure || _requestServiceOnFailure
    });

    // le sampling est soit defini par l'utilisateur (opts),
    // ou soit calculé dynamiquement...
    var sampling = options.sampling;
    if (!sampling) {
        // computing sampling
        var _sampling = 50;
        var _length = this._getLength();
        // logger.trace("length", _length);
        var p = Math.floor(_length) / 5; // en mètre sur un pas moyen de 5m !
        if (p >= 200) {
            _sampling = 200;
        } else {
            _sampling = Math.floor(p);
        }

        _Utils2.default.mergeParams(options, {
            sampling: _sampling || 50
        });
    }

    // et enfin, la geometrie
    _Utils2.default.mergeParams(options, {
        positions: geometry
    });

    // logger.trace("options du service", options);

    // mise en place de la patience
    this._waitingContainer.className = "GPelevationPathCalcWaitingContainerVisible";

    // Request altitude service
    _gp2.default.Services.getAltitude(options);
};

// ################################################################### //
// ########################## Profil display ######################### //
// ################################################################### //

/**
 * this method computes results elevations (Z and distance)
 *
 * @param {Array} elevations - array of elevation
 * @return {Array} elevations
 * @private
 */
ElevationPath.prototype._computeElevationMeasure = function (elevations) {
    // logger.trace("ElevationPath::_computeElevationMeasure", elevations);

    var _data = elevations;

    // FIXME facteur à 2000 doit il etre une option ?
    var _limite = 2000; // metres
    var _unit = "km";
    var _factor = 1000;
    var _length = this._getLength();
    if (_length < _limite) {
        _factor = 1;
        _unit = "m";
    }

    // Calcul de la distance au départ pour chaque point + arrondi des lat/lon
    _data[0].dist = 0;
    _data[0].slope = 0;

    var _distanceMinus = 0;
    var _distancePlus = 0;
    var _ascendingElevation = 0;
    var _descendingElevation = 0;
    var _distance = 0;
    var _slopes = 0;

    var wgs84Sphere = new _ol2.default.Sphere(6378137);

    for (var i = 1; i < _data.length; i++) {
        var a = [_data[i].lon, _data[i].lat];
        var b = [_data[i - 1].lon, _data[i - 1].lat];
        var dist = wgs84Sphere.haversineDistance(a, b);

        var za = _data[i].z;
        var zb = _data[i - 1].z;
        if (za < 0) {
            za = 0;
        }
        if (zb < 0) {
            zb = 0;
        }
        var slope = za - zb;
        if (slope < 0) {
            _distanceMinus += dist;
            _descendingElevation += slope;
        } else if (slope > 0) {
            _distancePlus += dist;
            _ascendingElevation += slope;
        }
        _distance += dist / _factor;
        _data[i].dist = _distance;

        _slopes += slope ? Math.abs(Math.round(slope / dist * 100)) : 0;
        _data[i].slope = slope ? Math.abs(Math.round(slope / dist * 100)) : 0;

        // EVOL ?
        // cf. gradiant
        // http://www.color-hex.com/color/00b798
        var value = _data[i].slope;
        if (value > 15 && value < 30) {
            _data[i].color = "#005b4c";
        } else if (value > 30 && value < 45) {
            _data[i].color = "#00362d";
        } else if (value > 45) {
            _data[i].color = "#00120f";
        } else {
            _data[i].color = "#00B798";
        }

        _data[i].lat = Math.round(_data[i].lat * 10000) / 10000;
        _data[i].lon = Math.round(_data[i].lon * 10000) / 10000;
    }

    // Valeur du coeff d'arrondi des distances en fonction de la distance totale
    var coeffArrond = 100;
    if (_distance > 100) {
        coeffArrond = 1;
    } else if (_distance > 10) {
        coeffArrond = 10;
    }

    // Correction arrondi distance totale
    _distance = Math.round(_distance * coeffArrond) / coeffArrond;
    _distanceMinus = Math.round(_distanceMinus * coeffArrond) / coeffArrond;
    _distancePlus = Math.round(_distancePlus * coeffArrond) / coeffArrond;

    // Correction des altitudes aberrantes + arrondi des calculs de distance + ...
    var _altMin = _data[0].z;
    var _altMax = _data[0].z;
    var _greaterSlope = _data[0].slope;

    for (var ji = 0; ji < _data.length; ji++) {
        var d = _data[ji];
        if (d.z < 0) {
            d.z = 0;
        }
        if (d.z >= _altMax) {
            _altMax = d.z;
        }
        if (d.z <= _altMin) {
            _altMin = d.z;
        }

        d.dist = Math.round(d.dist * coeffArrond) / coeffArrond;
        // FIXME erreur avec D3 car cette lib souhaite un numerique !
        // d.dist = d.dist.toLocaleString();

        if (d.slope > _greaterSlope) {
            _greaterSlope = d.slope;
        }
    }

    return {
        greaterSlope: _greaterSlope, // pente max
        meanSlope: Math.round(_slopes / _data.length), // pente moyenne
        distancePlus: _distancePlus.toLocaleString(), // distance cumulée positive
        distanceMinus: _distanceMinus.toLocaleString(), // distance cumulée négative
        ascendingElevation: _ascendingElevation, // dénivelé cumulée positive
        descendingElevation: _descendingElevation, // dénivelé cumulée négative
        altMin: _altMin.toLocaleString(), // altitude min
        altMax: _altMax.toLocaleString(), // altitude max
        distance: _distance.toLocaleString(), // distance totale
        unit: _unit, // unité des mesures de distance
        points: _data
    };
};

/**
 * this method is called after service request (in case of success)
 * and display results
 *
 * @param {Array} elevations - array of elevation
 * @private
 */
ElevationPath.prototype._displayProfile = function (elevations) {
    // logger.trace("ElevationPath::_displayProfile", elevations);

    // data
    if (this._data) {
        this._data = {};
    }

    // sauvegarde des données
    var data = this._data = this._computeElevationMeasure(elevations);

    // container
    var container = this.options.displayProfileOptions.target;
    if (container) {
        container.appendChild(this._panelContainer);
    }
    container = this._profileContainer;

    // TODO contexte ?
    var context = this;

    // fonction
    var displayFunction = this.options.displayProfileOptions.apply;

    // execution...
    displayFunction.call(this, data, container, context);

    var opts = this.options.displayProfileOptions;
    var element = document.getElementById("GPelevationPathPanelInfo-" + this._uid);
    if (element) {
        if (opts.greaterSlope || opts.meanSlope || opts.ascendingElevation || opts.descendingElevation) {
            // on affiche les informations
            element.style.display = "block";
        }
    }
};

// ################################################################### //
// ####################### handlers events to dom #################### //
// ################################################################### //

/**
 * this method is called by event 'click' on '' picto
 * and enable or disable the entry of the path
 *
 * @private
 */
ElevationPath.prototype.onShowElevationPathClick = function () {
    var map = this.getMap();
    _Interactions2.default.unset(map, {
        current: "ElevationPath"
    });

    // Activation/Desactivation des interactions de dessins
    if (!this._showContainer.checked) {
        // on n'affiche pas la fenetre de profile s'il n'existe pas...
        if (this._profile === null) {
            this._panelContainer.style.display = "none";
            // this._panelContainer.style.visibility = "hidden";
        }
        this._initMeasureInteraction(map);
        this._addMeasureInteraction(map);
    } else {
        this._panelContainer.style.display = "none";
        // this._panelContainer.style.visibility = "hidden";
        this._removeMeasure();
        this._removeProfile();
        this._removeMeasureInteraction(map);
    }
};

/**
 * this method is called by event 'click' on '' picto
 * (cf. this.),
 * and display the panel info
 *
 * @private
 */
ElevationPath.prototype.onOpenElevationPathInfoClick = function () {
    // options d'affichage
    var meanSlope = this.options.displayProfileOptions.meanSlope;
    var greaterSlope = this.options.displayProfileOptions.greaterSlope;
    var ascendingElevation = this.options.displayProfileOptions.ascendingElevation;
    var descendingElevation = this.options.displayProfileOptions.descendingElevation;

    // clean
    var div = this._infoContainer;
    if (div.childElementCount) {
        while (div.firstChild) {
            div.removeChild(div.firstChild);
        }
    }

    // creation des infomations

    if (ascendingElevation) {
        this._addElevationPathInformationsItem("Dénivelé positif : " + this._data.ascendingElevation.toLocaleString() + " m");
    }

    if (descendingElevation) {
        this._addElevationPathInformationsItem("Dénivelé négatif : " + this._data.descendingElevation.toLocaleString() + " m");
    }

    if (meanSlope) {
        this._addElevationPathInformationsItem("Pente moyenne : " + this._data.meanSlope.toLocaleString() + " %");
    }

    if (greaterSlope) {
        this._addElevationPathInformationsItem("Plus forte pente : " + this._data.greaterSlope.toLocaleString() + " %");
    }

    // show des informations !
    if (div.className === "GPelevationPathInformationsContainerVisible") {
        clearTimeout(this._timerHdlr);
        div.className = "GPelevationPathInformationsContainerHidden";
    } else {
        div.className = "GPelevationPathInformationsContainerVisible";
    }

    // hidden des informations !
    this._timerHdlr = setTimeout(function () {
        div.className = "GPelevationPathInformationsContainerHidden";
    }, 4000);
};

exports.default = ElevationPath;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MeasureToolBoxDOM = {

    _toolboxId: "GPtoolbox-measure-main",
    _buttonId: "GPtoolbox-measure-button",
    _widgetId: "GPtoolbox-measure-widget",

    /**
    * get toolBox ID
    * @param {Number} uid - uid
    * @returns {String} id selector unique
    */
    getToolBoxID: function getToolBoxID(uid) {
        return uid ? this._toolboxId + "-" + uid : this._toolboxId;
    },

    /**
    * get button ID
    * @param {Number} uid - uid
    * @returns {String} id selector unique
    */
    getButtonID: function getButtonID(uid) {
        return uid ? this._buttonId + "-" + uid : this._buttonId;
    },

    /**
    * get toolBox Container for widget
    * @param {Number} uid - uid
    * @returns {String} id selector unique
    */
    getWidgetID: function getWidgetID(uid) {
        return uid ? this._widgetId + "-" + uid : this._widgetId;
    },

    /**
     * Main container (DOM)
     * @param {Number} uid - uid
     * @returns {DOMElement} DOM element
     */
    _createToolBoxContainerElement: function _createToolBoxContainerElement(uid) {
        // <div id="GPtoolbox-measure-main">
        //   <button id="GPtoolbox-measure-button">&#9776;</button>
        //   <div id="GPtoolbox-measure-widget">
        //     <!-- HERE : widgets tools measures -->
        //   </div>
        // </div>
        var container = document.createElement("div");
        container.id = this.getToolBoxID(uid);
        container.className = "GPshowAdvancedToolPicto";

        var button = document.createElement("button");
        button.id = this.getButtonID(uid);
        var self = this;
        button.addEventListener("click", function () {
            this.blur(); // permet de perdre le focus !
            var widget = document.getElementById(self.getWidgetID(uid));
            if (widget.style.display === "block") {
                widget.style.display = "none";
            } else {
                widget.style.display = "block";
            }
        });
        container.appendChild(button);

        var widget = document.createElement("div");
        widget.id = this.getWidgetID(uid);
        widget.addEventListener("click", function () {

            /*
                e.preventDefault();
                 // FIXME desactiver tous les outils sur
                // l'ouverture/fermeture de la toolbox ?
                 var current = e.target.parentNode.getAttribute("for");
                var widgets = this.querySelectorAll("div > input");
                for (var i = 0; i < widgets.length; i++) {
                    var id = widgets[i].id;
                     if (document.getElementById(id) &&
                        document.getElementById(id).checked &&
                        document.querySelector("#" + id + " + label")) {
                            document.querySelector("#" + id + " + label").click();
                            // document.getElementById(id).checked = true;
                    }
                     if (current === id && widgets[i].checked) {
                        widgets[i].checked = false;
                    } else if (current === id && !widgets[i].checked) {
                        widgets[i].checked = true;
                    }
                }
            */

        }, false);

        container.appendChild(widget);

        return container;
    }
};

exports.default = MeasureToolBoxDOM;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ElevationPathDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPelevationPath");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################# Methods to display Main Panel ################### //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing panel
     *
     * @returns {DOMElement} DOM element
     */
    _createShowElevationPathElement: function _createShowElevationPathElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowElevationPath");
        input.type = "checkbox";
        return input;
    },

    /**
     * Show control
     * see event !
     *
     * @returns {DOMElement} DOM element
     */
    _createShowElevationPathPictoElement: function _createShowElevationPathPictoElement() {
        // contexte d'execution
        var context = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowElevationPathPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowElevationPath");
        label.title = "Calculer un profil";

        // gestionnaire d'evenement :
        // on ouvre le menu de saisie de saisie
        // L'ouverture/Fermeture permet de faire le menage
        // (reinitialisation)
        if (label.addEventListener) {
            label.addEventListener("click", function (e) {
                context.onShowElevationPathClick(e);
            });
        } else if (label.attachEvent) {
            label.attachEvent("onclick", function (e) {
                context.onShowElevationPathClick(e);
            });
        }

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowElevationPathOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    },

    // ################################################################### //
    // ######################### Methods to Panel ######################## //
    // ################################################################### //

    /**
     * Create Container Panel
     *
     * FIXME
     * don't call this._createElevationPathPanelHeaderElement
     * don't call this._createElevationPathPanelProfilElement
     *
     * @returns {DOMElement} DOM element
     */
    _createElevationPathPanelElement: function _createElevationPathPanelElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPelevationPathPanel");
        div.className = "GPpanel";

        // div.appendChild(this._createElevationPathPanelHeaderElement());
        // div.appendChild(this._createElevationPathPanelProfilElement());

        return div;
    },

    /**
     * Create Header Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createElevationPathPanelHeaderElement: function _createElevationPathPanelHeaderElement() {
        var self = this;

        var container = document.createElement("div");
        container.className = "GPpanelHeader";

        var divInfo = document.createElement("div");
        divInfo.id = this._addUID("GPelevationPathPanelInfo");
        divInfo.className = "GPpanelInfo";
        divInfo.title = "Informations";
        // add event on click
        if (divInfo.addEventListener) {
            divInfo.addEventListener("click", function () {
                self.onOpenElevationPathInfoClick();
            });
        } else if (divInfo.attachEvent) {
            // internet explorer
            divInfo.attachEvent("onclick", function () {
                self.onOpenElevationPathInfoClick();
            });
        }
        container.appendChild(divInfo);

        var divTitle = document.createElement("div");
        divTitle.className = "GPpanelTitle";
        divTitle.innerHTML = "Profil Altimétrique";
        container.appendChild(divTitle);

        var divReduce = document.createElement("div");
        divReduce.id = this._addUID("GPelevationPathPanelReduce");
        divReduce.className = "GPpanelReduce";
        divReduce.title = "Masquer le panneau";

        if (divReduce.addEventListener) {
            divReduce.addEventListener("click", function () {
                if (typeof self.onReduceElevationPathPanelClick === "function") {
                    document.getElementById(self._addUID("GPshowElevationPath")).checked = false;
                    self.onReduceElevationPathPanelClick();
                }
            }, false);
        } else if (divReduce.attachEvent) {
            divReduce.attachEvent("onclick", function () {
                if (typeof self.onReduceElevationPathPanelClick === "function") {
                    document.getElementById(self._addUID("GPshowElevationPath")).checked = false;
                    self.onReduceElevationPathPanelClick();
                }
            });
        }
        container.appendChild(divReduce);

        var divClose = document.createElement("div");
        divClose.id = this._addUID("GPelevationPathPanelClose");
        divClose.className = "GPpanelClose";
        divClose.title = "Fermer le panneau";

        // Link panel close / visibility checkbox
        if (divClose.addEventListener) {
            divClose.addEventListener("click", function () {
                document.getElementById(self._addUID("GPshowElevationPathPicto")).click();
            }, false);
        } else if (divClose.attachEvent) {
            divClose.attachEvent("onclick", function () {
                document.getElementById(self._addUID("GPshowElevationPathPicto")).click();
            });
        }
        container.appendChild(divClose);

        return container;
    },

    /**
     * Create Form
     * see evenement !
     *
     * @returns {DOMElement} DOM element
     */
    _createElevationPathPanelProfilElement: function _createElevationPathPanelProfilElement() {
        var div = document.createElement("div");
        div.id = "GPelevationPathProfil";

        return div;
    },

    /**
     * Create Waiting Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createElevationPathWaitingElement: function _createElevationPathWaitingElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPelevationPathCalcWaitingContainer");
        div.className = "GPelevationPathCalcWaitingContainerHidden";

        var p = document.createElement("p");
        p.className = "GPelevationPathCalcWaiting";
        p.innerHTML = "Calcul en cours...";

        div.appendChild(p);

        return div;
    },

    /**
     * Create information Panel
     *
     * @returns {DOMElement} DOM element
     */
    _createElevationPathInformationsElement: function _createElevationPathInformationsElement() {
        var div = document.createElement("div");
        div.id = this._addUID("GPelevationPathInformationsContainer");
        div.className = "GPelevationPathInformationsContainerHidden";

        var p = document.createElement("p");
        p.className = "GPelevationPathInformations";
        p.innerHTML = "Aucune information...";
        div.appendChild(p);

        return div;
    },

    /**
     * Add a information into Panel
     *
     * @param {String} value - value of item
     * @returns {DOMElement} DOM element
     */
    _addElevationPathInformationsItem: function _addElevationPathInformationsItem(value) {
        var div = document.getElementById(this._addUID("GPelevationPathInformationsContainer"));

        if (div) {
            var p = document.createElement("p");
            p.className = "GPelevationPathInformations";
            p.innerHTML = value;
            div.appendChild(p);
        }

        return div;
    }
};

exports.default = ElevationPathDOM;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* globals AmCharts, d3 */
var ProfileElevationPathDOM = {

    /**
     * Display Profile function used by default : no additonal framework needed.
     * @param {Object} data - elevations values for profile
     * @param {HTMLElement} container - html container where to display profile
     * @param {Object} context - this control object
     * @param {Object} className - calling class (ie ElevationPath)
     * @returns {DOMElement} profil container
     */
    displayProfileByDefault: function displayProfileByDefault(data, container, context, className) {
        var self = context;

        // on nettoie toujours...
        if (container) {
            while (container.firstChild) {
                container.removeChild(container.firstChild);
            }
        }

        if (!data) {
            return;
        }

        var _displayProfileOptions = self.options.displayProfileOptions;

        var _points = data.points;

        var sortedElev = JSON.parse(JSON.stringify(_points));
        sortedElev.sort(function (e1, e2) {
            return e1.z - e2.z;
        });

        var minZ = sortedElev[0].z;
        var maxZ = sortedElev[sortedElev.length - 1].z;
        var diff = maxZ - minZ;
        var dist = data.distance;
        var unit = data.unit;
        // var distMin = 0;
        var barwidth = 100 / _points.length;

        var div = document.createElement("div");
        div.id = "profileElevationByDefault";
        container.appendChild(div);

        var divBox = document.createElement("div");
        divBox.className = "profile-box";

        var divZ = document.createElement("div");
        divZ.className = "profile-z-vertical";
        var ulZ = document.createElement("ul");
        var liZmin = document.createElement("li");
        liZmin.setAttribute("class", "profile-min-z");
        liZmin.innerHTML = minZ + " m";
        var liZmax = document.createElement("li");
        liZmax.setAttribute("class", "profile-max-z");
        liZmax.innerHTML = maxZ + " m";

        // var divUnit = document.createElement("div");
        // divUnit.className = "profile-unit";
        // divUnit.innerHTML = "m";

        ulZ.appendChild(liZmax);
        ulZ.appendChild(liZmin);
        divZ.appendChild(ulZ);
        // divZ.appendChild(divUnit);
        divBox.appendChild(divZ);

        var divData = document.createElement("div");
        divData.className = "profile-content";
        divData.addEventListener("mouseover", function (e) {
            var _lon = parseFloat(e.target.dataset["lon"]);
            var _lat = parseFloat(e.target.dataset["lat"]);

            if (_lon && _lat) {
                className.__createProfileMarker(self, {
                    lat: _lat,
                    lon: _lon
                });
            }
        });
        divData.addEventListener("mousemove", function (e) {
            var _lon = parseFloat(e.target.dataset["lon"]);
            var _lat = parseFloat(e.target.dataset["lat"]);

            if (_lon && _lat) {
                className.__updateProfileMarker(self, {
                    lat: _lat,
                    lon: _lon
                });
            }
        });
        divData.addEventListener("mouseout", function () {
            className.__removeProfileMarker(self);
        });

        var ulData = document.createElement("ul");
        ulData.id = "profile-data";
        ulData.className = "profile-z-axis profile-x-axis";
        divData.appendChild(ulData);

        for (var i = 0; i < _points.length; i++) {
            var d = _points[i];
            var li = document.createElement("li");
            li.setAttribute("data-z", d.z);
            li.setAttribute("data-lon", d.lon);
            li.setAttribute("data-lat", d.lat);
            li.setAttribute("data-dist", d.dist);

            var pct = Math.floor((d.z - minZ) * 100 / diff);
            li.setAttribute("class", "percent v" + pct);
            li.title = "Altitude : " + d.z + "m";
            if (_displayProfileOptions.currentSlope) {
                li.title += " - Pente : " + d.slope + "%";
            }
            li.title += " (Lat : " + d.lat + " / Lon : " + d.lon + ")";

            li.setAttribute("style", "width: " + barwidth + "%");
            ulData.appendChild(li);
        }

        divBox.appendChild(divData);
        div.appendChild(divBox);

        var divX = document.createElement("div");
        divX.className = "profile-x-horizontal";
        var ulX = document.createElement("ul");
        var liXmin = document.createElement("li");
        liXmin.setAttribute("class", "profile-min-x");
        liXmin.innerHTML = "";
        var liXmax = document.createElement("li");
        liXmax.setAttribute("class", "profile-max-x");
        liXmax.innerHTML = dist + " " + unit;
        ulX.appendChild(liXmin);
        ulX.appendChild(liXmax);
        divX.appendChild(ulX);
        div.appendChild(divX);

        return container;
    },

    /**
     * Display Profile without graphical rendering (raw service response)
     * @param {Object} data - elevations values for profile
     * @param {HTMLElement} container - html container where to display profile
     * @param {Object} context - this control object
     * @param {Object} className - calling class (ie ElevationPath)
     * @returns {DOMElement} profil container
     */
    displayProfileRaw: function displayProfileRaw(data, container, context, className) {
        // on nettoie toujours...
        if (container) {
            while (container.firstChild) {
                container.removeChild(container.firstChild);
            }
        }

        var _points = data.points;

        var div = document.createElement("textarea");
        div.id = "profilElevationResults";
        div.rows = 10;
        div.cols = 50;
        div.style.width = "100%";
        div.innerHTML = JSON.stringify(_points, undefined, 4);
        div.addEventListener("mouseover", function (e) {
            className.__customRawProfileMouseOverEvent(context, e);
        });

        // TODO
        // for (var i = 0; i < _points.length; i++) {
        //     var point = _points[i];
        //     var divC  = document.createElement("code");
        //     divC.id = "point_" + i;
        //     divC.innerHTML = JSON.stringify(point, undefined, 4);
        //     div.appendChild(divC);
        //     divC.addEventListener("mouseover", function (e) {
        //          className.__customRawProfileMouseOverEvent(context, e);
        //     });
        // }

        container.appendChild(div);

        return container;
    },

    /**
     * Display Profile using D3 javascript framework. This method needs D3 libraries to be loaded.
     * @param {Object} data - elevations values for profile
     * @param {HTMLElement} container - html container where to display profile
     * @param {Object} context - this control object
     * @param {Object} className - calling class (ie ElevationPath)
     * @returns {DOMElement} profil container
     */
    displayProfileLibD3: function displayProfileLibD3(data, container, context, className) {
        var self = context;

        // on nettoie toujours...
        if (container) {
            while (container.firstChild) {
                container.removeChild(container.firstChild);
            }
        }

        var _points = data.points;

        var _displayProfileOptions = self.options.displayProfileOptions;

        var margin = {
            top: 20,
            right: 20,
            bottom: 30,
            left: 40
        };

        var width = container.clientWidth - margin.left - margin.right;
        var height = container.clientHeight - margin.top - margin.bottom;

        var x = d3.scale.linear().range([0, width]);

        var y = d3.scale.linear().range([height, 0]);

        var xAxis = d3.svg.axis().scale(x).orient("bottom").ticks(5);

        var yAxis = d3.svg.axis().scale(y).orient("left").ticks(5);

        var line = d3.svg.line().interpolate("basis").x(function (d) {
            return x(d.dist);
        }).y(function (d) {
            return y(d.z);
        });

        var area = d3.svg.area().interpolate("basis").x(function (d) {
            return x(d.dist);
        }).y0(height).y1(function (d) {
            return y(d.z);
        });

        var svg = d3.select(container).append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        var xDomain = d3.extent(_points, function (d) {
            return d.dist;
        });
        x.domain(xDomain);

        var yDomain = [0, d3.max(_points, function (d) {
            return d.z;
        })];
        y.domain(yDomain);

        svg.append("path").datum(_points).attr("class", "area-d3").attr("d", area);

        svg.append("g").attr("class", "x axis-d3").attr("transform", "translate(0," + height + ")").call(xAxis).append("text").attr("y", -15).attr("dy", ".71em").attr("x", width).text("Distance (" + data.unit + ")");

        svg.append("g").attr("class", "y axis-d3").call(yAxis).append("text").attr("transform", "rotate(-90)").attr("y", 6).attr("dy", ".71em").text("Altitude (m)");

        svg.append("g").attr("class", "grid-d3 vertical").attr("transform", "translate(0," + height + ")").call(xAxis.orient("bottom").tickSize(-height, 0, 0).tickFormat(""));

        svg.append("g").attr("class", "grid-d3 horizontal").call(yAxis.orient("left").tickSize(-width, 0, 0).tickFormat(""));

        svg.append("path").datum(_points).attr("class", "line-d3").attr("d", line);

        svg.selectAll("circle").data(_points).enter().append("circle").attr("cx", function (d) {
            return x(d.dist);
        }).attr("cy", function (d) {
            return y(d.z);
        }).attr("r", 0).attr("class", "circle-d3");

        var focus = svg.append("g").style("display", "none");

        focus.append("line").attr("id", "focusLineX").attr("class", "focusLine-d3");
        focus.append("line").attr("id", "focusLineY").attr("class", "focusLine-d3");
        focus.append("circle").attr("id", "focusCircle").attr("r", 4).attr("class", "circle-d3 focusCircle-d3");

        var div = d3.select(container).append("div").attr("class", "tooltip-d3").style("opacity", 0);

        var bisectDist = d3.bisector(function (d) {
            return d.dist;
        }).left;

        svg.append("rect").attr("class", "overlay-d3").attr("width", width).attr("height", height).on("mouseover", function () {
            focus.style("display", null);
            className.__createProfileMarker(self, _points[0]);
        }).on("mouseout", function () {
            focus.style("display", "none");
            className.__removeProfileMarker(self);

            // tooltips
            div.transition().duration(500).style("opacity", 0);
        }).on("mousemove", function () {
            var m = d3.mouse(this);
            var distance = x.invert(m[0]);
            var i = bisectDist(_points, distance);

            var d0 = _points[i - 1];
            var d1 = _points[i];
            var d = distance - d0[0] > d1[0] - distance ? d1 : d0;

            var xc = x(d.dist);
            var yc = y(d.z);

            focus.select("#focusCircle").attr("cx", xc).attr("cy", yc);
            focus.select("#focusLineX").attr("x1", xc).attr("y1", y(yDomain[0])).attr("x2", xc).attr("y2", y(yDomain[1]));
            focus.select("#focusLineY").attr("x1", x(xDomain[0])).attr("y1", yc).attr("x2", x(xDomain[1])).attr("y2", yc);

            className.__updateProfileMarker(self, d);

            // tooltips
            div.transition().duration(200).style("opacity", 0.9);

            var _message = "";
            _message += " Altitude : " + d.z + " m";
            if (_displayProfileOptions.currentSlope) {
                _message += "<br/> Pente : " + d.slope + " %";
            }
            _message += "<br/> (Lat : " + d.lat + "/ Lon : " + d.lon + ")";

            div.html(_message).style("left", d3.event.pageX + "px").style("top", d3.event.pageY - 28 + "px");
        });

        // return d3.selectAll("rect.overlay")[0][0];
        return svg;
    },

    /**
     * Display Profile using Amcharts framework. This method needs AmCharts libraries to be loaded.
     * @param {Object} data - elevations values for profile
     * @param {HTMLElement} container - html container where to display profile
     * @param {Object} context - this control object
     * @param {Object} className - calling class (ie ElevationPath)
     * @returns {DOMElement} profil container
     */
    displayProfileLibAmCharts: function displayProfileLibAmCharts(data, container, context, className) {
        var self = context;

        var _points = data.points;

        var ballonText = "<span class='altiPathValue'>[[title]] : [[value]]m</span><br/>";
        var currentSlope = self.options.displayProfileOptions.currentSlope;
        if (currentSlope) {
            ballonText += "<span class='altiPathValue'>Pente : [[slope]] %</span><br/>";
        }
        ballonText += "<span class='altiPathCoords'>(Lat: [[lat]] / Lon:[[lon]])</span>";

        AmCharts.addInitHandler(function () {});

        var settings = {
            type: "serial",
            pathToImages: "http://cdn.amcharts.com/lib/3/images/",
            categoryField: "dist",
            autoMarginOffset: 0,
            marginRight: 10,
            marginTop: 10,
            startDuration: 0,
            color: "#5E5E5E",
            fontSize: 8,
            theme: "light",
            thousandsSeparator: "",
            numberFormatter: {
                precision: -1,
                decimalSeparator: ",",
                thousandsSeparato: " "
            },
            categoryAxis: {
                color: "#5E5E5E",
                gridPosition: "start",
                minHorizontalGap: 40,
                tickPosition: "start",
                title: "Distance (" + data.unit + ")",
                titleColor: "#5E5E5E",
                labelOffset: 0,
                startOnAxis: true
            },
            chartCursor: {
                animationDuration: 0,
                bulletsEnabled: true,
                bulletSize: 10,
                categoryBalloonEnabled: false,
                cursorColor: "#F90",
                graphBulletAlpha: 1,
                graphBulletSize: 1,
                zoomable: false
            },
            trendLines: [],
            graphs: [{
                balloonColor: "#CCCCCC",
                balloonText: ballonText,
                bullet: "round",
                bulletAlpha: 0,
                bulletBorderColor: "#FFF",
                bulletBorderThickness: 2,
                bulletColor: "#F90",
                bulletSize: 6,
                hidden: false,
                id: "AmGraph-1",
                fillAlphas: 0.4,
                fillColors: "#C77A04",
                lineAlpha: 1,
                lineColor: "#C77A04",
                lineThickness: 1,
                title: "Altitude",
                valueField: "z"
            }],
            guides: [],
            valueAxes: [{
                id: "ValueAxis-1",
                minVerticalGap: 20,
                title: "Altitude (m)"
            }],
            balloon: {
                borderColor: "#CCCCCC",
                borderThickness: 1,
                fillColor: "#FFFFFF",
                showBullet: true
            },
            titles: [],
            allLabels: [],
            dataProvider: _points
        };

        var _containerProfile = AmCharts.makeChart(container, settings);

        _containerProfile.addListener("changed", function (e) {
            var obj = e.chart.dataProvider[e.index];
            className.__updateProfileMarker(self, obj);
        });

        return _containerProfile;
    }
};

exports.default = ProfileElevationPathDOM;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _MeasureToolBox = __webpack_require__(10);

var _MeasureToolBox2 = _interopRequireDefault(_MeasureToolBox);

var _Measures = __webpack_require__(9);

var _Measures2 = _interopRequireDefault(_Measures);

var _MeasureLengthDOM = __webpack_require__(58);

var _MeasureLengthDOM2 = _interopRequireDefault(_MeasureLengthDOM);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Derived from OpenLayers measure example
// http://openlayers.org/en/latest/examples/measure.html

var logger = _LoggerByDefault2.default.getLogger("measurelength");

/**
 * @classdesc
 *
 * Length measurement Control. Allows users to draw a path on Openlayers map and have its length computed and displayed.
 *
 * @constructor
 * @alias ol.control.MeasureLength
 * @extends {ol.control.Control}
 * @param {Object} options - options for function call.
 * @param {Boolean} [options.geodesic = true] - If true, length will be computed on the global sphere using the {@link https://openlayers.org/en/latest/apidoc/ol.Sphere.html#haversineDistance ol.Sphere.haversineDistance()} function. Otherwise, length will be computed on the projected plane.
 * @param {Object} [options.styles = {}] - styles used when drawing. Specified with following properties.
 * @param {Object} [options.styles.pointer = {}] - Style for mouse pointer when drawing the path. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Image.html ol.style.Image} subclass object.
 * @param {Object} [options.styles.start = {}] - Line Style when drawing. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Style.html ol.style.Style} object.
 * @param {Object} [options.styles.finish = {}] - Line Style when finished drawing. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Style.html ol.style.Style} object.
 * <!-- @param {Object} [options.tooltip = {}] - NOT YET IMPLEMENTED ! -->
 * @param {Object} [options.layerDescription = {}] - Layer informations to be displayed in LayerSwitcher widget (only if a LayerSwitcher is also added to the map)
 * @param {String} [options.layerDescription.title = "Mesures de distance"] - Layer title to be displayed in LayerSwitcher
 * @param {String} [options.layerDescription.description = "Mes mesures"] - Layer description to be displayed in LayerSwitcher
 * @example
 * var measureLength = new ol.control.MeasureLength({
 *    geodesic : false
 * });
 */
function MeasureLength(options) {
    // options
    options = options || {};

    if (!(this instanceof MeasureLength)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    // Nom de la classe (heritage)
    this.CLASSNAME = "MeasureLength";

    // uuid
    this._uid = _SelectorID2.default.generate();

    // container d'activation du controle
    this._showContainer = null;
    this._pictoContainer = null;

    // initialisation du composant
    this._initialize(options);

    // creation du DOM container
    var container = options.element ? options.element : this._initializeContainer();

    // heritage
    _ol2.default.control.Control.call(this, {
        element: container,
        target: options.target,
        render: options.render
    });
}

// heritage avec ol.control.Control
_ol2.default.inherits(MeasureLength, _ol2.default.control.Control);

/**
 * @lends module:MeasureLength
 */
MeasureLength.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les mixins de la classe "MeasureLengthDOM" ainsi que celles
// de "Measures".
_Utils2.default.assign(MeasureLength.prototype, _Measures2.default);
_Utils2.default.assign(MeasureLength.prototype, _MeasureLengthDOM2.default);

/**
 * Constructor (alias)
 * @private
 */
MeasureLength.prototype.constructor = MeasureLength;

// ################################################################### //
// ##################### public methods ############################## //
// ################################################################### //

/**
 * Overwrite OpenLayers setMap method
 *
 * @param {ol.Map} map - Map.
 */
MeasureLength.prototype.setMap = function (map) {
    // logger.trace("setMap()");

    var className = this.CLASSNAME;

    // on fait le choix de ne pas activer les events sur la map à l'init de l'outil,
    // mais uniquement à son utilisation !
    if (map) {
        // var self = this;
        // map.on("click", function (e) {
        //     // logger.trace("event on map with click!");
        //     self.onPointerMoveHandler(e);
        // });
        //
        // map.on("singleclick", function (e) {
        //     // logger.trace("event on map with singleclick!");
        //     self.onPointerMoveHandler(e);
        // });
        //
        // map.on("pointermove", function (e) {
        //     // logger.trace("event on map with pointermove!");
        //     self.onPointerMoveHandler(e);
        // });

        if (!this.options.target) {
            _MeasureToolBox2.default.add(map, this);
        }
    } else {
        this.clean();
    }

    // sauvegarde de l'état de l'outil
    this.tools[className].push({
        instance: map ? this : null,
        active: false,
        map: map ? map.getTargetElement().id : null
    });

    // on appelle la méthode setMap originale d'OpenLayers
    _ol2.default.control.Control.prototype.setMap.call(this, map);
};

// ################################################################### //
// ##################### init component ############################## //
// ################################################################### //

/**
 * Initialize measure control (called by constructor)
 *
 * @param {Object} options - options
 *
 * @private
 */
MeasureLength.prototype._initialize = function (options) {
    // logger.trace("call MeasureLength::_initialize() : ", options);

    // liste des options
    this.options = {};
    this.options.geodesic = typeof options.geodesic !== "undefined" ? options.geodesic : true;
    this.options.target = typeof options.target !== "undefined" ? options.target : null;
    this.options.render = typeof options.render !== "undefined" ? options.render : null;
    this.options.layerDescription = typeof options.layerDescription !== "undefined" ? options.layerDescription : {
        title: "Mesures de distance",
        description: "Mes mesures"
    };

    // gestion des styles !
    this.createStylingMeasureInteraction(options.styles);
};

/**
 * initialize component container (DOM)
 *
 * @returns {DOMElement} DOM element
 *
 * @private
 */
MeasureLength.prototype._initializeContainer = function () {
    // logger.trace("call MeasureLength::_initializeContainer() : ", this._uid);

    var container = this._createMainContainerElement();

    var show = this._showContainer = this._createShowMeasureLengthElement();
    container.appendChild(show);

    // par defaut, pas d'interaction à l'initialisation...
    this._showContainer.checked = false;

    var picto = this._pictoContainer = this._createShowMeasureLengthPictoElement();
    container.appendChild(picto);

    return container;
};

// ################################################################### //
// ########################## methods ################################ //
// ################################################################### //

/**
 * Add all events on map
 *
 * @private
 */
MeasureLength.prototype.addMeasureEvents = function () {
    // logger.trace("call MeasureLength::addMeasureEvents()");

    var map = this.getMap();

    map.on("singleclick", this.onPointerMoveHandler, this);
    map.on("pointermove", this.onPointerMoveHandler, this);
};

/**
 * Remove all events on map
 *
 * @private
 */
MeasureLength.prototype.removeMeasureEvents = function () {
    // logger.trace("call MeasureLength::removeMeasureEvents()");

    var map = this.getMap();

    map.un("singleclick", this.onPointerMoveHandler, this);
    map.un("pointermove", this.onPointerMoveHandler, this);
};

/**
 * Format length output.
 *
 * @param {ol.geom.Line} line - geometry line.
 * @return {String} The formatted output.
 * @private
 */
MeasureLength.prototype.format = function (line) {
    // logger.trace("call MeasureLength::format()");

    var map = this.getMap();

    var measure;
    if (this.options.geodesic) {
        var wgs84Sphere = new _ol2.default.Sphere(6378137);
        var coordinates = line.getCoordinates();
        measure = 0;
        var sourceProj = map.getView().getProjection();
        for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
            var c1 = _ol2.default.proj.transform(coordinates[i], sourceProj, "EPSG:4326");
            var c2 = _ol2.default.proj.transform(coordinates[i + 1], sourceProj, "EPSG:4326");
            measure += wgs84Sphere.haversineDistance(c1, c2);
        }
    } else {
        measure = Math.round(line.getLength() * 100) / 100;
    }

    var output;
    if (measure > 1000) {
        output = Math.round(measure / 1000 * 100) / 100 + " " + "km";
    } else {
        output = Math.round(measure * 100) / 100 + " " + "m";
    }
    return output;
};

// ################################################################### //
// ####################### handlers events to dom #################### //
// ################################################################### //

/**
 * this method is called by event 'click' on picto
 *
 * @param {Object} e - HTMLElement
 *
 * @private
 */
MeasureLength.prototype.onShowMeasureLengthClick = function (e) {
    // logger.trace("call MeasureLength::onShowMeasureLengthClick()", e);

    // appel de la methode commune
    this.onShowMeasureClick(e, "LineString");
};

exports.default = MeasureLength;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MeasureLengthDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPmeasureLength");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################### Methods of main container ##################### //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing
     *
     * @returns {DOMElement} DOM element
     */
    _createShowMeasureLengthElement: function _createShowMeasureLengthElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowMeasureLength");
        input.type = "checkbox";
        return input;
    },

    /**
     * Show control
     * see event !
     *
     * @returns {DOMElement} DOM element
     */
    _createShowMeasureLengthPictoElement: function _createShowMeasureLengthPictoElement() {
        // contexte d'execution
        var context = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowMeasureLengthPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowMeasureLength");
        label.title = "Mesurer une distance";

        // gestionnaire d'evenement :
        // on ouvre le menu de saisie...
        // L'ouverture/Fermeture permet de faire le menage
        // (reinitialisation)
        if (label.addEventListener) {
            label.addEventListener("click", function (e) {
                context.onShowMeasureLengthClick(e);
            });
        } else if (label.attachEvent) {
            label.attachEvent("onclick", function (e) {
                context.onShowMeasureLengthClick(e);
            });
        }

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowMeasureLengthOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    }
};

exports.default = MeasureLengthDOM;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _MeasureToolBox = __webpack_require__(10);

var _MeasureToolBox2 = _interopRequireDefault(_MeasureToolBox);

var _Measures = __webpack_require__(9);

var _Measures2 = _interopRequireDefault(_Measures);

var _MeasureAreaDOM = __webpack_require__(60);

var _MeasureAreaDOM2 = _interopRequireDefault(_MeasureAreaDOM);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Derived from OpenLayers measure example
// http://openlayers.org/en/latest/examples/measure.html

var logger = _LoggerByDefault2.default.getLogger("measurearea");

/**
 * @classdesc
 *
 * Tool Measure Area Control. Allows users to measure the length of a path drawn on the map.
 *
 * @constructor
 * @alias ol.control.MeasureArea
 * @extends {ol.control.Control}
 * @param {Object} options - options for function call.
 * @param {Boolean} [options.geodesic = true] - If true, area will be computed on the global sphere using the {@link https://openlayers.org/en/latest/apidoc/ol.Sphere.html#geodesicArea ol.Sphere.geodesicArea()} function. Otherwise, area will be computed on the projected plane.
 * @param {Object} [options.styles = {}] - styles used when drawing. Specified with following properties.
 * @param {Object} [options.styles.pointer = {}] - Style for mouse pointer when drawing the polygon to measure. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Image.html ol.style.Image} subclass object.
 * @param {Object} [options.styles.start = {}] - Polygon Style when drawing. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Style.html ol.style.Style} object.
 * @param {Object} [options.styles.finish = {}] - Polygon Style when finished drawing. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Style.html ol.style.Style} object.
 * <!-- @param {Object} [options.tooltip = {}] - NOT YET IMPLEMENTED ! -->
 * @param {Object} [options.layerDescription = {}] - Layer informations to be displayed in LayerSwitcher widget (only if a LayerSwitcher is also added to the map)
 * @param {String} [options.layerDescription.title = "Mesures de surface"] - Layer title to be displayed in LayerSwitcher
 * @param {String} [options.layerDescription.description = "Mes mesures"] - Layer description to be displayed in LayerSwitcher
 * @example
 * var measureArea = new ol.control.MeasureArea({
 *    geodesic : false
 * });
 */
function MeasureArea(options) {
    /**
     * options
     * @private
     */
    options = options || {};

    if (!(this instanceof MeasureArea)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    /**
     * Nom de la classe (heritage)
     * @private
     */
    this.CLASSNAME = "MeasureArea";

    // uuid
    this._uid = _SelectorID2.default.generate();

    // container d'activation du controle
    this._showContainer = null;
    this._pictoContainer = null;

    // initialisation du composant
    this._initialize(options);

    // creation du DOM container
    var container = options.element ? options.element : this._initializeContainer();

    // heritage
    _ol2.default.control.Control.call(this, {
        element: container,
        target: options.target,
        render: options.render
    });
}

// heritage avec ol.control.Control
_ol2.default.inherits(MeasureArea, _ol2.default.control.Control);

/**
 * @lends module:MeasureArea
 */
MeasureArea.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les mixins de la classe "MeasureAreaDOM" ainsi que celles
// de "Measures".
_Utils2.default.assign(MeasureArea.prototype, _Measures2.default);
_Utils2.default.assign(MeasureArea.prototype, _MeasureAreaDOM2.default);

/**
 * Constructor (alias)
 * @private
 */
MeasureArea.prototype.constructor = MeasureArea;

// ################################################################### //
// ##################### public methods ############################## //
// ################################################################### //

/**
 * Overwrite OpenLayers setMap method
 *
 * @param {ol.Map} map - Map.
 */
MeasureArea.prototype.setMap = function (map) {
    // logger.trace("setMap()");

    var className = this.CLASSNAME;

    // on fait le choix de ne pas activer les events sur la map à l'init de l'outil,
    // mais uniquement à son utilisation !
    if (map) {
        // var self = this;
        // map.on("click", function (e) {
        //     // logger.trace("event on map with click!");
        //     self.onPointerMoveHandler(e);
        // });
        //
        // map.on("singleclick", function (e) {
        //     // logger.trace("event on map with singleclick!");
        //     self.onPointerMoveHandler(e);
        // });
        //
        // map.on("pointermove", function (e) {
        //     // logger.trace("event on map with pointermove!");
        //     self.onPointerMoveHandler(e);
        // });

        if (!this.options.target) {
            _MeasureToolBox2.default.add(map, this);
        }
    } else {
        this.clean();
    }

    // sauvegarde de l'état de l'outil
    this.tools[className].push({
        instance: map ? this : null,
        active: false,
        map: map ? map.getTargetElement().id : null
    });

    // on appelle la méthode setMap originale d'OpenLayers
    _ol2.default.control.Control.prototype.setMap.call(this, map);
};

// ################################################################### //
// ##################### init component ############################## //
// ################################################################### //

/**
 * Initialize measure control (called by constructor)
 *
 * @param {Object} options - options
 *
 * @private
 */
MeasureArea.prototype._initialize = function (options) {
    // logger.trace("call MeasureArea::_initialize() : ", options);

    // liste des options
    this.options = {};
    this.options.geodesic = typeof options.geodesic !== "undefined" ? options.geodesic : true;
    this.options.target = typeof options.target !== "undefined" ? options.target : null;
    this.options.render = typeof options.render !== "undefined" ? options.render : null;
    this.options.layerDescription = typeof options.layerDescription !== "undefined" ? options.layerDescription : {
        title: "Mesures de surface",
        description: "Mes mesures"
    };

    // gestion des styles !
    this.createStylingMeasureInteraction(options.styles);
};

/**
 * initialize component container (DOM)
 *
 * @returns {DOMElement} DOM element
 *
 * @private
 */
MeasureArea.prototype._initializeContainer = function () {
    // logger.trace("call MeasureArea::_initializeContainer() : ", this._uid);

    var container = this._createMainContainerElement();;

    var show = this._showContainer = this._createShowMeasureAreaElement();
    container.appendChild(show);

    // par defaut, pas d'interaction à l'initialisation...
    this._showContainer.checked = false;

    var picto = this._pictoContainer = this._createShowMeasureAreaPictoElement();
    container.appendChild(picto);

    return container;
};

// ################################################################### //
// ##################### overridden methods ########################## //
// ################################################################### //

/**
 * Add all events on map
 *
 * @private
 */
MeasureArea.prototype.addMeasureEvents = function () {
    // logger.trace("call MeasureArea::addMeasureEvents()");

    var map = this.getMap();

    map.on("singleclick", this.onPointerMoveHandler, this);
    map.on("pointermove", this.onPointerMoveHandler, this);
};

/**
 * Remove all events on map
 *
 * @private
 */
MeasureArea.prototype.removeMeasureEvents = function () {
    // logger.trace("call MeasureArea::removeMeasureEvents()");

    var map = this.getMap();

    map.un("singleclick", this.onPointerMoveHandler, this);
    map.un("pointermove", this.onPointerMoveHandler, this);
};

/**
 * Format length output.
 *
 * @param {ol.geom.Polygon} polygon - geometry polygon.
 * @return {String} The formatted output.
 * @private
 */
MeasureArea.prototype.format = function (polygon) {
    // logger.trace("call MeasureArea::format()");

    var map = this.getMap();

    var measure;
    if (this.options.geodesic) {
        var wgs84Sphere = new _ol2.default.Sphere(6378137);
        var sourceProj = map.getView().getProjection();
        var geom = polygon.clone().transform(sourceProj, "EPSG:4326");
        var coordinates = geom.getLinearRing(0).getCoordinates();
        measure = Math.abs(wgs84Sphere.geodesicArea(coordinates));
    } else {
        measure = polygon.getArea();
    }

    var output;
    if (measure > 1000000) {
        output = Math.round(measure / 1000000 * 100) / 100 + " " + "km<sup>2</sup>";
    } else if (measure > 100000) {
        output = Math.round(measure / 1000000 * 1000) / 1000 + " " + "km<sup>2</sup>";
    } else if (measure > 1000) {
        output = Math.round(measure / 10) * 10 + " " + "m<sup>2</sup>";
    } else {
        output = Math.round(measure * 100) / 100 + " " + "m<sup>2</sup>";
    }
    return output;
};

// ################################################################### //
// ####################### handlers events to dom #################### //
// ################################################################### //

/**
 * this method is called by event 'click' on picto
 *
 * @param {Object} e - HTMLElement
 *
 * @private
 */
MeasureArea.prototype.onShowMeasureAreaClick = function (e) {
    // logger.trace("call MeasureArea::onShowMeasureAreaClick()", e);

    // appel de la methode commune
    this.onShowMeasureClick(e, "Polygon");
};

exports.default = MeasureArea;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MeasureAreaDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPmeasureArea");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################### Methods of main container ##################### //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing
     *
     * @returns {DOMElement} DOM element
     */
    _createShowMeasureAreaElement: function _createShowMeasureAreaElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowMeasureArea");
        input.type = "checkbox";
        return input;
    },

    /**
     * Show control
     * see event !
     *
     * @returns {DOMElement} DOM element
     */
    _createShowMeasureAreaPictoElement: function _createShowMeasureAreaPictoElement() {
        // contexte d'execution
        var context = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowMeasureAreaPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowMeasureArea");
        label.title = "Mesurer une surface";

        // gestionnaire d'evenement :
        // on ouvre le menu de saisie...
        // L'ouverture/Fermeture permet de faire le menage
        // (reinitialisation)
        if (label.addEventListener) {
            label.addEventListener("click", function (e) {
                context.onShowMeasureAreaClick(e);
            });
        } else if (label.attachEvent) {
            label.attachEvent("onclick", function (e) {
                context.onShowMeasureAreaClick(e);
            });
        }

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowMeasureAreaOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    }
};

exports.default = MeasureAreaDOM;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ol = __webpack_require__(1);

var _ol2 = _interopRequireDefault(_ol);

var _LoggerByDefault = __webpack_require__(0);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _Utils = __webpack_require__(2);

var _Utils2 = _interopRequireDefault(_Utils);

var _MeasureToolBox = __webpack_require__(10);

var _MeasureToolBox2 = _interopRequireDefault(_MeasureToolBox);

var _Measures = __webpack_require__(9);

var _Measures2 = _interopRequireDefault(_Measures);

var _MeasureAzimuthDOM = __webpack_require__(62);

var _MeasureAzimuthDOM2 = _interopRequireDefault(_MeasureAzimuthDOM);

var _SelectorID = __webpack_require__(3);

var _SelectorID2 = _interopRequireDefault(_SelectorID);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Derived from OpenLayers measure example
// http://openlayers.org/en/latest/examples/measure.html

var logger = _LoggerByDefault2.default.getLogger("measureazimut");

/**
 * @classdesc
 *
 * Azimuth measurement Control. Allows users to draw a line on an Openlayers map and have its angle in decimal degrees clockwise from the geographical north.
 *
 * @constructor
 * @alias ol.control.MeasureAzimuth
 * @extends {ol.control.Control}
 * @param {Object} options - options for function call.
 * @param {Boolean} [options.geodesic = false] - If true, azimuth will be computed on the global sphere. Otherwise, it will be computed on the projected plane.
 * @param {Object} [options.styles = {}] - styles used when drawing. Specified with following properties.
 * @param {Object} [options.styles.pointer = {}] - Style for mouse pointer when drawing the line. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Image.html ol.style.Image} subclass object.
 * @param {Object} [options.styles.start = {}] - Line Style when drawing. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Style.html ol.style.Style} object.
 * @param {Object} [options.styles.finish = {}] - Line Style when finished drawing. Specified with an {@link https://openlayers.org/en/latest/apidoc/ol.style.Style.html ol.style.Style} object.
 * <!-- @param {Object} [options.tooltip = {}] - NOT YET IMPLEMENTED ! -->
 * @param {Object} [options.layerDescription = {}] - Layer informations to be displayed in LayerSwitcher widget (only if a LayerSwitcher is also added to the map)
 * @param {String} [options.layerDescription.title = "Mesures d'azimuth"] - Layer title to be displayed in LayerSwitcher
 * @param {String} [options.layerDescription.description = "Mes mesures"] - Layer description to be displayed in LayerSwitcher
 * @example
 * var measure = new ol.control.MeasureAzimuth({
 *   geodesic : true
 * });
 */
function MeasureAzimuth(options) {
    /**
     * options
     * @private
     */
    options = options || {};

    if (!(this instanceof MeasureAzimuth)) {
        throw new TypeError("ERROR CLASS_CONSTRUCTOR");
    }

    /**
     * Nom de la classe (heritage)
     * @private
     */
    this.CLASSNAME = "MeasureAzimuth";

    // uuid
    this._uid = _SelectorID2.default.generate();

    // container d'activation du controle
    this._showContainer = null;
    this._pictoContainer = null;

    // initialisation du composant
    this._initialize(options);

    // creation du DOM container
    var container = options.element ? options.element : this._initializeContainer();

    // heritage
    _ol2.default.control.Control.call(this, {
        element: container,
        target: options.target,
        render: options.render
    });
}

// heritage avec ol.control.Control
_ol2.default.inherits(MeasureAzimuth, _ol2.default.control.Control);

/**
 * @lends module:MeasureAzimuth
 */
MeasureAzimuth.prototype = Object.create(_ol2.default.control.Control.prototype, {});

// on récupère les mixins de la classe "MeasureAzimuthDOM" ainsi que celles
// de "Measures".
_Utils2.default.assign(MeasureAzimuth.prototype, _Measures2.default);
_Utils2.default.assign(MeasureAzimuth.prototype, _MeasureAzimuthDOM2.default);

/**
 * Constructor (alias)
 * @private
 */
MeasureAzimuth.prototype.constructor = MeasureAzimuth;

// ################################################################### //
// ##################### public methods ############################## //
// ################################################################### //

/**
 * Overwrite OpenLayers setMap method
 *
 * @param {ol.Map} map - Map.
 */
MeasureAzimuth.prototype.setMap = function (map) {
    // logger.trace("setMap()");

    var className = this.CLASSNAME;

    // on fait le choix de ne pas activer les events sur la map à l'init de l'outil,
    // mais uniquement à son utilisation !
    if (map) {
        // var self = this;
        // map.on("click", function (e) {
        //     // logger.trace("event on map with click!");
        //     self.onPointerMoveAzimutHandler(e);
        // });
        //
        // map.on("singleclick", function (e) {
        //     // logger.trace("event on map with singleclick!");
        //     self.onPointerMoveAzimutHandler(e);
        // });
        //
        // map.on("pointermove", function (e) {
        //     // logger.trace("event on map with pointermove!");
        //     self.onPointerMoveAzimutHandler(e);
        // });

        if (!this.options.target) {
            _MeasureToolBox2.default.add(map, this);
        }
    } else {
        this.clean();
    }

    // sauvegarde de l'état de l'outil
    this.tools[className].push({
        instance: map ? this : null,
        active: false,
        map: map ? map.getTargetElement().id : null
    });

    // on appelle la méthode setMap originale d'OpenLayers
    _ol2.default.control.Control.prototype.setMap.call(this, map);
};

/**
 * Setter for option Geodesic
 *
 * @param {Boolean} value - geodesic value
 */
MeasureAzimuth.prototype.setGeodesic = function (value) {
    this.options.geodesic = typeof value !== "undefined" ? value : false;
};

/**
 * Getter for option Geodesic
 *
 * @return {Boolean} geodesic value
 */
MeasureAzimuth.prototype.isGeodesic = function () {
    return this.options.geodesic;
};

// ################################################################### //
// ##################### init component ############################## //
// ################################################################### //

/**
 * Initialize measure control (called by constructor)
 *
 * @param {Object} options - options
 *
 * @private
 */
MeasureAzimuth.prototype._initialize = function (options) {
    // logger.trace("call MeasureAzimuth::_initialize() : ", options);

    // liste des options
    this.options = {};
    this.options.geodesic = typeof options.geodesic !== "undefined" ? options.geodesic : false;
    this.options.target = typeof options.target !== "undefined" ? options.target : null;
    this.options.render = typeof options.render !== "undefined" ? options.render : null;
    this.options.layerDescription = typeof options.layerDescription !== "undefined" ? options.layerDescription : {
        title: "Mesures d'azimuth",
        description: "Mes mesures"
    };

    // gestion des styles !
    this.createStylingMeasureInteraction(options.styles);
};

/**
 * initialize component container (DOM)
 *
 * @returns {DOMElement} DOM element
 *
 * @private
 */
MeasureAzimuth.prototype._initializeContainer = function () {
    // logger.trace("call MeasureAzimuth::_initializeContainer() : ", this._uid);

    var container = this._createMainContainerElement();;

    var show = this._showContainer = this._createShowMeasureAzimuthElement();
    container.appendChild(show);

    // par defaut, pas d'interaction à l'initialisation...
    this._showContainer.checked = false;

    var picto = this._pictoContainer = this._createShowMeasureAzimuthPictoElement();
    container.appendChild(picto);

    return container;
};

// ################################################################### //
// ##################### overridden methods ########################## //
// ################################################################### //

/**
 * Add all events on map
 *
 * @private
 */
MeasureAzimuth.prototype.addMeasureEvents = function () {
    // logger.trace("call MeasureAzimuth::addMeasureEvents()");

    var map = this.getMap();

    map.on("singleclick", this.onPointerMoveAzimutHandler, this);
    map.on("pointermove", this.onPointerMoveAzimutHandler, this);
};

/**
 * Remove all events on map
 *
 * @private
 */
MeasureAzimuth.prototype.removeMeasureEvents = function () {
    // logger.trace("call MeasureAzimuth::removeMeasureEvents()");

    var map = this.getMap();

    map.un("singleclick", this.onPointerMoveAzimutHandler, this);
    map.un("pointermove", this.onPointerMoveAzimutHandler, this);
};

/**
 * Format length output.
 *
 * @param {ol.geom.LineString} line - geometry line.
 * @return {String} The formatted output.
 * @private
 */
MeasureAzimuth.prototype.format = function (line) {
    // logger.trace("call MeasureAzimuth::format()");

    var map = this.getMap();

    var sourceProj = map.getView().getProjection();

    var c1 = _ol2.default.proj.transform(line.getFirstCoordinate(), sourceProj, "EPSG:4326");
    var c2 = _ol2.default.proj.transform(line.getLastCoordinate(), sourceProj, "EPSG:4326");

    if (!this.options.geodesic) {
        // TODO calcul sur une petite distance (>500m) afin de simuler un cap !
        var wgs84Sphere = new _ol2.default.Sphere(6378137);
        var lengthGeodesic = wgs84Sphere.haversineDistance(c1, c2);
        // logger.trace("measure between 2 points with geodesic method", lengthGeodesic);
        if (lengthGeodesic > 500) {
            var fraction = 500.0 / lengthGeodesic;
            // logger.trace("%", fraction);
            c2 = _ol2.default.proj.transform(line.getCoordinateAt(fraction), sourceProj, "EPSG:4326");
        }
    }

    var degrees2radians = Math.PI / 180;
    var radians2degrees = 180 / Math.PI;

    var lon1 = degrees2radians * c1[0];
    var lon2 = degrees2radians * c2[0];

    var lat1 = degrees2radians * c1[1];
    var lat2 = degrees2radians * c2[1];

    var a = Math.sin(lon2 - lon1) * Math.cos(lat2);
    var b = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);

    var atan = Math.atan2(a, b);

    var azimut = radians2degrees * atan;
    // logger.trace("azimut", azimut);

    if (azimut < 0) {
        azimut += 360;
    }
    var output = Math.round(azimut * 100) / 100 + " °";

    return output;
};

// ################################################################### //
// ####################### handlers events to dom #################### //
// ################################################################### //

/**
 * this method is called by event 'click' on picto
 *
 * @param {Object} e - HTMLElement
 * @private
 */
MeasureAzimuth.prototype.onShowMeasureAzimuthClick = function (e) {
    // logger.trace("call MeasureAzimuth::onShowMeasureAzimuthClick()", e);

    // appel de la methode commune
    this.onShowMeasureClick(e, "LineString");
};

/**
 * Handle pointer click.
 *
 * @param {ol.MapBrowserEvent} e - The event.
 * @private
 */
MeasureAzimuth.prototype.onPointerMoveAzimutHandler = function (e) {
    this.onPointerMoveHandler(e);

    if (this.sketch) {
        var geom = /** @type {ol.geom.LineString} */this.sketch.getGeometry();
        if (geom.getCoordinates().length > 2) {
            this.measureDraw.finishDrawing();
        }
    }
};

exports.default = MeasureAzimuth;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MeasureAzimuthDOM = {

    /**
    * Add uuid to the tag ID
    * @param {String} id - id selector
    * @returns {String} uid - id selector with an unique id
    */
    _addUID: function _addUID(id) {
        var uid = this._uid ? id + "-" + this._uid : id;
        return uid;
    },

    /**
     * Main container (DOM)
     *
     * @returns {DOMElement} DOM element
     */
    _createMainContainerElement: function _createMainContainerElement() {
        var container = document.createElement("div");
        container.id = this._addUID("GPmeasureAzimuth");
        container.className = "GPwidget";
        return container;
    },

    // ################################################################### //
    // ################### Methods of main container ##################### //
    // ################################################################### //

    /**
     * Hidden checkbox for minimizing/maximizing
     *
     * @returns {DOMElement} DOM element
     */
    _createShowMeasureAzimuthElement: function _createShowMeasureAzimuthElement() {
        var input = document.createElement("input");
        input.id = this._addUID("GPshowMeasureAzimuth");
        input.type = "checkbox";
        return input;
    },

    /**
     * Show control
     * see event !
     *
     * @returns {DOMElement} DOM element
     */
    _createShowMeasureAzimuthPictoElement: function _createShowMeasureAzimuthPictoElement() {
        // contexte d'execution
        var context = this;

        var label = document.createElement("label");
        label.id = this._addUID("GPshowMeasureAzimuthPicto");
        label.className = "GPshowAdvancedToolPicto";
        label.htmlFor = this._addUID("GPshowMeasureAzimuth");
        label.title = "Mesurer un azimut";

        // gestionnaire d'evenement :
        // on ouvre le menu de saisie...
        // L'ouverture/Fermeture permet de faire le menage
        // (reinitialisation)
        if (label.addEventListener) {
            label.addEventListener("click", function (e) {
                context.onShowMeasureAzimuthClick(e);
            });
        } else if (label.attachEvent) {
            label.attachEvent("onclick", function (e) {
                context.onShowMeasureAzimuthClick(e);
            });
        }

        var spanOpen = document.createElement("span");
        spanOpen.id = this._addUID("GPshowMeasureAzimuthOpen");
        spanOpen.className = "GPshowAdvancedToolOpen";
        label.appendChild(spanOpen);

        return label;
    }
};

exports.default = MeasureAzimuthDOM;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(64);

__webpack_require__(65);

__webpack_require__(66);

__webpack_require__(67);

__webpack_require__(68);

__webpack_require__(69);

__webpack_require__(70);

__webpack_require__(71);

__webpack_require__(72);

__webpack_require__(73);

__webpack_require__(74);

__webpack_require__(75);

__webpack_require__(76);

__webpack_require__(77);

__webpack_require__(78);

__webpack_require__(79);

__webpack_require__(80);

__webpack_require__(81);

__webpack_require__(82);

__webpack_require__(83);

__webpack_require__(84);

__webpack_require__(85);

__webpack_require__(86);

__webpack_require__(87);

__webpack_require__(88);

__webpack_require__(89);

__webpack_require__(90);

__webpack_require__(91);

__webpack_require__(92);

__webpack_require__(93);

__webpack_require__(94);

__webpack_require__(95);

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _gp = __webpack_require__(4);

var _gp2 = _interopRequireDefault(_gp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
    var scripts = document.getElementsByTagName("script");

    var key = scripts[scripts.length - 1].getAttribute("data-key");
    // in case of several keys
    if (key) {
        var splitKeys = key.split(/;|,|\|/);
        if (key && splitKeys.length > 1) {
            var keys = [];
            for (var i = 0; i < splitKeys.length; i++) {
                keys.push(splitKeys[i]);
            }
            key = keys;
        }
    }
    var url = scripts[scripts.length - 1].getAttribute("data-url");
    var timeout = scripts[scripts.length - 1].getAttribute("data-timeout");

    // callback
    var success = function success() {
        // Pas de messages en mode prod
        // // console.log("GetConfig success!");
    };

    // callback
    var error = function error(e) {
        throw new Error("Configuration load failed : " + e.message);
    };

    if (!key && !url) {
        // pas de message d'information !
        // // console.log("WARNING : parameters missing 'data-key' and 'data-url', the loading of configuration can not be done !");
        return;
    }

    var options = {
        apiKey: key,
        onSuccess: success,
        onFailure: error
    };

    if (url) {
        options.serverUrl = url;
        options.callbackSuffix = "";
    }

    if (timeout) {
        options.timeOut = timeout;
    }

    // test d'existance de la varibale globale Gp.Config
    if (!_gp2.default.Config) {
        // appel du service
        _gp2.default.Services.getConfig(options);
    }
})();

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = {"name":"geoportal-extensions","leafletExtName":"French Geoportal Extension for Leaflet","olExtName":"French Geoportal Extension for OpenLayers","itownsExtName":"French Geoportal Extension for Itowns","olItownsExtName":"French Geoportal Extension for OpenLayers & Itowns","version":"2.0.0","leafletExtVersion":"2.0.1","olExtVersion":"2.1.0","itownsExtVersion":"2.0.0","olItownsExtVersion":"2.0.1","description":"French Geoportal Extensions for OpenLayers, Leaflet and iTowns libraries","main":"dist/leaflet/GpPluginLeaflet.js, dist/openlayers/GpPluginOpenLayers.js, dist/itowns/GpPluginItowns.js, dist/mix/GpPluginOlItowns.js","directories":{},"scripts":{"setup":"npm install","clean":"echo \"Warning: target not yet implemented!\" && exit 0","test":"cd test && mocha-webpack --require setup.js --webpack-config webpack.test.js --glob \"test-*.js\" spec/Common/*/*","test:serve":"cd test && webpack-dev-server --hot --config webpack.test.serve.js","cover":"nyc --reporter=lcov --reporter=text npm run test","sample":"npm run sample:serve","sample:serve":"npm run sample:ol:serve","sample:itowns:serve":"webpack-dev-server --config webpack.config.itowns --open-page samples/index-itowns-src.html --contentBase . --port 9001 --open","sample:leaflet:serve":"webpack-dev-server --config webpack.config.leaflet --open-page samples/index-leaflet-src.html --contentBase . --port 9001 --open","sample:ol:serve":"webpack-dev-server --config webpack.config.openlayers --open-page samples/index-openlayers-src.html --contentBase . --port 9001 --open","doc":"npm run doc:serve","doc:serve":"npm run doc:ol:serve","doc:itowns:serve":"webpack-dev-server --config webpack.config.itowns --contentBase jsdoc/itowns --port 9001 --open","doc:leaflet:serve":"webpack-dev-server --config webpack.config.leaflet --contentBase jsdoc/leaflet --port 9001 --open","doc:ol:serve":"webpack-dev-server --config webpack.config.openlayers --contentBase jsdoc/openlayers --port 9001 --open","build:dev":"npm run build:ol:dev; npm run build:itowns:dev; npm run build:mix:dev; npm run build:leaflet:dev","build:prod":"npm run build:ol:prod; npm run build:itowns:prod; npm run build:mix:prod; npm run build:leaflet:prod","build":"npm run build:ol; npm run build:itowns; npm run build:mix; npm run build:leaflet","build:itowns:dev":"webpack --config webpack.config.itowns --env.development","build:itowns:prod":"webpack --config webpack.config.itowns --env.production","build:itowns":"webpack --config webpack.config.itowns","build:mix:dev":"webpack --config webpack.config.mix --env.development","build:mix:prod":"webpack --config webpack.config.mix --env.production","build:mix":"webpack --config webpack.config.mix","build:ol:dev":"webpack --config webpack.config.openlayers --env.development","build:ol:prod":"webpack --config webpack.config.openlayers --env.production","build:ol":"webpack --config webpack.config.openlayers","build:leaflet:dev":"webpack --config webpack.config.leaflet --env.development","build:leaflet:prod":"webpack --config webpack.config.leaflet --env.production","build:leaflet":"webpack --config webpack.config.leaflet"},"nyc":{"include":["src/**/*.js"],"instrument":false,"sourceMap":false},"repository":{"type":"git","url":"https://github.com/IGNF/geoportal-extensions.git"},"author":"IGNF","keywords":["geoportail","javascript","OpenLayers","Leaflet","Itowns","3D"],"license":"CECILL-B","bugs":{"url":"https://github.com/IGNF/geoportal-extensions/issues"},"homepage":"https://github.com/IGNF/geoportal-extensions#readme","dependencies":{"geoportal-access-lib":"2.1.0","itowns":"2.3.0","leaflet":"1.3.1","leaflet-draw":"1.0.2","loglevel":"~1.6.1","openlayers":"4.4.2","proj4":"2.4.4","proj4leaflet":"~1.0.2","sortablejs":"1.4.0","three":"~0.93.0","three.meshline":"~1.1.0"},"devDependencies":{"babel-core":"^6.26.0","babel-loader":"^7.1.2","babel-preset-env":"^1.6.1","chai":"^4.1.2","clean-webpack-plugin":"^0.1.19","copy-webpack-plugin":"^4.5.1","css-loader":"^0.28.10","eslint":"^4.18.2","eslint-config-standard":"^11.0.0","eslint-loader":"^2.0.0","eslint-plugin-import":"^2.9.0","eslint-plugin-node":"^6.0.1","eslint-plugin-promise":"^3.7.0","eslint-plugin-standard":"^3.0.1","expose-loader":"^0.7.4","extract-text-webpack-plugin":"^3.0.2","handlebars-layouts":"^3.1.4","handlebars-webpack-plugin":"^1.4.1","html-webpack-plugin":"^3.1.0","istanbul-instrumenter-loader":"^3.0.1","jsdoc-webpack-plugin":"0.0.1","jsdom":"^9.9.1","mocha":"^5.0.5","mocha-loader":"^1.1.3","mocha-webpack":"^1.1.0","nyc":"^12.0.2","path":"^0.12.7","replace-bundle-webpack-plugin":"^1.0.0","requirejs":"^2.3.5","speed-measure-webpack-plugin":"^1.2.2","string-template":"^1.0.0","style-loader":"^0.20.2","url-loader":"^1.0.1","webpack":"^3.11.0","webpack-dev-server":"^2.11.1","webpack-merge":"^4.1.2","webpack-node-externals":"^1.6.0"}}

/***/ })
/******/ ]);
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OlMap = undefined;

var _LoggerByDefault = __webpack_require__(4);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _IMap = __webpack_require__(3);

var _gp = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * OpenLayers IMap implementation class.
 *
 * @param {Object} opts - map options
 */
function OlMap(opts) {
    if (!(this instanceof OlMap)) {
        throw new TypeError("OlMap constructor cannot be called as a function.");
    }

    /**
     * Nom de la classe (heritage)
     */
    this.CLASSNAME = "OlMap";

    // appel du constructeur par heritage.
    _IMap.IMap.apply(this, arguments);

    this.logger = _LoggerByDefault2.default.getLogger("OlMap");
    // this.// logger.trace("[Constructeur OlMap (options)]");
};

// heritage
OlMap.prototype = Object.create(_IMap.IMap.prototype, {
    // todo
    // getter/setter
});

/*
 * Constructeur (alias)
 */
OlMap.prototype.constructor = OlMap;

/**
 * Empty Map initialization
 */
OlMap.prototype._initMap = function () {
    // this.// logger.trace("[OlMap] : _initMap");
    // creation de la view
    var view = new _gp.olExtended.View({
        // center : [center.x, center.y],
        enableRotation: this.mapOptions.enableRotation,
        zoom: this.mapOptions.zoom,
        minZoom: this.mapOptions.minZoom,
        maxZoom: this.mapOptions.maxZoom,
        projection: this.mapOptions.projection,
        rotation: this.mapOptions.azimuth * Math.PI / 180
    });

    // creation de la map vide
    this.libMap = new _gp.olExtended.Map({
        // interactions : interactions,
        target: this.div,
        view: view
        // controls : controls
    });

    this._afterInitMap();
};

/**
 * retourne la carte ol.Map
 * @return {Object} openlayers map
 */
OlMap.prototype.getLibMap = function () {
    return this.libMap;
};

exports.OlMap = OlMap;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IMap = undefined;

var _LoggerByDefault = __webpack_require__(4);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

var _openlayers = __webpack_require__(5);

var Ol = _interopRequireWildcard(_openlayers);

var _gp = __webpack_require__(0);

var _MapLoader = __webpack_require__(6);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Reloads the map with a new cartographic library. The current view options (camera position, layers, controls) will be conserved.
 * This function only works with the GpSDK3D bundle (run the "build:3d" npm task to generate it)
 *
 * @param {Integer} viewMode - The cartographic view mode. "2d" (for a 2D map) or "3d" (for a 3D map).
 *
 * @return {Object} the new map
 */
/* global __SWITCH2D3D_ALLOWED__ */

var switch2D3D = function switch2D3D(viewMode) {
    var oldMap = {};
    oldMap.projection = this.getProjection();
    oldMap.center = this.getCenter();
    oldMap.tilt = this.getTilt();
    oldMap.azimuth = this.getAzimuth();
    oldMap.zoom = this.getZoom();
    oldMap.layersOptions = this.getLayersOptions();
    oldMap.controlsOptions = this.getControlsOptions();
    oldMap.mapDiv = this.div.id;
    oldMap.apiKey = this.apiKey;
    oldMap.enginePath3d = this.mapOptions.enginePath3d || null;
    oldMap.enableRotation = this.mapOptions.enableRotation !== undefined ? this.mapOptions.enableRotation : null;

    // remove old controls and associated listeners
    for (var controlId in oldMap.controlsOptions) {
        this.removeControls(controlId);
    }
    if (viewMode === "3d") {
        // récupération des couches 3D qui n'étaient pas affichées en 2D
        if (this._3Dlayers) {
            for (var l = 0; l < this._3Dlayers.length; l++) {
                oldMap.layersOptions[this._3Dlayers[l].id] = this._3Dlayers[l].options;
            }
        }
        oldMap.center = [oldMap.center.x, oldMap.center.y];
        // transformation des coordonnées de planes en géographiques
        // FIXME : ne devrait pas se faire avec ol.proj mais avec proj4 car dans IMap, ol n'est pas forcement chargée !
        var lonlat = Ol.proj.transform(oldMap.center, oldMap.projection, "EPSG:4326");
        oldMap.center = {
            x: lonlat[0],
            y: lonlat[1]
        };
        oldMap.azimuth = this.getAzimuth();
        this.libMap.setTarget(null);
    } else if (viewMode === "2d") {
        oldMap.center = [oldMap.center.lon, oldMap.center.lat];
        // transformation des coordonnées de géographiques en planes
        // FIXME : ne devrait pas se faire avec ol.proj mais avec proj4 car dans IMap, ol n'est pas forcement chargée !
        var xy = Ol.proj.transform(oldMap.center, "EPSG:4326", "EPSG:3857");
        oldMap.center = {
            x: xy[0],
            y: xy[1]
        };
        // 1 - suppression de tous les listeners
        for (var listeners in this._events) {
            var keyIdx = 0;
            var eventName = Object.keys(this._events)[keyIdx];
            for (var i = 0; i < this._events[listeners].length; i++) {
                this.forget(eventName, this._events[listeners][i].action);
            }
            keyIdx++;
        }
        // 2 - suppression de la div
        while (this.div.firstChild) {
            this.div.removeChild(this.div.firstChild);
        }
    } else {
        // this.// logger.info("Unknown viewing mode");
        return;
    }
    // this.libMap = null;
    var newMap = _MapLoader.MapLoader.load(
    // FIXME faut-il rajouter un acces aux clés API directement dans Map getApiKeys()
    // this.libMap.getApiKeys(),
    // FIXME faut-il rajouter un acces à la div directement dans Map getDiv()
    // this.libMap.getDiv(),
    oldMap.mapDiv,
    // récupére le paramétrage courant de la carte (par les librairies) et pas le paramétrage initial (par this.mapOptions)
    {
        apiKey: oldMap.apiKey,
        enginePath3d: oldMap.enginePath3d,
        enableRotation: oldMap.enableRotation,
        projection: oldMap.projection,
        center: oldMap.center,
        azimuth: oldMap.azimuth,
        tilt: oldMap.tilt,
        zoom: oldMap.zoom,
        // maxZoom : this.
        // minZoom : this.
        // markerOptions :
        viewMode: viewMode,
        // proxyUrl
        // noProxyDomains
        // reloadConfig
        // autoconfUrl
        layersOptions: oldMap.layersOptions,
        controlsOptions: oldMap.controlsOptions
        // mapEventsOptions :
    });
    return newMap;
};

/**
 * Map Object. Returned by {@link module:Map Gp.Map.load()} function. Provides methods to interact with map view.
 *
 * @param {Object} opts - map options
 *
 * @namespace
 * @alias Gp.Map
 */
function IMap(opts) {
    if (!(this instanceof IMap)) {
        throw new TypeError("IMap constructor cannot be called as a function.");
    }

    // sauvegarde des options du constructeur.
    this._opts = opts;

    // logger
    this.logger = _LoggerByDefault2.default.getLogger("IMap");
    // this.// logger.trace("[Constructeur IMap (options)]");

    /**
     * Couches enregistrées par le SDK
     * Structure des objets stockés :
     * {
     *     id : layerId
     *     obj : objet couche géré par l'implémentation.
     *     options : propriétés de la couche (de type layerOptions)
     * }
     */
    this._layers = [];

    /**
     * Couches enregistrées par le SDK et supprimées
     * Structure des objets stockés :
     * {
     *     id : layerId
     *     obj : objet couche géré par l'implémentation.
     *     options : propriétés de la couche (de type layerOptions)
     * }
     */
    this._layersRemoved = [];

    /**
     * Controlss enregistrés par le SDK
     * Structure des objets stockés :
     * {
     *     id : controlId
     *     obj : objet control géré par l'implémentation.
     *     options : propriétés du controle (de type controlOptions)
     * }
     */
    this._controls = [];

    /**
     * object d'enriegistrements des evenements.
     * Les propriétés sont les identifiants de l'evenement associées à un tableau :
     * "eventId" : [{
     *      action : // function
     *      key : "clef retournée par OL pour l'enregistrement de l'evt"
     *      context : objet d'execution de l'action
     *  }]
     */
    this._events = {};

    if (this._opts.mapOptions) {
        this.apiKey = this._opts.mapOptions.apiKey;
    }
    this.div = this._opts.div;

    // récupère les options par défaut pour les paramètres optionnels
    // /!\ on duplique l'objet pour ne pas partager les mêmes options entre
    //     differentes cartes.
    this.mapOptions = Object.create(IMap.DEFAULTOPTIONS);

    // et on ajoute les options en paramètres aux options par défaut
    for (var opt in this._opts.mapOptions) {
        if (this._opts.mapOptions.hasOwnProperty(opt)) {
            this.mapOptions[opt] = this._opts.mapOptions[opt];
            // FIXME : ne marche qu'au premier niveau...
            // this.// logger.trace("option " + opt + " récupérée");
        }
    }

    // intialisation de la carte (à vide)
    this._initMap();

    if (false) {
        this.switch2D3D = switch2D3D.bind(this);
    }
};

/**
 * Options par défaut du service
 * (pour les options facultatives seulement)
 * @private
 */
IMap.DEFAULTOPTIONS = {
    projection: "EPSG:3857",
    center: {
        x: 0,
        y: 0,
        projection: "EPSG:4326",
        geolocate: false,
        location: null,
        locationType: ["StreetAddress", "PositionOfInterest"]
    },
    azimuth: 0,
    enableRotation: true,
    tilt: 0,
    zoom: 10,
    minZoom: 0,
    maxZoom: 21,
    reloadConfig: false,
    controlsOptions: {
        draggable: true,
        keyboard: true,
        selectable: true
    },
    mapEventsOptions: {},
    noProxyDomains: ["wxs.ign.fr"]
};

IMap.prototype = {

    /*
     * Constructeur (alias)
     */
    constructor: IMap,

    /**
     * Map initialisation with constructor parameters (after _initMap call)
     * needed for asynchronous _initMap implementation.
     *
     * @private
     */
    _afterInitMap: function _afterInitMap() {
        // abonnement aux evenements demandes
        var meOptions = this.mapOptions.mapEventsOptions;
        if (meOptions) {
            for (var evtId in meOptions) {
                this.listen(evtId, meOptions[evtId], this);
            }
        }

        // abonnement perso à l'evnement layerChanged pour tenir à jour l'objet this._layers
        this.listen("layerChanged", this._onLayerChanged, this);

        // centrage avec les coordonnées x, y (s'il y en a)
        this.setXYCenter(this.mapOptions.center);

        // FIXME Config est créé en runtime dans la variable globale Gp
        var scope = typeof window !== "undefined" ? window : {};
        var Config = scope.Gp ? scope.Gp.Config : undefined;

        // Gestion du paramètre apiKeys
        var needsGetConfig = false;
        if (this.apiKey || this._opts.mapOptions.configUrl || this._opts.mapOptions.autoconfUrl) {
            // une clef est fournie
            // on recharge l'autoconf si l'utilisateur l'a demandé
            // ou si aucun n'appel d'autoocnf n'a ete fait pour cette cle
            // TODO : this.apiKey.length > 1
            needsGetConfig = this._opts.reloadConfig || !Config || !Config.isConfLoaded(Array.isArray(this.apiKey) ? this.apiKey[0] : this.apiKey);
        } else {
            // une clef n'est pas fournie
            // on essaye de trouver une configuration existante
            if (Config) {
                this.apiKey = Object.keys(Config.generalOptions.apiKeys);
            }
        }

        // appel du service d'autoconfiguration si nécessaire
        // Dans tous les cas, le reste s'exécute dans _afterGetConfig
        if (needsGetConfig) {
            // autoconf locale ? on met par defaut un callbackSuffix à ""
            // à moins qu'on ne le surcharge (non documenté).
            var callbackSuffix = this._opts.mapOptions.callbackSuffix;
            // deprecated param autoconfUrl
            if (this._opts.mapOptions.configUrl || this._opts.mapOptions.autoconfUrl) {
                callbackSuffix = callbackSuffix || "";
            }
            var map = this;
            _gp.Services.getConfig({
                apiKey: this.apiKey,
                serverUrl: this._opts.mapOptions.configUrl || this._opts.mapOptions.autoconfUrl,
                callbackSuffix: callbackSuffix,
                // fonction de rappel onSuccess
                onSuccess: function onSuccess(configResponse) {
                    map._afterGetConfig(configResponse);
                },
                // fonction de rappel onSuccess
                onFailure: function onFailure(error) {
                    // this.// logger.info(error);
                    map._afterGetConfig(null);
                }
            });
        } else {
            this._afterGetConfig(Config);
        }
    },

    /**
     * callback d'appel à l'autoconf (ou non).
     *
     * @param {Object} configResponse - configuration associée à apiKey.
     * @private
     */
    _afterGetConfig: function _afterGetConfig(configResponse) {
        // this.// logger.trace("[IMap] : Autoconfiguration chargée ... ou pas");
        // TODO : detecter si on a le bon objet (error ou success)

        // declenchement de l'evenement "configured"
        var e = IMap.CustomEvent("configured", {
            detail: {
                config: configResponse
            }
        });
        this.div.dispatchEvent(e);

        // recuperation couche par defaut si aucune specifiee
        if (configResponse && !this.mapOptions.hasOwnProperty("layersOptions")) {
            // FIXME : trouver l'info dans l'autoconf ... ou pas ?
            this.mapOptions.layersOptions = {
                "ORTHOIMAGERY.ORTHOPHOTOS": {}
            };
        }

        // recuperation du centre par défaut si aucun spécifié
        if (configResponse && (!this.mapOptions.center.hasOwnProperty("x") || this.mapOptions.center.x === 0) && (!this.mapOptions.center.hasOwnProperty("y") || this.mapOptions.center.y === 0)) {
            var autoconfCenter;
            var territories = configResponse.getTerritories();
            for (var terrCode in territories) {
                if (territories[terrCode].isDefault) {
                    autoconfCenter = territories[terrCode].geoCenter;
                    // autoconfProj = territories[terrCode].defaultCRS;
                }
            }
            // this.// logger.trace("[IMap] : _afterGetConfig : setting default map center to (" + autoconfCenter.lon + ", " + autoconfCenter.lat + ")");
            this.mapOptions.center.x = autoconfCenter.lon;
            this.mapOptions.center.y = autoconfCenter.lat;
            this.mapOptions.center.projection = "EPSG:4326";
        }

        // Centrage de la carte avec les options demandées
        this.setCenter(this.mapOptions.center);

        // ajout des markers : TODO
        if (this.mapOptions.hasOwnProperty("markersOptions")) {
            this._addMarkers(this.mapOptions.markersOptions);
        }

        // ajout des couches
        this.addLayers(this.mapOptions.layersOptions);

        // ajout des controles
        // ... par defaut
        this.addControls(this._getDefaultControls());
        // ceux demandés par l'utilisateur
        this.addControls(this.mapOptions.controlsOptions);

        // declenchement de l'evenement "mapLoaded"
        var eMapLoaded = IMap.CustomEvent("mapLoaded", {
            detail: {
                map: this
            }
        });
        this.div.dispatchEvent(eMapLoaded);
    },

    /**
     * Empty Map initialization : abstract
     * Implementation has to call _afterInitMap() function.
     *
     * @private
     */
    _initMap: function _initMap() {
        // this.// logger.trace("[IMap] : _initMap");
    },

    /**
     * ajoute un proxy aux url des couches vecteurs si besoin.
     *
     * @param {String} url - url
     *
     * @return {String} proxified url
     *
     * @private
     */
    setProxy: function setProxy(url) {
        return _gp.ProxyUtils.proxifyUrl(url, this.mapOptions);
    },

    /**
     * Returns the current viewing mode (either 2D or 3d).
     *
     * @returns {String} - The current viewing mode
     * @private
     */
    getViewMode: function getViewMode() {
        return this.mapOptions.viewMode;
    },

    /**
     * Returns wrapped map object implemented by the underlying library. Can be :
     * - an [ol.Map](http://openlayers.org/en/latest/apidoc/ol.Map.html) object with current OpenLayers 3 implementation if the current map is in 2D.
     * - an [Itowns.GlobeView](https://www.itowns-project.org/itowns/API_Doc/GlobeView.html) object, ie the iTowns GlobeView object overloaded by Geoportal Extension for iTowns, if the current map is in 3D.
     *
     * @returns {Object} wrapped map object.
     */
    getLibMap: function getLibMap() {
        // TO BE OVERRIDDEN
        return {};
    }
};

exports.IMap = IMap;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMap = undefined;

var _IMapBase = __webpack_require__(2);

Object.defineProperty(exports, "IMap", {
  enumerable: true,
  get: function get() {
    return _IMapBase.IMap;
  }
});

__webpack_require__(17);

__webpack_require__(18);

__webpack_require__(19);

__webpack_require__(20);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loglevel = __webpack_require__(15);

var Log = _interopRequireWildcard(_loglevel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LoggerByDefault = {
    /**
     *logger statique
     * @param {String} [name="default"] - the logger name
     *
     * @returns {Object} logger
     */
    getLogger: function getLogger(name) {
        // Substitute global constants configured at compile time
        // cf. webpack.config.js
         false ? Log.disableAll() : Log.enableAll();
        var logname = name || "default";
        return Log.getLogger(logname);
    }
}; /* global __PRODUCTION__ */
exports.default = LoggerByDefault;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["ol"] = __webpack_require__(12);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MapLoader = undefined;

var _LoggerByDefault = __webpack_require__(4);

var _LoggerByDefault2 = _interopRequireDefault(_LoggerByDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Geoportal map loader.
 *
 * Provide convenience method to create a Map (instance of {@link Gp.Map}) and attach it to a HTML element.
 *
 * @module
 * @alias Gp.Map.load()
 */
var MapLoader = {
    /**
     * Initialize a Geoportal map in an HTML element.
     *
     * @method load
     * @static
     * @param {String | DOMElement} div - The HTML element or its id where the map will be loaded.
     * @param {Gp.MapOptions} [mapOptions] - Options for loading the map.
     * @example
     *      Gp.Map.load(
     *          'geoportalMap',
     *          {
     *              apiKey : "YOUR_API_KEY",
     *              center : {
     *                  location : "rue pasteur, Saint-Mandé"
     *              },
     *              zoom : 16,
     *              layersOptions : {
     *                  'GEOGRAPHICALGRIDSYSTEMS.MAPS.SCAN-EXPRESS.STANDARD' : {}
     *              }
     *          }
     *      );
     * @returns {Gp.Map} _ The Geoportal map.
     */
    load: function load(div, mapOptions) {
        var logger = _LoggerByDefault2.default.getLogger("MapLoader.load");

        // checking required parameter : div
        if (!div) {
            throw new Error("missing parameter div !");
        }
        if (typeof div === "string") {
            div = document.getElementById(div);
        }
        if (!div) {
            throw new Error("HTML element with id [" + div + "] not found.");
        }

        if (!mapOptions) {
            mapOptions = {};
        }

        // view mode by default
        if (!mapOptions.hasOwnProperty("viewMode")) {
            mapOptions.viewMode = "2d";
        }

        // auto detect lib. loaded
        var Map2d = null;
        var Map3d = null;

        if (this.__class2d !== null && typeof this.__class2d === "function") {
            Map2d = this.__class2d;
        }

        if (this.__class3d !== null && typeof this.__class3d === "function") {
            Map3d = this.__class3d;
        }

        // TODO => autres implementations

        // creating the library map instance
        var objMap = null;

        var viewMode = mapOptions.viewMode;
        switch (viewMode) {
            case "2d":
                // logger.trace("construction de la carte 2D");
                if (Map2d === null || typeof Map2d !== "function") {
                    throw new Error("library ol is not loaded !");
                }

                objMap = new Map2d({
                    div: div,
                    mapOptions: mapOptions
                });

                break;
            case "3d":
                // logger.trace("construction du globe 3D");
                if (Map3d === null || typeof Map3d !== "function") {
                    throw new Error("library itowns is not loaded !");
                }

                objMap = new Map3d({
                    div: div,
                    mapOptions: mapOptions
                });

                break;
            default:
                throw new Error("not supported view mode");
        }

        return objMap;
    }
};

exports.MapLoader = MapLoader;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(8);
__webpack_require__(9);
module.exports = __webpack_require__(10);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sdkDate = exports.sdkVersion = exports.Map = undefined;

var _gp = __webpack_require__(0);

Object.keys(_gp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _gp[key];
    }
  });
});

var _MapLoader = __webpack_require__(6);

var _OlMap = __webpack_require__(16);

__webpack_require__(25);

_MapLoader.MapLoader.__class2d = _OlMap.OlMap;
exports.Map = _MapLoader.MapLoader;
var sdkVersion = exports.sdkVersion = "2.0.1";
var sdkDate = exports.sdkDate = "2018-09-10";

/***/ }),
/* 11 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// OpenLayers. See https://openlayers.org/
// License: https://raw.githubusercontent.com/openlayers/openlayers/master/LICENSE.md
// Version: v4.4.2
;(function (root, factory) {
  if (true) {
    module.exports = factory();
  } else if (typeof define === "function" && define.amd) {
    define([], factory);
  } else {
    root.ol = factory();
  }
}(this, function () {
  var OPENLAYERS = {};
  var k,aa=this;function t(a,b){var c=OPENLAYERS;a=a.split(".");c=c||aa;a[0]in c||!c.execScript||c.execScript("var "+a[0]);for(var d;a.length&&(d=a.shift());)a.length||void 0===b?c[d]&&c[d]!==Object.prototype[d]?c=c[d]:c=c[d]={}:c[d]=b};var ba,da;function ea(a,b){return a>b?1:a<b?-1:0}function ha(a,b){return 0<=a.indexOf(b)}function ia(a,b,c){var d=a.length;if(a[0]<=b)return 0;if(!(b<=a[d-1]))if(0<c)for(c=1;c<d;++c){if(a[c]<b)return c-1}else if(0>c)for(c=1;c<d;++c){if(a[c]<=b)return c}else for(c=1;c<d;++c){if(a[c]==b)return c;if(a[c]<b)return a[c-1]-b<b-a[c]?c-1:c}return d-1}function ja(a,b){var c=Array.isArray(b)?b:[b],d=c.length;for(b=0;b<d;b++)a[a.length]=c[b]}
function ka(a,b){for(var c=a.length>>>0,d,e=0;e<c;e++)if(d=a[e],b(d,e,a))return d;return null}function ma(a,b){var c=a.length;if(c!==b.length)return!1;for(var d=0;d<c;d++)if(a[d]!==b[d])return!1;return!0}function na(a){var b=oa,c=a.length,d=Array(a.length),e;for(e=0;e<c;e++)d[e]={index:e,value:a[e]};d.sort(function(a,c){return b(a.value,c.value)||a.index-c.index});for(e=0;e<a.length;e++)a[e]=d[e].value}function pa(a,b){var c;return a.every(function(d,e){c=e;return!b(d,e,a)})?-1:c}
function qa(a,b){var c=b||ea;return a.every(function(b,e){if(0===e)return!0;b=c(a[e-1],b);return!(0<b||0===b)})};function v(a,b){a.prototype=Object.create(b.prototype);a.prototype.constructor=a}function sa(){}function w(a){return a.cp||(a.cp=++ta)}var ta=0;function ua(a){this.message="Assertion failed. See https://openlayers.org/en/v4.4.2/doc/errors/#"+a+" for details.";this.code=a;this.name="AssertionError"}v(ua,Error);function wa(a,b){if(!a)throw new ua(b);};function xa(a,b,c,d){this.ba=a;this.da=b;this.ea=c;this.ga=d}function ya(a,b,c,d,e){return void 0!==e?(e.ba=a,e.da=b,e.ea=c,e.ga=d,e):new xa(a,b,c,d)}function za(a,b,c){return a.ba<=b&&b<=a.da&&a.ea<=c&&c<=a.ga}function Aa(a,b){return a.ba==b.ba&&a.ea==b.ea&&a.da==b.da&&a.ga==b.ga}function Ba(a,b){return a.ba<=b.da&&a.da>=b.ba&&a.ea<=b.ga&&a.ga>=b.ea};function Da(a,b,c){return Math.min(Math.max(a,b),c)}var Ea=function(){var a;"cosh"in Math?a=Math.cosh:a=function(a){a=Math.exp(a);return(a+1/a)/2};return a}();function Fa(a){wa(0<a,29);return Math.pow(2,Math.ceil(Math.log(a)/Math.LN2))}function Ga(a,b,c,d,e,f){var g=e-c,h=f-d;if(0!==g||0!==h){var l=((a-c)*g+(b-d)*h)/(g*g+h*h);1<l?(c=e,d=f):0<l&&(c+=g*l,d+=h*l)}return Ha(a,b,c,d)}function Ha(a,b,c,d){a=c-a;b=d-b;return a*a+b*b}function Ia(a){return a*Math.PI/180}
function Ja(a,b){a%=b;return 0>a*b?a+b:a}function Ka(a,b,c){return a+c*(b-a)};function La(a,b,c){void 0===c&&(c=[0,0]);c[0]=a[0]+2*b;c[1]=a[1]+2*b;return c}function Ma(a,b,c){void 0===c&&(c=[0,0]);c[0]=a[0]*b+.5|0;c[1]=a[1]*b+.5|0;return c}function Na(a,b){if(Array.isArray(a))return a;void 0===b?b=[a,a]:b[0]=b[1]=a;return b};function Oa(a){for(var b=Pa(),c=0,d=a.length;c<d;++c)Qa(b,a[c]);return b}function Ra(a,b,c){return c?(c[0]=a[0]-b,c[1]=a[1]-b,c[2]=a[2]+b,c[3]=a[3]+b,c):[a[0]-b,a[1]-b,a[2]+b,a[3]+b]}function Sa(a,b){return b?(b[0]=a[0],b[1]=a[1],b[2]=a[2],b[3]=a[3],b):a.slice()}function Ta(a,b,c){b=b<a[0]?a[0]-b:a[2]<b?b-a[2]:0;a=c<a[1]?a[1]-c:a[3]<c?c-a[3]:0;return b*b+a*a}function Ua(a,b){return Va(a,b[0],b[1])}function Wa(a,b){return a[0]<=b[0]&&b[2]<=a[2]&&a[1]<=b[1]&&b[3]<=a[3]}
function Va(a,b,c){return a[0]<=b&&b<=a[2]&&a[1]<=c&&c<=a[3]}function Xa(a,b){var c=a[1],d=a[2],e=a[3],f=b[0];b=b[1];var g=0;f<a[0]?g|=16:f>d&&(g|=4);b<c?g|=8:b>e&&(g|=2);0===g&&(g=1);return g}function Pa(){return[Infinity,Infinity,-Infinity,-Infinity]}function Ya(a,b,c,d,e){return e?(e[0]=a,e[1]=b,e[2]=c,e[3]=d,e):[a,b,c,d]}function Za(a){return Ya(Infinity,Infinity,-Infinity,-Infinity,a)}function $a(a,b){var c=a[0];a=a[1];return Ya(c,a,c,a,b)}
function ab(a,b,c,d,e){e=Za(e);return bb(e,a,b,c,d)}function cb(a,b){return a[0]==b[0]&&a[2]==b[2]&&a[1]==b[1]&&a[3]==b[3]}function db(a,b){b[0]<a[0]&&(a[0]=b[0]);b[2]>a[2]&&(a[2]=b[2]);b[1]<a[1]&&(a[1]=b[1]);b[3]>a[3]&&(a[3]=b[3]);return a}function Qa(a,b){b[0]<a[0]&&(a[0]=b[0]);b[0]>a[2]&&(a[2]=b[0]);b[1]<a[1]&&(a[1]=b[1]);b[1]>a[3]&&(a[3]=b[1])}
function bb(a,b,c,d,e){for(;c<d;c+=e){var f=a,g=b[c],h=b[c+1];f[0]=Math.min(f[0],g);f[1]=Math.min(f[1],h);f[2]=Math.max(f[2],g);f[3]=Math.max(f[3],h)}return a}function eb(a,b,c){var d;return(d=b.call(c,fb(a)))||(d=b.call(c,gb(a)))||(d=b.call(c,hb(a)))?d:(d=b.call(c,ib(a)))?d:!1}function jb(a){var b=0;kb(a)||(b=lb(a)*mb(a));return b}function fb(a){return[a[0],a[1]]}function gb(a){return[a[2],a[1]]}function nb(a){return[(a[0]+a[2])/2,(a[1]+a[3])/2]}
function ob(a,b,c,d,e){var f=b*d[0]/2;d=b*d[1]/2;b=Math.cos(c);var g=Math.sin(c);c=f*b;f*=g;b*=d;var h=d*g,l=a[0],m=a[1];a=l-c+h;d=l-c-h;g=l+c-h;c=l+c+h;h=m-f-b;l=m-f+b;var n=m+f+b;f=m+f-b;return Ya(Math.min(a,d,g,c),Math.min(h,l,n,f),Math.max(a,d,g,c),Math.max(h,l,n,f),e)}function mb(a){return a[3]-a[1]}function pb(a,b,c){c=c?c:Pa();qb(a,b)&&(c[0]=a[0]>b[0]?a[0]:b[0],c[1]=a[1]>b[1]?a[1]:b[1],c[2]=a[2]<b[2]?a[2]:b[2],c[3]=a[3]<b[3]?a[3]:b[3]);return c}function ib(a){return[a[0],a[3]]}
function hb(a){return[a[2],a[3]]}function lb(a){return a[2]-a[0]}function qb(a,b){return a[0]<=b[2]&&a[2]>=b[0]&&a[1]<=b[3]&&a[3]>=b[1]}function kb(a){return a[2]<a[0]||a[3]<a[1]}function rb(a,b){var c=(a[2]-a[0])/2*(b-1);b=(a[3]-a[1])/2*(b-1);a[0]-=c;a[2]+=c;a[1]-=b;a[3]+=b}
function sb(a,b,c){a=[a[0],a[1],a[0],a[3],a[2],a[1],a[2],a[3]];b(a,a,2);var d=[a[0],a[2],a[4],a[6]],e=[a[1],a[3],a[5],a[7]];b=Math.min.apply(null,d);a=Math.min.apply(null,e);d=Math.max.apply(null,d);e=Math.max.apply(null,e);return Ya(b,a,d,e,c)};var tb="function"===typeof Object.assign?Object.assign:function(a,b){if(!a||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var c=Object(a),d=1,e=arguments.length;d<e;++d){var f=arguments[d];if(void 0!==f&&null!==f)for(var g in f)f.hasOwnProperty(g)&&(c[g]=f[g])}return c};function ub(a){for(var b in a)delete a[b]}function vb(a){var b=[],c;for(c in a)b.push(a[c]);return b}function wb(a){for(var b in a)return!1;return!b};/*

 Latitude/longitude spherical geodesy formulae taken from
 http://www.movable-type.co.uk/scripts/latlong.html
 Licensed under CC-BY-3.0.
*/
function xb(a){this.radius=a}xb.prototype.a=function(a){return yb(a,this.radius)};xb.prototype.b=function(a,b){return zb(a,b,this.radius)};xb.prototype.offset=function(a,b,c){var d=Ia(a[1]);b/=this.radius;var e=Math.asin(Math.sin(d)*Math.cos(b)+Math.cos(d)*Math.sin(b)*Math.cos(c));return[180*(Ia(a[0])+Math.atan2(Math.sin(c)*Math.sin(b)*Math.cos(d),Math.cos(b)-Math.sin(d)*Math.sin(e)))/Math.PI,180*e/Math.PI]};
function Ab(a,b){var c=b||{},d=c.radius||6371008.8;c=c.projection||"EPSG:3857";a=a.clone().hb(c,"EPSG:4326");var e=a.S();c=0;var f;switch(e){case "Point":case "MultiPoint":break;case "LineString":case "LinearRing":b=a.V();c=Bb(b,d);break;case "MultiLineString":case "Polygon":b=a.V();a=0;for(e=b.length;a<e;++a)c+=Bb(b[a],d);break;case "MultiPolygon":b=a.V();a=0;for(e=b.length;a<e;++a){var g=b[a];var h=0;for(f=g.length;h<f;++h)c+=Bb(g[h],d)}break;case "GeometryCollection":d=a.pd();a=0;for(e=d.length;a<
e;++a)c+=Ab(d[a],b);break;default:throw Error("Unsupported geometry type: "+e);}return c}function Bb(a,b){for(var c=0,d=0,e=a.length;d<e-1;++d)c+=zb(a[d],a[d+1],b);return c}function zb(a,b,c){var d=Ia(a[1]),e=Ia(b[1]),f=(e-d)/2;a=Ia(b[0]-a[0])/2;d=Math.sin(f)*Math.sin(f)+Math.sin(a)*Math.sin(a)*Math.cos(d)*Math.cos(e);return 2*c*Math.atan2(Math.sqrt(d),Math.sqrt(1-d))}
function Db(a,b){var c=b||{},d=c.radius||6371008.8;c=c.projection||"EPSG:3857";a=a.clone().hb(c,"EPSG:4326");var e=a.S();c=0;var f;switch(e){case "Point":case "MultiPoint":case "LineString":case "MultiLineString":case "LinearRing":break;case "Polygon":b=a.V();c=Math.abs(yb(b[0],d));a=1;for(e=b.length;a<e;++a)c-=Math.abs(yb(b[a],d));break;case "MultiPolygon":b=a.V();a=0;for(e=b.length;a<e;++a){var g=b[a];c+=Math.abs(yb(g[0],d));var h=1;for(f=g.length;h<f;++h)c-=Math.abs(yb(g[h],d))}break;case "GeometryCollection":d=
a.pd();a=0;for(e=d.length;a<e;++a)c+=Db(d[a],b);break;default:throw Error("Unsupported geometry type: "+e);}return c}function yb(a,b){for(var c=0,d=a.length,e=a[d-1][0],f=a[d-1][1],g=0;g<d;g++){var h=a[g][0],l=a[g][1];c+=Ia(h-e)*(2+Math.sin(Ia(f))+Math.sin(Ia(l)));e=h;f=l}return c*b*b/2};var Eb={};Eb.degrees=12741994*Math.PI/360;Eb.ft=.3048;Eb.m=1;Eb["us-ft"]=1200/3937;var Fb=null;function Gb(a){this.sb=a.code;this.a=a.units;this.i=void 0!==a.extent?a.extent:null;this.re=void 0!==a.worldExtent?a.worldExtent:null;this.b=void 0!==a.axisOrientation?a.axisOrientation:"enu";this.c=void 0!==a.global?a.global:!1;this.f=!(!this.c||!this.i);this.j=a.getPointResolution;this.g=null;this.l=a.metersPerUnit;var b=a.code,c=Fb||window.proj4;"function"==typeof c&&(b=c.defs(b),void 0!==b&&(void 0!==b.axis&&void 0===a.axisOrientation&&(this.b=b.axis),void 0===a.metersPerUnit&&(this.l=b.to_meter),
void 0===a.units&&(this.a=b.units)))}k=Gb.prototype;k.Tk=function(){return this.sb};k.G=function(){return this.i};k.eo=function(){return this.a};k.Rc=function(){return this.l||Eb[this.a]};k.Bl=function(){return this.re};k.mm=function(){return this.c};k.cq=function(a){this.c=a;this.f=!(!a||!this.i)};k.Pi=function(a){this.i=a;this.f=!(!this.c||!a)};k.Kj=function(a){this.re=a};k.bq=function(a){this.j=a};function Hb(a){Gb.call(this,{code:a,units:"m",extent:Ib,global:!0,worldExtent:Jb,getPointResolution:function(a,c){return a/Ea(c[1]/6378137)}})}v(Hb,Gb);var Kb=6378137*Math.PI,Ib=[-Kb,-Kb,Kb,Kb],Jb=[-180,-85,180,85],Lb=[new Hb("EPSG:3857"),new Hb("EPSG:102100"),new Hb("EPSG:102113"),new Hb("EPSG:900913"),new Hb("urn:ogc:def:crs:EPSG:6.18:3:3857"),new Hb("urn:ogc:def:crs:EPSG::3857"),new Hb("http://www.opengis.net/gml/srs/epsg.xml#3857")];
function Mb(a,b,c){var d=a.length;c=1<c?c:2;void 0===b&&(2<c?b=a.slice():b=Array(d));for(var e=0;e<d;e+=c){b[e]=Kb*a[e]/180;var f=6378137*Math.log(Math.tan(Math.PI*(a[e+1]+90)/360));f>Kb?f=Kb:f<-Kb&&(f=-Kb);b[e+1]=f}return b}function Nb(a,b,c){var d=a.length;c=1<c?c:2;void 0===b&&(2<c?b=a.slice():b=Array(d));for(var e=0;e<d;e+=c)b[e]=180*a[e]/Kb,b[e+1]=360*Math.atan(Math.exp(a[e+1]/6378137))/Math.PI-90;return b};function Ob(a,b){Gb.call(this,{code:a,units:"degrees",extent:Pb,axisOrientation:b,global:!0,metersPerUnit:Qb,worldExtent:Pb})}v(Ob,Gb);var Pb=[-180,-90,180,90],Qb=6378137*Math.PI/180,Rb=[new Ob("CRS:84"),new Ob("EPSG:4326","neu"),new Ob("urn:ogc:def:crs:EPSG::4326","neu"),new Ob("urn:ogc:def:crs:EPSG:6.6:4326","neu"),new Ob("urn:ogc:def:crs:OGC:1.3:CRS84"),new Ob("urn:ogc:def:crs:OGC:2:84"),new Ob("http://www.opengis.net/gml/srs/epsg.xml#4326","neu"),new Ob("urn:x-ogc:def:crs:EPSG:4326","neu")];var Sb={};var Tb={};function Ub(a,b,c){a=a.sb;b=b.sb;a in Tb||(Tb[a]={});Tb[a][b]=c}function Vb(a,b){var c;a in Tb&&b in Tb[a]&&(c=Tb[a][b]);return c};var Wb=new xb(6371008.8);function Yb(a,b,c,d){a=Zb(a);var e=a.j;e?b=e(b,c):"degrees"==a.a&&!d||"degrees"==d||(e=$b(a,Zb("EPSG:4326")),b=[c[0]-b/2,c[1],c[0]+b/2,c[1],c[0],c[1]-b/2,c[0],c[1]+b/2],b=e(b,b,2),b=(Wb.b(b.slice(0,2),b.slice(2,4))+Wb.b(b.slice(4,6),b.slice(6,8)))/2,a=d?Eb[d]:a.Rc(),void 0!==a&&(b/=a));return b}function ac(a){a.forEach(bc);a.forEach(function(b){a.forEach(function(a){b!==a&&Ub(b,a,cc)})})}
function dc(){Rb.forEach(function(a){Lb.forEach(function(b){Ub(a,b,Mb);Ub(b,a,Nb)})})}function bc(a){Sb[a.sb]=a;Ub(a,a,cc)}function ec(a){return a?"string"===typeof a?Zb(a):a:Zb("EPSG:3857")}function fc(a,b,c,d){a=Zb(a);b=Zb(b);Ub(a,b,gc(c));Ub(b,a,gc(d))}function gc(a){return function(b,c,d){var e=b.length;d=void 0!==d?d:2;c=void 0!==c?c:Array(e);var f;for(f=0;f<e;f+=d){var g=a([b[f],b[f+1]]);c[f]=g[0];c[f+1]=g[1];for(g=d-1;2<=g;--g)c[f+g]=b[f+g]}return c}}
function Zb(a){var b=null;if(a instanceof Gb)b=a;else if("string"===typeof a&&(b=Sb[a]||null,!b)){var c=Fb||window.proj4;"function"==typeof c&&void 0!==c.defs(a)&&(b=new Gb({code:a}),bc(b))}return b}function hc(a,b){if(a===b)return!0;var c=a.a===b.a;return a.sb===b.sb?c:$b(a,b)===cc&&c}function ic(a,b){a=Zb(a);b=Zb(b);return $b(a,b)}
function $b(a,b){var c=a.sb,d=b.sb,e=Vb(c,d);if(!e){var f=Fb||window.proj4;if("function"==typeof f){var g=f.defs(c),h=f.defs(d);void 0!==g&&void 0!==h&&(g===h?ac([b,a]):(e=f(d,c),fc(b,a,e.forward,e.inverse)),e=Vb(c,d))}}e||(e=jc);return e}function jc(a,b){if(void 0!==b&&a!==b){for(var c=0,d=a.length;c<d;++c)b[c]=a[c];a=b}return a}function cc(a,b){if(void 0!==b){for(var c=0,d=a.length;c<d;++c)b[c]=a[c];a=b}else a=a.slice();return a}function kc(a,b,c){return ic(b,c)(a,void 0,a.length)}
function lc(a,b,c){b=ic(b,c);return sb(a,b)}function mc(){ac(Lb);ac(Rb);dc()}mc();function oc(a,b,c,d){return void 0!==d?(d[0]=a,d[1]=b,d[2]=c,d):[a,b,c]}function pc(a){var b=a[0],c=Array(b),d=1<<b-1,e;for(e=0;e<b;++e){var f=48;a[1]&d&&(f+=1);a[2]&d&&(f+=2);c[e]=String.fromCharCode(f);d>>=1}return c.join("")};function qc(a){this.minZoom=void 0!==a.minZoom?a.minZoom:0;this.b=a.resolutions;wa(qa(this.b,function(a,b){return b-a}),17);if(!a.origins)for(var b=0,c=this.b.length-1;b<c;++b)if(!d)var d=this.b[b]/this.b[b+1];else if(this.b[b]/this.b[b+1]!==d){d=void 0;break}this.l=d;this.maxZoom=this.b.length-1;this.f=void 0!==a.origin?a.origin:null;this.c=null;void 0!==a.origins&&(this.c=a.origins,wa(this.c.length==this.b.length,20));d=a.extent;void 0===d||this.f||this.c||(this.f=ib(d));wa(!this.f&&this.c||this.f&&
!this.c,18);this.i=null;void 0!==a.tileSizes&&(this.i=a.tileSizes,wa(this.i.length==this.b.length,19));this.j=void 0!==a.tileSize?a.tileSize:this.i?null:256;wa(!this.j&&this.i||this.j&&!this.i,22);this.s=void 0!==d?d:null;this.a=null;this.g=[0,0];void 0!==a.sizes?this.a=a.sizes.map(function(a){return new xa(Math.min(0,a[0]),Math.max(a[0]-1,-1),Math.min(0,a[1]),Math.max(a[1]-1,-1))},this):d&&rc(this,d)}var sc=[0,0,0];k=qc.prototype;
k.Vf=function(a,b,c){a=tc(this,a,b);for(var d=a.ba,e=a.da;d<=e;++d)for(var f=a.ea,g=a.ga;f<=g;++f)c([b,d,f])};function uc(a,b,c,d,e){var f=null,g=b[0]-1;if(2===a.l){var h=b[1];var l=b[2]}else f=a.Ja(b,e);for(;g>=a.minZoom;){2===a.l?(h=Math.floor(h/2),l=Math.floor(l/2),b=ya(h,h,l,l,d)):b=tc(a,f,g,d);if(c.call(null,g,b))return!0;--g}return!1}k.G=function(){return this.s};k.gj=function(){return this.maxZoom};k.hj=function(){return this.minZoom};k.Cc=function(a){return this.f?this.f:this.c[a]};k.Qa=function(a){return this.b[a]};
k.ij=function(){return this.b};function vc(a,b,c,d){if(b[0]<a.maxZoom){if(2===a.l)return a=2*b[1],b=2*b[2],ya(a,a+1,b,b+1,c);d=a.Ja(b,d);return tc(a,d,b[0]+1,c)}return null}function wc(a,b,c){var d=a.Cc(b),e=a.Qa(b);a=Na(a.eb(b),a.g);return Ya(d[0]+c.ba*a[0]*e,d[1]+c.ea*a[1]*e,d[0]+(c.da+1)*a[0]*e,d[1]+(c.ga+1)*a[1]*e,void 0)}function tc(a,b,c,d){xc(a,b[0],b[1],c,!1,sc);var e=sc[1],f=sc[2];xc(a,b[2],b[3],c,!0,sc);return ya(e,sc[1],f,sc[2],d)}
function yc(a,b){var c=a.Cc(b[0]),d=a.Qa(b[0]);a=Na(a.eb(b[0]),a.g);return[c[0]+(b[1]+.5)*a[0]*d,c[1]+(b[2]+.5)*a[1]*d]}k.Ja=function(a,b){var c=this.Cc(a[0]),d=this.Qa(a[0]),e=Na(this.eb(a[0]),this.g),f=c[0]+a[1]*e[0]*d;a=c[1]+a[2]*e[1]*d;return Ya(f,a,f+e[0]*d,a+e[1]*d,b)};
k.Me=function(a,b,c){var d=a[0],e=a[1];a=this.xc(b);var f=b/this.Qa(a),g=this.Cc(a),h=Na(this.eb(a),this.g);d=f*Math.floor((d-g[0])/b+0)/h[0];b=f*Math.floor((e-g[1])/b+.5)/h[1];d=Math.floor(d);b=Math.floor(b);return oc(a,d,b,c)};function xc(a,b,c,d,e,f){var g=a.Cc(d),h=a.Qa(d);a=Na(a.eb(d),a.g);b=Math.floor((b-g[0])/h+(e?.5:0))/a[0];c=Math.floor((c-g[1])/h+(e?0:.5))/a[1];e?(b=Math.ceil(b)-1,c=Math.ceil(c)-1):(b=Math.floor(b),c=Math.floor(c));return oc(d,b,c,f)}
k.kg=function(a,b,c){return xc(this,a[0],a[1],b,!1,c)};k.eb=function(a){return this.j?this.j:this.i[a]};k.xc=function(a,b){return Da(ia(this.b,a,b||0),this.minZoom,this.maxZoom)};function rc(a,b){for(var c=a.b.length,d=Array(c),e=a.minZoom;e<c;++e)d[e]=tc(a,b,e);a.a=d};function zc(a){var b=a.g;b||(b=Ac(a),a.g=b);return b}function Bc(a){var b={};tb(b,a?a:{});void 0===b.extent&&(b.extent=Zb("EPSG:3857").G());b.resolutions=Cc(b.extent,b.maxZoom,b.tileSize);delete b.maxZoom;return new qc(b)}function Cc(a,b,c){b=void 0!==b?b:42;var d=mb(a);a=lb(a);c=Na(void 0!==c?c:256);c=Math.max(a/c[0],d/c[1]);b+=1;d=Array(b);for(a=0;a<b;++a)d[a]=c/Math.pow(2,a);return d}function Ac(a,b,c){a=Dc(a);b=Cc(a,b,c);return new qc({extent:a,origin:ib(a),resolutions:b,tileSize:c})}
function Dc(a){a=Zb(a);var b=a.G();b||(a=180*Eb.degrees/a.Rc(),b=Ya(-a,-a,a,a));return b};function Fc(a){this.b=a.html;this.a=a.tileRanges?a.tileRanges:null}Fc.prototype.f=function(){return this.b};function Gc(a){function b(b){var c=a.listener,e=a.zh||a.target;a.Bh&&Hc(a);return c.call(e,b)}return a.Ah=b}function Ic(a,b,c,d){for(var e,f=0,g=a.length;f<g;++f)if(e=a[f],e.listener===b&&e.zh===c)return d&&(e.deleteIndex=f),e}function Jc(a,b){return(a=a.kb)?a[b]:void 0}function Kc(a){var b=a.kb;b||(b=a.kb={});return b}
function Lc(a,b){var c=Jc(a,b);if(c){for(var d=0,e=c.length;d<e;++d)a.removeEventListener(b,c[d].Ah),ub(c[d]);c.length=0;if(c=a.kb)delete c[b],0===Object.keys(c).length&&delete a.kb}}function z(a,b,c,d,e){var f=Kc(a),g=f[b];g||(g=f[b]=[]);(f=Ic(g,c,d,!1))?e||(f.Bh=!1):(f={zh:d,Bh:!!e,listener:c,target:a,type:b},a.addEventListener(b,Gc(f)),g.push(f));return f}function Mc(a,b,c,d){return z(a,b,c,d,!0)}function Nc(a,b,c,d){(a=Jc(a,b))&&(c=Ic(a,c,d,!0))&&Hc(c)}
function Hc(a){if(a&&a.target){a.target.removeEventListener(a.type,a.Ah);var b=Jc(a.target,a.type);if(b){var c="deleteIndex"in a?a.deleteIndex:b.indexOf(a);-1!==c&&b.splice(c,1);0===b.length&&Lc(a.target,a.type)}ub(a)}}function Oc(a){var b=Kc(a),c;for(c in b)Lc(a,c)};function Pc(){}Pc.prototype.oc=!1;function Qc(a){a.oc||(a.oc=!0,a.ka())}Pc.prototype.ka=sa;function Rc(a){this.type=a;this.target=null}Rc.prototype.preventDefault=Rc.prototype.stopPropagation=function(){this.yp=!0};function Sc(a){a.stopPropagation()};function Tc(){this.Ua={};this.sa={};this.ra={}}v(Tc,Pc);Tc.prototype.addEventListener=function(a,b){var c=this.ra[a];c||(c=this.ra[a]=[]);-1===c.indexOf(b)&&c.push(b)};
Tc.prototype.b=function(a){var b="string"===typeof a?new Rc(a):a;a=b.type;b.target=this;var c=this.ra[a];if(c){a in this.sa||(this.sa[a]=0,this.Ua[a]=0);++this.sa[a];for(var d=0,e=c.length;d<e;++d)if(!1===c[d].call(this,b)||b.yp){var f=!1;break}--this.sa[a];if(0===this.sa[a]){b=this.Ua[a];for(delete this.Ua[a];b--;)this.removeEventListener(a,sa);delete this.sa[a]}return f}};Tc.prototype.ka=function(){Oc(this)};function Uc(a,b){return b?b in a.ra:0<Object.keys(a.ra).length}
Tc.prototype.removeEventListener=function(a,b){var c=this.ra[a];c&&(b=c.indexOf(b),a in this.Ua?(c[b]=sa,++this.Ua[a]):(c.splice(b,1),0===c.length&&delete this.ra[a]))};function Vc(){Tc.call(this);this.f=0}v(Vc,Tc);k=Vc.prototype;k.u=function(){++this.f;this.b("change")};k.L=function(){return this.f};k.J=function(a,b,c){if(Array.isArray(a)){for(var d=a.length,e=Array(d),f=0;f<d;++f)e[f]=z(this,a[f],b,c);return e}return z(this,a,b,c)};k.once=function(a,b,c){if(Array.isArray(a)){for(var d=a.length,e=Array(d),f=0;f<d;++f)e[f]=Mc(this,a[f],b,c);return e}return Mc(this,a,b,c)};
k.K=function(a,b,c){if(Array.isArray(a))for(var d=0,e=a.length;d<e;++d)Nc(this,a[d],b,c);else Nc(this,a,b,c)};function Wc(a){Vc.call(this);w(this);this.O={};void 0!==a&&this.H(a)}v(Wc,Vc);var Xc={};function Yc(a){return Xc.hasOwnProperty(a)?Xc[a]:Xc[a]="change:"+a}k=Wc.prototype;k.get=function(a){var b;this.O.hasOwnProperty(a)&&(b=this.O[a]);return b};k.P=function(){return Object.keys(this.O)};k.M=function(){return tb({},this.O)};function Zc(a,b,c){var d=Yc(b);a.b(new $c(d,b,c));a.b(new $c("propertychange",b,c))}k.set=function(a,b,c){c?this.O[a]=b:(c=this.O[a],this.O[a]=b,c!==b&&Zc(this,a,c))};
k.H=function(a,b){for(var c in a)this.set(c,a[c],b)};k.R=function(a,b){if(a in this.O){var c=this.O[a];delete this.O[a];b||Zc(this,a,c)}};function $c(a,b,c){Rc.call(this,a);this.key=b;this.oldValue=c}v($c,Rc);function C(a,b){Wc.call(this);this.c=!!(b||{}).unique;this.a=a?a:[];if(this.c)for(a=0,b=this.a.length;a<b;++a)ad(this,this.a[a],a);bd(this)}v(C,Wc);k=C.prototype;k.clear=function(){for(;0<this.gc();)this.pop()};k.pg=function(a){var b;var c=0;for(b=a.length;c<b;++c)this.push(a[c]);return this};k.forEach=function(a,b){a=b?a.bind(b):a;b=this.a;for(var c=0,d=b.length;c<d;++c)a(b[c],c,b)};k.Dm=function(){return this.a};k.item=function(a){return this.a[a]};k.gc=function(){return this.get(cd)};
k.Se=function(a,b){this.c&&ad(this,b);this.a.splice(a,0,b);bd(this);this.b(new dd("add",b))};k.pop=function(){return this.Ug(this.gc()-1)};k.push=function(a){this.c&&ad(this,a);var b=this.gc();this.Se(b,a);return this.gc()};k.remove=function(a){var b=this.a,c;var d=0;for(c=b.length;d<c;++d)if(b[d]===a)return this.Ug(d)};k.Ug=function(a){var b=this.a[a];this.a.splice(a,1);bd(this);this.b(new dd("remove",b));return b};
k.Yp=function(a,b){var c=this.gc();if(a<c)this.c&&ad(this,b,a),c=this.a[a],this.a[a]=b,this.b(new dd("remove",c)),this.b(new dd("add",b));else{for(;c<a;++c)this.Se(c,void 0);this.Se(a,b)}};function bd(a){a.set(cd,a.a.length)}function ad(a,b,c){for(var d=0,e=a.a.length;d<e;++d)if(a.a[d]===b&&d!==c)throw new ua(58);}var cd="length";function dd(a,b){Rc.call(this,a);this.element=b}v(dd,Rc);function ed(a,b,c){Rc.call(this,a);this.map=b;this.frameState=void 0!==c?c:null}v(ed,Rc);function fd(a,b,c,d,e){ed.call(this,a,b,e);this.originalEvent=c;this.pixel=b.od(c);this.coordinate=b.Na(this.pixel);this.dragging=void 0!==d?d:!1}v(fd,ed);fd.prototype.preventDefault=function(){ed.prototype.preventDefault.call(this);this.originalEvent.preventDefault()};fd.prototype.stopPropagation=function(){ed.prototype.stopPropagation.call(this);this.originalEvent.stopPropagation()};var gd=["experimental-webgl","webgl","webkit-3d","moz-webgl"];function hd(a,b){var c,d,e=gd.length;for(d=0;d<e;++d)try{if(c=a.getContext(gd[d],b))return c}catch(f){}return null};var id,jd="undefined"!==typeof navigator?navigator.userAgent.toLowerCase():"",kd=-1!==jd.indexOf("firefox"),ld=-1!==jd.indexOf("safari")&&-1==jd.indexOf("chrom"),nd=-1!==jd.indexOf("webkit")&&-1==jd.indexOf("edge"),od=-1!==jd.indexOf("macintosh"),pd=window.devicePixelRatio||1,qd=!1,rd=function(){if(!("HTMLCanvasElement"in window))return!1;try{var a=document.createElement("CANVAS").getContext("2d");return a?(void 0!==a.setLineDash&&(qd=!0),!0):!1}catch(b){return!1}}(),sd="DeviceOrientationEvent"in
window,td="geolocation"in navigator,ud="ontouchstart"in window,vd="PointerEvent"in window,wd=!!navigator.msPointerEnabled,yd=!1,zd,Ad=[];if("WebGLRenderingContext"in window)try{var Bd=hd(document.createElement("CANVAS"),{failIfMajorPerformanceCaveat:!0});Bd&&(yd=!0,zd=Bd.getParameter(Bd.MAX_TEXTURE_SIZE),Ad=Bd.getSupportedExtensions())}catch(a){}id=yd;da=Ad;ba=zd;var Cd={Lq:"singleclick",Aq:"click",Bq:"dblclick",Eq:"pointerdrag",Hq:"pointermove",Dq:"pointerdown",Kq:"pointerup",Jq:"pointerover",Iq:"pointerout",Fq:"pointerenter",Gq:"pointerleave",Cq:"pointercancel"};function Dd(a,b,c,d,e){fd.call(this,a,b,c.b,d,e);this.b=c}v(Dd,fd);function Ed(a,b){this.b=a;this.i=b};function Fd(a){Ed.call(this,a,{mousedown:this.pm,mousemove:this.qm,mouseup:this.tm,mouseover:this.sm,mouseout:this.rm});this.a=a.f;this.f=[]}v(Fd,Ed);function Gd(a,b){a=a.f;var c=b.clientX;b=b.clientY;for(var d=0,e=a.length,f;d<e&&(f=a[d]);d++){var g=Math.abs(b-f[1]);if(25>=Math.abs(c-f[0])&&25>=g)return!0}return!1}function Hd(a){var b=Id(a,a),c=b.preventDefault;b.preventDefault=function(){a.preventDefault();c()};b.pointerId=1;b.isPrimary=!0;b.pointerType="mouse";return b}k=Fd.prototype;
k.pm=function(a){if(!Gd(this,a)){(1).toString()in this.a&&this.cancel(a);var b=Hd(a);this.a[(1).toString()]=a;Jd(this.b,"pointerdown",b,a)}};k.qm=function(a){if(!Gd(this,a)){var b=Hd(a);Jd(this.b,"pointermove",b,a)}};k.tm=function(a){if(!Gd(this,a)){var b=this.a[(1).toString()];b&&b.button===a.button&&(b=Hd(a),Jd(this.b,"pointerup",b,a),delete this.a[(1).toString()])}};k.sm=function(a){if(!Gd(this,a)){var b=Hd(a);Kd(this.b,b,a)}};k.rm=function(a){if(!Gd(this,a)){var b=Hd(a);Ld(this.b,b,a)}};
k.cancel=function(a){var b=Hd(a);this.b.cancel(b,a);delete this.a[(1).toString()]};function Md(a){Ed.call(this,a,{MSPointerDown:this.ym,MSPointerMove:this.zm,MSPointerUp:this.Cm,MSPointerOut:this.Am,MSPointerOver:this.Bm,MSPointerCancel:this.xm,MSGotPointerCapture:this.vm,MSLostPointerCapture:this.wm});this.a=a.f;this.f=["","unavailable","touch","pen","mouse"]}v(Md,Ed);function Nd(a,b){var c=b;"number"===typeof b.pointerType&&(c=Id(b,b),c.pointerType=a.f[b.pointerType]);return c}k=Md.prototype;
k.ym=function(a){this.a[a.pointerId.toString()]=a;var b=Nd(this,a);Jd(this.b,"pointerdown",b,a)};k.zm=function(a){var b=Nd(this,a);Jd(this.b,"pointermove",b,a)};k.Cm=function(a){var b=Nd(this,a);Jd(this.b,"pointerup",b,a);delete this.a[a.pointerId.toString()]};k.Am=function(a){var b=Nd(this,a);Ld(this.b,b,a)};k.Bm=function(a){var b=Nd(this,a);Kd(this.b,b,a)};k.xm=function(a){var b=Nd(this,a);this.b.cancel(b,a);delete this.a[a.pointerId.toString()]};
k.wm=function(a){this.b.b(new Od("lostpointercapture",a,a))};k.vm=function(a){this.b.b(new Od("gotpointercapture",a,a))};function Pd(a){Ed.call(this,a,{pointerdown:this.qp,pointermove:this.rp,pointerup:this.up,pointerout:this.sp,pointerover:this.tp,pointercancel:this.pp,gotpointercapture:this.Cl,lostpointercapture:this.nm})}v(Pd,Ed);k=Pd.prototype;k.qp=function(a){Qd(this.b,a)};k.rp=function(a){Qd(this.b,a)};k.up=function(a){Qd(this.b,a)};k.sp=function(a){Qd(this.b,a)};k.tp=function(a){Qd(this.b,a)};k.pp=function(a){Qd(this.b,a)};k.nm=function(a){Qd(this.b,a)};k.Cl=function(a){Qd(this.b,a)};function Od(a,b,c){Rc.call(this,a);this.b=b;a=c?c:{};this.buttons=Rd(a);this.pressure=Sd(a,this.buttons);this.bubbles="bubbles"in a?a.bubbles:!1;this.cancelable="cancelable"in a?a.cancelable:!1;this.view="view"in a?a.view:null;this.detail="detail"in a?a.detail:null;this.screenX="screenX"in a?a.screenX:0;this.screenY="screenY"in a?a.screenY:0;this.clientX="clientX"in a?a.clientX:0;this.clientY="clientY"in a?a.clientY:0;this.ctrlKey="ctrlKey"in a?a.ctrlKey:!1;this.altKey="altKey"in a?a.altKey:!1;this.shiftKey=
"shiftKey"in a?a.shiftKey:!1;this.metaKey="metaKey"in a?a.metaKey:!1;this.button="button"in a?a.button:0;this.relatedTarget="relatedTarget"in a?a.relatedTarget:null;this.pointerId="pointerId"in a?a.pointerId:0;this.width="width"in a?a.width:0;this.height="height"in a?a.height:0;this.tiltX="tiltX"in a?a.tiltX:0;this.tiltY="tiltY"in a?a.tiltY:0;this.pointerType="pointerType"in a?a.pointerType:"";this.isPrimary="isPrimary"in a?a.isPrimary:!1;b.preventDefault&&(this.preventDefault=function(){b.preventDefault()})}
v(Od,Rc);function Rd(a){if(a.buttons||Td)a=a.buttons;else switch(a.which){case 1:a=1;break;case 2:a=4;break;case 3:a=2;break;default:a=0}return a}function Sd(a,b){var c=0;a.pressure?c=a.pressure:c=b?.5:0;return c}var Td=!1;try{Td=1===(new MouseEvent("click",{buttons:1})).buttons}catch(a){};function Ud(a,b){Ed.call(this,a,{touchstart:this.uq,touchmove:this.tq,touchend:this.sq,touchcancel:this.rq});this.a=a.f;this.j=b;this.f=void 0;this.g=0;this.c=void 0}v(Ud,Ed);k=Ud.prototype;k.wj=function(){this.g=0;this.c=void 0};
function Vd(a,b,c){b=Id(b,c);b.pointerId=c.identifier+2;b.bubbles=!0;b.cancelable=!0;b.detail=a.g;b.button=0;b.buttons=1;b.width=c.webkitRadiusX||c.radiusX||0;b.height=c.webkitRadiusY||c.radiusY||0;b.pressure=c.webkitForce||c.force||.5;b.isPrimary=a.f===c.identifier;b.pointerType="touch";b.clientX=c.clientX;b.clientY=c.clientY;b.screenX=c.screenX;b.screenY=c.screenY;return b}
function Wd(a,b,c){function d(){b.preventDefault()}var e=Array.prototype.slice.call(b.changedTouches),f=e.length,g;for(g=0;g<f;++g){var h=Vd(a,b,e[g]);h.preventDefault=d;c.call(a,b,h)}}
k.uq=function(a){var b=a.touches,c=Object.keys(this.a),d=c.length;if(d>=b.length){var e=[],f;for(f=0;f<d;++f){var g=c[f];var h=this.a[g];var l;if(!(l=1==g))a:{for(var m=b.length,n=0;n<m;n++)if(l=b[n],l.identifier===g-2){l=!0;break a}l=!1}l||e.push(h.out)}for(f=0;f<e.length;++f)this.Of(a,e[f])}b=a.changedTouches[0];c=Object.keys(this.a).length;if(0===c||1===c&&(1).toString()in this.a)this.f=b.identifier,void 0!==this.c&&clearTimeout(this.c);Xd(this,a);this.g++;Wd(this,a,this.lp)};
k.lp=function(a,b){this.a[b.pointerId]={target:b.target,out:b,jj:b.target};var c=this.b;b.bubbles=!0;Jd(c,"pointerover",b,a);c=this.b;b.bubbles=!1;Jd(c,"pointerenter",b,a);Jd(this.b,"pointerdown",b,a)};k.tq=function(a){a.preventDefault();Wd(this,a,this.um)};
k.um=function(a,b){var c=this.a[b.pointerId];if(c){var d=c.out,e=c.jj;Jd(this.b,"pointermove",b,a);d&&e!==b.target&&(d.relatedTarget=b.target,b.relatedTarget=e,d.target=e,b.target?(Ld(this.b,d,a),Kd(this.b,b,a)):(b.target=e,b.relatedTarget=null,this.Of(a,b)));c.out=b;c.jj=b.target}};k.sq=function(a){Xd(this,a);Wd(this,a,this.vq)};
k.vq=function(a,b){Jd(this.b,"pointerup",b,a);this.b.out(b,a);Yd(this.b,b,a);delete this.a[b.pointerId];b.isPrimary&&(this.f=void 0,this.c=setTimeout(this.wj.bind(this),200))};k.rq=function(a){Wd(this,a,this.Of)};k.Of=function(a,b){this.b.cancel(b,a);this.b.out(b,a);Yd(this.b,b,a);delete this.a[b.pointerId];b.isPrimary&&(this.f=void 0,this.c=setTimeout(this.wj.bind(this),200))};
function Xd(a,b){var c=a.j.f;b=b.changedTouches[0];if(a.f===b.identifier){var d=[b.clientX,b.clientY];c.push(d);setTimeout(function(){var a=c.indexOf(d);-1<a&&c.splice(a,1)},2500)}};function Zd(a){Tc.call(this);this.g=a;this.f={};this.i={};this.a=[];vd?$d(this,new Pd(this)):wd?$d(this,new Md(this)):(a=new Fd(this),$d(this,a),ud&&$d(this,new Ud(this,a)));a=this.a.length;for(var b,c=0;c<a;c++)b=this.a[c],ae(this,Object.keys(b.i))}v(Zd,Tc);function $d(a,b){var c=Object.keys(b.i);c&&(c.forEach(function(a){var c=b.i[a];c&&(this.i[a]=c.bind(b))},a),a.a.push(b))}Zd.prototype.c=function(a){var b=this.i[a.type];b&&b(a)};
function ae(a,b){b.forEach(function(a){z(this.g,a,this.c,this)},a)}function be(a,b){b.forEach(function(a){Nc(this.g,a,this.c,this)},a)}function Id(a,b){for(var c={},d,e=0,f=ce.length;e<f;e++)d=ce[e][0],c[d]=a[d]||b[d]||ce[e][1];return c}function Yd(a,b,c){b.bubbles=!1;Jd(a,"pointerleave",b,c)}Zd.prototype.out=function(a,b){a.bubbles=!0;Jd(this,"pointerout",a,b)};Zd.prototype.cancel=function(a,b){Jd(this,"pointercancel",a,b)};
function Ld(a,b,c){a.out(b,c);var d=b.target,e=b.relatedTarget;d&&e&&d.contains(e)||Yd(a,b,c)}function Kd(a,b,c){b.bubbles=!0;Jd(a,"pointerover",b,c);var d=b.target,e=b.relatedTarget;d&&e&&d.contains(e)||(b.bubbles=!1,Jd(a,"pointerenter",b,c))}function Jd(a,b,c,d){a.b(new Od(b,d,c))}function Qd(a,b){a.b(new Od(b.type,b,b))}Zd.prototype.ka=function(){for(var a=this.a.length,b,c=0;c<a;c++)b=this.a[c],be(this,Object.keys(b.i));Tc.prototype.ka.call(this)};
var ce=[["bubbles",!1],["cancelable",!1],["view",null],["detail",null],["screenX",0],["screenY",0],["clientX",0],["clientY",0],["ctrlKey",!1],["altKey",!1],["shiftKey",!1],["metaKey",!1],["button",0],["relatedTarget",null],["buttons",0],["pointerId",0],["width",0],["height",0],["pressure",0],["tiltX",0],["tiltY",0],["pointerType",""],["hwTimestamp",0],["isPrimary",!1],["type",""],["target",null],["currentTarget",null],["which",0]];function de(a,b){Tc.call(this);this.f=a;this.j=0;this.l=!1;this.i=[];this.C=b?b*pd:pd;this.c=null;a=this.f.a;this.O=0;this.s={};this.g=new Zd(a);this.a=null;this.o=z(this.g,"pointerdown",this.Wl,this);this.v=z(this.g,"pointermove",this.Tp,this)}v(de,Tc);function ee(a,b){var c=new Dd("click",a.f,b);a.b(c);0!==a.j?(clearTimeout(a.j),a.j=0,c=new Dd("dblclick",a.f,b),a.b(c)):a.j=setTimeout(function(){this.j=0;var a=new Dd("singleclick",this.f,b);this.b(a)}.bind(a),250)}
function fe(a,b){"pointerup"==b.type||"pointercancel"==b.type?delete a.s[b.pointerId]:"pointerdown"==b.type&&(a.s[b.pointerId]=!0);a.O=Object.keys(a.s).length}k=de.prototype;k.$h=function(a){fe(this,a);var b=new Dd("pointerup",this.f,a);this.b(b);!this.l&&0===a.button&&ee(this,this.c);0===this.O&&(this.i.forEach(Hc),this.i.length=0,this.l=!1,this.c=null,Qc(this.a),this.a=null)};
k.Wl=function(a){fe(this,a);var b=new Dd("pointerdown",this.f,a);this.b(b);this.c=a;0===this.i.length&&(this.a=new Zd(document),this.i.push(z(this.a,"pointermove",this.Sm,this),z(this.a,"pointerup",this.$h,this),z(this.g,"pointercancel",this.$h,this)))};k.Sm=function(a){if(ge(this,a)){this.l=!0;var b=new Dd("pointerdrag",this.f,a,this.l);this.b(b)}a.preventDefault()};k.Tp=function(a){this.b(new Dd(a.type,this.f,a,!(!this.c||!ge(this,a))))};
function ge(a,b){return Math.abs(b.clientX-a.c.clientX)>a.C||Math.abs(b.clientY-a.c.clientY)>a.C}k.ka=function(){this.v&&(Hc(this.v),this.v=null);this.o&&(Hc(this.o),this.o=null);this.i.forEach(Hc);this.i.length=0;this.a&&(Qc(this.a),this.a=null);this.g&&(Qc(this.g),this.g=null);Tc.prototype.ka.call(this)};function he(a,b){this.o=a;this.c=b;this.b=[];this.f=[];this.a={}}he.prototype.clear=function(){this.b.length=0;this.f.length=0;ub(this.a)};function ie(a){var b=a.b,c=a.f,d=b[0];1==b.length?(b.length=0,c.length=0):(b[0]=b.pop(),c[0]=c.pop(),je(a,0));b=a.c(d);delete a.a[b];return d}he.prototype.i=function(a){wa(!(this.c(a)in this.a),31);var b=this.o(a);return Infinity!=b?(this.b.push(a),this.f.push(b),this.a[this.c(a)]=!0,ke(this,0,this.b.length-1),!0):!1};
function je(a,b){for(var c=a.b,d=a.f,e=c.length,f=c[b],g=d[b],h=b;b<e>>1;){var l=2*b+1,m=2*b+2;l=m<e&&d[m]<d[l]?m:l;c[b]=c[l];d[b]=d[l];b=l}c[b]=f;d[b]=g;ke(a,h,b)}function ke(a,b,c){var d=a.b;a=a.f;for(var e=d[c],f=a[c];c>b;){var g=c-1>>1;if(a[g]>f)d[c]=d[g],a[c]=a[g],c=g;else break}d[c]=e;a[c]=f}
function le(a){var b=a.o,c=a.b,d=a.f,e=0,f=c.length,g;for(g=0;g<f;++g){var h=c[g];var l=b(h);Infinity==l?delete a.a[a.c(h)]:(d[e]=l,c[e++]=h)}c.length=e;d.length=e;for(b=(a.b.length>>1)-1;0<=b;b--)je(a,b)};function me(a,b){he.call(this,function(b){return a.apply(null,b)},function(a){return a[0].gb()});this.v=b;this.j=0;this.g={}}v(me,he);me.prototype.i=function(a){var b=he.prototype.i.call(this,a);b&&z(a[0],"change",this.l,this);return b};me.prototype.l=function(a){a=a.target;var b=a.getState();if(2===b||3===b||4===b||5===b)Nc(a,"change",this.l,this),a=a.gb(),a in this.g&&(delete this.g[a],--this.j),this.v()};
function ne(a,b,c){for(var d=0,e=!1,f,g,h;a.j<b&&d<c&&0<a.b.length;)g=ie(a)[0],h=g.gb(),f=g.getState(),5===f?e=!0:0!==f||h in a.g||(a.g[h]=!0,++a.j,++d,g.load());0===d&&e&&a.v()};function oe(a){return function(b){if(b)return[Da(b[0],a[0],a[2]),Da(b[1],a[1],a[3])]}}function pe(a){return a};function qe(a){return function(b,c,d){if(void 0!==b)return b=ia(a,b,d),b=Da(b+c,0,a.length-1),c=Math.floor(b),b!=c&&c<a.length-1?a[c]/Math.pow(a[c]/a[c+1],b-c):a[c]}}function re(a,b,c){return function(d,e,f){if(void 0!==d)return d=Math.max(Math.floor(Math.log(b/d)/Math.log(a)+(-f/2+.5))+e,0),void 0!==c&&(d=Math.min(d,c)),b/Math.pow(a,d)}};function se(a){if(void 0!==a)return 0}function te(a,b){if(void 0!==a)return a+b}function ue(a){var b=2*Math.PI/a;return function(a,d){if(void 0!==a)return a=Math.floor((a+d)/b+.5)*b}}function ve(){var a=Ia(5);return function(b,c){if(void 0!==b)return Math.abs(b+c)<=a?0:b+c}};function we(a,b){a=void 0!==b?a.toFixed(b):""+a;b=a.indexOf(".");b=-1===b?a.length:b;return 2<b?a:Array(3-b).join("0")+a}function xe(a){a=(""+a).split(".");for(var b=["1","3"],c=0;c<Math.max(a.length,b.length);c++){var d=parseInt(a[c]||"0",10),e=parseInt(b[c]||"0",10);if(d>e)return 1;if(e>d)return-1}return 0};function ye(a,b){a[0]+=b[0];a[1]+=b[1];return a}function ze(a,b){var c=b.xd(),d=b.xa();b=d[0];d=d[1];var e=a[0]-b;a=a[1]-d;0===e&&0===a&&(e=1);var f=Math.sqrt(e*e+a*a);return[b+c*e/f,d+c*a/f]}function Ae(a,b){var c=a[0];a=a[1];var d=b[0],e=b[1];b=d[0];d=d[1];var f=e[0];e=e[1];var g=f-b,h=e-d;c=0===g&&0===h?0:(g*(c-b)+h*(a-d))/(g*g+h*h||0);0>=c?(a=b,c=d):1<=c?(a=f,c=e):(a=b+c*g,c=d+c*h);return[a,c]}
function Be(a,b,c){b=Ja(b+180,360)-180;var d=Math.abs(3600*b);c=c||0;var e=Math.pow(10,c),f=Math.floor(d/3600),g=Math.floor((d-3600*f)/60);d=Math.ceil((d-3600*f-60*g)*e)/e;60<=d&&(d=0,g+=1);60<=g&&(g=0,f+=1);return f+"\u00b0 "+we(g)+"\u2032 "+we(d,c)+"\u2033"+(0==b?"":" "+a.charAt(0>b?1:0))}function Ce(a,b,c){return a?b.replace("{x}",a[0].toFixed(c)).replace("{y}",a[1].toFixed(c)):""}function De(a,b){for(var c=!0,d=a.length-1;0<=d;--d)if(a[d]!=b[d]){c=!1;break}return c}
function Ee(a,b){var c=Math.cos(b);b=Math.sin(b);var d=a[1]*c+a[0]*b;a[0]=a[0]*c-a[1]*b;a[1]=d;return a}function Fe(a,b){a[0]*=b;a[1]*=b}function Ge(a,b){var c=a[0]-b[0];a=a[1]-b[1];return c*c+a*a}function He(a,b){return Math.sqrt(Ge(a,b))}function Ie(a,b){return Ge(a,Ae(a,b))}function Ke(a,b){return Ce(a,"{x}, {y}",b)};function Le(a){return Math.pow(a,3)}function Me(a){return 1-Le(1-a)}function Ne(a){return 3*a*a-2*a*a*a}function Oe(a){return a};function Pe(){return!0}function Qe(){return!1};function Re(a,b,c,d,e,f){for(var g=f?f:[],h=0;b<c;b+=d){var l=a[b],m=a[b+1];g[h++]=e[0]*l+e[2]*m+e[4];g[h++]=e[1]*l+e[3]*m+e[5]}f&&g.length!=h&&(g.length=h);return g}function Se(a,b,c,d,e,f,g){for(var h=g?g:[],l=0,m;b<c;b+=d)for(h[l++]=a[b]+e,h[l++]=a[b+1]+f,m=b+2;m<b+d;++m)h[l++]=a[m];g&&h.length!=l&&(h.length=l);return h};var Te=Array(6);function Ue(){return[1,0,0,1,0,0]}function Ve(a){return We(a,1,0,0,1,0,0)}function Xe(a,b){var c=a[0],d=a[1],e=a[2],f=a[3],g=a[4],h=a[5],l=b[0],m=b[1],n=b[2],p=b[3],q=b[4];b=b[5];a[0]=c*l+e*m;a[1]=d*l+f*m;a[2]=c*n+e*p;a[3]=d*n+f*p;a[4]=c*q+e*b+g;a[5]=d*q+f*b+h;return a}function We(a,b,c,d,e,f,g){a[0]=b;a[1]=c;a[2]=d;a[3]=e;a[4]=f;a[5]=g;return a}function Ye(a,b){a[0]=b[0];a[1]=b[1];a[2]=b[2];a[3]=b[3];a[4]=b[4];a[5]=b[5];return a}
function Ze(a,b){var c=b[0],d=b[1];b[0]=a[0]*c+a[2]*d+a[4];b[1]=a[1]*c+a[3]*d+a[5];return b}function $e(a,b){var c=Math.cos(b);b=Math.sin(b);Xe(a,We(Te,c,b,-b,c,0,0))}function af(a,b,c){return Xe(a,We(Te,b,0,0,c,0,0))}function bf(a,b,c){Xe(a,We(Te,1,0,0,1,b,c))}function cf(a,b,c,d,e,f,g,h){var l=Math.sin(f);f=Math.cos(f);a[0]=d*f;a[1]=e*l;a[2]=-d*l;a[3]=e*f;a[4]=g*d*f-h*d*l+b;a[5]=g*e*l+h*e*f+c;return a}
function df(a){var b=a[0]*a[3]-a[1]*a[2];wa(0!==b,32);var c=a[0],d=a[1],e=a[2],f=a[3],g=a[4],h=a[5];a[0]=f/b;a[1]=-d/b;a[2]=-e/b;a[3]=c/b;a[4]=(e*h-f*g)/b;a[5]=-(c*h-d*g)/b;return a};function ef(){Wc.call(this);this.o=Pa();this.v=-1;this.i={};this.l=this.g=0;this.T=Ue()}v(ef,Wc);k=ef.prototype;k.Gb=function(a,b){b=b?b:[NaN,NaN];this.Mb(a[0],a[1],b,Infinity);return b};k.yb=function(a){return this.Tc(a[0],a[1])};k.Tc=Qe;k.G=function(a){this.v!=this.f&&(this.o=this.De(this.o),this.v=this.f);var b=this.o;a?(a[0]=b[0],a[1]=b[1],a[2]=b[2],a[3]=b[3]):a=b;return a};k.Rb=function(a){return this.Zd(a*a)};
k.hb=function(a,b){var c=this.T;a=Zb(a);var d="tile-pixels"==a.a?function(d,f,g){var e=a.G(),l=a.re;e=mb(l)/mb(e);cf(c,l[0],l[3],e,-e,0,0,0);Re(d,0,d.length,g,c,f);return ic(a,b)(d,f,g)}:ic(a,b);this.Jc(d);return this};function ff(){ef.call(this);this.ja="XY";this.a=2;this.A=null}v(ff,ef);function gf(a){var b;"XY"==a?b=2:"XYZ"==a||"XYM"==a?b=3:"XYZM"==a&&(b=4);return b}k=ff.prototype;k.Tc=Qe;k.De=function(a){return ab(this.A,0,this.A.length,this.a,a)};k.bc=function(){return this.A.slice(0,this.a)};k.ca=function(){return this.A};k.cc=function(){return this.A.slice(this.A.length-this.a)};k.ec=function(){return this.ja};
k.Zd=function(a){this.l!=this.f&&(ub(this.i),this.g=0,this.l=this.f);if(0>a||0!==this.g&&a<=this.g)return this;var b=a.toString();if(this.i.hasOwnProperty(b))return this.i[b];var c=this.rd(a);if(c.ca().length<this.A.length)return this.i[b]=c;this.g=a;return this};k.rd=function(){return this};k.pa=function(){return this.a};function hf(a,b,c){a.a=gf(b);a.ja=b;a.A=c}
function jf(a,b,c,d){if(b)c=gf(b);else{for(b=0;b<d;++b){if(0===c.length){a.ja="XY";a.a=2;return}c=c[0]}c=c.length;var e;2==c?e="XY":3==c?e="XYZ":4==c&&(e="XYZM");b=e}a.ja=b;a.a=c}k.Jc=function(a){this.A&&(a(this.A,this.A,this.a),this.u())};
k.rotate=function(a,b){var c=this.ca();if(c){var d=c.length,e=this.pa(),f=c?c:[],g=Math.cos(a);a=Math.sin(a);var h=b[0];b=b[1];for(var l=0,m=0;m<d;m+=e){var n=c[m]-h,p=c[m+1]-b;f[l++]=h+n*g-p*a;f[l++]=b+n*a+p*g;for(n=m+2;n<m+e;++n)f[l++]=c[n]}c&&f.length!=l&&(f.length=l);this.u()}};
k.scale=function(a,b,c){var d=b;void 0===d&&(d=a);var e=c;e||(e=nb(this.G()));if(c=this.ca()){b=c.length;var f=this.pa(),g=c?c:[],h=e[0];e=e[1];for(var l=0,m=0;m<b;m+=f){var n=c[m]-h,p=c[m+1]-e;g[l++]=h+a*n;g[l++]=e+d*p;for(n=m+2;n<m+f;++n)g[l++]=c[n]}c&&g.length!=l&&(g.length=l);this.u()}};k.translate=function(a,b){var c=this.ca();c&&(Se(c,0,c.length,this.pa(),a,b,c),this.u())};function mf(a,b,c,d){for(var e=0,f=a[c-d],g=a[c-d+1];b<c;b+=d){var h=a[b],l=a[b+1];e+=g*h-f*l;f=h;g=l}return e/2}function nf(a,b,c,d){var e=0,f;var g=0;for(f=c.length;g<f;++g){var h=c[g];e+=mf(a,b,h,d);b=h}return e};function of(a,b,c,d,e,f,g){var h=a[b],l=a[b+1],m=a[c]-h,n=a[c+1]-l;if(0!==m||0!==n)if(f=((e-h)*m+(f-l)*n)/(m*m+n*n),1<f)b=c;else if(0<f){for(e=0;e<d;++e)g[e]=Ka(a[b+e],a[c+e],f);g.length=d;return}for(e=0;e<d;++e)g[e]=a[b+e];g.length=d}function pf(a,b,c,d,e){var f=a[b],g=a[b+1];for(b+=d;b<c;b+=d){var h=a[b],l=a[b+1];f=Ha(f,g,h,l);f>e&&(e=f);f=h;g=l}return e}function qf(a,b,c,d,e){var f;var g=0;for(f=c.length;g<f;++g){var h=c[g];e=pf(a,b,h,d,e);b=h}return e}
function rf(a,b,c,d,e,f,g,h,l,m,n){if(b==c)return m;if(0===e){var p=Ha(g,h,a[b],a[b+1]);if(p<m){for(n=0;n<d;++n)l[n]=a[b+n];l.length=d;return p}return m}for(var q=n?n:[NaN,NaN],r=b+d;r<c;)if(of(a,r-d,r,d,g,h,q),p=Ha(g,h,q[0],q[1]),p<m){m=p;for(n=0;n<d;++n)l[n]=q[n];l.length=d;r+=d}else r+=d*Math.max((Math.sqrt(p)-Math.sqrt(m))/e|0,1);if(f&&(of(a,c-d,b,d,g,h,q),p=Ha(g,h,q[0],q[1]),p<m)){m=p;for(n=0;n<d;++n)l[n]=q[n];l.length=d}return m}
function sf(a,b,c,d,e,f,g,h,l,m,n){n=n?n:[NaN,NaN];var p;var q=0;for(p=c.length;q<p;++q){var r=c[q];m=rf(a,b,r,d,e,f,g,h,l,m,n);b=r}return m};function tf(a,b){var c=0,d;var e=0;for(d=b.length;e<d;++e)a[c++]=b[e];return c}function uf(a,b,c,d){var e;var f=0;for(e=c.length;f<e;++f){var g=c[f],h;for(h=0;h<d;++h)a[b++]=g[h]}return b}function vf(a,b,c,d,e){e=e?e:[];var f=0,g;var h=0;for(g=c.length;h<g;++h)b=uf(a,b,c[h],d),e[f++]=b;e.length=f;return e};function wf(a,b,c,d,e){e=void 0!==e?e:[];for(var f=0;b<c;b+=d)e[f++]=a.slice(b,b+d);e.length=f;return e}function xf(a,b,c,d,e){e=void 0!==e?e:[];var f=0,g;var h=0;for(g=c.length;h<g;++h){var l=c[h];e[f++]=wf(a,b,l,d,e[f]);b=l}e.length=f;return e}function yf(a,b,c,d,e){e=void 0!==e?e:[];var f=0,g;var h=0;for(g=c.length;h<g;++h){var l=c[h];e[f++]=xf(a,b,l,d,e[f]);b=l[l.length-1]}e.length=f;return e};function zf(a,b,c,d,e,f,g){var h=(c-b)/d;if(3>h){for(;b<c;b+=d)f[g++]=a[b],f[g++]=a[b+1];return g}var l=Array(h);l[0]=1;l[h-1]=1;c=[b,c-d];for(var m=0,n;0<c.length;){var p=c.pop(),q=c.pop(),r=0,u=a[q],x=a[q+1],B=a[p],A=a[p+1];for(n=q+d;n<p;n+=d){var y=Ga(a[n],a[n+1],u,x,B,A);y>r&&(m=n,r=y)}r>e&&(l[(m-b)/d]=1,q+d<m&&c.push(q,m),m+d<p&&c.push(m,p))}for(n=0;n<h;++n)l[n]&&(f[g++]=a[b+n*d],f[g++]=a[b+n*d+1]);return g}
function Af(a,b,c,d,e,f,g,h){var l;var m=0;for(l=c.length;m<l;++m){var n=c[m];a:{var p=a,q=n,r=d,u=e,x=f,B=g;if(b!=q){var A=u*Math.round(p[b]/u),y=u*Math.round(p[b+1]/u);b+=r;x[B++]=A;x[B++]=y;do{var N=u*Math.round(p[b]/u);g=u*Math.round(p[b+1]/u);b+=r;if(b==q){x[B++]=N;x[B++]=g;g=B;break a}}while(N==A&&g==y);for(;b<q;){var ca=u*Math.round(p[b]/u);var la=u*Math.round(p[b+1]/u);b+=r;if(ca!=N||la!=g){var fa=N-A,va=g-y,ra=ca-A,T=la-y;fa*T==va*ra&&(0>fa&&ra<fa||fa==ra||0<fa&&ra>fa)&&(0>va&&T<va||va==
T||0<va&&T>va)||(x[B++]=N,x[B++]=g,A=N,y=g);N=ca;g=la}}x[B++]=N;x[B++]=g}g=B}h.push(g);b=n}return g};function Bf(a,b){ff.call(this);this.c=this.j=-1;this.na(a,b)}v(Bf,ff);k=Bf.prototype;k.clone=function(){var a=new Bf(null);Cf(a,this.ja,this.A.slice());return a};k.Mb=function(a,b,c,d){if(d<Ta(this.G(),a,b))return d;this.c!=this.f&&(this.j=Math.sqrt(pf(this.A,0,this.A.length,this.a,0)),this.c=this.f);return rf(this.A,0,this.A.length,this.a,this.j,!0,a,b,c,d)};k.Bn=function(){return mf(this.A,0,this.A.length,this.a)};k.V=function(){return wf(this.A,0,this.A.length,this.a)};
k.rd=function(a){var b=[];b.length=zf(this.A,0,this.A.length,this.a,a,b,0);a=new Bf(null);Cf(a,"XY",b);return a};k.S=function(){return"LinearRing"};k.Ya=function(){};k.na=function(a,b){a?(jf(this,b,a,1),this.A||(this.A=[]),this.A.length=uf(this.A,0,a,this.a),this.u()):Cf(this,"XY",null)};function Cf(a,b,c){hf(a,b,c);a.u()};function D(a,b){ff.call(this);this.na(a,b)}v(D,ff);k=D.prototype;k.clone=function(){var a=new D(null);a.aa(this.ja,this.A.slice());return a};k.Mb=function(a,b,c,d){var e=this.A;a=Ha(a,b,e[0],e[1]);if(a<d){d=this.a;for(b=0;b<d;++b)c[b]=e[b];c.length=d;return a}return d};k.V=function(){return this.A?this.A.slice():[]};k.De=function(a){return $a(this.A,a)};k.S=function(){return"Point"};k.Ya=function(a){return Va(a,this.A[0],this.A[1])};
k.na=function(a,b){a?(jf(this,b,a,0),this.A||(this.A=[]),this.A.length=tf(this.A,a),this.u()):this.aa("XY",null)};k.aa=function(a,b){hf(this,a,b);this.u()};function Df(a,b,c,d,e){return!eb(e,function(e){return!Ef(a,b,c,d,e[0],e[1])})}function Ef(a,b,c,d,e,f){for(var g=0,h=a[c-d],l=a[c-d+1];b<c;b+=d){var m=a[b],n=a[b+1];l<=f?n>f&&0<(m-h)*(f-l)-(e-h)*(n-l)&&g++:n<=f&&0>(m-h)*(f-l)-(e-h)*(n-l)&&g--;h=m;l=n}return 0!==g}function Ff(a,b,c,d,e,f){if(0===c.length||!Ef(a,b,c[0],d,e,f))return!1;var g;b=1;for(g=c.length;b<g;++b)if(Ef(a,c[b-1],c[b],d,e,f))return!1;return!0};function Gf(a,b,c,d,e,f,g){var h,l=e[f+1],m=[],n=c[0];var p=a[n-d];var q=a[n-d+1];for(h=b;h<n;h+=d){var r=a[h];var u=a[h+1];if(l<=q&&u<=l||q<=l&&l<=u)p=(l-q)/(u-q)*(r-p)+p,m.push(p);p=r;q=u}n=NaN;q=-Infinity;m.sort(ea);p=m[0];h=1;for(u=m.length;h<u;++h){r=m[h];var x=Math.abs(r-p);x>q&&(p=(p+r)/2,Ff(a,b,c,d,p,l)&&(n=p,q=x));p=r}isNaN(n)&&(n=e[f]);return g?(g.push(n,l,q),g):[n,l,q]};function Hf(a,b,c,d,e,f){for(var g=[a[b],a[b+1]],h=[],l;b+d<c;b+=d){h[0]=a[b+d];h[1]=a[b+d+1];if(l=e.call(f,g,h))return l;g[0]=h[0];g[1]=h[1]}return!1};function If(a,b,c,d,e){var f=bb(Pa(),a,b,c,d);return qb(e,f)?Wa(e,f)||f[0]>=e[0]&&f[2]<=e[2]||f[1]>=e[1]&&f[3]<=e[3]?!0:Hf(a,b,c,d,function(a,b){var c=!1,d=Xa(e,a),f=Xa(e,b);if(1===d||1===f)c=!0;else{var g=e[0],h=e[1],r=e[2],u=e[3],x=b[0];b=b[1];a=(b-a[1])/(x-a[0]);f&2&&!(d&2)&&(c=x-(b-u)/a,c=c>=g&&c<=r);c||!(f&4)||d&4||(c=b-(x-r)*a,c=c>=h&&c<=u);c||!(f&8)||d&8||(c=x-(b-h)/a,c=c>=g&&c<=r);c||!(f&16)||d&16||(c=b-(x-g)*a,c=c>=h&&c<=u)}return c}):!1}
function Jf(a,b,c,d,e){var f=c[0];if(!(If(a,b,f,d,e)||Ef(a,b,f,d,e[0],e[1])||Ef(a,b,f,d,e[0],e[3])||Ef(a,b,f,d,e[2],e[1])||Ef(a,b,f,d,e[2],e[3])))return!1;if(1===c.length)return!0;b=1;for(f=c.length;b<f;++b)if(Df(a,c[b-1],c[b],d,e))return!1;return!0};function Kf(a,b,c,d){for(var e=0,f=a[c-d],g=a[c-d+1];b<c;b+=d){var h=a[b],l=a[b+1];e+=(h-f)*(l+g);f=h;g=l}return 0<e}function Lf(a,b,c,d){var e=0;d=void 0!==d?d:!1;var f;var g=0;for(f=b.length;g<f;++g){var h=b[g];e=Kf(a,e,h,c);if(0===g){if(d&&e||!d&&!e)return!1}else if(d&&!e||!d&&e)return!1;e=h}return!0}
function Mf(a,b,c,d,e){e=void 0!==e?e:!1;var f;var g=0;for(f=c.length;g<f;++g){var h=c[g],l=Kf(a,b,h,d);if(0===g?e&&l||!e&&!l:e&&!l||!e&&l){l=a;for(var m=h,n=d;b<m-n;){var p;for(p=0;p<n;++p){var q=l[b+p];l[b+p]=l[m-n+p];l[m-n+p]=q}b+=n;m-=n}}b=h}return b}function Of(a,b,c,d){var e=0,f;var g=0;for(f=b.length;g<f;++g)e=Mf(a,e,b[g],c,d);return e};function E(a,b){ff.call(this);this.c=[];this.s=-1;this.C=null;this.I=this.D=this.B=-1;this.j=null;this.na(a,b)}v(E,ff);k=E.prototype;k.zk=function(a){this.A?ja(this.A,a.ca()):this.A=a.ca().slice();this.c.push(this.A.length);this.u()};k.clone=function(){var a=new E(null);a.aa(this.ja,this.A.slice(),this.c.slice());return a};
k.Mb=function(a,b,c,d){if(d<Ta(this.G(),a,b))return d;this.D!=this.f&&(this.B=Math.sqrt(qf(this.A,0,this.c,this.a,0)),this.D=this.f);return sf(this.A,0,this.c,this.a,this.B,!0,a,b,c,d)};k.Tc=function(a,b){return Ff(this.Ub(),0,this.c,this.a,a,b)};k.En=function(){return nf(this.Ub(),0,this.c,this.a)};k.V=function(a){if(void 0!==a){var b=this.Ub().slice();Mf(b,0,this.c,this.a,a)}else b=this.A;return xf(b,0,this.c,this.a)};k.lb=function(){return this.c};
function Pf(a){if(a.s!=a.f){var b=nb(a.G());a.C=Gf(a.Ub(),0,a.c,a.a,b,0);a.s=a.f}return a.C}k.bl=function(){return new D(Pf(this),"XYM")};k.hl=function(){return this.c.length};k.Sh=function(a){if(0>a||this.c.length<=a)return null;var b=new Bf(null);Cf(b,this.ja,this.A.slice(0===a?0:this.c[a-1],this.c[a]));return b};k.Xd=function(){var a=this.ja,b=this.A,c=this.c,d=[],e=0,f;var g=0;for(f=c.length;g<f;++g){var h=c[g],l=new Bf(null);Cf(l,a,b.slice(e,h));d.push(l);e=h}return d};
k.Ub=function(){if(this.I!=this.f){var a=this.A;Lf(a,this.c,this.a)?this.j=a:(this.j=a.slice(),this.j.length=Mf(this.j,0,this.c,this.a));this.I=this.f}return this.j};k.rd=function(a){var b=[],c=[];b.length=Af(this.A,0,this.c,this.a,Math.sqrt(a),b,0,c);a=new E(null);a.aa("XY",b,c);return a};k.S=function(){return"Polygon"};k.Ya=function(a){return Jf(this.Ub(),0,this.c,this.a,a)};
k.na=function(a,b){a?(jf(this,b,a,2),this.A||(this.A=[]),a=vf(this.A,0,a,this.a,this.c),this.A.length=0===a.length?0:a[a.length-1],this.u()):this.aa("XY",null,this.c)};k.aa=function(a,b,c){hf(this,a,b);this.c=c;this.u()};function Qf(a,b,c,d){var e=d?d:32;d=[];var f;for(f=0;f<e;++f)ja(d,a.offset(b,c,2*Math.PI*f/e));d.push(d[0],d[1]);a=new E(null);a.aa("XY",d,[d.length]);return a}function Rf(a){var b=a[0],c=a[1],d=a[2];a=a[3];b=[b,c,b,a,d,a,d,c,b,c];c=new E(null);c.aa("XY",b,[b.length]);return c}
function Sf(a,b,c){var d=b?b:32,e=a.pa();b=a.ja;var f=new E(null,b);d=e*(d+1);e=Array(d);for(var g=0;g<d;g++)e[g]=0;f.aa(b,e,[e.length]);Tf(f,a.xa(),a.xd(),c);return f}function Tf(a,b,c,d){var e=a.ca(),f=a.ja,g=a.pa(),h=a.lb(),l=e.length/g-1;d=d?d:0;for(var m,n,p=0;p<=l;++p)n=p*g,m=d+2*Ja(p,l)*Math.PI/l,e[n]=b[0]+c*Math.cos(m),e[n+1]=b[1]+c*Math.sin(m);a.aa(f,e,h)};function F(a){Wc.call(this);a=tb({},a);this.l=[0,0];this.c=[];this.Ff=this.Ff.bind(this);this.v=ec(a.projection);Uf(this,a)}v(F,Wc);
function Uf(a,b){var c={};c.center=void 0!==b.center?b.center:null;var d=void 0!==b.minZoom?b.minZoom:0;var e=void 0!==b.maxZoom?b.maxZoom:28;var f=void 0!==b.zoomFactor?b.zoomFactor:2;if(void 0!==b.resolutions){e=b.resolutions;var g=e[0];var h=e[e.length-1];e=qe(e)}else{g=ec(b.projection);h=g.G();var l=(h?Math.max(lb(h),mb(h)):360*Eb.degrees/g.Rc())/256/Math.pow(2,0),m=l/Math.pow(2,28);g=b.maxResolution;void 0!==g?d=0:g=l/Math.pow(f,d);h=b.minResolution;void 0===h&&(h=void 0!==b.maxZoom?void 0!==
b.maxResolution?g/Math.pow(f,e):l/Math.pow(f,e):m);e=d+Math.floor(Math.log(g/h)/Math.log(f));h=g/Math.pow(f,e-d);e=re(f,g,e-d)}a.a=g;a.i=h;a.C=f;a.j=b.resolutions;a.o=d;(void 0!==b.enableRotation?b.enableRotation:1)?(d=b.constrainRotation,d=void 0===d||!0===d?ve():!1===d?te:"number"===typeof d?ue(d):te):d=se;a.g={center:void 0!==b.extent?oe(b.extent):pe,resolution:e,rotation:d};void 0!==b.resolution?c.resolution=b.resolution:void 0!==b.zoom&&(c.resolution=a.constrainResolution(a.a,b.zoom-a.o));c.rotation=
void 0!==b.rotation?b.rotation:0;a.H(c);a.D=b}function Vf(a,b){var c=tb({},a.D);void 0!==c.resolution?c.resolution=a.Oa():c.zoom=a.Yh();c.center=a.xa();c.rotation=a.Pa();return tb({},c,b)}k=F.prototype;
k.animate=function(a){var b=arguments.length;if(1<b&&"function"===typeof arguments[b-1]){var c=arguments[b-1];--b}if(Wf(this)){for(var d=Date.now(),e=this.xa().slice(),f=this.Oa(),g=this.Pa(),h=[],l=0;l<b;++l){var m=arguments[l],n={start:d,complete:!1,anchor:m.anchor,duration:void 0!==m.duration?m.duration:1E3,easing:m.easing||Ne};m.center&&(n.le=e,n.pe=m.center,e=n.pe);void 0!==m.zoom?(n.ne=f,n.dd=this.constrainResolution(this.a,m.zoom-this.o,0),f=n.dd):m.resolution&&(n.ne=f,n.dd=m.resolution,f=
n.dd);void 0!==m.rotation&&(n.Df=g,n.qe=g+(Ja(m.rotation-g+Math.PI,2*Math.PI)-Math.PI),g=n.qe);n.callback=c;n.le&&n.pe&&!De(n.le,n.pe)||n.ne!==n.dd||n.Df!==n.qe?d+=n.duration:n.complete=!0;h.push(n)}this.c.push(h);Xf(this,0,1);this.Ff()}else b=arguments[b-1],b.center&&this.rb(b.center),void 0!==b.zoom&&this.Lj(b.zoom),void 0!==b.rotation&&this.de(b.rotation),c&&c(!0)};k.Pc=function(){return 0<Yf(this)[0]};k.al=function(){return 0<Yf(this)[1]};
k.kd=function(){Xf(this,0,-Yf(this)[0]);for(var a=0,b=this.c.length;a<b;++a){var c=this.c[a];c[0].callback&&c[0].callback(!1)}this.c.length=0};
k.Ff=function(){void 0!==this.s&&(cancelAnimationFrame(this.s),this.s=void 0);if(this.Pc()){for(var a=Date.now(),b=!1,c=this.c.length-1;0<=c;--c){for(var d=this.c[c],e=!0,f=0,g=d.length;f<g;++f){var h=d[f];if(!h.complete){b=a-h.start;b=0<h.duration?b/h.duration:1;1<=b?(h.complete=!0,b=1):e=!1;b=h.easing(b);if(h.le){var l=h.le[0],m=h.le[1];this.set("center",[l+b*(h.pe[0]-l),m+b*(h.pe[1]-m)])}h.ne&&h.dd&&(l=1===b?h.dd:h.ne+b*(h.dd-h.ne),h.anchor&&this.set("center",Zf(this,l,h.anchor)),this.set("resolution",
l));void 0!==h.Df&&void 0!==h.qe&&(b=1===b?Ja(h.qe+Math.PI,2*Math.PI)-Math.PI:h.Df+b*(h.qe-h.Df),h.anchor&&this.set("center",$f(this,b,h.anchor)),this.set("rotation",b));b=!0;if(!h.complete)break}}e&&(this.c[c]=null,Xf(this,0,-1),(d=d[0].callback)&&d(!0))}this.c=this.c.filter(Boolean);b&&void 0===this.s&&(this.s=requestAnimationFrame(this.Ff))}};function $f(a,b,c){var d=a.xa();if(void 0!==d){var e=[d[0]-c[0],d[1]-c[1]];Ee(e,b-a.Pa());ye(e,c)}return e}
function Zf(a,b,c){var d,e=a.xa();a=a.Oa();void 0!==e&&void 0!==a&&(d=[c[0]-b*(c[0]-e[0])/a,c[1]-b*(c[1]-e[1])/a]);return d}function ag(a){var b=[100,100];a='.ol-viewport[data-view="'+w(a)+'"]';if(a=document.querySelector(a))a=getComputedStyle(a),b[0]=parseInt(a.width,10),b[1]=parseInt(a.height,10);return b}k.Kc=function(a){return this.g.center(a)};k.constrainResolution=function(a,b,c){return this.g.resolution(a,b||0,c||0)};k.constrainRotation=function(a,b){return this.g.rotation(a,b||0)};k.xa=function(){return this.get("center")};
function Yf(a,b){return void 0!==b?(b[0]=a.l[0],b[1]=a.l[1],b):a.l.slice()}k.jd=function(a){a=a||ag(this);var b=this.xa();wa(b,1);var c=this.Oa();wa(void 0!==c,2);var d=this.Pa();wa(void 0!==d,3);return ob(b,c,d,a)};k.Xm=function(){return this.a};k.Zm=function(){return this.i};k.Ym=function(){return this.Ne(this.i)};k.iq=function(a){Uf(this,Vf(this,{maxZoom:a}))};k.$m=function(){return this.Ne(this.a)};k.jq=function(a){Uf(this,Vf(this,{minZoom:a}))};k.an=function(){return this.v};k.Oa=function(){return this.get("resolution")};
k.bn=function(){return this.j};k.Ke=function(a,b){b=b||ag(this);return Math.max(lb(a)/b[0],mb(a)/b[1])};function bg(a){var b=a.a,c=Math.log(b/a.i)/Math.log(2);return function(a){return b/Math.pow(2,a*c)}}k.Pa=function(){return this.get("rotation")};function cg(a){var b=a.a,c=Math.log(b/a.i)/Math.log(2);return function(a){return Math.log(b/a)/Math.log(2)/c}}k.getState=function(){var a=this.xa(),b=this.v,c=this.Oa(),d=this.Pa();return{center:a.slice(),projection:void 0!==b?b:null,resolution:c,rotation:d}};
k.Yh=function(){var a,b=this.Oa();void 0!==b&&(a=this.Ne(b));return a};k.Ne=function(a){if(a>=this.i&&a<=this.a){var b=this.o||0;if(this.j){var c=ia(this.j,a,1);b+=c;if(c==this.j.length-1)return b;var d=this.j[c];c=d/this.j[c+1]}else d=this.a,c=this.C;b+=Math.log(d/a)/Math.log(c)}return b};k.Wh=function(a){return this.constrainResolution(this.a,a-this.o,0)};
k.Uf=function(a,b){b=b||{};var c=b.size;c||(c=ag(this));if(a instanceof ff)if("Circle"===a.S()){a=a.G();var d=Rf(a);d.rotate(this.Pa(),nb(a))}else d=a;else wa(Array.isArray(a),24),wa(!kb(a),25),d=Rf(a);var e=b.padding?b.padding:[0,0,0,0],f=void 0!==b.constrainResolution?b.constrainResolution:!0,g=void 0!==b.nearest?b.nearest:!1,h;void 0!==b.minResolution?h=b.minResolution:void 0!==b.maxZoom?h=this.constrainResolution(this.a,b.maxZoom-this.o,0):h=0;var l=d.ca(),m=this.Pa();a=Math.cos(-m);m=Math.sin(-m);
var n=Infinity,p=Infinity,q=-Infinity,r=-Infinity;d=d.pa();for(var u=0,x=l.length;u<x;u+=d){var B=l[u]*a-l[u+1]*m,A=l[u]*m+l[u+1]*a;n=Math.min(n,B);p=Math.min(p,A);q=Math.max(q,B);r=Math.max(r,A)}c=this.Ke([n,p,q,r],[c[0]-e[1]-e[3],c[1]-e[0]-e[2]]);c=isNaN(c)?h:Math.max(c,h);f&&(h=this.constrainResolution(c,0,0),!g&&h<c&&(h=this.constrainResolution(h,-1,0)),c=h);m=-m;h=(n+q)/2+(e[1]-e[3])/2*c;e=(p+r)/2+(e[0]-e[2])/2*c;a=[h*a-e*m,e*a+h*m];e=b.callback?b.callback:sa;void 0!==b.duration?this.animate({resolution:c,
center:a,duration:b.duration,easing:b.easing},e):(this.ad(c),this.rb(a),setTimeout(e.bind(void 0,!0),0))};k.Fk=function(a,b,c){var d=this.Pa(),e=Math.cos(-d);d=Math.sin(-d);var f=a[0]*e-a[1]*d;a=a[1]*e+a[0]*d;var g=this.Oa();f+=(b[0]/2-c[0])*g;a+=(c[1]-b[1]/2)*g;d=-d;this.rb([f*e-a*d,a*e+f*d])};function Wf(a){return!!a.xa()&&void 0!==a.Oa()}k.rotate=function(a,b){void 0!==b&&(b=$f(this,a,b),this.rb(b));this.de(a)};k.rb=function(a){this.set("center",a);this.Pc()&&this.kd()};
function Xf(a,b,c){a.l[b]+=c;a.u()}k.ad=function(a){this.set("resolution",a);this.Pc()&&this.kd()};k.de=function(a){this.set("rotation",a);this.Pc()&&this.kd()};k.Lj=function(a){this.ad(this.Wh(a))};function dg(a,b){var c=document.createElement("CANVAS");a&&(c.width=a);b&&(c.height=b);return c.getContext("2d")}function eg(a,b){var c=b.parentNode;c&&c.replaceChild(a,b)}function fg(a){a&&a.parentNode&&a.parentNode.removeChild(a)};function gg(a){Wc.call(this);var b=tb({},a);b.opacity=void 0!==a.opacity?a.opacity:1;b.visible=void 0!==a.visible?a.visible:!0;b.zIndex=void 0!==a.zIndex?a.zIndex:0;b.maxResolution=void 0!==a.maxResolution?a.maxResolution:Infinity;b.minResolution=void 0!==a.minResolution?a.minResolution:0;this.H(b);this.a={layer:this,Ue:!0}}v(gg,Wc);k=gg.prototype;k.S=function(){return this.type};
function hg(a){a.a.opacity=Da(a.jc(),0,1);a.a.Nj=a.ig();a.a.visible=a.Tb();a.a.extent=a.G();a.a.zIndex=a.za();a.a.maxResolution=a.hc();a.a.minResolution=Math.max(a.ic(),0);return a.a}k.G=function(){return this.get("extent")};k.hc=function(){return this.get("maxResolution")};k.ic=function(){return this.get("minResolution")};k.jc=function(){return this.get("opacity")};k.Tb=function(){return this.get("visible")};k.za=function(){return this.get("zIndex")};k.zc=function(a){this.set("extent",a)};
k.Ec=function(a){this.set("maxResolution",a)};k.Fc=function(a){this.set("minResolution",a)};k.Ac=function(a){this.set("opacity",a)};k.Bc=function(a){this.set("visible",a)};k.Xb=function(a){this.set("zIndex",a)};function ig(a){var b=a||{};a=tb({},b);delete a.layers;b=b.layers;gg.call(this,a);this.i=[];this.c={};z(this,Yc(jg),this.Pl,this);b?Array.isArray(b)?b=new C(b.slice(),{unique:!0}):wa(b instanceof C,43):b=new C(void 0,{unique:!0});this.Ni(b)}v(ig,gg);k=ig.prototype;k.Qe=function(){this.u()};
k.Pl=function(){this.i.forEach(Hc);this.i.length=0;var a=this.yd();this.i.push(z(a,"add",this.Ol,this),z(a,"remove",this.Ql,this));for(var b in this.c)this.c[b].forEach(Hc);ub(this.c);a=a.a;var c;b=0;for(c=a.length;b<c;b++){var d=a[b];this.c[w(d).toString()]=[z(d,"propertychange",this.Qe,this),z(d,"change",this.Qe,this)]}this.u()};k.Ol=function(a){a=a.element;var b=w(a).toString();this.c[b]=[z(a,"propertychange",this.Qe,this),z(a,"change",this.Qe,this)];this.u()};
k.Ql=function(a){a=w(a.element).toString();this.c[a].forEach(Hc);delete this.c[a];this.u()};k.yd=function(){return this.get(jg)};k.Ni=function(a){this.set(jg,a)};
k.eg=function(a){var b=void 0!==a?a:[],c=b.length;this.yd().forEach(function(a){a.eg(b)});a=hg(this);var d;for(d=b.length;c<d;c++){var e=b[c];e.opacity*=a.opacity;e.visible=e.visible&&a.visible;e.maxResolution=Math.min(e.maxResolution,a.maxResolution);e.minResolution=Math.max(e.minResolution,a.minResolution);void 0!==a.extent&&(e.extent=void 0!==e.extent?pb(e.extent,a.extent):a.extent)}return b};k.ig=function(){return"ready"};var jg="layers";var kg=[],lg=[];function mg(a,b){switch(a){case "MAP_RENDERER":a=kg;a.push(b);break;case "LAYER_RENDERER":a=lg;a.push(b);break;default:throw Error("Unsupported plugin type: "+a);}}function ng(a){for(var b=0,c=a.length;b<c;++b)mg("LAYER_RENDERER",a[b])};function G(a){Wc.call(this);var b=og(a);this.ub=void 0!==a.loadTilesWhileAnimating?a.loadTilesWhileAnimating:!1;this.Lb=void 0!==a.loadTilesWhileInteracting?a.loadTilesWhileInteracting:!1;this.Jd=void 0!==a.pixelRatio?a.pixelRatio:pd;this.gd=b.logos;this.U=function(){this.j=void 0;this.Wp.call(this,Date.now())}.bind(this);this.Va=Ue();this.If=Ue();this.ab=0;this.C=this.D=this.B=this.g=this.c=null;this.a=document.createElement("DIV");this.a.className="ol-viewport"+(ud?" ol-touch":"");this.a.style.position=
"relative";this.a.style.overflow="hidden";this.a.style.width="100%";this.a.style.height="100%";this.a.style.msTouchAction="none";this.a.style.touchAction="none";this.s=document.createElement("DIV");this.s.className="ol-overlaycontainer";this.a.appendChild(this.s);this.v=document.createElement("DIV");this.v.className="ol-overlaycontainer-stopevent";for(var c="click dblclick mousedown touchstart MSPointerDown pointerdown mousewheel wheel".split(" "),d=0,e=c.length;d<e;++d)z(this.v,c[d],Sc);this.a.appendChild(this.v);
this.fa=new de(this,a.moveTolerance);for(var f in Cd)z(this.fa,Cd[f],this.Zh,this);this.ta=b.keyboardEventTarget;this.o=null;z(this.a,"wheel",this.sd,this);z(this.a,"mousewheel",this.sd,this);this.controls=b.controls||new C;this.interactions=b.interactions||new C;this.l=b.overlays;this.Dg={};this.lc=b.om.create(this.a,this);this.I=null;this.oa=[];this.ma=new me(this.zl.bind(this),this.fm.bind(this));this.T={};z(this,Yc("layergroup"),this.Ml,this);z(this,Yc("view"),this.gm,this);z(this,Yc("size"),
this.am,this);z(this,Yc("target"),this.em,this);this.H(b.values);this.controls.forEach(function(a){a.setMap(this)},this);z(this.controls,"add",function(a){a.element.setMap(this)},this);z(this.controls,"remove",function(a){a.element.setMap(null)},this);this.interactions.forEach(function(a){a.setMap(this)},this);z(this.interactions,"add",function(a){a.element.setMap(this)},this);z(this.interactions,"remove",function(a){a.element.setMap(null)},this);this.l.forEach(this.xh,this);z(this.l,"add",function(a){this.xh(a.element)},
this);z(this.l,"remove",function(a){var b=a.element.g;void 0!==b&&delete this.Dg[b.toString()];a.element.setMap(null)},this)}v(G,Wc);k=G.prototype;k.Mf=function(a){this.controls.push(a)};k.Nf=function(a){this.interactions.push(a)};k.Ae=function(a){this.dc().yd().push(a)};k.Be=function(a){this.l.push(a)};k.xh=function(a){var b=a.g;void 0!==b&&(this.Dg[b.toString()]=a);a.setMap(this)};
k.ka=function(){Qc(this.fa);Qc(this.lc);Nc(this.a,"wheel",this.sd,this);Nc(this.a,"mousewheel",this.sd,this);this.i&&(window.removeEventListener("resize",this.i,!1),this.i=void 0);this.j&&(cancelAnimationFrame(this.j),this.j=void 0);this.vd(null);Wc.prototype.ka.call(this)};k.Mc=function(a,b,c){if(this.c)return a=this.Na(a),c=c?c:{},this.lc.Fa(a,this.c,void 0!==c.hitTolerance?c.hitTolerance*this.c.pixelRatio:0,b,null,c.layerFilter?c.layerFilter:Pe,null)};
k.Yf=function(a,b){var c=null;this.Mc(a,function(a){c||(c=[]);c.push(a)},b);return c};k.sg=function(a,b,c,d,e){if(this.c)return this.lc.Qi(a,this.c,b,void 0!==c?c:null,d?d:Pe,void 0!==e?e:null)};k.ng=function(a,b){if(!this.c)return!1;a=this.Na(a);b=b?b:{};return this.lc.Ri(a,this.c,void 0!==b.hitTolerance?b.hitTolerance*this.c.pixelRatio:0,b.layerFilter?b.layerFilter:Pe,null)};k.Wd=function(a){return this.Na(this.od(a))};
k.od=function(a){var b=this.a.getBoundingClientRect();a=a.changedTouches?a.changedTouches[0]:a;return[a.clientX-b.left,a.clientY-b.top]};k.$d=function(){return this.get("target")};k.wc=function(){var a=this.$d();return void 0!==a?"string"===typeof a?document.getElementById(a):a:null};k.Na=function(a){var b=this.c;return b?Ze(b.pixelToCoordinateTransform,a.slice()):null};k.Xf=function(){return this.controls};k.hg=function(){return this.l};
k.gg=function(a){a=this.Dg[a.toString()];return void 0!==a?a:null};k.cg=function(){return this.interactions};k.dc=function(){return this.get("layergroup")};k.Ye=function(){return this.dc().yd()};k.Ha=function(a){var b=this.c;return b?Ze(b.coordinateToPixelTransform,a.slice(0,2)):null};k.Je=function(){return this.lc};k.zb=function(){return this.get("size")};k.$=function(){return this.get("view")};k.lg=function(){return this.a};
k.zl=function(a,b,c,d){var e=this.c;if(!(e&&b in e.wantedTiles&&e.wantedTiles[b][a.gb()]))return Infinity;a=c[0]-e.focus[0];c=c[1]-e.focus[1];return 65536*Math.log(d)+Math.sqrt(a*a+c*c)/d};k.sd=function(a,b){a=new fd(b||a.type,this,a);this.Zh(a)};k.Zh=function(a){if(this.c){this.I=a.coordinate;a.frameState=this.c;var b=this.interactions.a,c;if(!1!==this.b(a))for(c=b.length-1;0<=c;c--){var d=b[c];if(d.c()&&!d.handleEvent(a))break}}};
k.Zl=function(){var a=this.c,b=this.ma;if(0!==b.b.length){var c=16,d=c;if(a){var e=a.viewHints;e[0]&&(c=this.ub?8:0,d=2);e[1]&&(c=this.Lb?8:0,d=2)}b.j<c&&(le(b),ne(b,c,d))}b=this.oa;c=0;for(d=b.length;c<d;++c)b[c](this,a);b.length=0};k.am=function(){this.render()};
k.em=function(){var a;this.$d()&&(a=this.wc());if(this.o){for(var b=0,c=this.o.length;b<c;++b)Hc(this.o[b]);this.o=null}a?(a.appendChild(this.a),a=this.ta?this.ta:a,this.o=[z(a,"keydown",this.sd,this),z(a,"keypress",this.sd,this)],this.i||(this.i=this.Gc.bind(this),window.addEventListener("resize",this.i,!1))):(fg(this.a),this.i&&(window.removeEventListener("resize",this.i,!1),this.i=void 0));this.Gc()};k.fm=function(){this.render()};k.bi=function(){this.render()};
k.gm=function(){this.B&&(Hc(this.B),this.B=null);this.D&&(Hc(this.D),this.D=null);var a=this.$();a&&(this.a.setAttribute("data-view",w(a)),this.B=z(a,"propertychange",this.bi,this),this.D=z(a,"change",this.bi,this));this.render()};k.Ml=function(){this.C&&(this.C.forEach(Hc),this.C=null);var a=this.dc();a&&(this.C=[z(a,"propertychange",this.render,this),z(a,"change",this.render,this)]);this.render()};k.ah=function(){this.j&&cancelAnimationFrame(this.j);this.U()};
k.render=function(){void 0===this.j&&(this.j=requestAnimationFrame(this.U))};k.Vg=function(a){return this.controls.remove(a)};k.Xg=function(a){return this.interactions.remove(a)};k.Yg=function(a){return this.dc().yd().remove(a)};k.Zg=function(a){return this.l.remove(a)};
k.Wp=function(a){var b,c=this.zb(),d=this.$(),e=Pa(),f=this.c,g=null;if(void 0!==c&&0<c[0]&&0<c[1]&&d&&Wf(d)){g=Yf(d,this.c?this.c.viewHints:void 0);var h=this.dc().eg(),l={};var m=0;for(b=h.length;m<b;++m)l[w(h[m].layer)]=h[m];m=d.getState();g={animate:!1,attributions:{},coordinateToPixelTransform:this.Va,extent:e,focus:this.I?this.I:m.center,index:this.ab++,layerStates:l,layerStatesArray:h,logos:tb({},this.gd),pixelRatio:this.Jd,pixelToCoordinateTransform:this.If,postRenderFunctions:[],size:c,skippedFeatureUids:this.T,
tileQueue:this.ma,time:a,usedTiles:{},viewState:m,viewHints:g,wantedTiles:{}}}g&&(g.extent=ob(m.center,m.resolution,m.rotation,g.size,e));this.c=g;this.lc.$g(g);g&&(g.animate&&this.render(),Array.prototype.push.apply(this.oa,g.postRenderFunctions),!f||this.g&&(kb(this.g)||cb(g.extent,this.g))||(this.b(new ed("movestart",this,f)),this.g=Za(this.g)),!this.g||g.viewHints[0]||g.viewHints[1]||cb(g.extent,this.g)||(this.b(new ed("moveend",this,g)),Sa(g.extent,this.g)));this.b(new ed("postrender",this,g));
setTimeout(this.Zl.bind(this),0)};k.zf=function(a){this.set("layergroup",a)};k.ke=function(a){this.set("size",a)};k.vd=function(a){this.set("target",a)};k.hh=function(a){this.set("view",a)};k.Mj=function(a){a=w(a).toString();this.T[a]=!0;this.render()};
k.Gc=function(){var a=this.wc();if(a){var b=getComputedStyle(a);this.ke([a.offsetWidth-parseFloat(b.borderLeftWidth)-parseFloat(b.paddingLeft)-parseFloat(b.paddingRight)-parseFloat(b.borderRightWidth),a.offsetHeight-parseFloat(b.borderTopWidth)-parseFloat(b.paddingTop)-parseFloat(b.paddingBottom)-parseFloat(b.borderBottomWidth)])}else this.ke(void 0)};k.Rj=function(a){a=w(a).toString();delete this.T[a];this.render()};var pg=["canvas","webgl"];
function og(a){var b=null;void 0!==a.keyboardEventTarget&&(b="string"===typeof a.keyboardEventTarget?document.getElementById(a.keyboardEventTarget):a.keyboardEventTarget);var c={},d={};if(void 0===a.logo||"boolean"===typeof a.logo&&a.logo)d["data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAHGAAABxgEXwfpGAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAhNQTFRF////AP//AICAgP//AFVVQECA////K1VVSbbbYL/fJ05idsTYJFtbbcjbJllmZszWWMTOIFhoHlNiZszTa9DdUcHNHlNlV8XRIVdiasrUHlZjIVZjaMnVH1RlIFRkH1RkH1ZlasvYasvXVsPQH1VkacnVa8vWIVZjIFRjVMPQa8rXIVVkXsXRsNveIFVkIFZlIVVj3eDeh6GmbMvXH1ZkIFRka8rWbMvXIFVkIFVjIFVkbMvWH1VjbMvWIFVlbcvWIFVla8vVIFVkbMvWbMvVH1VkbMvWIFVlbcvWIFVkbcvVbMvWjNPbIFVkU8LPwMzNIFVkbczWIFVkbsvWbMvXIFVkRnB8bcvW2+TkW8XRIFVkIlZlJVloJlpoKlxrLl9tMmJwOWd0Omh1RXF8TneCT3iDUHiDU8LPVMLPVcLPVcPQVsPPVsPQV8PQWMTQWsTQW8TQXMXSXsXRX4SNX8bSYMfTYcfTYsfTY8jUZcfSZsnUaIqTacrVasrVa8jTa8rWbI2VbMvWbcvWdJObdcvUdszUd8vVeJaee87Yfc3WgJyjhqGnitDYjaarldPZnrK2oNbborW5o9bbo9fbpLa6q9ndrL3ArtndscDDutzfu8fJwN7gwt7gxc/QyuHhy+HizeHi0NfX0+Pj19zb1+Tj2uXk29/e3uLg3+Lh3+bl4uXj4ufl4+fl5Ofl5ufl5ujm5+jmySDnBAAAAFp0Uk5TAAECAgMEBAYHCA0NDg4UGRogIiMmKSssLzU7PkJJT1JTVFliY2hrdHZ3foSFhYeJjY2QkpugqbG1tre5w8zQ09XY3uXn6+zx8vT09vf4+Pj5+fr6/P39/f3+gz7SsAAAAVVJREFUOMtjYKA7EBDnwCPLrObS1BRiLoJLnte6CQy8FLHLCzs2QUG4FjZ5GbcmBDDjxJBXDWxCBrb8aM4zbkIDzpLYnAcE9VXlJSWlZRU13koIeW57mGx5XjoMZEUqwxWYQaQbSzLSkYGfKFSe0QMsX5WbjgY0YS4MBplemI4BdGBW+DQ11eZiymfqQuXZIjqwyadPNoSZ4L+0FVM6e+oGI6g8a9iKNT3o8kVzNkzRg5lgl7p4wyRUL9Yt2jAxVh6mQCogae6GmflI8p0r13VFWTHBQ0rWPW7ahgWVcPm+9cuLoyy4kCJDzCm6d8PSFoh0zvQNC5OjDJhQopPPJqph1doJBUD5tnkbZiUEqaCnB3bTqLTFG1bPn71kw4b+GFdpLElKIzRxxgYgWNYc5SCENVHKeUaltHdXx0dZ8uBI1hJ2UUDgq82CM2MwKeibqAvSO7MCABq0wXEPiqWEAAAAAElFTkSuQmCC"]=
"https://openlayers.org/";else{var e=a.logo;"string"===typeof e?d[e]="":e instanceof HTMLElement?d[w(e).toString()]=e:e&&(wa("string"==typeof e.href,44),wa("string"==typeof e.src,45),d[e.src]=e.href)}e=a.layers instanceof ig?a.layers:new ig({layers:a.layers});c.layergroup=e;c.target=a.target;c.view=void 0!==a.view?a.view:new F;var f;void 0!==a.renderer?(Array.isArray(a.renderer)?f=a.renderer:"string"===typeof a.renderer?f=[a.renderer]:wa(!1,46),0<=f.indexOf("dom")&&(f=f.concat(pg))):f=pg;e=0;var g=
f.length;a:for(;e<g;++e)for(var h=f[e],l=0,m=kg.length;l<m;++l){var n=kg[l];if(n.handles(h)){var p=n;break a}}if(!p)throw Error("Unable to create a map renderer for types: "+f.join(", "));if(void 0!==a.controls)if(Array.isArray(a.controls))var q=new C(a.controls.slice());else wa(a.controls instanceof C,47),q=a.controls;if(void 0!==a.interactions)if(Array.isArray(a.interactions))var r=new C(a.interactions.slice());else wa(a.interactions instanceof C,48),r=a.interactions;void 0!==a.overlays?Array.isArray(a.overlays)?
a=new C(a.overlays.slice()):(wa(a.overlays instanceof C,49),a=a.overlays):a=new C;return{controls:q,interactions:r,keyboardEventTarget:b,logos:d,overlays:a,om:p,values:c}};function qg(a){Wc.call(this);this.element=a.element?a.element:null;this.a=this.T=null;this.v=[];this.render=a.render?a.render:sa;a.target&&this.i(a.target)}v(qg,Wc);qg.prototype.ka=function(){fg(this.element);Wc.prototype.ka.call(this)};qg.prototype.g=function(){return this.a};
qg.prototype.setMap=function(a){this.a&&fg(this.element);for(var b=0,c=this.v.length;b<c;++b)Hc(this.v[b]);this.v.length=0;if(this.a=a)(this.T?this.T:a.v).appendChild(this.element),this.render!==sa&&this.v.push(z(a,"postrender",this.render,this)),a.render()};qg.prototype.i=function(a){this.T="string"===typeof a?document.getElementById(a):a};function rg(a){a=a?a:{};this.I=document.createElement("UL");this.s=document.createElement("LI");this.I.appendChild(this.s);this.s.style.display="none";this.c=void 0!==a.collapsed?a.collapsed:!0;this.l=void 0!==a.collapsible?a.collapsible:!0;this.l||(this.c=!1);var b=void 0!==a.className?a.className:"ol-attribution",c=void 0!==a.tipLabel?a.tipLabel:"Attributions",d=void 0!==a.collapseLabel?a.collapseLabel:"\u00bb";"string"===typeof d?(this.C=document.createElement("span"),this.C.textContent=d):this.C=
d;d=void 0!==a.label?a.label:"i";"string"===typeof d?(this.D=document.createElement("span"),this.D.textContent=d):this.D=d;var e=this.l&&!this.c?this.C:this.D;d=document.createElement("button");d.setAttribute("type","button");d.title=c;d.appendChild(e);z(d,"click",this.en,this);c=document.createElement("div");c.className=b+" ol-unselectable ol-control"+(this.c&&this.l?" ol-collapsed":"")+(this.l?"":" ol-uncollapsible");c.appendChild(this.I);c.appendChild(d);qg.call(this,{element:c,render:a.render?
a.render:sg,target:a.target});this.B=!0;this.o={};this.j={};this.U={}}v(rg,qg);
function sg(a){if(a=a.frameState){var b,c,d,e,f,g=a.layerStatesArray,h=tb({},a.attributions),l={},m={},n=a.viewState.projection;var p=0;for(b=g.length;p<b;p++)if(e=g[p].layer.ia()){var q=w(e).toString();if(f=e.j){var r=0;for(c=f.length;r<c;r++){var u=f[r];var x=w(u).toString();if(!(x in h)){if(d=a.usedTiles[q]){var B=e.Xa(n);a:{var A=void 0;var y,N=u,ca=B,la=n;if(N.a){for(A in d)if(A in N.a){B=d[A];var fa=0;for(y=N.a[A].length;fa<y;++fa){var va=N.a[A][fa];if(Ba(va,B)){A=!0;break a}var ra=tc(ca,Dc(la),
parseInt(A,10)),T=ra.da-ra.ba+1;if(B.ba<ra.ba||B.da>ra.da)if(Ba(va,new xa(Ja(B.ba,T),Ja(B.da,T),B.ea,B.ga))||B.da-B.ba+1>T&&Ba(va,ra)){A=!0;break a}}}A=!1}else A=!0}}else A=!1;A?(x in l&&delete l[x],A=u.b,A in m||(m[A]=!0,h[x]=u)):l[x]=u}}}}b=[h,l];p=b[0];b=b[1];for(var U in this.o)U in p?(this.j[U]||(this.o[U].style.display="",this.j[U]=!0),delete p[U]):U in b?(this.j[U]&&(this.o[U].style.display="none",delete this.j[U]),delete b[U]):(fg(this.o[U]),delete this.o[U],delete this.j[U]);for(U in p)r=
document.createElement("LI"),r.innerHTML=p[U].b,this.I.appendChild(r),this.o[U]=r,this.j[U]=!0;for(U in b)r=document.createElement("LI"),r.innerHTML=b[U].b,r.style.display="none",this.I.appendChild(r),this.o[U]=r;U=!wb(this.j)||!wb(a.logos);this.B!=U&&(this.element.style.display=U?"":"none",this.B=U);U&&wb(this.j)?this.element.classList.add("ol-logo-only"):this.element.classList.remove("ol-logo-only");a=a.logos;U=this.U;for(Ca in U)Ca in a||(fg(U[Ca]),delete U[Ca]);for(var Xb in a)if(b=a[Xb],b instanceof
HTMLElement&&(this.s.appendChild(b),U[Xb]=b),!(Xb in U)){var Ca=new Image;Ca.src=Xb;""===b?p=Ca:(p=document.createElement("a"),p.href=b,p.appendChild(Ca));this.s.appendChild(p);U[Xb]=p}this.s.style.display=wb(a)?"none":""}else this.B&&(this.element.style.display="none",this.B=!1)}k=rg.prototype;k.en=function(a){a.preventDefault();tg(this)};function tg(a){a.element.classList.toggle("ol-collapsed");a.c?eg(a.C,a.D):eg(a.D,a.C);a.c=!a.c}k.dn=function(){return this.l};
k.gn=function(a){this.l!==a&&(this.l=a,this.element.classList.toggle("ol-uncollapsible"),!a&&this.c&&tg(this))};k.fn=function(a){this.l&&this.c!==a&&tg(this)};k.cn=function(){return this.c};function ug(a){a=a?a:{};var b=void 0!==a.className?a.className:"ol-rotate",c=void 0!==a.label?a.label:"\u21e7";this.c=null;"string"===typeof c?(this.c=document.createElement("span"),this.c.className="ol-compass",this.c.textContent=c):(this.c=c,this.c.classList.add("ol-compass"));var d=a.tipLabel?a.tipLabel:"Reset rotation";c=document.createElement("button");c.className=b+"-reset";c.setAttribute("type","button");c.title=d;c.appendChild(this.c);z(c,"click",ug.prototype.C,this);d=document.createElement("div");
d.className=b+" ol-unselectable ol-control";d.appendChild(c);b=a.render?a.render:vg;this.l=a.resetNorth?a.resetNorth:void 0;qg.call(this,{element:d,render:b,target:a.target});this.o=void 0!==a.duration?a.duration:250;this.j=void 0!==a.autoHide?a.autoHide:!0;this.s=void 0;this.j&&this.element.classList.add("ol-hidden")}v(ug,qg);ug.prototype.C=function(a){a.preventDefault();this.l?this.l():(a=this.a.$())&&void 0!==a.Pa()&&(0<this.o?a.animate({rotation:0,duration:this.o,easing:Me}):a.de(0))};
function vg(a){if(a=a.frameState){a=a.viewState.rotation;if(a!=this.s){var b="rotate("+a+"rad)";if(this.j){var c=this.element.classList.contains("ol-hidden");c||0!==a?c&&0!==a&&this.element.classList.remove("ol-hidden"):this.element.classList.add("ol-hidden")}this.c.style.msTransform=b;this.c.style.webkitTransform=b;this.c.style.transform=b}this.s=a}};function wg(a){a=a?a:{};var b=void 0!==a.className?a.className:"ol-zoom",c=void 0!==a.delta?a.delta:1,d=void 0!==a.zoomInLabel?a.zoomInLabel:"+",e=void 0!==a.zoomOutLabel?a.zoomOutLabel:"\u2212",f=void 0!==a.zoomInTipLabel?a.zoomInTipLabel:"Zoom in",g=void 0!==a.zoomOutTipLabel?a.zoomOutTipLabel:"Zoom out",h=document.createElement("button");h.className=b+"-in";h.setAttribute("type","button");h.title=f;h.appendChild("string"===typeof d?document.createTextNode(d):d);z(h,"click",wg.prototype.j.bind(this,
c));d=document.createElement("button");d.className=b+"-out";d.setAttribute("type","button");d.title=g;d.appendChild("string"===typeof e?document.createTextNode(e):e);z(d,"click",wg.prototype.j.bind(this,-c));c=document.createElement("div");c.className=b+" ol-unselectable ol-control";c.appendChild(h);c.appendChild(d);qg.call(this,{element:c,target:a.target});this.c=void 0!==a.duration?a.duration:250}v(wg,qg);
wg.prototype.j=function(a,b){b.preventDefault();if(b=this.a.$()){var c=b.Oa();c&&(a=b.constrainResolution(c,a),0<this.c?(b.Pc()&&b.kd(),b.animate({resolution:a,duration:this.c,easing:Me})):b.ad(a))}};function xg(a){a=a?a:{};var b=new C;(void 0!==a.zoom?a.zoom:1)&&b.push(new wg(a.zoomOptions));(void 0!==a.rotate?a.rotate:1)&&b.push(new ug(a.rotateOptions));(void 0!==a.attribution?a.attribution:1)&&b.push(new rg(a.attributionOptions));return b};function yg(a,b,c){this.i=a;this.c=b;this.g=c;this.b=[];this.a=this.f=0}function zg(a){a.b.length=0;a.f=0;a.a=0}function Ag(a){if(6>a.b.length)return!1;var b=Date.now()-a.g,c=a.b.length-3;if(a.b[c+2]<b)return!1;for(var d=c-3;0<d&&a.b[d+2]>b;)d-=3;b=a.b[c+2]-a.b[d+2];if(b<1E3/60)return!1;var e=a.b[c]-a.b[d];c=a.b[c+1]-a.b[d+1];a.f=Math.atan2(c,e);a.a=Math.sqrt(e*e+c*c)/b;return a.a>a.c};function Bg(a){Wc.call(this);this.v=null;this.Ga(!0);this.handleEvent=a.handleEvent}v(Bg,Wc);Bg.prototype.c=function(){return this.get("active")};Bg.prototype.i=function(){return this.v};Bg.prototype.Ga=function(a){this.set("active",a)};Bg.prototype.setMap=function(a){this.v=a};function Eg(a,b,c,d){if(void 0!==b){var e=a.Pa(),f=a.xa();void 0!==e&&f&&0<d?a.animate({rotation:b,anchor:c,duration:d,easing:Me}):a.rotate(b,c)}}
function Fg(a,b,c,d){var e=a.Oa();b=a.constrainResolution(e,b,0);if(c&&void 0!==b&&b!==e){var f=a.xa();c=Zf(a,b,c);c=a.Kc(c);c=[(b*f[0]-e*c[0])/(b-e),(b*f[1]-e*c[1])/(b-e)]}Gg(a,b,c,d)}function Gg(a,b,c,d){if(b){var e=a.Oa(),f=a.xa();void 0!==e&&f&&b!==e&&d?a.animate({resolution:b,anchor:c,duration:d,easing:Me}):(c&&(c=Zf(a,b,c),a.rb(c)),a.ad(b))}};function Hg(a){a=a?a:{};this.a=a.delta?a.delta:1;Bg.call(this,{handleEvent:Ig});this.g=void 0!==a.duration?a.duration:250}v(Hg,Bg);function Ig(a){var b=!1,c=a.originalEvent;if("dblclick"==a.type){b=a.coordinate;c=c.shiftKey?-this.a:this.a;var d=a.map.$();Fg(d,c,b,this.g);a.preventDefault();b=!0}return!b};function Jg(a){a=a.originalEvent;return a.altKey&&!(a.metaKey||a.ctrlKey)&&!a.shiftKey}function Kg(a){a=a.originalEvent;return a.altKey&&!(a.metaKey||a.ctrlKey)&&a.shiftKey}function Lg(a){a=a.originalEvent;return 0==a.button&&!(nd&&od&&a.ctrlKey)}function Mg(a){return"pointermove"==a.type}function Ng(a){return"singleclick"==a.type}function Og(a){a=a.originalEvent;return!a.altKey&&!(a.metaKey||a.ctrlKey)&&!a.shiftKey}
function Pg(a){a=a.originalEvent;return!a.altKey&&!(a.metaKey||a.ctrlKey)&&a.shiftKey}function Qg(a){a=a.originalEvent.target.tagName;return"INPUT"!==a&&"SELECT"!==a&&"TEXTAREA"!==a}function Rg(a){wa(a.b,56);return"mouse"==a.b.pointerType}function Sg(a){a=a.b;return a.isPrimary&&0===a.button};function Tg(a){a=a?a:{};Bg.call(this,{handleEvent:a.handleEvent?a.handleEvent:Ug});this.Vj=a.handleDownEvent?a.handleDownEvent:Qe;this.wk=a.handleDragEvent?a.handleDragEvent:sa;this.Ck=a.handleMoveEvent?a.handleMoveEvent:sa;this.Dk=a.handleUpEvent?a.handleUpEvent:Qe;this.C=!1;this.ta={};this.l=[]}v(Tg,Bg);function Vg(a){for(var b=a.length,c=0,d=0,e=0;e<b;e++)c+=a[e].clientX,d+=a[e].clientY;return[c/b,d/b]}
function Ug(a){if(!(a instanceof Dd))return!0;var b=!1,c=a.type;if("pointerdown"===c||"pointerdrag"===c||"pointerup"===c){c=a.b;var d=c.pointerId.toString();"pointerup"==a.type?delete this.ta[d]:"pointerdown"==a.type?this.ta[d]=c:d in this.ta&&(this.ta[d]=c);this.l=vb(this.ta)}this.C?"pointerdrag"==a.type?this.wk(a):"pointerup"==a.type&&(this.C=this.Dk(a)&&0<this.l.length):"pointerdown"==a.type?(this.C=a=this.Vj(a),b=this.cd(a)):"pointermove"==a.type&&this.Ck(a);return!b}Tg.prototype.cd=function(a){return a};function Wg(a){Tg.call(this,{handleDownEvent:Xg,handleDragEvent:Yg,handleUpEvent:Zg});a=a?a:{};this.a=a.kinetic;this.g=null;this.s=a.condition?a.condition:Og;this.j=!1}v(Wg,Tg);function Yg(a){var b=this.l,c=Vg(b);if(b.length==this.o){if(this.a&&this.a.b.push(c[0],c[1],Date.now()),this.g){var d=this.g[0]-c[0],e=c[1]-this.g[1];a=a.map.$();var f=a.getState();d=[d,e];Fe(d,f.resolution);Ee(d,f.rotation);ye(d,f.center);d=a.Kc(d);a.rb(d)}}else this.a&&zg(this.a);this.g=c;this.o=b.length}
function Zg(a){var b=a.map;a=b.$();if(0===this.l.length){if(!this.j&&this.a&&Ag(this.a)){var c=this.a;c=(c.c-c.a)/c.i;var d=this.a.f,e=a.xa();e=b.Ha(e);b=b.Na([e[0]-c*Math.cos(d),e[1]-c*Math.sin(d)]);a.animate({center:a.Kc(b),duration:500,easing:Me})}Xf(a,1,-1);return!1}this.a&&zg(this.a);this.g=null;return!0}
function Xg(a){if(0<this.l.length&&this.s(a)){var b=a.map.$();this.g=null;this.C||Xf(b,1,1);Yf(b)[0]&&b.rb(a.frameState.viewState.center);this.a&&zg(this.a);this.j=1<this.l.length;return!0}return!1}Wg.prototype.cd=Qe;function $g(a){a=a?a:{};Tg.call(this,{handleDownEvent:ah,handleDragEvent:bh,handleUpEvent:ch});this.g=a.condition?a.condition:Kg;this.a=void 0;this.j=void 0!==a.duration?a.duration:250}v($g,Tg);function bh(a){if(Rg(a)){var b=a.map,c=b.$();if(c.g.rotation!==se){b=b.zb();a=a.pixel;a=Math.atan2(b[1]/2-a[1],a[0]-b[0]/2);if(void 0!==this.a){b=a-this.a;var d=c.Pa();Eg(c,d-b)}this.a=a}}}
function ch(a){if(!Rg(a))return!0;a=a.map.$();Xf(a,1,-1);var b=a.Pa(),c=this.j;b=a.constrainRotation(b,0);Eg(a,b,void 0,c);return!1}function ah(a){return Rg(a)&&Lg(a)&&this.g(a)?(Xf(a.map.$(),1,1),this.a=void 0,!0):!1}$g.prototype.cd=Qe;function dh(a){this.Nc=null;this.a=document.createElement("div");this.a.style.position="absolute";this.a.className="ol-box "+a;this.f=this.c=this.b=null}v(dh,Pc);dh.prototype.ka=function(){this.setMap(null)};function eh(a){var b=a.c,c=a.f;a=a.a.style;a.left=Math.min(b[0],c[0])+"px";a.top=Math.min(b[1],c[1])+"px";a.width=Math.abs(c[0]-b[0])+"px";a.height=Math.abs(c[1]-b[1])+"px"}
dh.prototype.setMap=function(a){if(this.b){this.b.s.removeChild(this.a);var b=this.a.style;b.left=b.top=b.width=b.height="inherit"}(this.b=a)&&this.b.s.appendChild(this.a)};function fh(a){var b=a.c,c=a.f;b=[b,[b[0],c[1]],c,[c[0],b[1]]].map(a.b.Na,a.b);b[4]=b[0].slice();a.Nc?a.Nc.na([b]):a.Nc=new E([b])}dh.prototype.W=function(){return this.Nc};function gh(a){Tg.call(this,{handleDownEvent:hh,handleDragEvent:ih,handleUpEvent:jh});a=a?a:{};this.a=new dh(a.className||"ol-dragbox");this.s=void 0!==a.minArea?a.minArea:64;this.g=null;this.D=a.condition?a.condition:Pe;this.o=a.boxEndCondition?a.boxEndCondition:kh}v(gh,Tg);function kh(a,b,c){a=c[0]-b[0];b=c[1]-b[1];return a*a+b*b>=this.s}function ih(a){if(Rg(a)){var b=this.a,c=a.pixel;b.c=this.g;b.f=c;fh(b);eh(b);this.b(new lh(mh,a.coordinate,a))}}gh.prototype.W=function(){return this.a.W()};
gh.prototype.j=sa;function jh(a){if(!Rg(a))return!0;this.a.setMap(null);this.o(a,this.g,a.pixel)&&(this.j(a),this.b(new lh(nh,a.coordinate,a)));return!1}function hh(a){if(Rg(a)&&Lg(a)&&this.D(a)){this.g=a.pixel;this.a.setMap(a.map);var b=this.a,c=this.g;b.c=this.g;b.f=c;fh(b);eh(b);this.b(new lh(oh,a.coordinate,a));return!0}return!1}var oh="boxstart",mh="boxdrag",nh="boxend";function lh(a,b,c){Rc.call(this,a);this.coordinate=b;this.mapBrowserEvent=c}v(lh,Rc);function ph(a){a=a?a:{};var b=a.condition?a.condition:Pg;this.B=void 0!==a.duration?a.duration:200;this.I=void 0!==a.out?a.out:!1;gh.call(this,{condition:b,className:a.className||"ol-dragzoom"})}v(ph,gh);
ph.prototype.j=function(){var a=this.v,b=a.$(),c=a.zb(),d=this.W().G();if(this.I){var e=b.jd(c);d=[a.Ha(fb(d)),a.Ha(hb(d))];a=Za(void 0);var f;var g=0;for(f=d.length;g<f;++g)Qa(a,d[g]);d=b.Ke(a,c);rb(e,1/d);d=e}c=b.constrainResolution(b.Ke(d,c));e=nb(d);e=b.Kc(e);b.animate({resolution:c,center:e,duration:this.B,easing:Me})};function qh(a){Bg.call(this,{handleEvent:rh});a=a||{};this.a=function(a){return Og(a)&&Qg(a)};this.g=a.condition?a.condition:this.a;this.j=void 0!==a.duration?a.duration:100;this.l=void 0!==a.pixelDelta?a.pixelDelta:128}v(qh,Bg);
function rh(a){var b=!1;if("keydown"==a.type){var c=a.originalEvent.keyCode;if(this.g(a)&&(40==c||37==c||39==c||38==c)){b=a.map.$();var d=b.Oa()*this.l,e=0,f=0;40==c?f=-d:37==c?e=-d:39==c?e=d:f=d;d=[e,f];Ee(d,b.Pa());c=this.j;if(e=b.xa())d=b.Kc([e[0]+d[0],e[1]+d[1]]),c?b.animate({duration:c,easing:Oe,center:d}):b.rb(d);a.preventDefault();b=!0}}return!b};function th(a){Bg.call(this,{handleEvent:uh});a=a?a:{};this.g=a.condition?a.condition:Qg;this.a=a.delta?a.delta:1;this.j=void 0!==a.duration?a.duration:100}v(th,Bg);function uh(a){var b=!1;if("keydown"==a.type||"keypress"==a.type){var c=a.originalEvent.charCode;!this.g(a)||43!=c&&45!=c||(b=43==c?this.a:-this.a,c=a.map.$(),Fg(c,b,void 0,this.j),a.preventDefault(),b=!0)}return!b};function vh(a){Bg.call(this,{handleEvent:wh});a=a||{};this.j=0;this.C=void 0!==a.duration?a.duration:250;this.ta=void 0!==a.timeout?a.timeout:80;this.D=void 0!==a.useAnchor?a.useAnchor:!0;this.T=a.constrainResolution||!1;this.a=null;this.o=this.l=this.s=this.g=void 0}v(vh,Bg);
function wh(a){var b=a.type;if("wheel"!==b&&"mousewheel"!==b)return!0;a.preventDefault();b=a.map;var c=a.originalEvent;this.D&&(this.a=a.coordinate);if("wheel"==a.type){var d=c.deltaY;kd&&c.deltaMode===WheelEvent.DOM_DELTA_PIXEL&&(d/=pd);c.deltaMode===WheelEvent.DOM_DELTA_LINE&&(d*=40)}else"mousewheel"==a.type&&(d=-c.wheelDeltaY,ld&&(d/=3));if(0===d)return!1;a=Date.now();void 0===this.g&&(this.g=a);if(!this.l||400<a-this.g)this.l=4>Math.abs(d)?xh:yh;if(this.l===xh){b=b.$();this.o?clearTimeout(this.o):
Xf(b,1,1);this.o=setTimeout(this.B.bind(this),400);c=b.Oa()*Math.pow(2,d/300);var e=b.i,f=b.a,g=0;c<e?(c=Math.max(c,e/1.5),g=1):c>f&&(c=Math.min(c,1.5*f),g=-1);if(this.a){var h=Zf(b,c,this.a);b.rb(b.Kc(h))}b.ad(c);0===g&&this.T&&b.animate({resolution:b.constrainResolution(c,0<d?-1:1),easing:Me,anchor:this.a,duration:this.C});0<g?b.animate({resolution:e,easing:Me,anchor:this.a,duration:500}):0>g&&b.animate({resolution:f,easing:Me,anchor:this.a,duration:500});this.g=a;return!1}this.j+=d;d=Math.max(this.ta-
(a-this.g),0);clearTimeout(this.s);this.s=setTimeout(this.I.bind(this,b),d);return!1}vh.prototype.B=function(){this.o=void 0;Xf(this.v.$(),1,-1)};vh.prototype.I=function(a){a=a.$();a.Pc()&&a.kd();Fg(a,-Da(this.j,-1,1),this.a,this.C);this.l=void 0;this.j=0;this.a=null;this.s=this.g=void 0};vh.prototype.U=function(a){this.D=a;a||(this.a=null)};var xh="trackpad",yh="wheel";function zh(a){Tg.call(this,{handleDownEvent:Ah,handleDragEvent:Bh,handleUpEvent:Ch});a=a||{};this.g=null;this.j=void 0;this.a=!1;this.o=0;this.D=void 0!==a.threshold?a.threshold:.3;this.s=void 0!==a.duration?a.duration:250}v(zh,Tg);
function Bh(a){var b=0,c=this.l[0],d=this.l[1];c=Math.atan2(d.clientY-c.clientY,d.clientX-c.clientX);void 0!==this.j&&(b=c-this.j,this.o+=b,!this.a&&Math.abs(this.o)>this.D&&(this.a=!0));this.j=c;a=a.map;c=a.$();if(c.g.rotation!==se){d=a.a.getBoundingClientRect();var e=Vg(this.l);e[0]-=d.left;e[1]-=d.top;this.g=a.Na(e);this.a&&(d=c.Pa(),a.render(),Eg(c,d+b,this.g))}}
function Ch(a){if(2>this.l.length){a=a.map.$();Xf(a,1,-1);if(this.a){var b=a.Pa(),c=this.g,d=this.s;b=a.constrainRotation(b,0);Eg(a,b,c,d)}return!1}return!0}function Ah(a){return 2<=this.l.length?(a=a.map,this.g=null,this.j=void 0,this.a=!1,this.o=0,this.C||Xf(a.$(),1,1),!0):!1}zh.prototype.cd=Qe;function Dh(a){Tg.call(this,{handleDownEvent:Eh,handleDragEvent:Fh,handleUpEvent:Gh});a=a?a:{};this.o=a.constrainResolution||!1;this.g=null;this.s=void 0!==a.duration?a.duration:400;this.a=void 0;this.j=1}v(Dh,Tg);
function Fh(a){var b=1,c=this.l[0],d=this.l[1],e=c.clientX-d.clientX;c=c.clientY-d.clientY;e=Math.sqrt(e*e+c*c);void 0!==this.a&&(b=this.a/e);this.a=e;a=a.map;e=a.$();d=e.Oa();var f=e.a,g=e.i;c=d*b;c>f?(b=f/d,c=f):c<g&&(b=g/d,c=g);1!=b&&(this.j=b);b=a.a.getBoundingClientRect();d=Vg(this.l);d[0]-=b.left;d[1]-=b.top;this.g=a.Na(d);a.render();Gg(e,c,this.g)}
function Gh(a){if(2>this.l.length){a=a.map.$();Xf(a,1,-1);var b=a.Oa();if(this.o||b<a.i||b>a.a){var c=this.g,d=this.s;b=a.constrainResolution(b,0,this.j-1);Gg(a,b,c,d)}return!1}return!0}function Eh(a){return 2<=this.l.length?(a=a.map,this.g=null,this.a=void 0,this.j=1,this.C||Xf(a.$(),1,1),!0):!1}Dh.prototype.cd=Qe;function Hh(a){a=a?a:{};var b=new C,c=new yg(-.005,.05,100);(void 0!==a.altShiftDragRotate?a.altShiftDragRotate:1)&&b.push(new $g);(void 0!==a.doubleClickZoom?a.doubleClickZoom:1)&&b.push(new Hg({delta:a.zoomDelta,duration:a.zoomDuration}));(void 0!==a.dragPan?a.dragPan:1)&&b.push(new Wg({kinetic:c}));(void 0!==a.pinchRotate?a.pinchRotate:1)&&b.push(new zh);(void 0!==a.pinchZoom?a.pinchZoom:1)&&b.push(new Dh({constrainResolution:a.constrainResolution,duration:a.zoomDuration}));if(void 0!==a.keyboard?
a.keyboard:1)b.push(new qh),b.push(new th({delta:a.zoomDelta,duration:a.zoomDuration}));(void 0!==a.mouseWheelZoom?a.mouseWheelZoom:1)&&b.push(new vh({constrainResolution:a.constrainResolution,duration:a.zoomDuration}));(void 0!==a.shiftDragZoom?a.shiftDragZoom:1)&&b.push(new ph({duration:a.zoomDuration}));return b};function Ih(a,b,c,d,e){Rc.call(this,a);this.vectorContext=b;this.frameState=c;this.context=d;this.glContext=e}v(Ih,Rc);var Jh=[0,0,0,1],Kh=[],Lh=[0,0,0,1];function Mh(a,b,c,d){0!==b&&(a.translate(c,d),a.rotate(b),a.translate(-c,-d))};var Nh=/^#(?:[0-9a-f]{3}){1,2}$/i,Oh=/^([a-z]*)$/i;function Ph(a){return Array.isArray(a)?a:Qh(a)}function Rh(a){if("string"!==typeof a){var b=a[0];b!=(b|0)&&(b=b+.5|0);var c=a[1];c!=(c|0)&&(c=c+.5|0);var d=a[2];d!=(d|0)&&(d=d+.5|0);a="rgba("+b+","+c+","+d+","+(void 0===a[3]?1:a[3])+")"}return a}
var Qh=function(){var a={},b=0;return function(c){if(a.hasOwnProperty(c))var d=a[c];else{if(1024<=b){d=0;for(var e in a)0===(d++&3)&&(delete a[e],--b)}d=c;Oh.exec(d)&&(e=document.createElement("div"),e.style.color=d,document.body.appendChild(e),d=getComputedStyle(e).color,document.body.removeChild(e));if(Nh.exec(d)){var f=d.length-1;wa(3==f||6==f,54);var g=3==f?1:2;f=parseInt(d.substr(1+0*g,g),16);e=parseInt(d.substr(1+1*g,g),16);d=parseInt(d.substr(1+2*g,g),16);1==g&&(f=(f<<4)+f,e=(e<<4)+e,d=(d<<
4)+d);f=[f,e,d,1]}else 0==d.indexOf("rgba(")?(d=d.slice(5,-1).split(",").map(Number),f=Sh(d)):0==d.indexOf("rgb(")?(d=d.slice(4,-1).split(",").map(Number),d.push(1),f=Sh(d)):wa(!1,14);d=f;a[c]=d;++b}return d}}();function Sh(a){var b=[];b[0]=Da(a[0]+.5|0,0,255);b[1]=Da(a[1]+.5|0,0,255);b[2]=Da(a[2]+.5|0,0,255);b[3]=Da(a[3],0,1);return b};function Th(a){return"string"===typeof a||a instanceof CanvasPattern||a instanceof CanvasGradient?a:Rh(a)};function Uh(){}k=Uh.prototype;k.Eh=function(){};k.Fb=function(){};k.zd=function(){};k.$b=function(){};k.Fe=function(){};k.Ge=function(){};k.qc=function(){};k.rc=function(){};k.sc=function(){};k.tc=function(){};k.uc=function(){};k.vc=function(){};k.Sb=function(){};k.La=function(){};k.Wb=function(){};k.ib=function(){};function Vh(a,b,c,d,e){this.f=a;this.g=b;this.c=c;this.O=d;this.Lb=e;this.N=this.b=this.a=this.Ua=this.T=this.I=null;this.ta=this.U=this.v=this.B=this.D=this.C=0;this.fa=!1;this.i=this.kb=0;this.ma=!1;this.ra=0;this.qa="";this.oc=this.oa=0;this.Va=!1;this.l=this.ab=0;this.sa=this.o=this.j=null;this.s=[];this.ub=Ue()}v(Vh,Uh);
function Wh(a,b,c){if(a.N){b=Re(b,0,c,2,a.O,a.s);c=a.f;var d=a.ub,e=c.globalAlpha;1!=a.v&&(c.globalAlpha=e*a.v);var f=a.kb;a.fa&&(f+=a.Lb);var g;var h=0;for(g=b.length;h<g;h+=2){var l=b[h]-a.C,m=b[h+1]-a.D;a.ma&&(l=Math.round(l),m=Math.round(m));if(0!==f||1!=a.i){var n=l+a.C,p=m+a.D;cf(d,n,p,a.i,a.i,f,-n,-p);c.setTransform.apply(c,d)}c.drawImage(a.N,a.U,a.ta,a.ra,a.B,l,m,a.ra,a.B)}0===f&&1==a.i||c.setTransform(1,0,0,1,0,0);1!=a.v&&(c.globalAlpha=e)}}
function Xh(a,b,c,d){var e=0;if(a.sa&&""!==a.qa){a.j&&Yh(a,a.j);a.o&&Zh(a,a.o);var f=a.sa,g=a.f,h=a.Ua,l=f.textAlign?f.textAlign:"center";h?(h.font!=f.font&&(h.font=g.font=f.font),h.textAlign!=l&&(h.textAlign=l),h.textBaseline!=f.textBaseline&&(h.textBaseline=g.textBaseline=f.textBaseline)):(g.font=f.font,g.textAlign=l,g.textBaseline=f.textBaseline,a.Ua={font:f.font,textAlign:l,textBaseline:f.textBaseline});b=Re(b,e,c,d,a.O,a.s);f=a.f;g=a.ab;for(a.Va&&(g+=a.Lb);e<c;e+=d){h=b[e]+a.oa;l=b[e+1]+a.oc;
if(0!==g||1!=a.l){var m=cf(a.ub,h,l,a.l,a.l,g,-h,-l);f.setTransform.apply(f,m)}a.o&&f.strokeText(a.qa,h,l);a.j&&f.fillText(a.qa,h,l)}0===g&&1==a.l||f.setTransform(1,0,0,1,0,0)}}function $h(a,b,c,d,e,f){var g=a.f;a=Re(b,c,d,e,a.O,a.s);g.moveTo(a[0],a[1]);b=a.length;f&&(b-=2);for(c=2;c<b;c+=2)g.lineTo(a[c],a[c+1]);f&&g.closePath();return d}function ai(a,b,c,d,e){var f;var g=0;for(f=d.length;g<f;++g)c=$h(a,b,c,d[g],e,!0);return c}k=Vh.prototype;
k.$b=function(a){if(qb(this.c,a.G())){if(this.a||this.b){this.a&&Yh(this,this.a);this.b&&Zh(this,this.b);var b=this.O;var c=this.s,d=a.ca();b=d?Re(d,0,d.length,a.pa(),b,c):null;c=b[2]-b[0];d=b[3]-b[1];c=Math.sqrt(c*c+d*d);d=this.f;d.beginPath();d.arc(b[0],b[1],c,0,2*Math.PI);this.a&&d.fill();this.b&&d.stroke()}""!==this.qa&&Xh(this,a.xa(),2,2)}};k.zd=function(a){this.La(a.Ca(),a.Da());this.Wb(a.Y());this.ib(a.Ia())};
k.Fb=function(a){switch(a.S()){case "Point":this.uc(a);break;case "LineString":this.qc(a);break;case "Polygon":this.vc(a);break;case "MultiPoint":this.sc(a);break;case "MultiLineString":this.rc(a);break;case "MultiPolygon":this.tc(a);break;case "GeometryCollection":this.Ge(a);break;case "Circle":this.$b(a)}};k.Fe=function(a,b){(a=(0,b.Za)(a))&&qb(this.c,a.G())&&(this.zd(b),this.Fb(a))};k.Ge=function(a){a=a.a;var b;var c=0;for(b=a.length;c<b;++c)this.Fb(a[c])};
k.uc=function(a){var b=a.ca();a=a.pa();this.N&&Wh(this,b,b.length);""!==this.qa&&Xh(this,b,b.length,a)};k.sc=function(a){var b=a.ca();a=a.pa();this.N&&Wh(this,b,b.length);""!==this.qa&&Xh(this,b,b.length,a)};k.qc=function(a){if(qb(this.c,a.G())){if(this.b){Zh(this,this.b);var b=this.f,c=a.ca();b.beginPath();$h(this,c,0,c.length,a.pa(),!1);b.stroke()}""!==this.qa&&(a=bi(a),Xh(this,a,2,2))}};
k.rc=function(a){var b=a.G();if(qb(this.c,b)){if(this.b){Zh(this,this.b);b=this.f;var c=a.ca(),d=0,e=a.lb(),f=a.pa();b.beginPath();var g;var h=0;for(g=e.length;h<g;++h)d=$h(this,c,d,e[h],f,!1);b.stroke()}""!==this.qa&&(a=ci(a),Xh(this,a,a.length,2))}};k.vc=function(a){if(qb(this.c,a.G())){if(this.b||this.a){this.a&&Yh(this,this.a);this.b&&Zh(this,this.b);var b=this.f;b.beginPath();ai(this,a.Ub(),0,a.lb(),a.pa());this.a&&b.fill();this.b&&b.stroke()}""!==this.qa&&(a=Pf(a),Xh(this,a,2,2))}};
k.tc=function(a){if(qb(this.c,a.G())){if(this.b||this.a){this.a&&Yh(this,this.a);this.b&&Zh(this,this.b);var b=this.f,c=di(a),d=0,e=a.md(),f=a.pa(),g;b.beginPath();var h=0;for(g=e.length;h<g;++h)d=ai(this,c,d,e[h],f);this.a&&b.fill();this.b&&b.stroke()}""!==this.qa&&(a=ei(a),Xh(this,a,a.length,2))}};function Yh(a,b){var c=a.f,d=a.I;d?d.fillStyle!=b.fillStyle&&(d.fillStyle=c.fillStyle=b.fillStyle):(c.fillStyle=b.fillStyle,a.I={fillStyle:b.fillStyle})}
function Zh(a,b){var c=a.f,d=a.T;d?(d.lineCap!=b.lineCap&&(d.lineCap=c.lineCap=b.lineCap),qd&&(ma(d.lineDash,b.lineDash)||c.setLineDash(d.lineDash=b.lineDash),d.lineDashOffset!=b.lineDashOffset&&(d.lineDashOffset=c.lineDashOffset=b.lineDashOffset)),d.lineJoin!=b.lineJoin&&(d.lineJoin=c.lineJoin=b.lineJoin),d.lineWidth!=b.lineWidth&&(d.lineWidth=c.lineWidth=b.lineWidth),d.miterLimit!=b.miterLimit&&(d.miterLimit=c.miterLimit=b.miterLimit),d.strokeStyle!=b.strokeStyle&&(d.strokeStyle=c.strokeStyle=b.strokeStyle)):
(c.lineCap=b.lineCap,qd&&(c.setLineDash(b.lineDash),c.lineDashOffset=b.lineDashOffset),c.lineJoin=b.lineJoin,c.lineWidth=b.lineWidth,c.miterLimit=b.miterLimit,c.strokeStyle=b.strokeStyle,a.T={lineCap:b.lineCap,lineDash:b.lineDash,lineDashOffset:b.lineDashOffset,lineJoin:b.lineJoin,lineWidth:b.lineWidth,miterLimit:b.miterLimit,strokeStyle:b.strokeStyle})}
k.La=function(a,b){a?(a=a.b,this.a={fillStyle:Th(a?a:Jh)}):this.a=null;if(b){a=b.b;var c=b.g,d=b.f,e=b.i,f=b.j,g=b.c;b=b.l;this.b={lineCap:void 0!==c?c:"round",lineDash:d?d:Kh,lineDashOffset:e?e:0,lineJoin:void 0!==f?f:"round",lineWidth:this.g*(void 0!==g?g:1),miterLimit:void 0!==b?b:10,strokeStyle:Th(a?a:Lh)}}else this.b=null};
k.Wb=function(a){if(a){var b=a.Oc(),c=a.Y(1),d=a.Vc(),e=a.kc();this.C=b[0];this.D=b[1];this.B=e[1];this.N=c;this.v=a.i;this.U=d[0];this.ta=d[1];this.fa=a.o;this.kb=a.g;this.i=a.a*this.g;this.ma=a.v;this.ra=e[0]}else this.N=null};
k.ib=function(a){if(a){var b=a.Ca();b?(b=b.b,this.j={fillStyle:Th(b?b:Jh)}):this.j=null;var c=a.Da();if(c){b=c.b;var d=c.g,e=c.f,f=c.i,g=c.j,h=c.c;c=c.l;this.o={lineCap:void 0!==d?d:"round",lineDash:e?e:Kh,lineDashOffset:f?f:0,lineJoin:void 0!==g?g:"round",lineWidth:void 0!==h?h:1,miterLimit:void 0!==c?c:10,strokeStyle:Th(b?b:Lh)}}else this.o=null;b=a.a;d=a.f;e=a.c;f=a.l;g=a.i;h=a.b;c=a.Ia();var l=a.g;a=a.j;this.sa={font:void 0!==b?b:"10px sans-serif",textAlign:void 0!==l?l:"center",textBaseline:void 0!==
a?a:"middle"};this.qa=void 0!==c?c:"";this.oa=void 0!==d?this.g*d:0;this.oc=void 0!==e?this.g*e:0;this.Va=void 0!==f?f:!1;this.ab=void 0!==g?g:0;this.l=this.g*(void 0!==h?h:1)}else this.qa=""};function fi(a){Vc.call(this);this.a=a}v(fi,Vc);fi.prototype.Fa=sa;fi.prototype.df=Qe;fi.prototype.Rf=function(a,b,c){return function(d,e){return gi(a,b,d,e,function(a){c[d]||(c[d]={});c[d][a.wa.toString()]=a})}};fi.prototype.ta=function(a){2===a.target.getState()&&hi(this)};function ii(a,b){var c=b.getState();2!=c&&3!=c&&z(b,"change",a.ta,a);0==c&&(b.load(),c=b.getState());return 2==c}function hi(a){var b=a.a;b.Tb()&&"ready"==b.ig()&&a.u()}
function ji(a,b){b.Xi()&&a.postRenderFunctions.push(function(a,b,e){b=w(a).toString();b in e.usedTiles&&a.ld(e.viewState.projection,e.usedTiles[b])}.bind(null,b))}function ki(a,b){if(b){var c;var d=0;for(c=b.length;d<c;++d){var e=b[d];a[w(e).toString()]=e}}}function li(a,b){b=b.D;void 0!==b&&("string"===typeof b?a.logos[b]="":b&&(wa("string"==typeof b.href,44),wa("string"==typeof b.src,45),a.logos[b.src]=b.href))}
function mi(a,b,c,d){b=w(b).toString();c=c.toString();b in a?c in a[b]?(a=a[b][c],d.ba<a.ba&&(a.ba=d.ba),d.da>a.da&&(a.da=d.da),d.ea<a.ea&&(a.ea=d.ea),d.ga>a.ga&&(a.ga=d.ga)):a[b][c]=d:(a[b]={},a[b][c]=d)}
function ni(a,b,c,d,e,f,g,h,l,m){var n=w(b).toString();n in a.wantedTiles||(a.wantedTiles[n]={});var p=a.wantedTiles[n];a=a.tileQueue;var q,r,u;for(u=c.minZoom;u<=g;++u){var x=tc(c,f,u,x);var B=c.Qa(u);for(q=x.ba;q<=x.da;++q)for(r=x.ea;r<=x.ga;++r)if(g-u<=h){var A=b.Uc(u,q,r,d,e);0==A.getState()&&(p[A.gb()]=!0,A.gb()in a.a||a.i([A,n,yc(c,A.wa),B]));l&&l.call(m,A)}else b.ih(u,q,r,e)}};function oi(a){fi.call(this,a);this.T=Ue()}v(oi,fi);function pi(a,b,c){var d=b.pixelRatio,e=b.size[0]*d,f=b.size[1]*d,g=b.viewState.rotation,h=ib(c),l=hb(c),m=gb(c);c=fb(c);Ze(b.coordinateToPixelTransform,h);Ze(b.coordinateToPixelTransform,l);Ze(b.coordinateToPixelTransform,m);Ze(b.coordinateToPixelTransform,c);a.save();Mh(a,-g,e/2,f/2);a.beginPath();a.moveTo(h[0]*d,h[1]*d);a.lineTo(l[0]*d,l[1]*d);a.lineTo(m[0]*d,m[1]*d);a.lineTo(c[0]*d,c[1]*d);a.clip();Mh(a,g,e/2,f/2)}
function qi(a,b,c,d,e){var f=a.a;if(Uc(f,b)){var g=d.size[0]*d.pixelRatio,h=d.size[1]*d.pixelRatio,l=d.viewState.rotation;Mh(c,-l,g/2,h/2);a=e?e:ri(a,d,0);f.b(new Ih(b,new Vh(c,d.pixelRatio,d.extent,a,d.viewState.rotation),d,c,null));Mh(c,l,g/2,h/2)}}oi.prototype.o=function(a,b,c,d){if(this.Fa(a,b,0,Pe,this))return c.call(d,this.a,null)};oi.prototype.pf=function(a,b,c,d){qi(this,"postcompose",a,b,d)};
function ri(a,b,c){var d=b.viewState,e=b.pixelRatio,f=e/d.resolution;return cf(a.T,e*b.size[0]/2,e*b.size[1]/2,f,-f,-d.rotation,-d.center[0]+c,-d.center[1])};function si(a){oi.call(this,a);this.l=Ue();this.j=null}v(si,oi);si.prototype.v=function(a,b,c){qi(this,"precompose",c,a,void 0);var d=this.Y();if(d){var e=b.extent,f=void 0!==e&&!Wa(e,a.extent)&&qb(e,a.extent);f&&pi(c,a,e);e=this.s();var g=c.globalAlpha;c.globalAlpha=b.opacity;c.drawImage(d,0,0,+d.width,+d.height,Math.round(e[4]),Math.round(e[5]),Math.round(d.width*e[0]),Math.round(d.height*e[3]));c.globalAlpha=g;f&&c.restore()}this.pf(c,a,b)};
si.prototype.Fa=function(a,b,c,d,e){var f=this.a;return f.ia().Fa(a,b.viewState.resolution,b.viewState.rotation,c,b.skippedFeatureUids,function(a){return d.call(e,a,f)})};
si.prototype.o=function(a,b,c,d){if(this.Y()){if(this.a.ia().Fa!==sa)return oi.prototype.o.apply(this,arguments);var e=Ze(this.l,a.slice());Fe(e,b.viewState.resolution/this.i);this.j||(this.j=dg(1,1));this.j.clearRect(0,0,1,1);this.j.drawImage(this.Y(),e[0],e[1],1,1,0,0,1,1);e=this.j.getImageData(0,0,1,1).data;if(0<e[3])return c.call(d,this.a,e)}};function vi(a){si.call(this,a);this.N=null;this.c=Ue()}v(vi,si);vi.handles=function(a,b){return"canvas"===a&&"IMAGE"===b.S()};vi.create=function(a,b){return new vi(b)};vi.prototype.Y=function(){return this.N?this.N.Y():null};vi.prototype.s=function(){return this.c};
vi.prototype.Ad=function(a,b){var c=a.pixelRatio,d=a.size,e=a.viewState,f=e.center,g=e.resolution,h=this.a.ia(),l=a.viewHints,m=a.extent;void 0!==b.extent&&(m=pb(m,b.extent));l[0]||l[1]||kb(m)||(b=h.Y(m,g,c,e.projection))&&ii(this,b)&&(this.N=b);if(this.N){b=this.N;m=b.G();e=b.resolution;l=b.a;var n=c*e/(g*l);m=cf(this.c,c*d[0]/2,c*d[1]/2,n,n,0,l*(m[0]-f[0])/e,l*(f[1]-m[3])/e);cf(this.l,c*d[0]/2-m[4],c*d[1]/2-m[5],c/g,-c/g,0,-f[0],-f[1]);ki(a.attributions,b.c);li(a,h);this.i=e*c/l}return!!this.N};function wi(a){var b=tb({},a);delete b.source;gg.call(this,b);this.s=this.o=this.l=null;a.map&&this.setMap(a.map);z(this,Yc("source"),this.cm,this);this.bd(a.source?a.source:null)}v(wi,gg);function xi(a,b){return a.visible&&b>=a.minResolution&&b<a.maxResolution}k=wi.prototype;k.eg=function(a){a=a?a:[];a.push(hg(this));return a};k.ia=function(){return this.get("source")||null};k.ig=function(){var a=this.ia();return a?a.getState():"undefined"};k.co=function(){this.u()};
k.cm=function(){this.s&&(Hc(this.s),this.s=null);var a=this.ia();a&&(this.s=z(a,"change",this.co,this));this.u()};k.setMap=function(a){this.l&&(Hc(this.l),this.l=null);a||this.u();this.o&&(Hc(this.o),this.o=null);a&&(this.l=z(a,"precompose",function(a){var b=hg(this);b.Ue=!1;b.zIndex=Infinity;a.frameState.layerStatesArray.push(b);a.frameState.layerStates[w(this)]=b},this),this.o=z(this,"change",a.render,a),this.u())};k.bd=function(a){this.set("source",a)};function yi(){this.b={};this.a=0}yi.prototype.clear=function(){this.b={};this.a=0};yi.prototype.get=function(a,b,c){a=b+":"+a+":"+(c?Rh(c):"null");return a in this.b?this.b[a]:null};yi.prototype.set=function(a,b,c,d){this.b[b+":"+a+":"+(c?Rh(c):"null")]=d;++this.a};var zi=new yi;function Ai(a,b){this.j=b;this.c={};this.o={}}v(Ai,Pc);function Bi(a){var b=a.viewState,c=a.coordinateToPixelTransform,d=a.pixelToCoordinateTransform;cf(c,a.size[0]/2,a.size[1]/2,1/b.resolution,-1/b.resolution,-b.rotation,-b.center[0],-b.center[1]);df(Ye(d,c))}k=Ai.prototype;k.ka=function(){for(var a in this.c)Qc(this.c[a])};function Ci(){if(32<zi.a){var a=0,b;for(b in zi.b){var c=zi.b[b];0!==(a++&3)||Uc(c)||(delete zi.b[b],--zi.a)}}}
k.Fa=function(a,b,c,d,e,f,g){function h(a,c){var f=w(a).toString(),g=b.layerStates[w(c)].Ue;if(!(f in b.skippedFeatureUids)||g)return d.call(e,a,g?c:null)}var l,m=b.viewState,n=m.resolution,p=m.projection;m=a;if(p.f){p=p.G();var q=lb(p),r=a[0];if(r<p[0]||r>p[2])m=[r+q*Math.ceil((p[0]-r)/q),a[1]]}p=b.layerStatesArray;for(q=p.length-1;0<=q;--q){var u=p[q];r=u.layer;if(xi(u,n)&&f.call(g,r)&&(u=Di(this,r),r.ia()&&(l=u.Fa(r.ia().C?m:a,b,c,h,e)),l))return l}};
k.Ri=function(a,b,c,d,e){return void 0!==this.Fa(a,b,c,Pe,this,d,e)};function Di(a,b){var c=w(b).toString();if(c in a.c)return a.c[c];for(var d,e=a.S(),f=0,g=lg.length;f<g;++f){var h=lg[f];if(h.handles(e,b)){d=h.create(a,b);break}}if(d)a.c[c]=d,a.o[c]=z(d,"change",a.Nl,a);else throw Error("Unable to create renderer for layer: "+b.S());return d}k.Nl=function(){this.j.render()};k.$g=sa;
k.Vp=function(a,b){for(var c in this.c)if(!(b&&c in b.layerStates)){a=c;var d=this.c[a];delete this.c[a];Hc(this.o[a]);delete this.o[a];Qc(d)}};function Ei(a,b){for(var c in a.c)if(!(c in b.layerStates)){b.postRenderFunctions.push(a.Vp.bind(a));break}}function oa(a,b){return a.zIndex-b.zIndex};function Fi(a,b){Ai.call(this,0,b);this.f=dg();this.b=this.f.canvas;this.b.style.width="100%";this.b.style.height="100%";this.b.style.display="block";this.b.className="ol-unselectable";a.insertBefore(this.b,a.childNodes[0]||null);this.a=!0;this.i=Ue()}v(Fi,Ai);Fi.handles=function(a){return"canvas"===a};Fi.create=function(a,b){return new Fi(a,b)};
function Gi(a,b,c){var d=a.j,e=a.f;if(Uc(d,b)){var f=c.extent,g=c.pixelRatio,h=c.viewState.rotation,l=c.viewState,m=c.pixelRatio/l.resolution;a=cf(a.i,a.b.width/2,a.b.height/2,m,-m,-l.rotation,-l.center[0],-l.center[1]);d.b(new Ih(b,new Vh(e,g,f,a,h),c,e,null))}}Fi.prototype.S=function(){return"canvas"};
Fi.prototype.$g=function(a){if(a){var b=this.f,c=a.pixelRatio,d=Math.round(a.size[0]*c),e=Math.round(a.size[1]*c);this.b.width!=d||this.b.height!=e?(this.b.width=d,this.b.height=e):b.clearRect(0,0,d,e);c=a.viewState.rotation;Bi(a);Gi(this,"precompose",a);var f=a.layerStatesArray;na(f);c&&(b.save(),Mh(b,c,d/2,e/2));d=a.viewState.resolution;var g;e=0;for(g=f.length;e<g;++e){var h=f[e];var l=h.layer;l=Di(this,l);xi(h,d)&&"ready"==h.Nj&&l.Ad(a,h)&&l.v(a,h,b)}c&&b.restore();Gi(this,"postcompose",a);this.a||
(this.b.style.display="",this.a=!0);Ei(this,a);a.postRenderFunctions.push(Ci)}else this.a&&(this.b.style.display="none",this.a=!1)};Fi.prototype.Qi=function(a,b,c,d,e,f){var g=b.viewState.resolution,h=b.layerStatesArray,l=h.length;a=Ze(b.pixelToCoordinateTransform,a.slice());for(--l;0<=l;--l){var m=h[l];var n=m.layer;if(xi(m,g)&&e.call(f,n)&&(m=Di(this,n).o(a,b,c,d)))return m}};function Hi(a){si.call(this,a);this.context=null===this.context?null:dg();this.c=null;this.g=[];this.B=Pa();this.ma=new xa(0,0,0,0);this.O=Ue();this.I=0}v(Hi,si);Hi.handles=function(a,b){return"canvas"===a&&"TILE"===b.S()};Hi.create=function(a,b){return new Hi(b)};function Ii(a,b){b=b.getState();a=a.a.i();return 2==b||4==b||3==b&&!a}
Hi.prototype.Ad=function(a,b){var c=a.pixelRatio,d=a.size,e=a.viewState,f=e.projection,g=e.resolution;e=e.center;var h=this.a,l=h.ia(),m=l.f,n=l.Xa(f),p=n.xc(g,this.I),q=n.Qa(p),r=Math.round(g/q)||1,u=a.extent;void 0!==b.extent&&(u=pb(u,b.extent));if(kb(u))return!1;var x=tc(n,u,p),B=wc(n,p,x),A=l.Sc(c),y={};y[p]={};var N=this.Rf(l,f,y),ca=this.B,la=this.ma,fa=!1,va,ra;for(va=x.ba;va<=x.da;++va)for(ra=x.ea;ra<=x.ga;++ra){var T=l.Uc(p,va,ra,c,f);3==T.getState()&&(h.i()?0<h.c()&&(fa=!0):Ji(T,2));Ii(this,
T)||(T=Ki(T));if(Ii(this,T)){var U=w(this);if(2==T.getState()){y[p][T.wa.toString()]=T;var Xb=T.j?-1!==T.o[U]:!1;fa||!Xb&&-1!==this.g.indexOf(T)||(fa=!0)}if(1===Li(T,U,a.time))continue}U=vc(n,T.wa,la,ca);Xb=!1;U&&(Xb=N(p+1,U));Xb||uc(n,T.wa,N,la,ca)}T=a.viewHints;T=T[0]||T[1];if(!(this.i&&16<Date.now()-a.time&&T||!fa&&this.c&&Wa(this.c,u)&&this.wf==m&&r==this.D&&(T||q*c/A*r==this.i))){if(T=this.context)ra=l.be(p,c,f),va=Math.round((x.da-x.ba+1)*ra[0]/r),ra=Math.round((x.ga-x.ea+1)*ra[1]/r),fa=T.canvas,
fa.width!=va||fa.height!=ra?(this.D=r,fa.width=va,fa.height=ra):(this.c&&!cb(B,this.c)&&T.clearRect(0,0,va,ra),r=this.D);this.g.length=0;fa=Object.keys(y).map(Number);fa.sort(function(a,b){return a===p?1:b===p?-1:a>b?1:a<b?-1:0});U=0;for(Xb=fa.length;U<Xb;++U){la=fa[U];N=l.be(la,c,f);T=n.Qa(la);var Ca=T/q;var Cb=A*l.$f(f);var nc=y[la];for(var xd in nc){T=nc[xd];ra=n.Ja(T.wa,ca);va=(ra[0]-B[0])/q*A/r;ra=(B[3]-ra[3])/q*A/r;var Ec=N[0]*Ca/r;var md=N[1]*Ca/r;this.Sf(T,a,b,va,ra,Ec,md,Cb,p===la);this.g.push(T)}}this.wf=
m;this.i=q*c/A*r;this.c=B}b=this.i/g;b=cf(this.O,c*d[0]/2,c*d[1]/2,b,b,0,(this.c[0]-e[0])/this.i*c,(e[1]-this.c[3])/this.i*c);cf(this.l,c*d[0]/2-b[4],c*d[1]/2-b[5],c/g,-c/g,0,-e[0],-e[1]);mi(a.usedTiles,l,p,x);ni(a,l,n,c,f,u,p,h.c());ji(a,l);li(a,l);return 0<this.g.length};
Hi.prototype.Sf=function(a,b,c,d,e,f,g,h,l){if(c=a.Y(this.a)){var m=w(this),n=l?Li(a,m,b.time):1;1!==n||this.a.ia().fg(b.viewState.projection)||this.context.clearRect(d,e,f,g);var p=n!==this.context.globalAlpha;p&&(this.context.save(),this.context.globalAlpha=n);this.context.drawImage(c,h,h,c.width-2*h,c.height-2*h,d,e,f,g);p&&this.context.restore();1!==n?b.animate=!0:l&&a.j&&(a.o[m]=-1)}};Hi.prototype.Y=function(){var a=this.context;return a?a.canvas:null};Hi.prototype.s=function(){return this.O};function Mi(){};function Ni(a,b,c,d){var e=a[b],f=a[b+1],g=0;for(b+=d;b<c;b+=d){var h=a[b],l=a[b+1];g+=Math.sqrt((h-e)*(h-e)+(l-f)*(l-f));e=h;f=l}return g};function Oi(a,b,c,d,e){this.oa=a;this.Ua=b;this.overlaps=e;this.pixelRatio=d;this.c=0;this.resolution=c;this.sa=this.ra=null;this.a=[];this.coordinates=[];this.kb={};this.U=Ue();this.b=[];this.B=null;this.ma=Ue();this.ta=Ue();this.fa=[]}v(Oi,Uh);
function Pi(a,b,c,d,e,f,g,h,l,m,n,p,q,r,u){var x=a.ma;f*=q;g*=q;c-=f;d-=g;r&&(c=Math.round(c),d=Math.round(d));0!==p&&(f=c+f,g=d+g,cf(x,f,g,1,1,p,-f,-g),b.setTransform.apply(b,x));x=b.globalAlpha;1!=l&&(b.globalAlpha=x*l);u=u+m>e.width?e.width-m:u;h=h+n>e.height?e.height-n:h;b.drawImage(e,m,n,u,h,c,d,u*q,h*q);1!=l&&(b.globalAlpha=x);0!==p&&b.setTransform.apply(b,a.ta)}function Qi(a,b){var c=a.pixelRatio;return 1==c?b:b.map(function(a){return a*c})}
function Ri(a,b,c,d,e,f,g){var h=a.coordinates.length,l=a.Wf();g&&(c+=e);g=[b[c],b[c+1]];var m=[NaN,NaN],n=!0,p;for(p=c+e;p<d;p+=e){m[0]=b[p];m[1]=b[p+1];var q=Xa(l,m);q!==r?(n&&(a.coordinates[h++]=g[0],a.coordinates[h++]=g[1]),a.coordinates[h++]=m[0],a.coordinates[h++]=m[1],n=!1):1===q?(a.coordinates[h++]=m[0],a.coordinates[h++]=m[1],n=!1):n=!0;g[0]=m[0];g[1]=m[1];var r=q}if(f&&n||p===c+e)a.coordinates[h++]=g[0],a.coordinates[h++]=g[1];return h}
function Si(a,b,c,d,e,f){for(var g=0,h=d.length;g<h;++g){var l=d[g];c=Ri(a,b,c,l,e,!1,!1);f.push(c);c=l}return c}k=Oi.prototype;
k.Eh=function(a,b,c){Ti(this,b);var d=a.S(),e=a.pa(),f=this.coordinates.length,g;if("MultiPolygon"==d){d=di(a);var h=[];for(var l=a.md(),m=g=0,n=l.length;m<n;++m){var p=[];g=Si(this,d,g,l[m],e,p);h.push(p)}this.a.push([4,f,h,a,c,yf])}else"Polygon"==d||"MultiLineString"==d?(h=[],d="Polygon"==d?a.Ub():a.ca(),Si(this,d,0,a.lb(),e,h),this.a.push([4,f,h,a,c,xf])):"LineString"==d||"MultiPoint"==d?(d=a.ca(),e=Ri(this,d,0,d.length,e,!1,!1),this.a.push([4,f,e,a,c,wf])):"Point"==d&&(d=a.ca(),this.coordinates.push(d[0],
d[1]),e=this.coordinates.length,this.a.push([4,f,e,a,c]));Ui(this,b)};function Ti(a,b){a.ra=[0,b,0];a.a.push(a.ra);a.sa=[0,b,0];a.b.push(a.sa)}k.Wa=function(a,b){if(this.T){var c=Ze(this.U,this.T.slice());a.translate(c[0],c[1]);a.rotate(b)}a.fill();this.T&&a.setTransform.apply(a,this.ta)};
function Vi(a,b,c,d,e,f,g,h){if(a.B&&ma(c,a.U))var l=a.B;else a.B||(a.B=[]),l=Re(a.coordinates,0,a.coordinates.length,2,c,a.B),Ye(a.U,c);c=!wb(e);for(var m=0,n=f.length,p,q,r,u,x,B,A,y,N=0,ca=0,la=a.kb,fa={context:b,pixelRatio:a.pixelRatio,resolution:a.resolution,rotation:d},va=a.a!=f||a.overlaps?0:200;m<n;)switch(y=f[m],y[0]){case 0:var ra=y[1];c&&e[w(ra).toString()]||!ra.W()?m=y[2]:void 0===h||qb(h,ra.W().G())?++m:m=y[2]+1;break;case 1:N>va&&(a.Wa(b,d),N=0);ca>va&&(b.stroke(),ca=0);N||ca||(b.beginPath(),
x=B=NaN);++m;break;case 2:p=y[1];q=l[p];A=l[p+1];y=l[p+2]-q;p=l[p+3]-A;p=Math.sqrt(y*y+p*p);b.moveTo(q+p,A);b.arc(q,A,p,0,2*Math.PI,!0);++m;break;case 3:b.closePath();++m;break;case 4:p=y[1];q=y[2];A=y[4];r=6==y.length?y[5]:void 0;fa.geometry=y[3];fa.feature=ra;m in la||(la[m]=[]);y=la[m];r?r(l,p,q,2,y):(y[0]=l[p],y[1]=l[p+1],y.length=2);A(y,fa);++m;break;case 6:p=y[1];q=y[2];A=y[3];r=y[4];u=y[5];var T=y[6],U=y[7],Xb=y[8],Ca=y[9],Cb=y[11],nc=y[12],xd=y[13],Ec=y[14];for(y[10]&&(Cb+=d);p<q;p+=2)Pi(a,
b,l[p],l[p+1],A,r,u,T,U,Xb,Ca,Cb,nc,xd,Ec);++m;break;case 5:U=y[1];Xb=y[2];p=y[3];q=y[4];u=y[5];xd=y[6];Cb=y[7];A=y[8];r=y[9];nc=y[10];y=y[11];Ec=Ni(l,U,Xb,2);var md=Cb(r);if(u||md<=Ec){a:{T=void 0;u=l;Ca=r;nc=(Ec-md)*nc;md=(Ec=a.fa)?Ec:[];var sh=u[U]>u[Xb-2],kf=Ca.length,Je=u[U],Nf=u[U+1];U+=2;for(var Cg=u[U],Dg=u[U+1],pk=0,ti=Math.sqrt(Math.pow(Cg-Je,2)+Math.pow(Dg-Nf,2)),ui=0;ui<kf;++ui){Ec=sh?kf-ui-1:ui;for(var Go=Cb(Ca[Ec]),lf=nc+Go/2;U<Xb-2&&pk+ti<lf;)Je=Cg,Nf=Dg,U+=2,Cg=u[U],Dg=u[U+1],pk+=
ti,ti=Math.sqrt(Math.pow(Cg-Je,2)+Math.pow(Dg-Nf,2));var qk=lf-pk;lf=Math.atan2(Dg-Nf,Cg-Je);sh&&(lf+=0<lf?-Math.PI:Math.PI);if(void 0!==T&&(T=lf-T,T+=T>Math.PI?-2*Math.PI:T<-Math.PI?2*Math.PI:0,Math.abs(T)>xd)){T=null;break a}T=lf;qk/=ti;md[Ec]=[Ka(Je,Cg,qk),Ka(Nf,Dg,qk),lf];nc+=Go}T=md}U=r.length;if(T)for(Xb=p[p.length-1].height,Ca=0,Cb=p.length;Ca<Cb;++Ca)nc=T[Ca%U],xd=p[Ca],r=xd.width/2,u=q*xd.height+(.5-q)*(xd.height-Xb)-A,Pi(a,b,nc[0],nc[1],xd,r,u,xd.height,1,0,0,nc[2],y,!1,xd.width)}++m;break;
case 7:if(g&&(ra=y[1],p=g(ra)))return p;++m;break;case 8:va?N++:a.Wa(b,d);++m;break;case 9:p=y[1];q=y[2];r=l[p];u=l[p+1];A=r+.5|0;y=u+.5|0;if(A!==x||y!==B)b.moveTo(r,u),x=A,B=y;for(p+=2;p<q;p+=2)if(r=l[p],u=l[p+1],A=r+.5|0,y=u+.5|0,p==q-2||A!==x||y!==B)b.lineTo(r,u),x=A,B=y;++m;break;case 10:a.T=y[2];N&&(a.Wa(b,d),N=0,ca&&(b.stroke(),ca=0));b.fillStyle=y[1];++m;break;case 11:ca&&(b.stroke(),ca=0);b.strokeStyle=y[1];b.lineWidth=y[2];b.lineCap=y[3];b.lineJoin=y[4];b.miterLimit=y[5];qd&&(b.lineDashOffset=
y[7],b.setLineDash(y[6]));++m;break;case 12:va?ca++:b.stroke();++m;break;default:++m}N&&a.Wa(b,d);ca&&b.stroke()}k.Ka=function(a,b,c,d){Vi(this,a,b,c,d,this.a,void 0,void 0)};function Wi(a){var b=a.b;b.reverse();var c,d=b.length,e=-1;for(c=0;c<d;++c){var f=b[c];var g=f[0];if(7==g)e=c;else if(0==g){f[2]=c;f=a.b;for(g=c;e<g;){var h=f[e];f[e]=f[g];f[g]=h;++e;--g}e=-1}}}function Ui(a,b){a.ra[2]=a.a.length;a.ra=null;a.sa[2]=a.b.length;a.sa=null;b=[7,b];a.a.push(b);a.b.push(b)}k.cf=sa;k.Wf=function(){return this.Ua};function Xi(a,b,c,d,e){Oi.call(this,a,b,c,d,e);this.N=this.I=null;this.O=this.s=this.v=this.o=this.l=this.D=this.C=this.j=this.g=this.i=this.f=void 0}v(Xi,Oi);
Xi.prototype.uc=function(a,b){if(this.N){Ti(this,b);var c=a.ca(),d=this.coordinates.length;a=Ri(this,c,0,c.length,a.pa(),!1,!1);this.a.push([6,d,a,this.N,this.f,this.i,this.g,this.j,this.C,this.D,this.l,this.o,this.v*this.pixelRatio,this.s,this.O]);this.b.push([6,d,a,this.I,this.f,this.i,this.g,this.j,this.C,this.D,this.l,this.o,this.v,this.s,this.O]);Ui(this,b)}};
Xi.prototype.sc=function(a,b){if(this.N){Ti(this,b);var c=a.ca(),d=this.coordinates.length;a=Ri(this,c,0,c.length,a.pa(),!1,!1);this.a.push([6,d,a,this.N,this.f,this.i,this.g,this.j,this.C,this.D,this.l,this.o,this.v*this.pixelRatio,this.s,this.O]);this.b.push([6,d,a,this.I,this.f,this.i,this.g,this.j,this.C,this.D,this.l,this.o,this.v,this.s,this.O]);Ui(this,b)}};
Xi.prototype.cf=function(){Wi(this);this.i=this.f=void 0;this.N=this.I=null;this.O=this.s=this.o=this.l=this.D=this.C=this.j=this.v=this.g=void 0};Xi.prototype.Wb=function(a){var b=a.Oc(),c=a.kc(),d=a.Cg(1),e=a.Y(1),f=a.Vc();this.f=b[0];this.i=b[1];this.I=d;this.N=e;this.g=c[1];this.j=a.i;this.C=f[0];this.D=f[1];this.l=a.o;this.o=a.g;this.v=a.a;this.s=a.v;this.O=c[0]};function Yi(a,b,c,d,e){Oi.call(this,a,b,c,d,e);this.i=null;this.f={Rd:void 0,Ld:void 0,Md:null,Nd:void 0,Od:void 0,Pd:void 0,Qd:void 0,td:void 0,strokeStyle:void 0,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:void 0,miterLimit:void 0}}v(Yi,Oi);function Zi(a,b,c,d,e){var f=a.coordinates.length;b=Ri(a,b,c,d,e,!1,!1);f=[9,f,b];a.a.push(f);a.b.push(f);return d}k=Yi.prototype;
k.Wf=function(){this.i||(this.i=Sa(this.Ua),0<this.c&&Ra(this.i,this.resolution*(this.c+1)/2,this.i));return this.i};
function $i(a){var b=a.f,c=b.strokeStyle,d=b.lineCap,e=b.lineDash,f=b.lineDashOffset,g=b.lineJoin,h=b.lineWidth,l=b.miterLimit;b.Rd==c&&b.Ld==d&&ma(b.Md,e)&&b.Nd==f&&b.Od==g&&b.Pd==h&&b.Qd==l||(void 0!=b.td&&b.td!=a.coordinates.length&&(a.a.push([12]),b.td=a.coordinates.length),b.td=0,a.a.push([11,c,h*a.pixelRatio,d,g,l,Qi(a,e),f*a.pixelRatio],[1]),b.Rd=c,b.Ld=d,b.Md=e,b.Nd=f,b.Od=g,b.Pd=h,b.Qd=l)}
k.qc=function(a,b){var c=this.f,d=c.lineWidth;void 0!==c.strokeStyle&&void 0!==d&&($i(this),Ti(this,b),this.b.push([11,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset],[1]),c=a.ca(),Zi(this,c,0,c.length,a.pa()),this.b.push([12]),Ui(this,b))};
k.rc=function(a,b){var c=this.f,d=c.lineWidth;if(void 0!==c.strokeStyle&&void 0!==d){$i(this);Ti(this,b);this.b.push([11,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset],[1]);c=a.lb();d=a.ca();a=a.pa();var e=0,f;var g=0;for(f=c.length;g<f;++g)e=Zi(this,d,e,c[g],a);this.b.push([12]);Ui(this,b)}};k.cf=function(){var a=this.f;void 0!=a.td&&a.td!=this.coordinates.length&&this.a.push([12]);Wi(this);this.f=null};
k.La=function(a,b){a=b.b;this.f.strokeStyle=Th(a?a:Lh);a=b.g;this.f.lineCap=void 0!==a?a:"round";a=b.f;this.f.lineDash=a?a:Kh;a=b.i;this.f.lineDashOffset=a?a:0;a=b.j;this.f.lineJoin=void 0!==a?a:"round";a=b.c;this.f.lineWidth=void 0!==a?a:1;b=b.l;this.f.miterLimit=void 0!==b?b:10;this.f.lineWidth>this.c&&(this.c=this.f.lineWidth,this.i=null)};function aj(a,b,c,d,e){Oi.call(this,a,b,c,d,e);this.i=null;this.f={Ch:void 0,Rd:void 0,Ld:void 0,Md:null,Nd:void 0,Od:void 0,Pd:void 0,Qd:void 0,fillStyle:void 0,strokeStyle:void 0,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:void 0,miterLimit:void 0}}v(aj,Oi);
function bj(a,b,c,d,e){var f=a.f,g=void 0!==f.fillStyle;f=void 0!=f.strokeStyle;var h=d.length,l=[1];a.a.push(l);a.b.push(l);for(l=0;l<h;++l){var m=d[l],n=a.coordinates.length;c=Ri(a,b,c,m,e,!0,!f);c=[9,n,c];a.a.push(c);a.b.push(c);f&&(c=[3],a.a.push(c),a.b.push(c));c=m}b=[8];a.b.push(b);g&&a.a.push(b);f&&(g=[12],a.a.push(g),a.b.push(g));return c}k=aj.prototype;
k.$b=function(a,b){var c=this.f,d=c.strokeStyle;if(void 0!==c.fillStyle||void 0!==d){cj(this,a);Ti(this,b);this.b.push([10,Rh(Jh)]);void 0!==c.strokeStyle&&this.b.push([11,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset]);var e=a.ca();d=this.coordinates.length;Ri(this,e,0,e.length,a.pa(),!1,!1);a=[1];d=[2,d];this.a.push(a,d);this.b.push(a,d);a=[8];this.b.push(a);void 0!==c.fillStyle&&this.a.push(a);void 0!==c.strokeStyle&&(c=[12],this.a.push(c),this.b.push(c));
Ui(this,b)}};k.vc=function(a,b){var c=this.f;cj(this,a);Ti(this,b);this.b.push([10,Rh(Jh)]);void 0!==c.strokeStyle&&this.b.push([11,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset]);c=a.lb();var d=a.Ub();bj(this,d,0,c,a.pa());Ui(this,b)};
k.tc=function(a,b){var c=this.f,d=c.strokeStyle;if(void 0!==c.fillStyle||void 0!==d){cj(this,a);Ti(this,b);this.b.push([10,Rh(Jh)]);void 0!==c.strokeStyle&&this.b.push([11,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset]);c=a.md();d=di(a);a=a.pa();var e=0,f;var g=0;for(f=c.length;g<f;++g)e=bj(this,d,e,c[g],a);Ui(this,b)}};
k.cf=function(){Wi(this);this.f=null;var a=this.oa;if(0!==a){var b=this.coordinates,c;var d=0;for(c=b.length;d<c;++d)b[d]=a*Math.round(b[d]/a)}};k.Wf=function(){this.i||(this.i=Sa(this.Ua),0<this.c&&Ra(this.i,this.resolution*(this.c+1)/2,this.i));return this.i};
k.La=function(a,b){var c=this.f;a?(a=a.b,c.fillStyle=Th(a?a:Jh)):c.fillStyle=void 0;b?(a=b.b,c.strokeStyle=Th(a?a:Lh),a=b.g,c.lineCap=void 0!==a?a:"round",a=b.f,c.lineDash=a?a.slice():Kh,a=b.i,c.lineDashOffset=a?a:0,a=b.j,c.lineJoin=void 0!==a?a:"round",a=b.c,c.lineWidth=void 0!==a?a:1,b=b.l,c.miterLimit=void 0!==b?b:10,c.lineWidth>this.c&&(this.c=c.lineWidth,this.i=null)):(c.strokeStyle=void 0,c.lineCap=void 0,c.lineDash=null,c.lineDashOffset=void 0,c.lineJoin=void 0,c.lineWidth=void 0,c.miterLimit=
void 0)};function cj(a,b){var c=a.f,d=c.fillStyle,e=c.strokeStyle,f=c.lineCap,g=c.lineDash,h=c.lineDashOffset,l=c.lineJoin,m=c.lineWidth,n=c.miterLimit;if(void 0!==d&&("string"!==typeof d||c.Ch!=d)){var p=[10,d];"string"!==typeof d&&(b=b.G(),p.push([b[0],b[3]]));a.a.push(p);c.Ch=c.fillStyle}void 0===e||c.Rd==e&&c.Ld==f&&ma(c.Md,g)&&c.Nd==h&&c.Od==l&&c.Pd==m&&c.Qd==n||(a.a.push([11,e,m*a.pixelRatio,f,l,n,Qi(a,g),h*a.pixelRatio]),c.Rd=e,c.Ld=f,c.Md=g,c.Nd=h,c.Od=l,c.Pd=m,c.Qd=n)};var dj="Polygon Circle LineString Image Text Default".split(" "),ej={left:0,end:0,center:.5,right:1,start:1,top:0,middle:.5,hanging:.2,alphabetic:.8,ideographic:.8,bottom:1};function fj(a){this.highWaterMark=void 0!==a?a:2048;this.c=0;this.b={};this.f=this.a=null}function gj(a){return a.c>a.highWaterMark}k=fj.prototype;k.clear=function(){this.c=0;this.b={};this.f=this.a=null};k.forEach=function(a,b){for(var c=this.a;c;)a.call(b,c.Hc,c.fc,this),c=c.fb};k.get=function(a){a=this.b[a];wa(!!a,15);if(a===this.f)return a.Hc;a===this.a?(this.a=this.a.fb,this.a.Ob=null):(a.fb.Ob=a.Ob,a.Ob.fb=a.fb);a.fb=null;a.Ob=this.f;this.f=this.f.fb=a;return a.Hc};
k.remove=function(a){var b=this.b[a];wa(!!b,15);if(b===this.f){if(this.f=b.Ob)this.f.fb=null}else if(b===this.a){if(this.a=b.fb)this.a.Ob=null}else b.fb.Ob=b.Ob,b.Ob.fb=b.fb;delete this.b[a];--this.c;return b.Hc};k.pop=function(){var a=this.a;delete this.b[a.fc];a.fb&&(a.fb.Ob=null);this.a=a.fb;this.a||(this.f=null);--this.c;return a.Hc};k.replace=function(a,b){this.get(a);this.b[a].Hc=b};
k.set=function(a,b){wa(!(a in this.b),16);b={fc:a,fb:null,Ob:this.f,Hc:b};this.f?this.f.fb=b:this.a=b;this.f=b;this.b[a]=b;++this.c};function hj(a,b,c,d,e){Oi.call(this,a,b,c,d,e);this.qa="";this.l=this.o=0;this.v=void 0;this.j=this.s=0;this.g=this.f=this.i=null;for(this.C=this.O=this.D="";gj(ij);)ij.pop()}v(hj,Oi);var ij=new fj,jj=function(){var a;return function(b){a||(a=document.createElement("span"),a.textContent="M",a.style.visibility="hidden",a.style.whiteSpace="nowrap");a.style.font=b;document.body.appendChild(a);b=a.offsetHeight;document.body.removeChild(a);return b}}();
function kj(a,b,c){var d=this[c];d||(this[c]=d=a.measureText(c).width);return d*b}var lj=function(){var a;return function(b,c,d){a||(a=dg(1,1));a.font=b;b=c.length;var e=0,f;for(f=0;f<b;++f){var g=a.measureText(c[f]).width;e=Math.max(e,g);d.push(g)}return e}}();
hj.prototype.Sb=function(a,b){var c=this.i,d=this.f,e=this.g;if(""!==this.qa&&e&&(c||d)){var f=this.coordinates.length,g=a.S();c=null;var h=2;d=2;if("line"===this.g.placement){c=a.ca();d=a.pa();if("LineString"==g)var l=[c.length];else if("MultiLineString"==g)l=a.lb();else if("Polygon"==g)l=a.lb().slice(0,1);else if("MultiPolygon"==g){var m=a.md();l=[];a=0;for(g=m.length;a<g;++a)l.push(m[a][0])}Ti(this,b);a=e.textAlign;var n=0;m=0;for(g=l.length;m<g;++m){if(void 0==a){for(var p,q,r=void 0,u=void 0,
x=h=q=p=void 0,B=n,A=n,y=0,N=0,ca=n;n<l[m];n+=d){var la=c[n],fa=c[n+1];void 0!==q&&(q=la-q,p=fa-p,h=Math.sqrt(q*q+p*p),void 0!==u&&(N+=x,r=Math.acos((u*q+r*p)/(x*h)),r>e.maxAngle&&(N>y&&(y=N,B=ca,A=n),N=0,ca=n-d)),x=h,u=q,r=p);q=la;p=fa}h=N+h>y?[ca,n]:[B,A];n=h[0];h=h[1]}else h=l[m];h=Ri(this,c,n,h,d,!1,!1);n=l[m];B=h;A=this.pixelRatio;u=!!this.i;x=!!this.f;y=this.g;N=ej[y.textBaseline];ca=[];la=this.qa;fa=this.qa.length;if(x)for(r=0;r<fa;++r)ca.push(mj(this,la.charAt(r),!1,x));if(u)for(r=0;r<fa;++r)ca.push(mj(this,
la.charAt(r),u,!1));r=ca[0].getContext("2d");u=this.l*A;x=ej[y.textAlign||"center"];la={};this.a.push([5,f,B,ca,N,y.exceedLength,y.maxAngle,kj.bind(la,r,A*this.j),u,this.qa,x,1]);this.b.push([5,f,B,ca,N,y.exceedLength,y.maxAngle,kj.bind(la,r,this.j),u,this.qa,x,1/A]);f=h}}else{l=mj(this,this.qa,!!this.i,!!this.f);m=l.width/this.pixelRatio;switch(g){case "Point":case "MultiPoint":c=a.ca();h=c.length;break;case "LineString":c=bi(a);break;case "Circle":c=a.xa();break;case "MultiLineString":c=ci(a);h=
c.length;break;case "Polygon":c=Pf(a);if(!e.exceedLength&&c[2]/this.resolution<m)return;d=3;break;case "MultiPolygon":n=ei(a);c=[];a=0;for(g=n.length;a<g;a+=3)(e.exceedLength||n[a+2]/this.resolution>=m)&&c.push(n[a],n[a+1]);h=c.length;if(0==h)return}h=Ri(this,c,0,h,d,!1,!1);Ti(this,b);e=f;c=h;m=this.g;g=this.f;d=this.pixelRatio;a=ej[m.textAlign||"center"];m=ej[m.textBaseline];g=g&&g.lineWidth?g.lineWidth:0;a=a*l.width/d+2*(.5-a)*g;m=m*l.height/d+2*(.5-m)*g;this.a.push([6,e,c,l,(a-this.o)*d,(m-this.l)*
d,l.height,1,0,0,this.v,this.s,1,!0,l.width]);this.b.push([6,e,c,l,(a-this.o)*d,(m-this.l)*d,l.height,1,0,0,this.v,this.s,1/d,!0,l.width])}Ui(this,b)}};
function mj(a,b,c,d){var e=(d?a.C:"")+a.D+b+(c?a.O:"");b=b.split("\n");var f=b.length;if(!ij.b.hasOwnProperty(e)){var g=a.f,h=a.i,l=a.g,m=a.j*a.pixelRatio,n=ej[l.textAlign||"center"];a=d&&g.lineWidth?g.lineWidth:0;var p=[],q=lj(l.font,b,p),r=jj(l.font);q=dg(Math.ceil((q+a)*m),Math.ceil((r*f+a)*m));var u=q.canvas;ij.set(e,u);q.scale(m,m);q.font=l.font;d&&(q.strokeStyle=g.strokeStyle,q.lineWidth=a*(ld?m:1),q.lineCap=g.lineCap,q.lineJoin=g.lineJoin,q.miterLimit=g.miterLimit,qd&&(q.setLineDash(g.lineDash),
q.lineDashOffset=g.lineDashOffset));c&&(q.fillStyle=h.fillStyle);q.textBaseline="top";q.textAlign="center";g=.5-n;h=n*u.width/m+g*a;if(d)for(d=0;d<f;++d)q.strokeText(b[d],h+g*p[d],.5*a+d*r);if(c)for(d=0;d<f;++d)q.fillText(b[d],h+g*p[d],.5*a+d*r)}return ij.get(e)}
hj.prototype.ib=function(a){var b;if(a){if(b=a.Ca()){b=b.b;var c=Th(b?b:Jh);b=this.i;b||(b=this.i={});b.fillStyle=c}else b=this.i=null;var d=a.Da();if(d){c=d.b;var e=d.g;var f=d.f,g=d.i,h=d.j,l=d.c;d=d.l;f=f?f.slice():Kh;var m=Th(c?c:Lh);c=this.f;c||(c=this.f={});c.lineCap=void 0!==e?e:"round";c.lineDash=f;c.lineDashOffset=void 0!==g?g:0;c.lineJoin=void 0!==h?h:"round";c.lineWidth=void 0!==l?l:1;c.miterLimit=void 0!==d?d:10;c.strokeStyle=m}else c=this.f=null;g=a.a;h=a.f;l=a.c;d=a.l;f=a.i;m=a.b;var n=
a.Ia(),p=a.g,q=a.j;e=this.g;e||(e=this.g={});e.exceedLength=a.o;e.font=void 0!==g?g:"10px sans-serif";e.maxAngle=a.v;e.placement=a.s;e.textAlign=p;e.textBaseline=void 0!==q?q:"middle";this.qa=void 0!==n?n:"";this.o=void 0!==h?h:0;this.l=void 0!==l?l:0;this.v=void 0!==d?d:!1;this.s=void 0!==f?f:0;this.j=void 0!==m?m:1;this.C=c?("string"==typeof c.strokeStyle?c.strokeStyle:w(c.strokeStyle))+c.lineCap+c.lineDashOffset+"|"+c.lineWidth+c.lineJoin+c.miterLimit+"["+c.lineDash.join()+"]":"";this.D=e.font+
(e.textAlign||"?")+this.j;this.O=b?"string"==typeof b.fillStyle?b.fillStyle:"|"+w(b.fillStyle):""}else this.qa=""};function nj(a,b,c,d,e,f){this.s=a;this.f=b;this.l=e;this.o=d;this.v=c;this.i=f;this.a={};this.g=dg(1,1);this.j=Ue()}v(nj,Mi);var oj={0:[[!0]]};function pj(a,b,c){var d,e=Math.floor(a.length/2);if(b>=e)for(d=e;d<b;d++)a[d][c]=!0;else if(b<e)for(d=b+1;d<e;d++)a[d][c]=!0}
function qj(a){if(void 0!==oj[a])return oj[a];for(var b=2*a+1,c=Array(b),d=0;d<b;d++)c[d]=Array(b);b=a;for(var e=d=0;b>=d;)pj(c,a+b,a+d),pj(c,a+d,a+b),pj(c,a-d,a+b),pj(c,a-b,a+d),pj(c,a-b,a-d),pj(c,a-d,a-b),pj(c,a+d,a-b),pj(c,a+b,a-d),d++,e+=1+2*d,0<2*(e-b)+1&&(--b,e+=1-2*b);return oj[a]=c}function rj(a){for(var b in a.a){var c=a.a[b],d;for(d in c)c[d].cf()}}
nj.prototype.Fa=function(a,b,c,d,e,f){d=Math.round(d);var g=2*d+1,h=cf(this.j,d+.5,d+.5,1/b,-1/b,-c,-a[0],-a[1]),l=this.g;l.canvas.width!==g||l.canvas.height!==g?(l.canvas.width=g,l.canvas.height=g):l.clearRect(0,0,g,g);if(void 0!==this.i){var m=Pa();Qa(m,a);Ra(m,b*(this.i+d),m)}var n=qj(d);return sj(this,l,h,c,e,function(a){for(var b=l.getImageData(0,0,g,g).data,c=0;c<g;c++)for(var d=0;d<g;d++)if(n[c][d]&&0<b[4*(d*g+c)+3]){if(a=f(a))return a;l.clearRect(0,0,g,g);return}},m)};
function tj(a,b){var c=a.f;a=c[0];var d=c[1],e=c[2];c=c[3];a=[a,d,a,c,e,c,e,d];Re(a,0,8,2,b,a);return a}nj.prototype.b=function(a,b){var c=void 0!==a?a.toString():"0";a=this.a[c];void 0===a&&(a={},this.a[c]=a);c=a[b];void 0===c&&(c=new uj[b](this.s,this.f,this.v,this.o,this.l),a[b]=c);return c};nj.prototype.c=function(){return wb(this.a)};
nj.prototype.Ka=function(a,b,c,d,e){var f=Object.keys(this.a).map(Number);f.sort(ea);var g=tj(this,b);a.save();a.beginPath();a.moveTo(g[0],g[1]);a.lineTo(g[2],g[3]);a.lineTo(g[4],g[5]);a.lineTo(g[6],g[7]);a.clip();e=e?e:dj;var h,l;g=0;for(h=f.length;g<h;++g){var m=this.a[f[g].toString()];var n=0;for(l=e.length;n<l;++n){var p=m[e[n]];void 0!==p&&p.Ka(a,b,c,d)}}a.restore()};
function sj(a,b,c,d,e,f,g){var h=Object.keys(a.a).map(Number);h.sort(function(a,b){return b-a});var l,m;var n=0;for(l=h.length;n<l;++n){var p=a.a[h[n].toString()];for(m=dj.length-1;0<=m;--m){var q=p[dj[m]];if(void 0!==q&&(q=Vi(q,b,c,d,e,q.b,f,g)))return q}}}var uj={Circle:aj,Default:Oi,Image:Xi,LineString:Yi,Polygon:aj,Text:hj};function vj(a,b){return w(a)-w(b)}function wj(a,b){a=.5*a/b;return a*a}function xj(a,b,c,d,e,f){var g=!1,h;if(h=c.Y()){var l=h.gf();2==l||3==l?h.Qj(e,f):(0==l&&h.load(),h.di(e,f),g=!0)}if(e=(0,c.Za)(b))if(d=e.Zd(d),c.Je())yj(a,d,c,b);else(0,zj[d.S()])(a,d,c,b);return g}function yj(a,b,c,d){if("GeometryCollection"==b.S()){b=b.pd();for(var e=0,f=b.length;e<f;++e)yj(a,b[e],c,d)}else a.b(c.za(),"Default").Eh(b,d,c.Je())}
var zj={Point:function(a,b,c,d){var e=c.Y();if(e){if(2!=e.gf())return;var f=a.b(c.za(),"Image");f.Wb(e);f.uc(b,d)}if(e=c.Ia())a=a.b(c.za(),"Text"),a.ib(e),a.Sb(b,d)},LineString:function(a,b,c,d){var e=c.Da();if(e){var f=a.b(c.za(),"LineString");f.La(null,e);f.qc(b,d)}if(e=c.Ia())a=a.b(c.za(),"Text"),a.ib(e),a.Sb(b,d)},Polygon:function(a,b,c,d){var e=c.Ca(),f=c.Da();if(e||f){var g=a.b(c.za(),"Polygon");g.La(e,f);g.vc(b,d)}if(e=c.Ia())a=a.b(c.za(),"Text"),a.ib(e),a.Sb(b,d)},MultiPoint:function(a,b,
c,d){var e=c.Y();if(e){if(2!=e.gf())return;var f=a.b(c.za(),"Image");f.Wb(e);f.sc(b,d)}if(e=c.Ia())a=a.b(c.za(),"Text"),a.ib(e),a.Sb(b,d)},MultiLineString:function(a,b,c,d){var e=c.Da();if(e){var f=a.b(c.za(),"LineString");f.La(null,e);f.rc(b,d)}if(e=c.Ia())a=a.b(c.za(),"Text"),a.ib(e),a.Sb(b,d)},MultiPolygon:function(a,b,c,d){var e=c.Ca(),f=c.Da();if(f||e){var g=a.b(c.za(),"Polygon");g.La(e,f);g.tc(b,d)}if(e=c.Ia())a=a.b(c.za(),"Text"),a.ib(e),a.Sb(b,d)},GeometryCollection:function(a,b,c,d){b=b.a;
var e;var f=0;for(e=b.length;f<e;++f)(0,zj[b[f].S()])(a,b[f],c,d)},Circle:function(a,b,c,d){var e=c.Ca(),f=c.Da();if(e||f){var g=a.b(c.za(),"Circle");g.La(e,f);g.$b(b,d)}if(e=c.Ia())a=a.b(c.za(),"Text"),a.ib(e),a.Sb(b,d)}};function Aj(a){oi.call(this,a);this.c=!1;this.O=-1;this.s=NaN;this.j=Pa();this.i=this.l=null;this.g=dg()}v(Aj,oi);Aj.handles=function(a,b){return"canvas"===a&&"VECTOR"===b.S()};Aj.create=function(a,b){return new Aj(b)};
Aj.prototype.v=function(a,b,c){var d=a.extent,e=a.pixelRatio,f=b.Ue?a.skippedFeatureUids:{},g=a.viewState,h=g.projection,l=g.rotation,m=h.G(),n=this.a.ia(),p=ri(this,a,0);qi(this,"precompose",c,a,p);var q=b.extent;(g=void 0!==q)&&pi(c,a,q);var r=this.i;if(r&&!r.c()){var u=q=0,x=1!==b.opacity,B=Uc(this.a,"render");if(x||B){var A=c.canvas.width;var y=c.canvas.height;if(l){var N=Math.round(Math.sqrt(A*A+y*y));q=(N-A)/2;u=(N-y)/2;A=y=N}this.g.canvas.width=A;this.g.canvas.height=y;A=this.g}else A=c;y=
A.globalAlpha;x||(A.globalAlpha=b.opacity);A!=c&&A.translate(q,u);N=a.size[0]*e;e*=a.size[1];Mh(A,-l,N/2,e/2);r.Ka(A,p,l,f);if(n.C&&h.f&&!Wa(m,d)){h=d[0];n=lb(m);for(var ca=0;h<m[0];)--ca,p=n*ca,p=ri(this,a,p),r.Ka(A,p,l,f),h+=n;ca=0;for(h=d[2];h>m[2];)++ca,p=n*ca,p=ri(this,a,p),r.Ka(A,p,l,f),h-=n;p=ri(this,a,0)}Mh(A,l,N/2,e/2);A!=c&&(B&&qi(this,"render",A,a,p),x?(d=c.globalAlpha,c.globalAlpha=b.opacity,c.drawImage(A.canvas,-q,-u),c.globalAlpha=d):c.drawImage(A.canvas,-q,-u),A.translate(-q,-u));x||
(A.globalAlpha=y)}g&&c.restore();this.pf(c,a,b,p)};Aj.prototype.Fa=function(a,b,c,d,e){if(this.i){var f=this.a,g={};return this.i.Fa(a,b.viewState.resolution,b.viewState.rotation,c,{},function(a){var b=w(a).toString();if(!(b in g))return g[b]=!0,d.call(e,a,f)})}};Aj.prototype.C=function(){hi(this)};
Aj.prototype.Ad=function(a){var b=this.a,c=b.ia();ki(a.attributions,c.j);li(a,c);var d=a.viewHints[0],e=a.viewHints[1],f=b.U,g=b.ta;if(!this.c&&!f&&d||!g&&e)return!0;f=a.extent;var h=a.viewState;g=h.projection;var l=h.resolution,m=a.pixelRatio;d=b.f;var n=b.g;e=b.get(Bj);void 0===e&&(e=vj);f=Ra(f,n*l);n=h.projection.G();c.C&&h.projection.f&&!Wa(n,a.extent)&&(a=Math.max(lb(f)/2,lb(n)),f[0]=n[0]-a,f[2]=n[2]+a);if(!this.c&&this.s==l&&this.O==d&&this.l==e&&Wa(this.j,f))return!0;this.i=null;this.c=!1;
var p=new nj(.5*l/m,f,l,m,c.U,b.g);c.ce(f,l,g);a=function(a){var c=a.bb();if(c)var d=c.call(a,l);else(c=b.bb())&&(d=c(a,l));if(d){if(d){c=!1;if(Array.isArray(d))for(var e=0,f=d.length;e<f;++e)c=xj(p,a,d[e],wj(l,m),this.C,this)||c;else c=xj(p,a,d,wj(l,m),this.C,this)||c;a=c}else a=!1;this.c=this.c||a}}.bind(this);if(e){var q=[];c.ac(f,function(a){q.push(a)},this);q.sort(e);c=0;for(g=q.length;c<g;++c)a(q[c])}else c.ac(f,a,this);rj(p);this.s=l;this.O=d;this.l=e;this.j=f;this.i=p;return!0};function Cj(a){this.context=null;Hi.call(this,a);this.C=!1;this.U=Ue();this.I="vector"==a.v?1:0}v(Cj,Hi);Cj.handles=function(a,b){return"canvas"===a&&"VECTOR_TILE"===b.S()};Cj.create=function(a,b){return new Cj(b)};var Dj={image:["Polygon","Circle","LineString","Image","Text"],hybrid:["Polygon","LineString"]},Ej={image:["Default"],hybrid:["Image","Text","Default"],vector:dj};k=Cj.prototype;
k.Ad=function(a,b){var c=this.a,d=c.f;this.fa!=d&&(this.g.length=0,c=c.v,this.context||"vector"==c||(this.context=dg()),this.context&&"vector"==c&&(this.context=null));this.fa=d;return Hi.prototype.Ad.apply(this,arguments)};
k.Sf=function(a,b,c,d,e,f,g,h,l){var m=a,n=this.a,p=b.pixelRatio,q=b.viewState.projection,r=n.f,u=n.get(Bj)||null,x=Fj(m,n);if(x.Ee||x.wf!=r||x.bh!=u){var B=n.ia(),A=B.tileGrid,y=B.Xa(q),N=y.Qa(m.wa[0]);y=y.Ja(m.O);for(var ca=0,la=m.a.length;ca<la;++ca){var fa=m.c[m.a[ca]];if(3!=fa.getState()){var va=A.Ja(fa.wa),ra=pb(y,va),T=fa.s,U=!1;hc(q,T)||(U=!0,fa.ug(q));x.Ee=!1;ra=new nj(0,ra,N,p,B.v,n.g);var Xb=wj(N,p),Ca=fa.a;u&&u!==x.bh&&Ca.sort(u);for(var Cb,nc=0,xd=Ca.length;nc<xd;++nc){Cb=Ca[nc];U&&("tile-pixels"==
T.a&&(T.Kj(va),T.Pi(fa.G())),Cb.W().hb(T,q));var Ec=void 0,md=Cb.bb();md?Ec=md.call(Cb,N):(md=n.bb())&&(Ec=md(Cb,N));if(Ec){md=Xb;var sh=ra;if(Ec){var kf=!1;if(Array.isArray(Ec))for(var Je=0,Nf=Ec.length;Je<Nf;++Je)kf=xj(sh,Cb,Ec[Je],md,this.Si,this)||kf;else kf=xj(sh,Cb,Ec,md,this.Si,this)||kf;Cb=kf}else Cb=!1;this.C=this.C||Cb;x.Ee=x.Ee||Cb}}rj(ra);va=m.wa.toString();T=ra;fa.g[w(n)+","+va]=T}}x.wf=r;x.bh=u}if(this.context){x=b;n=this.a;q=Fj(m,n);r=n.f;if((p=Dj[n.v])&&q.dh!==r)for(q.dh=r,B=m.O,N=
B[0],q=x.pixelRatio,y=n.ia(),A=y.Xa(x.viewState.projection),r=A.Qa(N),u=m.getContext(n),x=y.be(N,q,x.viewState.projection),u.canvas.width=x[0],u.canvas.height=x[1],x=A.Ja(B),B=0,A=m.a.length;B<A;++B)N=m.c[m.a[B]],3!=N.getState()&&(y=q/r,ca=Ve(this.U),af(ca,y,-y),bf(ca,-x[0],-x[3]),Gj(N,n,m.wa.toString()).Ka(u,ca,0,{},p,!0));Hi.prototype.Sf.apply(this,arguments)}};
k.Fa=function(a,b,c,d,e){var f=b.viewState.resolution,g=b.viewState.rotation;c=void 0==c?0:c;var h=this.a,l={},m=this.g;b=h.ia().Xa(b.viewState.projection);var n;var p=0;for(n=m.length;p<n;++p){var q=m[p];var r=q.wa;r=b.Ja(r,this.B);var u=Ra(r,c*f,u);if(Ua(u,a)){r=0;for(var x=q.a.length;r<x;++r){var B=q.c[q.a[r]];if(3!=B.getState()){B=Gj(B,h,q.wa.toString());var A=A||B.Fa(a,f,g,c,{},function(a){var b=w(a).toString();if(!(b in l))return l[b]=!0,d.call(e,a,h)})}}}}return A};k.Si=function(){hi(this)};
k.pf=function(a,b,c){var d=this.a,e=d.ia(),f=d.v,g=Ej[f],h=b.pixelRatio,l=b.viewState.rotation,m=b.size,n=Math.round(h*m[0]/2);h=Math.round(h*m[1]/2);m=this.g;e=e.Xa(b.viewState.projection);for(var p=[],q=[],r=m.length-1;0<=r;--r){var u=m[r];if(5!=u.getState())for(var x=u.wa,B=e.Ja(x)[0]-e.Ja(u.O)[0],A=0,y=u.a.length;A<y;++A){var N=u.c[u.a[A]];if(3!=N.getState()){var ca=Gj(N,d,x.toString()),la;if(!(la="vector"==f))a:{la=void 0;for(la in ca.a)for(var fa=ca.a[la],va=0,ra=g.length;va<ra;++va)if(g[va]in
fa){la=!0;break a}la=!1}if(la){N=N.wa[0];la=ri(this,b,B);fa=tj(ca,la);a.save();a.globalAlpha=c.opacity;Mh(a,-l,n,h);va=0;for(ra=p.length;va<ra;++va){var T=p[va];N<q[va]&&(a.beginPath(),a.moveTo(fa[0],fa[1]),a.lineTo(fa[2],fa[3]),a.lineTo(fa[4],fa[5]),a.lineTo(fa[6],fa[7]),a.moveTo(T[6],T[7]),a.lineTo(T[4],T[5]),a.lineTo(T[2],T[3]),a.lineTo(T[0],T[1]),a.clip())}ca.Ka(a,la,l,{},g);a.restore();p.push(fa);q.push(N)}}}}Hi.prototype.pf.apply(this,arguments)};mg("MAP_RENDERER",Fi);ng([vi,Hi,Aj,Cj]);function H(a){a=tb({},a);delete a.renderer;a.controls||(a.controls=xg());a.interactions||(a.interactions=Hh());G.call(this,a)}v(H,G);function Hj(a){a=a?a:{};this.c=void 0!==a.className?a.className:"ol-full-screen";var b=void 0!==a.label?a.label:"\u2922";this.l="string"===typeof b?document.createTextNode(b):b;b=void 0!==a.labelActive?a.labelActive:"\u00d7";this.o="string"===typeof b?document.createTextNode(b):b;var c=a.tipLabel?a.tipLabel:"Toggle full-screen";b=document.createElement("button");b.className=this.c+"-"+Ij();b.setAttribute("type","button");b.title=c;b.appendChild(this.l);z(b,"click",this.D,this);c=document.createElement("div");
c.className=this.c+" ol-unselectable ol-control "+(Jj()?"":"ol-unsupported");c.appendChild(b);qg.call(this,{element:c,target:a.target});this.C=void 0!==a.keys?a.keys:!1;this.j=a.source}v(Hj,qg);
Hj.prototype.D=function(a){a.preventDefault();Jj()&&(a=this.a)&&(Ij()?document.exitFullscreen?document.exitFullscreen():document.msExitFullscreen?document.msExitFullscreen():document.mozCancelFullScreen?document.mozCancelFullScreen():document.webkitExitFullscreen&&document.webkitExitFullscreen():(a=this.j?"string"===typeof this.j?document.getElementById(this.j):this.j:a.wc(),this.C?a.mozRequestFullScreenWithKeys?a.mozRequestFullScreenWithKeys():a.webkitRequestFullscreen?a.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT):
Kj(a):Kj(a)))};Hj.prototype.s=function(){var a=this.element.firstElementChild,b=this.a;Ij()?(a.className=this.c+"-true",eg(this.o,this.l)):(a.className=this.c+"-false",eg(this.l,this.o));b&&b.Gc()};Hj.prototype.setMap=function(a){qg.prototype.setMap.call(this,a);a&&this.v.push(z(document,Lj(),this.s,this))};
function Jj(){var a=document.body;return!!(a.webkitRequestFullscreen||a.mozRequestFullScreen&&document.mozFullScreenEnabled||a.msRequestFullscreen&&document.msFullscreenEnabled||a.requestFullscreen&&document.fullscreenEnabled)}function Ij(){return!!(document.webkitIsFullScreen||document.mozFullScreen||document.msFullscreenElement||document.fullscreenElement)}
function Kj(a){a.requestFullscreen?a.requestFullscreen():a.msRequestFullscreen?a.msRequestFullscreen():a.mozRequestFullScreen?a.mozRequestFullScreen():a.webkitRequestFullscreen&&a.webkitRequestFullscreen()}var Lj=function(){var a;return function(){if(!a){var b=document.body;b.webkitRequestFullscreen?a="webkitfullscreenchange":b.mozRequestFullScreen?a="mozfullscreenchange":b.msRequestFullscreen?a="MSFullscreenChange":b.requestFullscreen&&(a="fullscreenchange")}return a}}();function Mj(a){a=a?a:{};var b=document.createElement("DIV");b.className=void 0!==a.className?a.className:"ol-mouse-position";qg.call(this,{element:b,render:a.render?a.render:Nj,target:a.target});z(this,Yc(Oj),this.hn,this);a.coordinateFormat&&this.yj(a.coordinateFormat);a.projection&&this.pi(a.projection);this.s=void 0!==a.undefinedHTML?a.undefinedHTML:"";this.o=b.innerHTML;this.l=this.j=this.c=null}v(Mj,qg);
function Nj(a){a=a.frameState;a?this.c!=a.viewState.projection&&(this.c=a.viewState.projection,this.j=null):this.c=null;Pj(this,this.l)}k=Mj.prototype;k.hn=function(){this.j=null};k.Nh=function(){return this.get(Qj)};k.oi=function(){return this.get(Oj)};k.Tl=function(a){this.l=this.a.od(a);Pj(this,this.l)};k.Ul=function(){Pj(this,null);this.l=null};k.setMap=function(a){qg.prototype.setMap.call(this,a);a&&(a=a.a,this.v.push(z(a,"mousemove",this.Tl,this),z(a,"mouseout",this.Ul,this)))};
k.yj=function(a){this.set(Qj,a)};k.pi=function(a){this.set(Oj,Zb(a))};function Pj(a,b){var c=a.s;if(b&&a.c){if(!a.j){var d=a.oi();a.j=d?$b(a.c,d):jc}if(b=a.a.Na(b))a.j(b,b),c=(c=a.Nh())?c(b):b.toString()}a.o&&c==a.o||(a.element.innerHTML=c,a.o=c)}var Oj="projection",Qj="coordinateFormat";function Rj(a){Wc.call(this);this.g=a.id;this.o=void 0!==a.insertFirst?a.insertFirst:!0;this.v=void 0!==a.stopEvent?a.stopEvent:!0;this.c=document.createElement("DIV");this.c.className="ol-overlay-container ol-selectable";this.c.style.position="absolute";this.autoPan=void 0!==a.autoPan?a.autoPan:!1;this.j=a.autoPanAnimation||{};this.l=void 0!==a.autoPanMargin?a.autoPanMargin:20;this.a={Ce:"",Te:"",xf:"",Ef:"",visible:!0};this.i=null;z(this,Yc(Sj),this.Hl,this);z(this,Yc(Tj),this.Rl,this);z(this,Yc(Uj),
this.Vl,this);z(this,Yc(Vj),this.Xl,this);z(this,Yc(Wj),this.Yl,this);void 0!==a.element&&this.zj(a.element);this.Ej(void 0!==a.offset?a.offset:[0,0]);this.Hj(void 0!==a.positioning?a.positioning:"top-left");void 0!==a.position&&this.Xe(a.position)}v(Rj,Wc);k=Rj.prototype;k.Vd=function(){return this.get(Sj)};k.Tm=function(){return this.g};k.We=function(){return this.get(Tj)};k.Th=function(){return this.get(Uj)};k.mi=function(){return this.get(Vj)};k.Uh=function(){return this.get(Wj)};
k.Hl=function(){for(var a=this.c;a.lastChild;)a.removeChild(a.lastChild);(a=this.Vd())&&this.c.appendChild(a)};k.Rl=function(){this.i&&(fg(this.c),Hc(this.i),this.i=null);var a=this.We();a&&(this.i=z(a,"postrender",this.render,this),Xj(this),a=this.v?a.v:a.s,this.o?a.insertBefore(this.c,a.childNodes[0]||null):a.appendChild(this.c))};k.render=function(){Xj(this)};k.Vl=function(){Xj(this)};
k.Xl=function(){Xj(this);if(this.get(Vj)&&this.autoPan){var a=this.We();if(a&&a.wc()){var b=Yj(a.wc(),a.zb()),c=this.Vd(),d=c.offsetWidth,e=getComputedStyle(c);d+=parseInt(e.marginLeft,10)+parseInt(e.marginRight,10);e=c.offsetHeight;var f=getComputedStyle(c);e+=parseInt(f.marginTop,10)+parseInt(f.marginBottom,10);var g=Yj(c,[d,e]);c=this.l;Wa(b,g)||(d=g[0]-b[0],e=b[2]-g[2],f=g[1]-b[1],g=b[3]-g[3],b=[0,0],0>d?b[0]=d-c:0>e&&(b[0]=Math.abs(e)+c),0>f?b[1]=f-c:0>g&&(b[1]=Math.abs(g)+c),0===b[0]&&0===b[1])||
(c=a.$().xa(),c=a.Ha(c),b=[c[0]+b[0],c[1]+b[1]],a.$().animate({center:a.Na(b),duration:this.j.duration,easing:this.j.easing}))}}};k.Yl=function(){Xj(this)};k.zj=function(a){this.set(Sj,a)};k.setMap=function(a){this.set(Tj,a)};k.Ej=function(a){this.set(Uj,a)};k.Xe=function(a){this.set(Vj,a)};function Yj(a,b){var c=a.getBoundingClientRect();a=c.left+window.pageXOffset;c=c.top+window.pageYOffset;return[a,c,a+b[0],c+b[1]]}k.Hj=function(a){this.set(Wj,a)};
function Zj(a,b){a.a.visible!==b&&(a.c.style.display=b?"":"none",a.a.visible=b)}
function Xj(a){var b=a.We(),c=a.mi();if(b&&b.c&&c){c=b.Ha(c);var d=b.zb();b=a.c.style;var e=a.Th(),f=a.Uh();Zj(a,!0);var g=e[0];e=e[1];if("bottom-right"==f||"center-right"==f||"top-right"==f)""!==a.a.Te&&(a.a.Te=b.left=""),g=Math.round(d[0]-c[0]-g)+"px",a.a.xf!=g&&(a.a.xf=b.right=g);else{""!==a.a.xf&&(a.a.xf=b.right="");if("bottom-center"==f||"center-center"==f||"top-center"==f)g-=a.c.offsetWidth/2;g=Math.round(c[0]+g)+"px";a.a.Te!=g&&(a.a.Te=b.left=g)}if("bottom-left"==f||"bottom-center"==f||"bottom-right"==
f)""!==a.a.Ef&&(a.a.Ef=b.top=""),c=Math.round(d[1]-c[1]-e)+"px",a.a.Ce!=c&&(a.a.Ce=b.bottom=c);else{""!==a.a.Ce&&(a.a.Ce=b.bottom="");if("center-left"==f||"center-center"==f||"center-right"==f)e-=a.c.offsetHeight/2;c=Math.round(c[1]+e)+"px";a.a.Ef!=c&&(a.a.Ef=b.top=c)}}else Zj(a,!1)}var Sj="element",Tj="map",Uj="offset",Vj="position",Wj="positioning";function ak(a){function b(a){a=h.Wd(a);l.a.$().rb(a);window.removeEventListener("mousemove",c);window.removeEventListener("mouseup",b)}function c(a){a=h.Wd({clientX:a.clientX-n.offsetWidth/2,clientY:a.clientY+n.offsetHeight/2});m.Xe(a)}a=a?a:{};this.j=void 0!==a.collapsed?a.collapsed:!0;this.l=void 0!==a.collapsible?a.collapsible:!0;this.l||(this.j=!1);var d=void 0!==a.className?a.className:"ol-overviewmap",e=void 0!==a.tipLabel?a.tipLabel:"Overview map",f=void 0!==a.collapseLabel?a.collapseLabel:
"\u00ab";"string"===typeof f?(this.s=document.createElement("span"),this.s.textContent=f):this.s=f;f=void 0!==a.label?a.label:"\u00bb";"string"===typeof f?(this.C=document.createElement("span"),this.C.textContent=f):this.C=f;var g=this.l&&!this.j?this.s:this.C;f=document.createElement("button");f.setAttribute("type","button");f.title=e;f.appendChild(g);z(f,"click",this.ln,this);this.D=document.createElement("DIV");this.D.className="ol-overviewmap-map";var h=this.c=new G({controls:new C,interactions:new C,
view:a.view});a.layers&&a.layers.forEach(function(a){h.Ae(a)},this);e=document.createElement("DIV");e.className="ol-overviewmap-box";e.style.boxSizing="border-box";this.o=new Rj({position:[0,0],positioning:"bottom-left",element:e});this.c.Be(this.o);e=document.createElement("div");e.className=d+" ol-unselectable ol-control"+(this.j&&this.l?" ol-collapsed":"")+(this.l?"":" ol-uncollapsible");e.appendChild(this.D);e.appendChild(f);qg.call(this,{element:e,render:a.render?a.render:bk,target:a.target});
var l=this,m=this.o,n=this.o.Vd();n.addEventListener("mousedown",function(){window.addEventListener("mousemove",c);window.addEventListener("mouseup",b)})}v(ak,qg);k=ak.prototype;k.setMap=function(a){var b=this.a;a!==b&&(b&&((b=b.$())&&Nc(b,Yc("rotation"),this.Re,this),this.c.vd(null)),qg.prototype.setMap.call(this,a),a&&(this.c.vd(this.D),this.v.push(z(a,"propertychange",this.Sl,this)),0===this.c.Ye().gc()&&this.c.zf(a.dc()),a=a.$()))&&(z(a,Yc("rotation"),this.Re,this),Wf(a)&&(this.c.Gc(),ck(this)))};
k.Sl=function(a){"view"===a.key&&((a=a.oldValue)&&Nc(a,Yc("rotation"),this.Re,this),a=this.a.$(),z(a,Yc("rotation"),this.Re,this))};k.Re=function(){this.c.$().de(this.a.$().Pa())};function bk(){var a=this.a,b=this.c;if(a.c&&b.c){var c=a.zb();a=a.$().jd(c);var d=b.zb();c=b.$().jd(d);var e=b.Ha(ib(a)),f=b.Ha(gb(a));b=Math.abs(e[0]-f[0]);e=Math.abs(e[1]-f[1]);f=d[0];d=d[1];b<.1*f||e<.1*d||b>.75*f||e>.75*d?ck(this):Wa(c,a)||(a=this.c,c=this.a.$(),a.$().rb(c.xa()))}dk(this)}
function ck(a){var b=a.a;a=a.c;var c=b.zb();b=b.$().jd(c);a=a.$();rb(b,1/(.1*Math.pow(2,Math.log(7.5)/Math.LN2/2)));a.Uf(b)}function dk(a){var b=a.a,c=a.c;if(b.c&&c.c){var d=b.zb(),e=b.$(),f=c.$();c=e.Pa();b=a.o;var g=a.o.Vd(),h=e.jd(d);d=f.Oa();e=fb(h);f=hb(h);if(a=a.a.$().xa()){var l=[e[0]-a[0],e[1]-a[1]];Ee(l,c);ye(l,a)}b.Xe(l);g&&(g.style.width=Math.abs((e[0]-f[0])/d)+"px",g.style.height=Math.abs((f[1]-e[1])/d)+"px")}}k.ln=function(a){a.preventDefault();ek(this)};
function ek(a){a.element.classList.toggle("ol-collapsed");a.j?eg(a.s,a.C):eg(a.C,a.s);a.j=!a.j;var b=a.c;a.j||b.c||(b.Gc(),ck(a),Mc(b,"postrender",function(){dk(this)},a))}k.kn=function(){return this.l};k.nn=function(a){this.l!==a&&(this.l=a,this.element.classList.toggle("ol-uncollapsible"),!a&&this.j&&ek(this))};k.mn=function(a){this.l&&this.j!==a&&ek(this)};k.jn=function(){return this.j};k.ol=function(){return this.c};function fk(a){a=a?a:{};var b=void 0!==a.className?a.className:"ol-scale-line";this.l=document.createElement("DIV");this.l.className=b+"-inner";this.c=document.createElement("DIV");this.c.className=b+" ol-unselectable";this.c.appendChild(this.l);this.s=null;this.o=void 0!==a.minWidth?a.minWidth:64;this.j=!1;this.B=void 0;this.C="";qg.call(this,{element:this.c,render:a.render?a.render:gk,target:a.target});z(this,Yc(hk),this.U,this);this.I(a.units||"metric")}v(fk,qg);var ik=[1,2,5];fk.prototype.D=function(){return this.get(hk)};
function gk(a){(a=a.frameState)?this.s=a.viewState:this.s=null;jk(this)}fk.prototype.U=function(){jk(this)};fk.prototype.I=function(a){this.set(hk,a)};
function jk(a){var b=a.s;if(b){var c=b.center,d=b.projection,e=a.D();b=Yb(d,b.resolution,c,"degrees"==e?"degrees":"m");var f=a.o*b;c="";"degrees"==e?(c=Eb.degrees,"degrees"==d.a?f*=c:b/=c,f<c/60?(c="\u2033",b*=3600):f<c?(c="\u2032",b*=60):c="\u00b0"):"imperial"==e?.9144>f?(c="in",b/=.0254):1609.344>f?(c="ft",b/=.3048):(c="mi",b/=1609.344):"nautical"==e?(b/=1852,c="nm"):"metric"==e?.001>f?(c="\u03bcm",b*=1E6):1>f?(c="mm",b*=1E3):1E3>f?c="m":(c="km",b/=1E3):"us"==e?.9144>f?(c="in",b*=39.37):1609.344>
f?(c="ft",b/=.30480061):(c="mi",b/=1609.3472):wa(!1,33);for(e=3*Math.floor(Math.log(a.o*b)/Math.log(10));;){f=ik[(e%3+3)%3]*Math.pow(10,Math.floor(e/3));d=Math.round(f/b);if(isNaN(d)){a.c.style.display="none";a.j=!1;return}if(d>=a.o)break;++e}b=f+" "+c;a.C!=b&&(a.l.innerHTML=b,a.C=b);a.B!=d&&(a.l.style.width=d+"px",a.B=d);a.j||(a.c.style.display="",a.j=!0)}else a.j&&(a.c.style.display="none",a.j=!1)}var hk="units";function kk(a){a=a?a:{};this.c=void 0;this.j=lk;this.C=this.o=0;this.I=null;this.ta=!1;this.U=void 0!==a.duration?a.duration:200;var b=void 0!==a.className?a.className:"ol-zoomslider",c=document.createElement("button");c.setAttribute("type","button");c.className=b+"-thumb ol-unselectable";var d=document.createElement("div");d.className=b+" ol-unselectable ol-control";d.appendChild(c);this.l=new Zd(d);z(this.l,"pointerdown",this.Gl,this);z(this.l,"pointermove",this.El,this);z(this.l,"pointerup",this.Fl,
this);z(d,"click",this.Dl,this);z(c,"click",Sc);qg.call(this,{element:d,render:a.render?a.render:mk})}v(kk,qg);kk.prototype.ka=function(){Qc(this.l);qg.prototype.ka.call(this)};var lk=0;k=kk.prototype;k.setMap=function(a){qg.prototype.setMap.call(this,a);a&&a.render()};
function mk(a){if(a.frameState){if(!this.ta){var b=this.element,c=b.offsetWidth,d=b.offsetHeight,e=b.firstElementChild,f=getComputedStyle(e);b=e.offsetWidth+parseFloat(f.marginRight)+parseFloat(f.marginLeft);e=e.offsetHeight+parseFloat(f.marginTop)+parseFloat(f.marginBottom);this.I=[b,e];c>d?(this.j=1,this.C=c-b):(this.j=lk,this.o=d-e);this.ta=!0}a=a.frameState.viewState.resolution;a!==this.c&&(this.c=a,nk(this,a))}}
k.Dl=function(a){var b=this.a.$();a=ok(this,Da(1===this.j?(a.offsetX-this.I[0]/2)/this.C:(a.offsetY-this.I[1]/2)/this.o,0,1));b.animate({resolution:b.constrainResolution(a),duration:this.U,easing:Me})};k.Gl=function(a){this.s||a.b.target!==this.element.firstElementChild||(Xf(this.a.$(),1,1),this.D=a.clientX,this.B=a.clientY,this.s=!0)};
k.El=function(a){if(this.s){var b=this.element.firstElementChild;this.c=ok(this,Da(1===this.j?(a.clientX-this.D+parseInt(b.style.left,10))/this.C:(a.clientY-this.B+parseInt(b.style.top,10))/this.o,0,1));this.a.$().ad(this.c);nk(this,this.c);this.D=a.clientX;this.B=a.clientY}};k.Fl=function(){if(this.s){var a=this.a.$();Xf(a,1,-1);a.animate({resolution:a.constrainResolution(this.c),duration:this.U,easing:Me});this.s=!1;this.B=this.D=void 0}};
function nk(a,b){b=1-cg(a.a.$())(b);var c=a.element.firstElementChild;1==a.j?c.style.left=a.C*b+"px":c.style.top=a.o*b+"px"}function ok(a,b){return bg(a.a.$())(1-b)};function rk(a){a=a?a:{};this.c=a.extent?a.extent:null;var b=void 0!==a.className?a.className:"ol-zoom-extent",c=void 0!==a.label?a.label:"E",d=void 0!==a.tipLabel?a.tipLabel:"Fit to extent",e=document.createElement("button");e.setAttribute("type","button");e.title=d;e.appendChild("string"===typeof c?document.createTextNode(c):c);z(e,"click",this.j,this);c=document.createElement("div");c.className=b+" ol-unselectable ol-control";c.appendChild(e);qg.call(this,{element:c,target:a.target})}v(rk,qg);
rk.prototype.j=function(a){a.preventDefault();a=this.a.$();var b=this.c?this.c:a.v.G();a.Uf(b)};function sk(a){Wc.call(this);a=a?a:{};this.a=null;z(this,Yc(tk),this.Gm,this);this.qg(void 0!==a.tracking?a.tracking:!1)}v(sk,Wc);k=sk.prototype;k.ka=function(){this.qg(!1);Wc.prototype.ka.call(this)};
k.jp=function(a){if(null!==a.alpha){var b=Ia(a.alpha);this.set(uk,b);"boolean"===typeof a.absolute&&a.absolute?this.set(vk,b):"number"===typeof a.webkitCompassHeading&&-1!=a.webkitCompassAccuracy&&this.set(vk,Ia(a.webkitCompassHeading))}null!==a.beta&&this.set(wk,Ia(a.beta));null!==a.gamma&&this.set(xk,Ia(a.gamma));this.u()};k.Em=function(){return this.get(uk)};k.Sk=function(){return this.get(wk)};k.Yk=function(){return this.get(xk)};k.Fm=function(){return this.get(vk)};k.ii=function(){return this.get(tk)};
k.Gm=function(){if(sd){var a=this.ii();a&&!this.a?this.a=z(window,"deviceorientation",this.jp,this):a||null===this.a||(Hc(this.a),this.a=null)}};k.qg=function(a){this.set(tk,a)};var uk="alpha",wk="beta",xk="gamma",vk="heading",tk="tracking";function yk(a){this.i=a.opacity;this.o=a.rotateWithView;this.g=a.rotation;this.a=a.scale;this.v=a.snapToPixel}k=yk.prototype;k.hf=function(){return this.i};k.jf=function(){return this.o};k.kf=function(){return this.g};k.lf=function(){return this.a};k.Le=function(){return this.v};k.Bd=function(a){this.i=a};k.mf=function(a){this.g=a};k.Cd=function(a){this.a=a};function zk(a){this.C=this.s=this.c=null;this.Wa=void 0!==a.fill?a.fill:null;this.ra=[0,0];this.l=a.points;this.b=void 0!==a.radius?a.radius:a.radius1;this.f=a.radius2;this.j=void 0!==a.angle?a.angle:0;this.Ta=void 0!==a.stroke?a.stroke:null;this.B=this.sa=this.D=null;this.O=a.atlasManager;Ak(this,this.O);yk.call(this,{opacity:1,rotateWithView:void 0!==a.rotateWithView?a.rotateWithView:!1,rotation:void 0!==a.rotation?a.rotation:0,scale:1,snapToPixel:void 0!==a.snapToPixel?a.snapToPixel:!0})}
v(zk,yk);k=zk.prototype;k.clone=function(){var a=new zk({fill:this.Ca()?this.Ca().clone():void 0,points:this.l,radius:this.b,radius2:this.f,angle:this.j,snapToPixel:this.v,stroke:this.Da()?this.Da().clone():void 0,rotation:this.g,rotateWithView:this.o,atlasManager:this.O});a.Bd(this.i);a.Cd(this.a);return a};k.Oc=function(){return this.D};k.cj=function(){return this.j};k.Ca=function(){return this.Wa};k.Cg=function(){return this.C};k.Y=function(){return this.s};k.Ie=function(){return this.B};
k.gf=function(){return 2};k.Vc=function(){return this.ra};k.dj=function(){return this.l};k.ej=function(){return this.b};k.Vh=function(){return this.f};k.kc=function(){return this.sa};k.Da=function(){return this.Ta};k.di=function(){};k.load=function(){};k.Qj=function(){};
function Ak(a,b){var c="",d="",e=0,f=null,g=0,h=0;if(a.Ta){var l=a.Ta.b;null===l&&(l=Lh);l=Th(l);h=a.Ta.c;void 0===h&&(h=1);f=a.Ta.f;g=a.Ta.i;qd||(f=null,g=0);d=a.Ta.j;void 0===d&&(d="round");c=a.Ta.g;void 0===c&&(c="round");e=a.Ta.l;void 0===e&&(e=10)}var m=2*(a.b+h)+1;c={strokeStyle:l,Oj:h,size:m,lineCap:c,lineDash:f,lineDashOffset:g,lineJoin:d,miterLimit:e};if(void 0===b){var n=dg(m,m);a.s=n.canvas;b=m=a.s.width;a.Gh(c,n,0,0);a.Wa?a.C=a.s:(n=dg(c.size,c.size),a.C=n.canvas,a.Fh(c,n,0,0))}else m=
Math.round(m),(d=!a.Wa)&&(n=a.Fh.bind(a,c)),a.Ta?(e=a.Ta,void 0===e.a&&(e.a="s",e.a=e.b?"string"===typeof e.b?e.a+e.b:e.a+w(e.b).toString():e.a+"-",e.a+=","+(void 0!==e.g?e.g.toString():"-")+","+(e.f?e.f.toString():"-")+","+(void 0!==e.i?e.i:"-")+","+(void 0!==e.j?e.j:"-")+","+(void 0!==e.l?e.l.toString():"-")+","+(void 0!==e.c?e.c.toString():"-")),e=e.a):e="-",a.Wa?(f=a.Wa,void 0===f.a&&(f.a=f.b instanceof CanvasPattern||f.b instanceof CanvasGradient?w(f.b).toString():"f"+(f.b?Rh(f.b):"-")),f=f.a):
f="-",a.c&&e==a.c[1]&&f==a.c[2]&&a.b==a.c[3]&&a.f==a.c[4]&&a.j==a.c[5]&&a.l==a.c[6]||(a.c=["r"+e+f+(void 0!==a.b?a.b.toString():"-")+(void 0!==a.f?a.f.toString():"-")+(void 0!==a.j?a.j.toString():"-")+(void 0!==a.l?a.l.toString():"-"),e,f,a.b,a.f,a.j,a.l]),n=b.add(a.c[0],m,m,a.Gh.bind(a,c),n),a.s=n.image,a.ra=[n.offsetX,n.offsetY],b=n.image.width,a.C=d?n.hm:a.s;a.D=[m/2,m/2];a.sa=[m,m];a.B=[b,b]}
k.Gh=function(a,b,c,d){b.setTransform(1,0,0,1,0,0);b.translate(c,d);b.beginPath();var e=this.l;if(Infinity===e)b.arc(a.size/2,a.size/2,this.b,0,2*Math.PI,!0);else{var f=void 0!==this.f?this.f:this.b;f!==this.b&&(e*=2);for(c=0;c<=e;c++){d=2*c*Math.PI/e-Math.PI/2+this.j;var g=0===c%2?this.b:f;b.lineTo(a.size/2+g*Math.cos(d),a.size/2+g*Math.sin(d))}}this.Wa&&(c=this.Wa.b,null===c&&(c=Jh),b.fillStyle=Th(c),b.fill());this.Ta&&(b.strokeStyle=a.strokeStyle,b.lineWidth=a.Oj,a.lineDash&&(b.setLineDash(a.lineDash),
b.lineDashOffset=a.lineDashOffset),b.lineCap=a.lineCap,b.lineJoin=a.lineJoin,b.miterLimit=a.miterLimit,b.stroke());b.closePath()};
k.Fh=function(a,b,c,d){b.setTransform(1,0,0,1,0,0);b.translate(c,d);b.beginPath();c=this.l;if(Infinity===c)b.arc(a.size/2,a.size/2,this.b,0,2*Math.PI,!0);else{d=void 0!==this.f?this.f:this.b;d!==this.b&&(c*=2);var e;for(e=0;e<=c;e++){var f=2*e*Math.PI/c-Math.PI/2+this.j;var g=0===e%2?this.b:d;b.lineTo(a.size/2+g*Math.cos(f),a.size/2+g*Math.sin(f))}}b.fillStyle=Jh;b.fill();this.Ta&&(b.strokeStyle=a.strokeStyle,b.lineWidth=a.Oj,a.lineDash&&(b.setLineDash(a.lineDash),b.lineDashOffset=a.lineDashOffset),
b.stroke());b.closePath()};function Bk(a){a=a||{};zk.call(this,{points:Infinity,fill:a.fill,radius:a.radius,snapToPixel:a.snapToPixel,stroke:a.stroke,atlasManager:a.atlasManager})}v(Bk,zk);Bk.prototype.clone=function(){var a=new Bk({fill:this.Ca()?this.Ca().clone():void 0,stroke:this.Da()?this.Da().clone():void 0,radius:this.b,snapToPixel:this.v,atlasManager:this.O});a.Bd(this.i);a.Cd(this.a);return a};Bk.prototype.$c=function(a){this.b=a;Ak(this,this.O)};function Ck(a){a=a||{};this.b=void 0!==a.color?a.color:null;this.a=void 0}Ck.prototype.clone=function(){var a=this.b;return new Ck({color:a&&a.slice?a.slice():a||void 0})};Ck.prototype.f=function(){return this.b};Ck.prototype.c=function(a){this.b=a;this.a=void 0};function Dk(a){a=a||{};this.b=void 0!==a.color?a.color:null;this.g=a.lineCap;this.f=void 0!==a.lineDash?a.lineDash:null;this.i=a.lineDashOffset;this.j=a.lineJoin;this.l=a.miterLimit;this.c=a.width;this.a=void 0}k=Dk.prototype;k.clone=function(){var a=this.b;return new Dk({color:a&&a.slice?a.slice():a||void 0,lineCap:this.g,lineDash:this.f?this.f.slice():void 0,lineDashOffset:this.i,lineJoin:this.j,miterLimit:this.l,width:this.c})};k.Vo=function(){return this.b};k.dl=function(){return this.g};
k.Wo=function(){return this.f};k.el=function(){return this.i};k.fl=function(){return this.j};k.ll=function(){return this.l};k.Xo=function(){return this.c};k.Yo=function(a){this.b=a;this.a=void 0};k.eq=function(a){this.g=a;this.a=void 0};k.setLineDash=function(a){this.f=a;this.a=void 0};k.fq=function(a){this.i=a;this.a=void 0};k.gq=function(a){this.j=a;this.a=void 0};k.kq=function(a){this.l=a;this.a=void 0};k.oq=function(a){this.c=a;this.a=void 0};function Ek(a){a=a||{};this.Nc=null;this.Za=Fk;void 0!==a.geometry&&this.Sa(a.geometry);this.Wa=void 0!==a.fill?a.fill:null;this.N=void 0!==a.image?a.image:null;this.lc=a.renderer?a.renderer:null;this.Ta=void 0!==a.stroke?a.stroke:null;this.qa=void 0!==a.text?a.text:null;this.Uj=a.zIndex}k=Ek.prototype;
k.clone=function(){var a=this.W();a&&a.clone&&(a=a.clone());return new Ek({geometry:a,fill:this.Ca()?this.Ca().clone():void 0,image:this.Y()?this.Y().clone():void 0,stroke:this.Da()?this.Da().clone():void 0,text:this.Ia()?this.Ia().clone():void 0,zIndex:this.za()})};k.Je=function(){return this.lc};k.mq=function(a){this.lc=a};k.W=function(){return this.Nc};k.Zk=function(){return this.Za};k.Ca=function(){return this.Wa};k.yf=function(a){this.Wa=a};k.Y=function(){return this.N};
k.gh=function(a){this.N=a};k.Da=function(){return this.Ta};k.Af=function(a){this.Ta=a};k.Ia=function(){return this.qa};k.Ed=function(a){this.qa=a};k.za=function(){return this.Uj};k.Sa=function(a){"function"===typeof a?this.Za=a:"string"===typeof a?this.Za=function(b){return b.get(a)}:a?a&&(this.Za=function(){return a}):this.Za=Fk;this.Nc=a};k.Xb=function(a){this.Uj=a};
function Gk(a){if("function"!==typeof a){if(Array.isArray(a))var b=a;else wa(a instanceof Ek,41),b=[a];a=function(){return b}}return a}var Hk=null;function Ik(){if(!Hk){var a=new Ck({color:"rgba(255,255,255,0.4)"}),b=new Dk({color:"#3399CC",width:1.25});Hk=[new Ek({image:new Bk({fill:a,stroke:b,radius:5}),fill:a,stroke:b})]}return Hk}
function Jk(){var a={},b=[255,255,255,1],c=[0,153,255,1];a.Polygon=[new Ek({fill:new Ck({color:[255,255,255,.5]})})];a.MultiPolygon=a.Polygon;a.LineString=[new Ek({stroke:new Dk({color:b,width:5})}),new Ek({stroke:new Dk({color:c,width:3})})];a.MultiLineString=a.LineString;a.Circle=a.Polygon.concat(a.LineString);a.Point=[new Ek({image:new Bk({radius:6,fill:new Ck({color:c}),stroke:new Dk({color:b,width:1.5})}),zIndex:Infinity})];a.MultiPoint=a.Point;a.GeometryCollection=a.Polygon.concat(a.LineString,
a.Point);return a}function Fk(a){return a.W()};function Kk(a){Wc.call(this);this.c=void 0;this.a="geometry";this.g=null;this.j=void 0;this.i=null;z(this,Yc(this.a),this.Pe,this);void 0!==a&&(a instanceof ef||!a?this.Sa(a):this.H(a))}v(Kk,Wc);k=Kk.prototype;k.clone=function(){var a=new Kk(this.M());a.Zc(this.a);var b=this.W();b&&a.Sa(b.clone());(b=this.g)&&a.rg(b);return a};k.W=function(){return this.get(this.a)};k.Hm=function(){return this.c};k.$k=function(){return this.a};k.Im=function(){return this.g};k.bb=function(){return this.j};k.Il=function(){this.u()};
k.Pe=function(){this.i&&(Hc(this.i),this.i=null);var a=this.W();a&&(this.i=z(a,"change",this.Il,this));this.u()};k.Sa=function(a){this.set(this.a,a)};k.rg=function(a){this.j=(this.g=a)?Lk(a):void 0;this.u()};k.mc=function(a){this.c=a;this.u()};k.Zc=function(a){Nc(this,Yc(this.a),this.Pe,this);this.a=a;z(this,Yc(this.a),this.Pe,this);this.Pe()};
function Lk(a){var b;if("function"===typeof a)2==a.length?b=function(b){return a(this,b)}:b=a;else{if(Array.isArray(a))var c=a;else wa(a instanceof Ek,41),c=[a];b=function(){return c}}return b};var Mk=document.implementation.createDocument("","",null);function Nk(a,b){return Mk.createElementNS(a,b)}function Ok(a,b){return Pk(a,b,[]).join("")}function Pk(a,b,c){if(a.nodeType==Node.CDATA_SECTION_NODE||a.nodeType==Node.TEXT_NODE)b?c.push(String(a.nodeValue).replace(/(\r\n|\r|\n)/g,"")):c.push(a.nodeValue);else for(a=a.firstChild;a;a=a.nextSibling)Pk(a,b,c);return c}function Qk(a){return a instanceof Document}function Rk(a){return a instanceof Node}
function Sk(a){return(new DOMParser).parseFromString(a,"application/xml")}function Tk(a,b){return function(c,d){c=a.call(b,c,d);void 0!==c&&ja(d[d.length-1],c)}}function Uk(a,b){return function(c,d){c=a.call(void 0!==b?b:this,c,d);void 0!==c&&d[d.length-1].push(c)}}function Vk(a,b){return function(c,d){c=a.call(void 0!==b?b:this,c,d);void 0!==c&&(d[d.length-1]=c)}}
function Wk(a){return function(b,c){var d=a.call(this,b,c);if(void 0!==d){c=c[c.length-1];b=b.localName;var e;b in c?e=c[b]:e=c[b]=[];e.push(d)}}}function I(a,b){return function(c,d){var e=a.call(this,c,d);void 0!==e&&(d[d.length-1][void 0!==b?b:c.localName]=e)}}function J(a,b){return function(c,d,e){a.call(void 0!==b?b:this,c,d,e);e[e.length-1].node.appendChild(c)}}
function Xk(a){var b,c;return function(d,e,f){if(!b){b={};var g={};g[d.localName]=a;b[d.namespaceURI]=g;c=Yk(d.localName)}Zk(b,c,e,f)}}function Yk(a,b){return function(c,d,e){c=d[d.length-1].node;d=a;void 0===d&&(d=e);e=b;void 0===b&&(e=c.namespaceURI);return Nk(e,d)}}var $k=Yk();function al(a,b){for(var c=b.length,d=Array(c),e=0;e<c;++e)d[e]=a[b[e]];return d}function K(a,b,c){c=void 0!==c?c:{};var d;var e=0;for(d=a.length;e<d;++e)c[a[e]]=b;return c}
function bl(a,b,c,d){for(b=b.firstElementChild;b;b=b.nextElementSibling){var e=a[b.namespaceURI];void 0!==e&&(e=e[b.localName])&&e.call(d,b,c)}}function L(a,b,c,d,e){d.push(a);bl(b,c,d,e);return d.pop()}function Zk(a,b,c,d,e,f){for(var g=(void 0!==e?e:c).length,h,l,m=0;m<g;++m)h=c[m],void 0!==h&&(l=b.call(f,h,d,void 0!==e?e[m]:void 0),void 0!==l&&a[l.namespaceURI][l.localName].call(f,l,h,d))}function cl(a,b,c,d,e,f,g){e.push(a);Zk(b,c,d,e,f,g);e.pop()};function dl(a,b,c,d){return function(e,f,g){var h=new XMLHttpRequest;h.open("GET","function"===typeof a?a(e,f,g):a,!0);"arraybuffer"==b.S()&&(h.responseType="arraybuffer");h.onload=function(){if(!h.status||200<=h.status&&300>h.status){var a=b.S();if("json"==a||"text"==a)var e=h.responseText;else"xml"==a?(e=h.responseXML)||(e=Sk(h.responseText)):"arraybuffer"==a&&(e=h.response);e?c.call(this,b.Ma(e,{featureProjection:g}),b.pb(e),b.dg()):d.call(this)}else d.call(this)}.bind(this);h.onerror=function(){d.call(this)}.bind(this);
h.send()}}function el(a,b){return dl(a,b,function(a){this.Ic(a)},sa)};function fl(){this.i=this.defaultDataProjection=null}function gl(a,b,c){var d;c&&(d={dataProjection:c.dataProjection?c.dataProjection:a.pb(b),featureProjection:c.featureProjection});return hl(a,d)}function hl(a,b){return tb({dataProjection:a.defaultDataProjection,featureProjection:a.i},b)}fl.prototype.dg=function(){return null};
function il(a,b,c){var d=c?Zb(c.featureProjection):null,e=c?Zb(c.dataProjection):null,f;d&&e&&!hc(d,e)?a instanceof ef?f=(b?a.clone():a).hb(b?d:e,b?e:d):f=lc(a,e,d):f=a;if(b&&c&&void 0!==c.decimals){var g=Math.pow(10,c.decimals);f===a&&(f=f.clone());f.Jc(function(a){for(var b=0,c=a.length;b<c;++b)a[b]=Math.round(a[b]*g)/g;return a})}return f};function jl(){fl.call(this)}v(jl,fl);function kl(a){return"string"===typeof a?(a=JSON.parse(a))?a:null:null!==a?a:null}k=jl.prototype;k.S=function(){return"json"};k.Vb=function(a,b){return this.Xc(kl(a),gl(this,a,b))};k.Ma=function(a,b){return this.Kg(kl(a),gl(this,a,b))};k.Yc=function(a,b){return this.Og(kl(a),gl(this,a,b))};k.pb=function(a){return this.Rg(kl(a))};k.Gd=function(a,b){return JSON.stringify(this.ed(a,b))};k.Yb=function(a,b){return JSON.stringify(this.te(a,b))};
k.fd=function(a,b){return JSON.stringify(this.ve(a,b))};function ll(a,b,c,d,e,f){var g=NaN,h=NaN,l=(c-b)/d;if(1===l)g=a[b],h=a[b+1];else if(2==l)g=(1-e)*a[b]+e*a[b+d],h=(1-e)*a[b+1]+e*a[b+d+1];else if(0!==l){h=a[b];l=a[b+1];var m=0;g=[0];var n;for(n=b+d;n<c;n+=d){var p=a[n],q=a[n+1];m+=Math.sqrt((p-h)*(p-h)+(q-l)*(q-l));g.push(m);h=p;l=q}c=e*m;l=0;m=g.length;for(n=!1;l<m;)e=l+(m-l>>1),h=+ea(g[e],c),0>h?l=e+1:(m=e,n=!h);e=n?l:~l;0>e?(c=(c-g[-e-2])/(g[-e-1]-g[-e-2]),b+=(-e-2)*d,g=Ka(a[b],a[b+d],c),h=Ka(a[b+1],a[b+d+1],c)):(g=a[b+e*d],h=a[b+e*d+1])}return f?
(f[0]=g,f[1]=h,f):[g,h]}function ml(a,b,c,d,e,f){if(c==b)return null;if(e<a[b+d-1])return f?(c=a.slice(b,b+d),c[d-1]=e,c):null;if(a[c-1]<e)return f?(c=a.slice(c-d,c),c[d-1]=e,c):null;if(e==a[b+d-1])return a.slice(b,b+d);b/=d;for(c/=d;b<c;)f=b+c>>1,e<a[(f+1)*d-1]?c=f:b=f+1;c=a[b*d-1];if(e==c)return a.slice((b-1)*d,(b-1)*d+d);f=(e-c)/(a[(b+1)*d-1]-c);c=[];var g;for(g=0;g<d-1;++g)c.push(Ka(a[(b-1)*d+g],a[b*d+g],f));c.push(e);return c}
function nl(a,b,c,d,e,f){var g=0;if(f)return ml(a,g,b[b.length-1],c,d,e);if(d<a[c-1])return e?(a=a.slice(0,c),a[c-1]=d,a):null;if(a[a.length-1]<d)return e?(a=a.slice(a.length-c),a[c-1]=d,a):null;e=0;for(f=b.length;e<f;++e){var h=b[e];if(g!=h){if(d<a[g+c-1])break;else if(d<=a[h-1])return ml(a,g,h,c,d,!1);g=h}}return null};function M(a,b){ff.call(this);this.c=null;this.s=this.C=this.j=-1;this.na(a,b)}v(M,ff);k=M.prototype;k.xk=function(a){this.A?ja(this.A,a):this.A=a.slice();this.u()};k.clone=function(){var a=new M(null);a.aa(this.ja,this.A.slice());return a};k.Mb=function(a,b,c,d){if(d<Ta(this.G(),a,b))return d;this.s!=this.f&&(this.C=Math.sqrt(pf(this.A,0,this.A.length,this.a,0)),this.s=this.f);return rf(this.A,0,this.A.length,this.a,this.C,!1,a,b,c,d)};
k.Nk=function(a,b){return Hf(this.A,0,this.A.length,this.a,a,b)};k.zn=function(a,b){return"XYM"!=this.ja&&"XYZM"!=this.ja?null:ml(this.A,0,this.A.length,this.a,a,void 0!==b?b:!1)};k.V=function(){return wf(this.A,0,this.A.length,this.a)};k.Mh=function(a,b){return ll(this.A,0,this.A.length,this.a,a,b)};k.An=function(){return Ni(this.A,0,this.A.length,this.a)};function bi(a){a.j!=a.f&&(a.c=a.Mh(.5,a.c),a.j=a.f);return a.c}
k.rd=function(a){var b=[];b.length=zf(this.A,0,this.A.length,this.a,a,b,0);a=new M(null);a.aa("XY",b);return a};k.S=function(){return"LineString"};k.Ya=function(a){return If(this.A,0,this.A.length,this.a,a)};k.na=function(a,b){a?(jf(this,b,a,1),this.A||(this.A=[]),this.A.length=uf(this.A,0,a,this.a),this.u()):this.aa("XY",null)};k.aa=function(a,b){hf(this,a,b);this.u()};function O(a,b){ff.call(this);this.c=[];this.j=this.s=-1;this.na(a,b)}v(O,ff);k=O.prototype;k.yk=function(a){this.A?ja(this.A,a.ca().slice()):this.A=a.ca().slice();this.c.push(this.A.length);this.u()};k.clone=function(){var a=new O(null);a.aa(this.ja,this.A.slice(),this.c.slice());return a};k.Mb=function(a,b,c,d){if(d<Ta(this.G(),a,b))return d;this.j!=this.f&&(this.s=Math.sqrt(qf(this.A,0,this.c,this.a,0)),this.j=this.f);return sf(this.A,0,this.c,this.a,this.s,!1,a,b,c,d)};
k.Cn=function(a,b,c){return"XYM"!=this.ja&&"XYZM"!=this.ja||0===this.A.length?null:nl(this.A,this.c,this.a,a,void 0!==b?b:!1,void 0!==c?c:!1)};k.V=function(){return xf(this.A,0,this.c,this.a)};k.lb=function(){return this.c};k.gl=function(a){if(0>a||this.c.length<=a)return null;var b=new M(null);b.aa(this.ja,this.A.slice(0===a?0:this.c[a-1],this.c[a]));return b};
k.qd=function(){var a=this.A,b=this.c,c=this.ja,d=[],e=0,f;var g=0;for(f=b.length;g<f;++g){var h=b[g],l=new M(null);l.aa(c,a.slice(e,h));d.push(l);e=h}return d};function ci(a){var b=[],c=a.A,d=0,e=a.c;a=a.a;var f;var g=0;for(f=e.length;g<f;++g){var h=e[g];d=ll(c,d,h,a,.5);ja(b,d);d=h}return b}k.rd=function(a){var b=[],c=[],d=this.A,e=this.c,f=this.a,g=0,h=0,l;var m=0;for(l=e.length;m<l;++m){var n=e[m];h=zf(d,g,n,f,a,b,h);c.push(h);g=n}b.length=h;a=new O(null);a.aa("XY",b,c);return a};k.S=function(){return"MultiLineString"};
k.Ya=function(a){a:{var b=this.A,c=this.c,d=this.a,e=0,f;var g=0;for(f=c.length;g<f;++g){if(If(b,e,c[g],d,a)){a=!0;break a}e=c[g]}a=!1}return a};k.na=function(a,b){a?(jf(this,b,a,2),this.A||(this.A=[]),a=vf(this.A,0,a,this.a,this.c),this.A.length=0===a.length?0:a[a.length-1],this.u()):this.aa("XY",null,this.c)};k.aa=function(a,b,c){hf(this,a,b);this.c=c;this.u()};
function pl(a,b){var c=a.ja,d=[],e=[],f;var g=0;for(f=b.length;g<f;++g){var h=b[g];0===g&&(c=h.ja);ja(d,h.ca());e.push(d.length)}a.aa(c,d,e)};function ql(a,b){ff.call(this);this.na(a,b)}v(ql,ff);k=ql.prototype;k.Ak=function(a){this.A?ja(this.A,a.ca()):this.A=a.ca().slice();this.u()};k.clone=function(){var a=new ql(null);a.aa(this.ja,this.A.slice());return a};k.Mb=function(a,b,c,d){if(d<Ta(this.G(),a,b))return d;var e=this.A,f=this.a,g;var h=0;for(g=e.length;h<g;h+=f){var l=Ha(a,b,e[h],e[h+1]);if(l<d){d=l;for(l=0;l<f;++l)c[l]=e[h+l];c.length=f}}return d};k.V=function(){return wf(this.A,0,this.A.length,this.a)};
k.rl=function(a){var b=this.A?this.A.length/this.a:0;if(0>a||b<=a)return null;b=new D(null);b.aa(this.ja,this.A.slice(a*this.a,(a+1)*this.a));return b};k.ee=function(){var a=this.A,b=this.ja,c=this.a,d=[],e;var f=0;for(e=a.length;f<e;f+=c){var g=new D(null);g.aa(b,a.slice(f,f+c));d.push(g)}return d};k.S=function(){return"MultiPoint"};k.Ya=function(a){var b=this.A,c=this.a,d;var e=0;for(d=b.length;e<d;e+=c){var f=b[e];var g=b[e+1];if(Va(a,f,g))return!0}return!1};
k.na=function(a,b){a?(jf(this,b,a,1),this.A||(this.A=[]),this.A.length=uf(this.A,0,a,this.a),this.u()):this.aa("XY",null)};k.aa=function(a,b){hf(this,a,b);this.u()};function P(a,b){ff.call(this);this.c=[];this.s=-1;this.C=null;this.I=this.D=this.B=-1;this.j=null;this.na(a,b)}v(P,ff);k=P.prototype;k.Bk=function(a){if(this.A){var b=this.A.length;ja(this.A,a.ca());a=a.lb().slice();var c;var d=0;for(c=a.length;d<c;++d)a[d]+=b}else this.A=a.ca().slice(),a=a.lb().slice(),this.c.push();this.c.push(a);this.u()};k.clone=function(){for(var a=new P(null),b=this.c.length,c=Array(b),d=0;d<b;++d)c[d]=this.c[d].slice();a.aa(this.ja,this.A.slice(),c);return a};
k.Mb=function(a,b,c,d){if(d<Ta(this.G(),a,b))return d;if(this.D!=this.f){var e=this.c,f=0,g=0,h;var l=0;for(h=e.length;l<h;++l){var m=e[l];g=qf(this.A,f,m,this.a,g);f=m[m.length-1]}this.B=Math.sqrt(g);this.D=this.f}e=di(this);f=this.c;g=this.a;l=this.B;h=0;m=[NaN,NaN];var n;var p=0;for(n=f.length;p<n;++p){var q=f[p];d=sf(e,h,q,g,l,!0,a,b,c,d,m);h=q[q.length-1]}return d};
k.Tc=function(a,b){a:{var c=di(this),d=this.c,e=0;if(0!==d.length){var f;var g=0;for(f=d.length;g<f;++g){var h=d[g];if(Ff(c,e,h,this.a,a,b)){a=!0;break a}e=h[h.length-1]}}a=!1}return a};k.Dn=function(){var a=di(this),b=this.c,c=0,d=0,e;var f=0;for(e=b.length;f<e;++f){var g=b[f];d+=nf(a,c,g,this.a);c=g[g.length-1]}return d};k.V=function(a){if(void 0!==a){var b=di(this).slice();Of(b,this.c,this.a,a)}else b=this.A;return yf(b,0,this.c,this.a)};k.md=function(){return this.c};
function ei(a){if(a.s!=a.f){var b=a.A,c=a.c,d=a.a,e=0,f=[],g;var h=0;for(g=c.length;h<g;++h){var l=c[h];e=ab(b,e,l[0],d);f.push((e[0]+e[2])/2,(e[1]+e[3])/2);e=l[l.length-1]}b=di(a);c=a.c;d=a.a;h=0;g=[];l=0;for(e=c.length;l<e;++l){var m=c[l];g=Gf(b,h,m,d,f,2*l,g);h=m[m.length-1]}a.C=g;a.s=a.f}return a.C}k.cl=function(){var a=new ql(null);a.aa("XYM",ei(this).slice());return a};
function di(a){if(a.I!=a.f){var b=a.A;a:{var c=a.c;var d;var e=0;for(d=c.length;e<d;++e)if(!Lf(b,c[e],a.a,void 0)){c=!1;break a}c=!0}c?a.j=b:(a.j=b.slice(),a.j.length=Of(a.j,a.c,a.a));a.I=a.f}return a.j}k.rd=function(a){var b=[],c=[],d=this.A,e=this.c,f=this.a;a=Math.sqrt(a);var g=0,h=0,l;var m=0;for(l=e.length;m<l;++m){var n=e[m],p=[];h=Af(d,g,n,f,a,b,h,p);c.push(p);g=n[n.length-1]}b.length=h;d=new P(null);d.aa("XY",b,c);return d};
k.sl=function(a){if(0>a||this.c.length<=a)return null;if(0===a)var b=0;else b=this.c[a-1],b=b[b.length-1];a=this.c[a].slice();var c=a[a.length-1];if(0!==b){var d;var e=0;for(d=a.length;e<d;++e)a[e]-=b}e=new E(null);e.aa(this.ja,this.A.slice(b,c),a);return e};k.Yd=function(){var a=this.ja,b=this.A,c=this.c,d=[],e=0,f,g;var h=0;for(f=c.length;h<f;++h){var l=c[h].slice(),m=l[l.length-1];if(0!==e){var n=0;for(g=l.length;n<g;++n)l[n]-=e}n=new E(null);n.aa(a,b.slice(e,m),l);d.push(n);e=m}return d};
k.S=function(){return"MultiPolygon"};k.Ya=function(a){a:{var b=di(this),c=this.c,d=this.a,e=0,f;var g=0;for(f=c.length;g<f;++g){var h=c[g];if(Jf(b,e,h,d,a)){a=!0;break a}e=h[h.length-1]}a=!1}return a};
k.na=function(a,b){if(a){jf(this,b,a,3);this.A||(this.A=[]);b=this.A;var c=this.a,d=this.c,e=0;d=d?d:[];var f=0,g;var h=0;for(g=a.length;h<g;++h)e=vf(b,e,a[h],c,d[f]),d[f++]=e,e=e[e.length-1];d.length=f;0===d.length?this.A.length=0:(a=d[d.length-1],this.A.length=0===a.length?0:a[a.length-1]);this.u()}else this.aa("XY",null,this.c)};k.aa=function(a,b,c){hf(this,a,b);this.c=c;this.u()};
function rl(a,b){var c=a.ja,d=[],e=[],f;var g=0;for(f=b.length;g<f;++g){var h=b[g];0===g&&(c=h.ja);var l=d.length;var m=h.lb();var n;var p=0;for(n=m.length;p<n;++p)m[p]+=l;ja(d,h.ca());e.push(m)}a.aa(c,d,e)};function sl(a){a=a?a:{};fl.call(this);this.b=a.geometryName}v(sl,jl);
function tl(a,b){if(!a)return null;if("number"===typeof a.x&&"number"===typeof a.y)var c="Point";else if(a.points)c="MultiPoint";else if(a.paths)c=1===a.paths.length?"LineString":"MultiLineString";else if(a.rings){var d=a.rings,e=ul(a),f=[],g=[];c=[];var h;var l=0;for(h=d.length;l<h;++l)f.length=0,uf(f,0,d[l],e.length),Kf(f,0,f.length,e.length)?g.push([d[l]]):c.push(d[l]);for(;c.length;){d=c.shift();e=!1;for(l=g.length-1;0<=l;l--)if(Wa((new Bf(g[l][0])).G(),(new Bf(d)).G())){g[l].push(d);e=!0;break}e||
g.push([d.reverse()])}a=tb({},a);1===g.length?(c="Polygon",a.rings=g[0]):(c="MultiPolygon",a.rings=g)}return il((0,vl[c])(a),!1,b)}function ul(a){var b="XY";!0===a.hasZ&&!0===a.hasM?b="XYZM":!0===a.hasZ?b="XYZ":!0===a.hasM&&(b="XYM");return b}function wl(a){a=a.ja;return{hasZ:"XYZ"===a||"XYZM"===a,hasM:"XYM"===a||"XYZM"===a}}
var vl={Point:function(a){return void 0!==a.m&&void 0!==a.z?new D([a.x,a.y,a.z,a.m],"XYZM"):void 0!==a.z?new D([a.x,a.y,a.z],"XYZ"):void 0!==a.m?new D([a.x,a.y,a.m],"XYM"):new D([a.x,a.y])},LineString:function(a){return new M(a.paths[0],ul(a))},Polygon:function(a){return new E(a.rings,ul(a))},MultiPoint:function(a){return new ql(a.points,ul(a))},MultiLineString:function(a){return new O(a.paths,ul(a))},MultiPolygon:function(a){return new P(a.rings,ul(a))}},xl={Point:function(a){var b=a.V(),c;a=a.ja;
"XYZ"===a?c={x:b[0],y:b[1],z:b[2]}:"XYM"===a?c={x:b[0],y:b[1],m:b[2]}:"XYZM"===a?c={x:b[0],y:b[1],z:b[2],m:b[3]}:"XY"===a?c={x:b[0],y:b[1]}:wa(!1,34);return c},LineString:function(a){var b=wl(a);return{hasZ:b.hasZ,hasM:b.hasM,paths:[a.V()]}},Polygon:function(a){var b=wl(a);return{hasZ:b.hasZ,hasM:b.hasM,rings:a.V(!1)}},MultiPoint:function(a){var b=wl(a);return{hasZ:b.hasZ,hasM:b.hasM,points:a.V()}},MultiLineString:function(a){var b=wl(a);return{hasZ:b.hasZ,hasM:b.hasM,paths:a.V()}},MultiPolygon:function(a){var b=
wl(a);a=a.V(!1);for(var c=[],d=0;d<a.length;d++)for(var e=a[d].length-1;0<=e;e--)c.push(a[d][e]);return{hasZ:b.hasZ,hasM:b.hasM,rings:c}}};k=sl.prototype;k.Xc=function(a,b){var c=tl(a.geometry,b),d=new Kk;this.b&&d.Zc(this.b);d.Sa(c);b&&b.og&&a.attributes[b.og]&&d.mc(a.attributes[b.og]);a.attributes&&d.H(a.attributes);return d};k.Kg=function(a,b){b=b?b:{};if(a.features){var c=[],d=a.features,e;b.og=a.objectIdFieldName;a=0;for(e=d.length;a<e;++a)c.push(this.Xc(d[a],b));return c}return[this.Xc(a,b)]};
k.Og=function(a,b){return tl(a,b)};k.Rg=function(a){return a.spatialReference&&a.spatialReference.wkid?Zb("EPSG:"+a.spatialReference.wkid):null};function yl(a,b){return(0,xl[a.S()])(il(a,!0,b),b)}k.ve=function(a,b){return yl(a,hl(this,b))};k.ed=function(a,b){b=hl(this,b);var c={},d=a.W();d&&(c.geometry=yl(d,b),b&&b.featureProjection&&(c.geometry.spatialReference={wkid:Zb(b.featureProjection).sb.split(":").pop()}));b=a.M();delete b[a.a];c.attributes=wb(b)?{}:b;return c};
k.te=function(a,b){b=hl(this,b);var c=[],d;var e=0;for(d=a.length;e<d;++e)c.push(this.ed(a[e],b));return{features:c}};function zl(a){this.nc=a};function Al(a,b){this.nc=a;this.b=Array.prototype.slice.call(arguments,1);wa(2<=this.b.length,57)}v(Al,zl);function Bl(a){var b=["And"].concat(Array.prototype.slice.call(arguments));Al.apply(this,b)}v(Bl,Al);function Cl(a,b,c){this.nc="BBOX";this.geometryName=a;this.extent=b;this.srsName=c}v(Cl,zl);function Dl(a,b){this.nc=a;this.b=b}v(Dl,zl);function El(a,b,c){Dl.call(this,"During",a);this.a=b;this.f=c}v(El,Dl);function Fl(a,b,c,d){Dl.call(this,a,b);this.f=c;this.a=d}v(Fl,Dl);function Gl(a,b,c){Fl.call(this,"PropertyIsEqualTo",a,b,c)}v(Gl,Fl);function Hl(a,b){Fl.call(this,"PropertyIsGreaterThan",a,b)}v(Hl,Fl);function Il(a,b){Fl.call(this,"PropertyIsGreaterThanOrEqualTo",a,b)}v(Il,Fl);function Jl(a,b,c,d){this.nc=a;this.geometryName=b||"the_geom";this.geometry=c;this.srsName=d}v(Jl,zl);function Kl(a,b,c){Jl.call(this,"Intersects",a,b,c)}v(Kl,Jl);function Ll(a,b,c){Dl.call(this,"PropertyIsBetween",a);this.a=b;this.f=c}v(Ll,Dl);function Ml(a,b,c,d,e,f){Dl.call(this,"PropertyIsLike",a);this.c=b;this.g=void 0!==c?c:"*";this.i=void 0!==d?d:".";this.f=void 0!==e?e:"!";this.a=f}v(Ml,Dl);function Nl(a){Dl.call(this,"PropertyIsNull",a)}v(Nl,Dl);function Ol(a,b){Fl.call(this,"PropertyIsLessThan",a,b)}v(Ol,Fl);function Pl(a,b){Fl.call(this,"PropertyIsLessThanOrEqualTo",a,b)}v(Pl,Fl);function Ql(a){this.nc="Not";this.condition=a}v(Ql,zl);function Rl(a,b,c){Fl.call(this,"PropertyIsNotEqualTo",a,b,c)}v(Rl,Fl);function Sl(a){var b=["Or"].concat(Array.prototype.slice.call(arguments));Al.apply(this,b)}v(Sl,Al);function Tl(a,b,c){Jl.call(this,"Within",a,b,c)}v(Tl,Jl);function Ul(a){var b=[null].concat(Array.prototype.slice.call(arguments));return new (Function.prototype.bind.apply(Bl,b))}function Vl(a,b,c){return new Cl(a,b,c)};function Wl(a){ef.call(this);this.a=a?a:null;Xl(this)}v(Wl,ef);function Yl(a){var b=[],c;var d=0;for(c=a.length;d<c;++d)b.push(a[d].clone());return b}function Zl(a){var b;if(a.a){var c=0;for(b=a.a.length;c<b;++c)Nc(a.a[c],"change",a.u,a)}}function Xl(a){var b;if(a.a){var c=0;for(b=a.a.length;c<b;++c)z(a.a[c],"change",a.u,a)}}k=Wl.prototype;k.clone=function(){var a=new Wl(null);a.Cj(this.a);return a};
k.Mb=function(a,b,c,d){if(d<Ta(this.G(),a,b))return d;var e=this.a,f;var g=0;for(f=e.length;g<f;++g)d=e[g].Mb(a,b,c,d);return d};k.Tc=function(a,b){var c=this.a,d;var e=0;for(d=c.length;e<d;++e)if(c[e].Tc(a,b))return!0;return!1};k.De=function(a){Za(a);for(var b=this.a,c=0,d=b.length;c<d;++c)db(a,b[c].G());return a};k.pd=function(){return Yl(this.a)};
k.Zd=function(a){this.l!=this.f&&(ub(this.i),this.g=0,this.l=this.f);if(0>a||0!==this.g&&a<this.g)return this;var b=a.toString();if(this.i.hasOwnProperty(b))return this.i[b];var c=[],d=this.a,e=!1,f;var g=0;for(f=d.length;g<f;++g){var h=d[g],l=h.Zd(a);c.push(l);l!==h&&(e=!0)}if(e)return a=new Wl(null),Zl(a),a.a=c,Xl(a),a.u(),this.i[b]=a;this.g=a;return this};k.S=function(){return"GeometryCollection"};k.Ya=function(a){var b=this.a,c;var d=0;for(c=b.length;d<c;++d)if(b[d].Ya(a))return!0;return!1};
k.rotate=function(a,b){for(var c=this.a,d=0,e=c.length;d<e;++d)c[d].rotate(a,b);this.u()};k.scale=function(a,b,c){c||(c=nb(this.G()));for(var d=this.a,e=0,f=d.length;e<f;++e)d[e].scale(a,b,c);this.u()};k.Cj=function(a){a=Yl(a);Zl(this);this.a=a;Xl(this);this.u()};k.Jc=function(a){var b=this.a,c;var d=0;for(c=b.length;d<c;++d)b[d].Jc(a);this.u()};k.translate=function(a,b){var c=this.a,d;var e=0;for(d=c.length;e<d;++e)c[e].translate(a,b);this.u()};k.ka=function(){Zl(this);ef.prototype.ka.call(this)};function $l(a){a=a?a:{};fl.call(this);this.defaultDataProjection=Zb(a.defaultDataProjection?a.defaultDataProjection:"EPSG:4326");a.featureProjection&&(this.i=Zb(a.featureProjection));this.b=a.geometryName}v($l,jl);function am(a,b){return a?il((0,bm[a.type])(a),!1,b):null}function cm(a,b){return(0,dm[a.S()])(il(a,!0,b),b)}
var bm={Point:function(a){return new D(a.coordinates)},LineString:function(a){return new M(a.coordinates)},Polygon:function(a){return new E(a.coordinates)},MultiPoint:function(a){return new ql(a.coordinates)},MultiLineString:function(a){return new O(a.coordinates)},MultiPolygon:function(a){return new P(a.coordinates)},GeometryCollection:function(a,b){a=a.geometries.map(function(a){return am(a,b)});return new Wl(a)}},dm={Point:function(a){return{type:"Point",coordinates:a.V()}},LineString:function(a){return{type:"LineString",
coordinates:a.V()}},Polygon:function(a,b){if(b)var c=b.rightHanded;return{type:"Polygon",coordinates:a.V(c)}},MultiPoint:function(a){return{type:"MultiPoint",coordinates:a.V()}},MultiLineString:function(a){return{type:"MultiLineString",coordinates:a.V()}},MultiPolygon:function(a,b){if(b)var c=b.rightHanded;return{type:"MultiPolygon",coordinates:a.V(c)}},GeometryCollection:function(a,b){return{type:"GeometryCollection",geometries:a.a.map(function(a){var c=tb({},b);delete c.featureProjection;return cm(a,
c)})}},Circle:function(){return{type:"GeometryCollection",geometries:[]}}};k=$l.prototype;k.Xc=function(a,b){a="Feature"===a.type?a:{type:"Feature",geometry:a};b=am(a.geometry,b);var c=new Kk;this.b&&c.Zc(this.b);c.Sa(b);void 0!==a.id&&c.mc(a.id);a.properties&&c.H(a.properties);return c};k.Kg=function(a,b){if("FeatureCollection"===a.type){var c=[];a=a.features;var d;var e=0;for(d=a.length;e<d;++e)c.push(this.Xc(a[e],b))}else c=[this.Xc(a,b)];return c};k.Og=function(a,b){return am(a,b)};
k.Rg=function(a){a=a.crs;var b;a?"name"==a.type?b=Zb(a.properties.name):"EPSG"==a.type?b=Zb("EPSG:"+a.properties.code):wa(!1,36):b=this.defaultDataProjection;return b};k.ed=function(a,b){b=hl(this,b);var c={type:"Feature"},d=a.c;void 0!==d&&(c.id=d);(d=a.W())?c.geometry=cm(d,b):c.geometry=null;b=a.M();delete b[a.a];wb(b)?c.properties=null:c.properties=b;return c};k.te=function(a,b){b=hl(this,b);var c=[],d;var e=0;for(d=a.length;e<d;++e)c.push(this.ed(a[e],b));return{type:"FeatureCollection",features:c}};
k.ve=function(a,b){return cm(a,hl(this,b))};function em(){this.f=new XMLSerializer;fl.call(this)}v(em,fl);k=em.prototype;k.S=function(){return"xml"};k.Vb=function(a,b){return Qk(a)?fm(this,a,b):Rk(a)?this.Jg(a,b):"string"===typeof a?(a=Sk(a),fm(this,a,b)):null};function fm(a,b,c){a=gm(a,b,c);return 0<a.length?a[0]:null}k.Jg=function(){return null};k.Ma=function(a,b){return Qk(a)?gm(this,a,b):Rk(a)?this.Dc(a,b):"string"===typeof a?(a=Sk(a),gm(this,a,b)):[]};
function gm(a,b,c){var d=[];for(b=b.firstChild;b;b=b.nextSibling)b.nodeType==Node.ELEMENT_NODE&&ja(d,a.Dc(b,c));return d}k.Yc=function(a,b){if(Qk(a))return null;if(Rk(a))return this.oj(a,b);"string"===typeof a&&Sk(a);return null};k.oj=function(){return null};k.pb=function(a){return Qk(a)?this.Qg(a):Rk(a)?this.uf(a):"string"===typeof a?(a=Sk(a),this.Qg(a)):null};k.Qg=function(){return this.defaultDataProjection};k.uf=function(){return this.defaultDataProjection};
k.Gd=function(a,b){return this.f.serializeToString(this.kh(a,b))};k.kh=function(){return null};k.Yb=function(a,b){a=this.Zb(a,b);return this.f.serializeToString(a)};k.Zb=function(){return null};k.fd=function(a,b){a=this.ue(a,b);return this.f.serializeToString(a)};k.ue=function(){return null};function hm(a){a=a?a:{};this.featureType=a.featureType;this.featureNS=a.featureNS;this.srsName=a.srsName;this.schemaLocation="";this.b={};this.b["http://www.opengis.net/gml"]={featureMember:Vk(hm.prototype.ie),featureMembers:Vk(hm.prototype.ie)};em.call(this)}v(hm,em);var im=/^[\s\xa0]*$/;k=hm.prototype;
k.ie=function(a,b){var c=a.localName,d=null;if("FeatureCollection"==c)"http://www.opengis.net/wfs"===a.namespaceURI?d=L([],this.b,a,b,this):d=L(null,this.b,a,b,this);else if("featureMembers"==c||"featureMember"==c){var e=b[0],f=e.featureType,g=e.featureNS,h;if(!f&&a.childNodes){f=[];g={};var l=0;for(h=a.childNodes.length;l<h;++l){var m=a.childNodes[l];if(1===m.nodeType){var n=m.nodeName.split(":").pop();if(-1===f.indexOf(n)){var p="",q=0;m=m.namespaceURI;for(var r in g){if(g[r]===m){p=r;break}++q}p||
(p="p"+q,g[p]=m);f.push(p+":"+n)}}}"featureMember"!=c&&(e.featureType=f,e.featureNS=g)}"string"===typeof g&&(l=g,g={},g.p0=l);e={};f=Array.isArray(f)?f:[f];for(var u in g){n={};l=0;for(h=f.length;l<h;++l)(-1===f[l].indexOf(":")?"p0":f[l].split(":")[0])===u&&(n[f[l].split(":").pop()]="featureMembers"==c?Uk(this.Ig,this):Vk(this.Ig,this));e[g[u]]=n}"featureMember"==c?d=L(void 0,e,a,b):d=L([],e,a,b)}null===d&&(d=[]);return d};
k.rf=function(a,b){var c=b[0];c.srsName=a.firstElementChild.getAttribute("srsName");c.srsDimension=a.firstElementChild.getAttribute("srsDimension");if(a=L(null,this.oh,a,b,this))return il(a,!1,c)};
k.Ig=function(a,b){var c;(c=a.getAttribute("fid"))||(c=a.getAttributeNS("http://www.opengis.net/gml","id")||"");var d={},e;for(a=a.firstElementChild;a;a=a.nextElementSibling){var f=a.localName;if(0===a.childNodes.length||1===a.childNodes.length&&(3===a.firstChild.nodeType||4===a.firstChild.nodeType)){var g=Ok(a,!1);im.test(g)&&(g=void 0);d[f]=g}else"boundedBy"!==f&&(e=f),d[f]=this.rf(a,b)}b=new Kk(d);e&&b.Zc(e);c&&b.mc(c);return b};
k.tj=function(a,b){if(a=this.qf(a,b))return b=new D(null),b.aa("XYZ",a),b};k.rj=function(a,b){if(a=L([],this.ck,a,b,this))return new ql(a)};k.qj=function(a,b){if(a=L([],this.bk,a,b,this))return b=new O(null),pl(b,a),b};k.sj=function(a,b){if(a=L([],this.dk,a,b,this))return b=new P(null),rl(b,a),b};k.kj=function(a,b){bl(this.gk,a,b,this)};k.ci=function(a,b){bl(this.$j,a,b,this)};k.lj=function(a,b){bl(this.hk,a,b,this)};k.sf=function(a,b){if(a=this.qf(a,b))return b=new M(null),b.aa("XYZ",a),b};
k.Ep=function(a,b){if(a=L(null,this.we,a,b,this))return a};k.pj=function(a,b){if(a=this.qf(a,b))return b=new Bf(null),Cf(b,"XYZ",a),b};k.tf=function(a,b){if((a=L([null],this.Gf,a,b,this))&&a[0]){b=new E(null);var c=a[0],d=[c.length],e;var f=1;for(e=a.length;f<e;++f)ja(c,a[f]),d.push(c.length);b.aa("XYZ",c,d);return b}};k.qf=function(a,b){return L(null,this.we,a,b,this)};k.ck={"http://www.opengis.net/gml":{pointMember:Uk(hm.prototype.kj),pointMembers:Uk(hm.prototype.kj)}};
k.bk={"http://www.opengis.net/gml":{lineStringMember:Uk(hm.prototype.ci),lineStringMembers:Uk(hm.prototype.ci)}};k.dk={"http://www.opengis.net/gml":{polygonMember:Uk(hm.prototype.lj),polygonMembers:Uk(hm.prototype.lj)}};k.gk={"http://www.opengis.net/gml":{Point:Uk(hm.prototype.qf)}};k.$j={"http://www.opengis.net/gml":{LineString:Uk(hm.prototype.sf)}};k.hk={"http://www.opengis.net/gml":{Polygon:Uk(hm.prototype.tf)}};k.xe={"http://www.opengis.net/gml":{LinearRing:Vk(hm.prototype.Ep)}};
k.oj=function(a,b){return(a=this.rf(a,[gl(this,a,b?b:{})]))?a:null};k.Dc=function(a,b){var c={featureType:this.featureType,featureNS:this.featureNS};b&&tb(c,gl(this,a,b));return this.ie(a,[c])||[]};k.uf=function(a){return Zb(this.srsName?this.srsName:a.firstElementChild.getAttribute("srsName"))};function jm(a){a=Ok(a,!1);return km(a)}function km(a){if(a=/^\s*(true|1)|(false|0)\s*$/.exec(a))return void 0!==a[1]||!1}function lm(a){a=Ok(a,!1);a=Date.parse(a);return isNaN(a)?void 0:a/1E3}function mm(a){a=Ok(a,!1);return nm(a)}function nm(a){if(a=/^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*$/i.exec(a))return parseFloat(a[1])}function om(a){a=Ok(a,!1);return pm(a)}function pm(a){if(a=/^\s*(\d+)\s*$/.exec(a))return parseInt(a[1],10)}function Q(a){return Ok(a,!1).trim()}
function qm(a,b){rm(a,b?"1":"0")}function sm(a,b){a.appendChild(Mk.createTextNode(b.toPrecision()))}function tm(a,b){a.appendChild(Mk.createTextNode(b.toString()))}function rm(a,b){a.appendChild(Mk.createTextNode(b))};function um(a){a=a?a:{};hm.call(this,a);this.o=void 0!==a.surface?a.surface:!1;this.c=void 0!==a.curve?a.curve:!1;this.g=void 0!==a.multiCurve?a.multiCurve:!0;this.j=void 0!==a.multiSurface?a.multiSurface:!0;this.schemaLocation=a.schemaLocation?a.schemaLocation:"http://www.opengis.net/gml http://schemas.opengis.net/gml/3.1.1/profiles/gmlsfProfile/1.0.0/gmlsf.xsd";this.hasZ=void 0!==a.hasZ?a.hasZ:!1}v(um,hm);k=um.prototype;
k.Ip=function(a,b){if(a=L([],this.ak,a,b,this))return b=new O(null),pl(b,a),b};k.Jp=function(a,b){if(a=L([],this.ek,a,b,this))return b=new P(null),rl(b,a),b};k.Dh=function(a,b){bl(this.Xj,a,b,this)};k.Pj=function(a,b){bl(this.jk,a,b,this)};k.Mp=function(a,b){return L([null],this.fk,a,b,this)};k.Pp=function(a,b){return L([null],this.ik,a,b,this)};k.Np=function(a,b){return L([null],this.Gf,a,b,this)};k.Hp=function(a,b){return L([null],this.we,a,b,this)};
k.lm=function(a,b){(a=L(void 0,this.xe,a,b,this))&&b[b.length-1].push(a)};k.Jk=function(a,b){(a=L(void 0,this.xe,a,b,this))&&(b[b.length-1][0]=a)};k.uj=function(a,b){if((a=L([null],this.kk,a,b,this))&&a[0]){b=new E(null);var c=a[0],d=[c.length],e;var f=1;for(e=a.length;f<e;++f)ja(c,a[f]),d.push(c.length);b.aa("XYZ",c,d);return b}};k.mj=function(a,b){if(a=L([null],this.Yj,a,b,this))return b=new M(null),b.aa("XYZ",a),b};
k.Dp=function(a,b){a=L([null],this.Zj,a,b,this);return Ya(a[1][0],a[1][1],a[2][0],a[2][1])};k.Fp=function(a,b){var c=Ok(a,!1),d=/^\s*([+\-]?\d*\.?\d+(?:[eE][+\-]?\d+)?)\s*/;a=[];for(var e;e=d.exec(c);)a.push(parseFloat(e[1])),c=c.substr(e[0].length);if(""===c){b=b[0].srsName;c="enu";b&&(c=Zb(b).b);if("neu"===c)for(b=0,c=a.length;b<c;b+=3)d=a[b],a[b]=a[b+1],a[b+1]=d;b=a.length;2==b&&a.push(0);if(0!==b)return a}};
k.Ng=function(a,b){var c=Ok(a,!1).replace(/^\s*|\s*$/g,"");b=b[0];var d=b.srsName,e=b.srsDimension;b="enu";d&&(b=Zb(d).b);c=c.split(/\s+/);d=2;a.getAttribute("srsDimension")?d=pm(a.getAttribute("srsDimension")):a.getAttribute("dimension")?d=pm(a.getAttribute("dimension")):a.parentNode.getAttribute("srsDimension")?d=pm(a.parentNode.getAttribute("srsDimension")):e&&(d=pm(e));for(var f,g=[],h=0,l=c.length;h<l;h+=d)a=parseFloat(c[h]),e=parseFloat(c[h+1]),f=3===d?parseFloat(c[h+2]):0,"en"===b.substr(0,
2)?g.push(a,e,f):g.push(e,a,f);return g};k.we={"http://www.opengis.net/gml":{pos:Vk(um.prototype.Fp),posList:Vk(um.prototype.Ng)}};k.Gf={"http://www.opengis.net/gml":{interior:um.prototype.lm,exterior:um.prototype.Jk}};
k.oh={"http://www.opengis.net/gml":{Point:Vk(hm.prototype.tj),MultiPoint:Vk(hm.prototype.rj),LineString:Vk(hm.prototype.sf),MultiLineString:Vk(hm.prototype.qj),LinearRing:Vk(hm.prototype.pj),Polygon:Vk(hm.prototype.tf),MultiPolygon:Vk(hm.prototype.sj),Surface:Vk(um.prototype.uj),MultiSurface:Vk(um.prototype.Jp),Curve:Vk(um.prototype.mj),MultiCurve:Vk(um.prototype.Ip),Envelope:Vk(um.prototype.Dp)}};k.ak={"http://www.opengis.net/gml":{curveMember:Uk(um.prototype.Dh),curveMembers:Uk(um.prototype.Dh)}};
k.ek={"http://www.opengis.net/gml":{surfaceMember:Uk(um.prototype.Pj),surfaceMembers:Uk(um.prototype.Pj)}};k.Xj={"http://www.opengis.net/gml":{LineString:Uk(hm.prototype.sf),Curve:Uk(um.prototype.mj)}};k.jk={"http://www.opengis.net/gml":{Polygon:Uk(hm.prototype.tf),Surface:Uk(um.prototype.uj)}};k.kk={"http://www.opengis.net/gml":{patches:Vk(um.prototype.Mp)}};k.Yj={"http://www.opengis.net/gml":{segments:Vk(um.prototype.Pp)}};k.Zj={"http://www.opengis.net/gml":{lowerCorner:Uk(um.prototype.Ng),upperCorner:Uk(um.prototype.Ng)}};
k.fk={"http://www.opengis.net/gml":{PolygonPatch:Vk(um.prototype.Np)}};k.ik={"http://www.opengis.net/gml":{LineStringSegment:Vk(um.prototype.Hp)}};function vm(a,b,c){var d=c[c.length-1];c=d.hasZ;a.setAttribute("srsDimension",c?3:2);d=d.srsName;b=b.V();for(var e=b.length,f=Array(e),g,h=0;h<e;++h){g=b[h];var l=h,m=c,n="enu";d&&(n=Zb(d).b);n="en"===n.substr(0,2)?g[0]+" "+g[1]:g[1]+" "+g[0];m&&(n+=" "+(g[2]||0));f[l]=n}rm(a,f.join(" "))}
k.Ei=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);d=Nk(a.namespaceURI,"pos");a.appendChild(d);c=c[c.length-1];a=c.hasZ;d.setAttribute("srsDimension",a?3:2);var e=c.srsName;c="enu";e&&(c=Zb(e).b);b=b.V();c="en"===c.substr(0,2)?b[0]+" "+b[1]:b[1]+" "+b[0];a&&(c+=" "+(b[2]||0));rm(d,c)};var wm={"http://www.opengis.net/gml":{lowerCorner:J(rm),upperCorner:J(rm)}};k=um.prototype;
k.vn=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);cl({node:a},wm,$k,[b[0]+" "+b[1],b[2]+" "+b[3]],c,["lowerCorner","upperCorner"],this)};k.Bi=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);d=Nk(a.namespaceURI,"posList");a.appendChild(d);vm(d,b,c)};k.tn=function(a,b){a=b[b.length-1];b=a.node;var c=a.exteriorWritten;void 0===c&&(a.exteriorWritten=!0);return Nk(b.namespaceURI,void 0!==c?"interior":"exterior")};
k.bf=function(a,b,c){var d=c[c.length-1],e=d.hasZ;d=d.srsName;"PolygonPatch"!==a.nodeName&&d&&a.setAttribute("srsName",d);"Polygon"===a.nodeName||"PolygonPatch"===a.nodeName?(b=b.Xd(),cl({node:a,hasZ:e,srsName:d},xm,this.tn,b,c,void 0,this)):"Surface"===a.nodeName&&(e=Nk(a.namespaceURI,"patches"),a.appendChild(e),a=Nk(e.namespaceURI,"PolygonPatch"),e.appendChild(a),this.bf(a,b,c))};
k.af=function(a,b,c){var d=c[c.length-1].srsName;"LineStringSegment"!==a.nodeName&&d&&a.setAttribute("srsName",d);"LineString"===a.nodeName||"LineStringSegment"===a.nodeName?(d=Nk(a.namespaceURI,"posList"),a.appendChild(d),vm(d,b,c)):"Curve"===a.nodeName&&(d=Nk(a.namespaceURI,"segments"),a.appendChild(d),a=Nk(d.namespaceURI,"LineStringSegment"),d.appendChild(a),this.af(a,b,c))};
k.Di=function(a,b,c){var d=c[c.length-1],e=d.hasZ,f=d.srsName;d=d.surface;f&&a.setAttribute("srsName",f);b=b.Yd();cl({node:a,hasZ:e,srsName:f,surface:d},ym,this.l,b,c,void 0,this)};k.wn=function(a,b,c){var d=c[c.length-1],e=d.srsName;d=d.hasZ;e&&a.setAttribute("srsName",e);b=b.ee();cl({node:a,hasZ:d,srsName:e},zm,Yk("pointMember"),b,c,void 0,this)};
k.Ci=function(a,b,c){var d=c[c.length-1],e=d.hasZ,f=d.srsName;d=d.curve;f&&a.setAttribute("srsName",f);b=b.qd();cl({node:a,hasZ:e,srsName:f,curve:d},Am,this.l,b,c,void 0,this)};k.Fi=function(a,b,c){var d=Nk(a.namespaceURI,"LinearRing");a.appendChild(d);this.Bi(d,b,c)};k.Gi=function(a,b,c){var d=this.a(b,c);d&&(a.appendChild(d),this.bf(d,b,c))};k.xn=function(a,b,c){var d=Nk(a.namespaceURI,"Point");a.appendChild(d);this.Ei(d,b,c)};
k.Ai=function(a,b,c){var d=this.a(b,c);d&&(a.appendChild(d),this.af(d,b,c))};k.wd=function(a,b,c){var d=c[c.length-1],e=tb({},d);e.node=a;var f;Array.isArray(b)?d.dataProjection?f=lc(b,d.featureProjection,d.dataProjection):f=b:f=il(b,!0,d);cl(e,Bm,this.a,[f],c,void 0,this)};
k.zi=function(a,b,c){var d=b.c;d&&a.setAttribute("fid",d);d=c[c.length-1];var e=d.featureNS,f=b.a;d.qb||(d.qb={},d.qb[e]={});var g=b.M();b=[];var h=[];for(m in g){var l=g[m];null!==l&&(b.push(m),h.push(l),m==f||l instanceof ef?m in d.qb[e]||(d.qb[e][m]=J(this.wd,this)):m in d.qb[e]||(d.qb[e][m]=J(rm)))}var m=tb({},d);m.node=a;cl(m,d.qb,Yk(void 0,e),h,c,b)};
var ym={"http://www.opengis.net/gml":{surfaceMember:J(um.prototype.Gi),polygonMember:J(um.prototype.Gi)}},zm={"http://www.opengis.net/gml":{pointMember:J(um.prototype.xn)}},Am={"http://www.opengis.net/gml":{lineStringMember:J(um.prototype.Ai),curveMember:J(um.prototype.Ai)}},xm={"http://www.opengis.net/gml":{exterior:J(um.prototype.Fi),interior:J(um.prototype.Fi)}},Bm={"http://www.opengis.net/gml":{Curve:J(um.prototype.af),MultiCurve:J(um.prototype.Ci),Point:J(um.prototype.Ei),MultiPoint:J(um.prototype.wn),
LineString:J(um.prototype.af),MultiLineString:J(um.prototype.Ci),LinearRing:J(um.prototype.Bi),Polygon:J(um.prototype.bf),MultiPolygon:J(um.prototype.Di),Surface:J(um.prototype.bf),MultiSurface:J(um.prototype.Di),Envelope:J(um.prototype.vn)}},Cm={MultiLineString:"lineStringMember",MultiCurve:"curveMember",MultiPolygon:"polygonMember",MultiSurface:"surfaceMember"};um.prototype.l=function(a,b){return Nk("http://www.opengis.net/gml",Cm[b[b.length-1].node.nodeName])};
um.prototype.a=function(a,b){var c=b[b.length-1];b=c.multiSurface;var d=c.surface,e=c.curve;c=c.multiCurve;Array.isArray(a)?a="Envelope":(a=a.S(),"MultiPolygon"===a&&!0===b?a="MultiSurface":"Polygon"===a&&!0===d?a="Surface":"LineString"===a&&!0===e?a="Curve":"MultiLineString"===a&&!0===c&&(a="MultiCurve"));return Nk("http://www.opengis.net/gml",a)};
um.prototype.ue=function(a,b){b=hl(this,b);var c=Nk("http://www.opengis.net/gml","geom"),d={node:c,hasZ:this.hasZ,srsName:this.srsName,curve:this.c,surface:this.o,multiSurface:this.j,multiCurve:this.g};b&&tb(d,b);this.wd(c,a,[d]);return c};
um.prototype.Zb=function(a,b){b=hl(this,b);var c=Nk("http://www.opengis.net/gml","featureMembers");c.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation",this.schemaLocation);var d={srsName:this.srsName,hasZ:this.hasZ,curve:this.c,surface:this.o,multiSurface:this.j,multiCurve:this.g,featureNS:this.featureNS,featureType:this.featureType};b&&tb(d,b);b=[d];var e=b[b.length-1];d=e.featureType;var f=e.featureNS,g={};g[f]={};g[f][d]=J(this.zi,this);e=tb({},e);e.node=c;cl(e,g,
Yk(d,f),a,b);return c};function Dm(a){a=a?a:{};hm.call(this,a);this.b["http://www.opengis.net/gml"].featureMember=Uk(hm.prototype.ie);this.schemaLocation=a.schemaLocation?a.schemaLocation:"http://www.opengis.net/gml http://schemas.opengis.net/gml/2.1.2/feature.xsd"}v(Dm,hm);k=Dm.prototype;
k.nj=function(a,b){a=Ok(a,!1).replace(/^\s*|\s*$/g,"");var c=b[0].srsName;b="enu";c&&(c=Zb(c))&&(b=c.b);a=a.trim().split(/\s+/);for(var d,e,f=[],g=0,h=a.length;g<h;g++)e=a[g].split(/,+/),c=parseFloat(e[0]),d=parseFloat(e[1]),e=3===e.length?parseFloat(e[2]):0,"en"===b.substr(0,2)?f.push(c,d,e):f.push(d,c,e);return f};k.Bp=function(a,b){a=L([null],this.Wj,a,b,this);return Ya(a[1][0],a[1][1],a[1][3],a[1][4])};k.jm=function(a,b){(a=L(void 0,this.xe,a,b,this))&&b[b.length-1].push(a)};
k.kp=function(a,b){(a=L(void 0,this.xe,a,b,this))&&(b[b.length-1][0]=a)};k.we={"http://www.opengis.net/gml":{coordinates:Vk(Dm.prototype.nj)}};k.Gf={"http://www.opengis.net/gml":{innerBoundaryIs:Dm.prototype.jm,outerBoundaryIs:Dm.prototype.kp}};k.Wj={"http://www.opengis.net/gml":{coordinates:Uk(Dm.prototype.nj)}};
k.oh={"http://www.opengis.net/gml":{Point:Vk(hm.prototype.tj),MultiPoint:Vk(hm.prototype.rj),LineString:Vk(hm.prototype.sf),MultiLineString:Vk(hm.prototype.qj),LinearRing:Vk(hm.prototype.pj),Polygon:Vk(hm.prototype.tf),MultiPolygon:Vk(hm.prototype.sj),Box:Vk(Dm.prototype.Bp)}};
k.vg=function(a,b){var c=b[b.length-1];b=c.multiSurface;var d=c.surface;c=c.multiCurve;Array.isArray(a)?a="Envelope":(a=a.S(),"MultiPolygon"===a&&!0===b?a="MultiSurface":"Polygon"===a&&!0===d?a="Surface":"MultiLineString"===a&&!0===c&&(a="MultiCurve"));return Nk("http://www.opengis.net/gml",a)};k.ri=function(a,b,c){var d=c[c.length-1],e=tb({},d);e.node=a;var f;Array.isArray(b)?d.dataProjection?f=lc(b,d.featureProjection,d.dataProjection):f=b:f=il(b,!0,d);cl(e,Em,this.vg,[f],c,void 0,this)};
k.Ze=function(a,b,c){var d=c[c.length-1].srsName;"LineStringSegment"!==a.nodeName&&d&&a.setAttribute("srsName",d);"LineString"===a.nodeName||"LineStringSegment"===a.nodeName?(d=Fm(a.namespaceURI),a.appendChild(d),Gm(d,b,c)):"Curve"===a.nodeName&&(d=Nk(a.namespaceURI,"segments"),a.appendChild(d),a=Nk(d.namespaceURI,"LineStringSegment"),d.appendChild(a),this.Ze(a,b,c))};function Fm(a){a=Nk(a,"coordinates");a.setAttribute("decimal",".");a.setAttribute("cs",",");a.setAttribute("ts"," ");return a}
function Gm(a,b,c){var d=c[c.length-1];c=d.hasZ;d=d.srsName;b=b.V();for(var e=b.length,f=Array(e),g,h=0;h<e;++h)g=b[h],f[h]=Hm(g,d,c);rm(a,f.join(" "))}
k.$e=function(a,b,c){var d=c[c.length-1],e=d.hasZ;d=d.srsName;"PolygonPatch"!==a.nodeName&&d&&a.setAttribute("srsName",d);"Polygon"===a.nodeName||"PolygonPatch"===a.nodeName?(b=b.Xd(),cl({node:a,hasZ:e,srsName:d},Im,this.pn,b,c,void 0,this)):"Surface"===a.nodeName&&(e=Nk(a.namespaceURI,"patches"),a.appendChild(e),a=Nk(e.namespaceURI,"PolygonPatch"),e.appendChild(a),this.$e(a,b,c))};
k.pn=function(a,b){a=b[b.length-1];b=a.node;var c=a.exteriorWritten;void 0===c&&(a.exteriorWritten=!0);return Nk(b.namespaceURI,void 0!==c?"innerBoundaryIs":"outerBoundaryIs")};k.xi=function(a,b,c){var d=Nk(a.namespaceURI,"LinearRing");a.appendChild(d);this.ti(d,b,c)};function Hm(a,b,c){var d="enu";b&&(d=Zb(b).b);b="en"===d.substr(0,2)?a[0]+","+a[1]:a[1]+","+a[0];c&&(b+=","+(a[2]||0));return b}
k.ui=function(a,b,c){var d=c[c.length-1],e=d.hasZ,f=d.srsName;d=d.curve;f&&a.setAttribute("srsName",f);b=b.qd();cl({node:a,hasZ:e,srsName:f,curve:d},Jm,this.a,b,c,void 0,this)};k.wi=function(a,b,c){var d=c[c.length-1];c=d.hasZ;var e=d.srsName;e&&a.setAttribute("srsName",e);d=Fm(a.namespaceURI);a.appendChild(d);a=b.V();a=Hm(a,e,c);rm(d,a)};
k.rn=function(a,b,c){var d=c[c.length-1],e=d.hasZ;(d=d.srsName)&&a.setAttribute("srsName",d);b=b.ee();cl({node:a,hasZ:e,srsName:d},Km,Yk("pointMember"),b,c,void 0,this)};k.sn=function(a,b,c){var d=Nk(a.namespaceURI,"Point");a.appendChild(d);this.wi(d,b,c)};k.si=function(a,b,c){var d=this.vg(b,c);d&&(a.appendChild(d),this.Ze(d,b,c))};k.ti=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);d=Fm(a.namespaceURI);a.appendChild(d);Gm(d,b,c)};
k.vi=function(a,b,c){var d=c[c.length-1],e=d.hasZ,f=d.srsName;d=d.surface;f&&a.setAttribute("srsName",f);b=b.Yd();cl({node:a,hasZ:e,srsName:f,surface:d},Lm,this.a,b,c,void 0,this)};k.yi=function(a,b,c){var d=this.vg(b,c);d&&(a.appendChild(d),this.$e(d,b,c))};k.qn=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);cl({node:a},Mm,$k,[b[0]+" "+b[1],b[2]+" "+b[3]],c,["lowerCorner","upperCorner"],this)};
var Em={"http://www.opengis.net/gml":{Curve:J(Dm.prototype.Ze),MultiCurve:J(Dm.prototype.ui),Point:J(Dm.prototype.wi),MultiPoint:J(Dm.prototype.rn),LineString:J(Dm.prototype.Ze),MultiLineString:J(Dm.prototype.ui),LinearRing:J(Dm.prototype.ti),Polygon:J(Dm.prototype.$e),MultiPolygon:J(Dm.prototype.vi),Surface:J(Dm.prototype.$e),MultiSurface:J(Dm.prototype.vi),Envelope:J(Dm.prototype.qn)}},Im={"http://www.opengis.net/gml":{outerBoundaryIs:J(Dm.prototype.xi),innerBoundaryIs:J(Dm.prototype.xi)}},Km={"http://www.opengis.net/gml":{pointMember:J(Dm.prototype.sn)}},
Jm={"http://www.opengis.net/gml":{lineStringMember:J(Dm.prototype.si),curveMember:J(Dm.prototype.si)}};Dm.prototype.a=function(a,b){return Nk("http://www.opengis.net/gml",Nm[b[b.length-1].node.nodeName])};var Nm={MultiLineString:"lineStringMember",MultiCurve:"curveMember",MultiPolygon:"polygonMember",MultiSurface:"surfaceMember"},Lm={"http://www.opengis.net/gml":{surfaceMember:J(Dm.prototype.yi),polygonMember:J(Dm.prototype.yi)}},Mm={"http://www.opengis.net/gml":{lowerCorner:J(rm),upperCorner:J(rm)}};function Om(a){a=a?a:{};em.call(this);this.defaultDataProjection=Zb("EPSG:4326");this.b=a.readExtensions}v(Om,em);var Pm=[null,"http://www.topografix.com/GPX/1/0","http://www.topografix.com/GPX/1/1"];function Qm(a,b,c,d){a.push(parseFloat(c.getAttribute("lon")),parseFloat(c.getAttribute("lat")));"ele"in d?(a.push(d.ele),delete d.ele,b.hasZ=!0):a.push(0);"time"in d?(a.push(d.time),delete d.time,b.hasM=!0):a.push(0);return a}
function Rm(a,b,c){var d="XY",e=2;a.hasZ&&a.hasM?(d="XYZM",e=4):a.hasZ?(d="XYZ",e=3):a.hasM&&(d="XYM",e=3);if(4!==e){var f;var g=0;for(f=b.length/4;g<f;g++)b[g*e]=b[4*g],b[g*e+1]=b[4*g+1],a.hasZ&&(b[g*e+2]=b[4*g+2]),a.hasM&&(b[g*e+2]=b[4*g+3]);b.length=b.length/4*e;if(c)for(g=0,f=c.length;g<f;g++)c[g]=c[g]/4*e}return d}function Sm(a,b){var c=b[b.length-1],d=a.getAttribute("href");null!==d&&(c.link=d);bl(Tm,a,b)}function Um(a,b){b[b.length-1].extensionsNode_=a}
function Vm(a,b){var c=b[0];if(a=L({flatCoordinates:[],layoutOptions:{}},Wm,a,b)){b=a.flatCoordinates;delete a.flatCoordinates;var d=a.layoutOptions;delete a.layoutOptions;d=Rm(d,b);var e=new M(null);e.aa(d,b);il(e,!1,c);c=new Kk(e);c.H(a);return c}}
function Xm(a,b){var c=b[0];if(a=L({flatCoordinates:[],ends:[],layoutOptions:{}},Ym,a,b)){b=a.flatCoordinates;delete a.flatCoordinates;var d=a.ends;delete a.ends;var e=a.layoutOptions;delete a.layoutOptions;e=Rm(e,b,d);var f=new O(null);f.aa(e,b,d);il(f,!1,c);c=new Kk(f);c.H(a);return c}}function Zm(a,b){var c=b[0];if(b=L({},$m,a,b)){var d={};a=Qm([],d,a,b);d=Rm(d,a);a=new D(a,d);il(a,!1,c);c=new Kk(a);c.H(b);return c}}
var an={rte:Vm,trk:Xm,wpt:Zm},bn=K(Pm,{rte:Uk(Vm),trk:Uk(Xm),wpt:Uk(Zm)}),Tm=K(Pm,{text:I(Q,"linkText"),type:I(Q,"linkType")}),Wm=K(Pm,{name:I(Q),cmt:I(Q),desc:I(Q),src:I(Q),link:Sm,number:I(om),extensions:Um,type:I(Q),rtept:function(a,b){var c=L({},cn,a,b);c&&(b=b[b.length-1],Qm(b.flatCoordinates,b.layoutOptions,a,c))}}),cn=K(Pm,{ele:I(mm),time:I(lm)}),Ym=K(Pm,{name:I(Q),cmt:I(Q),desc:I(Q),src:I(Q),link:Sm,number:I(om),type:I(Q),extensions:Um,trkseg:function(a,b){var c=b[b.length-1];bl(dn,a,b);c.ends.push(c.flatCoordinates.length)}}),
dn=K(Pm,{trkpt:function(a,b){var c=L({},en,a,b);c&&(b=b[b.length-1],Qm(b.flatCoordinates,b.layoutOptions,a,c))}}),en=K(Pm,{ele:I(mm),time:I(lm)}),$m=K(Pm,{ele:I(mm),time:I(lm),magvar:I(mm),geoidheight:I(mm),name:I(Q),cmt:I(Q),desc:I(Q),src:I(Q),link:Sm,sym:I(Q),type:I(Q),fix:I(Q),sat:I(om),hdop:I(mm),vdop:I(mm),pdop:I(mm),ageofdgpsdata:I(mm),dgpsid:I(om),extensions:Um});
function fn(a,b){b||(b=[]);for(var c=0,d=b.length;c<d;++c){var e=b[c];if(a.b){var f=e.get("extensionsNode_")||null;a.b(e,f)}e.set("extensionsNode_",void 0)}}Om.prototype.Jg=function(a,b){if(!ha(Pm,a.namespaceURI))return null;var c=an[a.localName];if(!c)return null;a=c(a,[gl(this,a,b)]);if(!a)return null;fn(this,[a]);return a};Om.prototype.Dc=function(a,b){return ha(Pm,a.namespaceURI)?"gpx"==a.localName&&(a=L([],bn,a,[gl(this,a,b)]))?(fn(this,a),a):[]:[]};
function gn(a,b,c){a.setAttribute("href",b);b=c[c.length-1].properties;cl({node:a},hn,$k,[b.linkText,b.linkType],c,jn)}function kn(a,b,c){var d=c[c.length-1],e=d.node.namespaceURI,f=d.properties;a.setAttributeNS(null,"lat",b[1]);a.setAttributeNS(null,"lon",b[0]);switch(d.geometryLayout){case "XYZM":0!==b[3]&&(f.time=b[3]);case "XYZ":0!==b[2]&&(f.ele=b[2]);break;case "XYM":0!==b[2]&&(f.time=b[2])}b="rtept"==a.nodeName?ln[e]:mn[e];d=al(f,b);cl({node:a,properties:f},nn,$k,d,c,b)}
var jn=["text","type"],hn=K(Pm,{text:J(rm),type:J(rm)}),on=K(Pm,"name cmt desc src link number type rtept".split(" ")),pn=K(Pm,{name:J(rm),cmt:J(rm),desc:J(rm),src:J(rm),link:J(gn),number:J(tm),type:J(rm),rtept:Xk(J(kn))}),ln=K(Pm,["ele","time"]),qn=K(Pm,"name cmt desc src link number type trkseg".split(" ")),tn=K(Pm,{name:J(rm),cmt:J(rm),desc:J(rm),src:J(rm),link:J(gn),number:J(tm),type:J(rm),trkseg:Xk(J(function(a,b,c){cl({node:a,geometryLayout:b.ja,properties:{}},rn,sn,b.V(),c)}))}),sn=Yk("trkpt"),
rn=K(Pm,{trkpt:J(kn)}),mn=K(Pm,"ele time magvar geoidheight name cmt desc src link sym type fix sat hdop vdop pdop ageofdgpsdata dgpsid".split(" ")),nn=K(Pm,{ele:J(sm),time:J(function(a,b){b=new Date(1E3*b);a.appendChild(Mk.createTextNode(b.getUTCFullYear()+"-"+we(b.getUTCMonth()+1)+"-"+we(b.getUTCDate())+"T"+we(b.getUTCHours())+":"+we(b.getUTCMinutes())+":"+we(b.getUTCSeconds())+"Z"))}),magvar:J(sm),geoidheight:J(sm),name:J(rm),cmt:J(rm),desc:J(rm),src:J(rm),link:J(gn),sym:J(rm),type:J(rm),fix:J(rm),
sat:J(tm),hdop:J(sm),vdop:J(sm),pdop:J(sm),ageofdgpsdata:J(sm),dgpsid:J(tm)}),un={Point:"wpt",LineString:"rte",MultiLineString:"trk"};function vn(a,b){if(a=a.W())if(a=un[a.S()])return Nk(b[b.length-1].node.namespaceURI,a)}
var wn=K(Pm,{rte:J(function(a,b,c){var d=c[0],e=b.M();a={node:a,properties:e};if(b=b.W())b=il(b,!0,d),a.geometryLayout=b.ja,e.rtept=b.V();d=on[c[c.length-1].node.namespaceURI];e=al(e,d);cl(a,pn,$k,e,c,d)}),trk:J(function(a,b,c){var d=c[0],e=b.M();a={node:a,properties:e};if(b=b.W())b=il(b,!0,d),e.trkseg=b.qd();d=qn[c[c.length-1].node.namespaceURI];e=al(e,d);cl(a,tn,$k,e,c,d)}),wpt:J(function(a,b,c){var d=c[0],e=c[c.length-1];e.properties=b.M();if(b=b.W())b=il(b,!0,d),e.geometryLayout=b.ja,kn(a,b.V(),
c)})});Om.prototype.Zb=function(a,b){b=hl(this,b);var c=Nk("http://www.topografix.com/GPX/1/1","gpx");c.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:xsi","http://www.w3.org/2001/XMLSchema-instance");c.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation","http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd");c.setAttribute("version","1.1");c.setAttribute("creator","OpenLayers");cl({node:c},wn,vn,a,[b]);return c};function xn(){fl.call(this)}v(xn,fl);function yn(a){return"string"===typeof a?a:""}k=xn.prototype;k.S=function(){return"text"};k.Vb=function(a,b){return this.he(yn(a),hl(this,b))};k.Ma=function(a,b){return this.Lg(yn(a),hl(this,b))};k.Yc=function(a,b){return this.Dd(yn(a),hl(this,b))};k.pb=function(){return this.defaultDataProjection};k.Gd=function(a,b){return this.se(a,hl(this,b))};k.Yb=function(a,b){return this.lh(a,hl(this,b))};k.fd=function(a,b){return this.Hd(a,hl(this,b))};function zn(a){a=a?a:{};fl.call(this);this.defaultDataProjection=Zb("EPSG:4326");this.b=a.altitudeMode?a.altitudeMode:"none"}v(zn,xn);var An=/^B(\d{2})(\d{2})(\d{2})(\d{2})(\d{5})([NS])(\d{3})(\d{5})([EW])([AV])(\d{5})(\d{5})/,Bn=/^H.([A-Z]{3}).*?:(.*)/,Cn=/^HFDTE(\d{2})(\d{2})(\d{2})/,Dn=/\r\n|\r|\n/;k=zn.prototype;
k.he=function(a,b){var c=this.b,d=a.split(Dn);a={};var e=[],f=2E3,g=0,h=1,l=-1,m;var n=0;for(m=d.length;n<m;++n){var p=d[n],q;if("B"==p.charAt(0)){if(q=An.exec(p)){p=parseInt(q[1],10);var r=parseInt(q[2],10),u=parseInt(q[3],10),x=parseInt(q[4],10)+parseInt(q[5],10)/6E4;"S"==q[6]&&(x=-x);var B=parseInt(q[7],10)+parseInt(q[8],10)/6E4;"W"==q[9]&&(B=-B);e.push(B,x);"none"!=c&&e.push("gps"==c?parseInt(q[11],10):"barometric"==c?parseInt(q[12],10):0);q=Date.UTC(f,g,h,p,r,u);q<l&&(q=Date.UTC(f,g,h+1,p,r,
u));e.push(q/1E3);l=q}}else"H"==p.charAt(0)&&((q=Cn.exec(p))?(h=parseInt(q[1],10),g=parseInt(q[2],10)-1,f=2E3+parseInt(q[3],10)):(q=Bn.exec(p))&&(a[q[1]]=q[2].trim()))}if(0===e.length)return null;d=new M(null);d.aa("none"==c?"XYM":"XYZM",e);b=new Kk(il(d,!1,b));b.H(a);return b};k.Lg=function(a,b){return(a=this.he(a,b))?[a]:[]};k.se=function(){};k.lh=function(){};k.Hd=function(){};k.Dd=function(){};function En(a,b,c,d,e,f){Tc.call(this);this.j=null;this.N=a?a:new Image;null!==d&&(this.N.crossOrigin=d);this.c=f?document.createElement("CANVAS"):null;this.g=f;this.i=null;this.f=e;this.a=c;this.l=b;this.o=!1;2==this.f&&Fn(this)}v(En,Tc);function Fn(a){var b=dg(1,1);try{b.drawImage(a.N,0,0),b.getImageData(0,0,1,1)}catch(c){a.o=!0}}En.prototype.v=function(){this.f=3;this.i.forEach(Hc);this.i=null;this.b("change")};
En.prototype.s=function(){this.f=2;this.a&&(this.N.width=this.a[0],this.N.height=this.a[1]);this.a=[this.N.width,this.N.height];this.i.forEach(Hc);this.i=null;Fn(this);if(!this.o&&null!==this.g){this.c.width=this.N.width;this.c.height=this.N.height;var a=this.c.getContext("2d");a.drawImage(this.N,0,0);for(var b=a.getImageData(0,0,this.N.width,this.N.height),c=b.data,d=this.g[0]/255,e=this.g[1]/255,f=this.g[2]/255,g=0,h=c.length;g<h;g+=4)c[g]*=d,c[g+1]*=e,c[g+2]*=f;a.putImageData(b,0,0)}this.b("change")};
En.prototype.Y=function(){return this.c?this.c:this.N};En.prototype.load=function(){if(0==this.f){this.f=1;this.i=[Mc(this.N,"error",this.v,this),Mc(this.N,"load",this.s,this)];try{this.N.src=this.l}catch(a){this.v()}}};function Gn(a){a=a||{};this.l=void 0!==a.anchor?a.anchor:[.5,.5];this.s=null;this.f=void 0!==a.anchorOrigin?a.anchorOrigin:"top-left";this.D=void 0!==a.anchorXUnits?a.anchorXUnits:"fraction";this.B=void 0!==a.anchorYUnits?a.anchorYUnits:"fraction";this.sa=void 0!==a.crossOrigin?a.crossOrigin:null;var b=void 0!==a.img?a.img:null,c=void 0!==a.imgSize?a.imgSize:null,d=a.src;wa(!(void 0!==d&&b),4);wa(!b||b&&c,5);void 0!==d&&0!==d.length||!b||(d=b.src||w(b).toString());wa(void 0!==d&&0<d.length,6);var e=
void 0!==a.src?0:2;this.j=void 0!==a.color?Ph(a.color):null;var f=this.sa,g=this.j,h=zi.get(d,f,g);h||(h=new En(b,d,c,f,e,g),zi.set(d,f,g,h));this.b=h;this.ra=void 0!==a.offset?a.offset:[0,0];this.c=void 0!==a.offsetOrigin?a.offsetOrigin:"top-left";this.O=null;this.C=void 0!==a.size?a.size:null;yk.call(this,{opacity:void 0!==a.opacity?a.opacity:1,rotation:void 0!==a.rotation?a.rotation:0,scale:void 0!==a.scale?a.scale:1,snapToPixel:void 0!==a.snapToPixel?a.snapToPixel:!0,rotateWithView:void 0!==a.rotateWithView?
a.rotateWithView:!1})}v(Gn,yk);k=Gn.prototype;k.clone=function(){return new Gn({anchor:this.l.slice(),anchorOrigin:this.f,anchorXUnits:this.D,anchorYUnits:this.B,crossOrigin:this.sa,color:this.j&&this.j.slice?this.j.slice():this.j||void 0,src:this.b.l,offset:this.ra.slice(),offsetOrigin:this.c,size:null!==this.C?this.C.slice():void 0,opacity:this.i,scale:this.a,snapToPixel:this.v,rotation:this.g,rotateWithView:this.o})};
k.Oc=function(){if(this.s)return this.s;var a=this.l,b=this.kc();if("fraction"==this.D||"fraction"==this.B){if(!b)return null;a=this.l.slice();"fraction"==this.D&&(a[0]*=b[0]);"fraction"==this.B&&(a[1]*=b[1])}if("top-left"!=this.f){if(!b)return null;a===this.l&&(a=this.l.slice());if("top-right"==this.f||"bottom-right"==this.f)a[0]=-a[0]+b[0];if("bottom-left"==this.f||"bottom-right"==this.f)a[1]=-a[1]+b[1]}return this.s=a};k.To=function(){return this.j};k.Y=function(a){return this.b.Y(a)};k.Ie=function(){return this.b.a};
k.gf=function(){return this.b.f};k.Cg=function(){var a=this.b;if(!a.j)if(a.o){var b=a.a[0],c=a.a[1],d=dg(b,c);d.fillRect(0,0,b,c);a.j=d.canvas}else a.j=a.N;return a.j};k.Vc=function(){if(this.O)return this.O;var a=this.ra;if("top-left"!=this.c){var b=this.kc(),c=this.b.a;if(!b||!c)return null;a=a.slice();if("top-right"==this.c||"bottom-right"==this.c)a[0]=c[0]-b[0]-a[0];if("bottom-left"==this.c||"bottom-right"==this.c)a[1]=c[1]-b[1]-a[1]}return this.O=a};k.Uo=function(){return this.b.l};
k.kc=function(){return this.C?this.C:this.b.a};k.di=function(a,b){return z(this.b,"change",a,b)};k.load=function(){this.b.load()};k.Qj=function(a,b){Nc(this.b,"change",a,b)};function Hn(a){a=a||{};this.a=a.font;this.i=a.rotation;this.l=a.rotateWithView;this.b=a.scale;this.qa=a.text;this.g=a.textAlign;this.j=a.textBaseline;this.Wa=void 0!==a.fill?a.fill:new Ck({color:"#333"});this.v=void 0!==a.maxAngle?a.maxAngle:Math.PI/4;this.s=void 0!==a.placement?a.placement:"point";this.o=void 0!==a.exceedLength?a.exceedLength:!1;this.Ta=void 0!==a.stroke?a.stroke:null;this.f=void 0!==a.offsetX?a.offsetX:0;this.c=void 0!==a.offsetY?a.offsetY:0}k=Hn.prototype;
k.clone=function(){return new Hn({font:this.a,placement:this.s,maxAngle:this.v,exceedLength:this.o,rotation:this.i,rotateWithView:this.l,scale:this.b,text:this.Ia(),textAlign:this.g,textBaseline:this.j,fill:this.Ca()?this.Ca().clone():void 0,stroke:this.Da()?this.Da().clone():void 0,offsetX:this.f,offsetY:this.c})};k.Wk=function(){return this.o};k.Xk=function(){return this.a};k.jl=function(){return this.v};k.ql=function(){return this.s};k.ml=function(){return this.f};k.nl=function(){return this.c};
k.Ca=function(){return this.Wa};k.Zo=function(){return this.l};k.$o=function(){return this.i};k.ap=function(){return this.b};k.Da=function(){return this.Ta};k.Ia=function(){return this.qa};k.wl=function(){return this.g};k.xl=function(){return this.j};k.aq=function(a){this.o=a};k.Bj=function(a){this.a=a};k.hq=function(a){this.v=a};k.Fj=function(a){this.f=a};k.Gj=function(a){this.c=a};k.lq=function(a){this.s=a};k.yf=function(a){this.Wa=a};k.bp=function(a){this.i=a};k.fj=function(a){this.b=a};
k.Af=function(a){this.Ta=a};k.Ed=function(a){this.qa=a};k.Ij=function(a){this.g=a};k.nq=function(a){this.j=a};function In(a){a=a?a:{};em.call(this);Jn||(Kn=[255,255,255,1],Ln=new Ck({color:Kn}),Mn=[20,2],Nn=On="pixels",Pn=[64,64],Qn="https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png",Rn=.5,Sn=new Gn({anchor:Mn,anchorOrigin:"bottom-left",anchorXUnits:On,anchorYUnits:Nn,crossOrigin:"anonymous",rotation:0,scale:Rn,size:Pn,src:Qn}),Tn="NO_IMAGE",Un=new Dk({color:Kn,width:1}),Vn=new Dk({color:[51,51,51,1],width:2}),Wn=new Hn({font:"bold 16px Helvetica",fill:Ln,stroke:Vn,scale:.8}),Xn=new Ek({fill:Ln,
image:Sn,text:Wn,stroke:Un,zIndex:0}),Jn=[Xn]);this.defaultDataProjection=Zb("EPSG:4326");this.a=a.defaultStyle?a.defaultStyle:Jn;this.c=void 0!==a.extractStyles?a.extractStyles:!0;this.j=void 0!==a.writeStyles?a.writeStyles:!0;this.b={};this.g=void 0!==a.showPointNames?a.showPointNames:!0}var Jn,Kn,Ln,Mn,On,Nn,Pn,Qn,Rn,Sn,Tn,Un,Vn,Wn,Xn;v(In,em);
var Yn=["http://www.google.com/kml/ext/2.2"],Zn=[null,"http://earth.google.com/kml/2.0","http://earth.google.com/kml/2.1","http://earth.google.com/kml/2.2","http://www.opengis.net/kml/2.2"],$n={fraction:"fraction",pixels:"pixels",insetPixels:"pixels"};
function ao(a,b){var c=[0,0],d="start";if(a.Y()){var e=a.Y().Ie();null===e&&(e=Pn);2==e.length&&(d=a.Y().a,c[0]=d*e[0]/2,c[1]=-d*e[1]/2,d="left")}null!==a.Ia()?(e=a.Ia(),a=e.clone(),a.Bj(e.a||Wn.a),a.fj(e.b||Wn.b),a.yf(e.Ca()||Wn.Ca()),a.Af(e.Da()||Vn)):a=Wn.clone();a.Ed(b);a.Fj(c[0]);a.Gj(c[1]);a.Ij(d);return new Ek({text:a})}
function bo(a,b,c,d,e){return function(){var f=e,g="";f&&this.W()&&(f="Point"===this.W().S());f&&(g=this.get("name"),f=f&&g);if(a)return f?(f=ao(a[0],g),a.concat(f)):a;if(b){var h=co(b,c,d);return f?(f=ao(h[0],g),h.concat(f)):h}return f?(f=ao(c[0],g),c.concat(f)):c}}function co(a,b,c){return Array.isArray(a)?a:"string"===typeof a?(!(a in c)&&"#"+a in c&&(a="#"+a),co(c[a],b,c)):b}
function eo(a){a=Ok(a,!1);if(a=/^\s*#?\s*([0-9A-Fa-f]{8})\s*$/.exec(a))return a=a[1],[parseInt(a.substr(6,2),16),parseInt(a.substr(4,2),16),parseInt(a.substr(2,2),16),parseInt(a.substr(0,2),16)/255]}function fo(a){a=Ok(a,!1);for(var b=[],c=/^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*,\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s*,\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?))?\s*/i,d;d=c.exec(a);)b.push(parseFloat(d[1]),parseFloat(d[2]),d[3]?parseFloat(d[3]):0),a=a.substr(d[0].length);if(""===a)return b}
function go(a){var b=Ok(a,!1).trim();a=a.baseURI;a&&"about:blank"!=a||(a=window.location.href);return a?(new URL(b,a)).href:b}function ho(a){return mm(a)}function io(a,b){return L(null,jo,a,b)}function ko(a,b){if(b=L({A:[],Tj:[]},lo,a,b)){a=b.A;b=b.Tj;var c;var d=0;for(c=Math.min(a.length,b.length);d<c;++d)a[4*d+3]=b[d];b=new M(null);b.aa("XYZM",a);return b}}function mo(a,b){var c=L({},no,a,b);if(a=L(null,oo,a,b))return b=new M(null),b.aa("XYZ",a),b.H(c),b}
function po(a,b){var c=L({},no,a,b);if(a=L(null,oo,a,b))return b=new E(null),b.aa("XYZ",a,[a.length]),b.H(c),b}
function qo(a,b){a=L([],ro,a,b);if(!a)return null;if(0===a.length)return new Wl(a);var c=!0,d=a[0].S(),e;var f=1;for(e=a.length;f<e;++f)if(b=a[f],b.S()!=d){c=!1;break}if(c)if("Point"==d){var g=a[0];c=g.ja;d=g.ca();f=1;for(e=a.length;f<e;++f)b=a[f],ja(d,b.ca());g=new ql(null);g.aa(c,d);so(g,a)}else"LineString"==d?(g=new O(null),pl(g,a),so(g,a)):"Polygon"==d?(g=new P(null),rl(g,a),so(g,a)):"GeometryCollection"==d?g=new Wl(a):wa(!1,37);else g=new Wl(a);return g}
function to(a,b){var c=L({},no,a,b);if(a=L(null,oo,a,b))return b=new D(null),b.aa("XYZ",a),b.H(c),b}function uo(a,b){var c=L({},no,a,b);if((a=L([null],vo,a,b))&&a[0]){b=new E(null);var d=a[0],e=[d.length],f;var g=1;for(f=a.length;g<f;++g)ja(d,a[g]),e.push(d.length);b.aa("XYZ",d,e);b.H(c);return b}}
function wo(a,b){b=L({},xo,a,b);if(!b)return null;a="fillStyle"in b?b.fillStyle:Ln;var c=b.fill;void 0===c||c||(a=null);c="imageStyle"in b?b.imageStyle:Sn;c==Tn&&(c=void 0);var d="textStyle"in b?b.textStyle:Wn,e="strokeStyle"in b?b.strokeStyle:Un;b=b.outline;void 0===b||b||(e=null);return[new Ek({fill:a,image:c,stroke:e,text:d,zIndex:void 0})]}
function so(a,b){var c=b.length,d=Array(b.length),e=Array(b.length),f=Array(b.length),g,h,l;var m=h=l=!1;for(g=0;g<c;++g){var n=b[g];d[g]=n.get("extrude");e[g]=n.get("tessellate");f[g]=n.get("altitudeMode");m=m||void 0!==d[g];h=h||void 0!==e[g];l=l||f[g]}m&&a.set("extrude",d);h&&a.set("tessellate",e);l&&a.set("altitudeMode",f)}function yo(a,b){bl(zo,a,b)}function Ao(a,b){bl(Bo,a,b)}
var Co=K(Zn,{displayName:I(Q),value:I(Q)}),zo=K(Zn,{Data:function(a,b){var c=a.getAttribute("name");bl(Co,a,b);a=b[b.length-1];null!==c?a[c]=a.value:null!==a.displayName&&(a[a.displayName]=a.value);delete a.value},SchemaData:function(a,b){bl(Do,a,b)}}),Bo=K(Zn,{LatLonAltBox:function(a,b){if(a=L({},Eo,a,b))b=b[b.length-1],b.extent=[parseFloat(a.west),parseFloat(a.south),parseFloat(a.east),parseFloat(a.north)],b.altitudeMode=a.altitudeMode,b.minAltitude=parseFloat(a.minAltitude),b.maxAltitude=parseFloat(a.maxAltitude)},
Lod:function(a,b){if(a=L({},Fo,a,b))b=b[b.length-1],b.minLodPixels=parseFloat(a.minLodPixels),b.maxLodPixels=parseFloat(a.maxLodPixels),b.minFadeExtent=parseFloat(a.minFadeExtent),b.maxFadeExtent=parseFloat(a.maxFadeExtent)}}),Eo=K(Zn,{altitudeMode:I(Q),minAltitude:I(mm),maxAltitude:I(mm),north:I(mm),south:I(mm),east:I(mm),west:I(mm)}),Fo=K(Zn,{minLodPixels:I(mm),maxLodPixels:I(mm),minFadeExtent:I(mm),maxFadeExtent:I(mm)}),no=K(Zn,{extrude:I(jm),tessellate:I(jm),altitudeMode:I(Q)}),jo=K(Zn,{coordinates:Vk(fo)}),
vo=K(Zn,{innerBoundaryIs:function(a,b){(a=L(void 0,Ho,a,b))&&b[b.length-1].push(a)},outerBoundaryIs:function(a,b){(a=L(void 0,Io,a,b))&&(b[b.length-1][0]=a)}}),lo=K(Zn,{when:function(a,b){b=b[b.length-1].Tj;a=Ok(a,!1);a=Date.parse(a);b.push(isNaN(a)?0:a)}},K(Yn,{coord:function(a,b){b=b[b.length-1].A;a=Ok(a,!1);(a=/^\s*([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s*$/i.exec(a))?b.push(parseFloat(a[1]),parseFloat(a[2]),parseFloat(a[3]),
0):b.push(0,0,0,0)}})),oo=K(Zn,{coordinates:Vk(fo)}),Jo=K(Zn,{href:I(go)},K(Yn,{x:I(mm),y:I(mm),w:I(mm),h:I(mm)})),Ko=K(Zn,{Icon:I(function(a,b){return(a=L({},Jo,a,b))?a:null}),heading:I(mm),hotSpot:I(function(a){var b=a.getAttribute("xunits"),c=a.getAttribute("yunits");var d="insetPixels"!==b?"insetPixels"!==c?"bottom-left":"top-left":"insetPixels"!==c?"bottom-right":"top-right";return{x:parseFloat(a.getAttribute("x")),mh:$n[b],y:parseFloat(a.getAttribute("y")),nh:$n[c],origin:d}}),scale:I(ho)}),
Ho=K(Zn,{LinearRing:Vk(io)}),Lo=K(Zn,{color:I(eo),scale:I(ho)}),Mo=K(Zn,{color:I(eo),width:I(mm)}),ro=K(Zn,{LineString:Uk(mo),LinearRing:Uk(po),MultiGeometry:Uk(qo),Point:Uk(to),Polygon:Uk(uo)}),No=K(Yn,{Track:Uk(ko)}),Po=K(Zn,{ExtendedData:yo,Region:Ao,Link:function(a,b){bl(Oo,a,b)},address:I(Q),description:I(Q),name:I(Q),open:I(jm),phoneNumber:I(Q),visibility:I(jm)}),Oo=K(Zn,{href:I(go)}),Io=K(Zn,{LinearRing:Vk(io)}),Qo=K(Zn,{Style:I(wo),key:I(Q),styleUrl:I(go)}),So=K(Zn,{ExtendedData:yo,Region:Ao,
MultiGeometry:I(qo,"geometry"),LineString:I(mo,"geometry"),LinearRing:I(po,"geometry"),Point:I(to,"geometry"),Polygon:I(uo,"geometry"),Style:I(wo),StyleMap:function(a,b){if(a=L(void 0,Ro,a,b))b=b[b.length-1],Array.isArray(a)?b.Style=a:"string"===typeof a?b.styleUrl=a:wa(!1,38)},address:I(Q),description:I(Q),name:I(Q),open:I(jm),phoneNumber:I(Q),styleUrl:I(go),visibility:I(jm)},K(Yn,{MultiTrack:I(function(a,b){if(a=L([],No,a,b))return b=new O(null),pl(b,a),b},"geometry"),Track:I(ko,"geometry")})),
To=K(Zn,{color:I(eo),fill:I(jm),outline:I(jm)}),Do=K(Zn,{SimpleData:function(a,b){var c=a.getAttribute("name");null!==c&&(a=Q(a),b[b.length-1][c]=a)}}),xo=K(Zn,{IconStyle:function(a,b){if(a=L({},Ko,a,b)){b=b[b.length-1];var c="Icon"in a?a.Icon:{},d=!("Icon"in a)||0<Object.keys(c).length,e,f=c.href;f?e=f:d&&(e=Qn);f="bottom-left";var g=a.hotSpot;if(g){var h=[g.x,g.y];var l=g.mh;var m=g.nh;f=g.origin}else e===Qn?(h=Mn,l=On,m=Nn):/^http:\/\/maps\.(?:google|gstatic)\.com\//.test(e)&&(h=[.5,0],m=l="fraction");
var n;g=c.x;var p=c.y;void 0!==g&&void 0!==p&&(n=[g,p]);var q;g=c.w;c=c.h;void 0!==g&&void 0!==c&&(q=[g,c]);var r;c=a.heading;void 0!==c&&(r=Ia(c));a=a.scale;d?(e==Qn&&(q=Pn,void 0===a&&(a=Rn)),e=new Gn({anchor:h,anchorOrigin:f,anchorXUnits:l,anchorYUnits:m,crossOrigin:"anonymous",offset:n,offsetOrigin:"bottom-left",rotation:r,scale:a,size:q,src:e}),b.imageStyle=e):b.imageStyle=Tn}},LabelStyle:function(a,b){(a=L({},Lo,a,b))&&(b[b.length-1].textStyle=new Hn({fill:new Ck({color:"color"in a?a.color:
Kn}),scale:a.scale}))},LineStyle:function(a,b){(a=L({},Mo,a,b))&&(b[b.length-1].strokeStyle=new Dk({color:"color"in a?a.color:Kn,width:"width"in a?a.width:1}))},PolyStyle:function(a,b){if(a=L({},To,a,b)){b=b[b.length-1];b.fillStyle=new Ck({color:"color"in a?a.color:Kn});var c=a.fill;void 0!==c&&(b.fill=c);a=a.outline;void 0!==a&&(b.outline=a)}}}),Ro=K(Zn,{Pair:function(a,b){if(a=L({},Qo,a,b)){var c=a.key;c&&"normal"==c&&((c=a.styleUrl)&&(b[b.length-1]=c),(a=a.Style)&&(b[b.length-1]=a))}}});k=In.prototype;
k.Hg=function(a,b){var c=K(Zn,{Document:Tk(this.Hg,this),Folder:Tk(this.Hg,this),Placemark:Uk(this.Pg,this),Style:this.Rp.bind(this),StyleMap:this.Qp.bind(this)});if(a=L([],c,a,b,this))return a};k.Pg=function(a,b){var c=L({geometry:null},So,a,b);if(c){var d=new Kk;a=a.getAttribute("id");null!==a&&d.mc(a);b=b[0];(a=c.geometry)&&il(a,!1,b);d.Sa(a);delete c.geometry;this.c&&d.rg(bo(c.Style,c.styleUrl,this.a,this.b,this.g));delete c.Style;d.H(c);return d}};
k.Rp=function(a,b){var c=a.getAttribute("id");null!==c&&(b=wo(a,b))&&(a=a.baseURI,a&&"about:blank"!=a||(a=window.location.href),c=a?(new URL("#"+c,a)).href:"#"+c,this.b[c]=b)};k.Qp=function(a,b){var c=a.getAttribute("id");null!==c&&(b=L(void 0,Ro,a,b))&&(a=a.baseURI,a&&"about:blank"!=a||(a=window.location.href),c=a?(new URL("#"+c,a)).href:"#"+c,this.b[c]=b)};k.Jg=function(a,b){return ha(Zn,a.namespaceURI)?(a=this.Pg(a,[gl(this,a,b)]))?a:null:null};
k.Dc=function(a,b){if(!ha(Zn,a.namespaceURI))return[];var c=a.localName;if("Document"==c||"Folder"==c)return(c=this.Hg(a,[gl(this,a,b)]))?c:[];if("Placemark"==c)return(b=this.Pg(a,[gl(this,a,b)]))?[b]:[];if("kml"==c){c=[];for(a=a.firstElementChild;a;a=a.nextElementSibling){var d=this.Dc(a,b);d&&ja(c,d)}return c}return[]};k.Kp=function(a){if(Qk(a))return Uo(this,a);if(Rk(a))return Vo(this,a);if("string"===typeof a)return a=Sk(a),Uo(this,a)};
function Uo(a,b){for(b=b.firstChild;b;b=b.nextSibling)if(b.nodeType==Node.ELEMENT_NODE){var c=Vo(a,b);if(c)return c}}function Vo(a,b){var c;for(c=b.firstElementChild;c;c=c.nextElementSibling)if(ha(Zn,c.namespaceURI)&&"name"==c.localName)return Q(c);for(c=b.firstElementChild;c;c=c.nextElementSibling)if(b=c.localName,ha(Zn,c.namespaceURI)&&("Document"==b||"Folder"==b||"Placemark"==b||"kml"==b)&&(b=Vo(a,c)))return b}
k.Lp=function(a){var b=[];Qk(a)?ja(b,Wo(this,a)):Rk(a)?ja(b,Xo(this,a)):"string"===typeof a&&(a=Sk(a),ja(b,Wo(this,a)));return b};function Wo(a,b){var c=[];for(b=b.firstChild;b;b=b.nextSibling)b.nodeType==Node.ELEMENT_NODE&&ja(c,Xo(a,b));return c}
function Xo(a,b){var c,d=[];for(c=b.firstElementChild;c;c=c.nextElementSibling)if(ha(Zn,c.namespaceURI)&&"NetworkLink"==c.localName){var e=L({},Po,c,[]);d.push(e)}for(c=b.firstElementChild;c;c=c.nextElementSibling)b=c.localName,!ha(Zn,c.namespaceURI)||"Document"!=b&&"Folder"!=b&&"kml"!=b||ja(d,Xo(a,c));return d}k.Op=function(a){var b=[];Qk(a)?ja(b,Yo(this,a)):Rk(a)?ja(b,this.vf(a)):"string"===typeof a&&(a=Sk(a),ja(b,Yo(this,a)));return b};
function Yo(a,b){var c=[];for(b=b.firstChild;b;b=b.nextSibling)b.nodeType==Node.ELEMENT_NODE&&ja(c,a.vf(b));return c}k.vf=function(a){var b,c=[];for(b=a.firstElementChild;b;b=b.nextElementSibling)if(ha(Zn,b.namespaceURI)&&"Region"==b.localName){var d=L({},Bo,b,[]);c.push(d)}for(b=a.firstElementChild;b;b=b.nextElementSibling)a=b.localName,!ha(Zn,b.namespaceURI)||"Document"!=a&&"Folder"!=a&&"kml"!=a||ja(c,this.vf(b));return c};
function Zo(a,b){b=Ph(b);b=[255*(4==b.length?b[3]:1),b[2],b[1],b[0]];var c;for(c=0;4>c;++c){var d=parseInt(b[c],10).toString(16);b[c]=1==d.length?"0"+d:d}rm(a,b.join(""))}function $o(a,b,c){a={node:a};var d=b.S();if("GeometryCollection"==d){var e=b.pd();var f=ap}else"MultiPoint"==d?(e=b.ee(),f=bp):"MultiLineString"==d?(e=b.qd(),f=cp):"MultiPolygon"==d?(e=b.Yd(),f=dp):wa(!1,39);cl(a,ep,f,e,c)}function fp(a,b,c){cl({node:a},gp,hp,[b],c)}
function ip(a,b,c){var d={node:a};b.c&&a.setAttribute("id",b.c);a=b.M();var e={address:1,description:1,name:1,open:1,phoneNumber:1,styleUrl:1,visibility:1};e[b.a]=1;var f=Object.keys(a||{}).sort().filter(function(a){return!e[a]});if(0<f.length){var g=al(a,f);cl(d,jp,kp,[{names:f,values:g}],c)}if(f=b.bb())if(f=f.call(b,0))f=Array.isArray(f)?f[0]:f,this.j&&(a.Style=f),(f=f.Ia())&&(a.name=f.Ia());f=lp[c[c.length-1].node.namespaceURI];a=al(a,f);cl(d,jp,$k,a,c,f);a=c[0];(b=b.W())&&(b=il(b,!0,a));cl(d,
jp,ap,[b],c)}function mp(a,b,c){var d=b.ca();a={node:a};a.layout=b.ja;a.stride=b.pa();b=b.M();b.coordinates=d;d=np[c[c.length-1].node.namespaceURI];b=al(b,d);cl(a,op,$k,b,c,d)}function pp(a,b,c){b=b.Xd();var d=b.shift();a={node:a};cl(a,qp,rp,b,c);cl(a,qp,sp,[d],c)}function tp(a,b){sm(a,Math.round(1E6*b)/1E6)}
var up=K(Zn,["Document","Placemark"]),xp=K(Zn,{Document:J(function(a,b,c){cl({node:a},vp,wp,b,c,void 0,this)}),Placemark:J(ip)}),vp=K(Zn,{Placemark:J(ip)}),yp=K(Zn,{Data:J(function(a,b,c){a.setAttribute("name",b.name);a={node:a};b=b.value;"object"==typeof b?(null!==b&&b.displayName&&cl(a,yp,$k,[b.displayName],c,["displayName"]),null!==b&&b.value&&cl(a,yp,$k,[b.value],c,["value"])):cl(a,yp,$k,[b],c,["value"])}),value:J(function(a,b){rm(a,b)}),displayName:J(function(a,b){a.appendChild(Mk.createCDATASection(b))})}),
zp={Point:"Point",LineString:"LineString",LinearRing:"LinearRing",Polygon:"Polygon",MultiPoint:"MultiGeometry",MultiLineString:"MultiGeometry",MultiPolygon:"MultiGeometry",GeometryCollection:"MultiGeometry"},Ap=K(Zn,["href"],K(Yn,["x","y","w","h"])),Bp=K(Zn,{href:J(rm)},K(Yn,{x:J(sm),y:J(sm),w:J(sm),h:J(sm)})),Cp=K(Zn,["scale","heading","Icon","hotSpot"]),Ep=K(Zn,{Icon:J(function(a,b,c){a={node:a};var d=Ap[c[c.length-1].node.namespaceURI],e=al(b,d);cl(a,Bp,$k,e,c,d);d=Ap[Yn[0]];e=al(b,d);cl(a,Bp,
Dp,e,c,d)}),heading:J(sm),hotSpot:J(function(a,b){a.setAttribute("x",b.x);a.setAttribute("y",b.y);a.setAttribute("xunits",b.mh);a.setAttribute("yunits",b.nh)}),scale:J(tp)}),Fp=K(Zn,["color","scale"]),Gp=K(Zn,{color:J(Zo),scale:J(tp)}),Hp=K(Zn,["color","width"]),Ip=K(Zn,{color:J(Zo),width:J(sm)}),gp=K(Zn,{LinearRing:J(mp)}),ep=K(Zn,{LineString:J(mp),Point:J(mp),Polygon:J(pp),GeometryCollection:J($o)}),lp=K(Zn,"name open visibility address phoneNumber description styleUrl Style".split(" ")),jp=K(Zn,
{ExtendedData:J(function(a,b,c){a={node:a};var d=b.names;b=b.values;for(var e=d.length,f=0;f<e;f++)cl(a,yp,Jp,[{name:d[f],value:b[f]}],c)}),MultiGeometry:J($o),LineString:J(mp),LinearRing:J(mp),Point:J(mp),Polygon:J(pp),Style:J(function(a,b,c){a={node:a};var d={},e=b.Ca(),f=b.Da(),g=b.Y();b=b.Ia();g instanceof Gn&&(d.IconStyle=g);b&&(d.LabelStyle=b);f&&(d.LineStyle=f);e&&(d.PolyStyle=e);b=Kp[c[c.length-1].node.namespaceURI];d=al(d,b);cl(a,Lp,$k,d,c,b)}),address:J(rm),description:J(rm),name:J(rm),
open:J(qm),phoneNumber:J(rm),styleUrl:J(rm),visibility:J(qm)}),np=K(Zn,["extrude","tessellate","altitudeMode","coordinates"]),op=K(Zn,{extrude:J(qm),tessellate:J(qm),altitudeMode:J(rm),coordinates:J(function(a,b,c){c=c[c.length-1];var d=c.layout;c=c.stride;var e;"XY"==d||"XYM"==d?e=2:"XYZ"==d||"XYZM"==d?e=3:wa(!1,34);var f,g=b.length,h="";if(0<g){h+=b[0];for(d=1;d<e;++d)h+=","+b[d];for(f=c;f<g;f+=c)for(h+=" "+b[f],d=1;d<e;++d)h+=","+b[f+d]}rm(a,h)})}),qp=K(Zn,{outerBoundaryIs:J(fp),innerBoundaryIs:J(fp)}),
Mp=K(Zn,{color:J(Zo)}),Kp=K(Zn,["IconStyle","LabelStyle","LineStyle","PolyStyle"]),Lp=K(Zn,{IconStyle:J(function(a,b,c){a={node:a};var d={},e=b.kc(),f=b.Ie(),g={href:b.b.l};if(e){g.w=e[0];g.h=e[1];var h=b.Oc(),l=b.Vc();l&&f&&0!==l[0]&&l[1]!==e[1]&&(g.x=l[0],g.y=f[1]-(l[1]+e[1]));!h||h[0]===e[0]/2&&h[1]===e[1]/2||(d.hotSpot={x:h[0],mh:"pixels",y:e[1]-h[1],nh:"pixels"})}d.Icon=g;e=b.a;1!==e&&(d.scale=e);b=b.g;0!==b&&(d.heading=b);b=Cp[c[c.length-1].node.namespaceURI];d=al(d,b);cl(a,Ep,$k,d,c,b)}),LabelStyle:J(function(a,
b,c){a={node:a};var d={},e=b.Ca();e&&(d.color=e.b);(b=b.b)&&1!==b&&(d.scale=b);b=Fp[c[c.length-1].node.namespaceURI];d=al(d,b);cl(a,Gp,$k,d,c,b)}),LineStyle:J(function(a,b,c){a={node:a};var d=Hp[c[c.length-1].node.namespaceURI];b=al({color:b.b,width:b.c},d);cl(a,Ip,$k,b,c,d)}),PolyStyle:J(function(a,b,c){cl({node:a},Mp,Np,[b.b],c)})});function Dp(a,b,c){return Nk(Yn[0],"gx:"+c)}function wp(a,b){return Nk(b[b.length-1].node.namespaceURI,"Placemark")}
function ap(a,b){if(a)return Nk(b[b.length-1].node.namespaceURI,zp[a.S()])}var Np=Yk("color"),Jp=Yk("Data"),kp=Yk("ExtendedData"),rp=Yk("innerBoundaryIs"),bp=Yk("Point"),cp=Yk("LineString"),hp=Yk("LinearRing"),dp=Yk("Polygon"),sp=Yk("outerBoundaryIs");
In.prototype.Zb=function(a,b){b=hl(this,b);var c=Nk(Zn[4],"kml");c.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:gx",Yn[0]);c.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:xsi","http://www.w3.org/2001/XMLSchema-instance");c.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation","http://www.opengis.net/kml/2.2 https://developers.google.com/kml/schema/kml22gx.xsd");var d={node:c},e={};1<a.length?e.Document=a:1==a.length&&(e.Placemark=a[0]);a=up[c.namespaceURI];
e=al(e,a);cl(d,xp,$k,e,[b],a,this);return c};var Op={Id:function(){}};
(function(a){function b(a){this.pc=ArrayBuffer.isView&&ArrayBuffer.isView(a)?a:new Uint8Array(a||0);this.type=this.ha=0;this.length=this.pc.length}function c(a,b,c){var e=c.pc;var f=e[c.ha++];var g=(f&112)>>4;if(128>f)return d(a,g,b);f=e[c.ha++];g|=(f&127)<<3;if(128>f)return d(a,g,b);f=e[c.ha++];g|=(f&127)<<10;if(128>f)return d(a,g,b);f=e[c.ha++];g|=(f&127)<<17;if(128>f)return d(a,g,b);f=e[c.ha++];g|=(f&127)<<24;if(128>f)return d(a,g,b);f=e[c.ha++];if(128>f)return d(a,g|(f&1)<<31,b);throw Error("Expected varint not more than 10 bytes");
}function d(a,b,c){return c?4294967296*b+(a>>>0):4294967296*(b>>>0)+(a>>>0)}var e={read:function(a,b,c,d,e){var f=8*e-d-1;var g=(1<<f)-1,h=g>>1,l=-7;e=c?e-1:0;var m=c?-1:1,x=a[b+e];e+=m;c=x&(1<<-l)-1;x>>=-l;for(l+=f;0<l;c=256*c+a[b+e],e+=m,l-=8);f=c&(1<<-l)-1;c>>=-l;for(l+=d;0<l;f=256*f+a[b+e],e+=m,l-=8);if(0===c)c=1-h;else{if(c===g)return f?NaN:Infinity*(x?-1:1);f+=Math.pow(2,d);c-=h}return(x?-1:1)*f*Math.pow(2,c-d)},write:function(a,b,c,d,e,n){var f,g=8*n-e-1,h=(1<<g)-1,l=h>>1,m=23===e?Math.pow(2,
-24)-Math.pow(2,-77):0;n=d?0:n-1;var B=d?1:-1,A=0>b||0===b&&0>1/b?1:0;b=Math.abs(b);isNaN(b)||Infinity===b?(b=isNaN(b)?1:0,d=h):(d=Math.floor(Math.log(b)/Math.LN2),1>b*(f=Math.pow(2,-d))&&(d--,f*=2),b=1<=d+l?b+m/f:b+m*Math.pow(2,1-l),2<=b*f&&(d++,f/=2),d+l>=h?(b=0,d=h):1<=d+l?(b=(b*f-1)*Math.pow(2,e),d+=l):(b=b*Math.pow(2,l-1)*Math.pow(2,e),d=0));for(;8<=e;a[c+n]=b&255,n+=B,b/=256,e-=8);d=d<<e|b;for(g+=e;0<g;a[c+n]=d&255,n+=B,d/=256,g-=8);a[c+n-B]|=128*A}};"use strict";b.c=0;b.f=1;b.b=2;b.a=5;b.prototype=
{Mg:function(a,b,c){for(c=c||this.length;this.ha<c;){var d=this.Ra(),e=d>>3,f=this.ha;this.type=d&7;a(e,b,this);this.ha===f&&this.pq(d)}return b},Gp:function(){var a=e.read(this.pc,this.ha,!0,23,4);this.ha+=4;return a},Cp:function(){var a=e.read(this.pc,this.ha,!0,52,8);this.ha+=8;return a},Ra:function(a){var b=this.pc;var d=b[this.ha++];var e=d&127;if(128>d)return e;d=b[this.ha++];e|=(d&127)<<7;if(128>d)return e;d=b[this.ha++];e|=(d&127)<<14;if(128>d)return e;d=b[this.ha++];e|=(d&127)<<21;if(128>
d)return e;d=b[this.ha];return c(e|(d&15)<<28,a,this)},Sp:function(){return this.Ra(!0)},Sg:function(){var a=this.Ra();return 1===a%2?(a+1)/-2:a/2},Ap:function(){return!!this.Ra()},Tg:function(){for(var a=this.Ra()+this.ha,b=this.pc,c="",d=this.ha;d<a;){var e=b[d],n=null,p=239<e?4:223<e?3:191<e?2:1;if(d+p>a)break;if(1===p)128>e&&(n=e);else if(2===p){var q=b[d+1];128===(q&192)&&(n=(e&31)<<6|q&63,127>=n&&(n=null))}else if(3===p){q=b[d+1];var r=b[d+2];128===(q&192)&&128===(r&192)&&(n=(e&15)<<12|(q&63)<<
6|r&63,2047>=n||55296<=n&&57343>=n)&&(n=null)}else if(4===p){q=b[d+1];r=b[d+2];var u=b[d+3];128===(q&192)&&128===(r&192)&&128===(u&192)&&(n=(e&15)<<18|(q&63)<<12|(r&63)<<6|u&63,65535>=n||1114112<=n)&&(n=null)}null===n?(n=65533,p=1):65535<n&&(n-=65536,c+=String.fromCharCode(n>>>10&1023|55296),n=56320|n&1023);c+=String.fromCharCode(n);d+=p}this.ha=a;return c},pq:function(a){a&=7;if(a===b.c)for(;127<this.pc[this.ha++];);else if(a===b.b)this.ha=this.Ra()+this.ha;else if(a===b.a)this.ha+=4;else if(a===
b.f)this.ha+=8;else throw Error("Unimplemented type: "+a);}};a["default"]=b})(Op.Id=Op.Id||{});Op.Id=Op.Id.default;function Pp(a,b,c,d,e){this.g=e;this.f=a;this.b=b;this.i=c;this.c=d;this.j=Ue()}k=Pp.prototype;k.get=function(a){return this.c[a]};k.lb=Pp.prototype.md=function(){return this.i};k.G=function(){this.a||(this.a="Point"===this.f?$a(this.b):ab(this.b,0,this.b.length,2));return this.a};k.fo=function(){return this.g};k.Ub=function(){return this.b};k.ca=Pp.prototype.Ub;k.W=function(){return this};k.ho=function(){return this.c};k.Zd=Pp.prototype.W;k.pa=function(){return 2};k.bb=sa;k.S=function(){return this.f};
k.hb=function(a){var b=a.G();a=a.re;b=mb(a)/mb(b);var c=this.j;cf(c,a[0],a[3],b,-b,0,0,0);Re(this.b,0,this.b.length,2,c,this.b)};function Qp(a){fl.call(this);a=a?a:{};this.defaultDataProjection=new Gb({code:"EPSG:3857",units:"tile-pixels"});this.b=a.featureClass?a.featureClass:Pp;this.f=a.geometryName;this.g=a.layerName?a.layerName:"layer";this.c=a.layers?a.layers:null;this.a=null}v(Qp,fl);function Rp(a,b,c){if(3===a){a={keys:[],values:[],features:[]};var d=c.Ra()+c.ha;c.Mg(Sp,a,d);a.length=a.features.length;a.length&&(b[a.name]=a)}}
function Sp(a,b,c){if(15===a)b.version=c.Ra();else if(1===a)b.name=c.Tg();else if(5===a)b.extent=c.Ra();else if(2===a)b.features.push(c.ha);else if(3===a)b.keys.push(c.Tg());else if(4===a){a=null;for(var d=c.Ra()+c.ha;c.ha<d;)a=c.Ra()>>3,a=1===a?c.Tg():2===a?c.Gp():3===a?c.Cp():4===a?c.Sp():5===a?c.Ra():6===a?c.Sg():7===a?c.Ap():null;b.values.push(a)}}
function Tp(a,b,c){if(1==a)b.id=c.Ra();else if(2==a)for(a=c.Ra()+c.ha;c.ha<a;){var d=b.layer.keys[c.Ra()],e=b.layer.values[c.Ra()];b.properties[d]=e}else 3==a?b.type=c.Ra():4==a&&(b.geometry=c.ha)}
function Up(a,b,c){var d=c.type;if(0===d)return null;var e=c.id,f=c.properties;f[a.g]=c.layer.name;var g=[];var h=[],l=h;b.ha=c.geometry;c=b.Ra()+b.ha;for(var m=1,n=0,p=0,q=0,r=0,u=0;b.ha<c;)n||(n=b.Ra(),m=n&7,n>>=3),n--,1===m||2===m?(p+=b.Sg(),q+=b.Sg(),1===m&&r>u&&(l.push(r),u=r),g.push(p,q),r+=2):7===m?r>u&&(g.push(g[u],g[u+1]),r+=2):wa(!1,59);r>u&&l.push(r);b=h.length;var x;1===d?x=1===b?"Point":"MultiPoint":2===d?x=1===b?"LineString":"MultiLineString":3===d&&(x="Polygon");d=x;if(a.b===Pp)g=new a.b(d,
g,h,f,e);else{if("Polygon"==d){d=[];l=b=x=0;for(c=h.length;l<c;++l)m=h[l],Kf(g,x,m,2)||(d.push(h.slice(b,l)),b=l),x=m;1<d.length?(h=d,d=new P(null)):d=new E(null)}else d="Point"===d?new D(null):"LineString"===d?new M(null):"Polygon"===d?new E(null):"MultiPoint"===d?new ql(null):"MultiLineString"===d?new O(null):null;d.aa("XY",g,h);g=new a.b;a.f&&g.Zc(a.f);a=il(d,!1,hl(a,void 0));g.Sa(a);g.mc(e);g.H(f)}return g}k=Qp.prototype;k.dg=function(){return this.a};k.S=function(){return"arraybuffer"};
k.Ma=function(a){var b=this.c;a=new Op.Id(a);var c=a.Mg(Rp,{}),d=[],e;for(e in c)if(!b||-1!=b.indexOf(e)){var f=c[e];for(var g,h=0,l=f.length;h<l;++h){g=a;var m=f;g.ha=m.features[h];var n=g.Ra()+g.ha;m={layer:m,type:0,properties:{}};g.Mg(Tp,m,n);g=m;d.push(Up(this,a,g))}this.a=f?[0,0,f.extent,f.extent]:null}return d};k.pb=function(){return this.defaultDataProjection};k.yn=function(a){this.c=a};k.Vb=function(){};k.Yc=function(){};k.Gd=function(){};k.fd=function(){};k.Yb=function(){};function Vp(){em.call(this);this.defaultDataProjection=Zb("EPSG:4326")}v(Vp,em);function Wp(a,b){b[b.length-1].oe[a.getAttribute("k")]=a.getAttribute("v")}
var Xp=[null],Yp=K(Xp,{nd:function(a,b){b[b.length-1].ud.push(a.getAttribute("ref"))},tag:Wp}),$p=K(Xp,{node:function(a,b){var c=b[0],d=b[b.length-1],e=a.getAttribute("id"),f=[parseFloat(a.getAttribute("lon")),parseFloat(a.getAttribute("lat"))];d.hi[e]=f;a=L({oe:{}},Zp,a,b);wb(a.oe)||(f=new D(f),il(f,!1,c),c=new Kk(f),c.mc(e),c.H(a.oe),d.features.push(c))},way:function(a,b){var c=a.getAttribute("id");a=L({id:c,ud:[],oe:{}},Yp,a,b);b[b.length-1].jh.push(a)}}),Zp=K(Xp,{tag:Wp});
Vp.prototype.Dc=function(a,b){b=gl(this,a,b);if("osm"==a.localName){a=L({hi:{},jh:[],features:[]},$p,a,[b]);for(var c=0;c<a.jh.length;c++){for(var d=a.jh[c],e=[],f=0,g=d.ud.length;f<g;f++)ja(e,a.hi[d.ud[f]]);d.ud[0]==d.ud[d.ud.length-1]?(f=new E(null),f.aa("XY",e,[e.length])):(f=new M(null),f.aa("XY",e));il(f,!1,b);e=new Kk(f);e.mc(d.id);e.H(d.oe);a.features.push(e)}if(a.features)return a.features}return[]};Vp.prototype.kh=function(){};Vp.prototype.Zb=function(){};Vp.prototype.ue=function(){};function aq(a){return a.getAttributeNS("http://www.w3.org/1999/xlink","href")};function bq(){}bq.prototype.read=function(a){return Qk(a)?this.a(a):Rk(a)?this.b(a):"string"===typeof a?(a=Sk(a),this.a(a)):null};function cq(){}v(cq,bq);cq.prototype.a=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.b(a);return null};cq.prototype.b=function(a){return(a=L({},dq,a,[]))?a:null};
var eq=[null,"http://www.opengis.net/ows/1.1"],dq=K(eq,{ServiceIdentification:I(function(a,b){return L({},fq,a,b)}),ServiceProvider:I(function(a,b){return L({},gq,a,b)}),OperationsMetadata:I(function(a,b){return L({},hq,a,b)})}),iq=K(eq,{DeliveryPoint:I(Q),City:I(Q),AdministrativeArea:I(Q),PostalCode:I(Q),Country:I(Q),ElectronicMailAddress:I(Q)}),jq=K(eq,{Value:Wk(function(a){return Q(a)})}),kq=K(eq,{AllowedValues:I(function(a,b){return L({},jq,a,b)})}),mq=K(eq,{Phone:I(function(a,b){return L({},
lq,a,b)}),Address:I(function(a,b){return L({},iq,a,b)})}),oq=K(eq,{HTTP:I(function(a,b){return L({},nq,a,b)})}),nq=K(eq,{Get:Wk(function(a,b){var c=aq(a);if(c)return L({href:c},pq,a,b)}),Post:void 0}),qq=K(eq,{DCP:I(function(a,b){return L({},oq,a,b)})}),hq=K(eq,{Operation:function(a,b){var c=a.getAttribute("name");(a=L({},qq,a,b))&&(b[b.length-1][c]=a)}}),lq=K(eq,{Voice:I(Q),Facsimile:I(Q)}),pq=K(eq,{Constraint:Wk(function(a,b){var c=a.getAttribute("name");if(c)return L({name:c},kq,a,b)})}),rq=K(eq,
{IndividualName:I(Q),PositionName:I(Q),ContactInfo:I(function(a,b){return L({},mq,a,b)})}),fq=K(eq,{Title:I(Q),ServiceTypeVersion:I(Q),ServiceType:I(Q)}),gq=K(eq,{ProviderName:I(Q),ProviderSite:I(aq),ServiceContact:I(function(a,b){return L({},rq,a,b)})});function sq(a,b,c,d){var e;void 0!==d?e=d:e=[];for(var f=d=0;f<b;){var g=a[f++];e[d++]=a[f++];e[d++]=g;for(g=2;g<c;++g)e[d++]=a[f++]}e.length=d};function tq(a){a=a?a:{};fl.call(this);this.defaultDataProjection=Zb("EPSG:4326");this.b=a.factor?a.factor:1E5;this.a=a.geometryLayout?a.geometryLayout:"XY"}v(tq,xn);function uq(a,b,c){var d,e=Array(b);for(d=0;d<b;++d)e[d]=0;var f;var g=0;for(f=a.length;g<f;)for(d=0;d<b;++d,++g){var h=a[g],l=h-e[d];e[d]=h;a[g]=l}return vq(a,c?c:1E5)}function wq(a,b,c){var d,e=Array(b);for(d=0;d<b;++d)e[d]=0;a=xq(a,c?c:1E5);var f;c=0;for(f=a.length;c<f;)for(d=0;d<b;++d,++c)e[d]+=a[c],a[c]=e[d];return a}
function vq(a,b){b=b?b:1E5;var c;var d=0;for(c=a.length;d<c;++d)a[d]=Math.round(a[d]*b);b=0;for(d=a.length;b<d;++b)c=a[b],a[b]=0>c?~(c<<1):c<<1;b="";d=0;for(c=a.length;d<c;++d){for(var e,f=a[d],g="";32<=f;)e=(32|f&31)+63,g+=String.fromCharCode(e),f>>=5;g+=String.fromCharCode(f+63);b+=g}return b}
function xq(a,b){b=b?b:1E5;var c=[],d=0,e=0,f;var g=0;for(f=a.length;g<f;++g){var h=a.charCodeAt(g)-63;d|=(h&31)<<e;32>h?(c.push(d),e=d=0):e+=5}a=0;for(d=c.length;a<d;++a)e=c[a],c[a]=e&1?~(e>>1):e>>1;a=0;for(d=c.length;a<d;++a)c[a]/=b;return c}k=tq.prototype;k.he=function(a,b){a=this.Dd(a,b);return new Kk(a)};k.Lg=function(a,b){return[this.he(a,b)]};k.Dd=function(a,b){var c=gf(this.a);a=wq(a,c,this.b);sq(a,a.length,c,a);c=wf(a,0,a.length,c);return il(new M(c,this.a),!1,hl(this,b))};
k.se=function(a,b){if(a=a.W())return this.Hd(a,b);wa(!1,40);return""};k.lh=function(a,b){return this.se(a[0],b)};k.Hd=function(a,b){a=il(a,!0,hl(this,b));b=a.ca();a=a.pa();sq(b,b.length,a,b);return uq(b,a,this.b)};function yq(a){a=a?a:{};fl.call(this);this.a=a.layerName;this.b=a.layers?a.layers:null;this.defaultDataProjection=Zb(a.defaultDataProjection?a.defaultDataProjection:"EPSG:4326")}v(yq,jl);function zq(a,b){var c=[],d,e;var f=0;for(e=a.length;f<e;++f){var g=a[f];0<f&&c.pop();0<=g?d=b[g]:d=b[~g].slice().reverse();c.push.apply(c,d)}a=0;for(b=c.length;a<b;++a)c[a]=c[a].slice();return c}
function Aq(a,b,c,d,e,f,g){a=a.geometries;var h=[],l;var m=0;for(l=a.length;m<l;++m)h[m]=Bq(a[m],b,c,d,e,f,g);return h}function Bq(a,b,c,d,e,f,g){var h=a.type,l=Cq[h];c="Point"===h||"MultiPoint"===h?l(a,c,d):l(a,b);b=new Kk;b.Sa(il(c,!1,g));void 0!==a.id&&b.mc(a.id);a=a.properties;e&&(a||(a={}),a[e]=f);a&&b.H(a);return b}
yq.prototype.Kg=function(a,b){if("Topology"==a.type){var c=null,d=null;if(a.transform){var e=a.transform;c=e.scale;d=e.translate}var f=a.arcs;if(e){e=c;var g=d,h;var l=0;for(h=f.length;l<h;++l){var m,n=f[l],p=e,q=g,r=0,u=0;var x=0;for(m=n.length;x<m;++x){var B=n[x];r+=B[0];u+=B[1];B[0]=r;B[1]=u;Dq(B,p,q)}}}e=[];a=a.objects;g=this.a;for(var A in a)this.b&&-1==this.b.indexOf(A)||("GeometryCollection"===a[A].type?(l=a[A],e.push.apply(e,Aq(l,f,c,d,g,A,b))):(l=a[A],e.push(Bq(l,f,c,d,g,A,b))));return e}return[]};
function Dq(a,b,c){a[0]=a[0]*b[0]+c[0];a[1]=a[1]*b[1]+c[1]}yq.prototype.Rg=function(){return this.defaultDataProjection};
var Cq={Point:function(a,b,c){a=a.coordinates;b&&c&&Dq(a,b,c);return new D(a)},LineString:function(a,b){a=zq(a.arcs,b);return new M(a)},Polygon:function(a,b){var c=[],d;var e=0;for(d=a.arcs.length;e<d;++e)c[e]=zq(a.arcs[e],b);return new E(c)},MultiPoint:function(a,b,c){a=a.coordinates;var d;if(b&&c){var e=0;for(d=a.length;e<d;++e)Dq(a[e],b,c)}return new ql(a)},MultiLineString:function(a,b){var c=[],d;var e=0;for(d=a.arcs.length;e<d;++e)c[e]=zq(a.arcs[e],b);return new O(c)},MultiPolygon:function(a,
b){var c=[],d,e;var f=0;for(e=a.arcs.length;f<e;++f){var g=a.arcs[f];var h=[];var l=0;for(d=g.length;l<d;++l)h[l]=zq(g[l],b);c[f]=h}return new P(c)}};k=yq.prototype;k.ed=function(){};k.te=function(){};k.ve=function(){};k.Og=function(){};k.Xc=function(){};function Eq(a){a=a?a:{};this.c=a.featureType;this.a=a.featureNS;this.b=a.gmlFormat?a.gmlFormat:new um;this.l=a.schemaLocation?a.schemaLocation:Fq["1.1.0"];em.call(this)}v(Eq,em);var Fq={"1.1.0":"http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.1.0/wfs.xsd","1.0.0":"http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.0.0/wfs.xsd"};
Eq.prototype.Dc=function(a,b){var c={featureType:this.c,featureNS:this.a};tb(c,gl(this,a,b?b:{}));b=[c];this.b.b["http://www.opengis.net/gml"].featureMember=Uk(hm.prototype.ie);(a=L([],this.b.b,a,b,this.b))||(a=[]);return a};Eq.prototype.j=function(a){if(Qk(a))return Gq(a);if(Rk(a))return L({},Hq,a,[]);if("string"===typeof a)return a=Sk(a),Gq(a)};Eq.prototype.g=function(a){if(Qk(a))return Iq(this,a);if(Rk(a))return Jq(this,a);if("string"===typeof a)return a=Sk(a),Iq(this,a)};
function Iq(a,b){for(b=b.firstChild;b;b=b.nextSibling)if(b.nodeType==Node.ELEMENT_NODE)return Jq(a,b)}var Kq={"http://www.opengis.net/gml":{boundedBy:I(hm.prototype.rf,"bounds")}};function Jq(a,b){var c={},d=pm(b.getAttribute("numberOfFeatures"));c.numberOfFeatures=d;return L(c,Kq,b,[],a.b)}
var Lq={"http://www.opengis.net/wfs":{totalInserted:I(om),totalUpdated:I(om),totalDeleted:I(om)}},Mq={"http://www.opengis.net/ogc":{FeatureId:Uk(function(a){return a.getAttribute("fid")})}},Nq={"http://www.opengis.net/wfs":{Feature:function(a,b){bl(Mq,a,b)}}},Hq={"http://www.opengis.net/wfs":{TransactionSummary:I(function(a,b){return L({},Lq,a,b)},"transactionSummary"),InsertResults:I(function(a,b){return L([],Nq,a,b)},"insertIds")}};
function Gq(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return L({},Hq,a,[])}var Oq={"http://www.opengis.net/wfs":{PropertyName:J(rm)}};function Pq(a,b){var c=Nk("http://www.opengis.net/ogc","Filter"),d=Nk("http://www.opengis.net/ogc","FeatureId");c.appendChild(d);d.setAttribute("fid",b);a.appendChild(c)}function Qq(a,b){a=(a?a:"feature")+":";return 0===b.indexOf(a)?b:a+b}
var Rq={"http://www.opengis.net/wfs":{Insert:J(function(a,b,c){var d=c[c.length-1],e=d.gmlVersion;d=Nk(d.featureNS,d.featureType);a.appendChild(d);if(2===e){a=Dm.prototype;(e=b.c)&&d.setAttribute("fid",e);e=c[c.length-1];var f=e.featureNS,g=b.a;e.qb||(e.qb={},e.qb[f]={});var h=b.M();b=[];var l=[];for(n in h){var m=h[n];null!==m&&(b.push(n),l.push(m),n==g||m instanceof ef?n in e.qb[f]||(e.qb[f][n]=J(a.ri,a)):n in e.qb[f]||(e.qb[f][n]=J(rm)))}var n=tb({},e);n.node=d;cl(n,e.qb,Yk(void 0,f),l,c,b)}else um.prototype.zi(d,
b,c)}),Update:J(function(a,b,c){var d=c[c.length-1];wa(void 0!==b.c,27);var e=d.featurePrefix,f=d.featureNS,g=b.a;a.setAttribute("typeName",Qq(e,d.featureType));a.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:"+e,f);e=b.c;if(void 0!==e){f=b.P();for(var h=[],l=0,m=f.length;l<m;l++){var n=b.get(f[l]);if(void 0!==n){var p=f[l];n instanceof ef&&(p=g);h.push({name:p,value:n})}}cl({gmlVersion:d.gmlVersion,node:a,hasZ:d.hasZ,srsName:d.srsName},Rq,Yk("Property"),h,c);Pq(a,e)}}),Delete:J(function(a,
b,c){c=c[c.length-1];wa(void 0!==b.c,26);var d=c.featurePrefix,e=c.featureNS;a.setAttribute("typeName",Qq(d,c.featureType));a.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:"+d,e);b=b.c;void 0!==b&&Pq(a,b)}),Property:J(function(a,b,c){var d=Nk("http://www.opengis.net/wfs","Name"),e=c[c.length-1].gmlVersion;a.appendChild(d);rm(d,b.name);void 0!==b.value&&null!==b.value&&(d=Nk("http://www.opengis.net/wfs","Value"),a.appendChild(d),b.value instanceof ef?2===e?Dm.prototype.ri(d,b.value,c):um.prototype.wd(d,
b.value,c):rm(d,b.value))}),Native:J(function(a,b){b.yq&&a.setAttribute("vendorId",b.yq);void 0!==b.Xp&&a.setAttribute("safeToIgnore",b.Xp);void 0!==b.value&&rm(a,b.value)})}};function Sq(a,b,c){a={node:a};b=b.b;for(var d=0,e=b.length;d<e;++d){var f=b[d];cl(a,Tq,Yk(f.nc),[f],c)}}function Uq(a,b){void 0!==b.a&&a.setAttribute("matchCase",b.a.toString());Vq(a,b.b);Wq(a,""+b.f)}function Xq(a,b,c){a=Nk("http://www.opengis.net/ogc",a);rm(a,c);b.appendChild(a)}function Vq(a,b){Xq("PropertyName",a,b)}
function Wq(a,b){Xq("Literal",a,b)}function Yq(a,b){var c=Nk("http://www.opengis.net/gml","TimeInstant");a.appendChild(c);a=Nk("http://www.opengis.net/gml","timePosition");c.appendChild(a);rm(a,b)}
var Tq={"http://www.opengis.net/wfs":{Query:J(function(a,b,c){var d=c[c.length-1],e=d.featurePrefix,f=d.featureNS,g=d.propertyNames,h=d.srsName;a.setAttribute("typeName",e?Qq(e,b):b);h&&a.setAttribute("srsName",h);f&&a.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:"+e,f);b=tb({},d);b.node=a;cl(b,Oq,Yk("PropertyName"),g,c);if(d=d.filter)g=Nk("http://www.opengis.net/ogc","Filter"),a.appendChild(g),cl({node:g},Tq,Yk(d.nc),[d],c)})},"http://www.opengis.net/ogc":{During:J(function(a,b){var c=Nk("http://www.opengis.net/fes",
"ValueReference");rm(c,b.b);a.appendChild(c);c=Nk("http://www.opengis.net/gml","TimePeriod");a.appendChild(c);a=Nk("http://www.opengis.net/gml","begin");c.appendChild(a);Yq(a,b.a);a=Nk("http://www.opengis.net/gml","end");c.appendChild(a);Yq(a,b.f)}),And:J(Sq),Or:J(Sq),Not:J(function(a,b,c){b=b.condition;cl({node:a},Tq,Yk(b.nc),[b],c)}),BBOX:J(function(a,b,c){c[c.length-1].srsName=b.srsName;Vq(a,b.geometryName);um.prototype.wd(a,b.extent,c)}),Intersects:J(function(a,b,c){c[c.length-1].srsName=b.srsName;
Vq(a,b.geometryName);um.prototype.wd(a,b.geometry,c)}),Within:J(function(a,b,c){c[c.length-1].srsName=b.srsName;Vq(a,b.geometryName);um.prototype.wd(a,b.geometry,c)}),PropertyIsEqualTo:J(Uq),PropertyIsNotEqualTo:J(Uq),PropertyIsLessThan:J(Uq),PropertyIsLessThanOrEqualTo:J(Uq),PropertyIsGreaterThan:J(Uq),PropertyIsGreaterThanOrEqualTo:J(Uq),PropertyIsNull:J(function(a,b){Vq(a,b.b)}),PropertyIsBetween:J(function(a,b){Vq(a,b.b);var c=Nk("http://www.opengis.net/ogc","LowerBoundary");a.appendChild(c);
Wq(c,""+b.a);c=Nk("http://www.opengis.net/ogc","UpperBoundary");a.appendChild(c);Wq(c,""+b.f)}),PropertyIsLike:J(function(a,b){a.setAttribute("wildCard",b.g);a.setAttribute("singleChar",b.i);a.setAttribute("escapeChar",b.f);void 0!==b.a&&a.setAttribute("matchCase",b.a.toString());Vq(a,b.b);Wq(a,""+b.c)})}};
Eq.prototype.o=function(a){var b=Nk("http://www.opengis.net/wfs","GetFeature");b.setAttribute("service","WFS");b.setAttribute("version","1.1.0");if(a){a.handle&&b.setAttribute("handle",a.handle);a.outputFormat&&b.setAttribute("outputFormat",a.outputFormat);void 0!==a.maxFeatures&&b.setAttribute("maxFeatures",a.maxFeatures);a.resultType&&b.setAttribute("resultType",a.resultType);void 0!==a.startIndex&&b.setAttribute("startIndex",a.startIndex);void 0!==a.count&&b.setAttribute("count",a.count);var c=
a.filter;if(a.bbox){wa(a.geometryName,12);var d=Vl(a.geometryName,a.bbox,a.srsName);c?c=Ul(c,d):c=d}}b.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation",this.l);c={node:b,srsName:a.srsName,featureNS:a.featureNS?a.featureNS:this.a,featurePrefix:a.featurePrefix,geometryName:a.geometryName,filter:c,propertyNames:a.propertyNames?a.propertyNames:[]};wa(Array.isArray(a.featureTypes),11);a=a.featureTypes;c=[c];d=tb({},c[c.length-1]);d.node=b;cl(d,Tq,Yk("Query"),a,c);return b};
Eq.prototype.v=function(a,b,c,d){var e=[],f=Nk("http://www.opengis.net/wfs","Transaction"),g=d.version?d.version:"1.1.0",h="1.0.0"===g?2:3;f.setAttribute("service","WFS");f.setAttribute("version",g);if(d){var l=d.gmlOptions?d.gmlOptions:{};d.handle&&f.setAttribute("handle",d.handle)}f.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation",Fq[g]);var m=d.featurePrefix?d.featurePrefix:"feature";a&&(g={node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:m,gmlVersion:h,
hasZ:d.hasZ,srsName:d.srsName},tb(g,l),cl(g,Rq,Yk("Insert"),a,e));b&&(g={node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:m,gmlVersion:h,hasZ:d.hasZ,srsName:d.srsName},tb(g,l),cl(g,Rq,Yk("Update"),b,e));c&&cl({node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:m,gmlVersion:h,srsName:d.srsName},Rq,Yk("Delete"),c,e);d.nativeElements&&cl({node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:m,gmlVersion:h,srsName:d.srsName},Rq,Yk("Native"),d.nativeElements,
e);return f};Eq.prototype.Qg=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.uf(a);return null};Eq.prototype.uf=function(a){if(a.firstElementChild&&a.firstElementChild.firstElementChild)for(a=a.firstElementChild.firstElementChild,a=a.firstElementChild;a;a=a.nextElementSibling)if(0!==a.childNodes.length&&(1!==a.childNodes.length||3!==a.firstChild.nodeType)){var b=[{}];this.b.rf(a,b);return Zb(b.pop().srsName)}return null};function Zq(a){a=a?a:{};fl.call(this);this.b=void 0!==a.splitCollection?a.splitCollection:!1}v(Zq,xn);function $q(a){a=a.V();return 0===a.length?"":a.join(" ")}function ar(a){a=a.V();for(var b=[],c=0,d=a.length;c<d;++c)b.push(a[c].join(" "));return b.join(",")}function br(a){var b=[];a=a.Xd();for(var c=0,d=a.length;c<d;++c)b.push("("+ar(a[c])+")");return b.join(",")}
function cr(a){var b=a.S(),c=(0,dr[b])(a);b=b.toUpperCase();if(a instanceof ff){a=a.ja;var d="";if("XYZ"===a||"XYZM"===a)d+="Z";if("XYM"===a||"XYZM"===a)d+="M";a=d;0<a.length&&(b+=" "+a)}return 0===c.length?b+" EMPTY":b+"("+c+")"}
var dr={Point:$q,LineString:ar,Polygon:br,MultiPoint:function(a){var b=[];a=a.ee();for(var c=0,d=a.length;c<d;++c)b.push("("+$q(a[c])+")");return b.join(",")},MultiLineString:function(a){var b=[];a=a.qd();for(var c=0,d=a.length;c<d;++c)b.push("("+ar(a[c])+")");return b.join(",")},MultiPolygon:function(a){var b=[];a=a.Yd();for(var c=0,d=a.length;c<d;++c)b.push("("+br(a[c])+")");return b.join(",")},GeometryCollection:function(a){var b=[];a=a.pd();for(var c=0,d=a.length;c<d;++c)b.push(cr(a[c]));return b.join(",")}};
k=Zq.prototype;k.he=function(a,b){return(a=this.Dd(a,b))?(b=new Kk,b.Sa(a),b):null};k.Lg=function(a,b){var c=[];a=this.Dd(a,b);this.b&&"GeometryCollection"==a.S()?c=a.a:c=[a];b=[];for(var d=0,e=c.length;d<e;++d)a=new Kk,a.Sa(c[d]),b.push(a);return b};k.Dd=function(a,b){a=new er(new fr(a));gr(a);return(a=hr(a))?il(a,!1,b):null};k.se=function(a,b){return(a=a.W())?this.Hd(a,b):""};
k.lh=function(a,b){if(1==a.length)return this.se(a[0],b);for(var c=[],d=0,e=a.length;d<e;++d)c.push(a[d].W());a=new Wl(c);return this.Hd(a,b)};k.Hd=function(a,b){return cr(il(a,!0,b))};function fr(a){this.a=a;this.b=-1}
function ir(a){var b=a.a.charAt(++a.b),c={position:a.b,value:b};if("("==b)c.type=2;else if(","==b)c.type=5;else if(")"==b)c.type=3;else if("0"<=b&&"9">=b||"."==b||"-"==b){c.type=4;b=a.b;var d=!1,e=!1;do{if("."==f)d=!0;else if("e"==f||"E"==f)e=!0;var f=a.a.charAt(++a.b)}while("0"<=f&&"9">=f||"."==f&&(void 0===d||!d)||!e&&("e"==f||"E"==f)||e&&("-"==f||"+"==f));a=parseFloat(a.a.substring(b,a.b--));c.value=a}else if("a"<=b&&"z">=b||"A"<=b&&"Z">=b){c.type=1;b=a.b;do f=a.a.charAt(++a.b);while("a"<=f&&"z">=
f||"A"<=f&&"Z">=f);a=a.a.substring(b,a.b--).toUpperCase();c.value=a}else{if(" "==b||"\t"==b||"\r"==b||"\n"==b)return ir(a);if(""===b)c.type=6;else throw Error("Unexpected character: "+b);}return c}function er(a){this.f=a;this.a="XY"}function gr(a){a.b=ir(a.f)}function jr(a,b){(b=a.b.type==b)&&gr(a);return b}
function hr(a){var b=a.b;if(jr(a,1)){b=b.value;var c="XY",d=a.b;1==a.b.type&&(d=d.value,"Z"===d?c="XYZ":"M"===d?c="XYM":"ZM"===d&&(c="XYZM"),"XY"!==c&&gr(a));a.a=c;if("GEOMETRYCOLLECTION"==b){a:{if(jr(a,2)){b=[];do b.push(hr(a));while(jr(a,5));if(jr(a,3)){a=b;break a}}else if(kr(a)){a=[];break a}throw Error(lr(a));}return new Wl(a)}d=mr[b];c=nr[b];if(!d||!c)throw Error("Invalid geometry type: "+b);b=d.call(a);return new c(b,a.a)}throw Error(lr(a));}k=er.prototype;
k.Fg=function(){if(jr(this,2)){var a=or(this);if(jr(this,3))return a}else if(kr(this))return null;throw Error(lr(this));};k.Eg=function(){if(jr(this,2)){var a=pr(this);if(jr(this,3))return a}else if(kr(this))return[];throw Error(lr(this));};k.Gg=function(){if(jr(this,2)){var a=qr(this);if(jr(this,3))return a}else if(kr(this))return[];throw Error(lr(this));};
k.np=function(){if(jr(this,2)){var a;if(2==this.b.type)for(a=[this.Fg()];jr(this,5);)a.push(this.Fg());else a=pr(this);if(jr(this,3))return a}else if(kr(this))return[];throw Error(lr(this));};k.mp=function(){if(jr(this,2)){var a=qr(this);if(jr(this,3))return a}else if(kr(this))return[];throw Error(lr(this));};k.op=function(){if(jr(this,2)){for(var a=[this.Gg()];jr(this,5);)a.push(this.Gg());if(jr(this,3))return a}else if(kr(this))return[];throw Error(lr(this));};
function or(a){for(var b=[],c=a.a.length,d=0;d<c;++d){var e=a.b;if(jr(a,4))b.push(e.value);else break}if(b.length==c)return b;throw Error(lr(a));}function pr(a){for(var b=[or(a)];jr(a,5);)b.push(or(a));return b}function qr(a){for(var b=[a.Eg()];jr(a,5);)b.push(a.Eg());return b}function kr(a){var b=1==a.b.type&&"EMPTY"==a.b.value;b&&gr(a);return b}function lr(a){return"Unexpected `"+a.b.value+"` at position "+a.b.position+" in `"+a.f.a+"`"}
var nr={POINT:D,LINESTRING:M,POLYGON:E,MULTIPOINT:ql,MULTILINESTRING:O,MULTIPOLYGON:P},mr={POINT:er.prototype.Fg,LINESTRING:er.prototype.Eg,POLYGON:er.prototype.Gg,MULTIPOINT:er.prototype.np,MULTILINESTRING:er.prototype.mp,MULTIPOLYGON:er.prototype.op};function rr(){this.version=void 0}v(rr,bq);rr.prototype.a=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.b(a);return null};rr.prototype.b=function(a){this.version=a.getAttribute("version").trim();return(a=L({version:this.version},sr,a,[]))?a:null};function tr(a,b){return L({},ur,a,b)}function vr(a,b){return L({},wr,a,b)}function xr(a,b){if(b=tr(a,b))return a=[pm(a.getAttribute("width")),pm(a.getAttribute("height"))],b.size=a,b}
function yr(a,b){return L([],zr,a,b)}
var Ar=[null,"http://www.opengis.net/wms"],sr=K(Ar,{Service:I(function(a,b){return L({},Br,a,b)}),Capability:I(function(a,b){return L({},Cr,a,b)})}),Cr=K(Ar,{Request:I(function(a,b){return L({},Dr,a,b)}),Exception:I(function(a,b){return L([],Er,a,b)}),Layer:I(function(a,b){return L({},Fr,a,b)})}),Br=K(Ar,{Name:I(Q),Title:I(Q),Abstract:I(Q),KeywordList:I(yr),OnlineResource:I(aq),ContactInformation:I(function(a,b){return L({},Gr,a,b)}),Fees:I(Q),AccessConstraints:I(Q),LayerLimit:I(om),MaxWidth:I(om),
MaxHeight:I(om)}),Gr=K(Ar,{ContactPersonPrimary:I(function(a,b){return L({},Hr,a,b)}),ContactPosition:I(Q),ContactAddress:I(function(a,b){return L({},Ir,a,b)}),ContactVoiceTelephone:I(Q),ContactFacsimileTelephone:I(Q),ContactElectronicMailAddress:I(Q)}),Hr=K(Ar,{ContactPerson:I(Q),ContactOrganization:I(Q)}),Ir=K(Ar,{AddressType:I(Q),Address:I(Q),City:I(Q),StateOrProvince:I(Q),PostCode:I(Q),Country:I(Q)}),Er=K(Ar,{Format:Uk(Q)}),Fr=K(Ar,{Name:I(Q),Title:I(Q),Abstract:I(Q),KeywordList:I(yr),CRS:Wk(Q),
EX_GeographicBoundingBox:I(function(a,b){var c=L({},Jr,a,b);if(c){a=c.westBoundLongitude;b=c.southBoundLatitude;var d=c.eastBoundLongitude;c=c.northBoundLatitude;if(void 0!==a&&void 0!==b&&void 0!==d&&void 0!==c)return[a,b,d,c]}}),BoundingBox:Wk(function(a){var b=[nm(a.getAttribute("minx")),nm(a.getAttribute("miny")),nm(a.getAttribute("maxx")),nm(a.getAttribute("maxy"))],c=[nm(a.getAttribute("resx")),nm(a.getAttribute("resy"))];return{crs:a.getAttribute("CRS"),extent:b,res:c}}),Dimension:Wk(function(a){return{name:a.getAttribute("name"),
units:a.getAttribute("units"),unitSymbol:a.getAttribute("unitSymbol"),"default":a.getAttribute("default"),multipleValues:km(a.getAttribute("multipleValues")),nearestValue:km(a.getAttribute("nearestValue")),current:km(a.getAttribute("current")),values:Q(a)}}),Attribution:I(function(a,b){return L({},Kr,a,b)}),AuthorityURL:Wk(function(a,b){if(b=tr(a,b))return b.name=a.getAttribute("name"),b}),Identifier:Wk(Q),MetadataURL:Wk(function(a,b){if(b=tr(a,b))return b.type=a.getAttribute("type"),b}),DataURL:Wk(tr),
FeatureListURL:Wk(tr),Style:Wk(function(a,b){return L({},Lr,a,b)}),MinScaleDenominator:I(mm),MaxScaleDenominator:I(mm),Layer:Wk(function(a,b){var c=b[b.length-1],d=L({},Fr,a,b);if(d)return b=km(a.getAttribute("queryable")),void 0===b&&(b=c.queryable),d.queryable=void 0!==b?b:!1,b=pm(a.getAttribute("cascaded")),void 0===b&&(b=c.cascaded),d.cascaded=b,b=km(a.getAttribute("opaque")),void 0===b&&(b=c.opaque),d.opaque=void 0!==b?b:!1,b=km(a.getAttribute("noSubsets")),void 0===b&&(b=c.noSubsets),d.noSubsets=
void 0!==b?b:!1,(b=nm(a.getAttribute("fixedWidth")))||(b=c.fixedWidth),d.fixedWidth=b,(a=nm(a.getAttribute("fixedHeight")))||(a=c.fixedHeight),d.fixedHeight=a,["Style","CRS","AuthorityURL"].forEach(function(a){a in c&&(d[a]=(d[a]||[]).concat(c[a]))}),"EX_GeographicBoundingBox BoundingBox Dimension Attribution MinScaleDenominator MaxScaleDenominator".split(" ").forEach(function(a){a in d||(d[a]=c[a])}),d})}),Kr=K(Ar,{Title:I(Q),OnlineResource:I(aq),LogoURL:I(xr)}),Jr=K(Ar,{westBoundLongitude:I(mm),
eastBoundLongitude:I(mm),southBoundLatitude:I(mm),northBoundLatitude:I(mm)}),Dr=K(Ar,{GetCapabilities:I(vr),GetMap:I(vr),GetFeatureInfo:I(vr)}),wr=K(Ar,{Format:Wk(Q),DCPType:Wk(function(a,b){return L({},Mr,a,b)})}),Mr=K(Ar,{HTTP:I(function(a,b){return L({},Nr,a,b)})}),Nr=K(Ar,{Get:I(tr),Post:I(tr)}),Lr=K(Ar,{Name:I(Q),Title:I(Q),Abstract:I(Q),LegendURL:Wk(xr),StyleSheetURL:I(tr),StyleURL:I(tr)}),ur=K(Ar,{Format:I(Q),OnlineResource:I(aq)}),zr=K(Ar,{Keyword:Uk(Q)});function Or(a){a=a?a:{};this.a="http://mapserver.gis.umn.edu/mapserver";this.b=new Dm;this.c=a.layers?a.layers:null;em.call(this)}v(Or,em);
Or.prototype.Dc=function(a,b){var c={};b&&tb(c,gl(this,a,b));c=[c];a.setAttribute("namespaceURI",this.a);var d=a.localName;b=[];if(0!==a.childNodes.length){if("msGMLOutput"==d)for(var e=0,f=a.childNodes.length;e<f;e++){var g=a.childNodes[e];if(g.nodeType===Node.ELEMENT_NODE){var h=c[0],l=g.localName.replace("_layer","");if(!this.c||ha(this.c,l)){l+="_feature";h.featureType=l;h.featureNS=this.a;var m={};m[l]=Uk(this.b.Ig,this.b);h=K([h.featureNS,null],m);g.setAttribute("namespaceURI",this.a);(g=L([],
h,g,c,this.b))&&ja(b,g)}}}"FeatureCollection"==d&&(a=L([],this.b.b,a,[{}],this.b))&&(b=a)}return b};Or.prototype.kh=function(){};Or.prototype.Zb=function(){};Or.prototype.ue=function(){};function Pr(){this.f=new cq}v(Pr,bq);Pr.prototype.a=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.b(a);return null};Pr.prototype.b=function(a){var b=a.getAttribute("version").trim(),c=this.f.b(a);if(!c)return null;c.version=b;return(c=L(c,Qr,a,[]))?c:null};function Rr(a){var b=Q(a).split(" ");if(b&&2==b.length&&(a=+b[0],b=+b[1],!isNaN(a)&&!isNaN(b)))return[a,b]}
var Sr=[null,"http://www.opengis.net/wmts/1.0"],Tr=[null,"http://www.opengis.net/ows/1.1"],Qr=K(Sr,{Contents:I(function(a,b){return L({},Ur,a,b)})}),Ur=K(Sr,{Layer:Wk(function(a,b){return L({},Vr,a,b)}),TileMatrixSet:Wk(function(a,b){return L({},Wr,a,b)})}),Vr=K(Sr,{Style:Wk(function(a,b){if(b=L({},Xr,a,b))return a="true"===a.getAttribute("isDefault"),b.isDefault=a,b}),Format:Wk(Q),TileMatrixSetLink:Wk(function(a,b){return L({},Yr,a,b)}),Dimension:Wk(function(a,b){return L({},Zr,a,b)}),ResourceURL:Wk(function(a){var b=
a.getAttribute("format"),c=a.getAttribute("template");a=a.getAttribute("resourceType");var d={};b&&(d.format=b);c&&(d.template=c);a&&(d.resourceType=a);return d})},K(Tr,{Title:I(Q),Abstract:I(Q),WGS84BoundingBox:I(function(a,b){a=L([],$r,a,b);if(2==a.length)return Oa(a)}),Identifier:I(Q)})),Xr=K(Sr,{LegendURL:Wk(function(a){var b={};b.format=a.getAttribute("format");b.href=aq(a);return b})},K(Tr,{Title:I(Q),Identifier:I(Q)})),Yr=K(Sr,{TileMatrixSet:I(Q),TileMatrixSetLimits:I(function(a,b){return L([],
as,a,b)})}),as=K(Sr,{TileMatrixLimits:Uk(function(a,b){return L({},bs,a,b)})}),bs=K(Sr,{TileMatrix:I(Q),MinTileRow:I(om),MaxTileRow:I(om),MinTileCol:I(om),MaxTileCol:I(om)}),Zr=K(Sr,{Default:I(Q),Value:Wk(Q)},K(Tr,{Identifier:I(Q)})),$r=K(Tr,{LowerCorner:Uk(Rr),UpperCorner:Uk(Rr)}),Wr=K(Sr,{WellKnownScaleSet:I(Q),TileMatrix:Wk(function(a,b){return L({},cs,a,b)})},K(Tr,{SupportedCRS:I(Q),Identifier:I(Q)})),cs=K(Sr,{TopLeftCorner:I(Rr),ScaleDenominator:I(mm),TileWidth:I(om),TileHeight:I(om),MatrixWidth:I(om),
MatrixHeight:I(om)},K(Tr,{Identifier:I(Q)}));function ds(a){Wc.call(this);a=a||{};this.a=null;this.i=jc;this.g=new xb(6378137);this.c=void 0;z(this,Yc("projection"),this.Lm,this);z(this,Yc("tracking"),this.Mm,this);void 0!==a.projection&&this.li(a.projection);void 0!==a.trackingOptions&&this.Jj(a.trackingOptions);this.Ve(void 0!==a.tracking?a.tracking:!1)}v(ds,Wc);k=ds.prototype;k.ka=function(){this.Ve(!1);Wc.prototype.ka.call(this)};k.Lm=function(){var a=this.ji();a&&(this.i=$b(Zb("EPSG:4326"),a),this.a&&this.set("position",this.i(this.a)))};
k.Mm=function(){if(td){var a=this.ki();a&&void 0===this.c?this.c=navigator.geolocation.watchPosition(this.vp.bind(this),this.wp.bind(this),this.Xh()):a||void 0===this.c||(navigator.geolocation.clearWatch(this.c),this.c=void 0)}};
k.vp=function(a){a=a.coords;this.set("accuracy",a.accuracy);this.set("altitude",null===a.altitude?void 0:a.altitude);this.set("altitudeAccuracy",null===a.altitudeAccuracy?void 0:a.altitudeAccuracy);this.set("heading",null===a.heading?void 0:Ia(a.heading));this.a?(this.a[0]=a.longitude,this.a[1]=a.latitude):this.a=[a.longitude,a.latitude];var b=this.i(this.a);this.set("position",b);this.set("speed",null===a.speed?void 0:a.speed);a=Qf(this.g,this.a,a.accuracy);a.Jc(this.i);this.set("accuracyGeometry",
a);this.u()};k.wp=function(a){a.type="error";this.Ve(!1);this.b(a)};k.Ok=function(){return this.get("accuracy")};k.Pk=function(){return this.get("accuracyGeometry")||null};k.Qk=function(){return this.get("altitude")};k.Rk=function(){return this.get("altitudeAccuracy")};k.Jm=function(){return this.get("heading")};k.Km=function(){return this.get("position")};k.ji=function(){return this.get("projection")};k.ul=function(){return this.get("speed")};k.ki=function(){return this.get("tracking")};k.Xh=function(){return this.get("trackingOptions")};
k.li=function(a){this.set("projection",Zb(a))};k.Ve=function(a){this.set("tracking",a)};k.Jj=function(a){this.set("trackingOptions",a)};function es(a,b,c){ff.call(this);this.fh(a,b?b:0,c)}v(es,ff);k=es.prototype;k.clone=function(){var a=new es(null);hf(a,this.ja,this.A.slice());a.u();return a};k.Mb=function(a,b,c,d){var e=this.A;a-=e[0];var f=b-e[1];b=a*a+f*f;if(b<d){if(0===b)for(d=0;d<this.a;++d)c[d]=e[d];else for(d=this.xd()/Math.sqrt(b),c[0]=e[0]+d*a,c[1]=e[1]+d*f,d=2;d<this.a;++d)c[d]=e[d];c.length=this.a;return b}return d};k.Tc=function(a,b){var c=this.A;a-=c[0];b-=c[1];return a*a+b*b<=fs(this)};
k.xa=function(){return this.A.slice(0,this.a)};k.De=function(a){var b=this.A,c=b[this.a]-b[0];return Ya(b[0]-c,b[1]-c,b[0]+c,b[1]+c,a)};k.xd=function(){return Math.sqrt(fs(this))};function fs(a){var b=a.A[a.a]-a.A[0];a=a.A[a.a+1]-a.A[1];return b*b+a*a}k.S=function(){return"Circle"};k.Ya=function(a){var b=this.G();return qb(a,b)?(b=this.xa(),a[0]<=b[0]&&a[2]>=b[0]||a[1]<=b[1]&&a[3]>=b[1]?!0:eb(a,this.yb,this)):!1};
k.rb=function(a){var b=this.a,c=a.slice();c[b]=c[0]+(this.A[b]-this.A[0]);var d;for(d=1;d<b;++d)c[b+d]=a[d];hf(this,this.ja,c);this.u()};k.fh=function(a,b,c){if(a){jf(this,c,a,0);this.A||(this.A=[]);c=this.A;a=tf(c,a);c[a++]=c[0]+b;var d;b=1;for(d=this.a;b<d;++b)c[a++]=c[b];c.length=a}else hf(this,"XY",null);this.u()};k.V=function(){};k.na=function(){};k.$c=function(a){this.A[this.a]=this.A[0]+a;this.u()};function gs(a,b,c){for(var d=[],e=a(0),f=a(1),g=b(e),h=b(f),l=[f,e],m=[h,g],n=[1,0],p={},q=1E5,r,u,x,B,A;0<--q&&0<n.length;)x=n.pop(),e=l.pop(),g=m.pop(),f=x.toString(),f in p||(d.push(g[0],g[1]),p[f]=!0),B=n.pop(),f=l.pop(),h=m.pop(),A=(x+B)/2,r=a(A),u=b(r),Ga(u[0],u[1],g[0],g[1],h[0],h[1])<c?(d.push(h[0],h[1]),f=B.toString(),p[f]=!0):(n.push(B,A,A,x),m.push(h,u,u,g),l.push(f,r,r,e));return d}function hs(a,b,c,d,e){var f=Zb("EPSG:4326");return gs(function(d){return[a,b+(c-b)*d]},ic(f,d),e)}
function is(a,b,c,d,e){var f=Zb("EPSG:4326");return gs(function(d){return[b+(c-b)*d,a]},ic(f,d),e)};function js(a,b,c){var d=b-c;return a[0]===a[d]&&a[1]===a[d+1]&&3<(b-0)/c?!!mf(a,0,b,c):!1};function ks(a){a=a||{};this.i=this.v=null;this.j=this.g=Infinity;this.o=this.l=-Infinity;this.sa=this.ra=Infinity;this.T=this.I=-Infinity;this.oa=void 0!==a.targetSize?a.targetSize:100;this.kb=void 0!==a.maxLines?a.maxLines:100;this.f=[];this.c=[];this.ma=void 0!==a.strokeStyle?a.strokeStyle:ls;this.C=this.s=void 0;this.a=this.b=this.O=null;1==a.showLabels&&(this.ta=a.lonLabelFormatter?a.lonLabelFormatter:Be.bind(this,"EW"),this.Ua=a.latLabelFormatter?a.latLabelFormatter:Be.bind(this,"NS"),this.fa=
void 0==a.lonLabelPosition?0:a.lonLabelPosition,this.U=void 0==a.latLabelPosition?1:a.latLabelPosition,this.B=void 0!==a.lonLabelStyle?a.lonLabelStyle:new Hn({font:"12px Calibri,sans-serif",textBaseline:"bottom",fill:new Ck({color:"rgba(0,0,0,1)"}),stroke:new Dk({color:"rgba(255,255,255,1)",width:3})}),this.D=void 0!==a.latLabelStyle?a.latLabelStyle:new Hn({font:"12px Calibri,sans-serif",textAlign:"end",fill:new Ck({color:"rgba(0,0,0,1)"}),stroke:new Dk({color:"rgba(255,255,255,1)",width:3})}),this.b=
[],this.a=[]);this.setMap(void 0!==a.map?a.map:null)}var ls=new Dk({color:"rgba(0,0,0,0.2)"}),ms=[90,45,30,20,10,5,2,1,.5,.2,.1,.05,.01,.005,.002,.001];function ns(a,b,c,d,e,f,g){var h=g;c=hs(b,c,d,a.i,e);h=void 0!==a.f[h]?a.f[h]:new M(null);h.aa("XY",c);qb(h.G(),f)&&(a.b&&(c=g,d=h.ca(),f=[d[0],Da(f[1]+Math.abs(f[1]-f[3])*a.fa,Math.max(f[1],d[1]),Math.min(f[3],d[d.length-1]))],c=a.b[c]?a.b[c].Ud:new D(null),c.na(f),a.b[g]={Ud:c,text:a.ta(b)}),a.f[g++]=h);return g}
function os(a,b,c,d,e,f,g){var h=g;c=is(b,c,d,a.i,e);h=void 0!==a.c[h]?a.c[h]:new M(null);h.aa("XY",c);qb(h.G(),f)&&(a.a&&(c=g,d=h.ca(),f=[Da(f[0]+Math.abs(f[0]-f[2])*a.U,Math.max(f[0],d[0]),Math.min(f[2],d[d.length-2])),d[1]],c=a.a[c]?a.a[c].Ud:new D(null),c.na(f),a.a[g]={Ud:c,text:a.Ua(b)}),a.c[g++]=h);return g}k=ks.prototype;k.Nm=function(){return this.v};k.kl=function(){return this.f};k.pl=function(){return this.c};
k.ai=function(a){var b=a.vectorContext,c=a.frameState;a=c.extent;var d=c.viewState,e=d.center,f=d.projection;d=d.resolution;c=c.pixelRatio;c=d*d/(4*c*c);if(!this.i||!hc(this.i,f)){var g=Zb("EPSG:4326"),h=f.G(),l=f.re,m=lc(l,g,f),n=l[2],p=l[1],q=l[0],r=m[3],u=m[2],x=m[1];m=m[0];this.g=l[3];this.j=n;this.l=p;this.o=q;this.ra=r;this.sa=u;this.I=x;this.T=m;this.s=ic(g,f);this.C=ic(f,g);this.O=this.C(nb(h));this.i=f}f=this.O[0];g=this.O[1];h=-1;n=Math.pow(this.oa*d,2);p=[];q=[];d=0;for(l=ms.length;d<l;++d){r=
ms[d]/2;p[0]=f-r;p[1]=g-r;q[0]=f+r;q[1]=g+r;this.s(p,p);this.s(q,q);r=Math.pow(q[0]-p[0],2)+Math.pow(q[1]-p[1],2);if(r<=n)break;h=ms[d]}d=h;if(-1==d)this.f.length=this.c.length=0,this.b&&(this.b.length=0),this.a&&(this.a.length=0);else{f=this.C(e);e=f[0];f=f[1];g=this.kb;l=[Math.max(a[0],this.T),Math.max(a[1],this.I),Math.min(a[2],this.sa),Math.min(a[3],this.ra)];l=lc(l,this.i,"EPSG:4326");p=l[3];h=l[2];q=l[1];r=l[0];e=Math.floor(e/d)*d;u=Da(e,this.o,this.j);n=ns(this,u,q,p,c,a,0);for(l=0;u!=this.o&&
l++<g;)u=Math.max(u-d,this.o),n=ns(this,u,q,p,c,a,n);u=Da(e,this.o,this.j);for(l=0;u!=this.j&&l++<g;)u=Math.min(u+d,this.j),n=ns(this,u,q,p,c,a,n);this.f.length=n;this.b&&(this.b.length=n);f=Math.floor(f/d)*d;e=Da(f,this.l,this.g);n=os(this,e,r,h,c,a,0);for(l=0;e!=this.l&&l++<g;)e=Math.max(e-d,this.l),n=os(this,e,r,h,c,a,n);e=Da(f,this.l,this.g);for(l=0;e!=this.g&&l++<g;)e=Math.min(e+d,this.g),n=os(this,e,r,h,c,a,n);this.c.length=n;this.a&&(this.a.length=n)}b.La(null,this.ma);a=0;for(c=this.f.length;a<
c;++a)e=this.f[a],b.Fb(e);a=0;for(c=this.c.length;a<c;++a)e=this.c[a],b.Fb(e);if(this.b)for(a=0,c=this.b.length;a<c;++a)e=this.b[a],this.B.Ed(e.text),b.ib(this.B),b.Fb(e.Ud);if(this.a)for(a=0,c=this.a.length;a<c;++a)e=this.a[a],this.D.Ed(e.text),b.ib(this.D),b.Fb(e.Ud)};k.setMap=function(a){this.v&&(this.v.K("postcompose",this.ai,this),this.v.render());a&&(a.J("postcompose",this.ai,this),a.render());this.v=a};function ps(a,b,c,d,e){Tc.call(this);this.c=e;this.extent=a;this.a=c;this.resolution=b;this.state=d}v(ps,Tc);ps.prototype.u=function(){this.b("change")};ps.prototype.G=function(){return this.extent};ps.prototype.getState=function(){return this.state};function qs(a,b,c,d,e,f,g){ps.call(this,a,b,c,0,d);this.g=e;this.N=new Image;null!==f&&(this.N.crossOrigin=f);this.f=null;this.state=0;this.i=g}v(qs,ps);k=qs.prototype;k.Y=function(){return this.N};k.Qm=function(){this.state=3;this.f.forEach(Hc);this.f=null;this.u()};k.Rm=function(){void 0===this.resolution&&(this.resolution=mb(this.extent)/this.N.height);this.state=2;this.f.forEach(Hc);this.f=null;this.u()};
k.load=function(){if(0==this.state||3==this.state)this.state=1,this.u(),this.f=[Mc(this.N,"error",this.Qm,this),Mc(this.N,"load",this.Rm,this)],this.i(this,this.g)};k.gh=function(a){this.N=a};function rs(a,b,c,d,e,f){this.i=f?f:null;ps.call(this,a,b,c,f?0:2,d);this.f=e}v(rs,ps);rs.prototype.g=function(a){this.state=a?3:2;this.u()};rs.prototype.load=function(){0==this.state&&(this.state=1,this.u(),this.i(this.g.bind(this)))};rs.prototype.Y=function(){return this.f};function ss(a,b,c){Tc.call(this);c=c?c:{};this.wa=a;this.state=b;this.f=null;this.key="";this.j=void 0===c.transition?250:c.transition;this.o={}}v(ss,Tc);ss.prototype.u=function(){this.b("change")};ss.prototype.gb=function(){return this.key+"/"+this.wa};function Ki(a){if(!a.f)return a;var b=a.f;do{if(2==b.getState())return b;b=b.f}while(b);return a}function ts(a){if(a.f){var b=a.f;do{if(2==b.getState()){b.f=null;break}else 1==b.getState()?a=b:0==b.getState()?a.f=b.f:a=b;b=a.f}while(b)}}
ss.prototype.i=function(){return this.wa};ss.prototype.getState=function(){return this.state};function Ji(a,b){a.state=b;a.u()}function Li(a,b,c){if(!a.j)return 1;var d=a.o[b];if(!d)d=c,a.o[b]=d;else if(-1===d)return 1;b=c-d+1E3/60;return b>=a.j?1:Le(b/a.j)};function us(a,b,c,d,e,f){ss.call(this,a,b,f);this.g=c;this.N=new Image;null!==d&&(this.N.crossOrigin=d);this.c=null;this.l=e}v(us,ss);k=us.prototype;k.ka=function(){1==this.state&&(vs(this),this.N.src=ws);this.f&&Qc(this.f);this.state=5;this.u();ss.prototype.ka.call(this)};k.Y=function(){return this.N};k.gb=function(){return this.g};k.Om=function(){this.state=3;vs(this);this.N.src=ws;this.u()};k.Pm=function(){this.state=this.N.naturalWidth&&this.N.naturalHeight?2:4;vs(this);this.u()};
k.load=function(){if(0==this.state||3==this.state)this.state=1,this.u(),this.c=[Mc(this.N,"error",this.Om,this),Mc(this.N,"load",this.Pm,this)],this.l(this,this.g)};function vs(a){a.c.forEach(Hc);a.c=null}var ws,xs=dg(1,1);xs.fillStyle="rgba(0,0,0,0)";xs.fillRect(0,0,1,1);ws=xs.canvas.toDataURL("image/png");function ys(a){a=a?a:{};Bg.call(this,{handleEvent:Pe});this.j=a.formatConstructors?a.formatConstructors:[];this.o=a.projection?Zb(a.projection):null;this.a=null;this.g=a.source||null;this.target=a.target?a.target:null}v(ys,Bg);function zs(a){a=a.dataTransfer.files;var b;var c=0;for(b=a.length;c<b;++c){var d=a.item(c);var e=new FileReader;e.addEventListener("load",this.l.bind(this,d));e.readAsText(d)}}function As(a){a.stopPropagation();a.preventDefault();a.dataTransfer.dropEffect="copy"}
ys.prototype.l=function(a,b){b=b.target.result;var c=this.v,d=this.o;d||(d=c.$().v);c=this.j;var e=[],f;var g=0;for(f=c.length;g<f;++g){var h=new c[g];var l={featureProjection:d};try{e=h.Ma(b,l)}catch(m){e=null}if(e&&0<e.length)break}this.g&&(this.g.clear(),this.g.Ic(e));this.b(new Bs(Cs,a,e,d))};function Ds(a){var b=a.v;b&&(b=a.target?a.target:b.a,a.a=[z(b,"drop",zs,a),z(b,"dragenter",As,a),z(b,"dragover",As,a),z(b,"drop",As,a)])}
ys.prototype.Ga=function(a){Bg.prototype.Ga.call(this,a);a?Ds(this):Es(this)};ys.prototype.setMap=function(a){Es(this);Bg.prototype.setMap.call(this,a);this.c()&&Ds(this)};function Es(a){a.a&&(a.a.forEach(Hc),a.a=null)}var Cs="addfeatures";function Bs(a,b,c,d){Rc.call(this,a);this.features=c;this.file=b;this.projection=d}v(Bs,Rc);function Fs(a){a=a?a:{};Tg.call(this,{handleDownEvent:Gs,handleDragEvent:Hs,handleUpEvent:Is});this.o=a.condition?a.condition:Pg;this.a=this.g=void 0;this.j=0;this.s=void 0!==a.duration?a.duration:400}v(Fs,Tg);
function Hs(a){if(Rg(a)){var b=a.map,c=b.zb(),d=a.pixel;a=d[0]-c[0]/2;d=c[1]/2-d[1];c=Math.atan2(d,a);a=Math.sqrt(a*a+d*d);b=b.$();b.g.rotation!==se&&void 0!==this.g&&(d=c-this.g,Eg(b,b.Pa()-d));this.g=c;void 0!==this.a&&(c=this.a*(b.Oa()/a),Gg(b,c));void 0!==this.a&&(this.j=this.a/a);this.a=a}}
function Is(a){if(!Rg(a))return!0;a=a.map.$();Xf(a,1,-1);var b=this.j-1,c=a.Pa();c=a.constrainRotation(c,0);Eg(a,c,void 0,void 0);c=a.Oa();var d=this.s;c=a.constrainResolution(c,0,b);Gg(a,c,void 0,d);this.j=0;return!1}function Gs(a){return Rg(a)&&this.o(a)?(Xf(a.map.$(),1,1),this.a=this.g=void 0,!0):!1};function R(a){a=a?a:{};var b=tb({},a);delete b.style;delete b.renderBuffer;delete b.updateWhileAnimating;delete b.updateWhileInteracting;wi.call(this,b);this.g=void 0!==a.renderBuffer?a.renderBuffer:100;this.C=null;this.I=void 0;this.j(a.style);this.U=void 0!==a.updateWhileAnimating?a.updateWhileAnimating:!1;this.ta=void 0!==a.updateWhileInteracting?a.updateWhileInteracting:!1;this.type="VECTOR"}v(R,wi);R.prototype.D=function(){return this.C};R.prototype.bb=function(){return this.I};
R.prototype.j=function(a){this.C=void 0!==a?a:Ik;this.I=null===a?void 0:Gk(this.C);this.u()};var Bj="renderOrder";function Js(){return[[-Infinity,-Infinity,Infinity,Infinity]]};function Ks(a){Wc.call(this);this.c=Zb(a.projection);this.j=Ls(a.attributions);this.D=a.logo;this.ta=void 0!==a.state?a.state:"ready";this.C=void 0!==a.wrapX?a.wrapX:!1}v(Ks,Wc);function Ls(a){if("string"===typeof a)return[new Fc({html:a})];if(a instanceof Fc)return[a];if(Array.isArray(a)){for(var b=a.length,c=Array(b),d=0;d<b;d++){var e=a[d];c[d]="string"===typeof e?new Fc({html:e}):e}return c}return null}k=Ks.prototype;k.Fa=sa;k.Aa=function(){return this.j};k.ya=function(){return this.D};k.Ba=function(){return this.c};
k.getState=function(){return this.ta};k.ua=function(){this.u()};k.va=function(a){this.j=Ls(a);this.u()};function Ms(a,b){a.ta=b;a.u()};Op.ge=function(){};
(function(a){function b(a,e,f,g,h){f=f||0;g=g||a.length-1;for(h=h||d;g>f;){if(600<g-f){var l=g-f+1,m=e-f+1,n=Math.log(l),p=.5*Math.exp(2*n/3);n=.5*Math.sqrt(n*p*(l-p)/l)*(0>m-l/2?-1:1);b(a,e,Math.max(f,Math.floor(e-m*p/l+n)),Math.min(g,Math.floor(e+(l-m)*p/l+n)),h)}l=a[e];m=f;p=g;c(a,f,e);for(0<h(a[g],l)&&c(a,f,g);m<p;){c(a,m,p);m++;for(p--;0>h(a[m],l);)m++;for(;0<h(a[p],l);)p--}0===h(a[f],l)?c(a,f,p):(p++,c(a,p,g));p<=e&&(f=p+1);e<=p&&(g=p-1)}}function c(a,b,c){var d=a[b];a[b]=a[c];a[c]=d}function d(a,
b){return a<b?-1:a>b?1:0}function e(a,b){if(!(this instanceof e))return new e(a,b);this.Lf=Math.max(4,a||9);this.uh=Math.max(2,Math.ceil(.4*this.Lf));b&&this.sk(b);this.clear()}function f(a,b){g(a,0,a.children.length,b,a)}function g(a,b,c,d,e){e||(e=u(null));e.ba=Infinity;e.ea=Infinity;e.da=-Infinity;e.ga=-Infinity;for(var f;b<c;b++)f=a.children[b],h(e,a.nb?d(f):f);return e}function h(a,b){a.ba=Math.min(a.ba,b.ba);a.ea=Math.min(a.ea,b.ea);a.da=Math.max(a.da,b.da);a.ga=Math.max(a.ga,b.ga)}function l(a,
b){return a.ba-b.ba}function m(a,b){return a.ea-b.ea}function n(a){return(a.da-a.ba)*(a.ga-a.ea)}function p(a){return a.da-a.ba+(a.ga-a.ea)}function q(a,b){return a.ba<=b.ba&&a.ea<=b.ea&&b.da<=a.da&&b.ga<=a.ga}function r(a,b){return b.ba<=a.da&&b.ea<=a.ga&&b.da>=a.ba&&b.ga>=a.ea}function u(a){return{children:a,height:1,nb:!0,ba:Infinity,ea:Infinity,da:-Infinity,ga:-Infinity}}function x(a,b,c,d,e){for(var f=[b,c],g;f.length;)c=f.pop(),b=f.pop(),c-b<=d||(g=b+Math.ceil((c-b)/d/2)*d,B(a,g,b,c,e),f.push(b,
g,g,c))}var B=b;"use strict";e.prototype={all:function(){return this.ph(this.data,[])},search:function(a){var b=this.data,c=[],d=this.Db;if(!r(a,b))return c;for(var e=[],f,g,h,l;b;){f=0;for(g=b.children.length;f<g;f++)h=b.children[f],l=b.nb?d(h):h,r(a,l)&&(b.nb?c.push(h):q(a,l)?this.ph(h,c):e.push(h));b=e.pop()}return c},load:function(a){if(!a||!a.length)return this;if(a.length<this.uh){for(var b=0,c=a.length;b<c;b++)this.Ea(a[b]);return this}a=this.rh(a.slice(),0,a.length-1,0);this.data.children.length?
this.data.height===a.height?this.wh(this.data,a):(this.data.height<a.height&&(b=this.data,this.data=a,a=b),this.th(a,this.data.height-a.height-1,!0)):this.data=a;return this},Ea:function(a){a&&this.th(a,this.data.height-1);return this},clear:function(){this.data=u([]);return this},remove:function(a,b){if(!a)return this;for(var c=this.data,d=this.Db(a),e=[],f=[],g,h,l,m;c||e.length;){c||(c=e.pop(),h=e[e.length-1],g=f.pop(),m=!0);if(c.nb){a:{l=a;var n=c.children,p=b;if(p){for(var r=0;r<n.length;r++)if(p(l,
n[r])){l=r;break a}l=-1}else l=n.indexOf(l)}if(-1!==l){c.children.splice(l,1);e.push(c);this.qk(e);break}}m||c.nb||!q(c,d)?h?(g++,c=h.children[g],m=!1):c=null:(e.push(c),f.push(g),g=0,h=c,c=c.children[0])}return this},Db:function(a){return a},Pf:l,Qf:m,toJSON:function(){return this.data},ph:function(a,b){for(var c=[];a;)a.nb?b.push.apply(b,a.children):c.push.apply(c,a.children),a=c.pop();return b},rh:function(a,b,c,d){var e=c-b+1,g=this.Lf;if(e<=g){var h=u(a.slice(b,c+1));f(h,this.Db);return h}d||
(d=Math.ceil(Math.log(e)/Math.log(g)),g=Math.ceil(e/Math.pow(g,d-1)));h=u([]);h.nb=!1;h.height=d;e=Math.ceil(e/g);g=e*Math.ceil(Math.sqrt(g));var l;for(x(a,b,c,g,this.Pf);b<=c;b+=g){var m=Math.min(b+g-1,c);x(a,b,m,e,this.Qf);for(l=b;l<=m;l+=e){var n=Math.min(l+e-1,m);h.children.push(this.rh(a,l,n,d-1))}}f(h,this.Db);return h},pk:function(a,b,c,d){for(var e,f,g,h,l,m,p,q;;){d.push(b);if(b.nb||d.length-1===c)break;p=q=Infinity;e=0;for(f=b.children.length;e<f;e++)g=b.children[e],l=n(g),m=(Math.max(g.da,
a.da)-Math.min(g.ba,a.ba))*(Math.max(g.ga,a.ga)-Math.min(g.ea,a.ea))-l,m<q?(q=m,p=l<p?l:p,h=g):m===q&&l<p&&(p=l,h=g);b=h||b.children[0]}return b},th:function(a,b,c){var d=this.Db;c=c?a:d(a);d=[];var e=this.pk(c,this.data,b,d);e.children.push(a);for(h(e,c);0<=b;)if(d[b].children.length>this.Lf)this.vk(d,b),b--;else break;this.lk(c,d,b)},vk:function(a,b){var c=a[b],d=c.children.length,e=this.uh;this.mk(c,e,d);d=this.nk(c,e,d);d=u(c.children.splice(d,c.children.length-d));d.height=c.height;d.nb=c.nb;
f(c,this.Db);f(d,this.Db);b?a[b-1].children.push(d):this.wh(c,d)},wh:function(a,b){this.data=u([a,b]);this.data.height=a.height+1;this.data.nb=!1;f(this.data,this.Db)},nk:function(a,b,c){var d,e;var f=e=Infinity;for(d=b;d<=c-b;d++){var h=g(a,0,d,this.Db);var l=g(a,d,c,this.Db);var m=Math.max(0,Math.min(h.da,l.da)-Math.max(h.ba,l.ba))*Math.max(0,Math.min(h.ga,l.ga)-Math.max(h.ea,l.ea));h=n(h)+n(l);if(m<f){f=m;var p=d;e=h<e?h:e}else m===f&&h<e&&(e=h,p=d)}return p},mk:function(a,b,c){var d=a.nb?this.Pf:
l,e=a.nb?this.Qf:m,f=this.qh(a,b,c,d);b=this.qh(a,b,c,e);f<b&&a.children.sort(d)},qh:function(a,b,c,d){a.children.sort(d);d=this.Db;var e=g(a,0,b,d),f=g(a,c-b,c,d),l=p(e)+p(f),m;for(m=b;m<c-b;m++){var n=a.children[m];h(e,a.nb?d(n):n);l+=p(e)}for(m=c-b-1;m>=b;m--)n=a.children[m],h(f,a.nb?d(n):n),l+=p(f);return l},lk:function(a,b,c){for(;0<=c;c--)h(b[c],a)},qk:function(a){for(var b=a.length-1,c;0<=b;b--)0===a[b].children.length?0<b?(c=a[b-1].children,c.splice(c.indexOf(a[b]),1)):this.clear():f(a[b],
this.Db)},sk:function(a){var b=["return a"," - b",";"];this.Pf=new Function("a","b",b.join(a[0]));this.Qf=new Function("a","b",b.join(a[1]));this.Db=new Function("a","return {minX: a"+a[0]+", minY: a"+a[1]+", maxX: a"+a[2]+", maxY: a"+a[3]+"};")}};a["default"]=e})(Op.ge=Op.ge||{});Op.ge=Op.ge.default;function Ns(a){this.a=Op.ge(a);this.b={}}k=Ns.prototype;k.Ea=function(a,b){a={ba:a[0],ea:a[1],da:a[2],ga:a[3],value:b};this.a.Ea(a);this.b[w(b)]=a};k.load=function(a,b){for(var c=Array(b.length),d=0,e=b.length;d<e;d++){var f=a[d],g=b[d];f={ba:f[0],ea:f[1],da:f[2],ga:f[3],value:g};c[d]=f;this.b[w(g)]=f}this.a.load(c)};k.remove=function(a){a=w(a);var b=this.b[a];delete this.b[a];return null!==this.a.remove(b)};function Os(a,b,c){var d=a.b[w(c)];cb([d.ba,d.ea,d.da,d.ga],b)||(a.remove(c),a.Ea(b,c))}
function Ps(a){return a.a.all().map(function(a){return a.value})}function Qs(a,b){return a.a.search({ba:b[0],ea:b[1],da:b[2],ga:b[3]}).map(function(a){return a.value})}k.forEach=function(a,b){return Rs(Ps(this),a,b)};function Ss(a,b,c,d){return Rs(Qs(a,b),c,d)}function Rs(a,b,c){for(var d,e=0,f=a.length;e<f&&!(d=b.call(c,a[e]));e++);return d}k.clear=function(){this.a.clear();this.b={}};k.G=function(a){var b=this.a.data;return Ya(b.ba,b.ea,b.da,b.ga,a)};
k.concat=function(a){this.a.load(a.a.all());for(var b in a.b)this.b[b|0]=a.b[b|0]};function S(a){a=a||{};Ks.call(this,{attributions:a.attributions,logo:a.logo,projection:void 0,state:"ready",wrapX:void 0!==a.wrapX?a.wrapX:!0});this.s=sa;this.B=a.format;this.U=void 0==a.overlaps?!0:a.overlaps;this.I=a.url;a.loader?this.s=a.loader:void 0!==this.I&&(wa(this.B,7),this.s=el(this.I,this.B));this.fa=a.strategy?a.strategy:Js;var b=void 0!==a.useSpatialIndex?a.useSpatialIndex:!0;this.a=b?new Ns:null;this.T=new Ns;this.g={};this.l={};this.o={};this.v={};this.i=null;if(a.features instanceof
C){var c=a.features;var d=c.a}else Array.isArray(a.features)&&(d=a.features);b||c||(c=new C(d));d&&Ts(this,d);c&&Us(this,c)}v(S,Ks);k=S.prototype;k.Eb=function(a){var b=w(a).toString();if(Vs(this,b,a)){Ws(this,b,a);var c=a.W();c?(b=c.G(),this.a&&this.a.Ea(b,a)):this.g[b]=a;this.b(new Xs("addfeature",a))}this.u()};function Ws(a,b,c){a.v[b]=[z(c,"change",a.aj,a),z(c,"propertychange",a.aj,a)]}
function Vs(a,b,c){var d=!0,e=c.c;void 0!==e?e.toString()in a.l?d=!1:a.l[e.toString()]=c:(wa(!(b in a.o),30),a.o[b]=c);return d}k.Ic=function(a){Ts(this,a);this.u()};function Ts(a,b){var c,d=[],e=[],f=[];var g=0;for(c=b.length;g<c;g++){var h=b[g];var l=w(h).toString();Vs(a,l,h)&&e.push(h)}g=0;for(c=e.length;g<c;g++)h=e[g],l=w(h).toString(),Ws(a,l,h),(b=h.W())?(l=b.G(),d.push(l),f.push(h)):a.g[l]=h;a.a&&a.a.load(d,f);g=0;for(c=e.length;g<c;g++)a.b(new Xs("addfeature",e[g]))}
function Us(a,b){var c=!1;z(a,"addfeature",function(a){c||(c=!0,b.push(a.feature),c=!1)});z(a,"removefeature",function(a){c||(c=!0,b.remove(a.feature),c=!1)});z(b,"add",function(a){c||(c=!0,this.Eb(a.element),c=!1)},a);z(b,"remove",function(a){c||(c=!0,this.Ib(a.element),c=!1)},a);a.i=b}
k.clear=function(a){if(a){for(var b in this.v)this.v[b].forEach(Hc);this.i||(this.v={},this.l={},this.o={})}else if(this.a){this.a.forEach(this.Wg,this);for(var c in this.g)this.Wg(this.g[c])}this.i&&this.i.clear();this.a&&this.a.clear();this.T.clear();this.g={};this.b(new Xs("clear"));this.u()};k.Ih=function(a,b){if(this.a)return this.a.forEach(a,b);if(this.i)return this.i.forEach(a,b)};function Ys(a,b,c){a.ac([b[0],b[1],b[0],b[1]],function(a){if(a.W().yb(b))return c.call(void 0,a)})}
k.ac=function(a,b,c){if(this.a)return Ss(this.a,a,b,c);if(this.i)return this.i.forEach(b,c)};k.Jh=function(a,b,c){return this.ac(a,function(d){if(d.W().Ya(a)&&(d=b.call(c,d)))return d})};k.Qh=function(){return this.i};k.fe=function(){if(this.i)var a=this.i.a;else this.a&&(a=Ps(this.a),wb(this.g)||ja(a,vb(this.g)));return a};k.Ph=function(a){var b=[];Ys(this,a,function(a){b.push(a)});return b};k.Zf=function(a){return Qs(this.a,a)};
k.Lh=function(a,b){var c=a[0],d=a[1],e=null,f=[NaN,NaN],g=Infinity,h=[-Infinity,-Infinity,Infinity,Infinity],l=b?b:Pe;Ss(this.a,h,function(a){if(l(a)){var b=a.W(),m=g;g=b.Mb(c,d,f,g);g<m&&(e=a,a=Math.sqrt(g),h[0]=c-a,h[1]=d-a,h[2]=c+a,h[3]=d+a)}});return e};k.G=function(a){return this.a.G(a)};k.Oh=function(a){a=this.l[a.toString()];return void 0!==a?a:null};k.Zi=function(){return this.B};k.$i=function(){return this.I};
k.aj=function(a){a=a.target;var b=w(a).toString(),c=a.W();c?(c=c.G(),b in this.g?(delete this.g[b],this.a&&this.a.Ea(c,a)):this.a&&Os(this.a,c,a)):b in this.g||(this.a&&this.a.remove(a),this.g[b]=a);c=a.c;void 0!==c?(c=c.toString(),b in this.o?(delete this.o[b],this.l[c]=a):this.l[c]!==a&&(Zs(this,a),this.l[c]=a)):b in this.o||(Zs(this,a),this.o[b]=a);this.u();this.b(new Xs("changefeature",a))};
k.ce=function(a,b,c){var d=this.T;a=this.fa(a,b);var e;var f=0;for(e=a.length;f<e;++f){var g=a[f];Ss(d,g,function(a){return Wa(a.extent,g)})||(this.s.call(this,g,b,c),d.Ea(g,{extent:g.slice()}))}};k.Ib=function(a){var b=w(a).toString();b in this.g?delete this.g[b]:this.a&&this.a.remove(a);this.Wg(a);this.u()};k.Wg=function(a){var b=w(a).toString();this.v[b].forEach(Hc);delete this.v[b];var c=a.c;void 0!==c?delete this.l[c.toString()]:delete this.o[b];this.b(new Xs("removefeature",a))};
function Zs(a,b){for(var c in a.l)if(a.l[c]===b){delete a.l[c];break}}k.bj=function(a){this.s=a};function Xs(a,b){Rc.call(this,a);this.feature=b}v(Xs,Rc);function $s(a){Tg.call(this,{handleDownEvent:at,handleEvent:bt,handleUpEvent:ct});this.U=!1;this.fa=null;this.s=!1;this.Lb=a.source?a.source:null;this.ab=a.features?a.features:null;this.Hk=a.snapTolerance?a.snapTolerance:12;this.T=a.type;this.g=dt(this.T);this.Va=a.minPoints?a.minPoints:this.g===et?3:2;this.oa=a.maxPoints?a.maxPoints:Infinity;this.Jd=a.finishCondition?a.finishCondition:Pe;var b=a.geometryFunction;if(!b)if("Circle"===this.T)b=function(a,b){b=b?b:new es([NaN,NaN]);b.fh(a[0],Math.sqrt(Ge(a[0],
a[1])));return b};else{var c,d=this.g;d===ft?c=D:d===gt?c=M:d===et&&(c=E);b=function(a,b){b?d===et?b.na([a[0].concat([a[0][0]])]):b.na(a):b=new c(a);return b}}this.Za=b;this.I=this.D=this.a=this.B=this.j=this.o=null;this.gd=a.clickTolerance?a.clickTolerance*a.clickTolerance:36;this.ma=new R({source:new S({useSpatialIndex:!1,wrapX:a.wrapX?a.wrapX:!1}),style:a.style?a.style:ht()});this.ub=a.geometryName;this.Gk=a.condition?a.condition:Og;this.If=a.freehand?Pe:a.freehandCondition?a.freehandCondition:
Pg;z(this,Yc("active"),this.Hi,this)}v($s,Tg);function ht(){var a=Jk();return function(b){return a[b.W().S()]}}k=$s.prototype;k.setMap=function(a){Tg.prototype.setMap.call(this,a);this.Hi()};function bt(a){this.s=this.g!==ft&&this.If(a);var b=!0;this.s&&"pointerdrag"===a.type&&null!==this.j?(it(this,a),b=!1):this.s&&"pointerdown"===a.type?b=!1:"pointermove"===a.type?b=jt(this,a):"dblclick"===a.type&&(b=!1);return Ug.call(this,a)&&b}
function at(a){this.U=!this.s;return this.s?(this.fa=a.pixel,this.o||kt(this,a),!0):this.Gk(a)?(this.fa=a.pixel,!0):!1}function ct(a){var b=!0;jt(this,a);var c=this.g===lt;this.U?(this.o?this.s||c?this.Td():mt(this,a)?this.Jd(a)&&this.Td():it(this,a):(kt(this,a),this.g===ft&&this.Td()),b=!1):this.s&&(this.o=null,nt(this));return b}
function jt(a,b){if(a.fa&&(!a.s&&a.U||a.s&&!a.U)){var c=a.fa,d=b.pixel,e=c[0]-d[0];c=c[1]-d[1];e=e*e+c*c;a.U=a.s?e>a.gd:e<=a.gd}a.o?(e=b.coordinate,c=a.j.W(),a.g===ft?d=a.a:a.g===et?(d=a.a[0],d=d[d.length-1],mt(a,b)&&(e=a.o.slice())):(d=a.a,d=d[d.length-1]),d[0]=e[0],d[1]=e[1],a.Za(a.a,c),a.B&&a.B.W().na(e),c instanceof E&&a.g!==et?(a.D||(a.D=new Kk(new M(null))),e=c.Sh(0),b=a.D.W(),b.aa(e.ja,e.ca())):a.I&&(b=a.D.W(),b.na(a.I)),ot(a)):(b=b.coordinate.slice(),a.B?a.B.W().na(b):(a.B=new Kk(new D(b)),
ot(a)));return!0}function mt(a,b){var c=!1;if(a.j){var d=!1,e=[a.o];a.g===gt?d=a.a.length>a.Va:a.g===et&&(d=a.a[0].length>a.Va,e=[a.a[0][0],a.a[0][a.a[0].length-2]]);if(d){d=b.map;for(var f=0,g=e.length;f<g;f++){var h=e[f],l=d.Ha(h),m=b.pixel;c=m[0]-l[0];l=m[1]-l[1];if(c=Math.sqrt(c*c+l*l)<=(a.s?1:a.Hk)){a.o=h;break}}}}return c}
function kt(a,b){b=b.coordinate;a.o=b;a.g===ft?a.a=b.slice():a.g===et?(a.a=[[b.slice(),b.slice()]],a.I=a.a[0]):(a.a=[b.slice(),b.slice()],a.g===lt&&(a.I=a.a));a.I&&(a.D=new Kk(new M(a.I)));b=a.Za(a.a);a.j=new Kk;a.ub&&a.j.Zc(a.ub);a.j.Sa(b);ot(a);a.b(new pt("drawstart",a.j))}
function it(a,b){b=b.coordinate;var c=a.j.W(),d;if(a.g===gt){a.o=b.slice();var e=a.a;e.length>=a.oa&&(a.s?e.pop():d=!0);e.push(b.slice());a.Za(e,c)}else a.g===et&&(e=a.a[0],e.length>=a.oa&&(a.s?e.pop():d=!0),e.push(b.slice()),d&&(a.o=e[0]),a.Za(a.a,c));ot(a);d&&a.Td()}
k.Up=function(){if(this.j){var a=this.j.W();if(this.g===gt){var b=this.a;b.splice(-2,1);this.Za(b,a);2<=b.length&&(this.o=b[b.length-2].slice())}else if(this.g===et){b=this.a[0];b.splice(-2,1);var c=this.D.W();c.na(b);this.Za(this.a,a)}0===b.length&&(this.o=null);ot(this)}};
k.Td=function(){var a=nt(this),b=this.a,c=a.W();this.g===gt?(b.pop(),this.Za(b,c)):this.g===et&&(b[0].pop(),this.Za(b,c),b=c.V());"MultiPoint"===this.T?a.Sa(new ql([b])):"MultiLineString"===this.T?a.Sa(new O([b])):"MultiPolygon"===this.T&&a.Sa(new P([b]));this.b(new pt("drawend",a));this.ab&&this.ab.push(a);this.Lb&&this.Lb.Eb(a)};function nt(a){a.o=null;var b=a.j;b&&(a.j=null,a.B=null,a.D=null,a.ma.ia().clear(!0));return b}
k.Fn=function(a){var b=a.W();this.j=a;this.a=b.V();a=this.a[this.a.length-1];this.o=a.slice();this.a.push(a.slice());ot(this);this.b(new pt("drawstart",this.j))};k.cd=Qe;function ot(a){var b=[];a.j&&b.push(a.j);a.D&&b.push(a.D);a.B&&b.push(a.B);a=a.ma.ia();a.clear(!0);a.Ic(b)}k.Hi=function(){var a=this.v,b=this.c();a&&b||nt(this);this.ma.setMap(b?a:null)};
function dt(a){var b;"Point"===a||"MultiPoint"===a?b=ft:"LineString"===a||"MultiLineString"===a?b=gt:"Polygon"===a||"MultiPolygon"===a?b=et:"Circle"===a&&(b=lt);return b}var ft="Point",gt="LineString",et="Polygon",lt="Circle";function pt(a,b){Rc.call(this,a);this.feature=b}v(pt,Rc);function qt(a){this.a=this.j=null;this.D=!1;this.B=this.o=null;a||(a={});Tg.call(this,{handleDownEvent:rt,handleDragEvent:st,handleEvent:tt,handleUpEvent:ut});this.s=new R({source:new S({useSpatialIndex:!1,wrapX:!!a.wrapX}),style:a.boxStyle?a.boxStyle:vt(),updateWhileAnimating:!0,updateWhileInteracting:!0});this.I=new R({source:new S({useSpatialIndex:!1,wrapX:!!a.wrapX}),style:a.pointerStyle?a.pointerStyle:wt(),updateWhileAnimating:!0,updateWhileInteracting:!0});a.extent&&this.g(a.extent)}v(qt,Tg);
function tt(a){if(!(a instanceof Dd))return!0;if("pointermove"==a.type&&!this.C){var b=a.pixel,c=a.map,d=xt(this,b,c);d||(d=c.Na(b));yt(this,d)}Ug.call(this,a);return!1}
function rt(a){function b(a){var b=null,c=null;a[0]==e[0]?b=e[2]:a[0]==e[2]&&(b=e[0]);a[1]==e[1]?c=e[3]:a[1]==e[3]&&(c=e[1]);return null!==b&&null!==c?[b,c]:null}var c=a.pixel,d=a.map,e=this.G();(a=xt(this,c,d))&&e?(c=a[0]==e[0]||a[0]==e[2]?a[0]:null,d=a[1]==e[1]||a[1]==e[3]?a[1]:null,null!==c&&null!==d?this.a=zt(b(a)):null!==c?this.a=At(b([c,e[1]]),b([c,e[3]])):null!==d&&(this.a=At(b([e[0],d]),b([e[2],d])))):(a=d.Na(c),this.g([a[0],a[1],a[0],a[1]]),this.a=zt(a));return!0}
function st(a){this.a&&(a=a.coordinate,this.g(this.a(a)),yt(this,a));return!0}function ut(){this.a=null;var a=this.G();a&&0!==jb(a)||this.g(null);return!1}function vt(){var a=Jk();return function(){return a.Polygon}}function wt(){var a=Jk();return function(){return a.Point}}function zt(a){return function(b){return Oa([a,b])}}function At(a,b){return a[0]==b[0]?function(c){return Oa([a,[c[0],b[1]]])}:a[1]==b[1]?function(c){return Oa([a,[b[0],c[1]]])}:null}
function xt(a,b,c){function d(a,b){return Ie(e,a)-Ie(e,b)}var e=c.Na(b),f=a.G();if(f){f=[[[f[0],f[1]],[f[0],f[3]]],[[f[0],f[3]],[f[2],f[3]]],[[f[2],f[3]],[f[2],f[1]]],[[f[2],f[1]],[f[0],f[1]]]];f.sort(d);f=f[0];var g=Ae(e,f),h=c.Ha(g);if(10>=He(b,h))return b=c.Ha(f[0]),c=c.Ha(f[1]),b=Ge(h,b),c=Ge(h,c),a.D=10>=Math.sqrt(Math.min(b,c)),a.D&&(g=b>c?f[1]:f[0]),g}return null}function yt(a,b){var c=a.B;c?c.W().na(b):(c=new Kk(new D(b)),a.B=c,a.I.ia().Eb(c))}
qt.prototype.setMap=function(a){this.s.setMap(a);this.I.setMap(a);Tg.prototype.setMap.call(this,a)};qt.prototype.G=function(){return this.j};qt.prototype.g=function(a){this.j=a?a:null;var b=this.o;b?a?b.Sa(Rf(a)):b.Sa(void 0):(this.o=b=a?new Kk(Rf(a)):new Kk({}),this.s.ia().Eb(b));this.b(new Bt(this.j))};function Bt(a){Rc.call(this,"extentchanged");this.extent=a}v(Bt,Rc);function Ct(a){Tg.call(this,{handleDownEvent:Dt,handleDragEvent:Et,handleEvent:Ft,handleUpEvent:Gt});this.Jd=a.condition?a.condition:Sg;this.ub=function(a){return Jg(a)&&Ng(a)};this.Lb=a.deleteCondition?a.deleteCondition:this.ub;this.gd=a.insertVertexCondition?a.insertVertexCondition:Pe;this.ab=this.g=null;this.Va=[0,0];this.D=this.I=!1;this.a=new Ns;this.ma=void 0!==a.pixelTolerance?a.pixelTolerance:10;this.o=this.oa=!1;this.j=[];this.B=new R({source:new S({useSpatialIndex:!1,wrapX:!!a.wrapX}),style:a.style?
a.style:Ht(),updateWhileAnimating:!0,updateWhileInteracting:!0});this.fa={Point:this.Nn,LineString:this.Ji,LinearRing:this.Ji,Polygon:this.On,MultiPoint:this.Ln,MultiLineString:this.Kn,MultiPolygon:this.Mn,Circle:this.In,GeometryCollection:this.Jn};this.U=null;a.source?(this.U=a.source,a=new C(this.U.fe()),z(this.U,"addfeature",this.bm,this),z(this.U,"removefeature",this.dm,this)):a=a.features;if(!a)throw Error("The modify interaction requires features or a source");this.s=a;this.s.forEach(this.wg,
this);z(this.s,"add",this.Gn,this);z(this.s,"remove",this.Hn,this);this.T=null}v(Ct,Tg);k=Ct.prototype;k.wg=function(a){var b=a.W();b&&b.S()in this.fa&&this.fa[b.S()].call(this,a,b);(b=this.v)&&b.c&&this.c()&&It(this,this.Va,b);z(a,"change",this.Ii,this)};function Jt(a,b){a.D||(a.D=!0,a.b(new Kt("modifystart",a.s,b)))}function Lt(a,b){Mt(a,b);a.g&&0===a.s.gc()&&(a.B.ia().Ib(a.g),a.g=null);Nc(b,"change",a.Ii,a)}
function Mt(a,b){a=a.a;var c=[];a.forEach(function(a){b===a.feature&&c.push(a)});for(var d=c.length-1;0<=d;--d)a.remove(c[d])}k.Ga=function(a){this.g&&!a&&(this.B.ia().Ib(this.g),this.g=null);Tg.prototype.Ga.call(this,a)};k.setMap=function(a){this.B.setMap(a);Tg.prototype.setMap.call(this,a)};k.bm=function(a){a.feature&&this.s.push(a.feature)};k.dm=function(a){a.feature&&this.s.remove(a.feature)};k.Gn=function(a){this.wg(a.element)};k.Ii=function(a){this.o||(a=a.target,Lt(this,a),this.wg(a))};
k.Hn=function(a){Lt(this,a.element)};k.Nn=function(a,b){var c=b.V();a={feature:a,geometry:b,la:[c,c]};this.a.Ea(b.G(),a)};k.Ln=function(a,b){var c=b.V(),d;var e=0;for(d=c.length;e<d;++e){var f=c[e];f={feature:a,geometry:b,depth:[e],index:e,la:[f,f]};this.a.Ea(b.G(),f)}};k.Ji=function(a,b){var c=b.V(),d;var e=0;for(d=c.length-1;e<d;++e){var f=c.slice(e,e+2);var g={feature:a,geometry:b,index:e,la:f};this.a.Ea(Oa(f),g)}};
k.Kn=function(a,b){var c=b.V(),d,e;var f=0;for(e=c.length;f<e;++f){var g=c[f];var h=0;for(d=g.length-1;h<d;++h){var l=g.slice(h,h+2);var m={feature:a,geometry:b,depth:[f],index:h,la:l};this.a.Ea(Oa(l),m)}}};k.On=function(a,b){var c=b.V(),d,e;var f=0;for(e=c.length;f<e;++f){var g=c[f];var h=0;for(d=g.length-1;h<d;++h){var l=g.slice(h,h+2);var m={feature:a,geometry:b,depth:[f],index:h,la:l};this.a.Ea(Oa(l),m)}}};
k.Mn=function(a,b){var c=b.V(),d,e,f;var g=0;for(f=c.length;g<f;++g){var h=c[g];var l=0;for(e=h.length;l<e;++l){var m=h[l];var n=0;for(d=m.length-1;n<d;++n){var p=m.slice(n,n+2);var q={feature:a,geometry:b,depth:[l,g],index:n,la:p};this.a.Ea(Oa(p),q)}}}};k.In=function(a,b){var c=b.xa(),d={feature:a,geometry:b,index:0,la:[c,c]};a={feature:a,geometry:b,index:1,la:[c,c]};d.Tf=a.Tf=[d,a];this.a.Ea($a(c),d);this.a.Ea(b.G(),a)};
k.Jn=function(a,b){var c=b.a;for(b=0;b<c.length;++b)this.fa[c[b].S()].call(this,a,c[b])};function Nt(a,b){var c=a.g;c?c.W().na(b):(c=new Kk(new D(b)),a.g=c,a.B.ia().Eb(c))}function Ot(a,b){return a.index-b.index}
function Dt(a){if(!this.Jd(a))return!1;It(this,a.pixel,a.map);var b=a.map.Na(a.pixel);this.j.length=0;this.D=!1;var c=this.g;if(c){var d=[];c=c.W().V();var e=Oa([c]);e=Qs(this.a,e);var f={};e.sort(Ot);for(var g=0,h=e.length;g<h;++g){var l=e[g],m=l.la,n=w(l.feature),p=l.depth;p&&(n+="-"+p.join("-"));f[n]||(f[n]=Array(2));if("Circle"===l.geometry.S()&&1===l.index)m=Pt(b,l),De(m,c)&&!f[n][0]&&(this.j.push([l,0]),f[n][0]=l);else if(De(m[0],c)&&!f[n][0])this.j.push([l,0]),f[n][0]=l;else if(De(m[1],c)&&
!f[n][1]){if("LineString"!==l.geometry.S()&&"MultiLineString"!==l.geometry.S()||!f[n][0]||0!==f[n][0].index)this.j.push([l,1]),f[n][1]=l}else this.gd(a)&&w(m)in this.ab&&!f[n][0]&&!f[n][1]&&d.push([l,c])}d.length&&Jt(this,a);for(a=d.length-1;0<=a;--a)this.km.apply(this,d[a])}return!!this.g}
function Et(a){this.I=!1;Jt(this,a);a=a.coordinate;for(var b=0,c=this.j.length;b<c;++b){var d=this.j[b],e=d[0],f=e.depth,g=e.geometry,h=e.la;for(d=d[1];a.length<g.pa();)a.push(h[d][a.length]);switch(g.S()){case "Point":var l=a;h[0]=h[1]=a;break;case "MultiPoint":l=g.V();l[e.index]=a;h[0]=h[1]=a;break;case "LineString":l=g.V();l[e.index+d]=a;h[d]=a;break;case "MultiLineString":l=g.V();l[f[0]][e.index+d]=a;h[d]=a;break;case "Polygon":l=g.V();l[f[0]][e.index+d]=a;h[d]=a;break;case "MultiPolygon":l=g.V();
l[f[1]][f[0]][e.index+d]=a;h[d]=a;break;case "Circle":h[0]=h[1]=a,0===e.index?(this.o=!0,g.rb(a)):(this.o=!0,g.$c(He(g.xa(),a))),this.o=!1}l&&(e=g,f=l,this.o=!0,e.na(f),this.o=!1)}Nt(this,a)}function Gt(a){for(var b,c,d=this.j.length-1;0<=d;--d)if(b=this.j[d][0],c=b.geometry,"Circle"===c.S()){var e=c.xa(),f=b.Tf[0];b=b.Tf[1];f.la[0]=f.la[1]=e;b.la[0]=b.la[1]=e;Os(this.a,$a(e),f);Os(this.a,c.G(),b)}else Os(this.a,Oa(b.la),b);this.D&&(this.b(new Kt("modifyend",this.s,a)),this.D=!1);return!1}
function Ft(a){if(!(a instanceof Dd))return!0;this.T=a;var b;Yf(a.map.$())[1]||"pointermove"!=a.type||this.C||(this.Va=a.pixel,It(this,a.pixel,a.map));this.g&&this.Lb(a)&&(b="singleclick"==a.type&&this.I?!0:this.vj());"singleclick"==a.type&&(this.I=!1);return Ug.call(this,a)&&!b}
function It(a,b,c){function d(a,b){return Qt(e,a)-Qt(e,b)}var e=c.Na(b),f=Ra($a(e),c.$().Oa()*a.ma);f=Qs(a.a,f);if(0<f.length){f.sort(d);var g=f[0],h=g.la,l=Pt(e,g),m=c.Ha(l),n=He(b,m);if(n<=a.ma){b={};if("Circle"===g.geometry.S()&&1===g.index)a.oa=!0,Nt(a,l);else for(n=c.Ha(h[0]),g=c.Ha(h[1]),c=Ge(m,n),m=Ge(m,g),n=Math.sqrt(Math.min(c,m)),a.oa=n<=a.ma,a.oa&&(l=c>m?h[1]:h[0]),Nt(a,l),m=1,c=f.length;m<c;++m)if(l=f[m].la,De(h[0],l[0])&&De(h[1],l[1])||De(h[0],l[1])&&De(h[1],l[0]))b[w(l)]=!0;else break;
b[w(h)]=!0;a.ab=b;return}}a.g&&(a.B.ia().Ib(a.g),a.g=null)}function Qt(a,b){var c=b.geometry;return"Circle"===c.S()&&1===b.index?(a=Ge(c.xa(),a),c=Math.sqrt(a)-c.xd(),c*c):Ie(a,b.la)}function Pt(a,b){var c=b.geometry;return"Circle"===c.S()&&1===b.index?c.Gb(a):Ae(a,b.la)}
k.km=function(a,b){for(var c=a.la,d=a.feature,e=a.geometry,f=a.depth,g=a.index,h;b.length<e.pa();)b.push(0);switch(e.S()){case "MultiLineString":h=e.V();h[f[0]].splice(g+1,0,b);break;case "Polygon":h=e.V();h[f[0]].splice(g+1,0,b);break;case "MultiPolygon":h=e.V();h[f[1]][f[0]].splice(g+1,0,b);break;case "LineString":h=e.V();h.splice(g+1,0,b);break;default:return}this.o=!0;e.na(h);this.o=!1;h=this.a;h.remove(a);Rt(this,e,g,f,1);a={la:[c[0],b],feature:d,geometry:e,depth:f,index:g};h.Ea(Oa(a.la),a);
this.j.push([a,1]);b={la:[b,c[1]],feature:d,geometry:e,depth:f,index:g+1};h.Ea(Oa(b.la),b);this.j.push([b,0]);this.I=!0};
k.vj=function(){if(this.T&&"pointerdrag"!=this.T.type){var a=this.T;Jt(this,a);var b=this.j,c={},d,e;for(e=b.length-1;0<=e;--e){var f=b[e];var g=f[0];var h=w(g.feature);g.depth&&(h+="-"+g.depth.join("-"));h in c||(c[h]={});0===f[1]?(c[h].right=g,c[h].index=g.index):1==f[1]&&(c[h].left=g,c[h].index=g.index+1)}for(h in c){var l=c[h].right;var m=c[h].left;e=c[h].index;var n=e-1;g=void 0!==m?m:l;0>n&&(n=0);f=g.geometry;var p=d=f.V();var q=!1;switch(f.S()){case "MultiLineString":2<d[g.depth[0]].length&&
(d[g.depth[0]].splice(e,1),q=!0);break;case "LineString":2<d.length&&(d.splice(e,1),q=!0);break;case "MultiPolygon":p=p[g.depth[1]];case "Polygon":p=p[g.depth[0]],4<p.length&&(e==p.length-1&&(e=0),p.splice(e,1),q=!0,0===e&&(p.pop(),p.push(p[0]),n=p.length-1))}q&&(q=f,this.o=!0,q.na(d),this.o=!1,d=[],void 0!==m&&(this.a.remove(m),d.push(m.la[0])),void 0!==l&&(this.a.remove(l),d.push(l.la[1])),void 0!==m&&void 0!==l&&(m={depth:g.depth,feature:g.feature,geometry:g.geometry,index:n,la:d},this.a.Ea(Oa(m.la),
m)),Rt(this,f,e,g.depth,-1),this.g&&(this.B.ia().Ib(this.g),this.g=null),b.length=0)}this.b(new Kt("modifyend",this.s,a));this.D=!1;return!0}return!1};function Rt(a,b,c,d,e){Ss(a.a,b.G(),function(a){a.geometry===b&&(void 0===d||void 0===a.depth||ma(a.depth,d))&&a.index>c&&(a.index+=e)})}function Ht(){var a=Jk();return function(){return a.Point}}function Kt(a,b,c){Rc.call(this,a);this.features=b;this.mapBrowserEvent=c}v(Kt,Rc);function St(a){Bg.call(this,{handleEvent:Tt});a=a?a:{};this.D=a.condition?a.condition:Ng;this.C=a.addCondition?a.addCondition:Qe;this.B=a.removeCondition?a.removeCondition:Qe;this.I=a.toggleCondition?a.toggleCondition:Pg;this.o=a.multi?a.multi:!1;this.l=a.filter?a.filter:Pe;this.j=a.hitTolerance?a.hitTolerance:0;this.g=new R({source:new S({useSpatialIndex:!1,features:a.features,wrapX:a.wrapX}),style:a.style?a.style:Ut(),updateWhileAnimating:!0,updateWhileInteracting:!0});if(a.layers)if("function"===
typeof a.layers)a=a.layers;else{var b=a.layers;a=function(a){return ha(b,a)}}else a=Pe;this.s=a;this.a={};a=this.g.ia().i;z(a,"add",this.Pn,this);z(a,"remove",this.Tn,this)}v(St,Bg);k=St.prototype;k.Qn=function(){return this.g.ia().i};k.Rn=function(){return this.j};k.Sn=function(a){a=w(a);return this.a[a]};
function Tt(a){if(!this.D(a))return!0;var b=this.C(a),c=this.B(a),d=this.I(a),e=!b&&!c&&!d,f=a.map,g=this.g.ia().i,h=[],l=[];if(e){ub(this.a);f.Mc(a.pixel,function(a,b){if(this.l(a,b))return l.push(a),a=w(a),this.a[a]=b,!this.o}.bind(this),{layerFilter:this.s,hitTolerance:this.j});for(e=g.gc()-1;0<=e;--e){f=g.item(e);var m=l.indexOf(f);-1<m?l.splice(m,1):(g.remove(f),h.push(f))}0!==l.length&&g.pg(l)}else{f.Mc(a.pixel,function(a,e){if(this.l(a,e))return!b&&!d||ha(g.a,a)?(c||d)&&ha(g.a,a)&&(h.push(a),
e=w(a),delete this.a[e]):(l.push(a),a=w(a),this.a[a]=e),!this.o}.bind(this),{layerFilter:this.s,hitTolerance:this.j});for(e=h.length-1;0<=e;--e)g.remove(h[e]);g.pg(l)}(0<l.length||0<h.length)&&this.b(new Vt(Wt,l,h,a));return Mg(a)}k.Un=function(a){this.j=a};k.setMap=function(a){var b=this.v,c=this.g.ia().i;b&&c.forEach(b.Rj,b);Bg.prototype.setMap.call(this,a);this.g.setMap(a);a&&c.forEach(a.Mj,a)};
function Ut(){var a=Jk();ja(a.Polygon,a.LineString);ja(a.GeometryCollection,a.LineString);return function(b){return b.W()?a[b.W().S()]:null}}k.Pn=function(a){var b=this.v;b&&b.Mj(a.element)};k.Tn=function(a){var b=this.v;b&&b.Rj(a.element)};function Vt(a,b,c,d){Rc.call(this,a);this.selected=b;this.deselected=c;this.mapBrowserEvent=d}v(Vt,Rc);var Wt="select";function Xt(a){Tg.call(this,{handleEvent:Yt,handleDownEvent:Pe,handleUpEvent:Zt});a=a?a:{};this.o=a.source?a.source:null;this.T=void 0!==a.vertex?a.vertex:!0;this.D=void 0!==a.edge?a.edge:!0;this.j=a.features?a.features:null;this.ma=[];this.B={};this.U={};this.s={};this.I=null;this.g=void 0!==a.pixelTolerance?a.pixelTolerance:10;this.oa=$t.bind(this);this.a=new Ns;this.fa={Point:this.ao,LineString:this.Mi,LinearRing:this.Mi,Polygon:this.bo,MultiPoint:this.Zn,MultiLineString:this.Yn,MultiPolygon:this.$n,
GeometryCollection:this.Xn,Circle:this.Wn}}v(Xt,Tg);k=Xt.prototype;k.Eb=function(a,b){b=void 0!==b?b:!0;var c=w(a),d=a.W();if(d){var e=this.fa[d.S()];e&&(this.U[c]=d.G(Pa()),e.call(this,a,d))}b&&(this.B[c]=z(a,"change",this.Vn,this))};k.Lk=function(a){this.Eb(a)};k.Mk=function(a){this.Ib(a)};k.Ki=function(a){if(a instanceof Xs)var b=a.feature;else a instanceof dd&&(b=a.element);this.Eb(b)};k.Li=function(a){if(a instanceof Xs)var b=a.feature;else a instanceof dd&&(b=a.element);this.Ib(b)};
k.Vn=function(a){a=a.target;if(this.C){var b=w(a);b in this.s||(this.s[b]=a)}else this.Sj(a)};k.Ib=function(a,b){b=void 0!==b?b:!0;var c=w(a),d=this.U[c];if(d){var e=this.a,f=[];Ss(e,d,function(b){a===b.feature&&f.push(b)});for(d=f.length-1;0<=d;--d)e.remove(f[d])}b&&(Hc(this.B[c]),delete this.B[c])};
k.setMap=function(a){var b=this.v,c=this.ma,d;this.j?d=this.j:this.o&&(d=this.o.fe());b&&(c.forEach(Hc),c.length=0,d.forEach(this.Mk,this));Tg.prototype.setMap.call(this,a);a&&(this.j?c.push(z(this.j,"add",this.Ki,this),z(this.j,"remove",this.Li,this)):this.o&&c.push(z(this.o,"addfeature",this.Ki,this),z(this.o,"removefeature",this.Li,this)),d.forEach(this.Lk,this))};k.cd=Qe;
function au(a,b,c,d){var e=d.Na([b[0]-a.g,b[1]+a.g]),f=d.Na([b[0]+a.g,b[1]-a.g]);e=Oa([e,f]);var g=Qs(a.a,e);a.T&&!a.D&&(g=g.filter(function(a){return"Circle"!==a.feature.W().S()}));var h=!1;e=!1;var l=f=null;if(0<g.length){a.I=c;g.sort(a.oa);var m=g[0].la;h="Circle"===g[0].feature.W().S();if(a.T&&!a.D){if(c=d.Ha(m[0]),h=d.Ha(m[1]),c=Ge(b,c),b=Ge(b,h),h=Math.sqrt(Math.min(c,b)),h=h<=a.g)e=!0,f=c>b?m[1]:m[0],l=d.Ha(f)}else a.D&&(f=h?ze(c,g[0].feature.W()):Ae(c,m),l=d.Ha(f),He(b,l)<=a.g&&(e=!0,a.T&&
!h&&(c=d.Ha(m[0]),h=d.Ha(m[1]),c=Ge(l,c),b=Ge(l,h),h=Math.sqrt(Math.min(c,b)),h=h<=a.g)))&&(f=c>b?m[1]:m[0],l=d.Ha(f));e&&(l=[Math.round(l[0]),Math.round(l[1])])}return{qq:e,vertex:f,zq:l}}k.Sj=function(a){this.Ib(a,!1);this.Eb(a,!1)};k.Wn=function(a,b){b=Sf(b).V()[0];var c;var d=0;for(c=b.length-1;d<c;++d){var e=b.slice(d,d+2);var f={feature:a,la:e};this.a.Ea(Oa(e),f)}};k.Xn=function(a,b){var c=b.a;for(b=0;b<c.length;++b){var d=this.fa[c[b].S()];d&&d.call(this,a,c[b])}};
k.Mi=function(a,b){b=b.V();var c;var d=0;for(c=b.length-1;d<c;++d){var e=b.slice(d,d+2);var f={feature:a,la:e};this.a.Ea(Oa(e),f)}};k.Yn=function(a,b){b=b.V();var c,d;var e=0;for(d=b.length;e<d;++e){var f=b[e];var g=0;for(c=f.length-1;g<c;++g){var h=f.slice(g,g+2);var l={feature:a,la:h};this.a.Ea(Oa(h),l)}}};k.Zn=function(a,b){var c=b.V(),d;var e=0;for(d=c.length;e<d;++e){var f=c[e];f={feature:a,la:[f,f]};this.a.Ea(b.G(),f)}};
k.$n=function(a,b){b=b.V();var c,d,e;var f=0;for(e=b.length;f<e;++f){var g=b[f];var h=0;for(d=g.length;h<d;++h){var l=g[h];var m=0;for(c=l.length-1;m<c;++m){var n=l.slice(m,m+2);var p={feature:a,la:n};this.a.Ea(Oa(n),p)}}}};k.ao=function(a,b){var c=b.V();a={feature:a,la:[c,c]};this.a.Ea(b.G(),a)};k.bo=function(a,b){b=b.V();var c,d;var e=0;for(d=b.length;e<d;++e){var f=b[e];var g=0;for(c=f.length-1;g<c;++g){var h=f.slice(g,g+2);var l={feature:a,la:h};this.a.Ea(Oa(h),l)}}};
function Yt(a){var b=au(this,a.pixel,a.coordinate,a.map);b.qq&&(a.coordinate=b.vertex.slice(0,2),a.pixel=b.zq);return Ug.call(this,a)}function Zt(){var a=vb(this.s);a.length&&(a.forEach(this.Sj,this),this.s={});return!1}function $t(a,b){return Ie(this.I,a.la)-Ie(this.I,b.la)};function bu(a){Tg.call(this,{handleDownEvent:cu,handleDragEvent:du,handleMoveEvent:eu,handleUpEvent:fu});a=a?a:{};this.a=null;this.j=void 0!==a.features?a.features:null;if(a.layers)if("function"===typeof a.layers)var b=a.layers;else{var c=a.layers;b=function(a){return ha(c,a)}}else b=Pe;this.D=b;this.o=a.hitTolerance?a.hitTolerance:0;this.g=null;z(this,Yc("active"),this.s,this)}v(bu,Tg);
function cu(a){this.g=gu(this,a.pixel,a.map);if(!this.a&&this.g){this.a=a.coordinate;eu.call(this,a);var b=this.j||new C([this.g]);this.b(new hu("translatestart",b,a.coordinate));return!0}return!1}function fu(a){if(this.a){this.a=null;eu.call(this,a);var b=this.j||new C([this.g]);this.b(new hu("translateend",b,a.coordinate));return!0}return!1}
function du(a){if(this.a){a=a.coordinate;var b=a[0]-this.a[0],c=a[1]-this.a[1],d=this.j||new C([this.g]);d.forEach(function(a){var d=a.W();d.translate(b,c);a.Sa(d)});this.a=a;this.b(new hu("translating",d,a))}}function eu(a){var b=a.map.a;gu(this,a.pixel,a.map)?(b.classList.remove(this.a?"ol-grab":"ol-grabbing"),b.classList.add(this.a?"ol-grabbing":"ol-grab")):b.classList.remove("ol-grab","ol-grabbing")}
function gu(a,b,c){return c.Mc(b,function(a){if(!this.j||ha(this.j.a,a))return a}.bind(a),{layerFilter:a.D,hitTolerance:a.o})}bu.prototype.B=function(){return this.o};bu.prototype.I=function(a){this.o=a};bu.prototype.setMap=function(a){var b=this.v;Tg.prototype.setMap.call(this,a);iu(this,b)};bu.prototype.s=function(){iu(this,null)};function iu(a,b){var c=a.v;a=a.c();c&&a||(c=c||b)&&c.a.classList.remove("ol-grab","ol-grabbing")}
function hu(a,b,c){Rc.call(this,a);this.features=b;this.coordinate=c}v(hu,Rc);function V(a){a=a?a:{};var b=tb({},a);delete b.gradient;delete b.radius;delete b.blur;delete b.shadow;delete b.weight;R.call(this,b);this.c=null;this.T=void 0!==a.shadow?a.shadow:250;this.B=void 0;this.v=null;z(this,Yc(ju),this.Jl,this);this.Dj(a.gradient?a.gradient:ku);this.xj(void 0!==a.blur?a.blur:15);this.$c(void 0!==a.radius?a.radius:8);z(this,Yc(lu),this.mg,this);z(this,Yc(mu),this.mg,this);this.mg();var c=a.weight?a.weight:"weight",d;"string"===typeof c?d=function(a){return a.get(c)}:d=c;this.j(function(a){a=
d(a);a=void 0!==a?Da(a,0,1):1;var b=255*a|0,c=this.v[b];c||(c=[new Ek({image:new Gn({opacity:a,src:this.B})})],this.v[b]=c);return c}.bind(this));this.set(Bj,null);z(this,"render",this.$l,this)}v(V,R);var ku=["#00f","#0ff","#0f0","#ff0","#f00"];k=V.prototype;k.Kh=function(){return this.get(lu)};k.Rh=function(){return this.get(ju)};k.Oi=function(){return this.get(mu)};
k.Jl=function(){for(var a=this.Rh(),b=dg(1,256),c=b.createLinearGradient(0,0,1,256),d=1/(a.length-1),e=0,f=a.length;e<f;++e)c.addColorStop(e*d,a[e]);b.fillStyle=c;b.fillRect(0,0,1,256);this.c=b.getImageData(0,0,1,256).data};k.mg=function(){var a=this.Oi(),b=this.Kh(),c=a+b+1,d=2*c;d=dg(d,d);d.shadowOffsetX=d.shadowOffsetY=this.T;d.shadowBlur=b;d.shadowColor="#000";d.beginPath();b=c-this.T;d.arc(b,b,a,0,2*Math.PI,!0);d.fill();this.B=d.canvas.toDataURL();this.v=Array(256);this.u()};
k.$l=function(a){a=a.context;var b=a.canvas;b=a.getImageData(0,0,b.width,b.height);var c=b.data,d,e;var f=0;for(d=c.length;f<d;f+=4)if(e=4*c[f+3])c[f]=this.c[e],c[f+1]=this.c[e+1],c[f+2]=this.c[e+2];a.putImageData(b,0,0)};k.xj=function(a){this.set(lu,a)};k.Dj=function(a){this.set(ju,a)};k.$c=function(a){this.set(mu,a)};var lu="blur",ju="gradient",mu="radius";function nu(a){wi.call(this,a?a:{});this.type="IMAGE"}v(nu,wi);function ou(a){a=a?a:{};var b=tb({},a);delete b.preload;delete b.useInterimTilesOnError;wi.call(this,b);this.j(void 0!==a.preload?a.preload:0);this.C(void 0!==a.useInterimTilesOnError?a.useInterimTilesOnError:!0);this.type="TILE"}v(ou,wi);ou.prototype.c=function(){return this.get("preload")};ou.prototype.j=function(a){this.set("preload",a)};ou.prototype.i=function(){return this.get("useInterimTilesOnError")};ou.prototype.C=function(a){this.set("useInterimTilesOnError",a)};function W(a){a=a?a:{};var b=tb({},a);delete b.preload;delete b.useInterimTilesOnError;R.call(this,b);this.B(a.preload?a.preload:0);this.T(a.useInterimTilesOnError?a.useInterimTilesOnError:!0);wa(void 0==a.renderMode||"image"==a.renderMode||"hybrid"==a.renderMode||"vector"==a.renderMode,28);this.v=a.renderMode||"hybrid";this.type="VECTOR_TILE"}v(W,R);W.prototype.c=function(){return this.get("preload")};W.prototype.i=function(){return this.get("useInterimTilesOnError")};
W.prototype.B=function(a){this.set("preload",a)};W.prototype.T=function(a){this.set("useInterimTilesOnError",a)};function pu(a){this.b=a};function qu(a){this.b=a}v(qu,pu);qu.prototype.S=function(){return 35632};function ru(a){this.b=a}v(ru,pu);ru.prototype.S=function(){return 35633};var su=new qu("precision mediump float;varying vec2 a;varying vec2 b;varying float c;varying float d;uniform float m;uniform vec4 n;uniform vec4 o;uniform vec2 p;void main(void){vec2 windowCenter=vec2((a.x+1.0)/2.0*p.x*d,(a.y+1.0)/2.0*p.y*d);vec2 windowOffset=vec2((b.x+1.0)/2.0*p.x*d,(b.y+1.0)/2.0*p.y*d);float radius=length(windowCenter-windowOffset);float dist=length(windowCenter-gl_FragCoord.xy);if(dist>radius+c){if(o.a==0.0){gl_FragColor=n;}else{gl_FragColor=o;}gl_FragColor.a=gl_FragColor.a-(dist-(radius+c));}else if(n.a==0.0){gl_FragColor=o;if(dist<radius-c){gl_FragColor.a=gl_FragColor.a-(radius-c-dist);}} else{gl_FragColor=n;float strokeDist=radius-c;float antialias=2.0*d;if(dist>strokeDist){gl_FragColor=o;}else if(dist>=strokeDist-antialias){float step=smoothstep(strokeDist-antialias,strokeDist,dist);gl_FragColor=mix(n,o,step);}} gl_FragColor.a=gl_FragColor.a*m;if(gl_FragColor.a<=0.0){discard;}}"),
tu=new ru("varying vec2 a;varying vec2 b;varying float c;varying float d;attribute vec2 e;attribute float f;attribute float g;uniform mat4 h;uniform mat4 i;uniform mat4 j;uniform float k;uniform float l;void main(void){mat4 offsetMatrix=i*j;a=vec4(h*vec4(e,0.0,1.0)).xy;d=l;float lineWidth=k*l;c=lineWidth/2.0;if(lineWidth==0.0){lineWidth=2.0*l;}vec2 offset;float radius=g+3.0*l;//Until we get gl_VertexID in WebGL,we store an instruction.if(f==0.0){//Offsetting the edges of the triangle by lineWidth/2 is necessary,however//we should also leave some space for the antialiasing,thus we offset by lineWidth.offset=vec2(-1.0,1.0);}else if(f==1.0){offset=vec2(-1.0,-1.0);}else if(f==2.0){offset=vec2(1.0,-1.0);}else{offset=vec2(1.0,1.0);}gl_Position=h*vec4(e+offset*radius,0.0,1.0)+offsetMatrix*vec4(offset*lineWidth,0.0,0.0);b=vec4(h*vec4(e.x+g,e.y,0.0,1.0)).xy;if(distance(a,b)>20000.0){gl_Position=vec4(a,0.0,1.0);}}");function uu(a,b){this.f=a.getUniformLocation(b,"h");this.i=a.getUniformLocation(b,"i");this.c=a.getUniformLocation(b,"j");this.ra=a.getUniformLocation(b,"k");this.sa=a.getUniformLocation(b,"l");this.a=a.getUniformLocation(b,"m");this.D=a.getUniformLocation(b,"n");this.T=a.getUniformLocation(b,"o");this.I=a.getUniformLocation(b,"p");this.b=a.getAttribLocation(b,"e");this.j=a.getAttribLocation(b,"f");this.O=a.getAttribLocation(b,"g")};function vu(){return[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]}function wu(a,b){a[0]=b[0];a[1]=b[1];a[4]=b[2];a[5]=b[3];a[12]=b[4];a[13]=b[5];return a};function xu(a,b){this.origin=nb(b);this.ub=Ue();this.Va=Ue();this.ab=Ue();this.U=vu();this.b=[];this.j=null;this.f=[];this.i=[];this.a=[];this.o=null;this.g=void 0}v(xu,Uh);
xu.prototype.Ka=function(a,b,c,d,e,f,g,h,l,m,n){var p=a.b;if(this.g){var q=p.isEnabled(p.STENCIL_TEST);var r=p.getParameter(p.STENCIL_FUNC);var u=p.getParameter(p.STENCIL_VALUE_MASK);var x=p.getParameter(p.STENCIL_REF);var B=p.getParameter(p.STENCIL_WRITEMASK);var A=p.getParameter(p.STENCIL_FAIL);var y=p.getParameter(p.STENCIL_PASS_DEPTH_PASS);var N=p.getParameter(p.STENCIL_PASS_DEPTH_FAIL);p.enable(p.STENCIL_TEST);p.clear(p.STENCIL_BUFFER_BIT);p.stencilMask(255);p.stencilFunc(p.ALWAYS,1,255);p.stencilOp(p.KEEP,
p.KEEP,p.REPLACE);this.g.Ka(a,b,c,d,e,f,g,h,l,m,n);p.stencilMask(0);p.stencilFunc(p.NOTEQUAL,1,255)}yu(a,34962,this.o);yu(a,34963,this.j);f=this.Bf(p,a,e,f);var ca=Ve(this.ub);af(ca,2/(c*e[0]),2/(c*e[1]));$e(ca,-d);bf(ca,-(b[0]-this.origin[0]),-(b[1]-this.origin[1]));b=Ve(this.ab);af(b,2/e[0],2/e[1]);e=Ve(this.Va);0!==d&&$e(e,-d);p.uniformMatrix4fv(f.f,!1,wu(this.U,ca));p.uniformMatrix4fv(f.i,!1,wu(this.U,b));p.uniformMatrix4fv(f.c,!1,wu(this.U,e));p.uniform1f(f.a,g);if(l){m?a=this.He(p,a,h,l,n):
(p.clear(p.COLOR_BUFFER_BIT|p.DEPTH_BUFFER_BIT),this.Sd(p,a,h,!0),a=(a=l(null))?a:void 0);var la=a}else this.Sd(p,a,h,!1);this.Cf(p,f);this.g&&(q||p.disable(p.STENCIL_TEST),p.clear(p.STENCIL_BUFFER_BIT),p.stencilFunc(r,x,u),p.stencilMask(B),p.stencilOp(A,N,y));return la};function zu(a,b,c,d){a.drawElements(4,d-c,b.g?5125:5123,c*(b.g?4:2))};var Au=[0,0,0,1],Bu=[],Cu=[0,0,0,1];function Du(a,b,c,d,e,f){a=(c-a)*(f-b)-(e-a)*(d-b);return a<=Eu&&a>=-Eu?void 0:0<a}var Eu=Number.EPSILON||2.220446049250313E-16;function Fu(a){this.b=void 0!==a?a:[];this.a=Gu}var Gu=35044;function Hu(a,b){xu.call(this,0,b);this.v=null;this.l=[];this.s=[];this.O=0;this.c={fillColor:null,strokeColor:null,lineDash:null,lineDashOffset:void 0,lineWidth:void 0,u:!1}}v(Hu,xu);k=Hu.prototype;
k.$b=function(a,b){var c=a.xd(),d=a.pa();if(c){this.f.push(this.b.length);this.i.push(b);this.c.u&&(this.s.push(this.b.length),this.c.u=!1);this.O=c;a=a.ca();a=Se(a,0,2,d,-this.origin[0],-this.origin[1]);b=this.a.length;c=this.b.length;var e=b/4,f;for(f=0;2>f;f+=d)this.a[b++]=a[f],this.a[b++]=a[f+1],this.a[b++]=0,this.a[b++]=this.O,this.a[b++]=a[f],this.a[b++]=a[f+1],this.a[b++]=1,this.a[b++]=this.O,this.a[b++]=a[f],this.a[b++]=a[f+1],this.a[b++]=2,this.a[b++]=this.O,this.a[b++]=a[f],this.a[b++]=
a[f+1],this.a[b++]=3,this.a[b++]=this.O,this.b[c++]=e,this.b[c++]=e+1,this.b[c++]=e+2,this.b[c++]=e+2,this.b[c++]=e+3,this.b[c++]=e,e+=4}else this.c.u&&(this.l.pop(),this.l.length&&(d=this.l[this.l.length-1],this.c.fillColor=d[0],this.c.strokeColor=d[1],this.c.lineWidth=d[2],this.c.u=!1))};k.$a=function(){this.o=new Fu(this.a);this.j=new Fu(this.b);this.f.push(this.b.length);0===this.s.length&&0<this.l.length&&(this.l=[]);this.b=this.a=null};
k.Ab=function(a){var b=this.o,c=this.j;return function(){Iu(a,b);Iu(a,c)}};k.Bf=function(a,b,c,d){var e=Ju(b,su,tu);if(this.v)var f=this.v;else this.v=f=new uu(a,e);b.Wc(e);a.enableVertexAttribArray(f.b);a.vertexAttribPointer(f.b,2,5126,!1,16,0);a.enableVertexAttribArray(f.j);a.vertexAttribPointer(f.j,1,5126,!1,16,8);a.enableVertexAttribArray(f.O);a.vertexAttribPointer(f.O,1,5126,!1,16,12);a.uniform2fv(f.I,c);a.uniform1f(f.sa,d);return f};
k.Cf=function(a,b){a.disableVertexAttribArray(b.b);a.disableVertexAttribArray(b.j);a.disableVertexAttribArray(b.O)};
k.Sd=function(a,b,c){if(wb(c)){var d=this.f[this.f.length-1];for(c=this.s.length-1;0<=c;--c){var e=this.s[c];var f=this.l[c];a.uniform4fv(this.v.D,f[0]);Ku(this,a,f[1],f[2]);zu(a,b,e,d);d=e}}else{var g=this.f.length-2;f=d=this.f[g+1];for(e=this.s.length-1;0<=e;--e){var h=this.l[e];a.uniform4fv(this.v.D,h[0]);Ku(this,a,h[1],h[2]);for(h=this.s[e];0<=g&&this.f[g]>=h;){var l=this.f[g];var m=this.i[g];m=w(m).toString();c[m]&&(d!==f&&zu(a,b,d,f),f=l);g--;d=l}d!==f&&zu(a,b,d,f);d=f=h}}};
k.He=function(a,b,c,d,e){var f,g;var h=this.f.length-2;var l=this.f[h+1];for(f=this.s.length-1;0<=f;--f){var m=this.l[f];a.uniform4fv(this.v.D,m[0]);Ku(this,a,m[1],m[2]);for(g=this.s[f];0<=h&&this.f[h]>=g;){m=this.f[h];var n=this.i[h];var p=w(n).toString();if(void 0===c[p]&&n.W()&&(void 0===e||qb(e,n.W().G()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),zu(a,b,m,l),l=d(n)))return l;h--;l=m}}};function Ku(a,b,c,d){b.uniform4fv(a.v.T,c);b.uniform1f(a.v.ra,d)}
k.La=function(a,b){if(b){var c=b.f;this.c.lineDash=c?c:Bu;c=b.i;this.c.lineDashOffset=c?c:0;c=b.b;c instanceof CanvasGradient||c instanceof CanvasPattern?c=Cu:c=Ph(c).map(function(a,b){return 3!=b?a/255:a})||Cu;b=b.c;b=void 0!==b?b:1}else c=[0,0,0,0],b=0;a=a?a.b:[0,0,0,0];a instanceof CanvasGradient||a instanceof CanvasPattern?a=Au:a=Ph(a).map(function(a,b){return 3!=b?a/255:a})||Au;this.c.strokeColor&&ma(this.c.strokeColor,c)&&this.c.fillColor&&ma(this.c.fillColor,a)&&this.c.lineWidth===b||(this.c.u=
!0,this.c.fillColor=a,this.c.strokeColor=c,this.c.lineWidth=b,this.l.push([a,c,b]))};var Lu=new qu("precision mediump float;varying vec2 a;varying float b;uniform float k;uniform sampler2D l;void main(void){vec4 texColor=texture2D(l,a);gl_FragColor.rgb=texColor.rgb;float alpha=texColor.a*b*k;if(alpha==0.0){discard;}gl_FragColor.a=alpha;}"),Mu=new ru("varying vec2 a;varying float b;attribute vec2 c;attribute vec2 d;attribute vec2 e;attribute float f;attribute float g;uniform mat4 h;uniform mat4 i;uniform mat4 j;void main(void){mat4 offsetMatrix=i;if(g==1.0){offsetMatrix=i*j;}vec4 offsets=offsetMatrix*vec4(e,0.0,0.0);gl_Position=h*vec4(c,0.0,1.0)+offsets;a=d;b=f;}");function Nu(a,b){this.f=a.getUniformLocation(b,"h");this.i=a.getUniformLocation(b,"i");this.c=a.getUniformLocation(b,"j");this.a=a.getUniformLocation(b,"k");this.b=a.getAttribLocation(b,"c");this.B=a.getAttribLocation(b,"d");this.v=a.getAttribLocation(b,"e");this.s=a.getAttribLocation(b,"f");this.C=a.getAttribLocation(b,"g")};function Ou(a,b){this.j=a;this.b=b;this.a={};this.c={};this.f={};this.o=this.v=this.i=this.l=null;(this.g=ha(da,"OES_element_index_uint"))&&b.getExtension("OES_element_index_uint");z(this.j,"webglcontextlost",this.fp,this);z(this.j,"webglcontextrestored",this.gp,this)}v(Ou,Pc);
function yu(a,b,c){var d=a.b,e=c.b,f=String(w(c));if(f in a.a)d.bindBuffer(b,a.a[f].buffer);else{var g=d.createBuffer();d.bindBuffer(b,g);var h;34962==b?h=new Float32Array(e):34963==b&&(h=a.g?new Uint32Array(e):new Uint16Array(e));d.bufferData(b,h,c.a);a.a[f]={pc:c,buffer:g}}}function Iu(a,b){var c=a.b;b=String(w(b));var d=a.a[b];c.isContextLost()||c.deleteBuffer(d.buffer);delete a.a[b]}k=Ou.prototype;
k.ka=function(){Oc(this.j);var a=this.b;if(!a.isContextLost()){for(var b in this.a)a.deleteBuffer(this.a[b].buffer);for(b in this.f)a.deleteProgram(this.f[b]);for(b in this.c)a.deleteShader(this.c[b]);a.deleteFramebuffer(this.i);a.deleteRenderbuffer(this.o);a.deleteTexture(this.v)}};k.ep=function(){return this.b};
function Pu(a){if(!a.i){var b=a.b,c=b.createFramebuffer();b.bindFramebuffer(b.FRAMEBUFFER,c);var d=Qu(b,1,1),e=b.createRenderbuffer();b.bindRenderbuffer(b.RENDERBUFFER,e);b.renderbufferStorage(b.RENDERBUFFER,b.DEPTH_COMPONENT16,1,1);b.framebufferTexture2D(b.FRAMEBUFFER,b.COLOR_ATTACHMENT0,b.TEXTURE_2D,d,0);b.framebufferRenderbuffer(b.FRAMEBUFFER,b.DEPTH_ATTACHMENT,b.RENDERBUFFER,e);b.bindTexture(b.TEXTURE_2D,null);b.bindRenderbuffer(b.RENDERBUFFER,null);b.bindFramebuffer(b.FRAMEBUFFER,null);a.i=c;
a.v=d;a.o=e}return a.i}function Ru(a,b){var c=String(w(b));if(c in a.c)return a.c[c];var d=a.b,e=d.createShader(b.S());d.shaderSource(e,b.b);d.compileShader(e);return a.c[c]=e}function Ju(a,b,c){var d=w(b)+"/"+w(c);if(d in a.f)return a.f[d];var e=a.b,f=e.createProgram();e.attachShader(f,Ru(a,b));e.attachShader(f,Ru(a,c));e.linkProgram(f);return a.f[d]=f}k.fp=function(){ub(this.a);ub(this.c);ub(this.f);this.o=this.v=this.i=this.l=null};k.gp=function(){};
k.Wc=function(a){if(a==this.l)return!1;this.b.useProgram(a);this.l=a;return!0};function Su(a,b,c){var d=a.createTexture();a.bindTexture(a.TEXTURE_2D,d);a.texParameteri(a.TEXTURE_2D,a.TEXTURE_MAG_FILTER,a.LINEAR);a.texParameteri(a.TEXTURE_2D,a.TEXTURE_MIN_FILTER,a.LINEAR);void 0!==b&&a.texParameteri(3553,10242,b);void 0!==c&&a.texParameteri(3553,10243,c);return d}function Qu(a,b,c){var d=Su(a,void 0,void 0);a.texImage2D(a.TEXTURE_2D,0,a.RGBA,b,c,0,a.RGBA,a.UNSIGNED_BYTE,null);return d}
function Tu(a,b){var c=Su(a,33071,33071);a.texImage2D(a.TEXTURE_2D,0,a.RGBA,a.RGBA,a.UNSIGNED_BYTE,b);return c};function Uu(a,b){xu.call(this,0,b);this.D=this.C=void 0;this.v=[];this.s=[];this.sa=this.ra=this.height=void 0;this.Ua=null;this.width=this.scale=this.rotation=this.rotateWithView=this.T=this.I=this.opacity=void 0}v(Uu,xu);k=Uu.prototype;k.Ab=function(a){var b=this.o,c=this.j,d=this.jg(!0),e=a.b;return function(){if(!e.isContextLost()){var f;var g=0;for(f=d.length;g<f;++g)e.deleteTexture(d[g])}Iu(a,b);Iu(a,c)}};
function Vu(a,b,c,d){var e=a.C,f=a.D,g=a.height,h=a.ra,l=a.sa,m=a.opacity,n=a.I,p=a.T,q=a.rotateWithView?1:0,r=-a.rotation,u=a.scale,x=a.width,B=Math.cos(r);r=Math.sin(r);var A=a.b.length,y=a.a.length,N;for(N=0;N<c;N+=d){var ca=b[N]-a.origin[0];var la=b[N+1]-a.origin[1];var fa=y/8;var va=-u*e;var ra=-u*(g-f);a.a[y++]=ca;a.a[y++]=la;a.a[y++]=va*B-ra*r;a.a[y++]=va*r+ra*B;a.a[y++]=n/l;a.a[y++]=(p+g)/h;a.a[y++]=m;a.a[y++]=q;va=u*(x-e);ra=-u*(g-f);a.a[y++]=ca;a.a[y++]=la;a.a[y++]=va*B-ra*r;a.a[y++]=va*
r+ra*B;a.a[y++]=(n+x)/l;a.a[y++]=(p+g)/h;a.a[y++]=m;a.a[y++]=q;va=u*(x-e);ra=u*f;a.a[y++]=ca;a.a[y++]=la;a.a[y++]=va*B-ra*r;a.a[y++]=va*r+ra*B;a.a[y++]=(n+x)/l;a.a[y++]=p/h;a.a[y++]=m;a.a[y++]=q;va=-u*e;ra=u*f;a.a[y++]=ca;a.a[y++]=la;a.a[y++]=va*B-ra*r;a.a[y++]=va*r+ra*B;a.a[y++]=n/l;a.a[y++]=p/h;a.a[y++]=m;a.a[y++]=q;a.b[A++]=fa;a.b[A++]=fa+1;a.b[A++]=fa+2;a.b[A++]=fa;a.b[A++]=fa+2;a.b[A++]=fa+3}}
function Wu(a,b,c,d){var e,f=b.length;for(e=0;e<f;++e){var g=b[e];var h=w(g).toString();h in c?g=c[h]:(g=Tu(d,g),c[h]=g);a[e]=g}}
k.Bf=function(a,b){var c=Ju(b,Lu,Mu);if(this.Ua)var d=this.Ua;else this.Ua=d=new Nu(a,c);b.Wc(c);a.enableVertexAttribArray(d.b);a.vertexAttribPointer(d.b,2,5126,!1,32,0);a.enableVertexAttribArray(d.v);a.vertexAttribPointer(d.v,2,5126,!1,32,8);a.enableVertexAttribArray(d.B);a.vertexAttribPointer(d.B,2,5126,!1,32,16);a.enableVertexAttribArray(d.s);a.vertexAttribPointer(d.s,1,5126,!1,32,24);a.enableVertexAttribArray(d.C);a.vertexAttribPointer(d.C,1,5126,!1,32,28);return d};
k.Cf=function(a,b){a.disableVertexAttribArray(b.b);a.disableVertexAttribArray(b.v);a.disableVertexAttribArray(b.B);a.disableVertexAttribArray(b.s);a.disableVertexAttribArray(b.C)};
k.Sd=function(a,b,c,d){var e=d?this.bg():this.jg();d=d?this.s:this.v;if(wb(c)){var f;c=0;var g=e.length;for(f=0;c<g;++c){a.bindTexture(3553,e[c]);var h=d[c];zu(a,b,f,h);f=h}}else for(f=g=0,h=e.length;f<h;++f){a.bindTexture(3553,e[f]);for(var l=0<f?d[f-1]:0,m=d[f],n=l;g<this.f.length&&this.f[g]<=m;){var p=w(this.i[g]).toString();void 0!==c[p]?(n!==l&&zu(a,b,n,l),l=n=g===this.f.length-1?m:this.f[g+1]):l=g===this.f.length-1?m:this.f[g+1];g++}n!==l&&zu(a,b,n,l)}};
k.He=function(a,b,c,d,e){var f,g,h=this.f.length-1,l=this.bg();for(f=l.length-1;0<=f;--f){a.bindTexture(3553,l[f]);var m=0<f?this.s[f-1]:0;for(g=this.s[f];0<=h&&this.f[h]>=m;){var n=this.f[h];var p=this.i[h];var q=w(p).toString();if(void 0===c[q]&&p.W()&&(void 0===e||qb(e,p.W().G()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),zu(a,b,n,g),g=d(p)))return g;g=n;h--}}};
k.$a=function(){this.sa=this.ra=this.height=this.D=this.C=void 0;this.b=null;this.scale=this.rotation=this.rotateWithView=this.T=this.I=this.opacity=void 0;this.a=null;this.width=void 0};function Xu(a,b){Uu.call(this,0,b);this.l=[];this.c=[];this.B=[];this.O=[]}v(Xu,Uu);k=Xu.prototype;k.sc=function(a,b){this.f.push(this.b.length);this.i.push(b);b=a.ca();Vu(this,b,b.length,a.pa())};k.uc=function(a,b){this.f.push(this.b.length);this.i.push(b);b=a.ca();Vu(this,b,b.length,a.pa())};
k.$a=function(a){var b=a.b;this.v.push(this.b.length);this.s.push(this.b.length);this.o=new Fu(this.a);this.j=new Fu(this.b);var c={};Wu(this.B,this.l,c,b);Wu(this.O,this.c,c,b);this.c=this.l=null;Uu.prototype.$a.call(this,a)};
k.Wb=function(a){var b=a.Oc(),c=a.Y(1),d=a.Ie(),e=a.Cg(1),f=a.i,g=a.Vc(),h=a.o,l=a.g,m=a.kc();a=a.a;if(0===this.l.length)this.l.push(c);else{var n=this.l[this.l.length-1];w(n)!=w(c)&&(this.v.push(this.b.length),this.l.push(c))}0===this.c.length?this.c.push(e):(n=this.c[this.c.length-1],w(n)!=w(e)&&(this.s.push(this.b.length),this.c.push(e)));this.C=b[0];this.D=b[1];this.height=m[1];this.ra=d[1];this.sa=d[0];this.opacity=f;this.I=g[0];this.T=g[1];this.rotation=l;this.rotateWithView=h;this.scale=a;
this.width=m[0]};k.jg=function(a){return a?this.B.concat(this.O):this.B};k.bg=function(){return this.O};var Yu=new qu("precision mediump float;varying float a;varying vec2 aVertex;varying float c;uniform float m;uniform vec4 n;uniform vec2 o;uniform float p;void main(void){if(a>0.0){vec2 windowCoords=vec2((aVertex.x+1.0)/2.0*o.x*p,(aVertex.y+1.0)/2.0*o.y*p);if(length(windowCoords-gl_FragCoord.xy)>c*p){discard;}} gl_FragColor=n;float alpha=n.a*m;if(alpha==0.0){discard;}gl_FragColor.a=alpha;}"),Zu=new ru("varying float a;varying vec2 aVertex;varying float c;attribute vec2 d;attribute vec2 e;attribute vec2 f;attribute float g;uniform mat4 h;uniform mat4 i;uniform mat4 j;uniform float k;uniform float l;bool nearlyEquals(in float value,in float ref){float epsilon=0.000000000001;return value>=ref-epsilon&&value<=ref+epsilon;}void alongNormal(out vec2 offset,in vec2 nextP,in float turnDir,in float direction){vec2 dirVect=nextP-e;vec2 normal=normalize(vec2(-turnDir*dirVect.y,turnDir*dirVect.x));offset=k/2.0*normal*direction;}void miterUp(out vec2 offset,out float round,in bool isRound,in float direction){float halfWidth=k/2.0;vec2 tangent=normalize(normalize(f-e)+normalize(e-d));vec2 normal=vec2(-tangent.y,tangent.x);vec2 dirVect=f-e;vec2 tmpNormal=normalize(vec2(-dirVect.y,dirVect.x));float miterLength=abs(halfWidth/dot(normal,tmpNormal));offset=normal*direction*miterLength;round=0.0;if(isRound){round=1.0;}else if(miterLength>l+k){offset=halfWidth*tmpNormal*direction;}} bool miterDown(out vec2 offset,in vec4 projPos,in mat4 offsetMatrix,in float direction){bool degenerate=false;vec2 tangent=normalize(normalize(f-e)+normalize(e-d));vec2 normal=vec2(-tangent.y,tangent.x);vec2 dirVect=d-e;vec2 tmpNormal=normalize(vec2(-dirVect.y,dirVect.x));vec2 longOffset,shortOffset,longVertex;vec4 shortProjVertex;float halfWidth=k/2.0;if(length(f-e)>length(d-e)){longOffset=tmpNormal*direction*halfWidth;shortOffset=normalize(vec2(dirVect.y,-dirVect.x))*direction*halfWidth;longVertex=f;shortProjVertex=h*vec4(d,0.0,1.0);}else{shortOffset=tmpNormal*direction*halfWidth;longOffset=normalize(vec2(dirVect.y,-dirVect.x))*direction*halfWidth;longVertex=d;shortProjVertex=h*vec4(f,0.0,1.0);}vec4 p1=h*vec4(longVertex,0.0,1.0)+offsetMatrix*vec4(longOffset,0.0,0.0);vec4 p2=projPos+offsetMatrix*vec4(longOffset,0.0,0.0);vec4 p3=shortProjVertex+offsetMatrix*vec4(-shortOffset,0.0,0.0);vec4 p4=shortProjVertex+offsetMatrix*vec4(shortOffset,0.0,0.0);float denom=(p4.y-p3.y)*(p2.x-p1.x)-(p4.x-p3.x)*(p2.y-p1.y);float firstU=((p4.x-p3.x)*(p1.y-p3.y)-(p4.y-p3.y)*(p1.x-p3.x))/denom;float secondU=((p2.x-p1.x)*(p1.y-p3.y)-(p2.y-p1.y)*(p1.x-p3.x))/denom;float epsilon=0.000000000001;if(firstU>epsilon&&firstU<1.0-epsilon&&secondU>epsilon&&secondU<1.0-epsilon){shortProjVertex.x=p1.x+firstU*(p2.x-p1.x);shortProjVertex.y=p1.y+firstU*(p2.y-p1.y);offset=shortProjVertex.xy;degenerate=true;}else{float miterLength=abs(halfWidth/dot(normal,tmpNormal));offset=normal*direction*miterLength;}return degenerate;}void squareCap(out vec2 offset,out float round,in bool isRound,in vec2 nextP,in float turnDir,in float direction){round=0.0;vec2 dirVect=e-nextP;vec2 firstNormal=normalize(dirVect);vec2 secondNormal=vec2(turnDir*firstNormal.y*direction,-turnDir*firstNormal.x*direction);vec2 hypotenuse=normalize(firstNormal-secondNormal);vec2 normal=vec2(turnDir*hypotenuse.y*direction,-turnDir*hypotenuse.x*direction);float length=sqrt(c*c*2.0);offset=normal*length;if(isRound){round=1.0;}} void main(void){bool degenerate=false;float direction=float(sign(g));mat4 offsetMatrix=i*j;vec2 offset;vec4 projPos=h*vec4(e,0.0,1.0);bool round=nearlyEquals(mod(g,2.0),0.0);a=0.0;c=k/2.0;aVertex=projPos.xy;if(nearlyEquals(mod(g,3.0),0.0)||nearlyEquals(mod(g,17.0),0.0)){alongNormal(offset,f,1.0,direction);}else if(nearlyEquals(mod(g,5.0),0.0)||nearlyEquals(mod(g,13.0),0.0)){alongNormal(offset,d,-1.0,direction);}else if(nearlyEquals(mod(g,23.0),0.0)){miterUp(offset,a,round,direction);}else if(nearlyEquals(mod(g,19.0),0.0)){degenerate=miterDown(offset,projPos,offsetMatrix,direction);}else if(nearlyEquals(mod(g,7.0),0.0)){squareCap(offset,a,round,f,1.0,direction);}else if(nearlyEquals(mod(g,11.0),0.0)){squareCap(offset,a,round,d,-1.0,direction);}if(!degenerate){vec4 offsets=offsetMatrix*vec4(offset,0.0,0.0);gl_Position=projPos+offsets;}else{gl_Position=vec4(offset,0.0,1.0);}}");function $u(a,b){this.f=a.getUniformLocation(b,"h");this.i=a.getUniformLocation(b,"i");this.c=a.getUniformLocation(b,"j");this.ra=a.getUniformLocation(b,"k");this.T=a.getUniformLocation(b,"l");this.a=a.getUniformLocation(b,"m");this.D=a.getUniformLocation(b,"n");this.I=a.getUniformLocation(b,"o");this.sa=a.getUniformLocation(b,"p");this.l=a.getAttribLocation(b,"d");this.b=a.getAttribLocation(b,"e");this.o=a.getAttribLocation(b,"f");this.g=a.getAttribLocation(b,"g")};function av(a,b){xu.call(this,0,b);this.v=null;this.s=[];this.l=[];this.c={strokeColor:null,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:void 0,miterLimit:void 0,u:!1}}v(av,xu);
function bv(a,b,c,d){var e,f=a.a.length,g=a.b.length,h="bevel"===a.c.lineJoin?0:"miter"===a.c.lineJoin?1:2,l="butt"===a.c.lineCap?0:"square"===a.c.lineCap?1:2,m=js(b,c,d),n=g,p=1;for(e=0;e<c;e+=d){var q=f/7;var r=u;var u=x||[b[e],b[e+1]];if(0===e){var x=[b[e+d],b[e+d+1]];if(c-0===2*d&&ma(u,x))break;if(m){r=[b[c-2*d],b[c-2*d+1]];var B=x}else{l&&(f=cv(a,[0,0],u,x,p*dv*l,f),f=cv(a,[0,0],u,x,-p*dv*l,f),a.b[g++]=q+2,a.b[g++]=q,a.b[g++]=q+1,a.b[g++]=q+1,a.b[g++]=q+3,a.b[g++]=q+2);f=cv(a,[0,0],u,x,p*ev*
(l||1),f);f=cv(a,[0,0],u,x,-p*ev*(l||1),f);n=f/7-1;continue}}else if(e===c-d){m?x=B:(r=r||[0,0],f=cv(a,r,u,[0,0],p*fv*(l||1),f),f=cv(a,r,u,[0,0],-p*fv*(l||1),f),a.b[g++]=q,a.b[g++]=n-1,a.b[g++]=n,a.b[g++]=n,a.b[g++]=q+1,a.b[g++]=q,l&&(f=cv(a,r,u,[0,0],p*gv*l,f),f=cv(a,r,u,[0,0],-p*gv*l,f),a.b[g++]=q+2,a.b[g++]=q,a.b[g++]=q+1,a.b[g++]=q+1,a.b[g++]=q+3,a.b[g++]=q+2));break}else x=[b[e+d],b[e+d+1]];var A=Du(r[0],r[1],u[0],u[1],x[0],x[1])?-1:1;f=cv(a,r,u,x,A*hv*(h||1),f);f=cv(a,r,u,x,A*iv*(h||1),f);f=
cv(a,r,u,x,-A*jv*(h||1),f);0<e&&(a.b[g++]=q,a.b[g++]=n-1,a.b[g++]=n,a.b[g++]=q+2,a.b[g++]=q,a.b[g++]=0<p*A?n:n-1);a.b[g++]=q;a.b[g++]=q+2;a.b[g++]=q+1;n=q+2;p=A;h&&(f=cv(a,r,u,x,A*kv*h,f),a.b[g++]=q+1,a.b[g++]=q+3,a.b[g++]=q)}m&&(q=q||f/7,A=Kf([r[0],r[1],u[0],u[1],x[0],x[1]],0,6,2)?1:-1,f=cv(a,r,u,x,A*hv*(h||1),f),cv(a,r,u,x,-A*jv*(h||1),f),a.b[g++]=q,a.b[g++]=n-1,a.b[g++]=n,a.b[g++]=q+1,a.b[g++]=q,a.b[g++]=0<p*A?n:n-1)}
function cv(a,b,c,d,e,f){a.a[f++]=b[0];a.a[f++]=b[1];a.a[f++]=c[0];a.a[f++]=c[1];a.a[f++]=d[0];a.a[f++]=d[1];a.a[f++]=e;return f}function lv(a,b,c,d){c-=b;return c<2*d?!1:c===2*d?!ma([a[b],a[b+1]],[a[b+d],a[b+d+1]]):!0}k=av.prototype;k.qc=function(a,b){var c=a.ca();a=a.pa();lv(c,0,c.length,a)&&(c=Se(c,0,c.length,a,-this.origin[0],-this.origin[1]),this.c.u&&(this.l.push(this.b.length),this.c.u=!1),this.f.push(this.b.length),this.i.push(b),bv(this,c,c.length,a))};
k.rc=function(a,b){var c=this.b.length,d=a.lb();d.unshift(0);var e=a.ca();a=a.pa();var f;if(1<d.length){var g=1;for(f=d.length;g<f;++g)if(lv(e,d[g-1],d[g],a)){var h=Se(e,d[g-1],d[g],a,-this.origin[0],-this.origin[1]);bv(this,h,h.length,a)}}this.b.length>c&&(this.f.push(c),this.i.push(b),this.c.u&&(this.l.push(c),this.c.u=!1))};
function mv(a,b,c,d){js(b,b.length,d)||(b.push(b[0]),b.push(b[1]));bv(a,b,b.length,d);if(c.length){var e;b=0;for(e=c.length;b<e;++b)js(c[b],c[b].length,d)||(c[b].push(c[b][0]),c[b].push(c[b][1])),bv(a,c[b],c[b].length,d)}}function nv(a,b,c){c=void 0===c?a.b.length:c;a.f.push(c);a.i.push(b);a.c.u&&(a.l.push(c),a.c.u=!1)}k.$a=function(){this.o=new Fu(this.a);this.j=new Fu(this.b);this.f.push(this.b.length);0===this.l.length&&0<this.s.length&&(this.s=[]);this.b=this.a=null};
k.Ab=function(a){var b=this.o,c=this.j;return function(){Iu(a,b);Iu(a,c)}};
k.Bf=function(a,b,c,d){var e=Ju(b,Yu,Zu);if(this.v)var f=this.v;else this.v=f=new $u(a,e);b.Wc(e);a.enableVertexAttribArray(f.l);a.vertexAttribPointer(f.l,2,5126,!1,28,0);a.enableVertexAttribArray(f.b);a.vertexAttribPointer(f.b,2,5126,!1,28,8);a.enableVertexAttribArray(f.o);a.vertexAttribPointer(f.o,2,5126,!1,28,16);a.enableVertexAttribArray(f.g);a.vertexAttribPointer(f.g,1,5126,!1,28,24);a.uniform2fv(f.I,c);a.uniform1f(f.sa,d);return f};
k.Cf=function(a,b){a.disableVertexAttribArray(b.l);a.disableVertexAttribArray(b.b);a.disableVertexAttribArray(b.o);a.disableVertexAttribArray(b.g)};
k.Sd=function(a,b,c,d){var e=a.getParameter(a.DEPTH_FUNC),f=a.getParameter(a.DEPTH_WRITEMASK);d||(a.enable(a.DEPTH_TEST),a.depthMask(!0),a.depthFunc(a.NOTEQUAL));if(wb(c)){var g=this.f[this.f.length-1];for(c=this.l.length-1;0<=c;--c){var h=this.l[c];var l=this.s[c];ov(this,a,l[0],l[1],l[2]);zu(a,b,h,g);a.clear(a.DEPTH_BUFFER_BIT);g=h}}else{var m=this.f.length-2;l=g=this.f[m+1];for(h=this.l.length-1;0<=h;--h){var n=this.s[h];ov(this,a,n[0],n[1],n[2]);for(n=this.l[h];0<=m&&this.f[m]>=n;){var p=this.f[m];
var q=this.i[m];q=w(q).toString();c[q]&&(g!==l&&(zu(a,b,g,l),a.clear(a.DEPTH_BUFFER_BIT)),l=p);m--;g=p}g!==l&&(zu(a,b,g,l),a.clear(a.DEPTH_BUFFER_BIT));g=l=n}}d||(a.disable(a.DEPTH_TEST),a.clear(a.DEPTH_BUFFER_BIT),a.depthMask(f),a.depthFunc(e))};
k.He=function(a,b,c,d,e){var f,g;var h=this.f.length-2;var l=this.f[h+1];for(f=this.l.length-1;0<=f;--f){var m=this.s[f];ov(this,a,m[0],m[1],m[2]);for(g=this.l[f];0<=h&&this.f[h]>=g;){m=this.f[h];var n=this.i[h];var p=w(n).toString();if(void 0===c[p]&&n.W()&&(void 0===e||qb(e,n.W().G()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),zu(a,b,m,l),l=d(n)))return l;h--;l=m}}};function ov(a,b,c,d,e){b.uniform4fv(a.v.D,c);b.uniform1f(a.v.ra,d);b.uniform1f(a.v.T,e)}
k.La=function(a,b){a=b.g;this.c.lineCap=void 0!==a?a:"round";a=b.f;this.c.lineDash=a?a:Bu;a=b.i;this.c.lineDashOffset=a?a:0;a=b.j;this.c.lineJoin=void 0!==a?a:"round";a=b.b;a instanceof CanvasGradient||a instanceof CanvasPattern?a=Cu:a=Ph(a).map(function(a,b){return 3!=b?a/255:a})||Cu;var c=b.c;c=void 0!==c?c:1;b=b.l;b=void 0!==b?b:10;this.c.strokeColor&&ma(this.c.strokeColor,a)&&this.c.lineWidth===c&&this.c.miterLimit===b||(this.c.u=!0,this.c.strokeColor=a,this.c.lineWidth=c,this.c.miterLimit=b,
this.s.push([a,c,b]))};var ev=3,fv=5,dv=7,gv=11,hv=13,iv=17,jv=19,kv=23;var pv=new qu("precision mediump float;uniform vec4 e;uniform float f;void main(void){gl_FragColor=e;float alpha=e.a*f;if(alpha==0.0){discard;}gl_FragColor.a=alpha;}"),qv=new ru("attribute vec2 a;uniform mat4 b;uniform mat4 c;uniform mat4 d;void main(void){gl_Position=b*vec4(a,0.0,1.0);}");function rv(a,b){this.f=a.getUniformLocation(b,"b");this.i=a.getUniformLocation(b,"c");this.c=a.getUniformLocation(b,"d");this.D=a.getUniformLocation(b,"e");this.a=a.getUniformLocation(b,"f");this.b=a.getAttribLocation(b,"a")};function sv(a){this.b=this.a=this.f=void 0;this.i=void 0===a?!0:a;this.c=0}function tv(a){var b=a.b;if(b){var c=b.next,d=b.Bb;c&&(c.Bb=d);d&&(d.next=c);a.b=c||d;a.f===a.a?(a.b=void 0,a.f=void 0,a.a=void 0):a.f===b?a.f=a.b:a.a===b&&(a.a=d?a.b.Bb:a.b);a.c--}}function uv(a){a.b=a.f;if(a.b)return a.b.data}function vv(a){if(a.b&&a.b.next)return a.b=a.b.next,a.b.data}function wv(a){if(a.b&&a.b.next)return a.b.next.data}function xv(a){if(a.b&&a.b.Bb)return a.b=a.b.Bb,a.b.data}
function yv(a){if(a.b&&a.b.Bb)return a.b.Bb.data}function zv(a){if(a.b)return a.b.data}sv.prototype.concat=function(a){if(a.b){if(this.b){var b=this.b.next;this.b.next=a.f;a.f.Bb=this.b;b.Bb=a.a;a.a.next=b;this.c+=a.c}else this.b=a.b,this.f=a.f,this.a=a.a,this.c=a.c;a.b=void 0;a.f=void 0;a.a=void 0;a.c=0}};function Av(a,b){xu.call(this,0,b);this.g=new av(0,b);this.v=null;this.s=[];this.c=[];this.l={fillColor:null,u:!1}}v(Av,xu);
function Bv(a,b,c,d){var e=new sv,f=new Ns;Cv(a,b,d,e,f,!0);b=Dv(e);if(c.length){var g,h=[];var l=0;for(g=c.length;l<g;++l){var m={list:new sv,yc:void 0,eh:new Ns};h.push(m);Cv(a,c[l],d,m.list,m.eh,!1);Ev(m.list,m.eh,!0);m.yc=Dv(m.list)}h.sort(function(a,b){return b.yc[0]===a.yc[0]?a.yc[1]-b.yc[1]:b.yc[0]-a.yc[0]});for(l=0;l<h.length;++l){c=h[l].list;g=d=uv(c);do{if(Fv(g,f).length){var n=!0;break}g=vv(c)}while(d!==g);!n&&Gv(c,h[l].yc[0],e,b[0],f)&&(f.concat(h[l].eh),Ev(e,f,!1))}}else Ev(e,f,!1);Hv(a,
e,f)}
function Cv(a,b,c,d,e,f){var g,h=a.a.length/2,l=[],m=[];if(f===Kf(b,0,b.length,c)){var n=f=Iv(a,b[0],b[1],h++);var p=c;for(g=b.length;p<g;p+=c){var q=Iv(a,b[p],b[p+1],h++);m.push(Jv(n,q,d));l.push([Math.min(n.x,q.x),Math.min(n.y,q.y),Math.max(n.x,q.x),Math.max(n.y,q.y)]);n=q}}else for(p=b.length-c,n=f=Iv(a,b[p],b[p+1],h++),p-=c,g=0;p>=g;p-=c)q=Iv(a,b[p],b[p+1],h++),m.push(Jv(n,q,d)),l.push([Math.min(n.x,q.x),Math.min(n.y,q.y),Math.max(n.x,q.x),Math.max(n.y,q.y)]),n=q;m.push(Jv(q,f,d));l.push([Math.min(n.x,q.x),
Math.min(n.y,q.y),Math.max(n.x,q.x),Math.max(n.y,q.y)]);e.load(l,m)}function Dv(a){var b=uv(a),c=b,d=[c.Z.x,c.Z.y];do c=vv(a),c.Z.x>d[0]&&(d=[c.Z.x,c.Z.y]);while(c!==b);return d}function Ev(a,b,c){var d=uv(a),e=d,f=vv(a),g=!1;do{var h=c?Du(f.X.x,f.X.y,e.X.x,e.X.y,e.Z.x,e.Z.y):Du(e.Z.x,e.Z.y,e.X.x,e.X.y,f.X.x,f.X.y);void 0===h?(Kv(e,f,a,b),g=!0,f===d&&(d=wv(a)),f=e,xv(a)):e.X.Hb!==h&&(e.X.Hb=h,g=!0);e=f;f=vv(a)}while(e!==d);return g}
function Gv(a,b,c,d,e){for(var f=uv(a);f.X.x!==b;)f=vv(a);b=f.X;d={x:d,y:b.y,mb:-1};var g=Infinity,h;var l=Fv({Z:b,X:d},e,!0);var m=0;for(h=l.length;m<h;++m){var n=l[m],p=Lv(b,d,n.Z,n.X,!0),q=Math.abs(b.x-p[0]);if(q<g&&void 0!==Du(b.x,b.y,n.Z.x,n.Z.y,n.X.x,n.X.y)){g=q;var r={x:p[0],y:p[1],mb:-1};f=n}}if(Infinity===g)return!1;l=f.X;if(0<g&&(f=Mv(b,r,f.X,e),f.length))for(r=Infinity,m=0,h=f.length;m<h;++m)if(g=f[m],n=Math.atan2(b.y-g.y,d.x-g.x),n<r||n===r&&g.x<l.x)r=n,l=g;for(f=uv(c);f.X.x!==l.x||f.X.y!==
l.y;)f=vv(c);d={x:b.x,y:b.y,mb:b.mb,Hb:void 0};m={x:f.X.x,y:f.X.y,mb:f.X.mb,Hb:void 0};wv(a).Z=d;Jv(b,f.X,a,e);Jv(m,d,a,e);f.X=m;a.i&&a.b&&(a.f=a.b,a.a=a.b.Bb);c.concat(a);return!0}
function Hv(a,b,c){for(var d=!1,e=Nv(b,c);3<b.c;)if(e){if(!Ov(a,b,c,e,d)&&!Ev(b,c,d)&&!Pv(a,b,c,!0))break}else if(!Ov(a,b,c,e,d)&&!Ev(b,c,d)&&!Pv(a,b,c))if(e=Nv(b,c)){d=b;var f=2*d.c,g=Array(f),h=uv(d),l=h,m=0;do g[m++]=l.Z.x,g[m++]=l.Z.y,l=vv(d);while(l!==h);d=!Kf(g,0,f,2);Ev(b,c,d)}else{e=a;d=b;f=g=uv(d);do{h=Fv(f,c);if(h.length){g=h[0];h=Lv(f.Z,f.X,g.Z,g.X);h=Iv(e,h[0],h[1],e.a.length/2);l=new sv;m=new Ns;Jv(h,f.X,l,m);f.X=h;Os(c,[Math.min(f.Z.x,h.x),Math.min(f.Z.y,h.y),Math.max(f.Z.x,h.x),Math.max(f.Z.y,
h.y)],f);for(f=vv(d);f!==g;)Jv(f.Z,f.X,l,m),c.remove(f),tv(d),f=zv(d);Jv(g.Z,h,l,m);g.Z=h;Os(c,[Math.min(g.X.x,h.x),Math.min(g.X.y,h.y),Math.max(g.X.x,h.x),Math.max(g.X.y,h.y)],g);Ev(d,c,!1);Hv(e,d,c);Ev(l,m,!1);Hv(e,l,m);break}f=vv(d)}while(f!==g);break}3===b.c&&(e=a.b.length,a.b[e++]=yv(b).Z.mb,a.b[e++]=zv(b).Z.mb,a.b[e++]=wv(b).Z.mb)}
function Ov(a,b,c,d,e){var f=a.b.length,g=uv(b),h=yv(b),l=g,m=vv(b),n=wv(b),p=!1;do{var q=l.Z;var r=l.X;var u=m.X;if(!1===r.Hb){var x=d?0===Mv(q,r,u,c,!0).length:e?Qv(n.X,u,r,q,h.Z):Qv(h.Z,q,r,u,n.X);!d&&0!==Fv({Z:q,X:u},c).length||!x||!d&&!1!==q.Hb&&!1!==u.Hb&&Kf([h.Z.x,h.Z.y,q.x,q.y,r.x,r.y,u.x,u.y,n.X.x,n.X.y],0,10,2)!==!e||(a.b[f++]=q.mb,a.b[f++]=r.mb,a.b[f++]=u.mb,Kv(l,m,b,c),m===g&&(g=n),p=!0)}h=yv(b);l=zv(b);m=vv(b);n=wv(b)}while(l!==g&&3<b.c);return p}
function Pv(a,b,c,d){var e=uv(b);vv(b);var f=e,g=vv(b),h=!1;do{var l=Lv(f.Z,f.X,g.Z,g.X,d);if(l){h=a.b.length;var m=a.a.length/2,n=xv(b);tv(b);c.remove(n);var p=n===e;d?(l[0]===f.Z.x&&l[1]===f.Z.y?(xv(b),l=f.Z,g.Z=l,c.remove(f),p=p||f===e):(l=g.X,f.X=l,c.remove(g),p=p||g===e),tv(b)):(l=Iv(a,l[0],l[1],m),f.X=l,g.Z=l,Os(c,[Math.min(f.Z.x,f.X.x),Math.min(f.Z.y,f.X.y),Math.max(f.Z.x,f.X.x),Math.max(f.Z.y,f.X.y)],f),Os(c,[Math.min(g.Z.x,g.X.x),Math.min(g.Z.y,g.X.y),Math.max(g.Z.x,g.X.x),Math.max(g.Z.y,
g.X.y)],g));a.b[h++]=n.Z.mb;a.b[h++]=n.X.mb;a.b[h++]=l.mb;h=!0;if(p)break}f=yv(b);g=vv(b)}while(f!==e);return h}function Nv(a,b){var c=uv(a),d=c;do{if(Fv(d,b).length)return!1;d=vv(a)}while(d!==c);return!0}function Iv(a,b,c,d){var e=a.a.length;a.a[e++]=b;a.a[e++]=c;return{x:b,y:c,mb:d,Hb:void 0}}
function Jv(a,b,c,d){var e={Z:a,X:b},f={Bb:void 0,next:void 0,data:e},g=c.b;if(g){var h=g.next;f.Bb=g;f.next=h;g.next=f;h&&(h.Bb=f);g===c.a&&(c.a=f)}else c.f=f,c.a=f,c.i&&(f.next=f,f.Bb=f);c.b=f;c.c++;d&&d.Ea([Math.min(a.x,b.x),Math.min(a.y,b.y),Math.max(a.x,b.x),Math.max(a.y,b.y)],e);return e}function Kv(a,b,c,d){zv(c)===b&&(tv(c),a.X=b.X,d.remove(b),Os(d,[Math.min(a.Z.x,a.X.x),Math.min(a.Z.y,a.X.y),Math.max(a.Z.x,a.X.x),Math.max(a.Z.y,a.X.y)],a))}
function Mv(a,b,c,d,e){var f,g,h=[],l=Qs(d,[Math.min(a.x,b.x,c.x),Math.min(a.y,b.y,c.y),Math.max(a.x,b.x,c.x),Math.max(a.y,b.y,c.y)]);d=0;for(f=l.length;d<f;++d)for(g in l[d]){var m=l[d][g];"object"!==typeof m||e&&!m.Hb||m.x===a.x&&m.y===a.y||m.x===b.x&&m.y===b.y||m.x===c.x&&m.y===c.y||-1!==h.indexOf(m)||!Ef([a.x,a.y,b.x,b.y,c.x,c.y],0,6,2,m.x,m.y)||h.push(m)}return h}
function Fv(a,b,c){var d=a.Z,e=a.X;b=Qs(b,[Math.min(d.x,e.x),Math.min(d.y,e.y),Math.max(d.x,e.x),Math.max(d.y,e.y)]);var f=[],g;var h=0;for(g=b.length;h<g;++h){var l=b[h];a!==l&&(c||l.Z!==e||l.X!==d)&&Lv(d,e,l.Z,l.X,c)&&f.push(l)}return f}
function Lv(a,b,c,d,e){var f=(d.y-c.y)*(b.x-a.x)-(d.x-c.x)*(b.y-a.y);if(0!==f&&(d=((d.x-c.x)*(a.y-c.y)-(d.y-c.y)*(a.x-c.x))/f,c=((b.x-a.x)*(a.y-c.y)-(b.y-a.y)*(a.x-c.x))/f,!e&&d>Eu&&d<1-Eu&&c>Eu&&c<1-Eu||e&&0<=d&&1>=d&&0<=c&&1>=c))return[a.x+d*(b.x-a.x),a.y+d*(b.y-a.y)]}
function Qv(a,b,c,d,e){if(void 0===b.Hb||void 0===d.Hb)return!1;var f=(c.x-d.x)*(b.y-d.y)>(c.y-d.y)*(b.x-d.x);e=(e.x-d.x)*(b.y-d.y)<(e.y-d.y)*(b.x-d.x);a=(a.x-b.x)*(d.y-b.y)>(a.y-b.y)*(d.x-b.x);c=(c.x-b.x)*(d.y-b.y)<(c.y-b.y)*(d.x-b.x);b=b.Hb?c||a:c&&a;return(d.Hb?e||f:e&&f)&&b}k=Av.prototype;
k.tc=function(a,b){var c=a.md(),d=a.pa(),e=this.b.length,f=this.g.b.length;a=a.ca();var g,h,l;var m=h=0;for(g=c.length;m<g;++m){var n=c[m];if(0<n.length){var p=Se(a,h,n[0],d,-this.origin[0],-this.origin[1]);if(p.length){var q=[];h=1;for(l=n.length;h<l;++h)if(n[h]!==n[h-1]){var r=Se(a,n[h-1],n[h],d,-this.origin[0],-this.origin[1]);q.push(r)}mv(this.g,p,q,d);Bv(this,p,q,d)}}h=n[n.length-1]}this.b.length>e&&(this.f.push(e),this.i.push(b),this.l.u&&(this.c.push(e),this.l.u=!1));this.g.b.length>f&&nv(this.g,
b,f)};k.vc=function(a,b){var c=a.lb(),d=a.pa();if(0<c.length){a=a.ca().map(Number);var e=Se(a,0,c[0],d,-this.origin[0],-this.origin[1]);if(e.length){var f=[],g;var h=1;for(g=c.length;h<g;++h)if(c[h]!==c[h-1]){var l=Se(a,c[h-1],c[h],d,-this.origin[0],-this.origin[1]);f.push(l)}this.f.push(this.b.length);this.i.push(b);this.l.u&&(this.c.push(this.b.length),this.l.u=!1);nv(this.g,b);mv(this.g,e,f,d);Bv(this,e,f,d)}}};
k.$a=function(a){this.o=new Fu(this.a);this.j=new Fu(this.b);this.f.push(this.b.length);this.g.$a(a);0===this.c.length&&0<this.s.length&&(this.s=[]);this.b=this.a=null};k.Ab=function(a){var b=this.o,c=this.j,d=this.g.Ab(a);return function(){Iu(a,b);Iu(a,c);d()}};k.Bf=function(a,b){var c=Ju(b,pv,qv);if(this.v)var d=this.v;else this.v=d=new rv(a,c);b.Wc(c);a.enableVertexAttribArray(d.b);a.vertexAttribPointer(d.b,2,5126,!1,8,0);return d};k.Cf=function(a,b){a.disableVertexAttribArray(b.b)};
k.Sd=function(a,b,c,d){var e=a.getParameter(a.DEPTH_FUNC),f=a.getParameter(a.DEPTH_WRITEMASK);d||(a.enable(a.DEPTH_TEST),a.depthMask(!0),a.depthFunc(a.NOTEQUAL));if(wb(c)){var g=this.f[this.f.length-1];for(c=this.c.length-1;0<=c;--c){var h=this.c[c];var l=this.s[c];a.uniform4fv(this.v.D,l);zu(a,b,h,g);g=h}}else{var m=this.f.length-2;l=g=this.f[m+1];for(h=this.c.length-1;0<=h;--h){var n=this.s[h];a.uniform4fv(this.v.D,n);for(n=this.c[h];0<=m&&this.f[m]>=n;){var p=this.f[m];var q=this.i[m];q=w(q).toString();
c[q]&&(g!==l&&(zu(a,b,g,l),a.clear(a.DEPTH_BUFFER_BIT)),l=p);m--;g=p}g!==l&&(zu(a,b,g,l),a.clear(a.DEPTH_BUFFER_BIT));g=l=n}}d||(a.disable(a.DEPTH_TEST),a.clear(a.DEPTH_BUFFER_BIT),a.depthMask(f),a.depthFunc(e))};
k.He=function(a,b,c,d,e){var f,g;var h=this.f.length-2;var l=this.f[h+1];for(f=this.c.length-1;0<=f;--f){var m=this.s[f];a.uniform4fv(this.v.D,m);for(g=this.c[f];0<=h&&this.f[h]>=g;){m=this.f[h];var n=this.i[h];var p=w(n).toString();if(void 0===c[p]&&n.W()&&(void 0===e||qb(e,n.W().G()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),zu(a,b,m,l),l=d(n)))return l;h--;l=m}}};
k.La=function(a,b){a=a?a.b:[0,0,0,0];a instanceof CanvasGradient||a instanceof CanvasPattern?a=Au:a=Ph(a).map(function(a,b){return 3!=b?a/255:a})||Au;this.l.fillColor&&ma(a,this.l.fillColor)||(this.l.fillColor=a,this.l.u=!0,this.s.push(a));b?this.g.La(null,b):this.g.La(null,new Dk({color:[0,0,0,0],lineWidth:0}))};function Rv(a,b){this.b=b;this.a=[{x:0,y:0,width:a,height:a}];this.c={};this.f=dg(a,a);this.i=this.f.canvas}Rv.prototype.get=function(a){return this.c[a]||null};
Rv.prototype.add=function(a,b,c,d,e){var f;var g=0;for(f=this.a.length;g<f;++g){var h=this.a[g];if(h.width>=b+this.b&&h.height>=c+this.b)return f={offsetX:h.x+this.b,offsetY:h.y+this.b,image:this.i},this.c[a]=f,d.call(e,this.f,h.x+this.b,h.y+this.b),a=g,b+=this.b,d=c+this.b,h.width-b>h.height-d?(c={x:h.x+b,y:h.y,width:h.width-b,height:h.height},b={x:h.x,y:h.y+d,width:b,height:h.height-d},Sv(this,a,c,b)):(c={x:h.x+b,y:h.y,width:h.width-b,height:d},b={x:h.x,y:h.y+d,width:h.width,height:h.height-d},
Sv(this,a,c,b)),f}return null};function Sv(a,b,c,d){b=[b,1];0<c.width&&0<c.height&&b.push(c);0<d.width&&0<d.height&&b.push(d);a.a.splice.apply(a.a,b)};function Tv(a){a=a||{};this.a=void 0!==a.initialSize?a.initialSize:256;this.f=void 0!==a.maxSize?a.maxSize:void 0!==ba?ba:2048;this.b=void 0!==a.space?a.space:1;this.g=[new Rv(this.a,this.b)];this.c=this.a;this.i=[new Rv(this.c,this.b)]}function Uv(a,b){var c;var d=0;for(c=a.length;d<c;++d){var e=a[d];if(e=e.get(b))return e}return null}function Vv(a,b){return{offsetX:a.offsetX,offsetY:a.offsetY,image:a.image,hm:b.image}}
Tv.prototype.add=function(a,b,c,d,e,f){if(b+this.b>this.f||c+this.b>this.f)return null;d=Wv(this,!1,a,b,c,d,f);if(!d)return null;a=Wv(this,!0,a,b,c,e?e:sa,f);return Vv(d,a)};function Wv(a,b,c,d,e,f,g){var h=b?a.i:a.g,l;var m=0;for(l=h.length;m<l;++m){var n=h[m];if(n=n.add(c,d,e,f,g))return n;n||m!==l-1||(b?(n=Math.min(2*a.c,a.f),a.c=n):(n=Math.min(2*a.a,a.f),a.a=n),n=new Rv(n,a.b),h.push(n),++l)}return null};function Xv(a,b){Uu.call(this,0,b);this.c=[];this.oa=[];this.oc=dg(0,0).canvas;this.O={strokeColor:null,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:0,miterLimit:void 0,fillColor:null,font:void 0,scale:void 0};this.qa="";this.fa=this.ta=this.ma=this.kb=void 0;this.B={};this.l=void 0;this.opacity=this.scale=1}v(Xv,Uu);k=Xv.prototype;
k.Sb=function(a,b){if(this.qa){var c=null,d=2,e=2;switch(a.S()){case "Point":case "MultiPoint":c=a.ca();d=c.length;e=a.pa();break;case "Circle":c=a.xa();break;case "LineString":c=bi(a);break;case "MultiLineString":c=ci(a);d=c.length;break;case "Polygon":c=Pf(a);break;case "MultiPolygon":c=ei(a),d=c.length}this.f.push(this.b.length);this.i.push(b);a=this.l;b=this.qa.split("\n");var f=Yv(this,b),g,h,l=Math.round(f[0]*this.kb-this.ta),m=Math.round(f[1]*this.ma-this.fa),n=this.O.lineWidth/2*this.O.scale;
f=0;for(g=b.length;f<g;++f){var p=0;var q=a.height*f;var r=b[f].split("");var u=0;for(h=r.length;u<h;++u){var x=a.yh;var B=r[u],A=Uv(x.g,B);A?(x=Uv(x.i,B),x=Vv(A,x)):x=null;if(x){A=x.image;this.C=l-p;this.D=m-q;this.I=0===u?x.offsetX-n:x.offsetX;this.T=x.offsetY;this.height=a.height;this.width=0===u||u===r.length-1?a.width[r[u]]+n:a.width[r[u]];this.ra=A.height;this.sa=A.width;0===this.c.length?this.c.push(A):(x=this.c[this.c.length-1],w(x)!=w(A)&&(this.v.push(this.b.length),this.c.push(A)));x=c;
B=d;var y=e;for(A=0;A<B;A+=y)Vu(this,x,B,y)}p+=this.width}}}};function Yv(a,b){var c=a.l,d=b.length*c.height;return[b.map(function(b){var d=0,e;var h=0;for(e=b.length;h<e;++h){var l=b[h];c.width[l]||Zv(a,l);d+=c.width[l]?c.width[l]:0}return d}).reduce(function(a,b){return Math.max(a,b)}),d]}
function Zv(a,b){if(1===b.length){var c=a.l,d=a.O;a=a.oc.getContext("2d");a.font=d.font;a=Math.ceil(a.measureText(b).width*d.scale);c.yh.add(b,a,c.height,function(a,c,g){a.font=d.font;a.fillStyle=d.fillColor;a.strokeStyle=d.strokeColor;a.lineWidth=d.lineWidth;a.lineCap=d.lineCap;a.lineJoin=d.lineJoin;a.miterLimit=d.miterLimit;a.textAlign="left";a.textBaseline="top";qd&&d.lineDash&&(a.setLineDash(d.lineDash),a.lineDashOffset=d.lineDashOffset);1!==d.scale&&a.setTransform(d.scale,0,0,d.scale,0,0);d.strokeColor&&
a.strokeText(b,c,g);d.fillColor&&a.fillText(b,c,g)})&&(c.width[b]=a)}}k.$a=function(a){var b=a.b;this.v.push(this.b.length);this.s=this.v;this.o=new Fu(this.a);this.j=new Fu(this.b);Wu(this.oa,this.c,{},b);this.O={strokeColor:null,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:0,miterLimit:void 0,fillColor:null,font:void 0,scale:void 0};this.qa="";this.fa=this.ta=this.ma=this.kb=void 0;this.c=null;this.B={};this.l=void 0;Uu.prototype.$a.call(this,a)};
k.ib=function(a){var b=this.O,c=a.Ca(),d=a.Da();if(a&&a.Ia()&&(c||d)){c?(c=c.b,b.fillColor=Th(c?c:Au)):b.fillColor=null;d?(c=d.b,b.strokeColor=Th(c?c:Cu),b.lineWidth=d.c||1,b.lineCap=d.g||"round",b.lineDashOffset=d.i||0,b.lineJoin=d.j||"round",b.miterLimit=d.l||10,d=d.f,b.lineDash=d?d.slice():Bu):(b.strokeColor=null,b.lineWidth=0);b.font=a.a||"10px sans-serif";b.scale=a.b||1;this.qa=a.Ia();d=ej[a.g];c=ej[a.j];this.kb=void 0===d?.5:d;this.ma=void 0===c?.5:c;this.ta=a.f||0;this.fa=a.c||0;this.rotateWithView=
!!a.l;this.rotation=a.i||0;a=[];for(var e in b)if(b[e]||0===b[e])Array.isArray(b[e])?a=a.concat(b[e]):a.push(b[e]);c="";e=0;for(d=a.length;e<d;++e)c+=a[e];e=c;this.B[e]||(a=this.oc.getContext("2d"),a.font=b.font,a=Math.ceil((1.5*a.measureText("M").width+b.lineWidth/2)*b.scale),this.B[e]={yh:new Tv({space:b.lineWidth+1}),width:{},height:a});this.l=this.B[e]}else this.qa=""};k.jg=function(){return this.oa};k.bg=function(){return this.oa};function $v(a,b,c){this.g=b;this.j=a;this.i=c;this.f={}}v($v,Mi);function aw(a,b){var c=[],d;for(d in a.f){var e=a.f[d],f;for(f in e)c.push(e[f].Ab(b))}return function(){for(var a=c.length,b,d=0;d<a;d++)b=c[d].apply(this,arguments);return b}}function bw(a,b){for(var c in a.f){var d=a.f[c],e;for(e in d)d[e].$a(b)}}$v.prototype.b=function(a,b){var c=void 0!==a?a.toString():"0";a=this.f[c];void 0===a&&(a={},this.f[c]=a);c=a[b];void 0===c&&(c=new cw[b](this.j,this.g),a[b]=c);return c};
$v.prototype.c=function(){return wb(this.f)};$v.prototype.Ka=function(a,b,c,d,e,f,g,h){var l=Object.keys(this.f).map(Number);l.sort(ea);var m,n;var p=0;for(m=l.length;p<m;++p){var q=this.f[l[p].toString()];var r=0;for(n=dj.length;r<n;++r){var u=q[dj[r]];void 0!==u&&u.Ka(a,b,c,d,e,f,g,h,void 0,!1)}}};
function dw(a,b,c,d,e,f,g,h,l,m,n){var p=ew,q=Object.keys(a.f).map(Number);q.sort(function(a,b){return b-a});var r,u;var x=0;for(r=q.length;x<r;++x){var B=a.f[q[x].toString()];for(u=dj.length-1;0<=u;--u){var A=B[dj[u]];if(void 0!==A&&(A=A.Ka(b,c,d,e,p,f,g,h,l,m,n)))return A}}}
$v.prototype.Fa=function(a,b,c,d,e,f,g,h,l,m){var n=b.b;n.bindFramebuffer(n.FRAMEBUFFER,Pu(b));var p;void 0!==this.i&&(p=Ra($a(a),d*this.i));return dw(this,b,a,d,e,g,h,l,function(a){var b=new Uint8Array(4);n.readPixels(0,0,1,1,n.RGBA,n.UNSIGNED_BYTE,b);if(0<b[3]&&(a=m(a)))return a},!0,p)};
function fw(a,b,c,d,e,f,g,h){var l=c.b;l.bindFramebuffer(l.FRAMEBUFFER,Pu(c));return void 0!==dw(a,c,b,d,e,f,g,h,function(){var a=new Uint8Array(4);l.readPixels(0,0,1,1,l.RGBA,l.UNSIGNED_BYTE,a);return 0<a[3]},!1)}var ew=[1,1],cw={Circle:Hu,Image:Xu,LineString:av,Polygon:Av,Text:Xv};function gw(a,b,c,d,e,f,g){this.b=a;this.f=b;this.c=f;this.i=g;this.l=e;this.j=d;this.g=c;this.a=this.o=this.v=this.s=null}v(gw,Uh);function hw(a,b,c){var d=a.b;b=b.b(0,"Text");b.ib(a.a);b.Sb(c,null);b.$a(d);b.Ka(a.b,a.f,a.g,a.j,a.l,a.i,1,{},void 0,!1);b.Ab(d)()}k=gw.prototype;k.zd=function(a){this.La(a.Ca(),a.Da());this.Wb(a.Y());this.ib(a.Ia())};
k.Fb=function(a){switch(a.S()){case "Point":this.uc(a,null);break;case "LineString":this.qc(a,null);break;case "Polygon":this.vc(a,null);break;case "MultiPoint":this.sc(a,null);break;case "MultiLineString":this.rc(a,null);break;case "MultiPolygon":this.tc(a,null);break;case "GeometryCollection":this.Ge(a,null);break;case "Circle":this.$b(a,null)}};k.Fe=function(a,b){(a=(0,b.Za)(a))&&qb(this.c,a.G())&&(this.zd(b),this.Fb(a))};k.Ge=function(a){a=a.a;var b;var c=0;for(b=a.length;c<b;++c)this.Fb(a[c])};
k.uc=function(a,b){var c=this.b,d=new $v(1,this.c),e=d.b(0,"Image");e.Wb(this.s);e.uc(a,b);e.$a(c);e.Ka(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.Ab(c)();this.a&&hw(this,d,a)};k.sc=function(a,b){var c=this.b,d=new $v(1,this.c),e=d.b(0,"Image");e.Wb(this.s);e.sc(a,b);e.$a(c);e.Ka(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.Ab(c)();this.a&&hw(this,d,a)};
k.qc=function(a,b){var c=this.b,d=new $v(1,this.c),e=d.b(0,"LineString");e.La(null,this.o);e.qc(a,b);e.$a(c);e.Ka(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.Ab(c)();this.a&&hw(this,d,a)};k.rc=function(a,b){var c=this.b,d=new $v(1,this.c),e=d.b(0,"LineString");e.La(null,this.o);e.rc(a,b);e.$a(c);e.Ka(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.Ab(c)();this.a&&hw(this,d,a)};
k.vc=function(a,b){var c=this.b,d=new $v(1,this.c),e=d.b(0,"Polygon");e.La(this.v,this.o);e.vc(a,b);e.$a(c);e.Ka(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.Ab(c)();this.a&&hw(this,d,a)};k.tc=function(a,b){var c=this.b,d=new $v(1,this.c),e=d.b(0,"Polygon");e.La(this.v,this.o);e.tc(a,b);e.$a(c);e.Ka(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.Ab(c)();this.a&&hw(this,d,a)};
k.$b=function(a,b){var c=this.b,d=new $v(1,this.c),e=d.b(0,"Circle");e.La(this.v,this.o);e.$b(a,b);e.$a(c);e.Ka(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.Ab(c)();this.a&&hw(this,d,a)};k.Wb=function(a){this.s=a};k.La=function(a,b){this.v=a;this.o=b};k.ib=function(a){this.a=a};var iw=new qu("precision mediump float;varying vec2 a;uniform float f;uniform sampler2D g;void main(void){vec4 texColor=texture2D(g,a);gl_FragColor.rgb=texColor.rgb;gl_FragColor.a=texColor.a*f;}"),jw=new ru("varying vec2 a;attribute vec2 b;attribute vec2 c;uniform mat4 d;uniform mat4 e;void main(void){gl_Position=e*vec4(b,0.,1.);a=(d*vec4(c,0.,1.)).st;}");function kw(a,b){this.g=a.getUniformLocation(b,"d");this.c=a.getUniformLocation(b,"e");this.f=a.getUniformLocation(b,"f");this.i=a.getUniformLocation(b,"g");this.b=a.getAttribLocation(b,"b");this.a=a.getAttribLocation(b,"c")};function lw(a,b){fi.call(this,b);this.c=a;this.U=new Fu([-1,-1,0,0,1,-1,1,0,-1,1,0,1,1,1,1,1]);this.g=this.Kb=null;this.j=void 0;this.v=Ue();this.O=Ue();this.D=vu();this.s=null}v(lw,fi);
function mw(a,b,c){var d=a.c.f;if(void 0===a.j||a.j!=c){b.postRenderFunctions.push(function(a,b,c){a.isContextLost()||(a.deleteFramebuffer(b),a.deleteTexture(c))}.bind(null,d,a.g,a.Kb));b=Qu(d,c,c);var e=d.createFramebuffer();d.bindFramebuffer(36160,e);d.framebufferTexture2D(36160,36064,3553,b,0);a.Kb=b;a.g=e;a.j=c}else d.bindFramebuffer(36160,a.g)}
lw.prototype.Ti=function(a,b,c){nw(this,"precompose",c,a);yu(c,34962,this.U);var d=c.b,e=Ju(c,iw,jw);if(this.s)var f=this.s;else this.s=f=new kw(d,e);c.Wc(e)&&(d.enableVertexAttribArray(f.b),d.vertexAttribPointer(f.b,2,5126,!1,16,0),d.enableVertexAttribArray(f.a),d.vertexAttribPointer(f.a,2,5126,!1,16,8),d.uniform1i(f.i,0));d.uniformMatrix4fv(f.g,!1,wu(this.D,this.v));d.uniformMatrix4fv(f.c,!1,wu(this.D,this.O));d.uniform1f(f.f,b.opacity);d.bindTexture(3553,this.Kb);d.drawArrays(5,0,4);nw(this,"postcompose",
c,a)};function nw(a,b,c,d){a=a.a;if(Uc(a,b)){var e=d.viewState;a.b(new Ih(b,new gw(c,e.center,e.resolution,e.rotation,d.size,d.extent,d.pixelRatio),d,null,c))}}lw.prototype.yg=function(){this.g=this.Kb=null;this.j=void 0};function ow(a,b,c,d){var e=kc(c,b,a);c=Yb(b,d,c);b=b.Rc();void 0!==b&&(c*=b);b=a.Rc();void 0!==b&&(c/=b);b=a.G();if(!b||Ua(b,e))a=Yb(a,c,e)/c,isFinite(a)&&0<a&&(c/=a);return c}function pw(a,b,c,d){a=c-a;b=d-b;var e=Math.sqrt(a*a+b*b);return[Math.round(c+a/e),Math.round(d+b/e)]}
function qw(a,b,c,d,e,f,g,h,l,m,n){var p=dg(Math.round(c*a),Math.round(c*b));if(0===l.length)return p.canvas;p.scale(c,c);var q=Pa();l.forEach(function(a){db(q,a.extent)});var r=dg(Math.round(c*lb(q)/d),Math.round(c*mb(q)/d)),u=c/d;l.forEach(function(a){r.drawImage(a.image,m,m,a.image.width-2*m,a.image.height-2*m,(a.extent[0]-q[0])*u,-(a.extent[3]-q[3])*u,lb(a.extent)*u,mb(a.extent)*u)});var x=ib(g);h.c.forEach(function(a){var b=a.source,e=a.target,g=b[1][0],h=b[1][1],l=b[2][0],m=b[2][1];a=(e[0][0]-
x[0])/f;var n=-(e[0][1]-x[1])/f,u=(e[1][0]-x[0])/f,B=-(e[1][1]-x[1])/f,U=(e[2][0]-x[0])/f,Xb=-(e[2][1]-x[1])/f;e=b[0][0];b=b[0][1];g-=e;h-=b;l-=e;m-=b;a:{g=[[g,h,0,0,u-a],[l,m,0,0,U-a],[0,0,g,h,B-n],[0,0,l,m,Xb-n]];h=g.length;for(l=0;l<h;l++){m=l;for(var Ca=Math.abs(g[l][l]),Cb=l+1;Cb<h;Cb++){var nc=Math.abs(g[Cb][l]);nc>Ca&&(Ca=nc,m=Cb)}if(0===Ca){g=null;break a}Ca=g[m];g[m]=g[l];g[l]=Ca;for(m=l+1;m<h;m++)for(Ca=-g[m][l]/g[l][l],Cb=l;Cb<h+1;Cb++)g[m][Cb]=l==Cb?0:g[m][Cb]+Ca*g[l][Cb]}l=Array(h);for(m=
h-1;0<=m;m--)for(l[m]=g[m][h]/g[m][m],Ca=m-1;0<=Ca;Ca--)g[Ca][h]-=g[Ca][m]*l[m];g=l}g&&(p.save(),p.beginPath(),l=(a+u+U)/3,m=(n+B+Xb)/3,h=pw(l,m,a,n),u=pw(l,m,u,B),U=pw(l,m,U,Xb),p.moveTo(u[0],u[1]),p.lineTo(h[0],h[1]),p.lineTo(U[0],U[1]),p.clip(),p.transform(g[0],g[2],g[1],g[3],a,n),p.translate(q[0]-e,q[3]-b),p.scale(d/c,-d/c),p.drawImage(r.canvas,0,0),p.restore())});n&&(p.save(),p.strokeStyle="black",p.lineWidth=1,h.c.forEach(function(a){var b=a.target;a=(b[0][0]-x[0])/f;var c=-(b[0][1]-x[1])/f,
d=(b[1][0]-x[0])/f,e=-(b[1][1]-x[1])/f,g=(b[2][0]-x[0])/f;b=-(b[2][1]-x[1])/f;p.beginPath();p.moveTo(d,e);p.lineTo(a,c);p.lineTo(g,b);p.closePath();p.stroke()}),p.restore());return p.canvas};function rw(a,b,c,d,e){this.f=a;this.i=b;var f={},g=ic(this.i,this.f);this.a=function(a){var b=a[0]+"/"+a[1];f[b]||(f[b]=g(a));return f[b]};this.g=d;this.v=e*e;this.c=[];this.l=!1;this.o=this.f.f&&!!d&&!!this.f.G()&&lb(d)==lb(this.f.G());this.b=this.f.G()?lb(this.f.G()):null;this.j=this.i.G()?lb(this.i.G()):null;a=ib(c);b=hb(c);d=gb(c);c=fb(c);e=this.a(a);var h=this.a(b),l=this.a(d),m=this.a(c);sw(this,a,b,d,c,e,h,l,m,10);if(this.l){var n=Infinity;this.c.forEach(function(a){n=Math.min(n,a.source[0][0],
a.source[1][0],a.source[2][0])});this.c.forEach(function(a){if(Math.max(a.source[0][0],a.source[1][0],a.source[2][0])-n>this.b/2){var b=[[a.source[0][0],a.source[0][1]],[a.source[1][0],a.source[1][1]],[a.source[2][0],a.source[2][1]]];b[0][0]-n>this.b/2&&(b[0][0]-=this.b);b[1][0]-n>this.b/2&&(b[1][0]-=this.b);b[2][0]-n>this.b/2&&(b[2][0]-=this.b);Math.max(b[0][0],b[1][0],b[2][0])-Math.min(b[0][0],b[1][0],b[2][0])<this.b/2&&(a.source=b)}},this)}f={}}
function sw(a,b,c,d,e,f,g,h,l,m){var n=Oa([f,g,h,l]),p=a.b?lb(n)/a.b:null,q=a.b,r=a.f.f&&.5<p&&1>p,u=!1;if(0<m){if(a.i.c&&a.j){var x=Oa([b,c,d,e]);u|=.25<lb(x)/a.j}!r&&a.f.c&&p&&(u|=.25<p)}if(u||!a.g||qb(n,a.g)){if(!(u||isFinite(f[0])&&isFinite(f[1])&&isFinite(g[0])&&isFinite(g[1])&&isFinite(h[0])&&isFinite(h[1])&&isFinite(l[0])&&isFinite(l[1])))if(0<m)u=!0;else return;if(0<m&&(u||(n=a.a([(b[0]+d[0])/2,(b[1]+d[1])/2]),q=r?(Ja(f[0],q)+Ja(h[0],q))/2-Ja(n[0],q):(f[0]+h[0])/2-n[0],n=(f[1]+h[1])/2-n[1],
u=q*q+n*n>a.v),u)){Math.abs(b[0]-d[0])<=Math.abs(b[1]-d[1])?(r=[(c[0]+d[0])/2,(c[1]+d[1])/2],q=a.a(r),n=[(e[0]+b[0])/2,(e[1]+b[1])/2],p=a.a(n),sw(a,b,c,r,n,f,g,q,p,m-1),sw(a,n,r,d,e,p,q,h,l,m-1)):(r=[(b[0]+c[0])/2,(b[1]+c[1])/2],q=a.a(r),n=[(d[0]+e[0])/2,(d[1]+e[1])/2],p=a.a(n),sw(a,b,r,n,e,f,q,p,l,m-1),sw(a,r,c,d,n,q,g,h,p,m-1));return}if(r){if(!a.o)return;a.l=!0}a.c.push({source:[f,h,l],target:[b,d,e]});a.c.push({source:[f,g,h],target:[b,c,d]})}}
function tw(a){var b=Pa();a.c.forEach(function(a){a=a.source;Qa(b,a[0]);Qa(b,a[1]);Qa(b,a[2])});return b};function uw(a,b,c,d,e,f){this.v=b;this.o=a.G();var g=b.G(),h=g?pb(c,g):c;g=ow(a,b,nb(h),d);this.j=new rw(a,b,h,this.o,.5*g);this.i=d;this.f=c;a=tw(this.j);this.l=(this.Jb=f(a,g,e))?this.Jb.a:1;this.me=this.g=null;e=2;f=[];this.Jb&&(e=0,f=this.Jb.c);ps.call(this,c,d,this.l,e,f)}v(uw,ps);uw.prototype.ka=function(){1==this.state&&(Hc(this.me),this.me=null);ps.prototype.ka.call(this)};uw.prototype.Y=function(){return this.g};
uw.prototype.je=function(){var a=this.Jb.getState();2==a&&(this.g=qw(lb(this.f)/this.i,mb(this.f)/this.i,this.l,this.Jb.resolution,0,this.i,this.f,this.j,[{extent:this.Jb.G(),image:this.Jb.Y()}],0));this.state=a;this.u()};uw.prototype.load=function(){if(0==this.state){this.state=1;this.u();var a=this.Jb.getState();2==a||3==a?this.je():(this.me=z(this.Jb,"change",function(){var a=this.Jb.getState();if(2==a||3==a)Hc(this.me),this.me=null,this.je()},this),this.Jb.load())}};function vw(a){Ks.call(this,{attributions:a.attributions,extent:a.extent,logo:a.logo,projection:a.projection,state:a.state});this.s=void 0!==a.resolutions?a.resolutions:null;this.i=null;this.fa=0}v(vw,Ks);function ww(a,b){a.s&&(b=a.s[ia(a.s,b,0)]);return b}
vw.prototype.Y=function(a,b,c,d){var e=this.c;if(e&&d&&!hc(e,d)){if(this.i){if(this.fa==this.f&&hc(this.i.v,d)&&this.i.resolution==b&&cb(this.i.G(),a))return this.i;Qc(this.i);this.i=null}this.i=new uw(e,d,a,b,c,function(a,b,c){return this.Qc(a,b,c,e)}.bind(this));this.fa=this.f;return this.i}e&&(d=e);return this.Qc(a,b,c,d)};vw.prototype.l=function(a){a=a.target;switch(a.getState()){case 1:this.b(new xw(yw,a));break;case 2:this.b(new xw(zw,a));break;case 3:this.b(new xw(Aw,a))}};
function Bw(a,b){a.Y().src=b}function xw(a,b){Rc.call(this,a);this.image=b}v(xw,Rc);var yw="imageloadstart",zw="imageloadend",Aw="imageloaderror";function Cw(a){vw.call(this,{attributions:a.attributions,logo:a.logo,projection:a.projection,resolutions:a.resolutions,state:a.state});this.ma=a.canvasFunction;this.T=null;this.U=0;this.oa=void 0!==a.ratio?a.ratio:1.5}v(Cw,vw);Cw.prototype.Qc=function(a,b,c,d){b=ww(this,b);var e=this.T;if(e&&this.U==this.f&&e.resolution==b&&e.a==c&&Wa(e.G(),a))return e;a=a.slice();rb(a,this.oa);(d=this.ma(a,b,c,[lb(a)/b*c,mb(a)/b*c],d))&&(e=new rs(a,b,c,this.j,d));this.T=e;this.U=this.f;return e};function Dw(a){this.a=a.source;this.ab=Ue();this.g=dg();this.o=[0,0];this.Va=void 0==a.renderBuffer?100:a.renderBuffer;this.B=null;Cw.call(this,{attributions:a.attributions,canvasFunction:this.Ek.bind(this),logo:a.logo,projection:a.projection,ratio:a.ratio,resolutions:a.resolutions,state:this.a.getState()});this.I=null;this.v=void 0;this.Vi(a.style);z(this.a,"change",this.zo,this)}v(Dw,Cw);k=Dw.prototype;
k.Ek=function(a,b,c,d,e){var f=new nj(.5*b/c,a,b,c,this.a.U,this.Va);this.a.ce(a,b,e);var g=!1;this.a.ac(a,function(a){var d;if(!(d=g)){var e;(d=a.bb())?e=d.call(a,b):this.v&&(e=this.v(a,b));if(e){var h,p=!1;Array.isArray(e)||(e=[e]);d=0;for(h=e.length;d<h;++d)p=xj(f,a,e[d],wj(b,c),this.yo,this)||p;d=p}else d=!1}g=d},this);rj(f);if(g)return null;this.o[0]!=d[0]||this.o[1]!=d[1]?(this.g.canvas.width=d[0],this.g.canvas.height=d[1],this.o[0]=d[0],this.o[1]=d[1]):this.g.clearRect(0,0,d[0],d[1]);a=Ew(this,
nb(a),b,c,d);f.Ka(this.g,a,0,{});this.B=f;return this.g.canvas};k.Fa=function(a,b,c,d,e,f){if(this.B){var g={};return this.B.Fa(a,b,0,d,e,function(a){var b=w(a).toString();if(!(b in g))return g[b]=!0,f(a)})}};k.wo=function(){return this.a};k.xo=function(){return this.I};k.bb=function(){return this.v};function Ew(a,b,c,d,e){c=d/c;return cf(a.ab,e[0]/2,e[1]/2,c,-c,0,-b[0],-b[1])}k.yo=function(){this.u()};k.zo=function(){Ms(this,this.a.getState())};
k.Vi=function(a){this.I=void 0!==a?a:Ik;this.v=a?Gk(this.I):void 0;this.u()};function Fw(a,b){lw.call(this,a,b);this.l=this.i=this.N=null}v(Fw,lw);Fw.handles=function(a,b){return"webgl"===a&&"IMAGE"===b.S()};Fw.create=function(a,b){return new Fw(a,b)};function Gw(a,b){b=b.Y();return Tu(a.c.f,b)}Fw.prototype.Fa=function(a,b,c,d,e){var f=this.a;return f.ia().Fa(a,b.viewState.resolution,b.viewState.rotation,c,b.skippedFeatureUids,function(a){return d.call(e,a,f)})};
Fw.prototype.zg=function(a,b){var c=this.c.f,d=a.pixelRatio,e=a.viewState,f=e.center,g=e.resolution,h=e.rotation,l=this.N,m=this.Kb,n=this.a.ia(),p=a.viewHints,q=a.extent;void 0!==b.extent&&(q=pb(q,b.extent));p[0]||p[1]||kb(q)||(b=n.Y(q,g,d,e.projection))&&ii(this,b)&&(l=b,m=Gw(this,b),this.Kb&&a.postRenderFunctions.push(function(a,b){a.isContextLost()||a.deleteTexture(b)}.bind(null,c,this.Kb)));l&&(c=this.c.getContext().j,Hw(this,c.width,c.height,d,f,g,h,l.G()),this.l=null,d=this.v,Ve(d),af(d,1,
-1),bf(d,0,-1),this.N=l,this.Kb=m,ki(a.attributions,l.c),li(a,n));return!!l};function Hw(a,b,c,d,e,f,g,h){b*=f;c*=f;a=a.O;Ve(a);af(a,2*d/b,2*d/c);$e(a,-g);bf(a,h[0]-e[0],h[1]-e[1]);af(a,(h[2]-h[0])/2,(h[3]-h[1])/2);bf(a,1,1)}Fw.prototype.df=function(a,b){return void 0!==this.Fa(a,b,0,Pe,this)};
Fw.prototype.xg=function(a,b,c,d){if(this.N&&this.N.Y())if(this.a.ia()instanceof Dw){var e=Ze(b.pixelToCoordinateTransform,a.slice());if(this.Fa(e,b,0,Pe,this))return c.call(d,this.a,null)}else{e=[this.N.Y().width,this.N.Y().height];if(!this.l){var f=b.size;b=Ue();bf(b,-1,-1);af(b,2/f[0],2/f[1]);bf(b,0,f[1]);af(b,1,-1);f=df(this.O.slice());var g=Ue();bf(g,0,e[1]);af(g,1,-1);af(g,e[0]/2,e[1]/2);bf(g,1,1);Xe(g,f);Xe(g,b);this.l=g}a=Ze(this.l,a.slice());if(!(0>a[0]||a[0]>e[0]||0>a[1]||a[1]>e[1])&&(this.i||
(this.i=dg(1,1)),this.i.clearRect(0,0,1,1),this.i.drawImage(this.N.Y(),a[0],a[1],1,1,0,0,1,1),e=this.i.getImageData(0,0,1,1).data,0<e[3]))return c.call(d,this.a,e)}};function Iw(a,b){Ai.call(this,0,b);this.b=document.createElement("CANVAS");this.b.style.width="100%";this.b.style.height="100%";this.b.style.display="block";this.b.className="ol-unselectable";a.insertBefore(this.b,a.childNodes[0]||null);this.O=this.C=0;this.D=dg();this.l=!0;this.f=hd(this.b,{antialias:!0,depth:!0,failIfMajorPerformanceCaveat:!0,preserveDrawingBuffer:!1,stencil:!0});this.v=new Ou(this.b,this.f);z(this.b,"webglcontextlost",this.io,this);z(this.b,"webglcontextrestored",this.jo,this);
this.a=new fj;this.s=null;this.g=new he(function(a){var b=a[1];a=a[2];var c=b[0]-this.s[0];b=b[1]-this.s[1];return 65536*Math.log(a)+Math.sqrt(c*c+b*b)/a}.bind(this),function(a){return a[0].gb()});this.B=function(){if(0!==this.g.b.length){le(this.g);var a=ie(this.g);Jw(this,a[0],a[3],a[4])}return!1}.bind(this);this.i=0;Kw(this)}v(Iw,Ai);Iw.handles=function(a){return id&&"webgl"===a};Iw.create=function(a,b){return new Iw(a,b)};
function Jw(a,b,c,d){var e=a.f,f=b.gb();if(a.a.b.hasOwnProperty(f))a=a.a.get(f),e.bindTexture(3553,a.Kb),9729!=a.ei&&(e.texParameteri(3553,10240,9729),a.ei=9729),9729!=a.gi&&(e.texParameteri(3553,10241,9729),a.gi=9729);else{var g=e.createTexture();e.bindTexture(3553,g);if(0<d){var h=a.D.canvas,l=a.D;a.C!==c[0]||a.O!==c[1]?(h.width=c[0],h.height=c[1],a.C=c[0],a.O=c[1]):l.clearRect(0,0,c[0],c[1]);l.drawImage(b.Y(),d,d,c[0],c[1],0,0,c[0],c[1]);e.texImage2D(3553,0,6408,6408,5121,h)}else e.texImage2D(3553,
0,6408,6408,5121,b.Y());e.texParameteri(3553,10240,9729);e.texParameteri(3553,10241,9729);e.texParameteri(3553,10242,33071);e.texParameteri(3553,10243,33071);a.a.set(f,{Kb:g,ei:9729,gi:9729})}}function Lw(a,b,c){var d=a.j;if(Uc(d,b)){a=a.v;var e=c.viewState;d.b(new Ih(b,new gw(a,e.center,e.resolution,e.rotation,c.size,c.extent,c.pixelRatio),c,null,a))}}k=Iw.prototype;k.ka=function(){var a=this.f;a.isContextLost()||this.a.forEach(function(b){b&&a.deleteTexture(b.Kb)});Qc(this.v);Ai.prototype.ka.call(this)};
k.Ik=function(a,b){a=this.f;for(var c;1024<this.a.c-this.i;){if(c=this.a.a.Hc)a.deleteTexture(c.Kb);else if(+this.a.a.fc==b.index)break;else--this.i;this.a.pop()}};k.getContext=function(){return this.v};k.S=function(){return"webgl"};k.io=function(a){a.preventDefault();this.a.clear();this.i=0;a=this.c;for(var b in a)a[b].yg()};k.jo=function(){Kw(this);this.j.render()};
function Kw(a){a=a.f;a.activeTexture(33984);a.blendFuncSeparate(770,771,1,771);a.disable(2884);a.disable(2929);a.disable(3089);a.disable(2960)}
k.$g=function(a){var b=this.getContext(),c=this.f;if(c.isContextLost())return!1;if(!a)return this.l&&(this.b.style.display="none",this.l=!1),!1;this.s=a.focus;this.a.set((-a.index).toString(),null);++this.i;Lw(this,"precompose",a);var d=[],e=a.layerStatesArray;na(e);var f=a.viewState.resolution,g;var h=0;for(g=e.length;h<g;++h){var l=e[h];if(xi(l,f)&&"ready"==l.Nj){var m=Di(this,l.layer);m.zg(a,l,b)&&d.push(l)}}e=a.size[0]*a.pixelRatio;f=a.size[1]*a.pixelRatio;if(this.b.width!=e||this.b.height!=f)this.b.width=
e,this.b.height=f;c.bindFramebuffer(36160,null);c.clearColor(0,0,0,0);c.clear(16384);c.enable(3042);c.viewport(0,0,this.b.width,this.b.height);h=0;for(g=d.length;h<g;++h)l=d[h],m=Di(this,l.layer),m.Ti(a,l,b);this.l||(this.b.style.display="",this.l=!0);Bi(a);1024<this.a.c-this.i&&a.postRenderFunctions.push(this.Ik.bind(this));0!==this.g.b.length&&(a.postRenderFunctions.push(this.B),a.animate=!0);Lw(this,"postcompose",a);Ei(this,a);a.postRenderFunctions.push(Ci)};
k.Fa=function(a,b,c,d,e,f,g){if(this.f.isContextLost())return!1;var h=b.viewState,l=b.layerStatesArray,m;for(m=l.length-1;0<=m;--m){var n=l[m];var p=n.layer;if(xi(n,h.resolution)&&f.call(g,p)&&(n=Di(this,p).Fa(a,b,c,d,e)))return n}};k.Ri=function(a,b,c,d,e){c=!1;if(this.f.isContextLost())return!1;var f=b.viewState,g=b.layerStatesArray,h;for(h=g.length-1;0<=h;--h){var l=g[h],m=l.layer;if(xi(l,f.resolution)&&d.call(e,m)&&(c=Di(this,m).df(a,b)))return!0}return c};
k.Qi=function(a,b,c,d,e){if(this.f.isContextLost())return!1;var f=b.viewState,g=b.layerStatesArray,h;for(h=g.length-1;0<=h;--h){var l=g[h];var m=l.layer;if(xi(l,f.resolution)&&e.call(d,m)&&(l=Di(this,m).xg(a,b,c,d)))return l}};var Mw=new qu("precision mediump float;varying vec2 a;uniform sampler2D e;void main(void){gl_FragColor=texture2D(e,a);}"),Nw=new ru("varying vec2 a;attribute vec2 b;attribute vec2 c;uniform vec4 d;void main(void){gl_Position=vec4(b*d.xy+d.zw,0.,1.);a=c;}");function Ow(a,b){this.c=a.getUniformLocation(b,"d");this.f=a.getUniformLocation(b,"e");this.b=a.getAttribLocation(b,"b");this.a=a.getAttribLocation(b,"c")};function Pw(a,b){lw.call(this,a,b);this.I=Mw;this.fa=Nw;this.i=null;this.B=new Fu([0,0,0,1,1,0,1,1,0,1,0,0,1,1,1,0]);this.C=this.l=null;this.o=-1;this.T=[0,0]}v(Pw,lw);Pw.handles=function(a,b){return"webgl"===a&&"TILE"===b.S()};Pw.create=function(a,b){return new Pw(a,b)};k=Pw.prototype;k.ka=function(){Iu(this.c.getContext(),this.B);lw.prototype.ka.call(this)};
k.Rf=function(a,b,c){var d=this.c;return function(e,f){return gi(a,b,e,f,function(a){var b=d.a.b.hasOwnProperty(a.gb());b&&(c[e]||(c[e]={}),c[e][a.wa.toString()]=a);return b})}};k.yg=function(){lw.prototype.yg.call(this);this.i=null};
k.zg=function(a,b,c){var d=this.c,e=c.b,f=a.viewState,g=f.projection,h=this.a,l=h.ia(),m=l.Xa(g),n=m.xc(f.resolution),p=m.Qa(n),q=l.be(n,a.pixelRatio,g),r=q[0]/Na(m.eb(n),this.T)[0],u=p/r,x=l.Sc(r)*l.$f(g),B=f.center,A=a.extent,y=tc(m,A,n);if(this.l&&Aa(this.l,y)&&this.o==l.f)u=this.C;else{var N=[y.da-y.ba+1,y.ga-y.ea+1],ca=Fa(Math.max(N[0]*q[0],N[1]*q[1]));N=u*ca;var la=m.Cc(n),fa=la[0]+y.ba*q[0]*u;u=la[1]+y.ea*q[1]*u;u=[fa,u,fa+N,u+N];mw(this,a,ca);e.viewport(0,0,ca,ca);e.clearColor(0,0,0,0);e.clear(16384);
e.disable(3042);ca=Ju(c,this.I,this.fa);c.Wc(ca);this.i||(this.i=new Ow(e,ca));yu(c,34962,this.B);e.enableVertexAttribArray(this.i.b);e.vertexAttribPointer(this.i.b,2,5126,!1,16,0);e.enableVertexAttribArray(this.i.a);e.vertexAttribPointer(this.i.a,2,5126,!1,16,8);e.uniform1i(this.i.f,0);c={};c[n]={};var va=this.Rf(l,g,c),ra=h.i();ca=!0;fa=Pa();var T=new xa(0,0,0,0),U,Xb;for(U=y.ba;U<=y.da;++U)for(Xb=y.ea;Xb<=y.ga;++Xb){la=l.Uc(n,U,Xb,r,g);if(void 0!==b.extent){var Ca=m.Ja(la.wa,fa);if(!qb(Ca,b.extent))continue}Ca=
la.getState();(Ca=2==Ca||4==Ca||3==Ca&&!ra)||(la=Ki(la));Ca=la.getState();if(2==Ca){if(d.a.b.hasOwnProperty(la.gb())){c[n][la.wa.toString()]=la;continue}}else if(4==Ca||3==Ca&&!ra)continue;ca=!1;Ca=uc(m,la.wa,va,T,fa);Ca||(la=vc(m,la.wa,T,fa))&&va(n+1,la)}b=Object.keys(c).map(Number);b.sort(ea);va=new Float32Array(4);var Cb;ra=0;for(T=b.length;ra<T;++ra)for(Cb in U=c[b[ra]],U)la=U[Cb],Ca=m.Ja(la.wa,fa),va[0]=2*(Ca[2]-Ca[0])/N,va[1]=2*(Ca[3]-Ca[1])/N,va[2]=2*(Ca[0]-u[0])/N-1,va[3]=2*(Ca[1]-u[1])/N-
1,e.uniform4fv(this.i.c,va),Jw(d,la,q,x*r),e.drawArrays(5,0,4);ca?(this.l=y,this.C=u,this.o=l.f):(this.C=this.l=null,this.o=-1,a.animate=!0)}mi(a.usedTiles,l,n,y);var nc=d.g;ni(a,l,m,r,g,A,n,h.c(),function(a){2!=a.getState()||d.a.b.hasOwnProperty(a.gb())||a.gb()in nc.a||nc.i([a,yc(m,a.wa),m.Qa(a.wa[0]),q,x*r])},this);ji(a,l);li(a,l);e=this.v;Ve(e);bf(e,(Math.round(B[0]/p)*p-u[0])/(u[2]-u[0]),(Math.round(B[1]/p)*p-u[1])/(u[3]-u[1]));0!==f.rotation&&$e(e,f.rotation);af(e,a.size[0]*f.resolution/(u[2]-
u[0]),a.size[1]*f.resolution/(u[3]-u[1]));bf(e,-.5,-.5);return!0};k.xg=function(a,b,c,d){if(this.g){a=Ze(this.v,[a[0]/b.size[0],(b.size[1]-a[1])/b.size[1]].slice());a=[a[0]*this.j,a[1]*this.j];b=this.c.getContext().b;b.bindFramebuffer(b.FRAMEBUFFER,this.g);var e=new Uint8Array(4);b.readPixels(a[0],a[1],1,1,b.RGBA,b.UNSIGNED_BYTE,e);if(0<e[3])return c.call(d,this.a,e)}};function Qw(a,b){lw.call(this,a,b);this.o=!1;this.T=-1;this.I=NaN;this.C=Pa();this.l=this.i=this.B=null}v(Qw,lw);Qw.handles=function(a,b){return"webgl"===a&&"VECTOR"===b.S()};Qw.create=function(a,b){return new Qw(a,b)};k=Qw.prototype;k.Ti=function(a,b,c){this.l=b;var d=a.viewState,e=this.i,f=a.size,g=a.pixelRatio,h=this.c.f;e&&!e.c()&&(h.enable(h.SCISSOR_TEST),h.scissor(0,0,f[0]*g,f[1]*g),e.Ka(c,d.center,d.resolution,d.rotation,f,g,b.opacity,b.Ue?a.skippedFeatureUids:{}),h.disable(h.SCISSOR_TEST))};
k.ka=function(){var a=this.i;if(a){var b=this.c.getContext();aw(a,b)();this.i=null}lw.prototype.ka.call(this)};k.Fa=function(a,b,c,d,e){if(this.i&&this.l){c=this.c.getContext();var f=b.viewState,g=this.a,h={};return this.i.Fa(a,c,f.center,f.resolution,f.rotation,b.size,b.pixelRatio,this.l.opacity,{},function(a){var b=w(a).toString();if(!(b in h))return h[b]=!0,d.call(e,a,g)})}};
k.df=function(a,b){if(this.i&&this.l){var c=this.c.getContext(),d=b.viewState;return fw(this.i,a,c,d.resolution,d.rotation,b.pixelRatio,this.l.opacity,b.skippedFeatureUids)}return!1};k.xg=function(a,b,c,d){a=Ze(b.pixelToCoordinateTransform,a.slice());if(this.df(a,b))return c.call(d,this.a,null)};k.Ui=function(){hi(this)};
k.zg=function(a,b,c){function d(a){var b=a.bb();if(b)var c=b.call(a,m);else(b=e.bb())&&(c=b(a,m));if(c){if(c){b=!1;if(Array.isArray(c))for(var d=c.length-1;0<=d;--d)b=xj(q,a,c[d],wj(m,n),this.Ui,this)||b;else b=xj(q,a,c,wj(m,n),this.Ui,this)||b;a=b}else a=!1;this.o=this.o||a}}var e=this.a;b=e.ia();ki(a.attributions,b.j);li(a,b);var f=a.viewHints[0],g=a.viewHints[1],h=e.U,l=e.ta;if(!this.o&&!h&&f||!l&&g)return!0;g=a.extent;h=a.viewState;f=h.projection;var m=h.resolution,n=a.pixelRatio;h=e.f;var p=
e.g;l=e.get(Bj);void 0===l&&(l=vj);g=Ra(g,p*m);if(!this.o&&this.I==m&&this.T==h&&this.B==l&&Wa(this.C,g))return!0;this.i&&a.postRenderFunctions.push(aw(this.i,c));this.o=!1;var q=new $v(.5*m/n,g,e.g);b.ce(g,m,f);if(l){var r=[];b.ac(g,function(a){r.push(a)},this);r.sort(l);r.forEach(d,this)}else b.ac(g,d,this);bw(q,c);this.I=m;this.T=h;this.B=l;this.C=g;this.i=q;return!0};mg("MAP_RENDERER",Fi);ng([vi,Hi,Aj,Cj]);mg("MAP_RENDERER",Iw);ng([Fw,Pw,Qw]);function X(a){a=tb({},a);a.controls||(a.controls=xg());a.interactions||(a.interactions=Hh());G.call(this,a)}v(X,G);function Rw(a,b,c,d){function e(){delete window[g];f.parentNode.removeChild(f)}var f=document.createElement("script"),g="olc_"+w(b);f.async=!0;f.src=a+(-1==a.indexOf("?")?"?":"&")+(d||"callback")+"="+g;var h=setTimeout(function(){e();c&&c()},1E4);window[g]=function(a){clearTimeout(h);e();b(a)};document.getElementsByTagName("head")[0].appendChild(f)};function Sw(a,b,c,d,e,f,g,h,l,m,n){ss.call(this,e,0);this.B=void 0!==n?n:!1;this.D=g;this.C=h;this.O=null;this.c=b;this.l=d;this.v=f?f:e;this.a=[];this.Fd=null;this.g=0;f=d.Ja(this.v);h=this.l.G();e=this.c.G();f=h?pb(f,h):f;if(0===jb(f))this.state=4;else if((h=a.G())&&(e?e=pb(e,h):e=h),d=ow(a,c,nb(f),d.Qa(this.v[0])),!isFinite(d)||0>=d)this.state=4;else if(this.s=new rw(a,c,f,e,d*(void 0!==m?m:.5)),0===this.s.c.length)this.state=4;else if(this.g=b.xc(d),c=tw(this.s),e&&(a.f?(c[1]=Da(c[1],e[1],e[3]),
c[3]=Da(c[3],e[1],e[3])):c=pb(c,e)),jb(c)){a=tc(b,c,this.g);for(b=a.ba;b<=a.da;b++)for(c=a.ea;c<=a.ga;c++)(m=l(this.g,b,c,g))&&this.a.push(m);0===this.a.length&&(this.state=4)}else this.state=4}v(Sw,ss);Sw.prototype.ka=function(){1==this.state&&(this.Fd.forEach(Hc),this.Fd=null);ss.prototype.ka.call(this)};Sw.prototype.Y=function(){return this.O};
Sw.prototype.je=function(){var a=[];this.a.forEach(function(b){b&&2==b.getState()&&a.push({extent:this.c.Ja(b.wa),image:b.Y()})},this);this.a.length=0;if(0===a.length)this.state=3;else{var b=this.v[0],c=this.l.eb(b),d="number"===typeof c?c:c[0];c="number"===typeof c?c:c[1];b=this.l.Qa(b);var e=this.c.Qa(this.g),f=this.l.Ja(this.v);this.O=qw(d,c,this.D,e,this.c.G(),b,f,this.s,a,this.C,this.B);this.state=2}this.u()};
Sw.prototype.load=function(){if(0==this.state){this.state=1;this.u();var a=0;this.Fd=[];this.a.forEach(function(b){var c=b.getState();if(0==c||1==c){a++;var d=z(b,"change",function(){var c=b.getState();if(2==c||3==c||4==c)Hc(d),a--,0===a&&(this.Fd.forEach(Hc),this.Fd=null,this.je())},this);this.Fd.push(d)}},this);this.a.forEach(function(a){0==a.getState()&&a.load()});0===a&&setTimeout(this.je.bind(this),0)}};function Tw(a,b){var c=/\{z\}/g,d=/\{x\}/g,e=/\{y\}/g,f=/\{-y\}/g;return function(g){if(g)return a.replace(c,g[0].toString()).replace(d,g[1].toString()).replace(e,function(){return(-g[2]-1).toString()}).replace(f,function(){var a=b.a?b.a[g[0]]:null;wa(a,55);return(a.ga-a.ea+1+g[2]).toString()})}}function Uw(a,b){for(var c=a.length,d=Array(c),e=0;e<c;++e)d[e]=Tw(a[e],b);return Vw(d)}function Vw(a){return 1===a.length?a[0]:function(b,c,d){if(b)return a[Ja((b[1]<<b[0])+b[2],a.length)](b,c,d)}}
function Ww(){}function Xw(a){var b=[],c=/\{([a-z])-([a-z])\}/.exec(a);if(c){var d=c[2].charCodeAt(0),e;for(e=c[1].charCodeAt(0);e<=d;++e)b.push(a.replace(c[0],String.fromCharCode(e)));return b}if(c=c=/\{(\d+)-(\d+)\}/.exec(a)){d=parseInt(c[2],10);for(e=parseInt(c[1],10);e<=d;e++)b.push(a.replace(c[0],e.toString()));return b}b.push(a);return b};function Yw(a){fj.call(this,a)}v(Yw,fj);Yw.prototype.ld=function(a){for(var b,c;gj(this);){b=this.a.Hc;c=b.wa[0].toString();var d;if(d=c in a)b=b.wa,d=za(a[c],b[1],b[2]);if(d)break;else Qc(this.pop())}};function Zw(a){if(0!==a.c){var b=a.f.fc.split("/").map(Number)[0];a.forEach(function(a){if(a.wa[0]!==b){var c=a.wa;this.remove(c[0]+"/"+c[1]+"/"+c[2]);Qc(a)}},a)}};function $w(a){Ks.call(this,{attributions:a.attributions,extent:a.extent,logo:a.logo,projection:a.projection,state:a.state,wrapX:a.wrapX});this.ab=void 0!==a.opaque?a.opaque:!1;this.Lb=void 0!==a.tilePixelRatio?a.tilePixelRatio:1;this.tileGrid=void 0!==a.tileGrid?a.tileGrid:null;this.a=new Yw(a.cacheSize);this.l=[0,0];this.fc="";this.ma={transition:a.transition}}v($w,Ks);k=$w.prototype;k.Xi=function(){return gj(this.a)};k.ld=function(a,b){(a=this.ae(a))&&a.ld(b)};
function gi(a,b,c,d,e){a=a.ae(b);if(!a)return!1;b=!0;for(var f,g,h=d.ba;h<=d.da;++h)for(var l=d.ea;l<=d.ga;++l)f=c+"/"+h+"/"+l,g=!1,a.b.hasOwnProperty(f)&&(f=a.get(f),(g=2===f.getState())&&(g=!1!==e(f))),g||(b=!1);return b}k.$f=function(){return 0};function ax(a,b){a.fc!==b&&(a.fc=b,a.u())}k.fg=function(){return this.ab};k.cb=function(){return this.tileGrid};k.Xa=function(a){return this.tileGrid?this.tileGrid:zc(a)};k.ae=function(a){var b=this.c;return b&&!hc(b,a)?null:this.a};k.Sc=function(){return this.Lb};
k.be=function(a,b,c){c=this.Xa(c);b=this.Sc(b);a=Na(c.eb(a),this.l);return 1==b?a:Ma(a,b,this.l)};function bx(a,b,c){var d=void 0!==c?c:a.c;c=a.Xa(d);if(a.C&&d.c){var e=b;b=e[0];a=yc(c,e);d=Dc(d);Ua(d,a)?b=e:(e=lb(d),a[0]+=e*Math.ceil((d[0]-a[0])/e),b=c.kg(a,b))}e=b[0];d=b[1];a=b[2];if(c.minZoom>e||e>c.maxZoom)c=!1;else{var f=c.G();c=(c=f?tc(c,f,e):c.a?c.a[e]:null)?za(c,d,a):!0}return c?b:null}k.ua=function(){this.a.clear();this.u()};k.ih=sa;function cx(a,b){Rc.call(this,a);this.tile=b}v(cx,Rc);function dx(a){$w.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,extent:a.extent,logo:a.logo,opaque:a.opaque,projection:a.projection,state:a.state,tileGrid:a.tileGrid,tilePixelRatio:a.tilePixelRatio,wrapX:a.wrapX,transition:a.transition});this.tileLoadFunction=a.tileLoadFunction;this.tileUrlFunction=this.Lc?this.Lc.bind(this):Ww;this.urls=null;a.urls?this.tb(a.urls):a.url&&this.ob(a.url);a.tileUrlFunction&&this.jb(a.tileUrlFunction);this.T={}}v(dx,$w);k=dx.prototype;k.vb=function(){return this.tileLoadFunction};
k.wb=function(){return this.tileUrlFunction};k.xb=function(){return this.urls};k.Yi=function(a){a=a.target;var b=w(a),c=a.getState();if(1==c){this.T[b]=!0;var d="tileloadstart"}else b in this.T&&(delete this.T[b],d=3==c?"tileloaderror":2==c||5==c?"tileloadend":void 0);void 0!=d&&this.b(new cx(d,a))};k.Cb=function(a){this.a.clear();this.tileLoadFunction=a;this.u()};k.jb=function(a,b){this.tileUrlFunction=a;Zw(this.a);"undefined"!==typeof b?ax(this,b):this.u()};
k.ob=function(a){var b=this.urls=Xw(a);this.jb(this.Lc?this.Lc.bind(this):Uw(b,this.tileGrid),a)};k.tb=function(a){this.urls=a;var b=a.join("\n");this.jb(this.Lc?this.Lc.bind(this):Uw(a,this.tileGrid),b)};k.ih=function(a,b,c){a=a+"/"+b+"/"+c;this.a.b.hasOwnProperty(a)&&this.a.get(a)};function ex(a){dx.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,extent:a.extent,logo:a.logo,opaque:a.opaque,projection:a.projection,state:a.state,tileGrid:a.tileGrid,tileLoadFunction:a.tileLoadFunction?a.tileLoadFunction:fx,tilePixelRatio:a.tilePixelRatio,tileUrlFunction:a.tileUrlFunction,url:a.url,urls:a.urls,wrapX:a.wrapX,transition:a.transition});this.crossOrigin=void 0!==a.crossOrigin?a.crossOrigin:null;this.tileClass=a.tileClass?a.tileClass:us;this.g={};this.v={};this.ub=a.reprojectionErrorThreshold;
this.I=!1}v(ex,dx);k=ex.prototype;k.Xi=function(){if(gj(this.a))return!0;for(var a in this.g)if(gj(this.g[a]))return!0;return!1};k.ld=function(a,b){a=this.ae(a);this.a.ld(this.a==a?b:{});for(var c in this.g){var d=this.g[c];d.ld(d==a?b:{})}};k.$f=function(a){return this.c&&a&&!hc(this.c,a)?0:this.ag()};k.ag=function(){return 0};k.fg=function(a){return this.c&&a&&!hc(this.c,a)?!1:dx.prototype.fg.call(this,a)};
k.Xa=function(a){var b=this.c;return!this.tileGrid||b&&!hc(b,a)?(b=w(a).toString(),b in this.v||(this.v[b]=zc(a)),this.v[b]):this.tileGrid};k.ae=function(a){var b=this.c;if(!b||hc(b,a))return this.a;a=w(a).toString();a in this.g||(this.g[a]=new Yw(this.a.highWaterMark));return this.g[a]};
function gx(a,b,c,d,e,f,g){b=[b,c,d];e=(c=bx(a,b,f))?a.tileUrlFunction(c,e,f):void 0;e=new a.tileClass(b,void 0!==e?0:4,void 0!==e?e:"",a.crossOrigin,a.tileLoadFunction,a.ma);e.key=g;z(e,"change",a.Yi,a);return e}
k.Uc=function(a,b,c,d,e){if(this.c&&e&&!hc(this.c,e)){var f=this.ae(e);c=[a,b,c];var g;a=c[0]+"/"+c[1]+"/"+c[2];f.b.hasOwnProperty(a)&&(g=f.get(a));b=this.fc;if(g&&g.key==b)return g;var h=this.c,l=this.Xa(h),m=this.Xa(e),n=bx(this,c,e);d=new Sw(h,l,e,m,c,n,this.Sc(d),this.ag(),function(a,b,c,d){return hx(this,a,b,c,d,h)}.bind(this),this.ub,this.I);d.key=b;g?(d.f=g,ts(d),f.replace(a,d)):f.set(a,d);return d}return hx(this,a,b,c,d,e)};
function hx(a,b,c,d,e,f){var g=b+"/"+c+"/"+d,h=a.fc;if(a.a.b.hasOwnProperty(g)){var l=a.a.get(g);if(l.key!=h){var m=l;l=gx(a,b,c,d,e,f,h);0==m.getState()?l.f=m.f:l.f=m;ts(l);a.a.replace(g,l)}}else l=gx(a,b,c,d,e,f,h),a.a.set(g,l);return l}k.Pb=function(a){if(this.I!=a){this.I=a;for(var b in this.g)this.g[b].clear();this.u()}};k.Qb=function(a,b){if(a=Zb(a))a=w(a).toString(),a in this.v||(this.v[a]=b)};function fx(a,b){a.Y().src=b};function ix(a){this.i=void 0!==a.hidpi?a.hidpi:!1;ex.call(this,{cacheSize:a.cacheSize,crossOrigin:"anonymous",opaque:!0,projection:Zb("EPSG:3857"),reprojectionErrorThreshold:a.reprojectionErrorThreshold,state:"loading",tileLoadFunction:a.tileLoadFunction,tilePixelRatio:this.i?2:1,wrapX:void 0!==a.wrapX?a.wrapX:!0,transition:a.transition});this.U=void 0!==a.culture?a.culture:"en-us";this.B=void 0!==a.maxZoom?a.maxZoom:-1;this.o=a.key;this.s=a.imagerySet;Rw("https://dev.virtualearth.net/REST/v1/Imagery/Metadata/"+
this.s+"?uriScheme=https&include=ImageryProviders&key="+this.o,this.Va.bind(this),void 0,"jsonp")}v(ix,ex);var jx=new Fc({html:'<a class="ol-attribution-bing-tos" href="https://www.microsoft.com/maps/product/terms.html">Terms of Use</a>'});ix.prototype.fa=function(){return this.o};ix.prototype.oa=function(){return this.s};
ix.prototype.Va=function(a){if(200!=a.statusCode||"OK"!=a.statusDescription||"ValidCredentials"!=a.authenticationResultCode||1!=a.resourceSets.length||1!=a.resourceSets[0].resources.length)Ms(this,"error");else{var b=a.brandLogoUri;-1==b.indexOf("https")&&(b=b.replace("http","https"));var c=a.resourceSets[0].resources[0],d=-1==this.B?c.zoomMax:this.B;a=Dc(this.c);var e=Bc({extent:a,minZoom:c.zoomMin,maxZoom:d,tileSize:(c.imageWidth==c.imageHeight?c.imageWidth:[c.imageWidth,c.imageHeight])/(this.i?
2:1)});this.tileGrid=e;var f=this.U,g=this.i;this.tileUrlFunction=Vw(c.imageUrlSubdomains.map(function(a){var b=[0,0,0],d=c.imageUrl.replace("{subdomain}",a).replace("{culture}",f);return function(a){if(a)return oc(a[0],a[1],-a[2]-1,b),a=d,g&&(a+="&dpi=d1&device=mobile"),a.replace("{quadkey}",pc(b))}}));if(c.imageryProviders){var h=$b(Zb("EPSG:4326"),this.c);a=c.imageryProviders.map(function(a){var b=a.attribution,c={};a.coverageAreas.forEach(function(a){var b=a.zoomMin,f=Math.min(a.zoomMax,d);a=
a.bbox;a=sb([a[1],a[0],a[3],a[2]],h);var g;for(g=b;g<=f;++g){var l=g.toString();b=tc(e,a,g);l in c?c[l].push(b):c[l]=[b]}});return new Fc({html:b,tileRanges:c})});a.push(jx);this.va(a)}this.D=b;Ms(this,"ready")}};function kx(a){a=a||{};var b=void 0!==a.projection?a.projection:"EPSG:3857",c=void 0!==a.tileGrid?a.tileGrid:Bc({extent:Dc(b),maxZoom:a.maxZoom,minZoom:a.minZoom,tileSize:a.tileSize});ex.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,opaque:a.opaque,projection:b,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileGrid:c,tileLoadFunction:a.tileLoadFunction,tilePixelRatio:a.tilePixelRatio,tileUrlFunction:a.tileUrlFunction,url:a.url,urls:a.urls,
wrapX:void 0!==a.wrapX?a.wrapX:!0,transition:a.transition})}v(kx,ex);function lx(a){this.s=a.account;this.B=a.map||"";this.i=a.config||{};this.o={};kx.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,maxZoom:void 0!==a.maxZoom?a.maxZoom:18,minZoom:a.minZoom,projection:a.projection,state:"loading",wrapX:a.wrapX});mx(this)}v(lx,kx);k=lx.prototype;k.Uk=function(){return this.i};k.wq=function(a){tb(this.i,a);mx(this)};k.Zp=function(a){this.i=a||{};mx(this)};
function mx(a){var b=JSON.stringify(a.i);if(a.o[b])nx(a,a.o[b]);else{var c="https://"+a.s+".carto.com/api/v1/map";a.B&&(c+="/named/"+a.B);var d=new XMLHttpRequest;d.addEventListener("load",a.Ll.bind(a,b));d.addEventListener("error",a.Kl.bind(a));d.open("POST",c);d.setRequestHeader("Content-type","application/json");d.send(JSON.stringify(a.i))}}
k.Ll=function(a,b){b=b.target;if(!b.status||200<=b.status&&300>b.status){try{var c=JSON.parse(b.responseText)}catch(d){Ms(this,"error");return}nx(this,c);this.o[a]=c;Ms(this,"ready")}else Ms(this,"error")};k.Kl=function(){Ms(this,"error")};function nx(a,b){a.ob("https://"+b.cdn_url.https+"/"+a.s+"/api/v1/map/"+b.layergroupid+"/{z}/{x}/{y}.png")};function Y(a){S.call(this,{attributions:a.attributions,extent:a.extent,logo:a.logo,projection:a.projection,wrapX:a.wrapX});this.resolution=void 0;this.distance=void 0!==a.distance?a.distance:20;this.features=[];this.geometryFunction=a.geometryFunction||function(a){a=a.W();wa(a instanceof D,10);return a};this.source=a.source;this.source.J("change",Y.prototype.ua,this)}v(Y,S);k=Y.prototype;k.ko=function(){return this.distance};k.lo=function(){return this.source};
k.ce=function(a,b,c){this.source.ce(a,b,c);b!==this.resolution&&(this.clear(),this.resolution=b,ox(this),this.Ic(this.features))};k.$p=function(a){this.distance=a;this.ua()};k.ua=function(){this.clear();ox(this);this.Ic(this.features);S.prototype.ua.call(this)};
function ox(a){if(void 0!==a.resolution){a.features.length=0;for(var b=Pa(),c=a.distance*a.resolution,d=a.source.fe(),e={},f=0,g=d.length;f<g;f++){var h=d[f];w(h).toString()in e||!(h=a.geometryFunction(h))||(h=h.V(),$a(h,b),Ra(b,c,b),h=a.source.Zf(b),h=h.filter(function(a){a=w(a).toString();return a in e?!1:e[a]=!0}),a.features.push(px(a,h)))}}}
function px(a,b){for(var c=[0,0],d=b.length-1;0<=d;--d){var e=a.geometryFunction(b[d]);e?ye(c,e.V()):b.splice(d,1)}Fe(c,1/b.length);a=new Kk(new D(c));a.set("features",b);return a};function qx(a,b){var c=[];Object.keys(b).forEach(function(a){null!==b[a]&&void 0!==b[a]&&c.push(a+"="+encodeURIComponent(b[a]))});var d=c.join("&");a=a.replace(/[?&]$/,"");a=-1===a.indexOf("?")?a+"?":a+"&";return a+d};function rx(a){a=a||{};vw.call(this,{attributions:a.attributions,logo:a.logo,projection:a.projection,resolutions:a.resolutions});this.T=void 0!==a.crossOrigin?a.crossOrigin:null;this.U=void 0!==a.hidpi?a.hidpi:!0;this.a=a.url;this.g=a.imageLoadFunction?a.imageLoadFunction:Bw;this.v=a.params||{};this.N=null;this.o=[0,0];this.I=0;this.B=void 0!==a.ratio?a.ratio:1.5}v(rx,vw);k=rx.prototype;k.no=function(){return this.v};
k.Qc=function(a,b,c,d){if(void 0===this.a)return null;b=ww(this,b);c=this.U?c:1;var e=this.N;if(e&&this.I==this.f&&e.resolution==b&&e.a==c&&Wa(e.G(),a))return e;e={F:"image",FORMAT:"PNG32",TRANSPARENT:!0};tb(e,this.v);a=a.slice();var f=(a[0]+a[2])/2,g=(a[1]+a[3])/2;if(1!=this.B){var h=this.B*lb(a)/2,l=this.B*mb(a)/2;a[0]=f-h;a[1]=g-l;a[2]=f+h;a[3]=g+l}h=b/c;l=Math.ceil(lb(a)/h);var m=Math.ceil(mb(a)/h);a[0]=f-h*l/2;a[2]=f+h*l/2;a[1]=g-h*m/2;a[3]=g+h*m/2;this.o[0]=l;this.o[1]=m;f=a;g=this.o;h=c;d=
d.sb.split(":").pop();e.SIZE=g[0]+","+g[1];e.BBOX=f.join(",");e.BBOXSR=d;e.IMAGESR=d;e.DPI=Math.round(90*h);d=this.a;f=d.replace(/MapServer\/?$/,"MapServer/export").replace(/ImageServer\/?$/,"ImageServer/exportImage");f==d&&wa(!1,50);e=qx(f,e);this.N=new qs(a,b,c,this.j,e,this.T,this.g);this.I=this.f;z(this.N,"change",this.l,this);return this.N};k.mo=function(){return this.g};k.oo=function(){return this.a};k.po=function(a){this.N=null;this.g=a;this.u()};
k.qo=function(a){a!=this.a&&(this.a=a,this.N=null,this.u())};k.ro=function(a){tb(this.v,a);this.N=null;this.u()};function sx(a){vw.call(this,{projection:a.projection,resolutions:a.resolutions});this.T=void 0!==a.crossOrigin?a.crossOrigin:null;this.o=void 0!==a.displayDpi?a.displayDpi:96;this.g=a.params||{};this.I=a.url;this.a=a.imageLoadFunction?a.imageLoadFunction:Bw;this.U=void 0!==a.hidpi?a.hidpi:!0;this.ma=void 0!==a.metersPerUnit?a.metersPerUnit:1;this.v=void 0!==a.ratio?a.ratio:1;this.oa=void 0!==a.useOverlay?a.useOverlay:!1;this.N=null;this.B=0}v(sx,vw);k=sx.prototype;k.to=function(){return this.g};
k.Qc=function(a,b,c){b=ww(this,b);c=this.U?c:1;var d=this.N;if(d&&this.B==this.f&&d.resolution==b&&d.a==c&&Wa(d.G(),a))return d;1!=this.v&&(a=a.slice(),rb(a,this.v));var e=[lb(a)/b*c,mb(a)/b*c];if(void 0!==this.I){d=this.I;var f=nb(a),g=this.ma,h=lb(a),l=mb(a),m=e[0],n=e[1],p=.0254/this.o;e={OPERATION:this.oa?"GETDYNAMICMAPOVERLAYIMAGE":"GETMAPIMAGE",VERSION:"2.0.0",LOCALE:"en",CLIENTAGENT:"ol.source.ImageMapGuide source",CLIP:"1",SETDISPLAYDPI:this.o,SETDISPLAYWIDTH:Math.round(e[0]),SETDISPLAYHEIGHT:Math.round(e[1]),
SETVIEWSCALE:n*h>m*l?h*g/(m*p):l*g/(n*p),SETVIEWCENTERX:f[0],SETVIEWCENTERY:f[1]};tb(e,this.g);d=qx(d,e);d=new qs(a,b,c,this.j,d,this.T,this.a);z(d,"change",this.l,this)}else d=null;this.N=d;this.B=this.f;return d};k.so=function(){return this.a};k.vo=function(a){tb(this.g,a);this.u()};k.uo=function(a){this.N=null;this.a=a;this.u()};function tx(a){var b=a.imageExtent,c=void 0!==a.crossOrigin?a.crossOrigin:null,d=a.imageLoadFunction?a.imageLoadFunction:Bw;vw.call(this,{attributions:a.attributions,logo:a.logo,projection:Zb(a.projection)});this.N=new qs(b,void 0,1,this.j,a.url,c,d);this.a=a.imageSize?a.imageSize:null;z(this.N,"change",this.l,this)}v(tx,vw);tx.prototype.Qc=function(a){return qb(a,this.N.G())?this.N:null};
tx.prototype.l=function(a){if(2==this.N.getState()){var b=this.N.G(),c=this.N.Y();if(this.a){var d=this.a[0];var e=this.a[1]}else d=c.width,e=c.height;b=Math.ceil(lb(b)/(mb(b)/e));if(b!=d){b=dg(b,e);var f=b.canvas;b.drawImage(c,0,0,d,e,0,0,f.width,f.height);this.N.gh(f)}}vw.prototype.l.call(this,a)};function ux(a){a=a||{};vw.call(this,{attributions:a.attributions,logo:a.logo,projection:a.projection,resolutions:a.resolutions});this.ma=void 0!==a.crossOrigin?a.crossOrigin:null;this.g=a.url;this.v=a.imageLoadFunction?a.imageLoadFunction:Bw;this.a=a.params||{};this.o=!0;vx(this);this.U=a.serverType;this.oa=void 0!==a.hidpi?a.hidpi:!0;this.N=null;this.B=[0,0];this.T=0;this.I=void 0!==a.ratio?a.ratio:1.5}v(ux,vw);var wx=[101,101];k=ux.prototype;
k.Ao=function(a,b,c,d){if(void 0!==this.g){var e=ob(a,b,0,wx),f={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetFeatureInfo",FORMAT:"image/png",TRANSPARENT:!0,QUERY_LAYERS:this.a.LAYERS};tb(f,this.a,d);d=Math.floor((e[3]-a[1])/b);f[this.o?"I":"X"]=Math.floor((a[0]-e[0])/b);f[this.o?"J":"Y"]=d;return xx(this,e,wx,1,Zb(c),f)}};k.Co=function(){return this.a};
k.Qc=function(a,b,c,d){if(void 0===this.g)return null;b=ww(this,b);1==c||this.oa&&void 0!==this.U||(c=1);var e=b/c,f=nb(a),g=ob(f,e,0,[Math.ceil(lb(a)/e),Math.ceil(mb(a)/e)]);a=ob(f,e,0,[Math.ceil(this.I*lb(a)/e),Math.ceil(this.I*mb(a)/e)]);if((f=this.N)&&this.T==this.f&&f.resolution==b&&f.a==c&&Wa(f.G(),g))return f;g={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetMap",FORMAT:"image/png",TRANSPARENT:!0};tb(g,this.a);this.B[0]=Math.round(lb(a)/e);this.B[1]=Math.round(mb(a)/e);d=xx(this,a,this.B,c,d,g);
this.N=new qs(a,b,c,this.j,d,this.ma,this.v);this.T=this.f;z(this.N,"change",this.l,this);return this.N};k.Bo=function(){return this.v};
function xx(a,b,c,d,e,f){wa(void 0!==a.g,9);f[a.o?"CRS":"SRS"]=e.sb;"STYLES"in a.a||(f.STYLES="");if(1!=d)switch(a.U){case "geoserver":d=90*d+.5|0;f.FORMAT_OPTIONS="FORMAT_OPTIONS"in f?f.FORMAT_OPTIONS+(";dpi:"+d):"dpi:"+d;break;case "mapserver":f.MAP_RESOLUTION=90*d;break;case "carmentaserver":case "qgis":f.DPI=90*d;break;default:wa(!1,8)}f.WIDTH=c[0];f.HEIGHT=c[1];c=e.b;var g;a.o&&"ne"==c.substr(0,2)?g=[b[1],b[0],b[3],b[2]]:g=b;f.BBOX=g.join(",");return qx(a.g,f)}k.Do=function(){return this.g};
k.Eo=function(a){this.N=null;this.v=a;this.u()};k.Fo=function(a){a!=this.g&&(this.g=a,this.N=null,this.u())};k.Go=function(a){tb(this.a,a);vx(this);this.N=null;this.u()};function vx(a){a.o=0<=xe(a.a.VERSION||"1.3.0")};function yx(a){a=a||{};var b;void 0!==a.attributions?b=a.attributions:b=[zx];kx.call(this,{attributions:b,cacheSize:a.cacheSize,crossOrigin:void 0!==a.crossOrigin?a.crossOrigin:"anonymous",opaque:void 0!==a.opaque?a.opaque:!0,maxZoom:void 0!==a.maxZoom?a.maxZoom:19,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileLoadFunction:a.tileLoadFunction,url:void 0!==a.url?a.url:"https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png",wrapX:a.wrapX})}v(yx,kx);var zx=new Fc({html:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors.'});Op.nf={};Op.nf.Hf=function(){};
(function(a){function b(a,b,c){if(g)return new ImageData(a,b,c);b=h.createImageData(b,c);b.data.set(a);return b}function c(a){var b=!0;try{new ImageData(10,10)}catch(n){b=!1}return function(c){var d=c.buffers,e=c.meta,f=c.width,g=c.height,h=d.length,l=d[0].byteLength;if(c.imageOps){l=Array(h);for(c=0;c<h;++c){var m=c;var n=new Uint8ClampedArray(d[c]);var N=f,ca=g;n=b?new ImageData(n,N,ca):{data:n,width:N,height:ca};l[m]=n}f=a(l,e).data}else{f=new Uint8ClampedArray(l);g=Array(h);m=Array(h);for(c=0;c<
h;++c)g[c]=new Uint8ClampedArray(d[c]),m[c]=[0,0,0,0];for(d=0;d<l;d+=4){for(c=0;c<h;++c)n=g[c],m[c][0]=n[d],m[c][1]=n[d+1],m[c][2]=n[d+2],m[c][3]=n[d+3];c=a(m,e);f[d]=c[0];f[d+1]=c[1];f[d+2]=c[2];f[d+3]=c[3]}}return f.buffer}}function d(a,b){var d=Object.keys(a.lib||{}).map(function(b){return"var "+b+" = "+a.lib[b].toString()+";"}).concat(["var __minion__ = ("+c.toString()+")(",a.operation.toString(),");",'self.addEventListener("message", function(event) {',"  var buffer = __minion__(event.data);",
"  self.postMessage({buffer: buffer, meta: event.data.meta}, [buffer]);","});"]);d=URL.createObjectURL(new Blob(d,{type:"text/javascript"}));d=new Worker(d);d.addEventListener("message",b);return d}function e(a,b){var d=c(a.operation);return{postMessage:function(a){setTimeout(function(){b({data:{buffer:d(a),meta:a.meta}})},0)}}}function f(a){this.Jf=!!a.im;var b;0===a.threads?b=0:this.Jf?b=1:b=a.threads||1;var c=[];if(b)for(var f=0;f<b;++f)c[f]=d(a,this.vh.bind(this,f));else c[0]=e(a,this.vh.bind(this,
0));this.ze=c;this.Kd=[];this.tk=a.zp||Infinity;this.ye=0;this.hd={};this.Kf=null}var g=!0;try{new ImageData(10,10)}catch(l){g=!1}var h=document.createElement("canvas").getContext("2d");f.prototype.xp=function(a,b,c){this.rk({inputs:a,fi:b,callback:c});this.sh()};f.prototype.rk=function(a){for(this.Kd.push(a);this.Kd.length>this.tk;)this.Kd.shift().callback(null,null)};f.prototype.sh=function(){if(0===this.ye&&0<this.Kd.length){var a=this.Kf=this.Kd.shift(),b=a.inputs[0].width,c=a.inputs[0].height,
d=a.inputs.map(function(a){return a.data.buffer}),e=this.ze.length;this.ye=e;if(1===e)this.ze[0].postMessage({buffers:d,meta:a.fi,imageOps:this.Jf,width:b,height:c},d);else for(var f=4*Math.ceil(a.inputs[0].data.length/4/e),g=0;g<e;++g){for(var h=g*f,B=[],A=0,y=d.length;A<y;++A)B.push(d[g].slice(h,h+f));this.ze[g].postMessage({buffers:B,meta:a.fi,imageOps:this.Jf,width:b,height:c},B)}}};f.prototype.vh=function(a,b){this.Mq||(this.hd[a]=b.data,--this.ye,0===this.ye&&this.uk())};f.prototype.uk=function(){var a=
this.Kf,c=this.ze.length;if(1===c){var d=new Uint8ClampedArray(this.hd[0].buffer);var e=this.hd[0].meta}else{var f=a.inputs[0].data.length;d=new Uint8ClampedArray(f);e=Array(f);f=4*Math.ceil(f/4/c);for(var g=0;g<c;++g){var h=g*f;d.set(new Uint8ClampedArray(this.hd[g].buffer),h);e[g]=this.hd[g].meta}}this.Kf=null;this.hd={};a.callback(null,b(d,a.inputs[0].width,a.inputs[0].height),e);this.sh()};a["default"]={Hf:f};a.Hf=f})(Op.nf=Op.nf||{});function Ax(a){this.B=null;this.oa=void 0!==a.operationType?a.operationType:"pixel";this.Va=void 0!==a.threads?a.threads:1;this.g=Bx(a.sources);for(var b=0,c=this.g.length;b<c;++b)z(this.g[b],"change",this.u,this);this.U=new me(function(){return 1},this.u.bind(this));b=Cx(this.g);c={};for(var d=0,e=b.length;d<e;++d)c[w(b[d].layer)]=b[d];this.a=null;this.I={animate:!1,attributions:{},coordinateToPixelTransform:Ue(),extent:null,focus:null,index:0,layerStates:c,layerStatesArray:b,logos:{},pixelRatio:1,
pixelToCoordinateTransform:Ue(),postRenderFunctions:[],size:[0,0],skippedFeatureUids:{},tileQueue:this.U,time:Date.now(),usedTiles:{},viewState:{rotation:0},viewHints:[],wantedTiles:{}};vw.call(this,{});a.operation&&this.v(a.operation,a.lib)}v(Ax,vw);Ax.prototype.v=function(a,b){this.B=new Op.nf.Hf({operation:a,im:"image"===this.oa,zp:1,lib:b,threads:this.Va});this.u()};
Ax.prototype.Y=function(a,b,c,d){c=!0;for(var e,f=0,g=this.g.length;f<g;++f)if(e=this.g[f].a.ia(),"ready"!==e.getState()){c=!1;break}if(!c)return null;c=tb({},this.I);c.viewState=tb({},c.viewState);e=nb(a);c.extent=a.slice();c.focus=e;c.size[0]=Math.round(lb(a)/b);c.size[1]=Math.round(mb(a)/b);c.time=Date.now();c.animate=!1;f=c.viewState;f.center=e;f.projection=d;f.resolution=b;this.o=c;this.a&&(d=this.a.resolution,e=this.a.G(),b===d&&cb(a,e)||(this.a=null));if(!this.a||this.f!==this.T)a:{a=this.o;
d=this.g.length;b=Array(d);for(e=0;e<d;++e){f=this.g[e];g=a;var h=a.layerStatesArray[e];if(f.Ad(g,h)){var l=g.size[0],m=g.size[1];if(Dx){var n=Dx.canvas;n.width!==l||n.height!==m?Dx=dg(l,m):Dx.clearRect(0,0,l,m)}else Dx=dg(l,m);f.v(g,h,Dx);f=Dx.getImageData(0,0,l,m)}else f=null;if(f)b[e]=f;else break a}d={};this.b(new Ex(Fx,a,d));this.B.xp(b,d,this.ma.bind(this,a))}ne(c.tileQueue,16,16);c.animate&&requestAnimationFrame(this.u.bind(this));return this.a};
Ax.prototype.ma=function(a,b,c,d){if(!b&&c){b=a.extent;var e=a.viewState.resolution;if(e===this.o.viewState.resolution&&cb(b,this.o.extent)){if(this.a)var f=this.a.Y().getContext("2d");else f=dg(Math.round(lb(b)/e),Math.round(mb(b)/e)),this.a=new rs(b,e,1,this.j,f.canvas);f.putImageData(c,0,0);this.u();this.T=this.f;this.b(new Ex(Gx,a,d))}}};var Dx=null;function Cx(a){return a.map(function(a){return hg(a.a)})}
function Bx(a){for(var b=a.length,c=Array(b),d=0;d<b;++d){var e=d,f=a[d],g=null;f instanceof $w?(f=new ou({source:f}),g=new Hi(f)):f instanceof vw&&(f=new nu({source:f}),g=new vi(f));c[e]=g}return c}function Ex(a,b,c){Rc.call(this,a);this.extent=b.extent;this.resolution=b.viewState.resolution/b.pixelRatio;this.data=c}v(Ex,Rc);Ax.prototype.Qc=function(){return null};var Fx="beforeoperations",Gx="afteroperations";function Hx(a){var b=a.layer.indexOf("-");b=Ix[-1==b?a.layer:a.layer.slice(0,b)];var c=Jx[a.layer];kx.call(this,{attributions:Kx,cacheSize:a.cacheSize,crossOrigin:"anonymous",maxZoom:void 0!=a.maxZoom?a.maxZoom:b.maxZoom,minZoom:void 0!=a.minZoom?a.minZoom:b.minZoom,opaque:c.opaque,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileLoadFunction:a.tileLoadFunction,url:void 0!==a.url?a.url:"https://stamen-tiles-{a-d}.a.ssl.fastly.net/"+a.layer+"/{z}/{x}/{y}."+c.Nb,wrapX:a.wrapX})}v(Hx,kx);
var Kx=[new Fc({html:'Map tiles by <a href="https://stamen.com/">Stamen Design</a>, under <a href="https://creativecommons.org/licenses/by/3.0/">CC BY 3.0</a>.'}),zx],Jx={terrain:{Nb:"jpg",opaque:!0},"terrain-background":{Nb:"jpg",opaque:!0},"terrain-labels":{Nb:"png",opaque:!1},"terrain-lines":{Nb:"png",opaque:!1},"toner-background":{Nb:"png",opaque:!0},toner:{Nb:"png",opaque:!0},"toner-hybrid":{Nb:"png",opaque:!1},"toner-labels":{Nb:"png",opaque:!1},"toner-lines":{Nb:"png",opaque:!1},"toner-lite":{Nb:"png",
opaque:!0},watercolor:{Nb:"jpg",opaque:!0}},Ix={terrain:{minZoom:4,maxZoom:18},toner:{minZoom:0,maxZoom:20},watercolor:{minZoom:1,maxZoom:16}};function Lx(a){a=a||{};ex.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileGrid:a.tileGrid,tileLoadFunction:a.tileLoadFunction,url:a.url,urls:a.urls,wrapX:void 0!==a.wrapX?a.wrapX:!0,transition:a.transition});this.i=a.params||{};this.o=Pa();ax(this,Mx(this))}v(Lx,ex);function Mx(a){var b=0,c=[],d;for(d in a.i)c[b++]=d+"-"+a.i[d];return c.join("/")}Lx.prototype.s=function(){return this.i};
Lx.prototype.Sc=function(a){return a};
Lx.prototype.Lc=function(a,b,c){var d=this.tileGrid;d||(d=this.Xa(c));if(!(d.b.length<=a[0])){var e=d.Ja(a,this.o),f=Na(d.eb(a[0]),this.l);1!=b&&(f=Ma(f,b,this.l));d={F:"image",FORMAT:"PNG32",TRANSPARENT:!0};tb(d,this.i);var g=this.urls;g?(c=c.sb.split(":").pop(),d.SIZE=f[0]+","+f[1],d.BBOX=e.join(","),d.BBOXSR=c,d.IMAGESR=c,d.DPI=Math.round(d.DPI?d.DPI*b:90*b),a=(1==g.length?g[0]:g[Ja((a[1]<<a[0])+a[2],g.length)]).replace(/MapServer\/?$/,"MapServer/export").replace(/ImageServer\/?$/,"ImageServer/exportImage"),
a=qx(a,d)):a=void 0;return a}};Lx.prototype.B=function(a){tb(this.i,a);ax(this,Mx(this))};function Nx(a){$w.call(this,{opaque:!1,projection:a.projection,tileGrid:a.tileGrid,wrapX:void 0!==a.wrapX?a.wrapX:!0})}v(Nx,$w);Nx.prototype.Uc=function(a,b,c){var d=a+"/"+b+"/"+c;if(this.a.b.hasOwnProperty(d))return this.a.get(d);var e=Na(this.tileGrid.eb(a));a=[a,b,c];b=(b=bx(this,a))?bx(this,b).toString():"";e=new Ox(a,e,b);this.a.set(d,e);return e};function Ox(a,b,c){ss.call(this,a,2);this.c=b;this.qa=c;this.a=null}v(Ox,ss);
Ox.prototype.Y=function(){if(this.a)return this.a;var a=this.c,b=dg(a[0],a[1]);b.strokeStyle="black";b.strokeRect(.5,.5,a[0]+.5,a[1]+.5);b.fillStyle="black";b.textAlign="center";b.textBaseline="middle";b.font="24px sans-serif";b.fillText(this.qa,a[0]/2,a[1]/2);return this.a=b.canvas};Ox.prototype.load=function(){};function Px(a){this.i=null;ex.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,projection:Zb("EPSG:3857"),reprojectionErrorThreshold:a.reprojectionErrorThreshold,state:"loading",tileLoadFunction:a.tileLoadFunction,wrapX:void 0!==a.wrapX?a.wrapX:!0,transition:a.transition});if(a.url)if(a.jsonp)Rw(a.url,this.Ag.bind(this),this.ef.bind(this));else{var b=new XMLHttpRequest;b.addEventListener("load",this.Io.bind(this));b.addEventListener("error",this.Ho.bind(this));
b.open("GET",a.url);b.send()}else a.tileJSON?this.Ag(a.tileJSON):wa(!1,51)}v(Px,ex);k=Px.prototype;k.Io=function(a){a=a.target;if(!a.status||200<=a.status&&300>a.status){try{var b=JSON.parse(a.responseText)}catch(c){this.ef();return}this.Ag(b)}else this.ef()};k.Ho=function(){this.ef()};k.yl=function(){return this.i};
k.Ag=function(a){var b=Zb("EPSG:4326"),c=this.c;if(a.bounds){var d=$b(b,c);var e=sb(a.bounds,d)}var f=a.minzoom||0;d=a.maxzoom||22;this.tileGrid=c=Bc({extent:Dc(c),maxZoom:d,minZoom:f});this.tileUrlFunction=Uw(a.tiles,c);if(void 0!==a.attribution&&!this.j){b=void 0!==e?e:b.G();e={};for(var g;f<=d;++f)g=f.toString(),e[g]=[tc(c,b,f)];this.va([new Fc({html:a.attribution,tileRanges:e})])}this.i=a;Ms(this,"ready")};k.ef=function(){Ms(this,"error")};function Qx(a){$w.call(this,{projection:Zb("EPSG:3857"),state:"loading"});this.v=void 0!==a.preemptive?a.preemptive:!0;this.o=Ww;this.g=void 0;this.i=a.jsonp||!1;if(a.url)if(this.i)Rw(a.url,this.Bg.bind(this),this.ff.bind(this));else{var b=new XMLHttpRequest;b.addEventListener("load",this.Mo.bind(this));b.addEventListener("error",this.Lo.bind(this));b.open("GET",a.url);b.send()}else a.tileJSON?this.Bg(a.tileJSON):wa(!1,51)}v(Qx,$w);k=Qx.prototype;
k.Mo=function(a){a=a.target;if(!a.status||200<=a.status&&300>a.status){try{var b=JSON.parse(a.responseText)}catch(c){this.ff();return}this.Bg(b)}else this.ff()};k.Lo=function(){this.ff()};k.vl=function(){return this.g};k.Kk=function(a,b,c,d,e){this.tileGrid?(b=this.tileGrid.Me(a,b),Rx(this.Uc(b[0],b[1],b[2],1,this.c),a,c,d,e)):!0===e?setTimeout(function(){c.call(d,null)},0):c.call(d,null)};k.ff=function(){Ms(this,"error")};
k.Bg=function(a){var b=Zb("EPSG:4326"),c=this.c;if(a.bounds){var d=$b(b,c);var e=sb(a.bounds,d)}var f=a.minzoom||0;d=a.maxzoom||22;this.tileGrid=c=Bc({extent:Dc(c),maxZoom:d,minZoom:f});this.g=a.template;var g=a.grids;if(g){this.o=Uw(g,c);if(void 0!==a.attribution){b=void 0!==e?e:b.G();for(e={};f<=d;++f)g=f.toString(),e[g]=[tc(c,b,f)];this.va([new Fc({html:a.attribution,tileRanges:e})])}Ms(this,"ready")}else Ms(this,"error")};
k.Uc=function(a,b,c,d,e){var f=a+"/"+b+"/"+c;if(this.a.b.hasOwnProperty(f))return this.a.get(f);a=[a,b,c];b=bx(this,a,e);d=this.o(b,d,e);d=new Sx(a,void 0!==d?0:4,void 0!==d?d:"",this.tileGrid.Ja(a),this.v,this.i);this.a.set(f,d);return d};k.ih=function(a,b,c){a=a+"/"+b+"/"+c;this.a.b.hasOwnProperty(a)&&this.a.get(a)};function Sx(a,b,c,d,e,f){ss.call(this,a,b);this.v=c;this.a=d;this.O=e;this.c=this.l=this.g=null;this.s=f}v(Sx,ss);k=Sx.prototype;k.Y=function(){return null};
k.getData=function(a){if(!this.g||!this.l)return null;var b=this.g[Math.floor((1-(a[1]-this.a[1])/(this.a[3]-this.a[1]))*this.g.length)];if("string"!==typeof b)return null;b=b.charCodeAt(Math.floor((a[0]-this.a[0])/(this.a[2]-this.a[0])*b.length));93<=b&&b--;35<=b&&b--;b-=32;a=null;b in this.l&&(b=this.l[b],this.c&&b in this.c?a=this.c[b]:a=b);return a};
function Rx(a,b,c,d,e){0==a.state&&!0===e?(Mc(a,"change",function(){c.call(d,this.getData(b))},a),Tx(a)):!0===e?setTimeout(function(){c.call(d,this.getData(b))}.bind(a),0):c.call(d,a.getData(b))}k.gb=function(){return this.v};k.Oe=function(){this.state=3;this.u()};k.Wi=function(a){this.g=a.grid;this.l=a.keys;this.c=a.data;this.state=4;this.u()};
function Tx(a){if(0==a.state)if(a.state=1,a.s)Rw(a.v,a.Wi.bind(a),a.Oe.bind(a));else{var b=new XMLHttpRequest;b.addEventListener("load",a.Ko.bind(a));b.addEventListener("error",a.Jo.bind(a));b.open("GET",a.v);b.send()}}k.Ko=function(a){a=a.target;if(!a.status||200<=a.status&&300>a.status){try{var b=JSON.parse(a.responseText)}catch(c){this.Oe();return}this.Wi(b)}else this.Oe()};k.Jo=function(){this.Oe()};k.load=function(){this.O&&Tx(this)};function Ux(a){a=a||{};var b=a.params||{};ex.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,opaque:!("TRANSPARENT"in b?b.TRANSPARENT:1),projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileClass:a.tileClass,tileGrid:a.tileGrid,tileLoadFunction:a.tileLoadFunction,url:a.url,urls:a.urls,wrapX:void 0!==a.wrapX?a.wrapX:!0,transition:a.transition});this.s=void 0!==a.gutter?a.gutter:0;this.i=b;this.o=!0;this.B=a.serverType;
this.U=void 0!==a.hidpi?a.hidpi:!0;this.fa=Pa();Vx(this);ax(this,Wx(this))}v(Ux,ex);k=Ux.prototype;
k.No=function(a,b,c,d){c=Zb(c);var e=this.tileGrid;e||(e=this.Xa(c));b=e.Me(a,b);if(!(e.b.length<=b[0])){var f=e.Qa(b[0]),g=e.Ja(b,this.fa);e=Na(e.eb(b[0]),this.l);var h=this.s;0!==h&&(e=La(e,h,this.l),g=Ra(g,f*h,g));h={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetFeatureInfo",FORMAT:"image/png",TRANSPARENT:!0,QUERY_LAYERS:this.i.LAYERS};tb(h,this.i,d);d=Math.floor((g[3]-a[1])/f);h[this.o?"I":"X"]=Math.floor((a[0]-g[0])/f);h[this.o?"J":"Y"]=d;return Xx(this,b,e,g,1,c,h)}};k.ag=function(){return this.s};
k.Oo=function(){return this.i};
function Xx(a,b,c,d,e,f,g){var h=a.urls;if(h){g.WIDTH=c[0];g.HEIGHT=c[1];g[a.o?"CRS":"SRS"]=f.sb;"STYLES"in a.i||(g.STYLES="");if(1!=e)switch(a.B){case "geoserver":c=90*e+.5|0;g.FORMAT_OPTIONS="FORMAT_OPTIONS"in g?g.FORMAT_OPTIONS+(";dpi:"+c):"dpi:"+c;break;case "mapserver":g.MAP_RESOLUTION=90*e;break;case "carmentaserver":case "qgis":g.DPI=90*e;break;default:wa(!1,52)}f=f.b;a.o&&"ne"==f.substr(0,2)&&(a=d[0],d[0]=d[1],d[1]=a,a=d[2],d[2]=d[3],d[3]=a);g.BBOX=d.join(",");return qx(1==h.length?h[0]:h[Ja((b[1]<<
b[0])+b[2],h.length)],g)}}k.Sc=function(a){return this.U&&void 0!==this.B?a:1};function Wx(a){var b=0,c=[],d;for(d in a.i)c[b++]=d+"-"+a.i[d];return c.join("/")}
k.Lc=function(a,b,c){var d=this.tileGrid;d||(d=this.Xa(c));if(!(d.b.length<=a[0])){1==b||this.U&&void 0!==this.B||(b=1);var e=d.Qa(a[0]),f=d.Ja(a,this.fa);d=Na(d.eb(a[0]),this.l);var g=this.s;0!==g&&(d=La(d,g,this.l),f=Ra(f,e*g,f));1!=b&&(d=Ma(d,b,this.l));e={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetMap",FORMAT:"image/png",TRANSPARENT:!0};tb(e,this.i);return Xx(this,a,d,f,b,c,e)}};k.Po=function(a){tb(this.i,a);Vx(this);ax(this,Wx(this))};function Vx(a){a.o=0<=xe(a.i.VERSION||"1.3.0")};function Yx(a,b,c,d,e,f,g,h,l,m,n,p,q,r,u){ss.call(this,a,b,u);this.l={};this.v={};this.c=m;this.a=[];this.C=c;this.O=f;this.g=[];this.s=[];if(f){var x=l.Ja(f),B=l.Qa(a[0]);h.Vf(x,h.xc(B),function(a){var b=pb(x,h.Ja(a)),c=h.G();c&&(b=pb(b,c));.5<=lb(b)/B&&.5<=mb(b)/B&&(b=a.toString(),c=m[b],c||(c=g(a,n,p),c=m[b]=new q(a,void 0==c?4:0,void 0==c?"":c,d,e),this.s.push(z(c,"change",r))),c.c++,this.a.push(b))}.bind(this))}}v(Yx,ss);k=Yx.prototype;
k.ka=function(){for(var a=0,b=this.a.length;a<b;++a){var c=this.a[a],d=this.c[c];d.c--;0==d.c&&(delete this.c[c],Qc(d))}this.a.length=0;this.c=null;this.g.forEach(Hc);this.g.length=0;this.f&&Qc(this.f);this.state=5;this.u();this.s.forEach(Hc);this.s.length=0;ss.prototype.ka.call(this)};k.getContext=function(a){a=w(a).toString();a in this.l||(this.l[a]=dg());return this.l[a]};k.Y=function(a){return-1==Fj(this,a).dh?null:this.getContext(a).canvas};
function Fj(a,b){b=w(b).toString();b in a.v||(a.v[b]={Ee:!1,bh:null,wf:-1,dh:-1});return a.v[b]}k.gb=function(){return this.a.join("/")+"/"+this.C};
k.load=function(){var a=0,b={};0==this.state&&Ji(this,1);1==this.state&&this.a.forEach(function(c){var d=this.c[c];0==d.state&&(d.tg(this.D),d.load());1==d.state&&(c=z(d,"change",function(){var c=d.getState();if(2==c||3==c){var f=w(d);3==c?b[f]=!0:(--a,delete b[f]);0==a-Object.keys(b).length&&this.Hh()}}.bind(this)),this.g.push(c),++a)}.bind(this));0==a-Object.keys(b).length&&setTimeout(this.Hh.bind(this),0)};
k.Hh=function(){for(var a=this.a.length,b=0,c=a-1;0<=c;--c){var d=this.c[this.a[c]].getState();2!=d&&--a;4==d&&++b}a==this.a.length?(this.g.forEach(Hc),this.g.length=0,Ji(this,2)):Ji(this,b==this.a.length?4:3)};function Zx(a,b){a.tg(dl(b,a.v,a.ip.bind(a),a.hp.bind(a)))};function $x(a,b,c,d,e,f){ss.call(this,a,b,f);this.c=0;this.l=null;this.v=d;this.a=null;this.g={};this.D=e;this.O=c}v($x,ss);k=$x.prototype;k.ka=function(){this.a=null;this.g={};this.state=5;this.u();ss.prototype.ka.call(this)};k.G=function(){return this.l||ay};k.Vm=function(){return this.v};k.Um=function(){return this.a};k.gb=function(){return this.O};k.Wm=function(){return this.s};function Gj(a,b,c){return a.g[w(b)+","+c]}
k.load=function(){0==this.state&&(Ji(this,1),this.D(this,this.O),this.C(null,NaN,null))};k.ip=function(a,b,c){this.ug(b);this.Aj(a);this.ni(c)};k.hp=function(){Ji(this,3)};k.ni=function(a){this.l=a};k.Aj=function(a){this.a=a;Ji(this,2)};k.ug=function(a){this.s=a};k.tg=function(a){this.C=a};var ay=[0,0,4096,4096];function by(a){var b=a.projection||"EPSG:3857",c=a.extent||Dc(b),d=a.tileGrid||Bc({extent:c,maxZoom:a.maxZoom||22,minZoom:a.minZoom,tileSize:a.tileSize||512});dx.call(this,{attributions:a.attributions,cacheSize:void 0!==a.cacheSize?a.cacheSize:128,extent:c,logo:a.logo,opaque:!1,projection:b,state:a.state,tileGrid:d,tileLoadFunction:a.tileLoadFunction?a.tileLoadFunction:Zx,tileUrlFunction:a.tileUrlFunction,url:a.url,urls:a.urls,wrapX:void 0===a.wrapX?!0:a.wrapX,transition:a.transition});this.o=a.format?
a.format:null;this.i={};this.v=void 0==a.overlaps?!0:a.overlaps;this.tileClass=a.tileClass?a.tileClass:$x;this.g={}}v(by,dx);k=by.prototype;k.clear=function(){this.a.clear();this.i={}};
k.Uc=function(a,b,c,d,e){var f=a+"/"+b+"/"+c;if(this.a.b.hasOwnProperty(f))return this.a.get(f);a=[a,b,c];c=(b=bx(this,a,e))?this.tileUrlFunction(b,d,e):void 0;d=new Yx(a,void 0!==c?0:4,void 0!==c?c:"",this.o,this.tileLoadFunction,b,this.tileUrlFunction,this.tileGrid,this.Xa(e),this.i,d,e,this.tileClass,this.Yi.bind(this),this.ma);this.a.set(f,d);return d};k.Xa=function(a){var b=a.sb,c=this.g[b];c||(c=this.tileGrid,c=this.g[b]=Ac(a,void 0,c?c.eb(c.minZoom):void 0));return c};k.Sc=function(a){return a};
k.be=function(a,b,c){a=Na(this.Xa(c).eb(a));return[Math.round(a[0]*b),Math.round(a[1]*b)]};function cy(a){this.o=a.matrixIds;qc.call(this,{extent:a.extent,origin:a.origin,origins:a.origins,resolutions:a.resolutions,tileSize:a.tileSize,tileSizes:a.tileSizes,sizes:a.sizes})}v(cy,qc);cy.prototype.v=function(){return this.o};
function dy(a,b,c){var d=[],e=[],f=[],g=[],h=[],l=void 0!==c?c:[];c=Zb(a.SupportedCRS.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"));var m=c.Rc(),n="ne"==c.b.substr(0,2);a.TileMatrix.sort(function(a,b){return b.ScaleDenominator-a.ScaleDenominator});a.TileMatrix.forEach(function(a){var b;0<l.length?b=ka(l,function(b){return a.Identifier==b.TileMatrix}):b=!0;if(b){e.push(a.Identifier);b=2.8E-4*a.ScaleDenominator/m;var c=a.TileWidth,p=a.TileHeight;n?f.push([a.TopLeftCorner[1],a.TopLeftCorner[0]]):
f.push(a.TopLeftCorner);d.push(b);g.push(c==p?c:[c,p]);h.push([a.MatrixWidth,-a.MatrixHeight])}});return new cy({extent:b,origins:f,resolutions:d,matrixIds:e,tileSizes:g,sizes:h})};function Z(a){function b(a){a="KVP"==d?qx(a,f):a.replace(/\{(\w+?)\}/g,function(a,b){return b.toLowerCase()in f?f[b.toLowerCase()]:a});return function(b){if(b){var c={TileMatrix:e.o[b[0]],TileCol:b[1],TileRow:-b[2]-1};tb(c,g);b=a;return b="KVP"==d?qx(b,c):b.replace(/\{(\w+?)\}/g,function(a,b){return c[b]})}}}this.oa=void 0!==a.version?a.version:"1.0.0";this.s=void 0!==a.format?a.format:"image/jpeg";this.i=a.dimensions?a.dimensions:{};this.B=a.layer;this.o=a.matrixSet;this.U=a.style;var c=a.urls;void 0===
c&&void 0!==a.url&&(c=Xw(a.url));var d=this.fa=void 0!==a.requestEncoding?a.requestEncoding:"KVP",e=a.tileGrid,f={layer:this.B,style:this.U,tilematrixset:this.o};"KVP"==d&&tb(f,{Service:"WMTS",Request:"GetTile",Version:this.oa,Format:this.s});var g=this.i,h=c&&0<c.length?Vw(c.map(b)):Ww;ex.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileClass:a.tileClass,tileGrid:e,
tileLoadFunction:a.tileLoadFunction,tilePixelRatio:a.tilePixelRatio,tileUrlFunction:h,urls:c,wrapX:void 0!==a.wrapX?a.wrapX:!1,transition:a.transition});ax(this,ey(this))}v(Z,ex);k=Z.prototype;k.Vk=function(){return this.i};k.Qo=function(){return this.s};k.Ro=function(){return this.B};k.il=function(){return this.o};k.tl=function(){return this.fa};k.So=function(){return this.U};k.Al=function(){return this.oa};function ey(a){var b=0,c=[],d;for(d in a.i)c[b++]=d+"-"+a.i[d];return c.join("/")}
k.xq=function(a){tb(this.i,a);ax(this,ey(this))};function fy(a){a=a||{};var b=a.size,c=b[0],d=b[1],e=[],f=256;switch(void 0!==a.tierSizeCalculation?a.tierSizeCalculation:gy){case gy:for(;c>f||d>f;)e.push([Math.ceil(c/f),Math.ceil(d/f)]),f+=f;break;case hy:for(;c>f||d>f;)e.push([Math.ceil(c/f),Math.ceil(d/f)]),c>>=1,d>>=1;break;default:wa(!1,53)}e.push([1,1]);e.reverse();f=[1];var g=[0];d=1;for(c=e.length;d<c;d++)f.push(1<<d),g.push(e[d-1][0]*e[d-1][1]+g[d-1]);f.reverse();b=[0,-b[1],b[0],0];b=new qc({extent:b,origin:ib(b),resolutions:f});(f=a.url)&&
-1==f.indexOf("{TileGroup}")&&-1==f.indexOf("{tileIndex}")&&(f+="{TileGroup}/{z}-{x}-{y}.jpg");f=Xw(f);f=Vw(f.map(function(a){return function(b){if(b){var c=b[0],d=b[1];b=-b[2]-1;var f=d+b*e[c][0],h={z:c,x:d,y:b,tileIndex:f,TileGroup:"TileGroup"+((f+g[c])/256|0)};return a.replace(/\{(\w+?)\}/g,function(a,b){return h[b]})}}}));ex.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,
tileClass:iy,tileGrid:b,tileUrlFunction:f,transition:a.transition})}v(fy,ex);function iy(a,b,c,d,e,f){us.call(this,a,b,c,d,e,f);this.a=null}v(iy,us);iy.prototype.Y=function(){if(this.a)return this.a;var a=us.prototype.Y.call(this);if(2==this.state){if(256==a.width&&256==a.height)return this.a=a;var b=dg(256,256);b.drawImage(a,0,0);return this.a=b.canvas}return a};var gy="default",hy="truncated";ua.prototype.code=ua.prototype.code;t("ol.Attribution",Fc);Fc.prototype.getHTML=Fc.prototype.f;t("ol.CanvasMap",H);t("ol.Collection",C);C.prototype.clear=C.prototype.clear;C.prototype.extend=C.prototype.pg;C.prototype.forEach=C.prototype.forEach;C.prototype.getArray=C.prototype.Dm;C.prototype.item=C.prototype.item;C.prototype.getLength=C.prototype.gc;C.prototype.insertAt=C.prototype.Se;C.prototype.pop=C.prototype.pop;C.prototype.push=C.prototype.push;C.prototype.remove=C.prototype.remove;
C.prototype.removeAt=C.prototype.Ug;C.prototype.setAt=C.prototype.Yp;dd.prototype.element=dd.prototype.element;t("ol.color.asArray",Ph);t("ol.color.asString",Rh);t("ol.colorlike.asColorLike",Th);t("ol.control.defaults",xg);t("ol.coordinate.add",ye);t("ol.coordinate.createStringXY",function(a){return function(b){return Ke(b,a)}});t("ol.coordinate.format",Ce);t("ol.coordinate.rotate",Ee);t("ol.coordinate.toStringHDMS",function(a,b){return a?Be("NS",a[1],b)+" "+Be("EW",a[0],b):""});
t("ol.coordinate.toStringXY",Ke);t("ol.DeviceOrientation",sk);sk.prototype.getAlpha=sk.prototype.Em;sk.prototype.getBeta=sk.prototype.Sk;sk.prototype.getGamma=sk.prototype.Yk;sk.prototype.getHeading=sk.prototype.Fm;sk.prototype.getTracking=sk.prototype.ii;sk.prototype.setTracking=sk.prototype.qg;t("ol.easing.easeIn",Le);t("ol.easing.easeOut",Me);t("ol.easing.inAndOut",Ne);t("ol.easing.linear",Oe);t("ol.easing.upAndDown",function(a){return.5>a?Ne(2*a):1-Ne(2*(a-.5))});
t("ol.extent.boundingExtent",Oa);t("ol.extent.buffer",Ra);t("ol.extent.containsCoordinate",Ua);t("ol.extent.containsExtent",Wa);t("ol.extent.containsXY",Va);t("ol.extent.createEmpty",Pa);t("ol.extent.equals",cb);t("ol.extent.extend",db);t("ol.extent.getArea",jb);t("ol.extent.getBottomLeft",fb);t("ol.extent.getBottomRight",gb);t("ol.extent.getCenter",nb);t("ol.extent.getHeight",mb);t("ol.extent.getIntersection",pb);t("ol.extent.getSize",function(a){return[a[2]-a[0],a[3]-a[1]]});
t("ol.extent.getTopLeft",ib);t("ol.extent.getTopRight",hb);t("ol.extent.getWidth",lb);t("ol.extent.intersects",qb);t("ol.extent.isEmpty",kb);t("ol.extent.applyTransform",sb);t("ol.Feature",Kk);Kk.prototype.clone=Kk.prototype.clone;Kk.prototype.getGeometry=Kk.prototype.W;Kk.prototype.getId=Kk.prototype.Hm;Kk.prototype.getGeometryName=Kk.prototype.$k;Kk.prototype.getStyle=Kk.prototype.Im;Kk.prototype.getStyleFunction=Kk.prototype.bb;Kk.prototype.setGeometry=Kk.prototype.Sa;Kk.prototype.setStyle=Kk.prototype.rg;
Kk.prototype.setId=Kk.prototype.mc;Kk.prototype.setGeometryName=Kk.prototype.Zc;t("ol.featureloader.xhr",el);t("ol.Geolocation",ds);ds.prototype.getAccuracy=ds.prototype.Ok;ds.prototype.getAccuracyGeometry=ds.prototype.Pk;ds.prototype.getAltitude=ds.prototype.Qk;ds.prototype.getAltitudeAccuracy=ds.prototype.Rk;ds.prototype.getHeading=ds.prototype.Jm;ds.prototype.getPosition=ds.prototype.Km;ds.prototype.getProjection=ds.prototype.ji;ds.prototype.getSpeed=ds.prototype.ul;ds.prototype.getTracking=ds.prototype.ki;
ds.prototype.getTrackingOptions=ds.prototype.Xh;ds.prototype.setProjection=ds.prototype.li;ds.prototype.setTracking=ds.prototype.Ve;ds.prototype.setTrackingOptions=ds.prototype.Jj;t("ol.Graticule",ks);ks.prototype.getMap=ks.prototype.Nm;ks.prototype.getMeridians=ks.prototype.kl;ks.prototype.getParallels=ks.prototype.pl;ks.prototype.setMap=ks.prototype.setMap;t("ol.has.DEVICE_PIXEL_RATIO",pd);t("ol.has.CANVAS",rd);t("ol.has.DEVICE_ORIENTATION",sd);t("ol.has.GEOLOCATION",td);t("ol.has.TOUCH",ud);
t("ol.has.WEBGL",id);qs.prototype.getImage=qs.prototype.Y;qs.prototype.load=qs.prototype.load;us.prototype.getImage=us.prototype.Y;t("ol.inherits",v);t("ol.interaction.defaults",Hh);t("ol.Kinetic",yg);t("ol.loadingstrategy.all",Js);t("ol.loadingstrategy.bbox",function(a){return[a]});t("ol.loadingstrategy.tile",function(a){return function(b,c){c=a.xc(c);b=tc(a,b,c);var d=[];c=[c,0,0];for(c[1]=b.ba;c[1]<=b.da;++c[1])for(c[2]=b.ea;c[2]<=b.ga;++c[2])d.push(a.Ja(c));return d}});t("ol.Map",X);
fd.prototype.originalEvent=fd.prototype.originalEvent;fd.prototype.pixel=fd.prototype.pixel;fd.prototype.coordinate=fd.prototype.coordinate;fd.prototype.dragging=fd.prototype.dragging;ed.prototype.map=ed.prototype.map;ed.prototype.frameState=ed.prototype.frameState;t("ol.Object",Wc);Wc.prototype.get=Wc.prototype.get;Wc.prototype.getKeys=Wc.prototype.P;Wc.prototype.getProperties=Wc.prototype.M;Wc.prototype.set=Wc.prototype.set;Wc.prototype.setProperties=Wc.prototype.H;Wc.prototype.unset=Wc.prototype.R;
$c.prototype.key=$c.prototype.key;$c.prototype.oldValue=$c.prototype.oldValue;t("ol.Observable",Vc);t("ol.Observable.unByKey",function(a){if(Array.isArray(a))for(var b=0,c=a.length;b<c;++b)Hc(a[b]);else Hc(a)});Vc.prototype.changed=Vc.prototype.u;Vc.prototype.dispatchEvent=Vc.prototype.b;Vc.prototype.getRevision=Vc.prototype.L;Vc.prototype.on=Vc.prototype.J;Vc.prototype.once=Vc.prototype.once;Vc.prototype.un=Vc.prototype.K;t("ol.Overlay",Rj);Rj.prototype.getElement=Rj.prototype.Vd;
Rj.prototype.getId=Rj.prototype.Tm;Rj.prototype.getMap=Rj.prototype.We;Rj.prototype.getOffset=Rj.prototype.Th;Rj.prototype.getPosition=Rj.prototype.mi;Rj.prototype.getPositioning=Rj.prototype.Uh;Rj.prototype.setElement=Rj.prototype.zj;Rj.prototype.setMap=Rj.prototype.setMap;Rj.prototype.setOffset=Rj.prototype.Ej;Rj.prototype.setPosition=Rj.prototype.Xe;Rj.prototype.setPositioning=Rj.prototype.Hj;t("ol.PluggableMap",G);G.prototype.addControl=G.prototype.Mf;G.prototype.addInteraction=G.prototype.Nf;
G.prototype.addLayer=G.prototype.Ae;G.prototype.addOverlay=G.prototype.Be;G.prototype.forEachFeatureAtPixel=G.prototype.Mc;G.prototype.getFeaturesAtPixel=G.prototype.Yf;G.prototype.forEachLayerAtPixel=G.prototype.sg;G.prototype.hasFeatureAtPixel=G.prototype.ng;G.prototype.getEventCoordinate=G.prototype.Wd;G.prototype.getEventPixel=G.prototype.od;G.prototype.getTarget=G.prototype.$d;G.prototype.getTargetElement=G.prototype.wc;G.prototype.getCoordinateFromPixel=G.prototype.Na;
G.prototype.getControls=G.prototype.Xf;G.prototype.getOverlays=G.prototype.hg;G.prototype.getOverlayById=G.prototype.gg;G.prototype.getInteractions=G.prototype.cg;G.prototype.getLayerGroup=G.prototype.dc;G.prototype.getLayers=G.prototype.Ye;G.prototype.getPixelFromCoordinate=G.prototype.Ha;G.prototype.getSize=G.prototype.zb;G.prototype.getView=G.prototype.$;G.prototype.getViewport=G.prototype.lg;G.prototype.renderSync=G.prototype.ah;G.prototype.render=G.prototype.render;
G.prototype.removeControl=G.prototype.Vg;G.prototype.removeInteraction=G.prototype.Xg;G.prototype.removeLayer=G.prototype.Yg;G.prototype.removeOverlay=G.prototype.Zg;G.prototype.setLayerGroup=G.prototype.zf;G.prototype.setSize=G.prototype.ke;G.prototype.setTarget=G.prototype.vd;G.prototype.setView=G.prototype.hh;G.prototype.updateSize=G.prototype.Gc;t("ol.proj.METERS_PER_UNIT",Eb);t("ol.proj.setProj4",function(a){Fb=a});t("ol.proj.getPointResolution",Yb);t("ol.proj.addEquivalentProjections",ac);
t("ol.proj.addProjection",bc);t("ol.proj.addCoordinateTransforms",fc);t("ol.proj.fromLonLat",function(a,b){return kc(a,"EPSG:4326",void 0!==b?b:"EPSG:3857")});t("ol.proj.toLonLat",function(a,b){return kc(a,void 0!==b?b:"EPSG:3857","EPSG:4326")});t("ol.proj.get",Zb);t("ol.proj.equivalent",hc);t("ol.proj.getTransform",ic);t("ol.proj.transform",kc);t("ol.proj.transformExtent",lc);
t("ol.render.toContext",function(a,b){var c=a.canvas,d=b?b:{};b=d.pixelRatio||pd;if(d=d.size)c.width=d[0]*b,c.height=d[1]*b,c.style.width=d[0]+"px",c.style.height=d[1]+"px";c=[0,0,c.width,c.height];d=af(Ue(),b,b);return new Vh(a,b,c,d,0)});t("ol.size.toSize",Na);t("ol.Sphere",xb);xb.prototype.geodesicArea=xb.prototype.a;xb.prototype.haversineDistance=xb.prototype.b;t("ol.Sphere.getLength",Ab);t("ol.Sphere.getArea",Db);ss.prototype.getTileCoord=ss.prototype.i;ss.prototype.load=ss.prototype.load;
t("ol.tilegrid.createXYZ",Bc);$x.prototype.getFormat=$x.prototype.Vm;$x.prototype.getFeatures=$x.prototype.Um;$x.prototype.getProjection=$x.prototype.Wm;$x.prototype.setExtent=$x.prototype.ni;$x.prototype.setFeatures=$x.prototype.Aj;$x.prototype.setProjection=$x.prototype.ug;$x.prototype.setLoader=$x.prototype.tg;t("ol.View",F);F.prototype.animate=F.prototype.animate;F.prototype.getAnimating=F.prototype.Pc;F.prototype.getInteracting=F.prototype.al;F.prototype.cancelAnimations=F.prototype.kd;
F.prototype.constrainCenter=F.prototype.Kc;F.prototype.constrainResolution=F.prototype.constrainResolution;F.prototype.constrainRotation=F.prototype.constrainRotation;F.prototype.getCenter=F.prototype.xa;F.prototype.calculateExtent=F.prototype.jd;F.prototype.getMaxResolution=F.prototype.Xm;F.prototype.getMinResolution=F.prototype.Zm;F.prototype.getMaxZoom=F.prototype.Ym;F.prototype.setMaxZoom=F.prototype.iq;F.prototype.getMinZoom=F.prototype.$m;F.prototype.setMinZoom=F.prototype.jq;
F.prototype.getProjection=F.prototype.an;F.prototype.getResolution=F.prototype.Oa;F.prototype.getResolutions=F.prototype.bn;F.prototype.getResolutionForExtent=F.prototype.Ke;F.prototype.getRotation=F.prototype.Pa;F.prototype.getZoom=F.prototype.Yh;F.prototype.getZoomForResolution=F.prototype.Ne;F.prototype.getResolutionForZoom=F.prototype.Wh;F.prototype.fit=F.prototype.Uf;F.prototype.centerOn=F.prototype.Fk;F.prototype.rotate=F.prototype.rotate;F.prototype.setCenter=F.prototype.rb;
F.prototype.setResolution=F.prototype.ad;F.prototype.setRotation=F.prototype.de;F.prototype.setZoom=F.prototype.Lj;t("ol.xml.getAllTextContent",Ok);t("ol.xml.parse",Sk);Ou.prototype.getGL=Ou.prototype.ep;Ou.prototype.useProgram=Ou.prototype.Wc;t("ol.tilegrid.TileGrid",qc);qc.prototype.forEachTileCoord=qc.prototype.Vf;qc.prototype.getMaxZoom=qc.prototype.gj;qc.prototype.getMinZoom=qc.prototype.hj;qc.prototype.getOrigin=qc.prototype.Cc;qc.prototype.getResolution=qc.prototype.Qa;
qc.prototype.getResolutions=qc.prototype.ij;qc.prototype.getTileCoordExtent=qc.prototype.Ja;qc.prototype.getTileCoordForCoordAndResolution=qc.prototype.Me;qc.prototype.getTileCoordForCoordAndZ=qc.prototype.kg;qc.prototype.getTileSize=qc.prototype.eb;qc.prototype.getZForResolution=qc.prototype.xc;t("ol.tilegrid.WMTS",cy);cy.prototype.getMatrixIds=cy.prototype.v;t("ol.tilegrid.WMTS.createFromCapabilitiesMatrixSet",dy);t("ol.style.AtlasManager",Tv);t("ol.style.Circle",Bk);Bk.prototype.setRadius=Bk.prototype.$c;
t("ol.style.Fill",Ck);Ck.prototype.clone=Ck.prototype.clone;Ck.prototype.getColor=Ck.prototype.f;Ck.prototype.setColor=Ck.prototype.c;t("ol.style.Icon",Gn);Gn.prototype.clone=Gn.prototype.clone;Gn.prototype.getAnchor=Gn.prototype.Oc;Gn.prototype.getColor=Gn.prototype.To;Gn.prototype.getImage=Gn.prototype.Y;Gn.prototype.getOrigin=Gn.prototype.Vc;Gn.prototype.getSrc=Gn.prototype.Uo;Gn.prototype.getSize=Gn.prototype.kc;Gn.prototype.load=Gn.prototype.load;t("ol.style.Image",yk);
yk.prototype.getOpacity=yk.prototype.hf;yk.prototype.getRotateWithView=yk.prototype.jf;yk.prototype.getRotation=yk.prototype.kf;yk.prototype.getScale=yk.prototype.lf;yk.prototype.getSnapToPixel=yk.prototype.Le;yk.prototype.setOpacity=yk.prototype.Bd;yk.prototype.setRotation=yk.prototype.mf;yk.prototype.setScale=yk.prototype.Cd;t("ol.style.RegularShape",zk);zk.prototype.clone=zk.prototype.clone;zk.prototype.getAnchor=zk.prototype.Oc;zk.prototype.getAngle=zk.prototype.cj;zk.prototype.getFill=zk.prototype.Ca;
zk.prototype.getImage=zk.prototype.Y;zk.prototype.getOrigin=zk.prototype.Vc;zk.prototype.getPoints=zk.prototype.dj;zk.prototype.getRadius=zk.prototype.ej;zk.prototype.getRadius2=zk.prototype.Vh;zk.prototype.getSize=zk.prototype.kc;zk.prototype.getStroke=zk.prototype.Da;t("ol.style.Stroke",Dk);Dk.prototype.clone=Dk.prototype.clone;Dk.prototype.getColor=Dk.prototype.Vo;Dk.prototype.getLineCap=Dk.prototype.dl;Dk.prototype.getLineDash=Dk.prototype.Wo;Dk.prototype.getLineDashOffset=Dk.prototype.el;
Dk.prototype.getLineJoin=Dk.prototype.fl;Dk.prototype.getMiterLimit=Dk.prototype.ll;Dk.prototype.getWidth=Dk.prototype.Xo;Dk.prototype.setColor=Dk.prototype.Yo;Dk.prototype.setLineCap=Dk.prototype.eq;Dk.prototype.setLineDash=Dk.prototype.setLineDash;Dk.prototype.setLineDashOffset=Dk.prototype.fq;Dk.prototype.setLineJoin=Dk.prototype.gq;Dk.prototype.setMiterLimit=Dk.prototype.kq;Dk.prototype.setWidth=Dk.prototype.oq;t("ol.style.Style",Ek);Ek.prototype.clone=Ek.prototype.clone;
Ek.prototype.getRenderer=Ek.prototype.Je;Ek.prototype.setRenderer=Ek.prototype.mq;Ek.prototype.getGeometry=Ek.prototype.W;Ek.prototype.getGeometryFunction=Ek.prototype.Zk;Ek.prototype.getFill=Ek.prototype.Ca;Ek.prototype.setFill=Ek.prototype.yf;Ek.prototype.getImage=Ek.prototype.Y;Ek.prototype.setImage=Ek.prototype.gh;Ek.prototype.getStroke=Ek.prototype.Da;Ek.prototype.setStroke=Ek.prototype.Af;Ek.prototype.getText=Ek.prototype.Ia;Ek.prototype.setText=Ek.prototype.Ed;Ek.prototype.getZIndex=Ek.prototype.za;
Ek.prototype.setGeometry=Ek.prototype.Sa;Ek.prototype.setZIndex=Ek.prototype.Xb;t("ol.style.Text",Hn);Hn.prototype.clone=Hn.prototype.clone;Hn.prototype.getExceedLength=Hn.prototype.Wk;Hn.prototype.getFont=Hn.prototype.Xk;Hn.prototype.getMaxAngle=Hn.prototype.jl;Hn.prototype.getPlacement=Hn.prototype.ql;Hn.prototype.getOffsetX=Hn.prototype.ml;Hn.prototype.getOffsetY=Hn.prototype.nl;Hn.prototype.getFill=Hn.prototype.Ca;Hn.prototype.getRotateWithView=Hn.prototype.Zo;Hn.prototype.getRotation=Hn.prototype.$o;
Hn.prototype.getScale=Hn.prototype.ap;Hn.prototype.getStroke=Hn.prototype.Da;Hn.prototype.getText=Hn.prototype.Ia;Hn.prototype.getTextAlign=Hn.prototype.wl;Hn.prototype.getTextBaseline=Hn.prototype.xl;Hn.prototype.setExceedLength=Hn.prototype.aq;Hn.prototype.setFont=Hn.prototype.Bj;Hn.prototype.setMaxAngle=Hn.prototype.hq;Hn.prototype.setOffsetX=Hn.prototype.Fj;Hn.prototype.setOffsetY=Hn.prototype.Gj;Hn.prototype.setPlacement=Hn.prototype.lq;Hn.prototype.setFill=Hn.prototype.yf;
Hn.prototype.setRotation=Hn.prototype.bp;Hn.prototype.setScale=Hn.prototype.fj;Hn.prototype.setStroke=Hn.prototype.Af;Hn.prototype.setText=Hn.prototype.Ed;Hn.prototype.setTextAlign=Hn.prototype.Ij;Hn.prototype.setTextBaseline=Hn.prototype.nq;t("ol.source.BingMaps",ix);t("ol.source.BingMaps.TOS_ATTRIBUTION",jx);ix.prototype.getApiKey=ix.prototype.fa;ix.prototype.getImagerySet=ix.prototype.oa;t("ol.source.CartoDB",lx);lx.prototype.getConfig=lx.prototype.Uk;lx.prototype.updateConfig=lx.prototype.wq;
lx.prototype.setConfig=lx.prototype.Zp;t("ol.source.Cluster",Y);Y.prototype.getDistance=Y.prototype.ko;Y.prototype.getSource=Y.prototype.lo;Y.prototype.setDistance=Y.prototype.$p;t("ol.source.Image",vw);xw.prototype.image=xw.prototype.image;t("ol.source.ImageArcGISRest",rx);rx.prototype.getParams=rx.prototype.no;rx.prototype.getImageLoadFunction=rx.prototype.mo;rx.prototype.getUrl=rx.prototype.oo;rx.prototype.setImageLoadFunction=rx.prototype.po;rx.prototype.setUrl=rx.prototype.qo;
rx.prototype.updateParams=rx.prototype.ro;t("ol.source.ImageCanvas",Cw);t("ol.source.ImageMapGuide",sx);sx.prototype.getParams=sx.prototype.to;sx.prototype.getImageLoadFunction=sx.prototype.so;sx.prototype.updateParams=sx.prototype.vo;sx.prototype.setImageLoadFunction=sx.prototype.uo;t("ol.source.ImageStatic",tx);t("ol.source.ImageVector",Dw);Dw.prototype.getSource=Dw.prototype.wo;Dw.prototype.getStyle=Dw.prototype.xo;Dw.prototype.getStyleFunction=Dw.prototype.bb;Dw.prototype.setStyle=Dw.prototype.Vi;
t("ol.source.ImageWMS",ux);ux.prototype.getGetFeatureInfoUrl=ux.prototype.Ao;ux.prototype.getParams=ux.prototype.Co;ux.prototype.getImageLoadFunction=ux.prototype.Bo;ux.prototype.getUrl=ux.prototype.Do;ux.prototype.setImageLoadFunction=ux.prototype.Eo;ux.prototype.setUrl=ux.prototype.Fo;ux.prototype.updateParams=ux.prototype.Go;t("ol.source.OSM",yx);t("ol.source.OSM.ATTRIBUTION",zx);t("ol.source.Raster",Ax);Ax.prototype.setOperation=Ax.prototype.v;Ex.prototype.extent=Ex.prototype.extent;
Ex.prototype.resolution=Ex.prototype.resolution;Ex.prototype.data=Ex.prototype.data;t("ol.source.Source",Ks);Ks.prototype.getAttributions=Ks.prototype.Aa;Ks.prototype.getLogo=Ks.prototype.ya;Ks.prototype.getProjection=Ks.prototype.Ba;Ks.prototype.getState=Ks.prototype.getState;Ks.prototype.refresh=Ks.prototype.ua;Ks.prototype.setAttributions=Ks.prototype.va;t("ol.source.Stamen",Hx);t("ol.source.Tile",$w);$w.prototype.getTileGrid=$w.prototype.cb;cx.prototype.tile=cx.prototype.tile;
t("ol.source.TileArcGISRest",Lx);Lx.prototype.getParams=Lx.prototype.s;Lx.prototype.updateParams=Lx.prototype.B;t("ol.source.TileDebug",Nx);t("ol.source.TileImage",ex);ex.prototype.setRenderReprojectionEdges=ex.prototype.Pb;ex.prototype.setTileGridForProjection=ex.prototype.Qb;t("ol.source.TileJSON",Px);Px.prototype.getTileJSON=Px.prototype.yl;t("ol.source.TileUTFGrid",Qx);Qx.prototype.getTemplate=Qx.prototype.vl;Qx.prototype.forDataAtCoordinateAndResolution=Qx.prototype.Kk;
t("ol.source.TileWMS",Ux);Ux.prototype.getGetFeatureInfoUrl=Ux.prototype.No;Ux.prototype.getParams=Ux.prototype.Oo;Ux.prototype.updateParams=Ux.prototype.Po;dx.prototype.getTileLoadFunction=dx.prototype.vb;dx.prototype.getTileUrlFunction=dx.prototype.wb;dx.prototype.getUrls=dx.prototype.xb;dx.prototype.setTileLoadFunction=dx.prototype.Cb;dx.prototype.setTileUrlFunction=dx.prototype.jb;dx.prototype.setUrl=dx.prototype.ob;dx.prototype.setUrls=dx.prototype.tb;t("ol.source.Vector",S);
S.prototype.addFeature=S.prototype.Eb;S.prototype.addFeatures=S.prototype.Ic;S.prototype.clear=S.prototype.clear;S.prototype.forEachFeature=S.prototype.Ih;S.prototype.forEachFeatureInExtent=S.prototype.ac;S.prototype.forEachFeatureIntersectingExtent=S.prototype.Jh;S.prototype.getFeaturesCollection=S.prototype.Qh;S.prototype.getFeatures=S.prototype.fe;S.prototype.getFeaturesAtCoordinate=S.prototype.Ph;S.prototype.getFeaturesInExtent=S.prototype.Zf;S.prototype.getClosestFeatureToCoordinate=S.prototype.Lh;
S.prototype.getExtent=S.prototype.G;S.prototype.getFeatureById=S.prototype.Oh;S.prototype.getFormat=S.prototype.Zi;S.prototype.getUrl=S.prototype.$i;S.prototype.removeFeature=S.prototype.Ib;S.prototype.setLoader=S.prototype.bj;Xs.prototype.feature=Xs.prototype.feature;t("ol.source.VectorTile",by);by.prototype.clear=by.prototype.clear;t("ol.source.WMTS",Z);Z.prototype.getDimensions=Z.prototype.Vk;Z.prototype.getFormat=Z.prototype.Qo;Z.prototype.getLayer=Z.prototype.Ro;Z.prototype.getMatrixSet=Z.prototype.il;
Z.prototype.getRequestEncoding=Z.prototype.tl;Z.prototype.getStyle=Z.prototype.So;Z.prototype.getVersion=Z.prototype.Al;Z.prototype.updateDimensions=Z.prototype.xq;
t("ol.source.WMTS.optionsFromCapabilities",function(a,b){var c=ka(a.Contents.Layer,function(a){return a.Identifier==b.layer});if(null===c)return null;var d=a.Contents.TileMatrixSet;var e=1<c.TileMatrixSetLink.length?"projection"in b?pa(c.TileMatrixSetLink,function(a){var c=ka(d,function(b){return b.Identifier==a.TileMatrixSet}).SupportedCRS.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"),e=Zb(c),f=Zb(b.projection);return e&&f?hc(e,f):c==b.projection}):pa(c.TileMatrixSetLink,function(a){return a.TileMatrixSet==
b.matrixSet}):0;0>e&&(e=0);var f=c.TileMatrixSetLink[e].TileMatrixSet;var g=c.TileMatrixSetLink[e].TileMatrixSetLimits;var h=c.Format[0];"format"in b&&(h=b.format);e=pa(c.Style,function(a){return"style"in b?a.Title==b.style:a.isDefault});0>e&&(e=0);e=c.Style[e].Identifier;var l={};"Dimension"in c&&c.Dimension.forEach(function(a){var b=a.Identifier,c=a.Default;void 0===c&&(c=a.Value[0]);l[b]=c});var m=ka(a.Contents.TileMatrixSet,function(a){return a.Identifier==f});var n="projection"in b?Zb(b.projection):
Zb(m.SupportedCRS.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"));var p=c.WGS84BoundingBox;if(void 0!==p){var q=Zb("EPSG:4326").G();q=p[0]==q[0]&&p[2]==q[2];var r=lc(p,"EPSG:4326",n);(p=n.G())&&(Wa(p,r)||(r=void 0))}g=dy(m,r,g);var u=[];m=b.requestEncoding;m=void 0!==m?m:"";if("OperationsMetadata"in a&&"GetTile"in a.OperationsMetadata)for(a=a.OperationsMetadata.GetTile.DCP.HTTP.Get,r=0,p=a.length;r<p;++r){var x=ka(a[r].Constraint,function(a){return"GetEncoding"==a.name}).AllowedValues.Value;
""===m&&(m=x[0]);if("KVP"===m)ha(x,"KVP")&&u.push(a[r].href);else break}0===u.length&&(m="REST",c.ResourceURL.forEach(function(a){"tile"===a.resourceType&&(h=a.format,u.push(a.template))}));return{urls:u,layer:b.layer,matrixSet:f,format:h,projection:n,requestEncoding:m,tileGrid:g,style:e,dimensions:l,wrapX:q,crossOrigin:b.crossOrigin}});t("ol.source.XYZ",kx);t("ol.source.Zoomify",fy);t("ol.renderer.webgl.ImageLayer",Fw);t("ol.renderer.webgl.Map",Iw);t("ol.renderer.webgl.TileLayer",Pw);
t("ol.renderer.webgl.VectorLayer",Qw);t("ol.renderer.canvas.ImageLayer",vi);t("ol.renderer.canvas.Map",Fi);t("ol.renderer.canvas.TileLayer",Hi);t("ol.renderer.canvas.VectorLayer",Aj);t("ol.renderer.canvas.VectorTileLayer",Cj);Ih.prototype.vectorContext=Ih.prototype.vectorContext;Ih.prototype.frameState=Ih.prototype.frameState;Ih.prototype.context=Ih.prototype.context;Ih.prototype.glContext=Ih.prototype.glContext;Pp.prototype.get=Pp.prototype.get;Pp.prototype.getExtent=Pp.prototype.G;
Pp.prototype.getId=Pp.prototype.fo;Pp.prototype.getGeometry=Pp.prototype.W;Pp.prototype.getProperties=Pp.prototype.ho;Pp.prototype.getType=Pp.prototype.S;t("ol.render.VectorContext",Uh);gw.prototype.setStyle=gw.prototype.zd;gw.prototype.drawGeometry=gw.prototype.Fb;gw.prototype.drawFeature=gw.prototype.Fe;Vh.prototype.drawCircle=Vh.prototype.$b;Vh.prototype.setStyle=Vh.prototype.zd;Vh.prototype.drawGeometry=Vh.prototype.Fb;Vh.prototype.drawFeature=Vh.prototype.Fe;t("ol.proj.common.add",mc);
t("ol.proj.Projection",Gb);Gb.prototype.getCode=Gb.prototype.Tk;Gb.prototype.getExtent=Gb.prototype.G;Gb.prototype.getUnits=Gb.prototype.eo;Gb.prototype.getMetersPerUnit=Gb.prototype.Rc;Gb.prototype.getWorldExtent=Gb.prototype.Bl;Gb.prototype.isGlobal=Gb.prototype.mm;Gb.prototype.setGlobal=Gb.prototype.cq;Gb.prototype.setExtent=Gb.prototype.Pi;Gb.prototype.setWorldExtent=Gb.prototype.Kj;Gb.prototype.setGetPointResolution=Gb.prototype.bq;t("ol.proj.Units.METERS_PER_UNIT",Eb);t("ol.layer.Base",gg);
gg.prototype.getExtent=gg.prototype.G;gg.prototype.getMaxResolution=gg.prototype.hc;gg.prototype.getMinResolution=gg.prototype.ic;gg.prototype.getOpacity=gg.prototype.jc;gg.prototype.getVisible=gg.prototype.Tb;gg.prototype.getZIndex=gg.prototype.za;gg.prototype.setExtent=gg.prototype.zc;gg.prototype.setMaxResolution=gg.prototype.Ec;gg.prototype.setMinResolution=gg.prototype.Fc;gg.prototype.setOpacity=gg.prototype.Ac;gg.prototype.setVisible=gg.prototype.Bc;gg.prototype.setZIndex=gg.prototype.Xb;
t("ol.layer.Group",ig);ig.prototype.getLayers=ig.prototype.yd;ig.prototype.setLayers=ig.prototype.Ni;t("ol.layer.Heatmap",V);V.prototype.getBlur=V.prototype.Kh;V.prototype.getGradient=V.prototype.Rh;V.prototype.getRadius=V.prototype.Oi;V.prototype.setBlur=V.prototype.xj;V.prototype.setGradient=V.prototype.Dj;V.prototype.setRadius=V.prototype.$c;t("ol.layer.Image",nu);nu.prototype.getSource=nu.prototype.ia;t("ol.layer.Layer",wi);wi.prototype.getSource=wi.prototype.ia;wi.prototype.setMap=wi.prototype.setMap;
wi.prototype.setSource=wi.prototype.bd;t("ol.layer.Tile",ou);ou.prototype.getPreload=ou.prototype.c;ou.prototype.getSource=ou.prototype.ia;ou.prototype.setPreload=ou.prototype.j;ou.prototype.getUseInterimTilesOnError=ou.prototype.i;ou.prototype.setUseInterimTilesOnError=ou.prototype.C;t("ol.layer.Vector",R);R.prototype.getSource=R.prototype.ia;R.prototype.getStyle=R.prototype.D;R.prototype.getStyleFunction=R.prototype.bb;R.prototype.setStyle=R.prototype.j;t("ol.layer.VectorTile",W);
W.prototype.getPreload=W.prototype.c;W.prototype.getUseInterimTilesOnError=W.prototype.i;W.prototype.setPreload=W.prototype.B;W.prototype.setUseInterimTilesOnError=W.prototype.T;W.prototype.getSource=W.prototype.ia;t("ol.interaction.DoubleClickZoom",Hg);t("ol.interaction.DoubleClickZoom.handleEvent",Ig);t("ol.interaction.DragAndDrop",ys);t("ol.interaction.DragAndDrop.handleEvent",Pe);Bs.prototype.features=Bs.prototype.features;Bs.prototype.file=Bs.prototype.file;Bs.prototype.projection=Bs.prototype.projection;
t("ol.interaction.DragBox",gh);gh.prototype.getGeometry=gh.prototype.W;lh.prototype.coordinate=lh.prototype.coordinate;lh.prototype.mapBrowserEvent=lh.prototype.mapBrowserEvent;t("ol.interaction.DragPan",Wg);t("ol.interaction.DragRotate",$g);t("ol.interaction.DragRotateAndZoom",Fs);t("ol.interaction.DragZoom",ph);t("ol.interaction.Draw",$s);t("ol.interaction.Draw.handleEvent",bt);$s.prototype.removeLastPoint=$s.prototype.Up;$s.prototype.finishDrawing=$s.prototype.Td;$s.prototype.extend=$s.prototype.Fn;
t("ol.interaction.Draw.createRegularPolygon",function(a,b){return function(c,d){var e=c[0];c=c[1];var f=Math.sqrt(Ge(e,c));d=d?d:Sf(new es(e),a);Tf(d,e,f,b?b:Math.atan((c[1]-e[1])/(c[0]-e[0])));return d}});t("ol.interaction.Draw.createBox",function(){return function(a,b){a=Oa(a);b=b||new E(null);b.na([[fb(a),gb(a),hb(a),ib(a),fb(a)]]);return b}});pt.prototype.feature=pt.prototype.feature;t("ol.interaction.Extent",qt);qt.prototype.getExtent=qt.prototype.G;qt.prototype.setExtent=qt.prototype.g;
Bt.prototype.extent=Bt.prototype.extent;t("ol.interaction.Interaction",Bg);Bg.prototype.getActive=Bg.prototype.c;Bg.prototype.getMap=Bg.prototype.i;Bg.prototype.setActive=Bg.prototype.Ga;t("ol.interaction.KeyboardPan",qh);t("ol.interaction.KeyboardPan.handleEvent",rh);t("ol.interaction.KeyboardZoom",th);t("ol.interaction.KeyboardZoom.handleEvent",uh);t("ol.interaction.Modify",Ct);t("ol.interaction.Modify.handleEvent",Ft);Ct.prototype.removePoint=Ct.prototype.vj;Kt.prototype.features=Kt.prototype.features;
Kt.prototype.mapBrowserEvent=Kt.prototype.mapBrowserEvent;t("ol.interaction.MouseWheelZoom",vh);t("ol.interaction.MouseWheelZoom.handleEvent",wh);vh.prototype.setMouseAnchor=vh.prototype.U;t("ol.interaction.PinchRotate",zh);t("ol.interaction.PinchZoom",Dh);t("ol.interaction.Pointer",Tg);t("ol.interaction.Pointer.handleEvent",Ug);t("ol.interaction.Select",St);St.prototype.getFeatures=St.prototype.Qn;St.prototype.getHitTolerance=St.prototype.Rn;St.prototype.getLayer=St.prototype.Sn;
t("ol.interaction.Select.handleEvent",Tt);St.prototype.setHitTolerance=St.prototype.Un;St.prototype.setMap=St.prototype.setMap;Vt.prototype.selected=Vt.prototype.selected;Vt.prototype.deselected=Vt.prototype.deselected;Vt.prototype.mapBrowserEvent=Vt.prototype.mapBrowserEvent;t("ol.interaction.Snap",Xt);Xt.prototype.addFeature=Xt.prototype.Eb;Xt.prototype.removeFeature=Xt.prototype.Ib;t("ol.interaction.Translate",bu);bu.prototype.getHitTolerance=bu.prototype.B;bu.prototype.setHitTolerance=bu.prototype.I;
hu.prototype.features=hu.prototype.features;hu.prototype.coordinate=hu.prototype.coordinate;t("ol.geom.Circle",es);es.prototype.clone=es.prototype.clone;es.prototype.getCenter=es.prototype.xa;es.prototype.getRadius=es.prototype.xd;es.prototype.getType=es.prototype.S;es.prototype.intersectsExtent=es.prototype.Ya;es.prototype.setCenter=es.prototype.rb;es.prototype.setCenterAndRadius=es.prototype.fh;es.prototype.setRadius=es.prototype.$c;es.prototype.transform=es.prototype.hb;t("ol.geom.Geometry",ef);
ef.prototype.getClosestPoint=ef.prototype.Gb;ef.prototype.intersectsCoordinate=ef.prototype.yb;ef.prototype.getExtent=ef.prototype.G;ef.prototype.rotate=ef.prototype.rotate;ef.prototype.scale=ef.prototype.scale;ef.prototype.simplify=ef.prototype.Rb;ef.prototype.transform=ef.prototype.hb;t("ol.geom.GeometryCollection",Wl);Wl.prototype.clone=Wl.prototype.clone;Wl.prototype.getGeometries=Wl.prototype.pd;Wl.prototype.getType=Wl.prototype.S;Wl.prototype.intersectsExtent=Wl.prototype.Ya;
Wl.prototype.setGeometries=Wl.prototype.Cj;Wl.prototype.applyTransform=Wl.prototype.Jc;Wl.prototype.translate=Wl.prototype.translate;t("ol.geom.LinearRing",Bf);Bf.prototype.clone=Bf.prototype.clone;Bf.prototype.getArea=Bf.prototype.Bn;Bf.prototype.getCoordinates=Bf.prototype.V;Bf.prototype.getType=Bf.prototype.S;Bf.prototype.setCoordinates=Bf.prototype.na;t("ol.geom.LineString",M);M.prototype.appendCoordinate=M.prototype.xk;M.prototype.clone=M.prototype.clone;M.prototype.forEachSegment=M.prototype.Nk;
M.prototype.getCoordinateAtM=M.prototype.zn;M.prototype.getCoordinates=M.prototype.V;M.prototype.getCoordinateAt=M.prototype.Mh;M.prototype.getLength=M.prototype.An;M.prototype.getType=M.prototype.S;M.prototype.intersectsExtent=M.prototype.Ya;M.prototype.setCoordinates=M.prototype.na;t("ol.geom.MultiLineString",O);O.prototype.appendLineString=O.prototype.yk;O.prototype.clone=O.prototype.clone;O.prototype.getCoordinateAtM=O.prototype.Cn;O.prototype.getCoordinates=O.prototype.V;
O.prototype.getLineString=O.prototype.gl;O.prototype.getLineStrings=O.prototype.qd;O.prototype.getType=O.prototype.S;O.prototype.intersectsExtent=O.prototype.Ya;O.prototype.setCoordinates=O.prototype.na;t("ol.geom.MultiPoint",ql);ql.prototype.appendPoint=ql.prototype.Ak;ql.prototype.clone=ql.prototype.clone;ql.prototype.getCoordinates=ql.prototype.V;ql.prototype.getPoint=ql.prototype.rl;ql.prototype.getPoints=ql.prototype.ee;ql.prototype.getType=ql.prototype.S;ql.prototype.intersectsExtent=ql.prototype.Ya;
ql.prototype.setCoordinates=ql.prototype.na;t("ol.geom.MultiPolygon",P);P.prototype.appendPolygon=P.prototype.Bk;P.prototype.clone=P.prototype.clone;P.prototype.getArea=P.prototype.Dn;P.prototype.getCoordinates=P.prototype.V;P.prototype.getInteriorPoints=P.prototype.cl;P.prototype.getPolygon=P.prototype.sl;P.prototype.getPolygons=P.prototype.Yd;P.prototype.getType=P.prototype.S;P.prototype.intersectsExtent=P.prototype.Ya;P.prototype.setCoordinates=P.prototype.na;t("ol.geom.Point",D);
D.prototype.clone=D.prototype.clone;D.prototype.getCoordinates=D.prototype.V;D.prototype.getType=D.prototype.S;D.prototype.intersectsExtent=D.prototype.Ya;D.prototype.setCoordinates=D.prototype.na;t("ol.geom.Polygon",E);E.prototype.appendLinearRing=E.prototype.zk;E.prototype.clone=E.prototype.clone;E.prototype.getArea=E.prototype.En;E.prototype.getCoordinates=E.prototype.V;E.prototype.getInteriorPoint=E.prototype.bl;E.prototype.getLinearRingCount=E.prototype.hl;E.prototype.getLinearRing=E.prototype.Sh;
E.prototype.getLinearRings=E.prototype.Xd;E.prototype.getType=E.prototype.S;E.prototype.intersectsExtent=E.prototype.Ya;E.prototype.setCoordinates=E.prototype.na;t("ol.geom.Polygon.circular",Qf);t("ol.geom.Polygon.fromExtent",Rf);t("ol.geom.Polygon.fromCircle",Sf);t("ol.geom.SimpleGeometry",ff);ff.prototype.getFirstCoordinate=ff.prototype.bc;ff.prototype.getLastCoordinate=ff.prototype.cc;ff.prototype.getLayout=ff.prototype.ec;ff.prototype.applyTransform=ff.prototype.Jc;ff.prototype.translate=ff.prototype.translate;
t("ol.format.EsriJSON",sl);sl.prototype.readFeature=sl.prototype.Vb;sl.prototype.readFeatures=sl.prototype.Ma;sl.prototype.readGeometry=sl.prototype.Yc;sl.prototype.readProjection=sl.prototype.pb;sl.prototype.writeGeometry=sl.prototype.fd;sl.prototype.writeGeometryObject=sl.prototype.ve;sl.prototype.writeFeature=sl.prototype.Gd;sl.prototype.writeFeatureObject=sl.prototype.ed;sl.prototype.writeFeatures=sl.prototype.Yb;sl.prototype.writeFeaturesObject=sl.prototype.te;t("ol.format.Feature",fl);
t("ol.format.filter.and",Ul);t("ol.format.filter.or",function(a){var b=[null].concat(Array.prototype.slice.call(arguments));return new (Function.prototype.bind.apply(Sl,b))});t("ol.format.filter.not",function(a){return new Ql(a)});t("ol.format.filter.bbox",Vl);t("ol.format.filter.intersects",function(a,b,c){return new Kl(a,b,c)});t("ol.format.filter.within",function(a,b,c){return new Tl(a,b,c)});t("ol.format.filter.equalTo",function(a,b,c){return new Gl(a,b,c)});
t("ol.format.filter.notEqualTo",function(a,b,c){return new Rl(a,b,c)});t("ol.format.filter.lessThan",function(a,b){return new Ol(a,b)});t("ol.format.filter.lessThanOrEqualTo",function(a,b){return new Pl(a,b)});t("ol.format.filter.greaterThan",function(a,b){return new Hl(a,b)});t("ol.format.filter.greaterThanOrEqualTo",function(a,b){return new Il(a,b)});t("ol.format.filter.isNull",function(a){return new Nl(a)});t("ol.format.filter.between",function(a,b,c){return new Ll(a,b,c)});
t("ol.format.filter.like",function(a,b,c,d,e,f){return new Ml(a,b,c,d,e,f)});t("ol.format.filter.during",function(a,b,c){return new El(a,b,c)});t("ol.format.GeoJSON",$l);$l.prototype.readFeature=$l.prototype.Vb;$l.prototype.readFeatures=$l.prototype.Ma;$l.prototype.readGeometry=$l.prototype.Yc;$l.prototype.readProjection=$l.prototype.pb;$l.prototype.writeFeature=$l.prototype.Gd;$l.prototype.writeFeatureObject=$l.prototype.ed;$l.prototype.writeFeatures=$l.prototype.Yb;
$l.prototype.writeFeaturesObject=$l.prototype.te;$l.prototype.writeGeometry=$l.prototype.fd;$l.prototype.writeGeometryObject=$l.prototype.ve;t("ol.format.GML",um);um.prototype.writeFeatures=um.prototype.Yb;um.prototype.writeFeaturesNode=um.prototype.Zb;t("ol.format.GML2",Dm);t("ol.format.GML3",um);um.prototype.writeGeometryNode=um.prototype.ue;um.prototype.writeFeatures=um.prototype.Yb;um.prototype.writeFeaturesNode=um.prototype.Zb;hm.prototype.readFeatures=hm.prototype.Ma;t("ol.format.GPX",Om);
Om.prototype.readFeature=Om.prototype.Vb;Om.prototype.readFeatures=Om.prototype.Ma;Om.prototype.readProjection=Om.prototype.pb;Om.prototype.writeFeatures=Om.prototype.Yb;Om.prototype.writeFeaturesNode=Om.prototype.Zb;t("ol.format.IGC",zn);zn.prototype.readFeature=zn.prototype.Vb;zn.prototype.readFeatures=zn.prototype.Ma;zn.prototype.readProjection=zn.prototype.pb;t("ol.format.KML",In);In.prototype.readFeature=In.prototype.Vb;In.prototype.readFeatures=In.prototype.Ma;In.prototype.readName=In.prototype.Kp;
In.prototype.readNetworkLinks=In.prototype.Lp;In.prototype.readRegion=In.prototype.Op;In.prototype.readRegionFromNode=In.prototype.vf;In.prototype.readProjection=In.prototype.pb;In.prototype.writeFeatures=In.prototype.Yb;In.prototype.writeFeaturesNode=In.prototype.Zb;t("ol.format.MVT",Qp);Qp.prototype.getLastExtent=Qp.prototype.dg;Qp.prototype.readFeatures=Qp.prototype.Ma;Qp.prototype.readProjection=Qp.prototype.pb;Qp.prototype.setLayers=Qp.prototype.yn;t("ol.format.OSMXML",Vp);
Vp.prototype.readFeatures=Vp.prototype.Ma;Vp.prototype.readProjection=Vp.prototype.pb;t("ol.format.Polyline",tq);t("ol.format.Polyline.encodeDeltas",uq);t("ol.format.Polyline.decodeDeltas",wq);t("ol.format.Polyline.encodeFloats",vq);t("ol.format.Polyline.decodeFloats",xq);tq.prototype.readFeature=tq.prototype.Vb;tq.prototype.readFeatures=tq.prototype.Ma;tq.prototype.readGeometry=tq.prototype.Yc;tq.prototype.readProjection=tq.prototype.pb;tq.prototype.writeGeometry=tq.prototype.fd;
t("ol.format.TopoJSON",yq);yq.prototype.readFeatures=yq.prototype.Ma;yq.prototype.readProjection=yq.prototype.pb;t("ol.format.WFS",Eq);Eq.prototype.readFeatures=Eq.prototype.Ma;Eq.prototype.readTransactionResponse=Eq.prototype.j;Eq.prototype.readFeatureCollectionMetadata=Eq.prototype.g;t("ol.format.WFS.writeFilter",function(a){var b=Nk("http://www.opengis.net/ogc","Filter");cl({node:b},Tq,Yk(a.nc),[a],[]);return b});Eq.prototype.writeGetFeature=Eq.prototype.o;Eq.prototype.writeTransaction=Eq.prototype.v;
Eq.prototype.readProjection=Eq.prototype.pb;t("ol.format.WKT",Zq);Zq.prototype.readFeature=Zq.prototype.Vb;Zq.prototype.readFeatures=Zq.prototype.Ma;Zq.prototype.readGeometry=Zq.prototype.Yc;Zq.prototype.writeFeature=Zq.prototype.Gd;Zq.prototype.writeFeatures=Zq.prototype.Yb;Zq.prototype.writeGeometry=Zq.prototype.fd;t("ol.format.WMSCapabilities",rr);rr.prototype.read=rr.prototype.read;t("ol.format.WMSGetFeatureInfo",Or);Or.prototype.readFeatures=Or.prototype.Ma;t("ol.format.WMTSCapabilities",Pr);
Pr.prototype.read=Pr.prototype.read;t("ol.format.filter.And",Bl);t("ol.format.filter.Bbox",Cl);t("ol.format.filter.Comparison",Dl);t("ol.format.filter.ComparisonBinary",Fl);t("ol.format.filter.During",El);t("ol.format.filter.EqualTo",Gl);t("ol.format.filter.Filter",zl);t("ol.format.filter.GreaterThan",Hl);t("ol.format.filter.GreaterThanOrEqualTo",Il);t("ol.format.filter.Intersects",Kl);t("ol.format.filter.IsBetween",Ll);t("ol.format.filter.IsLike",Ml);t("ol.format.filter.IsNull",Nl);
t("ol.format.filter.LessThan",Ol);t("ol.format.filter.LessThanOrEqualTo",Pl);t("ol.format.filter.Not",Ql);t("ol.format.filter.NotEqualTo",Rl);t("ol.format.filter.Or",Sl);t("ol.format.filter.Spatial",Jl);t("ol.format.filter.Within",Tl);t("ol.events.condition.altKeyOnly",Jg);t("ol.events.condition.altShiftKeysOnly",Kg);t("ol.events.condition.always",Pe);t("ol.events.condition.click",function(a){return"click"==a.type});t("ol.events.condition.never",Qe);t("ol.events.condition.pointerMove",Mg);
t("ol.events.condition.singleClick",Ng);t("ol.events.condition.doubleClick",function(a){return"dblclick"==a.type});t("ol.events.condition.noModifierKeys",Og);t("ol.events.condition.platformModifierKeyOnly",function(a){a=a.originalEvent;return!a.altKey&&(od?a.metaKey:a.ctrlKey)&&!a.shiftKey});t("ol.events.condition.shiftKeyOnly",Pg);t("ol.events.condition.targetNotEditable",Qg);t("ol.events.condition.mouseOnly",Rg);t("ol.events.condition.primaryAction",Sg);Rc.prototype.type=Rc.prototype.type;
Rc.prototype.target=Rc.prototype.target;Rc.prototype.preventDefault=Rc.prototype.preventDefault;Rc.prototype.stopPropagation=Rc.prototype.stopPropagation;t("ol.control.Attribution",rg);t("ol.control.Attribution.render",sg);rg.prototype.getCollapsible=rg.prototype.dn;rg.prototype.setCollapsible=rg.prototype.gn;rg.prototype.setCollapsed=rg.prototype.fn;rg.prototype.getCollapsed=rg.prototype.cn;t("ol.control.Control",qg);qg.prototype.getMap=qg.prototype.g;qg.prototype.setMap=qg.prototype.setMap;
qg.prototype.setTarget=qg.prototype.i;t("ol.control.FullScreen",Hj);t("ol.control.MousePosition",Mj);t("ol.control.MousePosition.render",Nj);Mj.prototype.getCoordinateFormat=Mj.prototype.Nh;Mj.prototype.getProjection=Mj.prototype.oi;Mj.prototype.setCoordinateFormat=Mj.prototype.yj;Mj.prototype.setProjection=Mj.prototype.pi;t("ol.control.OverviewMap",ak);t("ol.control.OverviewMap.render",bk);ak.prototype.getCollapsible=ak.prototype.kn;ak.prototype.setCollapsible=ak.prototype.nn;
ak.prototype.setCollapsed=ak.prototype.mn;ak.prototype.getCollapsed=ak.prototype.jn;ak.prototype.getOverviewMap=ak.prototype.ol;t("ol.control.Rotate",ug);t("ol.control.Rotate.render",vg);t("ol.control.ScaleLine",fk);fk.prototype.getUnits=fk.prototype.D;t("ol.control.ScaleLine.render",gk);fk.prototype.setUnits=fk.prototype.I;t("ol.control.Zoom",wg);t("ol.control.ZoomSlider",kk);t("ol.control.ZoomSlider.render",mk);t("ol.control.ZoomToExtent",rk);Wc.prototype.changed=Wc.prototype.u;
Wc.prototype.dispatchEvent=Wc.prototype.b;Wc.prototype.getRevision=Wc.prototype.L;Wc.prototype.on=Wc.prototype.J;Wc.prototype.once=Wc.prototype.once;Wc.prototype.un=Wc.prototype.K;G.prototype.get=G.prototype.get;G.prototype.getKeys=G.prototype.P;G.prototype.getProperties=G.prototype.M;G.prototype.set=G.prototype.set;G.prototype.setProperties=G.prototype.H;G.prototype.unset=G.prototype.R;G.prototype.changed=G.prototype.u;G.prototype.dispatchEvent=G.prototype.b;G.prototype.getRevision=G.prototype.L;
G.prototype.on=G.prototype.J;G.prototype.once=G.prototype.once;G.prototype.un=G.prototype.K;H.prototype.addControl=H.prototype.Mf;H.prototype.addInteraction=H.prototype.Nf;H.prototype.addLayer=H.prototype.Ae;H.prototype.addOverlay=H.prototype.Be;H.prototype.forEachFeatureAtPixel=H.prototype.Mc;H.prototype.getFeaturesAtPixel=H.prototype.Yf;H.prototype.forEachLayerAtPixel=H.prototype.sg;H.prototype.hasFeatureAtPixel=H.prototype.ng;H.prototype.getEventCoordinate=H.prototype.Wd;
H.prototype.getEventPixel=H.prototype.od;H.prototype.getTarget=H.prototype.$d;H.prototype.getTargetElement=H.prototype.wc;H.prototype.getCoordinateFromPixel=H.prototype.Na;H.prototype.getControls=H.prototype.Xf;H.prototype.getOverlays=H.prototype.hg;H.prototype.getOverlayById=H.prototype.gg;H.prototype.getInteractions=H.prototype.cg;H.prototype.getLayerGroup=H.prototype.dc;H.prototype.getLayers=H.prototype.Ye;H.prototype.getPixelFromCoordinate=H.prototype.Ha;H.prototype.getSize=H.prototype.zb;
H.prototype.getView=H.prototype.$;H.prototype.getViewport=H.prototype.lg;H.prototype.renderSync=H.prototype.ah;H.prototype.render=H.prototype.render;H.prototype.removeControl=H.prototype.Vg;H.prototype.removeInteraction=H.prototype.Xg;H.prototype.removeLayer=H.prototype.Yg;H.prototype.removeOverlay=H.prototype.Zg;H.prototype.setLayerGroup=H.prototype.zf;H.prototype.setSize=H.prototype.ke;H.prototype.setTarget=H.prototype.vd;H.prototype.setView=H.prototype.hh;H.prototype.updateSize=H.prototype.Gc;
H.prototype.get=H.prototype.get;H.prototype.getKeys=H.prototype.P;H.prototype.getProperties=H.prototype.M;H.prototype.set=H.prototype.set;H.prototype.setProperties=H.prototype.H;H.prototype.unset=H.prototype.R;H.prototype.changed=H.prototype.u;H.prototype.dispatchEvent=H.prototype.b;H.prototype.getRevision=H.prototype.L;H.prototype.on=H.prototype.J;H.prototype.once=H.prototype.once;H.prototype.un=H.prototype.K;C.prototype.get=C.prototype.get;C.prototype.getKeys=C.prototype.P;
C.prototype.getProperties=C.prototype.M;C.prototype.set=C.prototype.set;C.prototype.setProperties=C.prototype.H;C.prototype.unset=C.prototype.R;C.prototype.changed=C.prototype.u;C.prototype.dispatchEvent=C.prototype.b;C.prototype.getRevision=C.prototype.L;C.prototype.on=C.prototype.J;C.prototype.once=C.prototype.once;C.prototype.un=C.prototype.K;dd.prototype.type=dd.prototype.type;dd.prototype.target=dd.prototype.target;dd.prototype.preventDefault=dd.prototype.preventDefault;
dd.prototype.stopPropagation=dd.prototype.stopPropagation;sk.prototype.get=sk.prototype.get;sk.prototype.getKeys=sk.prototype.P;sk.prototype.getProperties=sk.prototype.M;sk.prototype.set=sk.prototype.set;sk.prototype.setProperties=sk.prototype.H;sk.prototype.unset=sk.prototype.R;sk.prototype.changed=sk.prototype.u;sk.prototype.dispatchEvent=sk.prototype.b;sk.prototype.getRevision=sk.prototype.L;sk.prototype.on=sk.prototype.J;sk.prototype.once=sk.prototype.once;sk.prototype.un=sk.prototype.K;
Kk.prototype.get=Kk.prototype.get;Kk.prototype.getKeys=Kk.prototype.P;Kk.prototype.getProperties=Kk.prototype.M;Kk.prototype.set=Kk.prototype.set;Kk.prototype.setProperties=Kk.prototype.H;Kk.prototype.unset=Kk.prototype.R;Kk.prototype.changed=Kk.prototype.u;Kk.prototype.dispatchEvent=Kk.prototype.b;Kk.prototype.getRevision=Kk.prototype.L;Kk.prototype.on=Kk.prototype.J;Kk.prototype.once=Kk.prototype.once;Kk.prototype.un=Kk.prototype.K;ds.prototype.get=ds.prototype.get;ds.prototype.getKeys=ds.prototype.P;
ds.prototype.getProperties=ds.prototype.M;ds.prototype.set=ds.prototype.set;ds.prototype.setProperties=ds.prototype.H;ds.prototype.unset=ds.prototype.R;ds.prototype.changed=ds.prototype.u;ds.prototype.dispatchEvent=ds.prototype.b;ds.prototype.getRevision=ds.prototype.L;ds.prototype.on=ds.prototype.J;ds.prototype.once=ds.prototype.once;ds.prototype.un=ds.prototype.K;us.prototype.getTileCoord=us.prototype.i;us.prototype.load=us.prototype.load;X.prototype.addControl=X.prototype.Mf;
X.prototype.addInteraction=X.prototype.Nf;X.prototype.addLayer=X.prototype.Ae;X.prototype.addOverlay=X.prototype.Be;X.prototype.forEachFeatureAtPixel=X.prototype.Mc;X.prototype.getFeaturesAtPixel=X.prototype.Yf;X.prototype.forEachLayerAtPixel=X.prototype.sg;X.prototype.hasFeatureAtPixel=X.prototype.ng;X.prototype.getEventCoordinate=X.prototype.Wd;X.prototype.getEventPixel=X.prototype.od;X.prototype.getTarget=X.prototype.$d;X.prototype.getTargetElement=X.prototype.wc;
X.prototype.getCoordinateFromPixel=X.prototype.Na;X.prototype.getControls=X.prototype.Xf;X.prototype.getOverlays=X.prototype.hg;X.prototype.getOverlayById=X.prototype.gg;X.prototype.getInteractions=X.prototype.cg;X.prototype.getLayerGroup=X.prototype.dc;X.prototype.getLayers=X.prototype.Ye;X.prototype.getPixelFromCoordinate=X.prototype.Ha;X.prototype.getSize=X.prototype.zb;X.prototype.getView=X.prototype.$;X.prototype.getViewport=X.prototype.lg;X.prototype.renderSync=X.prototype.ah;
X.prototype.render=X.prototype.render;X.prototype.removeControl=X.prototype.Vg;X.prototype.removeInteraction=X.prototype.Xg;X.prototype.removeLayer=X.prototype.Yg;X.prototype.removeOverlay=X.prototype.Zg;X.prototype.setLayerGroup=X.prototype.zf;X.prototype.setSize=X.prototype.ke;X.prototype.setTarget=X.prototype.vd;X.prototype.setView=X.prototype.hh;X.prototype.updateSize=X.prototype.Gc;X.prototype.get=X.prototype.get;X.prototype.getKeys=X.prototype.P;X.prototype.getProperties=X.prototype.M;
X.prototype.set=X.prototype.set;X.prototype.setProperties=X.prototype.H;X.prototype.unset=X.prototype.R;X.prototype.changed=X.prototype.u;X.prototype.dispatchEvent=X.prototype.b;X.prototype.getRevision=X.prototype.L;X.prototype.on=X.prototype.J;X.prototype.once=X.prototype.once;X.prototype.un=X.prototype.K;ed.prototype.type=ed.prototype.type;ed.prototype.target=ed.prototype.target;ed.prototype.preventDefault=ed.prototype.preventDefault;ed.prototype.stopPropagation=ed.prototype.stopPropagation;
fd.prototype.map=fd.prototype.map;fd.prototype.frameState=fd.prototype.frameState;fd.prototype.type=fd.prototype.type;fd.prototype.target=fd.prototype.target;fd.prototype.preventDefault=fd.prototype.preventDefault;fd.prototype.stopPropagation=fd.prototype.stopPropagation;Dd.prototype.originalEvent=Dd.prototype.originalEvent;Dd.prototype.pixel=Dd.prototype.pixel;Dd.prototype.coordinate=Dd.prototype.coordinate;Dd.prototype.dragging=Dd.prototype.dragging;Dd.prototype.preventDefault=Dd.prototype.preventDefault;
Dd.prototype.stopPropagation=Dd.prototype.stopPropagation;Dd.prototype.map=Dd.prototype.map;Dd.prototype.frameState=Dd.prototype.frameState;Dd.prototype.type=Dd.prototype.type;Dd.prototype.target=Dd.prototype.target;$c.prototype.type=$c.prototype.type;$c.prototype.target=$c.prototype.target;$c.prototype.preventDefault=$c.prototype.preventDefault;$c.prototype.stopPropagation=$c.prototype.stopPropagation;Rj.prototype.get=Rj.prototype.get;Rj.prototype.getKeys=Rj.prototype.P;
Rj.prototype.getProperties=Rj.prototype.M;Rj.prototype.set=Rj.prototype.set;Rj.prototype.setProperties=Rj.prototype.H;Rj.prototype.unset=Rj.prototype.R;Rj.prototype.changed=Rj.prototype.u;Rj.prototype.dispatchEvent=Rj.prototype.b;Rj.prototype.getRevision=Rj.prototype.L;Rj.prototype.on=Rj.prototype.J;Rj.prototype.once=Rj.prototype.once;Rj.prototype.un=Rj.prototype.K;Yx.prototype.getTileCoord=Yx.prototype.i;Yx.prototype.load=Yx.prototype.load;$x.prototype.getTileCoord=$x.prototype.i;
$x.prototype.load=$x.prototype.load;F.prototype.get=F.prototype.get;F.prototype.getKeys=F.prototype.P;F.prototype.getProperties=F.prototype.M;F.prototype.set=F.prototype.set;F.prototype.setProperties=F.prototype.H;F.prototype.unset=F.prototype.R;F.prototype.changed=F.prototype.u;F.prototype.dispatchEvent=F.prototype.b;F.prototype.getRevision=F.prototype.L;F.prototype.on=F.prototype.J;F.prototype.once=F.prototype.once;F.prototype.un=F.prototype.K;cy.prototype.forEachTileCoord=cy.prototype.Vf;
cy.prototype.getMaxZoom=cy.prototype.gj;cy.prototype.getMinZoom=cy.prototype.hj;cy.prototype.getOrigin=cy.prototype.Cc;cy.prototype.getResolution=cy.prototype.Qa;cy.prototype.getResolutions=cy.prototype.ij;cy.prototype.getTileCoordExtent=cy.prototype.Ja;cy.prototype.getTileCoordForCoordAndResolution=cy.prototype.Me;cy.prototype.getTileCoordForCoordAndZ=cy.prototype.kg;cy.prototype.getTileSize=cy.prototype.eb;cy.prototype.getZForResolution=cy.prototype.xc;zk.prototype.getOpacity=zk.prototype.hf;
zk.prototype.getRotateWithView=zk.prototype.jf;zk.prototype.getRotation=zk.prototype.kf;zk.prototype.getScale=zk.prototype.lf;zk.prototype.getSnapToPixel=zk.prototype.Le;zk.prototype.setOpacity=zk.prototype.Bd;zk.prototype.setRotation=zk.prototype.mf;zk.prototype.setScale=zk.prototype.Cd;Bk.prototype.clone=Bk.prototype.clone;Bk.prototype.getAngle=Bk.prototype.cj;Bk.prototype.getFill=Bk.prototype.Ca;Bk.prototype.getPoints=Bk.prototype.dj;Bk.prototype.getRadius=Bk.prototype.ej;
Bk.prototype.getRadius2=Bk.prototype.Vh;Bk.prototype.getStroke=Bk.prototype.Da;Bk.prototype.getOpacity=Bk.prototype.hf;Bk.prototype.getRotateWithView=Bk.prototype.jf;Bk.prototype.getRotation=Bk.prototype.kf;Bk.prototype.getScale=Bk.prototype.lf;Bk.prototype.getSnapToPixel=Bk.prototype.Le;Bk.prototype.setOpacity=Bk.prototype.Bd;Bk.prototype.setRotation=Bk.prototype.mf;Bk.prototype.setScale=Bk.prototype.Cd;Gn.prototype.getOpacity=Gn.prototype.hf;Gn.prototype.getRotateWithView=Gn.prototype.jf;
Gn.prototype.getRotation=Gn.prototype.kf;Gn.prototype.getScale=Gn.prototype.lf;Gn.prototype.getSnapToPixel=Gn.prototype.Le;Gn.prototype.setOpacity=Gn.prototype.Bd;Gn.prototype.setRotation=Gn.prototype.mf;Gn.prototype.setScale=Gn.prototype.Cd;Ks.prototype.get=Ks.prototype.get;Ks.prototype.getKeys=Ks.prototype.P;Ks.prototype.getProperties=Ks.prototype.M;Ks.prototype.set=Ks.prototype.set;Ks.prototype.setProperties=Ks.prototype.H;Ks.prototype.unset=Ks.prototype.R;Ks.prototype.changed=Ks.prototype.u;
Ks.prototype.dispatchEvent=Ks.prototype.b;Ks.prototype.getRevision=Ks.prototype.L;Ks.prototype.on=Ks.prototype.J;Ks.prototype.once=Ks.prototype.once;Ks.prototype.un=Ks.prototype.K;$w.prototype.getAttributions=$w.prototype.Aa;$w.prototype.getLogo=$w.prototype.ya;$w.prototype.getProjection=$w.prototype.Ba;$w.prototype.getState=$w.prototype.getState;$w.prototype.refresh=$w.prototype.ua;$w.prototype.setAttributions=$w.prototype.va;$w.prototype.get=$w.prototype.get;$w.prototype.getKeys=$w.prototype.P;
$w.prototype.getProperties=$w.prototype.M;$w.prototype.set=$w.prototype.set;$w.prototype.setProperties=$w.prototype.H;$w.prototype.unset=$w.prototype.R;$w.prototype.changed=$w.prototype.u;$w.prototype.dispatchEvent=$w.prototype.b;$w.prototype.getRevision=$w.prototype.L;$w.prototype.on=$w.prototype.J;$w.prototype.once=$w.prototype.once;$w.prototype.un=$w.prototype.K;dx.prototype.getTileGrid=dx.prototype.cb;dx.prototype.refresh=dx.prototype.ua;dx.prototype.getAttributions=dx.prototype.Aa;
dx.prototype.getLogo=dx.prototype.ya;dx.prototype.getProjection=dx.prototype.Ba;dx.prototype.getState=dx.prototype.getState;dx.prototype.setAttributions=dx.prototype.va;dx.prototype.get=dx.prototype.get;dx.prototype.getKeys=dx.prototype.P;dx.prototype.getProperties=dx.prototype.M;dx.prototype.set=dx.prototype.set;dx.prototype.setProperties=dx.prototype.H;dx.prototype.unset=dx.prototype.R;dx.prototype.changed=dx.prototype.u;dx.prototype.dispatchEvent=dx.prototype.b;dx.prototype.getRevision=dx.prototype.L;
dx.prototype.on=dx.prototype.J;dx.prototype.once=dx.prototype.once;dx.prototype.un=dx.prototype.K;ex.prototype.getTileLoadFunction=ex.prototype.vb;ex.prototype.getTileUrlFunction=ex.prototype.wb;ex.prototype.getUrls=ex.prototype.xb;ex.prototype.setTileLoadFunction=ex.prototype.Cb;ex.prototype.setTileUrlFunction=ex.prototype.jb;ex.prototype.setUrl=ex.prototype.ob;ex.prototype.setUrls=ex.prototype.tb;ex.prototype.getTileGrid=ex.prototype.cb;ex.prototype.refresh=ex.prototype.ua;
ex.prototype.getAttributions=ex.prototype.Aa;ex.prototype.getLogo=ex.prototype.ya;ex.prototype.getProjection=ex.prototype.Ba;ex.prototype.getState=ex.prototype.getState;ex.prototype.setAttributions=ex.prototype.va;ex.prototype.get=ex.prototype.get;ex.prototype.getKeys=ex.prototype.P;ex.prototype.getProperties=ex.prototype.M;ex.prototype.set=ex.prototype.set;ex.prototype.setProperties=ex.prototype.H;ex.prototype.unset=ex.prototype.R;ex.prototype.changed=ex.prototype.u;ex.prototype.dispatchEvent=ex.prototype.b;
ex.prototype.getRevision=ex.prototype.L;ex.prototype.on=ex.prototype.J;ex.prototype.once=ex.prototype.once;ex.prototype.un=ex.prototype.K;ix.prototype.setRenderReprojectionEdges=ix.prototype.Pb;ix.prototype.setTileGridForProjection=ix.prototype.Qb;ix.prototype.getTileLoadFunction=ix.prototype.vb;ix.prototype.getTileUrlFunction=ix.prototype.wb;ix.prototype.getUrls=ix.prototype.xb;ix.prototype.setTileLoadFunction=ix.prototype.Cb;ix.prototype.setTileUrlFunction=ix.prototype.jb;ix.prototype.setUrl=ix.prototype.ob;
ix.prototype.setUrls=ix.prototype.tb;ix.prototype.getTileGrid=ix.prototype.cb;ix.prototype.refresh=ix.prototype.ua;ix.prototype.getAttributions=ix.prototype.Aa;ix.prototype.getLogo=ix.prototype.ya;ix.prototype.getProjection=ix.prototype.Ba;ix.prototype.getState=ix.prototype.getState;ix.prototype.setAttributions=ix.prototype.va;ix.prototype.get=ix.prototype.get;ix.prototype.getKeys=ix.prototype.P;ix.prototype.getProperties=ix.prototype.M;ix.prototype.set=ix.prototype.set;
ix.prototype.setProperties=ix.prototype.H;ix.prototype.unset=ix.prototype.R;ix.prototype.changed=ix.prototype.u;ix.prototype.dispatchEvent=ix.prototype.b;ix.prototype.getRevision=ix.prototype.L;ix.prototype.on=ix.prototype.J;ix.prototype.once=ix.prototype.once;ix.prototype.un=ix.prototype.K;kx.prototype.setRenderReprojectionEdges=kx.prototype.Pb;kx.prototype.setTileGridForProjection=kx.prototype.Qb;kx.prototype.getTileLoadFunction=kx.prototype.vb;kx.prototype.getTileUrlFunction=kx.prototype.wb;
kx.prototype.getUrls=kx.prototype.xb;kx.prototype.setTileLoadFunction=kx.prototype.Cb;kx.prototype.setTileUrlFunction=kx.prototype.jb;kx.prototype.setUrl=kx.prototype.ob;kx.prototype.setUrls=kx.prototype.tb;kx.prototype.getTileGrid=kx.prototype.cb;kx.prototype.refresh=kx.prototype.ua;kx.prototype.getAttributions=kx.prototype.Aa;kx.prototype.getLogo=kx.prototype.ya;kx.prototype.getProjection=kx.prototype.Ba;kx.prototype.getState=kx.prototype.getState;kx.prototype.setAttributions=kx.prototype.va;
kx.prototype.get=kx.prototype.get;kx.prototype.getKeys=kx.prototype.P;kx.prototype.getProperties=kx.prototype.M;kx.prototype.set=kx.prototype.set;kx.prototype.setProperties=kx.prototype.H;kx.prototype.unset=kx.prototype.R;kx.prototype.changed=kx.prototype.u;kx.prototype.dispatchEvent=kx.prototype.b;kx.prototype.getRevision=kx.prototype.L;kx.prototype.on=kx.prototype.J;kx.prototype.once=kx.prototype.once;kx.prototype.un=kx.prototype.K;lx.prototype.setRenderReprojectionEdges=lx.prototype.Pb;
lx.prototype.setTileGridForProjection=lx.prototype.Qb;lx.prototype.getTileLoadFunction=lx.prototype.vb;lx.prototype.getTileUrlFunction=lx.prototype.wb;lx.prototype.getUrls=lx.prototype.xb;lx.prototype.setTileLoadFunction=lx.prototype.Cb;lx.prototype.setTileUrlFunction=lx.prototype.jb;lx.prototype.setUrl=lx.prototype.ob;lx.prototype.setUrls=lx.prototype.tb;lx.prototype.getTileGrid=lx.prototype.cb;lx.prototype.refresh=lx.prototype.ua;lx.prototype.getAttributions=lx.prototype.Aa;
lx.prototype.getLogo=lx.prototype.ya;lx.prototype.getProjection=lx.prototype.Ba;lx.prototype.getState=lx.prototype.getState;lx.prototype.setAttributions=lx.prototype.va;lx.prototype.get=lx.prototype.get;lx.prototype.getKeys=lx.prototype.P;lx.prototype.getProperties=lx.prototype.M;lx.prototype.set=lx.prototype.set;lx.prototype.setProperties=lx.prototype.H;lx.prototype.unset=lx.prototype.R;lx.prototype.changed=lx.prototype.u;lx.prototype.dispatchEvent=lx.prototype.b;lx.prototype.getRevision=lx.prototype.L;
lx.prototype.on=lx.prototype.J;lx.prototype.once=lx.prototype.once;lx.prototype.un=lx.prototype.K;S.prototype.getAttributions=S.prototype.Aa;S.prototype.getLogo=S.prototype.ya;S.prototype.getProjection=S.prototype.Ba;S.prototype.getState=S.prototype.getState;S.prototype.refresh=S.prototype.ua;S.prototype.setAttributions=S.prototype.va;S.prototype.get=S.prototype.get;S.prototype.getKeys=S.prototype.P;S.prototype.getProperties=S.prototype.M;S.prototype.set=S.prototype.set;
S.prototype.setProperties=S.prototype.H;S.prototype.unset=S.prototype.R;S.prototype.changed=S.prototype.u;S.prototype.dispatchEvent=S.prototype.b;S.prototype.getRevision=S.prototype.L;S.prototype.on=S.prototype.J;S.prototype.once=S.prototype.once;S.prototype.un=S.prototype.K;Y.prototype.addFeature=Y.prototype.Eb;Y.prototype.addFeatures=Y.prototype.Ic;Y.prototype.clear=Y.prototype.clear;Y.prototype.forEachFeature=Y.prototype.Ih;Y.prototype.forEachFeatureInExtent=Y.prototype.ac;
Y.prototype.forEachFeatureIntersectingExtent=Y.prototype.Jh;Y.prototype.getFeaturesCollection=Y.prototype.Qh;Y.prototype.getFeatures=Y.prototype.fe;Y.prototype.getFeaturesAtCoordinate=Y.prototype.Ph;Y.prototype.getFeaturesInExtent=Y.prototype.Zf;Y.prototype.getClosestFeatureToCoordinate=Y.prototype.Lh;Y.prototype.getExtent=Y.prototype.G;Y.prototype.getFeatureById=Y.prototype.Oh;Y.prototype.getFormat=Y.prototype.Zi;Y.prototype.getUrl=Y.prototype.$i;Y.prototype.removeFeature=Y.prototype.Ib;
Y.prototype.setLoader=Y.prototype.bj;Y.prototype.getAttributions=Y.prototype.Aa;Y.prototype.getLogo=Y.prototype.ya;Y.prototype.getProjection=Y.prototype.Ba;Y.prototype.getState=Y.prototype.getState;Y.prototype.refresh=Y.prototype.ua;Y.prototype.setAttributions=Y.prototype.va;Y.prototype.get=Y.prototype.get;Y.prototype.getKeys=Y.prototype.P;Y.prototype.getProperties=Y.prototype.M;Y.prototype.set=Y.prototype.set;Y.prototype.setProperties=Y.prototype.H;Y.prototype.unset=Y.prototype.R;
Y.prototype.changed=Y.prototype.u;Y.prototype.dispatchEvent=Y.prototype.b;Y.prototype.getRevision=Y.prototype.L;Y.prototype.on=Y.prototype.J;Y.prototype.once=Y.prototype.once;Y.prototype.un=Y.prototype.K;vw.prototype.getAttributions=vw.prototype.Aa;vw.prototype.getLogo=vw.prototype.ya;vw.prototype.getProjection=vw.prototype.Ba;vw.prototype.getState=vw.prototype.getState;vw.prototype.refresh=vw.prototype.ua;vw.prototype.setAttributions=vw.prototype.va;vw.prototype.get=vw.prototype.get;
vw.prototype.getKeys=vw.prototype.P;vw.prototype.getProperties=vw.prototype.M;vw.prototype.set=vw.prototype.set;vw.prototype.setProperties=vw.prototype.H;vw.prototype.unset=vw.prototype.R;vw.prototype.changed=vw.prototype.u;vw.prototype.dispatchEvent=vw.prototype.b;vw.prototype.getRevision=vw.prototype.L;vw.prototype.on=vw.prototype.J;vw.prototype.once=vw.prototype.once;vw.prototype.un=vw.prototype.K;xw.prototype.type=xw.prototype.type;xw.prototype.target=xw.prototype.target;
xw.prototype.preventDefault=xw.prototype.preventDefault;xw.prototype.stopPropagation=xw.prototype.stopPropagation;rx.prototype.getAttributions=rx.prototype.Aa;rx.prototype.getLogo=rx.prototype.ya;rx.prototype.getProjection=rx.prototype.Ba;rx.prototype.getState=rx.prototype.getState;rx.prototype.refresh=rx.prototype.ua;rx.prototype.setAttributions=rx.prototype.va;rx.prototype.get=rx.prototype.get;rx.prototype.getKeys=rx.prototype.P;rx.prototype.getProperties=rx.prototype.M;rx.prototype.set=rx.prototype.set;
rx.prototype.setProperties=rx.prototype.H;rx.prototype.unset=rx.prototype.R;rx.prototype.changed=rx.prototype.u;rx.prototype.dispatchEvent=rx.prototype.b;rx.prototype.getRevision=rx.prototype.L;rx.prototype.on=rx.prototype.J;rx.prototype.once=rx.prototype.once;rx.prototype.un=rx.prototype.K;Cw.prototype.getAttributions=Cw.prototype.Aa;Cw.prototype.getLogo=Cw.prototype.ya;Cw.prototype.getProjection=Cw.prototype.Ba;Cw.prototype.getState=Cw.prototype.getState;Cw.prototype.refresh=Cw.prototype.ua;
Cw.prototype.setAttributions=Cw.prototype.va;Cw.prototype.get=Cw.prototype.get;Cw.prototype.getKeys=Cw.prototype.P;Cw.prototype.getProperties=Cw.prototype.M;Cw.prototype.set=Cw.prototype.set;Cw.prototype.setProperties=Cw.prototype.H;Cw.prototype.unset=Cw.prototype.R;Cw.prototype.changed=Cw.prototype.u;Cw.prototype.dispatchEvent=Cw.prototype.b;Cw.prototype.getRevision=Cw.prototype.L;Cw.prototype.on=Cw.prototype.J;Cw.prototype.once=Cw.prototype.once;Cw.prototype.un=Cw.prototype.K;
sx.prototype.getAttributions=sx.prototype.Aa;sx.prototype.getLogo=sx.prototype.ya;sx.prototype.getProjection=sx.prototype.Ba;sx.prototype.getState=sx.prototype.getState;sx.prototype.refresh=sx.prototype.ua;sx.prototype.setAttributions=sx.prototype.va;sx.prototype.get=sx.prototype.get;sx.prototype.getKeys=sx.prototype.P;sx.prototype.getProperties=sx.prototype.M;sx.prototype.set=sx.prototype.set;sx.prototype.setProperties=sx.prototype.H;sx.prototype.unset=sx.prototype.R;sx.prototype.changed=sx.prototype.u;
sx.prototype.dispatchEvent=sx.prototype.b;sx.prototype.getRevision=sx.prototype.L;sx.prototype.on=sx.prototype.J;sx.prototype.once=sx.prototype.once;sx.prototype.un=sx.prototype.K;tx.prototype.getAttributions=tx.prototype.Aa;tx.prototype.getLogo=tx.prototype.ya;tx.prototype.getProjection=tx.prototype.Ba;tx.prototype.getState=tx.prototype.getState;tx.prototype.refresh=tx.prototype.ua;tx.prototype.setAttributions=tx.prototype.va;tx.prototype.get=tx.prototype.get;tx.prototype.getKeys=tx.prototype.P;
tx.prototype.getProperties=tx.prototype.M;tx.prototype.set=tx.prototype.set;tx.prototype.setProperties=tx.prototype.H;tx.prototype.unset=tx.prototype.R;tx.prototype.changed=tx.prototype.u;tx.prototype.dispatchEvent=tx.prototype.b;tx.prototype.getRevision=tx.prototype.L;tx.prototype.on=tx.prototype.J;tx.prototype.once=tx.prototype.once;tx.prototype.un=tx.prototype.K;Dw.prototype.getAttributions=Dw.prototype.Aa;Dw.prototype.getLogo=Dw.prototype.ya;Dw.prototype.getProjection=Dw.prototype.Ba;
Dw.prototype.getState=Dw.prototype.getState;Dw.prototype.refresh=Dw.prototype.ua;Dw.prototype.setAttributions=Dw.prototype.va;Dw.prototype.get=Dw.prototype.get;Dw.prototype.getKeys=Dw.prototype.P;Dw.prototype.getProperties=Dw.prototype.M;Dw.prototype.set=Dw.prototype.set;Dw.prototype.setProperties=Dw.prototype.H;Dw.prototype.unset=Dw.prototype.R;Dw.prototype.changed=Dw.prototype.u;Dw.prototype.dispatchEvent=Dw.prototype.b;Dw.prototype.getRevision=Dw.prototype.L;Dw.prototype.on=Dw.prototype.J;
Dw.prototype.once=Dw.prototype.once;Dw.prototype.un=Dw.prototype.K;ux.prototype.getAttributions=ux.prototype.Aa;ux.prototype.getLogo=ux.prototype.ya;ux.prototype.getProjection=ux.prototype.Ba;ux.prototype.getState=ux.prototype.getState;ux.prototype.refresh=ux.prototype.ua;ux.prototype.setAttributions=ux.prototype.va;ux.prototype.get=ux.prototype.get;ux.prototype.getKeys=ux.prototype.P;ux.prototype.getProperties=ux.prototype.M;ux.prototype.set=ux.prototype.set;ux.prototype.setProperties=ux.prototype.H;
ux.prototype.unset=ux.prototype.R;ux.prototype.changed=ux.prototype.u;ux.prototype.dispatchEvent=ux.prototype.b;ux.prototype.getRevision=ux.prototype.L;ux.prototype.on=ux.prototype.J;ux.prototype.once=ux.prototype.once;ux.prototype.un=ux.prototype.K;yx.prototype.setRenderReprojectionEdges=yx.prototype.Pb;yx.prototype.setTileGridForProjection=yx.prototype.Qb;yx.prototype.getTileLoadFunction=yx.prototype.vb;yx.prototype.getTileUrlFunction=yx.prototype.wb;yx.prototype.getUrls=yx.prototype.xb;
yx.prototype.setTileLoadFunction=yx.prototype.Cb;yx.prototype.setTileUrlFunction=yx.prototype.jb;yx.prototype.setUrl=yx.prototype.ob;yx.prototype.setUrls=yx.prototype.tb;yx.prototype.getTileGrid=yx.prototype.cb;yx.prototype.refresh=yx.prototype.ua;yx.prototype.getAttributions=yx.prototype.Aa;yx.prototype.getLogo=yx.prototype.ya;yx.prototype.getProjection=yx.prototype.Ba;yx.prototype.getState=yx.prototype.getState;yx.prototype.setAttributions=yx.prototype.va;yx.prototype.get=yx.prototype.get;
yx.prototype.getKeys=yx.prototype.P;yx.prototype.getProperties=yx.prototype.M;yx.prototype.set=yx.prototype.set;yx.prototype.setProperties=yx.prototype.H;yx.prototype.unset=yx.prototype.R;yx.prototype.changed=yx.prototype.u;yx.prototype.dispatchEvent=yx.prototype.b;yx.prototype.getRevision=yx.prototype.L;yx.prototype.on=yx.prototype.J;yx.prototype.once=yx.prototype.once;yx.prototype.un=yx.prototype.K;Ax.prototype.getAttributions=Ax.prototype.Aa;Ax.prototype.getLogo=Ax.prototype.ya;
Ax.prototype.getProjection=Ax.prototype.Ba;Ax.prototype.getState=Ax.prototype.getState;Ax.prototype.refresh=Ax.prototype.ua;Ax.prototype.setAttributions=Ax.prototype.va;Ax.prototype.get=Ax.prototype.get;Ax.prototype.getKeys=Ax.prototype.P;Ax.prototype.getProperties=Ax.prototype.M;Ax.prototype.set=Ax.prototype.set;Ax.prototype.setProperties=Ax.prototype.H;Ax.prototype.unset=Ax.prototype.R;Ax.prototype.changed=Ax.prototype.u;Ax.prototype.dispatchEvent=Ax.prototype.b;Ax.prototype.getRevision=Ax.prototype.L;
Ax.prototype.on=Ax.prototype.J;Ax.prototype.once=Ax.prototype.once;Ax.prototype.un=Ax.prototype.K;Ex.prototype.type=Ex.prototype.type;Ex.prototype.target=Ex.prototype.target;Ex.prototype.preventDefault=Ex.prototype.preventDefault;Ex.prototype.stopPropagation=Ex.prototype.stopPropagation;Hx.prototype.setRenderReprojectionEdges=Hx.prototype.Pb;Hx.prototype.setTileGridForProjection=Hx.prototype.Qb;Hx.prototype.getTileLoadFunction=Hx.prototype.vb;Hx.prototype.getTileUrlFunction=Hx.prototype.wb;
Hx.prototype.getUrls=Hx.prototype.xb;Hx.prototype.setTileLoadFunction=Hx.prototype.Cb;Hx.prototype.setTileUrlFunction=Hx.prototype.jb;Hx.prototype.setUrl=Hx.prototype.ob;Hx.prototype.setUrls=Hx.prototype.tb;Hx.prototype.getTileGrid=Hx.prototype.cb;Hx.prototype.refresh=Hx.prototype.ua;Hx.prototype.getAttributions=Hx.prototype.Aa;Hx.prototype.getLogo=Hx.prototype.ya;Hx.prototype.getProjection=Hx.prototype.Ba;Hx.prototype.getState=Hx.prototype.getState;Hx.prototype.setAttributions=Hx.prototype.va;
Hx.prototype.get=Hx.prototype.get;Hx.prototype.getKeys=Hx.prototype.P;Hx.prototype.getProperties=Hx.prototype.M;Hx.prototype.set=Hx.prototype.set;Hx.prototype.setProperties=Hx.prototype.H;Hx.prototype.unset=Hx.prototype.R;Hx.prototype.changed=Hx.prototype.u;Hx.prototype.dispatchEvent=Hx.prototype.b;Hx.prototype.getRevision=Hx.prototype.L;Hx.prototype.on=Hx.prototype.J;Hx.prototype.once=Hx.prototype.once;Hx.prototype.un=Hx.prototype.K;cx.prototype.type=cx.prototype.type;cx.prototype.target=cx.prototype.target;
cx.prototype.preventDefault=cx.prototype.preventDefault;cx.prototype.stopPropagation=cx.prototype.stopPropagation;Lx.prototype.setRenderReprojectionEdges=Lx.prototype.Pb;Lx.prototype.setTileGridForProjection=Lx.prototype.Qb;Lx.prototype.getTileLoadFunction=Lx.prototype.vb;Lx.prototype.getTileUrlFunction=Lx.prototype.wb;Lx.prototype.getUrls=Lx.prototype.xb;Lx.prototype.setTileLoadFunction=Lx.prototype.Cb;Lx.prototype.setTileUrlFunction=Lx.prototype.jb;Lx.prototype.setUrl=Lx.prototype.ob;
Lx.prototype.setUrls=Lx.prototype.tb;Lx.prototype.getTileGrid=Lx.prototype.cb;Lx.prototype.refresh=Lx.prototype.ua;Lx.prototype.getAttributions=Lx.prototype.Aa;Lx.prototype.getLogo=Lx.prototype.ya;Lx.prototype.getProjection=Lx.prototype.Ba;Lx.prototype.getState=Lx.prototype.getState;Lx.prototype.setAttributions=Lx.prototype.va;Lx.prototype.get=Lx.prototype.get;Lx.prototype.getKeys=Lx.prototype.P;Lx.prototype.getProperties=Lx.prototype.M;Lx.prototype.set=Lx.prototype.set;
Lx.prototype.setProperties=Lx.prototype.H;Lx.prototype.unset=Lx.prototype.R;Lx.prototype.changed=Lx.prototype.u;Lx.prototype.dispatchEvent=Lx.prototype.b;Lx.prototype.getRevision=Lx.prototype.L;Lx.prototype.on=Lx.prototype.J;Lx.prototype.once=Lx.prototype.once;Lx.prototype.un=Lx.prototype.K;Nx.prototype.getTileGrid=Nx.prototype.cb;Nx.prototype.refresh=Nx.prototype.ua;Nx.prototype.getAttributions=Nx.prototype.Aa;Nx.prototype.getLogo=Nx.prototype.ya;Nx.prototype.getProjection=Nx.prototype.Ba;
Nx.prototype.getState=Nx.prototype.getState;Nx.prototype.setAttributions=Nx.prototype.va;Nx.prototype.get=Nx.prototype.get;Nx.prototype.getKeys=Nx.prototype.P;Nx.prototype.getProperties=Nx.prototype.M;Nx.prototype.set=Nx.prototype.set;Nx.prototype.setProperties=Nx.prototype.H;Nx.prototype.unset=Nx.prototype.R;Nx.prototype.changed=Nx.prototype.u;Nx.prototype.dispatchEvent=Nx.prototype.b;Nx.prototype.getRevision=Nx.prototype.L;Nx.prototype.on=Nx.prototype.J;Nx.prototype.once=Nx.prototype.once;
Nx.prototype.un=Nx.prototype.K;Px.prototype.setRenderReprojectionEdges=Px.prototype.Pb;Px.prototype.setTileGridForProjection=Px.prototype.Qb;Px.prototype.getTileLoadFunction=Px.prototype.vb;Px.prototype.getTileUrlFunction=Px.prototype.wb;Px.prototype.getUrls=Px.prototype.xb;Px.prototype.setTileLoadFunction=Px.prototype.Cb;Px.prototype.setTileUrlFunction=Px.prototype.jb;Px.prototype.setUrl=Px.prototype.ob;Px.prototype.setUrls=Px.prototype.tb;Px.prototype.getTileGrid=Px.prototype.cb;
Px.prototype.refresh=Px.prototype.ua;Px.prototype.getAttributions=Px.prototype.Aa;Px.prototype.getLogo=Px.prototype.ya;Px.prototype.getProjection=Px.prototype.Ba;Px.prototype.getState=Px.prototype.getState;Px.prototype.setAttributions=Px.prototype.va;Px.prototype.get=Px.prototype.get;Px.prototype.getKeys=Px.prototype.P;Px.prototype.getProperties=Px.prototype.M;Px.prototype.set=Px.prototype.set;Px.prototype.setProperties=Px.prototype.H;Px.prototype.unset=Px.prototype.R;Px.prototype.changed=Px.prototype.u;
Px.prototype.dispatchEvent=Px.prototype.b;Px.prototype.getRevision=Px.prototype.L;Px.prototype.on=Px.prototype.J;Px.prototype.once=Px.prototype.once;Px.prototype.un=Px.prototype.K;Qx.prototype.getTileGrid=Qx.prototype.cb;Qx.prototype.refresh=Qx.prototype.ua;Qx.prototype.getAttributions=Qx.prototype.Aa;Qx.prototype.getLogo=Qx.prototype.ya;Qx.prototype.getProjection=Qx.prototype.Ba;Qx.prototype.getState=Qx.prototype.getState;Qx.prototype.setAttributions=Qx.prototype.va;Qx.prototype.get=Qx.prototype.get;
Qx.prototype.getKeys=Qx.prototype.P;Qx.prototype.getProperties=Qx.prototype.M;Qx.prototype.set=Qx.prototype.set;Qx.prototype.setProperties=Qx.prototype.H;Qx.prototype.unset=Qx.prototype.R;Qx.prototype.changed=Qx.prototype.u;Qx.prototype.dispatchEvent=Qx.prototype.b;Qx.prototype.getRevision=Qx.prototype.L;Qx.prototype.on=Qx.prototype.J;Qx.prototype.once=Qx.prototype.once;Qx.prototype.un=Qx.prototype.K;Ux.prototype.setRenderReprojectionEdges=Ux.prototype.Pb;Ux.prototype.setTileGridForProjection=Ux.prototype.Qb;
Ux.prototype.getTileLoadFunction=Ux.prototype.vb;Ux.prototype.getTileUrlFunction=Ux.prototype.wb;Ux.prototype.getUrls=Ux.prototype.xb;Ux.prototype.setTileLoadFunction=Ux.prototype.Cb;Ux.prototype.setTileUrlFunction=Ux.prototype.jb;Ux.prototype.setUrl=Ux.prototype.ob;Ux.prototype.setUrls=Ux.prototype.tb;Ux.prototype.getTileGrid=Ux.prototype.cb;Ux.prototype.refresh=Ux.prototype.ua;Ux.prototype.getAttributions=Ux.prototype.Aa;Ux.prototype.getLogo=Ux.prototype.ya;Ux.prototype.getProjection=Ux.prototype.Ba;
Ux.prototype.getState=Ux.prototype.getState;Ux.prototype.setAttributions=Ux.prototype.va;Ux.prototype.get=Ux.prototype.get;Ux.prototype.getKeys=Ux.prototype.P;Ux.prototype.getProperties=Ux.prototype.M;Ux.prototype.set=Ux.prototype.set;Ux.prototype.setProperties=Ux.prototype.H;Ux.prototype.unset=Ux.prototype.R;Ux.prototype.changed=Ux.prototype.u;Ux.prototype.dispatchEvent=Ux.prototype.b;Ux.prototype.getRevision=Ux.prototype.L;Ux.prototype.on=Ux.prototype.J;Ux.prototype.once=Ux.prototype.once;
Ux.prototype.un=Ux.prototype.K;Xs.prototype.type=Xs.prototype.type;Xs.prototype.target=Xs.prototype.target;Xs.prototype.preventDefault=Xs.prototype.preventDefault;Xs.prototype.stopPropagation=Xs.prototype.stopPropagation;by.prototype.getTileLoadFunction=by.prototype.vb;by.prototype.getTileUrlFunction=by.prototype.wb;by.prototype.getUrls=by.prototype.xb;by.prototype.setTileLoadFunction=by.prototype.Cb;by.prototype.setTileUrlFunction=by.prototype.jb;by.prototype.setUrl=by.prototype.ob;
by.prototype.setUrls=by.prototype.tb;by.prototype.getTileGrid=by.prototype.cb;by.prototype.refresh=by.prototype.ua;by.prototype.getAttributions=by.prototype.Aa;by.prototype.getLogo=by.prototype.ya;by.prototype.getProjection=by.prototype.Ba;by.prototype.getState=by.prototype.getState;by.prototype.setAttributions=by.prototype.va;by.prototype.get=by.prototype.get;by.prototype.getKeys=by.prototype.P;by.prototype.getProperties=by.prototype.M;by.prototype.set=by.prototype.set;
by.prototype.setProperties=by.prototype.H;by.prototype.unset=by.prototype.R;by.prototype.changed=by.prototype.u;by.prototype.dispatchEvent=by.prototype.b;by.prototype.getRevision=by.prototype.L;by.prototype.on=by.prototype.J;by.prototype.once=by.prototype.once;by.prototype.un=by.prototype.K;Z.prototype.setRenderReprojectionEdges=Z.prototype.Pb;Z.prototype.setTileGridForProjection=Z.prototype.Qb;Z.prototype.getTileLoadFunction=Z.prototype.vb;Z.prototype.getTileUrlFunction=Z.prototype.wb;
Z.prototype.getUrls=Z.prototype.xb;Z.prototype.setTileLoadFunction=Z.prototype.Cb;Z.prototype.setTileUrlFunction=Z.prototype.jb;Z.prototype.setUrl=Z.prototype.ob;Z.prototype.setUrls=Z.prototype.tb;Z.prototype.getTileGrid=Z.prototype.cb;Z.prototype.refresh=Z.prototype.ua;Z.prototype.getAttributions=Z.prototype.Aa;Z.prototype.getLogo=Z.prototype.ya;Z.prototype.getProjection=Z.prototype.Ba;Z.prototype.getState=Z.prototype.getState;Z.prototype.setAttributions=Z.prototype.va;Z.prototype.get=Z.prototype.get;
Z.prototype.getKeys=Z.prototype.P;Z.prototype.getProperties=Z.prototype.M;Z.prototype.set=Z.prototype.set;Z.prototype.setProperties=Z.prototype.H;Z.prototype.unset=Z.prototype.R;Z.prototype.changed=Z.prototype.u;Z.prototype.dispatchEvent=Z.prototype.b;Z.prototype.getRevision=Z.prototype.L;Z.prototype.on=Z.prototype.J;Z.prototype.once=Z.prototype.once;Z.prototype.un=Z.prototype.K;fy.prototype.setRenderReprojectionEdges=fy.prototype.Pb;fy.prototype.setTileGridForProjection=fy.prototype.Qb;
fy.prototype.getTileLoadFunction=fy.prototype.vb;fy.prototype.getTileUrlFunction=fy.prototype.wb;fy.prototype.getUrls=fy.prototype.xb;fy.prototype.setTileLoadFunction=fy.prototype.Cb;fy.prototype.setTileUrlFunction=fy.prototype.jb;fy.prototype.setUrl=fy.prototype.ob;fy.prototype.setUrls=fy.prototype.tb;fy.prototype.getTileGrid=fy.prototype.cb;fy.prototype.refresh=fy.prototype.ua;fy.prototype.getAttributions=fy.prototype.Aa;fy.prototype.getLogo=fy.prototype.ya;fy.prototype.getProjection=fy.prototype.Ba;
fy.prototype.getState=fy.prototype.getState;fy.prototype.setAttributions=fy.prototype.va;fy.prototype.get=fy.prototype.get;fy.prototype.getKeys=fy.prototype.P;fy.prototype.getProperties=fy.prototype.M;fy.prototype.set=fy.prototype.set;fy.prototype.setProperties=fy.prototype.H;fy.prototype.unset=fy.prototype.R;fy.prototype.changed=fy.prototype.u;fy.prototype.dispatchEvent=fy.prototype.b;fy.prototype.getRevision=fy.prototype.L;fy.prototype.on=fy.prototype.J;fy.prototype.once=fy.prototype.once;
fy.prototype.un=fy.prototype.K;Sw.prototype.getTileCoord=Sw.prototype.i;Sw.prototype.load=Sw.prototype.load;fi.prototype.changed=fi.prototype.u;fi.prototype.dispatchEvent=fi.prototype.b;fi.prototype.getRevision=fi.prototype.L;fi.prototype.on=fi.prototype.J;fi.prototype.once=fi.prototype.once;fi.prototype.un=fi.prototype.K;lw.prototype.changed=lw.prototype.u;lw.prototype.dispatchEvent=lw.prototype.b;lw.prototype.getRevision=lw.prototype.L;lw.prototype.on=lw.prototype.J;lw.prototype.once=lw.prototype.once;
lw.prototype.un=lw.prototype.K;Fw.prototype.changed=Fw.prototype.u;Fw.prototype.dispatchEvent=Fw.prototype.b;Fw.prototype.getRevision=Fw.prototype.L;Fw.prototype.on=Fw.prototype.J;Fw.prototype.once=Fw.prototype.once;Fw.prototype.un=Fw.prototype.K;Pw.prototype.changed=Pw.prototype.u;Pw.prototype.dispatchEvent=Pw.prototype.b;Pw.prototype.getRevision=Pw.prototype.L;Pw.prototype.on=Pw.prototype.J;Pw.prototype.once=Pw.prototype.once;Pw.prototype.un=Pw.prototype.K;Qw.prototype.changed=Qw.prototype.u;
Qw.prototype.dispatchEvent=Qw.prototype.b;Qw.prototype.getRevision=Qw.prototype.L;Qw.prototype.on=Qw.prototype.J;Qw.prototype.once=Qw.prototype.once;Qw.prototype.un=Qw.prototype.K;oi.prototype.changed=oi.prototype.u;oi.prototype.dispatchEvent=oi.prototype.b;oi.prototype.getRevision=oi.prototype.L;oi.prototype.on=oi.prototype.J;oi.prototype.once=oi.prototype.once;oi.prototype.un=oi.prototype.K;si.prototype.changed=si.prototype.u;si.prototype.dispatchEvent=si.prototype.b;si.prototype.getRevision=si.prototype.L;
si.prototype.on=si.prototype.J;si.prototype.once=si.prototype.once;si.prototype.un=si.prototype.K;vi.prototype.changed=vi.prototype.u;vi.prototype.dispatchEvent=vi.prototype.b;vi.prototype.getRevision=vi.prototype.L;vi.prototype.on=vi.prototype.J;vi.prototype.once=vi.prototype.once;vi.prototype.un=vi.prototype.K;Hi.prototype.changed=Hi.prototype.u;Hi.prototype.dispatchEvent=Hi.prototype.b;Hi.prototype.getRevision=Hi.prototype.L;Hi.prototype.on=Hi.prototype.J;Hi.prototype.once=Hi.prototype.once;
Hi.prototype.un=Hi.prototype.K;Aj.prototype.changed=Aj.prototype.u;Aj.prototype.dispatchEvent=Aj.prototype.b;Aj.prototype.getRevision=Aj.prototype.L;Aj.prototype.on=Aj.prototype.J;Aj.prototype.once=Aj.prototype.once;Aj.prototype.un=Aj.prototype.K;Cj.prototype.changed=Cj.prototype.u;Cj.prototype.dispatchEvent=Cj.prototype.b;Cj.prototype.getRevision=Cj.prototype.L;Cj.prototype.on=Cj.prototype.J;Cj.prototype.once=Cj.prototype.once;Cj.prototype.un=Cj.prototype.K;Ih.prototype.type=Ih.prototype.type;
Ih.prototype.target=Ih.prototype.target;Ih.prototype.preventDefault=Ih.prototype.preventDefault;Ih.prototype.stopPropagation=Ih.prototype.stopPropagation;Od.prototype.type=Od.prototype.type;Od.prototype.target=Od.prototype.target;Od.prototype.preventDefault=Od.prototype.preventDefault;Od.prototype.stopPropagation=Od.prototype.stopPropagation;gg.prototype.get=gg.prototype.get;gg.prototype.getKeys=gg.prototype.P;gg.prototype.getProperties=gg.prototype.M;gg.prototype.set=gg.prototype.set;
gg.prototype.setProperties=gg.prototype.H;gg.prototype.unset=gg.prototype.R;gg.prototype.changed=gg.prototype.u;gg.prototype.dispatchEvent=gg.prototype.b;gg.prototype.getRevision=gg.prototype.L;gg.prototype.on=gg.prototype.J;gg.prototype.once=gg.prototype.once;gg.prototype.un=gg.prototype.K;ig.prototype.getExtent=ig.prototype.G;ig.prototype.getMaxResolution=ig.prototype.hc;ig.prototype.getMinResolution=ig.prototype.ic;ig.prototype.getOpacity=ig.prototype.jc;ig.prototype.getVisible=ig.prototype.Tb;
ig.prototype.getZIndex=ig.prototype.za;ig.prototype.setExtent=ig.prototype.zc;ig.prototype.setMaxResolution=ig.prototype.Ec;ig.prototype.setMinResolution=ig.prototype.Fc;ig.prototype.setOpacity=ig.prototype.Ac;ig.prototype.setVisible=ig.prototype.Bc;ig.prototype.setZIndex=ig.prototype.Xb;ig.prototype.get=ig.prototype.get;ig.prototype.getKeys=ig.prototype.P;ig.prototype.getProperties=ig.prototype.M;ig.prototype.set=ig.prototype.set;ig.prototype.setProperties=ig.prototype.H;ig.prototype.unset=ig.prototype.R;
ig.prototype.changed=ig.prototype.u;ig.prototype.dispatchEvent=ig.prototype.b;ig.prototype.getRevision=ig.prototype.L;ig.prototype.on=ig.prototype.J;ig.prototype.once=ig.prototype.once;ig.prototype.un=ig.prototype.K;wi.prototype.getExtent=wi.prototype.G;wi.prototype.getMaxResolution=wi.prototype.hc;wi.prototype.getMinResolution=wi.prototype.ic;wi.prototype.getOpacity=wi.prototype.jc;wi.prototype.getVisible=wi.prototype.Tb;wi.prototype.getZIndex=wi.prototype.za;wi.prototype.setExtent=wi.prototype.zc;
wi.prototype.setMaxResolution=wi.prototype.Ec;wi.prototype.setMinResolution=wi.prototype.Fc;wi.prototype.setOpacity=wi.prototype.Ac;wi.prototype.setVisible=wi.prototype.Bc;wi.prototype.setZIndex=wi.prototype.Xb;wi.prototype.get=wi.prototype.get;wi.prototype.getKeys=wi.prototype.P;wi.prototype.getProperties=wi.prototype.M;wi.prototype.set=wi.prototype.set;wi.prototype.setProperties=wi.prototype.H;wi.prototype.unset=wi.prototype.R;wi.prototype.changed=wi.prototype.u;wi.prototype.dispatchEvent=wi.prototype.b;
wi.prototype.getRevision=wi.prototype.L;wi.prototype.on=wi.prototype.J;wi.prototype.once=wi.prototype.once;wi.prototype.un=wi.prototype.K;R.prototype.setMap=R.prototype.setMap;R.prototype.setSource=R.prototype.bd;R.prototype.getExtent=R.prototype.G;R.prototype.getMaxResolution=R.prototype.hc;R.prototype.getMinResolution=R.prototype.ic;R.prototype.getOpacity=R.prototype.jc;R.prototype.getVisible=R.prototype.Tb;R.prototype.getZIndex=R.prototype.za;R.prototype.setExtent=R.prototype.zc;
R.prototype.setMaxResolution=R.prototype.Ec;R.prototype.setMinResolution=R.prototype.Fc;R.prototype.setOpacity=R.prototype.Ac;R.prototype.setVisible=R.prototype.Bc;R.prototype.setZIndex=R.prototype.Xb;R.prototype.get=R.prototype.get;R.prototype.getKeys=R.prototype.P;R.prototype.getProperties=R.prototype.M;R.prototype.set=R.prototype.set;R.prototype.setProperties=R.prototype.H;R.prototype.unset=R.prototype.R;R.prototype.changed=R.prototype.u;R.prototype.dispatchEvent=R.prototype.b;
R.prototype.getRevision=R.prototype.L;R.prototype.on=R.prototype.J;R.prototype.once=R.prototype.once;R.prototype.un=R.prototype.K;V.prototype.getSource=V.prototype.ia;V.prototype.getStyle=V.prototype.D;V.prototype.getStyleFunction=V.prototype.bb;V.prototype.setStyle=V.prototype.j;V.prototype.setMap=V.prototype.setMap;V.prototype.setSource=V.prototype.bd;V.prototype.getExtent=V.prototype.G;V.prototype.getMaxResolution=V.prototype.hc;V.prototype.getMinResolution=V.prototype.ic;
V.prototype.getOpacity=V.prototype.jc;V.prototype.getVisible=V.prototype.Tb;V.prototype.getZIndex=V.prototype.za;V.prototype.setExtent=V.prototype.zc;V.prototype.setMaxResolution=V.prototype.Ec;V.prototype.setMinResolution=V.prototype.Fc;V.prototype.setOpacity=V.prototype.Ac;V.prototype.setVisible=V.prototype.Bc;V.prototype.setZIndex=V.prototype.Xb;V.prototype.get=V.prototype.get;V.prototype.getKeys=V.prototype.P;V.prototype.getProperties=V.prototype.M;V.prototype.set=V.prototype.set;
V.prototype.setProperties=V.prototype.H;V.prototype.unset=V.prototype.R;V.prototype.changed=V.prototype.u;V.prototype.dispatchEvent=V.prototype.b;V.prototype.getRevision=V.prototype.L;V.prototype.on=V.prototype.J;V.prototype.once=V.prototype.once;V.prototype.un=V.prototype.K;nu.prototype.setMap=nu.prototype.setMap;nu.prototype.setSource=nu.prototype.bd;nu.prototype.getExtent=nu.prototype.G;nu.prototype.getMaxResolution=nu.prototype.hc;nu.prototype.getMinResolution=nu.prototype.ic;
nu.prototype.getOpacity=nu.prototype.jc;nu.prototype.getVisible=nu.prototype.Tb;nu.prototype.getZIndex=nu.prototype.za;nu.prototype.setExtent=nu.prototype.zc;nu.prototype.setMaxResolution=nu.prototype.Ec;nu.prototype.setMinResolution=nu.prototype.Fc;nu.prototype.setOpacity=nu.prototype.Ac;nu.prototype.setVisible=nu.prototype.Bc;nu.prototype.setZIndex=nu.prototype.Xb;nu.prototype.get=nu.prototype.get;nu.prototype.getKeys=nu.prototype.P;nu.prototype.getProperties=nu.prototype.M;nu.prototype.set=nu.prototype.set;
nu.prototype.setProperties=nu.prototype.H;nu.prototype.unset=nu.prototype.R;nu.prototype.changed=nu.prototype.u;nu.prototype.dispatchEvent=nu.prototype.b;nu.prototype.getRevision=nu.prototype.L;nu.prototype.on=nu.prototype.J;nu.prototype.once=nu.prototype.once;nu.prototype.un=nu.prototype.K;ou.prototype.setMap=ou.prototype.setMap;ou.prototype.setSource=ou.prototype.bd;ou.prototype.getExtent=ou.prototype.G;ou.prototype.getMaxResolution=ou.prototype.hc;ou.prototype.getMinResolution=ou.prototype.ic;
ou.prototype.getOpacity=ou.prototype.jc;ou.prototype.getVisible=ou.prototype.Tb;ou.prototype.getZIndex=ou.prototype.za;ou.prototype.setExtent=ou.prototype.zc;ou.prototype.setMaxResolution=ou.prototype.Ec;ou.prototype.setMinResolution=ou.prototype.Fc;ou.prototype.setOpacity=ou.prototype.Ac;ou.prototype.setVisible=ou.prototype.Bc;ou.prototype.setZIndex=ou.prototype.Xb;ou.prototype.get=ou.prototype.get;ou.prototype.getKeys=ou.prototype.P;ou.prototype.getProperties=ou.prototype.M;ou.prototype.set=ou.prototype.set;
ou.prototype.setProperties=ou.prototype.H;ou.prototype.unset=ou.prototype.R;ou.prototype.changed=ou.prototype.u;ou.prototype.dispatchEvent=ou.prototype.b;ou.prototype.getRevision=ou.prototype.L;ou.prototype.on=ou.prototype.J;ou.prototype.once=ou.prototype.once;ou.prototype.un=ou.prototype.K;W.prototype.getStyle=W.prototype.D;W.prototype.getStyleFunction=W.prototype.bb;W.prototype.setStyle=W.prototype.j;W.prototype.setMap=W.prototype.setMap;W.prototype.setSource=W.prototype.bd;
W.prototype.getExtent=W.prototype.G;W.prototype.getMaxResolution=W.prototype.hc;W.prototype.getMinResolution=W.prototype.ic;W.prototype.getOpacity=W.prototype.jc;W.prototype.getVisible=W.prototype.Tb;W.prototype.getZIndex=W.prototype.za;W.prototype.setExtent=W.prototype.zc;W.prototype.setMaxResolution=W.prototype.Ec;W.prototype.setMinResolution=W.prototype.Fc;W.prototype.setOpacity=W.prototype.Ac;W.prototype.setVisible=W.prototype.Bc;W.prototype.setZIndex=W.prototype.Xb;W.prototype.get=W.prototype.get;
W.prototype.getKeys=W.prototype.P;W.prototype.getProperties=W.prototype.M;W.prototype.set=W.prototype.set;W.prototype.setProperties=W.prototype.H;W.prototype.unset=W.prototype.R;W.prototype.changed=W.prototype.u;W.prototype.dispatchEvent=W.prototype.b;W.prototype.getRevision=W.prototype.L;W.prototype.on=W.prototype.J;W.prototype.once=W.prototype.once;W.prototype.un=W.prototype.K;Bg.prototype.get=Bg.prototype.get;Bg.prototype.getKeys=Bg.prototype.P;Bg.prototype.getProperties=Bg.prototype.M;
Bg.prototype.set=Bg.prototype.set;Bg.prototype.setProperties=Bg.prototype.H;Bg.prototype.unset=Bg.prototype.R;Bg.prototype.changed=Bg.prototype.u;Bg.prototype.dispatchEvent=Bg.prototype.b;Bg.prototype.getRevision=Bg.prototype.L;Bg.prototype.on=Bg.prototype.J;Bg.prototype.once=Bg.prototype.once;Bg.prototype.un=Bg.prototype.K;Hg.prototype.getActive=Hg.prototype.c;Hg.prototype.getMap=Hg.prototype.i;Hg.prototype.setActive=Hg.prototype.Ga;Hg.prototype.get=Hg.prototype.get;Hg.prototype.getKeys=Hg.prototype.P;
Hg.prototype.getProperties=Hg.prototype.M;Hg.prototype.set=Hg.prototype.set;Hg.prototype.setProperties=Hg.prototype.H;Hg.prototype.unset=Hg.prototype.R;Hg.prototype.changed=Hg.prototype.u;Hg.prototype.dispatchEvent=Hg.prototype.b;Hg.prototype.getRevision=Hg.prototype.L;Hg.prototype.on=Hg.prototype.J;Hg.prototype.once=Hg.prototype.once;Hg.prototype.un=Hg.prototype.K;ys.prototype.getActive=ys.prototype.c;ys.prototype.getMap=ys.prototype.i;ys.prototype.setActive=ys.prototype.Ga;ys.prototype.get=ys.prototype.get;
ys.prototype.getKeys=ys.prototype.P;ys.prototype.getProperties=ys.prototype.M;ys.prototype.set=ys.prototype.set;ys.prototype.setProperties=ys.prototype.H;ys.prototype.unset=ys.prototype.R;ys.prototype.changed=ys.prototype.u;ys.prototype.dispatchEvent=ys.prototype.b;ys.prototype.getRevision=ys.prototype.L;ys.prototype.on=ys.prototype.J;ys.prototype.once=ys.prototype.once;ys.prototype.un=ys.prototype.K;Bs.prototype.type=Bs.prototype.type;Bs.prototype.target=Bs.prototype.target;
Bs.prototype.preventDefault=Bs.prototype.preventDefault;Bs.prototype.stopPropagation=Bs.prototype.stopPropagation;Tg.prototype.getActive=Tg.prototype.c;Tg.prototype.getMap=Tg.prototype.i;Tg.prototype.setActive=Tg.prototype.Ga;Tg.prototype.get=Tg.prototype.get;Tg.prototype.getKeys=Tg.prototype.P;Tg.prototype.getProperties=Tg.prototype.M;Tg.prototype.set=Tg.prototype.set;Tg.prototype.setProperties=Tg.prototype.H;Tg.prototype.unset=Tg.prototype.R;Tg.prototype.changed=Tg.prototype.u;
Tg.prototype.dispatchEvent=Tg.prototype.b;Tg.prototype.getRevision=Tg.prototype.L;Tg.prototype.on=Tg.prototype.J;Tg.prototype.once=Tg.prototype.once;Tg.prototype.un=Tg.prototype.K;gh.prototype.getActive=gh.prototype.c;gh.prototype.getMap=gh.prototype.i;gh.prototype.setActive=gh.prototype.Ga;gh.prototype.get=gh.prototype.get;gh.prototype.getKeys=gh.prototype.P;gh.prototype.getProperties=gh.prototype.M;gh.prototype.set=gh.prototype.set;gh.prototype.setProperties=gh.prototype.H;gh.prototype.unset=gh.prototype.R;
gh.prototype.changed=gh.prototype.u;gh.prototype.dispatchEvent=gh.prototype.b;gh.prototype.getRevision=gh.prototype.L;gh.prototype.on=gh.prototype.J;gh.prototype.once=gh.prototype.once;gh.prototype.un=gh.prototype.K;lh.prototype.type=lh.prototype.type;lh.prototype.target=lh.prototype.target;lh.prototype.preventDefault=lh.prototype.preventDefault;lh.prototype.stopPropagation=lh.prototype.stopPropagation;Wg.prototype.getActive=Wg.prototype.c;Wg.prototype.getMap=Wg.prototype.i;
Wg.prototype.setActive=Wg.prototype.Ga;Wg.prototype.get=Wg.prototype.get;Wg.prototype.getKeys=Wg.prototype.P;Wg.prototype.getProperties=Wg.prototype.M;Wg.prototype.set=Wg.prototype.set;Wg.prototype.setProperties=Wg.prototype.H;Wg.prototype.unset=Wg.prototype.R;Wg.prototype.changed=Wg.prototype.u;Wg.prototype.dispatchEvent=Wg.prototype.b;Wg.prototype.getRevision=Wg.prototype.L;Wg.prototype.on=Wg.prototype.J;Wg.prototype.once=Wg.prototype.once;Wg.prototype.un=Wg.prototype.K;$g.prototype.getActive=$g.prototype.c;
$g.prototype.getMap=$g.prototype.i;$g.prototype.setActive=$g.prototype.Ga;$g.prototype.get=$g.prototype.get;$g.prototype.getKeys=$g.prototype.P;$g.prototype.getProperties=$g.prototype.M;$g.prototype.set=$g.prototype.set;$g.prototype.setProperties=$g.prototype.H;$g.prototype.unset=$g.prototype.R;$g.prototype.changed=$g.prototype.u;$g.prototype.dispatchEvent=$g.prototype.b;$g.prototype.getRevision=$g.prototype.L;$g.prototype.on=$g.prototype.J;$g.prototype.once=$g.prototype.once;$g.prototype.un=$g.prototype.K;
Fs.prototype.getActive=Fs.prototype.c;Fs.prototype.getMap=Fs.prototype.i;Fs.prototype.setActive=Fs.prototype.Ga;Fs.prototype.get=Fs.prototype.get;Fs.prototype.getKeys=Fs.prototype.P;Fs.prototype.getProperties=Fs.prototype.M;Fs.prototype.set=Fs.prototype.set;Fs.prototype.setProperties=Fs.prototype.H;Fs.prototype.unset=Fs.prototype.R;Fs.prototype.changed=Fs.prototype.u;Fs.prototype.dispatchEvent=Fs.prototype.b;Fs.prototype.getRevision=Fs.prototype.L;Fs.prototype.on=Fs.prototype.J;
Fs.prototype.once=Fs.prototype.once;Fs.prototype.un=Fs.prototype.K;ph.prototype.getGeometry=ph.prototype.W;ph.prototype.getActive=ph.prototype.c;ph.prototype.getMap=ph.prototype.i;ph.prototype.setActive=ph.prototype.Ga;ph.prototype.get=ph.prototype.get;ph.prototype.getKeys=ph.prototype.P;ph.prototype.getProperties=ph.prototype.M;ph.prototype.set=ph.prototype.set;ph.prototype.setProperties=ph.prototype.H;ph.prototype.unset=ph.prototype.R;ph.prototype.changed=ph.prototype.u;
ph.prototype.dispatchEvent=ph.prototype.b;ph.prototype.getRevision=ph.prototype.L;ph.prototype.on=ph.prototype.J;ph.prototype.once=ph.prototype.once;ph.prototype.un=ph.prototype.K;$s.prototype.getActive=$s.prototype.c;$s.prototype.getMap=$s.prototype.i;$s.prototype.setActive=$s.prototype.Ga;$s.prototype.get=$s.prototype.get;$s.prototype.getKeys=$s.prototype.P;$s.prototype.getProperties=$s.prototype.M;$s.prototype.set=$s.prototype.set;$s.prototype.setProperties=$s.prototype.H;$s.prototype.unset=$s.prototype.R;
$s.prototype.changed=$s.prototype.u;$s.prototype.dispatchEvent=$s.prototype.b;$s.prototype.getRevision=$s.prototype.L;$s.prototype.on=$s.prototype.J;$s.prototype.once=$s.prototype.once;$s.prototype.un=$s.prototype.K;pt.prototype.type=pt.prototype.type;pt.prototype.target=pt.prototype.target;pt.prototype.preventDefault=pt.prototype.preventDefault;pt.prototype.stopPropagation=pt.prototype.stopPropagation;qt.prototype.getActive=qt.prototype.c;qt.prototype.getMap=qt.prototype.i;
qt.prototype.setActive=qt.prototype.Ga;qt.prototype.get=qt.prototype.get;qt.prototype.getKeys=qt.prototype.P;qt.prototype.getProperties=qt.prototype.M;qt.prototype.set=qt.prototype.set;qt.prototype.setProperties=qt.prototype.H;qt.prototype.unset=qt.prototype.R;qt.prototype.changed=qt.prototype.u;qt.prototype.dispatchEvent=qt.prototype.b;qt.prototype.getRevision=qt.prototype.L;qt.prototype.on=qt.prototype.J;qt.prototype.once=qt.prototype.once;qt.prototype.un=qt.prototype.K;Bt.prototype.type=Bt.prototype.type;
Bt.prototype.target=Bt.prototype.target;Bt.prototype.preventDefault=Bt.prototype.preventDefault;Bt.prototype.stopPropagation=Bt.prototype.stopPropagation;qh.prototype.getActive=qh.prototype.c;qh.prototype.getMap=qh.prototype.i;qh.prototype.setActive=qh.prototype.Ga;qh.prototype.get=qh.prototype.get;qh.prototype.getKeys=qh.prototype.P;qh.prototype.getProperties=qh.prototype.M;qh.prototype.set=qh.prototype.set;qh.prototype.setProperties=qh.prototype.H;qh.prototype.unset=qh.prototype.R;
qh.prototype.changed=qh.prototype.u;qh.prototype.dispatchEvent=qh.prototype.b;qh.prototype.getRevision=qh.prototype.L;qh.prototype.on=qh.prototype.J;qh.prototype.once=qh.prototype.once;qh.prototype.un=qh.prototype.K;th.prototype.getActive=th.prototype.c;th.prototype.getMap=th.prototype.i;th.prototype.setActive=th.prototype.Ga;th.prototype.get=th.prototype.get;th.prototype.getKeys=th.prototype.P;th.prototype.getProperties=th.prototype.M;th.prototype.set=th.prototype.set;
th.prototype.setProperties=th.prototype.H;th.prototype.unset=th.prototype.R;th.prototype.changed=th.prototype.u;th.prototype.dispatchEvent=th.prototype.b;th.prototype.getRevision=th.prototype.L;th.prototype.on=th.prototype.J;th.prototype.once=th.prototype.once;th.prototype.un=th.prototype.K;Ct.prototype.getActive=Ct.prototype.c;Ct.prototype.getMap=Ct.prototype.i;Ct.prototype.setActive=Ct.prototype.Ga;Ct.prototype.get=Ct.prototype.get;Ct.prototype.getKeys=Ct.prototype.P;
Ct.prototype.getProperties=Ct.prototype.M;Ct.prototype.set=Ct.prototype.set;Ct.prototype.setProperties=Ct.prototype.H;Ct.prototype.unset=Ct.prototype.R;Ct.prototype.changed=Ct.prototype.u;Ct.prototype.dispatchEvent=Ct.prototype.b;Ct.prototype.getRevision=Ct.prototype.L;Ct.prototype.on=Ct.prototype.J;Ct.prototype.once=Ct.prototype.once;Ct.prototype.un=Ct.prototype.K;Kt.prototype.type=Kt.prototype.type;Kt.prototype.target=Kt.prototype.target;Kt.prototype.preventDefault=Kt.prototype.preventDefault;
Kt.prototype.stopPropagation=Kt.prototype.stopPropagation;vh.prototype.getActive=vh.prototype.c;vh.prototype.getMap=vh.prototype.i;vh.prototype.setActive=vh.prototype.Ga;vh.prototype.get=vh.prototype.get;vh.prototype.getKeys=vh.prototype.P;vh.prototype.getProperties=vh.prototype.M;vh.prototype.set=vh.prototype.set;vh.prototype.setProperties=vh.prototype.H;vh.prototype.unset=vh.prototype.R;vh.prototype.changed=vh.prototype.u;vh.prototype.dispatchEvent=vh.prototype.b;vh.prototype.getRevision=vh.prototype.L;
vh.prototype.on=vh.prototype.J;vh.prototype.once=vh.prototype.once;vh.prototype.un=vh.prototype.K;zh.prototype.getActive=zh.prototype.c;zh.prototype.getMap=zh.prototype.i;zh.prototype.setActive=zh.prototype.Ga;zh.prototype.get=zh.prototype.get;zh.prototype.getKeys=zh.prototype.P;zh.prototype.getProperties=zh.prototype.M;zh.prototype.set=zh.prototype.set;zh.prototype.setProperties=zh.prototype.H;zh.prototype.unset=zh.prototype.R;zh.prototype.changed=zh.prototype.u;zh.prototype.dispatchEvent=zh.prototype.b;
zh.prototype.getRevision=zh.prototype.L;zh.prototype.on=zh.prototype.J;zh.prototype.once=zh.prototype.once;zh.prototype.un=zh.prototype.K;Dh.prototype.getActive=Dh.prototype.c;Dh.prototype.getMap=Dh.prototype.i;Dh.prototype.setActive=Dh.prototype.Ga;Dh.prototype.get=Dh.prototype.get;Dh.prototype.getKeys=Dh.prototype.P;Dh.prototype.getProperties=Dh.prototype.M;Dh.prototype.set=Dh.prototype.set;Dh.prototype.setProperties=Dh.prototype.H;Dh.prototype.unset=Dh.prototype.R;Dh.prototype.changed=Dh.prototype.u;
Dh.prototype.dispatchEvent=Dh.prototype.b;Dh.prototype.getRevision=Dh.prototype.L;Dh.prototype.on=Dh.prototype.J;Dh.prototype.once=Dh.prototype.once;Dh.prototype.un=Dh.prototype.K;St.prototype.getActive=St.prototype.c;St.prototype.getMap=St.prototype.i;St.prototype.setActive=St.prototype.Ga;St.prototype.get=St.prototype.get;St.prototype.getKeys=St.prototype.P;St.prototype.getProperties=St.prototype.M;St.prototype.set=St.prototype.set;St.prototype.setProperties=St.prototype.H;St.prototype.unset=St.prototype.R;
St.prototype.changed=St.prototype.u;St.prototype.dispatchEvent=St.prototype.b;St.prototype.getRevision=St.prototype.L;St.prototype.on=St.prototype.J;St.prototype.once=St.prototype.once;St.prototype.un=St.prototype.K;Vt.prototype.type=Vt.prototype.type;Vt.prototype.target=Vt.prototype.target;Vt.prototype.preventDefault=Vt.prototype.preventDefault;Vt.prototype.stopPropagation=Vt.prototype.stopPropagation;Xt.prototype.getActive=Xt.prototype.c;Xt.prototype.getMap=Xt.prototype.i;
Xt.prototype.setActive=Xt.prototype.Ga;Xt.prototype.get=Xt.prototype.get;Xt.prototype.getKeys=Xt.prototype.P;Xt.prototype.getProperties=Xt.prototype.M;Xt.prototype.set=Xt.prototype.set;Xt.prototype.setProperties=Xt.prototype.H;Xt.prototype.unset=Xt.prototype.R;Xt.prototype.changed=Xt.prototype.u;Xt.prototype.dispatchEvent=Xt.prototype.b;Xt.prototype.getRevision=Xt.prototype.L;Xt.prototype.on=Xt.prototype.J;Xt.prototype.once=Xt.prototype.once;Xt.prototype.un=Xt.prototype.K;bu.prototype.getActive=bu.prototype.c;
bu.prototype.getMap=bu.prototype.i;bu.prototype.setActive=bu.prototype.Ga;bu.prototype.get=bu.prototype.get;bu.prototype.getKeys=bu.prototype.P;bu.prototype.getProperties=bu.prototype.M;bu.prototype.set=bu.prototype.set;bu.prototype.setProperties=bu.prototype.H;bu.prototype.unset=bu.prototype.R;bu.prototype.changed=bu.prototype.u;bu.prototype.dispatchEvent=bu.prototype.b;bu.prototype.getRevision=bu.prototype.L;bu.prototype.on=bu.prototype.J;bu.prototype.once=bu.prototype.once;bu.prototype.un=bu.prototype.K;
hu.prototype.type=hu.prototype.type;hu.prototype.target=hu.prototype.target;hu.prototype.preventDefault=hu.prototype.preventDefault;hu.prototype.stopPropagation=hu.prototype.stopPropagation;ef.prototype.get=ef.prototype.get;ef.prototype.getKeys=ef.prototype.P;ef.prototype.getProperties=ef.prototype.M;ef.prototype.set=ef.prototype.set;ef.prototype.setProperties=ef.prototype.H;ef.prototype.unset=ef.prototype.R;ef.prototype.changed=ef.prototype.u;ef.prototype.dispatchEvent=ef.prototype.b;
ef.prototype.getRevision=ef.prototype.L;ef.prototype.on=ef.prototype.J;ef.prototype.once=ef.prototype.once;ef.prototype.un=ef.prototype.K;ff.prototype.getClosestPoint=ff.prototype.Gb;ff.prototype.intersectsCoordinate=ff.prototype.yb;ff.prototype.getExtent=ff.prototype.G;ff.prototype.rotate=ff.prototype.rotate;ff.prototype.scale=ff.prototype.scale;ff.prototype.simplify=ff.prototype.Rb;ff.prototype.transform=ff.prototype.hb;ff.prototype.get=ff.prototype.get;ff.prototype.getKeys=ff.prototype.P;
ff.prototype.getProperties=ff.prototype.M;ff.prototype.set=ff.prototype.set;ff.prototype.setProperties=ff.prototype.H;ff.prototype.unset=ff.prototype.R;ff.prototype.changed=ff.prototype.u;ff.prototype.dispatchEvent=ff.prototype.b;ff.prototype.getRevision=ff.prototype.L;ff.prototype.on=ff.prototype.J;ff.prototype.once=ff.prototype.once;ff.prototype.un=ff.prototype.K;es.prototype.getFirstCoordinate=es.prototype.bc;es.prototype.getLastCoordinate=es.prototype.cc;es.prototype.getLayout=es.prototype.ec;
es.prototype.rotate=es.prototype.rotate;es.prototype.scale=es.prototype.scale;es.prototype.getClosestPoint=es.prototype.Gb;es.prototype.intersectsCoordinate=es.prototype.yb;es.prototype.getExtent=es.prototype.G;es.prototype.simplify=es.prototype.Rb;es.prototype.get=es.prototype.get;es.prototype.getKeys=es.prototype.P;es.prototype.getProperties=es.prototype.M;es.prototype.set=es.prototype.set;es.prototype.setProperties=es.prototype.H;es.prototype.unset=es.prototype.R;es.prototype.changed=es.prototype.u;
es.prototype.dispatchEvent=es.prototype.b;es.prototype.getRevision=es.prototype.L;es.prototype.on=es.prototype.J;es.prototype.once=es.prototype.once;es.prototype.un=es.prototype.K;Wl.prototype.getClosestPoint=Wl.prototype.Gb;Wl.prototype.intersectsCoordinate=Wl.prototype.yb;Wl.prototype.getExtent=Wl.prototype.G;Wl.prototype.rotate=Wl.prototype.rotate;Wl.prototype.scale=Wl.prototype.scale;Wl.prototype.simplify=Wl.prototype.Rb;Wl.prototype.transform=Wl.prototype.hb;Wl.prototype.get=Wl.prototype.get;
Wl.prototype.getKeys=Wl.prototype.P;Wl.prototype.getProperties=Wl.prototype.M;Wl.prototype.set=Wl.prototype.set;Wl.prototype.setProperties=Wl.prototype.H;Wl.prototype.unset=Wl.prototype.R;Wl.prototype.changed=Wl.prototype.u;Wl.prototype.dispatchEvent=Wl.prototype.b;Wl.prototype.getRevision=Wl.prototype.L;Wl.prototype.on=Wl.prototype.J;Wl.prototype.once=Wl.prototype.once;Wl.prototype.un=Wl.prototype.K;Bf.prototype.getFirstCoordinate=Bf.prototype.bc;Bf.prototype.getLastCoordinate=Bf.prototype.cc;
Bf.prototype.getLayout=Bf.prototype.ec;Bf.prototype.rotate=Bf.prototype.rotate;Bf.prototype.scale=Bf.prototype.scale;Bf.prototype.getClosestPoint=Bf.prototype.Gb;Bf.prototype.intersectsCoordinate=Bf.prototype.yb;Bf.prototype.getExtent=Bf.prototype.G;Bf.prototype.simplify=Bf.prototype.Rb;Bf.prototype.transform=Bf.prototype.hb;Bf.prototype.get=Bf.prototype.get;Bf.prototype.getKeys=Bf.prototype.P;Bf.prototype.getProperties=Bf.prototype.M;Bf.prototype.set=Bf.prototype.set;Bf.prototype.setProperties=Bf.prototype.H;
Bf.prototype.unset=Bf.prototype.R;Bf.prototype.changed=Bf.prototype.u;Bf.prototype.dispatchEvent=Bf.prototype.b;Bf.prototype.getRevision=Bf.prototype.L;Bf.prototype.on=Bf.prototype.J;Bf.prototype.once=Bf.prototype.once;Bf.prototype.un=Bf.prototype.K;M.prototype.getFirstCoordinate=M.prototype.bc;M.prototype.getLastCoordinate=M.prototype.cc;M.prototype.getLayout=M.prototype.ec;M.prototype.rotate=M.prototype.rotate;M.prototype.scale=M.prototype.scale;M.prototype.getClosestPoint=M.prototype.Gb;
M.prototype.intersectsCoordinate=M.prototype.yb;M.prototype.getExtent=M.prototype.G;M.prototype.simplify=M.prototype.Rb;M.prototype.transform=M.prototype.hb;M.prototype.get=M.prototype.get;M.prototype.getKeys=M.prototype.P;M.prototype.getProperties=M.prototype.M;M.prototype.set=M.prototype.set;M.prototype.setProperties=M.prototype.H;M.prototype.unset=M.prototype.R;M.prototype.changed=M.prototype.u;M.prototype.dispatchEvent=M.prototype.b;M.prototype.getRevision=M.prototype.L;M.prototype.on=M.prototype.J;
M.prototype.once=M.prototype.once;M.prototype.un=M.prototype.K;O.prototype.getFirstCoordinate=O.prototype.bc;O.prototype.getLastCoordinate=O.prototype.cc;O.prototype.getLayout=O.prototype.ec;O.prototype.rotate=O.prototype.rotate;O.prototype.scale=O.prototype.scale;O.prototype.getClosestPoint=O.prototype.Gb;O.prototype.intersectsCoordinate=O.prototype.yb;O.prototype.getExtent=O.prototype.G;O.prototype.simplify=O.prototype.Rb;O.prototype.transform=O.prototype.hb;O.prototype.get=O.prototype.get;
O.prototype.getKeys=O.prototype.P;O.prototype.getProperties=O.prototype.M;O.prototype.set=O.prototype.set;O.prototype.setProperties=O.prototype.H;O.prototype.unset=O.prototype.R;O.prototype.changed=O.prototype.u;O.prototype.dispatchEvent=O.prototype.b;O.prototype.getRevision=O.prototype.L;O.prototype.on=O.prototype.J;O.prototype.once=O.prototype.once;O.prototype.un=O.prototype.K;ql.prototype.getFirstCoordinate=ql.prototype.bc;ql.prototype.getLastCoordinate=ql.prototype.cc;ql.prototype.getLayout=ql.prototype.ec;
ql.prototype.rotate=ql.prototype.rotate;ql.prototype.scale=ql.prototype.scale;ql.prototype.getClosestPoint=ql.prototype.Gb;ql.prototype.intersectsCoordinate=ql.prototype.yb;ql.prototype.getExtent=ql.prototype.G;ql.prototype.simplify=ql.prototype.Rb;ql.prototype.transform=ql.prototype.hb;ql.prototype.get=ql.prototype.get;ql.prototype.getKeys=ql.prototype.P;ql.prototype.getProperties=ql.prototype.M;ql.prototype.set=ql.prototype.set;ql.prototype.setProperties=ql.prototype.H;ql.prototype.unset=ql.prototype.R;
ql.prototype.changed=ql.prototype.u;ql.prototype.dispatchEvent=ql.prototype.b;ql.prototype.getRevision=ql.prototype.L;ql.prototype.on=ql.prototype.J;ql.prototype.once=ql.prototype.once;ql.prototype.un=ql.prototype.K;P.prototype.getFirstCoordinate=P.prototype.bc;P.prototype.getLastCoordinate=P.prototype.cc;P.prototype.getLayout=P.prototype.ec;P.prototype.rotate=P.prototype.rotate;P.prototype.scale=P.prototype.scale;P.prototype.getClosestPoint=P.prototype.Gb;P.prototype.intersectsCoordinate=P.prototype.yb;
P.prototype.getExtent=P.prototype.G;P.prototype.simplify=P.prototype.Rb;P.prototype.transform=P.prototype.hb;P.prototype.get=P.prototype.get;P.prototype.getKeys=P.prototype.P;P.prototype.getProperties=P.prototype.M;P.prototype.set=P.prototype.set;P.prototype.setProperties=P.prototype.H;P.prototype.unset=P.prototype.R;P.prototype.changed=P.prototype.u;P.prototype.dispatchEvent=P.prototype.b;P.prototype.getRevision=P.prototype.L;P.prototype.on=P.prototype.J;P.prototype.once=P.prototype.once;
P.prototype.un=P.prototype.K;D.prototype.getFirstCoordinate=D.prototype.bc;D.prototype.getLastCoordinate=D.prototype.cc;D.prototype.getLayout=D.prototype.ec;D.prototype.rotate=D.prototype.rotate;D.prototype.scale=D.prototype.scale;D.prototype.getClosestPoint=D.prototype.Gb;D.prototype.intersectsCoordinate=D.prototype.yb;D.prototype.getExtent=D.prototype.G;D.prototype.simplify=D.prototype.Rb;D.prototype.transform=D.prototype.hb;D.prototype.get=D.prototype.get;D.prototype.getKeys=D.prototype.P;
D.prototype.getProperties=D.prototype.M;D.prototype.set=D.prototype.set;D.prototype.setProperties=D.prototype.H;D.prototype.unset=D.prototype.R;D.prototype.changed=D.prototype.u;D.prototype.dispatchEvent=D.prototype.b;D.prototype.getRevision=D.prototype.L;D.prototype.on=D.prototype.J;D.prototype.once=D.prototype.once;D.prototype.un=D.prototype.K;E.prototype.getFirstCoordinate=E.prototype.bc;E.prototype.getLastCoordinate=E.prototype.cc;E.prototype.getLayout=E.prototype.ec;E.prototype.rotate=E.prototype.rotate;
E.prototype.scale=E.prototype.scale;E.prototype.getClosestPoint=E.prototype.Gb;E.prototype.intersectsCoordinate=E.prototype.yb;E.prototype.getExtent=E.prototype.G;E.prototype.simplify=E.prototype.Rb;E.prototype.transform=E.prototype.hb;E.prototype.get=E.prototype.get;E.prototype.getKeys=E.prototype.P;E.prototype.getProperties=E.prototype.M;E.prototype.set=E.prototype.set;E.prototype.setProperties=E.prototype.H;E.prototype.unset=E.prototype.R;E.prototype.changed=E.prototype.u;
E.prototype.dispatchEvent=E.prototype.b;E.prototype.getRevision=E.prototype.L;E.prototype.on=E.prototype.J;E.prototype.once=E.prototype.once;E.prototype.un=E.prototype.K;um.prototype.readFeatures=um.prototype.Ma;Dm.prototype.readFeatures=Dm.prototype.Ma;um.prototype.readFeatures=um.prototype.Ma;qg.prototype.get=qg.prototype.get;qg.prototype.getKeys=qg.prototype.P;qg.prototype.getProperties=qg.prototype.M;qg.prototype.set=qg.prototype.set;qg.prototype.setProperties=qg.prototype.H;
qg.prototype.unset=qg.prototype.R;qg.prototype.changed=qg.prototype.u;qg.prototype.dispatchEvent=qg.prototype.b;qg.prototype.getRevision=qg.prototype.L;qg.prototype.on=qg.prototype.J;qg.prototype.once=qg.prototype.once;qg.prototype.un=qg.prototype.K;rg.prototype.getMap=rg.prototype.g;rg.prototype.setMap=rg.prototype.setMap;rg.prototype.setTarget=rg.prototype.i;rg.prototype.get=rg.prototype.get;rg.prototype.getKeys=rg.prototype.P;rg.prototype.getProperties=rg.prototype.M;rg.prototype.set=rg.prototype.set;
rg.prototype.setProperties=rg.prototype.H;rg.prototype.unset=rg.prototype.R;rg.prototype.changed=rg.prototype.u;rg.prototype.dispatchEvent=rg.prototype.b;rg.prototype.getRevision=rg.prototype.L;rg.prototype.on=rg.prototype.J;rg.prototype.once=rg.prototype.once;rg.prototype.un=rg.prototype.K;Hj.prototype.getMap=Hj.prototype.g;Hj.prototype.setMap=Hj.prototype.setMap;Hj.prototype.setTarget=Hj.prototype.i;Hj.prototype.get=Hj.prototype.get;Hj.prototype.getKeys=Hj.prototype.P;
Hj.prototype.getProperties=Hj.prototype.M;Hj.prototype.set=Hj.prototype.set;Hj.prototype.setProperties=Hj.prototype.H;Hj.prototype.unset=Hj.prototype.R;Hj.prototype.changed=Hj.prototype.u;Hj.prototype.dispatchEvent=Hj.prototype.b;Hj.prototype.getRevision=Hj.prototype.L;Hj.prototype.on=Hj.prototype.J;Hj.prototype.once=Hj.prototype.once;Hj.prototype.un=Hj.prototype.K;Mj.prototype.getMap=Mj.prototype.g;Mj.prototype.setMap=Mj.prototype.setMap;Mj.prototype.setTarget=Mj.prototype.i;Mj.prototype.get=Mj.prototype.get;
Mj.prototype.getKeys=Mj.prototype.P;Mj.prototype.getProperties=Mj.prototype.M;Mj.prototype.set=Mj.prototype.set;Mj.prototype.setProperties=Mj.prototype.H;Mj.prototype.unset=Mj.prototype.R;Mj.prototype.changed=Mj.prototype.u;Mj.prototype.dispatchEvent=Mj.prototype.b;Mj.prototype.getRevision=Mj.prototype.L;Mj.prototype.on=Mj.prototype.J;Mj.prototype.once=Mj.prototype.once;Mj.prototype.un=Mj.prototype.K;ak.prototype.getMap=ak.prototype.g;ak.prototype.setMap=ak.prototype.setMap;
ak.prototype.setTarget=ak.prototype.i;ak.prototype.get=ak.prototype.get;ak.prototype.getKeys=ak.prototype.P;ak.prototype.getProperties=ak.prototype.M;ak.prototype.set=ak.prototype.set;ak.prototype.setProperties=ak.prototype.H;ak.prototype.unset=ak.prototype.R;ak.prototype.changed=ak.prototype.u;ak.prototype.dispatchEvent=ak.prototype.b;ak.prototype.getRevision=ak.prototype.L;ak.prototype.on=ak.prototype.J;ak.prototype.once=ak.prototype.once;ak.prototype.un=ak.prototype.K;ug.prototype.getMap=ug.prototype.g;
ug.prototype.setMap=ug.prototype.setMap;ug.prototype.setTarget=ug.prototype.i;ug.prototype.get=ug.prototype.get;ug.prototype.getKeys=ug.prototype.P;ug.prototype.getProperties=ug.prototype.M;ug.prototype.set=ug.prototype.set;ug.prototype.setProperties=ug.prototype.H;ug.prototype.unset=ug.prototype.R;ug.prototype.changed=ug.prototype.u;ug.prototype.dispatchEvent=ug.prototype.b;ug.prototype.getRevision=ug.prototype.L;ug.prototype.on=ug.prototype.J;ug.prototype.once=ug.prototype.once;
ug.prototype.un=ug.prototype.K;fk.prototype.getMap=fk.prototype.g;fk.prototype.setMap=fk.prototype.setMap;fk.prototype.setTarget=fk.prototype.i;fk.prototype.get=fk.prototype.get;fk.prototype.getKeys=fk.prototype.P;fk.prototype.getProperties=fk.prototype.M;fk.prototype.set=fk.prototype.set;fk.prototype.setProperties=fk.prototype.H;fk.prototype.unset=fk.prototype.R;fk.prototype.changed=fk.prototype.u;fk.prototype.dispatchEvent=fk.prototype.b;fk.prototype.getRevision=fk.prototype.L;fk.prototype.on=fk.prototype.J;
fk.prototype.once=fk.prototype.once;fk.prototype.un=fk.prototype.K;wg.prototype.getMap=wg.prototype.g;wg.prototype.setMap=wg.prototype.setMap;wg.prototype.setTarget=wg.prototype.i;wg.prototype.get=wg.prototype.get;wg.prototype.getKeys=wg.prototype.P;wg.prototype.getProperties=wg.prototype.M;wg.prototype.set=wg.prototype.set;wg.prototype.setProperties=wg.prototype.H;wg.prototype.unset=wg.prototype.R;wg.prototype.changed=wg.prototype.u;wg.prototype.dispatchEvent=wg.prototype.b;
wg.prototype.getRevision=wg.prototype.L;wg.prototype.on=wg.prototype.J;wg.prototype.once=wg.prototype.once;wg.prototype.un=wg.prototype.K;kk.prototype.getMap=kk.prototype.g;kk.prototype.setMap=kk.prototype.setMap;kk.prototype.setTarget=kk.prototype.i;kk.prototype.get=kk.prototype.get;kk.prototype.getKeys=kk.prototype.P;kk.prototype.getProperties=kk.prototype.M;kk.prototype.set=kk.prototype.set;kk.prototype.setProperties=kk.prototype.H;kk.prototype.unset=kk.prototype.R;kk.prototype.changed=kk.prototype.u;
kk.prototype.dispatchEvent=kk.prototype.b;kk.prototype.getRevision=kk.prototype.L;kk.prototype.on=kk.prototype.J;kk.prototype.once=kk.prototype.once;kk.prototype.un=kk.prototype.K;rk.prototype.getMap=rk.prototype.g;rk.prototype.setMap=rk.prototype.setMap;rk.prototype.setTarget=rk.prototype.i;rk.prototype.get=rk.prototype.get;rk.prototype.getKeys=rk.prototype.P;rk.prototype.getProperties=rk.prototype.M;rk.prototype.set=rk.prototype.set;rk.prototype.setProperties=rk.prototype.H;rk.prototype.unset=rk.prototype.R;
rk.prototype.changed=rk.prototype.u;rk.prototype.dispatchEvent=rk.prototype.b;rk.prototype.getRevision=rk.prototype.L;rk.prototype.on=rk.prototype.J;rk.prototype.once=rk.prototype.once;rk.prototype.un=rk.prototype.K;
  return OPENLAYERS.ol;
}));



/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(this, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      var storageKey = "loglevel";
      if (name) {
        storageKey += ":" + name;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    return defaultLogger;
}));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OlMap = undefined;

var _OlMapBase = __webpack_require__(1);

Object.defineProperty(exports, "OlMap", {
  enumerable: true,
  get: function get() {
    return _OlMapBase.OlMap;
  }
});

__webpack_require__(21);

__webpack_require__(22);

__webpack_require__(23);

__webpack_require__(24);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _IMapBase = __webpack_require__(2);

/**
 * Options par défaut des styles des couches vecteur (KML, GPX, GeoJSON)
 * @private
 */
_IMapBase.IMap.DEFAULT_VECTORLAYERS_STYLES = {
    markerSrc: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARDSURBVFiF3ZndaxxVGMZ/Z/YjX00Nadpo1qrFBgu56D9QbAtiLoRC7ywSNK1NURRREBKRFlSwFBW0gnSrJXY1CmISgyjFiyYSFC9ajE3MmpjdjWlMUtNos9lN9mteLzbRuCbZmTMTBB+Yi51znvd5n3nPnjnnjBIR/i/wuh4xpCpI0ojiENAA1AE1wCzwKzCE0EM5l2iShJvSyrXKnFVb8dOK4hmg3AIjifAmaU7ztMy7kYI7Zs6rQwjvka+AXcyiOMZx6XGahuE0AEHVitCFnhGAGoQugqrVaSrOKpNP4FWnSaxCGy1yWpesbyY/tLpwo7p/w0RxWHfI6Zk5q7ZSwhj6Q2sjzJLiXp1JQe+p+mllc4wA1CzHtw37lQmpCha5gbXpVxdJythh9z1kvzJJGrFixPBmOXixl+Z4mONmguZ4mIMXezG8WQsq5cs6tmDfTP7NXiSqN0vTzBD1TQfwbdmDUhX4tuyhvukATTNDlgxZ0SmUtUsgv0TZGPsv9FNSvXfNtpLqvey/0O+KTgF0zNQV7XHP4dsdtVvVKYCOmeqiPbwVOx21W9UpgI6ZWNEe2cSEo3arOgWwb0YYLp5G17Sjdqs6BdCZzYqL9B3dR2puYM221NwAfUf3uaJTAB0zaye5GmbWS6i2gdFQL5mFMCIJMgthRkO9hGobMLPFN4VWdAoptlcAQeUDRoG77YrZwDhQT4tk7JDsV6ZFMggv2+bZwyt2jYDuQnOa94GIFrc4IkzRrkPUM3NKsijatLjF0copsbJ++xec7TTPqw6EI/oB/glT+PC+13Y/aSQNv/Is+tNer09lMn7DMHwAYppp8fvTIpISkVQsFrslqww4M9OuqkgzANzl1MhCyrjZGAycm573pK1yFCyi5FoWvo/FYlPOT2fOqftRXMbB9lkEs+3zbe2f/FD5i3YMj2p3vn8/IV8DZ5yE+Gqkot+JEQCPada5dRhxEriiQ5ya90w+272916F+KpnJDLhjpkUy5HgESNqhZU2Vfr5ne+dSFtOBeso06J6cnEy6d0z0hPwEPGeH8sGVykvfjpfe1NZUci2+mHg7Go2G8z/d/goQVJ9B8S1veMYffujduo/thl+ZwUzDuBqJRGZWt7n/FcDH46lFNVLilar1uiTTxsJTnTssH/QpJVlMNQa5wbGJiWERya3Vz30zzfLb3OveY3dU5j5dp4e80Xdbd3TOu/H/yyAtpjnqgeGS8crRQRks+v5xf5gtY/KM/6NAVebhwvv90bLvHu2o/XId2pJSMmIaxo/RaHRMxN6yZtPM0K5K/7hl/FxVZgZWbs0mPDceeKcuGE95/kpSKUmaImHDNIfHrl+PiIj2zOb+MFvBY7IUOVl2ZG9g6bJH4ckJuRe/2NYZT3myKIkrGM4pNRyLjY+LW09URDb1+uaF0pfm3zJ+7zhRGdq1c9eDuwOBOzdLa/OG2X+APwE8DU64Y/5gfAAAAABJRU5ErkJggg==",
    markerXAnchor: 25.5,
    markerYAnchor: 38,
    strokeColor: "#002A50",
    strokeWidth: 4,
    strokeOpacity: 0.8,
    polyFillColor: "#00B798",
    polyFillOpacity: 0.5,
    textStrokeColor: "#000000",
    textColor: "#FFFFFF"
};

/**
 * Caractéristiques par defaut pour les TMS Géoportail
 * @private
 */
_IMapBase.IMap.WMTSDEFAULTS = {
    "EPSG:3857": {
        resolutions: [156543.033928041, 78271.51696402048, 39135.758482010235, 19567.87924100512, 9783.93962050256, 4891.96981025128, 2445.98490512564, 1222.99245256282, 611.49622628141, 305.7481131407048, 152.8740565703525, 76.43702828517624, 38.21851414258813, 19.10925707129406, 9.554628535647032, 4.777314267823516, 2.388657133911758, 1.194328566955879, 0.5971642834779395, 0.2985821417389697, 0.1492910708694849, 0.0746455354347424],
        scales: {
            0: 559082264,
            1: 279541132,
            2: 139770566,
            3: 69885283,
            4: 34942642,
            5: 17471321,
            6: 8735660,
            7: 4367830,
            8: 2183915,
            9: 1091958,
            10: 545979,
            11: 272989,
            12: 136495,
            13: 68247,
            14: 34124,
            15: 17062,
            16: 8531,
            17: 4265,
            18: 2133,
            19: 1066,
            20: 533,
            21: 267
        },
        threshold: 0.0000001,
        topLeftCorner: {
            x: -20037508,
            y: 20037508
        }
    },
    "EPSG:4326": {
        resolutions: [1.40625, 0.703125, 0.3515625, 0.17578125, 0.087890625, 0.0439453125, 0.02197265625, 0.010986328125, 0.0054931640625, 0.00274658203125, 0.001373291015625, 0.0006866455078125, 0.00034332275390625, 0.000171661376953126, 0.0000858306884765628, 0.0000429153442382813, 0.0000214576721191407, 0.0000107288360595703, 0.00000536441802978517, 0.00000268220901489259, 0.0000013411045074463, 0.000000670552253723145, 0.00000033527612686157],
        threshold: 0.0000000001,
        topLeftCorner: {
            x: 90,
            y: -180
        }
    },
    "EPSG:2154": {
        resolutions: [104579.22454989408, 52277.53235379051, 26135.487078595408, 13066.891381800004, 6533.228604113456, 3266.5595244626675, 1633.2660045974187, 816.6295549860224, 408.31391467683596, 204.15674151090204, 102.07831678324082, 51.0391448966112, 25.519569074269395, 12.759783693647506, 6.379891635966491, 3.18994576530532, 1.5949728694977277, 0.7974864315474559, 0.398743214900604, 0.19937160727567999, 0.099685803696052, 0.049842901818919996],
        threshold: 0.00000001,
        topLeftCorner: {
            x: 0,
            y: 12000000
        }
    }
};

/**
 * Returns the current layers options. If layerIds is precised, returns just the options of the layers listed. If layerIds = null, returns the options of all the map's layers.
 *
 * @param {Array.<String> | null} layerIds - A list of layer's id or null.
 * @returns {Object} - The options of map's layers. Associative array mapping given layers ids with their {@link Gp.LayerOptions} properties.
 */
_IMapBase.IMap.prototype.getLayersOptions = function (layerIds) {
    // aucun layerIds fourni => on les retourne tous
    if (!layerIds || Array.isArray(layerIds) && layerIds.length === 0) {
        layerIds = [];
        this._layers.forEach(function (layer) {
            layerIds.push(layer.id);
        }, this);
    }
    var layersOptions = {};
    // tri du tableau dans l'ordre des positions.
    this._layers.sort(function (l1, l2) {
        return l1.options.position - l2.options.position;
    });
    if (!Array.isArray(layerIds)) {
        layerIds = [layerIds];
    }
    this._layers.forEach(function (layer) {
        if (layerIds.indexOf(layer.id) < 0) {
            return;
        }
        layersOptions[layer.id] = layer.options;
    }, this);
    return layersOptions;
};

/**
 * Adds a list of layers to the map.<br/>
 * The **layersOptions** parameter is an associative array mapping ids of layers to display and their properties.<br/>
 * For each layer, the id may be either the name of a Geoportal layer (eg : "ORTHOIMAGERY.ORTHOPHOTOS") available with the given [apiKey used to initialize the map](Gp.MapOptions.html) or an id of your choice for external resources.<br/>
 * The properties associated to each ID are given as {@link Gp.LayerOptions} objects.<br/>
 * For Geoportal Layers availables with the given apiKey, values are automaticaly fetched from key configuration. You only need to specify a {@link Gp.LayerOptions} object with properties you want to overide or an empty object if you don't want to overide anything.
 *
 * @param {Object} layersOptions - Layers to add to the map and their options. Associative array mapping ids of layers to add (keys) and their properties (values given as {@link Gp.LayerOptions}).
 */
_IMapBase.IMap.prototype.addLayers = function (layersOptions) {
    if (!layersOptions) {
        // this.// logger.trace("[IMap] addLayers : no layers to add");
        return;
    }
    // abonnement perso à l'evnement layerChanged pour tenir à jour l'objet this._layers
    this.listen("layerChanged", this._onLayerChanged, this);
    var layerId = null;
    for (layerId in layersOptions) {
        // on ne peut pas rajouter la même couche avec le même identifiant
        if (this._getLayersObj([layerId]).length > 0) {
            // this.// logger.info("Layer [" + layerId + "] already added to map.");
            continue;
        }
        // this.// logger.trace("[IMap] addLayers : adding : [" + layerId + "]");
        var layerOpts = layersOptions[layerId];
        // parametre pour l'ajout individuel de couche
        var addLayerParam = {};
        addLayerParam[layerId] = layerOpts;

        // FIXME Config est créé en runtime dans la variable globale Gp
        var scope = typeof window !== "undefined" ? window : {};
        var Config = scope.Gp ? scope.Gp.Config : undefined;

        // Est-ce un layer Geoportail ?
        // si on a donné une URL, on ne cherche pas à découvrir la couche Géoportail
        if (!layerOpts.hasOwnProperty("url") && Config) {
            var format = null;
            if (layerOpts && layerOpts.format) {
                format = layerOpts.format;
            }
            var layerConf = null;
            // on essaye d'abord WMTS
            if (format == null || format.toUpperCase() === "WMTS") {
                layerConf = Config.getLayerConf(layerId + "$GEOPORTAIL:OGC:WMTS");
                if (layerConf) {
                    format = "WMTS";
                }
            }
            // ... puis WMS GEOPORTAIL
            if (format == null || format.toUpperCase() === "WMS") {
                layerConf = Config.getLayerConf(layerId + "$GEOPORTAIL:OGC:WMS");
                if (layerConf) {
                    format = "WMS";
                } else {
                    // ... puis WMS INSPIRE
                    layerConf = Config.getLayerConf(layerId + "$INSPIRE:OGC:WMS");
                    if (layerConf) {
                        format = "WMS";
                    }
                }
            }
            // FIXME / TODO : WFS Geoportail ?
            if (layerConf) {
                // on a trouve la couche Geoportail : on rajoute sa configuration à ses options.
                // this.// logger.trace("[IMap] addLayers : [" + layerId + "] is a geoportalLayer. Adding inner properties.");
                addLayerParam[layerId].format = format;
                addLayerParam[layerId].originators = addLayerParam[layerId].originators || layerConf.originators;
                // options du layerswitcher
                addLayerParam[layerId] = this._layerOptions2layerConf(layerConf, addLayerParam[layerId]);
            }
            switch (format) {
                case "WMTS":
                case "WMS":
                    this._addGeoportalLayer(addLayerParam, layerConf);
                    continue;
                default:
                    // this.// logger.trace("[IMap] addLayers : [" + layerId + "] is not a Geoportal Layer");
            }
        }
        // Si on est ici, c'est que ce n'est pas un layer Geoportail
        // on a besoin du format et de l'URL (à minima)
        if (!layerOpts.hasOwnProperty("format") || typeof layerOpts.format !== "string") {
            // this.// logger.info("Impossible to add layer [" + layerId + "] : no format given");
            continue;
        }
        if (!layerOpts.hasOwnProperty("url") || typeof layerOpts.url !== "string") {
            // this.// logger.info("Impossible to add layer [" + layerId + "] : no url given");
            continue;
        }
        // verification des parametres obligatoires en fonction du format
        if (!this._checkLayerParams(layerOpts)) {
            // this.// logger.info("Impossible to add layer [" + layerId + "] : unsufficient or inadapted parameters given");
            continue;
        }
        switch (layerOpts.format.toUpperCase()) {
            case "georss":
                // TODO GeoRSS
                break;
            case "KML":
            case "GPX":
            case "GEOJSON":
            case "WFS":
            case "DRAWING":
                this._addVectorLayer(addLayerParam);
                break;
            case "WMS":
            case "WMTS":
            case "OSM":
                this._addRasterLayer(addLayerParam);
                break;
            default:
                // this.// logger.info("Impossible to add layer [" + layerId + "] : unhandled format [" + layerOpts.format + "]");
                break;
        }
    }

    // re-abonnement à l'evenement layerChanged
    // nécessaire pour ecouter les changements de propriétés sur la nouvelle couche
    this._resetLayerChangedEvent();
};

/**
 * Remove layers from the map.
 *
 * @param {Array.<String>} layerIds - A list of layer's id to be removed.
 * @returns {Boolean} - true if OK, false otherwise.
 */
_IMapBase.IMap.prototype.removeLayers = function (layerIds) {
    if (!layerIds || Array.isArray(layerIds) && layerIds.length === 0) {
        // this.// logger.info("removeLayers : nothing to remove !");
        return false;
    }
    if (!Array.isArray(layerIds)) {
        layerIds = [layerIds];
    }
    return true;
};

/**
 * Modify the layers given with layersOptions parameter
 *
 * @param {Object} layersOptions - Layers to modify and their options. Associative array mapping official name of the Geoportal layer or the id of a personal layer (keys) with their properties (values given as {@link Gp.LayerOptions}). Only following options are modified : opacity, visibility, maxZoom and minZoom.
 *
 * @return {Boolean} indicates if the le parameter layersOptions has the correct format
 */
_IMapBase.IMap.prototype.modifyLayers = function (layersOptions) {
    if (!layersOptions) {
        // this.// logger.info("modifyLayers : nothing to modify !");
        return false;
    }
    var layerIds = Object.keys(layersOptions);
    if (!layerIds || !Array.isArray(layerIds)) {
        // this.// logger.info("modifyLayers : wrong format for layersOptions !");
        return false;
    }
    return true;
};

/**
 * Defautl options for WMTS layers
 *
 * @return {Object} wmts options
 *
 * @private
 */
_IMapBase.IMap.prototype._getWMTSDefaultOpts = function () {
    // this.// logger.trace("[IMap] : _getWMTSDefaultOpts");

    var wmtsOpts = {
        version: "1.0.0",
        outputFormat: "image/jpeg"
    };
    // identifiants des niveaux de zooms : 0, 1, 2, ...
    var matrixIds = [];
    for (var i = 0; i <= 20; i++) {
        matrixIds.push("" + i);
    }
    wmtsOpts.matrixIds = matrixIds;

    // resolutions par defaut :
    var resolutions = null;
    var topLeftCorner = null;
    var mapProj = this.getProjection();
    // topLeftCorner par defaut :
    if (typeof mapProj !== "string" || ["EPSG:3857"].indexOf(mapProj.toUpperCase()) >= 0) {
        resolutions = _IMapBase.IMap.WMTSDEFAULTS["EPSG:3857"].resolutions;
        topLeftCorner = _IMapBase.IMap.WMTSDEFAULTS["EPSG:3857"].topLeftCorner;
    } else if (["EPSG:4326", "CRS:84"].indexOf(mapProj.toUpperCase()) >= 0) {
        resolutions = _IMapBase.IMap.WMTSDEFAULTS["EPSG:4326"].resolution7s;
        topLeftCorner = _IMapBase.IMap.WMTSDEFAULTS["EPSG:4326"].topLeftCorner;
    } else if (["EPSG:2154"].indexOf(mapProj.toUpperCase()) >= 0) {
        resolutions = _IMapBase.IMap.WMTSDEFAULTS["EPSG:2154"].resolution7s;
        topLeftCorner = _IMapBase.IMap.WMTSDEFAULTS["EPSG:2154"].topLeftCorner;
    }
    if (resolutions) {
        wmtsOpts.resolutions = resolutions;
        wmtsOpts.topLeftCorner = topLeftCorner;
    }

    return wmtsOpts;
};

/**
 * Returns the layers Obj identified by layerIds
 *
 * @param {Array.<String>} layerIds - A list of layer's id.
 * @returns {Array.<Object>} - The internal objects layers identified by layerIds.
 * @private
 */
_IMapBase.IMap.prototype._getLayersObj = function (layerIds) {
    var _layerObjs = [];
    this._layers.forEach(function (layer, i, array) {
        if (layerIds.indexOf(layer.id) < 0) {
            // this.// logger.trace("[IMap] _getLayersObj : " + layer.id + " not found.");
            return;
        }
        // this.// logger.trace("[IMap] _getLayersObj : found obj for : " + layer.id);
        _layerObjs.push(layer);
    }, this);
    return _layerObjs;
};

/**
 * Add the markers to the map
 * FIXME : make it public ?
 *
 * @param {Array.<Gp.MarkerOptions>} markersOptions - Markers to add to the Map.
 * @private
 */
_IMapBase.IMap.prototype._addMarkers = function (markersOptions) {
    // this.// logger.trace("[IMap] _addMarkers : generic function");
};

/**
 * Check params for layerDisplay
 *
 * @param {Gp.LayerOptions} layerOpts - options of the layer
 * @returns {Boolean} true if parameters are OK, false otherwise
 *
 * @private
 */
_IMapBase.IMap.prototype._checkLayerParams = function (layerOpts) {
    // La vérification peut être surchargée selon les spécificités de l'implémentation.
    var missingParams = [];
    switch (layerOpts.format.toUpperCase()) {
        case "WMS":
            if (!layerOpts.hasOwnProperty("layers") || !(layerOpts.layers instanceof Array)) {
                missingParams.push("layers");
            }
            break;
        case "WMTS":
            if (!layerOpts.hasOwnProperty("layer") || typeof layerOpts.layer !== "string") {
                missingParams.push("layer");
            }
            if (!layerOpts.hasOwnProperty("tileMatrixSet") || typeof layerOpts.tileMatrixSet !== "string") {
                missingParams.push("tileMatrixSet");
            }
            if (!layerOpts.hasOwnProperty("styleName") || typeof layerOpts.styleName !== "string") {
                missingParams.push("styleName");
            }
            break;
        case "WFS":
            if (!layerOpts.hasOwnProperty("typeNames") || typeof layerOpts.typeNames !== "string") {
                missingParams.push("typeNames");
            }
            break;
    }
    if (missingParams.length > 0) {
        // this.// logger.info("Impossible to add " + layerOpts.format + " layer : missing mandatory parameter(s) : " + missingParams.toString());
        return false;
    }
    return true;
};

/**
 * Add a Raster Layer to the map
 *
 * @param {Object} layerObj - geoportalLayer to add.
 * @param {Gp.LayerOptions} layerObj.geoportalLayerID - options of the layer
 *
 * @private
 */
_IMapBase.IMap.prototype._addRasterLayer = function (layerObj) {
    // Abstract method to be overridden
};

/**
 * Add a vector Layer to the map
 *
 * @param {Object} layerObj - geoportalLayer to add.
 * @param {Gp.LayerOptions} layerObj.geoportalLayerID - options of the layer
 *
 * @private
 */
_IMapBase.IMap.prototype._addVectorLayer = function (layerObj) {
    // Abstract method to be overridden
};

/**
 * Add a geoportal Layer to the map
 *
 * @param {Object} layerObj - geoportalLayer to add.
 * @param {Gp.LayerOptions} layerObj.geoportalLayerID - options of the layer
 *
 * @private
 */
_IMapBase.IMap.prototype._addGeoportalLayer = function (layerObj) {
    // Abstract method to be overridden
};

/**
 * Apply params common to all kind of layers :
 * opacity, visibility, minZoom, maxZoom
 *
 * @param {Gp.LayerOptions} layerOpts - options of the layer
 * @returns {Object} the modified implementation layer object
 *
 * @private
 */
_IMapBase.IMap.prototype._applyCommonLayerParams = function (layerOpts) {
    // TO BE OVERRIDDEN
    return {};
};

/**
 * Recherche une couche dans le tableau this._layers à partir de son objet descriptif.
 *
 * @param {Gp.LayerOptions} layerOpts - objet de descrition de la couche
 * @return {Integer} l'index de la couche dans le tableau; -1 si non trouvé.
 * @private
 */
_IMapBase.IMap.prototype._getLayerIndexByLayerOpts = function (layerOpts) {
    if (!layerOpts) {
        return -1;
    }
    for (var i = 0; i < this._layers.length; i++) {
        var l = this._layers[i];
        if (layerOpts.hasOwnProperty(l.id)) {
            return i;
        }
    }
    return -1;
};

/**
 * Recherche une couche dans le tableau this._layers à partir de son identifiant.
 *
 * @param {String} layerId - identifiant de la couche
 * @return {Integer} l'index de la couche dans le tableau; -1 si non trouvé.
 * @private
 */
_IMapBase.IMap.prototype._getLayerIndexByLayerId = function (layerId) {
    for (var i = 0; i < this._layers.length; i++) {
        var l = this._layers[i];
        if (layerId === l.id) {
            return i;
        }
    }
    return -1;
};

/**
 * Filtre les metadata avec un url vide.
 *
 * @param {Array.<Object>} metadata - metadata objects array to filter
 * @returns {Array.<Object>} - filtered metadata objects array.
 * @private
 */
_IMapBase.IMap.prototype._filterEmptyMetadata = function (metadata) {
    if (!metadata || !Array.isArray(metadata)) {
        return metadata;
    }
    var fullMetadata = [];
    for (var i = 0; i < metadata.length; i++) {
        if (metadata[i].url && metadata[i].url.trim().length > 0) {
            fullMetadata.push(metadata[i]);
        }
    }
    return fullMetadata;
};

/**
 * Copie les proprietes des couches (layerOptions) en configuration pour le layerSwitcher (layerOpts)
 *
 * @param {Object} layerOptions - options de configuration d'une couche
 * @param {Object} layerConf - options de configuration de la couche pour le LayerSwitcher à completer.
 * @returns {Object} - options de configuration pour le layerSwitcher.
 * @private
 */
_IMapBase.IMap.prototype._layerOptions2layerConf = function (layerOptions, layerConf) {
    var lConf = layerConf || {};

    lConf.title = lConf.title || layerOptions.title;
    lConf.description = lConf.description || layerOptions.description;
    lConf.quicklookUrl = lConf.quicklookUrl || layerOptions.quicklookUrl;
    lConf.legends = lConf.legends || layerOptions.legends;
    lConf.metadata = lConf.metadata || layerOptions.metadata;
    lConf.metadata = this._filterEmptyMetadata(lConf.metadata);
    return lConf;
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _IMapBase = __webpack_require__(2);

/**
 * Default autoPanOptions
 * @private
 */
_IMapBase.IMap.DEFAULT_AUTOPAN_OPTIONS = {
    autoPan: true,
    duration: 250,
    margin: 5
};

/**
 * Options par défaut des styles de dessin
 * @private
 */
_IMapBase.IMap.DEFAULT_MEAS_STYLES = {
    pointer: {
        strokeColor: "#002A50",
        strokeWidth: 2,
        radius: 5,
        fillColor: "rgba(255, 155, 0, 0.7)"
    },
    start: {
        strokeColor: "#002A50",
        strokeWidth: 2,
        strokeLineDash: "[10, 10]",
        fillColor: "rgba(0, 183, 152, 0.2)"
    },
    finish: {
        strokeColor: "#002A50",
        strokeWidth: 3,
        fillColor: "rgba(0, 183, 152, 0.3)"
    }
};

/**
 * Converts hex color and opacity value to rgba String.
 * (Code adapted from : http://stackoverflow.com/a/5624139)
 * TODO : mettre ailleurs (extension)
 *
 * @param {String} hex - hex color
 * @param {Number} opacity - opacity
 *
 * @return {String} rgba String
 *
 * @private
 */
_IMapBase.IMap.prototype._hexToRgba = function (hex, opacity) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    rgb = rgb ? {
        r: parseInt(rgb[1], 16),
        g: parseInt(rgb[2], 16),
        b: parseInt(rgb[3], 16)
    } : null;
    var result = rgb ? "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + opacity + ")" : null;
    return result;
};

/**
 * Returns the current control options. If controlIds is precised, returns just the options of the controls listed. If controlIds = null, returns the options of all the map's controls.<br/>
 *
 * @param {Array.<String> | null} controlIds - A list of control's id or null.
 * @returns {Object} - The options of the map's controls : Associative Array, mapping given controls Ids with their {@link Gp.ControlOptions} properties.
 */
_IMapBase.IMap.prototype.getControlsOptions = function (controlIds) {
    // aucun controlIds fourni => on les retourne tous
    if (!controlIds || Array.isArray(controlIds) && controlIds.length === 0) {
        controlIds = [];
        this._controls.forEach(function (control) {
            controlIds.push(control.id);
        }, this);
    }
    var controlsOptions = {};
    if (!Array.isArray(controlIds)) {
        controlIds = [controlIds];
    }
    this._controls.forEach(function (control) {
        if (controlIds.indexOf(control.id) < 0) {
            return;
        }
        controlsOptions[control.id] = control.options;
    }, this);
    return controlsOptions;
};

/**
 * Returns underlying implementation of the control identified by controlId. Can be :
 * - an [ol.control.Control](http://openlayers.org/en/latest/apidoc/ol.control.Control.html) subclass with current OpenLayers 3 implementation if the current map is in 2D.
 * - an [itowns.control.Widget](https://ignf.github.io/geoportal-extensions/current/jsdoc/itowns/itowns.control.Widget.html) subclass with current OpenLayers 3 implementation if the current map is in 2D.
 *
 * @param {String} controlId - identifier of the control
 * @returns {Object} - implementation object of the control if it is on the map. null otherwise.
 */
_IMapBase.IMap.prototype.getLibMapControl = function (controlId) {
    // TO BE OVERRIDDEN
    var olControl = null;
    return olControl;
};

/**
 * Add the list of controls to the map
 *
 * @param {Object} controlsOptions - Controls to add to the map and their options. Associative array mapping the control's name (keys) with a Boolean (value) for activating / deactivating or with their properties (values given as {@link Gp.ControlOptions}).
 *
 *
 * **Common 2D/3D controls :**
 *
 * | Key | Control Description |
 * |-|-|
 * | 'layerswitcher' | Adds layers selector widget to the map. See [options availables](./Gp.ControlOptions.html#layerswitcher) |
 * | 'graphicscale' | Adds scale line widget to the map. See [options availables](./Gp.ControlOptions.html#graphicscale) |
 * | 'mouseposition' | Adds mouse position widget to the map. See [options availables](./Gp.ControlOptions.html#mouseposition) |
 * | 'overview' | Adds mini overview map to the map. See [options availables](./Gp.ControlOptions.html#overview) |
 * | 'attributions' | Adds layers originators display to the map. See [options availables](./Gp.ControlOptions.html#attributions) |
 *
 * **Specific 2D controls :**
 *
 * | Key | Control Description |
 * |-|-|
 * | 'draggable' | Enable (true) / disable (false) map dragging/zoomming by mouse or pointer interaction.|
 * | 'keyboard' | Enable (true) / disable (false) map dragging/zoomming by keybord interaction. |
 * | 'selectable' | Enable (true) / disable (false) feature selection on the map. [**DEPRECATED**] : use ['getfeatureinfo'](./Gp.ControlOptions.html#getfeatureinfo) control instead to allow users to interact with features.|
 * | 'zoom' | Adds Zoom widget to the map. See [options availables](./Gp.ControlOptions.html#zoom) |
 * | 'orientation' | Adds orientation widget to the map. See [options availables](./Gp.ControlOptions.html#orientation) |
 * | 'length' | Adds length measurement widget to the map. See [options availables](./Gp.ControlOptions.html#length).|
 * | 'area' | Adds area measurment widget to the map. See [options availables](./Gp.ControlOptions.html#area) |
 * | 'azimuth' | Adds azimuth measurment to the map. See [options availables](./Gp.ControlOptions.html#azimuth) |
 * | 'elevationpath' | Adds elevationpath computation widget to the map. See [options availables](./Gp.ControlOptions.html#elevationpath) |
 * | 'search' | Adds search widget to the map. See [options availables](./Gp.ControlOptions.html#searchctrl) |
 * | 'reversesearch' | Adds reverse search widget to the map. See [options availables](./Gp.ControlOptions.html#reversesearch) |
 * | 'layerimport' | Adds layer import widget to the map. See [options availables](./Gp.ControlOptions.html#layerimport) |
 * | 'drawing' | Adds drawing tools widget to the map. See [options availables](./Gp.ControlOptions.html#drawing) |
 * | 'route' | Adds route control to the map. See [options availables](./Gp.ControlOptions.html#route) |
 * | 'isocurve' | Adds isocurve control to the map. See [options availables](./Gp.ControlOptions.html#isocurve) |
 * | 'graticule' | Adds graticule control to the map. See [options availables](./Gp.ControlOptions.html#graticule) |
 * | 'getfeatureinfo' | Adds capability to retrieve and display information about layer features. See [options availables](./Gp.ControlOptions.html#getfeatureinfo) |
 *
 */
_IMapBase.IMap.prototype.addControls = function (controlsOptions) {
    // this.// logger.trace("[IMap] addControls");
    var controlId = null;
    for (controlId in controlsOptions) {
        var controlObj = null;
        var controlOpts = controlsOptions[controlId];
        // on regarde s'il existe dejà :
        // d'abord dans le registre this._controls
        var idx = -1;
        var libControl = this.getLibMapControl(controlId);
        idx = this._findRegisteredControl(controlId);
        if (idx >= 0 || libControl) {
            // trouve sur la carte et / ou dans le registre
            // this.// logger.info("[IMap] addControls : [" + controlId + "] déjà présent.");
            // on l'enleve
            this.removeControls([controlId]);
            if (controlOpts === null || controlOpts === undefined) {
                // si l'objet options associé est null : simple suppression.
                // FIXME : comportement à maintenir ?
                continue;
            }
        }
        // this.// logger.trace("[IMap] addControls : adding : [" + controlId + "]");
        switch (controlId.toLowerCase()) {
            case "draggable":
                controlObj = this.setDraggable(controlOpts);
                break;
            case "keyboard":
                controlObj = this.setKeyboard(controlOpts);
                break;
            case "selectable":
                controlObj = this.setSelectable(controlOpts);
                break;
            case "zoom":
                controlObj = this.addZoomControl(controlOpts);
                break;
            /* A REVOIR
             * Le control n'a pas le comportement attendu
             */
            case "zoombox":
                controlObj = this._addZoomBoxControl(controlOpts);
                break;
            case "overview":
                controlObj = this.addOverviewControl(controlOpts);
                break;
            case "orientation":
                controlObj = this.addOrientationControl(controlOpts);
                break;
            case "graphicscale":
                controlObj = this.addGraphicScaleControl(controlOpts);
                break;
            case "mouseposition":
                controlObj = this.addMousePositionControl(controlOpts);
                break;
            case "route":
                controlObj = this.addRouteControl(controlOpts);
                break;
            case "isocurve":
                controlObj = this.addIsocurveControl(controlOpts);
                break;
            case "graticule":
                controlObj = this.addGraticuleControl(controlOpts);
                break;
            case "layerswitcher":
                controlObj = this.addLayerSwitcherControl(controlOpts);
                break;
            case "layerimport":
                controlObj = this.addLayerImportControl(controlOpts);
                break;
            case "length":
                controlObj = this.addLengthControl(controlOpts);
                break;
            case "area":
                controlObj = this.addAreaControl(controlOpts);
                break;
            case "azimuth":
                controlObj = this.addAzimuthControl(controlOpts);
                break;
            case "elevationpath":
                controlObj = this.addElevationPathControl(controlOpts);
                break;
            case "search":
                controlObj = this.addSearchControl(controlOpts);
                break;
            case "reversesearch":
                controlObj = this.addReverseSearchControl(controlOpts);
                break;
            case "drawing":
                controlObj = this.addDrawingControl(controlOpts);
                break;
            case "attributions":
                controlObj = this.addAttributionsControl(controlOpts);
                break;
            case "camera":
                controlObj = this.addCameraControl(controlOpts);
                break;
            case "getfeatureinfo":
                controlObj = this.addGetFeatureInfoControl(controlOpts);
                break;
            default:
                // this.// logger.info("Controle " + controlId + "inconnu.");
                // if the controlId is not recognized, we skip it
                continue;
        }
        // this.// logger.trace("[IMap] addControls : registering : [" + controlId + "]");
        // if the control is not implemented in 3D, controlObj doesn't exist
        // then we register it as "2D-only-control", to re-add it in case of switch 3D->2D
        this._controls.push({
            obj: controlObj || "2D-only-control",
            id: controlId.toLowerCase(),
            options: controlOpts
        });
    }
};

/**
 * Removes given controls from the map.
 *
 * @param {Array.<String>} controlIds - A list of control's id to be removed.
 */
_IMapBase.IMap.prototype.removeControls = function (controlIds) {
    // TO BE OVERRIDDEN
};

/**
 * Modify the control'options listed to the map
 *
 * @param {Object} controlsOptions - Controls to modify on the map and their options. Associative array mapping the control's name (keys) with a Boolean (value) for activating / deactivating or with their properties (values given as {@link Gp.ControlOptions}). See [Gp.Map.addControls()](Gp.Map.html#addControls) for availables controls keys.
 */
_IMapBase.IMap.prototype.modifyControls = function (controlsOptions) {
    // this.// logger.trace("[IMap] : modifyControls ... ");
    var controlIds = Object.keys(controlsOptions);
    if (!controlIds || controlIds.length === 0) {
        // this.// logger.info("No control to modify.");
        return;
    }
    var controlId = null;
    for (var i = 0; i < controlIds.length; i++) {
        controlId = controlIds[i];
        // presence du controle sur la carte ?
        var controlObj = this.getLibMapControl(controlId);
        // si le controle est enregistre, on recupere ses options initiales.
        var idx = this._findRegisteredControl(controlId);
        if (idx >= 0) {
            // si le controle n'est plus sur la carte mais qu'il est enregistre, on se contente de le supprimmer
            if (!controlObj) {
                // this.// logger.trace("[IMap] : modifyControls : removing control : " + controlId);
                this.removeControls([controlId]);
                // on enleve le controle de controlsOptions
                delete controlsOptions[controlId];
                continue;
            }
            // on enrichit les anciennes options des nouvelles
            var newCtrlOptions = this._controls[idx].options;
            for (var opt in controlsOptions[controlId]) {
                newCtrlOptions[opt] = controlsOptions[controlId][opt];
            }
            controlsOptions[controlId] = newCtrlOptions;
        } else if (!controlObj) {
            // controle absent de la carte et du registre :
            // on enleve le controle de controlsOptions
            delete controlsOptions[controlId];
            continue;
        }
    }
    // ici, controlsOptions contient uniquement les controles
    // pouvant être modifiés avec toutes les propriétés voulues.
    // => il suffit de faire un addcontrols
    this.addControls(controlsOptions);
};

/**
 * Adds zoom control to the Map.
 *
 * @param {Gp.ControlOptions} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addZoomControl = function (controlOpts) {};

/**
 * Adds zoombox control to the Map.
 *
 * @param {Gp.ControlOptions} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addZoomBoxControl = function (controlOpts) {};

/**
 * Adds overview map to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Array.<String>} controlOpts.layers - List of layers Ids to be displayed on the overview map (may be part of main map layersId or a geoportal WMTS layer ID).
 * @private
 */
_IMapBase.IMap.prototype.addOverviewControl = function (controlOpts) {};

/**
 * Adds orientation control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @private
 */
_IMapBase.IMap.prototype.addOrientationControl = function (controlOpts) {};

/**
 * Adds graphicScale control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {String} controlOpts.units - units of distances shown ("m" for metric display or "deg" for geographical display). Implementation values may also be supported.
 * @param {Number} controlOpts.minWidth - minimum size (in pixels) if the widget.
 * @private
 */
_IMapBase.IMap.prototype.addGraphicScaleControl = function (controlOpts) {};

/**
 * Adds mouse position control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Array.<Object>} controlOpts.systems - List of coordinates systems available for display.
 * @param {String} controlOpts.systems.crs - Coordinates system ID.
 * @param {String} controlOpts.systems.label - label used to designate the CRS.
 * @param {String} controlOpts.systems.type - "Geographical" or "Metric"
 * @param {Array.<String>} controlOpts.units - units used for coordinates display ("m", "km" for Metric coordinates, "dec", "dms", "rad" or "gon" for geographical coordinates).
 * @param {Boolean} controlOpts.displayAltitude - (de)activate altitude display
 * @param {Boolean} controlOpts.displayCoordinates - (de)activate planimetric coorinates display.
 * @param {Object} controlOpts.altitude - altitude interaction specific configuration. Implementation specific.
 * @private
 */
_IMapBase.IMap.prototype.addMousePositionControl = function (controlOpts) {};

/**
 * Adds route control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Object} controlOpts.exclusions - exclusions to be proposed for control. Il null all exclusions will be proposed by default.
 * @param {Boolean} controlOpts.exclusions.toll - proposing toll exclusion. If true, this exclusion will be checked by default.
 * @param {Boolean} controlOpts.exclusions.bridge - proposing bridge exclusion. If true, this exclusion will be checked by default.
 * @param {Boolean} controlOpts.exclusions.tunnel - proposing tunnel exclusion. If true, this exclusion will be checked by default.
 * @param {Array.<String>} controlOpts.graphs - available graphs to be proposed by control among "Pieton" (pedestrian) and "Voiture" (car). The first element of the array will be the default proposition of the control.
 * @param {Object} controlOpts.routeOptions - route service options. For advanced use only. See {@link http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~route Gp.Services.route()} to know all route options.
 * @param {Object} controlOpts.autocompleteOptions - autocomplete service options. See {@link http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~autoComplete Gp.Services.autoComplete()} to know all autocomplete options.
 * @private
 */
_IMapBase.IMap.prototype.addRouteControl = function (controlOpts) {};

/**
 * Adds isocurve control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Object} controlOpts.exclusions - exclusions to be proposed for control. Il null all exclusions will be proposed by default.
 * @param {Boolean} controlOpts.exclusions.toll - proposing toll exclusion. If true, this exclusion will be checked by default.
 * @param {Boolean} controlOpts.exclusions.bridge - proposing bridge exclusion. If true, this exclusion will be checked by default.
 * @param {Boolean} controlOpts.exclusions.tunnel - proposing tunnel exclusion. If true, this exclusion will be checked by default.
 * @param {Array.<String>} controlOpts.graphs - available graphs to be proposed by control among "Pieton" (pedestrian) and "Voiture" (car). The first element of the array will be the default proposition of the control.
 * @param {Array.<String>} controlOpts.methods - available methods of computation to be proposed by control among "time" (isochron) and "distance" (isodistance). The first element of the array will be the default proposition of the control.
 * @param {Array.<String>} controlOpts.directions - available directions to be proposed by control among "arrival" (isocurve to arrival point) and "departure" (isocruve from departure point). The first element of the array will be the default proposition of the control.
 * @param {Object} controlOpts.isocurveOptions - isocurve service options. For advanced use only. See {@link http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~isocurve Gp.Services.isocurve()} to know all isocurve options.
 * @param {Object} controlOpts.autocompleteOptions - autocomplete service options. See {@link http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~autoComplete Gp.Services.autoComplete()} to know all autocomplete options.
 * @private
 */
_IMapBase.IMap.prototype.addIsocurveControl = function (controlOpts) {};

/**
 * Adds graticule control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String} controlOpts.strokeColor - stroke color expressed in hex format (default : #000000)
 * @param {Number} controlOpts.strokeOpacity - stroke opacity expressed between 0 and 1 (default : 0.2).
 * @param {Number} controlOpts.strokeWidth - stroke width expressed in pixels (default : 1).
 * @private
 */
_IMapBase.IMap.prototype.addGraticuleControl = function (controlOpts) {};

/**
 * Adds LayerSwitcher control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @private
 */
_IMapBase.IMap.prototype.addLayerSwitcherControl = function (controlOpts) {};

/**
 * Adds layer import control to the map.
 *
 * @param {Object} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addLayerImportControl = function (controlOpts) {};

/**
 * Adds length measurment tool to the map.
 *
 * @param {Object} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addLengthControl = function (controlOpts) {};

/**
 * Adds area measurment tool to the map.
 *
 * @param {Object} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addAreaControl = function (controlOpts) {};

/**
 * Adds azimuth measurment tool to the map.
 *
 * @param {Object} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addAzimuthControl = function (controlOpts) {};

/**
 * Adds elevation profile control to the map.
 *
 * @param {Object} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addElevationPathControl = function (controlOpts) {};

/**
 * Adds search control to the map.
 *
 * @param {Object} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addSearchControl = function (controlOpts) {};

/**
 * Adds reverse geocoding control to the map.
 *
 * @param {Object} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addReverseSearchControl = function (controlOpts) {};

/**
 * Adds drawing tool bar control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {String} controlOpts.layer - layerId to be used by drawing tool. If none, an empty layer will be created, with id : "drawing-xxx".
 * @param {Object} controlOpts.tools - tools to be proposed by drawing tools box. All tools will be proposed by default.
 * @param {Boolean} [controlOpts.tools.points = true] - Display points drawing tool
 * @param {Boolean} [controlOpts.tools.lines = true] - Display lines drawing tool
 * @param {Boolean} [controlOpts.tools.polygons = true] - Display polygons drawing tool
 * @param {Boolean} [controlOpts.tools.text = true] - Display text drawing tool
 * @param {Boolean} [controlOpts.tools.remove = true] - Display feature removing tool
 * @param {Boolean} [controlOpts.tools.display = true] - Display style editing tool
 * @param {Boolean} [controlOpts.tools.edit = true] - Display editing tool
 * @param {Boolean} [controlOpts.tools.export = true] - Display exporting tool
 * @param {Object} controlOpts.labels - labels to be used instead of defaults for drawing tools.
 * @param {String} [controlOpts.labels.control] - Label for Control
 * @param {String} [controlOpts.labels.points] - Label for points drawing tool
 * @param {String} [controlOpts.labels.lines] - Label for lines drawing tool
 * @param {String} [controlOpts.labels.polygons] - Label for polygons drawing tool
 * @param {String} [controlOpts.labels.text] - Label for text drawing tool
 * @param {String} [controlOpts.labels.edit] - Label for editing tool
 * @param {String} [controlOpts.labels.display] - Label for style editing tool
 * @param {String} [controlOpts.labels.remove] - Label for feature removing tool
 * @param {String} [controlOpts.labels.export] - Label for exporting tool.
 * @param {String} [controlOpts.labels.exportTitle] - Title for exporting tool.
 * @param {String} [controlOpts.labels.applyToObject] - Label for apply to object button.
 * @param {String} [controlOpts.labels.saveDescription] - Label for save description button.
 * @param {String} [controlOpts.labels.setAsDefault] - Label for set as default style button.
 * @param {String} [controlOpts.labels.strokeColor] - Label for stroke color.
 * @param {String} [controlOpts.labels.strokeWidth] - Label for stroke width.
 * @param {String} [controlOpts.labels.fillColor] - Label for fill color.
 * @param {String} [controlOpts.labels.fillOpacity] - Label for fillOpacity.
 * @param {Array.<Object>} controlOpts.markersList - Array of markers urls and offsets to be used for points styling.
 * @param {String} controlOpts.markersList.src - URL of a marker image.
 * @param {Float} controlOpts.markersList.xAnchor - position of marker anchor in X from left of the image expressed in proportion of 1.
 * @param {Float} controlOpts.markersList.yAnchor - position of marker anchor in Y from top of the image expressed in proportion of 1.
 * @param {Float} controlOpts.markersList.yAnchor - URL of a marker image.
 * @param {Object} controlOpts.defaultStyles - Styles to apply by default to drawn features.
 * @param {String} [controlOpts.defaultStyles.textFillColor = "#000000"] - Text fill color for labels (RGB hex value).
 * @param {String} [controlOpts.defaultStyles.textStrokeColor = "#FFFFFF"] - Text surrounding color for labels (RGB hex value).
 * @param {String} [controlOpts.defaultStyles.strokeColor = "#ffcc33"] - Stroke color (RGB hex value).
 * @param {Number} [controlOpts.defaultStyles.strokeWidth = 2] - Stroke width in pixels.
 * @param {String} [controlOpts.defaultStyles.polyStrokeColor = "#ffcc33"] - Stroke color for polygons (RGB hex value).
 * @param {Number} [controlOpts.defaultStyles.polyStrokeWidth = 2] - Stroke width in pixels for polygons.
 * @param {String} [controlOpts.defaultStyles.polyFillColor = "#ffffff"] - Polygons fill color (RGB hex value).
 * @param {Number} [controlOpts.defaultStyles.polyFillOpacity = 0.2] - Polygon fill opacity (alpha value between 0:transparent and 1:opaque).
 * @param {Object} controlOpts.cursorStyle - cursor (circle) style when drawing or editing.
 * @param {String} [controlOpts.cursorStyle.fillColor = "rgba(0, 153, 255, 1)"] - Cursor fill color.
 * @param {String} [controlOpts.cursorStyle.strokeColor = "#FFF"] - Cursor stroke color.
 * @param {String} [controlOpts.cursorStyle.strokeWidth = 1] - Cursor surrounding stroke width.
 * @param {String} [controlOpts.cursorStyle.radius = 6] - Cursor radius.
 * @private
 */
_IMapBase.IMap.prototype.addDrawingControl = function (controlOpts) {};

/**
 * Adds attribution control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @private
 */
_IMapBase.IMap.prototype.addAttributionsControl = function (controlOpts) {};

/**
 * Adds camera orientation control to the map.
 *
 * @param {Object} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addCameraControl = function (controlOpts) {};

/**
 * Adds getFeatureInfo control to the map.
 *
 * @param {Object} controlOpts - control options
 * @private
 */
_IMapBase.IMap.prototype.addGetFeatureInfoControl = function (controlOpts) {};

/**
 * Gets Layer Container div ID for a given layerId.
 *
 * @param {String} layerId - layer identifier
 * @returns {String} - Layer Container div Id in the LayerSwitcher
 */
_IMapBase.IMap.prototype.getLSLayerContainerDivId = function (layerId) {
    // TO BE OVERRIDDEN
    var id = null;
    return id;
};

/**
 * Returns default Controls for the map
 *
 * @returns {Object} associative array mapping default controlIds with their ControlOptions.
 * @private
 */
_IMapBase.IMap.prototype._getDefaultControls = function () {
    return {
        draggable: true,
        keyboard: true,
        selectable: false,
        zoom: {},
        attributions: {
            maximised: false
        }
    };
};

/**
 * returns registerd Control in this._controls array.
 *
 * @param {String} controlId - control identifier
 * @returns {Integer} registered control index in this.controls array; -1 if not found.
 * @private
 */
_IMapBase.IMap.prototype._findRegisteredControl = function (controlId) {
    var regCtrl = -1;
    if (!controlId || typeof controlId !== "string") {
        this.logger.warn("[IMap] _findRegisteredControl : controlId is not a straight string");
        return regCtrl;
    }
    for (var i = 0; i < this._controls.length; i++) {
        if (this._controls[i].id.toLowerCase() === controlId.toLowerCase()) {
            // this.// logger.trace("[IMap] _findRegisteredControl : found control " + controlId + " at index : " + i);
            return i;
        }
    }
    // this.// logger.trace("[IMap] _findRegisteredControl : control " + controlId + " not found.");

    return regCtrl;
};

/**
 * Rajoute une configuration de couche au LayerSwitcher
 *
 * @param {Object} layerReg - element de this._layers correspondant à la couche
 * @param {Object} layerConf - options à rajouter au layerSwitcher.
 * @private
 */
_IMapBase.IMap.prototype._addLayerConfToLayerSwitcher = function (layerReg, layerConf) {
    // TO BE OVERRIDEN
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _IMapBase = __webpack_require__(2);

/**
 * cree un CustomEvent de maniere IE compatible
 *
 * @param {String} eventId - event id
 * @param {Object} eventObj - event
 *
 * @return {Object} custom event
 *
 * @private
 */
_IMapBase.IMap.CustomEvent = function (eventId, eventObj) {
    // creation d'un CustomEvent "IE" compatible
    // cf. http://caniuse.com/#feat=customevent
    // cf. https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    if (typeof CustomEvent === "function") {
        eventObj.bubbles = false;
        eventObj.cancelable = true;
        return new CustomEvent(eventId, eventObj);
    }
    var e = document.createEvent("CustomEvent");
    e.initCustomEvent(eventId, false, true, eventObj.detail);
    return e;
};

/**
 * Activate / Deactivate the ability to navigate on the map with mouse or pointer interaction.
 *
 * @param {Boolean} controlOpts - true for activation / false otherwise.
 * @private
 */
_IMapBase.IMap.prototype.setDraggable = function (controlOpts) {};

/**
 * Activate / Deactivate the ability to navigate on the map with keyborad.
 *
 * @param {Boolean} controlOpts - true for activation / false otherwise.
 * @private
 */
_IMapBase.IMap.prototype.setKeyboard = function (controlOpts) {};

/**
 * Activate / Deactivate the ability to select features on the map.
 *
 * @param {Boolean} controlOpts - true for activation / false otherwise.
 * @private
 */
_IMapBase.IMap.prototype.setSelectable = function (controlOpts) {};

/**
 * Associate a function to trigger when an event is received.
 *
 * @param {String} eventId - The map's event listened. Possible values are :
 *
 *
 * ** Common 2D/3D events **
 *
 * | eventId  | description |
 * |-|-|
 * | mapLoaded | fired when map has finished loading.  |
 * | geolocated | fired when map has finished centering by geolocation. Callback function handles a {@link Gp.GeolocatedEvent} object.|
 * | located | fired when map has finished centering by geocoding. Callback function handles a {@link Gp.LocatedEvent} object. |
 * | configured | fired when map has finished loading geoportal configuration. Callback function handles a {@link Gp.ConfiguredEvent} object |
 * | centerChanged | fired when map center has changed. Callback function handles a {@link Gp.CenterChangedEvent} object |
 * | zoomChanged | fired when map zoom has changed. Callback function handles a {@link Gp.ZoomChangedEvent} object |
 * | azimuthChanged | fired when map orientation has changed. Callback function handles a {@link Gp.AzimuthChangedEvent} object |
 * | layerChanged | fired when map's layer(s) has changed someway. Callback function handles a {@link Gp.LayerChangedEvent} object |
 *
 * ** Specific 3D events **
 *
 * | eventId  | description |
 * |-|-|
 * | tiltChanged | fired when map tilt has changed. Callback function handles a {@link Gp.TiltChangedEvent} object |
 *
 *
 * @param {Function} action - The function to execute when the event occures.
 * @param {Object} context - The object that will be used as "this" in the action function
 *
 * @return {Boolean} indicates if an event has been listened
 */
_IMapBase.IMap.prototype.listen = function (eventId, action, context) {
    // verifications de base
    if (typeof action !== "function") {
        // this.// logger.info("no action provided for event : " + eventId);
        return false;
    }
    context = context || this;
    var map = this;
    switch (eventId) {
        case "mapFailure":
            break;
        case "mapLoaded":
        case "geolocated":
        case "located":
        case "configured":
            // this.// logger.trace("[IMap] listening event : [" + eventId + "]");

            var callBack = function callBack(evt) {
                action.call(context, evt.detail);
            };

            var registredEvent = map._registerEvent(callBack, eventId, action, context);
            registredEvent.eventOrigin = this.div;
            registredEvent.eventType = eventId;
            registredEvent.eventOrigin.addEventListener(registredEvent.eventType, callBack, this);
            break;
        case "centerChanged":
        case "zoomChanged":
        case "azimuthChanged":
        case "tiltChanged":
        case "layerChanged":
            // evenements traites par l'implementation
            break;
        case "projectionChanged":
        case "controlChanged":
            // Interet de ces evenements ?
            break;
        default:
            // this.// logger.info("unhandled event : " + eventId);
            return false;
    };
    return true;
};

/**
 * Cancels an event listening previousely set with [Gp.Map.listen()](Gp.Map.html#listen) method.
 *
 * @param {String} eventId - The map's event to forget. Possible values are :
 *
 * ** Common 2D/3D events **
 *
 * | eventId  | description |
 * |-|-|
 * | mapLoaded | fired when map has finished loading |
 * | geolocated | fired when map has finished centering by geolocation |
 * | located | fired when map has finished centering by geocoding |
 * | configured | fired when map has finished loading geoportal configuration |
 * | centerChanged | fired when map center has changed |
 * | zoomChanged | fired when map zoom has changed |
 * | azimuthChanged | fired when map orientation has changed |
 * | layerChanged | fired when map's layer(s) has changed someway |
 *
 * ** Specific 3D events **
 *
 * | eventId  | description |
 * |-|-|
 * | tiltChanged | fired when map tilt has changed |
 * @param {Function} action - The function associated to the event.
 *
 * @return {Boolean} indicates if an event has been forgotten
 */
_IMapBase.IMap.prototype.forget = function (eventId, action) {
    // verifications de base
    if (typeof action !== "function") {
        // this.// logger.info("no action provided for event : " + eventId);
        return false;
    }
    switch (eventId) {
        case "mapLoaded":
        case "geolocated":
        case "located":
        case "configured":
        case "mapFailure":
        case "centerChanged":
        case "zoomChanged":
        case "azimuthChanged":
        case "tiltChanged":
        case "projectionChanged":
        case "layerChanged":
        case "controlChanged":
        case "pickFeature":
            // on cherche l'enregistrement de l'evenement
            var rEvents = this._events[eventId];
            if (!rEvents) {
                // this.// logger.info("nothing to forget for  : " + eventId);
                return false;
            }
            var itCallback = null;
            for (var i = rEvents.length - 1; i >= 0; i--) {
                if (rEvents[i].action == action) {
                    if (!rEvents[i].eventOrigin) {
                        continue;
                    }
                    itCallback = rEvents[i].key;
                    var eventOrigin = rEvents[i].eventOrigin;
                    var eventType = rEvents[i].eventType;
                    if (!itCallback) {
                        // this.// logger.info("action to forget not found for  : " + eventId);
                        return false;
                    }
                    rEvents.splice(i, 1);
                    // this.// logger.trace("[IT]  : forgetting  : " + eventId + " (" + itCallback + ")");

                    eventOrigin.removeEventListener(eventType, itCallback);
                }
            }
            if (!rEvents) {
                // this.// logger.info("action to forget not found for  : " + eventId);
                return false;
            }
            break;
        default:
            // this.// logger.info("unhandled event : " + eventId);
            return false;
    };
    return true;
};

/**
 * Ecouteur de changements sur les couches pour gerer le tableau this._layers.
 *
 * @param {Gp.LayerChangedEvent} evt - evenement de changement sur les couches
 * @private
 */
_IMapBase.IMap.prototype._onLayerChanged = function (evt) {
    var layerOpts = null;
    var idx = -1;
    var layerId = null;
    if (evt.hasOwnProperty("layerAdded")) {
        layerOpts = evt.layerAdded;
        idx = this._getLayerIndexByLayerOpts(layerOpts);
        // this.// logger.trace("[IMap] _onLayerChanged : layerAdded : " + idx);
        if (idx >= 0 && idx < this._layers.length) {
            layerId = this._layers[idx].id;
            this._layers[idx].options.position = evt.position;
            // this.// logger.trace("[IMap] _onLayerChanged : setting position value to " + evt.position + " for layer : " + layerId);
        } else {
            this.logger.warn("[IMap] _onLayerChanged : layerOpts (" + Object.keys(layerOpts)[0] + ") not found for layerAdded Event");
        }
    } else if (evt.hasOwnProperty("layerRemoved")) {
        layerOpts = evt.layerRemoved;
        idx = this._getLayerIndexByLayerOpts(layerOpts);
        if (idx >= 0 && idx < this._layers.length) {
            // this.// logger.trace("[IMap] _onLayerChanged : removing layer at index " + idx);
            // il faut garder trace de la couche supprimmée pour
            // d'autres abonnements à layerChanged.layerRemoved
            var layerRemoved = {};
            layerRemoved["id"] = this._layers[idx].id;
            layerRemoved["options"] = this._layers[idx].options;
            layerRemoved["obj"] = this._layers[idx].obj;
            this._layersRemoved.push(layerRemoved);
            this._layers.splice(idx, 1);
            // this.// logger.trace("[IMap] _onLayerChanged : #(layers) == " + this._layers.length);
        } else {
            this.logger.warn("[IMap] _onLayerChanged : layerOpts not found for layerRemoved Event");
        }
    } else if (evt.hasOwnProperty("layerChanged")) {
        layerOpts = evt.layerChanged;
        var idxx = this._getLayerIndexByLayerOpts(layerOpts);
        if (idxx >= 0 && idxx < this._layers.length) {
            layerId = this._layers[idxx].id;
            this._layers[idxx].options[evt.property] = evt.newValue;
            // this.// logger.trace("[IMap] _onLayerChanged : setting " + evt.property + " value to " + evt.newValue + " for layer : " + layerId);
        } else {
            this.logger.warn("[IMap] _onLayerChanged : layerOpts (" + Object.keys(layerOpts)[0] + ") not found for layerChanged Event");
        }
    }
};

/**
 * enregistre un evenement avec sa clef, sa fonction et sonID
 *
 * @param {Object} eventKey - ol layer
 * @param {String} eventId - id evenement pour le SDK
 * @param {Function} action - fonction associée à l'evt
 * @param {Object} context - contexte d'execution de l'action (context == this)
 *
 * @return {Object} the registred event
 * @private
 */
_IMapBase.IMap.prototype._registerEvent = function (eventKey, eventId, action, context) {
    // this.// logger.trace("[IMap] : listen registering : " + eventKey);
    if (eventKey) {
        if (!this._events.hasOwnProperty(eventId)) {
            this._events[eventId] = [];
        }
        this._events[eventId].push({
            action: action,
            key: eventKey,
            context: context
        });
    }

    return this._events[eventId][this._events[eventId].length - 1];
};

/**
 *  Remove and re-initialize layerChanged event
 *
 * @private
 */
_IMapBase.IMap.prototype._resetLayerChangedEvent = function () {
    // re-abonnement à l'evenement layerChanged
    // nécessaire pour ecouter les changements de propriétés sur la nouvelle couche
    if (this._events.hasOwnProperty("layerChanged")) {
        var actions = [];
        var contexts = [];

        this._events["layerChanged"].forEach(function (eventObj) {
            if (actions.indexOf(eventObj.action) < 0) {
                actions.push(eventObj.action);
                contexts.push(eventObj.context);
            }
        }, this);
        for (var i = 0; i < actions.length; ++i) {
            // on oublie ...
            this.forget("layerChanged", actions[i]);
            // ... pour mieux se souvenir
            this.listen("layerChanged", actions[i], contexts[i]);
        }
    }
};

/**
 *  Function to disable/enable layer color (grayscale or color mode).
 *
 * @param {String} layerId - layer identifier
 * @param {Boolean} colorToGray - indicate transformation direction (from or to grayscale)
 *
 * @private
 */
_IMapBase.IMap.prototype._changeLayerColor = function (layerId, colorToGray) {};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _IMapBase = __webpack_require__(2);

var _gp = __webpack_require__(0);

/**
 * envoie d'une requête de geocodage.
 *
 * @param {Object} opts - opts de geocodage
 * @param {String} opts.location - localisant
 * @param {Array.<String>} opts.locationType - types de localisants
 * @private
 */
_IMapBase.IMap.prototype.centerGeocode = function (opts) {
    // FIXME Config est créé en runtime dans la variable globale Gp
    var scope = typeof window !== "undefined" ? window : {};
    var Config = scope.Gp ? scope.Gp.Config : undefined;

    // le centrage par geocodage n'est possible que si l'utilisateur a les
    // droits sur le service.
    if (!Config || !this.apiKey) {
        // this.// logger.info("no rights for geocoding services");
        return;
    }
    // On cherche les types de géocodage disponibles
    var layersIds = Config.getLayersId(this.apiKey);
    var locTypes = opts.locationType || ["StreetAddress", "PositionOfInterest"];
    var fo = {};
    fo.type = [];
    while (locTypes.length > 0) {
        var lt = locTypes.pop();
        if (layersIds.indexOf(lt + "$OGC:OPENLS;Geocode") >= 0) {
            // this.// logger.trace("[IMap] centerGeocode : found rights for " + lt);
            fo.type.push(lt);
        }
    }
    // Si on n'a rien trouve, on ne peut pas geocoder
    if (fo.type.length === 0) {
        // this.// logger.info("no rights for geocoding services");
        return;
    }
    var map = this;
    _gp.Services.geocode({
        apiKey: this.apiKey,
        location: opts.location,
        filterOptions: fo,
        // si le service de geocodage répond
        onSuccess: function onSuccess(geocodeResponse) {
            // map.// logger.trace("[IMap] found center by geocoding (" + geocodeResponse.locations[0].position.x + ", " + geocodeResponse.locations[0].position.y + ")");
            var point = {
                x: geocodeResponse.locations[0].position.y,
                y: geocodeResponse.locations[0].position.x,
                projection: "EPSG:4326"
            };
            map.setAutoCenter(point);
            // declenchement de l'evenement "located"
            var e = _IMapBase.IMap.CustomEvent("located", {
                detail: {
                    position: point
                }
            });
            map.div.dispatchEvent(e);
        },
        // si le service de géocodage échoue
        onFailure: function onFailure() {
            // this.// logger.info("Erreur du service de géocodage !!!");
        }
    });
};

/**
 * envoie d'une requête de géolocalisation par IP.
 *
 * @private
 */
_IMapBase.IMap.prototype.centerGeolocate = function () {
    var map = this;
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
        // callback pour geolocalisation OK
        function (position) {
            // map.// logger.trace("[IMap] found center by geolocation (" + position.coords.longitude + ", " + position.coords.latitude + ")");
            var point = {
                x: position.coords.longitude,
                y: position.coords.latitude,
                projection: "EPSG:4326"
            };
            // paramater zoomLevel (=17 by default) used for 3D setAutoCenter function only
            map.setAutoCenter(point, 17);
            // declenchement de l'evenement "geolocated"
            var e = _IMapBase.IMap.CustomEvent("geolocated", {
                detail: {
                    position: point
                }
            });
            map.div.dispatchEvent(e);
        },
        // callback pour geolocalisation nOK
        function (error) {
            var info = "Erreur lors de la géolocalisation : ";
            switch (error.code) {
                case error.TIMEOUT:
                    info += "Timeout !";
                    break;
                case error.PERMISSION_DENIED:
                    info += "Vous n’avez pas donné la permission";
                    break;
                case error.POSITION_UNAVAILABLE:
                    info += "La position n’a pu être déterminée";
                    break;
                case error.UNKNOWN_ERROR:
                    info += "Erreur inconnue";
                    break;
            }
            // this.// logger.info(info);
        });
    } else {
        // this.// logger.info("Geolocate impossible");
    }
};

/**
 * Returns the current coordinates of the map's center in the current projection.
 *
 * @returns {Gp.Point} - The current map's center.
 */
_IMapBase.IMap.prototype.getCenter = function () {
    return {};
};

/**
 * Sets new center to the map.<br/>
 *
 * * Use x, y and projection properties to center the map with coordinates;
 * * Use location and locationType properties to center the map thanks to [Geoportal geocoding web service](http://api.ign.fr/tech-docs-js/fr/developpeur/search.html).
 * * Use geolocate to center the map with user position.
 *
 * @param {Gp.Center} center - options for centering the map
 */
_IMapBase.IMap.prototype.setCenter = function (center) {
    // this.// logger.trace("[IMap] : setCenter");
    if (!center) {
        return;
    }
    if (center.hasOwnProperty("x") && center.hasOwnProperty("y")) {
        // this.// logger.trace("[IMap] : setCenter - x, y");
        this.setXYCenter(center);
    }
    if (center.geolocate) {
        // this.// logger.trace("[IMap] : setCenter - geolocate");
        this.centerGeolocate();
    }
    if (center.location && center.location.trim().length > 0) {
        // this.// logger.trace("[IMap] : setCenter - geocode");
        this.centerGeocode(center);
    }
};

/**
 * center Map on a given point
 *
 * @param {Object} point - center point
 * @param {Float} point.x - x coordinates for center
 * @param {Float} point.y - y coordinates for center
 * @param {String} point.projection - srs center coordinates
 * @private
 *
 */
_IMapBase.IMap.prototype.setXYCenter = function (point) {};

/**
 * center Map on a given point in case of auto centering
 *
 * @param {Object} point - center point
 * @param {Float} point.x - x coordinates for center
 * @param {Float} point.y - y coordinates for center
 * @param {String} point.projection - srs center coordinates
 * @private
 *
 */
_IMapBase.IMap.prototype.setAutoCenter = function (point) {};

/**
 * Returns the current bounding box of the map in the current projection.
 *
 * @summary Specific 2D function
 * @param {String} [projection=map projection] - Coordinate Reference System of returned extent.
 * @returns {Gp.BBox} - The current map's extent.
 *
 */
_IMapBase.IMap.prototype.getViewExtent = function () {
    return {};
};

/**
 * Returns the current map's projection code (EPSG or IGNF).
 *
 * @summary Specific 2D function
 * @returns {String} The current map's projection.
 */
_IMapBase.IMap.prototype.getProjection = function () {
    return "";
};

/**
 * Sets current map's projection to given projection code (EPSG or IGNF).
 * (FIXME : non visible pour l'instant car le changement de
 *          projection à la volée ne fonctionne pas)
 *
 * @param {String} projection - The new map's projection code.
 * @private
 */
_IMapBase.IMap.prototype.setProjection = function (projection) {
    // TO BE OVERRIDDEN
};

/**
 * Returns the current camera's tilt.
 *
 * @summary Specific 3D function
 * @returns {Number} - The current camera's tilt.
 */
_IMapBase.IMap.prototype.getTilt = function () {
    return 0;
};

/**
 * Sets a new camera's tilt (3D only).
 *
 * @summary Specific 3D function
 * @param {Float} tilt - The camera's tilt.
 */
_IMapBase.IMap.prototype.setTilt = function (tilt) {};

/**
 * Returns the current map's azimuth.
 *
 * @returns {Number} - The current map's azimuth expressed in decimal degrees clockwise to the north.
 */
_IMapBase.IMap.prototype.getAzimuth = function () {
    return 0;
};

/**
 * Sets a new map's azimuth.
 *
 * @param {Float} azimuth - The new map's azimuth expressed in decimal degrees clockwise to the north.
 */
_IMapBase.IMap.prototype.setAzimuth = function (azimuth) {};

/**
 * Returns the current map's zoom level.
 *
 * @returns {Number} - The current map's zoom.
 */
_IMapBase.IMap.prototype.getZoom = function () {
    return 0;
};

/**
 * Sets a new map's zoom level.
 *
 * @param {Integer} zoom - The new map's zoom.
 */
_IMapBase.IMap.prototype.setZoom = function (zoom) {};

/**
 * Increases the current map's zoom level by 1.
 *
 */
_IMapBase.IMap.prototype.zoomIn = function () {};

/**
 * Decreases the current map's zoom level by 1.
 *
 */
_IMapBase.IMap.prototype.zoomOut = function () {};

/**
 * Returns the current map's resolution.
 *
 * @summary Specific 2D function
 * @returns {Number} - The current map's resolution (in meter per pixel).
 */
_IMapBase.IMap.prototype.getResolution = function () {
    return 0;
};

/**
 * Sets a new map's resolution.
 *
 * @summary Specific 2D function
 * @param {Float} resolution - The new map's resolution (in meter per pixel).
 */
_IMapBase.IMap.prototype.setResolution = function (resolution) {};

/**
 * Get zoom level from resolution
 *
 * @param {Number} resolution - resolution
 * @param {String} projCode - projection code
 *
 * @return {Integer} zoom level
 *
 * @private
 */
_IMapBase.IMap.prototype._getZoomFromResolution = function (resolution, projCode) {
    // this.// logger.trace("[IMap] : _getZoomFromResolution");
    var mapProj = this.getProjection();
    var wmtsDefaults = _IMapBase.IMap.WMTSDEFAULTS[projCode] || _IMapBase.IMap.WMTSDEFAULTS[mapProj] || _IMapBase.IMap.WMTSDEFAULTS["EPSG:3857"];

    var zoom = 0;
    var diffMin = Math.abs(wmtsDefaults.resolutions[0] - resolution);

    for (var i = 1; i < wmtsDefaults.resolutions.length; i++) {
        var diff = Math.abs(wmtsDefaults.resolutions[i] - resolution);
        if (diff >= diffMin) {
            break;
        }
        zoom = i;
        diffMin = diff;
    }
    return zoom;
};

/**
 * Get resolution from zoomLevel
 *
 * @param {Integer} zoom - zoom level
 * @param {String} projCode - projection code
 *
 * @return {Number} resolution
 *
 * @private
 */
_IMapBase.IMap.prototype._getResolutionFromZoomLevel = function (zoom, projCode) {
    // this.// logger.trace("[IMap] : _getResolutionFromZoomLevel");
    var mapProj = this.getProjection();
    var wmtsDefaults = _IMapBase.IMap.WMTSDEFAULTS[projCode] || _IMapBase.IMap.WMTSDEFAULTS[mapProj] || _IMapBase.IMap.WMTSDEFAULTS["EPSG:3857"];
    var res = -1;
    if (zoom >= 0 && zoom < wmtsDefaults.resolutions.length) {
        res = wmtsDefaults.resolutions[zoom];
    } else {
        // this.// logger.info("unhandled zoom level : " + zoom);
    }
    return res;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _OlMapBase = __webpack_require__(1);

var _IMap = __webpack_require__(3);

var _gp = __webpack_require__(0);

/**
 * Proprietes observables des couches pour le SDK
 */
_OlMapBase.OlMap.LAYERPROPERTIES = {
    visible: "visibility",
    opacity: "opacity",
    zIndex: "position",
    grayScaled: "grayScaled",
    minResolution: "maxZoom",
    maxResolution: "minZoom"
};

/**
 * Remove the layers listed to the map.
 *
 * @param {Array.<String>} layerIds - A list of layer's id or null.
 */
_OlMapBase.OlMap.prototype.removeLayers = function (layerIds) {
    if (!_IMap.IMap.prototype.removeLayers.apply(this, arguments)) {
        return;
    }
    // ici on sait que layerIds est un tableau
    var _layers = this._getLayersObj(layerIds);
    _layers.forEach(function (_layer, i, array) {
        this.libMap.removeLayer(_layer.obj);
    }, this);
};

/**
 * Modify the layers'options listed to the map
 *
 * @param {Object} layersOptions - Layers to add to the map and their options. Associative array mapping official name of the Geoportal layer or the id of a personal layer (keys) with their properties (values given as {@link Gp.LayerOptions}).
 */
_OlMapBase.OlMap.prototype.modifyLayers = function (layersOptions) {
    if (!_IMap.IMap.prototype.modifyLayers.apply(this, arguments)) {
        return;
    }
    var layerIds = Object.keys(layersOptions);
    // on recupere les objets correspondants dejà sur la carte
    var _layerObjs = this._getLayersObj(layerIds);
    _layerObjs.forEach(function (_layerObj) {
        // this.// logger.trace("[IMap] modifyLayers : modifying : [" + _layerObj.id + "]");
        // traduction options ahn => options OlMap
        var commonOpts = this._applyCommonLayerParams(layersOptions[_layerObj.id]);
        // application des options OL aux couches OL
        // l'objet _layerObj.options sera mis à jour par le mécanisme des evenements.
        if (commonOpts.hasOwnProperty("opacity")) {
            // this.// logger.trace("[IMap] modifyLayers : setting opacity of : [" + _layerObj.id + "] to : " + commonOpts.opacity);
            _layerObj.obj.setOpacity(commonOpts.opacity);
        }
        if (commonOpts.hasOwnProperty("visible")) {
            // this.// logger.trace("[IMap] modifyLayers : setting visible of : [" + _layerObj.id + "] to : " + commonOpts.visible);
            _layerObj.obj.setVisible(commonOpts.visible);
        }
        if (commonOpts.hasOwnProperty("zIndex")) {
            // this.// logger.trace("[IMap] modifyLayers : setting zIndex of : [" + _layerObj.id + "] to : " + commonOpts.zIndex);
            _layerObj.obj.setZIndex(commonOpts.zIndex);
            // pour forcer la prise en compte par le LayerSwitcher du zIndex quand il vaut zéro (extension OL) (cf. issue #12)
            if (commonOpts.zIndex === 0) {
                _layerObj.obj._forceNullzIndex = true;
            }
            // ou inversement pour ne plus forcer le zIndex à zéro lorsque ce n'est pas le cas
            if (commonOpts.zIndex !== 0 && _layerObj.obj._forceNullzIndex) {
                _layerObj.obj._forceNullzIndex = false;
            }
        }
        if (commonOpts.hasOwnProperty("minResolution")) {
            // this.// logger.trace("[IMap] modifyLayers : setting minResolution of : [" + _layerObj.id + "] to : " + commonOpts.minResolution);
            _layerObj.obj.setMinResolution(commonOpts.minResolution);
        }
        if (commonOpts.hasOwnProperty("maxResolution")) {
            // this.// logger.trace("[IMap] modifyLayers : setting maxResolution of : [" + _layerObj.id + "] to : " + commonOpts.maxResolution);
            _layerObj.obj.setMaxResolution(commonOpts.maxResolution);
        }
        if (commonOpts.hasOwnProperty("grayScaled")) {
            // this.// logger.trace("[IMap] modifyLayers : setting grayScaled of : [" + _layerObj.id + "] to : " + commonOpts.grayScaled);
            this._changeLayerColor(_layerObj.id, commonOpts.grayScaled);
        }
    }, this);
};

/**
 * Add a Raster Layer to the map
 *
 * @param {Object} layerObj - geoportalLayer to add.
 * @param {Gp.LayerOptions} layerObj.geoportalLayerID - options of the layer
 *
 * @private
 */
_OlMapBase.OlMap.prototype._addRasterLayer = function (layerObj) {
    var layerId = Object.keys(layerObj)[0];
    var layerOpts = layerObj[layerId];
    // au cas où la couche ajoutée est un MNT, on essaye pas de l'ajouter en 2D
    if (layerOpts.isElevation !== true) {
        var constructorOpts = this._applyCommonLayerParams(layerOpts);
        switch (layerOpts.format.toUpperCase()) {
            case "WMS":
                {
                    // this.// logger.trace("ajout d'une couche WMS");
                    var params = {};
                    params.LAYERS = layerOpts.layers.join(",");

                    if (layerOpts.version) {
                        params.VERSION = layerOpts.version;
                    }
                    // au cas ou maintien de l'ancien nom de paramètre :
                    // layerOpts.styleName (sans "s")
                    layerOpts.stylesNames = layerOpts.stylesNames || layerOpts.stylesName;
                    if (layerOpts.stylesNames) {
                        if (Array.isArray(layerOpts.stylesNames)) {
                            params.STYLES = layerOpts.stylesNames.join();
                        } else {
                            // this.// logger.info("'stylesNames' parameter should be an array of style names (string)");
                        }
                    }
                    if (layerOpts.outputFormat) {
                        params.FORMAT = layerOpts.outputFormat;
                    }
                    if (layerOpts.backgroundColor) {
                        params.BGCOLOR = layerOpts.backgroundColor;
                        params.TRANSPARENT = "FALSE";
                    } else {
                        params.TRANSPARENT = "TRUE";
                    }
                    var sourceOpts = {
                        url: layerOpts.url,
                        params: params
                    };
                    if (layerOpts.hasOwnProperty("projection")) {
                        sourceOpts.projection = layerOpts.projection;
                    }
                    if (layerOpts.hasOwnProperty("tiled") && layerOpts.tiled === true) {
                        constructorOpts.source = new _gp.olExtended.source.TileWMS(sourceOpts);
                    } else {
                        constructorOpts.source = new _gp.olExtended.source.ImageWMS(sourceOpts);
                    }
                    break;
                }
            case "WMTS":
                {
                    // this.// logger.trace("ajout d'une couche WMTS");
                    // chargement des options par defaut
                    var lOpts = this._getWMTSDefaultOpts();
                    // surcharge avec les options utilisateurs
                    for (var opt in layerOpts) {
                        lOpts[opt] = layerOpts[opt];
                    }
                    layerOpts = lOpts;
                    var _sourceOpts = {
                        url: layerOpts.url,
                        layer: layerOpts.layer,
                        matrixSet: layerOpts.tileMatrixSet,
                        format: layerOpts.outputFormat,
                        version: layerOpts.version,
                        style: layerOpts.styleName,
                        tileGrid: new _gp.olExtended.tilegrid.WMTS({
                            origin: [layerOpts.topLeftCorner.x, layerOpts.topLeftCorner.y],
                            resolutions: layerOpts.resolutions,
                            matrixIds: layerOpts.matrixIds
                        })
                    };
                    // RESTFul or KVP encoding ?
                    if (layerOpts.url.indexOf("{TileMatrixSet}") > 0 || layerOpts.url.indexOf("{TileRow}") > 0 || layerOpts.url.indexOf("{TileCol}") > 0) {
                        // its an url template => RESTFul
                        _sourceOpts.requestEncoding = "REST";
                    } else {
                        _sourceOpts.requestEncoding = "KVP";
                    }
                    constructorOpts.source = new _gp.olExtended.source.WMTSExtended(_sourceOpts);
                    break;
                }
            case "OSM":
                // this.// logger.trace("ajout d'une couche OSM");
                constructorOpts.source = new _gp.olExtended.source.OSM({
                    url: layerOpts.url
                });
                break;
            default:
        }
        if (constructorOpts.hasOwnProperty("source")) {
            // le controle geoportalAttribution exploite la propriete _originators
            if (layerOpts.hasOwnProperty("originators")) {
                constructorOpts.source._originators = layerOpts.originators;
            }
            var layer = null;
            if (layerOpts.format.toUpperCase() === "WMS" && (!layerOpts.hasOwnProperty("tiled") || layerOpts.tiled !== true)) {
                layer = new _gp.olExtended.layer.Image(constructorOpts);
            } else {
                layer = new _gp.olExtended.layer.Tile(constructorOpts);
            }
            // pour forcer la prise en compte par le LayerSwitcher du zIndex quand il vaut zéro (extension OL) (cf. issue #12)
            if (constructorOpts.hasOwnProperty("zIndex") && constructorOpts.zIndex === 0) {
                layer._forceNullzIndex = true;
            }
            var gpLayer = {
                id: layerId,
                obj: layer,
                options: layerOpts
            };

            if (layerOpts.hasOwnProperty("grayScaled") && layerOpts.grayScaled) {
                this._colorGrayscaleLayerSwitch(gpLayer, true);
            }

            this._layers.push(gpLayer);
            this.libMap.addLayer(gpLayer.obj);
            this._addLayerConfToLayerSwitcher(gpLayer.obj, layerOpts);
        }
    } else {
        // dans ce cas, on est sur une couche d'élévation
        // on la sauvegarde dans le tableau 3Dlayers pour l'ajouter si on passe en contexte 3D
        var elevationLayer = {
            id: layerId,
            obj: "3D-only-layer",
            options: layerOpts
        };
        if (!this._3Dlayers) {
            this._3Dlayers = [];
        }
        this._3Dlayers.push(elevationLayer);
    }
};

/**
 * Add a vector Layer to the map
 *
 * @param {Object} layerObj - geoportalLayer to add.
 * @param {Gp.LayerOptions} layerObj.geoportalLayerID - options of the layer
 *
 * @private
 */
_OlMapBase.OlMap.prototype._addVectorLayer = function (layerObj) {
    // FIXME : ajout d'un parametre projection pour les donnees
    var layerId = Object.keys(layerObj)[0];
    var layerOpts = layerObj[layerId];
    var constructorOpts = this._applyCommonLayerParams(layerOpts);

    var layerStyleOptions = layerOpts.styleOptions || {};
    var defaultMapOptions = this.mapOptions.defaultFeaturesStyle || {};
    var defaultOptions = _IMap.IMap.DEFAULT_VECTORLAYERS_STYLES;
    var styleOptions = {};
    styleOptions.image = new _gp.olExtended.style.Icon({
        src: layerStyleOptions.markerSrc || defaultMapOptions.markerSrc || defaultOptions.markerSrc,
        anchor: [layerStyleOptions.markerXAnchor || defaultMapOptions.markerXAnchor || defaultOptions.markerXAnchor, layerStyleOptions.markerYAnchor || defaultMapOptions.markerYAnchor || defaultOptions.markerYAnchor],
        anchorOrigin: "top-left",
        anchorXUnits: "pixels",
        anchorYUnits: "pixels"
    });
    styleOptions.stroke = new _gp.olExtended.style.Stroke({
        color: _IMap.IMap.prototype._hexToRgba.call(this, layerStyleOptions.strokeColor || defaultMapOptions.strokeColor || defaultOptions.strokeColor, layerStyleOptions.strokeOpacity || defaultMapOptions.strokeOpacity || defaultOptions.strokeOpacity),
        width: layerStyleOptions.strokeWidth || defaultMapOptions.strokeWidth || defaultOptions.strokeWidth
    });
    styleOptions.fill = new _gp.olExtended.style.Fill({
        color: _IMap.IMap.prototype._hexToRgba.call(this, layerStyleOptions.polyFillColor || defaultMapOptions.polyFillColor || defaultOptions.polyFillColor, layerStyleOptions.polyFillOpacity || defaultMapOptions.polyFillOpacity || defaultOptions.polyFillOpacity)
    });
    styleOptions.text = new _gp.olExtended.style.Text({
        font: "16px Sans",
        textAlign: "left",
        fill: new _gp.olExtended.style.Fill({
            color: _IMap.IMap.prototype._hexToRgba.call(this, layerStyleOptions.textColor || defaultMapOptions.textColor || defaultOptions.textColor, 1)
        })
    });
    if (layerStyleOptions.textStrokeColor) {
        styleOptions.text.stroke = new _gp.olExtended.style.Stroke({
            color: _IMap.IMap.prototype._hexToRgba.call(this, layerStyleOptions.textStrokeColor || defaultMapOptions.textStrokeColor || defaultOptions.textStrokeColor, 1),
            width: 1
        });
    }
    var vectorStyle = new _gp.olExtended.style.Style(styleOptions);

    switch (layerOpts.format.toUpperCase()) {
        case "KML":
            // this.// logger.trace("ajout d'une couche KML");

            // FIXME !?
            // constructorOpts.source = new ol.source.Vector({
            //     url : this.setProxy(layerOpts.url),
            //     format : new ol.format.KMLExtended({
            //         extractStyles : layerOpts.extractStyles,
            //         showPointNames : false
            //     })
            // });

            var urlKml = this.setProxy(layerOpts.url);
            var formatKml = new _gp.olExtended.format.KMLExtended({
                extractStyles: layerOpts.extractStyles,
                showPointNames: layerOpts.showPointNames,
                defaultStyle: [vectorStyle]
            });
            constructorOpts.source = new _gp.olExtended.source.Vector({
                features: new _gp.olExtended.Collection(),
                // features loader
                loader: function loader(extent, resolution, projectionFeature) {
                    _gp.Protocols.XHR.call({
                        url: urlKml,
                        method: "GET",
                        timeOut: 15000,
                        // callback on success
                        onResponse: function onResponse(response) {
                            var projectionData = formatKml.readProjection(response);
                            var features = formatKml.readFeatures(response, {
                                dataProjection: projectionData,
                                featureProjection: projectionFeature
                            });
                            if (features.length > 0) {
                                constructorOpts.source.addFeatures(features);
                            }
                        },
                        // callback on failure
                        onFailure: function onFailure(error) {
                            // this.// logger.info("[Ol.control.LayerImport] Kml/Gpx request failed : ", error);
                        }
                    });
                }
            });
            break;
        case "GPX":
            // this.// logger.trace("ajout d'une couche GPX");
            constructorOpts.source = new _gp.olExtended.source.Vector({
                url: this.setProxy(layerOpts.url),
                format: new _gp.olExtended.format.GPX()
            });
            constructorOpts.style = vectorStyle;
            break;
        case "GEORSS":
            // TODO GeoRSS
            break;
        case "GEOJSON":
            // this.// logger.trace("ajout d'une couche GeoJSON");
            constructorOpts.source = new _gp.olExtended.source.Vector({
                url: this.setProxy(layerOpts.url),
                format: new _gp.olExtended.format.GeoJSON()
            });
            constructorOpts.style = vectorStyle;
            break;
        case "WFS":
            // TODO : gestion des valeurs par defaut
            // this.// logger.trace("ajout d'une couche WFS");
            var maxFeatures = "";
            var sld = "";

            if (!layerOpts.version) {
                layerOpts.version = "2.0.0";
            }
            if (!layerOpts.outputFormat) {
                layerOpts.outputFormat = "application/json";
            }
            if (layerOpts.maxFeatures) {
                if (parseInt(layerOpts.version.charAt(0)) < 2) {
                    maxFeatures = "&maxFeatures=" + layerOpts.maxFeatures;
                } else {
                    maxFeatures = "&count=" + layerOpts.maxFeatures;
                }
            }
            if (layerOpts.sld) {
                sld = "&sld=" + layerOpts.sld;
            }

            var layerUrl = this.setProxy(layerOpts.url);
            var oflc = layerOpts.outputFormat.toLowerCase();
            var format = null;
            var formatOptions = {};
            // FIXME : useless projection param ?
            if (layerOpts.projection) {
                // param for GeoJSON format
                // FIXME
                // cf. https://github.com/openlayers/openlayers/commit/cbaa9a7567ae32629241bab4721bc429940c942e#diff-2734579f56e71d2f13d47cd894a3fe68
                // defaultDataProjection to dataProjection version > 5.0.0 !
                formatOptions["defaultDataProjection"] = layerOpts.projection;
                // param for GMLx format
                formatOptions["srsName"] = layerOpts.projection;
            }
            // FIXME à revoir...
            if (oflc.indexOf("gml") > 0 || oflc.indexOf("xml") > 0) {
                // GML => look for version indication
                if (oflc.indexOf("2.1") > 0 || oflc.indexOf("gml2") > 0) {
                    format = new _gp.olExtended.format.GML2(formatOptions);
                } else {
                    // GML => defaults to GML3
                    format = new _gp.olExtended.format.GML3(formatOptions);
                }
            } else {
                // Defaults format to GeoJSON
                format = new _gp.olExtended.format.GeoJSON(formatOptions);
            }
            constructorOpts.source = new _gp.olExtended.source.Vector({
                format: format,
                // envoi de la requête WFS
                url: function url(extent, resolution, projection) {
                    return layerUrl + "?service=WFS&request=GetFeature" + "&version=" + layerOpts.version + "&typename=" + layerOpts.typeNames + "&outputFormat=" + layerOpts.outputFormat + "&srsname=" + projection.getCode() + "&bbox=" + extent.join(",") + "," + projection.getCode() + maxFeatures + sld;
                },
                strategy: _gp.olExtended.loadingstrategy.bbox
            });

            break;
        case "drawing":
            // à tester avec les outils de dessins
            // this.// logger.trace("ajout d'une couche de dessin");

            constructorOpts.source = new _gp.olExtended.source.Vector({});
            break;
        default:
            break;
    }

    if (constructorOpts.hasOwnProperty("source")) {
        // le controle geoportalAttribution exploite la propriete _originators
        if (layerOpts.hasOwnProperty("originators")) {
            constructorOpts.source._originators = layerOpts.originators;
        }

        var layer = new _gp.olExtended.layer.Vector(constructorOpts);
        this._layers.push({
            id: layerId,
            obj: layer,
            options: layerOpts
        });

        this.libMap.addLayer(layer);
        this._addLayerConfToLayerSwitcher(layer, layerOpts);

        var _map = this.libMap;
        var _vectorSource = constructorOpts.source;
        // "getExtent" pour les vecteurs
        if (_map.getView() && _map.getSize() && _vectorSource.getExtent) {
            var _fit = layerOpts.zoomToExtent || false;
            if (_fit) {
                var key = _vectorSource.on("change", function () {
                    var _sourceExtent = _vectorSource.getExtent();
                    var _stateExtent = _vectorSource.getState();
                    if (_stateExtent === "ready" && _sourceExtent[0] !== Infinity) {
                        _gp.olExtended.Observable.unByKey(key);
                        _map.getView().fit(_sourceExtent, {
                            // size : _map.getSize(),
                            maxZoom: 18
                        });
                    }
                });

                setTimeout(function () {
                    _vectorSource.dispatchEvent("change");
                }, 100);
            }
        }
    }
};

/**
 * Add a geoportal Layer to the map
 *
 * @param {Object} layerObj - geoportalLayer to add.
 * @param {Gp.LayerOptions} layerObj.geoportalLayerID - options of the layer
 *
 * @private
 */
_OlMapBase.OlMap.prototype._addGeoportalLayer = function (layerObj) {
    var layerId = Object.keys(layerObj)[0];
    var layerOpts = layerObj[layerId];
    // parametres additionnels eventuels
    var olParams = {};
    if (layerOpts.hasOwnProperty("opacity")) {
        olParams.opacity = layerOpts.opacity;
    }
    if (layerOpts.hasOwnProperty("visibility")) {
        olParams.visible = layerOpts.visibility;
    }
    if (layerOpts.hasOwnProperty("position")) {
        olParams.zIndex = layerOpts.position;
    }
    if (layerOpts.hasOwnProperty("minZoom") && layerOpts.minZoom >= 0 && layerOpts.minZoom <= 28) {
        olParams.maxResolution = this._getResolutionFromZoomLevel(layerOpts.minZoom);
        // this.// logger.trace("[OlMap] : apply MaxResolution : " + olParams.maxResolution);
    }
    if (layerOpts.hasOwnProperty("maxZoom") && layerOpts.maxZoom >= 0 && layerOpts.maxZoom <= 28) {
        olParams.minResolution = this._getResolutionFromZoomLevel(layerOpts.maxZoom);
        // this.// logger.trace("[OlMap] : apply minResolution : " + olParams.minResolution);
    }
    var LayerClass = null;
    switch (layerOpts.format.toUpperCase()) {
        case "WMTS":
            LayerClass = _gp.olExtended.layer.GeoportalWMTS;
            break;
        case "WMS":
            LayerClass = _gp.olExtended.layer.GeoportalWMS;
            break;
        default:
            // this.// logger.info("addGeoportalLayer : no class found for " + layerOpts.format);
    }
    var olLayer = new LayerClass({
        layer: layerId,
        olParams: olParams
    });
    // le controle geoportalAttribution exploite la propriete _originators
    // si l'utilisateur en a passé des originators en paramètres, on écrase ceux de l'autoconf.
    if (layerOpts.hasOwnProperty("originators")) {
        olLayer.getSource()._originators = layerOpts.originators;
    }
    // pour forcer la prise en compte par le LayerSwitcher du zIndex quand il vaut zéro (extension OL) (cf. issue #12)
    if (olParams.hasOwnProperty("zIndex") && olParams.zIndex === 0) {
        olLayer._forceNullzIndex = true;
    }

    this._layers.push({
        id: layerId,
        obj: olLayer,
        options: layerOpts
    });
    this.libMap.addLayer(olLayer);
    this._addLayerConfToLayerSwitcher(olLayer, layerOpts);
};

/**
 * Trouve l'objet layerOpts correspondant au layer OL
 *
 * @param {Object} layerObj - ol layer
 * @param {Object} layersStack - tableau des couches où chercher
 *
 * @return {Object} layer options
 */
_OlMapBase.OlMap.prototype._getLayerOpts = function (layerObj, layersStack) {
    var layerOpts = null;
    layersStack = layersStack || this._layers;
    for (var i = 0; i < layersStack.length; i++) {
        var l = layersStack[i];
        if (l.obj === layerObj) {
            layerOpts = {};
            layerOpts[l.id] = l.options;
            break;
        }
    }
    return layerOpts;
};

/**
 * Registers unknown unregistered layer
 *
 * @param {Object} layerObj - ol layer
 * @returns {Object} - new layer index in this._layers
 */
_OlMapBase.OlMap.prototype._registerUnknownLayer = function (layerObj) {
    // couches de résultat (itineraire, isochrone)
    var layerId = "unknownLayer";
    if (layerObj.hasOwnProperty("gpResultLayerId")) {
        // isochrones : [GraphName]$GEOPORTAIL:GPP:Isocurve
        // itineraire : [GraphName]$GEOPORTAIL:GPP:Itineraire
        layerId = layerObj.gpResultLayerId;
    }
    // on rajoute un timestamp
    layerId += "-" + Date.now();
    // on rajoute des infos quand on en a
    var options = {};
    if (layerId.indexOf("drawing-") === 0) {
        options.format = "drawing";
    } else if (layerId.indexOf("layerimport:KML") === 0) {
        options.format = "KML";
    } else if (layerId.indexOf("layerimport:GPX") === 0) {
        options.format = "GPX";
    } else if (layerId.indexOf("layerimport:GeoJSON") === 0) {
        options.format = "GeoJSON";
    } else if (layerId.indexOf("layerimport:WMS") === 0) {
        options.format = "WMS";
        if (layerObj.gpGFIparams) {
            if (layerObj.gpGFIparams.queryable) {
                options.queryable = true;
            }
            if (Array.isArray(layerObj.gpGFIparams.formats)) {
                // par défaut on prend le premier
                options.gfiFormat = layerObj.gpGFIparams.formats[0];
                // si on trouve "text/html" dans les formats disponibles, on prend "text/html" par défaut
                for (var i = 0; i < layerObj.gpGFIparams.formats.length; i++) {
                    if (layerObj.gpGFIparams.formats[i] === "text/html") {
                        options.gfiFormat = "text/html";
                        break;
                    }
                }
            }
        }
    } else if (layerId.indexOf("layerimport:WMTS") === 0) {
        options.format = "WMTS";
    }
    this._layers.push({
        id: layerId,
        obj: layerObj,
        options: options
    });
    var layerOpts = {};
    layerOpts[layerId] = {};

    return layerOpts;
};

/**
 * Check params for layerDisplay
 *
 * @param {Gp.LayerOptions} layerOpts - options of the layer
 * @returns {Boolean} true if parameters are OK, false otherwise
 *
 * @private
 */
_OlMapBase.OlMap.prototype._checkLayerParams = function (layerOpts) {
    // verifications de base de la classe mère
    if (!_IMap.IMap.prototype._checkLayerParams.apply(this, arguments)) {
        return false;
    }
    // verifications specifiques pour affichage dans OL
    // TODO
    return true;
};

/**
 *
 * @param {String} layerId - layer identifier
 * @param {Boolean} toGrayScale - indicate transformation direction (from or to grayscale)
 *
 * @private
 */
_OlMapBase.OlMap.prototype._changeLayerColor = function (layerId, toGrayScale) {
    var layerIndex = this._getLayerIndexByLayerId(layerId);
    var gpLayer = this._layers[layerIndex];

    switch (gpLayer.options.format.toUpperCase()) {
        case "KML":
        case "GPX":
        case "WFS":
        case "drawing":
            // this.// logger.info("[OlMap.prototype._changeLayerColor] warning : _changeLayerColor not allowed on vector layers (layer id: " + layerId + ")");
            return;
    }

    this._colorGrayscaleLayerSwitch(gpLayer, toGrayScale);

    var event = _IMap.IMap.CustomEvent("change:grayScaled", {
        detail: {
            oldValue: !toGrayScale,
            newValue: toGrayScale
        }
    });
    gpLayer.obj.dispatchEvent(event);
};

/**
 * Function to switch layer display mode between color and grayscale.
 *
 * @param {Object} gpLayer - gp layer object
 * @param {String} gpLayer.id - layer identifier
 * @param {ol.layer.Layer} gpLayer.obj - implementation layer object (here openlayers)
 * @param {Object} gpLayer.options - layer properties (of type layerOptions)
 * @param {Boolean} toGrayScale - indicates conversion direction.
 *
 * @private
 */
_OlMapBase.OlMap.prototype._colorGrayscaleLayerSwitch = function (gpLayer, toGrayScale) {
    // fonction de conversion d'une image en n/b
    function getGrayScaledDataUrl(img) {
        // patch pour safari
        img.crossOrigin = null;

        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        var imageData = ctx.getImageData(0, 0, img.width, img.height);
        var data = imageData.data;

        for (var i = 0; i < data.length; i += 4) {
            var avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
            data[i] = avg; // red
            data[i + 1] = avg; // green
            data[i + 2] = avg; // blue
        }

        ctx.putImageData(imageData, 0, 0);
        return canvas.toDataURL();
    };

    // fonction de conversion et de chargement d'une image en n/b
    function convertImagetoGrayScale(image, context) {
        // conversion en n/b
        var dataUrl = getGrayScaledDataUrl(image);

        // chargement d'une image vide intermediaire pour eviter
        // l'affichage d'images couleurs (pour certains navigateurs
        // le chargement de l'image n/b et plus long et l'image originale
        // apparait de manière transitoire)
        image.src = "";

        // forcer le raffraichissement de l'affichage a l'issu
        // du chargement de l'image n/b
        /** onload */
        image.onload = function () {
            context.changed();
        };
        // chargement image n/b
        image.src = dataUrl;
    }

    // handler for event 'imageloadstart'
    function imageloadstartHandler(evt) {
        evt.image.getImage().crossOrigin = "Anonymous";
    };

    // handler for event 'tileloadstart'
    function tileloadstartHandler(evt) {
        evt.tile.getImage().crossOrigin = "Anonymous";
    };

    // handler for event 'imageloadend'
    function imageloadendHandler(evt) {
        convertImagetoGrayScale(evt.image.getImage(), evt.target);
    };

    // handler for event 'tileloadend'
    function tileloadendHandler(evt) {
        convertImagetoGrayScale(evt.tile.getImage(), evt.target);
    };

    // abonnement/desabonnement aux evenements permettant la conversion en n/b
    var source = gpLayer.obj.getSource();
    if (toGrayScale) {
        if (source instanceof _gp.olExtended.source.ImageWMS) {
            source.loadstartListenerKey = source.on("imageloadstart", imageloadstartHandler);
            source.loadendListenerKey = source.on("imageloadend", imageloadendHandler);
        } else {
            source.loadstartListenerKey = source.on("tileloadstart", tileloadstartHandler);
            source.loadendListenerKey = source.on("tileloadend", tileloadendHandler);
        }
    } else {
        _gp.olExtended.Observable.unByKey(source.loadstartListenerKey);
        _gp.olExtended.Observable.unByKey(source.loadendListenerKey);
        source.loadstartListenerKey = null;
        source.loadendListenerKey = null;
    }

    // maj du cache
    source.refresh();
};

/**
 * Apply params common to all kind of layers :
 * opacity, visibility, minZoom, maxZoom
 *
 * @param {Gp.LayerOptions} layerOpts - options of the layer
 * @returns {Object} a ol.layer.Layer constructor options object
 *
 * @private
 */
_OlMapBase.OlMap.prototype._applyCommonLayerParams = function (layerOpts) {
    var commonOpts = {};
    // this.// logger.trace("[OlMap] : _applyCommonLayerParams ");
    if (layerOpts.hasOwnProperty("opacity")) {
        // this.// logger.trace("[OlMap] : _applyCommonLayerParams - opacity : " + layerOpts.opacity);
        commonOpts.opacity = layerOpts.opacity;
    }
    if (layerOpts.hasOwnProperty("visibility")) {
        // this.// logger.trace("[OlMap] : _applyCommonLayerParams - visibility : " + layerOpts.visibility);
        commonOpts.visible = layerOpts.visibility;
    }
    if (layerOpts.hasOwnProperty("position")) {
        // this.// logger.trace("[OlMap] : _applyCommonLayerParams - position : " + layerOpts.position);
        commonOpts.zIndex = layerOpts.position;
    }
    if (layerOpts.hasOwnProperty("maxZoom") && layerOpts.maxZoom >= 0 && layerOpts.maxZoom <= 20) {
        var minRes = this._getResolutionFromZoomLevel(layerOpts.maxZoom);
        // this.// logger.trace("[OlMap] : _applyCommonLayerParams - minRes : " + minRes);
        commonOpts.minResolution = minRes;
    }
    if (layerOpts.hasOwnProperty("minZoom") && layerOpts.minZoom >= 0 && layerOpts.minZoom <= 20) {
        var maxRes = this._getResolutionFromZoomLevel(layerOpts.minZoom);
        // this.// logger.trace("[OlMap] : _applyCommonLayerParams - maxRes : " + maxRes);
        commonOpts.maxResolution = maxRes;
    }
    if (layerOpts.hasOwnProperty("grayScaled")) {
        // this.// logger.trace("[OlMap] : _applyCommonLayerParams - grayScaled : " + layerOpts.grayScaled);
        commonOpts.grayScaled = layerOpts.grayScaled;
    }

    return commonOpts;
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _OlMapBase = __webpack_require__(1);

var _IMap = __webpack_require__(3);

var _gp = __webpack_require__(0);

/**
 * Proprietes modifiables des controles pour OL
 */
_OlMapBase.OlMap.CONTROLPROPERTIES = {
    maximised: "collapsed"

    // TODO : rajouter mapping property SDK <-> property OL au fur et à mesure de l'ajout des controles.

};

/**
 * Association controlId <-> classe OpenLayers d'implemenation
 */
_OlMapBase.OlMap.CONTROLSCLASSES = {
    draggable: [_gp.olExtended.interaction.Pointer, _gp.olExtended.interaction.MouseWheelZoom, _gp.olExtended.interaction.DoubleClickZoom],
    keyboard: [_gp.olExtended.interaction.KeyboardPan, _gp.olExtended.interaction.KeyboardZoom],
    scrollwheel: null,
    selectable: [_gp.olExtended.interaction.Select],
    zoom: _gp.olExtended.control.Zoom,
    zoombox: null,
    overview: _gp.olExtended.control.OverviewMap,
    orientation: _gp.olExtended.control.Rotate,
    graphicscale: _gp.olExtended.control.ScaleLine,
    getfeatureinfo: _gp.olExtended.control.GetFeatureInfo,
    mouseposition: _gp.olExtended.control.GeoportalMousePosition,
    route: _gp.olExtended.control.Route,
    layerswitcher: _gp.olExtended.control.LayerSwitcher,
    layerimport: _gp.olExtended.control.LayerImport,
    isocurve: _gp.olExtended.control.Isocurve,
    length: _gp.olExtended.control.MeasureLength,
    area: _gp.olExtended.control.MeasureArea,
    azimuth: _gp.olExtended.control.MeasureAzimuth,
    elevationpath: _gp.olExtended.control.ElevationPath,
    graticule: _gp.olExtended.Graticule,
    search: _gp.olExtended.control.SearchEngine,
    reversesearch: _gp.olExtended.control.ReverseGeocode,
    drawing: _gp.olExtended.control.Drawing,
    attributions: _gp.olExtended.control.GeoportalAttribution,
    camera: null
};

/**
 * Ajoute le controle de Zoom sur la carte
 *
 * @param {Object} controlOpts - options du controle
 *
 * @returns {Ol.control.Zoom} control
 */
_OlMapBase.OlMap.prototype.addZoomControl = function (controlOpts) {
    var control = new _gp.olExtended.control.Zoom({
        target: controlOpts.div
    });
    this.libMap.addControl(control);
    return control;
};

/**
 * Ajoute le controle de Zoom (Box) sur la carte
 *
 * @param {Object} controlOpts - options du controle
 *
 * @returns {Object} control
 */
_OlMapBase.OlMap.prototype.addZoomBoxControl = function (controlOpts) {
    // TODO
    return null;
};

/**
 * Adds overview map to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Array.<String>} controlOpts.layers - List of layers Ids to be displayed on the overview map (may be part of main map layersId or a geoportal WMTS layer ID). If none, all main map layers will be used.
 * @param {Number} controlOpts.minZoom - min zoom level for overview map.
 * @param {Number} controlOpts.maxZoom - max zoom level for overview map.
 * @param {String} controlOpts.projection - projection code for overview map.
 *
 * @returns {Ol.control.OverviewMap} control
 */
_OlMapBase.OlMap.prototype.addOverviewControl = function (controlOpts) {
    // this.// logger.trace("[OlMap] addOverviewControl : ... ");
    var ovOpts = {};
    if (controlOpts.div) {
        ovOpts.target = controlOpts.div;
    }
    ovOpts.collapsed = !controlOpts.maximised;
    if (controlOpts.layers && Array.isArray(controlOpts.layers)) {
        var layerObjs = this._getLayersObj(controlOpts.layers);
        var olLayers = [];
        layerObjs.forEach(function (layerObj) {
            // this.// logger.trace("[OlMap] addOverviewControl : adding " + layerObj.id + " to map");
            olLayers.push(layerObj.obj);
        }, this);
        if (olLayers.length === 0 && controlOpts.layers.length > 0) {
            // couche(s) non chargée(s) dans la carte principale :
            // on essaye de les créer comme des couches WMTS Géoportail.
            for (var i = 0; i < controlOpts.layers.length; i++) {
                // this.// logger.trace("[OlMap] addOverviewControl : adding geoportal layer : " + controlOpts.layers[i] + " to map");
                var gpLayer = new _gp.olExtended.layer.GeoportalWMTS({
                    layer: controlOpts.layers[i] /*,
                                                 // on ecrase les contraintes de zoom qui peuvent
                                                 // exister par defaut sur la couche.
                                                 olParams : {
                                                 minResolution : this._getResolutionFromZoomLevel(21),
                                                 maxResolution : this._getResolutionFromZoomLevel(1)
                                                 }
                                                 */
                });
                if (gpLayer) {
                    olLayers.push(gpLayer);
                }
            }
        }
        if (olLayers.length > 0) {
            ovOpts.layers = olLayers;
        }
    }
    var viewOpts = {};
    var needsView = false;
    if (controlOpts.hasOwnProperty("minZoom")) {
        viewOpts.minZoom = controlOpts.minZoom;
        needsView = true;
    }
    if (controlOpts.hasOwnProperty("maxZoom")) {
        viewOpts.maxZoom = controlOpts.maxZoom;
        needsView = true;
    }
    if (controlOpts.hasOwnProperty("projection")) {
        viewOpts.projection = controlOpts.projection;
        needsView = true;
    }
    if (needsView) {
        ovOpts.view = new _gp.olExtended.View(viewOpts);
    }
    var control = new _gp.olExtended.control.OverviewMap(ovOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Ajoute le controle d'orientation sur la carte
 *
 * @param {Object} controlOpts - options du controle
 *
 * @returns {Ol.control.Rotate} control
 */
_OlMapBase.OlMap.prototype.addOrientationControl = function (controlOpts) {
    var control = new _gp.olExtended.control.Rotate({
        target: controlOpts.div,
        autoHide: controlOpts.autoHide || false // ol param
    });
    this.libMap.addControl(control);
    return control;
};

/**
 * Ajoute l'echelle graphique sur la carte
 *
 * @param {Object} controlOpts - options du controle
 * @param {String} controlOpts.div - Target HTML element container or its id. Default is chosen by map implementation.
 * @param {String} controlOpts.units - Units to display : "deg" (degrees) or "m" (metric values).
 * @param {Number} controlOpts.minWidth - Minimum width in pixels. Default is 64.
 *
 * @returns {Object} control
 */
_OlMapBase.OlMap.prototype.addGraphicScaleControl = function (controlOpts) {
    var olunits = controlOpts.units;
    if (olunits && controlOpts.units.toLowerCase() === "deg") {
        olunits = "degrees";
    } else if (olunits && controlOpts.units.toLowerCase() === "m") {
        olunits = "metric";
    }
    // this.// logger.trace("[OlMap] addGraphicScaleControl : setting graphicscale units to " + olunits);
    var control = new _gp.olExtended.control.ScaleLine({
        target: controlOpts.div,
        units: olunits,
        minWidth: controlOpts.minWidth
    });
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds graticule control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String} controlOpts.strokeColor - stroke color expressed in hex format (default : #000000)
 * @param {Number} controlOpts.strokeOpacity - stroke opacity expressed between 0 and 1 (default : 0.2).
 * @param {Number} controlOpts.strokeWidth - stroke width expressed in pixels (default : 1).
 *
 * @return {Ol.Graticule} graticule
 */
_OlMapBase.OlMap.prototype.addGraticuleControl = function (controlOpts) {
    var options = controlOpts || {};
    options.strokeColor = options.strokeColor || "#000000";
    options.strokeOpacity = options.strokeOpacity || 0.2;
    options.strokeWidth = options.strokeWidth || 1;
    var rgba = _IMap.IMap.prototype._hexToRgba.call(this, options.strokeColor, options.strokeOpacity);
    var graticule = new _gp.olExtended.Graticule({
        strokeStyle: new _gp.olExtended.style.Stroke({
            color: rgba,
            width: options.strokeWidth
        })
    });
    graticule.setMap(this.libMap);
    // ajout sauvage du graticule pour pouvoir le recuperer après
    // FIXME : trouver plus elegant...
    this.libMap.graticule = graticule;
    return graticule;
};

/**
 * Adds mouse position control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Array.<Object>} controlOpts.systems - List of coordinates systems available for display.
 * @param {String} controlOpts.systems.crs - Coordinates system ID.
 * @param {String} controlOpts.systems.label - label used to designate the CRS.
 * @param {String} controlOpts.systems.type - "Geographical" or "Metric"
 * @param {Array.<String>} controlOpts.units - units used for coordinates display ("m", "km" for Metric coordinates, "dec", "dms", "rad" or "gon" for geographical coordinates).
 * @param {Boolean} controlOpts.displayAltitude - (de)activate altitude display
 * @param {Boolean} controlOpts.displayCoordinates - (de)activate planimetric coorinates display.
 * @param {Boolean} [controlOpts.editCoordinates = false] - add edit coordinates options. False by default.
 * @param {Object} [controlOpts.positionMarker] - options for position marker to use while editingCoordinates.
 * @param {String} controlOpts.positionMarker.url - Marker url
 * @param {Array} controlOpts.positionMarker.offset - Offsets in pixels used when positioning the marker towards targeted point.
 *      The first element in the array is the horizontal offset. A positive value shifts the marker right.
 *      The second element in the array is the vertical offset. A positive value shifts the marker down. [0, 0] value positions the top-left corner of the marker image to the targeted point.
 *      Default is offset associated to default marker image.
 * @param {Boolean} controlOpts.positionMarker.hide - if true, marker is not displayed, otherwise displayed (False by default.)
 * @param {Object} controlOpts.altitude - altitude interaction specific configuration. Implementation specific.
 *
 * @return {Ol.control.GeoportalMousePosition} control
 */
_OlMapBase.OlMap.prototype.addMousePositionControl = function (controlOpts) {
    var mpOpts = {};
    if (controlOpts.div) {
        mpOpts.target = controlOpts.div;
    }
    mpOpts.collapsed = !controlOpts.maximised;
    if (controlOpts.systems && Array.isArray(controlOpts.systems) && controlOpts.systems.length > 0) {
        for (var i = 0; i < controlOpts.systems.length; i++) {
            if (!_gp.olExtended.proj.get(controlOpts.systems[i].crs)) {
                // on retire les systèmes non définis
                // this.// logger.trace("[OlMap] addMousePositionControl : crs [" + controlOpts.systems[i].crs + "] not found.");
                continue;
            }
            if (!mpOpts.systems) {
                mpOpts.systems = [];
            }
            mpOpts.systems.push(controlOpts.systems[i]);
        }
    }
    if (controlOpts.units && Array.isArray(controlOpts.units) && controlOpts.units.length > 0) {
        mpOpts.units = [];
        for (var ii = 0; ii < controlOpts.units.length; ii++) {
            if (typeof controlOpts.units[ii] === "string") {
                // this.// logger.trace("[OlMap] addMousePositionControl : adding unit   [" + controlOpts.units[ii].toUpperCase());
                mpOpts.units.push(controlOpts.units[ii]);
            }
        }
    }
    mpOpts.displayAltitude = controlOpts.displayAltitude;
    mpOpts.displayCoordinates = controlOpts.displayCoordinates;
    if (controlOpts.altitude) {
        mpOpts.altitude = controlOpts.altitude;
    }
    mpOpts.editCoordinates = controlOpts.editCoordinates;
    mpOpts.positionMarker = controlOpts.positionMarker;
    var control = new _gp.olExtended.control.GeoportalMousePosition(mpOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds route control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Object} controlOpts.exclusions - exclusions to be proposed for control. Il null all exclusions will be proposed by default.
 * @param {Boolean} controlOpts.exclusions.toll - proposing toll exclusion. If true, this exclusion will be checked by default.
 * @param {Boolean} controlOpts.exclusions.bridge - proposing bridge exclusion. If true, this exclusion will be checked by default.
 * @param {Boolean} controlOpts.exclusions.tunnel - proposing tunnel exclusion. If true, this exclusion will be checked by default.
 * @param {Array.<String>} controlOpts.graphs - available graphs to be proposed by control among "Pieton" (pedestrian) and "Voiture" (car). The first element of the array will be the default proposition of the control.
 * @param {Object} controlOpts.markersOpts - options to use your own markers. Object properties can be "departure", "stages" or "arrival". Corresponding value is an object with following properties :
 * @param {String} controlOpts.markersOpts[property].url - marker base64 encoded url (ex "data:image/png;base64, ...""). Mandatory for a custom marker
 * @param {Array} controlOpts.markersOpts[property].offset - Offsets in pixels used when positioning the overlay. The first element in the array is the horizontal offset. A positive value shifts the overlay right. The second element in the array is the vertical offset. A positive value shifts the overlay down. Default is [0, 0]. (see http://openlayers.org/en/latest/apidoc/ol.Overlay.html)
 * @param {Object} controlOpts.routeOptions - route service options. For advanced use only. See {@link http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~route Gp.Services.route()} to know all route options.
 * @param {Object} controlOpts.autocompleteOptions - autocomplete service options. See {@link http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~autoComplete Gp.Services.autoComplete()} to know all autocomplete options.
 *
 * @return {Ol.control.Route} control
 */
_OlMapBase.OlMap.prototype.addRouteControl = function (controlOpts) {
    var rteOpts = {};
    if (controlOpts.div) {
        rteOpts.target = controlOpts.div;
    }
    rteOpts.collapsed = !controlOpts.maximised;
    if (controlOpts.graphs) {
        rteOpts.graphs = controlOpts.graphs;
    }
    if (controlOpts.exclusions) {
        rteOpts.exclusions = controlOpts.exclusions;
    }
    if (controlOpts.markersOpts) {
        rteOpts.markersOpts = {};
        if (controlOpts.markersOpts.departure) {
            rteOpts.markersOpts.departure = controlOpts.markersOpts.departure;
        }
        if (controlOpts.markersOpts.stages) {
            rteOpts.markersOpts.stages = controlOpts.markersOpts.stages;
        }
        if (controlOpts.markersOpts.arrival) {
            rteOpts.markersOpts.arrival = controlOpts.markersOpts.arrival;
        }
    }
    if (controlOpts.routeOptions) {
        rteOpts.routeOptions = controlOpts.routeOptions;
    }
    if (controlOpts.autocompleteOptions) {
        rteOpts.autocompleteOptions = controlOpts.autocompleteOptions;
    }
    var control = new _gp.olExtended.control.Route(rteOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds isocurve control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Object} controlOpts.exclusions - exclusions to be proposed for control. Il null all exclusions will be proposed by default.
 * @param {Boolean} controlOpts.exclusions.toll - proposing toll exclusion. If true, this exclusion will be checked by default.
 * @param {Boolean} controlOpts.exclusions.bridge - proposing bridge exclusion. If true, this exclusion will be checked by default.
 * @param {Boolean} controlOpts.exclusions.tunnel - proposing tunnel exclusion. If true, this exclusion will be checked by default.
 * @param {Array.<String>} controlOpts.graphs - available graphs to be proposed by control among "Pieton" (pedestrian) and "Voiture" (car). The first element of the array will be the default proposition of the control.
 * @param {Array.<String>} controlOpts.methods - available methods of computation to be proposed by control among "time" (isochron) and "distance" (isodistance). The first element of the array will be the default proposition of the control.
 * @param {Array.<String>} controlOpts.directions - available directions to be proposed by control among "arrival" (isocurve to arrival point) and "departure" (isocruve from departure point). The first element of the array will be the default proposition of the control.
 * @param {Object} controlOpts.markerOpts - options to use your own marker. Default is a lightOrange marker.
 * @param {String} controlOpts.markerOpts.url - marker base64 encoded url (ex "data:image/png;base64, ...""). Mandatory for a custom marker
 * @param {Array} controlOpts.markerOpts.offset - Offsets in pixels used when positioning the overlay. The first element in the array is the horizontal offset. A positive value shifts the overlay right. The second element in the array is the vertical offset. A positive value shifts the overlay down. Default is [0, 0]. (see http://openlayers.org/en/latest/apidoc/ol.Overlay.html)
 * @param {Object} controlOpts.isocurveOptions - isocurve service options. For advanced use only. See {@link http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~isocurve Gp.Services.isocurve()} to know all isocurve options.
 * @param {Object} controlOpts.autocompleteOptions - autocomplete service options. See {@link http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~autoComplete Gp.Services.autoComplete()} to know all autocomplete options.
 *
 * @return {Ol.control.Isocurve} control
 */
_OlMapBase.OlMap.prototype.addIsocurveControl = function (controlOpts) {
    var isoOpts = {};
    if (controlOpts.div) {
        isoOpts.target = controlOpts.div;
    }
    isoOpts.collapsed = !controlOpts.maximised;
    if (controlOpts.graphs) {
        isoOpts.graphs = controlOpts.graphs;
    }
    if (controlOpts.exclusions) {
        isoOpts.exclusions = controlOpts.exclusions;
    }
    if (controlOpts.methods) {
        isoOpts.methods = controlOpts.methods;
    }
    if (controlOpts.directions) {
        isoOpts.directions = controlOpts.directions;
    }
    if (controlOpts.markerOpts) {
        isoOpts.markerOpts = controlOpts.markerOpts;
    }
    if (controlOpts.isocurveOptions) {
        isoOpts.isocurveOptions = controlOpts.isocurveOptions;
    }
    if (controlOpts.autocompleteOptions) {
        isoOpts.autocompleteOptions = controlOpts.autocompleteOptions;
    }
    var control = new _gp.olExtended.control.Isocurve(isoOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds layer import control to the map
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Array} controlOpts.layerTypes - data types that could be imported : "KML", "GPX", "GeoJSON", "WMS" and "WMTS". Values will be displayed in the same order in widget list. Default is : ["KML", "GPX", "GeoJSON", "WMS", "WMTS"]
 * @param {Object} controlOpts.webServicesOptions - Options to import WMS or WMTS layers
 * @param {String} controlOpts.webServicesOptions.proxyUrl - Proxy URL to avoid cross-domain problems, if not already set in mapOptions. Mandatory to import WMS and WMTS layer.
 * @param {Array.<String>} [controlOpts.webServicesOptions.noProxyDomains] - Proxy will not be used for this list of domain names. Only use if you know what you're doing (if not already set in mapOptions)
 * @param {Object} [controlOpts.defaultStyles] - Styles to apply by default to imported KML or GPX layers
 * @param {Object} [controlOpts.defaultStyles.KML] - Styles to apply by default to imported KML layers
 * @param {String} [controlOpts.defaultStyles.KML.markerSrc] - URL of a marker image (for KML points styling). Default is an orange marker.
 * @param {Float} [controlOpts.defaultStyles.KML.markerXAnchor = 25.5] - position of marker anchor in X from left of the image expressed in proportion of 1 (for KML points styling).
 * @param {Float} [controlOpts.defaultStyles.KML.markerYAnchor = 38] - position of marker anchor in Y from top of the image expressed in proportion of 1 (for KML points styling).
 * @param {String} [controlOpts.defaultStyles.KML.strokeColor = "#002A50"] - Stroke color for KML lines styling (RGB hex value).
 * @param {Number} [controlOpts.defaultStyles.KML.strokeWidth = 4] - Stroke width in pixels for KML lines styling.
 * @param {Number} [controlOpts.defaultStyles.KML.strokeOpacity = 0.8] - Stroke opacity for KML lines styling (alpha value between 0:transparent and 1:opaque)
 * @param {String} [controlOpts.defaultStyles.KML.polyFillColor = "#00B798"] - KML polygons fill color (RGB hex value).
 * @param {Number} [controlOpts.defaultStyles.KML.polyFillOpacity = 0.5] - KML polygons fill opacity (alpha value between 0:transparent and 1:opaque).
 * @param {Object} [controlOpts.defaultStyles.GPX] - Styles to apply by default to imported GPX layers
 * @param {String} [controlOpts.defaultStyles.GPX.markerSrc] - URL of a marker image (for GPX waypoints styling). Default is an orange marker.
 * @param {Float} [controlOpts.defaultStyles.GPX.markerXAnchor = 25.5] - position of marker anchor in X from left of the image expressed in proportion of 1 (for GPX waypoints styling).
 * @param {Float} [controlOpts.defaultStyles.GPX.markerYAnchor = 38] - position of marker anchor in Y from top of the image expressed in proportion of 1 (for GPX waypoints styling).
 * @param {String} [controlOpts.defaultStyles.GPX.strokeColor = "#002A50"] - Stroke color for GPX routes or tracks styling (RGB hex value).
 * @param {Number} [controlOpts.defaultStyles.GPX.strokeWidth = 4] - Stroke width in pixels for GPX routes or tracks styling.
 * @param {Number} [controlOpts.defaultStyles.GPX.strokeOpacity = 0.8] - Stroke opacity for GPX routes or tracks styling (alpha value between 0:transparent and 1:opaque)
 * @param {Object} [controlOpts.defaultStyles.GeoJSON] - Styles to apply by default to imported GeoJSON layers
 * @param {String} [controlOpts.defaultStyles.GeoJSON.markerSrc] - URL of a marker image (for GeoJSON points styling). Default is an orange marker.
 * @param {Float} [controlOpts.defaultStyles.GeoJSON.markerXAnchor = 25.5] - position of marker anchor in X from left of the image expressed in proportion of 1 (for GeoJSON points styling).
 * @param {Float} [controlOpts.defaultStyles.GeoJSON.markerYAnchor = 38] - position of marker anchor in Y from top of the image expressed in proportion of 1 (for GeoJSON points styling).
 * @param {String} [controlOpts.defaultStyles.GeoJSON.strokeColor = "#002A50"] - Stroke color for GeoJSON lines styling (RGB hex value).
 * @param {Number} [controlOpts.defaultStyles.GeoJSON.strokeWidth = 4] - Stroke width in pixels for GeoJSON lines styling.
 * @param {Number} [controlOpts.defaultStyles.GeoJSON.strokeOpacity = 0.8] - Stroke opacity for GeoJSON lines styling (alpha value between 0:transparent and 1:opaque)
 * @param {String} [controlOpts.defaultStyles.GeoJSON.polyFillColor = "#00B798"] - GeoJSON polygons fill color (RGB hex value).
 * @param {Number} [controlOpts.defaultStyles.GeoJSON.polyFillOpacity = 0.5] - GeoJSON polygons fill opacity (alpha value between 0:transparent and 1:opaque).
 *
 * @return {Ol.control.LayerImport} control
 */
_OlMapBase.OlMap.prototype.addLayerImportControl = function (controlOpts) {
    var importOpts = {};
    if (controlOpts.div) {
        importOpts.target = controlOpts.div;
    }
    importOpts.collapsed = !controlOpts.maximised;
    if (controlOpts.layerTypes) {
        importOpts.layerTypes = controlOpts.layerTypes;
    }
    importOpts.webServicesOptions = {};
    if (controlOpts.webServicesOptions) {
        importOpts.webServicesOptions = controlOpts.webServicesOptions;
    } else {
        if (this.mapOptions && this.mapOptions.proxyUrl) {
            importOpts.webServicesOptions.proxyUrl = this.mapOptions.proxyUrl;
        }
        if (this.mapOptions && this.mapOptions.noProxyDomains) {
            importOpts.webServicesOptions.noProxyDomains = this.mapOptions.noProxyDomains;
        }
    }
    if (controlOpts.defaultStyles) {
        importOpts.vectorStyleOptions = {};
        var defaultMarkerSrc = "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAADMAAAAmCAYAAABpuqMCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARDSURBVFiF3ZndaxxVGMZ/Z/YjX00Nadpo1qrFBgu56D9QbAtiLoRC7ywSNK1NURRREBKRFlSwFBW0gnSrJXY1CmISgyjFiyYSFC9ajE3MmpjdjWlMUtNos9lN9mteLzbRuCbZmTMTBB+Yi51znvd5n3nPnjnnjBIR/i/wuh4xpCpI0ojiENAA1AE1wCzwKzCE0EM5l2iShJvSyrXKnFVb8dOK4hmg3AIjifAmaU7ztMy7kYI7Zs6rQwjvka+AXcyiOMZx6XGahuE0AEHVitCFnhGAGoQugqrVaSrOKpNP4FWnSaxCGy1yWpesbyY/tLpwo7p/w0RxWHfI6Zk5q7ZSwhj6Q2sjzJLiXp1JQe+p+mllc4wA1CzHtw37lQmpCha5gbXpVxdJythh9z1kvzJJGrFixPBmOXixl+Z4mONmguZ4mIMXezG8WQsq5cs6tmDfTP7NXiSqN0vTzBD1TQfwbdmDUhX4tuyhvukATTNDlgxZ0SmUtUsgv0TZGPsv9FNSvXfNtpLqvey/0O+KTgF0zNQV7XHP4dsdtVvVKYCOmeqiPbwVOx21W9UpgI6ZWNEe2cSEo3arOgWwb0YYLp5G17Sjdqs6BdCZzYqL9B3dR2puYM221NwAfUf3uaJTAB0zaye5GmbWS6i2gdFQL5mFMCIJMgthRkO9hGobMLPFN4VWdAoptlcAQeUDRoG77YrZwDhQT4tk7JDsV6ZFMggv2+bZwyt2jYDuQnOa94GIFrc4IkzRrkPUM3NKsijatLjF0copsbJ++xec7TTPqw6EI/oB/glT+PC+13Y/aSQNv/Is+tNer09lMn7DMHwAYppp8fvTIpISkVQsFrslqww4M9OuqkgzANzl1MhCyrjZGAycm573pK1yFCyi5FoWvo/FYlPOT2fOqftRXMbB9lkEs+3zbe2f/FD5i3YMj2p3vn8/IV8DZ5yE+Gqkot+JEQCPada5dRhxEriiQ5ya90w+272916F+KpnJDLhjpkUy5HgESNqhZU2Vfr5ne+dSFtOBeso06J6cnEy6d0z0hPwEPGeH8sGVykvfjpfe1NZUci2+mHg7Go2G8z/d/goQVJ9B8S1veMYffujduo/thl+ZwUzDuBqJRGZWt7n/FcDH46lFNVLilar1uiTTxsJTnTssH/QpJVlMNQa5wbGJiWERya3Vz30zzfLb3OveY3dU5j5dp4e80Xdbd3TOu/H/yyAtpjnqgeGS8crRQRks+v5xf5gtY/KM/6NAVebhwvv90bLvHu2o/XId2pJSMmIaxo/RaHRMxN6yZtPM0K5K/7hl/FxVZgZWbs0mPDceeKcuGE95/kpSKUmaImHDNIfHrl+PiIj2zOb+MFvBY7IUOVl2ZG9g6bJH4ckJuRe/2NYZT3myKIkrGM4pNRyLjY+LW09URDb1+uaF0pfm3zJ+7zhRGdq1c9eDuwOBOzdLa/OG2X+APwE8DU64Y/5gfAAAAABJRU5ErkJggg==";
        var strokeOpacity;
        var strokeColor;
        var fillOpacity;
        var fillColor;
        if (controlOpts.defaultStyles.KML) {
            var userKMLDefaultStyles = controlOpts.defaultStyles.KML;
            var kmldefaultStyleOptions = {};
            kmldefaultStyleOptions.image = new _gp.olExtended.style.Icon({
                src: userKMLDefaultStyles.markerSrc || defaultMarkerSrc,
                anchor: [userKMLDefaultStyles.markerXAnchor || 25.5, userKMLDefaultStyles.markerYAnchor || 38],
                anchorOrigin: "top-left",
                anchorXUnits: "pixels",
                anchorYUnits: "pixels"
            });
            strokeOpacity = userKMLDefaultStyles.strokeOpacity || 0.8;
            strokeColor = userKMLDefaultStyles.strokeColor || "#002A50";
            kmldefaultStyleOptions.stroke = new _gp.olExtended.style.Stroke({
                color: _IMap.IMap.prototype._hexToRgba.call(this, strokeColor, strokeOpacity),
                width: userKMLDefaultStyles.strokeWidth || 4
            });
            fillOpacity = userKMLDefaultStyles.polyFillOpacity || 0.5;
            fillColor = userKMLDefaultStyles.polyFillColor || "#00B798";
            kmldefaultStyleOptions.fill = new _gp.olExtended.style.Fill({
                color: _IMap.IMap.prototype._hexToRgba.call(this, fillColor, fillOpacity)
            });
            var kmldefaultStyle = new _gp.olExtended.style.Style(kmldefaultStyleOptions);
            importOpts.vectorStyleOptions.KML = {
                defaultStyle: kmldefaultStyle
            };
        }
        if (controlOpts.defaultStyles.GPX) {
            var userGPXDefaultStyles = controlOpts.defaultStyles.GPX;
            var gpxdefaultStyleOptions = {};
            gpxdefaultStyleOptions.image = new _gp.olExtended.style.Icon({
                src: userGPXDefaultStyles.markerSrc || defaultMarkerSrc,
                anchor: [userGPXDefaultStyles.markerXAnchor || 25.5, userGPXDefaultStyles.markerYAnchor || 38],
                anchorOrigin: "top-left",
                anchorXUnits: "pixels",
                anchorYUnits: "pixels"
            });
            strokeOpacity = userGPXDefaultStyles.strokeOpacity || 0.8;
            strokeColor = userGPXDefaultStyles.strokeColor || "#002A50";
            gpxdefaultStyleOptions.stroke = new _gp.olExtended.style.Stroke({
                color: _IMap.IMap.prototype._hexToRgba.call(this, strokeColor, strokeOpacity),
                width: userGPXDefaultStyles.strokeWidth || 4
            });
            var gpxdefaultStyle = new _gp.olExtended.style.Style(gpxdefaultStyleOptions);
            importOpts.vectorStyleOptions.GPX = {
                defaultStyle: gpxdefaultStyle
            };
        }
        if (controlOpts.defaultStyles.GeoJSON) {
            var userGeoJSONDefaultStyles = controlOpts.defaultStyles.GeoJSON;
            var geoJSONdefaultStyleOptions = {};
            geoJSONdefaultStyleOptions.image = new _gp.olExtended.style.Icon({
                src: userGeoJSONDefaultStyles.markerSrc || defaultMarkerSrc,
                anchor: [userGeoJSONDefaultStyles.markerXAnchor || 25.5, userGeoJSONDefaultStyles.markerYAnchor || 38],
                anchorOrigin: "top-left",
                anchorXUnits: "pixels",
                anchorYUnits: "pixels"
            });
            strokeOpacity = userGeoJSONDefaultStyles.strokeOpacity || 0.8;
            strokeColor = userGeoJSONDefaultStyles.strokeColor || "#002A50";
            geoJSONdefaultStyleOptions.stroke = new _gp.olExtended.style.Stroke({
                color: _IMap.IMap.prototype._hexToRgba.call(this, strokeColor, strokeOpacity),
                width: userGeoJSONDefaultStyles.strokeWidth || 4
            });
            fillOpacity = userGeoJSONDefaultStyles.polyFillOpacity || 0.5;
            fillColor = userGeoJSONDefaultStyles.polyFillColor || "#00B798";
            geoJSONdefaultStyleOptions.fill = new _gp.olExtended.style.Fill({
                color: _IMap.IMap.prototype._hexToRgba.call(this, strokeColor, strokeOpacity)
            });
            var geoJSONdefaultStyle = new _gp.olExtended.style.Style(geoJSONdefaultStyleOptions);
            importOpts.vectorStyleOptions.GeoJSON = {
                defaultStyle: geoJSONdefaultStyle
            };
        }
    }
    var control = new _gp.olExtended.control.LayerImport(importOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds LayerSwitcher control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 *
 * @return {Ol.control.LayerSwitcher} control
 */
_OlMapBase.OlMap.prototype.addLayerSwitcherControl = function (controlOpts) {
    // this.// logger.trace("[OlMap] : addLayerSwitcherControl ... ");
    // TODO : parametrage des couches
    var lsOpts = {
        layers: [],
        options: {
            collapsed: !(controlOpts && controlOpts.maximised)
        }
    };
    if (controlOpts.div) {
        lsOpts.options.target = controlOpts.div;
    }
    // application des configuration des couches :
    for (var i = 0; i < this._layers.length; i++) {
        var layer = this._layers[i];
        // this.// logger.trace("[OlMap] : layerSwitcher : configuring layer : " + layer.id);
        // INFO : les couches Geoportail sont aussi configurées.
        var layerConf = {
            layer: layer.obj,
            config: {}
        };
        if (layer.options.title) {
            // this.// logger.trace("[OlMap] : layerSwitcher : setting title to [" + layer.options.title + "] for layer " + layer.id);
            layerConf.config.title = layer.options.title;
        }
        if (layer.options.description) {
            // this.// logger.trace("[OlMap] : layerSwitcher : setting description to [" + layer.options.description + "] for layer " + layer.id);
            layerConf.config.description = layer.options.description;
        }
        if (layer.options.quicklookUrl) {
            // this.// logger.trace("[OlMap] : layerSwitcher : setting quicklookUrl to [" + layer.options.quicklookUrl + "] for layer " + layer.id);
            layerConf.config.quicklookUrl = layer.options.quicklookUrl;
        }
        if (layer.options.legends) {
            // this.// logger.trace("[OlMap] : layerSwitcher : setting legends to [" + layer.options.legends + "] for layer " + layer.id);
            layerConf.config.legends = layer.options.legends;
        }
        if (layer.options.metadata) {
            // this.// logger.trace("[OlMap] : layerSwitcher : setting metadata to [" + layer.options.metadata + "] for layer " + layer.id);
            layerConf.config.metadata = this._filterEmptyMetadata(layer.options.metadata);
        }
        lsOpts.layers.push(layerConf);
    }

    // this.// logger.trace("[OlMap] : layerSwitcher Opts : ... ");
    var control = new _gp.olExtended.control.LayerSwitcher(lsOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds measure length tool bar control to the map.
 *
 * @param {Object} controlOpts - options du controle
 *
 * @return {Ol.control.MeasureLength} control
 */
_OlMapBase.OlMap.prototype.addLengthControl = function (controlOpts) {
    var lengthOpts = {};
    if (controlOpts.div) {
        lengthOpts.target = controlOpts.div;
    }

    // styles
    if (controlOpts.hasOwnProperty("styles")) {
        lengthOpts.styles = {};
        // pointer style creation
        if (controlOpts.styles.hasOwnProperty("pointer")) {
            lengthOpts.styles.pointer = this._fillPointerStyles(controlOpts.styles.pointer);
        }
        // drawStart style creation
        if (controlOpts.styles.hasOwnProperty("start")) {
            var startOpts = {};
            startOpts.stroke = this._fillStrokeStyles(controlOpts.styles.start);
            if (controlOpts.styles.start.hasOwnProperty("fillColor")) {
                startOpts.fill = new _gp.olExtended.style.Fill({
                    color: controlOpts.styles.start.fillColor
                });
            }
            lengthOpts.styles.start = new _gp.olExtended.style.Style(startOpts);
        }
        // drawEnd style creation
        if (controlOpts.styles.hasOwnProperty("finish")) {
            var finishOpts = {};
            finishOpts.stroke = this._fillStrokeStyles(controlOpts.styles.finish);
            if (controlOpts.styles.finish.hasOwnProperty("fillColor")) {
                finishOpts.fill = new _gp.olExtended.style.Fill({
                    color: controlOpts.styles.finish.fillColor
                });
            }
            lengthOpts.styles.finish = new _gp.olExtended.style.Style(finishOpts);
        }
    }
    // geodesic
    if (controlOpts.hasOwnProperty("geodesic")) {
        lengthOpts.geodesic = controlOpts.geodesic;
    }

    var control = new _gp.olExtended.control.MeasureLength(lengthOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds measure area tool bar control to the map.
 *
 * @param {Object} controlOpts - options du controle
 *
 * @return {Ol.control.MeasureArea} control
 */
_OlMapBase.OlMap.prototype.addAreaControl = function (controlOpts) {
    // this.// logger.trace("[OlMap] addAreaControl : ... ");
    var areaOpts = {};
    if (controlOpts.div) {
        areaOpts.target = controlOpts.div;
    }

    // styles
    if (controlOpts.hasOwnProperty("styles")) {
        areaOpts.styles = {};
        // pointer style creation
        if (controlOpts.styles.hasOwnProperty("pointer")) {
            areaOpts.styles.pointer = this._fillPointerStyles(controlOpts.styles.pointer);
        }
        // drawStart style creation
        if (controlOpts.styles.hasOwnProperty("start")) {
            var startOpts = {};
            startOpts.stroke = this._fillStrokeStyles(controlOpts.styles.start);
            if (controlOpts.styles.start.hasOwnProperty("fillColor")) {
                startOpts.fill = new _gp.olExtended.style.Fill({
                    color: controlOpts.styles.start.fillColor
                });
            }
            areaOpts.styles.start = new _gp.olExtended.style.Style(startOpts);
        }
        // drawEnd style creation
        if (controlOpts.styles.hasOwnProperty("finish")) {
            var finishOpts = {};
            finishOpts.stroke = this._fillStrokeStyles(controlOpts.styles.finish);
            if (controlOpts.styles.finish.hasOwnProperty("fillColor")) {
                finishOpts.fill = new _gp.olExtended.style.Fill({
                    color: controlOpts.styles.finish.fillColor
                });
            }
            areaOpts.styles.finish = new _gp.olExtended.style.Style(finishOpts);
        }
    }

    // geodesic
    if (controlOpts.hasOwnProperty("geodesic")) {
        areaOpts.geodesic = controlOpts.geodesic;
    }

    var control = new _gp.olExtended.control.MeasureArea(areaOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds measure azimuth tool bar control to the map.
 *
 * @param {Object} controlOpts - options du controle
 *
 * @return {Ol.control.MeasureAzimuth} control
 */
_OlMapBase.OlMap.prototype.addAzimuthControl = function (controlOpts) {
    var azimuthOpts = {};
    if (controlOpts.div) {
        azimuthOpts.target = controlOpts.div;
    }

    // styles
    if (controlOpts.hasOwnProperty("styles")) {
        azimuthOpts.styles = {};
        // pointer style creation
        if (controlOpts.styles.hasOwnProperty("pointer")) {
            azimuthOpts.styles.pointer = this._fillPointerStyles(controlOpts.styles.pointer);
        }
        // drawStart style creation
        if (controlOpts.styles.hasOwnProperty("start")) {
            var startOpts = {};
            startOpts.stroke = this._fillStrokeStyles(controlOpts.styles.start);
            if (controlOpts.styles.start.hasOwnProperty("fillColor")) {
                startOpts.fill = new _gp.olExtended.style.Fill({
                    color: controlOpts.styles.start.fillColor
                });
            }
            azimuthOpts.styles.start = new _gp.olExtended.style.Style(startOpts);
        }
        // drawEnd style creation
        if (controlOpts.styles.hasOwnProperty("finish")) {
            var finishOpts = {};
            finishOpts.stroke = this._fillStrokeStyles(controlOpts.styles.finish);
            if (controlOpts.styles.finish.hasOwnProperty("fillColor")) {
                finishOpts.fill = new _gp.olExtended.style.Fill({
                    color: controlOpts.styles.finish.fillColor
                });
            }
            azimuthOpts.styles.finish = new _gp.olExtended.style.Style(finishOpts);
        }
    }

    // geodesic
    if (controlOpts.hasOwnProperty("geodesic")) {
        azimuthOpts.geodesic = controlOpts.geodesic;
    }

    var control = new _gp.olExtended.control.MeasureAzimuth(azimuthOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Ajoute l'outil de profil alti sur la carte
 *
 * | property | Type | Description |
 * | - | - | - |
 * | div | String / DOMElement | Target HTML element container or its id. Default is chosen by map implementation.
 * | styles | Object | Styles to use to display the polygon area |
 * | styles.pointer | Object | Pointer (circle) style while measuring |
 * | styles.pointer.strokeColor | String | Stroke color |
 * | styles.pointer.strokeWidth | Number | Stroke width in pixels |
 * | styles.pointer.radius | Number | Circle radius in pixels |
 * | styles.pointer.fillColor | String | Circle fill color |
 * | styles.start | Object | Styles to use to display the polygon area while measuring |
 * | styles.start.strokeColor | String | Stroke color |
 * | styles.start.strokeWidth | Number | Stroke width in pixels |
 * | styles.start.strokeLineDash | Array(Number) | Line dash pattern : line and spaces widths |
 * | styles.start.fillColor | String | Polygon fill color |
 * | styles.finish | Object | Styles to use to display the polygon area when measure is finished |
 * | styles.finish.strokeColor | String | Stroke color |
 * | styles.finish.strokeWidth | Number | Stroke width in pixels |
 * | styles.finish.strokeLineDash | Array(Number) | Line dash pattern : line and spaces widths |
 * | styles.finish.fillColor | String | Polygon fill color |
 * | styles.marker | Object | Style for marker displayed on map when the user follows the elevation path.  |
 * | styles.marker.src | String | URL of a marker image. |
 * | styles.marker.xAnchor | Float | position of marker anchor in X from left of the image expressed in proportion of 1. |
 * | styles.marker.yAnchor | Float | position of marker anchor in Y from top of the image expressed in proportion of 1. |
 * | elevationPathOptions | Object | elevation path service options. See [Gp.Services.getAltitude()](http://ignf.github.io/geoportal-access-lib/latest/jsdoc/module-Services.html#~getAltitude) for available options |
 * | displayProfileOptions | Object | Options for displaying the profile |
 * | displayProfileOptions.apply | Function | function to display profile if you want to cutomise it. By default, built-in [DISPLAY_PROFILE_BY_DEFAULT()](http://ignf.github.io/geoportal-extensions/openlayers-latest/jsdoc/ol.control.ElevationPath.html#.DISPLAY_PROFILE_BY_DEFAULT) is used. You may also provide your own function using the same signature. |
 * | displayProfileOptions.target | Object | DOM container to use to display the profile. |
 *
 * @param {Object} controlOpts - options du controle
 *
 * @return {Ol.control.ElevationPath} control
 */
_OlMapBase.OlMap.prototype.addElevationPathControl = function (controlOpts) {
    var elevOpts = {};
    // this.// logger.trace("[OlMap] addElevationPathControl : ... ");
    if (controlOpts.div) {
        elevOpts.target = controlOpts.div;
    }
    // styles
    if (controlOpts.styles) {
        elevOpts.stylesOptions = {};
        // pointer style creation
        if (controlOpts.styles.hasOwnProperty("pointer")) {
            elevOpts.stylesOptions.draw = {};
            elevOpts.stylesOptions.draw.pointer = this._fillPointerStyles(controlOpts.styles.pointer);
        }
        // drawStart style creation
        if (controlOpts.styles.hasOwnProperty("start")) {
            if (!elevOpts.stylesOptions.draw) {
                elevOpts.stylesOptions.draw = {};
            }
            elevOpts.stylesOptions.draw.start = this._fillStrokeStyles(controlOpts.styles.start);
        }
        // drawEnd style creation
        if (controlOpts.styles.hasOwnProperty("finish")) {
            if (!elevOpts.stylesOptions.draw) {
                elevOpts.stylesOptions.draw = {};
            }
            elevOpts.stylesOptions.draw.finish = this._fillStrokeStyles(controlOpts.styles.finish);
        }
        // marker style creation
        if (controlOpts.styles.hasOwnProperty("marker")) {
            var markerOpts = {};
            if (controlOpts.styles.marker.src) {
                // on ne cree le marker que si une image source a été fournie
                markerOpts.src = controlOpts.styles.marker.src;
                markerOpts.anchor = [controlOpts.styles.marker.xAnchor ? controlOpts.styles.marker.xAnchor : 0, controlOpts.styles.marker.yAnchor ? controlOpts.styles.marker.yAnchor : 0];
            }
            if (Object.keys(markerOpts).length > 0) {
                elevOpts.stylesOptions.marker = new _gp.olExtended.style.Icon(markerOpts);
            }
        }
    }
    // elevationPathOptions
    if (controlOpts.elevationPathOptions) {
        elevOpts.elevationPathOptions = controlOpts.elevationPathOptions;
    }
    // displayProfileOptions
    if (controlOpts.displayProfileOptions) {
        elevOpts.displayProfileOptions = controlOpts.displayProfileOptions;
    }
    var control = new _gp.olExtended.control.ElevationPath(elevOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds search control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Object} controlOpts.resources - resources to be used by geocode and autocompletion services
 * @param {Array.<String>} controlOpts.resources.geocode - resources geocoding, by default : ["PositionOfInterest", "StreetAddress"]
 * @param {Array.<String>} controlOpts.resources.autocomplete - resources autocompletion, by default : ["PositionOfInterest", "StreetAddress"]
 * @param {Boolean} [controlOpts.displayAdvancedSearch = false] - True to display advanced search tools. Default is false (not displayed)
 * @param {Object} controlOpts.advancedSearch - advanced search options for geocoding (filters). Properties can be found among geocode options.filterOptions (see http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~geocode)
 * @param {Object} [controlOpts.geocodeOptions = {}] - options of geocode service (see http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~geocode)
 * @param {Object} [controlOpts.autocompleteOptions = {}] - options of autocomplete service (see http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~autoComplete)
 *
 * @return {Ol.control.SearchEngine} control
 */
_OlMapBase.OlMap.prototype.addSearchControl = function (controlOpts) {
    var searchOpts = {};
    if (searchOpts.div) {
        searchOpts.target = controlOpts.div;
    }
    searchOpts.collapsed = !controlOpts.maximised;

    // zoomTo
    searchOpts.zoomTo = controlOpts.zoomTo || null;

    // resources
    if (controlOpts.hasOwnProperty("resources")) {
        searchOpts.resources = {};
        if (controlOpts.resources.hasOwnProperty("geocode")) {
            searchOpts.resources.geocode = controlOpts.resources.geocode;
        }
        if (controlOpts.resources.hasOwnProperty("autocomplete")) {
            searchOpts.resources.autocomplete = controlOpts.resources.autocomplete;
        }
    }
    // advancedSearch
    searchOpts.displayAdvancedSearch = controlOpts.hasOwnProperty("displayAdvancedSearch") && controlOpts.displayAdvancedSearch;
    if (controlOpts.hasOwnProperty("advancedSearch")) {
        searchOpts.advancedSearch = controlOpts.advancedSearch;
    }
    if (controlOpts.hasOwnProperty("geocodeOptions")) {
        searchOpts.geocodeOptions = controlOpts.geocodeOptions;
    }
    if (controlOpts.hasOwnProperty("autocompleteOptions")) {
        searchOpts.autocompleteOptions = controlOpts.autocompleteOptions;
    }
    var control = new _gp.olExtended.control.SearchEngine(searchOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds reverse search control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {Array.<String>} controlOpts.resources - resources geocoding, by default : ["PositionOfInterest", "StreetAddress"]
 * @param {Array.<String>} controlOpts.delimitations - delimitations for reverse geocoding, by default : ["Point", "Circle", "Extent"]. Possible values are : "Point", "Circle", "Extent". Delimitations will be displayed in the same order in widget list.
 * @param {Object} [controlOpts.reverseGeocodeOptions = {}] - reverse geocode service options. see http://depot.ign.fr/geoportail/bibacces/develop/doc/module-Services.html#~reverseGeocode to know all reverse geocode options.
 *
 * @return {Ol.control.ReverseGeocode} control
 */
_OlMapBase.OlMap.prototype.addReverseSearchControl = function (controlOpts) {
    var searchOpts = {};
    if (searchOpts.div) {
        searchOpts.target = controlOpts.div;
    }
    searchOpts.collapsed = !controlOpts.maximised;
    // resources
    if (controlOpts.hasOwnProperty("resources")) {
        searchOpts.resources = controlOpts.resources;
    }
    if (controlOpts.hasOwnProperty("reverseGeocodeOptions")) {
        searchOpts.reverseGeocodeOptions = controlOpts.reverseGeocodeOptions;
    }
    if (controlOpts.hasOwnProperty("delimitations")) {
        searchOpts.delimitations = controlOpts.delimitations;
    }
    var control = new _gp.olExtended.control.ReverseGeocode(searchOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Adds drawing tool bar control to the map.
 *
 * @param {Object} controlOpts - control options
 * @param {String|Element} controlOpts.div - target HTML element container. Default is chosen by implementation.
 * @param {Boolean} controlOpts.maximised - if the control has to be opened or not.
 * @param {String} controlOpts.layer - layerId to be used by drawing tool. If none, an empty layer will be created, with id : "drawing-xxx".
 * @param {Object} controlOpts.tools - tools to be proposed by drawing tools box. All tools will be proposed by default.
 * @param {Boolean} [controlOpts.tools.points = true] - Display points drawing tool
 * @param {Boolean} [controlOpts.tools.lines = true] - Display lines drawing tool
 * @param {Boolean} [controlOpts.tools.polygons = true] - Display polygons drawing tool
 * @param {Boolean} [controlOpts.tools.text = true] - Display text drawing tool
 * @param {Boolean} [controlOpts.tools.remove = true] - Display feature removing tool
 * @param {Boolean} [controlOpts.tools.display = true] - Display style editing tool
 * @param {Boolean} [controlOpts.tools.edit = true] - Display editing tool
 * @param {Boolean} [controlOpts.tools.export = true] - Display exporting tool
 * @param {Object} controlOpts.labels - labels to be used instead of defaults for drawing tools.
 * @param {String} [controlOpts.labels.control] - Label for Control
 * @param {String} [controlOpts.labels.points] - Label for points drawing tool
 * @param {String} [controlOpts.labels.lines] - Label for lines drawing tool
 * @param {String} [controlOpts.labels.polygons] - Label for polygons drawing tool
 * @param {String} [controlOpts.labels.text] - Label for text drawing tool
 * @param {String} [controlOpts.labels.edit] - Label for editing tool
 * @param {String} [controlOpts.labels.display] - Label for style editing tool
 * @param {String} [controlOpts.labels.remove] - Label for feature removing tool
 * @param {String} [controlOpts.labels.export] - Label for exporting tool.
 * @param {String} [controlOpts.labels.exportTitle] - Title for exporting tool.
 * @param {String} [controlOpts.labels.applyToObject] - Label for apply to abject button.
 * @param {String} [controlOpts.labels.setAsDefault] - Label for set as default style button.
 * @param {String} [controlOpts.labels.strokeColor] - Label for stroke color.
 * @param {String} [controlOpts.labels.strokeWidth] - Label for stroke width.
 * @param {String} [controlOpts.labels.fillColor] - Label for fill color.
 * @param {String} [controlOpts.labels.fillOpacity] - Label for fillOpacity.
 * @param {Array.<Object>} controlOpts.markersList - Array of markers urls and offsets to be used for points styling.
 * @param {String} controlOpts.markersList.src - URL of a marker image.
 * @param {Float} controlOpts.markersList.xAnchor - position of marker anchor in X from left of the image expressed in proportion of 1.
 * @param {Float} controlOpts.markersList.yAnchor - position of marker anchor in Y from top of the image expressed in proportion of 1.
 * @param {Object} controlOpts.defaultStyles - Styles to apply by default to drawn features.
 * @param {String} [controlOpts.defaultStyles.textFillColor = "#000000"] - Text fill color for labels (RGB hex value).
 * @param {String} [controlOpts.defaultStyles.textStrokeColor = "#FFFFFF"] - Text surrounding color for labels (RGB hex value).
 * @param {String} [controlOpts.defaultStyles.strokeColor = "#ffcc33"] - Stroke color (RGB hex value).
 * @param {String} [controlOpts.defaultStyles.polyFillColor = "#ffffff"] - Polygons fill color (RGB hex value).
 * @param {Number} [controlOpts.defaultStyles.polyFillOpacity = 0.2] - Polygon fill opacity (alpha value between 0:transparent and 1:opaque).
 * @param {Number} [controlOpts.defaultStyles.strokeWidth = 2] - Stroke width in pixels.
 * @param {Object} controlOpts.cursorStyle - cursor (circle) style when drawing or editing.
 * @param {String} [controlOpts.cursorStyle.fillColor = "rgba(0, 153, 255, 1)"] - Cursor fill color.
 * @param {String} [controlOpts.cursorStyle.strokeColor = "#FFF"] - Cursor stroke color.
 * @param {String} [controlOpts.cursorStyle.strokeWidth = 1] - Cursor surrounding stroke width.
 * @param {String} [controlOpts.cursorStyle.radius = 6] - Cursor radius.
 *
 * @return {Ol.control.Drawing} control
 */
_OlMapBase.OlMap.prototype.addDrawingControl = function (controlOpts) {
    var drawingOpts = {};
    if (controlOpts.div) {
        drawingOpts.target = controlOpts.div;
    }
    drawingOpts.collapsed = !controlOpts.maximised;
    // tools
    if (controlOpts.hasOwnProperty("tools")) {
        drawingOpts.tools = controlOpts.tools;
    }
    // labels
    if (controlOpts.hasOwnProperty("labels")) {
        drawingOpts.labels = controlOpts.labels;
    }
    // defaultStyles
    if (controlOpts.hasOwnProperty("defaultStyles")) {
        drawingOpts.defaultStyles = controlOpts.defaultStyles;
    }
    // cursorStyle
    if (controlOpts.hasOwnProperty("cursorStyle")) {
        drawingOpts.cursorStyle = controlOpts.cursorStyle;
    }
    // markersList
    if (controlOpts.hasOwnProperty("markersList") && Array.isArray(controlOpts.markersList) && controlOpts.markersList.length > 0) {
        drawingOpts.markersList = [];
        for (var i = 0; i < controlOpts.markersList.length; i++) {
            var mrk = controlOpts.markersList[i];
            if (!mrk.src) {
                continue;
            }
            var olmrk = {
                src: mrk.src
            };
            if (mrk.xAnchor && mrk.yAnchor) {
                olmrk.anchor = [mrk.xAnchor, mrk.yAnchor];
            }
            drawingOpts.markersList.push(olmrk);
        }
    }
    // layer
    if (controlOpts.layer) {
        var olLayers = this._getLayersObj([controlOpts.layer]);
        if (olLayers && olLayers.length > 0) {
            drawingOpts.layer = olLayers[0];
        }
    }
    var control = new _gp.olExtended.control.Drawing(drawingOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Ajoute l'outil d'attributions
 *
 * @param {Object} controlOpts - options du controle
 * @return {Ol.control.GeoportalAttribution} control
 */
_OlMapBase.OlMap.prototype.addAttributionsControl = function (controlOpts) {
    var attOpts = {};
    if (controlOpts.div) {
        attOpts.target = controlOpts.div;
    }
    attOpts.collapsed = !controlOpts.maximised;
    var control = new _gp.olExtended.control.GeoportalAttribution(attOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Ajoute l'outil d'orientation de la camera sur la carte
 *
 * @param {Object} controlOpts - options du controle
 * @return {Object} control
 */
_OlMapBase.OlMap.prototype.addCameraControl = function (controlOpts) {
    // Not implemented (3D feature)
    return null;
};

/**
 * Ajoute l'outil getFeatureInfo
 *
 * @param {Object} controlOpts - options du controle
 * @return {Ol.control.GetFeatureInfo} control
 */
_OlMapBase.OlMap.prototype.addGetFeatureInfoControl = function (controlOpts) {
    var gfiOpts = {};
    gfiOpts.options = {};

    if (controlOpts.hasOwnProperty("options")) {
        if (controlOpts.options.hasOwnProperty("auto")) {
            gfiOpts.options.auto = controlOpts.options.auto;
        }
        if (controlOpts.options.hasOwnProperty("active")) {
            gfiOpts.options.active = controlOpts.options.active;
        }
        if (controlOpts.options.hasOwnProperty("hidden")) {
            gfiOpts.options.hidden = controlOpts.options.hidden;
        }
        if (controlOpts.options.hasOwnProperty("defaultEvent")) {
            gfiOpts.options.defaultEvent = controlOpts.options.defaultEvent;
        }
        if (controlOpts.options.hasOwnProperty("defaultInfoFormat")) {
            gfiOpts.options.defaultInfoFormat = controlOpts.options.defaultInfoFormat;
        }
        if (controlOpts.options.hasOwnProperty("cursorStyle")) {
            gfiOpts.options.cursorStyle = controlOpts.options.cursorStyle;
        }
        // autoPan Options. If undefined : set defaults
        if (!controlOpts.options.hasOwnProperty("autoPanOptions")) {
            controlOpts.options.autoPanOptions = _IMap.IMap.DEFAULT_AUTOPAN_OPTIONS;
        }
        gfiOpts.options.autoPan = controlOpts.options.autoPanOptions.autoPan;
        gfiOpts.options.autoPanAnimation = {
            duration: controlOpts.options.autoPanOptions.duration
        };
        gfiOpts.options.autoPanMargin = controlOpts.options.autoPanOptions.margin;
    }
    if (this.mapOptions && this.mapOptions.proxyUrl) {
        gfiOpts.options.proxyUrl = this.mapOptions.proxyUrl;
    }
    if (this.mapOptions && this.mapOptions.noProxyDomains) {
        gfiOpts.options.noProxyDomains = this.mapOptions.noProxyDomains;
    }

    gfiOpts.layers = [];
    for (var gfiLayerId in controlOpts.layers) {
        var gfiLayer = controlOpts.layers[gfiLayerId];

        for (var i = 0; i < this._layers.length; ++i) {
            var mapLayer = this._layers[i];

            if (gfiLayerId === mapLayer.id) {
                var format = mapLayer.options.format.toLowerCase();
                if (!mapLayer.options.queryable && format !== "kml" && format !== "geojson" && format !== "gpx" && format !== "georss" && format !== "wfs" && format !== "drawing") {
                    // this.// logger.info("GetFeatureInfo layer '" + gfiLayerId + "' has not been added to control because this layer is not queryable.");
                    break;
                } else {
                    var layerConf = {
                        obj: mapLayer.obj
                    };
                    if (gfiLayer.event) {
                        layerConf.event = gfiLayer.event;
                    }
                    if (mapLayer.options.gfiFormat) {
                        layerConf.infoFormat = mapLayer.options.gfiFormat;
                    }

                    gfiOpts.layers.push(layerConf);
                    break;
                }
            }
        }
    }

    var control = new _gp.olExtended.control.GetFeatureInfo(gfiOpts);
    this.libMap.addControl(control);
    return control;
};

/**
 * Remove the controls listed to the map.
 *
 * @param {Array.<String>} controlIds - A list of control's id or null.
 */
_OlMapBase.OlMap.prototype.removeControls = function (controlIds) {
    // this.// logger.trace("[OlMap] : removeControls ... ");
    if (!controlIds || Array.isArray(controlIds) && controlIds.length === 0) {
        // this.// logger.info("No control to remove.");
        return;
    }
    if (!Array.isArray(controlIds)) {
        controlIds = [controlIds];
    }
    var controlId = null;
    for (var i = 0; i < controlIds.length; i++) {
        controlId = controlIds[i];
        var idx = this._findRegisteredControl(controlId);
        if (idx >= 0) {
            // this.// logger.trace("[OlMap] : removeControls : removing [" + controlId + "] from register.");
            this._controls.splice(idx, 1);
        }
        var olControl = this.getLibMapControl(controlId);
        if (!olControl) {
            // this.// logger.info("Impossible to remove control [" + controlId + "] : not found or unhandled");
            continue;
        }
        // graticule n'est pas un controle : on le retire différemment
        if (controlId.toLowerCase() === "graticule") {
            olControl.setMap(null);
            delete this.getLibMap().graticule;
            continue;
        }
        if (Array.isArray(olControl)) {
            // ce sont des interactions => on ne fait rien.
            return;
        }
        // this.// logger.trace("[OlMap] : removeControls : removing [" + controlId + "] from Map.");
        this.libMap.removeControl(olControl);
    }
};

/**
 * Returns implementation of the control
 *
 * @param {String} controlId - identifier of the control
 * @returns {Object} - implementation object of the control if it is on the map. null otherwise.
 */
_OlMapBase.OlMap.prototype.getLibMapControl = function (controlId) {
    var foundOlControl = null;
    // verifications de base : controlId est bien gere.
    if (!_OlMapBase.OlMap.CONTROLSCLASSES.hasOwnProperty(controlId.toLowerCase()) || !_OlMapBase.OlMap.CONTROLSCLASSES[controlId.toLowerCase()]) {
        // this.// logger.trace("[OlMap] getLibMapControl : control " + controlId + " non implémenté.");
        return foundOlControl;
    }
    var olControlClass = _OlMapBase.OlMap.CONTROLSCLASSES[controlId.toLowerCase()];
    // olControlClass == Array => interactions
    if (Array.isArray(olControlClass)) {
        // this.// logger.trace("[OlMap] getLibMapControl : searching interactions.");
        var olInteractions = [];
        this.getLibMap().getInteractions().forEach(function (interaction) {
            for (var j = 0; j < olControlClass.length; j++) {
                if (interaction instanceof olControlClass[j]) {
                    // this.// logger.trace("[OlMap] getLibMapControl : found interaction : " + olControlClass[j].name);
                    olInteractions.push(interaction);
                    break;
                }
            }
        }, this);
        return olInteractions.length > 0 ? olInteractions : null;
    }
    // cas du graticule
    if (controlId.toLowerCase() === "graticule") {
        return this.getLibMap().hasOwnProperty("graticule") ? this.getLibMap().graticule : null;
    }
    // ici c'est un controle simple.
    // this.// logger.trace("[OlMap] getLibMapControl : controlClass : " + olControlClass.name);
    // on regarde du cote des controles
    var olControls = this.getLibMap().getControls().getArray();
    if (olControls.length === 0) {
        // this.// logger.trace("[OlMap] getLibMapControl : no control found on map");
        return foundOlControl;
    }
    for (var i = 0; i < olControls.length; i++) {
        var olControl = olControls[i];
        // this.// logger.trace("[OlMap] getLibMapControl : analyzing : " + (typeof olControl === "undefined" ? "undefined" : _typeof(olControl)));
        if (olControl instanceof olControlClass) {
            foundOlControl = olControl;
            // this.// logger.trace("[OlMap] getLibMapControl : found ! ");
            break;
        }
    }
    return foundOlControl;
};

/**
 * Adds the markers to the map
 * FIXME : make it public ?
 *
 * @param {Array.<Gp.MarkerOptions>} markersOptions - Markers to add to the Map.
 * @private
 */
_OlMapBase.OlMap.prototype._addMarkers = function (markersOptions) {
    // this.// logger.trace("[OlMap] : _addMarkers");
    if (!Array.isArray(markersOptions)) {
        // this.// logger.info("Can not process markersOptions. It is not an Array.");
        return;
    }
    var mo = null;
    var context = this;
    var ii = 0;
    // marker open popup function
    // this == img element associated to the marker
    var fopenPopup = function fopenPopup(evt) {
        var evtPx = context.getLibMap().getEventPixel(evt);
        // context.// logger.trace("[OlMap] : _addMarkers : display content : " + mo.content);
        _gp.olExtended.gp.GfiUtils.displayInfo(context.getLibMap(), context.getLibMap().getCoordinateFromPixel([evtPx[0] + this.mo.ppoffset[0], evtPx[1] + this.mo.ppoffset[1]]), this.mo.content, this.mo.contentType, this.mo.autoPanOptions);
    };
    for (ii = 0; ii < markersOptions.length; ii++) {
        mo = markersOptions[ii];
        // complete missing properties with default
        if (!mo.hasOwnProperty("content")) {
            mo.content = ""; // empty string to avoid errors on display
        }
        if (!mo.hasOwnProperty("url")) {
            mo.url = _gp.olExtended.control.DefaultMarkers["lightOrange"];
        }
        // image offset
        if (!mo.hasOwnProperty("offset")) {
            mo.offset = _gp.olExtended.control.DefaultMarkers["defaultOffset"];
        }
        // this.// logger.trace("[OlMap] : _addMarkers : offset [" + mo.offset[0] + "," + mo.offset[1] + "]");
        // popup offset (from mouse click)
        if (!mo.hasOwnProperty("ppoffset")) {
            // default popup has a 15px of y offset (see .gp-feature-info-div::before css class)
            mo.ppoffset = [0, -15];
        }
        var needsLocated = false;
        if (!mo.hasOwnProperty("position")) {
            // no position given : use map center
            mo.position = {
                x: this.libMap.getView().getCenter()[0],
                y: this.libMap.getView().getCenter()[1]
            };
            // when "located" or "geolocated", the center is not yet the final one (returned by located or geolocated event).
            needsLocated = true;
        }
        if (!mo.hasOwnProperty("contentType")) {
            mo.contentType = "text/html";
        }
        // autoPan Options
        if (!mo.hasOwnProperty("autoPanOptions")) {
            // by default : autoPan true
            mo.autoPanOptions = {
                autoPan: _IMap.IMap.DEFAULT_AUTOPAN_OPTIONS.autoPan,
                // properties of autoPanAnimation : https://openlayers.org/en/latest/apidoc/olx.html#.OverlayPanOptions
                autoPanAnimation: {
                    duration: _IMap.IMap.DEFAULT_AUTOPAN_OPTIONS.duration
                },
                autoPanMargin: _IMap.IMap.DEFAULT_AUTOPAN_OPTIONS.margin
            };
        }
        // create overlay
        var fcoords = [mo.position.x, mo.position.y];
        if (mo.position.hasOwnProperty("projection")) {
            fcoords = _gp.olExtended.proj.transform(fcoords, mo.position.projection, this.getProjection());
        }
        // this.// logger.trace("[OlMap] : _addMarkers : coords [" + fcoords[0] + ", " + fcoords[1] + "]");
        var mrkImg = document.createElement("img");
        mrkImg.src = mo.url;
        // mrkImg.setAttribute("content", mo.content);
        mrkImg.mo = mo;
        var mrk = new _gp.olExtended.Overlay({
            position: fcoords,
            offset: mo.offset,
            element: mrkImg
        });
        this.libMap.addOverlay(mrk);
        // listen to geolocated and located events (if marker has to be positionned to the center of the map
        if (needsLocated === true) {
            var gpMap = this;
            /**
             * Change markerPositon - this == mrk overlay object
             *
             * @param {Object} locEvt - Gp.Located or Gp.GeolocatedEvent
             */
            var changeCenter = function changeCenter(locEvt) {
                var fcoords = [locEvt.position.x, locEvt.position.y];
                if (locEvt.position.hasOwnProperty("projection")) {
                    fcoords = _gp.olExtended.proj.transform(fcoords, locEvt.position.projection, gpMap.getProjection());
                }
                this.setPosition(fcoords);
            };
            this.listen("located", changeCenter, mrk);
            this.listen("geolocated", changeCenter, mrk);
        }
        // listen to markerEvents
        mrkImg.addEventListener("click", fopenPopup, true);
        // TODO : test if useless or not
        mrkImg.addEventListener("touchend", fopenPopup, true);
        // TODO :
        //  - add option for making popup opened or not at startup
    }
};

/**
 * Fill ol styles with params
 *
 * @param {Object} stylesProps - properties
 * @returns {Ol.style.Stroke} - ol.style.Stroke Object
 * @private
 */
_OlMapBase.OlMap.prototype._fillStrokeStyles = function (stylesProps) {
    var strokeOpts = {};
    var resultStyle = null;
    if (stylesProps.hasOwnProperty("strokeLineDash")) {
        strokeOpts.lineDash = stylesProps.strokeLineDash;
    }
    if (stylesProps.hasOwnProperty("strokeColor")) {
        strokeOpts.color = stylesProps.strokeColor;
    }
    if (stylesProps.hasOwnProperty("strokeWidth")) {
        strokeOpts.width = stylesProps.strokeWidth;
    }
    if (Object.keys(strokeOpts).length > 0) {
        resultStyle = new _gp.olExtended.style.Stroke(strokeOpts);
    }
    return resultStyle;
};

/**
 * Fill ol styles with params
 *
 * @param {Object} stylesProps - properties
 * @returns {Ol.style.Stroke} - ol.style.Stroke Object
 * @private
 */
_OlMapBase.OlMap.prototype._fillPointerStyles = function (stylesProps) {
    var pointerOpts = {};
    if (stylesProps.hasOwnProperty("radius")) {
        pointerOpts.radius = stylesProps.radius;
    }
    pointerOpts.stroke = this._fillStrokeStyles(stylesProps);
    if (stylesProps.hasOwnProperty("fillColor")) {
        pointerOpts.fill = new _gp.olExtended.style.Fill({
            color: stylesProps.fillColor
        });
    }
    var pStyle = new _gp.olExtended.style.Circle(pointerOpts);
    return pStyle;
};

/**
 * Rajoute une configuration de couche au LayerSwitcher
 *
 * @param {Object} implLayer - objet couche de l'implémentation
 * @param {Gp.LayerOptions} layerOptions - options de la couche.
 * @private
 */
_OlMapBase.OlMap.prototype._addLayerConfToLayerSwitcher = function (implLayer, layerOptions) {
    // this.// logger.trace("[OlMap] : _addLayerConfToLayerSwitcher ... ");
    var lsControl = this.getLibMapControl("layerswitcher");
    if (lsControl) {
        lsControl.addLayer(implLayer, this._layerOptions2layerConf(layerOptions));
    }
};

/**
 * Gets Layer Container div ID for a given layerId.
 *
 * @param {String} layerId - layer identifier
 * @returns {String} - Layer Container div Id in the LayerSwitcher
 */
_OlMapBase.OlMap.prototype.getLSLayerContainerDivId = function (layerId) {
    var id = null;
    var idxLS = this._findRegisteredControl("layerswitcher");
    if (idxLS < 0) {
        // this.// logger.trace("[OlMap] : getLSLayerContainerDivId : no layerswitcher on map !");
        return id;
    }
    var olLayers = this._getLayersObj([layerId]);
    if (olLayers.length > 0) {
        var olLs = this._controls[idxLS].obj;
        return olLs.getLayerDOMId(olLayers[0].obj);
    }
    // this.// logger.trace("[OlMap] : getLSLayerContainerDivId : layer [" + layerId + "] not found on map !");
    return id;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _OlMapBase = __webpack_require__(1);

var _IMap = __webpack_require__(3);

var _gp = __webpack_require__(0);

/**
 * Associate a function to trigger when an event is received.
 *
 * @param {String} eventId - The map's event listened. Possible values are : 'loaded', 'failure', 'geolocated', 'located', 'zoomchanged', 'azimuthchanged', 'tiltchanged', 'dragstart', 'drag', 'dragend', 'projectionchanged', 'layerchanged', 'controlchanged'.
 *
 * | eventId  | description |
 * |-|-|
 * | mapLoaded | fired when map has finished loading |
 * | mapFailure | fired when map has problem loading |
 * | geolocated | fired when map has finished centering by geolocation |
 * | located | fired when map has finished centering by geocoding |
 * | configured | fired when map has finished loading geoportal configuration |
 * | centerChanged | fired when map center has changed |
 * | zoomChanged | fired when map zoom has changed |
 * | azimuthChanged | fired when map orientation has changed |
 * | tiltChanged | fired when map tilt has changed |
 * | projectionChanged | fired when map projection has changed |
 * | layerChanged | fired when map's layer(s) has changed someway |
 * | controlChanged | fired when map's control(s) has changed |
 *
 * @param {Function} action - The function to execute when the event occures.
 * @param {Object} context - The object that will be used as "this" in the action function
 */
_OlMapBase.OlMap.prototype.listen = function (eventId, action, context) {
    // this.// logger.trace("[OlMap] : listen...");
    // verifications de base de la classe mère
    if (!_IMap.IMap.prototype.listen.apply(this, arguments)) {
        return;
    }
    context = context || this;
    var map = this;
    var olEventKey = null;
    switch (eventId) {
        case "mapLoaded":
            break;
        case "mapFailure":
            break;
        case "located":
            // handled in IMap
            break;
        case "geolocated":
            // handled in IMap
            break;
        case "configured":
            // handled in IMap
            break;
        case "centerChanged":
            olEventKey = this.libMap.getView().on("change:center", function (olEvt) {
                var centerChangedEvt = {};
                if (olEvt.oldValue) {
                    centerChangedEvt.oldCenter = {
                        x: olEvt.oldValue[0],
                        y: olEvt.oldValue[1]
                    };
                }
                centerChangedEvt.newCenter = {
                    x: this.libMap.getView().getCenter()[0],
                    y: this.libMap.getView().getCenter()[1]
                };
                action.call(context, centerChangedEvt);
            }, this);
            break;
        case "zoomChanged":
            olEventKey = this.libMap.getView().on("change:resolution", function (olEvt) {
                action.call(context, {
                    // NB : quand on n'a precise aucun tableau de resolutions à
                    //      la creation de la vue, OL utilise les résolutions
                    //      Géographiques.
                    oldZoom: this._getZoomFromResolution(olEvt.oldValue /* , "EPSG:4326" */),
                    newZoom: this._getZoomFromResolution(this.libMap.getView().getResolution() /* , "EPSG:4326" */)
                });
            }, this);
            break;
        case "azimuthChanged":
            olEventKey = this.libMap.getView().on("change:rotation", function (olEvt) {
                action.call(context, {
                    oldAzimuth: olEvt.oldValue * 180 / Math.PI,
                    newAzimuth: this.libMap.getView().getRotation() * 180 / Math.PI
                });
            }, this);
            break;
        case "tiltChanged":
            // non pertinent en 2D
            break;
        case "projectionChanged":
            // TODO : interet ?
            break;
        case "layerChanged":
            // abonnement à un ajout de couche
            olEventKey = this.libMap.getLayers().on("add", function (olEvt) {
                var ladded = olEvt.element;
                var layerOpts = this._getLayerOpts(ladded);
                if (!layerOpts) {
                    // map.// logger.trace("[OlMap] listen : enregistrement d'une couche 'inconnue'.");
                    layerOpts = this._registerUnknownLayer(ladded);
                }
                action.call(context, {
                    layerAdded: layerOpts,
                    position: ladded.getZIndex()
                });
            }, this);
            this._registerEvent(olEventKey, eventId, action, context);
            // abonnement à un retrait de couche
            olEventKey = this.libMap.getLayers().on("remove", function (olEvt) {
                var lremoved = olEvt.element;
                // on cherche la couche a éventuellement déjà été
                // enlevée de this._layers
                var layerOpts = this._getLayerOpts(lremoved) || this._getLayerOpts(lremoved, this._layersRemoved);

                var self = context.getLibMap();
                if (self.featuresOverlay && layerOpts[self.featuresOverlay.getId()]) {
                    self.removeOverlay(self.featuresOverlay);
                    self.featuresOverlay = null;
                }
                action.call(context, {
                    layerRemoved: layerOpts
                });
            }, this);
            this._registerEvent(olEventKey, eventId, action, context);
            olEventKey = null;
            // abonnement à un changement de propriete sur chaque couche
            for (var obsProperty in _OlMapBase.OlMap.LAYERPROPERTIES) {
                // map.// logger.trace("[OlMap] listen : abonnement layerProperty : " + obsProperty);
                this.libMap.getLayers().forEach(function (olLayer, i, array) {
                    var layerOpts = this._getLayerOpts(olLayer);
                    if (obsProperty === "grayScaled") {
                        // layerChangeGrayScaled callback
                        var layerChangeGrayScaledCallBack = function layerChangeGrayScaledCallBack(evt) {
                            action.call(context, {
                                property: "grayScaled",
                                oldValue: evt.detail.oldValue,
                                newValue: evt.detail.newValue,
                                layerChanged: layerOpts
                            });
                        };

                        var registredEvent = map._registerEvent(layerChangeGrayScaledCallBack, eventId, action, context);
                        registredEvent.eventOrigin = olLayer;
                        registredEvent.eventType = "change:" + obsProperty;
                        registredEvent.eventOrigin.addEventListener(registredEvent.eventType, layerChangeGrayScaledCallBack, this);
                    } else {
                        olEventKey = olLayer.on("change:" + obsProperty, function (olEvt) {
                            // la fonction _getCommonLayerParams permet de faire la conversion
                            // propriete ol => propriete commune
                            var oldOlObj = {};
                            oldOlObj[olEvt.key] = olEvt.oldValue;
                            var oldCommonProp = map._getCommonLayerParams(oldOlObj);
                            var newOlObj = {};
                            newOlObj[olEvt.key] = this.get(olEvt.key);
                            var newCommonProp = map._getCommonLayerParams(newOlObj);
                            action.call(context, {
                                property: _OlMapBase.OlMap.LAYERPROPERTIES[olEvt.key],
                                oldValue: oldCommonProp[_OlMapBase.OlMap.LAYERPROPERTIES[olEvt.key]],
                                newValue: newCommonProp[_OlMapBase.OlMap.LAYERPROPERTIES[olEvt.key]],
                                layerChanged: layerOpts
                            });
                        }, olLayer);

                        this._registerEvent(olEventKey, eventId, action, context);
                        olEventKey = null;
                    }
                }, map);
            }
            break;
        case "controlChanged":
            break;
        default:
            // this.// logger.info("unhandled event : " + eventId);
    };
    // enregistrement de l'evenement
    if (olEventKey) {
        this._registerEvent(olEventKey, eventId, action, context);
    }
};

/**
 * Cancel an event listening.
 *
 * @param {String} eventId - The map's event to forget. Possible values are :
 *
 * | eventId  | description |
 * |-|-|
 * | mapLoaded | fired when map has finished loading |
 * | mapFailure | fired when map has problem loading |
 * | geolocated | fired when map has finished centering by geolocation |
 * | located | fired when map has finished centering by geocoding |
 * | configured | fired when map has finished loading geoportal configuration |
 * | centerChanged | fired when map center has changed |
 * | zoomChanged | fired when map zoom has changed |
 * | azimuthChanged | fired when map orientation has changed |
 * | tiltChanged | fired when map tilt has changed |
 * | projectionChanged | fired when map projection has changed |
 * | layerChanged | fired when map's layer(s) has changed someway |
 * | controlChanged | fired when map's control(s) has changed |
 *
 * @param {Function} action - The function associated to the event.
 */
_OlMapBase.OlMap.prototype.forget = function (eventId, action) {
    // this.// logger.trace("[OlMap] : forget...");

    // verifications de base de la classe mère
    if (!_IMap.IMap.prototype.forget.apply(this, arguments)) {
        return;
    }

    // on cherche l'enregistrement de l'evenement
    var rEvents = this._events[eventId];
    if (!rEvents) {
        // this.// logger.info("nothing to forget for : " + eventId);
        return;
    }
    var evKey = null;
    for (var i = rEvents.length - 1; i >= 0; i--) {
        if (rEvents[i].action == action) {
            evKey = rEvents[i].key;
            rEvents.splice(i, 1);
            // this.// logger.trace("[OlMap] : forgetting : " + eventId + " (" + evKey + ")");
            _gp.olExtended.Observable.unByKey(evKey);
        }
    }
};

/**
 * Activate / Deactivate the ability to navigate on the map with mouse or pointer interaction.
 *
 * @param {Boolean} controlOpts - true for activation / false otherwise.
 *
 * @return {Object[]} interactions
 */
_OlMapBase.OlMap.prototype.setDraggable = function (controlOpts) {
    return this._toggleInteractions("draggable", controlOpts);
};

/**
 * Activate / Deactivate the ability to navigate on the map with keyborad.
 *
 * @param {Boolean} controlOpts - true for activation / false otherwise.
 *
 * @return {Object[]} interactions
 */
_OlMapBase.OlMap.prototype.setKeyboard = function (controlOpts) {
    return this._toggleInteractions("keyboard", controlOpts);
};

/**
 * Activate / Deactivate the ability to select features on the map.
 *
 * @param {Boolean} controlOpts - true for activation / false otherwise.
 *
 * @return {Object[]} interactions
 */
_OlMapBase.OlMap.prototype.setSelectable = function (controlOpts) {
    return this._toggleInteractions("selectable", controlOpts);
};

/**
 * Active / desactive les interactions correspondant à controlId
 *
 * @param {String} controlId - identifiant du controle
 * @param {Boolean} controlOpts - etat à positionner pour les interactions.
 *
 * @return {Object[]} interactions
 */
_OlMapBase.OlMap.prototype._toggleInteractions = function (controlId, controlOpts) {
    var interactions = this.getLibMapControl(controlId);
    if (interactions == null) {
        interactions = [];
        // les interactions ne sont pas sur la carte, on les rajoute, quitte à les désactiver après !
        for (var i = 0; i < _OlMapBase.OlMap.CONTROLSCLASSES[controlId].length; i++) {
            // this.// logger.trace("[OlMap] : adding interaction " + _OlMapBase.OlMap.CONTROLSCLASSES[controlId][i].name + " to the map.");
            var interaction = new _OlMapBase.OlMap.CONTROLSCLASSES[controlId][i]();
            this.libMap.addInteraction(interaction);
            interactions.push(interaction);
        }
    }
    // on active / desactive toutes les interactions correspondantes
    for (var ii = 0; ii < interactions.length; ii++) {
        var _interaction = interactions[ii];
        // this.// logger.trace("[OlMap] : setting interaction to " + controlOpts + " for control : " + controlId);
        _interaction.setActive(controlOpts);
    }
    return interactions;
};

/**
 * get layer params from OL layer params
 * opacity, visibility, minZoom, maxZoom
 *
 * @param {Object} olLayerOpts - options of the layer
 * @returns {Gp.LayerOptions} - object with common options
 *
 * @private
 */
_OlMapBase.OlMap.prototype._getCommonLayerParams = function (olLayerOpts) {
    var commonOpts = {};
    // this.// logger.trace("[OlMap] : _getCommonLayerParams ");
    if (olLayerOpts.hasOwnProperty("opacity")) {
        // this.// logger.trace("[OlMap] : _getCommonLayerParams - opacity : " + olLayerOpts.opacity);
        commonOpts.opacity = olLayerOpts.opacity;
    }
    if (olLayerOpts.hasOwnProperty("visible")) {
        // this.// logger.trace("[OlMap] : _getCommonLayerParams - visibility : " + olLayerOpts.visible);
        commonOpts.visibility = olLayerOpts.visible;
    }
    if (olLayerOpts.hasOwnProperty("zIndex")) {
        // this.// logger.trace("[OlMap] : _getCommonLayerParams - position : " + olLayerOpts.zIndex);
        commonOpts.position = olLayerOpts.zIndex;
    }
    if (olLayerOpts.hasOwnProperty("maxResolution")) {
        var minZoom = this._getZoomFromResolution(olLayerOpts.maxResolution);
        // this.// logger.trace("[OlMap] : _getCommonLayerParams - minZoom : " + minZoom);
        commonOpts.minZoom = minZoom;
    }
    if (olLayerOpts.hasOwnProperty("minResolution")) {
        var maxZoom = this._getZoomFromResolution(olLayerOpts.minResolution);
        // this.// logger.trace("[OlMap] : _getCommonLayerParams - maxZoom : " + maxZoom);
        commonOpts.maxZoom = maxZoom;
    }

    return commonOpts;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _OlMapBase = __webpack_require__(1);

var _gp = __webpack_require__(0);

/**
 * retourne le code de la projection courante de la carte
 * @return {String} projection code
 */
_OlMapBase.OlMap.prototype.getProjection = function () {
    return this.libMap.getView().getProjection().getCode();
};

/**
 * retourne les coordonnées courantes du centre de la carte
 * @return {Object} center
 */
_OlMapBase.OlMap.prototype.getCenter = function () {
    var center = {
        x: this.libMap.getView().getCenter()[0],
        y: this.libMap.getView().getCenter()[1]
    };
    return center;
};

/**
 * Returns the current bounding box of the map in the current projection.
 *
 * @param {String} [projection=map projection] - Coordinate Reference System of returned extent.
 * @returns {Gp.BBox} - The current map's extent.
 */
_OlMapBase.OlMap.prototype.getViewExtent = function (projection) {
    var bbox = {};
    if (this.libMap && this.libMap.getView()) {
        var extent = this.libMap.getView().calculateExtent(this.libMap.getSize());
        var mapProj = this.libMap.getView().getProjection().getCode();
        if (projection && projection !== mapProj) {
            extent = _gp.olExtended.proj.transformExtent(extent, mapProj, projection);
        }
        // extent OL :
        // [-136845.07118250668, 5803180.6192946555, -124691.58368516366, 5810852.986008779]
        bbox.left = extent[0];
        bbox.right = extent[2];
        bbox.bottom = extent[1];
        bbox.top = extent[3];
    }
    return bbox;
};

/**
 * retourne l'azimut courant de la carte
 * @return {Number} azimuth
 */
_OlMapBase.OlMap.prototype.getAzimuth = function () {
    return this.libMap.getView().getRotation() * 180 / Math.PI;
};

/**
 * retourne le zoom courant de la carte
 * @return {Integer} zoom
 */
_OlMapBase.OlMap.prototype.getZoom = function () {
    return this._getZoomFromResolution(this.getResolution());
};

/**
 * retourne le zoom courant de la carte
 * @return {Number} resolution
 */
_OlMapBase.OlMap.prototype.getResolution = function () {
    return this.libMap.getView().getResolution();
};

/**
 * définit la projection de la carte
 * Si certaines couches ne sont pas compatibles avec la nouvelle projection, elles ne seront pas affichées.
 * // TODO : vérifier que ça fonctionne : un view.setProjection semblerait plus adapte ?
 * @param {String} projection - projection
 */
_OlMapBase.OlMap.prototype.setProjection = function (projection) {
    var view = new _gp.olExtended.View({
        center: this.libMap.getView().getCenter(),
        // minZoom : this.mapOptions.minZoom,
        // maxZoom : this.mapOptions.maxZoom,
        projection: projection,
        rotation: this.libMap.getView().getRotation(),
        zoom: this.getZoom()
    });
    this.libMap.setView(view);
};

/**
 * center Map on a given point
 *
 * @param {Object} point - center point
 * @param {Float} point.x - x coordinates for center
 * @param {Float} point.y - y coordinates for center
 * @param {String} point.projection - srs center coordinates
 */
_OlMapBase.OlMap.prototype.setXYCenter = function (point) {
    // this.// logger.trace("[OlMap] - setXYCenter");
    if (!point.hasOwnProperty("x") || !point.hasOwnProperty("y")) {
        // this.// logger.info("no valid coordinates for map center");
        return;
    }

    var center = [point.x, point.y];
    var mapProj = this.libMap.getView().getProjection().getCode();
    if (point.projection && point.projection !== mapProj) {
        center = _gp.olExtended.proj.transform(center, point.projection, mapProj);
    }
    this.libMap.getView().setCenter(center);
    // this.// logger.trace("[OlMap] - setXYCenter(" + point.x + "," + point.y + "), projection Map : " + mapProj);

    // FIXME : markerFeature
    // if (this.markerFeature)
    //    this.markerFeature.setGeometry(new ol.geom.Point(geocodeCenter));
};

/**
 * center Map on a given point in case of auto centering
 *
 * @param {Object} point - center point
 * @param {Float} point.x - x coordinates for center
 * @param {Float} point.y - y coordinates for center
 * @param {Number} zoom - zoom level (optional, used for geolocate)
 *
 */
_OlMapBase.OlMap.prototype.setAutoCenter = function (point, zoom) {
    // this.// logger.trace("[IT] - setAutoCenter");
    this.setXYCenter(point, zoom);
};

/**
 * définit l'azimut de la carte.
 * @param {Number} azimuth - azimuth
 */
_OlMapBase.OlMap.prototype.setAzimuth = function (azimuth) {
    this.libMap.getView().setRotation(azimuth * Math.PI / 180);
};

/**
 * définit le niveau de zoom de la carte
 * @param {Integer} zoom - zoom
 */
_OlMapBase.OlMap.prototype.setZoom = function (zoom) {
    this.libMap.getView().setZoom(zoom);
};

/**
 * Définit la résolution de la carte
 * @param {Number} resolution - resolution
 */
_OlMapBase.OlMap.prototype.setResolution = function (resolution) {
    this.libMap.getView().setResolution(resolution);
};

/**
 * Incrémente le niveau de zoom de la carte de 1.
 */
_OlMapBase.OlMap.prototype.zoomIn = function () {
    this.libMap.getView().setZoom(this.getZoom() + 1);
};

/**
 * Décrémente le niveau de zoom de la carte de 1.
 */
_OlMapBase.OlMap.prototype.zoomOut = function () {
    this.libMap.getView().setZoom(this.getZoom() - 1);
};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
});


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/GpSDK2D.js
// module id = ./src/assets/js/GpSDK2D.js
// module chunks = main